
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiredee5"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiredee5"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("eBFL7", function(module, exports) {

$parcel$export(module.exports, "StorageContext", () => $5b723b129baa13f6$export$37c52bbb9ad91dc9);
$parcel$export(module.exports, "StorageContextProvider", () => $5b723b129baa13f6$export$391446ce2f0d1557);
$parcel$export(module.exports, "useStorageContext", () => $5b723b129baa13f6$export$1d88f1dc01e47b0e);
$parcel$export(module.exports, "ArgumentIcon", () => $5b723b129baa13f6$export$e0b8b1afc6387616);
$parcel$export(module.exports, "ChevronDownIcon", () => $5b723b129baa13f6$export$4857d3f3f5f8319b);
$parcel$export(module.exports, "ChevronLeftIcon", () => $5b723b129baa13f6$export$20bc5960c3c9eebb);
$parcel$export(module.exports, "ChevronUpIcon", () => $5b723b129baa13f6$export$7f01a6cbee61a0f2);
$parcel$export(module.exports, "CloseIcon", () => $5b723b129baa13f6$export$cae179f078f4b4a4);
$parcel$export(module.exports, "CopyIcon", () => $5b723b129baa13f6$export$51b6cd98f8778f0d);
$parcel$export(module.exports, "DeprecatedArgumentIcon", () => $5b723b129baa13f6$export$3dece38e5f333c21);
$parcel$export(module.exports, "DeprecatedEnumValueIcon", () => $5b723b129baa13f6$export$f2559fa12473338f);
$parcel$export(module.exports, "DeprecatedFieldIcon", () => $5b723b129baa13f6$export$69318f45e191d5cf);
$parcel$export(module.exports, "DirectiveIcon", () => $5b723b129baa13f6$export$56acf24630a50a0f);
$parcel$export(module.exports, "DocsFilledIcon", () => $5b723b129baa13f6$export$9b2be5fcaf6117d1);
$parcel$export(module.exports, "DocsIcon", () => $5b723b129baa13f6$export$13c114d596b48571);
$parcel$export(module.exports, "EnumValueIcon", () => $5b723b129baa13f6$export$efd164bba9c3659a);
$parcel$export(module.exports, "FieldIcon", () => $5b723b129baa13f6$export$41064d4d91086d08);
$parcel$export(module.exports, "HistoryIcon", () => $5b723b129baa13f6$export$8d345d913bfb227);
$parcel$export(module.exports, "ImplementsIcon", () => $5b723b129baa13f6$export$89e42b2a2b168714);
$parcel$export(module.exports, "KeyboardShortcutIcon", () => $5b723b129baa13f6$export$2e8834204231f98a);
$parcel$export(module.exports, "MagnifyingGlassIcon", () => $5b723b129baa13f6$export$f7658c347b037c3f);
$parcel$export(module.exports, "MergeIcon", () => $5b723b129baa13f6$export$ec4f2b228b2eab);
$parcel$export(module.exports, "PenIcon", () => $5b723b129baa13f6$export$eeb42689c16a5321);
$parcel$export(module.exports, "PlayIcon", () => $5b723b129baa13f6$export$a6630b90defda83f);
$parcel$export(module.exports, "PlusIcon", () => $5b723b129baa13f6$export$f21ab0717a89c77f);
$parcel$export(module.exports, "PrettifyIcon", () => $5b723b129baa13f6$export$1b8875f5d2ff9f24);
$parcel$export(module.exports, "ReloadIcon", () => $5b723b129baa13f6$export$ca36f1a1d2d1ca14);
$parcel$export(module.exports, "RootTypeIcon", () => $5b723b129baa13f6$export$9463a1f0a61bd487);
$parcel$export(module.exports, "SettingsIcon", () => $5b723b129baa13f6$export$ac4e8b8ca2b79f39);
$parcel$export(module.exports, "StarFilledIcon", () => $5b723b129baa13f6$export$b9957ed2bd2cc18b);
$parcel$export(module.exports, "StarIcon", () => $5b723b129baa13f6$export$2ee28caa7f1e962e);
$parcel$export(module.exports, "StopIcon", () => $5b723b129baa13f6$export$dc6949a98411e916);
$parcel$export(module.exports, "TrashIcon", () => $5b723b129baa13f6$export$d23329de703dffc4);
$parcel$export(module.exports, "TypeIcon", () => $5b723b129baa13f6$export$ad8f8fc3bcd61b4a);
$parcel$export(module.exports, "UnStyledButton", () => $5b723b129baa13f6$export$fee7dc9850636d63);
$parcel$export(module.exports, "Button", () => $5b723b129baa13f6$export$353f5b6fc5456de1);
$parcel$export(module.exports, "ButtonGroup", () => $5b723b129baa13f6$export$69b1032f2ecdf404);
$parcel$export(module.exports, "DialogRoot", () => $5b723b129baa13f6$export$b99ad270d48ac6b2);
$parcel$export(module.exports, "Dialog", () => $5b723b129baa13f6$export$3ddf2d174ce01153);
$parcel$export(module.exports, "DropdownMenu", () => $5b723b129baa13f6$export$e44a253a59704894);
$parcel$export(module.exports, "MarkdownContent", () => $5b723b129baa13f6$export$759dadce87f95042);
$parcel$export(module.exports, "Spinner", () => $5b723b129baa13f6$export$7f7cbe89f1eacd2);
$parcel$export(module.exports, "TooltipRoot", () => $5b723b129baa13f6$export$c21697e1ea9173ed);
$parcel$export(module.exports, "Tooltip", () => $5b723b129baa13f6$export$28c660c63b792dea);
$parcel$export(module.exports, "Tab", () => $5b723b129baa13f6$export$3e41faf802a29e71);
$parcel$export(module.exports, "Tabs", () => $5b723b129baa13f6$export$b2539bed5023c21c);
$parcel$export(module.exports, "HistoryContext", () => $5b723b129baa13f6$export$2f62cb99760ab75b);
$parcel$export(module.exports, "HistoryContextProvider", () => $5b723b129baa13f6$export$a7f2b2c281690bcd);
$parcel$export(module.exports, "useHistoryContext", () => $5b723b129baa13f6$export$1c946c39bb2430a4);
$parcel$export(module.exports, "History", () => $5b723b129baa13f6$export$84202caead5689ba);
$parcel$export(module.exports, "useEditorContext", () => $5b723b129baa13f6$export$b119c82498f162a5);
$parcel$export(module.exports, "ExecutionContext", () => $5b723b129baa13f6$export$f7c638676c8af91d);
$parcel$export(module.exports, "ExecutionContextProvider", () => $5b723b129baa13f6$export$14f2a780bc6de643);
$parcel$export(module.exports, "useAutoCompleteLeafs", () => $5b723b129baa13f6$export$5abb433c7a1f773e);
$parcel$export(module.exports, "useExecutionContext", () => $5b723b129baa13f6$export$b0467ce6d1ed861f);
$parcel$export(module.exports, "DefaultValue", () => $5b723b129baa13f6$export$a4e369a19907695d);
$parcel$export(module.exports, "SchemaContext", () => $5b723b129baa13f6$export$77f26f02a668a7e2);
$parcel$export(module.exports, "SchemaContextProvider", () => $5b723b129baa13f6$export$ad72d84d137207fb);
$parcel$export(module.exports, "useSchemaContext", () => $5b723b129baa13f6$export$468d7ae1c12d1956);
$parcel$export(module.exports, "ExplorerContext", () => $5b723b129baa13f6$export$14a7fb59424347b4);
$parcel$export(module.exports, "ExplorerContextProvider", () => $5b723b129baa13f6$export$50f5f436c5e784bd);
$parcel$export(module.exports, "useExplorerContext", () => $5b723b129baa13f6$export$9ef0683d0e7c89e8);
$parcel$export(module.exports, "TypeLink", () => $5b723b129baa13f6$export$b60636963b84124);
$parcel$export(module.exports, "Argument", () => $5b723b129baa13f6$export$84637ea037d2e218);
$parcel$export(module.exports, "DeprecationReason", () => $5b723b129baa13f6$export$a4ad898a6061dca3);
$parcel$export(module.exports, "Directive", () => $5b723b129baa13f6$export$befdefbdce210f91);
$parcel$export(module.exports, "ExplorerSection", () => $5b723b129baa13f6$export$c30bfbdd7c818f60);
$parcel$export(module.exports, "FieldDocumentation", () => $5b723b129baa13f6$export$cfadd2888c69ccf7);
$parcel$export(module.exports, "SchemaDocumentation", () => $5b723b129baa13f6$export$77f7a1a1d3f40e71);
$parcel$export(module.exports, "Search", () => $5b723b129baa13f6$export$4b85d3515bd863a5);
$parcel$export(module.exports, "FieldLink", () => $5b723b129baa13f6$export$de2fc2a24a792f2d);
$parcel$export(module.exports, "TypeDocumentation", () => $5b723b129baa13f6$export$e4b2cda496ff71db);
$parcel$export(module.exports, "DocExplorer", () => $5b723b129baa13f6$export$6e0225bf113f4207);
$parcel$export(module.exports, "DOC_EXPLORER_PLUGIN", () => $5b723b129baa13f6$export$3e22af3f552d183);
$parcel$export(module.exports, "usePluginContext", () => $5b723b129baa13f6$export$b730231195af25bd);
$parcel$export(module.exports, "HISTORY_PLUGIN", () => $5b723b129baa13f6$export$1a56bd6804cd66a6);
$parcel$export(module.exports, "PluginContext", () => $5b723b129baa13f6$export$5cdd67ce320013cf);
$parcel$export(module.exports, "PluginContextProvider", () => $5b723b129baa13f6$export$841211ff5aa203b9);
$parcel$export(module.exports, "useCopyQuery", () => $5b723b129baa13f6$export$7de945a74ead2b3b);
$parcel$export(module.exports, "useMergeQuery", () => $5b723b129baa13f6$export$901e59078d6717b6);
$parcel$export(module.exports, "usePrettifyEditors", () => $5b723b129baa13f6$export$6cd47fbdfe85a578);
$parcel$export(module.exports, "useEditorState", () => $5b723b129baa13f6$export$e6e340c65601d57b);
$parcel$export(module.exports, "useOperationsEditorState", () => $5b723b129baa13f6$export$fd296a58afc2838d);
$parcel$export(module.exports, "useVariablesEditorState", () => $5b723b129baa13f6$export$ddaa834da7662225);
$parcel$export(module.exports, "useHeadersEditorState", () => $5b723b129baa13f6$export$4fe9bde1571c31df);
$parcel$export(module.exports, "useOptimisticState", () => $5b723b129baa13f6$export$d840f597e09ee733);
$parcel$export(module.exports, "useHeaderEditor", () => $5b723b129baa13f6$export$cdbbb29991d2bf8b);
$parcel$export(module.exports, "useQueryEditor", () => $5b723b129baa13f6$export$52fa6630ade3da25);
$parcel$export(module.exports, "useVariableEditor", () => $5b723b129baa13f6$export$33f22fd50da9021b);
$parcel$export(module.exports, "EditorContext", () => $5b723b129baa13f6$export$27b8dd149e32f6c7);
$parcel$export(module.exports, "EditorContextProvider", () => $5b723b129baa13f6$export$df6090aa0843ca0f);
$parcel$export(module.exports, "HeaderEditor", () => $5b723b129baa13f6$export$9c08f57eebcc7fbb);
$parcel$export(module.exports, "ImagePreview", () => $5b723b129baa13f6$export$4a96334d5925dbf2);
$parcel$export(module.exports, "QueryEditor", () => $5b723b129baa13f6$export$11208edffefb3435);
$parcel$export(module.exports, "useResponseEditor", () => $5b723b129baa13f6$export$b489312ecf6dd058);
$parcel$export(module.exports, "ResponseEditor", () => $5b723b129baa13f6$export$e8ec468881fc8802);
$parcel$export(module.exports, "VariableEditor", () => $5b723b129baa13f6$export$37f8f06e2ca92cb5);
$parcel$export(module.exports, "GraphiQLProvider", () => $5b723b129baa13f6$export$df7538e96c613481);
$parcel$export(module.exports, "useTheme", () => $5b723b129baa13f6$export$93d4e7f90805808f);
$parcel$export(module.exports, "useDragResize", () => $5b723b129baa13f6$export$cbaee0f66e3262dc);
$parcel$export(module.exports, "ToolbarButton", () => $5b723b129baa13f6$export$e5c1a33878e86e9e);
$parcel$export(module.exports, "ExecuteButton", () => $5b723b129baa13f6$export$55a335d669baee54);
$parcel$export(module.exports, "ToolbarMenu", () => $5b723b129baa13f6$export$1f4688db2a0d3d39);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $1SA7b = parcelRequire("1SA7b");

var $3MaO2 = parcelRequire("3MaO2");
var $iqtrZ = parcelRequire("iqtrZ");
var $56ITi = parcelRequire("56ITi");
var $54dWd = parcelRequire("54dWd");
var $3rrQl = parcelRequire("3rrQl");
var $8DJ2k = parcelRequire("8DJ2k");
var $3o9dz = parcelRequire("3o9dz");
var $dy8yN = parcelRequire("dy8yN");
var $9m7aI = parcelRequire("9m7aI");
parcelRequire("9wOaz");
var $2n7MZ = parcelRequire("2n7MZ");
var $c9xw3 = parcelRequire("c9xw3");
var $a8KRF = parcelRequire("a8KRF");
var $anr3h = parcelRequire("anr3h");
var $bWkaC = parcelRequire("bWkaC");
var $dhM2X = parcelRequire("dhM2X");
var $5mhgG = parcelRequire("5mhgG");
parcelRequire("48f6i");
var $eYQLF = parcelRequire("eYQLF");
var $8xP5p = parcelRequire("8xP5p");

var $02uF4 = parcelRequire("02uF4");

var $jIrAL = parcelRequire("jIrAL");

var $dBsUf = parcelRequire("dBsUf");

var $ac9wP = parcelRequire("ac9wP");

var $41AHY = parcelRequire("41AHY");

var $htSut = parcelRequire("htSut");

var $6b0aG = parcelRequire("6b0aG");

var $7UNcR = parcelRequire("7UNcR");

var $kausY = parcelRequire("kausY");

var $1u0KT = parcelRequire("1u0KT");
var $5b723b129baa13f6$var$un = Object.defineProperty;
var $5b723b129baa13f6$var$s = (e, t)=>$5b723b129baa13f6$var$un(e, "name", {
        value: t,
        configurable: !0
    });
function $5b723b129baa13f6$var$ce(e) {
    const t = (0, $acw62.createContext)(null);
    return t.displayName = e, t;
}
$5b723b129baa13f6$var$s($5b723b129baa13f6$var$ce, "createNullableContext");
function $5b723b129baa13f6$var$ue(e) {
    function t(n) {
        var l;
        const r = (0, $acw62.useContext)(e);
        if (r === null && n != null && n.nonNull) throw new Error(`Tried to use \`${((l = n.caller) == null ? void 0 : l.name) || t.caller.name}\` without the necessary context. Make sure to render the \`${e.displayName}Provider\` component higher up the tree.`);
        return r;
    }
    return $5b723b129baa13f6$var$s(t, "useGivenContext"), Object.defineProperty(t, "name", {
        value: `use${e.displayName}`
    }), t;
}
$5b723b129baa13f6$var$s($5b723b129baa13f6$var$ue, "createContextHook");
const $5b723b129baa13f6$export$37c52bbb9ad91dc9 = $5b723b129baa13f6$var$ce("StorageContext");
function $5b723b129baa13f6$export$391446ce2f0d1557(e) {
    const t = (0, $acw62.useRef)(!0), [n, r] = (0, $acw62.useState)(new (0, $5mhgG.StorageAPI)(e.storage));
    return (0, $acw62.useEffect)(()=>{
        t.current ? t.current = !1 : r(new (0, $5mhgG.StorageAPI)(e.storage));
    }, [
        e.storage
    ]), /* @__PURE__ */ (0, $ayMG0.jsx)($5b723b129baa13f6$export$37c52bbb9ad91dc9.Provider, {
        value: n,
        children: e.children
    });
}
$5b723b129baa13f6$var$s($5b723b129baa13f6$export$391446ce2f0d1557, "StorageContextProvider");
const $5b723b129baa13f6$export$1d88f1dc01e47b0e = $5b723b129baa13f6$var$ue($5b723b129baa13f6$export$37c52bbb9ad91dc9), $5b723b129baa13f6$var$Bn = /* @__PURE__ */ $5b723b129baa13f6$var$s(({ title: e, titleId: t, ...n })=>/* @__PURE__ */ $acw62.createElement("svg", {
        height: "1em",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": t,
        ...n
    }, e ? /* @__PURE__ */ $acw62.createElement("title", {
        id: t
    }, e) : null, /* @__PURE__ */ $acw62.createElement("path", {
        d: "M5.0484 1.40838C6.12624 0.33054 7.87376 0.330541 8.9516 1.40838L12.5916 5.0484C13.6695 6.12624 13.6695 7.87376 12.5916 8.9516L8.9516 12.5916C7.87376 13.6695 6.12624 13.6695 5.0484 12.5916L1.40838 8.9516C0.33054 7.87376 0.330541 6.12624 1.40838 5.0484L5.0484 1.40838Z",
        stroke: "currentColor",
        strokeWidth: 1.2
    }), /* @__PURE__ */ $acw62.createElement("rect", {
        x: 6,
        y: 6,
        width: 2,
        height: 2,
        rx: 1,
        fill: "currentColor"
    })), "SvgArgument"), $5b723b129baa13f6$var$Wn = /* @__PURE__ */ $5b723b129baa13f6$var$s(({ title: e, titleId: t, ...n })=>/* @__PURE__ */ $acw62.createElement("svg", {
        height: "1em",
        viewBox: "0 0 14 9",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": t,
        ...n
    }, e ? /* @__PURE__ */ $acw62.createElement("title", {
        id: t
    }, e) : null, /* @__PURE__ */ $acw62.createElement("path", {
        d: "M1 1L7 7L13 1",
        stroke: "currentColor",
        strokeWidth: 1.5
    })), "SvgChevronDown"), $5b723b129baa13f6$var$$n = /* @__PURE__ */ $5b723b129baa13f6$var$s(({ title: e, titleId: t, ...n })=>/* @__PURE__ */ $acw62.createElement("svg", {
        height: "1em",
        viewBox: "0 0 7 10",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": t,
        ...n
    }, e ? /* @__PURE__ */ $acw62.createElement("title", {
        id: t
    }, e) : null, /* @__PURE__ */ $acw62.createElement("path", {
        d: "M6 1.04819L2 5.04819L6 9.04819",
        stroke: "currentColor",
        strokeWidth: 1.75
    })), "SvgChevronLeft"), $5b723b129baa13f6$var$_n = /* @__PURE__ */ $5b723b129baa13f6$var$s(({ title: e, titleId: t, ...n })=>/* @__PURE__ */ $acw62.createElement("svg", {
        height: "1em",
        viewBox: "0 0 14 9",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": t,
        ...n
    }, e ? /* @__PURE__ */ $acw62.createElement("title", {
        id: t
    }, e) : null, /* @__PURE__ */ $acw62.createElement("path", {
        d: "M13 8L7 2L1 8",
        stroke: "currentColor",
        strokeWidth: 1.5
    })), "SvgChevronUp"), $5b723b129baa13f6$var$Zn = /* @__PURE__ */ $5b723b129baa13f6$var$s(({ title: e, titleId: t, ...n })=>/* @__PURE__ */ $acw62.createElement("svg", {
        height: "1em",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": t,
        ...n
    }, e ? /* @__PURE__ */ $acw62.createElement("title", {
        id: t
    }, e) : null, /* @__PURE__ */ $acw62.createElement("path", {
        d: "M1 1L12.9998 12.9997",
        stroke: "currentColor",
        strokeWidth: 1.5
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M13 1L1.00079 13.0003",
        stroke: "currentColor",
        strokeWidth: 1.5
    })), "SvgClose"), $5b723b129baa13f6$var$Gn = /* @__PURE__ */ $5b723b129baa13f6$var$s(({ title: e, titleId: t, ...n })=>/* @__PURE__ */ $acw62.createElement("svg", {
        height: "1em",
        viewBox: "-2 -2 22 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": t,
        ...n
    }, e ? /* @__PURE__ */ $acw62.createElement("title", {
        id: t
    }, e) : null, /* @__PURE__ */ $acw62.createElement("path", {
        d: "M11.25 14.2105V15.235C11.25 16.3479 10.3479 17.25 9.23501 17.25H2.76499C1.65214 17.25 0.75 16.3479 0.75 15.235L0.75 8.76499C0.75 7.65214 1.65214 6.75 2.76499 6.75L3.78947 6.75",
        stroke: "currentColor",
        strokeWidth: 1.5
    }), /* @__PURE__ */ $acw62.createElement("rect", {
        x: 6.75,
        y: 0.75,
        width: 10.5,
        height: 10.5,
        rx: 2.2069,
        stroke: "currentColor",
        strokeWidth: 1.5
    })), "SvgCopy"), $5b723b129baa13f6$var$Qn = /* @__PURE__ */ $5b723b129baa13f6$var$s(({ title: e, titleId: t, ...n })=>/* @__PURE__ */ $acw62.createElement("svg", {
        height: "1em",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": t,
        ...n
    }, e ? /* @__PURE__ */ $acw62.createElement("title", {
        id: t
    }, e) : null, /* @__PURE__ */ $acw62.createElement("path", {
        d: "M5.0484 1.40838C6.12624 0.33054 7.87376 0.330541 8.9516 1.40838L12.5916 5.0484C13.6695 6.12624 13.6695 7.87376 12.5916 8.9516L8.9516 12.5916C7.87376 13.6695 6.12624 13.6695 5.0484 12.5916L1.40838 8.9516C0.33054 7.87376 0.330541 6.12624 1.40838 5.0484L5.0484 1.40838Z",
        stroke: "currentColor",
        strokeWidth: 1.2
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M5 9L9 5",
        stroke: "currentColor",
        strokeWidth: 1.2
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M5 5L9 9",
        stroke: "currentColor",
        strokeWidth: 1.2
    })), "SvgDeprecatedArgument"), $5b723b129baa13f6$var$zn = /* @__PURE__ */ $5b723b129baa13f6$var$s(({ title: e, titleId: t, ...n })=>/* @__PURE__ */ $acw62.createElement("svg", {
        height: "1em",
        viewBox: "0 0 12 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": t,
        ...n
    }, e ? /* @__PURE__ */ $acw62.createElement("title", {
        id: t
    }, e) : null, /* @__PURE__ */ $acw62.createElement("path", {
        d: "M4 8L8 4",
        stroke: "currentColor",
        strokeWidth: 1.2
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M4 4L8 8",
        stroke: "currentColor",
        strokeWidth: 1.2
    }), /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.5 1.2H9C9.99411 1.2 10.8 2.00589 10.8 3V9C10.8 9.99411 9.99411 10.8 9 10.8H8.5V12H9C10.6569 12 12 10.6569 12 9V3C12 1.34315 10.6569 0 9 0H8.5V1.2ZM3.5 1.2V0H3C1.34315 0 0 1.34315 0 3V9C0 10.6569 1.34315 12 3 12H3.5V10.8H3C2.00589 10.8 1.2 9.99411 1.2 9V3C1.2 2.00589 2.00589 1.2 3 1.2H3.5Z",
        fill: "currentColor"
    })), "SvgDeprecatedEnumValue"), $5b723b129baa13f6$var$jn = /* @__PURE__ */ $5b723b129baa13f6$var$s(({ title: e, titleId: t, ...n })=>/* @__PURE__ */ $acw62.createElement("svg", {
        height: "1em",
        viewBox: "0 0 12 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": t,
        ...n
    }, e ? /* @__PURE__ */ $acw62.createElement("title", {
        id: t
    }, e) : null, /* @__PURE__ */ $acw62.createElement("rect", {
        x: 0.6,
        y: 0.6,
        width: 10.8,
        height: 10.8,
        rx: 3.4,
        stroke: "currentColor",
        strokeWidth: 1.2
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M4 8L8 4",
        stroke: "currentColor",
        strokeWidth: 1.2
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M4 4L8 8",
        stroke: "currentColor",
        strokeWidth: 1.2
    })), "SvgDeprecatedField"), $5b723b129baa13f6$var$Un = /* @__PURE__ */ $5b723b129baa13f6$var$s(({ title: e, titleId: t, ...n })=>/* @__PURE__ */ $acw62.createElement("svg", {
        height: "1em",
        viewBox: "0 0.5 12 12",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": t,
        ...n
    }, e ? /* @__PURE__ */ $acw62.createElement("title", {
        id: t
    }, e) : null, /* @__PURE__ */ $acw62.createElement("rect", {
        x: 7,
        y: 5.5,
        width: 2,
        height: 2,
        rx: 1,
        transform: "rotate(90 7 5.5)",
        fill: "currentColor"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.8 9L10.8 9.5C10.8 10.4941 9.99411 11.3 9 11.3L3 11.3C2.00589 11.3 1.2 10.4941 1.2 9.5L1.2 9L-3.71547e-07 9L-3.93402e-07 9.5C-4.65826e-07 11.1569 1.34314 12.5 3 12.5L9 12.5C10.6569 12.5 12 11.1569 12 9.5L12 9L10.8 9ZM10.8 4L12 4L12 3.5C12 1.84315 10.6569 0.5 9 0.5L3 0.5C1.34315 0.5 -5.87117e-08 1.84315 -1.31135e-07 3.5L-1.5299e-07 4L1.2 4L1.2 3.5C1.2 2.50589 2.00589 1.7 3 1.7L9 1.7C9.99411 1.7 10.8 2.50589 10.8 3.5L10.8 4Z",
        fill: "currentColor"
    })), "SvgDirective"), $5b723b129baa13f6$var$Kn = /* @__PURE__ */ $5b723b129baa13f6$var$s(({ title: e, titleId: t, ...n })=>/* @__PURE__ */ $acw62.createElement("svg", {
        height: "1em",
        viewBox: "0 0 20 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": t,
        ...n
    }, e ? /* @__PURE__ */ $acw62.createElement("title", {
        id: t
    }, e) : null, /* @__PURE__ */ $acw62.createElement("path", {
        d: "M0.75 3C0.75 1.75736 1.75736 0.75 3 0.75H17.25C17.8023 0.75 18.25 1.19772 18.25 1.75V5.25",
        stroke: "currentColor",
        strokeWidth: 1.5
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M0.75 3C0.75 4.24264 1.75736 5.25 3 5.25H18.25C18.8023 5.25 19.25 5.69771 19.25 6.25V22.25C19.25 22.8023 18.8023 23.25 18.25 23.25H3C1.75736 23.25 0.75 22.2426 0.75 21V3Z",
        stroke: "currentColor",
        strokeWidth: 1.5
    }), /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3 5.25C1.75736 5.25 0.75 4.24264 0.75 3V21C0.75 22.2426 1.75736 23.25 3 23.25H18.25C18.8023 23.25 19.25 22.8023 19.25 22.25V6.25C19.25 5.69771 18.8023 5.25 18.25 5.25H3ZM13 11L6 11V12.5L13 12.5V11Z",
        fill: "currentColor"
    })), "SvgDocsFilled"), $5b723b129baa13f6$var$Jn = /* @__PURE__ */ $5b723b129baa13f6$var$s(({ title: e, titleId: t, ...n })=>/* @__PURE__ */ $acw62.createElement("svg", {
        height: "1em",
        viewBox: "0 0 20 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": t,
        ...n
    }, e ? /* @__PURE__ */ $acw62.createElement("title", {
        id: t
    }, e) : null, /* @__PURE__ */ $acw62.createElement("path", {
        d: "M0.75 3C0.75 4.24264 1.75736 5.25 3 5.25H17.25M0.75 3C0.75 1.75736 1.75736 0.75 3 0.75H16.25C16.8023 0.75 17.25 1.19772 17.25 1.75V5.25M0.75 3V21C0.75 22.2426 1.75736 23.25 3 23.25H18.25C18.8023 23.25 19.25 22.8023 19.25 22.25V6.25C19.25 5.69771 18.8023 5.25 18.25 5.25H17.25",
        stroke: "currentColor",
        strokeWidth: 1.5
    }), /* @__PURE__ */ $acw62.createElement("line", {
        x1: 13,
        y1: 11.75,
        x2: 6,
        y2: 11.75,
        stroke: "currentColor",
        strokeWidth: 1.5
    })), "SvgDocs"), $5b723b129baa13f6$var$Yn = /* @__PURE__ */ $5b723b129baa13f6$var$s(({ title: e, titleId: t, ...n })=>/* @__PURE__ */ $acw62.createElement("svg", {
        height: "1em",
        viewBox: "0 0 12 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": t,
        ...n
    }, e ? /* @__PURE__ */ $acw62.createElement("title", {
        id: t
    }, e) : null, /* @__PURE__ */ $acw62.createElement("rect", {
        x: 5,
        y: 5,
        width: 2,
        height: 2,
        rx: 1,
        fill: "currentColor"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.5 1.2H9C9.99411 1.2 10.8 2.00589 10.8 3V9C10.8 9.99411 9.99411 10.8 9 10.8H8.5V12H9C10.6569 12 12 10.6569 12 9V3C12 1.34315 10.6569 0 9 0H8.5V1.2ZM3.5 1.2V0H3C1.34315 0 0 1.34315 0 3V9C0 10.6569 1.34315 12 3 12H3.5V10.8H3C2.00589 10.8 1.2 9.99411 1.2 9V3C1.2 2.00589 2.00589 1.2 3 1.2H3.5Z",
        fill: "currentColor"
    })), "SvgEnumValue"), $5b723b129baa13f6$var$Xn = /* @__PURE__ */ $5b723b129baa13f6$var$s(({ title: e, titleId: t, ...n })=>/* @__PURE__ */ $acw62.createElement("svg", {
        height: "1em",
        viewBox: "0 0 12 13",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": t,
        ...n
    }, e ? /* @__PURE__ */ $acw62.createElement("title", {
        id: t
    }, e) : null, /* @__PURE__ */ $acw62.createElement("rect", {
        x: 0.6,
        y: 1.1,
        width: 10.8,
        height: 10.8,
        rx: 2.4,
        stroke: "currentColor",
        strokeWidth: 1.2
    }), /* @__PURE__ */ $acw62.createElement("rect", {
        x: 5,
        y: 5.5,
        width: 2,
        height: 2,
        rx: 1,
        fill: "currentColor"
    })), "SvgField"), $5b723b129baa13f6$var$er = /* @__PURE__ */ $5b723b129baa13f6$var$s(({ title: e, titleId: t, ...n })=>/* @__PURE__ */ $acw62.createElement("svg", {
        height: "1em",
        viewBox: "0 0 24 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": t,
        ...n
    }, e ? /* @__PURE__ */ $acw62.createElement("title", {
        id: t
    }, e) : null, /* @__PURE__ */ $acw62.createElement("path", {
        d: "M1.59375 9.52344L4.87259 12.9944L8.07872 9.41249",
        stroke: "currentColor",
        strokeWidth: 1.5,
        strokeLinecap: "square"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M13.75 5.25V10.75H18.75",
        stroke: "currentColor",
        strokeWidth: 1.5,
        strokeLinecap: "square"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M4.95427 11.9332C4.55457 10.0629 4.74441 8.11477 5.49765 6.35686C6.25089 4.59894 7.5305 3.11772 9.16034 2.11709C10.7902 1.11647 12.6901 0.645626 14.5986 0.769388C16.5071 0.893151 18.3303 1.60543 19.8172 2.80818C21.3042 4.01093 22.3818 5.64501 22.9017 7.48548C23.4216 9.32595 23.3582 11.2823 22.7203 13.0853C22.0824 14.8883 20.9013 16.4492 19.3396 17.5532C17.778 18.6572 15.9125 19.25 14 19.25",
        stroke: "currentColor",
        strokeWidth: 1.5
    })), "SvgHistory"), $5b723b129baa13f6$var$tr = /* @__PURE__ */ $5b723b129baa13f6$var$s(({ title: e, titleId: t, ...n })=>/* @__PURE__ */ $acw62.createElement("svg", {
        height: "1em",
        viewBox: "0 0 12 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": t,
        ...n
    }, e ? /* @__PURE__ */ $acw62.createElement("title", {
        id: t
    }, e) : null, /* @__PURE__ */ $acw62.createElement("circle", {
        cx: 6,
        cy: 6,
        r: 5.4,
        stroke: "currentColor",
        strokeWidth: 1.2,
        strokeDasharray: "4.241025 4.241025",
        transform: "rotate(22.5)",
        "transform-origin": "center"
    }), /* @__PURE__ */ $acw62.createElement("circle", {
        cx: 6,
        cy: 6,
        r: 1,
        fill: "currentColor"
    })), "SvgImplements"), $5b723b129baa13f6$var$nr = /* @__PURE__ */ $5b723b129baa13f6$var$s(({ title: e, titleId: t, ...n })=>/* @__PURE__ */ $acw62.createElement("svg", {
        height: "1em",
        viewBox: "0 0 19 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": t,
        ...n
    }, e ? /* @__PURE__ */ $acw62.createElement("title", {
        id: t
    }, e) : null, /* @__PURE__ */ $acw62.createElement("path", {
        d: "M1.5 14.5653C1.5 15.211 1.75652 15.8303 2.21314 16.2869C2.66975 16.7435 3.28905 17 3.9348 17C4.58054 17 5.19984 16.7435 5.65646 16.2869C6.11307 15.8303 6.36959 15.211 6.36959 14.5653V12.1305H3.9348C3.28905 12.1305 2.66975 12.387 2.21314 12.8437C1.75652 13.3003 1.5 13.9195 1.5 14.5653Z",
        stroke: "currentColor",
        strokeWidth: 1.125,
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M3.9348 1.00063C3.28905 1.00063 2.66975 1.25715 2.21314 1.71375C1.75652 2.17035 1.5 2.78964 1.5 3.43537C1.5 4.0811 1.75652 4.70038 2.21314 5.15698C2.66975 5.61358 3.28905 5.8701 3.9348 5.8701H6.36959V3.43537C6.36959 2.78964 6.11307 2.17035 5.65646 1.71375C5.19984 1.25715 4.58054 1.00063 3.9348 1.00063Z",
        stroke: "currentColor",
        strokeWidth: 1.125,
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M15.0652 12.1305H12.6304V14.5653C12.6304 15.0468 12.7732 15.5175 13.0407 15.9179C13.3083 16.3183 13.6885 16.6304 14.1334 16.8147C14.5783 16.9989 15.0679 17.0472 15.5402 16.9532C16.0125 16.8593 16.4464 16.6274 16.7869 16.2869C17.1274 15.9464 17.3593 15.5126 17.4532 15.0403C17.5472 14.568 17.4989 14.0784 17.3147 13.6335C17.1304 13.1886 16.8183 12.8084 16.4179 12.5409C16.0175 12.2733 15.5468 12.1305 15.0652 12.1305Z",
        stroke: "currentColor",
        strokeWidth: 1.125,
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M12.6318 5.86775H6.36955V12.1285H12.6318V5.86775Z",
        stroke: "currentColor",
        strokeWidth: 1.125,
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M17.5 3.43473C17.5 2.789 17.2435 2.16972 16.7869 1.71312C16.3303 1.25652 15.711 1 15.0652 1C14.4195 1 13.8002 1.25652 13.3435 1.71312C12.8869 2.16972 12.6304 2.789 12.6304 3.43473V5.86946H15.0652C15.711 5.86946 16.3303 5.61295 16.7869 5.15635C17.2435 4.69975 17.5 4.08046 17.5 3.43473Z",
        stroke: "currentColor",
        strokeWidth: 1.125,
        strokeLinecap: "round",
        strokeLinejoin: "round"
    })), "SvgKeyboardShortcut"), $5b723b129baa13f6$var$rr = /* @__PURE__ */ $5b723b129baa13f6$var$s(({ title: e, titleId: t, ...n })=>/* @__PURE__ */ $acw62.createElement("svg", {
        height: "1em",
        viewBox: "0 0 13 13",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": t,
        ...n
    }, e ? /* @__PURE__ */ $acw62.createElement("title", {
        id: t
    }, e) : null, /* @__PURE__ */ $acw62.createElement("circle", {
        cx: 5,
        cy: 5,
        r: 4.35,
        stroke: "currentColor",
        strokeWidth: 1.3
    }), /* @__PURE__ */ $acw62.createElement("line", {
        x1: 8.45962,
        y1: 8.54038,
        x2: 11.7525,
        y2: 11.8333,
        stroke: "currentColor",
        strokeWidth: 1.3
    })), "SvgMagnifyingGlass"), $5b723b129baa13f6$var$or = /* @__PURE__ */ $5b723b129baa13f6$var$s(({ title: e, titleId: t, ...n })=>/* @__PURE__ */ $acw62.createElement("svg", {
        height: "1em",
        viewBox: "-2 -2 22 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": t,
        ...n
    }, e ? /* @__PURE__ */ $acw62.createElement("title", {
        id: t
    }, e) : null, /* @__PURE__ */ $acw62.createElement("path", {
        d: "M17.2492 6V2.9569C17.2492 1.73806 16.2611 0.75 15.0423 0.75L2.9569 0.75C1.73806 0.75 0.75 1.73806 0.75 2.9569L0.75 6",
        stroke: "currentColor",
        strokeWidth: 1.5
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M0.749873 12V15.0431C0.749873 16.2619 1.73794 17.25 2.95677 17.25H15.0421C16.261 17.25 17.249 16.2619 17.249 15.0431V12",
        stroke: "currentColor",
        strokeWidth: 1.5
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M6 4.5L9 7.5L12 4.5",
        stroke: "currentColor",
        strokeWidth: 1.5
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M12 13.5L9 10.5L6 13.5",
        stroke: "currentColor",
        strokeWidth: 1.5
    })), "SvgMerge"), $5b723b129baa13f6$var$lr = /* @__PURE__ */ $5b723b129baa13f6$var$s(({ title: e, titleId: t, ...n })=>/* @__PURE__ */ $acw62.createElement("svg", {
        height: "1em",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": t,
        ...n
    }, e ? /* @__PURE__ */ $acw62.createElement("title", {
        id: t
    }, e) : null, /* @__PURE__ */ $acw62.createElement("path", {
        d: "M0.75 13.25L0.0554307 12.967C-0.0593528 13.2488 0.00743073 13.5719 0.224488 13.7851C0.441545 13.9983 0.765869 14.0592 1.04549 13.9393L0.75 13.25ZM12.8214 1.83253L12.2911 2.36286L12.2911 2.36286L12.8214 1.83253ZM12.8214 3.90194L13.3517 4.43227L12.8214 3.90194ZM10.0981 1.17859L9.56773 0.648259L10.0981 1.17859ZM12.1675 1.17859L12.6978 0.648258L12.6978 0.648257L12.1675 1.17859ZM2.58049 8.75697L3.27506 9.03994L2.58049 8.75697ZM2.70066 8.57599L3.23099 9.10632L2.70066 8.57599ZM5.2479 11.4195L4.95355 10.7297L5.2479 11.4195ZM5.42036 11.303L4.89003 10.7727L5.42036 11.303ZM4.95355 10.7297C4.08882 11.0987 3.41842 11.362 2.73535 11.6308C2.05146 11.9 1.35588 12.1743 0.454511 12.5607L1.04549 13.9393C1.92476 13.5624 2.60256 13.2951 3.28469 13.0266C3.96762 12.7578 4.65585 12.4876 5.54225 12.1093L4.95355 10.7297ZM1.44457 13.533L3.27506 9.03994L1.88592 8.474L0.0554307 12.967L1.44457 13.533ZM3.23099 9.10632L10.6284 1.70892L9.56773 0.648259L2.17033 8.04566L3.23099 9.10632ZM11.6371 1.70892L12.2911 2.36286L13.3517 1.3022L12.6978 0.648258L11.6371 1.70892ZM12.2911 3.37161L4.89003 10.7727L5.95069 11.8333L13.3517 4.43227L12.2911 3.37161ZM12.2911 2.36286C12.5696 2.64142 12.5696 3.09305 12.2911 3.37161L13.3517 4.43227C14.2161 3.56792 14.2161 2.16654 13.3517 1.3022L12.2911 2.36286ZM10.6284 1.70892C10.9069 1.43036 11.3586 1.43036 11.6371 1.70892L12.6978 0.648257C11.8335 -0.216088 10.4321 -0.216084 9.56773 0.648259L10.6284 1.70892ZM3.27506 9.03994C3.26494 9.06479 3.24996 9.08735 3.23099 9.10632L2.17033 8.04566C2.04793 8.16806 1.95123 8.31369 1.88592 8.474L3.27506 9.03994ZM5.54225 12.1093C5.69431 12.0444 5.83339 11.9506 5.95069 11.8333L4.89003 10.7727C4.90863 10.7541 4.92988 10.7398 4.95355 10.7297L5.54225 12.1093Z",
        fill: "currentColor"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M11.5 4.5L9.5 2.5",
        stroke: "currentColor",
        strokeWidth: 1.4026,
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M5.5 10.5L3.5 8.5",
        stroke: "currentColor",
        strokeWidth: 1.4026,
        strokeLinecap: "round",
        strokeLinejoin: "round"
    })), "SvgPen"), $5b723b129baa13f6$var$ir = /* @__PURE__ */ $5b723b129baa13f6$var$s(({ title: e, titleId: t, ...n })=>/* @__PURE__ */ $acw62.createElement("svg", {
        height: "1em",
        viewBox: "0 0 16 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": t,
        ...n
    }, e ? /* @__PURE__ */ $acw62.createElement("title", {
        id: t
    }, e) : null, /* @__PURE__ */ $acw62.createElement("path", {
        d: "M1.32226e-07 1.6609C7.22332e-08 0.907329 0.801887 0.424528 1.46789 0.777117L15.3306 8.11621C16.0401 8.49182 16.0401 9.50818 15.3306 9.88379L1.46789 17.2229C0.801886 17.5755 1.36076e-06 17.0927 1.30077e-06 16.3391L1.32226e-07 1.6609Z",
        fill: "currentColor"
    })), "SvgPlay"), $5b723b129baa13f6$var$sr = /* @__PURE__ */ $5b723b129baa13f6$var$s(({ title: e, titleId: t, ...n })=>/* @__PURE__ */ $acw62.createElement("svg", {
        height: "1em",
        viewBox: "0 0 10 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": t,
        ...n
    }, e ? /* @__PURE__ */ $acw62.createElement("title", {
        id: t
    }, e) : null, /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4.25 9.25V13.5H5.75V9.25L10 9.25V7.75L5.75 7.75V3.5H4.25V7.75L0 7.75V9.25L4.25 9.25Z",
        fill: "currentColor"
    })), "SvgPlus"), $5b723b129baa13f6$var$ar = /* @__PURE__ */ $5b723b129baa13f6$var$s(({ title: e, titleId: t, ...n })=>/* @__PURE__ */ $acw62.createElement("svg", {
        width: 25,
        height: 25,
        viewBox: "0 0 25 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": t,
        ...n
    }, e ? /* @__PURE__ */ $acw62.createElement("title", {
        id: t
    }, e) : null, /* @__PURE__ */ $acw62.createElement("path", {
        d: "M10.2852 24.0745L13.7139 18.0742",
        stroke: "currentColor",
        strokeWidth: 1.5625
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M14.5742 24.0749L17.1457 19.7891",
        stroke: "currentColor",
        strokeWidth: 1.5625
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M19.4868 24.0735L20.7229 21.7523C21.3259 20.6143 21.5457 19.3122 21.3496 18.0394C21.1535 16.7666 20.5519 15.591 19.6342 14.6874L23.7984 6.87853C24.0123 6.47728 24.0581 6.00748 23.9256 5.57249C23.7932 5.1375 23.4933 4.77294 23.0921 4.55901C22.6908 4.34509 22.221 4.29932 21.7861 4.43178C21.3511 4.56424 20.9865 4.86408 20.7726 5.26533L16.6084 13.0742C15.3474 12.8142 14.0362 12.9683 12.8699 13.5135C11.7035 14.0586 10.7443 14.9658 10.135 16.1L6 24.0735",
        stroke: "currentColor",
        strokeWidth: 1.5625
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M4 15L5 13L7 12L5 11L4 9L3 11L1 12L3 13L4 15Z",
        stroke: "currentColor",
        strokeWidth: 1.5625,
        strokeLinejoin: "round"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M11.5 8L12.6662 5.6662L15 4.5L12.6662 3.3338L11.5 1L10.3338 3.3338L8 4.5L10.3338 5.6662L11.5 8Z",
        stroke: "currentColor",
        strokeWidth: 1.5625,
        strokeLinejoin: "round"
    })), "SvgPrettify"), $5b723b129baa13f6$var$cr = /* @__PURE__ */ $5b723b129baa13f6$var$s(({ title: e, titleId: t, ...n })=>/* @__PURE__ */ $acw62.createElement("svg", {
        height: "1em",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": t,
        ...n
    }, e ? /* @__PURE__ */ $acw62.createElement("title", {
        id: t
    }, e) : null, /* @__PURE__ */ $acw62.createElement("path", {
        d: "M4.75 9.25H1.25V12.75",
        stroke: "currentColor",
        strokeWidth: 1,
        strokeLinecap: "square"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M11.25 6.75H14.75V3.25",
        stroke: "currentColor",
        strokeWidth: 1,
        strokeLinecap: "square"
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M14.1036 6.65539C13.8 5.27698 13.0387 4.04193 11.9437 3.15131C10.8487 2.26069 9.48447 1.76694 8.0731 1.75043C6.66173 1.73392 5.28633 2.19563 4.17079 3.0604C3.05526 3.92516 2.26529 5.14206 1.92947 6.513",
        stroke: "currentColor",
        strokeWidth: 1
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M1.89635 9.34461C2.20001 10.723 2.96131 11.9581 4.05631 12.8487C5.15131 13.7393 6.51553 14.2331 7.9269 14.2496C9.33827 14.2661 10.7137 13.8044 11.8292 12.9396C12.9447 12.0748 13.7347 10.8579 14.0705 9.487",
        stroke: "currentColor",
        strokeWidth: 1
    })), "SvgReload"), $5b723b129baa13f6$var$ur = /* @__PURE__ */ $5b723b129baa13f6$var$s(({ title: e, titleId: t, ...n })=>/* @__PURE__ */ $acw62.createElement("svg", {
        height: "1em",
        viewBox: "0 0 13 13",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": t,
        ...n
    }, e ? /* @__PURE__ */ $acw62.createElement("title", {
        id: t
    }, e) : null, /* @__PURE__ */ $acw62.createElement("rect", {
        x: 0.6,
        y: 0.6,
        width: 11.8,
        height: 11.8,
        rx: 5.9,
        stroke: "currentColor",
        strokeWidth: 1.2
    }), /* @__PURE__ */ $acw62.createElement("path", {
        d: "M4.25 7.5C4.25 6 5.75 5 6.5 6.5C7.25 8 8.75 7 8.75 5.5",
        stroke: "currentColor",
        strokeWidth: 1.2
    })), "SvgRootType"), $5b723b129baa13f6$var$dr = /* @__PURE__ */ $5b723b129baa13f6$var$s(({ title: e, titleId: t, ...n })=>/* @__PURE__ */ $acw62.createElement("svg", {
        height: "1em",
        viewBox: "0 0 21 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": t,
        ...n
    }, e ? /* @__PURE__ */ $acw62.createElement("title", {
        id: t
    }, e) : null, /* @__PURE__ */ $acw62.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.29186 1.92702C9.06924 1.82745 8.87014 1.68202 8.70757 1.50024L7.86631 0.574931C7.62496 0.309957 7.30773 0.12592 6.95791 0.0479385C6.60809 -0.0300431 6.24274 0.00182978 5.91171 0.139208C5.58068 0.276585 5.3001 0.512774 5.10828 0.815537C4.91645 1.1183 4.82272 1.47288 4.83989 1.83089L4.90388 3.08019C4.91612 3.32348 4.87721 3.56662 4.78968 3.79394C4.70215 4.02126 4.56794 4.2277 4.39571 4.39994C4.22347 4.57219 4.01704 4.7064 3.78974 4.79394C3.56243 4.88147 3.3193 4.92038 3.07603 4.90814L1.8308 4.84414C1.47162 4.82563 1.11553 4.91881 0.811445 5.11086C0.507359 5.30292 0.270203 5.58443 0.132561 5.91671C-0.00508149 6.249 -0.0364554 6.61576 0.0427496 6.9666C0.121955 7.31744 0.307852 7.63514 0.5749 7.87606L1.50016 8.71204C1.68193 8.87461 1.82735 9.07373 1.92692 9.29636C2.02648 9.51898 2.07794 9.76012 2.07794 10.004C2.07794 10.2479 2.02648 10.489 1.92692 10.7116C1.82735 10.9343 1.68193 11.1334 1.50016 11.296L0.5749 12.1319C0.309856 12.3729 0.125575 12.6898 0.0471809 13.0393C-0.0312128 13.3888 9.64098e-05 13.754 0.13684 14.0851C0.273583 14.4162 0.509106 14.6971 0.811296 14.8894C1.11349 15.0817 1.46764 15.1762 1.82546 15.1599L3.0707 15.0959C3.31397 15.0836 3.5571 15.1225 3.7844 15.2101C4.01171 15.2976 4.21814 15.4318 4.39037 15.6041C4.56261 15.7763 4.69682 15.9827 4.78435 16.2101C4.87188 16.4374 4.91078 16.6805 4.89855 16.9238L4.83455 18.1691C4.81605 18.5283 4.90921 18.8844 5.10126 19.1885C5.2933 19.4926 5.5748 19.7298 5.90707 19.8674C6.23934 20.0051 6.60608 20.0365 6.9569 19.9572C7.30772 19.878 7.6254 19.6921 7.86631 19.4251L8.7129 18.4998C8.87547 18.318 9.07458 18.1725 9.29719 18.073C9.51981 17.9734 9.76093 17.9219 10.0048 17.9219C10.2487 17.9219 10.4898 17.9734 10.7124 18.073C10.935 18.1725 11.1341 18.318 11.2967 18.4998L12.1326 19.4251C12.3735 19.6921 12.6912 19.878 13.042 19.9572C13.3929 20.0365 13.7596 20.0051 14.0919 19.8674C14.4241 19.7298 14.7056 19.4926 14.8977 19.1885C15.0897 18.8844 15.1829 18.5283 15.1644 18.1691L15.1004 16.9238C15.0882 16.6805 15.1271 16.4374 15.2146 16.2101C15.3021 15.9827 15.4363 15.7763 15.6086 15.6041C15.7808 15.4318 15.9872 15.2976 16.2145 15.2101C16.4418 15.1225 16.685 15.0836 16.9282 15.0959L18.1735 15.1599C18.5326 15.1784 18.8887 15.0852 19.1928 14.8931C19.4969 14.7011 19.7341 14.4196 19.8717 14.0873C20.0093 13.755 20.0407 13.3882 19.9615 13.0374C19.8823 12.6866 19.6964 12.3689 19.4294 12.1279L18.5041 11.292C18.3223 11.1294 18.1769 10.9303 18.0774 10.7076C17.9778 10.485 17.9263 10.2439 17.9263 10C17.9263 9.75612 17.9778 9.51499 18.0774 9.29236C18.1769 9.06973 18.3223 8.87062 18.5041 8.70804L19.4294 7.87206C19.6964 7.63114 19.8823 7.31344 19.9615 6.9626C20.0407 6.61176 20.0093 6.245 19.8717 5.91271C19.7341 5.58043 19.4969 5.29892 19.1928 5.10686C18.8887 4.91481 18.5326 4.82163 18.1735 4.84014L16.9282 4.90414C16.685 4.91638 16.4418 4.87747 16.2145 4.78994C15.9872 4.7024 15.7808 4.56818 15.6086 4.39594C15.4363 4.2237 15.3021 4.01726 15.2146 3.78994C15.1271 3.56262 15.0882 3.31948 15.1004 3.07619L15.1644 1.83089C15.1829 1.4717 15.0897 1.11559 14.8977 0.811487C14.7056 0.507385 14.4241 0.270217 14.0919 0.132568C13.7596 -0.00508182 13.3929 -0.0364573 13.042 0.0427519C12.6912 0.121961 12.3735 0.307869 12.1326 0.574931L11.2914 1.50024C11.1288 1.68202 10.9297 1.82745 10.7071 1.92702C10.4845 2.02659 10.2433 2.07805 9.99947 2.07805C9.7556 2.07805 9.51448 2.02659 9.29186 1.92702ZM14.3745 10C14.3745 12.4162 12.4159 14.375 9.99977 14.375C7.58365 14.375 5.625 12.4162 5.625 10C5.625 7.58375 7.58365 5.625 9.99977 5.625C12.4159 5.625 14.3745 7.58375 14.3745 10Z",
        fill: "currentColor"
    })), "SvgSettings"), $5b723b129baa13f6$var$hr = /* @__PURE__ */ $5b723b129baa13f6$var$s(({ title: e, titleId: t, ...n })=>/* @__PURE__ */ $acw62.createElement("svg", {
        height: "1em",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": t,
        ...n
    }, e ? /* @__PURE__ */ $acw62.createElement("title", {
        id: t
    }, e) : null, /* @__PURE__ */ $acw62.createElement("path", {
        d: "M6.5782 1.07092C6.71096 0.643026 7.28904 0.643027 7.4218 1.07092L8.59318 4.84622C8.65255 5.03758 8.82284 5.16714 9.01498 5.16714L12.8056 5.16714C13.2353 5.16714 13.4139 5.74287 13.0663 6.00732L9.99962 8.34058C9.84418 8.45885 9.77913 8.66848 9.83851 8.85984L11.0099 12.6351C11.1426 13.063 10.675 13.4189 10.3274 13.1544L7.26069 10.8211C7.10524 10.7029 6.89476 10.7029 6.73931 10.8211L3.6726 13.1544C3.32502 13.4189 2.85735 13.063 2.99012 12.6351L4.16149 8.85984C4.22087 8.66848 4.15582 8.45885 4.00038 8.34058L0.933671 6.00732C0.586087 5.74287 0.764722 5.16714 1.19436 5.16714L4.98502 5.16714C5.17716 5.16714 5.34745 5.03758 5.40682 4.84622L6.5782 1.07092Z",
        fill: "currentColor",
        stroke: "currentColor"
    })), "SvgStarFilled"), $5b723b129baa13f6$var$mr = /* @__PURE__ */ $5b723b129baa13f6$var$s(({ title: e, titleId: t, ...n })=>/* @__PURE__ */ $acw62.createElement("svg", {
        height: "1em",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": t,
        ...n
    }, e ? /* @__PURE__ */ $acw62.createElement("title", {
        id: t
    }, e) : null, /* @__PURE__ */ $acw62.createElement("path", {
        d: "M6.5782 1.07092C6.71096 0.643026 7.28904 0.643027 7.4218 1.07092L8.59318 4.84622C8.65255 5.03758 8.82284 5.16714 9.01498 5.16714L12.8056 5.16714C13.2353 5.16714 13.4139 5.74287 13.0663 6.00732L9.99962 8.34058C9.84418 8.45885 9.77913 8.66848 9.83851 8.85984L11.0099 12.6351C11.1426 13.063 10.675 13.4189 10.3274 13.1544L7.26069 10.8211C7.10524 10.7029 6.89476 10.7029 6.73931 10.8211L3.6726 13.1544C3.32502 13.4189 2.85735 13.063 2.99012 12.6351L4.16149 8.85984C4.22087 8.66848 4.15582 8.45885 4.00038 8.34058L0.933671 6.00732C0.586087 5.74287 0.764722 5.16714 1.19436 5.16714L4.98502 5.16714C5.17716 5.16714 5.34745 5.03758 5.40682 4.84622L6.5782 1.07092Z",
        stroke: "currentColor",
        strokeWidth: 1.5
    })), "SvgStar"), $5b723b129baa13f6$var$fr = /* @__PURE__ */ $5b723b129baa13f6$var$s(({ title: e, titleId: t, ...n })=>/* @__PURE__ */ $acw62.createElement("svg", {
        height: "1em",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": t,
        ...n
    }, e ? /* @__PURE__ */ $acw62.createElement("title", {
        id: t
    }, e) : null, /* @__PURE__ */ $acw62.createElement("rect", {
        width: 16,
        height: 16,
        rx: 2,
        fill: "currentColor"
    })), "SvgStop"), $5b723b129baa13f6$var$pr = /* @__PURE__ */ $5b723b129baa13f6$var$s(({ title: e, titleId: t, ...n })=>/* @__PURE__ */ $acw62.createElement("svg", {
        width: "1em",
        height: "5em",
        xmlns: "http://www.w3.org/2000/svg",
        fillRule: "evenodd",
        "aria-hidden": "true",
        viewBox: "0 0 23 23",
        style: {
            height: "1.5em"
        },
        clipRule: "evenodd",
        "aria-labelledby": t,
        ...n
    }, e === void 0 ? /* @__PURE__ */ $acw62.createElement("title", {
        id: t
    }, "trash icon") : e ? /* @__PURE__ */ $acw62.createElement("title", {
        id: t
    }, e) : null, /* @__PURE__ */ $acw62.createElement("path", {
        d: "M19 24h-14c-1.104 0-2-.896-2-2v-17h-1v-2h6v-1.5c0-.827.673-1.5 1.5-1.5h5c.825 0 1.5.671 1.5 1.5v1.5h6v2h-1v17c0 1.104-.896 2-2 2zm0-19h-14v16.5c0 .276.224.5.5.5h13c.276 0 .5-.224.5-.5v-16.5zm-7 7.586l3.293-3.293 1.414 1.414-3.293 3.293 3.293 3.293-1.414 1.414-3.293-3.293-3.293 3.293-1.414-1.414 3.293-3.293-3.293-3.293 1.414-1.414 3.293 3.293zm2-10.586h-4v1h4v-1z",
        fill: "currentColor",
        strokeWidth: 0.25,
        stroke: "currentColor"
    })), "SvgTrash"), $5b723b129baa13f6$var$gr = /* @__PURE__ */ $5b723b129baa13f6$var$s(({ title: e, titleId: t, ...n })=>/* @__PURE__ */ $acw62.createElement("svg", {
        height: "1em",
        viewBox: "0 0 13 13",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-labelledby": t,
        ...n
    }, e ? /* @__PURE__ */ $acw62.createElement("title", {
        id: t
    }, e) : null, /* @__PURE__ */ $acw62.createElement("rect", {
        x: 0.6,
        y: 0.6,
        width: 11.8,
        height: 11.8,
        rx: 5.9,
        stroke: "currentColor",
        strokeWidth: 1.2
    }), /* @__PURE__ */ $acw62.createElement("rect", {
        x: 5.5,
        y: 5.5,
        width: 2,
        height: 2,
        rx: 1,
        fill: "currentColor"
    })), "SvgType"), $5b723b129baa13f6$export$e0b8b1afc6387616 = $5b723b129baa13f6$var$P($5b723b129baa13f6$var$Bn), $5b723b129baa13f6$export$4857d3f3f5f8319b = $5b723b129baa13f6$var$P($5b723b129baa13f6$var$Wn), $5b723b129baa13f6$export$20bc5960c3c9eebb = $5b723b129baa13f6$var$P($5b723b129baa13f6$var$$n), $5b723b129baa13f6$export$7f01a6cbee61a0f2 = $5b723b129baa13f6$var$P($5b723b129baa13f6$var$_n), $5b723b129baa13f6$export$cae179f078f4b4a4 = $5b723b129baa13f6$var$P($5b723b129baa13f6$var$Zn), $5b723b129baa13f6$export$51b6cd98f8778f0d = $5b723b129baa13f6$var$P($5b723b129baa13f6$var$Gn), $5b723b129baa13f6$export$3dece38e5f333c21 = $5b723b129baa13f6$var$P($5b723b129baa13f6$var$Qn), $5b723b129baa13f6$export$f2559fa12473338f = $5b723b129baa13f6$var$P($5b723b129baa13f6$var$zn), $5b723b129baa13f6$export$69318f45e191d5cf = $5b723b129baa13f6$var$P($5b723b129baa13f6$var$jn), $5b723b129baa13f6$export$56acf24630a50a0f = $5b723b129baa13f6$var$P($5b723b129baa13f6$var$Un), $5b723b129baa13f6$export$9b2be5fcaf6117d1 = $5b723b129baa13f6$var$P($5b723b129baa13f6$var$Kn, "filled docs icon"), $5b723b129baa13f6$export$13c114d596b48571 = $5b723b129baa13f6$var$P($5b723b129baa13f6$var$Jn), $5b723b129baa13f6$export$efd164bba9c3659a = $5b723b129baa13f6$var$P($5b723b129baa13f6$var$Yn), $5b723b129baa13f6$export$41064d4d91086d08 = $5b723b129baa13f6$var$P($5b723b129baa13f6$var$Xn), $5b723b129baa13f6$export$8d345d913bfb227 = $5b723b129baa13f6$var$P($5b723b129baa13f6$var$er), $5b723b129baa13f6$export$89e42b2a2b168714 = $5b723b129baa13f6$var$P($5b723b129baa13f6$var$tr), $5b723b129baa13f6$export$2e8834204231f98a = $5b723b129baa13f6$var$P($5b723b129baa13f6$var$nr), $5b723b129baa13f6$export$f7658c347b037c3f = $5b723b129baa13f6$var$P($5b723b129baa13f6$var$rr), $5b723b129baa13f6$export$ec4f2b228b2eab = $5b723b129baa13f6$var$P($5b723b129baa13f6$var$or), $5b723b129baa13f6$export$eeb42689c16a5321 = $5b723b129baa13f6$var$P($5b723b129baa13f6$var$lr), $5b723b129baa13f6$export$a6630b90defda83f = $5b723b129baa13f6$var$P($5b723b129baa13f6$var$ir), $5b723b129baa13f6$export$f21ab0717a89c77f = $5b723b129baa13f6$var$P($5b723b129baa13f6$var$sr), $5b723b129baa13f6$export$1b8875f5d2ff9f24 = $5b723b129baa13f6$var$P($5b723b129baa13f6$var$ar), $5b723b129baa13f6$export$ca36f1a1d2d1ca14 = $5b723b129baa13f6$var$P($5b723b129baa13f6$var$cr), $5b723b129baa13f6$export$9463a1f0a61bd487 = $5b723b129baa13f6$var$P($5b723b129baa13f6$var$ur), $5b723b129baa13f6$export$ac4e8b8ca2b79f39 = $5b723b129baa13f6$var$P($5b723b129baa13f6$var$dr), $5b723b129baa13f6$export$b9957ed2bd2cc18b = $5b723b129baa13f6$var$P($5b723b129baa13f6$var$hr, "filled star icon"), $5b723b129baa13f6$export$2ee28caa7f1e962e = $5b723b129baa13f6$var$P($5b723b129baa13f6$var$mr), $5b723b129baa13f6$export$dc6949a98411e916 = $5b723b129baa13f6$var$P($5b723b129baa13f6$var$fr), $5b723b129baa13f6$export$d23329de703dffc4 = $5b723b129baa13f6$var$P($5b723b129baa13f6$var$pr, "trash icon"), $5b723b129baa13f6$export$ad8f8fc3bcd61b4a = $5b723b129baa13f6$var$P($5b723b129baa13f6$var$gr);
function $5b723b129baa13f6$var$P(e, t = e.name.replace("Svg", "").replaceAll(/([A-Z])/g, " $1").trimStart().toLowerCase() + " icon") {
    return e.defaultProps = {
        title: t
    }, e;
}
$5b723b129baa13f6$var$s($5b723b129baa13f6$var$P, "generateIcon");
const $5b723b129baa13f6$export$fee7dc9850636d63 = (0, $acw62.forwardRef)((e, t)=>/* @__PURE__ */ (0, $ayMG0.jsx)("button", {
        ...e,
        ref: t,
        className: (0, $1SA7b.clsx)("graphiql-un-styled", e.className)
    }));
$5b723b129baa13f6$export$fee7dc9850636d63.displayName = "UnStyledButton";
const $5b723b129baa13f6$export$353f5b6fc5456de1 = (0, $acw62.forwardRef)((e, t)=>/* @__PURE__ */ (0, $ayMG0.jsx)("button", {
        ...e,
        ref: t,
        className: (0, $1SA7b.clsx)("graphiql-button", {
            success: "graphiql-button-success",
            error: "graphiql-button-error"
        }[e.state], e.className)
    }));
$5b723b129baa13f6$export$353f5b6fc5456de1.displayName = "Button";
const $5b723b129baa13f6$export$69b1032f2ecdf404 = (0, $acw62.forwardRef)((e, t)=>/* @__PURE__ */ (0, $ayMG0.jsx)("div", {
        ...e,
        ref: t,
        className: (0, $1SA7b.clsx)("graphiql-button-group", e.className)
    }));
$5b723b129baa13f6$export$69b1032f2ecdf404.displayName = "ButtonGroup";
const $5b723b129baa13f6$var$Se = /* @__PURE__ */ $5b723b129baa13f6$var$s((e, t)=>Object.entries(t).reduce((n, [r, l])=>(n[r] = l, n), e), "createComponentGroup");
const $5b723b129baa13f6$var$qt = (0, $acw62.forwardRef)((e, t)=>/* @__PURE__ */ (0, $ayMG0.jsx)($dBsUf.Close, {
        asChild: !0,
        children: /* @__PURE__ */ (0, $ayMG0.jsxs)($5b723b129baa13f6$export$fee7dc9850636d63, {
            ...e,
            ref: t,
            type: "button",
            className: (0, $1SA7b.clsx)("graphiql-dialog-close", e.className),
            children: [
                /* @__PURE__ */ (0, $ayMG0.jsx)((0, $ac9wP.Root), {
                    children: "Close dialog"
                }),
                /* @__PURE__ */ (0, $ayMG0.jsx)($5b723b129baa13f6$export$cae179f078f4b4a4, {})
            ]
        })
    }));
$5b723b129baa13f6$var$qt.displayName = "Dialog.Close";
function $5b723b129baa13f6$export$b99ad270d48ac6b2({ children: e, ...t }) {
    return /* @__PURE__ */ (0, $ayMG0.jsx)($dBsUf.Root, {
        ...t,
        children: /* @__PURE__ */ (0, $ayMG0.jsxs)($dBsUf.Portal, {
            children: [
                /* @__PURE__ */ (0, $ayMG0.jsx)($dBsUf.Overlay, {
                    className: "graphiql-dialog-overlay"
                }),
                /* @__PURE__ */ (0, $ayMG0.jsx)($dBsUf.Content, {
                    className: "graphiql-dialog",
                    children: e
                })
            ]
        })
    });
}
$5b723b129baa13f6$var$s($5b723b129baa13f6$export$b99ad270d48ac6b2, "DialogRoot");
const $5b723b129baa13f6$export$3ddf2d174ce01153 = $5b723b129baa13f6$var$Se($5b723b129baa13f6$export$b99ad270d48ac6b2, {
    Close: $5b723b129baa13f6$var$qt,
    Title: $dBsUf.Title,
    Trigger: $dBsUf.Trigger,
    Description: $dBsUf.Description
});
const $5b723b129baa13f6$var$Pt = (0, $acw62.forwardRef)((e, t)=>/* @__PURE__ */ (0, $ayMG0.jsx)((0, $41AHY.Trigger), {
        asChild: !0,
        children: /* @__PURE__ */ (0, $ayMG0.jsx)("button", {
            ...e,
            ref: t,
            className: (0, $1SA7b.clsx)("graphiql-un-styled", e.className)
        })
    }));
$5b723b129baa13f6$var$Pt.displayName = "DropdownMenuButton";
function $5b723b129baa13f6$var$Fr({ children: e, align: t = "start", sideOffset: n = 5, className: r, ...l }) {
    return /* @__PURE__ */ (0, $ayMG0.jsx)((0, $41AHY.Portal), {
        children: /* @__PURE__ */ (0, $ayMG0.jsx)((0, $41AHY.Content), {
            align: t,
            sideOffset: n,
            className: (0, $1SA7b.clsx)("graphiql-dropdown-content", r),
            ...l,
            children: e
        })
    });
}
$5b723b129baa13f6$var$s($5b723b129baa13f6$var$Fr, "Content");
const $5b723b129baa13f6$var$Br = /* @__PURE__ */ $5b723b129baa13f6$var$s(({ className: e, children: t, ...n })=>/* @__PURE__ */ (0, $ayMG0.jsx)((0, $41AHY.Item), {
        className: (0, $1SA7b.clsx)("graphiql-dropdown-item", e),
        ...n,
        children: t
    }), "Item"), $5b723b129baa13f6$export$e44a253a59704894 = $5b723b129baa13f6$var$Se((0, $41AHY.Root), {
    Button: $5b723b129baa13f6$var$Pt,
    Item: $5b723b129baa13f6$var$Br,
    Content: $5b723b129baa13f6$var$Fr
}), $5b723b129baa13f6$var$qe = new (0, (/*@__PURE__*/$parcel$interopDefault($htSut)))({
    breaks: !0,
    linkify: !0
});
const $5b723b129baa13f6$export$759dadce87f95042 = (0, $acw62.forwardRef)(({ children: e, onlyShowFirstChild: t, type: n, ...r }, l)=>/* @__PURE__ */ (0, $ayMG0.jsx)("div", {
        ...r,
        ref: l,
        className: (0, $1SA7b.clsx)(`graphiql-markdown-${n}`, t && "graphiql-markdown-preview", r.className),
        dangerouslySetInnerHTML: {
            __html: $5b723b129baa13f6$var$qe.render(e)
        }
    }));
$5b723b129baa13f6$export$759dadce87f95042.displayName = "MarkdownContent";
const $5b723b129baa13f6$export$7f7cbe89f1eacd2 = (0, $acw62.forwardRef)((e, t)=>/* @__PURE__ */ (0, $ayMG0.jsx)("div", {
        ...e,
        ref: t,
        className: (0, $1SA7b.clsx)("graphiql-spinner", e.className)
    }));
$5b723b129baa13f6$export$7f7cbe89f1eacd2.displayName = "Spinner";
function $5b723b129baa13f6$export$c21697e1ea9173ed({ children: e, align: t = "start", side: n = "bottom", sideOffset: r = 5, label: l }) {
    return /* @__PURE__ */ (0, $ayMG0.jsxs)($7UNcR.Root, {
        children: [
            /* @__PURE__ */ (0, $ayMG0.jsx)($7UNcR.Trigger, {
                asChild: !0,
                children: e
            }),
            /* @__PURE__ */ (0, $ayMG0.jsx)($7UNcR.Portal, {
                children: /* @__PURE__ */ (0, $ayMG0.jsx)($7UNcR.Content, {
                    className: "graphiql-tooltip",
                    align: t,
                    side: n,
                    sideOffset: r,
                    children: l
                })
            })
        ]
    });
}
$5b723b129baa13f6$var$s($5b723b129baa13f6$export$c21697e1ea9173ed, "TooltipRoot");
const $5b723b129baa13f6$export$28c660c63b792dea = $5b723b129baa13f6$var$Se($5b723b129baa13f6$export$c21697e1ea9173ed, {
    Provider: $7UNcR.Provider
});
const $5b723b129baa13f6$var$It = (0, $acw62.forwardRef)(({ isActive: e, value: t, children: n, className: r, ...l }, a)=>/* @__PURE__ */ (0, $ayMG0.jsx)((0, $6b0aG.Reorder).Item, {
        ...l,
        ref: a,
        value: t,
        "aria-selected": e ? "true" : void 0,
        role: "tab",
        className: (0, $1SA7b.clsx)("graphiql-tab", e && "graphiql-tab-active", r),
        children: n
    }));
$5b723b129baa13f6$var$It.displayName = "Tab";
const $5b723b129baa13f6$var$Ot = (0, $acw62.forwardRef)((e, t)=>/* @__PURE__ */ (0, $ayMG0.jsx)($5b723b129baa13f6$export$fee7dc9850636d63, {
        ...e,
        ref: t,
        type: "button",
        className: (0, $1SA7b.clsx)("graphiql-tab-button", e.className),
        children: e.children
    }));
$5b723b129baa13f6$var$Ot.displayName = "Tab.Button";
const $5b723b129baa13f6$var$Ft = (0, $acw62.forwardRef)((e, t)=>/* @__PURE__ */ (0, $ayMG0.jsx)($5b723b129baa13f6$export$28c660c63b792dea, {
        label: "Close Tab",
        children: /* @__PURE__ */ (0, $ayMG0.jsx)($5b723b129baa13f6$export$fee7dc9850636d63, {
            "aria-label": "Close Tab",
            ...e,
            ref: t,
            type: "button",
            className: (0, $1SA7b.clsx)("graphiql-tab-close", e.className),
            children: /* @__PURE__ */ (0, $ayMG0.jsx)($5b723b129baa13f6$export$cae179f078f4b4a4, {})
        })
    }));
$5b723b129baa13f6$var$Ft.displayName = "Tab.Close";
const $5b723b129baa13f6$export$3e41faf802a29e71 = $5b723b129baa13f6$var$Se($5b723b129baa13f6$var$It, {
    Button: $5b723b129baa13f6$var$Ot,
    Close: $5b723b129baa13f6$var$Ft
}), $5b723b129baa13f6$export$b2539bed5023c21c = (0, $acw62.forwardRef)(({ values: e, onReorder: t, children: n, className: r, ...l }, a)=>/* @__PURE__ */ (0, $ayMG0.jsx)((0, $6b0aG.Reorder).Group, {
        ...l,
        ref: a,
        values: e,
        onReorder: t,
        axis: "x",
        role: "tablist",
        className: (0, $1SA7b.clsx)("graphiql-tabs", r),
        children: n
    }));
$5b723b129baa13f6$export$b2539bed5023c21c.displayName = "Tabs";
const $5b723b129baa13f6$export$2f62cb99760ab75b = $5b723b129baa13f6$var$ce("HistoryContext");
function $5b723b129baa13f6$export$a7f2b2c281690bcd(e) {
    var v;
    const t = $5b723b129baa13f6$export$1d88f1dc01e47b0e(), n = (0, $acw62.useRef)(new (0, $bWkaC.HistoryStore)(// Fall back to a noop storage when the StorageContext is empty
    t || new (0, $5mhgG.StorageAPI)(null), e.maxHistoryLength || $5b723b129baa13f6$var$Zr)), [r, l] = (0, $acw62.useState)(((v = n.current) == null ? void 0 : v.queries) || []), a = (0, $acw62.useCallback)((d)=>{
        var g;
        (g = n.current) == null || g.updateHistory(d), l(n.current.queries);
    }, []), i = (0, $acw62.useCallback)((d, g)=>{
        n.current.editLabel(d, g), l(n.current.queries);
    }, []), u = (0, $acw62.useCallback)((d)=>{
        n.current.toggleFavorite(d), l(n.current.queries);
    }, []), p = (0, $acw62.useCallback)((d)=>d, []), h = (0, $acw62.useCallback)((d, g = !1)=>{
        n.current.deleteHistory(d, g), l(n.current.queries);
    }, []), f = (0, $acw62.useMemo)(()=>({
            addToHistory: a,
            editLabel: i,
            items: r,
            toggleFavorite: u,
            setActive: p,
            deleteFromHistory: h
        }), [
        a,
        i,
        r,
        u,
        p,
        h
    ]);
    return /* @__PURE__ */ (0, $ayMG0.jsx)($5b723b129baa13f6$export$2f62cb99760ab75b.Provider, {
        value: f,
        children: e.children
    });
}
$5b723b129baa13f6$var$s($5b723b129baa13f6$export$a7f2b2c281690bcd, "HistoryContextProvider");
const $5b723b129baa13f6$export$1c946c39bb2430a4 = $5b723b129baa13f6$var$ue($5b723b129baa13f6$export$2f62cb99760ab75b), $5b723b129baa13f6$var$Zr = 20;
function $5b723b129baa13f6$export$84202caead5689ba() {
    const { items: e, deleteFromHistory: t } = $5b723b129baa13f6$export$1c946c39bb2430a4({
        nonNull: !0
    });
    let n = e.slice().map((u, p)=>({
            ...u,
            index: p
        })).reverse();
    const r = n.filter((u)=>u.favorite);
    r.length && (n = n.filter((u)=>!u.favorite));
    const [l, a] = (0, $acw62.useState)(null);
    (0, $acw62.useEffect)(()=>{
        l && setTimeout(()=>{
            a(null);
        }, 2e3);
    }, [
        l
    ]);
    const i = (0, $acw62.useCallback)(()=>{
        try {
            for (const u of n)t(u, !0);
            a("success");
        } catch  {
            a("error");
        }
    }, [
        t,
        n
    ]);
    return /* @__PURE__ */ (0, $ayMG0.jsxs)("section", {
        "aria-label": "History",
        className: "graphiql-history",
        children: [
            /* @__PURE__ */ (0, $ayMG0.jsxs)("div", {
                className: "graphiql-history-header",
                children: [
                    "History",
                    (l || n.length > 0) && /* @__PURE__ */ (0, $ayMG0.jsx)($5b723b129baa13f6$export$353f5b6fc5456de1, {
                        type: "button",
                        state: l || void 0,
                        disabled: !n.length,
                        onClick: i,
                        children: {
                            success: "Cleared",
                            error: "Failed to Clear"
                        }[l] || "Clear"
                    })
                ]
            }),
            !!r.length && /* @__PURE__ */ (0, $ayMG0.jsx)("ul", {
                className: "graphiql-history-items",
                children: r.map((u)=>/* @__PURE__ */ (0, $ayMG0.jsx)($5b723b129baa13f6$var$Pe, {
                        item: u
                    }, u.index))
            }),
            !!r.length && !!n.length && /* @__PURE__ */ (0, $ayMG0.jsx)("div", {
                className: "graphiql-history-item-spacer"
            }),
            !!n.length && /* @__PURE__ */ (0, $ayMG0.jsx)("ul", {
                className: "graphiql-history-items",
                children: n.map((u)=>/* @__PURE__ */ (0, $ayMG0.jsx)($5b723b129baa13f6$var$Pe, {
                        item: u
                    }, u.index))
            })
        ]
    });
}
$5b723b129baa13f6$var$s($5b723b129baa13f6$export$84202caead5689ba, "History");
function $5b723b129baa13f6$var$Pe(e) {
    const { editLabel: t, toggleFavorite: n, deleteFromHistory: r, setActive: l } = $5b723b129baa13f6$export$1c946c39bb2430a4({
        nonNull: !0,
        caller: $5b723b129baa13f6$var$Pe
    }), { headerEditor: a, queryEditor: i, variableEditor: u } = $5b723b129baa13f6$export$b119c82498f162a5({
        nonNull: !0,
        caller: $5b723b129baa13f6$var$Pe
    }), p = (0, $acw62.useRef)(null), h = (0, $acw62.useRef)(null), [f, v] = (0, $acw62.useState)(!1);
    (0, $acw62.useEffect)(()=>{
        var b;
        f && ((b = p.current) == null || b.focus());
    }, [
        f
    ]);
    const d = e.item.label || e.item.operationName || $5b723b129baa13f6$var$Qr(e.item.query), g = (0, $acw62.useCallback)(()=>{
        var V;
        v(!1);
        const { index: b, ...w } = e.item;
        t({
            ...w,
            label: (V = p.current) == null ? void 0 : V.value
        }, b);
    }, [
        t,
        e.item
    ]), m = (0, $acw62.useCallback)(()=>{
        v(!1);
    }, []), C = (0, $acw62.useCallback)((b)=>{
        b.stopPropagation(), v(!0);
    }, []), x = (0, $acw62.useCallback)(()=>{
        const { query: b, variables: w, headers: V } = e.item;
        i == null || i.setValue(b ?? ""), u == null || u.setValue(w ?? ""), a == null || a.setValue(V ?? ""), l(e.item);
    }, [
        a,
        e.item,
        i,
        l,
        u
    ]), k = (0, $acw62.useCallback)((b)=>{
        b.stopPropagation(), r(e.item);
    }, [
        e.item,
        r
    ]), L = (0, $acw62.useCallback)((b)=>{
        b.stopPropagation(), n(e.item);
    }, [
        e.item,
        n
    ]);
    return /* @__PURE__ */ (0, $ayMG0.jsx)("li", {
        className: (0, $1SA7b.clsx)("graphiql-history-item", f && "editable"),
        children: f ? /* @__PURE__ */ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /* @__PURE__ */ (0, $ayMG0.jsx)("input", {
                    type: "text",
                    defaultValue: e.item.label,
                    ref: p,
                    onKeyDown: (b)=>{
                        b.key === "Esc" ? v(!1) : b.key === "Enter" && (v(!1), t({
                            ...e.item,
                            label: b.currentTarget.value
                        }));
                    },
                    placeholder: "Type a label"
                }),
                /* @__PURE__ */ (0, $ayMG0.jsx)($5b723b129baa13f6$export$fee7dc9850636d63, {
                    type: "button",
                    ref: h,
                    onClick: g,
                    children: "Save"
                }),
                /* @__PURE__ */ (0, $ayMG0.jsx)($5b723b129baa13f6$export$fee7dc9850636d63, {
                    type: "button",
                    ref: h,
                    onClick: m,
                    children: /* @__PURE__ */ (0, $ayMG0.jsx)($5b723b129baa13f6$export$cae179f078f4b4a4, {})
                })
            ]
        }) : /* @__PURE__ */ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /* @__PURE__ */ (0, $ayMG0.jsx)($5b723b129baa13f6$export$28c660c63b792dea, {
                    label: "Set active",
                    children: /* @__PURE__ */ (0, $ayMG0.jsx)($5b723b129baa13f6$export$fee7dc9850636d63, {
                        type: "button",
                        className: "graphiql-history-item-label",
                        onClick: x,
                        "aria-label": "Set active",
                        children: d
                    })
                }),
                /* @__PURE__ */ (0, $ayMG0.jsx)($5b723b129baa13f6$export$28c660c63b792dea, {
                    label: "Edit label",
                    children: /* @__PURE__ */ (0, $ayMG0.jsx)($5b723b129baa13f6$export$fee7dc9850636d63, {
                        type: "button",
                        className: "graphiql-history-item-action",
                        onClick: C,
                        "aria-label": "Edit label",
                        children: /* @__PURE__ */ (0, $ayMG0.jsx)($5b723b129baa13f6$export$eeb42689c16a5321, {
                            "aria-hidden": "true"
                        })
                    })
                }),
                /* @__PURE__ */ (0, $ayMG0.jsx)($5b723b129baa13f6$export$28c660c63b792dea, {
                    label: e.item.favorite ? "Remove favorite" : "Add favorite",
                    children: /* @__PURE__ */ (0, $ayMG0.jsx)($5b723b129baa13f6$export$fee7dc9850636d63, {
                        type: "button",
                        className: "graphiql-history-item-action",
                        onClick: L,
                        "aria-label": e.item.favorite ? "Remove favorite" : "Add favorite",
                        children: e.item.favorite ? /* @__PURE__ */ (0, $ayMG0.jsx)($5b723b129baa13f6$export$b9957ed2bd2cc18b, {
                            "aria-hidden": "true"
                        }) : /* @__PURE__ */ (0, $ayMG0.jsx)($5b723b129baa13f6$export$2ee28caa7f1e962e, {
                            "aria-hidden": "true"
                        })
                    })
                }),
                /* @__PURE__ */ (0, $ayMG0.jsx)($5b723b129baa13f6$export$28c660c63b792dea, {
                    label: "Delete from history",
                    children: /* @__PURE__ */ (0, $ayMG0.jsx)($5b723b129baa13f6$export$fee7dc9850636d63, {
                        type: "button",
                        className: "graphiql-history-item-action",
                        onClick: k,
                        "aria-label": "Delete from history",
                        children: /* @__PURE__ */ (0, $ayMG0.jsx)($5b723b129baa13f6$export$d23329de703dffc4, {
                            "aria-hidden": "true"
                        })
                    })
                })
            ]
        })
    });
}
$5b723b129baa13f6$var$s($5b723b129baa13f6$var$Pe, "HistoryItem");
function $5b723b129baa13f6$var$Qr(e) {
    return e == null ? void 0 : e.split(`
`).map((t)=>t.replace(/#(.*)/, "")).join(" ").replaceAll("{", " { ").replaceAll("}", " } ").replaceAll(/[\s]{2,}/g, " ");
}
$5b723b129baa13f6$var$s($5b723b129baa13f6$var$Qr, "formatQuery");
const $5b723b129baa13f6$export$f7c638676c8af91d = $5b723b129baa13f6$var$ce("ExecutionContext");
function $5b723b129baa13f6$export$14f2a780bc6de643({ fetcher: e, getDefaultFieldNames: t, children: n, operationName: r }) {
    if (!e) throw new TypeError("The `ExecutionContextProvider` component requires a `fetcher` function to be passed as prop.");
    const { externalFragments: l, headerEditor: a, queryEditor: i, responseEditor: u, variableEditor: p, updateActiveTabValues: h } = $5b723b129baa13f6$export$b119c82498f162a5({
        nonNull: !0,
        caller: $5b723b129baa13f6$export$14f2a780bc6de643
    }), f = $5b723b129baa13f6$export$1c946c39bb2430a4(), v = $5b723b129baa13f6$export$5abb433c7a1f773e({
        getDefaultFieldNames: t,
        caller: $5b723b129baa13f6$export$14f2a780bc6de643
    }), [d, g] = (0, $acw62.useState)(!1), [m, C] = (0, $acw62.useState)(null), x = (0, $acw62.useRef)(0), k = (0, $acw62.useCallback)(()=>{
        m == null || m.unsubscribe(), g(!1), C(null);
    }, [
        m
    ]), L = (0, $acw62.useCallback)(async ()=>{
        if (!i || !u) return;
        if (m) {
            k();
            return;
        }
        const V = /* @__PURE__ */ $5b723b129baa13f6$var$s((T)=>{
            u.setValue(T), h({
                response: T
            });
        }, "setResponse");
        x.current += 1;
        const W = x.current;
        let _ = v() || i.getValue();
        const D = p == null ? void 0 : p.getValue();
        let O;
        try {
            O = $5b723b129baa13f6$var$Ct({
                json: D,
                errorMessageParse: "Variables are invalid JSON",
                errorMessageType: "Variables are not a JSON object."
            });
        } catch (T) {
            V(T instanceof Error ? T.message : `${T}`);
            return;
        }
        const $ = a == null ? void 0 : a.getValue();
        let F;
        try {
            F = $5b723b129baa13f6$var$Ct({
                json: $,
                errorMessageParse: "Headers are invalid JSON",
                errorMessageType: "Headers are not a JSON object."
            });
        } catch (T) {
            V(T instanceof Error ? T.message : `${T}`);
            return;
        }
        if (l) {
            const T = i.documentAST ? (0, $eYQLF.getFragmentDependenciesForAST)(i.documentAST, l) : [];
            T.length > 0 && (_ += `
` + T.map((H)=>(0, $3o9dz.print)(H)).join(`
`));
        }
        V(""), g(!0);
        const A = r ?? i.operationName ?? void 0;
        f == null || f.addToHistory({
            query: _,
            variables: D,
            headers: $,
            operationName: A
        });
        try {
            let T = {
                data: {}
            };
            const H = /* @__PURE__ */ $5b723b129baa13f6$var$s((y)=>{
                if (W !== x.current) return;
                let S = Array.isArray(y) ? y : !1;
                if (!S && typeof y == "object" && y !== null && "hasNext" in y && (S = [
                    y
                ]), S) {
                    const R = {
                        data: T.data
                    }, U = [
                        ...(T == null ? void 0 : T.errors) || [],
                        ...S.flatMap((Y)=>Y.errors).filter(Boolean)
                    ];
                    U.length && (R.errors = U);
                    for (const Y of S){
                        const { path: ht, data: ke, errors: Po, ...cn } = Y;
                        if (ht) {
                            if (!ke) throw new Error(`Expected part to contain a data property, but got ${Y}`);
                            (0, (/*@__PURE__*/$parcel$interopDefault($02uF4)))(R.data, ht, ke, {
                                merge: !0
                            });
                        } else ke && (R.data = ke);
                        T = {
                            ...R,
                            ...cn
                        };
                    }
                    g(!1), V((0, $a8KRF.formatResult)(T));
                } else {
                    const R = (0, $a8KRF.formatResult)(y);
                    g(!1), V(R);
                }
            }, "handleResponse"), E = e({
                query: _,
                variables: O,
                operationName: A
            }, {
                headers: F ?? void 0,
                documentAST: i.documentAST ?? void 0
            }), Z = await Promise.resolve(E);
            if ((0, $2n7MZ.isObservable)(Z)) C(Z.subscribe({
                next (y) {
                    H(y);
                },
                error (y) {
                    g(!1), y && V((0, $a8KRF.formatError)(y)), C(null);
                },
                complete () {
                    g(!1), C(null);
                }
            }));
            else if ((0, $2n7MZ.isAsyncIterable)(Z)) {
                C({
                    unsubscribe: ()=>{
                        var y, S;
                        return (S = (y = Z[Symbol.asyncIterator]()).return) == null ? void 0 : S.call(y);
                    }
                });
                for await (const y of Z)H(y);
                g(!1), C(null);
            } else H(Z);
        } catch (T) {
            g(!1), V((0, $a8KRF.formatError)(T)), C(null);
        }
    }, [
        v,
        l,
        e,
        a,
        f,
        r,
        i,
        u,
        k,
        m,
        h,
        p
    ]), b = !!m, w = (0, $acw62.useMemo)(()=>({
            isFetching: d,
            isSubscribed: b,
            operationName: r ?? null,
            run: L,
            stop: k
        }), [
        d,
        b,
        r,
        L,
        k
    ]);
    return /* @__PURE__ */ (0, $ayMG0.jsx)($5b723b129baa13f6$export$f7c638676c8af91d.Provider, {
        value: w,
        children: n
    });
}
$5b723b129baa13f6$var$s($5b723b129baa13f6$export$14f2a780bc6de643, "ExecutionContextProvider");
const $5b723b129baa13f6$export$b0467ce6d1ed861f = $5b723b129baa13f6$var$ue($5b723b129baa13f6$export$f7c638676c8af91d);
function $5b723b129baa13f6$var$Ct({ json: e, errorMessageParse: t, errorMessageType: n }) {
    let r;
    try {
        r = e && e.trim() !== "" ? JSON.parse(e) : void 0;
    } catch (a) {
        throw new Error(`${t}: ${a instanceof Error ? a.message : a}.`);
    }
    const l = typeof r == "object" && r !== null && !Array.isArray(r);
    if (r !== void 0 && !l) throw new Error(n);
    return r;
}
$5b723b129baa13f6$var$s($5b723b129baa13f6$var$Ct, "tryParseJsonObject");
const $5b723b129baa13f6$var$_e = "graphiql", $5b723b129baa13f6$var$Ze = "sublime";
let $5b723b129baa13f6$var$$t = !1;
typeof window == "object" && ($5b723b129baa13f6$var$$t = window.navigator.platform.toLowerCase().indexOf("mac") === 0);
const $5b723b129baa13f6$var$Ge = {
    // Persistent search box in Query Editor
    [$5b723b129baa13f6$var$$t ? "Cmd-F" : "Ctrl-F"]: "findPersistent",
    "Cmd-G": "findPersistent",
    "Ctrl-G": "findPersistent",
    // Editor improvements
    "Ctrl-Left": "goSubwordLeft",
    "Ctrl-Right": "goSubwordRight",
    "Alt-Left": "goGroupLeft",
    "Alt-Right": "goGroupRight"
};











async function $5b723b129baa13f6$var$Ne(e, t) {
    const n = await (parcelRequire("dPZJA")).then((r)=>r.c).then((r)=>// Depending on bundler and settings the dynamic import either returns a
        // function (e.g. parcel) or an object containing a `default` property
        typeof r == "function" ? r : r.default);
    return await Promise.all((t == null ? void 0 : t.useCommonAddons) === !1 ? e : [
        (parcelRequire("lJBCZ")).then((r)=>r.s),
        (parcelRequire("cTVBx")).then((r)=>r.m),
        (parcelRequire("gCqBl")).then((r)=>r.c),
        (parcelRequire("3gtj7")).then((r)=>r.b),
        (parcelRequire("j9HgW")).then((r)=>r.f),
        (parcelRequire("9MfZT")).then((r)=>r.l),
        (parcelRequire("bEIbx")).then((r)=>r.s),
        (parcelRequire("8dNb8")).then((r)=>r.j),
        (parcelRequire("k6ghe")).then((r)=>r.d),
        // @ts-expect-error
        (parcelRequire("2dlfv")).then((r)=>r.s),
        ...e
    ]), n;
}
$5b723b129baa13f6$var$s($5b723b129baa13f6$var$Ne, "importCodeMirror");
const $5b723b129baa13f6$var$zr = /* @__PURE__ */ $5b723b129baa13f6$var$s((e)=>e ? (0, $3o9dz.print)(e) : "", "printDefault");
function $5b723b129baa13f6$export$a4e369a19907695d({ field: e }) {
    if (!("defaultValue" in e) || e.defaultValue === void 0) return null;
    const t = (0, $3MaO2.astFromValue)(e.defaultValue, e.type);
    return t ? /* @__PURE__ */ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            " = ",
            /* @__PURE__ */ (0, $ayMG0.jsx)("span", {
                className: "graphiql-doc-explorer-default-value",
                children: $5b723b129baa13f6$var$zr(t)
            })
        ]
    }) : null;
}
$5b723b129baa13f6$var$s($5b723b129baa13f6$export$a4e369a19907695d, "DefaultValue");
const $5b723b129baa13f6$export$77f26f02a668a7e2 = $5b723b129baa13f6$var$ce("SchemaContext");
function $5b723b129baa13f6$export$ad72d84d137207fb(e) {
    if (!e.fetcher) throw new TypeError("The `SchemaContextProvider` component requires a `fetcher` function to be passed as prop.");
    const { initialHeaders: t, headerEditor: n } = $5b723b129baa13f6$export$b119c82498f162a5({
        nonNull: !0,
        caller: $5b723b129baa13f6$export$ad72d84d137207fb
    }), [r, l] = (0, $acw62.useState)(), [a, i] = (0, $acw62.useState)(!1), [u, p] = (0, $acw62.useState)(null), h = (0, $acw62.useRef)(0);
    (0, $acw62.useEffect)(()=>{
        l((0, $3rrQl.isSchema)(e.schema) || e.schema === null || e.schema === void 0 ? e.schema : void 0), h.current++;
    }, [
        e.schema
    ]);
    const f = (0, $acw62.useRef)(t);
    (0, $acw62.useEffect)(()=>{
        n && (f.current = n.getValue());
    });
    const { introspectionQuery: v, introspectionQueryName: d, introspectionQuerySansSubscriptions: g } = $5b723b129baa13f6$var$jr({
        inputValueDeprecation: e.inputValueDeprecation,
        introspectionQueryName: e.introspectionQueryName,
        schemaDescription: e.schemaDescription
    }), { fetcher: m, onSchemaChange: C, dangerouslyAssumeSchemaIsValid: x, children: k } = e, L = (0, $acw62.useCallback)(()=>{
        if ((0, $3rrQl.isSchema)(e.schema) || e.schema === null) return;
        const V = ++h.current, W = e.schema;
        async function _() {
            if (W) return W;
            const D = $5b723b129baa13f6$var$Ur(f.current);
            if (!D.isValidJSON) {
                p("Introspection failed as headers are invalid.");
                return;
            }
            const O = D.headers ? {
                headers: D.headers
            } : {}, $ = (0, $2n7MZ.fetcherReturnToPromise)(m({
                query: v,
                operationName: d
            }, O));
            if (!(0, $2n7MZ.isPromise)($)) {
                p("Fetcher did not return a Promise for introspection.");
                return;
            }
            i(!0), p(null);
            let F = await $;
            if (typeof F != "object" || F === null || !("data" in F)) {
                const T = (0, $2n7MZ.fetcherReturnToPromise)(m({
                    query: g,
                    operationName: d
                }, O));
                if (!(0, $2n7MZ.isPromise)(T)) throw new Error("Fetcher did not return a Promise for introspection.");
                F = await T;
            }
            if (i(!1), F != null && F.data && "__schema" in F.data) return F.data;
            const A = typeof F == "string" ? F : (0, $a8KRF.formatResult)(F);
            p(A);
        }
        $5b723b129baa13f6$var$s(_, "fetchIntrospectionData"), _().then((D)=>{
            if (!(V !== h.current || !D)) try {
                const O = (0, $iqtrZ.buildClientSchema)(D);
                l(O), C == null || C(O);
            } catch (O) {
                p((0, $a8KRF.formatError)(O));
            }
        }).catch((D)=>{
            V === h.current && (p((0, $a8KRF.formatError)(D)), i(!1));
        });
    }, [
        m,
        d,
        v,
        g,
        C,
        e.schema
    ]);
    (0, $acw62.useEffect)(()=>{
        L();
    }, [
        L
    ]), (0, $acw62.useEffect)(()=>{
        function V(W) {
            W.ctrlKey && W.key === "R" && L();
        }
        return $5b723b129baa13f6$var$s(V, "triggerIntrospection"), window.addEventListener("keydown", V), ()=>window.removeEventListener("keydown", V);
    });
    const b = (0, $acw62.useMemo)(()=>!r || x ? [] : (0, $dy8yN.validateSchema)(r), [
        r,
        x
    ]), w = (0, $acw62.useMemo)(()=>({
            fetchError: u,
            introspect: L,
            isFetching: a,
            schema: r,
            validationErrors: b
        }), [
        u,
        L,
        a,
        r,
        b
    ]);
    return /* @__PURE__ */ (0, $ayMG0.jsx)($5b723b129baa13f6$export$77f26f02a668a7e2.Provider, {
        value: w,
        children: k
    });
}
$5b723b129baa13f6$var$s($5b723b129baa13f6$export$ad72d84d137207fb, "SchemaContextProvider");
const $5b723b129baa13f6$export$468d7ae1c12d1956 = $5b723b129baa13f6$var$ue($5b723b129baa13f6$export$77f26f02a668a7e2);
function $5b723b129baa13f6$var$jr({ inputValueDeprecation: e, introspectionQueryName: t, schemaDescription: n }) {
    return (0, $acw62.useMemo)(()=>{
        const r = t || "IntrospectionQuery";
        let l = (0, $56ITi.getIntrospectionQuery)({
            inputValueDeprecation: e,
            schemaDescription: n
        });
        t && (l = l.replace("query IntrospectionQuery", `query ${r}`));
        const a = l.replace("subscriptionType { name }", "");
        return {
            introspectionQueryName: r,
            introspectionQuery: l,
            introspectionQuerySansSubscriptions: a
        };
    }, [
        e,
        t,
        n
    ]);
}
$5b723b129baa13f6$var$s($5b723b129baa13f6$var$jr, "useIntrospectionQuery");
function $5b723b129baa13f6$var$Ur(e) {
    let t = null, n = !0;
    try {
        e && (t = JSON.parse(e));
    } catch  {
        n = !1;
    }
    return {
        headers: t,
        isValidJSON: n
    };
}
$5b723b129baa13f6$var$s($5b723b129baa13f6$var$Ur, "parseHeaderString");
const $5b723b129baa13f6$var$Me = {
    name: "Docs"
}, $5b723b129baa13f6$export$14a7fb59424347b4 = $5b723b129baa13f6$var$ce("ExplorerContext");
function $5b723b129baa13f6$export$50f5f436c5e784bd(e) {
    const { schema: t, validationErrors: n } = $5b723b129baa13f6$export$468d7ae1c12d1956({
        nonNull: !0,
        caller: $5b723b129baa13f6$export$50f5f436c5e784bd
    }), [r, l] = (0, $acw62.useState)([
        $5b723b129baa13f6$var$Me
    ]), a = (0, $acw62.useCallback)((h)=>{
        l((f)=>f.at(-1).def === h.def ? // Avoid pushing duplicate items
            f : [
                ...f,
                h
            ]);
    }, []), i = (0, $acw62.useCallback)(()=>{
        l((h)=>h.length > 1 ? h.slice(0, -1) : h);
    }, []), u = (0, $acw62.useCallback)(()=>{
        l((h)=>h.length === 1 ? h : [
                $5b723b129baa13f6$var$Me
            ]);
    }, []);
    (0, $acw62.useEffect)(()=>{
        t == null || n.length > 0 ? u() : l((h)=>{
            if (h.length === 1) return h;
            const f = [
                $5b723b129baa13f6$var$Me
            ];
            let v = null;
            for (const d of h)if (d !== $5b723b129baa13f6$var$Me) {
                if (d.def) {
                    if ((0, $54dWd.isNamedType)(d.def)) {
                        const g = t.getType(d.def.name);
                        if (g) f.push({
                            name: d.name,
                            def: g
                        }), v = g;
                        else break;
                    } else {
                        if (v === null) break;
                        if ((0, $54dWd.isObjectType)(v) || (0, $54dWd.isInputObjectType)(v)) {
                            const g = v.getFields()[d.name];
                            if (g) f.push({
                                name: d.name,
                                def: g
                            });
                            else break;
                        } else {
                            if ((0, $54dWd.isScalarType)(v) || (0, $54dWd.isEnumType)(v) || (0, $54dWd.isInterfaceType)(v) || (0, $54dWd.isUnionType)(v)) break;
                            {
                                const g = v;
                                if (g.args.find((C)=>C.name === d.name)) f.push({
                                    name: d.name,
                                    def: g
                                });
                                else break;
                            }
                        }
                    }
                } else v = null, f.push(d);
            }
            return f;
        });
    }, [
        u,
        t,
        n
    ]);
    const p = (0, $acw62.useMemo)(()=>({
            explorerNavStack: r,
            push: a,
            pop: i,
            reset: u
        }), [
        r,
        a,
        i,
        u
    ]);
    return /* @__PURE__ */ (0, $ayMG0.jsx)($5b723b129baa13f6$export$14a7fb59424347b4.Provider, {
        value: p,
        children: e.children
    });
}
$5b723b129baa13f6$var$s($5b723b129baa13f6$export$50f5f436c5e784bd, "ExplorerContextProvider");
const $5b723b129baa13f6$export$9ef0683d0e7c89e8 = $5b723b129baa13f6$var$ue($5b723b129baa13f6$export$14a7fb59424347b4);
function $5b723b129baa13f6$var$De(e, t) {
    return (0, $54dWd.isNonNullType)(e) ? /* @__PURE__ */ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            $5b723b129baa13f6$var$De(e.ofType, t),
            "!"
        ]
    }) : (0, $54dWd.isListType)(e) ? /* @__PURE__ */ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            "[",
            $5b723b129baa13f6$var$De(e.ofType, t),
            "]"
        ]
    }) : t(e);
}
$5b723b129baa13f6$var$s($5b723b129baa13f6$var$De, "renderType");
function $5b723b129baa13f6$export$b60636963b84124(e) {
    const { push: t } = $5b723b129baa13f6$export$9ef0683d0e7c89e8({
        nonNull: !0,
        caller: $5b723b129baa13f6$export$b60636963b84124
    });
    return e.type ? $5b723b129baa13f6$var$De(e.type, (n)=>/* @__PURE__ */ (0, $ayMG0.jsx)("a", {
            className: "graphiql-doc-explorer-type-name",
            onClick: (r)=>{
                r.preventDefault(), t({
                    name: n.name,
                    def: n
                });
            },
            href: "#",
            children: n.name
        })) : null;
}
$5b723b129baa13f6$var$s($5b723b129baa13f6$export$b60636963b84124, "TypeLink");
function $5b723b129baa13f6$export$84637ea037d2e218({ arg: e, showDefaultValue: t, inline: n }) {
    const r = /* @__PURE__ */ (0, $ayMG0.jsxs)("span", {
        children: [
            /* @__PURE__ */ (0, $ayMG0.jsx)("span", {
                className: "graphiql-doc-explorer-argument-name",
                children: e.name
            }),
            ": ",
            /* @__PURE__ */ (0, $ayMG0.jsx)($5b723b129baa13f6$export$b60636963b84124, {
                type: e.type
            }),
            t !== !1 && /* @__PURE__ */ (0, $ayMG0.jsx)($5b723b129baa13f6$export$a4e369a19907695d, {
                field: e
            })
        ]
    });
    return n ? r : /* @__PURE__ */ (0, $ayMG0.jsxs)("div", {
        className: "graphiql-doc-explorer-argument",
        children: [
            r,
            e.description ? /* @__PURE__ */ (0, $ayMG0.jsx)($5b723b129baa13f6$export$759dadce87f95042, {
                type: "description",
                children: e.description
            }) : null,
            e.deprecationReason ? /* @__PURE__ */ (0, $ayMG0.jsxs)("div", {
                className: "graphiql-doc-explorer-argument-deprecation",
                children: [
                    /* @__PURE__ */ (0, $ayMG0.jsx)("div", {
                        className: "graphiql-doc-explorer-argument-deprecation-label",
                        children: "Deprecated"
                    }),
                    /* @__PURE__ */ (0, $ayMG0.jsx)($5b723b129baa13f6$export$759dadce87f95042, {
                        type: "deprecation",
                        children: e.deprecationReason
                    })
                ]
            }) : null
        ]
    });
}
$5b723b129baa13f6$var$s($5b723b129baa13f6$export$84637ea037d2e218, "Argument");
function $5b723b129baa13f6$export$a4ad898a6061dca3(e) {
    return e.children ? /* @__PURE__ */ (0, $ayMG0.jsxs)("div", {
        className: "graphiql-doc-explorer-deprecation",
        children: [
            /* @__PURE__ */ (0, $ayMG0.jsx)("div", {
                className: "graphiql-doc-explorer-deprecation-label",
                children: "Deprecated"
            }),
            /* @__PURE__ */ (0, $ayMG0.jsx)($5b723b129baa13f6$export$759dadce87f95042, {
                type: "deprecation",
                onlyShowFirstChild: e.preview ?? !0,
                children: e.children
            })
        ]
    }) : null;
}
$5b723b129baa13f6$var$s($5b723b129baa13f6$export$a4ad898a6061dca3, "DeprecationReason");
function $5b723b129baa13f6$export$befdefbdce210f91({ directive: e }) {
    return /* @__PURE__ */ (0, $ayMG0.jsxs)("span", {
        className: "graphiql-doc-explorer-directive",
        children: [
            "@",
            e.name.value
        ]
    });
}
$5b723b129baa13f6$var$s($5b723b129baa13f6$export$befdefbdce210f91, "Directive");
function $5b723b129baa13f6$export$c30bfbdd7c818f60(e) {
    const t = $5b723b129baa13f6$var$Jr[e.title];
    return /* @__PURE__ */ (0, $ayMG0.jsxs)("div", {
        children: [
            /* @__PURE__ */ (0, $ayMG0.jsxs)("div", {
                className: "graphiql-doc-explorer-section-title",
                children: [
                    /* @__PURE__ */ (0, $ayMG0.jsx)(t, {}),
                    e.title
                ]
            }),
            /* @__PURE__ */ (0, $ayMG0.jsx)("div", {
                className: "graphiql-doc-explorer-section-content",
                children: e.children
            })
        ]
    });
}
$5b723b129baa13f6$var$s($5b723b129baa13f6$export$c30bfbdd7c818f60, "ExplorerSection");
const $5b723b129baa13f6$var$Jr = {
    Arguments: $5b723b129baa13f6$export$e0b8b1afc6387616,
    "Deprecated Arguments": $5b723b129baa13f6$export$3dece38e5f333c21,
    "Deprecated Enum Values": $5b723b129baa13f6$export$f2559fa12473338f,
    "Deprecated Fields": $5b723b129baa13f6$export$69318f45e191d5cf,
    Directives: $5b723b129baa13f6$export$56acf24630a50a0f,
    "Enum Values": $5b723b129baa13f6$export$efd164bba9c3659a,
    Fields: $5b723b129baa13f6$export$41064d4d91086d08,
    Implements: $5b723b129baa13f6$export$89e42b2a2b168714,
    Implementations: $5b723b129baa13f6$export$ad8f8fc3bcd61b4a,
    "Possible Types": $5b723b129baa13f6$export$ad8f8fc3bcd61b4a,
    "Root Types": $5b723b129baa13f6$export$9463a1f0a61bd487,
    Type: $5b723b129baa13f6$export$ad8f8fc3bcd61b4a,
    "All Schema Types": $5b723b129baa13f6$export$ad8f8fc3bcd61b4a
};
function $5b723b129baa13f6$export$cfadd2888c69ccf7(e) {
    return /* @__PURE__ */ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            e.field.description ? /* @__PURE__ */ (0, $ayMG0.jsx)($5b723b129baa13f6$export$759dadce87f95042, {
                type: "description",
                children: e.field.description
            }) : null,
            /* @__PURE__ */ (0, $ayMG0.jsx)($5b723b129baa13f6$export$a4ad898a6061dca3, {
                preview: !1,
                children: e.field.deprecationReason
            }),
            /* @__PURE__ */ (0, $ayMG0.jsx)($5b723b129baa13f6$export$c30bfbdd7c818f60, {
                title: "Type",
                children: /* @__PURE__ */ (0, $ayMG0.jsx)($5b723b129baa13f6$export$b60636963b84124, {
                    type: e.field.type
                })
            }),
            /* @__PURE__ */ (0, $ayMG0.jsx)($5b723b129baa13f6$var$Xr, {
                field: e.field
            }),
            /* @__PURE__ */ (0, $ayMG0.jsx)($5b723b129baa13f6$var$eo, {
                field: e.field
            })
        ]
    });
}
$5b723b129baa13f6$var$s($5b723b129baa13f6$export$cfadd2888c69ccf7, "FieldDocumentation");
function $5b723b129baa13f6$var$Xr({ field: e }) {
    const [t, n] = (0, $acw62.useState)(!1), r = (0, $acw62.useCallback)(()=>{
        n(!0);
    }, []);
    if (!("args" in e)) return null;
    const l = [], a = [];
    for (const i of e.args)i.deprecationReason ? a.push(i) : l.push(i);
    return /* @__PURE__ */ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            l.length > 0 ? /* @__PURE__ */ (0, $ayMG0.jsx)($5b723b129baa13f6$export$c30bfbdd7c818f60, {
                title: "Arguments",
                children: l.map((i)=>/* @__PURE__ */ (0, $ayMG0.jsx)($5b723b129baa13f6$export$84637ea037d2e218, {
                        arg: i
                    }, i.name))
            }) : null,
            a.length > 0 ? t || l.length === 0 ? /* @__PURE__ */ (0, $ayMG0.jsx)($5b723b129baa13f6$export$c30bfbdd7c818f60, {
                title: "Deprecated Arguments",
                children: a.map((i)=>/* @__PURE__ */ (0, $ayMG0.jsx)($5b723b129baa13f6$export$84637ea037d2e218, {
                        arg: i
                    }, i.name))
            }) : /* @__PURE__ */ (0, $ayMG0.jsx)($5b723b129baa13f6$export$353f5b6fc5456de1, {
                type: "button",
                onClick: r,
                children: "Show Deprecated Arguments"
            }) : null
        ]
    });
}
$5b723b129baa13f6$var$s($5b723b129baa13f6$var$Xr, "Arguments");
function $5b723b129baa13f6$var$eo({ field: e }) {
    var n;
    const t = ((n = e.astNode) == null ? void 0 : n.directives) || [];
    return !t || t.length === 0 ? null : /* @__PURE__ */ (0, $ayMG0.jsx)($5b723b129baa13f6$export$c30bfbdd7c818f60, {
        title: "Directives",
        children: t.map((r)=>/* @__PURE__ */ (0, $ayMG0.jsx)("div", {
                children: /* @__PURE__ */ (0, $ayMG0.jsx)($5b723b129baa13f6$export$befdefbdce210f91, {
                    directive: r
                })
            }, r.name.value))
    });
}
$5b723b129baa13f6$var$s($5b723b129baa13f6$var$eo, "Directives");
function $5b723b129baa13f6$export$77f7a1a1d3f40e71(e) {
    var i, u, p, h;
    const t = e.schema.getQueryType(), n = (u = (i = e.schema).getMutationType) == null ? void 0 : u.call(i), r = (h = (p = e.schema).getSubscriptionType) == null ? void 0 : h.call(p), l = e.schema.getTypeMap(), a = [
        t == null ? void 0 : t.name,
        n == null ? void 0 : n.name,
        r == null ? void 0 : r.name
    ];
    return /* @__PURE__ */ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /* @__PURE__ */ (0, $ayMG0.jsx)($5b723b129baa13f6$export$759dadce87f95042, {
                type: "description",
                children: e.schema.description || "A GraphQL schema provides a root type for each kind of operation."
            }),
            /* @__PURE__ */ (0, $ayMG0.jsxs)($5b723b129baa13f6$export$c30bfbdd7c818f60, {
                title: "Root Types",
                children: [
                    t ? /* @__PURE__ */ (0, $ayMG0.jsxs)("div", {
                        children: [
                            /* @__PURE__ */ (0, $ayMG0.jsx)("span", {
                                className: "graphiql-doc-explorer-root-type",
                                children: "query"
                            }),
                            ": ",
                            /* @__PURE__ */ (0, $ayMG0.jsx)($5b723b129baa13f6$export$b60636963b84124, {
                                type: t
                            })
                        ]
                    }) : null,
                    n && /* @__PURE__ */ (0, $ayMG0.jsxs)("div", {
                        children: [
                            /* @__PURE__ */ (0, $ayMG0.jsx)("span", {
                                className: "graphiql-doc-explorer-root-type",
                                children: "mutation"
                            }),
                            ": ",
                            /* @__PURE__ */ (0, $ayMG0.jsx)($5b723b129baa13f6$export$b60636963b84124, {
                                type: n
                            })
                        ]
                    }),
                    r && /* @__PURE__ */ (0, $ayMG0.jsxs)("div", {
                        children: [
                            /* @__PURE__ */ (0, $ayMG0.jsx)("span", {
                                className: "graphiql-doc-explorer-root-type",
                                children: "subscription"
                            }),
                            ": ",
                            /* @__PURE__ */ (0, $ayMG0.jsx)($5b723b129baa13f6$export$b60636963b84124, {
                                type: r
                            })
                        ]
                    })
                ]
            }),
            /* @__PURE__ */ (0, $ayMG0.jsx)($5b723b129baa13f6$export$c30bfbdd7c818f60, {
                title: "All Schema Types",
                children: l && /* @__PURE__ */ (0, $ayMG0.jsx)("div", {
                    children: Object.values(l).map((f)=>a.includes(f.name) || f.name.startsWith("__") ? null : /* @__PURE__ */ (0, $ayMG0.jsx)("div", {
                            children: /* @__PURE__ */ (0, $ayMG0.jsx)($5b723b129baa13f6$export$b60636963b84124, {
                                type: f
                            })
                        }, f.name))
                })
            })
        ]
    });
}
$5b723b129baa13f6$var$s($5b723b129baa13f6$export$77f7a1a1d3f40e71, "SchemaDocumentation");
function $5b723b129baa13f6$var$fe(e, t) {
    let n;
    return function(...r) {
        n && window.clearTimeout(n), n = window.setTimeout(()=>{
            n = null, t(...r);
        }, e);
    };
}
$5b723b129baa13f6$var$s($5b723b129baa13f6$var$fe, "debounce");
function $5b723b129baa13f6$export$4b85d3515bd863a5() {
    const { explorerNavStack: e, push: t } = $5b723b129baa13f6$export$9ef0683d0e7c89e8({
        nonNull: !0,
        caller: $5b723b129baa13f6$export$4b85d3515bd863a5
    }), n = (0, $acw62.useRef)(null), r = $5b723b129baa13f6$var$tt(), [l, a] = (0, $acw62.useState)(""), [i, u] = (0, $acw62.useState)(r(l)), p = (0, $acw62.useMemo)(()=>$5b723b129baa13f6$var$fe(200, (m)=>{
            u(r(m));
        }), [
        r
    ]);
    (0, $acw62.useEffect)(()=>{
        p(l);
    }, [
        p,
        l
    ]), (0, $acw62.useEffect)(()=>{
        function m(C) {
            var x;
            C.metaKey && C.key === "k" && ((x = n.current) == null || x.focus());
        }
        return $5b723b129baa13f6$var$s(m, "handleKeyDown"), window.addEventListener("keydown", m), ()=>window.removeEventListener("keydown", m);
    }, []);
    const h = e.at(-1), f = (0, $acw62.useCallback)((m)=>{
        t("field" in m ? {
            name: m.field.name,
            def: m.field
        } : {
            name: m.type.name,
            def: m.type
        });
    }, [
        t
    ]), v = (0, $acw62.useRef)(!1), d = (0, $acw62.useCallback)((m)=>{
        v.current = m.type === "focus";
    }, []);
    return e.length === 1 || (0, $54dWd.isObjectType)(h.def) || (0, $54dWd.isInterfaceType)(h.def) || (0, $54dWd.isInputObjectType)(h.def) ? /* @__PURE__ */ (0, $ayMG0.jsxs)((0, $kausY.Combobox), {
        as: "div",
        className: "graphiql-doc-explorer-search",
        onChange: f,
        "data-state": v ? void 0 : "idle",
        "aria-label": `Search ${h.name}...`,
        children: [
            /* @__PURE__ */ (0, $ayMG0.jsxs)("div", {
                className: "graphiql-doc-explorer-search-input",
                onClick: ()=>{
                    var m;
                    (m = n.current) == null || m.focus();
                },
                children: [
                    /* @__PURE__ */ (0, $ayMG0.jsx)($5b723b129baa13f6$export$f7658c347b037c3f, {}),
                    /* @__PURE__ */ (0, $ayMG0.jsx)((0, $kausY.Combobox).Input, {
                        autoComplete: "off",
                        onFocus: d,
                        onBlur: d,
                        onChange: (m)=>a(m.target.value),
                        placeholder: "\u2318 K",
                        ref: n,
                        value: l,
                        "data-cy": "doc-explorer-input"
                    })
                ]
            }),
            v.current && /* @__PURE__ */ (0, $ayMG0.jsxs)((0, $kausY.Combobox).Options, {
                "data-cy": "doc-explorer-list",
                children: [
                    i.within.length + i.types.length + i.fields.length === 0 ? /* @__PURE__ */ (0, $ayMG0.jsx)("li", {
                        className: "graphiql-doc-explorer-search-empty",
                        children: "No results found"
                    }) : i.within.map((m, C)=>/* @__PURE__ */ (0, $ayMG0.jsx)((0, $kausY.Combobox).Option, {
                            value: m,
                            "data-cy": "doc-explorer-option",
                            children: /* @__PURE__ */ (0, $ayMG0.jsx)($5b723b129baa13f6$var$yt, {
                                field: m.field,
                                argument: m.argument
                            })
                        }, `within-${C}`)),
                    i.within.length > 0 && i.types.length + i.fields.length > 0 ? /* @__PURE__ */ (0, $ayMG0.jsx)("div", {
                        className: "graphiql-doc-explorer-search-divider",
                        children: "Other results"
                    }) : null,
                    i.types.map((m, C)=>/* @__PURE__ */ (0, $ayMG0.jsx)((0, $kausY.Combobox).Option, {
                            value: m,
                            "data-cy": "doc-explorer-option",
                            children: /* @__PURE__ */ (0, $ayMG0.jsx)($5b723b129baa13f6$var$nt, {
                                type: m.type
                            })
                        }, `type-${C}`)),
                    i.fields.map((m, C)=>/* @__PURE__ */ (0, $ayMG0.jsxs)((0, $kausY.Combobox).Option, {
                            value: m,
                            "data-cy": "doc-explorer-option",
                            children: [
                                /* @__PURE__ */ (0, $ayMG0.jsx)($5b723b129baa13f6$var$nt, {
                                    type: m.type
                                }),
                                ".",
                                /* @__PURE__ */ (0, $ayMG0.jsx)($5b723b129baa13f6$var$yt, {
                                    field: m.field,
                                    argument: m.argument
                                })
                            ]
                        }, `field-${C}`))
                ]
            })
        ]
    }) : null;
}
$5b723b129baa13f6$var$s($5b723b129baa13f6$export$4b85d3515bd863a5, "Search");
function $5b723b129baa13f6$var$tt(e) {
    const { explorerNavStack: t } = $5b723b129baa13f6$export$9ef0683d0e7c89e8({
        nonNull: !0,
        caller: e || $5b723b129baa13f6$var$tt
    }), { schema: n } = $5b723b129baa13f6$export$468d7ae1c12d1956({
        nonNull: !0,
        caller: e || $5b723b129baa13f6$var$tt
    }), r = t.at(-1);
    return (0, $acw62.useCallback)((l)=>{
        const a = {
            within: [],
            types: [],
            fields: []
        };
        if (!n) return a;
        const i = r.def, u = n.getTypeMap();
        let p = Object.keys(u);
        i && (p = p.filter((h)=>h !== i.name), p.unshift(i.name));
        for (const h of p){
            if (a.within.length + a.types.length + a.fields.length >= 100) break;
            const f = u[h];
            if (i !== f && $5b723b129baa13f6$var$je(h, l) && a.types.push({
                type: f
            }), !(0, $54dWd.isObjectType)(f) && !(0, $54dWd.isInterfaceType)(f) && !(0, $54dWd.isInputObjectType)(f)) continue;
            const v = f.getFields();
            for(const d in v){
                const g = v[d];
                let m;
                if (!$5b723b129baa13f6$var$je(d, l)) {
                    if ("args" in g) {
                        if (m = g.args.filter((C)=>$5b723b129baa13f6$var$je(C.name, l)), m.length === 0) continue;
                    } else continue;
                }
                a[i === f ? "within" : "fields"].push(...m ? m.map((C)=>({
                        type: f,
                        field: g,
                        argument: C
                    })) : [
                    {
                        type: f,
                        field: g
                    }
                ]);
            }
        }
        return a;
    }, [
        r.def,
        n
    ]);
}
$5b723b129baa13f6$var$s($5b723b129baa13f6$var$tt, "useSearchResults");
function $5b723b129baa13f6$var$je(e, t) {
    try {
        const n = t.replaceAll(/[^_0-9A-Za-z]/g, (r)=>"\\" + r);
        return e.search(new RegExp(n, "i")) !== -1;
    } catch  {
        return e.toLowerCase().includes(t.toLowerCase());
    }
}
$5b723b129baa13f6$var$s($5b723b129baa13f6$var$je, "isMatch");
function $5b723b129baa13f6$var$nt(e) {
    return /* @__PURE__ */ (0, $ayMG0.jsx)("span", {
        className: "graphiql-doc-explorer-search-type",
        children: e.type.name
    });
}
$5b723b129baa13f6$var$s($5b723b129baa13f6$var$nt, "Type");
function $5b723b129baa13f6$var$yt({ field: e, argument: t }) {
    return /* @__PURE__ */ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /* @__PURE__ */ (0, $ayMG0.jsx)("span", {
                className: "graphiql-doc-explorer-search-field",
                children: e.name
            }),
            t ? /* @__PURE__ */ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    "(",
                    /* @__PURE__ */ (0, $ayMG0.jsx)("span", {
                        className: "graphiql-doc-explorer-search-argument",
                        children: t.name
                    }),
                    ":",
                    " ",
                    $5b723b129baa13f6$var$De(t.type, (n)=>/* @__PURE__ */ (0, $ayMG0.jsx)($5b723b129baa13f6$var$nt, {
                            type: n
                        })),
                    ")"
                ]
            }) : null
        ]
    });
}
$5b723b129baa13f6$var$s($5b723b129baa13f6$var$yt, "Field$1");
function $5b723b129baa13f6$export$de2fc2a24a792f2d(e) {
    const { push: t } = $5b723b129baa13f6$export$9ef0683d0e7c89e8({
        nonNull: !0
    });
    return /* @__PURE__ */ (0, $ayMG0.jsx)("a", {
        className: "graphiql-doc-explorer-field-name",
        onClick: (n)=>{
            n.preventDefault(), t({
                name: e.field.name,
                def: e.field
            });
        },
        href: "#",
        children: e.field.name
    });
}
$5b723b129baa13f6$var$s($5b723b129baa13f6$export$de2fc2a24a792f2d, "FieldLink");
function $5b723b129baa13f6$export$e4b2cda496ff71db(e) {
    return (0, $54dWd.isNamedType)(e.type) ? /* @__PURE__ */ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            e.type.description ? /* @__PURE__ */ (0, $ayMG0.jsx)($5b723b129baa13f6$export$759dadce87f95042, {
                type: "description",
                children: e.type.description
            }) : null,
            /* @__PURE__ */ (0, $ayMG0.jsx)($5b723b129baa13f6$var$oo, {
                type: e.type
            }),
            /* @__PURE__ */ (0, $ayMG0.jsx)($5b723b129baa13f6$var$lo, {
                type: e.type
            }),
            /* @__PURE__ */ (0, $ayMG0.jsx)($5b723b129baa13f6$var$io, {
                type: e.type
            }),
            /* @__PURE__ */ (0, $ayMG0.jsx)($5b723b129baa13f6$var$so, {
                type: e.type
            })
        ]
    }) : null;
}
$5b723b129baa13f6$var$s($5b723b129baa13f6$export$e4b2cda496ff71db, "TypeDocumentation");
function $5b723b129baa13f6$var$oo({ type: e }) {
    return (0, $54dWd.isObjectType)(e) && e.getInterfaces().length > 0 ? /* @__PURE__ */ (0, $ayMG0.jsx)($5b723b129baa13f6$export$c30bfbdd7c818f60, {
        title: "Implements",
        children: e.getInterfaces().map((n)=>/* @__PURE__ */ (0, $ayMG0.jsx)("div", {
                children: /* @__PURE__ */ (0, $ayMG0.jsx)($5b723b129baa13f6$export$b60636963b84124, {
                    type: n
                })
            }, n.name))
    }) : null;
}
$5b723b129baa13f6$var$s($5b723b129baa13f6$var$oo, "ImplementsInterfaces");
function $5b723b129baa13f6$var$lo({ type: e }) {
    const [t, n] = (0, $acw62.useState)(!1), r = (0, $acw62.useCallback)(()=>{
        n(!0);
    }, []);
    if (!(0, $54dWd.isObjectType)(e) && !(0, $54dWd.isInterfaceType)(e) && !(0, $54dWd.isInputObjectType)(e)) return null;
    const l = e.getFields(), a = [], i = [];
    for (const u of Object.keys(l).map((p)=>l[p]))u.deprecationReason ? i.push(u) : a.push(u);
    return /* @__PURE__ */ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            a.length > 0 ? /* @__PURE__ */ (0, $ayMG0.jsx)($5b723b129baa13f6$export$c30bfbdd7c818f60, {
                title: "Fields",
                children: a.map((u)=>/* @__PURE__ */ (0, $ayMG0.jsx)($5b723b129baa13f6$var$vt, {
                        field: u
                    }, u.name))
            }) : null,
            i.length > 0 ? t || a.length === 0 ? /* @__PURE__ */ (0, $ayMG0.jsx)($5b723b129baa13f6$export$c30bfbdd7c818f60, {
                title: "Deprecated Fields",
                children: i.map((u)=>/* @__PURE__ */ (0, $ayMG0.jsx)($5b723b129baa13f6$var$vt, {
                        field: u
                    }, u.name))
            }) : /* @__PURE__ */ (0, $ayMG0.jsx)($5b723b129baa13f6$export$353f5b6fc5456de1, {
                type: "button",
                onClick: r,
                children: "Show Deprecated Fields"
            }) : null
        ]
    });
}
$5b723b129baa13f6$var$s($5b723b129baa13f6$var$lo, "Fields");
function $5b723b129baa13f6$var$vt({ field: e }) {
    const t = "args" in e ? e.args.filter((n)=>!n.deprecationReason) : [];
    return /* @__PURE__ */ (0, $ayMG0.jsxs)("div", {
        className: "graphiql-doc-explorer-item",
        children: [
            /* @__PURE__ */ (0, $ayMG0.jsxs)("div", {
                children: [
                    /* @__PURE__ */ (0, $ayMG0.jsx)($5b723b129baa13f6$export$de2fc2a24a792f2d, {
                        field: e
                    }),
                    t.length > 0 ? /* @__PURE__ */ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            "(",
                            /* @__PURE__ */ (0, $ayMG0.jsx)("span", {
                                children: t.map((n)=>t.length === 1 ? /* @__PURE__ */ (0, $ayMG0.jsx)($5b723b129baa13f6$export$84637ea037d2e218, {
                                        arg: n,
                                        inline: !0
                                    }, n.name) : /* @__PURE__ */ (0, $ayMG0.jsx)("div", {
                                        className: "graphiql-doc-explorer-argument-multiple",
                                        children: /* @__PURE__ */ (0, $ayMG0.jsx)($5b723b129baa13f6$export$84637ea037d2e218, {
                                            arg: n,
                                            inline: !0
                                        })
                                    }, n.name))
                            }),
                            ")"
                        ]
                    }) : null,
                    ": ",
                    /* @__PURE__ */ (0, $ayMG0.jsx)($5b723b129baa13f6$export$b60636963b84124, {
                        type: e.type
                    }),
                    /* @__PURE__ */ (0, $ayMG0.jsx)($5b723b129baa13f6$export$a4e369a19907695d, {
                        field: e
                    })
                ]
            }),
            e.description ? /* @__PURE__ */ (0, $ayMG0.jsx)($5b723b129baa13f6$export$759dadce87f95042, {
                type: "description",
                onlyShowFirstChild: !0,
                children: e.description
            }) : null,
            /* @__PURE__ */ (0, $ayMG0.jsx)($5b723b129baa13f6$export$a4ad898a6061dca3, {
                children: e.deprecationReason
            })
        ]
    });
}
$5b723b129baa13f6$var$s($5b723b129baa13f6$var$vt, "Field");
function $5b723b129baa13f6$var$io({ type: e }) {
    const [t, n] = (0, $acw62.useState)(!1), r = (0, $acw62.useCallback)(()=>{
        n(!0);
    }, []);
    if (!(0, $54dWd.isEnumType)(e)) return null;
    const l = [], a = [];
    for (const i of e.getValues())i.deprecationReason ? a.push(i) : l.push(i);
    return /* @__PURE__ */ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            l.length > 0 ? /* @__PURE__ */ (0, $ayMG0.jsx)($5b723b129baa13f6$export$c30bfbdd7c818f60, {
                title: "Enum Values",
                children: l.map((i)=>/* @__PURE__ */ (0, $ayMG0.jsx)($5b723b129baa13f6$var$bt, {
                        value: i
                    }, i.name))
            }) : null,
            a.length > 0 ? t || l.length === 0 ? /* @__PURE__ */ (0, $ayMG0.jsx)($5b723b129baa13f6$export$c30bfbdd7c818f60, {
                title: "Deprecated Enum Values",
                children: a.map((i)=>/* @__PURE__ */ (0, $ayMG0.jsx)($5b723b129baa13f6$var$bt, {
                        value: i
                    }, i.name))
            }) : /* @__PURE__ */ (0, $ayMG0.jsx)($5b723b129baa13f6$export$353f5b6fc5456de1, {
                type: "button",
                onClick: r,
                children: "Show Deprecated Values"
            }) : null
        ]
    });
}
$5b723b129baa13f6$var$s($5b723b129baa13f6$var$io, "EnumValues");
function $5b723b129baa13f6$var$bt({ value: e }) {
    return /* @__PURE__ */ (0, $ayMG0.jsxs)("div", {
        className: "graphiql-doc-explorer-item",
        children: [
            /* @__PURE__ */ (0, $ayMG0.jsx)("div", {
                className: "graphiql-doc-explorer-enum-value",
                children: e.name
            }),
            e.description ? /* @__PURE__ */ (0, $ayMG0.jsx)($5b723b129baa13f6$export$759dadce87f95042, {
                type: "description",
                children: e.description
            }) : null,
            e.deprecationReason ? /* @__PURE__ */ (0, $ayMG0.jsx)($5b723b129baa13f6$export$759dadce87f95042, {
                type: "deprecation",
                children: e.deprecationReason
            }) : null
        ]
    });
}
$5b723b129baa13f6$var$s($5b723b129baa13f6$var$bt, "EnumValue");
function $5b723b129baa13f6$var$so({ type: e }) {
    const { schema: t } = $5b723b129baa13f6$export$468d7ae1c12d1956({
        nonNull: !0
    });
    return !t || !(0, $54dWd.isAbstractType)(e) ? null : /* @__PURE__ */ (0, $ayMG0.jsx)($5b723b129baa13f6$export$c30bfbdd7c818f60, {
        title: (0, $54dWd.isInterfaceType)(e) ? "Implementations" : "Possible Types",
        children: t.getPossibleTypes(e).map((n)=>/* @__PURE__ */ (0, $ayMG0.jsx)("div", {
                children: /* @__PURE__ */ (0, $ayMG0.jsx)($5b723b129baa13f6$export$b60636963b84124, {
                    type: n
                })
            }, n.name))
    });
}
$5b723b129baa13f6$var$s($5b723b129baa13f6$var$so, "PossibleTypes");
function $5b723b129baa13f6$export$6e0225bf113f4207() {
    const { fetchError: e, isFetching: t, schema: n, validationErrors: r } = $5b723b129baa13f6$export$468d7ae1c12d1956({
        nonNull: !0,
        caller: $5b723b129baa13f6$export$6e0225bf113f4207
    }), { explorerNavStack: l, pop: a } = $5b723b129baa13f6$export$9ef0683d0e7c89e8({
        nonNull: !0,
        caller: $5b723b129baa13f6$export$6e0225bf113f4207
    }), i = l.at(-1);
    let u = null;
    e ? u = /* @__PURE__ */ (0, $ayMG0.jsx)("div", {
        className: "graphiql-doc-explorer-error",
        children: "Error fetching schema"
    }) : r.length > 0 ? u = /* @__PURE__ */ (0, $ayMG0.jsxs)("div", {
        className: "graphiql-doc-explorer-error",
        children: [
            "Schema is invalid: ",
            r[0].message
        ]
    }) : t ? u = /* @__PURE__ */ (0, $ayMG0.jsx)($5b723b129baa13f6$export$7f7cbe89f1eacd2, {}) : n ? l.length === 1 ? u = /* @__PURE__ */ (0, $ayMG0.jsx)($5b723b129baa13f6$export$77f7a1a1d3f40e71, {
        schema: n
    }) : (0, $54dWd.isType)(i.def) ? u = /* @__PURE__ */ (0, $ayMG0.jsx)($5b723b129baa13f6$export$e4b2cda496ff71db, {
        type: i.def
    }) : i.def && (u = /* @__PURE__ */ (0, $ayMG0.jsx)($5b723b129baa13f6$export$cfadd2888c69ccf7, {
        field: i.def
    })) : u = /* @__PURE__ */ (0, $ayMG0.jsx)("div", {
        className: "graphiql-doc-explorer-error",
        children: "No GraphQL schema available"
    });
    let p;
    return l.length > 1 && (p = l.at(-2).name), /* @__PURE__ */ (0, $ayMG0.jsxs)("section", {
        className: "graphiql-doc-explorer",
        "aria-label": "Documentation Explorer",
        children: [
            /* @__PURE__ */ (0, $ayMG0.jsxs)("div", {
                className: "graphiql-doc-explorer-header",
                children: [
                    /* @__PURE__ */ (0, $ayMG0.jsxs)("div", {
                        className: "graphiql-doc-explorer-header-content",
                        children: [
                            p && /* @__PURE__ */ (0, $ayMG0.jsxs)("a", {
                                href: "#",
                                className: "graphiql-doc-explorer-back",
                                onClick: (h)=>{
                                    h.preventDefault(), a();
                                },
                                "aria-label": `Go back to ${p}`,
                                children: [
                                    /* @__PURE__ */ (0, $ayMG0.jsx)($5b723b129baa13f6$export$20bc5960c3c9eebb, {}),
                                    p
                                ]
                            }),
                            /* @__PURE__ */ (0, $ayMG0.jsx)("div", {
                                className: "graphiql-doc-explorer-title",
                                children: i.name
                            })
                        ]
                    }),
                    /* @__PURE__ */ (0, $ayMG0.jsx)($5b723b129baa13f6$export$4b85d3515bd863a5, {}, i.name)
                ]
            }),
            /* @__PURE__ */ (0, $ayMG0.jsx)("div", {
                className: "graphiql-doc-explorer-content",
                children: u
            })
        ]
    });
}
$5b723b129baa13f6$var$s($5b723b129baa13f6$export$6e0225bf113f4207, "DocExplorer");
const $5b723b129baa13f6$export$3e22af3f552d183 = {
    title: "Documentation Explorer",
    icon: /* @__PURE__ */ $5b723b129baa13f6$var$s(function() {
        const t = $5b723b129baa13f6$export$b730231195af25bd();
        return (t == null ? void 0 : t.visiblePlugin) === $5b723b129baa13f6$export$3e22af3f552d183 ? /* @__PURE__ */ (0, $ayMG0.jsx)($5b723b129baa13f6$export$9b2be5fcaf6117d1, {}) : /* @__PURE__ */ (0, $ayMG0.jsx)($5b723b129baa13f6$export$13c114d596b48571, {});
    }, "Icon"),
    content: $5b723b129baa13f6$export$6e0225bf113f4207
}, $5b723b129baa13f6$export$1a56bd6804cd66a6 = {
    title: "History",
    icon: $5b723b129baa13f6$export$8d345d913bfb227,
    content: $5b723b129baa13f6$export$84202caead5689ba
}, $5b723b129baa13f6$export$5cdd67ce320013cf = $5b723b129baa13f6$var$ce("PluginContext");
function $5b723b129baa13f6$export$841211ff5aa203b9(e) {
    const t = $5b723b129baa13f6$export$1d88f1dc01e47b0e(), n = $5b723b129baa13f6$export$9ef0683d0e7c89e8(), r = $5b723b129baa13f6$export$1c946c39bb2430a4(), l = !!n, a = !!r, i = (0, $acw62.useMemo)(()=>{
        const g = [], m = {};
        l && (g.push($5b723b129baa13f6$export$3e22af3f552d183), m[$5b723b129baa13f6$export$3e22af3f552d183.title] = !0), a && (g.push($5b723b129baa13f6$export$1a56bd6804cd66a6), m[$5b723b129baa13f6$export$1a56bd6804cd66a6.title] = !0);
        for (const C of e.plugins || []){
            if (typeof C.title != "string" || !C.title) throw new Error("All GraphiQL plugins must have a unique title");
            if (m[C.title]) throw new Error(`All GraphiQL plugins must have a unique title, found two plugins with the title '${C.title}'`);
            g.push(C), m[C.title] = !0;
        }
        return g;
    }, [
        l,
        a,
        e.plugins
    ]), [u, p] = (0, $acw62.useState)(()=>{
        const g = t == null ? void 0 : t.get($5b723b129baa13f6$var$xt), m = i.find((C)=>C.title === g);
        return m || (g && (t == null || t.set($5b723b129baa13f6$var$xt, "")), e.visiblePlugin && i.find((C)=>(typeof e.visiblePlugin == "string" ? C.title : C) === e.visiblePlugin) || null);
    }), { onTogglePluginVisibility: h, children: f } = e, v = (0, $acw62.useCallback)((g)=>{
        const m = g && i.find((C)=>(typeof g == "string" ? C.title : C) === g) || null;
        p((C)=>m === C ? C : (h == null || h(m), m));
    }, [
        h,
        i
    ]);
    (0, $acw62.useEffect)(()=>{
        e.visiblePlugin && v(e.visiblePlugin);
    }, [
        i,
        e.visiblePlugin,
        v
    ]);
    const d = (0, $acw62.useMemo)(()=>({
            plugins: i,
            setVisiblePlugin: v,
            visiblePlugin: u
        }), [
        i,
        v,
        u
    ]);
    return /* @__PURE__ */ (0, $ayMG0.jsx)($5b723b129baa13f6$export$5cdd67ce320013cf.Provider, {
        value: d,
        children: f
    });
}
$5b723b129baa13f6$var$s($5b723b129baa13f6$export$841211ff5aa203b9, "PluginContextProvider");
const $5b723b129baa13f6$export$b730231195af25bd = $5b723b129baa13f6$var$ue($5b723b129baa13f6$export$5cdd67ce320013cf), $5b723b129baa13f6$var$xt = "visiblePlugin";
function $5b723b129baa13f6$var$co(e, t, n, r, l, a) {
    $5b723b129baa13f6$var$Ne([], {
        useCommonAddons: !1
    }).then((u)=>{
        let p, h, f, v, d, g, m, C, x;
        u.on(t, "select", // @ts-expect-error
        (k, L)=>{
            if (!p) {
                const b = L.parentNode;
                p = document.createElement("div"), p.className = "CodeMirror-hint-information", b.append(p);
                const w = document.createElement("header");
                w.className = "CodeMirror-hint-information-header", p.append(w), h = document.createElement("span"), h.className = "CodeMirror-hint-information-field-name", w.append(h), f = document.createElement("span"), f.className = "CodeMirror-hint-information-type-name-pill", w.append(f), v = document.createElement("span"), f.append(v), d = document.createElement("a"), d.className = "CodeMirror-hint-information-type-name", d.href = "javascript:void 0", d.addEventListener("click", i), f.append(d), g = document.createElement("span"), f.append(g), m = document.createElement("div"), m.className = "CodeMirror-hint-information-description", p.append(m), C = document.createElement("div"), C.className = "CodeMirror-hint-information-deprecation", p.append(C);
                const V = document.createElement("span");
                V.className = "CodeMirror-hint-information-deprecation-label", V.textContent = "Deprecated", C.append(V), x = document.createElement("div"), x.className = "CodeMirror-hint-information-deprecation-reason", C.append(x);
                const W = parseInt(window.getComputedStyle(p).paddingBottom.replace(/px$/, ""), 10) || 0, _ = parseInt(window.getComputedStyle(p).maxHeight.replace(/px$/, ""), 10) || 0, D = /* @__PURE__ */ $5b723b129baa13f6$var$s(()=>{
                    p && (p.style.paddingTop = b.scrollTop + W + "px", p.style.maxHeight = b.scrollTop + _ + "px");
                }, "handleScroll");
                b.addEventListener("scroll", D);
                let O;
                b.addEventListener("DOMNodeRemoved", O = /* @__PURE__ */ $5b723b129baa13f6$var$s(($)=>{
                    $.target === b && (b.removeEventListener("scroll", D), b.removeEventListener("DOMNodeRemoved", O), p && p.removeEventListener("click", i), p = null, h = null, f = null, v = null, d = null, g = null, m = null, C = null, x = null, O = null);
                }, "onRemoveFn"));
            }
            if (h && (h.textContent = k.text), f && v && d && g) {
                if (k.type) {
                    f.style.display = "inline";
                    const b = /* @__PURE__ */ $5b723b129baa13f6$var$s((w)=>{
                        (0, $54dWd.isNonNullType)(w) ? (g.textContent = "!" + g.textContent, b(w.ofType)) : (0, $54dWd.isListType)(w) ? (v.textContent += "[", g.textContent = "]" + g.textContent, b(w.ofType)) : d.textContent = w.name;
                    }, "renderType");
                    v.textContent = "", g.textContent = "", b(k.type);
                } else v.textContent = "", d.textContent = "", g.textContent = "", f.style.display = "none";
            }
            m && (k.description ? (m.style.display = "block", m.innerHTML = $5b723b129baa13f6$var$qe.render(k.description)) : (m.style.display = "none", m.innerHTML = "")), C && x && (k.deprecationReason ? (C.style.display = "block", x.innerHTML = $5b723b129baa13f6$var$qe.render(k.deprecationReason)) : (C.style.display = "none", x.innerHTML = ""));
        });
    });
    function i(u) {
        if (!n || !r || !l || !(u.currentTarget instanceof HTMLElement)) return;
        const p = u.currentTarget.textContent || "", h = n.getType(p);
        h && (l.setVisiblePlugin($5b723b129baa13f6$export$3e22af3f552d183), r.push({
            name: h.name,
            def: h
        }), a == null || a(h));
    }
    $5b723b129baa13f6$var$s(i, "onClickHintInformation");
}
$5b723b129baa13f6$var$s($5b723b129baa13f6$var$co, "onHasCompletion");
function $5b723b129baa13f6$var$Ve(e, t) {
    (0, $acw62.useEffect)(()=>{
        e && typeof t == "string" && t !== e.getValue() && e.setValue(t);
    }, [
        e,
        t
    ]);
}
$5b723b129baa13f6$var$s($5b723b129baa13f6$var$Ve, "useSynchronizeValue");
function $5b723b129baa13f6$var$Qe(e, t, n) {
    (0, $acw62.useEffect)(()=>{
        e && e.setOption(t, n);
    }, [
        e,
        t,
        n
    ]);
}
$5b723b129baa13f6$var$s($5b723b129baa13f6$var$Qe, "useSynchronizeOption");
function $5b723b129baa13f6$var$Jt(e, t, n, r, l) {
    const { updateActiveTabValues: a } = $5b723b129baa13f6$export$b119c82498f162a5({
        nonNull: !0,
        caller: l
    }), i = $5b723b129baa13f6$export$1d88f1dc01e47b0e();
    (0, $acw62.useEffect)(()=>{
        if (!e) return;
        const u = $5b723b129baa13f6$var$fe(500, (f)=>{
            !i || n === null || i.set(n, f);
        }), p = $5b723b129baa13f6$var$fe(100, (f)=>{
            a({
                [r]: f
            });
        }), h = /* @__PURE__ */ $5b723b129baa13f6$var$s((f, v)=>{
            if (!v) return;
            const d = f.getValue();
            u(d), p(d), t == null || t(d);
        }, "handleChange");
        return e.on("change", h), ()=>e.off("change", h);
    }, [
        t,
        e,
        i,
        n,
        r,
        a
    ]);
}
$5b723b129baa13f6$var$s($5b723b129baa13f6$var$Jt, "useChangeHandler");
function $5b723b129baa13f6$var$Yt(e, t, n) {
    const { schema: r } = $5b723b129baa13f6$export$468d7ae1c12d1956({
        nonNull: !0,
        caller: n
    }), l = $5b723b129baa13f6$export$9ef0683d0e7c89e8(), a = $5b723b129baa13f6$export$b730231195af25bd();
    (0, $acw62.useEffect)(()=>{
        if (!e) return;
        const i = /* @__PURE__ */ $5b723b129baa13f6$var$s((u, p)=>{
            $5b723b129baa13f6$var$co(u, p, r, l, a, (h)=>{
                t == null || t({
                    kind: "Type",
                    type: h,
                    schema: r || void 0
                });
            });
        }, "handleCompletion");
        return e.on(// @ts-expect-error @TODO additional args for hasCompletion event
        "hasCompletion", i), ()=>e.off(// @ts-expect-error @TODO additional args for hasCompletion event
            "hasCompletion", i);
    }, [
        t,
        e,
        l,
        a,
        r
    ]);
}
$5b723b129baa13f6$var$s($5b723b129baa13f6$var$Yt, "useCompletion");
function $5b723b129baa13f6$var$te(e, t, n) {
    (0, $acw62.useEffect)(()=>{
        if (e) {
            for (const r of t)e.removeKeyMap(r);
            if (n) {
                const r = {};
                for (const l of t)r[l] = ()=>n();
                e.addKeyMap(r);
            }
        }
    }, [
        e,
        t,
        n
    ]);
}
$5b723b129baa13f6$var$s($5b723b129baa13f6$var$te, "useKeyMap");
function $5b723b129baa13f6$export$7de945a74ead2b3b({ caller: e, onCopyQuery: t } = {}) {
    const { queryEditor: n } = $5b723b129baa13f6$export$b119c82498f162a5({
        nonNull: !0,
        caller: e || $5b723b129baa13f6$export$7de945a74ead2b3b
    });
    return (0, $acw62.useCallback)(()=>{
        if (!n) return;
        const r = n.getValue();
        (0, (/*@__PURE__*/$parcel$interopDefault($jIrAL)))(r), t == null || t(r);
    }, [
        n,
        t
    ]);
}
$5b723b129baa13f6$var$s($5b723b129baa13f6$export$7de945a74ead2b3b, "useCopyQuery");
function $5b723b129baa13f6$export$901e59078d6717b6({ caller: e } = {}) {
    const { queryEditor: t } = $5b723b129baa13f6$export$b119c82498f162a5({
        nonNull: !0,
        caller: e || $5b723b129baa13f6$export$901e59078d6717b6
    }), { schema: n } = $5b723b129baa13f6$export$468d7ae1c12d1956({
        nonNull: !0,
        caller: $5b723b129baa13f6$export$901e59078d6717b6
    });
    return (0, $acw62.useCallback)(()=>{
        const r = t == null ? void 0 : t.documentAST, l = t == null ? void 0 : t.getValue();
        !r || !l || t.setValue((0, $3o9dz.print)((0, $dhM2X.mergeAst)(r, n)));
    }, [
        t,
        n
    ]);
}
$5b723b129baa13f6$var$s($5b723b129baa13f6$export$901e59078d6717b6, "useMergeQuery");
function $5b723b129baa13f6$export$6cd47fbdfe85a578({ caller: e } = {}) {
    const { queryEditor: t, headerEditor: n, variableEditor: r } = $5b723b129baa13f6$export$b119c82498f162a5({
        nonNull: !0,
        caller: e || $5b723b129baa13f6$export$6cd47fbdfe85a578
    });
    return (0, $acw62.useCallback)(()=>{
        if (r) {
            const l = r.getValue();
            try {
                const a = JSON.stringify(JSON.parse(l), null, 2);
                a !== l && r.setValue(a);
            } catch  {}
        }
        if (n) {
            const l = n.getValue();
            try {
                const a = JSON.stringify(JSON.parse(l), null, 2);
                a !== l && n.setValue(a);
            } catch  {}
        }
        if (t) {
            const l = t.getValue(), a = (0, $3o9dz.print)((0, $8DJ2k.parse)(l));
            a !== l && t.setValue(a);
        }
    }, [
        t,
        r,
        n
    ]);
}
$5b723b129baa13f6$var$s($5b723b129baa13f6$export$6cd47fbdfe85a578, "usePrettifyEditors");
function $5b723b129baa13f6$export$5abb433c7a1f773e({ getDefaultFieldNames: e, caller: t } = {}) {
    const { schema: n } = $5b723b129baa13f6$export$468d7ae1c12d1956({
        nonNull: !0,
        caller: t || $5b723b129baa13f6$export$5abb433c7a1f773e
    }), { queryEditor: r } = $5b723b129baa13f6$export$b119c82498f162a5({
        nonNull: !0,
        caller: t || $5b723b129baa13f6$export$5abb433c7a1f773e
    });
    return (0, $acw62.useCallback)(()=>{
        if (!r) return;
        const l = r.getValue(), { insertions: a, result: i } = (0, $c9xw3.fillLeafs)(n, l, e);
        return a && a.length > 0 && r.operation(()=>{
            const u = r.getCursor(), p = r.indexFromPos(u);
            r.setValue(i || "");
            let h = 0;
            const f = a.map(({ index: d, string: g })=>r.markText(r.posFromIndex(d + h), r.posFromIndex(d + (h += g.length)), {
                    className: "auto-inserted-leaf",
                    clearOnEnter: !0,
                    title: "Automatically added leaf fields"
                }));
            setTimeout(()=>{
                for (const d of f)d.clear();
            }, 7e3);
            let v = p;
            for (const { index: d, string: g } of a)d < p && (v += g.length);
            r.setCursor(r.posFromIndex(v));
        }), i;
    }, [
        e,
        r,
        n
    ]);
}
$5b723b129baa13f6$var$s($5b723b129baa13f6$export$5abb433c7a1f773e, "useAutoCompleteLeafs");
const $5b723b129baa13f6$export$e6e340c65601d57b = /* @__PURE__ */ $5b723b129baa13f6$var$s((e)=>{
    const n = $5b723b129baa13f6$export$b119c82498f162a5({
        nonNull: !0
    })[`${e}Editor`];
    let r = "";
    const l = (n == null ? void 0 : n.getValue()) ?? !1;
    l && l.length > 0 && (r = l);
    const a = (0, $acw62.useCallback)((i)=>n == null ? void 0 : n.setValue(i), [
        n
    ]);
    return (0, $acw62.useMemo)(()=>[
            r,
            a
        ], [
        r,
        a
    ]);
}, "useEditorState"), $5b723b129baa13f6$export$fd296a58afc2838d = /* @__PURE__ */ $5b723b129baa13f6$var$s(()=>$5b723b129baa13f6$export$e6e340c65601d57b("query"), "useOperationsEditorState"), $5b723b129baa13f6$export$ddaa834da7662225 = /* @__PURE__ */ $5b723b129baa13f6$var$s(()=>$5b723b129baa13f6$export$e6e340c65601d57b("variable"), "useVariablesEditorState"), $5b723b129baa13f6$export$4fe9bde1571c31df = /* @__PURE__ */ $5b723b129baa13f6$var$s(()=>$5b723b129baa13f6$export$e6e340c65601d57b("header"), "useHeadersEditorState");
function $5b723b129baa13f6$export$d840f597e09ee733([e, t]) {
    const n = (0, $acw62.useRef)({
        /** The last thing that we sent upstream; we're expecting this back */ pending: null,
        /** The last thing we received from upstream */ last: e
    }), [r, l] = (0, $acw62.useState)(e);
    (0, $acw62.useEffect)(()=>{
        n.current.last === e || (n.current.last = e, n.current.pending === null ? l(e) : n.current.pending === e ? (n.current.pending = null, e !== r && (n.current.pending = r, t(r))) : (n.current.pending = null, l(e)));
    }, [
        e,
        r,
        t
    ]);
    const a = (0, $acw62.useCallback)((i)=>{
        l(i), n.current.pending === null && n.current.last !== i && (n.current.pending = i, t(i));
    }, [
        t
    ]);
    return (0, $acw62.useMemo)(()=>[
            r,
            a
        ], [
        r,
        a
    ]);
}
$5b723b129baa13f6$var$s($5b723b129baa13f6$export$d840f597e09ee733, "useOptimisticState");

function $5b723b129baa13f6$export$cdbbb29991d2bf8b({ editorTheme: e = $5b723b129baa13f6$var$_e, keyMap: t = $5b723b129baa13f6$var$Ze, onEdit: n, readOnly: r = !1 } = {}, l) {
    const { initialHeaders: a, headerEditor: i, setHeaderEditor: u, shouldPersistHeaders: p } = $5b723b129baa13f6$export$b119c82498f162a5({
        nonNull: !0,
        caller: l || $5b723b129baa13f6$export$cdbbb29991d2bf8b
    }), h = $5b723b129baa13f6$export$b0467ce6d1ed861f(), f = $5b723b129baa13f6$export$901e59078d6717b6({
        caller: l || $5b723b129baa13f6$export$cdbbb29991d2bf8b
    }), v = $5b723b129baa13f6$export$6cd47fbdfe85a578({
        caller: l || $5b723b129baa13f6$export$cdbbb29991d2bf8b
    }), d = (0, $acw62.useRef)(null);
    return (0, $acw62.useEffect)(()=>{
        let g = !0;
        return $5b723b129baa13f6$var$Ne([
            // @ts-expect-error
            (parcelRequire("kuRNp")).then((m)=>m.j)
        ]).then((m)=>{
            if (!g) return;
            const C = d.current;
            if (!C) return;
            const x = m(C, {
                value: a,
                lineNumbers: !0,
                tabSize: 2,
                mode: {
                    name: "javascript",
                    json: !0
                },
                theme: e,
                autoCloseBrackets: !0,
                matchBrackets: !0,
                showCursorWhenSelecting: !0,
                readOnly: r ? "nocursor" : !1,
                foldGutter: !0,
                gutters: [
                    "CodeMirror-linenumbers",
                    "CodeMirror-foldgutter"
                ],
                extraKeys: $5b723b129baa13f6$var$Ge
            });
            x.addKeyMap({
                "Cmd-Space" () {
                    x.showHint({
                        completeSingle: !1,
                        container: C
                    });
                },
                "Ctrl-Space" () {
                    x.showHint({
                        completeSingle: !1,
                        container: C
                    });
                },
                "Alt-Space" () {
                    x.showHint({
                        completeSingle: !1,
                        container: C
                    });
                },
                "Shift-Space" () {
                    x.showHint({
                        completeSingle: !1,
                        container: C
                    });
                }
            }), x.on("keyup", (k, L)=>{
                const { code: b, key: w, shiftKey: V } = L, W = b.startsWith("Key"), _ = !V && b.startsWith("Digit");
                (W || _ || w === "_" || w === '"') && k.execCommand("autocomplete");
            }), u(x);
        }), ()=>{
            g = !1;
        };
    }, [
        e,
        a,
        r,
        u
    ]), $5b723b129baa13f6$var$Qe(i, "keyMap", t), $5b723b129baa13f6$var$Jt(i, n, p ? $5b723b129baa13f6$var$Ae : null, "headers", $5b723b129baa13f6$export$cdbbb29991d2bf8b), $5b723b129baa13f6$var$te(i, [
        "Cmd-Enter",
        "Ctrl-Enter"
    ], h == null ? void 0 : h.run), $5b723b129baa13f6$var$te(i, [
        "Shift-Ctrl-P"
    ], v), $5b723b129baa13f6$var$te(i, [
        "Shift-Ctrl-M"
    ], f), d;
}
$5b723b129baa13f6$var$s($5b723b129baa13f6$export$cdbbb29991d2bf8b, "useHeaderEditor");
const $5b723b129baa13f6$var$Ae = "headers", $5b723b129baa13f6$var$uo = Array.from({
    length: 11
}, (e, t)=>String.fromCharCode(8192 + t)).concat([
    "\u2028",
    "\u2029",
    "\u202F",
    "\xa0"
]), $5b723b129baa13f6$var$ho = new RegExp("[" + $5b723b129baa13f6$var$uo.join("") + "]", "g");
function $5b723b129baa13f6$var$mo(e) {
    return e.replace($5b723b129baa13f6$var$ho, " ");
}
$5b723b129baa13f6$var$s($5b723b129baa13f6$var$mo, "normalizeWhitespace");







function $5b723b129baa13f6$export$52fa6630ade3da25({ editorTheme: e = $5b723b129baa13f6$var$_e, keyMap: t = $5b723b129baa13f6$var$Ze, onClickReference: n, onCopyQuery: r, onEdit: l, readOnly: a = !1 } = {}, i) {
    const { schema: u } = $5b723b129baa13f6$export$468d7ae1c12d1956({
        nonNull: !0,
        caller: i || $5b723b129baa13f6$export$52fa6630ade3da25
    }), { externalFragments: p, initialQuery: h, queryEditor: f, setOperationName: v, setQueryEditor: d, validationRules: g, variableEditor: m, updateActiveTabValues: C } = $5b723b129baa13f6$export$b119c82498f162a5({
        nonNull: !0,
        caller: i || $5b723b129baa13f6$export$52fa6630ade3da25
    }), x = $5b723b129baa13f6$export$b0467ce6d1ed861f(), k = $5b723b129baa13f6$export$1d88f1dc01e47b0e(), L = $5b723b129baa13f6$export$9ef0683d0e7c89e8(), b = $5b723b129baa13f6$export$b730231195af25bd(), w = $5b723b129baa13f6$export$7de945a74ead2b3b({
        caller: i || $5b723b129baa13f6$export$52fa6630ade3da25,
        onCopyQuery: r
    }), V = $5b723b129baa13f6$export$901e59078d6717b6({
        caller: i || $5b723b129baa13f6$export$52fa6630ade3da25
    }), W = $5b723b129baa13f6$export$6cd47fbdfe85a578({
        caller: i || $5b723b129baa13f6$export$52fa6630ade3da25
    }), _ = (0, $acw62.useRef)(null), D = (0, $acw62.useRef)(), O = (0, $acw62.useRef)(()=>{});
    (0, $acw62.useEffect)(()=>{
        O.current = (A)=>{
            if (!(!L || !b)) {
                switch(b.setVisiblePlugin($5b723b129baa13f6$export$3e22af3f552d183), A.kind){
                    case "Type":
                        L.push({
                            name: A.type.name,
                            def: A.type
                        });
                        break;
                    case "Field":
                        L.push({
                            name: A.field.name,
                            def: A.field
                        });
                        break;
                    case "Argument":
                        A.field && L.push({
                            name: A.field.name,
                            def: A.field
                        });
                        break;
                    case "EnumValue":
                        A.type && L.push({
                            name: A.type.name,
                            def: A.type
                        });
                        break;
                }
                n == null || n(A);
            }
        };
    }, [
        L,
        n,
        b
    ]), (0, $acw62.useEffect)(()=>{
        let A = !0;
        return $5b723b129baa13f6$var$Ne([
            (parcelRequire("701BD")).then((T)=>T.c),
            (parcelRequire("dfFxh")).then((T)=>T.s),
            (parcelRequire("7xtjt")),
            (parcelRequire("hk8RF")),
            (parcelRequire("9Aiqa")),
            (parcelRequire("3FX5h")),
            (parcelRequire("9uJ5q"))
        ]).then((T)=>{
            if (!A) return;
            D.current = T;
            const H = _.current;
            if (!H) return;
            const E = T(H, {
                value: h,
                lineNumbers: !0,
                tabSize: 2,
                foldGutter: !0,
                mode: "graphql",
                theme: e,
                autoCloseBrackets: !0,
                matchBrackets: !0,
                showCursorWhenSelecting: !0,
                readOnly: a ? "nocursor" : !1,
                lint: {
                    // @ts-expect-error
                    schema: void 0,
                    validationRules: null,
                    // linting accepts string or FragmentDefinitionNode[]
                    externalFragments: void 0
                },
                hintOptions: {
                    // @ts-expect-error
                    schema: void 0,
                    closeOnUnfocus: !1,
                    completeSingle: !1,
                    container: H,
                    externalFragments: void 0
                },
                info: {
                    schema: void 0,
                    renderDescription: (y)=>$5b723b129baa13f6$var$qe.render(y),
                    onClick (y) {
                        O.current(y);
                    }
                },
                jump: {
                    schema: void 0,
                    onClick (y) {
                        O.current(y);
                    }
                },
                gutters: [
                    "CodeMirror-linenumbers",
                    "CodeMirror-foldgutter"
                ],
                extraKeys: {
                    ...$5b723b129baa13f6$var$Ge,
                    "Cmd-S" () {},
                    "Ctrl-S" () {}
                }
            });
            E.addKeyMap({
                "Cmd-Space" () {
                    E.showHint({
                        completeSingle: !0,
                        container: H
                    });
                },
                "Ctrl-Space" () {
                    E.showHint({
                        completeSingle: !0,
                        container: H
                    });
                },
                "Alt-Space" () {
                    E.showHint({
                        completeSingle: !0,
                        container: H
                    });
                },
                "Shift-Space" () {
                    E.showHint({
                        completeSingle: !0,
                        container: H
                    });
                },
                "Shift-Alt-Space" () {
                    E.showHint({
                        completeSingle: !0,
                        container: H
                    });
                }
            }), E.on("keyup", (y, S)=>{
                $5b723b129baa13f6$var$Co.test(S.key) && y.execCommand("autocomplete");
            });
            let Z = !1;
            E.on("startCompletion", ()=>{
                Z = !0;
            }), E.on("endCompletion", ()=>{
                Z = !1;
            }), E.on("keydown", (y, S)=>{
                S.key === "Escape" && Z && S.stopPropagation();
            }), E.on("beforeChange", (y, S)=>{
                var R;
                if (S.origin === "paste") {
                    const U = S.text.map($5b723b129baa13f6$var$mo);
                    (R = S.update) == null || R.call(S, S.from, S.to, U);
                }
            }), E.documentAST = null, E.operationName = null, E.operations = null, E.variableToType = null, d(E);
        }), ()=>{
            A = !1;
        };
    }, [
        e,
        h,
        a,
        d
    ]), $5b723b129baa13f6$var$Qe(f, "keyMap", t), (0, $acw62.useEffect)(()=>{
        if (!f) return;
        function A(H) {
            var y;
            const E = (0, $8xP5p.default)(u, H.getValue()), Z = (0, $anr3h.getSelectedOperationName)(H.operations ?? void 0, H.operationName ?? void 0, E == null ? void 0 : E.operations);
            return H.documentAST = (E == null ? void 0 : E.documentAST) ?? null, H.operationName = Z ?? null, H.operations = (E == null ? void 0 : E.operations) ?? null, m && (m.state.lint.linterOptions.variableToType = E == null ? void 0 : E.variableToType, m.options.lint.variableToType = E == null ? void 0 : E.variableToType, m.options.hintOptions.variableToType = E == null ? void 0 : E.variableToType, (y = D.current) == null || y.signal(m, "change", m)), E ? {
                ...E,
                operationName: Z
            } : null;
        }
        $5b723b129baa13f6$var$s(A, "getAndUpdateOperationFacts");
        const T = $5b723b129baa13f6$var$fe(100, (H)=>{
            const E = H.getValue();
            k == null || k.set($5b723b129baa13f6$var$en, E);
            const Z = H.operationName, y = A(H);
            (y == null ? void 0 : y.operationName) !== void 0 && (k == null || k.set($5b723b129baa13f6$var$yo, y.operationName)), l == null || l(E, y == null ? void 0 : y.documentAST), y != null && y.operationName && Z !== y.operationName && v(y.operationName), C({
                query: E,
                operationName: (y == null ? void 0 : y.operationName) ?? null
            });
        });
        return A(f), f.on("change", T), ()=>f.off("change", T);
    }, [
        l,
        f,
        u,
        v,
        k,
        m,
        C
    ]), $5b723b129baa13f6$var$fo(f, u ?? null, D), $5b723b129baa13f6$var$po(f, g ?? null, D), $5b723b129baa13f6$var$go(f, p, D), $5b723b129baa13f6$var$Yt(f, n || null, $5b723b129baa13f6$export$52fa6630ade3da25);
    const $ = x == null ? void 0 : x.run, F = (0, $acw62.useCallback)(()=>{
        var H;
        if (!$ || !f || !f.operations || !f.hasFocus()) {
            $ == null || $();
            return;
        }
        const A = f.indexFromPos(f.getCursor());
        let T;
        for (const E of f.operations)E.loc && E.loc.start <= A && E.loc.end >= A && (T = (H = E.name) == null ? void 0 : H.value);
        T && T !== f.operationName && v(T), $();
    }, [
        f,
        $,
        v
    ]);
    return $5b723b129baa13f6$var$te(f, [
        "Cmd-Enter",
        "Ctrl-Enter"
    ], F), $5b723b129baa13f6$var$te(f, [
        "Shift-Ctrl-C"
    ], w), $5b723b129baa13f6$var$te(f, [
        "Shift-Ctrl-P",
        // Shift-Ctrl-P is hard coded in Firefox for private browsing so adding an alternative to prettify
        "Shift-Ctrl-F"
    ], W), $5b723b129baa13f6$var$te(f, [
        "Shift-Ctrl-M"
    ], V), _;
}
$5b723b129baa13f6$var$s($5b723b129baa13f6$export$52fa6630ade3da25, "useQueryEditor");
function $5b723b129baa13f6$var$fo(e, t, n) {
    (0, $acw62.useEffect)(()=>{
        if (!e) return;
        const r = e.options.lint.schema !== t;
        e.state.lint.linterOptions.schema = t, e.options.lint.schema = t, e.options.hintOptions.schema = t, e.options.info.schema = t, e.options.jump.schema = t, r && n.current && n.current.signal(e, "change", e);
    }, [
        e,
        t,
        n
    ]);
}
$5b723b129baa13f6$var$s($5b723b129baa13f6$var$fo, "useSynchronizeSchema");
function $5b723b129baa13f6$var$po(e, t, n) {
    (0, $acw62.useEffect)(()=>{
        if (!e) return;
        const r = e.options.lint.validationRules !== t;
        e.state.lint.linterOptions.validationRules = t, e.options.lint.validationRules = t, r && n.current && n.current.signal(e, "change", e);
    }, [
        e,
        t,
        n
    ]);
}
$5b723b129baa13f6$var$s($5b723b129baa13f6$var$po, "useSynchronizeValidationRules");
function $5b723b129baa13f6$var$go(e, t, n) {
    const r = (0, $acw62.useMemo)(()=>[
            ...t.values()
        ], [
        t
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!e) return;
        const l = e.options.lint.externalFragments !== r;
        e.state.lint.linterOptions.externalFragments = r, e.options.lint.externalFragments = r, e.options.hintOptions.externalFragments = r, l && n.current && n.current.signal(e, "change", e);
    }, [
        e,
        r,
        n
    ]);
}
$5b723b129baa13f6$var$s($5b723b129baa13f6$var$go, "useSynchronizeExternalFragments");
const $5b723b129baa13f6$var$Co = /^[a-zA-Z0-9_@(]$/, $5b723b129baa13f6$var$en = "query", $5b723b129baa13f6$var$yo = "operationName";
function $5b723b129baa13f6$var$vo({ defaultQuery: e, defaultHeaders: t, headers: n, defaultTabs: r, query: l, variables: a, storage: i, shouldPersistHeaders: u }) {
    const p = i == null ? void 0 : i.get($5b723b129baa13f6$var$we);
    try {
        if (!p) throw new Error("Storage for tabs is empty");
        const h = JSON.parse(p), f = u ? n : void 0;
        if ($5b723b129baa13f6$var$bo(h)) {
            const v = $5b723b129baa13f6$var$Oe({
                query: l,
                variables: a,
                headers: f
            });
            let d = -1;
            for(let g = 0; g < h.tabs.length; g++){
                const m = h.tabs[g];
                m.hash = $5b723b129baa13f6$var$Oe({
                    query: m.query,
                    variables: m.variables,
                    headers: m.headers
                }), m.hash === v && (d = g);
            }
            if (d >= 0) h.activeTabIndex = d;
            else {
                const g = l ? $5b723b129baa13f6$var$ut(l) : null;
                h.tabs.push({
                    id: $5b723b129baa13f6$var$on(),
                    hash: v,
                    title: g || $5b723b129baa13f6$var$dt,
                    query: l,
                    variables: a,
                    headers: n,
                    operationName: g,
                    response: null
                }), h.activeTabIndex = h.tabs.length - 1;
            }
            return h;
        }
        throw new Error("Storage for tabs is invalid");
    } catch  {
        return {
            activeTabIndex: 0,
            tabs: (r || [
                {
                    query: l ?? e,
                    variables: a,
                    headers: n ?? t
                }
            ]).map($5b723b129baa13f6$var$nn)
        };
    }
}
$5b723b129baa13f6$var$s($5b723b129baa13f6$var$vo, "getDefaultTabState");
function $5b723b129baa13f6$var$bo(e) {
    return e && typeof e == "object" && !Array.isArray(e) && $5b723b129baa13f6$var$xo(e, "activeTabIndex") && "tabs" in e && Array.isArray(e.tabs) && e.tabs.every($5b723b129baa13f6$var$wo);
}
$5b723b129baa13f6$var$s($5b723b129baa13f6$var$bo, "isTabsState");
function $5b723b129baa13f6$var$wo(e) {
    return e && typeof e == "object" && !Array.isArray(e) && $5b723b129baa13f6$var$Et(e, "id") && $5b723b129baa13f6$var$Et(e, "title") && $5b723b129baa13f6$var$pe(e, "query") && $5b723b129baa13f6$var$pe(e, "variables") && $5b723b129baa13f6$var$pe(e, "headers") && $5b723b129baa13f6$var$pe(e, "operationName") && $5b723b129baa13f6$var$pe(e, "response");
}
$5b723b129baa13f6$var$s($5b723b129baa13f6$var$wo, "isTabState");
function $5b723b129baa13f6$var$xo(e, t) {
    return t in e && typeof e[t] == "number";
}
$5b723b129baa13f6$var$s($5b723b129baa13f6$var$xo, "hasNumberKey");
function $5b723b129baa13f6$var$Et(e, t) {
    return t in e && typeof e[t] == "string";
}
$5b723b129baa13f6$var$s($5b723b129baa13f6$var$Et, "hasStringKey");
function $5b723b129baa13f6$var$pe(e, t) {
    return t in e && (typeof e[t] == "string" || e[t] === null);
}
$5b723b129baa13f6$var$s($5b723b129baa13f6$var$pe, "hasStringOrNullKey");
function $5b723b129baa13f6$var$Eo({ queryEditor: e, variableEditor: t, headerEditor: n, responseEditor: r }) {
    return (0, $acw62.useCallback)((l)=>{
        const a = (e == null ? void 0 : e.getValue()) ?? null, i = (t == null ? void 0 : t.getValue()) ?? null, u = (n == null ? void 0 : n.getValue()) ?? null, p = (e == null ? void 0 : e.operationName) ?? null, h = (r == null ? void 0 : r.getValue()) ?? null;
        return $5b723b129baa13f6$var$rn(l, {
            query: a,
            variables: i,
            headers: u,
            response: h,
            operationName: p
        });
    }, [
        e,
        t,
        n,
        r
    ]);
}
$5b723b129baa13f6$var$s($5b723b129baa13f6$var$Eo, "useSynchronizeActiveTabValues");
function $5b723b129baa13f6$var$tn(e, t = !1) {
    return JSON.stringify(e, (n, r)=>n === "hash" || n === "response" || !t && n === "headers" ? null : r);
}
$5b723b129baa13f6$var$s($5b723b129baa13f6$var$tn, "serializeTabState");
function $5b723b129baa13f6$var$Lo({ storage: e, shouldPersistHeaders: t }) {
    const n = (0, $acw62.useMemo)(()=>$5b723b129baa13f6$var$fe(500, (r)=>{
            e == null || e.set($5b723b129baa13f6$var$we, r);
        }), [
        e
    ]);
    return (0, $acw62.useCallback)((r)=>{
        n($5b723b129baa13f6$var$tn(r, t));
    }, [
        t,
        n
    ]);
}
$5b723b129baa13f6$var$s($5b723b129baa13f6$var$Lo, "useStoreTabs");
function $5b723b129baa13f6$var$So({ queryEditor: e, variableEditor: t, headerEditor: n, responseEditor: r }) {
    return (0, $acw62.useCallback)(({ query: l, variables: a, headers: i, response: u })=>{
        e == null || e.setValue(l ?? ""), t == null || t.setValue(a ?? ""), n == null || n.setValue(i ?? ""), r == null || r.setValue(u ?? "");
    }, [
        n,
        e,
        r,
        t
    ]);
}
$5b723b129baa13f6$var$s($5b723b129baa13f6$var$So, "useSetEditorValues");
function $5b723b129baa13f6$var$nn({ query: e = null, variables: t = null, headers: n = null } = {}) {
    return {
        id: $5b723b129baa13f6$var$on(),
        hash: $5b723b129baa13f6$var$Oe({
            query: e,
            variables: t,
            headers: n
        }),
        title: e && $5b723b129baa13f6$var$ut(e) || $5b723b129baa13f6$var$dt,
        query: e,
        variables: t,
        headers: n,
        operationName: null,
        response: null
    };
}
$5b723b129baa13f6$var$s($5b723b129baa13f6$var$nn, "createTab");
function $5b723b129baa13f6$var$rn(e, t) {
    return {
        ...e,
        tabs: e.tabs.map((n, r)=>{
            if (r !== e.activeTabIndex) return n;
            const l = {
                ...n,
                ...t
            };
            return {
                ...l,
                hash: $5b723b129baa13f6$var$Oe(l),
                title: l.operationName || (l.query ? $5b723b129baa13f6$var$ut(l.query) : void 0) || $5b723b129baa13f6$var$dt
            };
        })
    };
}
$5b723b129baa13f6$var$s($5b723b129baa13f6$var$rn, "setPropertiesInActiveTab");
function $5b723b129baa13f6$var$on() {
    const e = /* @__PURE__ */ $5b723b129baa13f6$var$s(()=>Math.floor((1 + Math.random()) * 65536).toString(16).slice(1), "s4");
    return `${e()}${e()}-${e()}-${e()}-${e()}-${e()}${e()}${e()}`;
}
$5b723b129baa13f6$var$s($5b723b129baa13f6$var$on, "guid");
function $5b723b129baa13f6$var$Oe(e) {
    return [
        e.query ?? "",
        e.variables ?? "",
        e.headers ?? ""
    ].join("|");
}
$5b723b129baa13f6$var$s($5b723b129baa13f6$var$Oe, "hashFromTabContents");
function $5b723b129baa13f6$var$ut(e) {
    const n = /^(?!#).*(query|subscription|mutation)\s+([a-zA-Z0-9_]+)/m.exec(e);
    return (n == null ? void 0 : n[2]) ?? null;
}
$5b723b129baa13f6$var$s($5b723b129baa13f6$var$ut, "fuzzyExtractOperationName");
function $5b723b129baa13f6$var$No(e) {
    const t = e == null ? void 0 : e.get($5b723b129baa13f6$var$we);
    if (t) {
        const n = JSON.parse(t);
        e == null || e.set($5b723b129baa13f6$var$we, JSON.stringify(n, (r, l)=>r === "headers" ? null : l));
    }
}
$5b723b129baa13f6$var$s($5b723b129baa13f6$var$No, "clearHeadersFromTabs");
const $5b723b129baa13f6$var$dt = "<untitled>", $5b723b129baa13f6$var$we = "tabState";



function $5b723b129baa13f6$export$33f22fd50da9021b({ editorTheme: e = $5b723b129baa13f6$var$_e, keyMap: t = $5b723b129baa13f6$var$Ze, onClickReference: n, onEdit: r, readOnly: l = !1 } = {}, a) {
    const { initialVariables: i, variableEditor: u, setVariableEditor: p } = $5b723b129baa13f6$export$b119c82498f162a5({
        nonNull: !0,
        caller: a || $5b723b129baa13f6$export$33f22fd50da9021b
    }), h = $5b723b129baa13f6$export$b0467ce6d1ed861f(), f = $5b723b129baa13f6$export$901e59078d6717b6({
        caller: a || $5b723b129baa13f6$export$33f22fd50da9021b
    }), v = $5b723b129baa13f6$export$6cd47fbdfe85a578({
        caller: a || $5b723b129baa13f6$export$33f22fd50da9021b
    }), d = (0, $acw62.useRef)(null), g = (0, $acw62.useRef)();
    return (0, $acw62.useEffect)(()=>{
        let m = !0;
        return $5b723b129baa13f6$var$Ne([
            (parcelRequire("e4CiW")),
            (parcelRequire("6WJqa")),
            (parcelRequire("2kkuJ"))
        ]).then((C)=>{
            if (!m) return;
            g.current = C;
            const x = d.current;
            if (!x) return;
            const k = C(x, {
                value: i,
                lineNumbers: !0,
                tabSize: 2,
                mode: "graphql-variables",
                theme: e,
                autoCloseBrackets: !0,
                matchBrackets: !0,
                showCursorWhenSelecting: !0,
                readOnly: l ? "nocursor" : !1,
                foldGutter: !0,
                lint: {
                    // @ts-expect-error
                    variableToType: void 0
                },
                hintOptions: {
                    closeOnUnfocus: !1,
                    completeSingle: !1,
                    container: x,
                    // @ts-expect-error
                    variableToType: void 0
                },
                gutters: [
                    "CodeMirror-linenumbers",
                    "CodeMirror-foldgutter"
                ],
                extraKeys: $5b723b129baa13f6$var$Ge
            });
            k.addKeyMap({
                "Cmd-Space" () {
                    k.showHint({
                        completeSingle: !1,
                        container: x
                    });
                },
                "Ctrl-Space" () {
                    k.showHint({
                        completeSingle: !1,
                        container: x
                    });
                },
                "Alt-Space" () {
                    k.showHint({
                        completeSingle: !1,
                        container: x
                    });
                },
                "Shift-Space" () {
                    k.showHint({
                        completeSingle: !1,
                        container: x
                    });
                }
            }), k.on("keyup", (L, b)=>{
                const { code: w, key: V, shiftKey: W } = b, _ = w.startsWith("Key"), D = !W && w.startsWith("Digit");
                (_ || D || V === "_" || V === '"') && L.execCommand("autocomplete");
            }), p(k);
        }), ()=>{
            m = !1;
        };
    }, [
        e,
        i,
        l,
        p
    ]), $5b723b129baa13f6$var$Qe(u, "keyMap", t), $5b723b129baa13f6$var$Jt(u, r, $5b723b129baa13f6$var$ln, "variables", $5b723b129baa13f6$export$33f22fd50da9021b), $5b723b129baa13f6$var$Yt(u, n || null, $5b723b129baa13f6$export$33f22fd50da9021b), $5b723b129baa13f6$var$te(u, [
        "Cmd-Enter",
        "Ctrl-Enter"
    ], h == null ? void 0 : h.run), $5b723b129baa13f6$var$te(u, [
        "Shift-Ctrl-P"
    ], v), $5b723b129baa13f6$var$te(u, [
        "Shift-Ctrl-M"
    ], f), d;
}
$5b723b129baa13f6$var$s($5b723b129baa13f6$export$33f22fd50da9021b, "useVariableEditor");
const $5b723b129baa13f6$var$ln = "variables", $5b723b129baa13f6$export$27b8dd149e32f6c7 = $5b723b129baa13f6$var$ce("EditorContext");
function $5b723b129baa13f6$export$df6090aa0843ca0f(e) {
    const t = $5b723b129baa13f6$export$1d88f1dc01e47b0e(), [n, r] = (0, $acw62.useState)(null), [l, a] = (0, $acw62.useState)(null), [i, u] = (0, $acw62.useState)(null), [p, h] = (0, $acw62.useState)(null), [f, v] = (0, $acw62.useState)(()=>{
        const y = (t == null ? void 0 : t.get($5b723b129baa13f6$var$Ue)) !== null;
        return e.shouldPersistHeaders !== !1 && y ? (t == null ? void 0 : t.get($5b723b129baa13f6$var$Ue)) === "true" : !!e.shouldPersistHeaders;
    });
    $5b723b129baa13f6$var$Ve(n, e.headers), $5b723b129baa13f6$var$Ve(l, e.query), $5b723b129baa13f6$var$Ve(i, e.response), $5b723b129baa13f6$var$Ve(p, e.variables);
    const d = $5b723b129baa13f6$var$Lo({
        storage: t,
        shouldPersistHeaders: f
    }), [g] = (0, $acw62.useState)(()=>{
        const y = e.query ?? (t == null ? void 0 : t.get($5b723b129baa13f6$var$en)) ?? null, S = e.variables ?? (t == null ? void 0 : t.get($5b723b129baa13f6$var$ln)) ?? null, R = e.headers ?? (t == null ? void 0 : t.get($5b723b129baa13f6$var$Ae)) ?? null, U = e.response ?? "", Y = $5b723b129baa13f6$var$vo({
            query: y,
            variables: S,
            headers: R,
            defaultTabs: e.defaultTabs,
            defaultQuery: e.defaultQuery || $5b723b129baa13f6$var$To,
            defaultHeaders: e.defaultHeaders,
            storage: t,
            shouldPersistHeaders: f
        });
        return d(Y), {
            query: y ?? (Y.activeTabIndex === 0 ? Y.tabs[0].query : null) ?? "",
            variables: S ?? "",
            headers: R ?? e.defaultHeaders ?? "",
            response: U,
            tabState: Y
        };
    }), [m, C] = (0, $acw62.useState)(g.tabState), x = (0, $acw62.useCallback)((y)=>{
        if (y) {
            t == null || t.set($5b723b129baa13f6$var$Ae, (n == null ? void 0 : n.getValue()) ?? "");
            const S = $5b723b129baa13f6$var$tn(m, !0);
            t == null || t.set($5b723b129baa13f6$var$we, S);
        } else t == null || t.set($5b723b129baa13f6$var$Ae, ""), $5b723b129baa13f6$var$No(t);
        v(y), t == null || t.set($5b723b129baa13f6$var$Ue, y.toString());
    }, [
        t,
        m,
        n
    ]), k = (0, $acw62.useRef)();
    (0, $acw62.useEffect)(()=>{
        const y = !!e.shouldPersistHeaders;
        (k == null ? void 0 : k.current) !== y && (x(y), k.current = y);
    }, [
        e.shouldPersistHeaders,
        x
    ]);
    const L = $5b723b129baa13f6$var$Eo({
        queryEditor: l,
        variableEditor: p,
        headerEditor: n,
        responseEditor: i
    }), b = $5b723b129baa13f6$var$So({
        queryEditor: l,
        variableEditor: p,
        headerEditor: n,
        responseEditor: i
    }), { onTabChange: w, defaultHeaders: V, children: W } = e, _ = (0, $acw62.useCallback)(()=>{
        C((y)=>{
            const S = L(y), R = {
                tabs: [
                    ...S.tabs,
                    $5b723b129baa13f6$var$nn({
                        headers: V
                    })
                ],
                activeTabIndex: S.tabs.length
            };
            return d(R), b(R.tabs[R.activeTabIndex]), w == null || w(R), R;
        });
    }, [
        V,
        w,
        b,
        d,
        L
    ]), D = (0, $acw62.useCallback)((y)=>{
        C((S)=>{
            const R = {
                ...S,
                activeTabIndex: y
            };
            return d(R), b(R.tabs[R.activeTabIndex]), w == null || w(R), R;
        });
    }, [
        w,
        b,
        d
    ]), O = (0, $acw62.useCallback)((y)=>{
        C((S)=>{
            const R = S.tabs[S.activeTabIndex], U = {
                tabs: y,
                activeTabIndex: y.indexOf(R)
            };
            return d(U), b(U.tabs[U.activeTabIndex]), w == null || w(U), U;
        });
    }, [
        w,
        b,
        d
    ]), $ = (0, $acw62.useCallback)((y)=>{
        C((S)=>{
            const R = {
                tabs: S.tabs.filter((U, Y)=>y !== Y),
                activeTabIndex: Math.max(S.activeTabIndex - 1, 0)
            };
            return d(R), b(R.tabs[R.activeTabIndex]), w == null || w(R), R;
        });
    }, [
        w,
        b,
        d
    ]), F = (0, $acw62.useCallback)((y)=>{
        C((S)=>{
            const R = $5b723b129baa13f6$var$rn(S, y);
            return d(R), w == null || w(R), R;
        });
    }, [
        w,
        d
    ]), { onEditOperationName: A } = e, T = (0, $acw62.useCallback)((y)=>{
        l && (l.operationName = y, F({
            operationName: y
        }), A == null || A(y));
    }, [
        A,
        l,
        F
    ]), H = (0, $acw62.useMemo)(()=>{
        const y = /* @__PURE__ */ new Map();
        if (Array.isArray(e.externalFragments)) for (const S of e.externalFragments)y.set(S.name.value, S);
        else if (typeof e.externalFragments == "string") (0, $9m7aI.visit)((0, $8DJ2k.parse)(e.externalFragments, {}), {
            FragmentDefinition (S) {
                y.set(S.name.value, S);
            }
        });
        else if (e.externalFragments) throw new Error("The `externalFragments` prop must either be a string that contains the fragment definitions in SDL or a list of FragmentDefinitionNode objects.");
        return y;
    }, [
        e.externalFragments
    ]), E = (0, $acw62.useMemo)(()=>e.validationRules || [], [
        e.validationRules
    ]), Z = (0, $acw62.useMemo)(()=>({
            ...m,
            addTab: _,
            changeTab: D,
            moveTab: O,
            closeTab: $,
            updateActiveTabValues: F,
            headerEditor: n,
            queryEditor: l,
            responseEditor: i,
            variableEditor: p,
            setHeaderEditor: r,
            setQueryEditor: a,
            setResponseEditor: u,
            setVariableEditor: h,
            setOperationName: T,
            initialQuery: g.query,
            initialVariables: g.variables,
            initialHeaders: g.headers,
            initialResponse: g.response,
            externalFragments: H,
            validationRules: E,
            shouldPersistHeaders: f,
            setShouldPersistHeaders: x
        }), [
        m,
        _,
        D,
        O,
        $,
        F,
        n,
        l,
        i,
        p,
        T,
        g,
        H,
        E,
        f,
        x
    ]);
    return /* @__PURE__ */ (0, $ayMG0.jsx)($5b723b129baa13f6$export$27b8dd149e32f6c7.Provider, {
        value: Z,
        children: W
    });
}
$5b723b129baa13f6$var$s($5b723b129baa13f6$export$df6090aa0843ca0f, "EditorContextProvider");
const $5b723b129baa13f6$export$b119c82498f162a5 = $5b723b129baa13f6$var$ue($5b723b129baa13f6$export$27b8dd149e32f6c7), $5b723b129baa13f6$var$Ue = "shouldPersistHeaders", $5b723b129baa13f6$var$To = `# Welcome to GraphiQL
#
# GraphiQL is an in-browser tool for writing, validating, and
# testing GraphQL queries.
#
# Type queries into this side of the screen, and you will see intelligent
# typeaheads aware of the current GraphQL type schema and live syntax and
# validation errors highlighted within the text.
#
# GraphQL queries typically start with a "{" character. Lines that start
# with a # are ignored.
#
# An example GraphQL query might look like:
#
#     {
#       field(arg: "value") {
#         subField
#       }
#     }
#
# Keyboard shortcuts:
#
#   Prettify query:  Shift-Ctrl-P (or press the prettify button)
#
#  Merge fragments:  Shift-Ctrl-M (or press the merge button)
#
#        Run Query:  Ctrl-Enter (or press the play button)
#
#    Auto Complete:  Ctrl-Space (or just start typing)
#

`;
function $5b723b129baa13f6$export$9c08f57eebcc7fbb({ isHidden: e, ...t }) {
    const { headerEditor: n } = $5b723b129baa13f6$export$b119c82498f162a5({
        nonNull: !0,
        caller: $5b723b129baa13f6$export$9c08f57eebcc7fbb
    }), r = $5b723b129baa13f6$export$cdbbb29991d2bf8b(t, $5b723b129baa13f6$export$9c08f57eebcc7fbb);
    return (0, $acw62.useEffect)(()=>{
        e || n == null || n.refresh();
    }, [
        n,
        e
    ]), /* @__PURE__ */ (0, $ayMG0.jsx)("div", {
        className: (0, $1SA7b.clsx)("graphiql-editor", e && "hidden"),
        ref: r
    });
}
$5b723b129baa13f6$var$s($5b723b129baa13f6$export$9c08f57eebcc7fbb, "HeaderEditor");
function $5b723b129baa13f6$export$4a96334d5925dbf2(e) {
    var p;
    const [t, n] = (0, $acw62.useState)({
        width: null,
        height: null
    }), [r, l] = (0, $acw62.useState)(null), a = (0, $acw62.useRef)(null), i = (p = $5b723b129baa13f6$var$an(e.token)) == null ? void 0 : p.href;
    (0, $acw62.useEffect)(()=>{
        if (a.current) {
            if (!i) {
                n({
                    width: null,
                    height: null
                }), l(null);
                return;
            }
            fetch(i, {
                method: "HEAD"
            }).then((h)=>{
                l(h.headers.get("Content-Type"));
            }).catch(()=>{
                l(null);
            });
        }
    }, [
        i
    ]);
    const u = t.width !== null && t.height !== null ? /* @__PURE__ */ (0, $ayMG0.jsxs)("div", {
        children: [
            t.width,
            "x",
            t.height,
            r === null ? null : " " + r
        ]
    }) : null;
    return /* @__PURE__ */ (0, $ayMG0.jsxs)("div", {
        children: [
            /* @__PURE__ */ (0, $ayMG0.jsx)("img", {
                onLoad: ()=>{
                    var h, f;
                    n({
                        width: ((h = a.current) == null ? void 0 : h.naturalWidth) ?? null,
                        height: ((f = a.current) == null ? void 0 : f.naturalHeight) ?? null
                    });
                },
                ref: a,
                src: i
            }),
            u
        ]
    });
}
$5b723b129baa13f6$var$s($5b723b129baa13f6$export$4a96334d5925dbf2, "ImagePreview");
$5b723b129baa13f6$export$4a96334d5925dbf2.shouldRender = /* @__PURE__ */ $5b723b129baa13f6$var$s(function(t) {
    const n = $5b723b129baa13f6$var$an(t);
    return n ? $5b723b129baa13f6$var$Mo(n) : !1;
}, "shouldRender");
function $5b723b129baa13f6$var$an(e) {
    if (e.type !== "string") return;
    const t = e.string.slice(1).slice(0, -1).trim();
    try {
        const { location: n } = window;
        return new URL(t, n.protocol + "//" + n.host);
    } catch  {
        return;
    }
}
$5b723b129baa13f6$var$s($5b723b129baa13f6$var$an, "tokenToURL");
function $5b723b129baa13f6$var$Mo(e) {
    return /(bmp|gif|jpeg|jpg|png|svg)$/.test(e.pathname);
}
$5b723b129baa13f6$var$s($5b723b129baa13f6$var$Mo, "isImageURL");
function $5b723b129baa13f6$export$11208edffefb3435(e) {
    const t = $5b723b129baa13f6$export$52fa6630ade3da25(e, $5b723b129baa13f6$export$11208edffefb3435);
    return /* @__PURE__ */ (0, $ayMG0.jsx)("div", {
        className: "graphiql-editor",
        ref: t
    });
}
$5b723b129baa13f6$var$s($5b723b129baa13f6$export$11208edffefb3435, "QueryEditor");









function $5b723b129baa13f6$export$b489312ecf6dd058({ responseTooltip: e, editorTheme: t = $5b723b129baa13f6$var$_e, keyMap: n = $5b723b129baa13f6$var$Ze } = {}, r) {
    const { fetchError: l, validationErrors: a } = $5b723b129baa13f6$export$468d7ae1c12d1956({
        nonNull: !0,
        caller: r || $5b723b129baa13f6$export$b489312ecf6dd058
    }), { initialResponse: i, responseEditor: u, setResponseEditor: p } = $5b723b129baa13f6$export$b119c82498f162a5({
        nonNull: !0,
        caller: r || $5b723b129baa13f6$export$b489312ecf6dd058
    }), h = (0, $acw62.useRef)(null), f = (0, $acw62.useRef)(e);
    return (0, $acw62.useEffect)(()=>{
        f.current = e;
    }, [
        e
    ]), (0, $acw62.useEffect)(()=>{
        let v = !0;
        return $5b723b129baa13f6$var$Ne([
            (parcelRequire("j9HgW")).then((d)=>d.f),
            (parcelRequire("3gtj7")).then((d)=>d.b),
            (parcelRequire("k6ghe")).then((d)=>d.d),
            (parcelRequire("dfFxh")).then((d)=>d.s),
            (parcelRequire("bEIbx")).then((d)=>d.s),
            (parcelRequire("8dNb8")).then((d)=>d.j),
            // @ts-expect-error
            (parcelRequire("2dlfv")).then((d)=>d.s),
            (parcelRequire("e8vFr")),
            (parcelRequire("b4VEc"))
        ], {
            useCommonAddons: !1
        }).then((d)=>{
            if (!v) return;
            const g = document.createElement("div");
            d.registerHelper("info", "graphql-results", (x, k, L, b)=>{
                const w = [], V = f.current;
                return V && w.push(/* @__PURE__ */ (0, $ayMG0.jsx)(V, {
                    pos: b,
                    token: x
                })), $5b723b129baa13f6$export$4a96334d5925dbf2.shouldRender(x) && w.push(/* @__PURE__ */ (0, $ayMG0.jsx)($5b723b129baa13f6$export$4a96334d5925dbf2, {
                    token: x
                }, "image-preview")), w.length ? ((0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).render(w, g), g) : ((0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).unmountComponentAtNode(g), null);
            });
            const m = h.current;
            if (!m) return;
            const C = d(m, {
                value: i,
                lineWrapping: !0,
                readOnly: !0,
                theme: t,
                mode: "graphql-results",
                foldGutter: !0,
                gutters: [
                    "CodeMirror-foldgutter"
                ],
                // @ts-expect-error
                info: !0,
                extraKeys: $5b723b129baa13f6$var$Ge
            });
            p(C);
        }), ()=>{
            v = !1;
        };
    }, [
        t,
        i,
        p
    ]), $5b723b129baa13f6$var$Qe(u, "keyMap", n), (0, $acw62.useEffect)(()=>{
        l && (u == null || u.setValue(l)), a.length > 0 && (u == null || u.setValue((0, $a8KRF.formatError)(a)));
    }, [
        u,
        l,
        a
    ]), h;
}
$5b723b129baa13f6$var$s($5b723b129baa13f6$export$b489312ecf6dd058, "useResponseEditor");
function $5b723b129baa13f6$export$e8ec468881fc8802(e) {
    const t = $5b723b129baa13f6$export$b489312ecf6dd058(e, $5b723b129baa13f6$export$e8ec468881fc8802);
    return /* @__PURE__ */ (0, $ayMG0.jsx)("section", {
        className: "result-window",
        "aria-label": "Result Window",
        "aria-live": "polite",
        "aria-atomic": "true",
        ref: t
    });
}
$5b723b129baa13f6$var$s($5b723b129baa13f6$export$e8ec468881fc8802, "ResponseEditor");
function $5b723b129baa13f6$export$37f8f06e2ca92cb5({ isHidden: e, ...t }) {
    const { variableEditor: n } = $5b723b129baa13f6$export$b119c82498f162a5({
        nonNull: !0,
        caller: $5b723b129baa13f6$export$37f8f06e2ca92cb5
    }), r = $5b723b129baa13f6$export$33f22fd50da9021b(t, $5b723b129baa13f6$export$37f8f06e2ca92cb5);
    return (0, $acw62.useEffect)(()=>{
        n && !e && n.refresh();
    }, [
        n,
        e
    ]), /* @__PURE__ */ (0, $ayMG0.jsx)("div", {
        className: (0, $1SA7b.clsx)("graphiql-editor", e && "hidden"),
        ref: r
    });
}
$5b723b129baa13f6$var$s($5b723b129baa13f6$export$37f8f06e2ca92cb5, "VariableEditor");
function $5b723b129baa13f6$export$df7538e96c613481({ children: e, dangerouslyAssumeSchemaIsValid: t, defaultQuery: n, defaultHeaders: r, defaultTabs: l, externalFragments: a, fetcher: i, getDefaultFieldNames: u, headers: p, inputValueDeprecation: h, introspectionQueryName: f, maxHistoryLength: v, onEditOperationName: d, onSchemaChange: g, onTabChange: m, onTogglePluginVisibility: C, operationName: x, plugins: k, query: L, response: b, schema: w, schemaDescription: V, shouldPersistHeaders: W, storage: _, validationRules: D, variables: O, visiblePlugin: $ }) {
    return /* @__PURE__ */ (0, $ayMG0.jsx)($5b723b129baa13f6$export$391446ce2f0d1557, {
        storage: _,
        children: /* @__PURE__ */ (0, $ayMG0.jsx)($5b723b129baa13f6$export$a7f2b2c281690bcd, {
            maxHistoryLength: v,
            children: /* @__PURE__ */ (0, $ayMG0.jsx)($5b723b129baa13f6$export$df6090aa0843ca0f, {
                defaultQuery: n,
                defaultHeaders: r,
                defaultTabs: l,
                externalFragments: a,
                headers: p,
                onEditOperationName: d,
                onTabChange: m,
                query: L,
                response: b,
                shouldPersistHeaders: W,
                validationRules: D,
                variables: O,
                children: /* @__PURE__ */ (0, $ayMG0.jsx)($5b723b129baa13f6$export$ad72d84d137207fb, {
                    dangerouslyAssumeSchemaIsValid: t,
                    fetcher: i,
                    inputValueDeprecation: h,
                    introspectionQueryName: f,
                    onSchemaChange: g,
                    schema: w,
                    schemaDescription: V,
                    children: /* @__PURE__ */ (0, $ayMG0.jsx)($5b723b129baa13f6$export$14f2a780bc6de643, {
                        getDefaultFieldNames: u,
                        fetcher: i,
                        operationName: x,
                        children: /* @__PURE__ */ (0, $ayMG0.jsx)($5b723b129baa13f6$export$50f5f436c5e784bd, {
                            children: /* @__PURE__ */ (0, $ayMG0.jsx)($5b723b129baa13f6$export$841211ff5aa203b9, {
                                onTogglePluginVisibility: C,
                                plugins: k,
                                visiblePlugin: $,
                                children: e
                            })
                        })
                    })
                })
            })
        })
    });
}
$5b723b129baa13f6$var$s($5b723b129baa13f6$export$df7538e96c613481, "GraphiQLProvider");
function $5b723b129baa13f6$export$93d4e7f90805808f() {
    const e = $5b723b129baa13f6$export$1d88f1dc01e47b0e(), [t, n] = (0, $acw62.useState)(()=>{
        if (!e) return null;
        const l = e.get($5b723b129baa13f6$var$Ke);
        switch(l){
            case "light":
                return "light";
            case "dark":
                return "dark";
            default:
                return typeof l == "string" && e.set($5b723b129baa13f6$var$Ke, ""), null;
        }
    });
    (0, $acw62.useLayoutEffect)(()=>{
        typeof window > "u" || (document.body.classList.remove("graphiql-light", "graphiql-dark"), t && document.body.classList.add(`graphiql-${t}`));
    }, [
        t
    ]);
    const r = (0, $acw62.useCallback)((l)=>{
        e == null || e.set($5b723b129baa13f6$var$Ke, l || ""), n(l);
    }, [
        e
    ]);
    return (0, $acw62.useMemo)(()=>({
            theme: t,
            setTheme: r
        }), [
        t,
        r
    ]);
}
$5b723b129baa13f6$var$s($5b723b129baa13f6$export$93d4e7f90805808f, "useTheme");
const $5b723b129baa13f6$var$Ke = "theme";
function $5b723b129baa13f6$export$cbaee0f66e3262dc({ defaultSizeRelation: e = $5b723b129baa13f6$var$Ho, direction: t, initiallyHidden: n, onHiddenElementChange: r, sizeThresholdFirst: l = 100, sizeThresholdSecond: a = 100, storageKey: i }) {
    const u = $5b723b129baa13f6$export$1d88f1dc01e47b0e(), p = (0, $acw62.useMemo)(()=>$5b723b129baa13f6$var$fe(500, (L)=>{
            i && (u == null || u.set(i, L));
        }), [
        u,
        i
    ]), [h, f] = (0, $acw62.useState)(()=>{
        const L = i && (u == null ? void 0 : u.get(i));
        return L === $5b723b129baa13f6$var$Re || n === "first" ? "first" : L === $5b723b129baa13f6$var$He || n === "second" ? "second" : null;
    }), v = (0, $acw62.useCallback)((L)=>{
        L !== h && (f(L), r == null || r(L));
    }, [
        h,
        r
    ]), d = (0, $acw62.useRef)(null), g = (0, $acw62.useRef)(null), m = (0, $acw62.useRef)(null), C = (0, $acw62.useRef)(`${e}`);
    (0, $acw62.useLayoutEffect)(()=>{
        const L = i && (u == null ? void 0 : u.get(i)) || C.current;
        d.current && (d.current.style.display = "flex", d.current.style.flex = L === $5b723b129baa13f6$var$Re || L === $5b723b129baa13f6$var$He ? C.current : L), m.current && (m.current.style.display = "flex", m.current.style.flex = "1"), g.current && (g.current.style.display = "flex");
    }, [
        t,
        u,
        i
    ]);
    const x = (0, $acw62.useCallback)((L)=>{
        const b = L === "first" ? d.current : m.current;
        if (b && (b.style.left = "-1000px", b.style.position = "absolute", b.style.opacity = "0", b.style.height = "500px", b.style.width = "500px", d.current)) {
            const w = parseFloat(d.current.style.flex);
            (!Number.isFinite(w) || w < 1) && (d.current.style.flex = "1");
        }
    }, []), k = (0, $acw62.useCallback)((L)=>{
        const b = L === "first" ? d.current : m.current;
        if (b && (b.style.width = "", b.style.height = "", b.style.opacity = "", b.style.position = "", b.style.left = "", u && i)) {
            const w = u.get(i);
            d.current && w !== $5b723b129baa13f6$var$Re && w !== $5b723b129baa13f6$var$He && (d.current.style.flex = w || C.current);
        }
    }, [
        u,
        i
    ]);
    return (0, $acw62.useLayoutEffect)(()=>{
        h === "first" ? x("first") : k("first"), h === "second" ? x("second") : k("second");
    }, [
        h,
        x,
        k
    ]), (0, $acw62.useEffect)(()=>{
        if (!g.current || !d.current || !m.current) return;
        const L = g.current, b = d.current, w = b.parentElement, V = t === "horizontal" ? "clientX" : "clientY", W = t === "horizontal" ? "left" : "top", _ = t === "horizontal" ? "right" : "bottom", D = t === "horizontal" ? "clientWidth" : "clientHeight";
        function O(F) {
            F.preventDefault();
            const A = F[V] - L.getBoundingClientRect()[W];
            function T(E) {
                if (E.buttons === 0) return H();
                const Z = E[V] - w.getBoundingClientRect()[W] - A, y = w.getBoundingClientRect()[_] - E[V] + A - L[D];
                if (Z < l) v("first"), p($5b723b129baa13f6$var$Re);
                else if (y < a) v("second"), p($5b723b129baa13f6$var$He);
                else {
                    v(null);
                    const S = `${Z / y}`;
                    b.style.flex = S, p(S);
                }
            }
            $5b723b129baa13f6$var$s(T, "handleMouseMove");
            function H() {
                document.removeEventListener("mousemove", T), document.removeEventListener("mouseup", H);
            }
            $5b723b129baa13f6$var$s(H, "handleMouseUp"), document.addEventListener("mousemove", T), document.addEventListener("mouseup", H);
        }
        $5b723b129baa13f6$var$s(O, "handleMouseDown"), L.addEventListener("mousedown", O);
        function $() {
            d.current && (d.current.style.flex = C.current), p(C.current), v(null);
        }
        return $5b723b129baa13f6$var$s($, "reset"), L.addEventListener("dblclick", $), ()=>{
            L.removeEventListener("mousedown", O), L.removeEventListener("dblclick", $);
        };
    }, [
        t,
        v,
        l,
        a,
        p
    ]), (0, $acw62.useMemo)(()=>({
            dragBarRef: g,
            hiddenElement: h,
            firstRef: d,
            setHiddenElement: f,
            secondRef: m
        }), [
        h,
        f
    ]);
}
$5b723b129baa13f6$var$s($5b723b129baa13f6$export$cbaee0f66e3262dc, "useDragResize");
const $5b723b129baa13f6$var$Ho = 1, $5b723b129baa13f6$var$Re = "hide-first", $5b723b129baa13f6$var$He = "hide-second";
const $5b723b129baa13f6$export$e5c1a33878e86e9e = (0, $acw62.forwardRef)(({ label: e, onClick: t, ...n }, r)=>{
    const [l, a] = (0, $acw62.useState)(null), i = (0, $acw62.useCallback)((u)=>{
        try {
            t == null || t(u), a(null);
        } catch (p) {
            a(p instanceof Error ? p : new Error(`Toolbar button click failed: ${p}`));
        }
    }, [
        t
    ]);
    return /* @__PURE__ */ (0, $ayMG0.jsx)($5b723b129baa13f6$export$28c660c63b792dea, {
        label: e,
        children: /* @__PURE__ */ (0, $ayMG0.jsx)($5b723b129baa13f6$export$fee7dc9850636d63, {
            ...n,
            ref: r,
            type: "button",
            className: (0, $1SA7b.clsx)("graphiql-toolbar-button", l && "error", n.className),
            onClick: i,
            "aria-label": l ? l.message : e,
            "aria-invalid": l ? "true" : n["aria-invalid"]
        })
    });
});
$5b723b129baa13f6$export$e5c1a33878e86e9e.displayName = "ToolbarButton";
function $5b723b129baa13f6$export$55a335d669baee54() {
    const { queryEditor: e, setOperationName: t } = $5b723b129baa13f6$export$b119c82498f162a5({
        nonNull: !0,
        caller: $5b723b129baa13f6$export$55a335d669baee54
    }), { isFetching: n, isSubscribed: r, operationName: l, run: a, stop: i } = $5b723b129baa13f6$export$b0467ce6d1ed861f({
        nonNull: !0,
        caller: $5b723b129baa13f6$export$55a335d669baee54
    }), u = (e == null ? void 0 : e.operations) || [], p = u.length > 1 && typeof l != "string", h = n || r, f = `${h ? "Stop" : "Execute"} query (Ctrl-Enter)`, v = {
        type: "button",
        className: "graphiql-execute-button",
        children: h ? /* @__PURE__ */ (0, $ayMG0.jsx)($5b723b129baa13f6$export$dc6949a98411e916, {}) : /* @__PURE__ */ (0, $ayMG0.jsx)($5b723b129baa13f6$export$a6630b90defda83f, {}),
        "aria-label": f
    };
    return p && !h ? /* @__PURE__ */ (0, $ayMG0.jsxs)($5b723b129baa13f6$export$e44a253a59704894, {
        children: [
            /* @__PURE__ */ (0, $ayMG0.jsx)($5b723b129baa13f6$export$28c660c63b792dea, {
                label: f,
                children: /* @__PURE__ */ (0, $ayMG0.jsx)($5b723b129baa13f6$export$e44a253a59704894.Button, {
                    ...v
                })
            }),
            /* @__PURE__ */ (0, $ayMG0.jsx)($5b723b129baa13f6$export$e44a253a59704894.Content, {
                children: u.map((d, g)=>{
                    const m = d.name ? d.name.value : `<Unnamed ${d.operation}>`;
                    return /* @__PURE__ */ (0, $ayMG0.jsx)($5b723b129baa13f6$export$e44a253a59704894.Item, {
                        onSelect: ()=>{
                            var x;
                            const C = (x = d.name) == null ? void 0 : x.value;
                            e && C && C !== e.operationName && t(C), a();
                        },
                        children: m
                    }, `${m}-${g}`);
                })
            })
        ]
    }) : /* @__PURE__ */ (0, $ayMG0.jsx)($5b723b129baa13f6$export$28c660c63b792dea, {
        label: f,
        children: /* @__PURE__ */ (0, $ayMG0.jsx)("button", {
            ...v,
            onClick: ()=>{
                h ? i() : a();
            }
        })
    });
}
$5b723b129baa13f6$var$s($5b723b129baa13f6$export$55a335d669baee54, "ExecuteButton");
const $5b723b129baa13f6$var$qo = /* @__PURE__ */ $5b723b129baa13f6$var$s(({ button: e, children: t, label: n, ...r })=>/* @__PURE__ */ (0, $ayMG0.jsxs)($5b723b129baa13f6$export$e44a253a59704894, {
        ...r,
        children: [
            /* @__PURE__ */ (0, $ayMG0.jsx)($5b723b129baa13f6$export$28c660c63b792dea, {
                label: n,
                children: /* @__PURE__ */ (0, $ayMG0.jsx)($5b723b129baa13f6$export$e44a253a59704894.Button, {
                    className: (0, $1SA7b.clsx)("graphiql-un-styled graphiql-toolbar-menu", r.className),
                    "aria-label": n,
                    children: e
                })
            }),
            /* @__PURE__ */ (0, $ayMG0.jsx)($5b723b129baa13f6$export$e44a253a59704894.Content, {
                children: t
            })
        ]
    }), "ToolbarMenuRoot"), $5b723b129baa13f6$export$1f4688db2a0d3d39 = $5b723b129baa13f6$var$Se($5b723b129baa13f6$var$qo, {
    Item: $5b723b129baa13f6$export$e44a253a59704894.Item
});

});
parcelRegister("ayMG0", function(module, exports) {
"use strict";

module.exports = (parcelRequire("1b2ls"));

});
parcelRegister("1b2ls", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $0db8a335f84591c1$export$ffb0004e005737fa, (v) => $0db8a335f84591c1$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $0db8a335f84591c1$export$34b9dba7ce09269b, (v) => $0db8a335f84591c1$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $0db8a335f84591c1$export$25062201e9e25d76, (v) => $0db8a335f84591c1$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0db8a335f84591c1$export$ffb0004e005737fa;
var $0db8a335f84591c1$export$34b9dba7ce09269b;
var $0db8a335f84591c1$export$25062201e9e25d76;
"use strict";

var $acw62 = parcelRequire("acw62");
var $0db8a335f84591c1$var$k = Symbol.for("react.element"), $0db8a335f84591c1$var$l = Symbol.for("react.fragment"), $0db8a335f84591c1$var$m = Object.prototype.hasOwnProperty, $0db8a335f84591c1$var$n = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $0db8a335f84591c1$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0db8a335f84591c1$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$0db8a335f84591c1$var$m.call(a, b) && !$0db8a335f84591c1$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $0db8a335f84591c1$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $0db8a335f84591c1$var$n.current
    };
}
$0db8a335f84591c1$export$ffb0004e005737fa = $0db8a335f84591c1$var$l;
$0db8a335f84591c1$export$34b9dba7ce09269b = $0db8a335f84591c1$var$q;
$0db8a335f84591c1$export$25062201e9e25d76 = $0db8a335f84591c1$var$q;

});


parcelRegister("1SA7b", function(module, exports) {

$parcel$export(module.exports, "clsx", () => $15e6d94060e5d8b6$export$4f5d2d50c9deca37);
function $15e6d94060e5d8b6$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = $15e6d94060e5d8b6$var$r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function $15e6d94060e5d8b6$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = $15e6d94060e5d8b6$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $15e6d94060e5d8b6$export$2e2bcd8739ae039 = $15e6d94060e5d8b6$export$4f5d2d50c9deca37;

});

parcelRegister("3MaO2", function(module, exports) {

$parcel$export(module.exports, "astFromValue", () => $40951adfc94321ae$export$973c016b19737b40);

var $gHwk7 = parcelRequire("gHwk7");

var $l3zHt = parcelRequire("l3zHt");

var $4wIbP = parcelRequire("4wIbP");

var $cryJ5 = parcelRequire("cryJ5");

var $hu3w4 = parcelRequire("hu3w4");

var $54dWd = parcelRequire("54dWd");

var $l5aqI = parcelRequire("l5aqI");
function $40951adfc94321ae$export$973c016b19737b40(value, type) {
    if ((0, $54dWd.isNonNullType)(type)) {
        const astValue = $40951adfc94321ae$export$973c016b19737b40(value, type.ofType);
        if ((astValue === null || astValue === void 0 ? void 0 : astValue.kind) === (0, $hu3w4.Kind).NULL) return null;
        return astValue;
    } // only explicit null, not undefined, NaN
    if (value === null) return {
        kind: (0, $hu3w4.Kind).NULL
    };
     // undefined
    if (value === undefined) return null;
     // Convert JavaScript array to GraphQL list. If the GraphQLType is a list, but
    // the value is not an array, convert the value using the list's item type.
    if ((0, $54dWd.isListType)(type)) {
        const itemType = type.ofType;
        if ((0, $4wIbP.isIterableObject)(value)) {
            const valuesNodes = [];
            for (const item of value){
                const itemNode = $40951adfc94321ae$export$973c016b19737b40(item, itemType);
                if (itemNode != null) valuesNodes.push(itemNode);
            }
            return {
                kind: (0, $hu3w4.Kind).LIST,
                values: valuesNodes
            };
        }
        return $40951adfc94321ae$export$973c016b19737b40(value, itemType);
    } // Populate the fields of the input object by creating ASTs from each value
    // in the JavaScript object according to the fields in the input type.
    if ((0, $54dWd.isInputObjectType)(type)) {
        if (!(0, $cryJ5.isObjectLike)(value)) return null;
        const fieldNodes = [];
        for (const field of Object.values(type.getFields())){
            const fieldValue = $40951adfc94321ae$export$973c016b19737b40(value[field.name], field.type);
            if (fieldValue) fieldNodes.push({
                kind: (0, $hu3w4.Kind).OBJECT_FIELD,
                name: {
                    kind: (0, $hu3w4.Kind).NAME,
                    value: field.name
                },
                value: fieldValue
            });
        }
        return {
            kind: (0, $hu3w4.Kind).OBJECT,
            fields: fieldNodes
        };
    }
    if ((0, $54dWd.isLeafType)(type)) {
        // Since value is an internally represented value, it must be serialized
        // to an externally represented value before converting into an AST.
        const serialized = type.serialize(value);
        if (serialized == null) return null;
         // Others serialize based on their corresponding JavaScript scalar types.
        if (typeof serialized === "boolean") return {
            kind: (0, $hu3w4.Kind).BOOLEAN,
            value: serialized
        };
         // JavaScript numbers can be Int or Float values.
        if (typeof serialized === "number" && Number.isFinite(serialized)) {
            const stringNum = String(serialized);
            return $40951adfc94321ae$var$integerStringRegExp.test(stringNum) ? {
                kind: (0, $hu3w4.Kind).INT,
                value: stringNum
            } : {
                kind: (0, $hu3w4.Kind).FLOAT,
                value: stringNum
            };
        }
        if (typeof serialized === "string") {
            // Enum types use Enum literals.
            if ((0, $54dWd.isEnumType)(type)) return {
                kind: (0, $hu3w4.Kind).ENUM,
                value: serialized
            };
             // ID types can use Int literals.
            if (type === (0, $l5aqI.GraphQLID) && $40951adfc94321ae$var$integerStringRegExp.test(serialized)) return {
                kind: (0, $hu3w4.Kind).INT,
                value: serialized
            };
            return {
                kind: (0, $hu3w4.Kind).STRING,
                value: serialized
            };
        }
        throw new TypeError(`Cannot convert value to AST: ${(0, $gHwk7.inspect)(serialized)}.`);
    }
    /* c8 ignore next 3 */ // Not reachable, all possible types have been considered.
    (0, $l3zHt.invariant)(false, "Unexpected input type: " + (0, $gHwk7.inspect)(type));
}
/**
 * IntValue:
 *   - NegativeSign? 0
 *   - NegativeSign? NonZeroDigit ( Digit+ )?
 */ const $40951adfc94321ae$var$integerStringRegExp = /^-?(?:0|[1-9][0-9]*)$/;

});
parcelRegister("gHwk7", function(module, exports) {

$parcel$export(module.exports, "inspect", () => $9541a54af6a37409$export$9dec5d1b3b6a130d);
const $9541a54af6a37409$var$MAX_ARRAY_LENGTH = 10;
const $9541a54af6a37409$var$MAX_RECURSIVE_DEPTH = 2;
function $9541a54af6a37409$export$9dec5d1b3b6a130d(value) {
    return $9541a54af6a37409$var$formatValue(value, []);
}
function $9541a54af6a37409$var$formatValue(value, seenValues) {
    switch(typeof value){
        case "string":
            return JSON.stringify(value);
        case "function":
            return value.name ? `[function ${value.name}]` : "[function]";
        case "object":
            return $9541a54af6a37409$var$formatObjectValue(value, seenValues);
        default:
            return String(value);
    }
}
function $9541a54af6a37409$var$formatObjectValue(value, previouslySeenValues) {
    if (value === null) return "null";
    if (previouslySeenValues.includes(value)) return "[Circular]";
    const seenValues = [
        ...previouslySeenValues,
        value
    ];
    if ($9541a54af6a37409$var$isJSONable(value)) {
        const jsonValue = value.toJSON(); // check for infinite recursion
        if (jsonValue !== value) return typeof jsonValue === "string" ? jsonValue : $9541a54af6a37409$var$formatValue(jsonValue, seenValues);
    } else if (Array.isArray(value)) return $9541a54af6a37409$var$formatArray(value, seenValues);
    return $9541a54af6a37409$var$formatObject(value, seenValues);
}
function $9541a54af6a37409$var$isJSONable(value) {
    return typeof value.toJSON === "function";
}
function $9541a54af6a37409$var$formatObject(object, seenValues) {
    const entries = Object.entries(object);
    if (entries.length === 0) return "{}";
    if (seenValues.length > $9541a54af6a37409$var$MAX_RECURSIVE_DEPTH) return "[" + $9541a54af6a37409$var$getObjectTag(object) + "]";
    const properties = entries.map(([key, value])=>key + ": " + $9541a54af6a37409$var$formatValue(value, seenValues));
    return "{ " + properties.join(", ") + " }";
}
function $9541a54af6a37409$var$formatArray(array, seenValues) {
    if (array.length === 0) return "[]";
    if (seenValues.length > $9541a54af6a37409$var$MAX_RECURSIVE_DEPTH) return "[Array]";
    const len = Math.min($9541a54af6a37409$var$MAX_ARRAY_LENGTH, array.length);
    const remaining = array.length - len;
    const items = [];
    for(let i = 0; i < len; ++i)items.push($9541a54af6a37409$var$formatValue(array[i], seenValues));
    if (remaining === 1) items.push("... 1 more item");
    else if (remaining > 1) items.push(`... ${remaining} more items`);
    return "[" + items.join(", ") + "]";
}
function $9541a54af6a37409$var$getObjectTag(object) {
    const tag = Object.prototype.toString.call(object).replace(/^\[object /, "").replace(/]$/, "");
    if (tag === "Object" && typeof object.constructor === "function") {
        const name = object.constructor.name;
        if (typeof name === "string" && name !== "") return name;
    }
    return tag;
}

});

parcelRegister("l3zHt", function(module, exports) {

$parcel$export(module.exports, "invariant", () => $0989dd6156f69013$export$f5708dca728d7177);
function $0989dd6156f69013$export$f5708dca728d7177(condition, message) {
    const booleanCondition = Boolean(condition);
    if (!booleanCondition) throw new Error(message != null ? message : "Unexpected invariant triggered.");
}

});

parcelRegister("4wIbP", function(module, exports) {

$parcel$export(module.exports, "isIterableObject", () => $e5bdd3653712be35$export$b19d151aa2c09b40);
/**
 * Returns true if the provided object is an Object (i.e. not a string literal)
 * and implements the Iterator protocol.
 *
 * This may be used in place of [Array.isArray()][isArray] to determine if
 * an object should be iterated-over e.g. Array, Map, Set, Int8Array,
 * TypedArray, etc. but excludes string literals.
 *
 * @example
 * ```ts
 * isIterableObject([ 1, 2, 3 ]) // true
 * isIterableObject(new Map()) // true
 * isIterableObject('ABC') // false
 * isIterableObject({ key: 'value' }) // false
 * isIterableObject({ length: 1, 0: 'Alpha' }) // false
 * ```
 */ function $e5bdd3653712be35$export$b19d151aa2c09b40(maybeIterable) {
    return typeof maybeIterable === "object" && typeof (maybeIterable === null || maybeIterable === void 0 ? void 0 : maybeIterable[Symbol.iterator]) === "function";
}

});

parcelRegister("cryJ5", function(module, exports) {

$parcel$export(module.exports, "isObjectLike", () => $f419306d4be7fb23$export$c10d0b04eaa80a43);
/**
 * Return true if `value` is object-like. A value is object-like if it's not
 * `null` and has a `typeof` result of "object".
 */ function $f419306d4be7fb23$export$c10d0b04eaa80a43(value) {
    return typeof value == "object" && value !== null;
}

});

parcelRegister("hu3w4", function(module, exports) {

$parcel$export(module.exports, "Kind", () => $b7b8db97a7d116fe$export$a84bdc57c5122798);
/**
 * The set of allowed kind values for AST nodes.
 */ var $b7b8db97a7d116fe$export$a84bdc57c5122798;
(function(Kind) {
    Kind["NAME"] = "Name";
    Kind["DOCUMENT"] = "Document";
    Kind["OPERATION_DEFINITION"] = "OperationDefinition";
    Kind["VARIABLE_DEFINITION"] = "VariableDefinition";
    Kind["SELECTION_SET"] = "SelectionSet";
    Kind["FIELD"] = "Field";
    Kind["ARGUMENT"] = "Argument";
    Kind["FRAGMENT_SPREAD"] = "FragmentSpread";
    Kind["INLINE_FRAGMENT"] = "InlineFragment";
    Kind["FRAGMENT_DEFINITION"] = "FragmentDefinition";
    Kind["VARIABLE"] = "Variable";
    Kind["INT"] = "IntValue";
    Kind["FLOAT"] = "FloatValue";
    Kind["STRING"] = "StringValue";
    Kind["BOOLEAN"] = "BooleanValue";
    Kind["NULL"] = "NullValue";
    Kind["ENUM"] = "EnumValue";
    Kind["LIST"] = "ListValue";
    Kind["OBJECT"] = "ObjectValue";
    Kind["OBJECT_FIELD"] = "ObjectField";
    Kind["DIRECTIVE"] = "Directive";
    Kind["NAMED_TYPE"] = "NamedType";
    Kind["LIST_TYPE"] = "ListType";
    Kind["NON_NULL_TYPE"] = "NonNullType";
    Kind["SCHEMA_DEFINITION"] = "SchemaDefinition";
    Kind["OPERATION_TYPE_DEFINITION"] = "OperationTypeDefinition";
    Kind["SCALAR_TYPE_DEFINITION"] = "ScalarTypeDefinition";
    Kind["OBJECT_TYPE_DEFINITION"] = "ObjectTypeDefinition";
    Kind["FIELD_DEFINITION"] = "FieldDefinition";
    Kind["INPUT_VALUE_DEFINITION"] = "InputValueDefinition";
    Kind["INTERFACE_TYPE_DEFINITION"] = "InterfaceTypeDefinition";
    Kind["UNION_TYPE_DEFINITION"] = "UnionTypeDefinition";
    Kind["ENUM_TYPE_DEFINITION"] = "EnumTypeDefinition";
    Kind["ENUM_VALUE_DEFINITION"] = "EnumValueDefinition";
    Kind["INPUT_OBJECT_TYPE_DEFINITION"] = "InputObjectTypeDefinition";
    Kind["DIRECTIVE_DEFINITION"] = "DirectiveDefinition";
    Kind["SCHEMA_EXTENSION"] = "SchemaExtension";
    Kind["SCALAR_TYPE_EXTENSION"] = "ScalarTypeExtension";
    Kind["OBJECT_TYPE_EXTENSION"] = "ObjectTypeExtension";
    Kind["INTERFACE_TYPE_EXTENSION"] = "InterfaceTypeExtension";
    Kind["UNION_TYPE_EXTENSION"] = "UnionTypeExtension";
    Kind["ENUM_TYPE_EXTENSION"] = "EnumTypeExtension";
    Kind["INPUT_OBJECT_TYPE_EXTENSION"] = "InputObjectTypeExtension";
})($b7b8db97a7d116fe$export$a84bdc57c5122798 || ($b7b8db97a7d116fe$export$a84bdc57c5122798 = {}));
 /**
 * The enum type representing the possible kind values of AST nodes.
 *
 * @deprecated Please use `Kind`. Will be remove in v17.
 */ 
});

parcelRegister("54dWd", function(module, exports) {

$parcel$export(module.exports, "isType", () => $d1335bfebc5bc5fc$export$26b9f946b448f23e);
$parcel$export(module.exports, "isScalarType", () => $d1335bfebc5bc5fc$export$5ef3b9aefb31c08b);
$parcel$export(module.exports, "isObjectType", () => $d1335bfebc5bc5fc$export$f3091ca7b0907a5f);
$parcel$export(module.exports, "isInterfaceType", () => $d1335bfebc5bc5fc$export$32fba5696fa641e);
$parcel$export(module.exports, "isUnionType", () => $d1335bfebc5bc5fc$export$cca4caab5ef5a545);
$parcel$export(module.exports, "isEnumType", () => $d1335bfebc5bc5fc$export$360fc30cf304623);
$parcel$export(module.exports, "isInputObjectType", () => $d1335bfebc5bc5fc$export$594edc80cf154b94);
$parcel$export(module.exports, "isListType", () => $d1335bfebc5bc5fc$export$f1003c1e9d4b008c);
$parcel$export(module.exports, "isNonNullType", () => $d1335bfebc5bc5fc$export$146b6508fa0d6c82);
$parcel$export(module.exports, "assertType", () => $d1335bfebc5bc5fc$export$804de46662e4ac95);
$parcel$export(module.exports, "GraphQLScalarType", () => $d1335bfebc5bc5fc$export$64842b98ea53a3c9);
$parcel$export(module.exports, "assertScalarType", () => $d1335bfebc5bc5fc$export$6bfb69547e804cfa);
$parcel$export(module.exports, "GraphQLObjectType", () => $d1335bfebc5bc5fc$export$375d3757a19c2e6e);
$parcel$export(module.exports, "assertObjectType", () => $d1335bfebc5bc5fc$export$37a13eb12fbf3bc7);
$parcel$export(module.exports, "GraphQLInterfaceType", () => $d1335bfebc5bc5fc$export$148e92587b8bf1f9);
$parcel$export(module.exports, "assertInterfaceType", () => $d1335bfebc5bc5fc$export$b0fa8729bfe4811b);
$parcel$export(module.exports, "GraphQLUnionType", () => $d1335bfebc5bc5fc$export$33c479b4c3812d0b);
$parcel$export(module.exports, "assertUnionType", () => $d1335bfebc5bc5fc$export$fd1fc643145b79aa);
$parcel$export(module.exports, "GraphQLEnumType", () => $d1335bfebc5bc5fc$export$2577fb93f8748953);
$parcel$export(module.exports, "assertEnumType", () => $d1335bfebc5bc5fc$export$152b058be1610b0e);
$parcel$export(module.exports, "GraphQLInputObjectType", () => $d1335bfebc5bc5fc$export$ea29baa44b9fd772);
$parcel$export(module.exports, "assertInputObjectType", () => $d1335bfebc5bc5fc$export$d3177a47c4ed448a);
$parcel$export(module.exports, "GraphQLList", () => $d1335bfebc5bc5fc$export$de552006a6243367);
$parcel$export(module.exports, "assertListType", () => $d1335bfebc5bc5fc$export$a4a2309317558e91);
$parcel$export(module.exports, "GraphQLNonNull", () => $d1335bfebc5bc5fc$export$ea3122a3d819ac9d);
$parcel$export(module.exports, "assertNonNullType", () => $d1335bfebc5bc5fc$export$4c0a7702e4a2acc9);
$parcel$export(module.exports, "isInputType", () => $d1335bfebc5bc5fc$export$1e617af703572bb5);
$parcel$export(module.exports, "isWrappingType", () => $d1335bfebc5bc5fc$export$2dbe78c78d9c62bb);
$parcel$export(module.exports, "assertInputType", () => $d1335bfebc5bc5fc$export$6e3e8b9b85427518);
$parcel$export(module.exports, "isOutputType", () => $d1335bfebc5bc5fc$export$27aadee607de5794);
$parcel$export(module.exports, "assertOutputType", () => $d1335bfebc5bc5fc$export$3efb5e473c31d62b);
$parcel$export(module.exports, "isLeafType", () => $d1335bfebc5bc5fc$export$b390adabc64bab3);
$parcel$export(module.exports, "assertLeafType", () => $d1335bfebc5bc5fc$export$2bb5b8127c27d0cc);
$parcel$export(module.exports, "isCompositeType", () => $d1335bfebc5bc5fc$export$3d8f0e61f2e75bb0);
$parcel$export(module.exports, "assertCompositeType", () => $d1335bfebc5bc5fc$export$5b55b276a74cf725);
$parcel$export(module.exports, "isAbstractType", () => $d1335bfebc5bc5fc$export$6ea44a810dec4ac5);
$parcel$export(module.exports, "assertAbstractType", () => $d1335bfebc5bc5fc$export$d7092fd91c1fbaf8);
$parcel$export(module.exports, "isNullableType", () => $d1335bfebc5bc5fc$export$103e38848746832);
$parcel$export(module.exports, "assertWrappingType", () => $d1335bfebc5bc5fc$export$ee52e012d8d583c6);
$parcel$export(module.exports, "assertNullableType", () => $d1335bfebc5bc5fc$export$9c6e9b78e1767de4);
$parcel$export(module.exports, "getNullableType", () => $d1335bfebc5bc5fc$export$88b885687e78334b);
$parcel$export(module.exports, "isNamedType", () => $d1335bfebc5bc5fc$export$f99194494d5b1a26);
$parcel$export(module.exports, "assertNamedType", () => $d1335bfebc5bc5fc$export$57234e7b640498aa);
$parcel$export(module.exports, "getNamedType", () => $d1335bfebc5bc5fc$export$e6cd8ba67f39ede0);
$parcel$export(module.exports, "resolveReadonlyArrayThunk", () => $d1335bfebc5bc5fc$export$74e03cf55cd9824);
$parcel$export(module.exports, "resolveObjMapThunk", () => $d1335bfebc5bc5fc$export$a4816c39797d8bd4);
$parcel$export(module.exports, "defineArguments", () => $d1335bfebc5bc5fc$export$4fa00ef8239acb15);
$parcel$export(module.exports, "argsToArgsConfig", () => $d1335bfebc5bc5fc$export$ae5ade30c645f6fd);
$parcel$export(module.exports, "isRequiredArgument", () => $d1335bfebc5bc5fc$export$caef08b21560291a);
$parcel$export(module.exports, "isRequiredInputField", () => $d1335bfebc5bc5fc$export$2657dcc79c2b6229);

var $lDltR = parcelRequire("lDltR");

var $ej6fd = parcelRequire("ej6fd");

var $lVzZw = parcelRequire("lVzZw");

var $gHwk7 = parcelRequire("gHwk7");

var $7NKAi = parcelRequire("7NKAi");

var $cryJ5 = parcelRequire("cryJ5");

var $1inQZ = parcelRequire("1inQZ");

var $3ahKk = parcelRequire("3ahKk");

var $3LUIw = parcelRequire("3LUIw");

var $a2eVh = parcelRequire("a2eVh");

var $lNeRj = parcelRequire("lNeRj");

var $fHcz3 = parcelRequire("fHcz3");

var $hu3w4 = parcelRequire("hu3w4");

var $3o9dz = parcelRequire("3o9dz");

var $856R3 = parcelRequire("856R3");

var $kr4gH = parcelRequire("kr4gH");
function $d1335bfebc5bc5fc$export$26b9f946b448f23e(type) {
    return $d1335bfebc5bc5fc$export$5ef3b9aefb31c08b(type) || $d1335bfebc5bc5fc$export$f3091ca7b0907a5f(type) || $d1335bfebc5bc5fc$export$32fba5696fa641e(type) || $d1335bfebc5bc5fc$export$cca4caab5ef5a545(type) || $d1335bfebc5bc5fc$export$360fc30cf304623(type) || $d1335bfebc5bc5fc$export$594edc80cf154b94(type) || $d1335bfebc5bc5fc$export$f1003c1e9d4b008c(type) || $d1335bfebc5bc5fc$export$146b6508fa0d6c82(type);
}
function $d1335bfebc5bc5fc$export$804de46662e4ac95(type) {
    if (!$d1335bfebc5bc5fc$export$26b9f946b448f23e(type)) throw new Error(`Expected ${(0, $gHwk7.inspect)(type)} to be a GraphQL type.`);
    return type;
}
function $d1335bfebc5bc5fc$export$5ef3b9aefb31c08b(type) {
    return (0, $7NKAi.instanceOf)(type, $d1335bfebc5bc5fc$export$64842b98ea53a3c9);
}
function $d1335bfebc5bc5fc$export$6bfb69547e804cfa(type) {
    if (!$d1335bfebc5bc5fc$export$5ef3b9aefb31c08b(type)) throw new Error(`Expected ${(0, $gHwk7.inspect)(type)} to be a GraphQL Scalar type.`);
    return type;
}
function $d1335bfebc5bc5fc$export$f3091ca7b0907a5f(type) {
    return (0, $7NKAi.instanceOf)(type, $d1335bfebc5bc5fc$export$375d3757a19c2e6e);
}
function $d1335bfebc5bc5fc$export$37a13eb12fbf3bc7(type) {
    if (!$d1335bfebc5bc5fc$export$f3091ca7b0907a5f(type)) throw new Error(`Expected ${(0, $gHwk7.inspect)(type)} to be a GraphQL Object type.`);
    return type;
}
function $d1335bfebc5bc5fc$export$32fba5696fa641e(type) {
    return (0, $7NKAi.instanceOf)(type, $d1335bfebc5bc5fc$export$148e92587b8bf1f9);
}
function $d1335bfebc5bc5fc$export$b0fa8729bfe4811b(type) {
    if (!$d1335bfebc5bc5fc$export$32fba5696fa641e(type)) throw new Error(`Expected ${(0, $gHwk7.inspect)(type)} to be a GraphQL Interface type.`);
    return type;
}
function $d1335bfebc5bc5fc$export$cca4caab5ef5a545(type) {
    return (0, $7NKAi.instanceOf)(type, $d1335bfebc5bc5fc$export$33c479b4c3812d0b);
}
function $d1335bfebc5bc5fc$export$fd1fc643145b79aa(type) {
    if (!$d1335bfebc5bc5fc$export$cca4caab5ef5a545(type)) throw new Error(`Expected ${(0, $gHwk7.inspect)(type)} to be a GraphQL Union type.`);
    return type;
}
function $d1335bfebc5bc5fc$export$360fc30cf304623(type) {
    return (0, $7NKAi.instanceOf)(type, $d1335bfebc5bc5fc$export$2577fb93f8748953);
}
function $d1335bfebc5bc5fc$export$152b058be1610b0e(type) {
    if (!$d1335bfebc5bc5fc$export$360fc30cf304623(type)) throw new Error(`Expected ${(0, $gHwk7.inspect)(type)} to be a GraphQL Enum type.`);
    return type;
}
function $d1335bfebc5bc5fc$export$594edc80cf154b94(type) {
    return (0, $7NKAi.instanceOf)(type, $d1335bfebc5bc5fc$export$ea29baa44b9fd772);
}
function $d1335bfebc5bc5fc$export$d3177a47c4ed448a(type) {
    if (!$d1335bfebc5bc5fc$export$594edc80cf154b94(type)) throw new Error(`Expected ${(0, $gHwk7.inspect)(type)} to be a GraphQL Input Object type.`);
    return type;
}
function $d1335bfebc5bc5fc$export$f1003c1e9d4b008c(type) {
    return (0, $7NKAi.instanceOf)(type, $d1335bfebc5bc5fc$export$de552006a6243367);
}
function $d1335bfebc5bc5fc$export$a4a2309317558e91(type) {
    if (!$d1335bfebc5bc5fc$export$f1003c1e9d4b008c(type)) throw new Error(`Expected ${(0, $gHwk7.inspect)(type)} to be a GraphQL List type.`);
    return type;
}
function $d1335bfebc5bc5fc$export$146b6508fa0d6c82(type) {
    return (0, $7NKAi.instanceOf)(type, $d1335bfebc5bc5fc$export$ea3122a3d819ac9d);
}
function $d1335bfebc5bc5fc$export$4c0a7702e4a2acc9(type) {
    if (!$d1335bfebc5bc5fc$export$146b6508fa0d6c82(type)) throw new Error(`Expected ${(0, $gHwk7.inspect)(type)} to be a GraphQL Non-Null type.`);
    return type;
}
function $d1335bfebc5bc5fc$export$1e617af703572bb5(type) {
    return $d1335bfebc5bc5fc$export$5ef3b9aefb31c08b(type) || $d1335bfebc5bc5fc$export$360fc30cf304623(type) || $d1335bfebc5bc5fc$export$594edc80cf154b94(type) || $d1335bfebc5bc5fc$export$2dbe78c78d9c62bb(type) && $d1335bfebc5bc5fc$export$1e617af703572bb5(type.ofType);
}
function $d1335bfebc5bc5fc$export$6e3e8b9b85427518(type) {
    if (!$d1335bfebc5bc5fc$export$1e617af703572bb5(type)) throw new Error(`Expected ${(0, $gHwk7.inspect)(type)} to be a GraphQL input type.`);
    return type;
}
function $d1335bfebc5bc5fc$export$27aadee607de5794(type) {
    return $d1335bfebc5bc5fc$export$5ef3b9aefb31c08b(type) || $d1335bfebc5bc5fc$export$f3091ca7b0907a5f(type) || $d1335bfebc5bc5fc$export$32fba5696fa641e(type) || $d1335bfebc5bc5fc$export$cca4caab5ef5a545(type) || $d1335bfebc5bc5fc$export$360fc30cf304623(type) || $d1335bfebc5bc5fc$export$2dbe78c78d9c62bb(type) && $d1335bfebc5bc5fc$export$27aadee607de5794(type.ofType);
}
function $d1335bfebc5bc5fc$export$3efb5e473c31d62b(type) {
    if (!$d1335bfebc5bc5fc$export$27aadee607de5794(type)) throw new Error(`Expected ${(0, $gHwk7.inspect)(type)} to be a GraphQL output type.`);
    return type;
}
function $d1335bfebc5bc5fc$export$b390adabc64bab3(type) {
    return $d1335bfebc5bc5fc$export$5ef3b9aefb31c08b(type) || $d1335bfebc5bc5fc$export$360fc30cf304623(type);
}
function $d1335bfebc5bc5fc$export$2bb5b8127c27d0cc(type) {
    if (!$d1335bfebc5bc5fc$export$b390adabc64bab3(type)) throw new Error(`Expected ${(0, $gHwk7.inspect)(type)} to be a GraphQL leaf type.`);
    return type;
}
function $d1335bfebc5bc5fc$export$3d8f0e61f2e75bb0(type) {
    return $d1335bfebc5bc5fc$export$f3091ca7b0907a5f(type) || $d1335bfebc5bc5fc$export$32fba5696fa641e(type) || $d1335bfebc5bc5fc$export$cca4caab5ef5a545(type);
}
function $d1335bfebc5bc5fc$export$5b55b276a74cf725(type) {
    if (!$d1335bfebc5bc5fc$export$3d8f0e61f2e75bb0(type)) throw new Error(`Expected ${(0, $gHwk7.inspect)(type)} to be a GraphQL composite type.`);
    return type;
}
function $d1335bfebc5bc5fc$export$6ea44a810dec4ac5(type) {
    return $d1335bfebc5bc5fc$export$32fba5696fa641e(type) || $d1335bfebc5bc5fc$export$cca4caab5ef5a545(type);
}
function $d1335bfebc5bc5fc$export$d7092fd91c1fbaf8(type) {
    if (!$d1335bfebc5bc5fc$export$6ea44a810dec4ac5(type)) throw new Error(`Expected ${(0, $gHwk7.inspect)(type)} to be a GraphQL abstract type.`);
    return type;
}
class $d1335bfebc5bc5fc$export$de552006a6243367 {
    constructor(ofType){
        $d1335bfebc5bc5fc$export$26b9f946b448f23e(ofType) || (0, $lDltR.devAssert)(false, `Expected ${(0, $gHwk7.inspect)(ofType)} to be a GraphQL type.`);
        this.ofType = ofType;
    }
    get [Symbol.toStringTag]() {
        return "GraphQLList";
    }
    toString() {
        return "[" + String(this.ofType) + "]";
    }
    toJSON() {
        return this.toString();
    }
}
class $d1335bfebc5bc5fc$export$ea3122a3d819ac9d {
    constructor(ofType){
        $d1335bfebc5bc5fc$export$103e38848746832(ofType) || (0, $lDltR.devAssert)(false, `Expected ${(0, $gHwk7.inspect)(ofType)} to be a GraphQL nullable type.`);
        this.ofType = ofType;
    }
    get [Symbol.toStringTag]() {
        return "GraphQLNonNull";
    }
    toString() {
        return String(this.ofType) + "!";
    }
    toJSON() {
        return this.toString();
    }
}
function $d1335bfebc5bc5fc$export$2dbe78c78d9c62bb(type) {
    return $d1335bfebc5bc5fc$export$f1003c1e9d4b008c(type) || $d1335bfebc5bc5fc$export$146b6508fa0d6c82(type);
}
function $d1335bfebc5bc5fc$export$ee52e012d8d583c6(type) {
    if (!$d1335bfebc5bc5fc$export$2dbe78c78d9c62bb(type)) throw new Error(`Expected ${(0, $gHwk7.inspect)(type)} to be a GraphQL wrapping type.`);
    return type;
}
function $d1335bfebc5bc5fc$export$103e38848746832(type) {
    return $d1335bfebc5bc5fc$export$26b9f946b448f23e(type) && !$d1335bfebc5bc5fc$export$146b6508fa0d6c82(type);
}
function $d1335bfebc5bc5fc$export$9c6e9b78e1767de4(type) {
    if (!$d1335bfebc5bc5fc$export$103e38848746832(type)) throw new Error(`Expected ${(0, $gHwk7.inspect)(type)} to be a GraphQL nullable type.`);
    return type;
}
function $d1335bfebc5bc5fc$export$88b885687e78334b(type) {
    if (type) return $d1335bfebc5bc5fc$export$146b6508fa0d6c82(type) ? type.ofType : type;
}
function $d1335bfebc5bc5fc$export$f99194494d5b1a26(type) {
    return $d1335bfebc5bc5fc$export$5ef3b9aefb31c08b(type) || $d1335bfebc5bc5fc$export$f3091ca7b0907a5f(type) || $d1335bfebc5bc5fc$export$32fba5696fa641e(type) || $d1335bfebc5bc5fc$export$cca4caab5ef5a545(type) || $d1335bfebc5bc5fc$export$360fc30cf304623(type) || $d1335bfebc5bc5fc$export$594edc80cf154b94(type);
}
function $d1335bfebc5bc5fc$export$57234e7b640498aa(type) {
    if (!$d1335bfebc5bc5fc$export$f99194494d5b1a26(type)) throw new Error(`Expected ${(0, $gHwk7.inspect)(type)} to be a GraphQL named type.`);
    return type;
}
function $d1335bfebc5bc5fc$export$e6cd8ba67f39ede0(type) {
    if (type) {
        let unwrappedType = type;
        while($d1335bfebc5bc5fc$export$2dbe78c78d9c62bb(unwrappedType))unwrappedType = unwrappedType.ofType;
        return unwrappedType;
    }
}
function $d1335bfebc5bc5fc$export$74e03cf55cd9824(thunk) {
    return typeof thunk === "function" ? thunk() : thunk;
}
function $d1335bfebc5bc5fc$export$a4816c39797d8bd4(thunk) {
    return typeof thunk === "function" ? thunk() : thunk;
}
class $d1335bfebc5bc5fc$export$64842b98ea53a3c9 {
    constructor(config){
        var _config$parseValue, _config$serialize, _config$parseLiteral, _config$extensionASTN;
        const parseValue = (_config$parseValue = config.parseValue) !== null && _config$parseValue !== void 0 ? _config$parseValue : (0, $lVzZw.identityFunc);
        this.name = (0, $kr4gH.assertName)(config.name);
        this.description = config.description;
        this.specifiedByURL = config.specifiedByURL;
        this.serialize = (_config$serialize = config.serialize) !== null && _config$serialize !== void 0 ? _config$serialize : (0, $lVzZw.identityFunc);
        this.parseValue = parseValue;
        this.parseLiteral = (_config$parseLiteral = config.parseLiteral) !== null && _config$parseLiteral !== void 0 ? _config$parseLiteral : (node, variables)=>parseValue((0, $856R3.valueFromASTUntyped)(node, variables));
        this.extensions = (0, $lNeRj.toObjMap)(config.extensions);
        this.astNode = config.astNode;
        this.extensionASTNodes = (_config$extensionASTN = config.extensionASTNodes) !== null && _config$extensionASTN !== void 0 ? _config$extensionASTN : [];
        config.specifiedByURL == null || typeof config.specifiedByURL === "string" || (0, $lDltR.devAssert)(false, `${this.name} must provide "specifiedByURL" as a string, ` + `but got: ${(0, $gHwk7.inspect)(config.specifiedByURL)}.`);
        config.serialize == null || typeof config.serialize === "function" || (0, $lDltR.devAssert)(false, `${this.name} must provide "serialize" function. If this custom Scalar is also used as an input type, ensure "parseValue" and "parseLiteral" functions are also provided.`);
        if (config.parseLiteral) typeof config.parseValue === "function" && typeof config.parseLiteral === "function" || (0, $lDltR.devAssert)(false, `${this.name} must provide both "parseValue" and "parseLiteral" functions.`);
    }
    get [Symbol.toStringTag]() {
        return "GraphQLScalarType";
    }
    toConfig() {
        return {
            name: this.name,
            description: this.description,
            specifiedByURL: this.specifiedByURL,
            serialize: this.serialize,
            parseValue: this.parseValue,
            parseLiteral: this.parseLiteral,
            extensions: this.extensions,
            astNode: this.astNode,
            extensionASTNodes: this.extensionASTNodes
        };
    }
    toString() {
        return this.name;
    }
    toJSON() {
        return this.toString();
    }
}
class $d1335bfebc5bc5fc$export$375d3757a19c2e6e {
    constructor(config){
        var _config$extensionASTN2;
        this.name = (0, $kr4gH.assertName)(config.name);
        this.description = config.description;
        this.isTypeOf = config.isTypeOf;
        this.extensions = (0, $lNeRj.toObjMap)(config.extensions);
        this.astNode = config.astNode;
        this.extensionASTNodes = (_config$extensionASTN2 = config.extensionASTNodes) !== null && _config$extensionASTN2 !== void 0 ? _config$extensionASTN2 : [];
        this._fields = ()=>$d1335bfebc5bc5fc$var$defineFieldMap(config);
        this._interfaces = ()=>$d1335bfebc5bc5fc$var$defineInterfaces(config);
        config.isTypeOf == null || typeof config.isTypeOf === "function" || (0, $lDltR.devAssert)(false, `${this.name} must provide "isTypeOf" as a function, ` + `but got: ${(0, $gHwk7.inspect)(config.isTypeOf)}.`);
    }
    get [Symbol.toStringTag]() {
        return "GraphQLObjectType";
    }
    getFields() {
        if (typeof this._fields === "function") this._fields = this._fields();
        return this._fields;
    }
    getInterfaces() {
        if (typeof this._interfaces === "function") this._interfaces = this._interfaces();
        return this._interfaces;
    }
    toConfig() {
        return {
            name: this.name,
            description: this.description,
            interfaces: this.getInterfaces(),
            fields: $d1335bfebc5bc5fc$var$fieldsToFieldsConfig(this.getFields()),
            isTypeOf: this.isTypeOf,
            extensions: this.extensions,
            astNode: this.astNode,
            extensionASTNodes: this.extensionASTNodes
        };
    }
    toString() {
        return this.name;
    }
    toJSON() {
        return this.toString();
    }
}
function $d1335bfebc5bc5fc$var$defineInterfaces(config) {
    var _config$interfaces;
    const interfaces = $d1335bfebc5bc5fc$export$74e03cf55cd9824((_config$interfaces = config.interfaces) !== null && _config$interfaces !== void 0 ? _config$interfaces : []);
    Array.isArray(interfaces) || (0, $lDltR.devAssert)(false, `${config.name} interfaces must be an Array or a function which returns an Array.`);
    return interfaces;
}
function $d1335bfebc5bc5fc$var$defineFieldMap(config) {
    const fieldMap = $d1335bfebc5bc5fc$export$a4816c39797d8bd4(config.fields);
    $d1335bfebc5bc5fc$var$isPlainObj(fieldMap) || (0, $lDltR.devAssert)(false, `${config.name} fields must be an object with field names as keys or a function which returns such an object.`);
    return (0, $3LUIw.mapValue)(fieldMap, (fieldConfig, fieldName)=>{
        var _fieldConfig$args;
        $d1335bfebc5bc5fc$var$isPlainObj(fieldConfig) || (0, $lDltR.devAssert)(false, `${config.name}.${fieldName} field config must be an object.`);
        fieldConfig.resolve == null || typeof fieldConfig.resolve === "function" || (0, $lDltR.devAssert)(false, `${config.name}.${fieldName} field resolver must be a function if ` + `provided, but got: ${(0, $gHwk7.inspect)(fieldConfig.resolve)}.`);
        const argsConfig = (_fieldConfig$args = fieldConfig.args) !== null && _fieldConfig$args !== void 0 ? _fieldConfig$args : {};
        $d1335bfebc5bc5fc$var$isPlainObj(argsConfig) || (0, $lDltR.devAssert)(false, `${config.name}.${fieldName} args must be an object with argument names as keys.`);
        return {
            name: (0, $kr4gH.assertName)(fieldName),
            description: fieldConfig.description,
            type: fieldConfig.type,
            args: $d1335bfebc5bc5fc$export$4fa00ef8239acb15(argsConfig),
            resolve: fieldConfig.resolve,
            subscribe: fieldConfig.subscribe,
            deprecationReason: fieldConfig.deprecationReason,
            extensions: (0, $lNeRj.toObjMap)(fieldConfig.extensions),
            astNode: fieldConfig.astNode
        };
    });
}
function $d1335bfebc5bc5fc$export$4fa00ef8239acb15(config) {
    return Object.entries(config).map(([argName, argConfig])=>({
            name: (0, $kr4gH.assertName)(argName),
            description: argConfig.description,
            type: argConfig.type,
            defaultValue: argConfig.defaultValue,
            deprecationReason: argConfig.deprecationReason,
            extensions: (0, $lNeRj.toObjMap)(argConfig.extensions),
            astNode: argConfig.astNode
        }));
}
function $d1335bfebc5bc5fc$var$isPlainObj(obj) {
    return (0, $cryJ5.isObjectLike)(obj) && !Array.isArray(obj);
}
function $d1335bfebc5bc5fc$var$fieldsToFieldsConfig(fields) {
    return (0, $3LUIw.mapValue)(fields, (field)=>({
            description: field.description,
            type: field.type,
            args: $d1335bfebc5bc5fc$export$ae5ade30c645f6fd(field.args),
            resolve: field.resolve,
            subscribe: field.subscribe,
            deprecationReason: field.deprecationReason,
            extensions: field.extensions,
            astNode: field.astNode
        }));
}
function $d1335bfebc5bc5fc$export$ae5ade30c645f6fd(args) {
    return (0, $3ahKk.keyValMap)(args, (arg)=>arg.name, (arg)=>({
            description: arg.description,
            type: arg.type,
            defaultValue: arg.defaultValue,
            deprecationReason: arg.deprecationReason,
            extensions: arg.extensions,
            astNode: arg.astNode
        }));
}
function $d1335bfebc5bc5fc$export$caef08b21560291a(arg) {
    return $d1335bfebc5bc5fc$export$146b6508fa0d6c82(arg.type) && arg.defaultValue === undefined;
}
class $d1335bfebc5bc5fc$export$148e92587b8bf1f9 {
    constructor(config){
        var _config$extensionASTN3;
        this.name = (0, $kr4gH.assertName)(config.name);
        this.description = config.description;
        this.resolveType = config.resolveType;
        this.extensions = (0, $lNeRj.toObjMap)(config.extensions);
        this.astNode = config.astNode;
        this.extensionASTNodes = (_config$extensionASTN3 = config.extensionASTNodes) !== null && _config$extensionASTN3 !== void 0 ? _config$extensionASTN3 : [];
        this._fields = $d1335bfebc5bc5fc$var$defineFieldMap.bind(undefined, config);
        this._interfaces = $d1335bfebc5bc5fc$var$defineInterfaces.bind(undefined, config);
        config.resolveType == null || typeof config.resolveType === "function" || (0, $lDltR.devAssert)(false, `${this.name} must provide "resolveType" as a function, ` + `but got: ${(0, $gHwk7.inspect)(config.resolveType)}.`);
    }
    get [Symbol.toStringTag]() {
        return "GraphQLInterfaceType";
    }
    getFields() {
        if (typeof this._fields === "function") this._fields = this._fields();
        return this._fields;
    }
    getInterfaces() {
        if (typeof this._interfaces === "function") this._interfaces = this._interfaces();
        return this._interfaces;
    }
    toConfig() {
        return {
            name: this.name,
            description: this.description,
            interfaces: this.getInterfaces(),
            fields: $d1335bfebc5bc5fc$var$fieldsToFieldsConfig(this.getFields()),
            resolveType: this.resolveType,
            extensions: this.extensions,
            astNode: this.astNode,
            extensionASTNodes: this.extensionASTNodes
        };
    }
    toString() {
        return this.name;
    }
    toJSON() {
        return this.toString();
    }
}
class $d1335bfebc5bc5fc$export$33c479b4c3812d0b {
    constructor(config){
        var _config$extensionASTN4;
        this.name = (0, $kr4gH.assertName)(config.name);
        this.description = config.description;
        this.resolveType = config.resolveType;
        this.extensions = (0, $lNeRj.toObjMap)(config.extensions);
        this.astNode = config.astNode;
        this.extensionASTNodes = (_config$extensionASTN4 = config.extensionASTNodes) !== null && _config$extensionASTN4 !== void 0 ? _config$extensionASTN4 : [];
        this._types = $d1335bfebc5bc5fc$var$defineTypes.bind(undefined, config);
        config.resolveType == null || typeof config.resolveType === "function" || (0, $lDltR.devAssert)(false, `${this.name} must provide "resolveType" as a function, ` + `but got: ${(0, $gHwk7.inspect)(config.resolveType)}.`);
    }
    get [Symbol.toStringTag]() {
        return "GraphQLUnionType";
    }
    getTypes() {
        if (typeof this._types === "function") this._types = this._types();
        return this._types;
    }
    toConfig() {
        return {
            name: this.name,
            description: this.description,
            types: this.getTypes(),
            resolveType: this.resolveType,
            extensions: this.extensions,
            astNode: this.astNode,
            extensionASTNodes: this.extensionASTNodes
        };
    }
    toString() {
        return this.name;
    }
    toJSON() {
        return this.toString();
    }
}
function $d1335bfebc5bc5fc$var$defineTypes(config) {
    const types = $d1335bfebc5bc5fc$export$74e03cf55cd9824(config.types);
    Array.isArray(types) || (0, $lDltR.devAssert)(false, `Must provide Array of types or a function which returns such an array for Union ${config.name}.`);
    return types;
}
class $d1335bfebc5bc5fc$export$2577fb93f8748953 {
    /* <T> */ constructor(config){
        var _config$extensionASTN5;
        this.name = (0, $kr4gH.assertName)(config.name);
        this.description = config.description;
        this.extensions = (0, $lNeRj.toObjMap)(config.extensions);
        this.astNode = config.astNode;
        this.extensionASTNodes = (_config$extensionASTN5 = config.extensionASTNodes) !== null && _config$extensionASTN5 !== void 0 ? _config$extensionASTN5 : [];
        this._values = $d1335bfebc5bc5fc$var$defineEnumValues(this.name, config.values);
        this._valueLookup = new Map(this._values.map((enumValue)=>[
                enumValue.value,
                enumValue
            ]));
        this._nameLookup = (0, $1inQZ.keyMap)(this._values, (value)=>value.name);
    }
    get [Symbol.toStringTag]() {
        return "GraphQLEnumType";
    }
    getValues() {
        return this._values;
    }
    getValue(name) {
        return this._nameLookup[name];
    }
    serialize(outputValue) {
        const enumValue = this._valueLookup.get(outputValue);
        if (enumValue === undefined) throw new (0, $fHcz3.GraphQLError)(`Enum "${this.name}" cannot represent value: ${(0, $gHwk7.inspect)(outputValue)}`);
        return enumValue.name;
    }
    parseValue(inputValue) /* T */ {
        if (typeof inputValue !== "string") {
            const valueStr = (0, $gHwk7.inspect)(inputValue);
            throw new (0, $fHcz3.GraphQLError)(`Enum "${this.name}" cannot represent non-string value: ${valueStr}.` + $d1335bfebc5bc5fc$var$didYouMeanEnumValue(this, valueStr));
        }
        const enumValue = this.getValue(inputValue);
        if (enumValue == null) throw new (0, $fHcz3.GraphQLError)(`Value "${inputValue}" does not exist in "${this.name}" enum.` + $d1335bfebc5bc5fc$var$didYouMeanEnumValue(this, inputValue));
        return enumValue.value;
    }
    parseLiteral(valueNode, _variables) /* T */ {
        // Note: variables will be resolved to a value before calling this function.
        if (valueNode.kind !== (0, $hu3w4.Kind).ENUM) {
            const valueStr = (0, $3o9dz.print)(valueNode);
            throw new (0, $fHcz3.GraphQLError)(`Enum "${this.name}" cannot represent non-enum value: ${valueStr}.` + $d1335bfebc5bc5fc$var$didYouMeanEnumValue(this, valueStr), {
                nodes: valueNode
            });
        }
        const enumValue = this.getValue(valueNode.value);
        if (enumValue == null) {
            const valueStr = (0, $3o9dz.print)(valueNode);
            throw new (0, $fHcz3.GraphQLError)(`Value "${valueStr}" does not exist in "${this.name}" enum.` + $d1335bfebc5bc5fc$var$didYouMeanEnumValue(this, valueStr), {
                nodes: valueNode
            });
        }
        return enumValue.value;
    }
    toConfig() {
        const values = (0, $3ahKk.keyValMap)(this.getValues(), (value)=>value.name, (value)=>({
                description: value.description,
                value: value.value,
                deprecationReason: value.deprecationReason,
                extensions: value.extensions,
                astNode: value.astNode
            }));
        return {
            name: this.name,
            description: this.description,
            values: values,
            extensions: this.extensions,
            astNode: this.astNode,
            extensionASTNodes: this.extensionASTNodes
        };
    }
    toString() {
        return this.name;
    }
    toJSON() {
        return this.toString();
    }
}
function $d1335bfebc5bc5fc$var$didYouMeanEnumValue(enumType, unknownValueStr) {
    const allNames = enumType.getValues().map((value)=>value.name);
    const suggestedValues = (0, $a2eVh.suggestionList)(unknownValueStr, allNames);
    return (0, $ej6fd.didYouMean)("the enum value", suggestedValues);
}
function $d1335bfebc5bc5fc$var$defineEnumValues(typeName, valueMap) {
    $d1335bfebc5bc5fc$var$isPlainObj(valueMap) || (0, $lDltR.devAssert)(false, `${typeName} values must be an object with value names as keys.`);
    return Object.entries(valueMap).map(([valueName, valueConfig])=>{
        $d1335bfebc5bc5fc$var$isPlainObj(valueConfig) || (0, $lDltR.devAssert)(false, `${typeName}.${valueName} must refer to an object with a "value" key ` + `representing an internal value but got: ${(0, $gHwk7.inspect)(valueConfig)}.`);
        return {
            name: (0, $kr4gH.assertEnumValueName)(valueName),
            description: valueConfig.description,
            value: valueConfig.value !== undefined ? valueConfig.value : valueName,
            deprecationReason: valueConfig.deprecationReason,
            extensions: (0, $lNeRj.toObjMap)(valueConfig.extensions),
            astNode: valueConfig.astNode
        };
    });
}
class $d1335bfebc5bc5fc$export$ea29baa44b9fd772 {
    constructor(config){
        var _config$extensionASTN6;
        this.name = (0, $kr4gH.assertName)(config.name);
        this.description = config.description;
        this.extensions = (0, $lNeRj.toObjMap)(config.extensions);
        this.astNode = config.astNode;
        this.extensionASTNodes = (_config$extensionASTN6 = config.extensionASTNodes) !== null && _config$extensionASTN6 !== void 0 ? _config$extensionASTN6 : [];
        this._fields = $d1335bfebc5bc5fc$var$defineInputFieldMap.bind(undefined, config);
    }
    get [Symbol.toStringTag]() {
        return "GraphQLInputObjectType";
    }
    getFields() {
        if (typeof this._fields === "function") this._fields = this._fields();
        return this._fields;
    }
    toConfig() {
        const fields = (0, $3LUIw.mapValue)(this.getFields(), (field)=>({
                description: field.description,
                type: field.type,
                defaultValue: field.defaultValue,
                deprecationReason: field.deprecationReason,
                extensions: field.extensions,
                astNode: field.astNode
            }));
        return {
            name: this.name,
            description: this.description,
            fields: fields,
            extensions: this.extensions,
            astNode: this.astNode,
            extensionASTNodes: this.extensionASTNodes
        };
    }
    toString() {
        return this.name;
    }
    toJSON() {
        return this.toString();
    }
}
function $d1335bfebc5bc5fc$var$defineInputFieldMap(config) {
    const fieldMap = $d1335bfebc5bc5fc$export$a4816c39797d8bd4(config.fields);
    $d1335bfebc5bc5fc$var$isPlainObj(fieldMap) || (0, $lDltR.devAssert)(false, `${config.name} fields must be an object with field names as keys or a function which returns such an object.`);
    return (0, $3LUIw.mapValue)(fieldMap, (fieldConfig, fieldName)=>{
        !("resolve" in fieldConfig) || (0, $lDltR.devAssert)(false, `${config.name}.${fieldName} field has a resolve property, but Input Types cannot define resolvers.`);
        return {
            name: (0, $kr4gH.assertName)(fieldName),
            description: fieldConfig.description,
            type: fieldConfig.type,
            defaultValue: fieldConfig.defaultValue,
            deprecationReason: fieldConfig.deprecationReason,
            extensions: (0, $lNeRj.toObjMap)(fieldConfig.extensions),
            astNode: fieldConfig.astNode
        };
    });
}
function $d1335bfebc5bc5fc$export$2657dcc79c2b6229(field) {
    return $d1335bfebc5bc5fc$export$146b6508fa0d6c82(field.type) && field.defaultValue === undefined;
}

});
parcelRegister("lDltR", function(module, exports) {

$parcel$export(module.exports, "devAssert", () => $8beb5260c793fc92$export$b6cb5906f04696c8);
function $8beb5260c793fc92$export$b6cb5906f04696c8(condition, message) {
    const booleanCondition = Boolean(condition);
    if (!booleanCondition) throw new Error(message);
}

});

parcelRegister("ej6fd", function(module, exports) {

$parcel$export(module.exports, "didYouMean", () => $2276489fb8169b90$export$a4677a39ee68b313);
const $2276489fb8169b90$var$MAX_SUGGESTIONS = 5;
function $2276489fb8169b90$export$a4677a39ee68b313(firstArg, secondArg) {
    const [subMessage, suggestionsArg] = secondArg ? [
        firstArg,
        secondArg
    ] : [
        undefined,
        firstArg
    ];
    let message = " Did you mean ";
    if (subMessage) message += subMessage + " ";
    const suggestions = suggestionsArg.map((x)=>`"${x}"`);
    switch(suggestions.length){
        case 0:
            return "";
        case 1:
            return message + suggestions[0] + "?";
        case 2:
            return message + suggestions[0] + " or " + suggestions[1] + "?";
    }
    const selected = suggestions.slice(0, $2276489fb8169b90$var$MAX_SUGGESTIONS);
    const lastItem = selected.pop();
    return message + selected.join(", ") + ", or " + lastItem + "?";
}

});

parcelRegister("lVzZw", function(module, exports) {

$parcel$export(module.exports, "identityFunc", () => $c1cfa6cb8f25a243$export$cbcd5bf93cd08b2b);
/**
 * Returns the first argument it receives.
 */ function $c1cfa6cb8f25a243$export$cbcd5bf93cd08b2b(x) {
    return x;
}

});

parcelRegister("7NKAi", function(module, exports) {

$parcel$export(module.exports, "instanceOf", () => $c44107310810d751$export$ca03416d6c9e029e);

var $gHwk7 = parcelRequire("gHwk7");
const $c44107310810d751$export$ca03416d6c9e029e = /* c8 ignore next 6 */ // FIXME: https://github.com/graphql/graphql-js/issues/2317
globalThis.process && globalThis.process.env.NODE_ENV === "production" ? function instanceOf(value, constructor) {
    return value instanceof constructor;
} : function instanceOf(value, constructor) {
    if (value instanceof constructor) return true;
    if (typeof value === "object" && value !== null) {
        var _value$constructor;
        // Prefer Symbol.toStringTag since it is immune to minification.
        const className = constructor.prototype[Symbol.toStringTag];
        const valueClassName = Symbol.toStringTag in value // @ts-expect-error TS bug see, https://github.com/microsoft/TypeScript/issues/38009
         ? value[Symbol.toStringTag] : (_value$constructor = value.constructor) === null || _value$constructor === void 0 ? void 0 : _value$constructor.name;
        if (className === valueClassName) {
            const stringifiedValue = (0, $gHwk7.inspect)(value);
            throw new Error(`Cannot use ${className} "${stringifiedValue}" from another module or realm.

Ensure that there is only one instance of "graphql" in the node_modules
directory. If different versions of "graphql" are the dependencies of other
relied on modules, use "resolutions" to ensure only one version is installed.

https://yarnpkg.com/en/docs/selective-version-resolutions

Duplicate "graphql" modules cannot be used at the same time since different
versions may have different capabilities and behavior. The data from one
version used in the function from another could produce confusing and
spurious results.`);
        }
    }
    return false;
};

});

parcelRegister("1inQZ", function(module, exports) {

$parcel$export(module.exports, "keyMap", () => $bb59d4b845058a07$export$120dab48c7c24490);
/**
 * Creates a keyed JS object from an array, given a function to produce the keys
 * for each value in the array.
 *
 * This provides a convenient lookup for the array items if the key function
 * produces unique results.
 * ```ts
 * const phoneBook = [
 *   { name: 'Jon', num: '555-1234' },
 *   { name: 'Jenny', num: '867-5309' }
 * ]
 *
 * const entriesByName = keyMap(
 *   phoneBook,
 *   entry => entry.name
 * )
 *
 * // {
 * //   Jon: { name: 'Jon', num: '555-1234' },
 * //   Jenny: { name: 'Jenny', num: '867-5309' }
 * // }
 *
 * const jennyEntry = entriesByName['Jenny']
 *
 * // { name: 'Jenny', num: '857-6309' }
 * ```
 */ function $bb59d4b845058a07$export$120dab48c7c24490(list, keyFn) {
    const result = Object.create(null);
    for (const item of list)result[keyFn(item)] = item;
    return result;
}

});

parcelRegister("3ahKk", function(module, exports) {

$parcel$export(module.exports, "keyValMap", () => $a188837587aa8079$export$5ad1cce38e19f426);
/**
 * Creates a keyed JS object from an array, given a function to produce the keys
 * and a function to produce the values from each item in the array.
 * ```ts
 * const phoneBook = [
 *   { name: 'Jon', num: '555-1234' },
 *   { name: 'Jenny', num: '867-5309' }
 * ]
 *
 * // { Jon: '555-1234', Jenny: '867-5309' }
 * const phonesByName = keyValMap(
 *   phoneBook,
 *   entry => entry.name,
 *   entry => entry.num
 * )
 * ```
 */ function $a188837587aa8079$export$5ad1cce38e19f426(list, keyFn, valFn) {
    const result = Object.create(null);
    for (const item of list)result[keyFn(item)] = valFn(item);
    return result;
}

});

parcelRegister("3LUIw", function(module, exports) {

$parcel$export(module.exports, "mapValue", () => $14652ba3529a8b0c$export$4f84e3a82c7b538);
/**
 * Creates an object map with the same keys as `map` and values generated by
 * running each value of `map` thru `fn`.
 */ function $14652ba3529a8b0c$export$4f84e3a82c7b538(map, fn) {
    const result = Object.create(null);
    for (const key of Object.keys(map))result[key] = fn(map[key], key);
    return result;
}

});

parcelRegister("a2eVh", function(module, exports) {

$parcel$export(module.exports, "suggestionList", () => $e511ebde7d433a8b$export$212245c7551a648);

var $a8VtN = parcelRequire("a8VtN");
function $e511ebde7d433a8b$export$212245c7551a648(input, options) {
    const optionsByDistance = Object.create(null);
    const lexicalDistance = new $e511ebde7d433a8b$var$LexicalDistance(input);
    const threshold = Math.floor(input.length * 0.4) + 1;
    for (const option of options){
        const distance = lexicalDistance.measure(option, threshold);
        if (distance !== undefined) optionsByDistance[option] = distance;
    }
    return Object.keys(optionsByDistance).sort((a, b)=>{
        const distanceDiff = optionsByDistance[a] - optionsByDistance[b];
        return distanceDiff !== 0 ? distanceDiff : (0, $a8VtN.naturalCompare)(a, b);
    });
}
/**
 * Computes the lexical distance between strings A and B.
 *
 * The "distance" between two strings is given by counting the minimum number
 * of edits needed to transform string A into string B. An edit can be an
 * insertion, deletion, or substitution of a single character, or a swap of two
 * adjacent characters.
 *
 * Includes a custom alteration from Damerau-Levenshtein to treat case changes
 * as a single edit which helps identify mis-cased values with an edit distance
 * of 1.
 *
 * This distance can be useful for detecting typos in input or sorting
 */ class $e511ebde7d433a8b$var$LexicalDistance {
    constructor(input){
        this._input = input;
        this._inputLowerCase = input.toLowerCase();
        this._inputArray = $e511ebde7d433a8b$var$stringToArray(this._inputLowerCase);
        this._rows = [
            new Array(input.length + 1).fill(0),
            new Array(input.length + 1).fill(0),
            new Array(input.length + 1).fill(0)
        ];
    }
    measure(option, threshold) {
        if (this._input === option) return 0;
        const optionLowerCase = option.toLowerCase(); // Any case change counts as a single edit
        if (this._inputLowerCase === optionLowerCase) return 1;
        let a = $e511ebde7d433a8b$var$stringToArray(optionLowerCase);
        let b = this._inputArray;
        if (a.length < b.length) {
            const tmp = a;
            a = b;
            b = tmp;
        }
        const aLength = a.length;
        const bLength = b.length;
        if (aLength - bLength > threshold) return undefined;
        const rows = this._rows;
        for(let j = 0; j <= bLength; j++)rows[0][j] = j;
        for(let i = 1; i <= aLength; i++){
            const upRow = rows[(i - 1) % 3];
            const currentRow = rows[i % 3];
            let smallestCell = currentRow[0] = i;
            for(let j = 1; j <= bLength; j++){
                const cost = a[i - 1] === b[j - 1] ? 0 : 1;
                let currentCell = Math.min(upRow[j] + 1, currentRow[j - 1] + 1, upRow[j - 1] + cost);
                if (i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) {
                    // transposition
                    const doubleDiagonalCell = rows[(i - 2) % 3][j - 2];
                    currentCell = Math.min(currentCell, doubleDiagonalCell + 1);
                }
                if (currentCell < smallestCell) smallestCell = currentCell;
                currentRow[j] = currentCell;
            } // Early exit, since distance can't go smaller than smallest element of the previous row.
            if (smallestCell > threshold) return undefined;
        }
        const distance = rows[aLength % 3][bLength];
        return distance <= threshold ? distance : undefined;
    }
}
function $e511ebde7d433a8b$var$stringToArray(str) {
    const strLength = str.length;
    const array = new Array(strLength);
    for(let i = 0; i < strLength; ++i)array[i] = str.charCodeAt(i);
    return array;
}

});
parcelRegister("a8VtN", function(module, exports) {

$parcel$export(module.exports, "naturalCompare", () => $3a81cd161020f08b$export$71889ebf54941867);
/**
 * Returns a number indicating whether a reference string comes before, or after,
 * or is the same as the given string in natural sort order.
 *
 * See: https://en.wikipedia.org/wiki/Natural_sort_order
 *
 */ function $3a81cd161020f08b$export$71889ebf54941867(aStr, bStr) {
    let aIndex = 0;
    let bIndex = 0;
    while(aIndex < aStr.length && bIndex < bStr.length){
        let aChar = aStr.charCodeAt(aIndex);
        let bChar = bStr.charCodeAt(bIndex);
        if ($3a81cd161020f08b$var$isDigit(aChar) && $3a81cd161020f08b$var$isDigit(bChar)) {
            let aNum = 0;
            do {
                ++aIndex;
                aNum = aNum * 10 + aChar - $3a81cd161020f08b$var$DIGIT_0;
                aChar = aStr.charCodeAt(aIndex);
            }while ($3a81cd161020f08b$var$isDigit(aChar) && aNum > 0);
            let bNum = 0;
            do {
                ++bIndex;
                bNum = bNum * 10 + bChar - $3a81cd161020f08b$var$DIGIT_0;
                bChar = bStr.charCodeAt(bIndex);
            }while ($3a81cd161020f08b$var$isDigit(bChar) && bNum > 0);
            if (aNum < bNum) return -1;
            if (aNum > bNum) return 1;
        } else {
            if (aChar < bChar) return -1;
            if (aChar > bChar) return 1;
            ++aIndex;
            ++bIndex;
        }
    }
    return aStr.length - bStr.length;
}
const $3a81cd161020f08b$var$DIGIT_0 = 48;
const $3a81cd161020f08b$var$DIGIT_9 = 57;
function $3a81cd161020f08b$var$isDigit(code) {
    return !isNaN(code) && $3a81cd161020f08b$var$DIGIT_0 <= code && code <= $3a81cd161020f08b$var$DIGIT_9;
}

});


parcelRegister("lNeRj", function(module, exports) {

$parcel$export(module.exports, "toObjMap", () => $70be0ba96ef74bdf$export$4f55a3cb354c9940);
function $70be0ba96ef74bdf$export$4f55a3cb354c9940(obj) {
    if (obj == null) return Object.create(null);
    if (Object.getPrototypeOf(obj) === null) return obj;
    const map = Object.create(null);
    for (const [key, value] of Object.entries(obj))map[key] = value;
    return map;
}

});

parcelRegister("fHcz3", function(module, exports) {

$parcel$export(module.exports, "GraphQLError", () => $52f13d37c0305dc6$export$92d6ed0888e7cb7f);
$parcel$export(module.exports, "printError", () => $52f13d37c0305dc6$export$55ee1551a3f962e6);
$parcel$export(module.exports, "formatError", () => $52f13d37c0305dc6$export$7b5b869ee98c16ab);

var $cryJ5 = parcelRequire("cryJ5");

var $8hTIi = parcelRequire("8hTIi");

var $2snEf = parcelRequire("2snEf");
function $52f13d37c0305dc6$var$toNormalizedOptions(args) {
    const firstArg = args[0];
    if (firstArg == null || "kind" in firstArg || "length" in firstArg) return {
        nodes: firstArg,
        source: args[1],
        positions: args[2],
        path: args[3],
        originalError: args[4],
        extensions: args[5]
    };
    return firstArg;
}
class $52f13d37c0305dc6$export$92d6ed0888e7cb7f extends Error {
    /**
   * An array of `{ line, column }` locations within the source GraphQL document
   * which correspond to this error.
   *
   * Errors during validation often contain multiple locations, for example to
   * point out two things with the same name. Errors during execution include a
   * single location, the field which produced the error.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */ /**
   * An array describing the JSON-path into the execution response which
   * corresponds to this error. Only included for errors during execution.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */ /**
   * An array of GraphQL AST Nodes corresponding to this error.
   */ /**
   * The source GraphQL document for the first location of this error.
   *
   * Note that if this Error represents more than one node, the source may not
   * represent nodes after the first node.
   */ /**
   * An array of character offsets within the source GraphQL document
   * which correspond to this error.
   */ /**
   * The original error thrown from a field resolver during execution.
   */ /**
   * Extension fields to add to the formatted error.
   */ /**
   * @deprecated Please use the `GraphQLErrorOptions` constructor overload instead.
   */ constructor(message, ...rawArgs){
        var _this$nodes, _nodeLocations$, _ref;
        const { nodes: nodes, source: source, positions: positions, path: path, originalError: originalError, extensions: extensions } = $52f13d37c0305dc6$var$toNormalizedOptions(rawArgs);
        super(message);
        this.name = "GraphQLError";
        this.path = path !== null && path !== void 0 ? path : undefined;
        this.originalError = originalError !== null && originalError !== void 0 ? originalError : undefined; // Compute list of blame nodes.
        this.nodes = $52f13d37c0305dc6$var$undefinedIfEmpty(Array.isArray(nodes) ? nodes : nodes ? [
            nodes
        ] : undefined);
        const nodeLocations = $52f13d37c0305dc6$var$undefinedIfEmpty((_this$nodes = this.nodes) === null || _this$nodes === void 0 ? void 0 : _this$nodes.map((node)=>node.loc).filter((loc)=>loc != null)); // Compute locations in the source for the given nodes/positions.
        this.source = source !== null && source !== void 0 ? source : nodeLocations === null || nodeLocations === void 0 ? void 0 : (_nodeLocations$ = nodeLocations[0]) === null || _nodeLocations$ === void 0 ? void 0 : _nodeLocations$.source;
        this.positions = positions !== null && positions !== void 0 ? positions : nodeLocations === null || nodeLocations === void 0 ? void 0 : nodeLocations.map((loc)=>loc.start);
        this.locations = positions && source ? positions.map((pos)=>(0, $8hTIi.getLocation)(source, pos)) : nodeLocations === null || nodeLocations === void 0 ? void 0 : nodeLocations.map((loc)=>(0, $8hTIi.getLocation)(loc.source, loc.start));
        const originalExtensions = (0, $cryJ5.isObjectLike)(originalError === null || originalError === void 0 ? void 0 : originalError.extensions) ? originalError === null || originalError === void 0 ? void 0 : originalError.extensions : undefined;
        this.extensions = (_ref = extensions !== null && extensions !== void 0 ? extensions : originalExtensions) !== null && _ref !== void 0 ? _ref : Object.create(null); // Only properties prescribed by the spec should be enumerable.
        // Keep the rest as non-enumerable.
        Object.defineProperties(this, {
            message: {
                writable: true,
                enumerable: true
            },
            name: {
                enumerable: false
            },
            nodes: {
                enumerable: false
            },
            source: {
                enumerable: false
            },
            positions: {
                enumerable: false
            },
            originalError: {
                enumerable: false
            }
        }); // Include (non-enumerable) stack trace.
        /* c8 ignore start */ // FIXME: https://github.com/graphql/graphql-js/issues/2317
        if (originalError !== null && originalError !== void 0 && originalError.stack) Object.defineProperty(this, "stack", {
            value: originalError.stack,
            writable: true,
            configurable: true
        });
        else if (Error.captureStackTrace) Error.captureStackTrace(this, $52f13d37c0305dc6$export$92d6ed0888e7cb7f);
        else Object.defineProperty(this, "stack", {
            value: Error().stack,
            writable: true,
            configurable: true
        });
    /* c8 ignore stop */ }
    get [Symbol.toStringTag]() {
        return "GraphQLError";
    }
    toString() {
        let output = this.message;
        if (this.nodes) {
            for (const node of this.nodes)if (node.loc) output += "\n\n" + (0, $2snEf.printLocation)(node.loc);
        } else if (this.source && this.locations) for (const location of this.locations)output += "\n\n" + (0, $2snEf.printSourceLocation)(this.source, location);
        return output;
    }
    toJSON() {
        const formattedError = {
            message: this.message
        };
        if (this.locations != null) formattedError.locations = this.locations;
        if (this.path != null) formattedError.path = this.path;
        if (this.extensions != null && Object.keys(this.extensions).length > 0) formattedError.extensions = this.extensions;
        return formattedError;
    }
}
function $52f13d37c0305dc6$var$undefinedIfEmpty(array) {
    return array === undefined || array.length === 0 ? undefined : array;
}
function $52f13d37c0305dc6$export$55ee1551a3f962e6(error) {
    return error.toString();
}
function $52f13d37c0305dc6$export$7b5b869ee98c16ab(error) {
    return error.toJSON();
}

});
parcelRegister("8hTIi", function(module, exports) {

$parcel$export(module.exports, "getLocation", () => $151337c9f32f7005$export$e7fd20fad3cf4b5f);

var $l3zHt = parcelRequire("l3zHt");
const $151337c9f32f7005$var$LineRegExp = /\r\n|[\n\r]/g;
function $151337c9f32f7005$export$e7fd20fad3cf4b5f(source, position) {
    let lastLineStart = 0;
    let line = 1;
    for (const match of source.body.matchAll($151337c9f32f7005$var$LineRegExp)){
        typeof match.index === "number" || (0, $l3zHt.invariant)(false);
        if (match.index >= position) break;
        lastLineStart = match.index + match[0].length;
        line += 1;
    }
    return {
        line: line,
        column: position + 1 - lastLineStart
    };
}

});

parcelRegister("2snEf", function(module, exports) {

$parcel$export(module.exports, "printLocation", () => $a45c53fbf464b798$export$96a9681e539deed);
$parcel$export(module.exports, "printSourceLocation", () => $a45c53fbf464b798$export$867940333fd9f869);

var $8hTIi = parcelRequire("8hTIi");
function $a45c53fbf464b798$export$96a9681e539deed(location) {
    return $a45c53fbf464b798$export$867940333fd9f869(location.source, (0, $8hTIi.getLocation)(location.source, location.start));
}
function $a45c53fbf464b798$export$867940333fd9f869(source, sourceLocation) {
    const firstLineColumnOffset = source.locationOffset.column - 1;
    const body = "".padStart(firstLineColumnOffset) + source.body;
    const lineIndex = sourceLocation.line - 1;
    const lineOffset = source.locationOffset.line - 1;
    const lineNum = sourceLocation.line + lineOffset;
    const columnOffset = sourceLocation.line === 1 ? firstLineColumnOffset : 0;
    const columnNum = sourceLocation.column + columnOffset;
    const locationStr = `${source.name}:${lineNum}:${columnNum}\n`;
    const lines = body.split(/\r\n|[\n\r]/g);
    const locationLine = lines[lineIndex]; // Special case for minified documents
    if (locationLine.length > 120) {
        const subLineIndex = Math.floor(columnNum / 80);
        const subLineColumnNum = columnNum % 80;
        const subLines = [];
        for(let i = 0; i < locationLine.length; i += 80)subLines.push(locationLine.slice(i, i + 80));
        return locationStr + $a45c53fbf464b798$var$printPrefixedLines([
            [
                `${lineNum} |`,
                subLines[0]
            ],
            ...subLines.slice(1, subLineIndex + 1).map((subLine)=>[
                    "|",
                    subLine
                ]),
            [
                "|",
                "^".padStart(subLineColumnNum)
            ],
            [
                "|",
                subLines[subLineIndex + 1]
            ]
        ]);
    }
    return locationStr + $a45c53fbf464b798$var$printPrefixedLines([
        // Lines specified like this: ["prefix", "string"],
        [
            `${lineNum - 1} |`,
            lines[lineIndex - 1]
        ],
        [
            `${lineNum} |`,
            locationLine
        ],
        [
            "|",
            "^".padStart(columnNum)
        ],
        [
            `${lineNum + 1} |`,
            lines[lineIndex + 1]
        ]
    ]);
}
function $a45c53fbf464b798$var$printPrefixedLines(lines) {
    const existingLines = lines.filter(([_, line])=>line !== undefined);
    const padLen = Math.max(...existingLines.map(([prefix])=>prefix.length));
    return existingLines.map(([prefix, line])=>prefix.padStart(padLen) + (line ? " " + line : "")).join("\n");
}

});


parcelRegister("3o9dz", function(module, exports) {

$parcel$export(module.exports, "print", () => $e6602c9cee6df4a2$export$c2d084dc44961371);

var $7tbLu = parcelRequire("7tbLu");

var $kkR0N = parcelRequire("kkR0N");

var $9m7aI = parcelRequire("9m7aI");
function $e6602c9cee6df4a2$export$c2d084dc44961371(ast) {
    return (0, $9m7aI.visit)(ast, $e6602c9cee6df4a2$var$printDocASTReducer);
}
const $e6602c9cee6df4a2$var$MAX_LINE_LENGTH = 80;
const $e6602c9cee6df4a2$var$printDocASTReducer = {
    Name: {
        leave: (node)=>node.value
    },
    Variable: {
        leave: (node)=>"$" + node.name
    },
    // Document
    Document: {
        leave: (node)=>$e6602c9cee6df4a2$var$join(node.definitions, "\n\n")
    },
    OperationDefinition: {
        leave (node) {
            const varDefs = $e6602c9cee6df4a2$var$wrap("(", $e6602c9cee6df4a2$var$join(node.variableDefinitions, ", "), ")");
            const prefix = $e6602c9cee6df4a2$var$join([
                node.operation,
                $e6602c9cee6df4a2$var$join([
                    node.name,
                    varDefs
                ]),
                $e6602c9cee6df4a2$var$join(node.directives, " ")
            ], " "); // Anonymous queries with no directives or variable definitions can use
            // the query short form.
            return (prefix === "query" ? "" : prefix + " ") + node.selectionSet;
        }
    },
    VariableDefinition: {
        leave: ({ variable: variable, type: type, defaultValue: defaultValue, directives: directives })=>variable + ": " + type + $e6602c9cee6df4a2$var$wrap(" = ", defaultValue) + $e6602c9cee6df4a2$var$wrap(" ", $e6602c9cee6df4a2$var$join(directives, " "))
    },
    SelectionSet: {
        leave: ({ selections: selections })=>$e6602c9cee6df4a2$var$block(selections)
    },
    Field: {
        leave ({ alias: alias, name: name, arguments: args, directives: directives, selectionSet: selectionSet }) {
            const prefix = $e6602c9cee6df4a2$var$wrap("", alias, ": ") + name;
            let argsLine = prefix + $e6602c9cee6df4a2$var$wrap("(", $e6602c9cee6df4a2$var$join(args, ", "), ")");
            if (argsLine.length > $e6602c9cee6df4a2$var$MAX_LINE_LENGTH) argsLine = prefix + $e6602c9cee6df4a2$var$wrap("(\n", $e6602c9cee6df4a2$var$indent($e6602c9cee6df4a2$var$join(args, "\n")), "\n)");
            return $e6602c9cee6df4a2$var$join([
                argsLine,
                $e6602c9cee6df4a2$var$join(directives, " "),
                selectionSet
            ], " ");
        }
    },
    Argument: {
        leave: ({ name: name, value: value })=>name + ": " + value
    },
    // Fragments
    FragmentSpread: {
        leave: ({ name: name, directives: directives })=>"..." + name + $e6602c9cee6df4a2$var$wrap(" ", $e6602c9cee6df4a2$var$join(directives, " "))
    },
    InlineFragment: {
        leave: ({ typeCondition: typeCondition, directives: directives, selectionSet: selectionSet })=>$e6602c9cee6df4a2$var$join([
                "...",
                $e6602c9cee6df4a2$var$wrap("on ", typeCondition),
                $e6602c9cee6df4a2$var$join(directives, " "),
                selectionSet
            ], " ")
    },
    FragmentDefinition: {
        leave: ({ name: name, typeCondition: typeCondition, variableDefinitions: variableDefinitions, directives: directives, selectionSet: selectionSet })=>// or removed in the future.
            `fragment ${name}${$e6602c9cee6df4a2$var$wrap("(", $e6602c9cee6df4a2$var$join(variableDefinitions, ", "), ")")} ` + `on ${typeCondition} ${$e6602c9cee6df4a2$var$wrap("", $e6602c9cee6df4a2$var$join(directives, " "), " ")}` + selectionSet
    },
    // Value
    IntValue: {
        leave: ({ value: value })=>value
    },
    FloatValue: {
        leave: ({ value: value })=>value
    },
    StringValue: {
        leave: ({ value: value, block: isBlockString })=>isBlockString ? (0, $7tbLu.printBlockString)(value) : (0, $kkR0N.printString)(value)
    },
    BooleanValue: {
        leave: ({ value: value })=>value ? "true" : "false"
    },
    NullValue: {
        leave: ()=>"null"
    },
    EnumValue: {
        leave: ({ value: value })=>value
    },
    ListValue: {
        leave: ({ values: values })=>"[" + $e6602c9cee6df4a2$var$join(values, ", ") + "]"
    },
    ObjectValue: {
        leave: ({ fields: fields })=>"{" + $e6602c9cee6df4a2$var$join(fields, ", ") + "}"
    },
    ObjectField: {
        leave: ({ name: name, value: value })=>name + ": " + value
    },
    // Directive
    Directive: {
        leave: ({ name: name, arguments: args })=>"@" + name + $e6602c9cee6df4a2$var$wrap("(", $e6602c9cee6df4a2$var$join(args, ", "), ")")
    },
    // Type
    NamedType: {
        leave: ({ name: name })=>name
    },
    ListType: {
        leave: ({ type: type })=>"[" + type + "]"
    },
    NonNullType: {
        leave: ({ type: type })=>type + "!"
    },
    // Type System Definitions
    SchemaDefinition: {
        leave: ({ description: description, directives: directives, operationTypes: operationTypes })=>$e6602c9cee6df4a2$var$wrap("", description, "\n") + $e6602c9cee6df4a2$var$join([
                "schema",
                $e6602c9cee6df4a2$var$join(directives, " "),
                $e6602c9cee6df4a2$var$block(operationTypes)
            ], " ")
    },
    OperationTypeDefinition: {
        leave: ({ operation: operation, type: type })=>operation + ": " + type
    },
    ScalarTypeDefinition: {
        leave: ({ description: description, name: name, directives: directives })=>$e6602c9cee6df4a2$var$wrap("", description, "\n") + $e6602c9cee6df4a2$var$join([
                "scalar",
                name,
                $e6602c9cee6df4a2$var$join(directives, " ")
            ], " ")
    },
    ObjectTypeDefinition: {
        leave: ({ description: description, name: name, interfaces: interfaces, directives: directives, fields: fields })=>$e6602c9cee6df4a2$var$wrap("", description, "\n") + $e6602c9cee6df4a2$var$join([
                "type",
                name,
                $e6602c9cee6df4a2$var$wrap("implements ", $e6602c9cee6df4a2$var$join(interfaces, " & ")),
                $e6602c9cee6df4a2$var$join(directives, " "),
                $e6602c9cee6df4a2$var$block(fields)
            ], " ")
    },
    FieldDefinition: {
        leave: ({ description: description, name: name, arguments: args, type: type, directives: directives })=>$e6602c9cee6df4a2$var$wrap("", description, "\n") + name + ($e6602c9cee6df4a2$var$hasMultilineItems(args) ? $e6602c9cee6df4a2$var$wrap("(\n", $e6602c9cee6df4a2$var$indent($e6602c9cee6df4a2$var$join(args, "\n")), "\n)") : $e6602c9cee6df4a2$var$wrap("(", $e6602c9cee6df4a2$var$join(args, ", "), ")")) + ": " + type + $e6602c9cee6df4a2$var$wrap(" ", $e6602c9cee6df4a2$var$join(directives, " "))
    },
    InputValueDefinition: {
        leave: ({ description: description, name: name, type: type, defaultValue: defaultValue, directives: directives })=>$e6602c9cee6df4a2$var$wrap("", description, "\n") + $e6602c9cee6df4a2$var$join([
                name + ": " + type,
                $e6602c9cee6df4a2$var$wrap("= ", defaultValue),
                $e6602c9cee6df4a2$var$join(directives, " ")
            ], " ")
    },
    InterfaceTypeDefinition: {
        leave: ({ description: description, name: name, interfaces: interfaces, directives: directives, fields: fields })=>$e6602c9cee6df4a2$var$wrap("", description, "\n") + $e6602c9cee6df4a2$var$join([
                "interface",
                name,
                $e6602c9cee6df4a2$var$wrap("implements ", $e6602c9cee6df4a2$var$join(interfaces, " & ")),
                $e6602c9cee6df4a2$var$join(directives, " "),
                $e6602c9cee6df4a2$var$block(fields)
            ], " ")
    },
    UnionTypeDefinition: {
        leave: ({ description: description, name: name, directives: directives, types: types })=>$e6602c9cee6df4a2$var$wrap("", description, "\n") + $e6602c9cee6df4a2$var$join([
                "union",
                name,
                $e6602c9cee6df4a2$var$join(directives, " "),
                $e6602c9cee6df4a2$var$wrap("= ", $e6602c9cee6df4a2$var$join(types, " | "))
            ], " ")
    },
    EnumTypeDefinition: {
        leave: ({ description: description, name: name, directives: directives, values: values })=>$e6602c9cee6df4a2$var$wrap("", description, "\n") + $e6602c9cee6df4a2$var$join([
                "enum",
                name,
                $e6602c9cee6df4a2$var$join(directives, " "),
                $e6602c9cee6df4a2$var$block(values)
            ], " ")
    },
    EnumValueDefinition: {
        leave: ({ description: description, name: name, directives: directives })=>$e6602c9cee6df4a2$var$wrap("", description, "\n") + $e6602c9cee6df4a2$var$join([
                name,
                $e6602c9cee6df4a2$var$join(directives, " ")
            ], " ")
    },
    InputObjectTypeDefinition: {
        leave: ({ description: description, name: name, directives: directives, fields: fields })=>$e6602c9cee6df4a2$var$wrap("", description, "\n") + $e6602c9cee6df4a2$var$join([
                "input",
                name,
                $e6602c9cee6df4a2$var$join(directives, " "),
                $e6602c9cee6df4a2$var$block(fields)
            ], " ")
    },
    DirectiveDefinition: {
        leave: ({ description: description, name: name, arguments: args, repeatable: repeatable, locations: locations })=>$e6602c9cee6df4a2$var$wrap("", description, "\n") + "directive @" + name + ($e6602c9cee6df4a2$var$hasMultilineItems(args) ? $e6602c9cee6df4a2$var$wrap("(\n", $e6602c9cee6df4a2$var$indent($e6602c9cee6df4a2$var$join(args, "\n")), "\n)") : $e6602c9cee6df4a2$var$wrap("(", $e6602c9cee6df4a2$var$join(args, ", "), ")")) + (repeatable ? " repeatable" : "") + " on " + $e6602c9cee6df4a2$var$join(locations, " | ")
    },
    SchemaExtension: {
        leave: ({ directives: directives, operationTypes: operationTypes })=>$e6602c9cee6df4a2$var$join([
                "extend schema",
                $e6602c9cee6df4a2$var$join(directives, " "),
                $e6602c9cee6df4a2$var$block(operationTypes)
            ], " ")
    },
    ScalarTypeExtension: {
        leave: ({ name: name, directives: directives })=>$e6602c9cee6df4a2$var$join([
                "extend scalar",
                name,
                $e6602c9cee6df4a2$var$join(directives, " ")
            ], " ")
    },
    ObjectTypeExtension: {
        leave: ({ name: name, interfaces: interfaces, directives: directives, fields: fields })=>$e6602c9cee6df4a2$var$join([
                "extend type",
                name,
                $e6602c9cee6df4a2$var$wrap("implements ", $e6602c9cee6df4a2$var$join(interfaces, " & ")),
                $e6602c9cee6df4a2$var$join(directives, " "),
                $e6602c9cee6df4a2$var$block(fields)
            ], " ")
    },
    InterfaceTypeExtension: {
        leave: ({ name: name, interfaces: interfaces, directives: directives, fields: fields })=>$e6602c9cee6df4a2$var$join([
                "extend interface",
                name,
                $e6602c9cee6df4a2$var$wrap("implements ", $e6602c9cee6df4a2$var$join(interfaces, " & ")),
                $e6602c9cee6df4a2$var$join(directives, " "),
                $e6602c9cee6df4a2$var$block(fields)
            ], " ")
    },
    UnionTypeExtension: {
        leave: ({ name: name, directives: directives, types: types })=>$e6602c9cee6df4a2$var$join([
                "extend union",
                name,
                $e6602c9cee6df4a2$var$join(directives, " "),
                $e6602c9cee6df4a2$var$wrap("= ", $e6602c9cee6df4a2$var$join(types, " | "))
            ], " ")
    },
    EnumTypeExtension: {
        leave: ({ name: name, directives: directives, values: values })=>$e6602c9cee6df4a2$var$join([
                "extend enum",
                name,
                $e6602c9cee6df4a2$var$join(directives, " "),
                $e6602c9cee6df4a2$var$block(values)
            ], " ")
    },
    InputObjectTypeExtension: {
        leave: ({ name: name, directives: directives, fields: fields })=>$e6602c9cee6df4a2$var$join([
                "extend input",
                name,
                $e6602c9cee6df4a2$var$join(directives, " "),
                $e6602c9cee6df4a2$var$block(fields)
            ], " ")
    }
};
/**
 * Given maybeArray, print an empty string if it is null or empty, otherwise
 * print all items together separated by separator if provided
 */ function $e6602c9cee6df4a2$var$join(maybeArray, separator = "") {
    var _maybeArray$filter$jo;
    return (_maybeArray$filter$jo = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.filter((x)=>x).join(separator)) !== null && _maybeArray$filter$jo !== void 0 ? _maybeArray$filter$jo : "";
}
/**
 * Given array, print each item on its own line, wrapped in an indented `{ }` block.
 */ function $e6602c9cee6df4a2$var$block(array) {
    return $e6602c9cee6df4a2$var$wrap("{\n", $e6602c9cee6df4a2$var$indent($e6602c9cee6df4a2$var$join(array, "\n")), "\n}");
}
/**
 * If maybeString is not null or empty, then wrap with start and end, otherwise print an empty string.
 */ function $e6602c9cee6df4a2$var$wrap(start, maybeString, end = "") {
    return maybeString != null && maybeString !== "" ? start + maybeString + end : "";
}
function $e6602c9cee6df4a2$var$indent(str) {
    return $e6602c9cee6df4a2$var$wrap("  ", str.replace(/\n/g, "\n  "));
}
function $e6602c9cee6df4a2$var$hasMultilineItems(maybeArray) {
    var _maybeArray$some;
    // FIXME: https://github.com/graphql/graphql-js/issues/2203
    /* c8 ignore next */ return (_maybeArray$some = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.some((str)=>str.includes("\n"))) !== null && _maybeArray$some !== void 0 ? _maybeArray$some : false;
}

});
parcelRegister("7tbLu", function(module, exports) {

$parcel$export(module.exports, "dedentBlockStringLines", () => $a51b3e37e1f6e888$export$d5ee19b441e8d2ae);
$parcel$export(module.exports, "isPrintableAsBlockString", () => $a51b3e37e1f6e888$export$40862a63ef85e395);
$parcel$export(module.exports, "printBlockString", () => $a51b3e37e1f6e888$export$adb6ca997eeb1f45);

var $gmlY8 = parcelRequire("gmlY8");
function $a51b3e37e1f6e888$export$d5ee19b441e8d2ae(lines) {
    var _firstNonEmptyLine2;
    let commonIndent = Number.MAX_SAFE_INTEGER;
    let firstNonEmptyLine = null;
    let lastNonEmptyLine = -1;
    for(let i = 0; i < lines.length; ++i){
        var _firstNonEmptyLine;
        const line = lines[i];
        const indent = $a51b3e37e1f6e888$var$leadingWhitespace(line);
        if (indent === line.length) continue; // skip empty lines
        firstNonEmptyLine = (_firstNonEmptyLine = firstNonEmptyLine) !== null && _firstNonEmptyLine !== void 0 ? _firstNonEmptyLine : i;
        lastNonEmptyLine = i;
        if (i !== 0 && indent < commonIndent) commonIndent = indent;
    }
    return lines // Remove common indentation from all lines but first.
    .map((line, i)=>i === 0 ? line : line.slice(commonIndent)) // Remove leading and trailing blank lines.
    .slice((_firstNonEmptyLine2 = firstNonEmptyLine) !== null && _firstNonEmptyLine2 !== void 0 ? _firstNonEmptyLine2 : 0, lastNonEmptyLine + 1);
}
function $a51b3e37e1f6e888$var$leadingWhitespace(str) {
    let i = 0;
    while(i < str.length && (0, $gmlY8.isWhiteSpace)(str.charCodeAt(i)))++i;
    return i;
}
function $a51b3e37e1f6e888$export$40862a63ef85e395(value) {
    if (value === "") return true; // empty string is printable
    let isEmptyLine = true;
    let hasIndent = false;
    let hasCommonIndent = true;
    let seenNonEmptyLine = false;
    for(let i = 0; i < value.length; ++i)switch(value.codePointAt(i)){
        case 0x0000:
        case 0x0001:
        case 0x0002:
        case 0x0003:
        case 0x0004:
        case 0x0005:
        case 0x0006:
        case 0x0007:
        case 0x0008:
        case 0x000b:
        case 0x000c:
        case 0x000e:
        case 0x000f:
            return false;
        // Has non-printable characters
        case 0x000d:
            //  \r
            return false;
        // Has \r or \r\n which will be replaced as \n
        case 10:
            //  \n
            if (isEmptyLine && !seenNonEmptyLine) return false; // Has leading new line
            seenNonEmptyLine = true;
            isEmptyLine = true;
            hasIndent = false;
            break;
        case 9:
        case 32:
            //  <space>
            hasIndent || (hasIndent = isEmptyLine);
            break;
        default:
            hasCommonIndent && (hasCommonIndent = hasIndent);
            isEmptyLine = false;
    }
    if (isEmptyLine) return false; // Has trailing empty lines
    if (hasCommonIndent && seenNonEmptyLine) return false; // Has internal indent
    return true;
}
function $a51b3e37e1f6e888$export$adb6ca997eeb1f45(value, options) {
    const escapedValue = value.replace(/"""/g, '\\"""'); // Expand a block string's raw value into independent lines.
    const lines = escapedValue.split(/\r\n|[\n\r]/g);
    const isSingleLine = lines.length === 1; // If common indentation is found we can fix some of those cases by adding leading new line
    const forceLeadingNewLine = lines.length > 1 && lines.slice(1).every((line)=>line.length === 0 || (0, $gmlY8.isWhiteSpace)(line.charCodeAt(0))); // Trailing triple quotes just looks confusing but doesn't force trailing new line
    const hasTrailingTripleQuotes = escapedValue.endsWith('\\"""'); // Trailing quote (single or double) or slash forces trailing new line
    const hasTrailingQuote = value.endsWith('"') && !hasTrailingTripleQuotes;
    const hasTrailingSlash = value.endsWith("\\");
    const forceTrailingNewline = hasTrailingQuote || hasTrailingSlash;
    const printAsMultipleLines = !(options !== null && options !== void 0 && options.minimize) && // add leading and trailing new lines only if it improves readability
    (!isSingleLine || value.length > 70 || forceTrailingNewline || forceLeadingNewLine || hasTrailingTripleQuotes);
    let result = ""; // Format a multi-line block quote to account for leading space.
    const skipLeadingNewLine = isSingleLine && (0, $gmlY8.isWhiteSpace)(value.charCodeAt(0));
    if (printAsMultipleLines && !skipLeadingNewLine || forceLeadingNewLine) result += "\n";
    result += escapedValue;
    if (printAsMultipleLines || forceTrailingNewline) result += "\n";
    return '"""' + result + '"""';
}

});
parcelRegister("gmlY8", function(module, exports) {

$parcel$export(module.exports, "isWhiteSpace", () => $876b79dde797933a$export$3c52dd84024ae72c);
$parcel$export(module.exports, "isDigit", () => $876b79dde797933a$export$727d9dbc4fbb948f);
$parcel$export(module.exports, "isNameStart", () => $876b79dde797933a$export$45a677ea7cb6d5c8);
$parcel$export(module.exports, "isNameContinue", () => $876b79dde797933a$export$d3f406ff46035894);
/**
 * ```
 * WhiteSpace ::
 *   - "Horizontal Tab (U+0009)"
 *   - "Space (U+0020)"
 * ```
 * @internal
 */ function $876b79dde797933a$export$3c52dd84024ae72c(code) {
    return code === 0x0009 || code === 0x0020;
}
function $876b79dde797933a$export$727d9dbc4fbb948f(code) {
    return code >= 0x0030 && code <= 0x0039;
}
function $876b79dde797933a$export$79c5d5217943d6a7(code) {
    return code >= 0x0061 && code <= 0x007a || // A-Z
    code >= 0x0041 && code <= 0x005a // a-z
    ;
}
function $876b79dde797933a$export$45a677ea7cb6d5c8(code) {
    return $876b79dde797933a$export$79c5d5217943d6a7(code) || code === 0x005f;
}
function $876b79dde797933a$export$d3f406ff46035894(code) {
    return $876b79dde797933a$export$79c5d5217943d6a7(code) || $876b79dde797933a$export$727d9dbc4fbb948f(code) || code === 0x005f;
}

});


parcelRegister("kkR0N", function(module, exports) {

$parcel$export(module.exports, "printString", () => $670ab209adef6fbd$export$3cdec7cf614a0ecc);
/**
 * Prints a string as a GraphQL StringValue literal. Replaces control characters
 * and excluded characters (" U+0022 and \\ U+005C) with escape sequences.
 */ function $670ab209adef6fbd$export$3cdec7cf614a0ecc(str) {
    return `"${str.replace($670ab209adef6fbd$var$escapedRegExp, $670ab209adef6fbd$var$escapedReplacer)}"`;
} // eslint-disable-next-line no-control-regex
const $670ab209adef6fbd$var$escapedRegExp = /[\x00-\x1f\x22\x5c\x7f-\x9f]/g;
function $670ab209adef6fbd$var$escapedReplacer(str) {
    return $670ab209adef6fbd$var$escapeSequences[str.charCodeAt(0)];
} // prettier-ignore
const $670ab209adef6fbd$var$escapeSequences = [
    "\\u0000",
    "\\u0001",
    "\\u0002",
    "\\u0003",
    "\\u0004",
    "\\u0005",
    "\\u0006",
    "\\u0007",
    "\\b",
    "\\t",
    "\\n",
    "\\u000B",
    "\\f",
    "\\r",
    "\\u000E",
    "\\u000F",
    "\\u0010",
    "\\u0011",
    "\\u0012",
    "\\u0013",
    "\\u0014",
    "\\u0015",
    "\\u0016",
    "\\u0017",
    "\\u0018",
    "\\u0019",
    "\\u001A",
    "\\u001B",
    "\\u001C",
    "\\u001D",
    "\\u001E",
    "\\u001F",
    "",
    "",
    '\\"',
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "\\\\",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "\\u007F",
    "\\u0080",
    "\\u0081",
    "\\u0082",
    "\\u0083",
    "\\u0084",
    "\\u0085",
    "\\u0086",
    "\\u0087",
    "\\u0088",
    "\\u0089",
    "\\u008A",
    "\\u008B",
    "\\u008C",
    "\\u008D",
    "\\u008E",
    "\\u008F",
    "\\u0090",
    "\\u0091",
    "\\u0092",
    "\\u0093",
    "\\u0094",
    "\\u0095",
    "\\u0096",
    "\\u0097",
    "\\u0098",
    "\\u0099",
    "\\u009A",
    "\\u009B",
    "\\u009C",
    "\\u009D",
    "\\u009E",
    "\\u009F"
];

});

parcelRegister("9m7aI", function(module, exports) {

$parcel$export(module.exports, "BREAK", () => $78b48476e314521e$export$a89c95c098ac2a58);
$parcel$export(module.exports, "visit", () => $78b48476e314521e$export$bf638b60ea8b89b7);
$parcel$export(module.exports, "getEnterLeaveForKind", () => $78b48476e314521e$export$736de8489257458);
$parcel$export(module.exports, "visitInParallel", () => $78b48476e314521e$export$728beebeea393478);
$parcel$export(module.exports, "getVisitFn", () => $78b48476e314521e$export$c9c25cca74db6e70);

var $lDltR = parcelRequire("lDltR");

var $gHwk7 = parcelRequire("gHwk7");

var $8r1qs = parcelRequire("8r1qs");

var $hu3w4 = parcelRequire("hu3w4");
const $78b48476e314521e$export$a89c95c098ac2a58 = Object.freeze({});
function $78b48476e314521e$export$bf638b60ea8b89b7(root, visitor, visitorKeys = (0, $8r1qs.QueryDocumentKeys)) {
    const enterLeaveMap = new Map();
    for (const kind of Object.values((0, $hu3w4.Kind)))enterLeaveMap.set(kind, $78b48476e314521e$export$736de8489257458(visitor, kind));
    /* eslint-disable no-undef-init */ let stack = undefined;
    let inArray = Array.isArray(root);
    let keys = [
        root
    ];
    let index = -1;
    let edits = [];
    let node = root;
    let key = undefined;
    let parent = undefined;
    const path = [];
    const ancestors = [];
    /* eslint-enable no-undef-init */ do {
        index++;
        const isLeaving = index === keys.length;
        const isEdited = isLeaving && edits.length !== 0;
        if (isLeaving) {
            key = ancestors.length === 0 ? undefined : path[path.length - 1];
            node = parent;
            parent = ancestors.pop();
            if (isEdited) {
                if (inArray) {
                    node = node.slice();
                    let editOffset = 0;
                    for (const [editKey, editValue] of edits){
                        const arrayKey = editKey - editOffset;
                        if (editValue === null) {
                            node.splice(arrayKey, 1);
                            editOffset++;
                        } else node[arrayKey] = editValue;
                    }
                } else {
                    node = Object.defineProperties({}, Object.getOwnPropertyDescriptors(node));
                    for (const [editKey, editValue] of edits)node[editKey] = editValue;
                }
            }
            index = stack.index;
            keys = stack.keys;
            edits = stack.edits;
            inArray = stack.inArray;
            stack = stack.prev;
        } else if (parent) {
            key = inArray ? index : keys[index];
            node = parent[key];
            if (node === null || node === undefined) continue;
            path.push(key);
        }
        let result;
        if (!Array.isArray(node)) {
            var _enterLeaveMap$get, _enterLeaveMap$get2;
            (0, $8r1qs.isNode)(node) || (0, $lDltR.devAssert)(false, `Invalid AST Node: ${(0, $gHwk7.inspect)(node)}.`);
            const visitFn = isLeaving ? (_enterLeaveMap$get = enterLeaveMap.get(node.kind)) === null || _enterLeaveMap$get === void 0 ? void 0 : _enterLeaveMap$get.leave : (_enterLeaveMap$get2 = enterLeaveMap.get(node.kind)) === null || _enterLeaveMap$get2 === void 0 ? void 0 : _enterLeaveMap$get2.enter;
            result = visitFn === null || visitFn === void 0 ? void 0 : visitFn.call(visitor, node, key, parent, path, ancestors);
            if (result === $78b48476e314521e$export$a89c95c098ac2a58) break;
            if (result === false) {
                if (!isLeaving) {
                    path.pop();
                    continue;
                }
            } else if (result !== undefined) {
                edits.push([
                    key,
                    result
                ]);
                if (!isLeaving) {
                    if ((0, $8r1qs.isNode)(result)) node = result;
                    else {
                        path.pop();
                        continue;
                    }
                }
            }
        }
        if (result === undefined && isEdited) edits.push([
            key,
            node
        ]);
        if (isLeaving) path.pop();
        else {
            var _node$kind;
            stack = {
                inArray: inArray,
                index: index,
                keys: keys,
                edits: edits,
                prev: stack
            };
            inArray = Array.isArray(node);
            keys = inArray ? node : (_node$kind = visitorKeys[node.kind]) !== null && _node$kind !== void 0 ? _node$kind : [];
            index = -1;
            edits = [];
            if (parent) ancestors.push(parent);
            parent = node;
        }
    }while (stack !== undefined);
    if (edits.length !== 0) // New root
    return edits[edits.length - 1][1];
    return root;
}
function $78b48476e314521e$export$728beebeea393478(visitors) {
    const skipping = new Array(visitors.length).fill(null);
    const mergedVisitor = Object.create(null);
    for (const kind of Object.values((0, $hu3w4.Kind))){
        let hasVisitor = false;
        const enterList = new Array(visitors.length).fill(undefined);
        const leaveList = new Array(visitors.length).fill(undefined);
        for(let i = 0; i < visitors.length; ++i){
            const { enter: enter, leave: leave } = $78b48476e314521e$export$736de8489257458(visitors[i], kind);
            hasVisitor || (hasVisitor = enter != null || leave != null);
            enterList[i] = enter;
            leaveList[i] = leave;
        }
        if (!hasVisitor) continue;
        const mergedEnterLeave = {
            enter (...args) {
                const node = args[0];
                for(let i = 0; i < visitors.length; i++)if (skipping[i] === null) {
                    var _enterList$i;
                    const result = (_enterList$i = enterList[i]) === null || _enterList$i === void 0 ? void 0 : _enterList$i.apply(visitors[i], args);
                    if (result === false) skipping[i] = node;
                    else if (result === $78b48476e314521e$export$a89c95c098ac2a58) skipping[i] = $78b48476e314521e$export$a89c95c098ac2a58;
                    else if (result !== undefined) return result;
                }
            },
            leave (...args) {
                const node = args[0];
                for(let i = 0; i < visitors.length; i++){
                    if (skipping[i] === null) {
                        var _leaveList$i;
                        const result = (_leaveList$i = leaveList[i]) === null || _leaveList$i === void 0 ? void 0 : _leaveList$i.apply(visitors[i], args);
                        if (result === $78b48476e314521e$export$a89c95c098ac2a58) skipping[i] = $78b48476e314521e$export$a89c95c098ac2a58;
                        else if (result !== undefined && result !== false) return result;
                    } else if (skipping[i] === node) skipping[i] = null;
                }
            }
        };
        mergedVisitor[kind] = mergedEnterLeave;
    }
    return mergedVisitor;
}
function $78b48476e314521e$export$736de8489257458(visitor, kind) {
    const kindVisitor = visitor[kind];
    if (typeof kindVisitor === "object") // { Kind: { enter() {}, leave() {} } }
    return kindVisitor;
    else if (typeof kindVisitor === "function") // { Kind() {} }
    return {
        enter: kindVisitor,
        leave: undefined
    };
     // { enter() {}, leave() {} }
    return {
        enter: visitor.enter,
        leave: visitor.leave
    };
}
function $78b48476e314521e$export$c9c25cca74db6e70(visitor, kind, isLeaving) {
    const { enter: enter, leave: leave } = $78b48476e314521e$export$736de8489257458(visitor, kind);
    return isLeaving ? leave : enter;
}

});
parcelRegister("8r1qs", function(module, exports) {

$parcel$export(module.exports, "Location", () => $11b06753ce50693f$export$18a2be9195644f38);
$parcel$export(module.exports, "Token", () => $11b06753ce50693f$export$50792b0e93539fde);
$parcel$export(module.exports, "QueryDocumentKeys", () => $11b06753ce50693f$export$4fcd777a40ccf407);
$parcel$export(module.exports, "isNode", () => $11b06753ce50693f$export$8ee0fc9ee280b4ee);
$parcel$export(module.exports, "OperationTypeNode", () => $11b06753ce50693f$export$f58c50edb4aef9d4);
/**
 * Contains a range of UTF-8 character offsets and token references that
 * identify the region of the source from which the AST derived.
 */ class $11b06753ce50693f$export$18a2be9195644f38 {
    /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The Token at which this Node begins.
   */ /**
   * The Token at which this Node ends.
   */ /**
   * The Source document the AST represents.
   */ constructor(startToken, endToken, source){
        this.start = startToken.start;
        this.end = endToken.end;
        this.startToken = startToken;
        this.endToken = endToken;
        this.source = source;
    }
    get [Symbol.toStringTag]() {
        return "Location";
    }
    toJSON() {
        return {
            start: this.start,
            end: this.end
        };
    }
}
class $11b06753ce50693f$export$50792b0e93539fde {
    /**
   * The kind of Token.
   */ /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The 1-indexed line number on which this Token appears.
   */ /**
   * The 1-indexed column number at which this Token begins.
   */ /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   *
   * Note: is undefined for punctuation tokens, but typed as string for
   * convenience in the parser.
   */ /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */ constructor(kind, start, end, line, column, value){
        this.kind = kind;
        this.start = start;
        this.end = end;
        this.line = line;
        this.column = column; // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        this.value = value;
        this.prev = null;
        this.next = null;
    }
    get [Symbol.toStringTag]() {
        return "Token";
    }
    toJSON() {
        return {
            kind: this.kind,
            value: this.value,
            line: this.line,
            column: this.column
        };
    }
}
const $11b06753ce50693f$export$4fcd777a40ccf407 = {
    Name: [],
    Document: [
        "definitions"
    ],
    OperationDefinition: [
        "name",
        "variableDefinitions",
        "directives",
        "selectionSet"
    ],
    VariableDefinition: [
        "variable",
        "type",
        "defaultValue",
        "directives"
    ],
    Variable: [
        "name"
    ],
    SelectionSet: [
        "selections"
    ],
    Field: [
        "alias",
        "name",
        "arguments",
        "directives",
        "selectionSet"
    ],
    Argument: [
        "name",
        "value"
    ],
    FragmentSpread: [
        "name",
        "directives"
    ],
    InlineFragment: [
        "typeCondition",
        "directives",
        "selectionSet"
    ],
    FragmentDefinition: [
        "name",
        "variableDefinitions",
        "typeCondition",
        "directives",
        "selectionSet"
    ],
    IntValue: [],
    FloatValue: [],
    StringValue: [],
    BooleanValue: [],
    NullValue: [],
    EnumValue: [],
    ListValue: [
        "values"
    ],
    ObjectValue: [
        "fields"
    ],
    ObjectField: [
        "name",
        "value"
    ],
    Directive: [
        "name",
        "arguments"
    ],
    NamedType: [
        "name"
    ],
    ListType: [
        "type"
    ],
    NonNullType: [
        "type"
    ],
    SchemaDefinition: [
        "description",
        "directives",
        "operationTypes"
    ],
    OperationTypeDefinition: [
        "type"
    ],
    ScalarTypeDefinition: [
        "description",
        "name",
        "directives"
    ],
    ObjectTypeDefinition: [
        "description",
        "name",
        "interfaces",
        "directives",
        "fields"
    ],
    FieldDefinition: [
        "description",
        "name",
        "arguments",
        "type",
        "directives"
    ],
    InputValueDefinition: [
        "description",
        "name",
        "type",
        "defaultValue",
        "directives"
    ],
    InterfaceTypeDefinition: [
        "description",
        "name",
        "interfaces",
        "directives",
        "fields"
    ],
    UnionTypeDefinition: [
        "description",
        "name",
        "directives",
        "types"
    ],
    EnumTypeDefinition: [
        "description",
        "name",
        "directives",
        "values"
    ],
    EnumValueDefinition: [
        "description",
        "name",
        "directives"
    ],
    InputObjectTypeDefinition: [
        "description",
        "name",
        "directives",
        "fields"
    ],
    DirectiveDefinition: [
        "description",
        "name",
        "arguments",
        "locations"
    ],
    SchemaExtension: [
        "directives",
        "operationTypes"
    ],
    ScalarTypeExtension: [
        "name",
        "directives"
    ],
    ObjectTypeExtension: [
        "name",
        "interfaces",
        "directives",
        "fields"
    ],
    InterfaceTypeExtension: [
        "name",
        "interfaces",
        "directives",
        "fields"
    ],
    UnionTypeExtension: [
        "name",
        "directives",
        "types"
    ],
    EnumTypeExtension: [
        "name",
        "directives",
        "values"
    ],
    InputObjectTypeExtension: [
        "name",
        "directives",
        "fields"
    ]
};
const $11b06753ce50693f$var$kindValues = new Set(Object.keys($11b06753ce50693f$export$4fcd777a40ccf407));
function $11b06753ce50693f$export$8ee0fc9ee280b4ee(maybeNode) {
    const maybeKind = maybeNode === null || maybeNode === void 0 ? void 0 : maybeNode.kind;
    return typeof maybeKind === "string" && $11b06753ce50693f$var$kindValues.has(maybeKind);
}
/** Name */ var $11b06753ce50693f$export$f58c50edb4aef9d4;
(function(OperationTypeNode) {
    OperationTypeNode["QUERY"] = "query";
    OperationTypeNode["MUTATION"] = "mutation";
    OperationTypeNode["SUBSCRIPTION"] = "subscription";
})($11b06753ce50693f$export$f58c50edb4aef9d4 || ($11b06753ce50693f$export$f58c50edb4aef9d4 = {}));

});



parcelRegister("856R3", function(module, exports) {

$parcel$export(module.exports, "valueFromASTUntyped", () => $80c769bee6e6f41a$export$448e0963aec9442f);

var $3ahKk = parcelRequire("3ahKk");

var $hu3w4 = parcelRequire("hu3w4");
function $80c769bee6e6f41a$export$448e0963aec9442f(valueNode, variables) {
    switch(valueNode.kind){
        case (0, $hu3w4.Kind).NULL:
            return null;
        case (0, $hu3w4.Kind).INT:
            return parseInt(valueNode.value, 10);
        case (0, $hu3w4.Kind).FLOAT:
            return parseFloat(valueNode.value);
        case (0, $hu3w4.Kind).STRING:
        case (0, $hu3w4.Kind).ENUM:
        case (0, $hu3w4.Kind).BOOLEAN:
            return valueNode.value;
        case (0, $hu3w4.Kind).LIST:
            return valueNode.values.map((node)=>$80c769bee6e6f41a$export$448e0963aec9442f(node, variables));
        case (0, $hu3w4.Kind).OBJECT:
            return (0, $3ahKk.keyValMap)(valueNode.fields, (field)=>field.name.value, (field)=>$80c769bee6e6f41a$export$448e0963aec9442f(field.value, variables));
        case (0, $hu3w4.Kind).VARIABLE:
            return variables === null || variables === void 0 ? void 0 : variables[valueNode.name.value];
    }
}

});

parcelRegister("kr4gH", function(module, exports) {

$parcel$export(module.exports, "assertName", () => $fb9da5efc33169c7$export$bb385db32a5f0983);
$parcel$export(module.exports, "assertEnumValueName", () => $fb9da5efc33169c7$export$7165da2a95b5ac38);

var $lDltR = parcelRequire("lDltR");

var $fHcz3 = parcelRequire("fHcz3");

var $gmlY8 = parcelRequire("gmlY8");
function $fb9da5efc33169c7$export$bb385db32a5f0983(name) {
    name != null || (0, $lDltR.devAssert)(false, "Must provide name.");
    typeof name === "string" || (0, $lDltR.devAssert)(false, "Expected name to be a string.");
    if (name.length === 0) throw new (0, $fHcz3.GraphQLError)("Expected name to be a non-empty string.");
    for(let i = 1; i < name.length; ++i){
        if (!(0, $gmlY8.isNameContinue)(name.charCodeAt(i))) throw new (0, $fHcz3.GraphQLError)(`Names must only contain [_a-zA-Z0-9] but "${name}" does not.`);
    }
    if (!(0, $gmlY8.isNameStart)(name.charCodeAt(0))) throw new (0, $fHcz3.GraphQLError)(`Names must start with [_a-zA-Z] but "${name}" does not.`);
    return name;
}
function $fb9da5efc33169c7$export$7165da2a95b5ac38(name) {
    if (name === "true" || name === "false" || name === "null") throw new (0, $fHcz3.GraphQLError)(`Enum values cannot be named: ${name}`);
    return $fb9da5efc33169c7$export$bb385db32a5f0983(name);
}

});


parcelRegister("l5aqI", function(module, exports) {

$parcel$export(module.exports, "GRAPHQL_MAX_INT", () => $fffcd7baf5e0ff7f$export$3712e80356fb0fd);
$parcel$export(module.exports, "GRAPHQL_MIN_INT", () => $fffcd7baf5e0ff7f$export$8cef32fface4b9f7);
$parcel$export(module.exports, "GraphQLInt", () => $fffcd7baf5e0ff7f$export$4d4383325330928b);
$parcel$export(module.exports, "GraphQLFloat", () => $fffcd7baf5e0ff7f$export$3b54cc45efb7ef0d);
$parcel$export(module.exports, "GraphQLString", () => $fffcd7baf5e0ff7f$export$bf00325280f7630c);
$parcel$export(module.exports, "GraphQLBoolean", () => $fffcd7baf5e0ff7f$export$bcd144a2158fe517);
$parcel$export(module.exports, "GraphQLID", () => $fffcd7baf5e0ff7f$export$530df982af95a879);
$parcel$export(module.exports, "specifiedScalarTypes", () => $fffcd7baf5e0ff7f$export$5df80378609411b9);
$parcel$export(module.exports, "isSpecifiedScalarType", () => $fffcd7baf5e0ff7f$export$5d6bb1cb0ae296ca);

var $gHwk7 = parcelRequire("gHwk7");

var $cryJ5 = parcelRequire("cryJ5");

var $fHcz3 = parcelRequire("fHcz3");

var $hu3w4 = parcelRequire("hu3w4");

var $3o9dz = parcelRequire("3o9dz");

var $54dWd = parcelRequire("54dWd");
const $fffcd7baf5e0ff7f$export$3712e80356fb0fd = 2147483647;
const $fffcd7baf5e0ff7f$export$8cef32fface4b9f7 = -2147483648;
const $fffcd7baf5e0ff7f$export$4d4383325330928b = new (0, $54dWd.GraphQLScalarType)({
    name: "Int",
    description: "The `Int` scalar type represents non-fractional signed whole numeric values. Int can represent values between -(2^31) and 2^31 - 1.",
    serialize (outputValue) {
        const coercedValue = $fffcd7baf5e0ff7f$var$serializeObject(outputValue);
        if (typeof coercedValue === "boolean") return coercedValue ? 1 : 0;
        let num = coercedValue;
        if (typeof coercedValue === "string" && coercedValue !== "") num = Number(coercedValue);
        if (typeof num !== "number" || !Number.isInteger(num)) throw new (0, $fHcz3.GraphQLError)(`Int cannot represent non-integer value: ${(0, $gHwk7.inspect)(coercedValue)}`);
        if (num > $fffcd7baf5e0ff7f$export$3712e80356fb0fd || num < $fffcd7baf5e0ff7f$export$8cef32fface4b9f7) throw new (0, $fHcz3.GraphQLError)("Int cannot represent non 32-bit signed integer value: " + (0, $gHwk7.inspect)(coercedValue));
        return num;
    },
    parseValue (inputValue) {
        if (typeof inputValue !== "number" || !Number.isInteger(inputValue)) throw new (0, $fHcz3.GraphQLError)(`Int cannot represent non-integer value: ${(0, $gHwk7.inspect)(inputValue)}`);
        if (inputValue > $fffcd7baf5e0ff7f$export$3712e80356fb0fd || inputValue < $fffcd7baf5e0ff7f$export$8cef32fface4b9f7) throw new (0, $fHcz3.GraphQLError)(`Int cannot represent non 32-bit signed integer value: ${inputValue}`);
        return inputValue;
    },
    parseLiteral (valueNode) {
        if (valueNode.kind !== (0, $hu3w4.Kind).INT) throw new (0, $fHcz3.GraphQLError)(`Int cannot represent non-integer value: ${(0, $3o9dz.print)(valueNode)}`, {
            nodes: valueNode
        });
        const num = parseInt(valueNode.value, 10);
        if (num > $fffcd7baf5e0ff7f$export$3712e80356fb0fd || num < $fffcd7baf5e0ff7f$export$8cef32fface4b9f7) throw new (0, $fHcz3.GraphQLError)(`Int cannot represent non 32-bit signed integer value: ${valueNode.value}`, {
            nodes: valueNode
        });
        return num;
    }
});
const $fffcd7baf5e0ff7f$export$3b54cc45efb7ef0d = new (0, $54dWd.GraphQLScalarType)({
    name: "Float",
    description: "The `Float` scalar type represents signed double-precision fractional values as specified by [IEEE 754](https://en.wikipedia.org/wiki/IEEE_floating_point).",
    serialize (outputValue) {
        const coercedValue = $fffcd7baf5e0ff7f$var$serializeObject(outputValue);
        if (typeof coercedValue === "boolean") return coercedValue ? 1 : 0;
        let num = coercedValue;
        if (typeof coercedValue === "string" && coercedValue !== "") num = Number(coercedValue);
        if (typeof num !== "number" || !Number.isFinite(num)) throw new (0, $fHcz3.GraphQLError)(`Float cannot represent non numeric value: ${(0, $gHwk7.inspect)(coercedValue)}`);
        return num;
    },
    parseValue (inputValue) {
        if (typeof inputValue !== "number" || !Number.isFinite(inputValue)) throw new (0, $fHcz3.GraphQLError)(`Float cannot represent non numeric value: ${(0, $gHwk7.inspect)(inputValue)}`);
        return inputValue;
    },
    parseLiteral (valueNode) {
        if (valueNode.kind !== (0, $hu3w4.Kind).FLOAT && valueNode.kind !== (0, $hu3w4.Kind).INT) throw new (0, $fHcz3.GraphQLError)(`Float cannot represent non numeric value: ${(0, $3o9dz.print)(valueNode)}`, valueNode);
        return parseFloat(valueNode.value);
    }
});
const $fffcd7baf5e0ff7f$export$bf00325280f7630c = new (0, $54dWd.GraphQLScalarType)({
    name: "String",
    description: "The `String` scalar type represents textual data, represented as UTF-8 character sequences. The String type is most often used by GraphQL to represent free-form human-readable text.",
    serialize (outputValue) {
        const coercedValue = $fffcd7baf5e0ff7f$var$serializeObject(outputValue); // Serialize string, boolean and number values to a string, but do not
        // attempt to coerce object, function, symbol, or other types as strings.
        if (typeof coercedValue === "string") return coercedValue;
        if (typeof coercedValue === "boolean") return coercedValue ? "true" : "false";
        if (typeof coercedValue === "number" && Number.isFinite(coercedValue)) return coercedValue.toString();
        throw new (0, $fHcz3.GraphQLError)(`String cannot represent value: ${(0, $gHwk7.inspect)(outputValue)}`);
    },
    parseValue (inputValue) {
        if (typeof inputValue !== "string") throw new (0, $fHcz3.GraphQLError)(`String cannot represent a non string value: ${(0, $gHwk7.inspect)(inputValue)}`);
        return inputValue;
    },
    parseLiteral (valueNode) {
        if (valueNode.kind !== (0, $hu3w4.Kind).STRING) throw new (0, $fHcz3.GraphQLError)(`String cannot represent a non string value: ${(0, $3o9dz.print)(valueNode)}`, {
            nodes: valueNode
        });
        return valueNode.value;
    }
});
const $fffcd7baf5e0ff7f$export$bcd144a2158fe517 = new (0, $54dWd.GraphQLScalarType)({
    name: "Boolean",
    description: "The `Boolean` scalar type represents `true` or `false`.",
    serialize (outputValue) {
        const coercedValue = $fffcd7baf5e0ff7f$var$serializeObject(outputValue);
        if (typeof coercedValue === "boolean") return coercedValue;
        if (Number.isFinite(coercedValue)) return coercedValue !== 0;
        throw new (0, $fHcz3.GraphQLError)(`Boolean cannot represent a non boolean value: ${(0, $gHwk7.inspect)(coercedValue)}`);
    },
    parseValue (inputValue) {
        if (typeof inputValue !== "boolean") throw new (0, $fHcz3.GraphQLError)(`Boolean cannot represent a non boolean value: ${(0, $gHwk7.inspect)(inputValue)}`);
        return inputValue;
    },
    parseLiteral (valueNode) {
        if (valueNode.kind !== (0, $hu3w4.Kind).BOOLEAN) throw new (0, $fHcz3.GraphQLError)(`Boolean cannot represent a non boolean value: ${(0, $3o9dz.print)(valueNode)}`, {
            nodes: valueNode
        });
        return valueNode.value;
    }
});
const $fffcd7baf5e0ff7f$export$530df982af95a879 = new (0, $54dWd.GraphQLScalarType)({
    name: "ID",
    description: 'The `ID` scalar type represents a unique identifier, often used to refetch an object or as key for a cache. The ID type appears in a JSON response as a String; however, it is not intended to be human-readable. When expected as an input type, any string (such as `"4"`) or integer (such as `4`) input value will be accepted as an ID.',
    serialize (outputValue) {
        const coercedValue = $fffcd7baf5e0ff7f$var$serializeObject(outputValue);
        if (typeof coercedValue === "string") return coercedValue;
        if (Number.isInteger(coercedValue)) return String(coercedValue);
        throw new (0, $fHcz3.GraphQLError)(`ID cannot represent value: ${(0, $gHwk7.inspect)(outputValue)}`);
    },
    parseValue (inputValue) {
        if (typeof inputValue === "string") return inputValue;
        if (typeof inputValue === "number" && Number.isInteger(inputValue)) return inputValue.toString();
        throw new (0, $fHcz3.GraphQLError)(`ID cannot represent value: ${(0, $gHwk7.inspect)(inputValue)}`);
    },
    parseLiteral (valueNode) {
        if (valueNode.kind !== (0, $hu3w4.Kind).STRING && valueNode.kind !== (0, $hu3w4.Kind).INT) throw new (0, $fHcz3.GraphQLError)("ID cannot represent a non-string and non-integer value: " + (0, $3o9dz.print)(valueNode), {
            nodes: valueNode
        });
        return valueNode.value;
    }
});
const $fffcd7baf5e0ff7f$export$5df80378609411b9 = Object.freeze([
    $fffcd7baf5e0ff7f$export$bf00325280f7630c,
    $fffcd7baf5e0ff7f$export$4d4383325330928b,
    $fffcd7baf5e0ff7f$export$3b54cc45efb7ef0d,
    $fffcd7baf5e0ff7f$export$bcd144a2158fe517,
    $fffcd7baf5e0ff7f$export$530df982af95a879
]);
function $fffcd7baf5e0ff7f$export$5d6bb1cb0ae296ca(type) {
    return $fffcd7baf5e0ff7f$export$5df80378609411b9.some(({ name: name })=>type.name === name);
} // Support serializing objects with custom valueOf() or toJSON() functions -
// a common way to represent a complex value which can be represented as
// a string (ex: MongoDB id objects).
function $fffcd7baf5e0ff7f$var$serializeObject(outputValue) {
    if ((0, $cryJ5.isObjectLike)(outputValue)) {
        if (typeof outputValue.valueOf === "function") {
            const valueOfResult = outputValue.valueOf();
            if (!(0, $cryJ5.isObjectLike)(valueOfResult)) return valueOfResult;
        }
        if (typeof outputValue.toJSON === "function") return outputValue.toJSON();
    }
    return outputValue;
}

});


parcelRegister("iqtrZ", function(module, exports) {

$parcel$export(module.exports, "buildClientSchema", () => $4bedeaca141fa918$export$de8c236cf09c987c);

var $lDltR = parcelRequire("lDltR");

var $gHwk7 = parcelRequire("gHwk7");

var $cryJ5 = parcelRequire("cryJ5");

var $3ahKk = parcelRequire("3ahKk");

var $8DJ2k = parcelRequire("8DJ2k");

var $54dWd = parcelRequire("54dWd");

var $9KaHw = parcelRequire("9KaHw");

var $jptTh = parcelRequire("jptTh");

var $l5aqI = parcelRequire("l5aqI");

var $3rrQl = parcelRequire("3rrQl");

var $9lFiU = parcelRequire("9lFiU");
function $4bedeaca141fa918$export$de8c236cf09c987c(introspection, options) {
    (0, $cryJ5.isObjectLike)(introspection) && (0, $cryJ5.isObjectLike)(introspection.__schema) || (0, $lDltR.devAssert)(false, `Invalid or incomplete introspection result. Ensure that you are passing "data" property of introspection response and no "errors" was returned alongside: ${(0, $gHwk7.inspect)(introspection)}.`); // Get the schema from the introspection result.
    const schemaIntrospection = introspection.__schema; // Iterate through all types, getting the type definition for each.
    const typeMap = (0, $3ahKk.keyValMap)(schemaIntrospection.types, (typeIntrospection)=>typeIntrospection.name, (typeIntrospection)=>buildType(typeIntrospection)); // Include standard types only if they are used.
    for (const stdType of [
        ...(0, $l5aqI.specifiedScalarTypes),
        ...(0, $jptTh.introspectionTypes)
    ])if (typeMap[stdType.name]) typeMap[stdType.name] = stdType;
     // Get the root Query, Mutation, and Subscription types.
    const queryType = schemaIntrospection.queryType ? getObjectType(schemaIntrospection.queryType) : null;
    const mutationType = schemaIntrospection.mutationType ? getObjectType(schemaIntrospection.mutationType) : null;
    const subscriptionType = schemaIntrospection.subscriptionType ? getObjectType(schemaIntrospection.subscriptionType) : null; // Get the directives supported by Introspection, assuming empty-set if
    // directives were not queried for.
    const directives = schemaIntrospection.directives ? schemaIntrospection.directives.map(buildDirective) : []; // Then produce and return a Schema with these types.
    return new (0, $3rrQl.GraphQLSchema)({
        description: schemaIntrospection.description,
        query: queryType,
        mutation: mutationType,
        subscription: subscriptionType,
        types: Object.values(typeMap),
        directives: directives,
        assumeValid: options === null || options === void 0 ? void 0 : options.assumeValid
    }); // Given a type reference in introspection, return the GraphQLType instance.
    // preferring cached instances before building new instances.
    function getType(typeRef) {
        if (typeRef.kind === (0, $jptTh.TypeKind).LIST) {
            const itemRef = typeRef.ofType;
            if (!itemRef) throw new Error("Decorated type deeper than introspection query.");
            return new (0, $54dWd.GraphQLList)(getType(itemRef));
        }
        if (typeRef.kind === (0, $jptTh.TypeKind).NON_NULL) {
            const nullableRef = typeRef.ofType;
            if (!nullableRef) throw new Error("Decorated type deeper than introspection query.");
            const nullableType = getType(nullableRef);
            return new (0, $54dWd.GraphQLNonNull)((0, $54dWd.assertNullableType)(nullableType));
        }
        return getNamedType(typeRef);
    }
    function getNamedType(typeRef) {
        const typeName = typeRef.name;
        if (!typeName) throw new Error(`Unknown type reference: ${(0, $gHwk7.inspect)(typeRef)}.`);
        const type = typeMap[typeName];
        if (!type) throw new Error(`Invalid or incomplete schema, unknown type: ${typeName}. Ensure that a full introspection query is used in order to build a client schema.`);
        return type;
    }
    function getObjectType(typeRef) {
        return (0, $54dWd.assertObjectType)(getNamedType(typeRef));
    }
    function getInterfaceType(typeRef) {
        return (0, $54dWd.assertInterfaceType)(getNamedType(typeRef));
    } // Given a type's introspection result, construct the correct
    // GraphQLType instance.
    function buildType(type) {
        // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
        if (type != null && type.name != null && type.kind != null) // FIXME: Properly type IntrospectionType, it's a breaking change so fix in v17
        // eslint-disable-next-line @typescript-eslint/switch-exhaustiveness-check
        switch(type.kind){
            case (0, $jptTh.TypeKind).SCALAR:
                return buildScalarDef(type);
            case (0, $jptTh.TypeKind).OBJECT:
                return buildObjectDef(type);
            case (0, $jptTh.TypeKind).INTERFACE:
                return buildInterfaceDef(type);
            case (0, $jptTh.TypeKind).UNION:
                return buildUnionDef(type);
            case (0, $jptTh.TypeKind).ENUM:
                return buildEnumDef(type);
            case (0, $jptTh.TypeKind).INPUT_OBJECT:
                return buildInputObjectDef(type);
        }
        const typeStr = (0, $gHwk7.inspect)(type);
        throw new Error(`Invalid or incomplete introspection result. Ensure that a full introspection query is used in order to build a client schema: ${typeStr}.`);
    }
    function buildScalarDef(scalarIntrospection) {
        return new (0, $54dWd.GraphQLScalarType)({
            name: scalarIntrospection.name,
            description: scalarIntrospection.description,
            specifiedByURL: scalarIntrospection.specifiedByURL
        });
    }
    function buildImplementationsList(implementingIntrospection) {
        // TODO: Temporary workaround until GraphQL ecosystem will fully support
        // 'interfaces' on interface types.
        if (implementingIntrospection.interfaces === null && implementingIntrospection.kind === (0, $jptTh.TypeKind).INTERFACE) return [];
        if (!implementingIntrospection.interfaces) {
            const implementingIntrospectionStr = (0, $gHwk7.inspect)(implementingIntrospection);
            throw new Error(`Introspection result missing interfaces: ${implementingIntrospectionStr}.`);
        }
        return implementingIntrospection.interfaces.map(getInterfaceType);
    }
    function buildObjectDef(objectIntrospection) {
        return new (0, $54dWd.GraphQLObjectType)({
            name: objectIntrospection.name,
            description: objectIntrospection.description,
            interfaces: ()=>buildImplementationsList(objectIntrospection),
            fields: ()=>buildFieldDefMap(objectIntrospection)
        });
    }
    function buildInterfaceDef(interfaceIntrospection) {
        return new (0, $54dWd.GraphQLInterfaceType)({
            name: interfaceIntrospection.name,
            description: interfaceIntrospection.description,
            interfaces: ()=>buildImplementationsList(interfaceIntrospection),
            fields: ()=>buildFieldDefMap(interfaceIntrospection)
        });
    }
    function buildUnionDef(unionIntrospection) {
        if (!unionIntrospection.possibleTypes) {
            const unionIntrospectionStr = (0, $gHwk7.inspect)(unionIntrospection);
            throw new Error(`Introspection result missing possibleTypes: ${unionIntrospectionStr}.`);
        }
        return new (0, $54dWd.GraphQLUnionType)({
            name: unionIntrospection.name,
            description: unionIntrospection.description,
            types: ()=>unionIntrospection.possibleTypes.map(getObjectType)
        });
    }
    function buildEnumDef(enumIntrospection) {
        if (!enumIntrospection.enumValues) {
            const enumIntrospectionStr = (0, $gHwk7.inspect)(enumIntrospection);
            throw new Error(`Introspection result missing enumValues: ${enumIntrospectionStr}.`);
        }
        return new (0, $54dWd.GraphQLEnumType)({
            name: enumIntrospection.name,
            description: enumIntrospection.description,
            values: (0, $3ahKk.keyValMap)(enumIntrospection.enumValues, (valueIntrospection)=>valueIntrospection.name, (valueIntrospection)=>({
                    description: valueIntrospection.description,
                    deprecationReason: valueIntrospection.deprecationReason
                }))
        });
    }
    function buildInputObjectDef(inputObjectIntrospection) {
        if (!inputObjectIntrospection.inputFields) {
            const inputObjectIntrospectionStr = (0, $gHwk7.inspect)(inputObjectIntrospection);
            throw new Error(`Introspection result missing inputFields: ${inputObjectIntrospectionStr}.`);
        }
        return new (0, $54dWd.GraphQLInputObjectType)({
            name: inputObjectIntrospection.name,
            description: inputObjectIntrospection.description,
            fields: ()=>buildInputValueDefMap(inputObjectIntrospection.inputFields)
        });
    }
    function buildFieldDefMap(typeIntrospection) {
        if (!typeIntrospection.fields) throw new Error(`Introspection result missing fields: ${(0, $gHwk7.inspect)(typeIntrospection)}.`);
        return (0, $3ahKk.keyValMap)(typeIntrospection.fields, (fieldIntrospection)=>fieldIntrospection.name, buildField);
    }
    function buildField(fieldIntrospection) {
        const type = getType(fieldIntrospection.type);
        if (!(0, $54dWd.isOutputType)(type)) {
            const typeStr = (0, $gHwk7.inspect)(type);
            throw new Error(`Introspection must provide output type for fields, but received: ${typeStr}.`);
        }
        if (!fieldIntrospection.args) {
            const fieldIntrospectionStr = (0, $gHwk7.inspect)(fieldIntrospection);
            throw new Error(`Introspection result missing field args: ${fieldIntrospectionStr}.`);
        }
        return {
            description: fieldIntrospection.description,
            deprecationReason: fieldIntrospection.deprecationReason,
            type: type,
            args: buildInputValueDefMap(fieldIntrospection.args)
        };
    }
    function buildInputValueDefMap(inputValueIntrospections) {
        return (0, $3ahKk.keyValMap)(inputValueIntrospections, (inputValue)=>inputValue.name, buildInputValue);
    }
    function buildInputValue(inputValueIntrospection) {
        const type = getType(inputValueIntrospection.type);
        if (!(0, $54dWd.isInputType)(type)) {
            const typeStr = (0, $gHwk7.inspect)(type);
            throw new Error(`Introspection must provide input type for arguments, but received: ${typeStr}.`);
        }
        const defaultValue = inputValueIntrospection.defaultValue != null ? (0, $9lFiU.valueFromAST)((0, $8DJ2k.parseValue)(inputValueIntrospection.defaultValue), type) : undefined;
        return {
            description: inputValueIntrospection.description,
            type: type,
            defaultValue: defaultValue,
            deprecationReason: inputValueIntrospection.deprecationReason
        };
    }
    function buildDirective(directiveIntrospection) {
        if (!directiveIntrospection.args) {
            const directiveIntrospectionStr = (0, $gHwk7.inspect)(directiveIntrospection);
            throw new Error(`Introspection result missing directive args: ${directiveIntrospectionStr}.`);
        }
        if (!directiveIntrospection.locations) {
            const directiveIntrospectionStr = (0, $gHwk7.inspect)(directiveIntrospection);
            throw new Error(`Introspection result missing directive locations: ${directiveIntrospectionStr}.`);
        }
        return new (0, $9KaHw.GraphQLDirective)({
            name: directiveIntrospection.name,
            description: directiveIntrospection.description,
            isRepeatable: directiveIntrospection.isRepeatable,
            locations: directiveIntrospection.locations.slice(),
            args: buildInputValueDefMap(directiveIntrospection.args)
        });
    }
}

});
parcelRegister("8DJ2k", function(module, exports) {

$parcel$export(module.exports, "parse", () => $0013c7ab45cf197d$export$98e6a39c04603d36);
$parcel$export(module.exports, "parseValue", () => $0013c7ab45cf197d$export$5303528d1070ff6f);
$parcel$export(module.exports, "parseConstValue", () => $0013c7ab45cf197d$export$e14c466bd0916f7a);
$parcel$export(module.exports, "parseType", () => $0013c7ab45cf197d$export$28b8f402ccc88182);

var $egTVJ = parcelRequire("egTVJ");

var $8r1qs = parcelRequire("8r1qs");

var $5zW8K = parcelRequire("5zW8K");

var $hu3w4 = parcelRequire("hu3w4");

var $dtMcr = parcelRequire("dtMcr");

var $1i7FZ = parcelRequire("1i7FZ");

var $bQgNI = parcelRequire("bQgNI");
function $0013c7ab45cf197d$export$98e6a39c04603d36(source, options) {
    const parser = new $0013c7ab45cf197d$export$7acfa6ed01010e37(source, options);
    return parser.parseDocument();
}
function $0013c7ab45cf197d$export$5303528d1070ff6f(source, options) {
    const parser = new $0013c7ab45cf197d$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $bQgNI.TokenKind).SOF);
    const value = parser.parseValueLiteral(false);
    parser.expectToken((0, $bQgNI.TokenKind).EOF);
    return value;
}
function $0013c7ab45cf197d$export$e14c466bd0916f7a(source, options) {
    const parser = new $0013c7ab45cf197d$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $bQgNI.TokenKind).SOF);
    const value = parser.parseConstValueLiteral();
    parser.expectToken((0, $bQgNI.TokenKind).EOF);
    return value;
}
function $0013c7ab45cf197d$export$28b8f402ccc88182(source, options) {
    const parser = new $0013c7ab45cf197d$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $bQgNI.TokenKind).SOF);
    const type = parser.parseTypeReference();
    parser.expectToken((0, $bQgNI.TokenKind).EOF);
    return type;
}
class $0013c7ab45cf197d$export$7acfa6ed01010e37 {
    constructor(source, options = {}){
        const sourceObj = (0, $1i7FZ.isSource)(source) ? source : new (0, $1i7FZ.Source)(source);
        this._lexer = new (0, $dtMcr.Lexer)(sourceObj);
        this._options = options;
        this._tokenCounter = 0;
    }
    /**
   * Converts a name lex token into a name parse node.
   */ parseName() {
        const token = this.expectToken((0, $bQgNI.TokenKind).NAME);
        return this.node(token, {
            kind: (0, $hu3w4.Kind).NAME,
            value: token.value
        });
    }
    /**
   * Document : Definition+
   */ parseDocument() {
        return this.node(this._lexer.token, {
            kind: (0, $hu3w4.Kind).DOCUMENT,
            definitions: this.many((0, $bQgNI.TokenKind).SOF, this.parseDefinition, (0, $bQgNI.TokenKind).EOF)
        });
    }
    /**
   * Definition :
   *   - ExecutableDefinition
   *   - TypeSystemDefinition
   *   - TypeSystemExtension
   *
   * ExecutableDefinition :
   *   - OperationDefinition
   *   - FragmentDefinition
   *
   * TypeSystemDefinition :
   *   - SchemaDefinition
   *   - TypeDefinition
   *   - DirectiveDefinition
   *
   * TypeDefinition :
   *   - ScalarTypeDefinition
   *   - ObjectTypeDefinition
   *   - InterfaceTypeDefinition
   *   - UnionTypeDefinition
   *   - EnumTypeDefinition
   *   - InputObjectTypeDefinition
   */ parseDefinition() {
        if (this.peek((0, $bQgNI.TokenKind).BRACE_L)) return this.parseOperationDefinition();
         // Many definitions begin with a description and require a lookahead.
        const hasDescription = this.peekDescription();
        const keywordToken = hasDescription ? this._lexer.lookahead() : this._lexer.token;
        if (keywordToken.kind === (0, $bQgNI.TokenKind).NAME) {
            switch(keywordToken.value){
                case "schema":
                    return this.parseSchemaDefinition();
                case "scalar":
                    return this.parseScalarTypeDefinition();
                case "type":
                    return this.parseObjectTypeDefinition();
                case "interface":
                    return this.parseInterfaceTypeDefinition();
                case "union":
                    return this.parseUnionTypeDefinition();
                case "enum":
                    return this.parseEnumTypeDefinition();
                case "input":
                    return this.parseInputObjectTypeDefinition();
                case "directive":
                    return this.parseDirectiveDefinition();
            }
            if (hasDescription) throw (0, $egTVJ.syntaxError)(this._lexer.source, this._lexer.token.start, "Unexpected description, descriptions are supported only on type definitions.");
            switch(keywordToken.value){
                case "query":
                case "mutation":
                case "subscription":
                    return this.parseOperationDefinition();
                case "fragment":
                    return this.parseFragmentDefinition();
                case "extend":
                    return this.parseTypeSystemExtension();
            }
        }
        throw this.unexpected(keywordToken);
    }
    /**
   * OperationDefinition :
   *  - SelectionSet
   *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
   */ parseOperationDefinition() {
        const start = this._lexer.token;
        if (this.peek((0, $bQgNI.TokenKind).BRACE_L)) return this.node(start, {
            kind: (0, $hu3w4.Kind).OPERATION_DEFINITION,
            operation: (0, $8r1qs.OperationTypeNode).QUERY,
            name: undefined,
            variableDefinitions: [],
            directives: [],
            selectionSet: this.parseSelectionSet()
        });
        const operation = this.parseOperationType();
        let name;
        if (this.peek((0, $bQgNI.TokenKind).NAME)) name = this.parseName();
        return this.node(start, {
            kind: (0, $hu3w4.Kind).OPERATION_DEFINITION,
            operation: operation,
            name: name,
            variableDefinitions: this.parseVariableDefinitions(),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet()
        });
    }
    /**
   * OperationType : one of query mutation subscription
   */ parseOperationType() {
        const operationToken = this.expectToken((0, $bQgNI.TokenKind).NAME);
        switch(operationToken.value){
            case "query":
                return (0, $8r1qs.OperationTypeNode).QUERY;
            case "mutation":
                return (0, $8r1qs.OperationTypeNode).MUTATION;
            case "subscription":
                return (0, $8r1qs.OperationTypeNode).SUBSCRIPTION;
        }
        throw this.unexpected(operationToken);
    }
    /**
   * VariableDefinitions : ( VariableDefinition+ )
   */ parseVariableDefinitions() {
        return this.optionalMany((0, $bQgNI.TokenKind).PAREN_L, this.parseVariableDefinition, (0, $bQgNI.TokenKind).PAREN_R);
    }
    /**
   * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
   */ parseVariableDefinition() {
        return this.node(this._lexer.token, {
            kind: (0, $hu3w4.Kind).VARIABLE_DEFINITION,
            variable: this.parseVariable(),
            type: (this.expectToken((0, $bQgNI.TokenKind).COLON), this.parseTypeReference()),
            defaultValue: this.expectOptionalToken((0, $bQgNI.TokenKind).EQUALS) ? this.parseConstValueLiteral() : undefined,
            directives: this.parseConstDirectives()
        });
    }
    /**
   * Variable : $ Name
   */ parseVariable() {
        const start = this._lexer.token;
        this.expectToken((0, $bQgNI.TokenKind).DOLLAR);
        return this.node(start, {
            kind: (0, $hu3w4.Kind).VARIABLE,
            name: this.parseName()
        });
    }
    /**
   * ```
   * SelectionSet : { Selection+ }
   * ```
   */ parseSelectionSet() {
        return this.node(this._lexer.token, {
            kind: (0, $hu3w4.Kind).SELECTION_SET,
            selections: this.many((0, $bQgNI.TokenKind).BRACE_L, this.parseSelection, (0, $bQgNI.TokenKind).BRACE_R)
        });
    }
    /**
   * Selection :
   *   - Field
   *   - FragmentSpread
   *   - InlineFragment
   */ parseSelection() {
        return this.peek((0, $bQgNI.TokenKind).SPREAD) ? this.parseFragment() : this.parseField();
    }
    /**
   * Field : Alias? Name Arguments? Directives? SelectionSet?
   *
   * Alias : Name :
   */ parseField() {
        const start = this._lexer.token;
        const nameOrAlias = this.parseName();
        let alias;
        let name;
        if (this.expectOptionalToken((0, $bQgNI.TokenKind).COLON)) {
            alias = nameOrAlias;
            name = this.parseName();
        } else name = nameOrAlias;
        return this.node(start, {
            kind: (0, $hu3w4.Kind).FIELD,
            alias: alias,
            name: name,
            arguments: this.parseArguments(false),
            directives: this.parseDirectives(false),
            selectionSet: this.peek((0, $bQgNI.TokenKind).BRACE_L) ? this.parseSelectionSet() : undefined
        });
    }
    /**
   * Arguments[Const] : ( Argument[?Const]+ )
   */ parseArguments(isConst) {
        const item = isConst ? this.parseConstArgument : this.parseArgument;
        return this.optionalMany((0, $bQgNI.TokenKind).PAREN_L, item, (0, $bQgNI.TokenKind).PAREN_R);
    }
    /**
   * Argument[Const] : Name : Value[?Const]
   */ parseArgument(isConst = false) {
        const start = this._lexer.token;
        const name = this.parseName();
        this.expectToken((0, $bQgNI.TokenKind).COLON);
        return this.node(start, {
            kind: (0, $hu3w4.Kind).ARGUMENT,
            name: name,
            value: this.parseValueLiteral(isConst)
        });
    }
    parseConstArgument() {
        return this.parseArgument(true);
    }
    /**
   * Corresponds to both FragmentSpread and InlineFragment in the spec.
   *
   * FragmentSpread : ... FragmentName Directives?
   *
   * InlineFragment : ... TypeCondition? Directives? SelectionSet
   */ parseFragment() {
        const start = this._lexer.token;
        this.expectToken((0, $bQgNI.TokenKind).SPREAD);
        const hasTypeCondition = this.expectOptionalKeyword("on");
        if (!hasTypeCondition && this.peek((0, $bQgNI.TokenKind).NAME)) return this.node(start, {
            kind: (0, $hu3w4.Kind).FRAGMENT_SPREAD,
            name: this.parseFragmentName(),
            directives: this.parseDirectives(false)
        });
        return this.node(start, {
            kind: (0, $hu3w4.Kind).INLINE_FRAGMENT,
            typeCondition: hasTypeCondition ? this.parseNamedType() : undefined,
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet()
        });
    }
    /**
   * FragmentDefinition :
   *   - fragment FragmentName on TypeCondition Directives? SelectionSet
   *
   * TypeCondition : NamedType
   */ parseFragmentDefinition() {
        const start = this._lexer.token;
        this.expectKeyword("fragment"); // Legacy support for defining variables within fragments changes
        // the grammar of FragmentDefinition:
        //   - fragment FragmentName VariableDefinitions? on TypeCondition Directives? SelectionSet
        if (this._options.allowLegacyFragmentVariables === true) return this.node(start, {
            kind: (0, $hu3w4.Kind).FRAGMENT_DEFINITION,
            name: this.parseFragmentName(),
            variableDefinitions: this.parseVariableDefinitions(),
            typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet()
        });
        return this.node(start, {
            kind: (0, $hu3w4.Kind).FRAGMENT_DEFINITION,
            name: this.parseFragmentName(),
            typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet()
        });
    }
    /**
   * FragmentName : Name but not `on`
   */ parseFragmentName() {
        if (this._lexer.token.value === "on") throw this.unexpected();
        return this.parseName();
    }
    /**
   * Value[Const] :
   *   - [~Const] Variable
   *   - IntValue
   *   - FloatValue
   *   - StringValue
   *   - BooleanValue
   *   - NullValue
   *   - EnumValue
   *   - ListValue[?Const]
   *   - ObjectValue[?Const]
   *
   * BooleanValue : one of `true` `false`
   *
   * NullValue : `null`
   *
   * EnumValue : Name but not `true`, `false` or `null`
   */ parseValueLiteral(isConst) {
        const token = this._lexer.token;
        switch(token.kind){
            case (0, $bQgNI.TokenKind).BRACKET_L:
                return this.parseList(isConst);
            case (0, $bQgNI.TokenKind).BRACE_L:
                return this.parseObject(isConst);
            case (0, $bQgNI.TokenKind).INT:
                this.advanceLexer();
                return this.node(token, {
                    kind: (0, $hu3w4.Kind).INT,
                    value: token.value
                });
            case (0, $bQgNI.TokenKind).FLOAT:
                this.advanceLexer();
                return this.node(token, {
                    kind: (0, $hu3w4.Kind).FLOAT,
                    value: token.value
                });
            case (0, $bQgNI.TokenKind).STRING:
            case (0, $bQgNI.TokenKind).BLOCK_STRING:
                return this.parseStringLiteral();
            case (0, $bQgNI.TokenKind).NAME:
                this.advanceLexer();
                switch(token.value){
                    case "true":
                        return this.node(token, {
                            kind: (0, $hu3w4.Kind).BOOLEAN,
                            value: true
                        });
                    case "false":
                        return this.node(token, {
                            kind: (0, $hu3w4.Kind).BOOLEAN,
                            value: false
                        });
                    case "null":
                        return this.node(token, {
                            kind: (0, $hu3w4.Kind).NULL
                        });
                    default:
                        return this.node(token, {
                            kind: (0, $hu3w4.Kind).ENUM,
                            value: token.value
                        });
                }
            case (0, $bQgNI.TokenKind).DOLLAR:
                if (isConst) {
                    this.expectToken((0, $bQgNI.TokenKind).DOLLAR);
                    if (this._lexer.token.kind === (0, $bQgNI.TokenKind).NAME) {
                        const varName = this._lexer.token.value;
                        throw (0, $egTVJ.syntaxError)(this._lexer.source, token.start, `Unexpected variable "$${varName}" in constant value.`);
                    } else throw this.unexpected(token);
                }
                return this.parseVariable();
            default:
                throw this.unexpected();
        }
    }
    parseConstValueLiteral() {
        return this.parseValueLiteral(true);
    }
    parseStringLiteral() {
        const token = this._lexer.token;
        this.advanceLexer();
        return this.node(token, {
            kind: (0, $hu3w4.Kind).STRING,
            value: token.value,
            block: token.kind === (0, $bQgNI.TokenKind).BLOCK_STRING
        });
    }
    /**
   * ListValue[Const] :
   *   - [ ]
   *   - [ Value[?Const]+ ]
   */ parseList(isConst) {
        const item = ()=>this.parseValueLiteral(isConst);
        return this.node(this._lexer.token, {
            kind: (0, $hu3w4.Kind).LIST,
            values: this.any((0, $bQgNI.TokenKind).BRACKET_L, item, (0, $bQgNI.TokenKind).BRACKET_R)
        });
    }
    /**
   * ```
   * ObjectValue[Const] :
   *   - { }
   *   - { ObjectField[?Const]+ }
   * ```
   */ parseObject(isConst) {
        const item = ()=>this.parseObjectField(isConst);
        return this.node(this._lexer.token, {
            kind: (0, $hu3w4.Kind).OBJECT,
            fields: this.any((0, $bQgNI.TokenKind).BRACE_L, item, (0, $bQgNI.TokenKind).BRACE_R)
        });
    }
    /**
   * ObjectField[Const] : Name : Value[?Const]
   */ parseObjectField(isConst) {
        const start = this._lexer.token;
        const name = this.parseName();
        this.expectToken((0, $bQgNI.TokenKind).COLON);
        return this.node(start, {
            kind: (0, $hu3w4.Kind).OBJECT_FIELD,
            name: name,
            value: this.parseValueLiteral(isConst)
        });
    }
    /**
   * Directives[Const] : Directive[?Const]+
   */ parseDirectives(isConst) {
        const directives = [];
        while(this.peek((0, $bQgNI.TokenKind).AT))directives.push(this.parseDirective(isConst));
        return directives;
    }
    parseConstDirectives() {
        return this.parseDirectives(true);
    }
    /**
   * ```
   * Directive[Const] : @ Name Arguments[?Const]?
   * ```
   */ parseDirective(isConst) {
        const start = this._lexer.token;
        this.expectToken((0, $bQgNI.TokenKind).AT);
        return this.node(start, {
            kind: (0, $hu3w4.Kind).DIRECTIVE,
            name: this.parseName(),
            arguments: this.parseArguments(isConst)
        });
    }
    /**
   * Type :
   *   - NamedType
   *   - ListType
   *   - NonNullType
   */ parseTypeReference() {
        const start = this._lexer.token;
        let type;
        if (this.expectOptionalToken((0, $bQgNI.TokenKind).BRACKET_L)) {
            const innerType = this.parseTypeReference();
            this.expectToken((0, $bQgNI.TokenKind).BRACKET_R);
            type = this.node(start, {
                kind: (0, $hu3w4.Kind).LIST_TYPE,
                type: innerType
            });
        } else type = this.parseNamedType();
        if (this.expectOptionalToken((0, $bQgNI.TokenKind).BANG)) return this.node(start, {
            kind: (0, $hu3w4.Kind).NON_NULL_TYPE,
            type: type
        });
        return type;
    }
    /**
   * NamedType : Name
   */ parseNamedType() {
        return this.node(this._lexer.token, {
            kind: (0, $hu3w4.Kind).NAMED_TYPE,
            name: this.parseName()
        });
    }
    peekDescription() {
        return this.peek((0, $bQgNI.TokenKind).STRING) || this.peek((0, $bQgNI.TokenKind).BLOCK_STRING);
    }
    /**
   * Description : StringValue
   */ parseDescription() {
        if (this.peekDescription()) return this.parseStringLiteral();
    }
    /**
   * ```
   * SchemaDefinition : Description? schema Directives[Const]? { OperationTypeDefinition+ }
   * ```
   */ parseSchemaDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword("schema");
        const directives = this.parseConstDirectives();
        const operationTypes = this.many((0, $bQgNI.TokenKind).BRACE_L, this.parseOperationTypeDefinition, (0, $bQgNI.TokenKind).BRACE_R);
        return this.node(start, {
            kind: (0, $hu3w4.Kind).SCHEMA_DEFINITION,
            description: description,
            directives: directives,
            operationTypes: operationTypes
        });
    }
    /**
   * OperationTypeDefinition : OperationType : NamedType
   */ parseOperationTypeDefinition() {
        const start = this._lexer.token;
        const operation = this.parseOperationType();
        this.expectToken((0, $bQgNI.TokenKind).COLON);
        const type = this.parseNamedType();
        return this.node(start, {
            kind: (0, $hu3w4.Kind).OPERATION_TYPE_DEFINITION,
            operation: operation,
            type: type
        });
    }
    /**
   * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
   */ parseScalarTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword("scalar");
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        return this.node(start, {
            kind: (0, $hu3w4.Kind).SCALAR_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives
        });
    }
    /**
   * ObjectTypeDefinition :
   *   Description?
   *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
   */ parseObjectTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword("type");
        const name = this.parseName();
        const interfaces = this.parseImplementsInterfaces();
        const directives = this.parseConstDirectives();
        const fields = this.parseFieldsDefinition();
        return this.node(start, {
            kind: (0, $hu3w4.Kind).OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields
        });
    }
    /**
   * ImplementsInterfaces :
   *   - implements `&`? NamedType
   *   - ImplementsInterfaces & NamedType
   */ parseImplementsInterfaces() {
        return this.expectOptionalKeyword("implements") ? this.delimitedMany((0, $bQgNI.TokenKind).AMP, this.parseNamedType) : [];
    }
    /**
   * ```
   * FieldsDefinition : { FieldDefinition+ }
   * ```
   */ parseFieldsDefinition() {
        return this.optionalMany((0, $bQgNI.TokenKind).BRACE_L, this.parseFieldDefinition, (0, $bQgNI.TokenKind).BRACE_R);
    }
    /**
   * FieldDefinition :
   *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
   */ parseFieldDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        const name = this.parseName();
        const args = this.parseArgumentDefs();
        this.expectToken((0, $bQgNI.TokenKind).COLON);
        const type = this.parseTypeReference();
        const directives = this.parseConstDirectives();
        return this.node(start, {
            kind: (0, $hu3w4.Kind).FIELD_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            type: type,
            directives: directives
        });
    }
    /**
   * ArgumentsDefinition : ( InputValueDefinition+ )
   */ parseArgumentDefs() {
        return this.optionalMany((0, $bQgNI.TokenKind).PAREN_L, this.parseInputValueDef, (0, $bQgNI.TokenKind).PAREN_R);
    }
    /**
   * InputValueDefinition :
   *   - Description? Name : Type DefaultValue? Directives[Const]?
   */ parseInputValueDef() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        const name = this.parseName();
        this.expectToken((0, $bQgNI.TokenKind).COLON);
        const type = this.parseTypeReference();
        let defaultValue;
        if (this.expectOptionalToken((0, $bQgNI.TokenKind).EQUALS)) defaultValue = this.parseConstValueLiteral();
        const directives = this.parseConstDirectives();
        return this.node(start, {
            kind: (0, $hu3w4.Kind).INPUT_VALUE_DEFINITION,
            description: description,
            name: name,
            type: type,
            defaultValue: defaultValue,
            directives: directives
        });
    }
    /**
   * InterfaceTypeDefinition :
   *   - Description? interface Name Directives[Const]? FieldsDefinition?
   */ parseInterfaceTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword("interface");
        const name = this.parseName();
        const interfaces = this.parseImplementsInterfaces();
        const directives = this.parseConstDirectives();
        const fields = this.parseFieldsDefinition();
        return this.node(start, {
            kind: (0, $hu3w4.Kind).INTERFACE_TYPE_DEFINITION,
            description: description,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields
        });
    }
    /**
   * UnionTypeDefinition :
   *   - Description? union Name Directives[Const]? UnionMemberTypes?
   */ parseUnionTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword("union");
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const types = this.parseUnionMemberTypes();
        return this.node(start, {
            kind: (0, $hu3w4.Kind).UNION_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            types: types
        });
    }
    /**
   * UnionMemberTypes :
   *   - = `|`? NamedType
   *   - UnionMemberTypes | NamedType
   */ parseUnionMemberTypes() {
        return this.expectOptionalToken((0, $bQgNI.TokenKind).EQUALS) ? this.delimitedMany((0, $bQgNI.TokenKind).PIPE, this.parseNamedType) : [];
    }
    /**
   * EnumTypeDefinition :
   *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
   */ parseEnumTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword("enum");
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const values = this.parseEnumValuesDefinition();
        return this.node(start, {
            kind: (0, $hu3w4.Kind).ENUM_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            values: values
        });
    }
    /**
   * ```
   * EnumValuesDefinition : { EnumValueDefinition+ }
   * ```
   */ parseEnumValuesDefinition() {
        return this.optionalMany((0, $bQgNI.TokenKind).BRACE_L, this.parseEnumValueDefinition, (0, $bQgNI.TokenKind).BRACE_R);
    }
    /**
   * EnumValueDefinition : Description? EnumValue Directives[Const]?
   */ parseEnumValueDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        const name = this.parseEnumValueName();
        const directives = this.parseConstDirectives();
        return this.node(start, {
            kind: (0, $hu3w4.Kind).ENUM_VALUE_DEFINITION,
            description: description,
            name: name,
            directives: directives
        });
    }
    /**
   * EnumValue : Name but not `true`, `false` or `null`
   */ parseEnumValueName() {
        if (this._lexer.token.value === "true" || this._lexer.token.value === "false" || this._lexer.token.value === "null") throw (0, $egTVJ.syntaxError)(this._lexer.source, this._lexer.token.start, `${$0013c7ab45cf197d$var$getTokenDesc(this._lexer.token)} is reserved and cannot be used for an enum value.`);
        return this.parseName();
    }
    /**
   * InputObjectTypeDefinition :
   *   - Description? input Name Directives[Const]? InputFieldsDefinition?
   */ parseInputObjectTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword("input");
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const fields = this.parseInputFieldsDefinition();
        return this.node(start, {
            kind: (0, $hu3w4.Kind).INPUT_OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            fields: fields
        });
    }
    /**
   * ```
   * InputFieldsDefinition : { InputValueDefinition+ }
   * ```
   */ parseInputFieldsDefinition() {
        return this.optionalMany((0, $bQgNI.TokenKind).BRACE_L, this.parseInputValueDef, (0, $bQgNI.TokenKind).BRACE_R);
    }
    /**
   * TypeSystemExtension :
   *   - SchemaExtension
   *   - TypeExtension
   *
   * TypeExtension :
   *   - ScalarTypeExtension
   *   - ObjectTypeExtension
   *   - InterfaceTypeExtension
   *   - UnionTypeExtension
   *   - EnumTypeExtension
   *   - InputObjectTypeDefinition
   */ parseTypeSystemExtension() {
        const keywordToken = this._lexer.lookahead();
        if (keywordToken.kind === (0, $bQgNI.TokenKind).NAME) switch(keywordToken.value){
            case "schema":
                return this.parseSchemaExtension();
            case "scalar":
                return this.parseScalarTypeExtension();
            case "type":
                return this.parseObjectTypeExtension();
            case "interface":
                return this.parseInterfaceTypeExtension();
            case "union":
                return this.parseUnionTypeExtension();
            case "enum":
                return this.parseEnumTypeExtension();
            case "input":
                return this.parseInputObjectTypeExtension();
        }
        throw this.unexpected(keywordToken);
    }
    /**
   * ```
   * SchemaExtension :
   *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
   *  - extend schema Directives[Const]
   * ```
   */ parseSchemaExtension() {
        const start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("schema");
        const directives = this.parseConstDirectives();
        const operationTypes = this.optionalMany((0, $bQgNI.TokenKind).BRACE_L, this.parseOperationTypeDefinition, (0, $bQgNI.TokenKind).BRACE_R);
        if (directives.length === 0 && operationTypes.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $hu3w4.Kind).SCHEMA_EXTENSION,
            directives: directives,
            operationTypes: operationTypes
        });
    }
    /**
   * ScalarTypeExtension :
   *   - extend scalar Name Directives[Const]
   */ parseScalarTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("scalar");
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        if (directives.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $hu3w4.Kind).SCALAR_TYPE_EXTENSION,
            name: name,
            directives: directives
        });
    }
    /**
   * ObjectTypeExtension :
   *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend type Name ImplementsInterfaces? Directives[Const]
   *  - extend type Name ImplementsInterfaces
   */ parseObjectTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("type");
        const name = this.parseName();
        const interfaces = this.parseImplementsInterfaces();
        const directives = this.parseConstDirectives();
        const fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $hu3w4.Kind).OBJECT_TYPE_EXTENSION,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields
        });
    }
    /**
   * InterfaceTypeExtension :
   *  - extend interface Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend interface Name ImplementsInterfaces? Directives[Const]
   *  - extend interface Name ImplementsInterfaces
   */ parseInterfaceTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("interface");
        const name = this.parseName();
        const interfaces = this.parseImplementsInterfaces();
        const directives = this.parseConstDirectives();
        const fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $hu3w4.Kind).INTERFACE_TYPE_EXTENSION,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields
        });
    }
    /**
   * UnionTypeExtension :
   *   - extend union Name Directives[Const]? UnionMemberTypes
   *   - extend union Name Directives[Const]
   */ parseUnionTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("union");
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const types = this.parseUnionMemberTypes();
        if (directives.length === 0 && types.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $hu3w4.Kind).UNION_TYPE_EXTENSION,
            name: name,
            directives: directives,
            types: types
        });
    }
    /**
   * EnumTypeExtension :
   *   - extend enum Name Directives[Const]? EnumValuesDefinition
   *   - extend enum Name Directives[Const]
   */ parseEnumTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("enum");
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const values = this.parseEnumValuesDefinition();
        if (directives.length === 0 && values.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $hu3w4.Kind).ENUM_TYPE_EXTENSION,
            name: name,
            directives: directives,
            values: values
        });
    }
    /**
   * InputObjectTypeExtension :
   *   - extend input Name Directives[Const]? InputFieldsDefinition
   *   - extend input Name Directives[Const]
   */ parseInputObjectTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("input");
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const fields = this.parseInputFieldsDefinition();
        if (directives.length === 0 && fields.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $hu3w4.Kind).INPUT_OBJECT_TYPE_EXTENSION,
            name: name,
            directives: directives,
            fields: fields
        });
    }
    /**
   * ```
   * DirectiveDefinition :
   *   - Description? directive @ Name ArgumentsDefinition? `repeatable`? on DirectiveLocations
   * ```
   */ parseDirectiveDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword("directive");
        this.expectToken((0, $bQgNI.TokenKind).AT);
        const name = this.parseName();
        const args = this.parseArgumentDefs();
        const repeatable = this.expectOptionalKeyword("repeatable");
        this.expectKeyword("on");
        const locations = this.parseDirectiveLocations();
        return this.node(start, {
            kind: (0, $hu3w4.Kind).DIRECTIVE_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            repeatable: repeatable,
            locations: locations
        });
    }
    /**
   * DirectiveLocations :
   *   - `|`? DirectiveLocation
   *   - DirectiveLocations | DirectiveLocation
   */ parseDirectiveLocations() {
        return this.delimitedMany((0, $bQgNI.TokenKind).PIPE, this.parseDirectiveLocation);
    }
    /*
   * DirectiveLocation :
   *   - ExecutableDirectiveLocation
   *   - TypeSystemDirectiveLocation
   *
   * ExecutableDirectiveLocation : one of
   *   `QUERY`
   *   `MUTATION`
   *   `SUBSCRIPTION`
   *   `FIELD`
   *   `FRAGMENT_DEFINITION`
   *   `FRAGMENT_SPREAD`
   *   `INLINE_FRAGMENT`
   *
   * TypeSystemDirectiveLocation : one of
   *   `SCHEMA`
   *   `SCALAR`
   *   `OBJECT`
   *   `FIELD_DEFINITION`
   *   `ARGUMENT_DEFINITION`
   *   `INTERFACE`
   *   `UNION`
   *   `ENUM`
   *   `ENUM_VALUE`
   *   `INPUT_OBJECT`
   *   `INPUT_FIELD_DEFINITION`
   */ parseDirectiveLocation() {
        const start = this._lexer.token;
        const name = this.parseName();
        if (Object.prototype.hasOwnProperty.call((0, $5zW8K.DirectiveLocation), name.value)) return name;
        throw this.unexpected(start);
    }
    /**
   * Returns a node that, if configured to do so, sets a "loc" field as a
   * location object, used to identify the place in the source that created a
   * given parsed object.
   */ node(startToken, node) {
        if (this._options.noLocation !== true) node.loc = new (0, $8r1qs.Location)(startToken, this._lexer.lastToken, this._lexer.source);
        return node;
    }
    /**
   * Determines if the next token is of a given kind
   */ peek(kind) {
        return this._lexer.token.kind === kind;
    }
    /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */ expectToken(kind) {
        const token = this._lexer.token;
        if (token.kind === kind) {
            this.advanceLexer();
            return token;
        }
        throw (0, $egTVJ.syntaxError)(this._lexer.source, token.start, `Expected ${$0013c7ab45cf197d$var$getTokenKindDesc(kind)}, found ${$0013c7ab45cf197d$var$getTokenDesc(token)}.`);
    }
    /**
   * If the next token is of the given kind, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */ expectOptionalToken(kind) {
        const token = this._lexer.token;
        if (token.kind === kind) {
            this.advanceLexer();
            return true;
        }
        return false;
    }
    /**
   * If the next token is a given keyword, advance the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */ expectKeyword(value) {
        const token = this._lexer.token;
        if (token.kind === (0, $bQgNI.TokenKind).NAME && token.value === value) this.advanceLexer();
        else throw (0, $egTVJ.syntaxError)(this._lexer.source, token.start, `Expected "${value}", found ${$0013c7ab45cf197d$var$getTokenDesc(token)}.`);
    }
    /**
   * If the next token is a given keyword, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */ expectOptionalKeyword(value) {
        const token = this._lexer.token;
        if (token.kind === (0, $bQgNI.TokenKind).NAME && token.value === value) {
            this.advanceLexer();
            return true;
        }
        return false;
    }
    /**
   * Helper function for creating an error when an unexpected lexed token is encountered.
   */ unexpected(atToken) {
        const token = atToken !== null && atToken !== void 0 ? atToken : this._lexer.token;
        return (0, $egTVJ.syntaxError)(this._lexer.source, token.start, `Unexpected ${$0013c7ab45cf197d$var$getTokenDesc(token)}.`);
    }
    /**
   * Returns a possibly empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ any(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        const nodes = [];
        while(!this.expectOptionalToken(closeKind))nodes.push(parseFn.call(this));
        return nodes;
    }
    /**
   * Returns a list of parse nodes, determined by the parseFn.
   * It can be empty only if open token is missing otherwise it will always return non-empty list
   * that begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ optionalMany(openKind, parseFn, closeKind) {
        if (this.expectOptionalToken(openKind)) {
            const nodes = [];
            do nodes.push(parseFn.call(this));
            while (!this.expectOptionalToken(closeKind));
            return nodes;
        }
        return [];
    }
    /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ many(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        const nodes = [];
        do nodes.push(parseFn.call(this));
        while (!this.expectOptionalToken(closeKind));
        return nodes;
    }
    /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list may begin with a lex token of delimiterKind followed by items separated by lex tokens of tokenKind.
   * Advances the parser to the next lex token after last item in the list.
   */ delimitedMany(delimiterKind, parseFn) {
        this.expectOptionalToken(delimiterKind);
        const nodes = [];
        do nodes.push(parseFn.call(this));
        while (this.expectOptionalToken(delimiterKind));
        return nodes;
    }
    advanceLexer() {
        const { maxTokens: maxTokens } = this._options;
        const token = this._lexer.advance();
        if (maxTokens !== undefined && token.kind !== (0, $bQgNI.TokenKind).EOF) {
            ++this._tokenCounter;
            if (this._tokenCounter > maxTokens) throw (0, $egTVJ.syntaxError)(this._lexer.source, token.start, `Document contains more that ${maxTokens} tokens. Parsing aborted.`);
        }
    }
}
/**
 * A helper function to describe a token as a string for debugging.
 */ function $0013c7ab45cf197d$var$getTokenDesc(token) {
    const value = token.value;
    return $0013c7ab45cf197d$var$getTokenKindDesc(token.kind) + (value != null ? ` "${value}"` : "");
}
/**
 * A helper function to describe a token kind as a string for debugging.
 */ function $0013c7ab45cf197d$var$getTokenKindDesc(kind) {
    return (0, $dtMcr.isPunctuatorTokenKind)(kind) ? `"${kind}"` : kind;
}

});
parcelRegister("egTVJ", function(module, exports) {

$parcel$export(module.exports, "syntaxError", () => $ddf6b9f696b0d6b2$export$bbee0c6176c019d4);

var $fHcz3 = parcelRequire("fHcz3");
function $ddf6b9f696b0d6b2$export$bbee0c6176c019d4(source, position, description) {
    return new (0, $fHcz3.GraphQLError)(`Syntax Error: ${description}`, {
        source: source,
        positions: [
            position
        ]
    });
}

});

parcelRegister("5zW8K", function(module, exports) {

$parcel$export(module.exports, "DirectiveLocation", () => $289bf729a82494c6$export$b45ffd2948484c41);
/**
 * The set of allowed directive location values.
 */ var $289bf729a82494c6$export$b45ffd2948484c41;
(function(DirectiveLocation) {
    DirectiveLocation["QUERY"] = "QUERY";
    DirectiveLocation["MUTATION"] = "MUTATION";
    DirectiveLocation["SUBSCRIPTION"] = "SUBSCRIPTION";
    DirectiveLocation["FIELD"] = "FIELD";
    DirectiveLocation["FRAGMENT_DEFINITION"] = "FRAGMENT_DEFINITION";
    DirectiveLocation["FRAGMENT_SPREAD"] = "FRAGMENT_SPREAD";
    DirectiveLocation["INLINE_FRAGMENT"] = "INLINE_FRAGMENT";
    DirectiveLocation["VARIABLE_DEFINITION"] = "VARIABLE_DEFINITION";
    DirectiveLocation["SCHEMA"] = "SCHEMA";
    DirectiveLocation["SCALAR"] = "SCALAR";
    DirectiveLocation["OBJECT"] = "OBJECT";
    DirectiveLocation["FIELD_DEFINITION"] = "FIELD_DEFINITION";
    DirectiveLocation["ARGUMENT_DEFINITION"] = "ARGUMENT_DEFINITION";
    DirectiveLocation["INTERFACE"] = "INTERFACE";
    DirectiveLocation["UNION"] = "UNION";
    DirectiveLocation["ENUM"] = "ENUM";
    DirectiveLocation["ENUM_VALUE"] = "ENUM_VALUE";
    DirectiveLocation["INPUT_OBJECT"] = "INPUT_OBJECT";
    DirectiveLocation["INPUT_FIELD_DEFINITION"] = "INPUT_FIELD_DEFINITION";
})($289bf729a82494c6$export$b45ffd2948484c41 || ($289bf729a82494c6$export$b45ffd2948484c41 = {}));
 /**
 * The enum type representing the directive location values.
 *
 * @deprecated Please use `DirectiveLocation`. Will be remove in v17.
 */ 
});

parcelRegister("dtMcr", function(module, exports) {

$parcel$export(module.exports, "Lexer", () => $971bc50063303b32$export$6168dc8908a6c652);
$parcel$export(module.exports, "isPunctuatorTokenKind", () => $971bc50063303b32$export$59ac0f4da287406a);

var $egTVJ = parcelRequire("egTVJ");

var $8r1qs = parcelRequire("8r1qs");

var $7tbLu = parcelRequire("7tbLu");

var $gmlY8 = parcelRequire("gmlY8");

var $bQgNI = parcelRequire("bQgNI");
class $971bc50063303b32$export$6168dc8908a6c652 {
    /**
   * The previously focused non-ignored token.
   */ /**
   * The currently focused non-ignored token.
   */ /**
   * The (1-indexed) line containing the current token.
   */ /**
   * The character offset at which the current line begins.
   */ constructor(source){
        const startOfFileToken = new (0, $8r1qs.Token)((0, $bQgNI.TokenKind).SOF, 0, 0, 0, 0);
        this.source = source;
        this.lastToken = startOfFileToken;
        this.token = startOfFileToken;
        this.line = 1;
        this.lineStart = 0;
    }
    get [Symbol.toStringTag]() {
        return "Lexer";
    }
    /**
   * Advances the token stream to the next non-ignored token.
   */ advance() {
        this.lastToken = this.token;
        const token = this.token = this.lookahead();
        return token;
    }
    /**
   * Looks ahead and returns the next non-ignored token, but does not change
   * the state of Lexer.
   */ lookahead() {
        let token = this.token;
        if (token.kind !== (0, $bQgNI.TokenKind).EOF) {
            do if (token.next) token = token.next;
            else {
                // Read the next token and form a link in the token linked-list.
                const nextToken = $971bc50063303b32$var$readNextToken(this, token.end); // @ts-expect-error next is only mutable during parsing.
                token.next = nextToken; // @ts-expect-error prev is only mutable during parsing.
                nextToken.prev = token;
                token = nextToken;
            }
            while (token.kind === (0, $bQgNI.TokenKind).COMMENT);
        }
        return token;
    }
}
function $971bc50063303b32$export$59ac0f4da287406a(kind) {
    return kind === (0, $bQgNI.TokenKind).BANG || kind === (0, $bQgNI.TokenKind).DOLLAR || kind === (0, $bQgNI.TokenKind).AMP || kind === (0, $bQgNI.TokenKind).PAREN_L || kind === (0, $bQgNI.TokenKind).PAREN_R || kind === (0, $bQgNI.TokenKind).SPREAD || kind === (0, $bQgNI.TokenKind).COLON || kind === (0, $bQgNI.TokenKind).EQUALS || kind === (0, $bQgNI.TokenKind).AT || kind === (0, $bQgNI.TokenKind).BRACKET_L || kind === (0, $bQgNI.TokenKind).BRACKET_R || kind === (0, $bQgNI.TokenKind).BRACE_L || kind === (0, $bQgNI.TokenKind).PIPE || kind === (0, $bQgNI.TokenKind).BRACE_R;
}
/**
 * A Unicode scalar value is any Unicode code point except surrogate code
 * points. In other words, the inclusive ranges of values 0x0000 to 0xD7FF and
 * 0xE000 to 0x10FFFF.
 *
 * SourceCharacter ::
 *   - "Any Unicode scalar value"
 */ function $971bc50063303b32$var$isUnicodeScalarValue(code) {
    return code >= 0x0000 && code <= 0xd7ff || code >= 0xe000 && code <= 0x10ffff;
}
/**
 * The GraphQL specification defines source text as a sequence of unicode scalar
 * values (which Unicode defines to exclude surrogate code points). However
 * JavaScript defines strings as a sequence of UTF-16 code units which may
 * include surrogates. A surrogate pair is a valid source character as it
 * encodes a supplementary code point (above U+FFFF), but unpaired surrogate
 * code points are not valid source characters.
 */ function $971bc50063303b32$var$isSupplementaryCodePoint(body, location) {
    return $971bc50063303b32$var$isLeadingSurrogate(body.charCodeAt(location)) && $971bc50063303b32$var$isTrailingSurrogate(body.charCodeAt(location + 1));
}
function $971bc50063303b32$var$isLeadingSurrogate(code) {
    return code >= 0xd800 && code <= 0xdbff;
}
function $971bc50063303b32$var$isTrailingSurrogate(code) {
    return code >= 0xdc00 && code <= 0xdfff;
}
/**
 * Prints the code point (or end of file reference) at a given location in a
 * source for use in error messages.
 *
 * Printable ASCII is printed quoted, while other points are printed in Unicode
 * code point form (ie. U+1234).
 */ function $971bc50063303b32$var$printCodePointAt(lexer, location) {
    const code = lexer.source.body.codePointAt(location);
    if (code === undefined) return (0, $bQgNI.TokenKind).EOF;
    else if (code >= 0x0020 && code <= 0x007e) {
        // Printable ASCII
        const char = String.fromCodePoint(code);
        return char === '"' ? "'\"'" : `"${char}"`;
    } // Unicode code point
    return "U+" + code.toString(16).toUpperCase().padStart(4, "0");
}
/**
 * Create a token with line and column location information.
 */ function $971bc50063303b32$var$createToken(lexer, kind, start, end, value) {
    const line = lexer.line;
    const col = 1 + start - lexer.lineStart;
    return new (0, $8r1qs.Token)(kind, start, end, line, col, value);
}
/**
 * Gets the next token from the source starting at the given position.
 *
 * This skips over whitespace until it finds the next lexable token, then lexes
 * punctuators immediately or calls the appropriate helper function for more
 * complicated tokens.
 */ function $971bc50063303b32$var$readNextToken(lexer, start) {
    const body = lexer.source.body;
    const bodyLength = body.length;
    let position = start;
    while(position < bodyLength){
        const code = body.charCodeAt(position); // SourceCharacter
        switch(code){
            // Ignored ::
            //   - UnicodeBOM
            //   - WhiteSpace
            //   - LineTerminator
            //   - Comment
            //   - Comma
            //
            // UnicodeBOM :: "Byte Order Mark (U+FEFF)"
            //
            // WhiteSpace ::
            //   - "Horizontal Tab (U+0009)"
            //   - "Space (U+0020)"
            //
            // Comma :: ,
            case 0xfeff:
            case 0x0009:
            case 0x0020:
            case 0x002c:
                // ,
                ++position;
                continue;
            // LineTerminator ::
            //   - "New Line (U+000A)"
            //   - "Carriage Return (U+000D)" [lookahead != "New Line (U+000A)"]
            //   - "Carriage Return (U+000D)" "New Line (U+000A)"
            case 0x000a:
                // \n
                ++position;
                ++lexer.line;
                lexer.lineStart = position;
                continue;
            case 0x000d:
                // \r
                if (body.charCodeAt(position + 1) === 0x000a) position += 2;
                else ++position;
                ++lexer.line;
                lexer.lineStart = position;
                continue;
            // Comment
            case 0x0023:
                // #
                return $971bc50063303b32$var$readComment(lexer, position);
            // Token ::
            //   - Punctuator
            //   - Name
            //   - IntValue
            //   - FloatValue
            //   - StringValue
            //
            // Punctuator :: one of ! $ & ( ) ... : = @ [ ] { | }
            case 0x0021:
                // !
                return $971bc50063303b32$var$createToken(lexer, (0, $bQgNI.TokenKind).BANG, position, position + 1);
            case 0x0024:
                // $
                return $971bc50063303b32$var$createToken(lexer, (0, $bQgNI.TokenKind).DOLLAR, position, position + 1);
            case 0x0026:
                // &
                return $971bc50063303b32$var$createToken(lexer, (0, $bQgNI.TokenKind).AMP, position, position + 1);
            case 0x0028:
                // (
                return $971bc50063303b32$var$createToken(lexer, (0, $bQgNI.TokenKind).PAREN_L, position, position + 1);
            case 0x0029:
                // )
                return $971bc50063303b32$var$createToken(lexer, (0, $bQgNI.TokenKind).PAREN_R, position, position + 1);
            case 0x002e:
                // .
                if (body.charCodeAt(position + 1) === 0x002e && body.charCodeAt(position + 2) === 0x002e) return $971bc50063303b32$var$createToken(lexer, (0, $bQgNI.TokenKind).SPREAD, position, position + 3);
                break;
            case 0x003a:
                // :
                return $971bc50063303b32$var$createToken(lexer, (0, $bQgNI.TokenKind).COLON, position, position + 1);
            case 0x003d:
                // =
                return $971bc50063303b32$var$createToken(lexer, (0, $bQgNI.TokenKind).EQUALS, position, position + 1);
            case 0x0040:
                // @
                return $971bc50063303b32$var$createToken(lexer, (0, $bQgNI.TokenKind).AT, position, position + 1);
            case 0x005b:
                // [
                return $971bc50063303b32$var$createToken(lexer, (0, $bQgNI.TokenKind).BRACKET_L, position, position + 1);
            case 0x005d:
                // ]
                return $971bc50063303b32$var$createToken(lexer, (0, $bQgNI.TokenKind).BRACKET_R, position, position + 1);
            case 0x007b:
                // {
                return $971bc50063303b32$var$createToken(lexer, (0, $bQgNI.TokenKind).BRACE_L, position, position + 1);
            case 0x007c:
                // |
                return $971bc50063303b32$var$createToken(lexer, (0, $bQgNI.TokenKind).PIPE, position, position + 1);
            case 0x007d:
                // }
                return $971bc50063303b32$var$createToken(lexer, (0, $bQgNI.TokenKind).BRACE_R, position, position + 1);
            // StringValue
            case 0x0022:
                // "
                if (body.charCodeAt(position + 1) === 0x0022 && body.charCodeAt(position + 2) === 0x0022) return $971bc50063303b32$var$readBlockString(lexer, position);
                return $971bc50063303b32$var$readString(lexer, position);
        } // IntValue | FloatValue (Digit | -)
        if ((0, $gmlY8.isDigit)(code) || code === 0x002d) return $971bc50063303b32$var$readNumber(lexer, position, code);
         // Name
        if ((0, $gmlY8.isNameStart)(code)) return $971bc50063303b32$var$readName(lexer, position);
        throw (0, $egTVJ.syntaxError)(lexer.source, position, code === 0x0027 ? "Unexpected single quote character ('), did you mean to use a double quote (\")?" : $971bc50063303b32$var$isUnicodeScalarValue(code) || $971bc50063303b32$var$isSupplementaryCodePoint(body, position) ? `Unexpected character: ${$971bc50063303b32$var$printCodePointAt(lexer, position)}.` : `Invalid character: ${$971bc50063303b32$var$printCodePointAt(lexer, position)}.`);
    }
    return $971bc50063303b32$var$createToken(lexer, (0, $bQgNI.TokenKind).EOF, bodyLength, bodyLength);
}
/**
 * Reads a comment token from the source file.
 *
 * ```
 * Comment :: # CommentChar* [lookahead != CommentChar]
 *
 * CommentChar :: SourceCharacter but not LineTerminator
 * ```
 */ function $971bc50063303b32$var$readComment(lexer, start) {
    const body = lexer.source.body;
    const bodyLength = body.length;
    let position = start + 1;
    while(position < bodyLength){
        const code = body.charCodeAt(position); // LineTerminator (\n | \r)
        if (code === 0x000a || code === 0x000d) break;
         // SourceCharacter
        if ($971bc50063303b32$var$isUnicodeScalarValue(code)) ++position;
        else if ($971bc50063303b32$var$isSupplementaryCodePoint(body, position)) position += 2;
        else break;
    }
    return $971bc50063303b32$var$createToken(lexer, (0, $bQgNI.TokenKind).COMMENT, start, position, body.slice(start + 1, position));
}
/**
 * Reads a number token from the source file, either a FloatValue or an IntValue
 * depending on whether a FractionalPart or ExponentPart is encountered.
 *
 * ```
 * IntValue :: IntegerPart [lookahead != {Digit, `.`, NameStart}]
 *
 * IntegerPart ::
 *   - NegativeSign? 0
 *   - NegativeSign? NonZeroDigit Digit*
 *
 * NegativeSign :: -
 *
 * NonZeroDigit :: Digit but not `0`
 *
 * FloatValue ::
 *   - IntegerPart FractionalPart ExponentPart [lookahead != {Digit, `.`, NameStart}]
 *   - IntegerPart FractionalPart [lookahead != {Digit, `.`, NameStart}]
 *   - IntegerPart ExponentPart [lookahead != {Digit, `.`, NameStart}]
 *
 * FractionalPart :: . Digit+
 *
 * ExponentPart :: ExponentIndicator Sign? Digit+
 *
 * ExponentIndicator :: one of `e` `E`
 *
 * Sign :: one of + -
 * ```
 */ function $971bc50063303b32$var$readNumber(lexer, start, firstCode) {
    const body = lexer.source.body;
    let position = start;
    let code = firstCode;
    let isFloat = false; // NegativeSign (-)
    if (code === 0x002d) code = body.charCodeAt(++position);
     // Zero (0)
    if (code === 0x0030) {
        code = body.charCodeAt(++position);
        if ((0, $gmlY8.isDigit)(code)) throw (0, $egTVJ.syntaxError)(lexer.source, position, `Invalid number, unexpected digit after 0: ${$971bc50063303b32$var$printCodePointAt(lexer, position)}.`);
    } else {
        position = $971bc50063303b32$var$readDigits(lexer, position, code);
        code = body.charCodeAt(position);
    } // Full stop (.)
    if (code === 0x002e) {
        isFloat = true;
        code = body.charCodeAt(++position);
        position = $971bc50063303b32$var$readDigits(lexer, position, code);
        code = body.charCodeAt(position);
    } // E e
    if (code === 0x0045 || code === 0x0065) {
        isFloat = true;
        code = body.charCodeAt(++position); // + -
        if (code === 0x002b || code === 0x002d) code = body.charCodeAt(++position);
        position = $971bc50063303b32$var$readDigits(lexer, position, code);
        code = body.charCodeAt(position);
    } // Numbers cannot be followed by . or NameStart
    if (code === 0x002e || (0, $gmlY8.isNameStart)(code)) throw (0, $egTVJ.syntaxError)(lexer.source, position, `Invalid number, expected digit but got: ${$971bc50063303b32$var$printCodePointAt(lexer, position)}.`);
    return $971bc50063303b32$var$createToken(lexer, isFloat ? (0, $bQgNI.TokenKind).FLOAT : (0, $bQgNI.TokenKind).INT, start, position, body.slice(start, position));
}
/**
 * Returns the new position in the source after reading one or more digits.
 */ function $971bc50063303b32$var$readDigits(lexer, start, firstCode) {
    if (!(0, $gmlY8.isDigit)(firstCode)) throw (0, $egTVJ.syntaxError)(lexer.source, start, `Invalid number, expected digit but got: ${$971bc50063303b32$var$printCodePointAt(lexer, start)}.`);
    const body = lexer.source.body;
    let position = start + 1; // +1 to skip first firstCode
    while((0, $gmlY8.isDigit)(body.charCodeAt(position)))++position;
    return position;
}
/**
 * Reads a single-quote string token from the source file.
 *
 * ```
 * StringValue ::
 *   - `""` [lookahead != `"`]
 *   - `"` StringCharacter+ `"`
 *
 * StringCharacter ::
 *   - SourceCharacter but not `"` or `\` or LineTerminator
 *   - `\u` EscapedUnicode
 *   - `\` EscapedCharacter
 *
 * EscapedUnicode ::
 *   - `{` HexDigit+ `}`
 *   - HexDigit HexDigit HexDigit HexDigit
 *
 * EscapedCharacter :: one of `"` `\` `/` `b` `f` `n` `r` `t`
 * ```
 */ function $971bc50063303b32$var$readString(lexer, start) {
    const body = lexer.source.body;
    const bodyLength = body.length;
    let position = start + 1;
    let chunkStart = position;
    let value = "";
    while(position < bodyLength){
        const code = body.charCodeAt(position); // Closing Quote (")
        if (code === 0x0022) {
            value += body.slice(chunkStart, position);
            return $971bc50063303b32$var$createToken(lexer, (0, $bQgNI.TokenKind).STRING, start, position + 1, value);
        } // Escape Sequence (\)
        if (code === 0x005c) {
            value += body.slice(chunkStart, position);
            const escape = body.charCodeAt(position + 1) === 0x0075 // u
             ? body.charCodeAt(position + 2) === 0x007b // {
             ? $971bc50063303b32$var$readEscapedUnicodeVariableWidth(lexer, position) : $971bc50063303b32$var$readEscapedUnicodeFixedWidth(lexer, position) : $971bc50063303b32$var$readEscapedCharacter(lexer, position);
            value += escape.value;
            position += escape.size;
            chunkStart = position;
            continue;
        } // LineTerminator (\n | \r)
        if (code === 0x000a || code === 0x000d) break;
         // SourceCharacter
        if ($971bc50063303b32$var$isUnicodeScalarValue(code)) ++position;
        else if ($971bc50063303b32$var$isSupplementaryCodePoint(body, position)) position += 2;
        else throw (0, $egTVJ.syntaxError)(lexer.source, position, `Invalid character within String: ${$971bc50063303b32$var$printCodePointAt(lexer, position)}.`);
    }
    throw (0, $egTVJ.syntaxError)(lexer.source, position, "Unterminated string.");
} // The string value and lexed size of an escape sequence.
function $971bc50063303b32$var$readEscapedUnicodeVariableWidth(lexer, position) {
    const body = lexer.source.body;
    let point = 0;
    let size = 3; // Cannot be larger than 12 chars (\u{00000000}).
    while(size < 12){
        const code = body.charCodeAt(position + size++); // Closing Brace (})
        if (code === 0x007d) {
            // Must be at least 5 chars (\u{0}) and encode a Unicode scalar value.
            if (size < 5 || !$971bc50063303b32$var$isUnicodeScalarValue(point)) break;
            return {
                value: String.fromCodePoint(point),
                size: size
            };
        } // Append this hex digit to the code point.
        point = point << 4 | $971bc50063303b32$var$readHexDigit(code);
        if (point < 0) break;
    }
    throw (0, $egTVJ.syntaxError)(lexer.source, position, `Invalid Unicode escape sequence: "${body.slice(position, position + size)}".`);
}
function $971bc50063303b32$var$readEscapedUnicodeFixedWidth(lexer, position) {
    const body = lexer.source.body;
    const code = $971bc50063303b32$var$read16BitHexCode(body, position + 2);
    if ($971bc50063303b32$var$isUnicodeScalarValue(code)) return {
        value: String.fromCodePoint(code),
        size: 6
    };
     // GraphQL allows JSON-style surrogate pair escape sequences, but only when
    // a valid pair is formed.
    if ($971bc50063303b32$var$isLeadingSurrogate(code)) // \u
    {
        if (body.charCodeAt(position + 6) === 0x005c && body.charCodeAt(position + 7) === 0x0075) {
            const trailingCode = $971bc50063303b32$var$read16BitHexCode(body, position + 8);
            if ($971bc50063303b32$var$isTrailingSurrogate(trailingCode)) // JavaScript defines strings as a sequence of UTF-16 code units and
            // encodes Unicode code points above U+FFFF using a surrogate pair of
            // code units. Since this is a surrogate pair escape sequence, just
            // include both codes into the JavaScript string value. Had JavaScript
            // not been internally based on UTF-16, then this surrogate pair would
            // be decoded to retrieve the supplementary code point.
            return {
                value: String.fromCodePoint(code, trailingCode),
                size: 12
            };
        }
    }
    throw (0, $egTVJ.syntaxError)(lexer.source, position, `Invalid Unicode escape sequence: "${body.slice(position, position + 6)}".`);
}
/**
 * Reads four hexadecimal characters and returns the positive integer that 16bit
 * hexadecimal string represents. For example, "000f" will return 15, and "dead"
 * will return 57005.
 *
 * Returns a negative number if any char was not a valid hexadecimal digit.
 */ function $971bc50063303b32$var$read16BitHexCode(body, position) {
    // readHexDigit() returns -1 on error. ORing a negative value with any other
    // value always produces a negative value.
    return $971bc50063303b32$var$readHexDigit(body.charCodeAt(position)) << 12 | $971bc50063303b32$var$readHexDigit(body.charCodeAt(position + 1)) << 8 | $971bc50063303b32$var$readHexDigit(body.charCodeAt(position + 2)) << 4 | $971bc50063303b32$var$readHexDigit(body.charCodeAt(position + 3));
}
/**
 * Reads a hexadecimal character and returns its positive integer value (0-15).
 *
 * '0' becomes 0, '9' becomes 9
 * 'A' becomes 10, 'F' becomes 15
 * 'a' becomes 10, 'f' becomes 15
 *
 * Returns -1 if the provided character code was not a valid hexadecimal digit.
 *
 * HexDigit :: one of
 *   - `0` `1` `2` `3` `4` `5` `6` `7` `8` `9`
 *   - `A` `B` `C` `D` `E` `F`
 *   - `a` `b` `c` `d` `e` `f`
 */ function $971bc50063303b32$var$readHexDigit(code) {
    return code >= 0x0030 && code <= 0x0039 // 0-9
     ? code - 0x0030 : code >= 0x0041 && code <= 0x0046 // A-F
     ? code - 0x0037 : code >= 0x0061 && code <= 0x0066 // a-f
     ? code - 0x0057 : -1;
}
/**
 * | Escaped Character | Code Point | Character Name               |
 * | ----------------- | ---------- | ---------------------------- |
 * | `"`               | U+0022     | double quote                 |
 * | `\`               | U+005C     | reverse solidus (back slash) |
 * | `/`               | U+002F     | solidus (forward slash)      |
 * | `b`               | U+0008     | backspace                    |
 * | `f`               | U+000C     | form feed                    |
 * | `n`               | U+000A     | line feed (new line)         |
 * | `r`               | U+000D     | carriage return              |
 * | `t`               | U+0009     | horizontal tab               |
 */ function $971bc50063303b32$var$readEscapedCharacter(lexer, position) {
    const body = lexer.source.body;
    const code = body.charCodeAt(position + 1);
    switch(code){
        case 0x0022:
            // "
            return {
                value: '"',
                size: 2
            };
        case 0x005c:
            // \
            return {
                value: "\\",
                size: 2
            };
        case 0x002f:
            // /
            return {
                value: "/",
                size: 2
            };
        case 0x0062:
            // b
            return {
                value: "\b",
                size: 2
            };
        case 0x0066:
            // f
            return {
                value: "\f",
                size: 2
            };
        case 0x006e:
            // n
            return {
                value: "\n",
                size: 2
            };
        case 0x0072:
            // r
            return {
                value: "\r",
                size: 2
            };
        case 0x0074:
            // t
            return {
                value: "	",
                size: 2
            };
    }
    throw (0, $egTVJ.syntaxError)(lexer.source, position, `Invalid character escape sequence: "${body.slice(position, position + 2)}".`);
}
/**
 * Reads a block string token from the source file.
 *
 * ```
 * StringValue ::
 *   - `"""` BlockStringCharacter* `"""`
 *
 * BlockStringCharacter ::
 *   - SourceCharacter but not `"""` or `\"""`
 *   - `\"""`
 * ```
 */ function $971bc50063303b32$var$readBlockString(lexer, start) {
    const body = lexer.source.body;
    const bodyLength = body.length;
    let lineStart = lexer.lineStart;
    let position = start + 3;
    let chunkStart = position;
    let currentLine = "";
    const blockLines = [];
    while(position < bodyLength){
        const code = body.charCodeAt(position); // Closing Triple-Quote (""")
        if (code === 0x0022 && body.charCodeAt(position + 1) === 0x0022 && body.charCodeAt(position + 2) === 0x0022) {
            currentLine += body.slice(chunkStart, position);
            blockLines.push(currentLine);
            const token = $971bc50063303b32$var$createToken(lexer, (0, $bQgNI.TokenKind).BLOCK_STRING, start, position + 3, (0, $7tbLu.dedentBlockStringLines)(blockLines).join("\n"));
            lexer.line += blockLines.length - 1;
            lexer.lineStart = lineStart;
            return token;
        } // Escaped Triple-Quote (\""")
        if (code === 0x005c && body.charCodeAt(position + 1) === 0x0022 && body.charCodeAt(position + 2) === 0x0022 && body.charCodeAt(position + 3) === 0x0022) {
            currentLine += body.slice(chunkStart, position);
            chunkStart = position + 1; // skip only slash
            position += 4;
            continue;
        } // LineTerminator
        if (code === 0x000a || code === 0x000d) {
            currentLine += body.slice(chunkStart, position);
            blockLines.push(currentLine);
            if (code === 0x000d && body.charCodeAt(position + 1) === 0x000a) position += 2;
            else ++position;
            currentLine = "";
            chunkStart = position;
            lineStart = position;
            continue;
        } // SourceCharacter
        if ($971bc50063303b32$var$isUnicodeScalarValue(code)) ++position;
        else if ($971bc50063303b32$var$isSupplementaryCodePoint(body, position)) position += 2;
        else throw (0, $egTVJ.syntaxError)(lexer.source, position, `Invalid character within String: ${$971bc50063303b32$var$printCodePointAt(lexer, position)}.`);
    }
    throw (0, $egTVJ.syntaxError)(lexer.source, position, "Unterminated string.");
}
/**
 * Reads an alphanumeric + underscore name from the source.
 *
 * ```
 * Name ::
 *   - NameStart NameContinue* [lookahead != NameContinue]
 * ```
 */ function $971bc50063303b32$var$readName(lexer, start) {
    const body = lexer.source.body;
    const bodyLength = body.length;
    let position = start + 1;
    while(position < bodyLength){
        const code = body.charCodeAt(position);
        if ((0, $gmlY8.isNameContinue)(code)) ++position;
        else break;
    }
    return $971bc50063303b32$var$createToken(lexer, (0, $bQgNI.TokenKind).NAME, start, position, body.slice(start, position));
}

});
parcelRegister("bQgNI", function(module, exports) {

$parcel$export(module.exports, "TokenKind", () => $ac240aaa94caf15d$export$8b9d26ab11394711);
/**
 * An exported enum describing the different kinds of tokens that the
 * lexer emits.
 */ var $ac240aaa94caf15d$export$8b9d26ab11394711;
(function(TokenKind) {
    TokenKind["SOF"] = "<SOF>";
    TokenKind["EOF"] = "<EOF>";
    TokenKind["BANG"] = "!";
    TokenKind["DOLLAR"] = "$";
    TokenKind["AMP"] = "&";
    TokenKind["PAREN_L"] = "(";
    TokenKind["PAREN_R"] = ")";
    TokenKind["SPREAD"] = "...";
    TokenKind["COLON"] = ":";
    TokenKind["EQUALS"] = "=";
    TokenKind["AT"] = "@";
    TokenKind["BRACKET_L"] = "[";
    TokenKind["BRACKET_R"] = "]";
    TokenKind["BRACE_L"] = "{";
    TokenKind["PIPE"] = "|";
    TokenKind["BRACE_R"] = "}";
    TokenKind["NAME"] = "Name";
    TokenKind["INT"] = "Int";
    TokenKind["FLOAT"] = "Float";
    TokenKind["STRING"] = "String";
    TokenKind["BLOCK_STRING"] = "BlockString";
    TokenKind["COMMENT"] = "Comment";
})($ac240aaa94caf15d$export$8b9d26ab11394711 || ($ac240aaa94caf15d$export$8b9d26ab11394711 = {}));
 /**
 * The enum type representing the token kinds values.
 *
 * @deprecated Please use `TokenKind`. Will be remove in v17.
 */ 
});


parcelRegister("1i7FZ", function(module, exports) {

$parcel$export(module.exports, "Source", () => $1ff584847d3a412c$export$1d2df86270c81ecb);
$parcel$export(module.exports, "isSource", () => $1ff584847d3a412c$export$75135ee9ed6e435b);

var $lDltR = parcelRequire("lDltR");

var $gHwk7 = parcelRequire("gHwk7");

var $7NKAi = parcelRequire("7NKAi");
class $1ff584847d3a412c$export$1d2df86270c81ecb {
    constructor(body, name = "GraphQL request", locationOffset = {
        line: 1,
        column: 1
    }){
        typeof body === "string" || (0, $lDltR.devAssert)(false, `Body must be a string. Received: ${(0, $gHwk7.inspect)(body)}.`);
        this.body = body;
        this.name = name;
        this.locationOffset = locationOffset;
        this.locationOffset.line > 0 || (0, $lDltR.devAssert)(false, "line in locationOffset is 1-indexed and must be positive.");
        this.locationOffset.column > 0 || (0, $lDltR.devAssert)(false, "column in locationOffset is 1-indexed and must be positive.");
    }
    get [Symbol.toStringTag]() {
        return "Source";
    }
}
function $1ff584847d3a412c$export$75135ee9ed6e435b(source) {
    return (0, $7NKAi.instanceOf)(source, $1ff584847d3a412c$export$1d2df86270c81ecb);
}

});


parcelRegister("9KaHw", function(module, exports) {

$parcel$export(module.exports, "isDirective", () => $31fff8926b459133$export$4b5d79f26e0e3ad5);
$parcel$export(module.exports, "GraphQLDirective", () => $31fff8926b459133$export$90407e48aac654e9);
$parcel$export(module.exports, "assertDirective", () => $31fff8926b459133$export$976bef3b79eaee5d);
$parcel$export(module.exports, "GraphQLIncludeDirective", () => $31fff8926b459133$export$f92fb5dbf075dbee);
$parcel$export(module.exports, "GraphQLSkipDirective", () => $31fff8926b459133$export$7adbe9be7084cfe3);
$parcel$export(module.exports, "DEFAULT_DEPRECATION_REASON", () => $31fff8926b459133$export$15edbda76f1f9a89);
$parcel$export(module.exports, "GraphQLDeprecatedDirective", () => $31fff8926b459133$export$ed64f8040ac801d1);
$parcel$export(module.exports, "GraphQLSpecifiedByDirective", () => $31fff8926b459133$export$26ce3cf10bb75d41);
$parcel$export(module.exports, "specifiedDirectives", () => $31fff8926b459133$export$c48d2e3f4e034403);
$parcel$export(module.exports, "isSpecifiedDirective", () => $31fff8926b459133$export$7d2e48434602f4fe);

var $lDltR = parcelRequire("lDltR");

var $gHwk7 = parcelRequire("gHwk7");

var $7NKAi = parcelRequire("7NKAi");

var $cryJ5 = parcelRequire("cryJ5");

var $lNeRj = parcelRequire("lNeRj");

var $5zW8K = parcelRequire("5zW8K");

var $kr4gH = parcelRequire("kr4gH");

var $54dWd = parcelRequire("54dWd");

var $l5aqI = parcelRequire("l5aqI");
function $31fff8926b459133$export$4b5d79f26e0e3ad5(directive) {
    return (0, $7NKAi.instanceOf)(directive, $31fff8926b459133$export$90407e48aac654e9);
}
function $31fff8926b459133$export$976bef3b79eaee5d(directive) {
    if (!$31fff8926b459133$export$4b5d79f26e0e3ad5(directive)) throw new Error(`Expected ${(0, $gHwk7.inspect)(directive)} to be a GraphQL directive.`);
    return directive;
}
class $31fff8926b459133$export$90407e48aac654e9 {
    constructor(config){
        var _config$isRepeatable, _config$args;
        this.name = (0, $kr4gH.assertName)(config.name);
        this.description = config.description;
        this.locations = config.locations;
        this.isRepeatable = (_config$isRepeatable = config.isRepeatable) !== null && _config$isRepeatable !== void 0 ? _config$isRepeatable : false;
        this.extensions = (0, $lNeRj.toObjMap)(config.extensions);
        this.astNode = config.astNode;
        Array.isArray(config.locations) || (0, $lDltR.devAssert)(false, `@${config.name} locations must be an Array.`);
        const args = (_config$args = config.args) !== null && _config$args !== void 0 ? _config$args : {};
        (0, $cryJ5.isObjectLike)(args) && !Array.isArray(args) || (0, $lDltR.devAssert)(false, `@${config.name} args must be an object with argument names as keys.`);
        this.args = (0, $54dWd.defineArguments)(args);
    }
    get [Symbol.toStringTag]() {
        return "GraphQLDirective";
    }
    toConfig() {
        return {
            name: this.name,
            description: this.description,
            locations: this.locations,
            args: (0, $54dWd.argsToArgsConfig)(this.args),
            isRepeatable: this.isRepeatable,
            extensions: this.extensions,
            astNode: this.astNode
        };
    }
    toString() {
        return "@" + this.name;
    }
    toJSON() {
        return this.toString();
    }
}
const $31fff8926b459133$export$f92fb5dbf075dbee = new $31fff8926b459133$export$90407e48aac654e9({
    name: "include",
    description: "Directs the executor to include this field or fragment only when the `if` argument is true.",
    locations: [
        (0, $5zW8K.DirectiveLocation).FIELD,
        (0, $5zW8K.DirectiveLocation).FRAGMENT_SPREAD,
        (0, $5zW8K.DirectiveLocation).INLINE_FRAGMENT
    ],
    args: {
        if: {
            type: new (0, $54dWd.GraphQLNonNull)((0, $l5aqI.GraphQLBoolean)),
            description: "Included when true."
        }
    }
});
const $31fff8926b459133$export$7adbe9be7084cfe3 = new $31fff8926b459133$export$90407e48aac654e9({
    name: "skip",
    description: "Directs the executor to skip this field or fragment when the `if` argument is true.",
    locations: [
        (0, $5zW8K.DirectiveLocation).FIELD,
        (0, $5zW8K.DirectiveLocation).FRAGMENT_SPREAD,
        (0, $5zW8K.DirectiveLocation).INLINE_FRAGMENT
    ],
    args: {
        if: {
            type: new (0, $54dWd.GraphQLNonNull)((0, $l5aqI.GraphQLBoolean)),
            description: "Skipped when true."
        }
    }
});
const $31fff8926b459133$export$15edbda76f1f9a89 = "No longer supported";
const $31fff8926b459133$export$ed64f8040ac801d1 = new $31fff8926b459133$export$90407e48aac654e9({
    name: "deprecated",
    description: "Marks an element of a GraphQL schema as no longer supported.",
    locations: [
        (0, $5zW8K.DirectiveLocation).FIELD_DEFINITION,
        (0, $5zW8K.DirectiveLocation).ARGUMENT_DEFINITION,
        (0, $5zW8K.DirectiveLocation).INPUT_FIELD_DEFINITION,
        (0, $5zW8K.DirectiveLocation).ENUM_VALUE
    ],
    args: {
        reason: {
            type: (0, $l5aqI.GraphQLString),
            description: "Explains why this element was deprecated, usually also including a suggestion for how to access supported similar data. Formatted using the Markdown syntax, as specified by [CommonMark](https://commonmark.org/).",
            defaultValue: $31fff8926b459133$export$15edbda76f1f9a89
        }
    }
});
const $31fff8926b459133$export$26ce3cf10bb75d41 = new $31fff8926b459133$export$90407e48aac654e9({
    name: "specifiedBy",
    description: "Exposes a URL that specifies the behavior of this scalar.",
    locations: [
        (0, $5zW8K.DirectiveLocation).SCALAR
    ],
    args: {
        url: {
            type: new (0, $54dWd.GraphQLNonNull)((0, $l5aqI.GraphQLString)),
            description: "The URL that specifies the behavior of this scalar."
        }
    }
});
const $31fff8926b459133$export$c48d2e3f4e034403 = Object.freeze([
    $31fff8926b459133$export$f92fb5dbf075dbee,
    $31fff8926b459133$export$7adbe9be7084cfe3,
    $31fff8926b459133$export$ed64f8040ac801d1,
    $31fff8926b459133$export$26ce3cf10bb75d41
]);
function $31fff8926b459133$export$7d2e48434602f4fe(directive) {
    return $31fff8926b459133$export$c48d2e3f4e034403.some(({ name: name })=>name === directive.name);
}

});

parcelRegister("jptTh", function(module, exports) {

$parcel$export(module.exports, "__Schema", () => $92fc0f50f85d1f12$export$1f18df711f6fa0ac);
$parcel$export(module.exports, "__Type", () => $92fc0f50f85d1f12$export$b46ca740abcddda7);
$parcel$export(module.exports, "__Directive", () => $92fc0f50f85d1f12$export$2492e8c5b8ba489f);
$parcel$export(module.exports, "__DirectiveLocation", () => $92fc0f50f85d1f12$export$70e870c5930737d1);
$parcel$export(module.exports, "__InputValue", () => $92fc0f50f85d1f12$export$bc79df5a9719c05b);
$parcel$export(module.exports, "__TypeKind", () => $92fc0f50f85d1f12$export$163610506c99e78f);
$parcel$export(module.exports, "TypeKind", () => $92fc0f50f85d1f12$export$c29cf3c48471da7c);
$parcel$export(module.exports, "__Field", () => $92fc0f50f85d1f12$export$c93780024e419b02);
$parcel$export(module.exports, "__EnumValue", () => $92fc0f50f85d1f12$export$b93e3441ec96b29a);
$parcel$export(module.exports, "SchemaMetaFieldDef", () => $92fc0f50f85d1f12$export$36ed059ad2080404);
$parcel$export(module.exports, "TypeMetaFieldDef", () => $92fc0f50f85d1f12$export$87a968d084148b61);
$parcel$export(module.exports, "TypeNameMetaFieldDef", () => $92fc0f50f85d1f12$export$b9c17490e825648e);
$parcel$export(module.exports, "introspectionTypes", () => $92fc0f50f85d1f12$export$560bc6e8f6d098f4);
$parcel$export(module.exports, "isIntrospectionType", () => $92fc0f50f85d1f12$export$e1862b156b15ce4f);

var $gHwk7 = parcelRequire("gHwk7");

var $l3zHt = parcelRequire("l3zHt");

var $5zW8K = parcelRequire("5zW8K");

var $3o9dz = parcelRequire("3o9dz");

var $3MaO2 = parcelRequire("3MaO2");

var $54dWd = parcelRequire("54dWd");

var $l5aqI = parcelRequire("l5aqI");
const $92fc0f50f85d1f12$export$1f18df711f6fa0ac = new (0, $54dWd.GraphQLObjectType)({
    name: "__Schema",
    description: "A GraphQL Schema defines the capabilities of a GraphQL server. It exposes all available types and directives on the server, as well as the entry points for query, mutation, and subscription operations.",
    fields: ()=>({
            description: {
                type: (0, $l5aqI.GraphQLString),
                resolve: (schema)=>schema.description
            },
            types: {
                description: "A list of all types supported by this server.",
                type: new (0, $54dWd.GraphQLNonNull)(new (0, $54dWd.GraphQLList)(new (0, $54dWd.GraphQLNonNull)($92fc0f50f85d1f12$export$b46ca740abcddda7))),
                resolve (schema) {
                    return Object.values(schema.getTypeMap());
                }
            },
            queryType: {
                description: "The type that query operations will be rooted at.",
                type: new (0, $54dWd.GraphQLNonNull)($92fc0f50f85d1f12$export$b46ca740abcddda7),
                resolve: (schema)=>schema.getQueryType()
            },
            mutationType: {
                description: "If this server supports mutation, the type that mutation operations will be rooted at.",
                type: $92fc0f50f85d1f12$export$b46ca740abcddda7,
                resolve: (schema)=>schema.getMutationType()
            },
            subscriptionType: {
                description: "If this server support subscription, the type that subscription operations will be rooted at.",
                type: $92fc0f50f85d1f12$export$b46ca740abcddda7,
                resolve: (schema)=>schema.getSubscriptionType()
            },
            directives: {
                description: "A list of all directives supported by this server.",
                type: new (0, $54dWd.GraphQLNonNull)(new (0, $54dWd.GraphQLList)(new (0, $54dWd.GraphQLNonNull)($92fc0f50f85d1f12$export$2492e8c5b8ba489f))),
                resolve: (schema)=>schema.getDirectives()
            }
        })
});
const $92fc0f50f85d1f12$export$2492e8c5b8ba489f = new (0, $54dWd.GraphQLObjectType)({
    name: "__Directive",
    description: "A Directive provides a way to describe alternate runtime execution and type validation behavior in a GraphQL document.\n\nIn some cases, you need to provide options to alter GraphQL's execution behavior in ways field arguments will not suffice, such as conditionally including or skipping a field. Directives provide this by describing additional information to the executor.",
    fields: ()=>({
            name: {
                type: new (0, $54dWd.GraphQLNonNull)((0, $l5aqI.GraphQLString)),
                resolve: (directive)=>directive.name
            },
            description: {
                type: (0, $l5aqI.GraphQLString),
                resolve: (directive)=>directive.description
            },
            isRepeatable: {
                type: new (0, $54dWd.GraphQLNonNull)((0, $l5aqI.GraphQLBoolean)),
                resolve: (directive)=>directive.isRepeatable
            },
            locations: {
                type: new (0, $54dWd.GraphQLNonNull)(new (0, $54dWd.GraphQLList)(new (0, $54dWd.GraphQLNonNull)($92fc0f50f85d1f12$export$70e870c5930737d1))),
                resolve: (directive)=>directive.locations
            },
            args: {
                type: new (0, $54dWd.GraphQLNonNull)(new (0, $54dWd.GraphQLList)(new (0, $54dWd.GraphQLNonNull)($92fc0f50f85d1f12$export$bc79df5a9719c05b))),
                args: {
                    includeDeprecated: {
                        type: (0, $l5aqI.GraphQLBoolean),
                        defaultValue: false
                    }
                },
                resolve (field, { includeDeprecated: includeDeprecated }) {
                    return includeDeprecated ? field.args : field.args.filter((arg)=>arg.deprecationReason == null);
                }
            }
        })
});
const $92fc0f50f85d1f12$export$70e870c5930737d1 = new (0, $54dWd.GraphQLEnumType)({
    name: "__DirectiveLocation",
    description: "A Directive can be adjacent to many parts of the GraphQL language, a __DirectiveLocation describes one such possible adjacencies.",
    values: {
        QUERY: {
            value: (0, $5zW8K.DirectiveLocation).QUERY,
            description: "Location adjacent to a query operation."
        },
        MUTATION: {
            value: (0, $5zW8K.DirectiveLocation).MUTATION,
            description: "Location adjacent to a mutation operation."
        },
        SUBSCRIPTION: {
            value: (0, $5zW8K.DirectiveLocation).SUBSCRIPTION,
            description: "Location adjacent to a subscription operation."
        },
        FIELD: {
            value: (0, $5zW8K.DirectiveLocation).FIELD,
            description: "Location adjacent to a field."
        },
        FRAGMENT_DEFINITION: {
            value: (0, $5zW8K.DirectiveLocation).FRAGMENT_DEFINITION,
            description: "Location adjacent to a fragment definition."
        },
        FRAGMENT_SPREAD: {
            value: (0, $5zW8K.DirectiveLocation).FRAGMENT_SPREAD,
            description: "Location adjacent to a fragment spread."
        },
        INLINE_FRAGMENT: {
            value: (0, $5zW8K.DirectiveLocation).INLINE_FRAGMENT,
            description: "Location adjacent to an inline fragment."
        },
        VARIABLE_DEFINITION: {
            value: (0, $5zW8K.DirectiveLocation).VARIABLE_DEFINITION,
            description: "Location adjacent to a variable definition."
        },
        SCHEMA: {
            value: (0, $5zW8K.DirectiveLocation).SCHEMA,
            description: "Location adjacent to a schema definition."
        },
        SCALAR: {
            value: (0, $5zW8K.DirectiveLocation).SCALAR,
            description: "Location adjacent to a scalar definition."
        },
        OBJECT: {
            value: (0, $5zW8K.DirectiveLocation).OBJECT,
            description: "Location adjacent to an object type definition."
        },
        FIELD_DEFINITION: {
            value: (0, $5zW8K.DirectiveLocation).FIELD_DEFINITION,
            description: "Location adjacent to a field definition."
        },
        ARGUMENT_DEFINITION: {
            value: (0, $5zW8K.DirectiveLocation).ARGUMENT_DEFINITION,
            description: "Location adjacent to an argument definition."
        },
        INTERFACE: {
            value: (0, $5zW8K.DirectiveLocation).INTERFACE,
            description: "Location adjacent to an interface definition."
        },
        UNION: {
            value: (0, $5zW8K.DirectiveLocation).UNION,
            description: "Location adjacent to a union definition."
        },
        ENUM: {
            value: (0, $5zW8K.DirectiveLocation).ENUM,
            description: "Location adjacent to an enum definition."
        },
        ENUM_VALUE: {
            value: (0, $5zW8K.DirectiveLocation).ENUM_VALUE,
            description: "Location adjacent to an enum value definition."
        },
        INPUT_OBJECT: {
            value: (0, $5zW8K.DirectiveLocation).INPUT_OBJECT,
            description: "Location adjacent to an input object type definition."
        },
        INPUT_FIELD_DEFINITION: {
            value: (0, $5zW8K.DirectiveLocation).INPUT_FIELD_DEFINITION,
            description: "Location adjacent to an input object field definition."
        }
    }
});
const $92fc0f50f85d1f12$export$b46ca740abcddda7 = new (0, $54dWd.GraphQLObjectType)({
    name: "__Type",
    description: "The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.\n\nDepending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByURL`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.",
    fields: ()=>({
            kind: {
                type: new (0, $54dWd.GraphQLNonNull)($92fc0f50f85d1f12$export$163610506c99e78f),
                resolve (type) {
                    if ((0, $54dWd.isScalarType)(type)) return $92fc0f50f85d1f12$export$c29cf3c48471da7c.SCALAR;
                    if ((0, $54dWd.isObjectType)(type)) return $92fc0f50f85d1f12$export$c29cf3c48471da7c.OBJECT;
                    if ((0, $54dWd.isInterfaceType)(type)) return $92fc0f50f85d1f12$export$c29cf3c48471da7c.INTERFACE;
                    if ((0, $54dWd.isUnionType)(type)) return $92fc0f50f85d1f12$export$c29cf3c48471da7c.UNION;
                    if ((0, $54dWd.isEnumType)(type)) return $92fc0f50f85d1f12$export$c29cf3c48471da7c.ENUM;
                    if ((0, $54dWd.isInputObjectType)(type)) return $92fc0f50f85d1f12$export$c29cf3c48471da7c.INPUT_OBJECT;
                    if ((0, $54dWd.isListType)(type)) return $92fc0f50f85d1f12$export$c29cf3c48471da7c.LIST;
                    if ((0, $54dWd.isNonNullType)(type)) return $92fc0f50f85d1f12$export$c29cf3c48471da7c.NON_NULL;
                    /* c8 ignore next 3 */ // Not reachable, all possible types have been considered)
                    (0, $l3zHt.invariant)(false, `Unexpected type: "${(0, $gHwk7.inspect)(type)}".`);
                }
            },
            name: {
                type: (0, $l5aqI.GraphQLString),
                resolve: (type)=>"name" in type ? type.name : undefined
            },
            description: {
                type: (0, $l5aqI.GraphQLString),
                resolve: (type)=>/* c8 ignore next */ "description" in type ? type.description : undefined
            },
            specifiedByURL: {
                type: (0, $l5aqI.GraphQLString),
                resolve: (obj)=>"specifiedByURL" in obj ? obj.specifiedByURL : undefined
            },
            fields: {
                type: new (0, $54dWd.GraphQLList)(new (0, $54dWd.GraphQLNonNull)($92fc0f50f85d1f12$export$c93780024e419b02)),
                args: {
                    includeDeprecated: {
                        type: (0, $l5aqI.GraphQLBoolean),
                        defaultValue: false
                    }
                },
                resolve (type, { includeDeprecated: includeDeprecated }) {
                    if ((0, $54dWd.isObjectType)(type) || (0, $54dWd.isInterfaceType)(type)) {
                        const fields = Object.values(type.getFields());
                        return includeDeprecated ? fields : fields.filter((field)=>field.deprecationReason == null);
                    }
                }
            },
            interfaces: {
                type: new (0, $54dWd.GraphQLList)(new (0, $54dWd.GraphQLNonNull)($92fc0f50f85d1f12$export$b46ca740abcddda7)),
                resolve (type) {
                    if ((0, $54dWd.isObjectType)(type) || (0, $54dWd.isInterfaceType)(type)) return type.getInterfaces();
                }
            },
            possibleTypes: {
                type: new (0, $54dWd.GraphQLList)(new (0, $54dWd.GraphQLNonNull)($92fc0f50f85d1f12$export$b46ca740abcddda7)),
                resolve (type, _args, _context, { schema: schema }) {
                    if ((0, $54dWd.isAbstractType)(type)) return schema.getPossibleTypes(type);
                }
            },
            enumValues: {
                type: new (0, $54dWd.GraphQLList)(new (0, $54dWd.GraphQLNonNull)($92fc0f50f85d1f12$export$b93e3441ec96b29a)),
                args: {
                    includeDeprecated: {
                        type: (0, $l5aqI.GraphQLBoolean),
                        defaultValue: false
                    }
                },
                resolve (type, { includeDeprecated: includeDeprecated }) {
                    if ((0, $54dWd.isEnumType)(type)) {
                        const values = type.getValues();
                        return includeDeprecated ? values : values.filter((field)=>field.deprecationReason == null);
                    }
                }
            },
            inputFields: {
                type: new (0, $54dWd.GraphQLList)(new (0, $54dWd.GraphQLNonNull)($92fc0f50f85d1f12$export$bc79df5a9719c05b)),
                args: {
                    includeDeprecated: {
                        type: (0, $l5aqI.GraphQLBoolean),
                        defaultValue: false
                    }
                },
                resolve (type, { includeDeprecated: includeDeprecated }) {
                    if ((0, $54dWd.isInputObjectType)(type)) {
                        const values = Object.values(type.getFields());
                        return includeDeprecated ? values : values.filter((field)=>field.deprecationReason == null);
                    }
                }
            },
            ofType: {
                type: $92fc0f50f85d1f12$export$b46ca740abcddda7,
                resolve: (type)=>"ofType" in type ? type.ofType : undefined
            }
        })
});
const $92fc0f50f85d1f12$export$c93780024e419b02 = new (0, $54dWd.GraphQLObjectType)({
    name: "__Field",
    description: "Object and Interface types are described by a list of Fields, each of which has a name, potentially a list of arguments, and a return type.",
    fields: ()=>({
            name: {
                type: new (0, $54dWd.GraphQLNonNull)((0, $l5aqI.GraphQLString)),
                resolve: (field)=>field.name
            },
            description: {
                type: (0, $l5aqI.GraphQLString),
                resolve: (field)=>field.description
            },
            args: {
                type: new (0, $54dWd.GraphQLNonNull)(new (0, $54dWd.GraphQLList)(new (0, $54dWd.GraphQLNonNull)($92fc0f50f85d1f12$export$bc79df5a9719c05b))),
                args: {
                    includeDeprecated: {
                        type: (0, $l5aqI.GraphQLBoolean),
                        defaultValue: false
                    }
                },
                resolve (field, { includeDeprecated: includeDeprecated }) {
                    return includeDeprecated ? field.args : field.args.filter((arg)=>arg.deprecationReason == null);
                }
            },
            type: {
                type: new (0, $54dWd.GraphQLNonNull)($92fc0f50f85d1f12$export$b46ca740abcddda7),
                resolve: (field)=>field.type
            },
            isDeprecated: {
                type: new (0, $54dWd.GraphQLNonNull)((0, $l5aqI.GraphQLBoolean)),
                resolve: (field)=>field.deprecationReason != null
            },
            deprecationReason: {
                type: (0, $l5aqI.GraphQLString),
                resolve: (field)=>field.deprecationReason
            }
        })
});
const $92fc0f50f85d1f12$export$bc79df5a9719c05b = new (0, $54dWd.GraphQLObjectType)({
    name: "__InputValue",
    description: "Arguments provided to Fields or Directives and the input fields of an InputObject are represented as Input Values which describe their type and optionally a default value.",
    fields: ()=>({
            name: {
                type: new (0, $54dWd.GraphQLNonNull)((0, $l5aqI.GraphQLString)),
                resolve: (inputValue)=>inputValue.name
            },
            description: {
                type: (0, $l5aqI.GraphQLString),
                resolve: (inputValue)=>inputValue.description
            },
            type: {
                type: new (0, $54dWd.GraphQLNonNull)($92fc0f50f85d1f12$export$b46ca740abcddda7),
                resolve: (inputValue)=>inputValue.type
            },
            defaultValue: {
                type: (0, $l5aqI.GraphQLString),
                description: "A GraphQL-formatted string representing the default value for this input value.",
                resolve (inputValue) {
                    const { type: type, defaultValue: defaultValue } = inputValue;
                    const valueAST = (0, $3MaO2.astFromValue)(defaultValue, type);
                    return valueAST ? (0, $3o9dz.print)(valueAST) : null;
                }
            },
            isDeprecated: {
                type: new (0, $54dWd.GraphQLNonNull)((0, $l5aqI.GraphQLBoolean)),
                resolve: (field)=>field.deprecationReason != null
            },
            deprecationReason: {
                type: (0, $l5aqI.GraphQLString),
                resolve: (obj)=>obj.deprecationReason
            }
        })
});
const $92fc0f50f85d1f12$export$b93e3441ec96b29a = new (0, $54dWd.GraphQLObjectType)({
    name: "__EnumValue",
    description: "One possible value for a given Enum. Enum values are unique values, not a placeholder for a string or numeric value. However an Enum value is returned in a JSON response as a string.",
    fields: ()=>({
            name: {
                type: new (0, $54dWd.GraphQLNonNull)((0, $l5aqI.GraphQLString)),
                resolve: (enumValue)=>enumValue.name
            },
            description: {
                type: (0, $l5aqI.GraphQLString),
                resolve: (enumValue)=>enumValue.description
            },
            isDeprecated: {
                type: new (0, $54dWd.GraphQLNonNull)((0, $l5aqI.GraphQLBoolean)),
                resolve: (enumValue)=>enumValue.deprecationReason != null
            },
            deprecationReason: {
                type: (0, $l5aqI.GraphQLString),
                resolve: (enumValue)=>enumValue.deprecationReason
            }
        })
});
var $92fc0f50f85d1f12$export$c29cf3c48471da7c;
(function(TypeKind) {
    TypeKind["SCALAR"] = "SCALAR";
    TypeKind["OBJECT"] = "OBJECT";
    TypeKind["INTERFACE"] = "INTERFACE";
    TypeKind["UNION"] = "UNION";
    TypeKind["ENUM"] = "ENUM";
    TypeKind["INPUT_OBJECT"] = "INPUT_OBJECT";
    TypeKind["LIST"] = "LIST";
    TypeKind["NON_NULL"] = "NON_NULL";
})($92fc0f50f85d1f12$export$c29cf3c48471da7c || ($92fc0f50f85d1f12$export$c29cf3c48471da7c = {}));
const $92fc0f50f85d1f12$export$163610506c99e78f = new (0, $54dWd.GraphQLEnumType)({
    name: "__TypeKind",
    description: "An enum describing what kind of type a given `__Type` is.",
    values: {
        SCALAR: {
            value: $92fc0f50f85d1f12$export$c29cf3c48471da7c.SCALAR,
            description: "Indicates this type is a scalar."
        },
        OBJECT: {
            value: $92fc0f50f85d1f12$export$c29cf3c48471da7c.OBJECT,
            description: "Indicates this type is an object. `fields` and `interfaces` are valid fields."
        },
        INTERFACE: {
            value: $92fc0f50f85d1f12$export$c29cf3c48471da7c.INTERFACE,
            description: "Indicates this type is an interface. `fields`, `interfaces`, and `possibleTypes` are valid fields."
        },
        UNION: {
            value: $92fc0f50f85d1f12$export$c29cf3c48471da7c.UNION,
            description: "Indicates this type is a union. `possibleTypes` is a valid field."
        },
        ENUM: {
            value: $92fc0f50f85d1f12$export$c29cf3c48471da7c.ENUM,
            description: "Indicates this type is an enum. `enumValues` is a valid field."
        },
        INPUT_OBJECT: {
            value: $92fc0f50f85d1f12$export$c29cf3c48471da7c.INPUT_OBJECT,
            description: "Indicates this type is an input object. `inputFields` is a valid field."
        },
        LIST: {
            value: $92fc0f50f85d1f12$export$c29cf3c48471da7c.LIST,
            description: "Indicates this type is a list. `ofType` is a valid field."
        },
        NON_NULL: {
            value: $92fc0f50f85d1f12$export$c29cf3c48471da7c.NON_NULL,
            description: "Indicates this type is a non-null. `ofType` is a valid field."
        }
    }
});
const $92fc0f50f85d1f12$export$36ed059ad2080404 = {
    name: "__schema",
    type: new (0, $54dWd.GraphQLNonNull)($92fc0f50f85d1f12$export$1f18df711f6fa0ac),
    description: "Access the current type schema of this server.",
    args: [],
    resolve: (_source, _args, _context, { schema: schema })=>schema,
    deprecationReason: undefined,
    extensions: Object.create(null),
    astNode: undefined
};
const $92fc0f50f85d1f12$export$87a968d084148b61 = {
    name: "__type",
    type: $92fc0f50f85d1f12$export$b46ca740abcddda7,
    description: "Request the type information of a single type.",
    args: [
        {
            name: "name",
            description: undefined,
            type: new (0, $54dWd.GraphQLNonNull)((0, $l5aqI.GraphQLString)),
            defaultValue: undefined,
            deprecationReason: undefined,
            extensions: Object.create(null),
            astNode: undefined
        }
    ],
    resolve: (_source, { name: name }, _context, { schema: schema })=>schema.getType(name),
    deprecationReason: undefined,
    extensions: Object.create(null),
    astNode: undefined
};
const $92fc0f50f85d1f12$export$b9c17490e825648e = {
    name: "__typename",
    type: new (0, $54dWd.GraphQLNonNull)((0, $l5aqI.GraphQLString)),
    description: "The name of the current Object type at runtime.",
    args: [],
    resolve: (_source, _args, _context, { parentType: parentType })=>parentType.name,
    deprecationReason: undefined,
    extensions: Object.create(null),
    astNode: undefined
};
const $92fc0f50f85d1f12$export$560bc6e8f6d098f4 = Object.freeze([
    $92fc0f50f85d1f12$export$1f18df711f6fa0ac,
    $92fc0f50f85d1f12$export$2492e8c5b8ba489f,
    $92fc0f50f85d1f12$export$70e870c5930737d1,
    $92fc0f50f85d1f12$export$b46ca740abcddda7,
    $92fc0f50f85d1f12$export$c93780024e419b02,
    $92fc0f50f85d1f12$export$bc79df5a9719c05b,
    $92fc0f50f85d1f12$export$b93e3441ec96b29a,
    $92fc0f50f85d1f12$export$163610506c99e78f
]);
function $92fc0f50f85d1f12$export$e1862b156b15ce4f(type) {
    return $92fc0f50f85d1f12$export$560bc6e8f6d098f4.some(({ name: name })=>type.name === name);
}

});

parcelRegister("3rrQl", function(module, exports) {

$parcel$export(module.exports, "isSchema", () => $72e00b94709394de$export$213e2a3e7c4f326e);
$parcel$export(module.exports, "GraphQLSchema", () => $72e00b94709394de$export$730e8b0fd6e4f02b);
$parcel$export(module.exports, "assertSchema", () => $72e00b94709394de$export$6554dabc0f90e0c3);

var $lDltR = parcelRequire("lDltR");

var $gHwk7 = parcelRequire("gHwk7");

var $7NKAi = parcelRequire("7NKAi");

var $cryJ5 = parcelRequire("cryJ5");

var $lNeRj = parcelRequire("lNeRj");

var $8r1qs = parcelRequire("8r1qs");

var $54dWd = parcelRequire("54dWd");

var $9KaHw = parcelRequire("9KaHw");

var $jptTh = parcelRequire("jptTh");
function $72e00b94709394de$export$213e2a3e7c4f326e(schema) {
    return (0, $7NKAi.instanceOf)(schema, $72e00b94709394de$export$730e8b0fd6e4f02b);
}
function $72e00b94709394de$export$6554dabc0f90e0c3(schema) {
    if (!$72e00b94709394de$export$213e2a3e7c4f326e(schema)) throw new Error(`Expected ${(0, $gHwk7.inspect)(schema)} to be a GraphQL schema.`);
    return schema;
}
class $72e00b94709394de$export$730e8b0fd6e4f02b {
    // Used as a cache for validateSchema().
    constructor(config){
        var _config$extensionASTN, _config$directives;
        // If this schema was built from a source known to be valid, then it may be
        // marked with assumeValid to avoid an additional type system validation.
        this.__validationErrors = config.assumeValid === true ? [] : undefined; // Check for common mistakes during construction to produce early errors.
        (0, $cryJ5.isObjectLike)(config) || (0, $lDltR.devAssert)(false, "Must provide configuration object.");
        !config.types || Array.isArray(config.types) || (0, $lDltR.devAssert)(false, `"types" must be Array if provided but got: ${(0, $gHwk7.inspect)(config.types)}.`);
        !config.directives || Array.isArray(config.directives) || (0, $lDltR.devAssert)(false, '"directives" must be Array if provided but got: ' + `${(0, $gHwk7.inspect)(config.directives)}.`);
        this.description = config.description;
        this.extensions = (0, $lNeRj.toObjMap)(config.extensions);
        this.astNode = config.astNode;
        this.extensionASTNodes = (_config$extensionASTN = config.extensionASTNodes) !== null && _config$extensionASTN !== void 0 ? _config$extensionASTN : [];
        this._queryType = config.query;
        this._mutationType = config.mutation;
        this._subscriptionType = config.subscription; // Provide specified directives (e.g. @include and @skip) by default.
        this._directives = (_config$directives = config.directives) !== null && _config$directives !== void 0 ? _config$directives : (0, $9KaHw.specifiedDirectives); // To preserve order of user-provided types, we add first to add them to
        // the set of "collected" types, so `collectReferencedTypes` ignore them.
        const allReferencedTypes = new Set(config.types);
        if (config.types != null) for (const type of config.types){
            // When we ready to process this type, we remove it from "collected" types
            // and then add it together with all dependent types in the correct position.
            allReferencedTypes.delete(type);
            $72e00b94709394de$var$collectReferencedTypes(type, allReferencedTypes);
        }
        if (this._queryType != null) $72e00b94709394de$var$collectReferencedTypes(this._queryType, allReferencedTypes);
        if (this._mutationType != null) $72e00b94709394de$var$collectReferencedTypes(this._mutationType, allReferencedTypes);
        if (this._subscriptionType != null) $72e00b94709394de$var$collectReferencedTypes(this._subscriptionType, allReferencedTypes);
        for (const directive of this._directives){
            // Directives are not validated until validateSchema() is called.
            if ((0, $9KaHw.isDirective)(directive)) for (const arg of directive.args)$72e00b94709394de$var$collectReferencedTypes(arg.type, allReferencedTypes);
        }
        $72e00b94709394de$var$collectReferencedTypes((0, $jptTh.__Schema), allReferencedTypes); // Storing the resulting map for reference by the schema.
        this._typeMap = Object.create(null);
        this._subTypeMap = Object.create(null); // Keep track of all implementations by interface name.
        this._implementationsMap = Object.create(null);
        for (const namedType of allReferencedTypes){
            if (namedType == null) continue;
            const typeName = namedType.name;
            typeName || (0, $lDltR.devAssert)(false, "One of the provided types for building the Schema is missing a name.");
            if (this._typeMap[typeName] !== undefined) throw new Error(`Schema must contain uniquely named types but contains multiple types named "${typeName}".`);
            this._typeMap[typeName] = namedType;
            if ((0, $54dWd.isInterfaceType)(namedType)) {
                // Store implementations by interface.
                for (const iface of namedType.getInterfaces())if ((0, $54dWd.isInterfaceType)(iface)) {
                    let implementations = this._implementationsMap[iface.name];
                    if (implementations === undefined) implementations = this._implementationsMap[iface.name] = {
                        objects: [],
                        interfaces: []
                    };
                    implementations.interfaces.push(namedType);
                }
            } else if ((0, $54dWd.isObjectType)(namedType)) {
                // Store implementations by objects.
                for (const iface of namedType.getInterfaces())if ((0, $54dWd.isInterfaceType)(iface)) {
                    let implementations = this._implementationsMap[iface.name];
                    if (implementations === undefined) implementations = this._implementationsMap[iface.name] = {
                        objects: [],
                        interfaces: []
                    };
                    implementations.objects.push(namedType);
                }
            }
        }
    }
    get [Symbol.toStringTag]() {
        return "GraphQLSchema";
    }
    getQueryType() {
        return this._queryType;
    }
    getMutationType() {
        return this._mutationType;
    }
    getSubscriptionType() {
        return this._subscriptionType;
    }
    getRootType(operation) {
        switch(operation){
            case (0, $8r1qs.OperationTypeNode).QUERY:
                return this.getQueryType();
            case (0, $8r1qs.OperationTypeNode).MUTATION:
                return this.getMutationType();
            case (0, $8r1qs.OperationTypeNode).SUBSCRIPTION:
                return this.getSubscriptionType();
        }
    }
    getTypeMap() {
        return this._typeMap;
    }
    getType(name) {
        return this.getTypeMap()[name];
    }
    getPossibleTypes(abstractType) {
        return (0, $54dWd.isUnionType)(abstractType) ? abstractType.getTypes() : this.getImplementations(abstractType).objects;
    }
    getImplementations(interfaceType) {
        const implementations = this._implementationsMap[interfaceType.name];
        return implementations !== null && implementations !== void 0 ? implementations : {
            objects: [],
            interfaces: []
        };
    }
    isSubType(abstractType, maybeSubType) {
        let map = this._subTypeMap[abstractType.name];
        if (map === undefined) {
            map = Object.create(null);
            if ((0, $54dWd.isUnionType)(abstractType)) for (const type of abstractType.getTypes())map[type.name] = true;
            else {
                const implementations = this.getImplementations(abstractType);
                for (const type of implementations.objects)map[type.name] = true;
                for (const type of implementations.interfaces)map[type.name] = true;
            }
            this._subTypeMap[abstractType.name] = map;
        }
        return map[maybeSubType.name] !== undefined;
    }
    getDirectives() {
        return this._directives;
    }
    getDirective(name) {
        return this.getDirectives().find((directive)=>directive.name === name);
    }
    toConfig() {
        return {
            description: this.description,
            query: this.getQueryType(),
            mutation: this.getMutationType(),
            subscription: this.getSubscriptionType(),
            types: Object.values(this.getTypeMap()),
            directives: this.getDirectives(),
            extensions: this.extensions,
            astNode: this.astNode,
            extensionASTNodes: this.extensionASTNodes,
            assumeValid: this.__validationErrors !== undefined
        };
    }
}
function $72e00b94709394de$var$collectReferencedTypes(type, typeSet) {
    const namedType = (0, $54dWd.getNamedType)(type);
    if (!typeSet.has(namedType)) {
        typeSet.add(namedType);
        if ((0, $54dWd.isUnionType)(namedType)) for (const memberType of namedType.getTypes())$72e00b94709394de$var$collectReferencedTypes(memberType, typeSet);
        else if ((0, $54dWd.isObjectType)(namedType) || (0, $54dWd.isInterfaceType)(namedType)) {
            for (const interfaceType of namedType.getInterfaces())$72e00b94709394de$var$collectReferencedTypes(interfaceType, typeSet);
            for (const field of Object.values(namedType.getFields())){
                $72e00b94709394de$var$collectReferencedTypes(field.type, typeSet);
                for (const arg of field.args)$72e00b94709394de$var$collectReferencedTypes(arg.type, typeSet);
            }
        } else if ((0, $54dWd.isInputObjectType)(namedType)) for (const field of Object.values(namedType.getFields()))$72e00b94709394de$var$collectReferencedTypes(field.type, typeSet);
    }
    return typeSet;
}

});

parcelRegister("9lFiU", function(module, exports) {

$parcel$export(module.exports, "valueFromAST", () => $d09baac7d0e0b72e$export$d32bfdfcfbe60e55);

var $gHwk7 = parcelRequire("gHwk7");

var $l3zHt = parcelRequire("l3zHt");

var $1inQZ = parcelRequire("1inQZ");

var $hu3w4 = parcelRequire("hu3w4");

var $54dWd = parcelRequire("54dWd");
function $d09baac7d0e0b72e$export$d32bfdfcfbe60e55(valueNode, type, variables) {
    if (!valueNode) // When there is no node, then there is also no value.
    // Importantly, this is different from returning the value null.
    return;
    if (valueNode.kind === (0, $hu3w4.Kind).VARIABLE) {
        const variableName = valueNode.name.value;
        if (variables == null || variables[variableName] === undefined) // No valid return value.
        return;
        const variableValue = variables[variableName];
        if (variableValue === null && (0, $54dWd.isNonNullType)(type)) return; // Invalid: intentionally return no value.
         // Note: This does no further checking that this variable is correct.
        // This assumes that this query has been validated and the variable
        // usage here is of the correct type.
        return variableValue;
    }
    if ((0, $54dWd.isNonNullType)(type)) {
        if (valueNode.kind === (0, $hu3w4.Kind).NULL) return; // Invalid: intentionally return no value.
        return $d09baac7d0e0b72e$export$d32bfdfcfbe60e55(valueNode, type.ofType, variables);
    }
    if (valueNode.kind === (0, $hu3w4.Kind).NULL) // This is explicitly returning the value null.
    return null;
    if ((0, $54dWd.isListType)(type)) {
        const itemType = type.ofType;
        if (valueNode.kind === (0, $hu3w4.Kind).LIST) {
            const coercedValues = [];
            for (const itemNode of valueNode.values)if ($d09baac7d0e0b72e$var$isMissingVariable(itemNode, variables)) {
                // If an array contains a missing variable, it is either coerced to
                // null or if the item type is non-null, it considered invalid.
                if ((0, $54dWd.isNonNullType)(itemType)) return; // Invalid: intentionally return no value.
                coercedValues.push(null);
            } else {
                const itemValue = $d09baac7d0e0b72e$export$d32bfdfcfbe60e55(itemNode, itemType, variables);
                if (itemValue === undefined) return; // Invalid: intentionally return no value.
                coercedValues.push(itemValue);
            }
            return coercedValues;
        }
        const coercedValue = $d09baac7d0e0b72e$export$d32bfdfcfbe60e55(valueNode, itemType, variables);
        if (coercedValue === undefined) return; // Invalid: intentionally return no value.
        return [
            coercedValue
        ];
    }
    if ((0, $54dWd.isInputObjectType)(type)) {
        if (valueNode.kind !== (0, $hu3w4.Kind).OBJECT) return; // Invalid: intentionally return no value.
        const coercedObj = Object.create(null);
        const fieldNodes = (0, $1inQZ.keyMap)(valueNode.fields, (field)=>field.name.value);
        for (const field of Object.values(type.getFields())){
            const fieldNode = fieldNodes[field.name];
            if (!fieldNode || $d09baac7d0e0b72e$var$isMissingVariable(fieldNode.value, variables)) {
                if (field.defaultValue !== undefined) coercedObj[field.name] = field.defaultValue;
                else if ((0, $54dWd.isNonNullType)(field.type)) return; // Invalid: intentionally return no value.
                continue;
            }
            const fieldValue = $d09baac7d0e0b72e$export$d32bfdfcfbe60e55(fieldNode.value, field.type, variables);
            if (fieldValue === undefined) return; // Invalid: intentionally return no value.
            coercedObj[field.name] = fieldValue;
        }
        return coercedObj;
    }
    if ((0, $54dWd.isLeafType)(type)) {
        // Scalars and Enums fulfill parsing a literal value via parseLiteral().
        // Invalid values represent a failure to parse correctly, in which case
        // no value is returned.
        let result;
        try {
            result = type.parseLiteral(valueNode, variables);
        } catch (_error) {
            return; // Invalid: intentionally return no value.
        }
        if (result === undefined) return; // Invalid: intentionally return no value.
        return result;
    }
    /* c8 ignore next 3 */ // Not reachable, all possible input types have been considered.
    (0, $l3zHt.invariant)(false, "Unexpected input type: " + (0, $gHwk7.inspect)(type));
} // Returns true if the provided valueNode is a variable which is not defined
// in the set of variables.
function $d09baac7d0e0b72e$var$isMissingVariable(valueNode, variables) {
    return valueNode.kind === (0, $hu3w4.Kind).VARIABLE && (variables == null || variables[valueNode.name.value] === undefined);
}

});


parcelRegister("56ITi", function(module, exports) {

$parcel$export(module.exports, "getIntrospectionQuery", () => $d91b6ee54681fcd5$export$67a66015194c88d7);
/**
 * Produce the GraphQL query recommended for a full schema introspection.
 * Accepts optional IntrospectionOptions.
 */ function $d91b6ee54681fcd5$export$67a66015194c88d7(options) {
    const optionsWithDefault = {
        descriptions: true,
        specifiedByUrl: false,
        directiveIsRepeatable: false,
        schemaDescription: false,
        inputValueDeprecation: false,
        ...options
    };
    const descriptions = optionsWithDefault.descriptions ? "description" : "";
    const specifiedByUrl = optionsWithDefault.specifiedByUrl ? "specifiedByURL" : "";
    const directiveIsRepeatable = optionsWithDefault.directiveIsRepeatable ? "isRepeatable" : "";
    const schemaDescription = optionsWithDefault.schemaDescription ? descriptions : "";
    function inputDeprecation(str) {
        return optionsWithDefault.inputValueDeprecation ? str : "";
    }
    return `
    query IntrospectionQuery {
      __schema {
        ${schemaDescription}
        queryType { name }
        mutationType { name }
        subscriptionType { name }
        types {
          ...FullType
        }
        directives {
          name
          ${descriptions}
          ${directiveIsRepeatable}
          locations
          args${inputDeprecation("(includeDeprecated: true)")} {
            ...InputValue
          }
        }
      }
    }

    fragment FullType on __Type {
      kind
      name
      ${descriptions}
      ${specifiedByUrl}
      fields(includeDeprecated: true) {
        name
        ${descriptions}
        args${inputDeprecation("(includeDeprecated: true)")} {
          ...InputValue
        }
        type {
          ...TypeRef
        }
        isDeprecated
        deprecationReason
      }
      inputFields${inputDeprecation("(includeDeprecated: true)")} {
        ...InputValue
      }
      interfaces {
        ...TypeRef
      }
      enumValues(includeDeprecated: true) {
        name
        ${descriptions}
        isDeprecated
        deprecationReason
      }
      possibleTypes {
        ...TypeRef
      }
    }

    fragment InputValue on __InputValue {
      name
      ${descriptions}
      type { ...TypeRef }
      defaultValue
      ${inputDeprecation("isDeprecated")}
      ${inputDeprecation("deprecationReason")}
    }

    fragment TypeRef on __Type {
      kind
      name
      ofType {
        kind
        name
        ofType {
          kind
          name
          ofType {
            kind
            name
            ofType {
              kind
              name
              ofType {
                kind
                name
                ofType {
                  kind
                  name
                  ofType {
                    kind
                    name
                    ofType {
                      kind
                      name
                      ofType {
                        kind
                        name
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  `;
}

});

parcelRegister("dy8yN", function(module, exports) {

$parcel$export(module.exports, "validateSchema", () => $f97f525a8965784f$export$4741711f07dbb8e7);
$parcel$export(module.exports, "assertValidSchema", () => $f97f525a8965784f$export$d32aa1886d3569c6);

var $gHwk7 = parcelRequire("gHwk7");

var $fHcz3 = parcelRequire("fHcz3");

var $8r1qs = parcelRequire("8r1qs");

var $f0jWA = parcelRequire("f0jWA");

var $54dWd = parcelRequire("54dWd");

var $9KaHw = parcelRequire("9KaHw");

var $jptTh = parcelRequire("jptTh");

var $3rrQl = parcelRequire("3rrQl");
function $f97f525a8965784f$export$4741711f07dbb8e7(schema) {
    // First check to ensure the provided value is in fact a GraphQLSchema.
    (0, $3rrQl.assertSchema)(schema); // If this Schema has already been validated, return the previous results.
    if (schema.__validationErrors) return schema.__validationErrors;
     // Validate the schema, producing a list of errors.
    const context = new $f97f525a8965784f$var$SchemaValidationContext(schema);
    $f97f525a8965784f$var$validateRootTypes(context);
    $f97f525a8965784f$var$validateDirectives(context);
    $f97f525a8965784f$var$validateTypes(context); // Persist the results of validation before returning to ensure validation
    // does not run multiple times for this schema.
    const errors = context.getErrors();
    schema.__validationErrors = errors;
    return errors;
}
function $f97f525a8965784f$export$d32aa1886d3569c6(schema) {
    const errors = $f97f525a8965784f$export$4741711f07dbb8e7(schema);
    if (errors.length !== 0) throw new Error(errors.map((error)=>error.message).join("\n\n"));
}
class $f97f525a8965784f$var$SchemaValidationContext {
    constructor(schema){
        this._errors = [];
        this.schema = schema;
    }
    reportError(message, nodes) {
        const _nodes = Array.isArray(nodes) ? nodes.filter(Boolean) : nodes;
        this._errors.push(new (0, $fHcz3.GraphQLError)(message, {
            nodes: _nodes
        }));
    }
    getErrors() {
        return this._errors;
    }
}
function $f97f525a8965784f$var$validateRootTypes(context) {
    const schema = context.schema;
    const queryType = schema.getQueryType();
    if (!queryType) context.reportError("Query root type must be provided.", schema.astNode);
    else if (!(0, $54dWd.isObjectType)(queryType)) {
        var _getOperationTypeNode;
        context.reportError(`Query root type must be Object type, it cannot be ${(0, $gHwk7.inspect)(queryType)}.`, (_getOperationTypeNode = $f97f525a8965784f$var$getOperationTypeNode(schema, (0, $8r1qs.OperationTypeNode).QUERY)) !== null && _getOperationTypeNode !== void 0 ? _getOperationTypeNode : queryType.astNode);
    }
    const mutationType = schema.getMutationType();
    if (mutationType && !(0, $54dWd.isObjectType)(mutationType)) {
        var _getOperationTypeNode2;
        context.reportError("Mutation root type must be Object type if provided, it cannot be " + `${(0, $gHwk7.inspect)(mutationType)}.`, (_getOperationTypeNode2 = $f97f525a8965784f$var$getOperationTypeNode(schema, (0, $8r1qs.OperationTypeNode).MUTATION)) !== null && _getOperationTypeNode2 !== void 0 ? _getOperationTypeNode2 : mutationType.astNode);
    }
    const subscriptionType = schema.getSubscriptionType();
    if (subscriptionType && !(0, $54dWd.isObjectType)(subscriptionType)) {
        var _getOperationTypeNode3;
        context.reportError("Subscription root type must be Object type if provided, it cannot be " + `${(0, $gHwk7.inspect)(subscriptionType)}.`, (_getOperationTypeNode3 = $f97f525a8965784f$var$getOperationTypeNode(schema, (0, $8r1qs.OperationTypeNode).SUBSCRIPTION)) !== null && _getOperationTypeNode3 !== void 0 ? _getOperationTypeNode3 : subscriptionType.astNode);
    }
}
function $f97f525a8965784f$var$getOperationTypeNode(schema, operation) {
    var _flatMap$find;
    return (_flatMap$find = [
        schema.astNode,
        ...schema.extensionASTNodes
    ].flatMap(// FIXME: https://github.com/graphql/graphql-js/issues/2203
    (schemaNode)=>{
        var _schemaNode$operation;
        return /* c8 ignore next */ (_schemaNode$operation = schemaNode === null || schemaNode === void 0 ? void 0 : schemaNode.operationTypes) !== null && _schemaNode$operation !== void 0 ? _schemaNode$operation : [];
    }).find((operationNode)=>operationNode.operation === operation)) === null || _flatMap$find === void 0 ? void 0 : _flatMap$find.type;
}
function $f97f525a8965784f$var$validateDirectives(context) {
    for (const directive of context.schema.getDirectives()){
        // Ensure all directives are in fact GraphQL directives.
        if (!(0, $9KaHw.isDirective)(directive)) {
            context.reportError(`Expected directive but got: ${(0, $gHwk7.inspect)(directive)}.`, directive === null || directive === void 0 ? void 0 : directive.astNode);
            continue;
        } // Ensure they are named correctly.
        $f97f525a8965784f$var$validateName(context, directive); // TODO: Ensure proper locations.
        // Ensure the arguments are valid.
        for (const arg of directive.args){
            // Ensure they are named correctly.
            $f97f525a8965784f$var$validateName(context, arg); // Ensure the type is an input type.
            if (!(0, $54dWd.isInputType)(arg.type)) context.reportError(`The type of @${directive.name}(${arg.name}:) must be Input Type ` + `but got: ${(0, $gHwk7.inspect)(arg.type)}.`, arg.astNode);
            if ((0, $54dWd.isRequiredArgument)(arg) && arg.deprecationReason != null) {
                var _arg$astNode;
                context.reportError(`Required argument @${directive.name}(${arg.name}:) cannot be deprecated.`, [
                    $f97f525a8965784f$var$getDeprecatedDirectiveNode(arg.astNode),
                    (_arg$astNode = arg.astNode) === null || _arg$astNode === void 0 ? void 0 : _arg$astNode.type
                ]);
            }
        }
    }
}
function $f97f525a8965784f$var$validateName(context, node) {
    // Ensure names are valid, however introspection types opt out.
    if (node.name.startsWith("__")) context.reportError(`Name "${node.name}" must not begin with "__", which is reserved by GraphQL introspection.`, node.astNode);
}
function $f97f525a8965784f$var$validateTypes(context) {
    const validateInputObjectCircularRefs = $f97f525a8965784f$var$createInputObjectCircularRefsValidator(context);
    const typeMap = context.schema.getTypeMap();
    for (const type of Object.values(typeMap)){
        // Ensure all provided types are in fact GraphQL type.
        if (!(0, $54dWd.isNamedType)(type)) {
            context.reportError(`Expected GraphQL named type but got: ${(0, $gHwk7.inspect)(type)}.`, type.astNode);
            continue;
        } // Ensure it is named correctly (excluding introspection types).
        if (!(0, $jptTh.isIntrospectionType)(type)) $f97f525a8965784f$var$validateName(context, type);
        if ((0, $54dWd.isObjectType)(type)) {
            // Ensure fields are valid
            $f97f525a8965784f$var$validateFields(context, type); // Ensure objects implement the interfaces they claim to.
            $f97f525a8965784f$var$validateInterfaces(context, type);
        } else if ((0, $54dWd.isInterfaceType)(type)) {
            // Ensure fields are valid.
            $f97f525a8965784f$var$validateFields(context, type); // Ensure interfaces implement the interfaces they claim to.
            $f97f525a8965784f$var$validateInterfaces(context, type);
        } else if ((0, $54dWd.isUnionType)(type)) // Ensure Unions include valid member types.
        $f97f525a8965784f$var$validateUnionMembers(context, type);
        else if ((0, $54dWd.isEnumType)(type)) // Ensure Enums have valid values.
        $f97f525a8965784f$var$validateEnumValues(context, type);
        else if ((0, $54dWd.isInputObjectType)(type)) {
            // Ensure Input Object fields are valid.
            $f97f525a8965784f$var$validateInputFields(context, type); // Ensure Input Objects do not contain non-nullable circular references
            validateInputObjectCircularRefs(type);
        }
    }
}
function $f97f525a8965784f$var$validateFields(context, type) {
    const fields = Object.values(type.getFields()); // Objects and Interfaces both must define one or more fields.
    if (fields.length === 0) context.reportError(`Type ${type.name} must define one or more fields.`, [
        type.astNode,
        ...type.extensionASTNodes
    ]);
    for (const field of fields){
        // Ensure they are named correctly.
        $f97f525a8965784f$var$validateName(context, field); // Ensure the type is an output type
        if (!(0, $54dWd.isOutputType)(field.type)) {
            var _field$astNode;
            context.reportError(`The type of ${type.name}.${field.name} must be Output Type ` + `but got: ${(0, $gHwk7.inspect)(field.type)}.`, (_field$astNode = field.astNode) === null || _field$astNode === void 0 ? void 0 : _field$astNode.type);
        } // Ensure the arguments are valid
        for (const arg of field.args){
            const argName = arg.name; // Ensure they are named correctly.
            $f97f525a8965784f$var$validateName(context, arg); // Ensure the type is an input type
            if (!(0, $54dWd.isInputType)(arg.type)) {
                var _arg$astNode2;
                context.reportError(`The type of ${type.name}.${field.name}(${argName}:) must be Input ` + `Type but got: ${(0, $gHwk7.inspect)(arg.type)}.`, (_arg$astNode2 = arg.astNode) === null || _arg$astNode2 === void 0 ? void 0 : _arg$astNode2.type);
            }
            if ((0, $54dWd.isRequiredArgument)(arg) && arg.deprecationReason != null) {
                var _arg$astNode3;
                context.reportError(`Required argument ${type.name}.${field.name}(${argName}:) cannot be deprecated.`, [
                    $f97f525a8965784f$var$getDeprecatedDirectiveNode(arg.astNode),
                    (_arg$astNode3 = arg.astNode) === null || _arg$astNode3 === void 0 ? void 0 : _arg$astNode3.type
                ]);
            }
        }
    }
}
function $f97f525a8965784f$var$validateInterfaces(context, type) {
    const ifaceTypeNames = Object.create(null);
    for (const iface of type.getInterfaces()){
        if (!(0, $54dWd.isInterfaceType)(iface)) {
            context.reportError(`Type ${(0, $gHwk7.inspect)(type)} must only implement Interface types, ` + `it cannot implement ${(0, $gHwk7.inspect)(iface)}.`, $f97f525a8965784f$var$getAllImplementsInterfaceNodes(type, iface));
            continue;
        }
        if (type === iface) {
            context.reportError(`Type ${type.name} cannot implement itself because it would create a circular reference.`, $f97f525a8965784f$var$getAllImplementsInterfaceNodes(type, iface));
            continue;
        }
        if (ifaceTypeNames[iface.name]) {
            context.reportError(`Type ${type.name} can only implement ${iface.name} once.`, $f97f525a8965784f$var$getAllImplementsInterfaceNodes(type, iface));
            continue;
        }
        ifaceTypeNames[iface.name] = true;
        $f97f525a8965784f$var$validateTypeImplementsAncestors(context, type, iface);
        $f97f525a8965784f$var$validateTypeImplementsInterface(context, type, iface);
    }
}
function $f97f525a8965784f$var$validateTypeImplementsInterface(context, type, iface) {
    const typeFieldMap = type.getFields(); // Assert each interface field is implemented.
    for (const ifaceField of Object.values(iface.getFields())){
        const fieldName = ifaceField.name;
        const typeField = typeFieldMap[fieldName]; // Assert interface field exists on type.
        if (!typeField) {
            context.reportError(`Interface field ${iface.name}.${fieldName} expected but ${type.name} does not provide it.`, [
                ifaceField.astNode,
                type.astNode,
                ...type.extensionASTNodes
            ]);
            continue;
        } // Assert interface field type is satisfied by type field type, by being
        // a valid subtype. (covariant)
        if (!(0, $f0jWA.isTypeSubTypeOf)(context.schema, typeField.type, ifaceField.type)) {
            var _ifaceField$astNode, _typeField$astNode;
            context.reportError(`Interface field ${iface.name}.${fieldName} expects type ` + `${(0, $gHwk7.inspect)(ifaceField.type)} but ${type.name}.${fieldName} ` + `is type ${(0, $gHwk7.inspect)(typeField.type)}.`, [
                (_ifaceField$astNode = ifaceField.astNode) === null || _ifaceField$astNode === void 0 ? void 0 : _ifaceField$astNode.type,
                (_typeField$astNode = typeField.astNode) === null || _typeField$astNode === void 0 ? void 0 : _typeField$astNode.type
            ]);
        } // Assert each interface field arg is implemented.
        for (const ifaceArg of ifaceField.args){
            const argName = ifaceArg.name;
            const typeArg = typeField.args.find((arg)=>arg.name === argName); // Assert interface field arg exists on object field.
            if (!typeArg) {
                context.reportError(`Interface field argument ${iface.name}.${fieldName}(${argName}:) expected but ${type.name}.${fieldName} does not provide it.`, [
                    ifaceArg.astNode,
                    typeField.astNode
                ]);
                continue;
            } // Assert interface field arg type matches object field arg type.
            // (invariant)
            // TODO: change to contravariant?
            if (!(0, $f0jWA.isEqualType)(ifaceArg.type, typeArg.type)) {
                var _ifaceArg$astNode, _typeArg$astNode;
                context.reportError(`Interface field argument ${iface.name}.${fieldName}(${argName}:) ` + `expects type ${(0, $gHwk7.inspect)(ifaceArg.type)} but ` + `${type.name}.${fieldName}(${argName}:) is type ` + `${(0, $gHwk7.inspect)(typeArg.type)}.`, [
                    (_ifaceArg$astNode = ifaceArg.astNode) === null || _ifaceArg$astNode === void 0 ? void 0 : _ifaceArg$astNode.type,
                    (_typeArg$astNode = typeArg.astNode) === null || _typeArg$astNode === void 0 ? void 0 : _typeArg$astNode.type
                ]);
            } // TODO: validate default values?
        } // Assert additional arguments must not be required.
        for (const typeArg of typeField.args){
            const argName = typeArg.name;
            const ifaceArg = ifaceField.args.find((arg)=>arg.name === argName);
            if (!ifaceArg && (0, $54dWd.isRequiredArgument)(typeArg)) context.reportError(`Object field ${type.name}.${fieldName} includes required argument ${argName} that is missing from the Interface field ${iface.name}.${fieldName}.`, [
                typeArg.astNode,
                ifaceField.astNode
            ]);
        }
    }
}
function $f97f525a8965784f$var$validateTypeImplementsAncestors(context, type, iface) {
    const ifaceInterfaces = type.getInterfaces();
    for (const transitive of iface.getInterfaces())if (!ifaceInterfaces.includes(transitive)) context.reportError(transitive === type ? `Type ${type.name} cannot implement ${iface.name} because it would create a circular reference.` : `Type ${type.name} must implement ${transitive.name} because it is implemented by ${iface.name}.`, [
        ...$f97f525a8965784f$var$getAllImplementsInterfaceNodes(iface, transitive),
        ...$f97f525a8965784f$var$getAllImplementsInterfaceNodes(type, iface)
    ]);
}
function $f97f525a8965784f$var$validateUnionMembers(context, union) {
    const memberTypes = union.getTypes();
    if (memberTypes.length === 0) context.reportError(`Union type ${union.name} must define one or more member types.`, [
        union.astNode,
        ...union.extensionASTNodes
    ]);
    const includedTypeNames = Object.create(null);
    for (const memberType of memberTypes){
        if (includedTypeNames[memberType.name]) {
            context.reportError(`Union type ${union.name} can only include type ${memberType.name} once.`, $f97f525a8965784f$var$getUnionMemberTypeNodes(union, memberType.name));
            continue;
        }
        includedTypeNames[memberType.name] = true;
        if (!(0, $54dWd.isObjectType)(memberType)) context.reportError(`Union type ${union.name} can only include Object types, ` + `it cannot include ${(0, $gHwk7.inspect)(memberType)}.`, $f97f525a8965784f$var$getUnionMemberTypeNodes(union, String(memberType)));
    }
}
function $f97f525a8965784f$var$validateEnumValues(context, enumType) {
    const enumValues = enumType.getValues();
    if (enumValues.length === 0) context.reportError(`Enum type ${enumType.name} must define one or more values.`, [
        enumType.astNode,
        ...enumType.extensionASTNodes
    ]);
    for (const enumValue of enumValues)// Ensure valid name.
    $f97f525a8965784f$var$validateName(context, enumValue);
}
function $f97f525a8965784f$var$validateInputFields(context, inputObj) {
    const fields = Object.values(inputObj.getFields());
    if (fields.length === 0) context.reportError(`Input Object type ${inputObj.name} must define one or more fields.`, [
        inputObj.astNode,
        ...inputObj.extensionASTNodes
    ]);
     // Ensure the arguments are valid
    for (const field of fields){
        // Ensure they are named correctly.
        $f97f525a8965784f$var$validateName(context, field); // Ensure the type is an input type
        if (!(0, $54dWd.isInputType)(field.type)) {
            var _field$astNode2;
            context.reportError(`The type of ${inputObj.name}.${field.name} must be Input Type ` + `but got: ${(0, $gHwk7.inspect)(field.type)}.`, (_field$astNode2 = field.astNode) === null || _field$astNode2 === void 0 ? void 0 : _field$astNode2.type);
        }
        if ((0, $54dWd.isRequiredInputField)(field) && field.deprecationReason != null) {
            var _field$astNode3;
            context.reportError(`Required input field ${inputObj.name}.${field.name} cannot be deprecated.`, [
                $f97f525a8965784f$var$getDeprecatedDirectiveNode(field.astNode),
                (_field$astNode3 = field.astNode) === null || _field$astNode3 === void 0 ? void 0 : _field$astNode3.type
            ]);
        }
    }
}
function $f97f525a8965784f$var$createInputObjectCircularRefsValidator(context) {
    // Modified copy of algorithm from 'src/validation/rules/NoFragmentCycles.js'.
    // Tracks already visited types to maintain O(N) and to ensure that cycles
    // are not redundantly reported.
    const visitedTypes = Object.create(null); // Array of types nodes used to produce meaningful errors
    const fieldPath = []; // Position in the type path
    const fieldPathIndexByTypeName = Object.create(null);
    return detectCycleRecursive; // This does a straight-forward DFS to find cycles.
    // It does not terminate when a cycle was found but continues to explore
    // the graph to find all possible cycles.
    function detectCycleRecursive(inputObj) {
        if (visitedTypes[inputObj.name]) return;
        visitedTypes[inputObj.name] = true;
        fieldPathIndexByTypeName[inputObj.name] = fieldPath.length;
        const fields = Object.values(inputObj.getFields());
        for (const field of fields)if ((0, $54dWd.isNonNullType)(field.type) && (0, $54dWd.isInputObjectType)(field.type.ofType)) {
            const fieldType = field.type.ofType;
            const cycleIndex = fieldPathIndexByTypeName[fieldType.name];
            fieldPath.push(field);
            if (cycleIndex === undefined) detectCycleRecursive(fieldType);
            else {
                const cyclePath = fieldPath.slice(cycleIndex);
                const pathStr = cyclePath.map((fieldObj)=>fieldObj.name).join(".");
                context.reportError(`Cannot reference Input Object "${fieldType.name}" within itself through a series of non-null fields: "${pathStr}".`, cyclePath.map((fieldObj)=>fieldObj.astNode));
            }
            fieldPath.pop();
        }
        fieldPathIndexByTypeName[inputObj.name] = undefined;
    }
}
function $f97f525a8965784f$var$getAllImplementsInterfaceNodes(type, iface) {
    const { astNode: astNode, extensionASTNodes: extensionASTNodes } = type;
    const nodes = astNode != null ? [
        astNode,
        ...extensionASTNodes
    ] : extensionASTNodes; // FIXME: https://github.com/graphql/graphql-js/issues/2203
    return nodes.flatMap((typeNode)=>{
        var _typeNode$interfaces;
        return /* c8 ignore next */ (_typeNode$interfaces = typeNode.interfaces) !== null && _typeNode$interfaces !== void 0 ? _typeNode$interfaces : [];
    }).filter((ifaceNode)=>ifaceNode.name.value === iface.name);
}
function $f97f525a8965784f$var$getUnionMemberTypeNodes(union, typeName) {
    const { astNode: astNode, extensionASTNodes: extensionASTNodes } = union;
    const nodes = astNode != null ? [
        astNode,
        ...extensionASTNodes
    ] : extensionASTNodes; // FIXME: https://github.com/graphql/graphql-js/issues/2203
    return nodes.flatMap((unionNode)=>{
        var _unionNode$types;
        return /* c8 ignore next */ (_unionNode$types = unionNode.types) !== null && _unionNode$types !== void 0 ? _unionNode$types : [];
    }).filter((typeNode)=>typeNode.name.value === typeName);
}
function $f97f525a8965784f$var$getDeprecatedDirectiveNode(definitionNode) {
    var _definitionNode$direc;
    return definitionNode === null || definitionNode === void 0 ? void 0 : (_definitionNode$direc = definitionNode.directives) === null || _definitionNode$direc === void 0 ? void 0 : _definitionNode$direc.find((node)=>node.name.value === (0, $9KaHw.GraphQLDeprecatedDirective).name);
}

});
parcelRegister("f0jWA", function(module, exports) {

$parcel$export(module.exports, "isEqualType", () => $7f46b4eea4bcb0a4$export$c8e484a9929e6d9f);
$parcel$export(module.exports, "isTypeSubTypeOf", () => $7f46b4eea4bcb0a4$export$c3f31adb68f3e853);
$parcel$export(module.exports, "doTypesOverlap", () => $7f46b4eea4bcb0a4$export$5e7a8ea86de754bd);

var $54dWd = parcelRequire("54dWd");
function $7f46b4eea4bcb0a4$export$c8e484a9929e6d9f(typeA, typeB) {
    // Equivalent types are equal.
    if (typeA === typeB) return true;
     // If either type is non-null, the other must also be non-null.
    if ((0, $54dWd.isNonNullType)(typeA) && (0, $54dWd.isNonNullType)(typeB)) return $7f46b4eea4bcb0a4$export$c8e484a9929e6d9f(typeA.ofType, typeB.ofType);
     // If either type is a list, the other must also be a list.
    if ((0, $54dWd.isListType)(typeA) && (0, $54dWd.isListType)(typeB)) return $7f46b4eea4bcb0a4$export$c8e484a9929e6d9f(typeA.ofType, typeB.ofType);
     // Otherwise the types are not equal.
    return false;
}
function $7f46b4eea4bcb0a4$export$c3f31adb68f3e853(schema, maybeSubType, superType) {
    // Equivalent type is a valid subtype
    if (maybeSubType === superType) return true;
     // If superType is non-null, maybeSubType must also be non-null.
    if ((0, $54dWd.isNonNullType)(superType)) {
        if ((0, $54dWd.isNonNullType)(maybeSubType)) return $7f46b4eea4bcb0a4$export$c3f31adb68f3e853(schema, maybeSubType.ofType, superType.ofType);
        return false;
    }
    if ((0, $54dWd.isNonNullType)(maybeSubType)) // If superType is nullable, maybeSubType may be non-null or nullable.
    return $7f46b4eea4bcb0a4$export$c3f31adb68f3e853(schema, maybeSubType.ofType, superType);
     // If superType type is a list, maybeSubType type must also be a list.
    if ((0, $54dWd.isListType)(superType)) {
        if ((0, $54dWd.isListType)(maybeSubType)) return $7f46b4eea4bcb0a4$export$c3f31adb68f3e853(schema, maybeSubType.ofType, superType.ofType);
        return false;
    }
    if ((0, $54dWd.isListType)(maybeSubType)) // If superType is not a list, maybeSubType must also be not a list.
    return false;
     // If superType type is an abstract type, check if it is super type of maybeSubType.
    // Otherwise, the child type is not a valid subtype of the parent type.
    return (0, $54dWd.isAbstractType)(superType) && ((0, $54dWd.isInterfaceType)(maybeSubType) || (0, $54dWd.isObjectType)(maybeSubType)) && schema.isSubType(superType, maybeSubType);
}
function $7f46b4eea4bcb0a4$export$5e7a8ea86de754bd(schema, typeA, typeB) {
    // Equivalent types overlap
    if (typeA === typeB) return true;
    if ((0, $54dWd.isAbstractType)(typeA)) {
        if ((0, $54dWd.isAbstractType)(typeB)) // If both types are abstract, then determine if there is any intersection
        // between possible concrete types of each.
        return schema.getPossibleTypes(typeA).some((type)=>schema.isSubType(typeB, type));
         // Determine if the latter type is a possible concrete type of the former.
        return schema.isSubType(typeA, typeB);
    }
    if ((0, $54dWd.isAbstractType)(typeB)) // Determine if the former type is a possible concrete type of the latter.
    return schema.isSubType(typeB, typeA);
     // Otherwise the types do not overlap.
    return false;
}

});


parcelRegister("9wOaz", function(module, exports) {
$parcel$export(module.exports, "fetcherReturnToPromise", () => (parcelRequire("2n7MZ")).fetcherReturnToPromise);
$parcel$export(module.exports, "isAsyncIterable", () => (parcelRequire("2n7MZ")).isAsyncIterable);
$parcel$export(module.exports, "isObservable", () => (parcelRequire("2n7MZ")).isObservable);
$parcel$export(module.exports, "isPromise", () => (parcelRequire("2n7MZ")).isPromise);
$parcel$export(module.exports, "createGraphiQLFetcher", () => (parcelRequire("gevl4")).createGraphiQLFetcher);
$parcel$export(module.exports, "formatError", () => (parcelRequire("a8KRF")).formatError);
$parcel$export(module.exports, "formatResult", () => (parcelRequire("a8KRF")).formatResult);
$parcel$export(module.exports, "fillLeafs", () => (parcelRequire("c9xw3")).fillLeafs);
$parcel$export(module.exports, "getSelectedOperationName", () => (parcelRequire("anr3h")).getSelectedOperationName);
$parcel$export(module.exports, "mergeAst", () => (parcelRequire("dhM2X")).mergeAst);
$parcel$export(module.exports, "HistoryStore", () => (parcelRequire("bWkaC")).HistoryStore);
$parcel$export(module.exports, "StorageAPI", () => (parcelRequire("5mhgG")).StorageAPI);
parcelRequire("2n7MZ");
parcelRequire("8f8Et");
parcelRequire("a8KRF");
parcelRequire("bI1EQ");
parcelRequire("aujiX");

});
parcelRegister("2n7MZ", function(module, exports) {

$parcel$export(module.exports, "isPromise", () => $1ba3c5826de35d7b$export$4369c812aac99591);
$parcel$export(module.exports, "isObservable", () => $1ba3c5826de35d7b$export$5cd057a6046189f9);
$parcel$export(module.exports, "isAsyncIterable", () => $1ba3c5826de35d7b$export$edb10ab8dd75a915);
$parcel$export(module.exports, "fetcherReturnToPromise", () => $1ba3c5826de35d7b$export$d7b1bba11630a247);
var $1ba3c5826de35d7b$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function $1ba3c5826de35d7b$export$4369c812aac99591(value) {
    return typeof value === "object" && value !== null && typeof value.then === "function";
}
function $1ba3c5826de35d7b$var$observableToPromise(observable) {
    return new Promise((resolve, reject)=>{
        const subscription = observable.subscribe({
            next (v) {
                resolve(v);
                subscription.unsubscribe();
            },
            error: reject,
            complete () {
                reject(new Error("no value resolved"));
            }
        });
    });
}
function $1ba3c5826de35d7b$export$5cd057a6046189f9(value) {
    return typeof value === "object" && value !== null && "subscribe" in value && typeof value.subscribe === "function";
}
function $1ba3c5826de35d7b$export$edb10ab8dd75a915(input) {
    return typeof input === "object" && input !== null && (input[Symbol.toStringTag] === "AsyncGenerator" || Symbol.asyncIterator in input);
}
function $1ba3c5826de35d7b$var$asyncIterableToPromise(input) {
    var _a;
    return $1ba3c5826de35d7b$var$__awaiter(this, void 0, void 0, function*() {
        const iteratorReturn = (_a = ("return" in input ? input : input[Symbol.asyncIterator]()).return) === null || _a === void 0 ? void 0 : _a.bind(input);
        const iteratorNext = ("next" in input ? input : input[Symbol.asyncIterator]()).next.bind(input);
        const result = yield iteratorNext();
        iteratorReturn === null || iteratorReturn === void 0 || iteratorReturn();
        return result.value;
    });
}
function $1ba3c5826de35d7b$export$d7b1bba11630a247(fetcherResult) {
    return $1ba3c5826de35d7b$var$__awaiter(this, void 0, void 0, function*() {
        const result = yield fetcherResult;
        if ($1ba3c5826de35d7b$export$edb10ab8dd75a915(result)) return $1ba3c5826de35d7b$var$asyncIterableToPromise(result);
        if ($1ba3c5826de35d7b$export$5cd057a6046189f9(result)) return $1ba3c5826de35d7b$var$observableToPromise(result);
        return result;
    });
}

});

parcelRegister("8f8Et", function(module, exports) {

$parcel$export(module.exports, "createGraphiQLFetcher", () => (parcelRequire("gevl4")).createGraphiQLFetcher);
parcelRequire("39kn4");

var $gevl4 = parcelRequire("gevl4");

});
parcelRegister("39kn4", function(module, exports) {

});

parcelRegister("gevl4", function(module, exports) {

$parcel$export(module.exports, "createGraphiQLFetcher", () => $bd16436a3844af5b$export$d546602d1ec411e2);

var $7redF = parcelRequire("7redF");
function $bd16436a3844af5b$export$d546602d1ec411e2(options) {
    let httpFetch;
    if (typeof window !== "undefined" && window.fetch) httpFetch = window.fetch;
    if ((options === null || options === void 0 ? void 0 : options.enableIncrementalDelivery) === null || options.enableIncrementalDelivery !== false) options.enableIncrementalDelivery = true;
    if (options.fetch) httpFetch = options.fetch;
    if (!httpFetch) throw new Error("No valid fetcher implementation available");
    const simpleFetcher = (0, $7redF.createSimpleFetcher)(options, httpFetch);
    const httpFetcher = options.enableIncrementalDelivery ? (0, $7redF.createMultipartFetcher)(options, httpFetch) : simpleFetcher;
    return (graphQLParams, fetcherOpts)=>{
        if (graphQLParams.operationName === "IntrospectionQuery") return (options.schemaFetcher || simpleFetcher)(graphQLParams, fetcherOpts);
        const isSubscription = (fetcherOpts === null || fetcherOpts === void 0 ? void 0 : fetcherOpts.documentAST) ? (0, $7redF.isSubscriptionWithName)(fetcherOpts.documentAST, graphQLParams.operationName || undefined) : false;
        if (isSubscription) {
            const wsFetcher = (0, $7redF.getWsFetcher)(options, fetcherOpts);
            if (!wsFetcher) throw new Error(`Your GraphiQL createFetcher is not properly configured for websocket subscriptions yet. ${options.subscriptionUrl ? `Provided URL ${options.subscriptionUrl} failed` : "Please provide subscriptionUrl, wsClient or legacyClient option first."}`);
            return wsFetcher(graphQLParams);
        }
        return httpFetcher(graphQLParams, fetcherOpts);
    };
}

});
parcelRegister("7redF", function(module, exports) {

$parcel$export(module.exports, "isSubscriptionWithName", () => $56a615b63cb40229$export$722d625010695a09);
$parcel$export(module.exports, "createSimpleFetcher", () => $56a615b63cb40229$export$4aabb0c4c66b7698);
$parcel$export(module.exports, "createMultipartFetcher", () => $56a615b63cb40229$export$faa74ea40065dadb);
$parcel$export(module.exports, "getWsFetcher", () => $56a615b63cb40229$export$17ebbd3d2fb95a47);

var $9m7aI = parcelRequire("9m7aI");

var $4gGkA = parcelRequire("4gGkA");

var $eQOpC = parcelRequire("eQOpC");
var $56a615b63cb40229$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $56a615b63cb40229$var$__await = undefined && undefined.__await || function(v) {
    return this instanceof $56a615b63cb40229$var$__await ? (this.v = v, this) : new $56a615b63cb40229$var$__await(v);
};
var $56a615b63cb40229$var$__asyncValues = undefined && undefined.__asyncValues || function(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
};
var $56a615b63cb40229$var$__asyncGenerator = undefined && undefined.__asyncGenerator || function(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $56a615b63cb40229$var$__await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
};
const $56a615b63cb40229$var$errorHasCode = (err)=>{
    return typeof err === "object" && err !== null && "code" in err;
};
const $56a615b63cb40229$export$722d625010695a09 = (document, name)=>{
    let isSubscription = false;
    (0, $9m7aI.visit)(document, {
        OperationDefinition (node) {
            var _a;
            if (name === ((_a = node.name) === null || _a === void 0 ? void 0 : _a.value) && node.operation === "subscription") isSubscription = true;
        }
    });
    return isSubscription;
};
const $56a615b63cb40229$export$4aabb0c4c66b7698 = (options, httpFetch)=>(graphQLParams, fetcherOpts)=>$56a615b63cb40229$var$__awaiter(void 0, void 0, void 0, function*() {
            const data = yield httpFetch(options.url, {
                method: "POST",
                body: JSON.stringify(graphQLParams),
                headers: Object.assign(Object.assign({
                    "content-type": "application/json"
                }, options.headers), fetcherOpts === null || fetcherOpts === void 0 ? void 0 : fetcherOpts.headers)
            });
            return data.json();
        });

const $56a615b63cb40229$export$96fca0851a7c716b = (url, connectionParams)=>{
    let wsClient;
    try {
        const { createClient: createClient } = $56a615b63cb40229$import$b43da0327eef1823;
        wsClient = createClient({
            url: url,
            connectionParams: connectionParams
        });
        return $56a615b63cb40229$export$e8d057bb84711f30(wsClient);
    } catch (err) {
        if ($56a615b63cb40229$var$errorHasCode(err) && err.code === "MODULE_NOT_FOUND") throw new Error("You need to install the 'graphql-ws' package to use websockets when passing a 'subscriptionUrl'");
        console.error(`Error creating websocket client for ${url}`, err);
    }
};
const $56a615b63cb40229$export$e8d057bb84711f30 = (wsClient)=>(graphQLParams)=>(0, $eQOpC.makeAsyncIterableIteratorFromSink)((sink)=>wsClient.subscribe(graphQLParams, Object.assign(Object.assign({}, sink), {
                error (err) {
                    if (err instanceof CloseEvent) sink.error(new Error(`Socket closed with event ${err.code} ${err.reason || ""}`.trim()));
                    else sink.error(err);
                }
            })));
const $56a615b63cb40229$export$912146aaf2c4a181 = (legacyWsClient)=>(graphQLParams)=>{
        const observable = legacyWsClient.request(graphQLParams);
        return (0, $eQOpC.makeAsyncIterableIteratorFromSink)((sink)=>observable.subscribe(sink).unsubscribe);
    };
const $56a615b63cb40229$export$faa74ea40065dadb = (options, httpFetch)=>function(graphQLParams, fetcherOpts) {
        return $56a615b63cb40229$var$__asyncGenerator(this, arguments, function*() {
            var e_1, _a;
            const response = yield $56a615b63cb40229$var$__await(httpFetch(options.url, {
                method: "POST",
                body: JSON.stringify(graphQLParams),
                headers: Object.assign(Object.assign({
                    "content-type": "application/json",
                    accept: "application/json, multipart/mixed"
                }, options.headers), fetcherOpts === null || fetcherOpts === void 0 ? void 0 : fetcherOpts.headers)
            }).then((r)=>(0, $4gGkA.meros)(r, {
                    multiple: true
                })));
            if (!(0, $eQOpC.isAsyncIterable)(response)) return yield $56a615b63cb40229$var$__await((yield yield $56a615b63cb40229$var$__await(response.json())));
            try {
                for(var response_1 = $56a615b63cb40229$var$__asyncValues(response), response_1_1; response_1_1 = yield $56a615b63cb40229$var$__await(response_1.next()), !response_1_1.done;){
                    const chunk = response_1_1.value;
                    if (chunk.some((part)=>!part.json)) {
                        const message = chunk.map((part)=>`Headers::\n${part.headers}\n\nBody::\n${part.body}`);
                        throw new Error(`Expected multipart chunks to be of json type. got:\n${message}`);
                    }
                    yield yield $56a615b63cb40229$var$__await(chunk.map((part)=>part.body));
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (response_1_1 && !response_1_1.done && (_a = response_1.return)) yield $56a615b63cb40229$var$__await(_a.call(response_1));
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
        });
    };
const $56a615b63cb40229$export$17ebbd3d2fb95a47 = (options, fetcherOpts)=>{
    if (options.wsClient) return $56a615b63cb40229$export$e8d057bb84711f30(options.wsClient);
    if (options.subscriptionUrl) return $56a615b63cb40229$export$96fca0851a7c716b(options.subscriptionUrl, Object.assign(Object.assign({}, options.wsConnectionParams), fetcherOpts === null || fetcherOpts === void 0 ? void 0 : fetcherOpts.headers));
    const legacyWebsocketsClient = options.legacyClient || options.legacyWsClient;
    if (legacyWebsocketsClient) return $56a615b63cb40229$export$912146aaf2c4a181(legacyWebsocketsClient);
};

});
parcelRegister("4gGkA", function(module, exports) {

$parcel$export(module.exports, "meros", () => $d56d91403a5b6ca5$export$74e0a034be2368c7);
var $d56d91403a5b6ca5$var$e = new TextDecoder;
async function $d56d91403a5b6ca5$export$74e0a034be2368c7(t, n) {
    if (!t.ok || !t.body || t.bodyUsed) return t;
    let i = t.headers.get("content-type");
    if (!i || !~i.indexOf("multipart/")) return t;
    let l = i.indexOf("boundary="), r = "-";
    if (~l) {
        let e = l + 9, t = i.indexOf(";", e);
        r = i.slice(e, t > -1 ? t : void 0).trim().replace(/"/g, "");
    }
    return async function*(t, n, i) {
        let l, r, d, o = t.getReader(), a = !i || !i.multiple, f = n.length, s = "", c = [];
        try {
            let t;
            e: for(; !(t = await o.read()).done;){
                let i = $d56d91403a5b6ca5$var$e.decode(t.value);
                l = s.length, s += i;
                let o = i.indexOf(n);
                for(~o ? l += o : l = s.indexOf(n), c = []; ~l;){
                    let e = s.slice(0, l), t = s.slice(l + f);
                    if (r) {
                        let n = e.indexOf("\r\n\r\n") + 4, i = e.lastIndexOf("\r\n", n), l = !1, r = e.slice(n, i > -1 ? void 0 : i), o = String(e.slice(0, n)).trim().split("\r\n"), f = {}, s = o.length;
                        for(; d = o[--s]; d = d.split(": "), f[d.shift().toLowerCase()] = d.join(": "));
                        if (d = f["content-type"], d && ~d.indexOf("application/json")) try {
                            r = JSON.parse(r), l = !0;
                        } catch (e) {}
                        if (d = {
                            headers: f,
                            body: r,
                            json: l
                        }, a ? yield d : c.push(d), "--" === t.slice(0, 2)) break e;
                    } else n = "\r\n" + n, r = f += 2;
                    s = t, l = s.indexOf(n);
                }
                c.length && (yield c);
            }
        } finally{
            c.length && (yield c), await o.cancel();
        }
    }(t.body, `--${r}`, n);
}

});

parcelRegister("eQOpC", function(module, exports) {

$parcel$export(module.exports, "makeAsyncIterableIteratorFromSink", () => $dd9acf81a197a35b$export$e39365dd55ddb6b5);
$parcel$export(module.exports, "isAsyncIterable", () => $dd9acf81a197a35b$export$edb10ab8dd75a915);
/**
 * Attaches a cleanup handler to a AsyncIterable.
 *
 * @param source The source that should have a return handler attached
 * @param onReturn The return handler that should be attached
 * @returns
 */ function $dd9acf81a197a35b$export$6694f59f66b0d5e5(source, onReturn, onThrow) {
    const stream = async function* withReturnSource() {
        yield* source;
    }();
    const originalReturn = stream.return.bind(stream);
    if (onReturn) stream.return = (...args)=>{
        onReturn();
        return originalReturn(...args);
    };
    if (onThrow) {
        const originalThrow = stream.throw.bind(stream);
        stream.throw = (err)=>{
            onThrow(err);
            return originalThrow(err);
        };
    }
    return stream;
}
function $dd9acf81a197a35b$var$createDeferred() {
    const d = {};
    d.promise = new Promise((resolve, reject)=>{
        d.resolve = resolve;
        d.reject = reject;
    });
    return d;
}
/**
 * makePushPullAsyncIterableIterator
 *
 * The iterable will publish values until return or throw is called.
 * Afterwards it is in the completed state and cannot be used for publishing any further values.
 * It will handle back-pressure and keep pushed values until they are consumed by a source.
 */ function $dd9acf81a197a35b$export$4b869c90645c701f() {
    let state = {
        type: "running" /* running */ 
    };
    let next = $dd9acf81a197a35b$var$createDeferred();
    const values = [];
    function pushValue(value) {
        if (state.type !== "running" /* running */ ) return;
        values.push(value);
        next.resolve();
        next = $dd9acf81a197a35b$var$createDeferred();
    }
    const source = async function* PushPullAsyncIterableIterator() {
        while(true)if (values.length > 0) // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        yield values.shift();
        else {
            if (state.type === "error" /* error */ ) throw state.error;
            if (state.type === "finished" /* finished */ ) return;
            await next.promise;
        }
    }();
    const stream = $dd9acf81a197a35b$export$6694f59f66b0d5e5(source, ()=>{
        if (state.type !== "running" /* running */ ) return;
        state = {
            type: "finished" /* finished */ 
        };
        next.resolve();
    }, (error)=>{
        if (state.type !== "running" /* running */ ) return;
        state = {
            type: "error" /* error */ ,
            error: error
        };
        next.resolve();
    });
    return {
        pushValue: pushValue,
        asyncIterableIterator: stream
    };
}
const $dd9acf81a197a35b$export$e39365dd55ddb6b5 = (make)=>{
    const { pushValue: pushValue, asyncIterableIterator: asyncIterableIterator } = $dd9acf81a197a35b$export$4b869c90645c701f();
    const dispose = make({
        next: (value)=>{
            pushValue(value);
        },
        complete: ()=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            asyncIterableIterator.return();
        },
        error: (err)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            asyncIterableIterator.throw(err);
        }
    });
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const originalReturn = asyncIterableIterator.return;
    let returnValue = undefined;
    asyncIterableIterator.return = ()=>{
        if (returnValue === undefined) {
            dispose();
            returnValue = originalReturn();
        }
        return returnValue;
    };
    return asyncIterableIterator;
};
function $dd9acf81a197a35b$export$a50bed4837a09f57(asyncIterableIterator, sink) {
    const run = async ()=>{
        try {
            for await (const value of asyncIterableIterator)sink.next(value);
            sink.complete();
        } catch (err) {
            sink.error(err);
        }
    };
    run();
    return ()=>{
        var _a;
        (_a = asyncIterableIterator.return) === null || _a === void 0 || _a.call(asyncIterableIterator);
    };
}
function $dd9acf81a197a35b$export$edb10ab8dd75a915(input) {
    return typeof input === "object" && input !== null && // The AsyncGenerator check is for Safari on iOS which currently does not have
    // Symbol.asyncIterator implemented
    // That means every custom AsyncIterable must be built using a AsyncGeneratorFunction (async function * () {})
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (input[Symbol.toStringTag] === "AsyncGenerator" || Symbol.asyncIterator && Symbol.asyncIterator in input);
}
/**
 * Attaches a cleanup handler from and AsyncIterable to an AsyncIterable.
 *
 * @param source
 * @param target
 */ function $dd9acf81a197a35b$export$d36d986746ec826c(/** The source that should be returned with attached handlers. */ source, /**The target on which the return and throw methods should be called. */ target) {
    return $dd9acf81a197a35b$export$6694f59f66b0d5e5(source, ()=>{
        var _a;
        return (_a = target.return) === null || _a === void 0 ? void 0 : _a.call(target);
    }, (err)=>{
        var _a;
        return (_a = target.throw) === null || _a === void 0 ? void 0 : _a.call(target, err);
    });
}
function $dd9acf81a197a35b$export$3dea766d36a8935f(filter) {
    return async function* filterGenerator(asyncIterable) {
        for await (const value of asyncIterable)if (filter(value)) yield value;
    };
}
/**
 * Map the events published by an AsyncIterable.
 */ const $dd9acf81a197a35b$export$871de8747c9eaa88 = (map)=>async function* mapGenerator(asyncIterable) {
        for await (const value of asyncIterable)yield map(value);
    };

});




parcelRegister("a8KRF", function(module, exports) {

$parcel$export(module.exports, "formatError", () => $761f01140f384084$export$7b5b869ee98c16ab);
$parcel$export(module.exports, "formatResult", () => $761f01140f384084$export$38b2987769816e9a);
function $761f01140f384084$var$stringify(obj) {
    return JSON.stringify(obj, null, 2);
}
function $761f01140f384084$var$formatSingleError(error) {
    return Object.assign(Object.assign({}, error), {
        message: error.message,
        stack: error.stack
    });
}
function $761f01140f384084$var$handleSingleError(error) {
    if (error instanceof Error) return $761f01140f384084$var$formatSingleError(error);
    return error;
}
function $761f01140f384084$export$7b5b869ee98c16ab(error) {
    if (Array.isArray(error)) return $761f01140f384084$var$stringify({
        errors: error.map((e)=>$761f01140f384084$var$handleSingleError(e))
    });
    return $761f01140f384084$var$stringify({
        errors: [
            $761f01140f384084$var$handleSingleError(error)
        ]
    });
}
function $761f01140f384084$export$38b2987769816e9a(result) {
    return $761f01140f384084$var$stringify(result);
}

});

parcelRegister("bI1EQ", function(module, exports) {
$parcel$export(module.exports, "fillLeafs", () => (parcelRequire("c9xw3")).fillLeafs);
$parcel$export(module.exports, "mergeAst", () => (parcelRequire("dhM2X")).mergeAst);
$parcel$export(module.exports, "getSelectedOperationName", () => (parcelRequire("anr3h")).getSelectedOperationName);
parcelRequire("c9xw3");
parcelRequire("dhM2X");
parcelRequire("anr3h");

});
parcelRegister("c9xw3", function(module, exports) {

$parcel$export(module.exports, "fillLeafs", () => $8d9052dadb6df813$export$81a2216aaf75a45d);

var $54dWd = parcelRequire("54dWd");
var $hu3w4 = parcelRequire("hu3w4");
var $8DJ2k = parcelRequire("8DJ2k");
var $3o9dz = parcelRequire("3o9dz");
var $eEwlA = parcelRequire("eEwlA");
var $9m7aI = parcelRequire("9m7aI");
function $8d9052dadb6df813$export$81a2216aaf75a45d(schema, docString, getDefaultFieldNames) {
    const insertions = [];
    if (!schema || !docString) return {
        insertions: insertions,
        result: docString
    };
    let ast;
    try {
        ast = (0, $8DJ2k.parse)(docString);
    } catch (_a) {
        return {
            insertions: insertions,
            result: docString
        };
    }
    const fieldNameFn = getDefaultFieldNames || $8d9052dadb6df813$var$defaultGetDefaultFieldNames;
    const typeInfo = new (0, $eEwlA.TypeInfo)(schema);
    (0, $9m7aI.visit)(ast, {
        leave (node) {
            typeInfo.leave(node);
        },
        enter (node) {
            typeInfo.enter(node);
            if (node.kind === "Field" && !node.selectionSet) {
                const fieldType = typeInfo.getType();
                const selectionSet = $8d9052dadb6df813$var$buildSelectionSet($8d9052dadb6df813$var$isFieldType(fieldType), fieldNameFn);
                if (selectionSet && node.loc) {
                    const indent = $8d9052dadb6df813$var$getIndentation(docString, node.loc.start);
                    insertions.push({
                        index: node.loc.end,
                        string: " " + (0, $3o9dz.print)(selectionSet).replaceAll("\n", "\n" + indent)
                    });
                }
            }
        }
    });
    return {
        insertions: insertions,
        result: $8d9052dadb6df813$var$withInsertions(docString, insertions)
    };
}
function $8d9052dadb6df813$var$defaultGetDefaultFieldNames(type) {
    if (!("getFields" in type)) return [];
    const fields = type.getFields();
    if (fields.id) return [
        "id"
    ];
    if (fields.edges) return [
        "edges"
    ];
    if (fields.node) return [
        "node"
    ];
    const leafFieldNames = [];
    for (const fieldName of Object.keys(fields))if ((0, $54dWd.isLeafType)(fields[fieldName].type)) leafFieldNames.push(fieldName);
    return leafFieldNames;
}
function $8d9052dadb6df813$var$buildSelectionSet(type, getDefaultFieldNames) {
    const namedType = (0, $54dWd.getNamedType)(type);
    if (!type || (0, $54dWd.isLeafType)(type)) return;
    const fieldNames = getDefaultFieldNames(namedType);
    if (!Array.isArray(fieldNames) || fieldNames.length === 0 || !("getFields" in namedType)) return;
    return {
        kind: (0, $hu3w4.Kind).SELECTION_SET,
        selections: fieldNames.map((fieldName)=>{
            const fieldDef = namedType.getFields()[fieldName];
            const fieldType = fieldDef ? fieldDef.type : null;
            return {
                kind: (0, $hu3w4.Kind).FIELD,
                name: {
                    kind: (0, $hu3w4.Kind).NAME,
                    value: fieldName
                },
                selectionSet: $8d9052dadb6df813$var$buildSelectionSet(fieldType, getDefaultFieldNames)
            };
        })
    };
}
function $8d9052dadb6df813$var$withInsertions(initial, insertions) {
    if (insertions.length === 0) return initial;
    let edited = "";
    let prevIndex = 0;
    for (const { index: index, string: string } of insertions){
        edited += initial.slice(prevIndex, index) + string;
        prevIndex = index;
    }
    edited += initial.slice(prevIndex);
    return edited;
}
function $8d9052dadb6df813$var$getIndentation(str, index) {
    let indentStart = index;
    let indentEnd = index;
    while(indentStart){
        const c = str.charCodeAt(indentStart - 1);
        if (c === 10 || c === 13 || c === 0x2028 || c === 0x2029) break;
        indentStart--;
        if (c !== 9 && c !== 11 && c !== 12 && c !== 32 && c !== 160) indentEnd = indentStart;
    }
    return str.slice(indentStart, indentEnd);
}
function $8d9052dadb6df813$var$isFieldType(fieldType) {
    if (fieldType) return fieldType;
}

});
parcelRegister("eEwlA", function(module, exports) {

$parcel$export(module.exports, "TypeInfo", () => $c920d5bd5120e88f$export$f0c1fe746ce4bb1e);
$parcel$export(module.exports, "visitWithTypeInfo", () => $c920d5bd5120e88f$export$18ca434620348336);

var $8r1qs = parcelRequire("8r1qs");

var $hu3w4 = parcelRequire("hu3w4");

var $9m7aI = parcelRequire("9m7aI");

var $54dWd = parcelRequire("54dWd");

var $jptTh = parcelRequire("jptTh");

var $IvZa0 = parcelRequire("IvZa0");
class $c920d5bd5120e88f$export$f0c1fe746ce4bb1e {
    constructor(schema, /**
     * Initial type may be provided in rare cases to facilitate traversals
     *  beginning somewhere other than documents.
     */ initialType, /** @deprecated will be removed in 17.0.0 */ getFieldDefFn){
        this._schema = schema;
        this._typeStack = [];
        this._parentTypeStack = [];
        this._inputTypeStack = [];
        this._fieldDefStack = [];
        this._defaultValueStack = [];
        this._directive = null;
        this._argument = null;
        this._enumValue = null;
        this._getFieldDef = getFieldDefFn !== null && getFieldDefFn !== void 0 ? getFieldDefFn : $c920d5bd5120e88f$var$getFieldDef;
        if (initialType) {
            if ((0, $54dWd.isInputType)(initialType)) this._inputTypeStack.push(initialType);
            if ((0, $54dWd.isCompositeType)(initialType)) this._parentTypeStack.push(initialType);
            if ((0, $54dWd.isOutputType)(initialType)) this._typeStack.push(initialType);
        }
    }
    get [Symbol.toStringTag]() {
        return "TypeInfo";
    }
    getType() {
        if (this._typeStack.length > 0) return this._typeStack[this._typeStack.length - 1];
    }
    getParentType() {
        if (this._parentTypeStack.length > 0) return this._parentTypeStack[this._parentTypeStack.length - 1];
    }
    getInputType() {
        if (this._inputTypeStack.length > 0) return this._inputTypeStack[this._inputTypeStack.length - 1];
    }
    getParentInputType() {
        if (this._inputTypeStack.length > 1) return this._inputTypeStack[this._inputTypeStack.length - 2];
    }
    getFieldDef() {
        if (this._fieldDefStack.length > 0) return this._fieldDefStack[this._fieldDefStack.length - 1];
    }
    getDefaultValue() {
        if (this._defaultValueStack.length > 0) return this._defaultValueStack[this._defaultValueStack.length - 1];
    }
    getDirective() {
        return this._directive;
    }
    getArgument() {
        return this._argument;
    }
    getEnumValue() {
        return this._enumValue;
    }
    enter(node) {
        const schema = this._schema; // Note: many of the types below are explicitly typed as "unknown" to drop
        // any assumptions of a valid schema to ensure runtime types are properly
        // checked before continuing since TypeInfo is used as part of validation
        // which occurs before guarantees of schema and document validity.
        switch(node.kind){
            case (0, $hu3w4.Kind).SELECTION_SET:
                {
                    const namedType = (0, $54dWd.getNamedType)(this.getType());
                    this._parentTypeStack.push((0, $54dWd.isCompositeType)(namedType) ? namedType : undefined);
                    break;
                }
            case (0, $hu3w4.Kind).FIELD:
                {
                    const parentType = this.getParentType();
                    let fieldDef;
                    let fieldType;
                    if (parentType) {
                        fieldDef = this._getFieldDef(schema, parentType, node);
                        if (fieldDef) fieldType = fieldDef.type;
                    }
                    this._fieldDefStack.push(fieldDef);
                    this._typeStack.push((0, $54dWd.isOutputType)(fieldType) ? fieldType : undefined);
                    break;
                }
            case (0, $hu3w4.Kind).DIRECTIVE:
                this._directive = schema.getDirective(node.name.value);
                break;
            case (0, $hu3w4.Kind).OPERATION_DEFINITION:
                {
                    const rootType = schema.getRootType(node.operation);
                    this._typeStack.push((0, $54dWd.isObjectType)(rootType) ? rootType : undefined);
                    break;
                }
            case (0, $hu3w4.Kind).INLINE_FRAGMENT:
            case (0, $hu3w4.Kind).FRAGMENT_DEFINITION:
                {
                    const typeConditionAST = node.typeCondition;
                    const outputType = typeConditionAST ? (0, $IvZa0.typeFromAST)(schema, typeConditionAST) : (0, $54dWd.getNamedType)(this.getType());
                    this._typeStack.push((0, $54dWd.isOutputType)(outputType) ? outputType : undefined);
                    break;
                }
            case (0, $hu3w4.Kind).VARIABLE_DEFINITION:
                {
                    const inputType = (0, $IvZa0.typeFromAST)(schema, node.type);
                    this._inputTypeStack.push((0, $54dWd.isInputType)(inputType) ? inputType : undefined);
                    break;
                }
            case (0, $hu3w4.Kind).ARGUMENT:
                {
                    var _this$getDirective;
                    let argDef;
                    let argType;
                    const fieldOrDirective = (_this$getDirective = this.getDirective()) !== null && _this$getDirective !== void 0 ? _this$getDirective : this.getFieldDef();
                    if (fieldOrDirective) {
                        argDef = fieldOrDirective.args.find((arg)=>arg.name === node.name.value);
                        if (argDef) argType = argDef.type;
                    }
                    this._argument = argDef;
                    this._defaultValueStack.push(argDef ? argDef.defaultValue : undefined);
                    this._inputTypeStack.push((0, $54dWd.isInputType)(argType) ? argType : undefined);
                    break;
                }
            case (0, $hu3w4.Kind).LIST:
                {
                    const listType = (0, $54dWd.getNullableType)(this.getInputType());
                    const itemType = (0, $54dWd.isListType)(listType) ? listType.ofType : listType; // List positions never have a default value.
                    this._defaultValueStack.push(undefined);
                    this._inputTypeStack.push((0, $54dWd.isInputType)(itemType) ? itemType : undefined);
                    break;
                }
            case (0, $hu3w4.Kind).OBJECT_FIELD:
                {
                    const objectType = (0, $54dWd.getNamedType)(this.getInputType());
                    let inputFieldType;
                    let inputField;
                    if ((0, $54dWd.isInputObjectType)(objectType)) {
                        inputField = objectType.getFields()[node.name.value];
                        if (inputField) inputFieldType = inputField.type;
                    }
                    this._defaultValueStack.push(inputField ? inputField.defaultValue : undefined);
                    this._inputTypeStack.push((0, $54dWd.isInputType)(inputFieldType) ? inputFieldType : undefined);
                    break;
                }
            case (0, $hu3w4.Kind).ENUM:
                {
                    const enumType = (0, $54dWd.getNamedType)(this.getInputType());
                    let enumValue;
                    if ((0, $54dWd.isEnumType)(enumType)) enumValue = enumType.getValue(node.value);
                    this._enumValue = enumValue;
                    break;
                }
            default:
        }
    }
    leave(node) {
        switch(node.kind){
            case (0, $hu3w4.Kind).SELECTION_SET:
                this._parentTypeStack.pop();
                break;
            case (0, $hu3w4.Kind).FIELD:
                this._fieldDefStack.pop();
                this._typeStack.pop();
                break;
            case (0, $hu3w4.Kind).DIRECTIVE:
                this._directive = null;
                break;
            case (0, $hu3w4.Kind).OPERATION_DEFINITION:
            case (0, $hu3w4.Kind).INLINE_FRAGMENT:
            case (0, $hu3w4.Kind).FRAGMENT_DEFINITION:
                this._typeStack.pop();
                break;
            case (0, $hu3w4.Kind).VARIABLE_DEFINITION:
                this._inputTypeStack.pop();
                break;
            case (0, $hu3w4.Kind).ARGUMENT:
                this._argument = null;
                this._defaultValueStack.pop();
                this._inputTypeStack.pop();
                break;
            case (0, $hu3w4.Kind).LIST:
            case (0, $hu3w4.Kind).OBJECT_FIELD:
                this._defaultValueStack.pop();
                this._inputTypeStack.pop();
                break;
            case (0, $hu3w4.Kind).ENUM:
                this._enumValue = null;
                break;
            default:
        }
    }
}
/**
 * Not exactly the same as the executor's definition of getFieldDef, in this
 * statically evaluated environment we do not always have an Object type,
 * and need to handle Interface and Union types.
 */ function $c920d5bd5120e88f$var$getFieldDef(schema, parentType, fieldNode) {
    const name = fieldNode.name.value;
    if (name === (0, $jptTh.SchemaMetaFieldDef).name && schema.getQueryType() === parentType) return 0, $jptTh.SchemaMetaFieldDef;
    if (name === (0, $jptTh.TypeMetaFieldDef).name && schema.getQueryType() === parentType) return 0, $jptTh.TypeMetaFieldDef;
    if (name === (0, $jptTh.TypeNameMetaFieldDef).name && (0, $54dWd.isCompositeType)(parentType)) return 0, $jptTh.TypeNameMetaFieldDef;
    if ((0, $54dWd.isObjectType)(parentType) || (0, $54dWd.isInterfaceType)(parentType)) return parentType.getFields()[name];
}
function $c920d5bd5120e88f$export$18ca434620348336(typeInfo, visitor) {
    return {
        enter (...args) {
            const node = args[0];
            typeInfo.enter(node);
            const fn = (0, $9m7aI.getEnterLeaveForKind)(visitor, node.kind).enter;
            if (fn) {
                const result = fn.apply(visitor, args);
                if (result !== undefined) {
                    typeInfo.leave(node);
                    if ((0, $8r1qs.isNode)(result)) typeInfo.enter(result);
                }
                return result;
            }
        },
        leave (...args) {
            const node = args[0];
            const fn = (0, $9m7aI.getEnterLeaveForKind)(visitor, node.kind).leave;
            let result;
            if (fn) result = fn.apply(visitor, args);
            typeInfo.leave(node);
            return result;
        }
    };
}

});
parcelRegister("IvZa0", function(module, exports) {

$parcel$export(module.exports, "typeFromAST", () => $a0486b4d2a27e4f4$export$292685f75a322892);

var $hu3w4 = parcelRequire("hu3w4");

var $54dWd = parcelRequire("54dWd");
function $a0486b4d2a27e4f4$export$292685f75a322892(schema, typeNode) {
    switch(typeNode.kind){
        case (0, $hu3w4.Kind).LIST_TYPE:
            {
                const innerType = $a0486b4d2a27e4f4$export$292685f75a322892(schema, typeNode.type);
                return innerType && new (0, $54dWd.GraphQLList)(innerType);
            }
        case (0, $hu3w4.Kind).NON_NULL_TYPE:
            {
                const innerType = $a0486b4d2a27e4f4$export$292685f75a322892(schema, typeNode.type);
                return innerType && new (0, $54dWd.GraphQLNonNull)(innerType);
            }
        case (0, $hu3w4.Kind).NAMED_TYPE:
            return schema.getType(typeNode.name.value);
    }
}

});



parcelRegister("dhM2X", function(module, exports) {

$parcel$export(module.exports, "mergeAst", () => $9ac221f848060cc0$export$56ff9a5fb4cf521b);

var $54dWd = parcelRequire("54dWd");
var $hu3w4 = parcelRequire("hu3w4");
var $eEwlA = parcelRequire("eEwlA");
var $9m7aI = parcelRequire("9m7aI");
function $9ac221f848060cc0$var$uniqueBy(array, iteratee) {
    var _a;
    const FilteredMap = new Map();
    const result = [];
    for (const item of array)if (item.kind === "Field") {
        const uniqueValue = iteratee(item);
        const existing = FilteredMap.get(uniqueValue);
        if ((_a = item.directives) === null || _a === void 0 ? void 0 : _a.length) {
            const itemClone = Object.assign({}, item);
            result.push(itemClone);
        } else if ((existing === null || existing === void 0 ? void 0 : existing.selectionSet) && item.selectionSet) existing.selectionSet.selections = [
            ...existing.selectionSet.selections,
            ...item.selectionSet.selections
        ];
        else if (!existing) {
            const itemClone = Object.assign({}, item);
            FilteredMap.set(uniqueValue, itemClone);
            result.push(itemClone);
        }
    } else result.push(item);
    return result;
}
function $9ac221f848060cc0$var$inlineRelevantFragmentSpreads(fragmentDefinitions, selections, selectionSetType) {
    var _a;
    const selectionSetTypeName = selectionSetType ? (0, $54dWd.getNamedType)(selectionSetType).name : null;
    const outputSelections = [];
    const seenSpreads = [];
    for (let selection of selections){
        if (selection.kind === "FragmentSpread") {
            const fragmentName = selection.name.value;
            if (!selection.directives || selection.directives.length === 0) {
                if (seenSpreads.includes(fragmentName)) continue;
                else seenSpreads.push(fragmentName);
            }
            const fragmentDefinition = fragmentDefinitions[selection.name.value];
            if (fragmentDefinition) {
                const { typeCondition: typeCondition, directives: directives, selectionSet: selectionSet } = fragmentDefinition;
                selection = {
                    kind: (0, $hu3w4.Kind).INLINE_FRAGMENT,
                    typeCondition: typeCondition,
                    directives: directives,
                    selectionSet: selectionSet
                };
            }
        }
        if (selection.kind === (0, $hu3w4.Kind).INLINE_FRAGMENT && (!selection.directives || ((_a = selection.directives) === null || _a === void 0 ? void 0 : _a.length) === 0)) {
            const fragmentTypeName = selection.typeCondition ? selection.typeCondition.name.value : null;
            if (!fragmentTypeName || fragmentTypeName === selectionSetTypeName) {
                outputSelections.push(...$9ac221f848060cc0$var$inlineRelevantFragmentSpreads(fragmentDefinitions, selection.selectionSet.selections, selectionSetType));
                continue;
            }
        }
        outputSelections.push(selection);
    }
    return outputSelections;
}
function $9ac221f848060cc0$export$56ff9a5fb4cf521b(documentAST, schema) {
    const typeInfo = schema ? new (0, $eEwlA.TypeInfo)(schema) : null;
    const fragmentDefinitions = Object.create(null);
    for (const definition of documentAST.definitions)if (definition.kind === (0, $hu3w4.Kind).FRAGMENT_DEFINITION) fragmentDefinitions[definition.name.value] = definition;
    const flattenVisitors = {
        SelectionSet (node) {
            const selectionSetType = typeInfo ? typeInfo.getParentType() : null;
            let { selections: selections } = node;
            selections = $9ac221f848060cc0$var$inlineRelevantFragmentSpreads(fragmentDefinitions, selections, selectionSetType);
            return Object.assign(Object.assign({}, node), {
                selections: selections
            });
        },
        FragmentDefinition () {
            return null;
        }
    };
    const flattenedAST = (0, $9m7aI.visit)(documentAST, typeInfo ? (0, $eEwlA.visitWithTypeInfo)(typeInfo, flattenVisitors) : flattenVisitors);
    const deduplicateVisitors = {
        SelectionSet (node) {
            let { selections: selections } = node;
            selections = $9ac221f848060cc0$var$uniqueBy(selections, (selection)=>selection.alias ? selection.alias.value : selection.name.value);
            return Object.assign(Object.assign({}, node), {
                selections: selections
            });
        },
        FragmentDefinition () {
            return null;
        }
    };
    return (0, $9m7aI.visit)(flattenedAST, deduplicateVisitors);
}

});

parcelRegister("anr3h", function(module, exports) {

$parcel$export(module.exports, "getSelectedOperationName", () => $78e1094d60675dc7$export$7704908c6e6d63c0);
function $78e1094d60675dc7$export$7704908c6e6d63c0(prevOperations, prevSelectedOperationName, operations) {
    if (!operations || operations.length < 1) return;
    const names = operations.map((op)=>{
        var _a;
        return (_a = op.name) === null || _a === void 0 ? void 0 : _a.value;
    });
    if (prevSelectedOperationName && names.includes(prevSelectedOperationName)) return prevSelectedOperationName;
    if (prevSelectedOperationName && prevOperations) {
        const prevNames = prevOperations.map((op)=>{
            var _a;
            return (_a = op.name) === null || _a === void 0 ? void 0 : _a.value;
        });
        const prevIndex = prevNames.indexOf(prevSelectedOperationName);
        if (prevIndex !== -1 && prevIndex < names.length) return names[prevIndex];
    }
    return names[0];
}

});


parcelRegister("aujiX", function(module, exports) {
$parcel$export(module.exports, "StorageAPI", () => (parcelRequire("5mhgG")).StorageAPI);
$parcel$export(module.exports, "HistoryStore", () => (parcelRequire("bWkaC")).HistoryStore);
parcelRequire("5mhgG");
parcelRequire("bWkaC");
parcelRequire("4NdNR");
parcelRequire("bZqkD");

});
parcelRegister("5mhgG", function(module, exports) {

$parcel$export(module.exports, "StorageAPI", () => $3e6c66eb3dec4b48$export$48bd512ac57cae24);
function $3e6c66eb3dec4b48$var$isQuotaError(storage, e) {
    return e instanceof DOMException && (e.code === 22 || e.code === 1014 || e.name === "QuotaExceededError" || e.name === "NS_ERROR_DOM_QUOTA_REACHED") && storage.length !== 0;
}
class $3e6c66eb3dec4b48$export$48bd512ac57cae24 {
    constructor(storage){
        if (storage) this.storage = storage;
        else if (storage === null) this.storage = null;
        else if (typeof window === "undefined") this.storage = null;
        else this.storage = {
            getItem: window.localStorage.getItem.bind(window.localStorage),
            setItem: window.localStorage.setItem.bind(window.localStorage),
            removeItem: window.localStorage.removeItem.bind(window.localStorage),
            get length () {
                let keys = 0;
                for(const key in window.localStorage)if (key.indexOf(`${$3e6c66eb3dec4b48$var$STORAGE_NAMESPACE}:`) === 0) keys += 1;
                return keys;
            },
            clear () {
                for(const key in window.localStorage)if (key.indexOf(`${$3e6c66eb3dec4b48$var$STORAGE_NAMESPACE}:`) === 0) window.localStorage.removeItem(key);
            }
        };
    }
    get(name) {
        if (!this.storage) return null;
        const key = `${$3e6c66eb3dec4b48$var$STORAGE_NAMESPACE}:${name}`;
        const value = this.storage.getItem(key);
        if (value === "null" || value === "undefined") {
            this.storage.removeItem(key);
            return null;
        }
        return value || null;
    }
    set(name, value) {
        let quotaError = false;
        let error = null;
        if (this.storage) {
            const key = `${$3e6c66eb3dec4b48$var$STORAGE_NAMESPACE}:${name}`;
            if (value) try {
                this.storage.setItem(key, value);
            } catch (e) {
                error = e instanceof Error ? e : new Error(`${e}`);
                quotaError = $3e6c66eb3dec4b48$var$isQuotaError(this.storage, e);
            }
            else this.storage.removeItem(key);
        }
        return {
            isQuotaError: quotaError,
            error: error
        };
    }
    clear() {
        if (this.storage) this.storage.clear();
    }
}
const $3e6c66eb3dec4b48$var$STORAGE_NAMESPACE = "graphiql";

});

parcelRegister("bWkaC", function(module, exports) {

$parcel$export(module.exports, "HistoryStore", () => $8b14c1dd2763bbd0$export$cdd2d1cccabf934b);

var $8DJ2k = parcelRequire("8DJ2k");

var $4NdNR = parcelRequire("4NdNR");
const $8b14c1dd2763bbd0$var$MAX_QUERY_SIZE = 100000;
class $8b14c1dd2763bbd0$export$cdd2d1cccabf934b {
    constructor(storage, maxHistoryLength){
        this.storage = storage;
        this.maxHistoryLength = maxHistoryLength;
        this.updateHistory = ({ query: query, variables: variables, headers: headers, operationName: operationName })=>{
            if (!this.shouldSaveQuery(query, variables, headers, this.history.fetchRecent())) return;
            this.history.push({
                query: query,
                variables: variables,
                headers: headers,
                operationName: operationName
            });
            const historyQueries = this.history.items;
            const favoriteQueries = this.favorite.items;
            this.queries = historyQueries.concat(favoriteQueries);
        };
        this.deleteHistory = ({ query: query, variables: variables, headers: headers, operationName: operationName, favorite: favorite }, clearFavorites = false)=>{
            function deleteFromStore(store) {
                const found = store.items.find((x)=>x.query === query && x.variables === variables && x.headers === headers && x.operationName === operationName);
                if (found) store.delete(found);
            }
            if (favorite || clearFavorites) deleteFromStore(this.favorite);
            if (!favorite || clearFavorites) deleteFromStore(this.history);
            this.queries = [
                ...this.history.items,
                ...this.favorite.items
            ];
        };
        this.history = new (0, $4NdNR.QueryStore)("queries", this.storage, this.maxHistoryLength);
        this.favorite = new (0, $4NdNR.QueryStore)("favorites", this.storage, null);
        this.queries = [
            ...this.history.fetchAll(),
            ...this.favorite.fetchAll()
        ];
    }
    shouldSaveQuery(query, variables, headers, lastQuerySaved) {
        if (!query) return false;
        try {
            (0, $8DJ2k.parse)(query);
        } catch (_a) {
            return false;
        }
        if (query.length > $8b14c1dd2763bbd0$var$MAX_QUERY_SIZE) return false;
        if (!lastQuerySaved) return true;
        if (JSON.stringify(query) === JSON.stringify(lastQuerySaved.query)) {
            if (JSON.stringify(variables) === JSON.stringify(lastQuerySaved.variables)) {
                if (JSON.stringify(headers) === JSON.stringify(lastQuerySaved.headers)) return false;
                if (headers && !lastQuerySaved.headers) return false;
            }
            if (variables && !lastQuerySaved.variables) return false;
        }
        return true;
    }
    toggleFavorite({ query: query, variables: variables, headers: headers, operationName: operationName, label: label, favorite: favorite }) {
        const item = {
            query: query,
            variables: variables,
            headers: headers,
            operationName: operationName,
            label: label
        };
        if (favorite) {
            item.favorite = false;
            this.favorite.delete(item);
            this.history.push(item);
        } else {
            item.favorite = true;
            this.favorite.push(item);
            this.history.delete(item);
        }
        this.queries = [
            ...this.history.items,
            ...this.favorite.items
        ];
    }
    editLabel({ query: query, variables: variables, headers: headers, operationName: operationName, label: label, favorite: favorite }, index) {
        const item = {
            query: query,
            variables: variables,
            headers: headers,
            operationName: operationName,
            label: label
        };
        if (favorite) this.favorite.edit(Object.assign(Object.assign({}, item), {
            favorite: favorite
        }), index);
        else this.history.edit(item, index);
        this.queries = [
            ...this.history.items,
            ...this.favorite.items
        ];
    }
}

});
parcelRegister("4NdNR", function(module, exports) {

$parcel$export(module.exports, "QueryStore", () => $37d6720e9e122260$export$56eb674193b2014d);
class $37d6720e9e122260$export$56eb674193b2014d {
    constructor(key, storage, maxSize = null){
        this.key = key;
        this.storage = storage;
        this.maxSize = maxSize;
        this.items = this.fetchAll();
    }
    get length() {
        return this.items.length;
    }
    contains(item) {
        return this.items.some((x)=>x.query === item.query && x.variables === item.variables && x.headers === item.headers && x.operationName === item.operationName);
    }
    edit(item, index) {
        if (typeof index === "number" && this.items[index]) {
            const found = this.items[index];
            if (found.query === item.query && found.variables === item.variables && found.headers === item.headers && found.operationName === item.operationName) {
                this.items.splice(index, 1, item);
                this.save();
                return;
            }
        }
        const itemIndex = this.items.findIndex((x)=>x.query === item.query && x.variables === item.variables && x.headers === item.headers && x.operationName === item.operationName);
        if (itemIndex !== -1) {
            this.items.splice(itemIndex, 1, item);
            this.save();
        }
    }
    delete(item) {
        const itemIndex = this.items.findIndex((x)=>x.query === item.query && x.variables === item.variables && x.headers === item.headers && x.operationName === item.operationName);
        if (itemIndex !== -1) {
            this.items.splice(itemIndex, 1);
            this.save();
        }
    }
    fetchRecent() {
        return this.items.at(-1);
    }
    fetchAll() {
        const raw = this.storage.get(this.key);
        if (raw) return JSON.parse(raw)[this.key];
        return [];
    }
    push(item) {
        const items = [
            ...this.items,
            item
        ];
        if (this.maxSize && items.length > this.maxSize) items.shift();
        for(let attempts = 0; attempts < 5; attempts++){
            const response = this.storage.set(this.key, JSON.stringify({
                [this.key]: items
            }));
            if (!(response === null || response === void 0 ? void 0 : response.error)) this.items = items;
            else if (response.isQuotaError && this.maxSize) items.shift();
            else return;
        }
    }
    save() {
        this.storage.set(this.key, JSON.stringify({
            [this.key]: this.items
        }));
    }
}

});


parcelRegister("bZqkD", function(module, exports) {
function $8ba9d129f36bcdf0$export$45ed3e83e1544b73({ namespace: namespace }) {
    const storageKeyPrefix = `${namespace}:`;
    const getStorageKey = (key)=>`${storageKeyPrefix}${key}`;
    const storage = {
        setItem: (key, value)=>localStorage.setItem(getStorageKey(key), value),
        getItem: (key)=>localStorage.getItem(getStorageKey(key)),
        removeItem: (key)=>localStorage.removeItem(getStorageKey(key)),
        get length () {
            let keys = 0;
            for(const key in window.localStorage)if (key.indexOf(storageKeyPrefix) === 0) keys += 1;
            return keys;
        },
        clear () {
            for(const key in window.localStorage)if (key.indexOf(storageKeyPrefix) === 0) window.localStorage.removeItem(key);
        }
    };
    return storage;
}

});



parcelRegister("48f6i", function(module, exports) {

$parcel$export(module.exports, "getAutocompleteSuggestions", () => (parcelRequire("fwdrM")).getAutocompleteSuggestions);
$parcel$export(module.exports, "getDiagnostics", () => (parcelRequire("36lGu")).getDiagnostics);
$parcel$export(module.exports, "onlineParser", () => (parcelRequire("imwtR")).default);
$parcel$export(module.exports, "ParseRules", () => (parcelRequire("gSA1H")).ParseRules);
$parcel$export(module.exports, "LexRules", () => (parcelRequire("gSA1H")).LexRules);
$parcel$export(module.exports, "isIgnored", () => (parcelRequire("gSA1H")).isIgnored);
$parcel$export(module.exports, "p", () => (parcelRequire("kW3R4")).p);
$parcel$export(module.exports, "list", () => (parcelRequire("kW3R4")).list);
$parcel$export(module.exports, "t", () => (parcelRequire("kW3R4")).t);
$parcel$export(module.exports, "opt", () => (parcelRequire("kW3R4")).opt);
$parcel$export(module.exports, "getFragmentDependenciesForAST", () => (parcelRequire("eYQLF")).getFragmentDependenciesForAST);
$parcel$export(module.exports, "getOperationFacts", () => (parcelRequire("8xP5p")).default);
$parcel$export(module.exports, "Position", () => (parcelRequire("87oLu")).Position);
parcelRequire("7Jc7H");
var $fwdrM = parcelRequire("fwdrM");
var $36lGu = parcelRequire("36lGu");
parcelRequire("k1lDu");
var $gSA1H = parcelRequire("gSA1H");
var $kW3R4 = parcelRequire("kW3R4");
var $imwtR = parcelRequire("imwtR");

var $9ES7u = parcelRequire("9ES7u");
parcelRequire("fcdqG");
var $eYQLF = parcelRequire("eYQLF");
var $8xP5p = parcelRequire("8xP5p");
var $87oLu = parcelRequire("87oLu");

});
parcelRegister("7Jc7H", function(module, exports) {
$parcel$export(module.exports, "getAutocompleteSuggestions", () => (parcelRequire("fwdrM")).getAutocompleteSuggestions);
$parcel$export(module.exports, "getDiagnostics", () => (parcelRequire("36lGu")).getDiagnostics);
parcelRequire("iptZb");
parcelRequire("fwdrM");
parcelRequire("eGAWc");
parcelRequire("36lGu");

var $k0EIl = parcelRequire("k0EIl");

var $kNoXO = parcelRequire("kNoXO");

});
parcelRegister("iptZb", function(module, exports) {

$parcel$export(module.exports, "getDefinitionState", () => $d671d25f75a4a379$export$efdfe61faac68a82);
$parcel$export(module.exports, "forEachState", () => $d671d25f75a4a379$export$e9c84b43d4cb3191);
$parcel$export(module.exports, "getFieldDef", () => $d671d25f75a4a379$export$dab6dcab745bb1b6);
$parcel$export(module.exports, "objectValues", () => $d671d25f75a4a379$export$ad1854f4a08c15f8);
$parcel$export(module.exports, "hintList", () => $d671d25f75a4a379$export$9d99d25657b3ba67);

var $54dWd = parcelRequire("54dWd");
var $jptTh = parcelRequire("jptTh");
function $d671d25f75a4a379$export$efdfe61faac68a82(tokenState) {
    let definitionState;
    $d671d25f75a4a379$export$e9c84b43d4cb3191(tokenState, (state)=>{
        switch(state.kind){
            case "Query":
            case "ShortQuery":
            case "Mutation":
            case "Subscription":
            case "FragmentDefinition":
                definitionState = state;
                break;
        }
    });
    return definitionState;
}
function $d671d25f75a4a379$export$dab6dcab745bb1b6(schema, type, fieldName) {
    if (fieldName === (0, $jptTh.SchemaMetaFieldDef).name && schema.getQueryType() === type) return 0, $jptTh.SchemaMetaFieldDef;
    if (fieldName === (0, $jptTh.TypeMetaFieldDef).name && schema.getQueryType() === type) return 0, $jptTh.TypeMetaFieldDef;
    if (fieldName === (0, $jptTh.TypeNameMetaFieldDef).name && (0, $54dWd.isCompositeType)(type)) return 0, $jptTh.TypeNameMetaFieldDef;
    if ("getFields" in type) return type.getFields()[fieldName];
    return null;
}
function $d671d25f75a4a379$export$e9c84b43d4cb3191(stack, fn) {
    const reverseStateStack = [];
    let state = stack;
    while(state === null || state === void 0 ? void 0 : state.kind){
        reverseStateStack.push(state);
        state = state.prevState;
    }
    for(let i = reverseStateStack.length - 1; i >= 0; i--)fn(reverseStateStack[i]);
}
function $d671d25f75a4a379$export$ad1854f4a08c15f8(object) {
    const keys = Object.keys(object);
    const len = keys.length;
    const values = new Array(len);
    for(let i = 0; i < len; ++i)values[i] = object[keys[i]];
    return values;
}
function $d671d25f75a4a379$export$9d99d25657b3ba67(token, list) {
    return $d671d25f75a4a379$var$filterAndSortList(list, $d671d25f75a4a379$var$normalizeText(token.string));
}
function $d671d25f75a4a379$var$filterAndSortList(list, text) {
    if (!text) return $d671d25f75a4a379$var$filterNonEmpty(list, (entry)=>!entry.isDeprecated);
    const byProximity = list.map((entry)=>({
            proximity: $d671d25f75a4a379$var$getProximity($d671d25f75a4a379$var$normalizeText(entry.label), text),
            entry: entry
        }));
    return $d671d25f75a4a379$var$filterNonEmpty($d671d25f75a4a379$var$filterNonEmpty(byProximity, (pair)=>pair.proximity <= 2), (pair)=>!pair.entry.isDeprecated).sort((a, b)=>(a.entry.isDeprecated ? 1 : 0) - (b.entry.isDeprecated ? 1 : 0) || a.proximity - b.proximity || a.entry.label.length - b.entry.label.length).map((pair)=>pair.entry);
}
function $d671d25f75a4a379$var$filterNonEmpty(array, predicate) {
    const filtered = array.filter(predicate);
    return filtered.length === 0 ? array : filtered;
}
function $d671d25f75a4a379$var$normalizeText(text) {
    return text.toLowerCase().replaceAll(/\W/g, "");
}
function $d671d25f75a4a379$var$getProximity(suggestion, text) {
    let proximity = $d671d25f75a4a379$var$lexicalDistance(text, suggestion);
    if (suggestion.length > text.length) {
        proximity -= suggestion.length - text.length - 1;
        proximity += suggestion.indexOf(text) === 0 ? 0 : 0.5;
    }
    return proximity;
}
function $d671d25f75a4a379$var$lexicalDistance(a, b) {
    let i;
    let j;
    const d = [];
    const aLength = a.length;
    const bLength = b.length;
    for(i = 0; i <= aLength; i++)d[i] = [
        i
    ];
    for(j = 1; j <= bLength; j++)d[0][j] = j;
    for(i = 1; i <= aLength; i++)for(j = 1; j <= bLength; j++){
        const cost = a[i - 1] === b[j - 1] ? 0 : 1;
        d[i][j] = Math.min(d[i - 1][j] + 1, d[i][j - 1] + 1, d[i - 1][j - 1] + cost);
        if (i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) d[i][j] = Math.min(d[i][j], d[i - 2][j - 2] + cost);
    }
    return d[aLength][bLength];
}

});

parcelRegister("fwdrM", function(module, exports) {

$parcel$export(module.exports, "getAutocompleteSuggestions", () => $b4c446768bc328cb$export$f4329c00e1153450);
$parcel$export(module.exports, "getTokenAtPosition", () => $b4c446768bc328cb$export$9fa6088aa2e364aa);
$parcel$export(module.exports, "getTypeInfo", () => $b4c446768bc328cb$export$51371b6979371c8b);

var $54dWd = parcelRequire("54dWd");
var $9m7aI = parcelRequire("9m7aI");
var $5zW8K = parcelRequire("5zW8K");
var $f0jWA = parcelRequire("f0jWA");
var $l5aqI = parcelRequire("l5aqI");
var $hu3w4 = parcelRequire("hu3w4");
var $8DJ2k = parcelRequire("8DJ2k");
var $jptTh = parcelRequire("jptTh");

var $9ES7u = parcelRequire("9ES7u");
var $5F0yi = parcelRequire("5F0yi");
parcelRequire("k1lDu");
var $8qHvn = parcelRequire("8qHvn");
var $imwtR = parcelRequire("imwtR");
var $3H3du = parcelRequire("3H3du");

var $iptZb = parcelRequire("iptZb");
const $b4c446768bc328cb$export$cfc69927379f4ffd = {
    command: "editor.action.triggerSuggest",
    title: "Suggestions"
};
const $b4c446768bc328cb$var$collectFragmentDefs = (op)=>{
    const externalFragments = [];
    if (op) try {
        (0, $9m7aI.visit)((0, $8DJ2k.parse)(op), {
            FragmentDefinition (def) {
                externalFragments.push(def);
            }
        });
    } catch (_a) {
        return [];
    }
    return externalFragments;
};
const $b4c446768bc328cb$var$typeSystemKinds = [
    (0, $hu3w4.Kind).SCHEMA_DEFINITION,
    (0, $hu3w4.Kind).OPERATION_TYPE_DEFINITION,
    (0, $hu3w4.Kind).SCALAR_TYPE_DEFINITION,
    (0, $hu3w4.Kind).OBJECT_TYPE_DEFINITION,
    (0, $hu3w4.Kind).INTERFACE_TYPE_DEFINITION,
    (0, $hu3w4.Kind).UNION_TYPE_DEFINITION,
    (0, $hu3w4.Kind).ENUM_TYPE_DEFINITION,
    (0, $hu3w4.Kind).INPUT_OBJECT_TYPE_DEFINITION,
    (0, $hu3w4.Kind).DIRECTIVE_DEFINITION,
    (0, $hu3w4.Kind).SCHEMA_EXTENSION,
    (0, $hu3w4.Kind).SCALAR_TYPE_EXTENSION,
    (0, $hu3w4.Kind).OBJECT_TYPE_EXTENSION,
    (0, $hu3w4.Kind).INTERFACE_TYPE_EXTENSION,
    (0, $hu3w4.Kind).UNION_TYPE_EXTENSION,
    (0, $hu3w4.Kind).ENUM_TYPE_EXTENSION,
    (0, $hu3w4.Kind).INPUT_OBJECT_TYPE_EXTENSION
];
const $b4c446768bc328cb$var$hasTypeSystemDefinitions = (sdl)=>{
    let hasTypeSystemDef = false;
    if (sdl) try {
        (0, $9m7aI.visit)((0, $8DJ2k.parse)(sdl), {
            enter (node) {
                if (node.kind === "Document") return;
                if ($b4c446768bc328cb$var$typeSystemKinds.includes(node.kind)) {
                    hasTypeSystemDef = true;
                    return 0, $9m7aI.BREAK;
                }
                return false;
            }
        });
    } catch (_a) {
        return hasTypeSystemDef;
    }
    return hasTypeSystemDef;
};
function $b4c446768bc328cb$export$f4329c00e1153450(schema, queryText, cursor, contextToken, fragmentDefs, options) {
    var _a;
    const opts = Object.assign(Object.assign({}, options), {
        schema: schema
    });
    const token = contextToken || $b4c446768bc328cb$export$9fa6088aa2e364aa(queryText, cursor, 1);
    const state = token.state.kind === "Invalid" ? token.state.prevState : token.state;
    const mode = (options === null || options === void 0 ? void 0 : options.mode) || $b4c446768bc328cb$var$getDocumentMode(queryText, options === null || options === void 0 ? void 0 : options.uri);
    if (!state) return [];
    const { kind: kind, step: step, prevState: prevState } = state;
    const typeInfo = $b4c446768bc328cb$export$51371b6979371c8b(schema, token.state);
    if (kind === (0, $3H3du.RuleKinds).DOCUMENT) {
        if (mode === $b4c446768bc328cb$export$1b3ab0250de60799.TYPE_SYSTEM) return $b4c446768bc328cb$var$getSuggestionsForTypeSystemDefinitions(token);
        return $b4c446768bc328cb$var$getSuggestionsForExecutableDefinitions(token);
    }
    if (kind === (0, $3H3du.RuleKinds).EXTEND_DEF) return $b4c446768bc328cb$var$getSuggestionsForExtensionDefinitions(token);
    if (((_a = prevState === null || prevState === void 0 ? void 0 : prevState.prevState) === null || _a === void 0 ? void 0 : _a.kind) === (0, $3H3du.RuleKinds).EXTENSION_DEFINITION && state.name) return (0, $iptZb.hintList)(token, []);
    if ((prevState === null || prevState === void 0 ? void 0 : prevState.kind) === (0, $hu3w4.Kind).SCALAR_TYPE_EXTENSION) return (0, $iptZb.hintList)(token, Object.values(schema.getTypeMap()).filter((0, $54dWd.isScalarType)).map((type)=>({
            label: type.name,
            kind: (0, $9ES7u.CompletionItemKind).Function
        })));
    if ((prevState === null || prevState === void 0 ? void 0 : prevState.kind) === (0, $hu3w4.Kind).OBJECT_TYPE_EXTENSION) return (0, $iptZb.hintList)(token, Object.values(schema.getTypeMap()).filter((type)=>(0, $54dWd.isObjectType)(type) && !type.name.startsWith("__")).map((type)=>({
            label: type.name,
            kind: (0, $9ES7u.CompletionItemKind).Function
        })));
    if ((prevState === null || prevState === void 0 ? void 0 : prevState.kind) === (0, $hu3w4.Kind).INTERFACE_TYPE_EXTENSION) return (0, $iptZb.hintList)(token, Object.values(schema.getTypeMap()).filter((0, $54dWd.isInterfaceType)).map((type)=>({
            label: type.name,
            kind: (0, $9ES7u.CompletionItemKind).Function
        })));
    if ((prevState === null || prevState === void 0 ? void 0 : prevState.kind) === (0, $hu3w4.Kind).UNION_TYPE_EXTENSION) return (0, $iptZb.hintList)(token, Object.values(schema.getTypeMap()).filter((0, $54dWd.isUnionType)).map((type)=>({
            label: type.name,
            kind: (0, $9ES7u.CompletionItemKind).Function
        })));
    if ((prevState === null || prevState === void 0 ? void 0 : prevState.kind) === (0, $hu3w4.Kind).ENUM_TYPE_EXTENSION) return (0, $iptZb.hintList)(token, Object.values(schema.getTypeMap()).filter((type)=>(0, $54dWd.isEnumType)(type) && !type.name.startsWith("__")).map((type)=>({
            label: type.name,
            kind: (0, $9ES7u.CompletionItemKind).Function
        })));
    if ((prevState === null || prevState === void 0 ? void 0 : prevState.kind) === (0, $hu3w4.Kind).INPUT_OBJECT_TYPE_EXTENSION) return (0, $iptZb.hintList)(token, Object.values(schema.getTypeMap()).filter((0, $54dWd.isInputObjectType)).map((type)=>({
            label: type.name,
            kind: (0, $9ES7u.CompletionItemKind).Function
        })));
    if (kind === (0, $3H3du.RuleKinds).IMPLEMENTS || kind === (0, $3H3du.RuleKinds).NAMED_TYPE && (prevState === null || prevState === void 0 ? void 0 : prevState.kind) === (0, $3H3du.RuleKinds).IMPLEMENTS) return $b4c446768bc328cb$var$getSuggestionsForImplements(token, state, schema, queryText, typeInfo);
    if (kind === (0, $3H3du.RuleKinds).SELECTION_SET || kind === (0, $3H3du.RuleKinds).FIELD || kind === (0, $3H3du.RuleKinds).ALIASED_FIELD) return $b4c446768bc328cb$var$getSuggestionsForFieldNames(token, typeInfo, opts);
    if (kind === (0, $3H3du.RuleKinds).ARGUMENTS || kind === (0, $3H3du.RuleKinds).ARGUMENT && step === 0) {
        const { argDefs: argDefs } = typeInfo;
        if (argDefs) return (0, $iptZb.hintList)(token, argDefs.map((argDef)=>{
            var _a;
            return {
                label: argDef.name,
                insertText: argDef.name + ": ",
                command: $b4c446768bc328cb$export$cfc69927379f4ffd,
                detail: String(argDef.type),
                documentation: (_a = argDef.description) !== null && _a !== void 0 ? _a : undefined,
                kind: (0, $9ES7u.CompletionItemKind).Variable,
                type: argDef.type
            };
        }));
    }
    if ((kind === (0, $3H3du.RuleKinds).OBJECT_VALUE || kind === (0, $3H3du.RuleKinds).OBJECT_FIELD && step === 0) && typeInfo.objectFieldDefs) {
        const objectFields = (0, $iptZb.objectValues)(typeInfo.objectFieldDefs);
        const completionKind = kind === (0, $3H3du.RuleKinds).OBJECT_VALUE ? (0, $9ES7u.CompletionItemKind).Value : (0, $9ES7u.CompletionItemKind).Field;
        return (0, $iptZb.hintList)(token, objectFields.map((field)=>{
            var _a;
            return {
                label: field.name,
                detail: String(field.type),
                documentation: (_a = field.description) !== null && _a !== void 0 ? _a : undefined,
                kind: completionKind,
                type: field.type
            };
        }));
    }
    if (kind === (0, $3H3du.RuleKinds).ENUM_VALUE || kind === (0, $3H3du.RuleKinds).LIST_VALUE && step === 1 || kind === (0, $3H3du.RuleKinds).OBJECT_FIELD && step === 2 || kind === (0, $3H3du.RuleKinds).ARGUMENT && step === 2) return $b4c446768bc328cb$var$getSuggestionsForInputValues(token, typeInfo, queryText, schema);
    if (kind === (0, $3H3du.RuleKinds).VARIABLE && step === 1) {
        const namedInputType = (0, $54dWd.getNamedType)(typeInfo.inputType);
        const variableDefinitions = $b4c446768bc328cb$export$fa1d480f69d01eaf(queryText, schema, token);
        return (0, $iptZb.hintList)(token, variableDefinitions.filter((v)=>v.detail === (namedInputType === null || namedInputType === void 0 ? void 0 : namedInputType.name)));
    }
    if (kind === (0, $3H3du.RuleKinds).TYPE_CONDITION && step === 1 || kind === (0, $3H3du.RuleKinds).NAMED_TYPE && prevState != null && prevState.kind === (0, $3H3du.RuleKinds).TYPE_CONDITION) return $b4c446768bc328cb$var$getSuggestionsForFragmentTypeConditions(token, typeInfo, schema, kind);
    if (kind === (0, $3H3du.RuleKinds).FRAGMENT_SPREAD && step === 1) return $b4c446768bc328cb$var$getSuggestionsForFragmentSpread(token, typeInfo, schema, queryText, Array.isArray(fragmentDefs) ? fragmentDefs : $b4c446768bc328cb$var$collectFragmentDefs(fragmentDefs));
    const unwrappedState = $b4c446768bc328cb$var$unwrapType(state);
    if (mode === $b4c446768bc328cb$export$1b3ab0250de60799.TYPE_SYSTEM && !unwrappedState.needsAdvance && kind === (0, $3H3du.RuleKinds).NAMED_TYPE || kind === (0, $3H3du.RuleKinds).LIST_TYPE) {
        if (unwrappedState.kind === (0, $3H3du.RuleKinds).FIELD_DEF) return (0, $iptZb.hintList)(token, Object.values(schema.getTypeMap()).filter((type)=>(0, $54dWd.isOutputType)(type) && !type.name.startsWith("__")).map((type)=>({
                label: type.name,
                kind: (0, $9ES7u.CompletionItemKind).Function
            })));
        if (unwrappedState.kind === (0, $3H3du.RuleKinds).INPUT_VALUE_DEF) return (0, $iptZb.hintList)(token, Object.values(schema.getTypeMap()).filter((type)=>(0, $54dWd.isInputType)(type) && !type.name.startsWith("__")).map((type)=>({
                label: type.name,
                kind: (0, $9ES7u.CompletionItemKind).Function
            })));
    }
    if (kind === (0, $3H3du.RuleKinds).VARIABLE_DEFINITION && step === 2 || kind === (0, $3H3du.RuleKinds).LIST_TYPE && step === 1 || kind === (0, $3H3du.RuleKinds).NAMED_TYPE && prevState && (prevState.kind === (0, $3H3du.RuleKinds).VARIABLE_DEFINITION || prevState.kind === (0, $3H3du.RuleKinds).LIST_TYPE || prevState.kind === (0, $3H3du.RuleKinds).NON_NULL_TYPE)) return $b4c446768bc328cb$var$getSuggestionsForVariableDefinition(token, schema, kind);
    if (kind === (0, $3H3du.RuleKinds).DIRECTIVE) return $b4c446768bc328cb$var$getSuggestionsForDirective(token, state, schema, kind);
    return [];
}
const $b4c446768bc328cb$var$insertSuffix = " {\n  $1\n}";
const $b4c446768bc328cb$var$getInsertText = (field)=>{
    const { type: type } = field;
    if ((0, $54dWd.isCompositeType)(type)) return $b4c446768bc328cb$var$insertSuffix;
    if ((0, $54dWd.isListType)(type) && (0, $54dWd.isCompositeType)(type.ofType)) return $b4c446768bc328cb$var$insertSuffix;
    if ((0, $54dWd.isNonNullType)(type)) {
        if ((0, $54dWd.isCompositeType)(type.ofType)) return $b4c446768bc328cb$var$insertSuffix;
        if ((0, $54dWd.isListType)(type.ofType) && (0, $54dWd.isCompositeType)(type.ofType.ofType)) return $b4c446768bc328cb$var$insertSuffix;
    }
    return null;
};
function $b4c446768bc328cb$var$getSuggestionsForTypeSystemDefinitions(token) {
    return (0, $iptZb.hintList)(token, [
        {
            label: "extend",
            kind: (0, $9ES7u.CompletionItemKind).Function
        },
        {
            label: "type",
            kind: (0, $9ES7u.CompletionItemKind).Function
        },
        {
            label: "interface",
            kind: (0, $9ES7u.CompletionItemKind).Function
        },
        {
            label: "union",
            kind: (0, $9ES7u.CompletionItemKind).Function
        },
        {
            label: "input",
            kind: (0, $9ES7u.CompletionItemKind).Function
        },
        {
            label: "scalar",
            kind: (0, $9ES7u.CompletionItemKind).Function
        },
        {
            label: "schema",
            kind: (0, $9ES7u.CompletionItemKind).Function
        }
    ]);
}
function $b4c446768bc328cb$var$getSuggestionsForExecutableDefinitions(token) {
    return (0, $iptZb.hintList)(token, [
        {
            label: "query",
            kind: (0, $9ES7u.CompletionItemKind).Function
        },
        {
            label: "mutation",
            kind: (0, $9ES7u.CompletionItemKind).Function
        },
        {
            label: "subscription",
            kind: (0, $9ES7u.CompletionItemKind).Function
        },
        {
            label: "fragment",
            kind: (0, $9ES7u.CompletionItemKind).Function
        },
        {
            label: "{",
            kind: (0, $9ES7u.CompletionItemKind).Constructor
        }
    ]);
}
function $b4c446768bc328cb$var$getSuggestionsForExtensionDefinitions(token) {
    return (0, $iptZb.hintList)(token, [
        {
            label: "type",
            kind: (0, $9ES7u.CompletionItemKind).Function
        },
        {
            label: "interface",
            kind: (0, $9ES7u.CompletionItemKind).Function
        },
        {
            label: "union",
            kind: (0, $9ES7u.CompletionItemKind).Function
        },
        {
            label: "input",
            kind: (0, $9ES7u.CompletionItemKind).Function
        },
        {
            label: "scalar",
            kind: (0, $9ES7u.CompletionItemKind).Function
        },
        {
            label: "schema",
            kind: (0, $9ES7u.CompletionItemKind).Function
        }
    ]);
}
function $b4c446768bc328cb$var$getSuggestionsForFieldNames(token, typeInfo, options) {
    var _a;
    if (typeInfo.parentType) {
        const { parentType: parentType } = typeInfo;
        let fields = [];
        if ("getFields" in parentType) fields = (0, $iptZb.objectValues)(parentType.getFields());
        if ((0, $54dWd.isCompositeType)(parentType)) fields.push((0, $jptTh.TypeNameMetaFieldDef));
        if (parentType === ((_a = options === null || options === void 0 ? void 0 : options.schema) === null || _a === void 0 ? void 0 : _a.getQueryType())) fields.push((0, $jptTh.SchemaMetaFieldDef), (0, $jptTh.TypeMetaFieldDef));
        return (0, $iptZb.hintList)(token, fields.map((field, index)=>{
            var _a;
            const suggestion = {
                sortText: String(index) + field.name,
                label: field.name,
                detail: String(field.type),
                documentation: (_a = field.description) !== null && _a !== void 0 ? _a : undefined,
                deprecated: Boolean(field.deprecationReason),
                isDeprecated: Boolean(field.deprecationReason),
                deprecationReason: field.deprecationReason,
                kind: (0, $9ES7u.CompletionItemKind).Field,
                type: field.type
            };
            if (options === null || options === void 0 ? void 0 : options.fillLeafsOnComplete) {
                const insertText = $b4c446768bc328cb$var$getInsertText(field);
                if (insertText) {
                    suggestion.insertText = field.name + insertText;
                    suggestion.insertTextFormat = (0, $5F0yi.InsertTextFormat).Snippet;
                    suggestion.command = $b4c446768bc328cb$export$cfc69927379f4ffd;
                }
            }
            return suggestion;
        }));
    }
    return [];
}
function $b4c446768bc328cb$var$getSuggestionsForInputValues(token, typeInfo, queryText, schema) {
    const namedInputType = (0, $54dWd.getNamedType)(typeInfo.inputType);
    const queryVariables = $b4c446768bc328cb$export$fa1d480f69d01eaf(queryText, schema, token).filter((v)=>v.detail === namedInputType.name);
    if (namedInputType instanceof (0, $54dWd.GraphQLEnumType)) {
        const values = namedInputType.getValues();
        return (0, $iptZb.hintList)(token, values.map((value)=>{
            var _a;
            return {
                label: value.name,
                detail: String(namedInputType),
                documentation: (_a = value.description) !== null && _a !== void 0 ? _a : undefined,
                deprecated: Boolean(value.deprecationReason),
                isDeprecated: Boolean(value.deprecationReason),
                deprecationReason: value.deprecationReason,
                kind: (0, $9ES7u.CompletionItemKind).EnumMember,
                type: namedInputType
            };
        }).concat(queryVariables));
    }
    if (namedInputType === (0, $l5aqI.GraphQLBoolean)) return (0, $iptZb.hintList)(token, queryVariables.concat([
        {
            label: "true",
            detail: String((0, $l5aqI.GraphQLBoolean)),
            documentation: "Not false.",
            kind: (0, $9ES7u.CompletionItemKind).Variable,
            type: (0, $l5aqI.GraphQLBoolean)
        },
        {
            label: "false",
            detail: String((0, $l5aqI.GraphQLBoolean)),
            documentation: "Not true.",
            kind: (0, $9ES7u.CompletionItemKind).Variable,
            type: (0, $l5aqI.GraphQLBoolean)
        }
    ]));
    return queryVariables;
}
function $b4c446768bc328cb$var$getSuggestionsForImplements(token, tokenState, schema, documentText, typeInfo) {
    if (tokenState.needsSeparator) return [];
    const typeMap = schema.getTypeMap();
    const schemaInterfaces = (0, $iptZb.objectValues)(typeMap).filter((0, $54dWd.isInterfaceType));
    const schemaInterfaceNames = schemaInterfaces.map(({ name: name })=>name);
    const inlineInterfaces = new Set();
    $b4c446768bc328cb$export$c8f6eac36533d3c9(documentText, (_, state)=>{
        var _a, _b, _c, _d, _e;
        if (state.name) {
            if (state.kind === (0, $3H3du.RuleKinds).INTERFACE_DEF && !schemaInterfaceNames.includes(state.name)) inlineInterfaces.add(state.name);
            if (state.kind === (0, $3H3du.RuleKinds).NAMED_TYPE && ((_a = state.prevState) === null || _a === void 0 ? void 0 : _a.kind) === (0, $3H3du.RuleKinds).IMPLEMENTS) {
                if (typeInfo.interfaceDef) {
                    const existingType = (_b = typeInfo.interfaceDef) === null || _b === void 0 ? void 0 : _b.getInterfaces().find(({ name: name })=>name === state.name);
                    if (existingType) return;
                    const type = schema.getType(state.name);
                    const interfaceConfig = (_c = typeInfo.interfaceDef) === null || _c === void 0 ? void 0 : _c.toConfig();
                    typeInfo.interfaceDef = new (0, $54dWd.GraphQLInterfaceType)(Object.assign(Object.assign({}, interfaceConfig), {
                        interfaces: [
                            ...interfaceConfig.interfaces,
                            type || new (0, $54dWd.GraphQLInterfaceType)({
                                name: state.name,
                                fields: {}
                            })
                        ]
                    }));
                } else if (typeInfo.objectTypeDef) {
                    const existingType = (_d = typeInfo.objectTypeDef) === null || _d === void 0 ? void 0 : _d.getInterfaces().find(({ name: name })=>name === state.name);
                    if (existingType) return;
                    const type = schema.getType(state.name);
                    const objectTypeConfig = (_e = typeInfo.objectTypeDef) === null || _e === void 0 ? void 0 : _e.toConfig();
                    typeInfo.objectTypeDef = new (0, $54dWd.GraphQLObjectType)(Object.assign(Object.assign({}, objectTypeConfig), {
                        interfaces: [
                            ...objectTypeConfig.interfaces,
                            type || new (0, $54dWd.GraphQLInterfaceType)({
                                name: state.name,
                                fields: {}
                            })
                        ]
                    }));
                }
            }
        }
    });
    const currentTypeToExtend = typeInfo.interfaceDef || typeInfo.objectTypeDef;
    const siblingInterfaces = (currentTypeToExtend === null || currentTypeToExtend === void 0 ? void 0 : currentTypeToExtend.getInterfaces()) || [];
    const siblingInterfaceNames = siblingInterfaces.map(({ name: name })=>name);
    const possibleInterfaces = schemaInterfaces.concat([
        ...inlineInterfaces
    ].map((name)=>({
            name: name
        }))).filter(({ name: name })=>name !== (currentTypeToExtend === null || currentTypeToExtend === void 0 ? void 0 : currentTypeToExtend.name) && !siblingInterfaceNames.includes(name));
    return (0, $iptZb.hintList)(token, possibleInterfaces.map((type)=>{
        const result = {
            label: type.name,
            kind: (0, $9ES7u.CompletionItemKind).Interface,
            type: type
        };
        if (type === null || type === void 0 ? void 0 : type.description) result.documentation = type.description;
        return result;
    }));
}
function $b4c446768bc328cb$var$getSuggestionsForFragmentTypeConditions(token, typeInfo, schema, _kind) {
    let possibleTypes;
    if (typeInfo.parentType) {
        if ((0, $54dWd.isAbstractType)(typeInfo.parentType)) {
            const abstractType = (0, $54dWd.assertAbstractType)(typeInfo.parentType);
            const possibleObjTypes = schema.getPossibleTypes(abstractType);
            const possibleIfaceMap = Object.create(null);
            for (const type of possibleObjTypes)for (const iface of type.getInterfaces())possibleIfaceMap[iface.name] = iface;
            possibleTypes = possibleObjTypes.concat((0, $iptZb.objectValues)(possibleIfaceMap));
        } else possibleTypes = [
            typeInfo.parentType
        ];
    } else {
        const typeMap = schema.getTypeMap();
        possibleTypes = (0, $iptZb.objectValues)(typeMap).filter((type)=>(0, $54dWd.isCompositeType)(type) && !type.name.startsWith("__"));
    }
    return (0, $iptZb.hintList)(token, possibleTypes.map((type)=>{
        const namedType = (0, $54dWd.getNamedType)(type);
        return {
            label: String(type),
            documentation: (namedType === null || namedType === void 0 ? void 0 : namedType.description) || "",
            kind: (0, $9ES7u.CompletionItemKind).Field
        };
    }));
}
function $b4c446768bc328cb$var$getSuggestionsForFragmentSpread(token, typeInfo, schema, queryText, fragmentDefs) {
    if (!queryText) return [];
    const typeMap = schema.getTypeMap();
    const defState = (0, $iptZb.getDefinitionState)(token.state);
    const fragments = $b4c446768bc328cb$export$5320a7ba9466a3df(queryText);
    if (fragmentDefs && fragmentDefs.length > 0) fragments.push(...fragmentDefs);
    const relevantFrags = fragments.filter((frag)=>typeMap[frag.typeCondition.name.value] && !(defState && defState.kind === (0, $3H3du.RuleKinds).FRAGMENT_DEFINITION && defState.name === frag.name.value) && (0, $54dWd.isCompositeType)(typeInfo.parentType) && (0, $54dWd.isCompositeType)(typeMap[frag.typeCondition.name.value]) && (0, $f0jWA.doTypesOverlap)(schema, typeInfo.parentType, typeMap[frag.typeCondition.name.value]));
    return (0, $iptZb.hintList)(token, relevantFrags.map((frag)=>({
            label: frag.name.value,
            detail: String(typeMap[frag.typeCondition.name.value]),
            documentation: `fragment ${frag.name.value} on ${frag.typeCondition.name.value}`,
            kind: (0, $9ES7u.CompletionItemKind).Field,
            type: typeMap[frag.typeCondition.name.value]
        })));
}
const $b4c446768bc328cb$var$getParentDefinition = (state, kind)=>{
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    if (((_a = state.prevState) === null || _a === void 0 ? void 0 : _a.kind) === kind) return state.prevState;
    if (((_c = (_b = state.prevState) === null || _b === void 0 ? void 0 : _b.prevState) === null || _c === void 0 ? void 0 : _c.kind) === kind) return state.prevState.prevState;
    if (((_f = (_e = (_d = state.prevState) === null || _d === void 0 ? void 0 : _d.prevState) === null || _e === void 0 ? void 0 : _e.prevState) === null || _f === void 0 ? void 0 : _f.kind) === kind) return state.prevState.prevState.prevState;
    if (((_k = (_j = (_h = (_g = state.prevState) === null || _g === void 0 ? void 0 : _g.prevState) === null || _h === void 0 ? void 0 : _h.prevState) === null || _j === void 0 ? void 0 : _j.prevState) === null || _k === void 0 ? void 0 : _k.kind) === kind) return state.prevState.prevState.prevState.prevState;
};
function $b4c446768bc328cb$export$fa1d480f69d01eaf(queryText, schema, token) {
    let variableName = null;
    let variableType;
    const definitions = Object.create({});
    $b4c446768bc328cb$export$c8f6eac36533d3c9(queryText, (_, state)=>{
        if ((state === null || state === void 0 ? void 0 : state.kind) === (0, $3H3du.RuleKinds).VARIABLE && state.name) variableName = state.name;
        if ((state === null || state === void 0 ? void 0 : state.kind) === (0, $3H3du.RuleKinds).NAMED_TYPE && variableName) {
            const parentDefinition = $b4c446768bc328cb$var$getParentDefinition(state, (0, $3H3du.RuleKinds).TYPE);
            if (parentDefinition === null || parentDefinition === void 0 ? void 0 : parentDefinition.type) variableType = schema.getType(parentDefinition === null || parentDefinition === void 0 ? void 0 : parentDefinition.type);
        }
        if (variableName && variableType && !definitions[variableName]) {
            definitions[variableName] = {
                detail: variableType.toString(),
                insertText: token.string === "$" ? variableName : "$" + variableName,
                label: variableName,
                type: variableType,
                kind: (0, $9ES7u.CompletionItemKind).Variable
            };
            variableName = null;
            variableType = null;
        }
    });
    return (0, $iptZb.objectValues)(definitions);
}
function $b4c446768bc328cb$export$5320a7ba9466a3df(queryText) {
    const fragmentDefs = [];
    $b4c446768bc328cb$export$c8f6eac36533d3c9(queryText, (_, state)=>{
        if (state.kind === (0, $3H3du.RuleKinds).FRAGMENT_DEFINITION && state.name && state.type) fragmentDefs.push({
            kind: (0, $3H3du.RuleKinds).FRAGMENT_DEFINITION,
            name: {
                kind: (0, $hu3w4.Kind).NAME,
                value: state.name
            },
            selectionSet: {
                kind: (0, $3H3du.RuleKinds).SELECTION_SET,
                selections: []
            },
            typeCondition: {
                kind: (0, $3H3du.RuleKinds).NAMED_TYPE,
                name: {
                    kind: (0, $hu3w4.Kind).NAME,
                    value: state.type
                }
            }
        });
    });
    return fragmentDefs;
}
function $b4c446768bc328cb$var$getSuggestionsForVariableDefinition(token, schema, _kind) {
    const inputTypeMap = schema.getTypeMap();
    const inputTypes = (0, $iptZb.objectValues)(inputTypeMap).filter((0, $54dWd.isInputType));
    return (0, $iptZb.hintList)(token, inputTypes.map((type)=>({
            label: type.name,
            documentation: type.description,
            kind: (0, $9ES7u.CompletionItemKind).Variable
        })));
}
function $b4c446768bc328cb$var$getSuggestionsForDirective(token, state, schema, _kind) {
    var _a;
    if ((_a = state.prevState) === null || _a === void 0 ? void 0 : _a.kind) {
        const directives = schema.getDirectives().filter((directive)=>$b4c446768bc328cb$export$1fb0983e2b4f0076(state.prevState, directive));
        return (0, $iptZb.hintList)(token, directives.map((directive)=>({
                label: directive.name,
                documentation: directive.description || "",
                kind: (0, $9ES7u.CompletionItemKind).Function
            })));
    }
    return [];
}
function $b4c446768bc328cb$export$9fa6088aa2e364aa(queryText, cursor, offset = 0) {
    let styleAtCursor = null;
    let stateAtCursor = null;
    let stringAtCursor = null;
    const token = $b4c446768bc328cb$export$c8f6eac36533d3c9(queryText, (stream, state, style, index)=>{
        if (index !== cursor.line || stream.getCurrentPosition() + offset < cursor.character + 1) return;
        styleAtCursor = style;
        stateAtCursor = Object.assign({}, state);
        stringAtCursor = stream.current();
        return "BREAK";
    });
    return {
        start: token.start,
        end: token.end,
        string: stringAtCursor || token.string,
        state: stateAtCursor || token.state,
        style: styleAtCursor || token.style
    };
}
function $b4c446768bc328cb$export$c8f6eac36533d3c9(queryText, callback) {
    const lines = queryText.split("\n");
    const parser = (0, $imwtR.default)();
    let state = parser.startState();
    let style = "";
    let stream = new (0, $8qHvn.default)("");
    for(let i = 0; i < lines.length; i++){
        stream = new (0, $8qHvn.default)(lines[i]);
        while(!stream.eol()){
            style = parser.token(stream, state);
            const code = callback(stream, state, style, i);
            if (code === "BREAK") break;
        }
        callback(stream, state, style, i);
        if (!state.kind) state = parser.startState();
    }
    return {
        start: stream.getStartOfToken(),
        end: stream.getCurrentPosition(),
        string: stream.current(),
        state: state,
        style: style
    };
}
function $b4c446768bc328cb$export$1fb0983e2b4f0076(state, directive) {
    if (!(state === null || state === void 0 ? void 0 : state.kind)) return false;
    const { kind: kind, prevState: prevState } = state;
    const { locations: locations } = directive;
    switch(kind){
        case (0, $3H3du.RuleKinds).QUERY:
            return locations.includes((0, $5zW8K.DirectiveLocation).QUERY);
        case (0, $3H3du.RuleKinds).MUTATION:
            return locations.includes((0, $5zW8K.DirectiveLocation).MUTATION);
        case (0, $3H3du.RuleKinds).SUBSCRIPTION:
            return locations.includes((0, $5zW8K.DirectiveLocation).SUBSCRIPTION);
        case (0, $3H3du.RuleKinds).FIELD:
        case (0, $3H3du.RuleKinds).ALIASED_FIELD:
            return locations.includes((0, $5zW8K.DirectiveLocation).FIELD);
        case (0, $3H3du.RuleKinds).FRAGMENT_DEFINITION:
            return locations.includes((0, $5zW8K.DirectiveLocation).FRAGMENT_DEFINITION);
        case (0, $3H3du.RuleKinds).FRAGMENT_SPREAD:
            return locations.includes((0, $5zW8K.DirectiveLocation).FRAGMENT_SPREAD);
        case (0, $3H3du.RuleKinds).INLINE_FRAGMENT:
            return locations.includes((0, $5zW8K.DirectiveLocation).INLINE_FRAGMENT);
        case (0, $3H3du.RuleKinds).SCHEMA_DEF:
            return locations.includes((0, $5zW8K.DirectiveLocation).SCHEMA);
        case (0, $3H3du.RuleKinds).SCALAR_DEF:
            return locations.includes((0, $5zW8K.DirectiveLocation).SCALAR);
        case (0, $3H3du.RuleKinds).OBJECT_TYPE_DEF:
            return locations.includes((0, $5zW8K.DirectiveLocation).OBJECT);
        case (0, $3H3du.RuleKinds).FIELD_DEF:
            return locations.includes((0, $5zW8K.DirectiveLocation).FIELD_DEFINITION);
        case (0, $3H3du.RuleKinds).INTERFACE_DEF:
            return locations.includes((0, $5zW8K.DirectiveLocation).INTERFACE);
        case (0, $3H3du.RuleKinds).UNION_DEF:
            return locations.includes((0, $5zW8K.DirectiveLocation).UNION);
        case (0, $3H3du.RuleKinds).ENUM_DEF:
            return locations.includes((0, $5zW8K.DirectiveLocation).ENUM);
        case (0, $3H3du.RuleKinds).ENUM_VALUE:
            return locations.includes((0, $5zW8K.DirectiveLocation).ENUM_VALUE);
        case (0, $3H3du.RuleKinds).INPUT_DEF:
            return locations.includes((0, $5zW8K.DirectiveLocation).INPUT_OBJECT);
        case (0, $3H3du.RuleKinds).INPUT_VALUE_DEF:
            const prevStateKind = prevState === null || prevState === void 0 ? void 0 : prevState.kind;
            switch(prevStateKind){
                case (0, $3H3du.RuleKinds).ARGUMENTS_DEF:
                    return locations.includes((0, $5zW8K.DirectiveLocation).ARGUMENT_DEFINITION);
                case (0, $3H3du.RuleKinds).INPUT_DEF:
                    return locations.includes((0, $5zW8K.DirectiveLocation).INPUT_FIELD_DEFINITION);
            }
    }
    return false;
}
function $b4c446768bc328cb$export$51371b6979371c8b(schema, tokenState) {
    let argDef;
    let argDefs;
    let directiveDef;
    let enumValue;
    let fieldDef;
    let inputType;
    let objectTypeDef;
    let objectFieldDefs;
    let parentType;
    let type;
    let interfaceDef;
    (0, $iptZb.forEachState)(tokenState, (state)=>{
        var _a;
        switch(state.kind){
            case (0, $3H3du.RuleKinds).QUERY:
            case "ShortQuery":
                type = schema.getQueryType();
                break;
            case (0, $3H3du.RuleKinds).MUTATION:
                type = schema.getMutationType();
                break;
            case (0, $3H3du.RuleKinds).SUBSCRIPTION:
                type = schema.getSubscriptionType();
                break;
            case (0, $3H3du.RuleKinds).INLINE_FRAGMENT:
            case (0, $3H3du.RuleKinds).FRAGMENT_DEFINITION:
                if (state.type) type = schema.getType(state.type);
                break;
            case (0, $3H3du.RuleKinds).FIELD:
            case (0, $3H3du.RuleKinds).ALIASED_FIELD:
                if (!type || !state.name) fieldDef = null;
                else {
                    fieldDef = parentType ? (0, $iptZb.getFieldDef)(schema, parentType, state.name) : null;
                    type = fieldDef ? fieldDef.type : null;
                }
                break;
            case (0, $3H3du.RuleKinds).SELECTION_SET:
                parentType = (0, $54dWd.getNamedType)(type);
                break;
            case (0, $3H3du.RuleKinds).DIRECTIVE:
                directiveDef = state.name ? schema.getDirective(state.name) : null;
                break;
            case (0, $3H3du.RuleKinds).INTERFACE_DEF:
                if (state.name) {
                    objectTypeDef = null;
                    interfaceDef = new (0, $54dWd.GraphQLInterfaceType)({
                        name: state.name,
                        interfaces: [],
                        fields: {}
                    });
                }
                break;
            case (0, $3H3du.RuleKinds).OBJECT_TYPE_DEF:
                if (state.name) {
                    interfaceDef = null;
                    objectTypeDef = new (0, $54dWd.GraphQLObjectType)({
                        name: state.name,
                        interfaces: [],
                        fields: {}
                    });
                }
                break;
            case (0, $3H3du.RuleKinds).ARGUMENTS:
                if (state.prevState) switch(state.prevState.kind){
                    case (0, $3H3du.RuleKinds).FIELD:
                        argDefs = fieldDef && fieldDef.args;
                        break;
                    case (0, $3H3du.RuleKinds).DIRECTIVE:
                        argDefs = directiveDef && directiveDef.args;
                        break;
                    case (0, $3H3du.RuleKinds).ALIASED_FIELD:
                        {
                            const name = (_a = state.prevState) === null || _a === void 0 ? void 0 : _a.name;
                            if (!name) {
                                argDefs = null;
                                break;
                            }
                            const field = parentType ? (0, $iptZb.getFieldDef)(schema, parentType, name) : null;
                            if (!field) {
                                argDefs = null;
                                break;
                            }
                            argDefs = field.args;
                            break;
                        }
                    default:
                        argDefs = null;
                        break;
                }
                else argDefs = null;
                break;
            case (0, $3H3du.RuleKinds).ARGUMENT:
                if (argDefs) {
                    for(let i = 0; i < argDefs.length; i++)if (argDefs[i].name === state.name) {
                        argDef = argDefs[i];
                        break;
                    }
                }
                inputType = argDef === null || argDef === void 0 ? void 0 : argDef.type;
                break;
            case (0, $3H3du.RuleKinds).ENUM_VALUE:
                const enumType = (0, $54dWd.getNamedType)(inputType);
                enumValue = enumType instanceof (0, $54dWd.GraphQLEnumType) ? enumType.getValues().find((val)=>val.value === state.name) : null;
                break;
            case (0, $3H3du.RuleKinds).LIST_VALUE:
                const nullableType = (0, $54dWd.getNullableType)(inputType);
                inputType = nullableType instanceof (0, $54dWd.GraphQLList) ? nullableType.ofType : null;
                break;
            case (0, $3H3du.RuleKinds).OBJECT_VALUE:
                const objectType = (0, $54dWd.getNamedType)(inputType);
                objectFieldDefs = objectType instanceof (0, $54dWd.GraphQLInputObjectType) ? objectType.getFields() : null;
                break;
            case (0, $3H3du.RuleKinds).OBJECT_FIELD:
                const objectField = state.name && objectFieldDefs ? objectFieldDefs[state.name] : null;
                inputType = objectField === null || objectField === void 0 ? void 0 : objectField.type;
                break;
            case (0, $3H3du.RuleKinds).NAMED_TYPE:
                if (state.name) type = schema.getType(state.name);
                break;
        }
    });
    return {
        argDef: argDef,
        argDefs: argDefs,
        directiveDef: directiveDef,
        enumValue: enumValue,
        fieldDef: fieldDef,
        inputType: inputType,
        objectFieldDefs: objectFieldDefs,
        parentType: parentType,
        type: type,
        interfaceDef: interfaceDef,
        objectTypeDef: objectTypeDef
    };
}
var $b4c446768bc328cb$export$1b3ab0250de60799;
(function(GraphQLDocumentMode) {
    GraphQLDocumentMode["TYPE_SYSTEM"] = "TYPE_SYSTEM";
    GraphQLDocumentMode["EXECUTABLE"] = "EXECUTABLE";
})($b4c446768bc328cb$export$1b3ab0250de60799 || ($b4c446768bc328cb$export$1b3ab0250de60799 = {}));
function $b4c446768bc328cb$var$getDocumentMode(documentText, uri) {
    if (uri === null || uri === void 0 ? void 0 : uri.endsWith(".graphqls")) return $b4c446768bc328cb$export$1b3ab0250de60799.TYPE_SYSTEM;
    return $b4c446768bc328cb$var$hasTypeSystemDefinitions(documentText) ? $b4c446768bc328cb$export$1b3ab0250de60799.TYPE_SYSTEM : $b4c446768bc328cb$export$1b3ab0250de60799.EXECUTABLE;
}
function $b4c446768bc328cb$var$unwrapType(state) {
    if (state.prevState && state.kind && [
        (0, $3H3du.RuleKinds).NAMED_TYPE,
        (0, $3H3du.RuleKinds).LIST_TYPE,
        (0, $3H3du.RuleKinds).TYPE,
        (0, $3H3du.RuleKinds).NON_NULL_TYPE
    ].includes(state.kind)) return $b4c446768bc328cb$var$unwrapType(state.prevState);
    return state;
}

});
parcelRegister("9ES7u", function(module, exports) {

$parcel$export(module.exports, "CompletionItemKind", () => $7081d48a8a2b8080$export$99d00115014a86a8);
$parcel$export(module.exports, "InsertTextFormat", () => (parcelRequire("5F0yi")).InsertTextFormat);

var $5F0yi = parcelRequire("5F0yi");
const $7081d48a8a2b8080$export$b7da7ecc92a88557 = {
    Created: 1,
    Changed: 2,
    Deleted: 3
};
var $7081d48a8a2b8080$export$99d00115014a86a8;
(function(CompletionItemKind) {
    CompletionItemKind.Text = 1;
    CompletionItemKind.Method = 2;
    CompletionItemKind.Function = 3;
    CompletionItemKind.Constructor = 4;
    CompletionItemKind.Field = 5;
    CompletionItemKind.Variable = 6;
    CompletionItemKind.Class = 7;
    CompletionItemKind.Interface = 8;
    CompletionItemKind.Module = 9;
    CompletionItemKind.Property = 10;
    CompletionItemKind.Unit = 11;
    CompletionItemKind.Value = 12;
    CompletionItemKind.Enum = 13;
    CompletionItemKind.Keyword = 14;
    CompletionItemKind.Snippet = 15;
    CompletionItemKind.Color = 16;
    CompletionItemKind.File = 17;
    CompletionItemKind.Reference = 18;
    CompletionItemKind.Folder = 19;
    CompletionItemKind.EnumMember = 20;
    CompletionItemKind.Constant = 21;
    CompletionItemKind.Struct = 22;
    CompletionItemKind.Event = 23;
    CompletionItemKind.Operator = 24;
    CompletionItemKind.TypeParameter = 25;
})($7081d48a8a2b8080$export$99d00115014a86a8 || ($7081d48a8a2b8080$export$99d00115014a86a8 = {}));

});
parcelRegister("5F0yi", function(module, exports) {
(function(factory) {
    if (typeof module.exports === "object") {
        var v = factory(undefined, module.exports);
        if (v !== undefined) module.exports = v;
    } else if (typeof define === "function" && define.amd) define([
        "require",
        "exports"
    ], factory);
})(function(require1, exports1) {
    /* --------------------------------------------------------------------------------------------
     * Copyright (c) Microsoft Corporation. All rights reserved.
     * Licensed under the MIT License. See License.txt in the project root for license information.
     * ------------------------------------------------------------------------------------------ */ "use strict";
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
    exports1.TextDocument = exports1.EOL = exports1.WorkspaceFolder = exports1.InlineCompletionContext = exports1.SelectedCompletionInfo = exports1.InlineCompletionTriggerKind = exports1.InlineCompletionList = exports1.InlineCompletionItem = exports1.StringValue = exports1.InlayHint = exports1.InlayHintLabelPart = exports1.InlayHintKind = exports1.InlineValueContext = exports1.InlineValueEvaluatableExpression = exports1.InlineValueVariableLookup = exports1.InlineValueText = exports1.SemanticTokens = exports1.SemanticTokenModifiers = exports1.SemanticTokenTypes = exports1.SelectionRange = exports1.DocumentLink = exports1.FormattingOptions = exports1.CodeLens = exports1.CodeAction = exports1.CodeActionContext = exports1.CodeActionTriggerKind = exports1.CodeActionKind = exports1.DocumentSymbol = exports1.WorkspaceSymbol = exports1.SymbolInformation = exports1.SymbolTag = exports1.SymbolKind = exports1.DocumentHighlight = exports1.DocumentHighlightKind = exports1.SignatureInformation = exports1.ParameterInformation = exports1.Hover = exports1.MarkedString = exports1.CompletionList = exports1.CompletionItem = exports1.CompletionItemLabelDetails = exports1.InsertTextMode = exports1.InsertReplaceEdit = exports1.CompletionItemTag = exports1.InsertTextFormat = exports1.CompletionItemKind = exports1.MarkupContent = exports1.MarkupKind = exports1.TextDocumentItem = exports1.OptionalVersionedTextDocumentIdentifier = exports1.VersionedTextDocumentIdentifier = exports1.TextDocumentIdentifier = exports1.WorkspaceChange = exports1.WorkspaceEdit = exports1.DeleteFile = exports1.RenameFile = exports1.CreateFile = exports1.TextDocumentEdit = exports1.AnnotatedTextEdit = exports1.ChangeAnnotationIdentifier = exports1.ChangeAnnotation = exports1.TextEdit = exports1.Command = exports1.Diagnostic = exports1.CodeDescription = exports1.DiagnosticTag = exports1.DiagnosticSeverity = exports1.DiagnosticRelatedInformation = exports1.FoldingRange = exports1.FoldingRangeKind = exports1.ColorPresentation = exports1.ColorInformation = exports1.Color = exports1.LocationLink = exports1.Location = exports1.Range = exports1.Position = exports1.uinteger = exports1.integer = exports1.URI = exports1.DocumentUri = void 0;
    var DocumentUri;
    (function(DocumentUri) {
        function is(value) {
            return typeof value === "string";
        }
        DocumentUri.is = is;
    })(DocumentUri || (exports1.DocumentUri = DocumentUri = {}));
    var URI;
    (function(URI) {
        function is(value) {
            return typeof value === "string";
        }
        URI.is = is;
    })(URI || (exports1.URI = URI = {}));
    var integer;
    (function(integer) {
        integer.MIN_VALUE = -2147483648;
        integer.MAX_VALUE = 2147483647;
        function is(value) {
            return typeof value === "number" && integer.MIN_VALUE <= value && value <= integer.MAX_VALUE;
        }
        integer.is = is;
    })(integer || (exports1.integer = integer = {}));
    var uinteger;
    (function(uinteger) {
        uinteger.MIN_VALUE = 0;
        uinteger.MAX_VALUE = 2147483647;
        function is(value) {
            return typeof value === "number" && uinteger.MIN_VALUE <= value && value <= uinteger.MAX_VALUE;
        }
        uinteger.is = is;
    })(uinteger || (exports1.uinteger = uinteger = {}));
    /**
     * The Position namespace provides helper functions to work with
     * {@link Position} literals.
     */ var Position;
    (function(Position) {
        /**
         * Creates a new Position literal from the given line and character.
         * @param line The position's line.
         * @param character The position's character.
         */ function create(line, character) {
            if (line === Number.MAX_VALUE) line = uinteger.MAX_VALUE;
            if (character === Number.MAX_VALUE) character = uinteger.MAX_VALUE;
            return {
                line: line,
                character: character
            };
        }
        Position.create = create;
        /**
         * Checks whether the given literal conforms to the {@link Position} interface.
         */ function is(value) {
            var candidate = value;
            return Is.objectLiteral(candidate) && Is.uinteger(candidate.line) && Is.uinteger(candidate.character);
        }
        Position.is = is;
    })(Position || (exports1.Position = Position = {}));
    /**
     * The Range namespace provides helper functions to work with
     * {@link Range} literals.
     */ var Range;
    (function(Range) {
        function create(one, two, three, four) {
            if (Is.uinteger(one) && Is.uinteger(two) && Is.uinteger(three) && Is.uinteger(four)) return {
                start: Position.create(one, two),
                end: Position.create(three, four)
            };
            else if (Position.is(one) && Position.is(two)) return {
                start: one,
                end: two
            };
            else throw new Error("Range#create called with invalid arguments[".concat(one, ", ").concat(two, ", ").concat(three, ", ").concat(four, "]"));
        }
        Range.create = create;
        /**
         * Checks whether the given literal conforms to the {@link Range} interface.
         */ function is(value) {
            var candidate = value;
            return Is.objectLiteral(candidate) && Position.is(candidate.start) && Position.is(candidate.end);
        }
        Range.is = is;
    })(Range || (exports1.Range = Range = {}));
    /**
     * The Location namespace provides helper functions to work with
     * {@link Location} literals.
     */ var Location;
    (function(Location) {
        /**
         * Creates a Location literal.
         * @param uri The location's uri.
         * @param range The location's range.
         */ function create(uri, range) {
            return {
                uri: uri,
                range: range
            };
        }
        Location.create = create;
        /**
         * Checks whether the given literal conforms to the {@link Location} interface.
         */ function is(value) {
            var candidate = value;
            return Is.objectLiteral(candidate) && Range.is(candidate.range) && (Is.string(candidate.uri) || Is.undefined(candidate.uri));
        }
        Location.is = is;
    })(Location || (exports1.Location = Location = {}));
    /**
     * The LocationLink namespace provides helper functions to work with
     * {@link LocationLink} literals.
     */ var LocationLink;
    (function(LocationLink) {
        /**
         * Creates a LocationLink literal.
         * @param targetUri The definition's uri.
         * @param targetRange The full range of the definition.
         * @param targetSelectionRange The span of the symbol definition at the target.
         * @param originSelectionRange The span of the symbol being defined in the originating source file.
         */ function create(targetUri, targetRange, targetSelectionRange, originSelectionRange) {
            return {
                targetUri: targetUri,
                targetRange: targetRange,
                targetSelectionRange: targetSelectionRange,
                originSelectionRange: originSelectionRange
            };
        }
        LocationLink.create = create;
        /**
         * Checks whether the given literal conforms to the {@link LocationLink} interface.
         */ function is(value) {
            var candidate = value;
            return Is.objectLiteral(candidate) && Range.is(candidate.targetRange) && Is.string(candidate.targetUri) && Range.is(candidate.targetSelectionRange) && (Range.is(candidate.originSelectionRange) || Is.undefined(candidate.originSelectionRange));
        }
        LocationLink.is = is;
    })(LocationLink || (exports1.LocationLink = LocationLink = {}));
    /**
     * The Color namespace provides helper functions to work with
     * {@link Color} literals.
     */ var Color;
    (function(Color) {
        /**
         * Creates a new Color literal.
         */ function create(red, green, blue, alpha) {
            return {
                red: red,
                green: green,
                blue: blue,
                alpha: alpha
            };
        }
        Color.create = create;
        /**
         * Checks whether the given literal conforms to the {@link Color} interface.
         */ function is(value) {
            var candidate = value;
            return Is.objectLiteral(candidate) && Is.numberRange(candidate.red, 0, 1) && Is.numberRange(candidate.green, 0, 1) && Is.numberRange(candidate.blue, 0, 1) && Is.numberRange(candidate.alpha, 0, 1);
        }
        Color.is = is;
    })(Color || (exports1.Color = Color = {}));
    /**
     * The ColorInformation namespace provides helper functions to work with
     * {@link ColorInformation} literals.
     */ var ColorInformation;
    (function(ColorInformation) {
        /**
         * Creates a new ColorInformation literal.
         */ function create(range, color) {
            return {
                range: range,
                color: color
            };
        }
        ColorInformation.create = create;
        /**
         * Checks whether the given literal conforms to the {@link ColorInformation} interface.
         */ function is(value) {
            var candidate = value;
            return Is.objectLiteral(candidate) && Range.is(candidate.range) && Color.is(candidate.color);
        }
        ColorInformation.is = is;
    })(ColorInformation || (exports1.ColorInformation = ColorInformation = {}));
    /**
     * The Color namespace provides helper functions to work with
     * {@link ColorPresentation} literals.
     */ var ColorPresentation;
    (function(ColorPresentation) {
        /**
         * Creates a new ColorInformation literal.
         */ function create(label, textEdit, additionalTextEdits) {
            return {
                label: label,
                textEdit: textEdit,
                additionalTextEdits: additionalTextEdits
            };
        }
        ColorPresentation.create = create;
        /**
         * Checks whether the given literal conforms to the {@link ColorInformation} interface.
         */ function is(value) {
            var candidate = value;
            return Is.objectLiteral(candidate) && Is.string(candidate.label) && (Is.undefined(candidate.textEdit) || TextEdit.is(candidate)) && (Is.undefined(candidate.additionalTextEdits) || Is.typedArray(candidate.additionalTextEdits, TextEdit.is));
        }
        ColorPresentation.is = is;
    })(ColorPresentation || (exports1.ColorPresentation = ColorPresentation = {}));
    /**
     * A set of predefined range kinds.
     */ var FoldingRangeKind;
    (function(FoldingRangeKind) {
        /**
         * Folding range for a comment
         */ FoldingRangeKind.Comment = "comment";
        /**
         * Folding range for an import or include
         */ FoldingRangeKind.Imports = "imports";
        /**
         * Folding range for a region (e.g. `#region`)
         */ FoldingRangeKind.Region = "region";
    })(FoldingRangeKind || (exports1.FoldingRangeKind = FoldingRangeKind = {}));
    /**
     * The folding range namespace provides helper functions to work with
     * {@link FoldingRange} literals.
     */ var FoldingRange;
    (function(FoldingRange) {
        /**
         * Creates a new FoldingRange literal.
         */ function create(startLine, endLine, startCharacter, endCharacter, kind, collapsedText) {
            var result = {
                startLine: startLine,
                endLine: endLine
            };
            if (Is.defined(startCharacter)) result.startCharacter = startCharacter;
            if (Is.defined(endCharacter)) result.endCharacter = endCharacter;
            if (Is.defined(kind)) result.kind = kind;
            if (Is.defined(collapsedText)) result.collapsedText = collapsedText;
            return result;
        }
        FoldingRange.create = create;
        /**
         * Checks whether the given literal conforms to the {@link FoldingRange} interface.
         */ function is(value) {
            var candidate = value;
            return Is.objectLiteral(candidate) && Is.uinteger(candidate.startLine) && Is.uinteger(candidate.startLine) && (Is.undefined(candidate.startCharacter) || Is.uinteger(candidate.startCharacter)) && (Is.undefined(candidate.endCharacter) || Is.uinteger(candidate.endCharacter)) && (Is.undefined(candidate.kind) || Is.string(candidate.kind));
        }
        FoldingRange.is = is;
    })(FoldingRange || (exports1.FoldingRange = FoldingRange = {}));
    /**
     * The DiagnosticRelatedInformation namespace provides helper functions to work with
     * {@link DiagnosticRelatedInformation} literals.
     */ var DiagnosticRelatedInformation;
    (function(DiagnosticRelatedInformation) {
        /**
         * Creates a new DiagnosticRelatedInformation literal.
         */ function create(location, message) {
            return {
                location: location,
                message: message
            };
        }
        DiagnosticRelatedInformation.create = create;
        /**
         * Checks whether the given literal conforms to the {@link DiagnosticRelatedInformation} interface.
         */ function is(value) {
            var candidate = value;
            return Is.defined(candidate) && Location.is(candidate.location) && Is.string(candidate.message);
        }
        DiagnosticRelatedInformation.is = is;
    })(DiagnosticRelatedInformation || (exports1.DiagnosticRelatedInformation = DiagnosticRelatedInformation = {}));
    /**
     * The diagnostic's severity.
     */ var DiagnosticSeverity;
    (function(DiagnosticSeverity) {
        /**
         * Reports an error.
         */ DiagnosticSeverity.Error = 1;
        /**
         * Reports a warning.
         */ DiagnosticSeverity.Warning = 2;
        /**
         * Reports an information.
         */ DiagnosticSeverity.Information = 3;
        /**
         * Reports a hint.
         */ DiagnosticSeverity.Hint = 4;
    })(DiagnosticSeverity || (exports1.DiagnosticSeverity = DiagnosticSeverity = {}));
    /**
     * The diagnostic tags.
     *
     * @since 3.15.0
     */ var DiagnosticTag;
    (function(DiagnosticTag) {
        /**
         * Unused or unnecessary code.
         *
         * Clients are allowed to render diagnostics with this tag faded out instead of having
         * an error squiggle.
         */ DiagnosticTag.Unnecessary = 1;
        /**
         * Deprecated or obsolete code.
         *
         * Clients are allowed to rendered diagnostics with this tag strike through.
         */ DiagnosticTag.Deprecated = 2;
    })(DiagnosticTag || (exports1.DiagnosticTag = DiagnosticTag = {}));
    /**
     * The CodeDescription namespace provides functions to deal with descriptions for diagnostic codes.
     *
     * @since 3.16.0
     */ var CodeDescription;
    (function(CodeDescription) {
        function is(value) {
            var candidate = value;
            return Is.objectLiteral(candidate) && Is.string(candidate.href);
        }
        CodeDescription.is = is;
    })(CodeDescription || (exports1.CodeDescription = CodeDescription = {}));
    /**
     * The Diagnostic namespace provides helper functions to work with
     * {@link Diagnostic} literals.
     */ var Diagnostic;
    (function(Diagnostic) {
        /**
         * Creates a new Diagnostic literal.
         */ function create(range, message, severity, code, source, relatedInformation) {
            var result = {
                range: range,
                message: message
            };
            if (Is.defined(severity)) result.severity = severity;
            if (Is.defined(code)) result.code = code;
            if (Is.defined(source)) result.source = source;
            if (Is.defined(relatedInformation)) result.relatedInformation = relatedInformation;
            return result;
        }
        Diagnostic.create = create;
        /**
         * Checks whether the given literal conforms to the {@link Diagnostic} interface.
         */ function is(value) {
            var _a;
            var candidate = value;
            return Is.defined(candidate) && Range.is(candidate.range) && Is.string(candidate.message) && (Is.number(candidate.severity) || Is.undefined(candidate.severity)) && (Is.integer(candidate.code) || Is.string(candidate.code) || Is.undefined(candidate.code)) && (Is.undefined(candidate.codeDescription) || Is.string((_a = candidate.codeDescription) === null || _a === void 0 ? void 0 : _a.href)) && (Is.string(candidate.source) || Is.undefined(candidate.source)) && (Is.undefined(candidate.relatedInformation) || Is.typedArray(candidate.relatedInformation, DiagnosticRelatedInformation.is));
        }
        Diagnostic.is = is;
    })(Diagnostic || (exports1.Diagnostic = Diagnostic = {}));
    /**
     * The Command namespace provides helper functions to work with
     * {@link Command} literals.
     */ var Command;
    (function(Command) {
        /**
         * Creates a new Command literal.
         */ function create(title, command) {
            var args = [];
            for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
            var result = {
                title: title,
                command: command
            };
            if (Is.defined(args) && args.length > 0) result.arguments = args;
            return result;
        }
        Command.create = create;
        /**
         * Checks whether the given literal conforms to the {@link Command} interface.
         */ function is(value) {
            var candidate = value;
            return Is.defined(candidate) && Is.string(candidate.title) && Is.string(candidate.command);
        }
        Command.is = is;
    })(Command || (exports1.Command = Command = {}));
    /**
     * The TextEdit namespace provides helper function to create replace,
     * insert and delete edits more easily.
     */ var TextEdit;
    (function(TextEdit) {
        /**
         * Creates a replace text edit.
         * @param range The range of text to be replaced.
         * @param newText The new text.
         */ function replace(range, newText) {
            return {
                range: range,
                newText: newText
            };
        }
        TextEdit.replace = replace;
        /**
         * Creates an insert text edit.
         * @param position The position to insert the text at.
         * @param newText The text to be inserted.
         */ function insert(position, newText) {
            return {
                range: {
                    start: position,
                    end: position
                },
                newText: newText
            };
        }
        TextEdit.insert = insert;
        /**
         * Creates a delete text edit.
         * @param range The range of text to be deleted.
         */ function del(range) {
            return {
                range: range,
                newText: ""
            };
        }
        TextEdit.del = del;
        function is(value) {
            var candidate = value;
            return Is.objectLiteral(candidate) && Is.string(candidate.newText) && Range.is(candidate.range);
        }
        TextEdit.is = is;
    })(TextEdit || (exports1.TextEdit = TextEdit = {}));
    var ChangeAnnotation;
    (function(ChangeAnnotation) {
        function create(label, needsConfirmation, description) {
            var result = {
                label: label
            };
            if (needsConfirmation !== undefined) result.needsConfirmation = needsConfirmation;
            if (description !== undefined) result.description = description;
            return result;
        }
        ChangeAnnotation.create = create;
        function is(value) {
            var candidate = value;
            return Is.objectLiteral(candidate) && Is.string(candidate.label) && (Is.boolean(candidate.needsConfirmation) || candidate.needsConfirmation === undefined) && (Is.string(candidate.description) || candidate.description === undefined);
        }
        ChangeAnnotation.is = is;
    })(ChangeAnnotation || (exports1.ChangeAnnotation = ChangeAnnotation = {}));
    var ChangeAnnotationIdentifier;
    (function(ChangeAnnotationIdentifier) {
        function is(value) {
            var candidate = value;
            return Is.string(candidate);
        }
        ChangeAnnotationIdentifier.is = is;
    })(ChangeAnnotationIdentifier || (exports1.ChangeAnnotationIdentifier = ChangeAnnotationIdentifier = {}));
    var AnnotatedTextEdit;
    (function(AnnotatedTextEdit) {
        /**
         * Creates an annotated replace text edit.
         *
         * @param range The range of text to be replaced.
         * @param newText The new text.
         * @param annotation The annotation.
         */ function replace(range, newText, annotation) {
            return {
                range: range,
                newText: newText,
                annotationId: annotation
            };
        }
        AnnotatedTextEdit.replace = replace;
        /**
         * Creates an annotated insert text edit.
         *
         * @param position The position to insert the text at.
         * @param newText The text to be inserted.
         * @param annotation The annotation.
         */ function insert(position, newText, annotation) {
            return {
                range: {
                    start: position,
                    end: position
                },
                newText: newText,
                annotationId: annotation
            };
        }
        AnnotatedTextEdit.insert = insert;
        /**
         * Creates an annotated delete text edit.
         *
         * @param range The range of text to be deleted.
         * @param annotation The annotation.
         */ function del(range, annotation) {
            return {
                range: range,
                newText: "",
                annotationId: annotation
            };
        }
        AnnotatedTextEdit.del = del;
        function is(value) {
            var candidate = value;
            return TextEdit.is(candidate) && (ChangeAnnotation.is(candidate.annotationId) || ChangeAnnotationIdentifier.is(candidate.annotationId));
        }
        AnnotatedTextEdit.is = is;
    })(AnnotatedTextEdit || (exports1.AnnotatedTextEdit = AnnotatedTextEdit = {}));
    /**
     * The TextDocumentEdit namespace provides helper function to create
     * an edit that manipulates a text document.
     */ var TextDocumentEdit;
    (function(TextDocumentEdit) {
        /**
         * Creates a new `TextDocumentEdit`
         */ function create(textDocument, edits) {
            return {
                textDocument: textDocument,
                edits: edits
            };
        }
        TextDocumentEdit.create = create;
        function is(value) {
            var candidate = value;
            return Is.defined(candidate) && OptionalVersionedTextDocumentIdentifier.is(candidate.textDocument) && Array.isArray(candidate.edits);
        }
        TextDocumentEdit.is = is;
    })(TextDocumentEdit || (exports1.TextDocumentEdit = TextDocumentEdit = {}));
    var CreateFile;
    (function(CreateFile) {
        function create(uri, options, annotation) {
            var result = {
                kind: "create",
                uri: uri
            };
            if (options !== undefined && (options.overwrite !== undefined || options.ignoreIfExists !== undefined)) result.options = options;
            if (annotation !== undefined) result.annotationId = annotation;
            return result;
        }
        CreateFile.create = create;
        function is(value) {
            var candidate = value;
            return candidate && candidate.kind === "create" && Is.string(candidate.uri) && (candidate.options === undefined || (candidate.options.overwrite === undefined || Is.boolean(candidate.options.overwrite)) && (candidate.options.ignoreIfExists === undefined || Is.boolean(candidate.options.ignoreIfExists))) && (candidate.annotationId === undefined || ChangeAnnotationIdentifier.is(candidate.annotationId));
        }
        CreateFile.is = is;
    })(CreateFile || (exports1.CreateFile = CreateFile = {}));
    var RenameFile;
    (function(RenameFile) {
        function create(oldUri, newUri, options, annotation) {
            var result = {
                kind: "rename",
                oldUri: oldUri,
                newUri: newUri
            };
            if (options !== undefined && (options.overwrite !== undefined || options.ignoreIfExists !== undefined)) result.options = options;
            if (annotation !== undefined) result.annotationId = annotation;
            return result;
        }
        RenameFile.create = create;
        function is(value) {
            var candidate = value;
            return candidate && candidate.kind === "rename" && Is.string(candidate.oldUri) && Is.string(candidate.newUri) && (candidate.options === undefined || (candidate.options.overwrite === undefined || Is.boolean(candidate.options.overwrite)) && (candidate.options.ignoreIfExists === undefined || Is.boolean(candidate.options.ignoreIfExists))) && (candidate.annotationId === undefined || ChangeAnnotationIdentifier.is(candidate.annotationId));
        }
        RenameFile.is = is;
    })(RenameFile || (exports1.RenameFile = RenameFile = {}));
    var DeleteFile;
    (function(DeleteFile) {
        function create(uri, options, annotation) {
            var result = {
                kind: "delete",
                uri: uri
            };
            if (options !== undefined && (options.recursive !== undefined || options.ignoreIfNotExists !== undefined)) result.options = options;
            if (annotation !== undefined) result.annotationId = annotation;
            return result;
        }
        DeleteFile.create = create;
        function is(value) {
            var candidate = value;
            return candidate && candidate.kind === "delete" && Is.string(candidate.uri) && (candidate.options === undefined || (candidate.options.recursive === undefined || Is.boolean(candidate.options.recursive)) && (candidate.options.ignoreIfNotExists === undefined || Is.boolean(candidate.options.ignoreIfNotExists))) && (candidate.annotationId === undefined || ChangeAnnotationIdentifier.is(candidate.annotationId));
        }
        DeleteFile.is = is;
    })(DeleteFile || (exports1.DeleteFile = DeleteFile = {}));
    var WorkspaceEdit;
    (function(WorkspaceEdit) {
        function is(value) {
            var candidate = value;
            return candidate && (candidate.changes !== undefined || candidate.documentChanges !== undefined) && (candidate.documentChanges === undefined || candidate.documentChanges.every(function(change) {
                if (Is.string(change.kind)) return CreateFile.is(change) || RenameFile.is(change) || DeleteFile.is(change);
                else return TextDocumentEdit.is(change);
            }));
        }
        WorkspaceEdit.is = is;
    })(WorkspaceEdit || (exports1.WorkspaceEdit = WorkspaceEdit = {}));
    var TextEditChangeImpl = /** @class */ function() {
        function TextEditChangeImpl(edits, changeAnnotations) {
            this.edits = edits;
            this.changeAnnotations = changeAnnotations;
        }
        TextEditChangeImpl.prototype.insert = function(position, newText, annotation) {
            var edit;
            var id;
            if (annotation === undefined) edit = TextEdit.insert(position, newText);
            else if (ChangeAnnotationIdentifier.is(annotation)) {
                id = annotation;
                edit = AnnotatedTextEdit.insert(position, newText, annotation);
            } else {
                this.assertChangeAnnotations(this.changeAnnotations);
                id = this.changeAnnotations.manage(annotation);
                edit = AnnotatedTextEdit.insert(position, newText, id);
            }
            this.edits.push(edit);
            if (id !== undefined) return id;
        };
        TextEditChangeImpl.prototype.replace = function(range, newText, annotation) {
            var edit;
            var id;
            if (annotation === undefined) edit = TextEdit.replace(range, newText);
            else if (ChangeAnnotationIdentifier.is(annotation)) {
                id = annotation;
                edit = AnnotatedTextEdit.replace(range, newText, annotation);
            } else {
                this.assertChangeAnnotations(this.changeAnnotations);
                id = this.changeAnnotations.manage(annotation);
                edit = AnnotatedTextEdit.replace(range, newText, id);
            }
            this.edits.push(edit);
            if (id !== undefined) return id;
        };
        TextEditChangeImpl.prototype.delete = function(range, annotation) {
            var edit;
            var id;
            if (annotation === undefined) edit = TextEdit.del(range);
            else if (ChangeAnnotationIdentifier.is(annotation)) {
                id = annotation;
                edit = AnnotatedTextEdit.del(range, annotation);
            } else {
                this.assertChangeAnnotations(this.changeAnnotations);
                id = this.changeAnnotations.manage(annotation);
                edit = AnnotatedTextEdit.del(range, id);
            }
            this.edits.push(edit);
            if (id !== undefined) return id;
        };
        TextEditChangeImpl.prototype.add = function(edit) {
            this.edits.push(edit);
        };
        TextEditChangeImpl.prototype.all = function() {
            return this.edits;
        };
        TextEditChangeImpl.prototype.clear = function() {
            this.edits.splice(0, this.edits.length);
        };
        TextEditChangeImpl.prototype.assertChangeAnnotations = function(value) {
            if (value === undefined) throw new Error("Text edit change is not configured to manage change annotations.");
        };
        return TextEditChangeImpl;
    }();
    /**
     * A helper class
     */ var ChangeAnnotations = /** @class */ function() {
        function ChangeAnnotations(annotations) {
            this._annotations = annotations === undefined ? Object.create(null) : annotations;
            this._counter = 0;
            this._size = 0;
        }
        ChangeAnnotations.prototype.all = function() {
            return this._annotations;
        };
        Object.defineProperty(ChangeAnnotations.prototype, "size", {
            get: function() {
                return this._size;
            },
            enumerable: false,
            configurable: true
        });
        ChangeAnnotations.prototype.manage = function(idOrAnnotation, annotation) {
            var id;
            if (ChangeAnnotationIdentifier.is(idOrAnnotation)) id = idOrAnnotation;
            else {
                id = this.nextId();
                annotation = idOrAnnotation;
            }
            if (this._annotations[id] !== undefined) throw new Error("Id ".concat(id, " is already in use."));
            if (annotation === undefined) throw new Error("No annotation provided for id ".concat(id));
            this._annotations[id] = annotation;
            this._size++;
            return id;
        };
        ChangeAnnotations.prototype.nextId = function() {
            this._counter++;
            return this._counter.toString();
        };
        return ChangeAnnotations;
    }();
    /**
     * A workspace change helps constructing changes to a workspace.
     */ var WorkspaceChange = /** @class */ function() {
        function WorkspaceChange(workspaceEdit) {
            var _this = this;
            this._textEditChanges = Object.create(null);
            if (workspaceEdit !== undefined) {
                this._workspaceEdit = workspaceEdit;
                if (workspaceEdit.documentChanges) {
                    this._changeAnnotations = new ChangeAnnotations(workspaceEdit.changeAnnotations);
                    workspaceEdit.changeAnnotations = this._changeAnnotations.all();
                    workspaceEdit.documentChanges.forEach(function(change) {
                        if (TextDocumentEdit.is(change)) {
                            var textEditChange = new TextEditChangeImpl(change.edits, _this._changeAnnotations);
                            _this._textEditChanges[change.textDocument.uri] = textEditChange;
                        }
                    });
                } else if (workspaceEdit.changes) Object.keys(workspaceEdit.changes).forEach(function(key) {
                    var textEditChange = new TextEditChangeImpl(workspaceEdit.changes[key]);
                    _this._textEditChanges[key] = textEditChange;
                });
            } else this._workspaceEdit = {};
        }
        Object.defineProperty(WorkspaceChange.prototype, "edit", {
            /**
             * Returns the underlying {@link WorkspaceEdit} literal
             * use to be returned from a workspace edit operation like rename.
             */ get: function() {
                this.initDocumentChanges();
                if (this._changeAnnotations !== undefined) {
                    if (this._changeAnnotations.size === 0) this._workspaceEdit.changeAnnotations = undefined;
                    else this._workspaceEdit.changeAnnotations = this._changeAnnotations.all();
                }
                return this._workspaceEdit;
            },
            enumerable: false,
            configurable: true
        });
        WorkspaceChange.prototype.getTextEditChange = function(key) {
            if (OptionalVersionedTextDocumentIdentifier.is(key)) {
                this.initDocumentChanges();
                if (this._workspaceEdit.documentChanges === undefined) throw new Error("Workspace edit is not configured for document changes.");
                var textDocument = {
                    uri: key.uri,
                    version: key.version
                };
                var result = this._textEditChanges[textDocument.uri];
                if (!result) {
                    var edits = [];
                    var textDocumentEdit = {
                        textDocument: textDocument,
                        edits: edits
                    };
                    this._workspaceEdit.documentChanges.push(textDocumentEdit);
                    result = new TextEditChangeImpl(edits, this._changeAnnotations);
                    this._textEditChanges[textDocument.uri] = result;
                }
                return result;
            } else {
                this.initChanges();
                if (this._workspaceEdit.changes === undefined) throw new Error("Workspace edit is not configured for normal text edit changes.");
                var result = this._textEditChanges[key];
                if (!result) {
                    var edits = [];
                    this._workspaceEdit.changes[key] = edits;
                    result = new TextEditChangeImpl(edits);
                    this._textEditChanges[key] = result;
                }
                return result;
            }
        };
        WorkspaceChange.prototype.initDocumentChanges = function() {
            if (this._workspaceEdit.documentChanges === undefined && this._workspaceEdit.changes === undefined) {
                this._changeAnnotations = new ChangeAnnotations();
                this._workspaceEdit.documentChanges = [];
                this._workspaceEdit.changeAnnotations = this._changeAnnotations.all();
            }
        };
        WorkspaceChange.prototype.initChanges = function() {
            if (this._workspaceEdit.documentChanges === undefined && this._workspaceEdit.changes === undefined) this._workspaceEdit.changes = Object.create(null);
        };
        WorkspaceChange.prototype.createFile = function(uri, optionsOrAnnotation, options) {
            this.initDocumentChanges();
            if (this._workspaceEdit.documentChanges === undefined) throw new Error("Workspace edit is not configured for document changes.");
            var annotation;
            if (ChangeAnnotation.is(optionsOrAnnotation) || ChangeAnnotationIdentifier.is(optionsOrAnnotation)) annotation = optionsOrAnnotation;
            else options = optionsOrAnnotation;
            var operation;
            var id;
            if (annotation === undefined) operation = CreateFile.create(uri, options);
            else {
                id = ChangeAnnotationIdentifier.is(annotation) ? annotation : this._changeAnnotations.manage(annotation);
                operation = CreateFile.create(uri, options, id);
            }
            this._workspaceEdit.documentChanges.push(operation);
            if (id !== undefined) return id;
        };
        WorkspaceChange.prototype.renameFile = function(oldUri, newUri, optionsOrAnnotation, options) {
            this.initDocumentChanges();
            if (this._workspaceEdit.documentChanges === undefined) throw new Error("Workspace edit is not configured for document changes.");
            var annotation;
            if (ChangeAnnotation.is(optionsOrAnnotation) || ChangeAnnotationIdentifier.is(optionsOrAnnotation)) annotation = optionsOrAnnotation;
            else options = optionsOrAnnotation;
            var operation;
            var id;
            if (annotation === undefined) operation = RenameFile.create(oldUri, newUri, options);
            else {
                id = ChangeAnnotationIdentifier.is(annotation) ? annotation : this._changeAnnotations.manage(annotation);
                operation = RenameFile.create(oldUri, newUri, options, id);
            }
            this._workspaceEdit.documentChanges.push(operation);
            if (id !== undefined) return id;
        };
        WorkspaceChange.prototype.deleteFile = function(uri, optionsOrAnnotation, options) {
            this.initDocumentChanges();
            if (this._workspaceEdit.documentChanges === undefined) throw new Error("Workspace edit is not configured for document changes.");
            var annotation;
            if (ChangeAnnotation.is(optionsOrAnnotation) || ChangeAnnotationIdentifier.is(optionsOrAnnotation)) annotation = optionsOrAnnotation;
            else options = optionsOrAnnotation;
            var operation;
            var id;
            if (annotation === undefined) operation = DeleteFile.create(uri, options);
            else {
                id = ChangeAnnotationIdentifier.is(annotation) ? annotation : this._changeAnnotations.manage(annotation);
                operation = DeleteFile.create(uri, options, id);
            }
            this._workspaceEdit.documentChanges.push(operation);
            if (id !== undefined) return id;
        };
        return WorkspaceChange;
    }();
    exports1.WorkspaceChange = WorkspaceChange;
    /**
     * The TextDocumentIdentifier namespace provides helper functions to work with
     * {@link TextDocumentIdentifier} literals.
     */ var TextDocumentIdentifier;
    (function(TextDocumentIdentifier) {
        /**
         * Creates a new TextDocumentIdentifier literal.
         * @param uri The document's uri.
         */ function create(uri) {
            return {
                uri: uri
            };
        }
        TextDocumentIdentifier.create = create;
        /**
         * Checks whether the given literal conforms to the {@link TextDocumentIdentifier} interface.
         */ function is(value) {
            var candidate = value;
            return Is.defined(candidate) && Is.string(candidate.uri);
        }
        TextDocumentIdentifier.is = is;
    })(TextDocumentIdentifier || (exports1.TextDocumentIdentifier = TextDocumentIdentifier = {}));
    /**
     * The VersionedTextDocumentIdentifier namespace provides helper functions to work with
     * {@link VersionedTextDocumentIdentifier} literals.
     */ var VersionedTextDocumentIdentifier;
    (function(VersionedTextDocumentIdentifier) {
        /**
         * Creates a new VersionedTextDocumentIdentifier literal.
         * @param uri The document's uri.
         * @param version The document's version.
         */ function create(uri, version) {
            return {
                uri: uri,
                version: version
            };
        }
        VersionedTextDocumentIdentifier.create = create;
        /**
         * Checks whether the given literal conforms to the {@link VersionedTextDocumentIdentifier} interface.
         */ function is(value) {
            var candidate = value;
            return Is.defined(candidate) && Is.string(candidate.uri) && Is.integer(candidate.version);
        }
        VersionedTextDocumentIdentifier.is = is;
    })(VersionedTextDocumentIdentifier || (exports1.VersionedTextDocumentIdentifier = VersionedTextDocumentIdentifier = {}));
    /**
     * The OptionalVersionedTextDocumentIdentifier namespace provides helper functions to work with
     * {@link OptionalVersionedTextDocumentIdentifier} literals.
     */ var OptionalVersionedTextDocumentIdentifier;
    (function(OptionalVersionedTextDocumentIdentifier) {
        /**
         * Creates a new OptionalVersionedTextDocumentIdentifier literal.
         * @param uri The document's uri.
         * @param version The document's version.
         */ function create(uri, version) {
            return {
                uri: uri,
                version: version
            };
        }
        OptionalVersionedTextDocumentIdentifier.create = create;
        /**
         * Checks whether the given literal conforms to the {@link OptionalVersionedTextDocumentIdentifier} interface.
         */ function is(value) {
            var candidate = value;
            return Is.defined(candidate) && Is.string(candidate.uri) && (candidate.version === null || Is.integer(candidate.version));
        }
        OptionalVersionedTextDocumentIdentifier.is = is;
    })(OptionalVersionedTextDocumentIdentifier || (exports1.OptionalVersionedTextDocumentIdentifier = OptionalVersionedTextDocumentIdentifier = {}));
    /**
     * The TextDocumentItem namespace provides helper functions to work with
     * {@link TextDocumentItem} literals.
     */ var TextDocumentItem;
    (function(TextDocumentItem) {
        /**
         * Creates a new TextDocumentItem literal.
         * @param uri The document's uri.
         * @param languageId The document's language identifier.
         * @param version The document's version number.
         * @param text The document's text.
         */ function create(uri, languageId, version, text) {
            return {
                uri: uri,
                languageId: languageId,
                version: version,
                text: text
            };
        }
        TextDocumentItem.create = create;
        /**
         * Checks whether the given literal conforms to the {@link TextDocumentItem} interface.
         */ function is(value) {
            var candidate = value;
            return Is.defined(candidate) && Is.string(candidate.uri) && Is.string(candidate.languageId) && Is.integer(candidate.version) && Is.string(candidate.text);
        }
        TextDocumentItem.is = is;
    })(TextDocumentItem || (exports1.TextDocumentItem = TextDocumentItem = {}));
    /**
     * Describes the content type that a client supports in various
     * result literals like `Hover`, `ParameterInfo` or `CompletionItem`.
     *
     * Please note that `MarkupKinds` must not start with a `$`. This kinds
     * are reserved for internal usage.
     */ var MarkupKind;
    (function(MarkupKind) {
        /**
         * Plain text is supported as a content format
         */ MarkupKind.PlainText = "plaintext";
        /**
         * Markdown is supported as a content format
         */ MarkupKind.Markdown = "markdown";
        /**
         * Checks whether the given value is a value of the {@link MarkupKind} type.
         */ function is(value) {
            var candidate = value;
            return candidate === MarkupKind.PlainText || candidate === MarkupKind.Markdown;
        }
        MarkupKind.is = is;
    })(MarkupKind || (exports1.MarkupKind = MarkupKind = {}));
    var MarkupContent;
    (function(MarkupContent) {
        /**
         * Checks whether the given value conforms to the {@link MarkupContent} interface.
         */ function is(value) {
            var candidate = value;
            return Is.objectLiteral(value) && MarkupKind.is(candidate.kind) && Is.string(candidate.value);
        }
        MarkupContent.is = is;
    })(MarkupContent || (exports1.MarkupContent = MarkupContent = {}));
    /**
     * The kind of a completion entry.
     */ var CompletionItemKind;
    (function(CompletionItemKind) {
        CompletionItemKind.Text = 1;
        CompletionItemKind.Method = 2;
        CompletionItemKind.Function = 3;
        CompletionItemKind.Constructor = 4;
        CompletionItemKind.Field = 5;
        CompletionItemKind.Variable = 6;
        CompletionItemKind.Class = 7;
        CompletionItemKind.Interface = 8;
        CompletionItemKind.Module = 9;
        CompletionItemKind.Property = 10;
        CompletionItemKind.Unit = 11;
        CompletionItemKind.Value = 12;
        CompletionItemKind.Enum = 13;
        CompletionItemKind.Keyword = 14;
        CompletionItemKind.Snippet = 15;
        CompletionItemKind.Color = 16;
        CompletionItemKind.File = 17;
        CompletionItemKind.Reference = 18;
        CompletionItemKind.Folder = 19;
        CompletionItemKind.EnumMember = 20;
        CompletionItemKind.Constant = 21;
        CompletionItemKind.Struct = 22;
        CompletionItemKind.Event = 23;
        CompletionItemKind.Operator = 24;
        CompletionItemKind.TypeParameter = 25;
    })(CompletionItemKind || (exports1.CompletionItemKind = CompletionItemKind = {}));
    /**
     * Defines whether the insert text in a completion item should be interpreted as
     * plain text or a snippet.
     */ var InsertTextFormat;
    (function(InsertTextFormat) {
        /**
         * The primary text to be inserted is treated as a plain string.
         */ InsertTextFormat.PlainText = 1;
        /**
         * The primary text to be inserted is treated as a snippet.
         *
         * A snippet can define tab stops and placeholders with `$1`, `$2`
         * and `${3:foo}`. `$0` defines the final tab stop, it defaults to
         * the end of the snippet. Placeholders with equal identifiers are linked,
         * that is typing in one will update others too.
         *
         * See also: https://microsoft.github.io/language-server-protocol/specifications/specification-current/#snippet_syntax
         */ InsertTextFormat.Snippet = 2;
    })(InsertTextFormat || (exports1.InsertTextFormat = InsertTextFormat = {}));
    /**
     * Completion item tags are extra annotations that tweak the rendering of a completion
     * item.
     *
     * @since 3.15.0
     */ var CompletionItemTag;
    (function(CompletionItemTag) {
        /**
         * Render a completion as obsolete, usually using a strike-out.
         */ CompletionItemTag.Deprecated = 1;
    })(CompletionItemTag || (exports1.CompletionItemTag = CompletionItemTag = {}));
    /**
     * The InsertReplaceEdit namespace provides functions to deal with insert / replace edits.
     *
     * @since 3.16.0
     */ var InsertReplaceEdit;
    (function(InsertReplaceEdit) {
        /**
         * Creates a new insert / replace edit
         */ function create(newText, insert, replace) {
            return {
                newText: newText,
                insert: insert,
                replace: replace
            };
        }
        InsertReplaceEdit.create = create;
        /**
         * Checks whether the given literal conforms to the {@link InsertReplaceEdit} interface.
         */ function is(value) {
            var candidate = value;
            return candidate && Is.string(candidate.newText) && Range.is(candidate.insert) && Range.is(candidate.replace);
        }
        InsertReplaceEdit.is = is;
    })(InsertReplaceEdit || (exports1.InsertReplaceEdit = InsertReplaceEdit = {}));
    /**
     * How whitespace and indentation is handled during completion
     * item insertion.
     *
     * @since 3.16.0
     */ var InsertTextMode;
    (function(InsertTextMode) {
        /**
         * The insertion or replace strings is taken as it is. If the
         * value is multi line the lines below the cursor will be
         * inserted using the indentation defined in the string value.
         * The client will not apply any kind of adjustments to the
         * string.
         */ InsertTextMode.asIs = 1;
        /**
         * The editor adjusts leading whitespace of new lines so that
         * they match the indentation up to the cursor of the line for
         * which the item is accepted.
         *
         * Consider a line like this: <2tabs><cursor><3tabs>foo. Accepting a
         * multi line completion item is indented using 2 tabs and all
         * following lines inserted will be indented using 2 tabs as well.
         */ InsertTextMode.adjustIndentation = 2;
    })(InsertTextMode || (exports1.InsertTextMode = InsertTextMode = {}));
    var CompletionItemLabelDetails;
    (function(CompletionItemLabelDetails) {
        function is(value) {
            var candidate = value;
            return candidate && (Is.string(candidate.detail) || candidate.detail === undefined) && (Is.string(candidate.description) || candidate.description === undefined);
        }
        CompletionItemLabelDetails.is = is;
    })(CompletionItemLabelDetails || (exports1.CompletionItemLabelDetails = CompletionItemLabelDetails = {}));
    /**
     * The CompletionItem namespace provides functions to deal with
     * completion items.
     */ var CompletionItem;
    (function(CompletionItem) {
        /**
         * Create a completion item and seed it with a label.
         * @param label The completion item's label
         */ function create(label) {
            return {
                label: label
            };
        }
        CompletionItem.create = create;
    })(CompletionItem || (exports1.CompletionItem = CompletionItem = {}));
    /**
     * The CompletionList namespace provides functions to deal with
     * completion lists.
     */ var CompletionList;
    (function(CompletionList) {
        /**
         * Creates a new completion list.
         *
         * @param items The completion items.
         * @param isIncomplete The list is not complete.
         */ function create(items, isIncomplete) {
            return {
                items: items ? items : [],
                isIncomplete: !!isIncomplete
            };
        }
        CompletionList.create = create;
    })(CompletionList || (exports1.CompletionList = CompletionList = {}));
    var MarkedString;
    (function(MarkedString) {
        /**
         * Creates a marked string from plain text.
         *
         * @param plainText The plain text.
         */ function fromPlainText(plainText) {
            return plainText.replace(/[\\`*_{}[\]()#+\-.!]/g, "\\$&"); // escape markdown syntax tokens: http://daringfireball.net/projects/markdown/syntax#backslash
        }
        MarkedString.fromPlainText = fromPlainText;
        /**
         * Checks whether the given value conforms to the {@link MarkedString} type.
         */ function is(value) {
            var candidate = value;
            return Is.string(candidate) || Is.objectLiteral(candidate) && Is.string(candidate.language) && Is.string(candidate.value);
        }
        MarkedString.is = is;
    })(MarkedString || (exports1.MarkedString = MarkedString = {}));
    var Hover;
    (function(Hover) {
        /**
         * Checks whether the given value conforms to the {@link Hover} interface.
         */ function is(value) {
            var candidate = value;
            return !!candidate && Is.objectLiteral(candidate) && (MarkupContent.is(candidate.contents) || MarkedString.is(candidate.contents) || Is.typedArray(candidate.contents, MarkedString.is)) && (value.range === undefined || Range.is(value.range));
        }
        Hover.is = is;
    })(Hover || (exports1.Hover = Hover = {}));
    /**
     * The ParameterInformation namespace provides helper functions to work with
     * {@link ParameterInformation} literals.
     */ var ParameterInformation;
    (function(ParameterInformation) {
        /**
         * Creates a new parameter information literal.
         *
         * @param label A label string.
         * @param documentation A doc string.
         */ function create(label, documentation) {
            return documentation ? {
                label: label,
                documentation: documentation
            } : {
                label: label
            };
        }
        ParameterInformation.create = create;
    })(ParameterInformation || (exports1.ParameterInformation = ParameterInformation = {}));
    /**
     * The SignatureInformation namespace provides helper functions to work with
     * {@link SignatureInformation} literals.
     */ var SignatureInformation;
    (function(SignatureInformation) {
        function create(label, documentation) {
            var parameters = [];
            for(var _i = 2; _i < arguments.length; _i++)parameters[_i - 2] = arguments[_i];
            var result = {
                label: label
            };
            if (Is.defined(documentation)) result.documentation = documentation;
            if (Is.defined(parameters)) result.parameters = parameters;
            else result.parameters = [];
            return result;
        }
        SignatureInformation.create = create;
    })(SignatureInformation || (exports1.SignatureInformation = SignatureInformation = {}));
    /**
     * A document highlight kind.
     */ var DocumentHighlightKind;
    (function(DocumentHighlightKind) {
        /**
         * A textual occurrence.
         */ DocumentHighlightKind.Text = 1;
        /**
         * Read-access of a symbol, like reading a variable.
         */ DocumentHighlightKind.Read = 2;
        /**
         * Write-access of a symbol, like writing to a variable.
         */ DocumentHighlightKind.Write = 3;
    })(DocumentHighlightKind || (exports1.DocumentHighlightKind = DocumentHighlightKind = {}));
    /**
     * DocumentHighlight namespace to provide helper functions to work with
     * {@link DocumentHighlight} literals.
     */ var DocumentHighlight;
    (function(DocumentHighlight) {
        /**
         * Create a DocumentHighlight object.
         * @param range The range the highlight applies to.
         * @param kind The highlight kind
         */ function create(range, kind) {
            var result = {
                range: range
            };
            if (Is.number(kind)) result.kind = kind;
            return result;
        }
        DocumentHighlight.create = create;
    })(DocumentHighlight || (exports1.DocumentHighlight = DocumentHighlight = {}));
    /**
     * A symbol kind.
     */ var SymbolKind;
    (function(SymbolKind) {
        SymbolKind.File = 1;
        SymbolKind.Module = 2;
        SymbolKind.Namespace = 3;
        SymbolKind.Package = 4;
        SymbolKind.Class = 5;
        SymbolKind.Method = 6;
        SymbolKind.Property = 7;
        SymbolKind.Field = 8;
        SymbolKind.Constructor = 9;
        SymbolKind.Enum = 10;
        SymbolKind.Interface = 11;
        SymbolKind.Function = 12;
        SymbolKind.Variable = 13;
        SymbolKind.Constant = 14;
        SymbolKind.String = 15;
        SymbolKind.Number = 16;
        SymbolKind.Boolean = 17;
        SymbolKind.Array = 18;
        SymbolKind.Object = 19;
        SymbolKind.Key = 20;
        SymbolKind.Null = 21;
        SymbolKind.EnumMember = 22;
        SymbolKind.Struct = 23;
        SymbolKind.Event = 24;
        SymbolKind.Operator = 25;
        SymbolKind.TypeParameter = 26;
    })(SymbolKind || (exports1.SymbolKind = SymbolKind = {}));
    /**
     * Symbol tags are extra annotations that tweak the rendering of a symbol.
     *
     * @since 3.16
     */ var SymbolTag;
    (function(SymbolTag) {
        /**
         * Render a symbol as obsolete, usually using a strike-out.
         */ SymbolTag.Deprecated = 1;
    })(SymbolTag || (exports1.SymbolTag = SymbolTag = {}));
    var SymbolInformation;
    (function(SymbolInformation) {
        /**
         * Creates a new symbol information literal.
         *
         * @param name The name of the symbol.
         * @param kind The kind of the symbol.
         * @param range The range of the location of the symbol.
         * @param uri The resource of the location of symbol.
         * @param containerName The name of the symbol containing the symbol.
         */ function create(name, kind, range, uri, containerName) {
            var result = {
                name: name,
                kind: kind,
                location: {
                    uri: uri,
                    range: range
                }
            };
            if (containerName) result.containerName = containerName;
            return result;
        }
        SymbolInformation.create = create;
    })(SymbolInformation || (exports1.SymbolInformation = SymbolInformation = {}));
    var WorkspaceSymbol;
    (function(WorkspaceSymbol) {
        /**
         * Create a new workspace symbol.
         *
         * @param name The name of the symbol.
         * @param kind The kind of the symbol.
         * @param uri The resource of the location of the symbol.
         * @param range An options range of the location.
         * @returns A WorkspaceSymbol.
         */ function create(name, kind, uri, range) {
            return range !== undefined ? {
                name: name,
                kind: kind,
                location: {
                    uri: uri,
                    range: range
                }
            } : {
                name: name,
                kind: kind,
                location: {
                    uri: uri
                }
            };
        }
        WorkspaceSymbol.create = create;
    })(WorkspaceSymbol || (exports1.WorkspaceSymbol = WorkspaceSymbol = {}));
    var DocumentSymbol;
    (function(DocumentSymbol) {
        /**
         * Creates a new symbol information literal.
         *
         * @param name The name of the symbol.
         * @param detail The detail of the symbol.
         * @param kind The kind of the symbol.
         * @param range The range of the symbol.
         * @param selectionRange The selectionRange of the symbol.
         * @param children Children of the symbol.
         */ function create(name, detail, kind, range, selectionRange, children) {
            var result = {
                name: name,
                detail: detail,
                kind: kind,
                range: range,
                selectionRange: selectionRange
            };
            if (children !== undefined) result.children = children;
            return result;
        }
        DocumentSymbol.create = create;
        /**
         * Checks whether the given literal conforms to the {@link DocumentSymbol} interface.
         */ function is(value) {
            var candidate = value;
            return candidate && Is.string(candidate.name) && Is.number(candidate.kind) && Range.is(candidate.range) && Range.is(candidate.selectionRange) && (candidate.detail === undefined || Is.string(candidate.detail)) && (candidate.deprecated === undefined || Is.boolean(candidate.deprecated)) && (candidate.children === undefined || Array.isArray(candidate.children)) && (candidate.tags === undefined || Array.isArray(candidate.tags));
        }
        DocumentSymbol.is = is;
    })(DocumentSymbol || (exports1.DocumentSymbol = DocumentSymbol = {}));
    /**
     * A set of predefined code action kinds
     */ var CodeActionKind;
    (function(CodeActionKind) {
        /**
         * Empty kind.
         */ CodeActionKind.Empty = "";
        /**
         * Base kind for quickfix actions: 'quickfix'
         */ CodeActionKind.QuickFix = "quickfix";
        /**
         * Base kind for refactoring actions: 'refactor'
         */ CodeActionKind.Refactor = "refactor";
        /**
         * Base kind for refactoring extraction actions: 'refactor.extract'
         *
         * Example extract actions:
         *
         * - Extract method
         * - Extract function
         * - Extract variable
         * - Extract interface from class
         * - ...
         */ CodeActionKind.RefactorExtract = "refactor.extract";
        /**
         * Base kind for refactoring inline actions: 'refactor.inline'
         *
         * Example inline actions:
         *
         * - Inline function
         * - Inline variable
         * - Inline constant
         * - ...
         */ CodeActionKind.RefactorInline = "refactor.inline";
        /**
         * Base kind for refactoring rewrite actions: 'refactor.rewrite'
         *
         * Example rewrite actions:
         *
         * - Convert JavaScript function to class
         * - Add or remove parameter
         * - Encapsulate field
         * - Make method static
         * - Move method to base class
         * - ...
         */ CodeActionKind.RefactorRewrite = "refactor.rewrite";
        /**
         * Base kind for source actions: `source`
         *
         * Source code actions apply to the entire file.
         */ CodeActionKind.Source = "source";
        /**
         * Base kind for an organize imports source action: `source.organizeImports`
         */ CodeActionKind.SourceOrganizeImports = "source.organizeImports";
        /**
         * Base kind for auto-fix source actions: `source.fixAll`.
         *
         * Fix all actions automatically fix errors that have a clear fix that do not require user input.
         * They should not suppress errors or perform unsafe fixes such as generating new types or classes.
         *
         * @since 3.15.0
         */ CodeActionKind.SourceFixAll = "source.fixAll";
    })(CodeActionKind || (exports1.CodeActionKind = CodeActionKind = {}));
    /**
     * The reason why code actions were requested.
     *
     * @since 3.17.0
     */ var CodeActionTriggerKind;
    (function(CodeActionTriggerKind) {
        /**
         * Code actions were explicitly requested by the user or by an extension.
         */ CodeActionTriggerKind.Invoked = 1;
        /**
         * Code actions were requested automatically.
         *
         * This typically happens when current selection in a file changes, but can
         * also be triggered when file content changes.
         */ CodeActionTriggerKind.Automatic = 2;
    })(CodeActionTriggerKind || (exports1.CodeActionTriggerKind = CodeActionTriggerKind = {}));
    /**
     * The CodeActionContext namespace provides helper functions to work with
     * {@link CodeActionContext} literals.
     */ var CodeActionContext;
    (function(CodeActionContext) {
        /**
         * Creates a new CodeActionContext literal.
         */ function create(diagnostics, only, triggerKind) {
            var result = {
                diagnostics: diagnostics
            };
            if (only !== undefined && only !== null) result.only = only;
            if (triggerKind !== undefined && triggerKind !== null) result.triggerKind = triggerKind;
            return result;
        }
        CodeActionContext.create = create;
        /**
         * Checks whether the given literal conforms to the {@link CodeActionContext} interface.
         */ function is(value) {
            var candidate = value;
            return Is.defined(candidate) && Is.typedArray(candidate.diagnostics, Diagnostic.is) && (candidate.only === undefined || Is.typedArray(candidate.only, Is.string)) && (candidate.triggerKind === undefined || candidate.triggerKind === CodeActionTriggerKind.Invoked || candidate.triggerKind === CodeActionTriggerKind.Automatic);
        }
        CodeActionContext.is = is;
    })(CodeActionContext || (exports1.CodeActionContext = CodeActionContext = {}));
    var CodeAction;
    (function(CodeAction) {
        function create(title, kindOrCommandOrEdit, kind) {
            var result = {
                title: title
            };
            var checkKind = true;
            if (typeof kindOrCommandOrEdit === "string") {
                checkKind = false;
                result.kind = kindOrCommandOrEdit;
            } else if (Command.is(kindOrCommandOrEdit)) result.command = kindOrCommandOrEdit;
            else result.edit = kindOrCommandOrEdit;
            if (checkKind && kind !== undefined) result.kind = kind;
            return result;
        }
        CodeAction.create = create;
        function is(value) {
            var candidate = value;
            return candidate && Is.string(candidate.title) && (candidate.diagnostics === undefined || Is.typedArray(candidate.diagnostics, Diagnostic.is)) && (candidate.kind === undefined || Is.string(candidate.kind)) && (candidate.edit !== undefined || candidate.command !== undefined) && (candidate.command === undefined || Command.is(candidate.command)) && (candidate.isPreferred === undefined || Is.boolean(candidate.isPreferred)) && (candidate.edit === undefined || WorkspaceEdit.is(candidate.edit));
        }
        CodeAction.is = is;
    })(CodeAction || (exports1.CodeAction = CodeAction = {}));
    /**
     * The CodeLens namespace provides helper functions to work with
     * {@link CodeLens} literals.
     */ var CodeLens;
    (function(CodeLens) {
        /**
         * Creates a new CodeLens literal.
         */ function create(range, data) {
            var result = {
                range: range
            };
            if (Is.defined(data)) result.data = data;
            return result;
        }
        CodeLens.create = create;
        /**
         * Checks whether the given literal conforms to the {@link CodeLens} interface.
         */ function is(value) {
            var candidate = value;
            return Is.defined(candidate) && Range.is(candidate.range) && (Is.undefined(candidate.command) || Command.is(candidate.command));
        }
        CodeLens.is = is;
    })(CodeLens || (exports1.CodeLens = CodeLens = {}));
    /**
     * The FormattingOptions namespace provides helper functions to work with
     * {@link FormattingOptions} literals.
     */ var FormattingOptions;
    (function(FormattingOptions) {
        /**
         * Creates a new FormattingOptions literal.
         */ function create(tabSize, insertSpaces) {
            return {
                tabSize: tabSize,
                insertSpaces: insertSpaces
            };
        }
        FormattingOptions.create = create;
        /**
         * Checks whether the given literal conforms to the {@link FormattingOptions} interface.
         */ function is(value) {
            var candidate = value;
            return Is.defined(candidate) && Is.uinteger(candidate.tabSize) && Is.boolean(candidate.insertSpaces);
        }
        FormattingOptions.is = is;
    })(FormattingOptions || (exports1.FormattingOptions = FormattingOptions = {}));
    /**
     * The DocumentLink namespace provides helper functions to work with
     * {@link DocumentLink} literals.
     */ var DocumentLink;
    (function(DocumentLink) {
        /**
         * Creates a new DocumentLink literal.
         */ function create(range, target, data) {
            return {
                range: range,
                target: target,
                data: data
            };
        }
        DocumentLink.create = create;
        /**
         * Checks whether the given literal conforms to the {@link DocumentLink} interface.
         */ function is(value) {
            var candidate = value;
            return Is.defined(candidate) && Range.is(candidate.range) && (Is.undefined(candidate.target) || Is.string(candidate.target));
        }
        DocumentLink.is = is;
    })(DocumentLink || (exports1.DocumentLink = DocumentLink = {}));
    /**
     * The SelectionRange namespace provides helper function to work with
     * SelectionRange literals.
     */ var SelectionRange;
    (function(SelectionRange) {
        /**
         * Creates a new SelectionRange
         * @param range the range.
         * @param parent an optional parent.
         */ function create(range, parent) {
            return {
                range: range,
                parent: parent
            };
        }
        SelectionRange.create = create;
        function is(value) {
            var candidate = value;
            return Is.objectLiteral(candidate) && Range.is(candidate.range) && (candidate.parent === undefined || SelectionRange.is(candidate.parent));
        }
        SelectionRange.is = is;
    })(SelectionRange || (exports1.SelectionRange = SelectionRange = {}));
    /**
     * A set of predefined token types. This set is not fixed
     * an clients can specify additional token types via the
     * corresponding client capabilities.
     *
     * @since 3.16.0
     */ var SemanticTokenTypes;
    (function(SemanticTokenTypes) {
        SemanticTokenTypes["namespace"] = "namespace";
        /**
         * Represents a generic type. Acts as a fallback for types which can't be mapped to
         * a specific type like class or enum.
         */ SemanticTokenTypes["type"] = "type";
        SemanticTokenTypes["class"] = "class";
        SemanticTokenTypes["enum"] = "enum";
        SemanticTokenTypes["interface"] = "interface";
        SemanticTokenTypes["struct"] = "struct";
        SemanticTokenTypes["typeParameter"] = "typeParameter";
        SemanticTokenTypes["parameter"] = "parameter";
        SemanticTokenTypes["variable"] = "variable";
        SemanticTokenTypes["property"] = "property";
        SemanticTokenTypes["enumMember"] = "enumMember";
        SemanticTokenTypes["event"] = "event";
        SemanticTokenTypes["function"] = "function";
        SemanticTokenTypes["method"] = "method";
        SemanticTokenTypes["macro"] = "macro";
        SemanticTokenTypes["keyword"] = "keyword";
        SemanticTokenTypes["modifier"] = "modifier";
        SemanticTokenTypes["comment"] = "comment";
        SemanticTokenTypes["string"] = "string";
        SemanticTokenTypes["number"] = "number";
        SemanticTokenTypes["regexp"] = "regexp";
        SemanticTokenTypes["operator"] = "operator";
        /**
         * @since 3.17.0
         */ SemanticTokenTypes["decorator"] = "decorator";
    })(SemanticTokenTypes || (exports1.SemanticTokenTypes = SemanticTokenTypes = {}));
    /**
     * A set of predefined token modifiers. This set is not fixed
     * an clients can specify additional token types via the
     * corresponding client capabilities.
     *
     * @since 3.16.0
     */ var SemanticTokenModifiers;
    (function(SemanticTokenModifiers) {
        SemanticTokenModifiers["declaration"] = "declaration";
        SemanticTokenModifiers["definition"] = "definition";
        SemanticTokenModifiers["readonly"] = "readonly";
        SemanticTokenModifiers["static"] = "static";
        SemanticTokenModifiers["deprecated"] = "deprecated";
        SemanticTokenModifiers["abstract"] = "abstract";
        SemanticTokenModifiers["async"] = "async";
        SemanticTokenModifiers["modification"] = "modification";
        SemanticTokenModifiers["documentation"] = "documentation";
        SemanticTokenModifiers["defaultLibrary"] = "defaultLibrary";
    })(SemanticTokenModifiers || (exports1.SemanticTokenModifiers = SemanticTokenModifiers = {}));
    /**
     * @since 3.16.0
     */ var SemanticTokens;
    (function(SemanticTokens) {
        function is(value) {
            var candidate = value;
            return Is.objectLiteral(candidate) && (candidate.resultId === undefined || typeof candidate.resultId === "string") && Array.isArray(candidate.data) && (candidate.data.length === 0 || typeof candidate.data[0] === "number");
        }
        SemanticTokens.is = is;
    })(SemanticTokens || (exports1.SemanticTokens = SemanticTokens = {}));
    /**
     * The InlineValueText namespace provides functions to deal with InlineValueTexts.
     *
     * @since 3.17.0
     */ var InlineValueText;
    (function(InlineValueText) {
        /**
         * Creates a new InlineValueText literal.
         */ function create(range, text) {
            return {
                range: range,
                text: text
            };
        }
        InlineValueText.create = create;
        function is(value) {
            var candidate = value;
            return candidate !== undefined && candidate !== null && Range.is(candidate.range) && Is.string(candidate.text);
        }
        InlineValueText.is = is;
    })(InlineValueText || (exports1.InlineValueText = InlineValueText = {}));
    /**
     * The InlineValueVariableLookup namespace provides functions to deal with InlineValueVariableLookups.
     *
     * @since 3.17.0
     */ var InlineValueVariableLookup;
    (function(InlineValueVariableLookup) {
        /**
         * Creates a new InlineValueText literal.
         */ function create(range, variableName, caseSensitiveLookup) {
            return {
                range: range,
                variableName: variableName,
                caseSensitiveLookup: caseSensitiveLookup
            };
        }
        InlineValueVariableLookup.create = create;
        function is(value) {
            var candidate = value;
            return candidate !== undefined && candidate !== null && Range.is(candidate.range) && Is.boolean(candidate.caseSensitiveLookup) && (Is.string(candidate.variableName) || candidate.variableName === undefined);
        }
        InlineValueVariableLookup.is = is;
    })(InlineValueVariableLookup || (exports1.InlineValueVariableLookup = InlineValueVariableLookup = {}));
    /**
     * The InlineValueEvaluatableExpression namespace provides functions to deal with InlineValueEvaluatableExpression.
     *
     * @since 3.17.0
     */ var InlineValueEvaluatableExpression;
    (function(InlineValueEvaluatableExpression) {
        /**
         * Creates a new InlineValueEvaluatableExpression literal.
         */ function create(range, expression) {
            return {
                range: range,
                expression: expression
            };
        }
        InlineValueEvaluatableExpression.create = create;
        function is(value) {
            var candidate = value;
            return candidate !== undefined && candidate !== null && Range.is(candidate.range) && (Is.string(candidate.expression) || candidate.expression === undefined);
        }
        InlineValueEvaluatableExpression.is = is;
    })(InlineValueEvaluatableExpression || (exports1.InlineValueEvaluatableExpression = InlineValueEvaluatableExpression = {}));
    /**
     * The InlineValueContext namespace provides helper functions to work with
     * {@link InlineValueContext} literals.
     *
     * @since 3.17.0
     */ var InlineValueContext;
    (function(InlineValueContext) {
        /**
         * Creates a new InlineValueContext literal.
         */ function create(frameId, stoppedLocation) {
            return {
                frameId: frameId,
                stoppedLocation: stoppedLocation
            };
        }
        InlineValueContext.create = create;
        /**
         * Checks whether the given literal conforms to the {@link InlineValueContext} interface.
         */ function is(value) {
            var candidate = value;
            return Is.defined(candidate) && Range.is(value.stoppedLocation);
        }
        InlineValueContext.is = is;
    })(InlineValueContext || (exports1.InlineValueContext = InlineValueContext = {}));
    /**
     * Inlay hint kinds.
     *
     * @since 3.17.0
     */ var InlayHintKind;
    (function(InlayHintKind) {
        /**
         * An inlay hint that for a type annotation.
         */ InlayHintKind.Type = 1;
        /**
         * An inlay hint that is for a parameter.
         */ InlayHintKind.Parameter = 2;
        function is(value) {
            return value === 1 || value === 2;
        }
        InlayHintKind.is = is;
    })(InlayHintKind || (exports1.InlayHintKind = InlayHintKind = {}));
    var InlayHintLabelPart;
    (function(InlayHintLabelPart) {
        function create(value) {
            return {
                value: value
            };
        }
        InlayHintLabelPart.create = create;
        function is(value) {
            var candidate = value;
            return Is.objectLiteral(candidate) && (candidate.tooltip === undefined || Is.string(candidate.tooltip) || MarkupContent.is(candidate.tooltip)) && (candidate.location === undefined || Location.is(candidate.location)) && (candidate.command === undefined || Command.is(candidate.command));
        }
        InlayHintLabelPart.is = is;
    })(InlayHintLabelPart || (exports1.InlayHintLabelPart = InlayHintLabelPart = {}));
    var InlayHint;
    (function(InlayHint) {
        function create(position, label, kind) {
            var result = {
                position: position,
                label: label
            };
            if (kind !== undefined) result.kind = kind;
            return result;
        }
        InlayHint.create = create;
        function is(value) {
            var candidate = value;
            return Is.objectLiteral(candidate) && Position.is(candidate.position) && (Is.string(candidate.label) || Is.typedArray(candidate.label, InlayHintLabelPart.is)) && (candidate.kind === undefined || InlayHintKind.is(candidate.kind)) && candidate.textEdits === undefined || Is.typedArray(candidate.textEdits, TextEdit.is) && (candidate.tooltip === undefined || Is.string(candidate.tooltip) || MarkupContent.is(candidate.tooltip)) && (candidate.paddingLeft === undefined || Is.boolean(candidate.paddingLeft)) && (candidate.paddingRight === undefined || Is.boolean(candidate.paddingRight));
        }
        InlayHint.is = is;
    })(InlayHint || (exports1.InlayHint = InlayHint = {}));
    var StringValue;
    (function(StringValue) {
        function createSnippet(value) {
            return {
                kind: "snippet",
                value: value
            };
        }
        StringValue.createSnippet = createSnippet;
    })(StringValue || (exports1.StringValue = StringValue = {}));
    var InlineCompletionItem;
    (function(InlineCompletionItem) {
        function create(insertText, filterText, range, command) {
            return {
                insertText: insertText,
                filterText: filterText,
                range: range,
                command: command
            };
        }
        InlineCompletionItem.create = create;
    })(InlineCompletionItem || (exports1.InlineCompletionItem = InlineCompletionItem = {}));
    var InlineCompletionList;
    (function(InlineCompletionList) {
        function create(items) {
            return {
                items: items
            };
        }
        InlineCompletionList.create = create;
    })(InlineCompletionList || (exports1.InlineCompletionList = InlineCompletionList = {}));
    /**
     * Describes how an {@link InlineCompletionItemProvider inline completion provider} was triggered.
     *
     * @since 3.18.0
     * @proposed
     */ var InlineCompletionTriggerKind;
    (function(InlineCompletionTriggerKind) {
        /**
         * Completion was triggered explicitly by a user gesture.
         */ InlineCompletionTriggerKind.Invoked = 0;
        /**
         * Completion was triggered automatically while editing.
         */ InlineCompletionTriggerKind.Automatic = 1;
    })(InlineCompletionTriggerKind || (exports1.InlineCompletionTriggerKind = InlineCompletionTriggerKind = {}));
    var SelectedCompletionInfo;
    (function(SelectedCompletionInfo) {
        function create(range, text) {
            return {
                range: range,
                text: text
            };
        }
        SelectedCompletionInfo.create = create;
    })(SelectedCompletionInfo || (exports1.SelectedCompletionInfo = SelectedCompletionInfo = {}));
    var InlineCompletionContext;
    (function(InlineCompletionContext) {
        function create(triggerKind, selectedCompletionInfo) {
            return {
                triggerKind: triggerKind,
                selectedCompletionInfo: selectedCompletionInfo
            };
        }
        InlineCompletionContext.create = create;
    })(InlineCompletionContext || (exports1.InlineCompletionContext = InlineCompletionContext = {}));
    var WorkspaceFolder;
    (function(WorkspaceFolder) {
        function is(value) {
            var candidate = value;
            return Is.objectLiteral(candidate) && URI.is(candidate.uri) && Is.string(candidate.name);
        }
        WorkspaceFolder.is = is;
    })(WorkspaceFolder || (exports1.WorkspaceFolder = WorkspaceFolder = {}));
    exports1.EOL = [
        "\n",
        "\r\n",
        "\r"
    ];
    /**
     * @deprecated Use the text document from the new vscode-languageserver-textdocument package.
     */ var TextDocument;
    (function(TextDocument) {
        /**
         * Creates a new ITextDocument literal from the given uri and content.
         * @param uri The document's uri.
         * @param languageId The document's language Id.
         * @param version The document's version.
         * @param content The document's content.
         */ function create(uri, languageId, version, content) {
            return new FullTextDocument(uri, languageId, version, content);
        }
        TextDocument.create = create;
        /**
         * Checks whether the given literal conforms to the {@link ITextDocument} interface.
         */ function is(value) {
            var candidate = value;
            return Is.defined(candidate) && Is.string(candidate.uri) && (Is.undefined(candidate.languageId) || Is.string(candidate.languageId)) && Is.uinteger(candidate.lineCount) && Is.func(candidate.getText) && Is.func(candidate.positionAt) && Is.func(candidate.offsetAt) ? true : false;
        }
        TextDocument.is = is;
        function applyEdits(document, edits) {
            var text = document.getText();
            var sortedEdits = mergeSort(edits, function(a, b) {
                var diff = a.range.start.line - b.range.start.line;
                if (diff === 0) return a.range.start.character - b.range.start.character;
                return diff;
            });
            var lastModifiedOffset = text.length;
            for(var i = sortedEdits.length - 1; i >= 0; i--){
                var e = sortedEdits[i];
                var startOffset = document.offsetAt(e.range.start);
                var endOffset = document.offsetAt(e.range.end);
                if (endOffset <= lastModifiedOffset) text = text.substring(0, startOffset) + e.newText + text.substring(endOffset, text.length);
                else throw new Error("Overlapping edit");
                lastModifiedOffset = startOffset;
            }
            return text;
        }
        TextDocument.applyEdits = applyEdits;
        function mergeSort(data, compare) {
            if (data.length <= 1) // sorted
            return data;
            var p = data.length / 2 | 0;
            var left = data.slice(0, p);
            var right = data.slice(p);
            mergeSort(left, compare);
            mergeSort(right, compare);
            var leftIdx = 0;
            var rightIdx = 0;
            var i = 0;
            while(leftIdx < left.length && rightIdx < right.length){
                var ret = compare(left[leftIdx], right[rightIdx]);
                if (ret <= 0) // smaller_equal -> take left to preserve order
                data[i++] = left[leftIdx++];
                else // greater -> take right
                data[i++] = right[rightIdx++];
            }
            while(leftIdx < left.length)data[i++] = left[leftIdx++];
            while(rightIdx < right.length)data[i++] = right[rightIdx++];
            return data;
        }
    })(TextDocument || (exports1.TextDocument = TextDocument = {}));
    /**
     * @deprecated Use the text document from the new vscode-languageserver-textdocument package.
     */ var FullTextDocument = /** @class */ function() {
        function FullTextDocument(uri, languageId, version, content) {
            this._uri = uri;
            this._languageId = languageId;
            this._version = version;
            this._content = content;
            this._lineOffsets = undefined;
        }
        Object.defineProperty(FullTextDocument.prototype, "uri", {
            get: function() {
                return this._uri;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(FullTextDocument.prototype, "languageId", {
            get: function() {
                return this._languageId;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(FullTextDocument.prototype, "version", {
            get: function() {
                return this._version;
            },
            enumerable: false,
            configurable: true
        });
        FullTextDocument.prototype.getText = function(range) {
            if (range) {
                var start = this.offsetAt(range.start);
                var end = this.offsetAt(range.end);
                return this._content.substring(start, end);
            }
            return this._content;
        };
        FullTextDocument.prototype.update = function(event, version) {
            this._content = event.text;
            this._version = version;
            this._lineOffsets = undefined;
        };
        FullTextDocument.prototype.getLineOffsets = function() {
            if (this._lineOffsets === undefined) {
                var lineOffsets = [];
                var text = this._content;
                var isLineStart = true;
                for(var i = 0; i < text.length; i++){
                    if (isLineStart) {
                        lineOffsets.push(i);
                        isLineStart = false;
                    }
                    var ch = text.charAt(i);
                    isLineStart = ch === "\r" || ch === "\n";
                    if (ch === "\r" && i + 1 < text.length && text.charAt(i + 1) === "\n") i++;
                }
                if (isLineStart && text.length > 0) lineOffsets.push(text.length);
                this._lineOffsets = lineOffsets;
            }
            return this._lineOffsets;
        };
        FullTextDocument.prototype.positionAt = function(offset) {
            offset = Math.max(Math.min(offset, this._content.length), 0);
            var lineOffsets = this.getLineOffsets();
            var low = 0, high = lineOffsets.length;
            if (high === 0) return Position.create(0, offset);
            while(low < high){
                var mid = Math.floor((low + high) / 2);
                if (lineOffsets[mid] > offset) high = mid;
                else low = mid + 1;
            }
            // low is the least x for which the line offset is larger than the current offset
            // or array.length if no line offset is larger than the current offset
            var line = low - 1;
            return Position.create(line, offset - lineOffsets[line]);
        };
        FullTextDocument.prototype.offsetAt = function(position) {
            var lineOffsets = this.getLineOffsets();
            if (position.line >= lineOffsets.length) return this._content.length;
            else if (position.line < 0) return 0;
            var lineOffset = lineOffsets[position.line];
            var nextLineOffset = position.line + 1 < lineOffsets.length ? lineOffsets[position.line + 1] : this._content.length;
            return Math.max(Math.min(lineOffset + position.character, nextLineOffset), lineOffset);
        };
        Object.defineProperty(FullTextDocument.prototype, "lineCount", {
            get: function() {
                return this.getLineOffsets().length;
            },
            enumerable: false,
            configurable: true
        });
        return FullTextDocument;
    }();
    var Is;
    (function(Is) {
        var toString = Object.prototype.toString;
        function defined(value) {
            return typeof value !== "undefined";
        }
        Is.defined = defined;
        function undefined1(value) {
            return typeof value === "undefined";
        }
        Is.undefined = undefined1;
        function boolean(value) {
            return value === true || value === false;
        }
        Is.boolean = boolean;
        function string(value) {
            return toString.call(value) === "[object String]";
        }
        Is.string = string;
        function number(value) {
            return toString.call(value) === "[object Number]";
        }
        Is.number = number;
        function numberRange(value, min, max) {
            return toString.call(value) === "[object Number]" && min <= value && value <= max;
        }
        Is.numberRange = numberRange;
        function integer(value) {
            return toString.call(value) === "[object Number]" && -2147483648 <= value && value <= 2147483647;
        }
        Is.integer = integer;
        function uinteger(value) {
            return toString.call(value) === "[object Number]" && 0 <= value && value <= 2147483647;
        }
        Is.uinteger = uinteger;
        function func(value) {
            return toString.call(value) === "[object Function]";
        }
        Is.func = func;
        function objectLiteral(value) {
            // Strictly speaking class instances pass this check as well. Since the LSP
            // doesn't use classes we ignore this for now. If we do we need to add something
            // like this: `Object.getPrototypeOf(Object.getPrototypeOf(x)) === null`
            return value !== null && typeof value === "object";
        }
        Is.objectLiteral = objectLiteral;
        function typedArray(value, check) {
            return Array.isArray(value) && value.every(check);
        }
        Is.typedArray = typedArray;
    })(Is || (Is = {}));
});

});


parcelRegister("k1lDu", function(module, exports) {
$parcel$export(module.exports, "RuleKinds", () => (parcelRequire("3H3du")).RuleKinds);

$parcel$export(module.exports, "CharacterStream", () => (parcelRequire("8qHvn")).default);
$parcel$export(module.exports, "LexRules", () => (parcelRequire("gSA1H")).LexRules);
$parcel$export(module.exports, "ParseRules", () => (parcelRequire("gSA1H")).ParseRules);
$parcel$export(module.exports, "isIgnored", () => (parcelRequire("gSA1H")).isIgnored);
$parcel$export(module.exports, "list", () => (parcelRequire("kW3R4")).list);
$parcel$export(module.exports, "opt", () => (parcelRequire("kW3R4")).opt);
$parcel$export(module.exports, "p", () => (parcelRequire("kW3R4")).p);
$parcel$export(module.exports, "t", () => (parcelRequire("kW3R4")).t);
$parcel$export(module.exports, "onlineParser", () => (parcelRequire("imwtR")).default);

var $8qHvn = parcelRequire("8qHvn");

var $gSA1H = parcelRequire("gSA1H");

var $kW3R4 = parcelRequire("kW3R4");

var $imwtR = parcelRequire("imwtR");
parcelRequire("3H3du");

});
parcelRegister("8qHvn", function(module, exports) {

$parcel$export(module.exports, "default", () => $62327fa1bcb4d475$export$2e2bcd8739ae039);
class $62327fa1bcb4d475$export$2e2bcd8739ae039 {
    constructor(sourceText){
        this._start = 0;
        this._pos = 0;
        this.getStartOfToken = ()=>this._start;
        this.getCurrentPosition = ()=>this._pos;
        this.eol = ()=>this._sourceText.length === this._pos;
        this.sol = ()=>this._pos === 0;
        this.peek = ()=>{
            return this._sourceText.charAt(this._pos) || null;
        };
        this.next = ()=>{
            const char = this._sourceText.charAt(this._pos);
            this._pos++;
            return char;
        };
        this.eat = (pattern)=>{
            const isMatched = this._testNextCharacter(pattern);
            if (isMatched) {
                this._start = this._pos;
                this._pos++;
                return this._sourceText.charAt(this._pos - 1);
            }
            return undefined;
        };
        this.eatWhile = (match)=>{
            let isMatched = this._testNextCharacter(match);
            let didEat = false;
            if (isMatched) {
                didEat = isMatched;
                this._start = this._pos;
            }
            while(isMatched){
                this._pos++;
                isMatched = this._testNextCharacter(match);
                didEat = true;
            }
            return didEat;
        };
        this.eatSpace = ()=>this.eatWhile(/[\s\u00a0]/);
        this.skipToEnd = ()=>{
            this._pos = this._sourceText.length;
        };
        this.skipTo = (position)=>{
            this._pos = position;
        };
        this.match = (pattern, consume = true, caseFold = false)=>{
            let token = null;
            let match = null;
            if (typeof pattern === "string") {
                const regex = new RegExp(pattern, caseFold ? "i" : "g");
                match = regex.test(this._sourceText.slice(this._pos, this._pos + pattern.length));
                token = pattern;
            } else if (pattern instanceof RegExp) {
                match = this._sourceText.slice(this._pos).match(pattern);
                token = match === null || match === void 0 ? void 0 : match[0];
            }
            if (match != null && (typeof pattern === "string" || match instanceof Array && this._sourceText.startsWith(match[0], this._pos))) {
                if (consume) {
                    this._start = this._pos;
                    if (token && token.length) this._pos += token.length;
                }
                return match;
            }
            return false;
        };
        this.backUp = (num)=>{
            this._pos -= num;
        };
        this.column = ()=>this._pos;
        this.indentation = ()=>{
            const match = this._sourceText.match(/\s*/);
            let indent = 0;
            if (match && match.length !== 0) {
                const whiteSpaces = match[0];
                let pos = 0;
                while(whiteSpaces.length > pos){
                    if (whiteSpaces.charCodeAt(pos) === 9) indent += 2;
                    else indent++;
                    pos++;
                }
            }
            return indent;
        };
        this.current = ()=>this._sourceText.slice(this._start, this._pos);
        this._sourceText = sourceText;
    }
    _testNextCharacter(pattern) {
        const character = this._sourceText.charAt(this._pos);
        let isMatched = false;
        if (typeof pattern === "string") isMatched = character === pattern;
        else isMatched = pattern instanceof RegExp ? pattern.test(character) : pattern(character);
        return isMatched;
    }
}

});

parcelRegister("gSA1H", function(module, exports) {

$parcel$export(module.exports, "isIgnored", () => $c49da2911909c1b2$export$ac3f691269cd6d9b);
$parcel$export(module.exports, "LexRules", () => $c49da2911909c1b2$export$bbe68772034ff21b);
$parcel$export(module.exports, "ParseRules", () => $c49da2911909c1b2$export$fa684e14cde3a8d6);

var $kW3R4 = parcelRequire("kW3R4");

var $hu3w4 = parcelRequire("hu3w4");
const $c49da2911909c1b2$export$ac3f691269cd6d9b = (ch)=>ch === " " || ch === "	" || ch === "," || ch === "\n" || ch === "\r" || ch === "\uFEFF" || ch === "\xa0";
const $c49da2911909c1b2$export$bbe68772034ff21b = {
    Name: /^[_A-Za-z][_0-9A-Za-z]*/,
    Punctuation: /^(?:!|\$|\(|\)|\.\.\.|:|=|&|@|\[|]|\{|\||\})/,
    Number: /^-?(?:0|(?:[1-9][0-9]*))(?:\.[0-9]*)?(?:[eE][+-]?[0-9]+)?/,
    String: /^(?:"""(?:\\"""|[^"]|"[^"]|""[^"])*(?:""")?|"(?:[^"\\]|\\(?:"|\/|\\|b|f|n|r|t|u[0-9a-fA-F]{4}))*"?)/,
    Comment: /^#.*/
};
const $c49da2911909c1b2$export$fa684e14cde3a8d6 = {
    Document: [
        (0, $kW3R4.list)("Definition")
    ],
    Definition (token) {
        switch(token.value){
            case "{":
                return "ShortQuery";
            case "query":
                return "Query";
            case "mutation":
                return "Mutation";
            case "subscription":
                return "Subscription";
            case "fragment":
                return (0, $hu3w4.Kind).FRAGMENT_DEFINITION;
            case "schema":
                return "SchemaDef";
            case "scalar":
                return "ScalarDef";
            case "type":
                return "ObjectTypeDef";
            case "interface":
                return "InterfaceDef";
            case "union":
                return "UnionDef";
            case "enum":
                return "EnumDef";
            case "input":
                return "InputDef";
            case "extend":
                return "ExtendDef";
            case "directive":
                return "DirectiveDef";
        }
    },
    ShortQuery: [
        "SelectionSet"
    ],
    Query: [
        $c49da2911909c1b2$var$word("query"),
        (0, $kW3R4.opt)($c49da2911909c1b2$var$name("def")),
        (0, $kW3R4.opt)("VariableDefinitions"),
        (0, $kW3R4.list)("Directive"),
        "SelectionSet"
    ],
    Mutation: [
        $c49da2911909c1b2$var$word("mutation"),
        (0, $kW3R4.opt)($c49da2911909c1b2$var$name("def")),
        (0, $kW3R4.opt)("VariableDefinitions"),
        (0, $kW3R4.list)("Directive"),
        "SelectionSet"
    ],
    Subscription: [
        $c49da2911909c1b2$var$word("subscription"),
        (0, $kW3R4.opt)($c49da2911909c1b2$var$name("def")),
        (0, $kW3R4.opt)("VariableDefinitions"),
        (0, $kW3R4.list)("Directive"),
        "SelectionSet"
    ],
    VariableDefinitions: [
        (0, $kW3R4.p)("("),
        (0, $kW3R4.list)("VariableDefinition"),
        (0, $kW3R4.p)(")")
    ],
    VariableDefinition: [
        "Variable",
        (0, $kW3R4.p)(":"),
        "Type",
        (0, $kW3R4.opt)("DefaultValue")
    ],
    Variable: [
        (0, $kW3R4.p)("$", "variable"),
        $c49da2911909c1b2$var$name("variable")
    ],
    DefaultValue: [
        (0, $kW3R4.p)("="),
        "Value"
    ],
    SelectionSet: [
        (0, $kW3R4.p)("{"),
        (0, $kW3R4.list)("Selection"),
        (0, $kW3R4.p)("}")
    ],
    Selection (token, stream) {
        return token.value === "..." ? stream.match(/[\s\u00a0,]*(on\b|@|{)/, false) ? "InlineFragment" : "FragmentSpread" : stream.match(/[\s\u00a0,]*:/, false) ? "AliasedField" : "Field";
    },
    AliasedField: [
        $c49da2911909c1b2$var$name("property"),
        (0, $kW3R4.p)(":"),
        $c49da2911909c1b2$var$name("qualifier"),
        (0, $kW3R4.opt)("Arguments"),
        (0, $kW3R4.list)("Directive"),
        (0, $kW3R4.opt)("SelectionSet")
    ],
    Field: [
        $c49da2911909c1b2$var$name("property"),
        (0, $kW3R4.opt)("Arguments"),
        (0, $kW3R4.list)("Directive"),
        (0, $kW3R4.opt)("SelectionSet")
    ],
    Arguments: [
        (0, $kW3R4.p)("("),
        (0, $kW3R4.list)("Argument"),
        (0, $kW3R4.p)(")")
    ],
    Argument: [
        $c49da2911909c1b2$var$name("attribute"),
        (0, $kW3R4.p)(":"),
        "Value"
    ],
    FragmentSpread: [
        (0, $kW3R4.p)("..."),
        $c49da2911909c1b2$var$name("def"),
        (0, $kW3R4.list)("Directive")
    ],
    InlineFragment: [
        (0, $kW3R4.p)("..."),
        (0, $kW3R4.opt)("TypeCondition"),
        (0, $kW3R4.list)("Directive"),
        "SelectionSet"
    ],
    FragmentDefinition: [
        $c49da2911909c1b2$var$word("fragment"),
        (0, $kW3R4.opt)((0, $kW3R4.butNot)($c49da2911909c1b2$var$name("def"), [
            $c49da2911909c1b2$var$word("on")
        ])),
        "TypeCondition",
        (0, $kW3R4.list)("Directive"),
        "SelectionSet"
    ],
    TypeCondition: [
        $c49da2911909c1b2$var$word("on"),
        "NamedType"
    ],
    Value (token) {
        switch(token.kind){
            case "Number":
                return "NumberValue";
            case "String":
                return "StringValue";
            case "Punctuation":
                switch(token.value){
                    case "[":
                        return "ListValue";
                    case "{":
                        return "ObjectValue";
                    case "$":
                        return "Variable";
                    case "&":
                        return "NamedType";
                }
                return null;
            case "Name":
                switch(token.value){
                    case "true":
                    case "false":
                        return "BooleanValue";
                }
                if (token.value === "null") return "NullValue";
                return "EnumValue";
        }
    },
    NumberValue: [
        (0, $kW3R4.t)("Number", "number")
    ],
    StringValue: [
        {
            style: "string",
            match: (token)=>token.kind === "String",
            update (state, token) {
                if (token.value.startsWith('"""')) state.inBlockstring = !token.value.slice(3).endsWith('"""');
            }
        }
    ],
    BooleanValue: [
        (0, $kW3R4.t)("Name", "builtin")
    ],
    NullValue: [
        (0, $kW3R4.t)("Name", "keyword")
    ],
    EnumValue: [
        $c49da2911909c1b2$var$name("string-2")
    ],
    ListValue: [
        (0, $kW3R4.p)("["),
        (0, $kW3R4.list)("Value"),
        (0, $kW3R4.p)("]")
    ],
    ObjectValue: [
        (0, $kW3R4.p)("{"),
        (0, $kW3R4.list)("ObjectField"),
        (0, $kW3R4.p)("}")
    ],
    ObjectField: [
        $c49da2911909c1b2$var$name("attribute"),
        (0, $kW3R4.p)(":"),
        "Value"
    ],
    Type (token) {
        return token.value === "[" ? "ListType" : "NonNullType";
    },
    ListType: [
        (0, $kW3R4.p)("["),
        "Type",
        (0, $kW3R4.p)("]"),
        (0, $kW3R4.opt)((0, $kW3R4.p)("!"))
    ],
    NonNullType: [
        "NamedType",
        (0, $kW3R4.opt)((0, $kW3R4.p)("!"))
    ],
    NamedType: [
        $c49da2911909c1b2$var$type("atom")
    ],
    Directive: [
        (0, $kW3R4.p)("@", "meta"),
        $c49da2911909c1b2$var$name("meta"),
        (0, $kW3R4.opt)("Arguments")
    ],
    DirectiveDef: [
        $c49da2911909c1b2$var$word("directive"),
        (0, $kW3R4.p)("@", "meta"),
        $c49da2911909c1b2$var$name("meta"),
        (0, $kW3R4.opt)("ArgumentsDef"),
        $c49da2911909c1b2$var$word("on"),
        (0, $kW3R4.list)("DirectiveLocation", (0, $kW3R4.p)("|"))
    ],
    InterfaceDef: [
        $c49da2911909c1b2$var$word("interface"),
        $c49da2911909c1b2$var$name("atom"),
        (0, $kW3R4.opt)("Implements"),
        (0, $kW3R4.list)("Directive"),
        (0, $kW3R4.p)("{"),
        (0, $kW3R4.list)("FieldDef"),
        (0, $kW3R4.p)("}")
    ],
    Implements: [
        $c49da2911909c1b2$var$word("implements"),
        (0, $kW3R4.list)("NamedType", (0, $kW3R4.p)("&"))
    ],
    DirectiveLocation: [
        $c49da2911909c1b2$var$name("string-2")
    ],
    SchemaDef: [
        $c49da2911909c1b2$var$word("schema"),
        (0, $kW3R4.list)("Directive"),
        (0, $kW3R4.p)("{"),
        (0, $kW3R4.list)("OperationTypeDef"),
        (0, $kW3R4.p)("}")
    ],
    OperationTypeDef: [
        $c49da2911909c1b2$var$name("keyword"),
        (0, $kW3R4.p)(":"),
        $c49da2911909c1b2$var$name("atom")
    ],
    ScalarDef: [
        $c49da2911909c1b2$var$word("scalar"),
        $c49da2911909c1b2$var$name("atom"),
        (0, $kW3R4.list)("Directive")
    ],
    ObjectTypeDef: [
        $c49da2911909c1b2$var$word("type"),
        $c49da2911909c1b2$var$name("atom"),
        (0, $kW3R4.opt)("Implements"),
        (0, $kW3R4.list)("Directive"),
        (0, $kW3R4.p)("{"),
        (0, $kW3R4.list)("FieldDef"),
        (0, $kW3R4.p)("}")
    ],
    FieldDef: [
        $c49da2911909c1b2$var$name("property"),
        (0, $kW3R4.opt)("ArgumentsDef"),
        (0, $kW3R4.p)(":"),
        "Type",
        (0, $kW3R4.list)("Directive")
    ],
    ArgumentsDef: [
        (0, $kW3R4.p)("("),
        (0, $kW3R4.list)("InputValueDef"),
        (0, $kW3R4.p)(")")
    ],
    InputValueDef: [
        $c49da2911909c1b2$var$name("attribute"),
        (0, $kW3R4.p)(":"),
        "Type",
        (0, $kW3R4.opt)("DefaultValue"),
        (0, $kW3R4.list)("Directive")
    ],
    UnionDef: [
        $c49da2911909c1b2$var$word("union"),
        $c49da2911909c1b2$var$name("atom"),
        (0, $kW3R4.list)("Directive"),
        (0, $kW3R4.p)("="),
        (0, $kW3R4.list)("UnionMember", (0, $kW3R4.p)("|"))
    ],
    UnionMember: [
        "NamedType"
    ],
    EnumDef: [
        $c49da2911909c1b2$var$word("enum"),
        $c49da2911909c1b2$var$name("atom"),
        (0, $kW3R4.list)("Directive"),
        (0, $kW3R4.p)("{"),
        (0, $kW3R4.list)("EnumValueDef"),
        (0, $kW3R4.p)("}")
    ],
    EnumValueDef: [
        $c49da2911909c1b2$var$name("string-2"),
        (0, $kW3R4.list)("Directive")
    ],
    InputDef: [
        $c49da2911909c1b2$var$word("input"),
        $c49da2911909c1b2$var$name("atom"),
        (0, $kW3R4.list)("Directive"),
        (0, $kW3R4.p)("{"),
        (0, $kW3R4.list)("InputValueDef"),
        (0, $kW3R4.p)("}")
    ],
    ExtendDef: [
        $c49da2911909c1b2$var$word("extend"),
        "ExtensionDefinition"
    ],
    ExtensionDefinition (token) {
        switch(token.value){
            case "schema":
                return (0, $hu3w4.Kind).SCHEMA_EXTENSION;
            case "scalar":
                return (0, $hu3w4.Kind).SCALAR_TYPE_EXTENSION;
            case "type":
                return (0, $hu3w4.Kind).OBJECT_TYPE_EXTENSION;
            case "interface":
                return (0, $hu3w4.Kind).INTERFACE_TYPE_EXTENSION;
            case "union":
                return (0, $hu3w4.Kind).UNION_TYPE_EXTENSION;
            case "enum":
                return (0, $hu3w4.Kind).ENUM_TYPE_EXTENSION;
            case "input":
                return (0, $hu3w4.Kind).INPUT_OBJECT_TYPE_EXTENSION;
        }
    },
    [(0, $hu3w4.Kind).SCHEMA_EXTENSION]: [
        "SchemaDef"
    ],
    [(0, $hu3w4.Kind).SCALAR_TYPE_EXTENSION]: [
        "ScalarDef"
    ],
    [(0, $hu3w4.Kind).OBJECT_TYPE_EXTENSION]: [
        "ObjectTypeDef"
    ],
    [(0, $hu3w4.Kind).INTERFACE_TYPE_EXTENSION]: [
        "InterfaceDef"
    ],
    [(0, $hu3w4.Kind).UNION_TYPE_EXTENSION]: [
        "UnionDef"
    ],
    [(0, $hu3w4.Kind).ENUM_TYPE_EXTENSION]: [
        "EnumDef"
    ],
    [(0, $hu3w4.Kind).INPUT_OBJECT_TYPE_EXTENSION]: [
        "InputDef"
    ]
};
function $c49da2911909c1b2$var$word(value) {
    return {
        style: "keyword",
        match: (token)=>token.kind === "Name" && token.value === value
    };
}
function $c49da2911909c1b2$var$name(style) {
    return {
        style: style,
        match: (token)=>token.kind === "Name",
        update (state, token) {
            state.name = token.value;
        }
    };
}
function $c49da2911909c1b2$var$type(style) {
    return {
        style: style,
        match: (token)=>token.kind === "Name",
        update (state, token) {
            var _a;
            if ((_a = state.prevState) === null || _a === void 0 ? void 0 : _a.prevState) {
                state.name = token.value;
                state.prevState.prevState.type = token.value;
            }
        }
    };
}

});
parcelRegister("kW3R4", function(module, exports) {

$parcel$export(module.exports, "opt", () => $f3dc36f5c7a1bff0$export$2b91d3689f613272);
$parcel$export(module.exports, "list", () => $f3dc36f5c7a1bff0$export$8837f4fc672e936d);
$parcel$export(module.exports, "butNot", () => $f3dc36f5c7a1bff0$export$c2e04e72ed820600);
$parcel$export(module.exports, "t", () => $f3dc36f5c7a1bff0$export$625550452a3fa3ec);
$parcel$export(module.exports, "p", () => $f3dc36f5c7a1bff0$export$ffb5f4729a158638);
function $f3dc36f5c7a1bff0$export$2b91d3689f613272(ofRule) {
    return {
        ofRule: ofRule
    };
}
function $f3dc36f5c7a1bff0$export$8837f4fc672e936d(ofRule, separator) {
    return {
        ofRule: ofRule,
        isList: true,
        separator: separator
    };
}
function $f3dc36f5c7a1bff0$export$c2e04e72ed820600(rule, exclusions) {
    const ruleMatch = rule.match;
    rule.match = (token)=>{
        let check = false;
        if (ruleMatch) check = ruleMatch(token);
        return check && exclusions.every((exclusion)=>exclusion.match && !exclusion.match(token));
    };
    return rule;
}
function $f3dc36f5c7a1bff0$export$625550452a3fa3ec(kind, style) {
    return {
        style: style,
        match: (token)=>token.kind === kind
    };
}
function $f3dc36f5c7a1bff0$export$ffb5f4729a158638(value, style) {
    return {
        style: style || "punctuation",
        match: (token)=>token.kind === "Punctuation" && token.value === value
    };
}

});


parcelRegister("imwtR", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5e37a0b44d863bf$export$2e2bcd8739ae039);

var $gSA1H = parcelRequire("gSA1H");

var $hu3w4 = parcelRequire("hu3w4");
function $d5e37a0b44d863bf$export$2e2bcd8739ae039(options = {
    eatWhitespace: (stream)=>stream.eatWhile((0, $gSA1H.isIgnored)),
    lexRules: (0, $gSA1H.LexRules),
    parseRules: (0, $gSA1H.ParseRules),
    editorConfig: {}
}) {
    return {
        startState () {
            const initialState = {
                level: 0,
                step: 0,
                name: null,
                kind: null,
                type: null,
                rule: null,
                needsSeparator: false,
                prevState: null
            };
            $d5e37a0b44d863bf$var$pushRule(options.parseRules, initialState, (0, $hu3w4.Kind).DOCUMENT);
            return initialState;
        },
        token (stream, state) {
            return $d5e37a0b44d863bf$var$getToken(stream, state, options);
        }
    };
}
function $d5e37a0b44d863bf$var$getToken(stream, state, options) {
    var _a;
    if (state.inBlockstring) {
        if (stream.match(/.*"""/)) {
            state.inBlockstring = false;
            return "string";
        }
        stream.skipToEnd();
        return "string";
    }
    const { lexRules: lexRules, parseRules: parseRules, eatWhitespace: eatWhitespace, editorConfig: editorConfig } = options;
    if (state.rule && state.rule.length === 0) $d5e37a0b44d863bf$var$popRule(state);
    else if (state.needsAdvance) {
        state.needsAdvance = false;
        $d5e37a0b44d863bf$var$advanceRule(state, true);
    }
    if (stream.sol()) {
        const tabSize = (editorConfig === null || editorConfig === void 0 ? void 0 : editorConfig.tabSize) || 2;
        state.indentLevel = Math.floor(stream.indentation() / tabSize);
    }
    if (eatWhitespace(stream)) return "ws";
    const token = $d5e37a0b44d863bf$var$lex(lexRules, stream);
    if (!token) {
        const matchedSomething = stream.match(/\S+/);
        if (!matchedSomething) stream.match(/\s/);
        $d5e37a0b44d863bf$var$pushRule($d5e37a0b44d863bf$var$SpecialParseRules, state, "Invalid");
        return "invalidchar";
    }
    if (token.kind === "Comment") {
        $d5e37a0b44d863bf$var$pushRule($d5e37a0b44d863bf$var$SpecialParseRules, state, "Comment");
        return "comment";
    }
    const backupState = $d5e37a0b44d863bf$var$assign({}, state);
    if (token.kind === "Punctuation") {
        if (/^[{([]/.test(token.value)) {
            if (state.indentLevel !== undefined) state.levels = (state.levels || []).concat(state.indentLevel + 1);
        } else if (/^[})\]]/.test(token.value)) {
            const levels = state.levels = (state.levels || []).slice(0, -1);
            if (state.indentLevel && levels.length > 0 && levels.at(-1) < state.indentLevel) state.indentLevel = levels.at(-1);
        }
    }
    while(state.rule){
        let expected = typeof state.rule === "function" ? state.step === 0 ? state.rule(token, stream) : null : state.rule[state.step];
        if (state.needsSeparator) expected = expected === null || expected === void 0 ? void 0 : expected.separator;
        if (expected) {
            if (expected.ofRule) expected = expected.ofRule;
            if (typeof expected === "string") {
                $d5e37a0b44d863bf$var$pushRule(parseRules, state, expected);
                continue;
            }
            if ((_a = expected.match) === null || _a === void 0 ? void 0 : _a.call(expected, token)) {
                if (expected.update) expected.update(state, token);
                if (token.kind === "Punctuation") $d5e37a0b44d863bf$var$advanceRule(state, true);
                else state.needsAdvance = true;
                return expected.style;
            }
        }
        $d5e37a0b44d863bf$var$unsuccessful(state);
    }
    $d5e37a0b44d863bf$var$assign(state, backupState);
    $d5e37a0b44d863bf$var$pushRule($d5e37a0b44d863bf$var$SpecialParseRules, state, "Invalid");
    return "invalidchar";
}
function $d5e37a0b44d863bf$var$assign(to, from) {
    const keys = Object.keys(from);
    for(let i = 0; i < keys.length; i++)to[keys[i]] = from[keys[i]];
    return to;
}
const $d5e37a0b44d863bf$var$SpecialParseRules = {
    Invalid: [],
    Comment: []
};
function $d5e37a0b44d863bf$var$pushRule(rules, state, ruleKind) {
    if (!rules[ruleKind]) throw new TypeError("Unknown rule: " + ruleKind);
    state.prevState = Object.assign({}, state);
    state.kind = ruleKind;
    state.name = null;
    state.type = null;
    state.rule = rules[ruleKind];
    state.step = 0;
    state.needsSeparator = false;
}
function $d5e37a0b44d863bf$var$popRule(state) {
    if (!state.prevState) return;
    state.kind = state.prevState.kind;
    state.name = state.prevState.name;
    state.type = state.prevState.type;
    state.rule = state.prevState.rule;
    state.step = state.prevState.step;
    state.needsSeparator = state.prevState.needsSeparator;
    state.prevState = state.prevState.prevState;
}
function $d5e37a0b44d863bf$var$advanceRule(state, successful) {
    var _a;
    if ($d5e37a0b44d863bf$var$isList(state) && state.rule) {
        const step = state.rule[state.step];
        if (step.separator) {
            const { separator: separator } = step;
            state.needsSeparator = !state.needsSeparator;
            if (!state.needsSeparator && separator.ofRule) return;
        }
        if (successful) return;
    }
    state.needsSeparator = false;
    state.step++;
    while(state.rule && !(Array.isArray(state.rule) && state.step < state.rule.length)){
        $d5e37a0b44d863bf$var$popRule(state);
        if (state.rule) {
            if ($d5e37a0b44d863bf$var$isList(state)) {
                if ((_a = state.rule) === null || _a === void 0 ? void 0 : _a[state.step].separator) state.needsSeparator = !state.needsSeparator;
            } else {
                state.needsSeparator = false;
                state.step++;
            }
        }
    }
}
function $d5e37a0b44d863bf$var$isList(state) {
    const step = Array.isArray(state.rule) && typeof state.rule[state.step] !== "string" && state.rule[state.step];
    return step && step.isList;
}
function $d5e37a0b44d863bf$var$unsuccessful(state) {
    while(state.rule && !(Array.isArray(state.rule) && state.rule[state.step].ofRule))$d5e37a0b44d863bf$var$popRule(state);
    if (state.rule) $d5e37a0b44d863bf$var$advanceRule(state, false);
}
function $d5e37a0b44d863bf$var$lex(lexRules, stream) {
    const kinds = Object.keys(lexRules);
    for(let i = 0; i < kinds.length; i++){
        const match = stream.match(lexRules[kinds[i]]);
        if (match && match instanceof Array) return {
            kind: kinds[i],
            value: match[0]
        };
    }
}

});

parcelRegister("3H3du", function(module, exports) {

$parcel$export(module.exports, "RuleKinds", () => $2b07e200d9c16f34$export$c65ff9dce581485d);

var $hu3w4 = parcelRequire("hu3w4");
const $2b07e200d9c16f34$export$4ed66a522b579e4d = {
    ALIASED_FIELD: "AliasedField",
    ARGUMENTS: "Arguments",
    SHORT_QUERY: "ShortQuery",
    QUERY: "Query",
    MUTATION: "Mutation",
    SUBSCRIPTION: "Subscription",
    TYPE_CONDITION: "TypeCondition",
    INVALID: "Invalid",
    COMMENT: "Comment",
    SCHEMA_DEF: "SchemaDef",
    SCALAR_DEF: "ScalarDef",
    OBJECT_TYPE_DEF: "ObjectTypeDef",
    OBJECT_VALUE: "ObjectValue",
    LIST_VALUE: "ListValue",
    INTERFACE_DEF: "InterfaceDef",
    UNION_DEF: "UnionDef",
    ENUM_DEF: "EnumDef",
    ENUM_VALUE: "EnumValue",
    FIELD_DEF: "FieldDef",
    INPUT_DEF: "InputDef",
    INPUT_VALUE_DEF: "InputValueDef",
    ARGUMENTS_DEF: "ArgumentsDef",
    EXTEND_DEF: "ExtendDef",
    EXTENSION_DEFINITION: "ExtensionDefinition",
    DIRECTIVE_DEF: "DirectiveDef",
    IMPLEMENTS: "Implements",
    VARIABLE_DEFINITIONS: "VariableDefinitions",
    TYPE: "Type"
};
const $2b07e200d9c16f34$export$c65ff9dce581485d = Object.assign(Object.assign({}, (0, $hu3w4.Kind)), $2b07e200d9c16f34$export$4ed66a522b579e4d);

});



parcelRegister("eGAWc", function(module, exports) {
parcelRequire("fcdqG");
var $87oLu = parcelRequire("87oLu");
var $ab11a3f8bf7e09e9$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $ab11a3f8bf7e09e9$export$a24496dc2b29f9aa = "GraphQL";
function $ab11a3f8bf7e09e9$var$assert(value, message) {
    if (!value) throw new Error(message);
}
function $ab11a3f8bf7e09e9$var$getRange(text, node) {
    const location = node.loc;
    $ab11a3f8bf7e09e9$var$assert(location, "Expected ASTNode to have a location.");
    return (0, $87oLu.locToRange)(text, location);
}
function $ab11a3f8bf7e09e9$var$getPosition(text, node) {
    const location = node.loc;
    $ab11a3f8bf7e09e9$var$assert(location, "Expected ASTNode to have a location.");
    return (0, $87oLu.offsetToPosition)(text, location.start);
}
function $ab11a3f8bf7e09e9$export$823c7b82669290aa(text, node, dependencies) {
    return $ab11a3f8bf7e09e9$var$__awaiter(this, void 0, void 0, function*() {
        const name = node.name.value;
        const defNodes = dependencies.filter(({ definition: definition })=>definition.name && definition.name.value === name);
        if (defNodes.length === 0) throw new Error(`Definition not found for GraphQL type ${name}`);
        const definitions = defNodes.map(({ filePath: filePath, content: content, definition: definition })=>$ab11a3f8bf7e09e9$var$getDefinitionForNodeDefinition(filePath || "", content, definition));
        return {
            definitions: definitions,
            queryRange: definitions.map((_)=>$ab11a3f8bf7e09e9$var$getRange(text, node))
        };
    });
}
function $ab11a3f8bf7e09e9$export$9532e07b1807fe5f(fieldName, typeName, dependencies) {
    var _a;
    return $ab11a3f8bf7e09e9$var$__awaiter(this, void 0, void 0, function*() {
        const defNodes = dependencies.filter(({ definition: definition })=>definition.name && definition.name.value === typeName);
        if (defNodes.length === 0) throw new Error(`Definition not found for GraphQL type ${typeName}`);
        const definitions = [];
        for (const { filePath: filePath, content: content, definition: definition } of defNodes){
            const fieldDefinition = (_a = definition.fields) === null || _a === void 0 ? void 0 : _a.find((item)=>item.name.value === fieldName);
            if (fieldDefinition == null) continue;
            definitions.push($ab11a3f8bf7e09e9$var$getDefinitionForFieldDefinition(filePath || "", content, fieldDefinition));
        }
        return {
            definitions: definitions,
            queryRange: []
        };
    });
}
function $ab11a3f8bf7e09e9$export$889ce4d1ad8b1e9(text, fragment, dependencies) {
    return $ab11a3f8bf7e09e9$var$__awaiter(this, void 0, void 0, function*() {
        const name = fragment.name.value;
        const defNodes = dependencies.filter(({ definition: definition })=>definition.name.value === name);
        if (defNodes.length === 0) throw new Error(`Definition not found for GraphQL fragment ${name}`);
        const definitions = defNodes.map(({ filePath: filePath, content: content, definition: definition })=>$ab11a3f8bf7e09e9$var$getDefinitionForFragmentDefinition(filePath || "", content, definition));
        return {
            definitions: definitions,
            queryRange: definitions.map((_)=>$ab11a3f8bf7e09e9$var$getRange(text, fragment))
        };
    });
}
function $ab11a3f8bf7e09e9$export$d6db7c6e0dc1a7f2(path, text, definition) {
    return {
        definitions: [
            $ab11a3f8bf7e09e9$var$getDefinitionForFragmentDefinition(path, text, definition)
        ],
        queryRange: definition.name ? [
            $ab11a3f8bf7e09e9$var$getRange(text, definition.name)
        ] : []
    };
}
function $ab11a3f8bf7e09e9$var$getDefinitionForFragmentDefinition(path, text, definition) {
    const { name: name } = definition;
    if (!name) throw new Error("Expected ASTNode to have a Name.");
    return {
        path: path,
        position: $ab11a3f8bf7e09e9$var$getPosition(text, definition),
        range: $ab11a3f8bf7e09e9$var$getRange(text, definition),
        name: name.value || "",
        language: $ab11a3f8bf7e09e9$export$a24496dc2b29f9aa,
        projectRoot: path
    };
}
function $ab11a3f8bf7e09e9$var$getDefinitionForNodeDefinition(path, text, definition) {
    const { name: name } = definition;
    $ab11a3f8bf7e09e9$var$assert(name, "Expected ASTNode to have a Name.");
    return {
        path: path,
        position: $ab11a3f8bf7e09e9$var$getPosition(text, definition),
        range: $ab11a3f8bf7e09e9$var$getRange(text, definition),
        name: name.value || "",
        language: $ab11a3f8bf7e09e9$export$a24496dc2b29f9aa,
        projectRoot: path
    };
}
function $ab11a3f8bf7e09e9$var$getDefinitionForFieldDefinition(path, text, definition) {
    const { name: name } = definition;
    $ab11a3f8bf7e09e9$var$assert(name, "Expected ASTNode to have a Name.");
    return {
        path: path,
        position: $ab11a3f8bf7e09e9$var$getPosition(text, definition),
        range: $ab11a3f8bf7e09e9$var$getRange(text, definition),
        name: name.value || "",
        language: $ab11a3f8bf7e09e9$export$a24496dc2b29f9aa,
        projectRoot: path
    };
}

});
parcelRegister("fcdqG", function(module, exports) {

$parcel$export(module.exports, "getFragmentDependenciesForAST", () => (parcelRequire("eYQLF")).getFragmentDependenciesForAST);
$parcel$export(module.exports, "Position", () => (parcelRequire("87oLu")).Position);
$parcel$export(module.exports, "Range", () => (parcelRequire("87oLu")).Range);
$parcel$export(module.exports, "locToRange", () => (parcelRequire("87oLu")).locToRange);
$parcel$export(module.exports, "offsetToPosition", () => (parcelRequire("87oLu")).offsetToPosition);
$parcel$export(module.exports, "validateWithCustomRules", () => (parcelRequire("eKt33")).validateWithCustomRules);
$parcel$export(module.exports, "getOperationFacts", () => (parcelRequire("8xP5p")).default);

var $eYQLF = parcelRequire("eYQLF");

var $klZBH = parcelRequire("klZBH");

var $aa5t1 = parcelRequire("aa5t1");

var $87oLu = parcelRequire("87oLu");

var $eKt33 = parcelRequire("eKt33");

var $jAx3E = parcelRequire("jAx3E");

var $8xP5p = parcelRequire("8xP5p");

});
parcelRegister("eYQLF", function(module, exports) {

$parcel$export(module.exports, "getFragmentDependenciesForAST", () => $ae7f99ddf842aa0e$export$fc48429668bd2e3b);

var $8DJ2k = parcelRequire("8DJ2k");
var $9m7aI = parcelRequire("9m7aI");

var $gkUrQ = parcelRequire("gkUrQ");
const $ae7f99ddf842aa0e$export$807cd5645b7db3a = (operationString, fragmentDefinitions)=>{
    if (!fragmentDefinitions) return [];
    let parsedOperation;
    try {
        parsedOperation = (0, $8DJ2k.parse)(operationString);
    } catch (_a) {
        return [];
    }
    return $ae7f99ddf842aa0e$export$fc48429668bd2e3b(parsedOperation, fragmentDefinitions);
};
const $ae7f99ddf842aa0e$export$fc48429668bd2e3b = (parsedOperation, fragmentDefinitions)=>{
    if (!fragmentDefinitions) return [];
    const existingFrags = new Map();
    const referencedFragNames = new Set();
    (0, $9m7aI.visit)(parsedOperation, {
        FragmentDefinition (node) {
            existingFrags.set(node.name.value, true);
        },
        FragmentSpread (node) {
            if (!referencedFragNames.has(node.name.value)) referencedFragNames.add(node.name.value);
        }
    });
    const asts = new Set();
    for (const name of referencedFragNames)if (!existingFrags.has(name) && fragmentDefinitions.has(name)) asts.add((0, (/*@__PURE__*/$parcel$interopDefault($gkUrQ)))(fragmentDefinitions.get(name)));
    const referencedFragments = [];
    for (const ast of asts){
        (0, $9m7aI.visit)(ast, {
            FragmentSpread (node) {
                if (!referencedFragNames.has(node.name.value) && fragmentDefinitions.get(node.name.value)) {
                    asts.add((0, (/*@__PURE__*/$parcel$interopDefault($gkUrQ)))(fragmentDefinitions.get(node.name.value)));
                    referencedFragNames.add(node.name.value);
                }
            }
        });
        if (!existingFrags.has(ast.name.value)) referencedFragments.push(ast);
    }
    return referencedFragments;
};

});
parcelRegister("gkUrQ", function(module, exports) {
"use strict";
function $be4a4d061f6e4fbb$var$nullthrows(x, message) {
    if (x != null) return x;
    var error = new Error(message !== undefined ? message : "Got unexpected " + x);
    error.framesToPop = 1; // Skip nullthrows's own stack frame.
    throw error;
}
module.exports = $be4a4d061f6e4fbb$var$nullthrows;
module.exports.default = $be4a4d061f6e4fbb$var$nullthrows;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});


parcelRegister("klZBH", function(module, exports) {

var $54dWd = parcelRequire("54dWd");
const $ed158eb45f536f0b$export$1ede7a12cdd7ab1d = {
    useMarkdownDescription: false
};
function $ed158eb45f536f0b$var$text(into, newText) {
    into.push(newText);
}
function $ed158eb45f536f0b$var$renderType(into, t) {
    if ((0, $54dWd.isNonNullType)(t)) {
        $ed158eb45f536f0b$var$renderType(into, t.ofType);
        $ed158eb45f536f0b$var$text(into, "!");
    } else if ((0, $54dWd.isListType)(t)) {
        $ed158eb45f536f0b$var$text(into, "[");
        $ed158eb45f536f0b$var$renderType(into, t.ofType);
        $ed158eb45f536f0b$var$text(into, "]");
    } else $ed158eb45f536f0b$var$text(into, t.name);
}
function $ed158eb45f536f0b$var$renderDefinitionDescription(t, useMarkdown, description) {
    const into = [];
    const type = "type" in t ? t.type : t;
    if ("type" in t && t.description) {
        $ed158eb45f536f0b$var$text(into, t.description);
        $ed158eb45f536f0b$var$text(into, "\n\n");
    }
    $ed158eb45f536f0b$var$text(into, $ed158eb45f536f0b$var$renderTypeToString(type, useMarkdown));
    if (description) {
        $ed158eb45f536f0b$var$text(into, "\n");
        $ed158eb45f536f0b$var$text(into, description);
    } else if (!(0, $54dWd.isScalarType)(type) && "description" in type && type.description) {
        $ed158eb45f536f0b$var$text(into, "\n");
        $ed158eb45f536f0b$var$text(into, type.description);
    } else if ("ofType" in type && !(0, $54dWd.isScalarType)(type.ofType) && "description" in type.ofType && type.ofType.description) {
        $ed158eb45f536f0b$var$text(into, "\n");
        $ed158eb45f536f0b$var$text(into, type.ofType.description);
    }
    return into.join("");
}
function $ed158eb45f536f0b$var$renderTypeToString(t, useMarkdown) {
    const into = [];
    if (useMarkdown) $ed158eb45f536f0b$var$text(into, "```graphql\n");
    $ed158eb45f536f0b$var$renderType(into, t);
    if (useMarkdown) $ed158eb45f536f0b$var$text(into, "\n```");
    return into.join("");
}
const $ed158eb45f536f0b$var$defaultScalarTypesMap = {
    Int: {
        type: "integer"
    },
    String: {
        type: "string"
    },
    Float: {
        type: "number"
    },
    ID: {
        type: "string"
    },
    Boolean: {
        type: "boolean"
    },
    DateTime: {
        type: "string"
    }
};
class $ed158eb45f536f0b$var$Marker {
    constructor(){
        this.set = new Set();
    }
    mark(name) {
        if (this.set.has(name)) return false;
        this.set.add(name);
        return true;
    }
}
function $ed158eb45f536f0b$var$getJSONSchemaFromGraphQLType(fieldOrType, options) {
    var _a, _b;
    let definition = Object.create(null);
    const definitions = Object.create(null);
    const isField = "type" in fieldOrType;
    const type = isField ? fieldOrType.type : fieldOrType;
    const baseType = (0, $54dWd.isNonNullType)(type) ? type.ofType : type;
    const required = (0, $54dWd.isNonNullType)(type);
    if ((0, $54dWd.isScalarType)(baseType)) {
        if ((_a = options === null || options === void 0 ? void 0 : options.scalarSchemas) === null || _a === void 0 ? void 0 : _a[baseType.name]) definition = JSON.parse(JSON.stringify(options.scalarSchemas[baseType.name]));
        else definition.type = [
            "string",
            "number",
            "boolean",
            "integer"
        ];
        if (!required) {
            if (Array.isArray(definition.type)) definition.type.push("null");
            else if (definition.type) definition.type = [
                definition.type,
                "null"
            ];
            else if (definition.enum) definition.enum.push(null);
            else if (definition.oneOf) definition.oneOf.push({
                type: "null"
            });
            else definition = {
                oneOf: [
                    definition,
                    {
                        type: "null"
                    }
                ]
            };
        }
    } else if ((0, $54dWd.isEnumType)(baseType)) {
        definition.enum = baseType.getValues().map((val)=>val.name);
        if (!required) definition.enum.push(null);
    } else if ((0, $54dWd.isListType)(baseType)) {
        if (required) definition.type = "array";
        else definition.type = [
            "array",
            "null"
        ];
        const { definition: def, definitions: defs } = $ed158eb45f536f0b$var$getJSONSchemaFromGraphQLType(baseType.ofType, options);
        definition.items = def;
        if (defs) for (const defName of Object.keys(defs))definitions[defName] = defs[defName];
    } else if ((0, $54dWd.isInputObjectType)(baseType)) {
        if (required) definition.$ref = `#/definitions/${baseType.name}`;
        else definition.oneOf = [
            {
                $ref: `#/definitions/${baseType.name}`
            },
            {
                type: "null"
            }
        ];
        if ((_b = options === null || options === void 0 ? void 0 : options.definitionMarker) === null || _b === void 0 ? void 0 : _b.mark(baseType.name)) {
            const fields = baseType.getFields();
            const fieldDef = {
                type: "object",
                properties: {},
                required: []
            };
            fieldDef.description = $ed158eb45f536f0b$var$renderDefinitionDescription(baseType);
            if (options === null || options === void 0 ? void 0 : options.useMarkdownDescription) fieldDef.markdownDescription = $ed158eb45f536f0b$var$renderDefinitionDescription(baseType, true);
            for (const fieldName of Object.keys(fields)){
                const field = fields[fieldName];
                const { required: fieldRequired, definition: fieldDefinition, definitions: typeDefinitions } = $ed158eb45f536f0b$var$getJSONSchemaFromGraphQLType(field, options);
                fieldDef.properties[fieldName] = fieldDefinition;
                if (fieldRequired) fieldDef.required.push(fieldName);
                if (typeDefinitions) for (const [defName, value] of Object.entries(typeDefinitions))definitions[defName] = value;
            }
            definitions[baseType.name] = fieldDef;
        }
    }
    if ("defaultValue" in fieldOrType && fieldOrType.defaultValue !== undefined) definition.default = fieldOrType.defaultValue;
    const { description: description } = definition;
    definition.description = $ed158eb45f536f0b$var$renderDefinitionDescription(fieldOrType, false, description);
    if (options === null || options === void 0 ? void 0 : options.useMarkdownDescription) definition.markdownDescription = $ed158eb45f536f0b$var$renderDefinitionDescription(fieldOrType, true, description);
    return {
        required: required,
        definition: definition,
        definitions: definitions
    };
}
function $ed158eb45f536f0b$export$1ec5f4e9b181b419(variableToType, options) {
    var _a;
    const jsonSchema = {
        $schema: "http://json-schema.org/draft-04/schema",
        type: "object",
        properties: {},
        required: []
    };
    const runtimeOptions = Object.assign(Object.assign({}, options), {
        definitionMarker: new $ed158eb45f536f0b$var$Marker(),
        scalarSchemas: Object.assign(Object.assign({}, $ed158eb45f536f0b$var$defaultScalarTypesMap), options === null || options === void 0 ? void 0 : options.scalarSchemas)
    });
    if (variableToType) for (const [variableName, type] of Object.entries(variableToType)){
        const { definition: definition, required: required, definitions: definitions } = $ed158eb45f536f0b$var$getJSONSchemaFromGraphQLType(type, runtimeOptions);
        jsonSchema.properties[variableName] = definition;
        if (required) (_a = jsonSchema.required) === null || _a === void 0 || _a.push(variableName);
        if (definitions) jsonSchema.definitions = Object.assign(Object.assign({}, jsonSchema === null || jsonSchema === void 0 ? void 0 : jsonSchema.definitions), definitions);
    }
    return jsonSchema;
}

});

parcelRegister("aa5t1", function(module, exports) {

var $9m7aI = parcelRequire("9m7aI");
function $765f1431b86a4a2c$export$e2a831ce1d30cab8(query, ast, point) {
    const offset = $765f1431b86a4a2c$export$2cbd7e3fe789687b(query, point);
    let nodeContainingPosition;
    (0, $9m7aI.visit)(ast, {
        enter (node) {
            if (node.kind !== "Name" && node.loc && node.loc.start <= offset && offset <= node.loc.end) nodeContainingPosition = node;
            else return false;
        },
        leave (node) {
            if (node.loc && node.loc.start <= offset && offset <= node.loc.end) return false;
        }
    });
    return nodeContainingPosition;
}
function $765f1431b86a4a2c$export$2cbd7e3fe789687b(text, point) {
    const linesUntilPosition = text.split("\n").slice(0, point.line);
    return point.character + linesUntilPosition.map((line)=>line.length + 1).reduce((a, b)=>a + b, 0);
}

});

parcelRegister("87oLu", function(module, exports) {

$parcel$export(module.exports, "Range", () => $5e922ff814df0e98$export$9a58ef0d7ad3278c);
$parcel$export(module.exports, "Position", () => $5e922ff814df0e98$export$13807d9ee5a34a42);
$parcel$export(module.exports, "offsetToPosition", () => $5e922ff814df0e98$export$3b112b88a4fef625);
$parcel$export(module.exports, "locToRange", () => $5e922ff814df0e98$export$81633fcc954a657);
class $5e922ff814df0e98$export$9a58ef0d7ad3278c {
    constructor(start, end){
        this.containsPosition = (position)=>{
            if (this.start.line === position.line) return this.start.character <= position.character;
            if (this.end.line === position.line) return this.end.character >= position.character;
            return this.start.line <= position.line && this.end.line >= position.line;
        };
        this.start = start;
        this.end = end;
    }
    setStart(line, character) {
        this.start = new $5e922ff814df0e98$export$13807d9ee5a34a42(line, character);
    }
    setEnd(line, character) {
        this.end = new $5e922ff814df0e98$export$13807d9ee5a34a42(line, character);
    }
}
class $5e922ff814df0e98$export$13807d9ee5a34a42 {
    constructor(line, character){
        this.lessThanOrEqualTo = (position)=>this.line < position.line || this.line === position.line && this.character <= position.character;
        this.line = line;
        this.character = character;
    }
    setLine(line) {
        this.line = line;
    }
    setCharacter(character) {
        this.character = character;
    }
}
function $5e922ff814df0e98$export$3b112b88a4fef625(text, loc) {
    const EOL = "\n";
    const buf = text.slice(0, loc);
    const lines = buf.split(EOL).length - 1;
    const lastLineIndex = buf.lastIndexOf(EOL);
    return new $5e922ff814df0e98$export$13807d9ee5a34a42(lines, loc - lastLineIndex - 1);
}
function $5e922ff814df0e98$export$81633fcc954a657(text, loc) {
    const start = $5e922ff814df0e98$export$3b112b88a4fef625(text, loc.start);
    const end = $5e922ff814df0e98$export$3b112b88a4fef625(text, loc.end);
    return new $5e922ff814df0e98$export$9a58ef0d7ad3278c(start, end);
}

});

parcelRegister("eKt33", function(module, exports) {

$parcel$export(module.exports, "validateWithCustomRules", () => $abcbe4f77e7f6684$export$201900a5c98a060e);

var $diQTm = parcelRequire("diQTm");
var $hu3w4 = parcelRequire("hu3w4");
var $1FUzv = parcelRequire("1FUzv");
var $bKjUm = parcelRequire("bKjUm");
var $jPaVD = parcelRequire("jPaVD");
var $7aIqC = parcelRequire("7aIqC");
var $j8NV2 = parcelRequire("j8NV2");
var $1Mpnv = parcelRequire("1Mpnv");
var $cEYhC = parcelRequire("cEYhC");
var $2hatF = parcelRequire("2hatF");
var $2ia4v = parcelRequire("2ia4v");
var $464Lr = parcelRequire("464Lr");
var $iH3W9 = parcelRequire("iH3W9");
var $3928j = parcelRequire("3928j");
var $8um4Z = parcelRequire("8um4Z");
var $5bfCp = parcelRequire("5bfCp");
var $lpOFf = parcelRequire("lpOFf");
var $dFUlP = parcelRequire("dFUlP");
const $abcbe4f77e7f6684$var$specifiedSDLRules = [
    (0, $7aIqC.LoneSchemaDefinitionRule),
    (0, $5bfCp.UniqueOperationTypesRule),
    (0, $lpOFf.UniqueTypeNamesRule),
    (0, $iH3W9.UniqueEnumValueNamesRule),
    (0, $3928j.UniqueFieldDefinitionNamesRule),
    (0, $2ia4v.UniqueDirectiveNamesRule),
    (0, $jPaVD.KnownTypeNamesRule),
    (0, $1FUzv.KnownDirectivesRule),
    (0, $464Lr.UniqueDirectivesPerLocationRule),
    (0, $1Mpnv.PossibleTypeExtensionsRule),
    (0, $2hatF.UniqueArgumentNamesRule),
    (0, $8um4Z.UniqueInputFieldNamesRule)
];
function $abcbe4f77e7f6684$export$201900a5c98a060e(schema, ast, customRules, isRelayCompatMode, isSchemaDocument) {
    const rules = (0, $cEYhC.specifiedRules).filter((rule)=>{
        if (rule === (0, $j8NV2.NoUnusedFragmentsRule) || rule === (0, $diQTm.ExecutableDefinitionsRule)) return false;
        if (isRelayCompatMode && rule === (0, $bKjUm.KnownFragmentNamesRule)) return false;
        return true;
    });
    if (customRules) Array.prototype.push.apply(rules, customRules);
    if (isSchemaDocument) Array.prototype.push.apply(rules, $abcbe4f77e7f6684$var$specifiedSDLRules);
    const errors = (0, $dFUlP.validate)(schema, ast, rules);
    return errors.filter((error)=>{
        if (error.message.includes("Unknown directive") && error.nodes) {
            const node = error.nodes[0];
            if (node && node.kind === (0, $hu3w4.Kind).DIRECTIVE) {
                const name = node.name.value;
                if (name === "arguments" || name === "argumentDefinitions") return false;
            }
        }
        return true;
    });
}

});
parcelRegister("diQTm", function(module, exports) {

$parcel$export(module.exports, "ExecutableDefinitionsRule", () => $a1b5c4649f4eb7a5$export$c3d3637a3c3c605e);

var $fHcz3 = parcelRequire("fHcz3");

var $hu3w4 = parcelRequire("hu3w4");

var $cftRS = parcelRequire("cftRS");
function $a1b5c4649f4eb7a5$export$c3d3637a3c3c605e(context) {
    return {
        Document (node) {
            for (const definition of node.definitions)if (!(0, $cftRS.isExecutableDefinitionNode)(definition)) {
                const defName = definition.kind === (0, $hu3w4.Kind).SCHEMA_DEFINITION || definition.kind === (0, $hu3w4.Kind).SCHEMA_EXTENSION ? "schema" : '"' + definition.name.value + '"';
                context.reportError(new (0, $fHcz3.GraphQLError)(`The ${defName} definition is not executable.`, {
                    nodes: definition
                }));
            }
            return false;
        }
    };
}

});
parcelRegister("cftRS", function(module, exports) {

$parcel$export(module.exports, "isDefinitionNode", () => $6320ab015e2889cc$export$e7ecd7c16613ccfd);
$parcel$export(module.exports, "isExecutableDefinitionNode", () => $6320ab015e2889cc$export$4cedd8740794bd78);
$parcel$export(module.exports, "isTypeSystemDefinitionNode", () => $6320ab015e2889cc$export$b05c7141ec7770ba);
$parcel$export(module.exports, "isTypeSystemExtensionNode", () => $6320ab015e2889cc$export$fbc18e88163d676d);
$parcel$export(module.exports, "isSelectionNode", () => $6320ab015e2889cc$export$65772b71e1d017ba);
$parcel$export(module.exports, "isValueNode", () => $6320ab015e2889cc$export$ab65b54ec7cbe9e4);
$parcel$export(module.exports, "isConstValueNode", () => $6320ab015e2889cc$export$f95bfad9e6aea45f);
$parcel$export(module.exports, "isTypeNode", () => $6320ab015e2889cc$export$26e8a4730f4310f4);
$parcel$export(module.exports, "isTypeDefinitionNode", () => $6320ab015e2889cc$export$a3584bba04f5bfe0);
$parcel$export(module.exports, "isTypeExtensionNode", () => $6320ab015e2889cc$export$d7907721b241e11f);

var $hu3w4 = parcelRequire("hu3w4");
function $6320ab015e2889cc$export$e7ecd7c16613ccfd(node) {
    return $6320ab015e2889cc$export$4cedd8740794bd78(node) || $6320ab015e2889cc$export$b05c7141ec7770ba(node) || $6320ab015e2889cc$export$fbc18e88163d676d(node);
}
function $6320ab015e2889cc$export$4cedd8740794bd78(node) {
    return node.kind === (0, $hu3w4.Kind).OPERATION_DEFINITION || node.kind === (0, $hu3w4.Kind).FRAGMENT_DEFINITION;
}
function $6320ab015e2889cc$export$65772b71e1d017ba(node) {
    return node.kind === (0, $hu3w4.Kind).FIELD || node.kind === (0, $hu3w4.Kind).FRAGMENT_SPREAD || node.kind === (0, $hu3w4.Kind).INLINE_FRAGMENT;
}
function $6320ab015e2889cc$export$ab65b54ec7cbe9e4(node) {
    return node.kind === (0, $hu3w4.Kind).VARIABLE || node.kind === (0, $hu3w4.Kind).INT || node.kind === (0, $hu3w4.Kind).FLOAT || node.kind === (0, $hu3w4.Kind).STRING || node.kind === (0, $hu3w4.Kind).BOOLEAN || node.kind === (0, $hu3w4.Kind).NULL || node.kind === (0, $hu3w4.Kind).ENUM || node.kind === (0, $hu3w4.Kind).LIST || node.kind === (0, $hu3w4.Kind).OBJECT;
}
function $6320ab015e2889cc$export$f95bfad9e6aea45f(node) {
    return $6320ab015e2889cc$export$ab65b54ec7cbe9e4(node) && (node.kind === (0, $hu3w4.Kind).LIST ? node.values.some($6320ab015e2889cc$export$f95bfad9e6aea45f) : node.kind === (0, $hu3w4.Kind).OBJECT ? node.fields.some((field)=>$6320ab015e2889cc$export$f95bfad9e6aea45f(field.value)) : node.kind !== (0, $hu3w4.Kind).VARIABLE);
}
function $6320ab015e2889cc$export$26e8a4730f4310f4(node) {
    return node.kind === (0, $hu3w4.Kind).NAMED_TYPE || node.kind === (0, $hu3w4.Kind).LIST_TYPE || node.kind === (0, $hu3w4.Kind).NON_NULL_TYPE;
}
function $6320ab015e2889cc$export$b05c7141ec7770ba(node) {
    return node.kind === (0, $hu3w4.Kind).SCHEMA_DEFINITION || $6320ab015e2889cc$export$a3584bba04f5bfe0(node) || node.kind === (0, $hu3w4.Kind).DIRECTIVE_DEFINITION;
}
function $6320ab015e2889cc$export$a3584bba04f5bfe0(node) {
    return node.kind === (0, $hu3w4.Kind).SCALAR_TYPE_DEFINITION || node.kind === (0, $hu3w4.Kind).OBJECT_TYPE_DEFINITION || node.kind === (0, $hu3w4.Kind).INTERFACE_TYPE_DEFINITION || node.kind === (0, $hu3w4.Kind).UNION_TYPE_DEFINITION || node.kind === (0, $hu3w4.Kind).ENUM_TYPE_DEFINITION || node.kind === (0, $hu3w4.Kind).INPUT_OBJECT_TYPE_DEFINITION;
}
function $6320ab015e2889cc$export$fbc18e88163d676d(node) {
    return node.kind === (0, $hu3w4.Kind).SCHEMA_EXTENSION || $6320ab015e2889cc$export$d7907721b241e11f(node);
}
function $6320ab015e2889cc$export$d7907721b241e11f(node) {
    return node.kind === (0, $hu3w4.Kind).SCALAR_TYPE_EXTENSION || node.kind === (0, $hu3w4.Kind).OBJECT_TYPE_EXTENSION || node.kind === (0, $hu3w4.Kind).INTERFACE_TYPE_EXTENSION || node.kind === (0, $hu3w4.Kind).UNION_TYPE_EXTENSION || node.kind === (0, $hu3w4.Kind).ENUM_TYPE_EXTENSION || node.kind === (0, $hu3w4.Kind).INPUT_OBJECT_TYPE_EXTENSION;
}

});


parcelRegister("1FUzv", function(module, exports) {

$parcel$export(module.exports, "KnownDirectivesRule", () => $89ce710b9cd200d1$export$f4ca94d7d1cf5874);

var $gHwk7 = parcelRequire("gHwk7");

var $l3zHt = parcelRequire("l3zHt");

var $fHcz3 = parcelRequire("fHcz3");

var $8r1qs = parcelRequire("8r1qs");

var $5zW8K = parcelRequire("5zW8K");

var $hu3w4 = parcelRequire("hu3w4");

var $9KaHw = parcelRequire("9KaHw");
function $89ce710b9cd200d1$export$f4ca94d7d1cf5874(context) {
    const locationsMap = Object.create(null);
    const schema = context.getSchema();
    const definedDirectives = schema ? schema.getDirectives() : (0, $9KaHw.specifiedDirectives);
    for (const directive of definedDirectives)locationsMap[directive.name] = directive.locations;
    const astDefinitions = context.getDocument().definitions;
    for (const def of astDefinitions)if (def.kind === (0, $hu3w4.Kind).DIRECTIVE_DEFINITION) locationsMap[def.name.value] = def.locations.map((name)=>name.value);
    return {
        Directive (node, _key, _parent, _path, ancestors) {
            const name = node.name.value;
            const locations = locationsMap[name];
            if (!locations) {
                context.reportError(new (0, $fHcz3.GraphQLError)(`Unknown directive "@${name}".`, {
                    nodes: node
                }));
                return;
            }
            const candidateLocation = $89ce710b9cd200d1$var$getDirectiveLocationForASTPath(ancestors);
            if (candidateLocation && !locations.includes(candidateLocation)) context.reportError(new (0, $fHcz3.GraphQLError)(`Directive "@${name}" may not be used on ${candidateLocation}.`, {
                nodes: node
            }));
        }
    };
}
function $89ce710b9cd200d1$var$getDirectiveLocationForASTPath(ancestors) {
    const appliedTo = ancestors[ancestors.length - 1];
    "kind" in appliedTo || (0, $l3zHt.invariant)(false);
    switch(appliedTo.kind){
        case (0, $hu3w4.Kind).OPERATION_DEFINITION:
            return $89ce710b9cd200d1$var$getDirectiveLocationForOperation(appliedTo.operation);
        case (0, $hu3w4.Kind).FIELD:
            return (0, $5zW8K.DirectiveLocation).FIELD;
        case (0, $hu3w4.Kind).FRAGMENT_SPREAD:
            return (0, $5zW8K.DirectiveLocation).FRAGMENT_SPREAD;
        case (0, $hu3w4.Kind).INLINE_FRAGMENT:
            return (0, $5zW8K.DirectiveLocation).INLINE_FRAGMENT;
        case (0, $hu3w4.Kind).FRAGMENT_DEFINITION:
            return (0, $5zW8K.DirectiveLocation).FRAGMENT_DEFINITION;
        case (0, $hu3w4.Kind).VARIABLE_DEFINITION:
            return (0, $5zW8K.DirectiveLocation).VARIABLE_DEFINITION;
        case (0, $hu3w4.Kind).SCHEMA_DEFINITION:
        case (0, $hu3w4.Kind).SCHEMA_EXTENSION:
            return (0, $5zW8K.DirectiveLocation).SCHEMA;
        case (0, $hu3w4.Kind).SCALAR_TYPE_DEFINITION:
        case (0, $hu3w4.Kind).SCALAR_TYPE_EXTENSION:
            return (0, $5zW8K.DirectiveLocation).SCALAR;
        case (0, $hu3w4.Kind).OBJECT_TYPE_DEFINITION:
        case (0, $hu3w4.Kind).OBJECT_TYPE_EXTENSION:
            return (0, $5zW8K.DirectiveLocation).OBJECT;
        case (0, $hu3w4.Kind).FIELD_DEFINITION:
            return (0, $5zW8K.DirectiveLocation).FIELD_DEFINITION;
        case (0, $hu3w4.Kind).INTERFACE_TYPE_DEFINITION:
        case (0, $hu3w4.Kind).INTERFACE_TYPE_EXTENSION:
            return (0, $5zW8K.DirectiveLocation).INTERFACE;
        case (0, $hu3w4.Kind).UNION_TYPE_DEFINITION:
        case (0, $hu3w4.Kind).UNION_TYPE_EXTENSION:
            return (0, $5zW8K.DirectiveLocation).UNION;
        case (0, $hu3w4.Kind).ENUM_TYPE_DEFINITION:
        case (0, $hu3w4.Kind).ENUM_TYPE_EXTENSION:
            return (0, $5zW8K.DirectiveLocation).ENUM;
        case (0, $hu3w4.Kind).ENUM_VALUE_DEFINITION:
            return (0, $5zW8K.DirectiveLocation).ENUM_VALUE;
        case (0, $hu3w4.Kind).INPUT_OBJECT_TYPE_DEFINITION:
        case (0, $hu3w4.Kind).INPUT_OBJECT_TYPE_EXTENSION:
            return (0, $5zW8K.DirectiveLocation).INPUT_OBJECT;
        case (0, $hu3w4.Kind).INPUT_VALUE_DEFINITION:
            {
                const parentNode = ancestors[ancestors.length - 3];
                "kind" in parentNode || (0, $l3zHt.invariant)(false);
                return parentNode.kind === (0, $hu3w4.Kind).INPUT_OBJECT_TYPE_DEFINITION ? (0, $5zW8K.DirectiveLocation).INPUT_FIELD_DEFINITION : (0, $5zW8K.DirectiveLocation).ARGUMENT_DEFINITION;
            }
        // Not reachable, all possible types have been considered.
        /* c8 ignore next */ default:
            (0, $l3zHt.invariant)(false, "Unexpected kind: " + (0, $gHwk7.inspect)(appliedTo.kind));
    }
}
function $89ce710b9cd200d1$var$getDirectiveLocationForOperation(operation) {
    switch(operation){
        case (0, $8r1qs.OperationTypeNode).QUERY:
            return (0, $5zW8K.DirectiveLocation).QUERY;
        case (0, $8r1qs.OperationTypeNode).MUTATION:
            return (0, $5zW8K.DirectiveLocation).MUTATION;
        case (0, $8r1qs.OperationTypeNode).SUBSCRIPTION:
            return (0, $5zW8K.DirectiveLocation).SUBSCRIPTION;
    }
}

});

parcelRegister("bKjUm", function(module, exports) {

$parcel$export(module.exports, "KnownFragmentNamesRule", () => $cc441e74fe1e968c$export$94c8dd81fb6d3111);

var $fHcz3 = parcelRequire("fHcz3");
function $cc441e74fe1e968c$export$94c8dd81fb6d3111(context) {
    return {
        FragmentSpread (node) {
            const fragmentName = node.name.value;
            const fragment = context.getFragment(fragmentName);
            if (!fragment) context.reportError(new (0, $fHcz3.GraphQLError)(`Unknown fragment "${fragmentName}".`, {
                nodes: node.name
            }));
        }
    };
}

});

parcelRegister("jPaVD", function(module, exports) {

$parcel$export(module.exports, "KnownTypeNamesRule", () => $1d5f21937c447b8c$export$2317edbae2efecbd);

var $ej6fd = parcelRequire("ej6fd");

var $a2eVh = parcelRequire("a2eVh");

var $fHcz3 = parcelRequire("fHcz3");

var $cftRS = parcelRequire("cftRS");

var $jptTh = parcelRequire("jptTh");

var $l5aqI = parcelRequire("l5aqI");
function $1d5f21937c447b8c$export$2317edbae2efecbd(context) {
    const schema = context.getSchema();
    const existingTypesMap = schema ? schema.getTypeMap() : Object.create(null);
    const definedTypes = Object.create(null);
    for (const def of context.getDocument().definitions)if ((0, $cftRS.isTypeDefinitionNode)(def)) definedTypes[def.name.value] = true;
    const typeNames = [
        ...Object.keys(existingTypesMap),
        ...Object.keys(definedTypes)
    ];
    return {
        NamedType (node, _1, parent, _2, ancestors) {
            const typeName = node.name.value;
            if (!existingTypesMap[typeName] && !definedTypes[typeName]) {
                var _ancestors$;
                const definitionNode = (_ancestors$ = ancestors[2]) !== null && _ancestors$ !== void 0 ? _ancestors$ : parent;
                const isSDL = definitionNode != null && $1d5f21937c447b8c$var$isSDLNode(definitionNode);
                if (isSDL && $1d5f21937c447b8c$var$standardTypeNames.includes(typeName)) return;
                const suggestedTypes = (0, $a2eVh.suggestionList)(typeName, isSDL ? $1d5f21937c447b8c$var$standardTypeNames.concat(typeNames) : typeNames);
                context.reportError(new (0, $fHcz3.GraphQLError)(`Unknown type "${typeName}".` + (0, $ej6fd.didYouMean)(suggestedTypes), {
                    nodes: node
                }));
            }
        }
    };
}
const $1d5f21937c447b8c$var$standardTypeNames = [
    ...(0, $l5aqI.specifiedScalarTypes),
    ...(0, $jptTh.introspectionTypes)
].map((type)=>type.name);
function $1d5f21937c447b8c$var$isSDLNode(value) {
    return "kind" in value && ((0, $cftRS.isTypeSystemDefinitionNode)(value) || (0, $cftRS.isTypeSystemExtensionNode)(value));
}

});

parcelRegister("7aIqC", function(module, exports) {

$parcel$export(module.exports, "LoneSchemaDefinitionRule", () => $4e92393a41b33410$export$9eae4c44f9d64405);

var $fHcz3 = parcelRequire("fHcz3");
function $4e92393a41b33410$export$9eae4c44f9d64405(context) {
    var _ref, _ref2, _oldSchema$astNode;
    const oldSchema = context.getSchema();
    const alreadyDefined = (_ref = (_ref2 = (_oldSchema$astNode = oldSchema === null || oldSchema === void 0 ? void 0 : oldSchema.astNode) !== null && _oldSchema$astNode !== void 0 ? _oldSchema$astNode : oldSchema === null || oldSchema === void 0 ? void 0 : oldSchema.getQueryType()) !== null && _ref2 !== void 0 ? _ref2 : oldSchema === null || oldSchema === void 0 ? void 0 : oldSchema.getMutationType()) !== null && _ref !== void 0 ? _ref : oldSchema === null || oldSchema === void 0 ? void 0 : oldSchema.getSubscriptionType();
    let schemaDefinitionsCount = 0;
    return {
        SchemaDefinition (node) {
            if (alreadyDefined) {
                context.reportError(new (0, $fHcz3.GraphQLError)("Cannot define a new schema within a schema extension.", {
                    nodes: node
                }));
                return;
            }
            if (schemaDefinitionsCount > 0) context.reportError(new (0, $fHcz3.GraphQLError)("Must provide only one schema definition.", {
                nodes: node
            }));
            ++schemaDefinitionsCount;
        }
    };
}

});

parcelRegister("j8NV2", function(module, exports) {

$parcel$export(module.exports, "NoUnusedFragmentsRule", () => $e777b21bd25199cf$export$d29d2e5ed74717af);

var $fHcz3 = parcelRequire("fHcz3");
function $e777b21bd25199cf$export$d29d2e5ed74717af(context) {
    const operationDefs = [];
    const fragmentDefs = [];
    return {
        OperationDefinition (node) {
            operationDefs.push(node);
            return false;
        },
        FragmentDefinition (node) {
            fragmentDefs.push(node);
            return false;
        },
        Document: {
            leave () {
                const fragmentNameUsed = Object.create(null);
                for (const operation of operationDefs)for (const fragment of context.getRecursivelyReferencedFragments(operation))fragmentNameUsed[fragment.name.value] = true;
                for (const fragmentDef of fragmentDefs){
                    const fragName = fragmentDef.name.value;
                    if (fragmentNameUsed[fragName] !== true) context.reportError(new (0, $fHcz3.GraphQLError)(`Fragment "${fragName}" is never used.`, {
                        nodes: fragmentDef
                    }));
                }
            }
        }
    };
}

});

parcelRegister("1Mpnv", function(module, exports) {

$parcel$export(module.exports, "PossibleTypeExtensionsRule", () => $7d7d1beb41e6b9a8$export$50309357bc4f0e8b);

var $ej6fd = parcelRequire("ej6fd");

var $gHwk7 = parcelRequire("gHwk7");

var $l3zHt = parcelRequire("l3zHt");

var $a2eVh = parcelRequire("a2eVh");

var $fHcz3 = parcelRequire("fHcz3");

var $hu3w4 = parcelRequire("hu3w4");

var $cftRS = parcelRequire("cftRS");

var $54dWd = parcelRequire("54dWd");
function $7d7d1beb41e6b9a8$export$50309357bc4f0e8b(context) {
    const schema = context.getSchema();
    const definedTypes = Object.create(null);
    for (const def of context.getDocument().definitions)if ((0, $cftRS.isTypeDefinitionNode)(def)) definedTypes[def.name.value] = def;
    return {
        ScalarTypeExtension: checkExtension,
        ObjectTypeExtension: checkExtension,
        InterfaceTypeExtension: checkExtension,
        UnionTypeExtension: checkExtension,
        EnumTypeExtension: checkExtension,
        InputObjectTypeExtension: checkExtension
    };
    function checkExtension(node) {
        const typeName = node.name.value;
        const defNode = definedTypes[typeName];
        const existingType = schema === null || schema === void 0 ? void 0 : schema.getType(typeName);
        let expectedKind;
        if (defNode) expectedKind = $7d7d1beb41e6b9a8$var$defKindToExtKind[defNode.kind];
        else if (existingType) expectedKind = $7d7d1beb41e6b9a8$var$typeToExtKind(existingType);
        if (expectedKind) {
            if (expectedKind !== node.kind) {
                const kindStr = $7d7d1beb41e6b9a8$var$extensionKindToTypeName(node.kind);
                context.reportError(new (0, $fHcz3.GraphQLError)(`Cannot extend non-${kindStr} type "${typeName}".`, {
                    nodes: defNode ? [
                        defNode,
                        node
                    ] : node
                }));
            }
        } else {
            const allTypeNames = Object.keys({
                ...definedTypes,
                ...schema === null || schema === void 0 ? void 0 : schema.getTypeMap()
            });
            const suggestedTypes = (0, $a2eVh.suggestionList)(typeName, allTypeNames);
            context.reportError(new (0, $fHcz3.GraphQLError)(`Cannot extend type "${typeName}" because it is not defined.` + (0, $ej6fd.didYouMean)(suggestedTypes), {
                nodes: node.name
            }));
        }
    }
}
const $7d7d1beb41e6b9a8$var$defKindToExtKind = {
    [(0, $hu3w4.Kind).SCALAR_TYPE_DEFINITION]: (0, $hu3w4.Kind).SCALAR_TYPE_EXTENSION,
    [(0, $hu3w4.Kind).OBJECT_TYPE_DEFINITION]: (0, $hu3w4.Kind).OBJECT_TYPE_EXTENSION,
    [(0, $hu3w4.Kind).INTERFACE_TYPE_DEFINITION]: (0, $hu3w4.Kind).INTERFACE_TYPE_EXTENSION,
    [(0, $hu3w4.Kind).UNION_TYPE_DEFINITION]: (0, $hu3w4.Kind).UNION_TYPE_EXTENSION,
    [(0, $hu3w4.Kind).ENUM_TYPE_DEFINITION]: (0, $hu3w4.Kind).ENUM_TYPE_EXTENSION,
    [(0, $hu3w4.Kind).INPUT_OBJECT_TYPE_DEFINITION]: (0, $hu3w4.Kind).INPUT_OBJECT_TYPE_EXTENSION
};
function $7d7d1beb41e6b9a8$var$typeToExtKind(type) {
    if ((0, $54dWd.isScalarType)(type)) return (0, $hu3w4.Kind).SCALAR_TYPE_EXTENSION;
    if ((0, $54dWd.isObjectType)(type)) return (0, $hu3w4.Kind).OBJECT_TYPE_EXTENSION;
    if ((0, $54dWd.isInterfaceType)(type)) return (0, $hu3w4.Kind).INTERFACE_TYPE_EXTENSION;
    if ((0, $54dWd.isUnionType)(type)) return (0, $hu3w4.Kind).UNION_TYPE_EXTENSION;
    if ((0, $54dWd.isEnumType)(type)) return (0, $hu3w4.Kind).ENUM_TYPE_EXTENSION;
    if ((0, $54dWd.isInputObjectType)(type)) return (0, $hu3w4.Kind).INPUT_OBJECT_TYPE_EXTENSION;
    /* c8 ignore next 3 */ // Not reachable. All possible types have been considered
    (0, $l3zHt.invariant)(false, "Unexpected type: " + (0, $gHwk7.inspect)(type));
}
function $7d7d1beb41e6b9a8$var$extensionKindToTypeName(kind) {
    switch(kind){
        case (0, $hu3w4.Kind).SCALAR_TYPE_EXTENSION:
            return "scalar";
        case (0, $hu3w4.Kind).OBJECT_TYPE_EXTENSION:
            return "object";
        case (0, $hu3w4.Kind).INTERFACE_TYPE_EXTENSION:
            return "interface";
        case (0, $hu3w4.Kind).UNION_TYPE_EXTENSION:
            return "union";
        case (0, $hu3w4.Kind).ENUM_TYPE_EXTENSION:
            return "enum";
        case (0, $hu3w4.Kind).INPUT_OBJECT_TYPE_EXTENSION:
            return "input object";
        // Not reachable. All possible types have been considered
        /* c8 ignore next */ default:
            (0, $l3zHt.invariant)(false, "Unexpected kind: " + (0, $gHwk7.inspect)(kind));
    }
}

});

parcelRegister("cEYhC", function(module, exports) {

$parcel$export(module.exports, "specifiedRules", () => $2d39278f56487198$export$ac8e8f03d4e8a76c);
$parcel$export(module.exports, "specifiedSDLRules", () => $2d39278f56487198$export$117d63808a280985);
// Spec Section: "Executable Definitions"

var $diQTm = parcelRequire("diQTm");

var $23gB0 = parcelRequire("23gB0");

var $bubWJ = parcelRequire("bubWJ");

var $8Pz2L = parcelRequire("8Pz2L");

var $1FUzv = parcelRequire("1FUzv");

var $bKjUm = parcelRequire("bKjUm");

var $jPaVD = parcelRequire("jPaVD");

var $6qg1x = parcelRequire("6qg1x");

var $7aIqC = parcelRequire("7aIqC");

var $fzcax = parcelRequire("fzcax");

var $kzsfS = parcelRequire("kzsfS");

var $j8NV2 = parcelRequire("j8NV2");

var $aZSFv = parcelRequire("aZSFv");

var $4lUBI = parcelRequire("4lUBI");

var $jHKhb = parcelRequire("jHKhb");

var $1Mpnv = parcelRequire("1Mpnv");

var $lPCXV = parcelRequire("lPCXV");

var $gBFeA = parcelRequire("gBFeA");

var $7su90 = parcelRequire("7su90");

var $g0gN2 = parcelRequire("g0gN2");

var $2hatF = parcelRequire("2hatF");

var $2ia4v = parcelRequire("2ia4v");

var $464Lr = parcelRequire("464Lr");

var $iH3W9 = parcelRequire("iH3W9");

var $3928j = parcelRequire("3928j");

var $iTZMn = parcelRequire("iTZMn");

var $8um4Z = parcelRequire("8um4Z");

var $6zN5l = parcelRequire("6zN5l");

var $5bfCp = parcelRequire("5bfCp");

var $lpOFf = parcelRequire("lpOFf");

var $972Dd = parcelRequire("972Dd");

var $l2KI6 = parcelRequire("l2KI6");

var $iaWPa = parcelRequire("iaWPa");

var $e186G = parcelRequire("e186G");
const $2d39278f56487198$export$ac8e8f03d4e8a76c = Object.freeze([
    (0, $diQTm.ExecutableDefinitionsRule),
    (0, $6zN5l.UniqueOperationNamesRule),
    (0, $6qg1x.LoneAnonymousOperationRule),
    (0, $7su90.SingleFieldSubscriptionsRule),
    (0, $jPaVD.KnownTypeNamesRule),
    (0, $bubWJ.FragmentsOnCompositeTypesRule),
    (0, $iaWPa.VariablesAreInputTypesRule),
    (0, $gBFeA.ScalarLeafsRule),
    (0, $23gB0.FieldsOnCorrectTypeRule),
    (0, $iTZMn.UniqueFragmentNamesRule),
    (0, $bKjUm.KnownFragmentNamesRule),
    (0, $j8NV2.NoUnusedFragmentsRule),
    (0, $jHKhb.PossibleFragmentSpreadsRule),
    (0, $fzcax.NoFragmentCyclesRule),
    (0, $972Dd.UniqueVariableNamesRule),
    (0, $kzsfS.NoUndefinedVariablesRule),
    (0, $aZSFv.NoUnusedVariablesRule),
    (0, $1FUzv.KnownDirectivesRule),
    (0, $464Lr.UniqueDirectivesPerLocationRule),
    (0, $8Pz2L.KnownArgumentNamesRule),
    (0, $2hatF.UniqueArgumentNamesRule),
    (0, $l2KI6.ValuesOfCorrectTypeRule),
    (0, $lPCXV.ProvidedRequiredArgumentsRule),
    (0, $e186G.VariablesInAllowedPositionRule),
    (0, $4lUBI.OverlappingFieldsCanBeMergedRule),
    (0, $8um4Z.UniqueInputFieldNamesRule)
]);
const $2d39278f56487198$export$117d63808a280985 = Object.freeze([
    (0, $7aIqC.LoneSchemaDefinitionRule),
    (0, $5bfCp.UniqueOperationTypesRule),
    (0, $lpOFf.UniqueTypeNamesRule),
    (0, $iH3W9.UniqueEnumValueNamesRule),
    (0, $3928j.UniqueFieldDefinitionNamesRule),
    (0, $g0gN2.UniqueArgumentDefinitionNamesRule),
    (0, $2ia4v.UniqueDirectiveNamesRule),
    (0, $jPaVD.KnownTypeNamesRule),
    (0, $1FUzv.KnownDirectivesRule),
    (0, $464Lr.UniqueDirectivesPerLocationRule),
    (0, $1Mpnv.PossibleTypeExtensionsRule),
    (0, $8Pz2L.KnownArgumentNamesOnDirectivesRule),
    (0, $2hatF.UniqueArgumentNamesRule),
    (0, $8um4Z.UniqueInputFieldNamesRule),
    (0, $lPCXV.ProvidedRequiredArgumentsOnDirectivesRule)
]);

});
parcelRegister("23gB0", function(module, exports) {

$parcel$export(module.exports, "FieldsOnCorrectTypeRule", () => $54724e1ffaaa361e$export$595e5c0bf2d10a85);

var $ej6fd = parcelRequire("ej6fd");

var $a8VtN = parcelRequire("a8VtN");

var $a2eVh = parcelRequire("a2eVh");

var $fHcz3 = parcelRequire("fHcz3");

var $54dWd = parcelRequire("54dWd");
function $54724e1ffaaa361e$export$595e5c0bf2d10a85(context) {
    return {
        Field (node) {
            const type = context.getParentType();
            if (type) {
                const fieldDef = context.getFieldDef();
                if (!fieldDef) {
                    // This field doesn't exist, lets look for suggestions.
                    const schema = context.getSchema();
                    const fieldName = node.name.value; // First determine if there are any suggested types to condition on.
                    let suggestion = (0, $ej6fd.didYouMean)("to use an inline fragment on", $54724e1ffaaa361e$var$getSuggestedTypeNames(schema, type, fieldName)); // If there are no suggested types, then perhaps this was a typo?
                    if (suggestion === "") suggestion = (0, $ej6fd.didYouMean)($54724e1ffaaa361e$var$getSuggestedFieldNames(type, fieldName));
                     // Report an error, including helpful suggestions.
                    context.reportError(new (0, $fHcz3.GraphQLError)(`Cannot query field "${fieldName}" on type "${type.name}".` + suggestion, {
                        nodes: node
                    }));
                }
            }
        }
    };
}
/**
 * Go through all of the implementations of type, as well as the interfaces that
 * they implement. If any of those types include the provided field, suggest them,
 * sorted by how often the type is referenced.
 */ function $54724e1ffaaa361e$var$getSuggestedTypeNames(schema, type, fieldName) {
    if (!(0, $54dWd.isAbstractType)(type)) // Must be an Object type, which does not have possible fields.
    return [];
    const suggestedTypes = new Set();
    const usageCount = Object.create(null);
    for (const possibleType of schema.getPossibleTypes(type)){
        if (!possibleType.getFields()[fieldName]) continue;
         // This object type defines this field.
        suggestedTypes.add(possibleType);
        usageCount[possibleType.name] = 1;
        for (const possibleInterface of possibleType.getInterfaces()){
            var _usageCount$possibleI;
            if (!possibleInterface.getFields()[fieldName]) continue;
             // This interface type defines this field.
            suggestedTypes.add(possibleInterface);
            usageCount[possibleInterface.name] = ((_usageCount$possibleI = usageCount[possibleInterface.name]) !== null && _usageCount$possibleI !== void 0 ? _usageCount$possibleI : 0) + 1;
        }
    }
    return [
        ...suggestedTypes
    ].sort((typeA, typeB)=>{
        // Suggest both interface and object types based on how common they are.
        const usageCountDiff = usageCount[typeB.name] - usageCount[typeA.name];
        if (usageCountDiff !== 0) return usageCountDiff;
         // Suggest super types first followed by subtypes
        if ((0, $54dWd.isInterfaceType)(typeA) && schema.isSubType(typeA, typeB)) return -1;
        if ((0, $54dWd.isInterfaceType)(typeB) && schema.isSubType(typeB, typeA)) return 1;
        return (0, $a8VtN.naturalCompare)(typeA.name, typeB.name);
    }).map((x)=>x.name);
}
/**
 * For the field name provided, determine if there are any similar field names
 * that may be the result of a typo.
 */ function $54724e1ffaaa361e$var$getSuggestedFieldNames(type, fieldName) {
    if ((0, $54dWd.isObjectType)(type) || (0, $54dWd.isInterfaceType)(type)) {
        const possibleFieldNames = Object.keys(type.getFields());
        return (0, $a2eVh.suggestionList)(fieldName, possibleFieldNames);
    } // Otherwise, must be a Union type, which does not define fields.
    return [];
}

});

parcelRegister("bubWJ", function(module, exports) {

$parcel$export(module.exports, "FragmentsOnCompositeTypesRule", () => $b02f5e74d2d98808$export$cb5241ba71fd55e0);

var $fHcz3 = parcelRequire("fHcz3");

var $3o9dz = parcelRequire("3o9dz");

var $54dWd = parcelRequire("54dWd");

var $IvZa0 = parcelRequire("IvZa0");
function $b02f5e74d2d98808$export$cb5241ba71fd55e0(context) {
    return {
        InlineFragment (node) {
            const typeCondition = node.typeCondition;
            if (typeCondition) {
                const type = (0, $IvZa0.typeFromAST)(context.getSchema(), typeCondition);
                if (type && !(0, $54dWd.isCompositeType)(type)) {
                    const typeStr = (0, $3o9dz.print)(typeCondition);
                    context.reportError(new (0, $fHcz3.GraphQLError)(`Fragment cannot condition on non composite type "${typeStr}".`, {
                        nodes: typeCondition
                    }));
                }
            }
        },
        FragmentDefinition (node) {
            const type = (0, $IvZa0.typeFromAST)(context.getSchema(), node.typeCondition);
            if (type && !(0, $54dWd.isCompositeType)(type)) {
                const typeStr = (0, $3o9dz.print)(node.typeCondition);
                context.reportError(new (0, $fHcz3.GraphQLError)(`Fragment "${node.name.value}" cannot condition on non composite type "${typeStr}".`, {
                    nodes: node.typeCondition
                }));
            }
        }
    };
}

});

parcelRegister("8Pz2L", function(module, exports) {

$parcel$export(module.exports, "KnownArgumentNamesRule", () => $c0d2b323dc37d243$export$5d7b3b4b6779c802);
$parcel$export(module.exports, "KnownArgumentNamesOnDirectivesRule", () => $c0d2b323dc37d243$export$6eb6eb4c5417f2c4);

var $ej6fd = parcelRequire("ej6fd");

var $a2eVh = parcelRequire("a2eVh");

var $fHcz3 = parcelRequire("fHcz3");

var $hu3w4 = parcelRequire("hu3w4");

var $9KaHw = parcelRequire("9KaHw");
function $c0d2b323dc37d243$export$5d7b3b4b6779c802(context) {
    return {
        // eslint-disable-next-line new-cap
        ...$c0d2b323dc37d243$export$6eb6eb4c5417f2c4(context),
        Argument (argNode) {
            const argDef = context.getArgument();
            const fieldDef = context.getFieldDef();
            const parentType = context.getParentType();
            if (!argDef && fieldDef && parentType) {
                const argName = argNode.name.value;
                const knownArgsNames = fieldDef.args.map((arg)=>arg.name);
                const suggestions = (0, $a2eVh.suggestionList)(argName, knownArgsNames);
                context.reportError(new (0, $fHcz3.GraphQLError)(`Unknown argument "${argName}" on field "${parentType.name}.${fieldDef.name}".` + (0, $ej6fd.didYouMean)(suggestions), {
                    nodes: argNode
                }));
            }
        }
    };
}
function $c0d2b323dc37d243$export$6eb6eb4c5417f2c4(context) {
    const directiveArgs = Object.create(null);
    const schema = context.getSchema();
    const definedDirectives = schema ? schema.getDirectives() : (0, $9KaHw.specifiedDirectives);
    for (const directive of definedDirectives)directiveArgs[directive.name] = directive.args.map((arg)=>arg.name);
    const astDefinitions = context.getDocument().definitions;
    for (const def of astDefinitions)if (def.kind === (0, $hu3w4.Kind).DIRECTIVE_DEFINITION) {
        var _def$arguments;
        // FIXME: https://github.com/graphql/graphql-js/issues/2203
        /* c8 ignore next */ const argsNodes = (_def$arguments = def.arguments) !== null && _def$arguments !== void 0 ? _def$arguments : [];
        directiveArgs[def.name.value] = argsNodes.map((arg)=>arg.name.value);
    }
    return {
        Directive (directiveNode) {
            const directiveName = directiveNode.name.value;
            const knownArgs = directiveArgs[directiveName];
            if (directiveNode.arguments && knownArgs) for (const argNode of directiveNode.arguments){
                const argName = argNode.name.value;
                if (!knownArgs.includes(argName)) {
                    const suggestions = (0, $a2eVh.suggestionList)(argName, knownArgs);
                    context.reportError(new (0, $fHcz3.GraphQLError)(`Unknown argument "${argName}" on directive "@${directiveName}".` + (0, $ej6fd.didYouMean)(suggestions), {
                        nodes: argNode
                    }));
                }
            }
            return false;
        }
    };
}

});

parcelRegister("6qg1x", function(module, exports) {

$parcel$export(module.exports, "LoneAnonymousOperationRule", () => $11d964cfe6da95e7$export$3a79c63c3de7a55f);

var $fHcz3 = parcelRequire("fHcz3");

var $hu3w4 = parcelRequire("hu3w4");
function $11d964cfe6da95e7$export$3a79c63c3de7a55f(context) {
    let operationCount = 0;
    return {
        Document (node) {
            operationCount = node.definitions.filter((definition)=>definition.kind === (0, $hu3w4.Kind).OPERATION_DEFINITION).length;
        },
        OperationDefinition (node) {
            if (!node.name && operationCount > 1) context.reportError(new (0, $fHcz3.GraphQLError)("This anonymous operation must be the only defined operation.", {
                nodes: node
            }));
        }
    };
}

});

parcelRegister("fzcax", function(module, exports) {

$parcel$export(module.exports, "NoFragmentCyclesRule", () => $8c0beb5e04ef8ec3$export$25eccb87f5a000e6);

var $fHcz3 = parcelRequire("fHcz3");
function $8c0beb5e04ef8ec3$export$25eccb87f5a000e6(context) {
    // Tracks already visited fragments to maintain O(N) and to ensure that cycles
    // are not redundantly reported.
    const visitedFrags = Object.create(null); // Array of AST nodes used to produce meaningful errors
    const spreadPath = []; // Position in the spread path
    const spreadPathIndexByName = Object.create(null);
    return {
        OperationDefinition: ()=>false,
        FragmentDefinition (node) {
            detectCycleRecursive(node);
            return false;
        }
    }; // This does a straight-forward DFS to find cycles.
    // It does not terminate when a cycle was found but continues to explore
    // the graph to find all possible cycles.
    function detectCycleRecursive(fragment) {
        if (visitedFrags[fragment.name.value]) return;
        const fragmentName = fragment.name.value;
        visitedFrags[fragmentName] = true;
        const spreadNodes = context.getFragmentSpreads(fragment.selectionSet);
        if (spreadNodes.length === 0) return;
        spreadPathIndexByName[fragmentName] = spreadPath.length;
        for (const spreadNode of spreadNodes){
            const spreadName = spreadNode.name.value;
            const cycleIndex = spreadPathIndexByName[spreadName];
            spreadPath.push(spreadNode);
            if (cycleIndex === undefined) {
                const spreadFragment = context.getFragment(spreadName);
                if (spreadFragment) detectCycleRecursive(spreadFragment);
            } else {
                const cyclePath = spreadPath.slice(cycleIndex);
                const viaPath = cyclePath.slice(0, -1).map((s)=>'"' + s.name.value + '"').join(", ");
                context.reportError(new (0, $fHcz3.GraphQLError)(`Cannot spread fragment "${spreadName}" within itself` + (viaPath !== "" ? ` via ${viaPath}.` : "."), {
                    nodes: cyclePath
                }));
            }
            spreadPath.pop();
        }
        spreadPathIndexByName[fragmentName] = undefined;
    }
}

});

parcelRegister("kzsfS", function(module, exports) {

$parcel$export(module.exports, "NoUndefinedVariablesRule", () => $2bbe9b0f92ca3ee1$export$207476dbb3f797ab);

var $fHcz3 = parcelRequire("fHcz3");
function $2bbe9b0f92ca3ee1$export$207476dbb3f797ab(context) {
    let variableNameDefined = Object.create(null);
    return {
        OperationDefinition: {
            enter () {
                variableNameDefined = Object.create(null);
            },
            leave (operation) {
                const usages = context.getRecursiveVariableUsages(operation);
                for (const { node: node } of usages){
                    const varName = node.name.value;
                    if (variableNameDefined[varName] !== true) context.reportError(new (0, $fHcz3.GraphQLError)(operation.name ? `Variable "$${varName}" is not defined by operation "${operation.name.value}".` : `Variable "$${varName}" is not defined.`, {
                        nodes: [
                            node,
                            operation
                        ]
                    }));
                }
            }
        },
        VariableDefinition (node) {
            variableNameDefined[node.variable.name.value] = true;
        }
    };
}

});

parcelRegister("aZSFv", function(module, exports) {

$parcel$export(module.exports, "NoUnusedVariablesRule", () => $4054e035b5f15efc$export$300a3bc5a4f49273);

var $fHcz3 = parcelRequire("fHcz3");
function $4054e035b5f15efc$export$300a3bc5a4f49273(context) {
    let variableDefs = [];
    return {
        OperationDefinition: {
            enter () {
                variableDefs = [];
            },
            leave (operation) {
                const variableNameUsed = Object.create(null);
                const usages = context.getRecursiveVariableUsages(operation);
                for (const { node: node } of usages)variableNameUsed[node.name.value] = true;
                for (const variableDef of variableDefs){
                    const variableName = variableDef.variable.name.value;
                    if (variableNameUsed[variableName] !== true) context.reportError(new (0, $fHcz3.GraphQLError)(operation.name ? `Variable "$${variableName}" is never used in operation "${operation.name.value}".` : `Variable "$${variableName}" is never used.`, {
                        nodes: variableDef
                    }));
                }
            }
        },
        VariableDefinition (def) {
            variableDefs.push(def);
        }
    };
}

});

parcelRegister("4lUBI", function(module, exports) {

$parcel$export(module.exports, "OverlappingFieldsCanBeMergedRule", () => $1d5356c77d703b71$export$ca8652d62af5670);

var $gHwk7 = parcelRequire("gHwk7");

var $fHcz3 = parcelRequire("fHcz3");

var $hu3w4 = parcelRequire("hu3w4");

var $3o9dz = parcelRequire("3o9dz");

var $54dWd = parcelRequire("54dWd");

var $7TQgG = parcelRequire("7TQgG");

var $IvZa0 = parcelRequire("IvZa0");
function $1d5356c77d703b71$var$reasonMessage(reason) {
    if (Array.isArray(reason)) return reason.map(([responseName, subReason])=>`subfields "${responseName}" conflict because ` + $1d5356c77d703b71$var$reasonMessage(subReason)).join(" and ");
    return reason;
}
function $1d5356c77d703b71$export$ca8652d62af5670(context) {
    // A memoization for when two fragments are compared "between" each other for
    // conflicts. Two fragments may be compared many times, so memoizing this can
    // dramatically improve the performance of this validator.
    const comparedFragmentPairs = new $1d5356c77d703b71$var$PairSet(); // A cache for the "field map" and list of fragment names found in any given
    // selection set. Selection sets may be asked for this information multiple
    // times, so this improves the performance of this validator.
    const cachedFieldsAndFragmentNames = new Map();
    return {
        SelectionSet (selectionSet) {
            const conflicts = $1d5356c77d703b71$var$findConflictsWithinSelectionSet(context, cachedFieldsAndFragmentNames, comparedFragmentPairs, context.getParentType(), selectionSet);
            for (const [[responseName, reason], fields1, fields2] of conflicts){
                const reasonMsg = $1d5356c77d703b71$var$reasonMessage(reason);
                context.reportError(new (0, $fHcz3.GraphQLError)(`Fields "${responseName}" conflict because ${reasonMsg}. Use different aliases on the fields to fetch both if this was intentional.`, {
                    nodes: fields1.concat(fields2)
                }));
            }
        }
    };
}
/**
 * Algorithm:
 *
 * Conflicts occur when two fields exist in a query which will produce the same
 * response name, but represent differing values, thus creating a conflict.
 * The algorithm below finds all conflicts via making a series of comparisons
 * between fields. In order to compare as few fields as possible, this makes
 * a series of comparisons "within" sets of fields and "between" sets of fields.
 *
 * Given any selection set, a collection produces both a set of fields by
 * also including all inline fragments, as well as a list of fragments
 * referenced by fragment spreads.
 *
 * A) Each selection set represented in the document first compares "within" its
 * collected set of fields, finding any conflicts between every pair of
 * overlapping fields.
 * Note: This is the *only time* that a the fields "within" a set are compared
 * to each other. After this only fields "between" sets are compared.
 *
 * B) Also, if any fragment is referenced in a selection set, then a
 * comparison is made "between" the original set of fields and the
 * referenced fragment.
 *
 * C) Also, if multiple fragments are referenced, then comparisons
 * are made "between" each referenced fragment.
 *
 * D) When comparing "between" a set of fields and a referenced fragment, first
 * a comparison is made between each field in the original set of fields and
 * each field in the the referenced set of fields.
 *
 * E) Also, if any fragment is referenced in the referenced selection set,
 * then a comparison is made "between" the original set of fields and the
 * referenced fragment (recursively referring to step D).
 *
 * F) When comparing "between" two fragments, first a comparison is made between
 * each field in the first referenced set of fields and each field in the the
 * second referenced set of fields.
 *
 * G) Also, any fragments referenced by the first must be compared to the
 * second, and any fragments referenced by the second must be compared to the
 * first (recursively referring to step F).
 *
 * H) When comparing two fields, if both have selection sets, then a comparison
 * is made "between" both selection sets, first comparing the set of fields in
 * the first selection set with the set of fields in the second.
 *
 * I) Also, if any fragment is referenced in either selection set, then a
 * comparison is made "between" the other set of fields and the
 * referenced fragment.
 *
 * J) Also, if two fragments are referenced in both selection sets, then a
 * comparison is made "between" the two fragments.
 *
 */ // Find all conflicts found "within" a selection set, including those found
// via spreading in fragments. Called when visiting each SelectionSet in the
// GraphQL Document.
function $1d5356c77d703b71$var$findConflictsWithinSelectionSet(context, cachedFieldsAndFragmentNames, comparedFragmentPairs, parentType, selectionSet) {
    const conflicts = [];
    const [fieldMap, fragmentNames] = $1d5356c77d703b71$var$getFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, parentType, selectionSet); // (A) Find find all conflicts "within" the fields of this selection set.
    // Note: this is the *only place* `collectConflictsWithin` is called.
    $1d5356c77d703b71$var$collectConflictsWithin(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, fieldMap);
    if (fragmentNames.length !== 0) // (B) Then collect conflicts between these fields and those represented by
    // each spread fragment name found.
    for(let i = 0; i < fragmentNames.length; i++){
        $1d5356c77d703b71$var$collectConflictsBetweenFieldsAndFragment(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, false, fieldMap, fragmentNames[i]); // (C) Then compare this fragment with all other fragments found in this
        // selection set to collect conflicts between fragments spread together.
        // This compares each item in the list of fragment names to every other
        // item in that same list (except for itself).
        for(let j = i + 1; j < fragmentNames.length; j++)$1d5356c77d703b71$var$collectConflictsBetweenFragments(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, false, fragmentNames[i], fragmentNames[j]);
    }
    return conflicts;
} // Collect all conflicts found between a set of fields and a fragment reference
// including via spreading in any nested fragments.
function $1d5356c77d703b71$var$collectConflictsBetweenFieldsAndFragment(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fieldMap, fragmentName) {
    const fragment = context.getFragment(fragmentName);
    if (!fragment) return;
    const [fieldMap2, referencedFragmentNames] = $1d5356c77d703b71$var$getReferencedFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, fragment); // Do not compare a fragment's fieldMap to itself.
    if (fieldMap === fieldMap2) return;
     // (D) First collect any conflicts between the provided collection of fields
    // and the collection of fields represented by the given fragment.
    $1d5356c77d703b71$var$collectConflictsBetween(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fieldMap, fieldMap2); // (E) Then collect any conflicts between the provided collection of fields
    // and any fragment names found in the given fragment.
    for (const referencedFragmentName of referencedFragmentNames){
        // Memoize so two fragments are not compared for conflicts more than once.
        if (comparedFragmentPairs.has(referencedFragmentName, fragmentName, areMutuallyExclusive)) continue;
        comparedFragmentPairs.add(referencedFragmentName, fragmentName, areMutuallyExclusive);
        $1d5356c77d703b71$var$collectConflictsBetweenFieldsAndFragment(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fieldMap, referencedFragmentName);
    }
} // Collect all conflicts found between two fragments, including via spreading in
// any nested fragments.
function $1d5356c77d703b71$var$collectConflictsBetweenFragments(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fragmentName1, fragmentName2) {
    // No need to compare a fragment to itself.
    if (fragmentName1 === fragmentName2) return;
     // Memoize so two fragments are not compared for conflicts more than once.
    if (comparedFragmentPairs.has(fragmentName1, fragmentName2, areMutuallyExclusive)) return;
    comparedFragmentPairs.add(fragmentName1, fragmentName2, areMutuallyExclusive);
    const fragment1 = context.getFragment(fragmentName1);
    const fragment2 = context.getFragment(fragmentName2);
    if (!fragment1 || !fragment2) return;
    const [fieldMap1, referencedFragmentNames1] = $1d5356c77d703b71$var$getReferencedFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, fragment1);
    const [fieldMap2, referencedFragmentNames2] = $1d5356c77d703b71$var$getReferencedFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, fragment2); // (F) First, collect all conflicts between these two collections of fields
    // (not including any nested fragments).
    $1d5356c77d703b71$var$collectConflictsBetween(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fieldMap1, fieldMap2); // (G) Then collect conflicts between the first fragment and any nested
    // fragments spread in the second fragment.
    for (const referencedFragmentName2 of referencedFragmentNames2)$1d5356c77d703b71$var$collectConflictsBetweenFragments(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fragmentName1, referencedFragmentName2);
     // (G) Then collect conflicts between the second fragment and any nested
    // fragments spread in the first fragment.
    for (const referencedFragmentName1 of referencedFragmentNames1)$1d5356c77d703b71$var$collectConflictsBetweenFragments(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, referencedFragmentName1, fragmentName2);
} // Find all conflicts found between two selection sets, including those found
// via spreading in fragments. Called when determining if conflicts exist
// between the sub-fields of two overlapping fields.
function $1d5356c77d703b71$var$findConflictsBetweenSubSelectionSets(context, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, parentType1, selectionSet1, parentType2, selectionSet2) {
    const conflicts = [];
    const [fieldMap1, fragmentNames1] = $1d5356c77d703b71$var$getFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, parentType1, selectionSet1);
    const [fieldMap2, fragmentNames2] = $1d5356c77d703b71$var$getFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, parentType2, selectionSet2); // (H) First, collect all conflicts between these two collections of field.
    $1d5356c77d703b71$var$collectConflictsBetween(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fieldMap1, fieldMap2); // (I) Then collect conflicts between the first collection of fields and
    // those referenced by each fragment name associated with the second.
    for (const fragmentName2 of fragmentNames2)$1d5356c77d703b71$var$collectConflictsBetweenFieldsAndFragment(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fieldMap1, fragmentName2);
     // (I) Then collect conflicts between the second collection of fields and
    // those referenced by each fragment name associated with the first.
    for (const fragmentName1 of fragmentNames1)$1d5356c77d703b71$var$collectConflictsBetweenFieldsAndFragment(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fieldMap2, fragmentName1);
     // (J) Also collect conflicts between any fragment names by the first and
    // fragment names by the second. This compares each item in the first set of
    // names to each item in the second set of names.
    for (const fragmentName1 of fragmentNames1)for (const fragmentName2 of fragmentNames2)$1d5356c77d703b71$var$collectConflictsBetweenFragments(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fragmentName1, fragmentName2);
    return conflicts;
} // Collect all Conflicts "within" one collection of fields.
function $1d5356c77d703b71$var$collectConflictsWithin(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, fieldMap) {
    // A field map is a keyed collection, where each key represents a response
    // name and the value at that key is a list of all fields which provide that
    // response name. For every response name, if there are multiple fields, they
    // must be compared to find a potential conflict.
    for (const [responseName, fields] of Object.entries(fieldMap))// This compares every field in the list to every other field in this list
    // (except to itself). If the list only has one item, nothing needs to
    // be compared.
    if (fields.length > 1) {
        for(let i = 0; i < fields.length; i++)for(let j = i + 1; j < fields.length; j++){
            const conflict = $1d5356c77d703b71$var$findConflict(context, cachedFieldsAndFragmentNames, comparedFragmentPairs, false, responseName, fields[i], fields[j]);
            if (conflict) conflicts.push(conflict);
        }
    }
} // Collect all Conflicts between two collections of fields. This is similar to,
// but different from the `collectConflictsWithin` function above. This check
// assumes that `collectConflictsWithin` has already been called on each
// provided collection of fields. This is true because this validator traverses
// each individual selection set.
function $1d5356c77d703b71$var$collectConflictsBetween(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, parentFieldsAreMutuallyExclusive, fieldMap1, fieldMap2) {
    // A field map is a keyed collection, where each key represents a response
    // name and the value at that key is a list of all fields which provide that
    // response name. For any response name which appears in both provided field
    // maps, each field from the first field map must be compared to every field
    // in the second field map to find potential conflicts.
    for (const [responseName, fields1] of Object.entries(fieldMap1)){
        const fields2 = fieldMap2[responseName];
        if (fields2) {
            for (const field1 of fields1)for (const field2 of fields2){
                const conflict = $1d5356c77d703b71$var$findConflict(context, cachedFieldsAndFragmentNames, comparedFragmentPairs, parentFieldsAreMutuallyExclusive, responseName, field1, field2);
                if (conflict) conflicts.push(conflict);
            }
        }
    }
} // Determines if there is a conflict between two particular fields, including
// comparing their sub-fields.
function $1d5356c77d703b71$var$findConflict(context, cachedFieldsAndFragmentNames, comparedFragmentPairs, parentFieldsAreMutuallyExclusive, responseName, field1, field2) {
    const [parentType1, node1, def1] = field1;
    const [parentType2, node2, def2] = field2; // If it is known that two fields could not possibly apply at the same
    // time, due to the parent types, then it is safe to permit them to diverge
    // in aliased field or arguments used as they will not present any ambiguity
    // by differing.
    // It is known that two parent types could never overlap if they are
    // different Object types. Interface or Union types might overlap - if not
    // in the current state of the schema, then perhaps in some future version,
    // thus may not safely diverge.
    const areMutuallyExclusive = parentFieldsAreMutuallyExclusive || parentType1 !== parentType2 && (0, $54dWd.isObjectType)(parentType1) && (0, $54dWd.isObjectType)(parentType2);
    if (!areMutuallyExclusive) {
        // Two aliases must refer to the same field.
        const name1 = node1.name.value;
        const name2 = node2.name.value;
        if (name1 !== name2) return [
            [
                responseName,
                `"${name1}" and "${name2}" are different fields`
            ],
            [
                node1
            ],
            [
                node2
            ]
        ];
         // Two field calls must have the same arguments.
        if (!$1d5356c77d703b71$var$sameArguments(node1, node2)) return [
            [
                responseName,
                "they have differing arguments"
            ],
            [
                node1
            ],
            [
                node2
            ]
        ];
    } // The return type for each field.
    const type1 = def1 === null || def1 === void 0 ? void 0 : def1.type;
    const type2 = def2 === null || def2 === void 0 ? void 0 : def2.type;
    if (type1 && type2 && $1d5356c77d703b71$var$doTypesConflict(type1, type2)) return [
        [
            responseName,
            `they return conflicting types "${(0, $gHwk7.inspect)(type1)}" and "${(0, $gHwk7.inspect)(type2)}"`
        ],
        [
            node1
        ],
        [
            node2
        ]
    ];
     // Collect and compare sub-fields. Use the same "visited fragment names" list
    // for both collections so fields in a fragment reference are never
    // compared to themselves.
    const selectionSet1 = node1.selectionSet;
    const selectionSet2 = node2.selectionSet;
    if (selectionSet1 && selectionSet2) {
        const conflicts = $1d5356c77d703b71$var$findConflictsBetweenSubSelectionSets(context, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, (0, $54dWd.getNamedType)(type1), selectionSet1, (0, $54dWd.getNamedType)(type2), selectionSet2);
        return $1d5356c77d703b71$var$subfieldConflicts(conflicts, responseName, node1, node2);
    }
}
function $1d5356c77d703b71$var$sameArguments(node1, node2) {
    const args1 = node1.arguments;
    const args2 = node2.arguments;
    if (args1 === undefined || args1.length === 0) return args2 === undefined || args2.length === 0;
    if (args2 === undefined || args2.length === 0) return false;
    /* c8 ignore next */ if (args1.length !== args2.length) /* c8 ignore next */ return false;
    const values2 = new Map(args2.map(({ name: name, value: value })=>[
            name.value,
            value
        ]));
    return args1.every((arg1)=>{
        const value1 = arg1.value;
        const value2 = values2.get(arg1.name.value);
        if (value2 === undefined) return false;
        return $1d5356c77d703b71$var$stringifyValue(value1) === $1d5356c77d703b71$var$stringifyValue(value2);
    });
}
function $1d5356c77d703b71$var$stringifyValue(value) {
    return (0, $3o9dz.print)((0, $7TQgG.sortValueNode)(value));
} // Two types conflict if both types could not apply to a value simultaneously.
// Composite types are ignored as their individual field types will be compared
// later recursively. However List and Non-Null types must match.
function $1d5356c77d703b71$var$doTypesConflict(type1, type2) {
    if ((0, $54dWd.isListType)(type1)) return (0, $54dWd.isListType)(type2) ? $1d5356c77d703b71$var$doTypesConflict(type1.ofType, type2.ofType) : true;
    if ((0, $54dWd.isListType)(type2)) return true;
    if ((0, $54dWd.isNonNullType)(type1)) return (0, $54dWd.isNonNullType)(type2) ? $1d5356c77d703b71$var$doTypesConflict(type1.ofType, type2.ofType) : true;
    if ((0, $54dWd.isNonNullType)(type2)) return true;
    if ((0, $54dWd.isLeafType)(type1) || (0, $54dWd.isLeafType)(type2)) return type1 !== type2;
    return false;
} // Given a selection set, return the collection of fields (a mapping of response
// name to field nodes and definitions) as well as a list of fragment names
// referenced via fragment spreads.
function $1d5356c77d703b71$var$getFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, parentType, selectionSet) {
    const cached = cachedFieldsAndFragmentNames.get(selectionSet);
    if (cached) return cached;
    const nodeAndDefs = Object.create(null);
    const fragmentNames = Object.create(null);
    $1d5356c77d703b71$var$_collectFieldsAndFragmentNames(context, parentType, selectionSet, nodeAndDefs, fragmentNames);
    const result = [
        nodeAndDefs,
        Object.keys(fragmentNames)
    ];
    cachedFieldsAndFragmentNames.set(selectionSet, result);
    return result;
} // Given a reference to a fragment, return the represented collection of fields
// as well as a list of nested fragment names referenced via fragment spreads.
function $1d5356c77d703b71$var$getReferencedFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, fragment) {
    // Short-circuit building a type from the node if possible.
    const cached = cachedFieldsAndFragmentNames.get(fragment.selectionSet);
    if (cached) return cached;
    const fragmentType = (0, $IvZa0.typeFromAST)(context.getSchema(), fragment.typeCondition);
    return $1d5356c77d703b71$var$getFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, fragmentType, fragment.selectionSet);
}
function $1d5356c77d703b71$var$_collectFieldsAndFragmentNames(context, parentType, selectionSet, nodeAndDefs, fragmentNames) {
    for (const selection of selectionSet.selections)switch(selection.kind){
        case (0, $hu3w4.Kind).FIELD:
            {
                const fieldName = selection.name.value;
                let fieldDef;
                if ((0, $54dWd.isObjectType)(parentType) || (0, $54dWd.isInterfaceType)(parentType)) fieldDef = parentType.getFields()[fieldName];
                const responseName = selection.alias ? selection.alias.value : fieldName;
                if (!nodeAndDefs[responseName]) nodeAndDefs[responseName] = [];
                nodeAndDefs[responseName].push([
                    parentType,
                    selection,
                    fieldDef
                ]);
                break;
            }
        case (0, $hu3w4.Kind).FRAGMENT_SPREAD:
            fragmentNames[selection.name.value] = true;
            break;
        case (0, $hu3w4.Kind).INLINE_FRAGMENT:
            {
                const typeCondition = selection.typeCondition;
                const inlineFragmentType = typeCondition ? (0, $IvZa0.typeFromAST)(context.getSchema(), typeCondition) : parentType;
                $1d5356c77d703b71$var$_collectFieldsAndFragmentNames(context, inlineFragmentType, selection.selectionSet, nodeAndDefs, fragmentNames);
                break;
            }
    }
} // Given a series of Conflicts which occurred between two sub-fields, generate
// a single Conflict.
function $1d5356c77d703b71$var$subfieldConflicts(conflicts, responseName, node1, node2) {
    if (conflicts.length > 0) return [
        [
            responseName,
            conflicts.map(([reason])=>reason)
        ],
        [
            node1,
            ...conflicts.map(([, fields1])=>fields1).flat()
        ],
        [
            node2,
            ...conflicts.map(([, , fields2])=>fields2).flat()
        ]
    ];
}
/**
 * A way to keep track of pairs of things when the ordering of the pair does not matter.
 */ class $1d5356c77d703b71$var$PairSet {
    constructor(){
        this._data = new Map();
    }
    has(a, b, areMutuallyExclusive) {
        var _this$_data$get;
        const [key1, key2] = a < b ? [
            a,
            b
        ] : [
            b,
            a
        ];
        const result = (_this$_data$get = this._data.get(key1)) === null || _this$_data$get === void 0 ? void 0 : _this$_data$get.get(key2);
        if (result === undefined) return false;
         // areMutuallyExclusive being false is a superset of being true, hence if
        // we want to know if this PairSet "has" these two with no exclusivity,
        // we have to ensure it was added as such.
        return areMutuallyExclusive ? true : areMutuallyExclusive === result;
    }
    add(a, b, areMutuallyExclusive) {
        const [key1, key2] = a < b ? [
            a,
            b
        ] : [
            b,
            a
        ];
        const map = this._data.get(key1);
        if (map === undefined) this._data.set(key1, new Map([
            [
                key2,
                areMutuallyExclusive
            ]
        ]));
        else map.set(key2, areMutuallyExclusive);
    }
}

});
parcelRegister("7TQgG", function(module, exports) {

$parcel$export(module.exports, "sortValueNode", () => $ae0bacb1c80641eb$export$79e0bf342cbf4943);

var $a8VtN = parcelRequire("a8VtN");

var $hu3w4 = parcelRequire("hu3w4");
function $ae0bacb1c80641eb$export$79e0bf342cbf4943(valueNode) {
    switch(valueNode.kind){
        case (0, $hu3w4.Kind).OBJECT:
            return {
                ...valueNode,
                fields: $ae0bacb1c80641eb$var$sortFields(valueNode.fields)
            };
        case (0, $hu3w4.Kind).LIST:
            return {
                ...valueNode,
                values: valueNode.values.map($ae0bacb1c80641eb$export$79e0bf342cbf4943)
            };
        case (0, $hu3w4.Kind).INT:
        case (0, $hu3w4.Kind).FLOAT:
        case (0, $hu3w4.Kind).STRING:
        case (0, $hu3w4.Kind).BOOLEAN:
        case (0, $hu3w4.Kind).NULL:
        case (0, $hu3w4.Kind).ENUM:
        case (0, $hu3w4.Kind).VARIABLE:
            return valueNode;
    }
}
function $ae0bacb1c80641eb$var$sortFields(fields) {
    return fields.map((fieldNode)=>({
            ...fieldNode,
            value: $ae0bacb1c80641eb$export$79e0bf342cbf4943(fieldNode.value)
        })).sort((fieldA, fieldB)=>(0, $a8VtN.naturalCompare)(fieldA.name.value, fieldB.name.value));
}

});


parcelRegister("jHKhb", function(module, exports) {

$parcel$export(module.exports, "PossibleFragmentSpreadsRule", () => $ec588280c7612295$export$aa7b39ab48da3359);

var $gHwk7 = parcelRequire("gHwk7");

var $fHcz3 = parcelRequire("fHcz3");

var $54dWd = parcelRequire("54dWd");

var $f0jWA = parcelRequire("f0jWA");

var $IvZa0 = parcelRequire("IvZa0");
function $ec588280c7612295$export$aa7b39ab48da3359(context) {
    return {
        InlineFragment (node) {
            const fragType = context.getType();
            const parentType = context.getParentType();
            if ((0, $54dWd.isCompositeType)(fragType) && (0, $54dWd.isCompositeType)(parentType) && !(0, $f0jWA.doTypesOverlap)(context.getSchema(), fragType, parentType)) {
                const parentTypeStr = (0, $gHwk7.inspect)(parentType);
                const fragTypeStr = (0, $gHwk7.inspect)(fragType);
                context.reportError(new (0, $fHcz3.GraphQLError)(`Fragment cannot be spread here as objects of type "${parentTypeStr}" can never be of type "${fragTypeStr}".`, {
                    nodes: node
                }));
            }
        },
        FragmentSpread (node) {
            const fragName = node.name.value;
            const fragType = $ec588280c7612295$var$getFragmentType(context, fragName);
            const parentType = context.getParentType();
            if (fragType && parentType && !(0, $f0jWA.doTypesOverlap)(context.getSchema(), fragType, parentType)) {
                const parentTypeStr = (0, $gHwk7.inspect)(parentType);
                const fragTypeStr = (0, $gHwk7.inspect)(fragType);
                context.reportError(new (0, $fHcz3.GraphQLError)(`Fragment "${fragName}" cannot be spread here as objects of type "${parentTypeStr}" can never be of type "${fragTypeStr}".`, {
                    nodes: node
                }));
            }
        }
    };
}
function $ec588280c7612295$var$getFragmentType(context, name) {
    const frag = context.getFragment(name);
    if (frag) {
        const type = (0, $IvZa0.typeFromAST)(context.getSchema(), frag.typeCondition);
        if ((0, $54dWd.isCompositeType)(type)) return type;
    }
}

});

parcelRegister("lPCXV", function(module, exports) {

$parcel$export(module.exports, "ProvidedRequiredArgumentsRule", () => $11a8e28056520f9d$export$4df169576372c8b2);
$parcel$export(module.exports, "ProvidedRequiredArgumentsOnDirectivesRule", () => $11a8e28056520f9d$export$5ff6a71c337c020f);

var $gHwk7 = parcelRequire("gHwk7");

var $1inQZ = parcelRequire("1inQZ");

var $fHcz3 = parcelRequire("fHcz3");

var $hu3w4 = parcelRequire("hu3w4");

var $3o9dz = parcelRequire("3o9dz");

var $54dWd = parcelRequire("54dWd");

var $9KaHw = parcelRequire("9KaHw");
function $11a8e28056520f9d$export$4df169576372c8b2(context) {
    return {
        // eslint-disable-next-line new-cap
        ...$11a8e28056520f9d$export$5ff6a71c337c020f(context),
        Field: {
            // Validate on leave to allow for deeper errors to appear first.
            leave (fieldNode) {
                var _fieldNode$arguments;
                const fieldDef = context.getFieldDef();
                if (!fieldDef) return false;
                const providedArgs = new Set(/* c8 ignore next */ (_fieldNode$arguments = fieldNode.arguments) === null || _fieldNode$arguments === void 0 ? void 0 : _fieldNode$arguments.map((arg)=>arg.name.value));
                for (const argDef of fieldDef.args)if (!providedArgs.has(argDef.name) && (0, $54dWd.isRequiredArgument)(argDef)) {
                    const argTypeStr = (0, $gHwk7.inspect)(argDef.type);
                    context.reportError(new (0, $fHcz3.GraphQLError)(`Field "${fieldDef.name}" argument "${argDef.name}" of type "${argTypeStr}" is required, but it was not provided.`, {
                        nodes: fieldNode
                    }));
                }
            }
        }
    };
}
function $11a8e28056520f9d$export$5ff6a71c337c020f(context) {
    var _schema$getDirectives;
    const requiredArgsMap = Object.create(null);
    const schema = context.getSchema();
    const definedDirectives = (_schema$getDirectives = schema === null || schema === void 0 ? void 0 : schema.getDirectives()) !== null && _schema$getDirectives !== void 0 ? _schema$getDirectives : (0, $9KaHw.specifiedDirectives);
    for (const directive of definedDirectives)requiredArgsMap[directive.name] = (0, $1inQZ.keyMap)(directive.args.filter((0, $54dWd.isRequiredArgument)), (arg)=>arg.name);
    const astDefinitions = context.getDocument().definitions;
    for (const def of astDefinitions)if (def.kind === (0, $hu3w4.Kind).DIRECTIVE_DEFINITION) {
        var _def$arguments;
        // FIXME: https://github.com/graphql/graphql-js/issues/2203
        /* c8 ignore next */ const argNodes = (_def$arguments = def.arguments) !== null && _def$arguments !== void 0 ? _def$arguments : [];
        requiredArgsMap[def.name.value] = (0, $1inQZ.keyMap)(argNodes.filter($11a8e28056520f9d$var$isRequiredArgumentNode), (arg)=>arg.name.value);
    }
    return {
        Directive: {
            // Validate on leave to allow for deeper errors to appear first.
            leave (directiveNode) {
                const directiveName = directiveNode.name.value;
                const requiredArgs = requiredArgsMap[directiveName];
                if (requiredArgs) {
                    var _directiveNode$argume;
                    // FIXME: https://github.com/graphql/graphql-js/issues/2203
                    /* c8 ignore next */ const argNodes = (_directiveNode$argume = directiveNode.arguments) !== null && _directiveNode$argume !== void 0 ? _directiveNode$argume : [];
                    const argNodeMap = new Set(argNodes.map((arg)=>arg.name.value));
                    for (const [argName, argDef] of Object.entries(requiredArgs))if (!argNodeMap.has(argName)) {
                        const argType = (0, $54dWd.isType)(argDef.type) ? (0, $gHwk7.inspect)(argDef.type) : (0, $3o9dz.print)(argDef.type);
                        context.reportError(new (0, $fHcz3.GraphQLError)(`Directive "@${directiveName}" argument "${argName}" of type "${argType}" is required, but it was not provided.`, {
                            nodes: directiveNode
                        }));
                    }
                }
            }
        }
    };
}
function $11a8e28056520f9d$var$isRequiredArgumentNode(arg) {
    return arg.type.kind === (0, $hu3w4.Kind).NON_NULL_TYPE && arg.defaultValue == null;
}

});

parcelRegister("gBFeA", function(module, exports) {

$parcel$export(module.exports, "ScalarLeafsRule", () => $481b803e84c659c8$export$d779f66f65c88b9a);

var $gHwk7 = parcelRequire("gHwk7");

var $fHcz3 = parcelRequire("fHcz3");

var $54dWd = parcelRequire("54dWd");
function $481b803e84c659c8$export$d779f66f65c88b9a(context) {
    return {
        Field (node) {
            const type = context.getType();
            const selectionSet = node.selectionSet;
            if (type) {
                if ((0, $54dWd.isLeafType)((0, $54dWd.getNamedType)(type))) {
                    if (selectionSet) {
                        const fieldName = node.name.value;
                        const typeStr = (0, $gHwk7.inspect)(type);
                        context.reportError(new (0, $fHcz3.GraphQLError)(`Field "${fieldName}" must not have a selection since type "${typeStr}" has no subfields.`, {
                            nodes: selectionSet
                        }));
                    }
                } else if (!selectionSet) {
                    const fieldName = node.name.value;
                    const typeStr = (0, $gHwk7.inspect)(type);
                    context.reportError(new (0, $fHcz3.GraphQLError)(`Field "${fieldName}" of type "${typeStr}" must have a selection of subfields. Did you mean "${fieldName} { ... }"?`, {
                        nodes: node
                    }));
                }
            }
        }
    };
}

});

parcelRegister("7su90", function(module, exports) {

$parcel$export(module.exports, "SingleFieldSubscriptionsRule", () => $632b628c19fca77e$export$477fa0c787c0222d);

var $fHcz3 = parcelRequire("fHcz3");

var $hu3w4 = parcelRequire("hu3w4");

var $eTaek = parcelRequire("eTaek");
function $632b628c19fca77e$export$477fa0c787c0222d(context) {
    return {
        OperationDefinition (node) {
            if (node.operation === "subscription") {
                const schema = context.getSchema();
                const subscriptionType = schema.getSubscriptionType();
                if (subscriptionType) {
                    const operationName = node.name ? node.name.value : null;
                    const variableValues = Object.create(null);
                    const document = context.getDocument();
                    const fragments = Object.create(null);
                    for (const definition of document.definitions)if (definition.kind === (0, $hu3w4.Kind).FRAGMENT_DEFINITION) fragments[definition.name.value] = definition;
                    const fields = (0, $eTaek.collectFields)(schema, fragments, variableValues, subscriptionType, node.selectionSet);
                    if (fields.size > 1) {
                        const fieldSelectionLists = [
                            ...fields.values()
                        ];
                        const extraFieldSelectionLists = fieldSelectionLists.slice(1);
                        const extraFieldSelections = extraFieldSelectionLists.flat();
                        context.reportError(new (0, $fHcz3.GraphQLError)(operationName != null ? `Subscription "${operationName}" must select only one top level field.` : "Anonymous Subscription must select only one top level field.", {
                            nodes: extraFieldSelections
                        }));
                    }
                    for (const fieldNodes of fields.values()){
                        const field = fieldNodes[0];
                        const fieldName = field.name.value;
                        if (fieldName.startsWith("__")) context.reportError(new (0, $fHcz3.GraphQLError)(operationName != null ? `Subscription "${operationName}" must not select an introspection top level field.` : "Anonymous Subscription must not select an introspection top level field.", {
                            nodes: fieldNodes
                        }));
                    }
                }
            }
        }
    };
}

});
parcelRegister("eTaek", function(module, exports) {

$parcel$export(module.exports, "collectFields", () => $6e91d73f567bfc26$export$c23741d442fe90e9);
$parcel$export(module.exports, "collectSubfields", () => $6e91d73f567bfc26$export$1efa47c016f2e173);

var $hu3w4 = parcelRequire("hu3w4");

var $54dWd = parcelRequire("54dWd");

var $9KaHw = parcelRequire("9KaHw");

var $IvZa0 = parcelRequire("IvZa0");

var $bErfz = parcelRequire("bErfz");
function $6e91d73f567bfc26$export$c23741d442fe90e9(schema, fragments, variableValues, runtimeType, selectionSet) {
    const fields = new Map();
    $6e91d73f567bfc26$var$collectFieldsImpl(schema, fragments, variableValues, runtimeType, selectionSet, fields, new Set());
    return fields;
}
function $6e91d73f567bfc26$export$1efa47c016f2e173(schema, fragments, variableValues, returnType, fieldNodes) {
    const subFieldNodes = new Map();
    const visitedFragmentNames = new Set();
    for (const node of fieldNodes)if (node.selectionSet) $6e91d73f567bfc26$var$collectFieldsImpl(schema, fragments, variableValues, returnType, node.selectionSet, subFieldNodes, visitedFragmentNames);
    return subFieldNodes;
}
function $6e91d73f567bfc26$var$collectFieldsImpl(schema, fragments, variableValues, runtimeType, selectionSet, fields, visitedFragmentNames) {
    for (const selection of selectionSet.selections)switch(selection.kind){
        case (0, $hu3w4.Kind).FIELD:
            {
                if (!$6e91d73f567bfc26$var$shouldIncludeNode(variableValues, selection)) continue;
                const name = $6e91d73f567bfc26$var$getFieldEntryKey(selection);
                const fieldList = fields.get(name);
                if (fieldList !== undefined) fieldList.push(selection);
                else fields.set(name, [
                    selection
                ]);
                break;
            }
        case (0, $hu3w4.Kind).INLINE_FRAGMENT:
            if (!$6e91d73f567bfc26$var$shouldIncludeNode(variableValues, selection) || !$6e91d73f567bfc26$var$doesFragmentConditionMatch(schema, selection, runtimeType)) continue;
            $6e91d73f567bfc26$var$collectFieldsImpl(schema, fragments, variableValues, runtimeType, selection.selectionSet, fields, visitedFragmentNames);
            break;
        case (0, $hu3w4.Kind).FRAGMENT_SPREAD:
            {
                const fragName = selection.name.value;
                if (visitedFragmentNames.has(fragName) || !$6e91d73f567bfc26$var$shouldIncludeNode(variableValues, selection)) continue;
                visitedFragmentNames.add(fragName);
                const fragment = fragments[fragName];
                if (!fragment || !$6e91d73f567bfc26$var$doesFragmentConditionMatch(schema, fragment, runtimeType)) continue;
                $6e91d73f567bfc26$var$collectFieldsImpl(schema, fragments, variableValues, runtimeType, fragment.selectionSet, fields, visitedFragmentNames);
                break;
            }
    }
}
/**
 * Determines if a field should be included based on the `@include` and `@skip`
 * directives, where `@skip` has higher precedence than `@include`.
 */ function $6e91d73f567bfc26$var$shouldIncludeNode(variableValues, node) {
    const skip = (0, $bErfz.getDirectiveValues)((0, $9KaHw.GraphQLSkipDirective), node, variableValues);
    if ((skip === null || skip === void 0 ? void 0 : skip.if) === true) return false;
    const include = (0, $bErfz.getDirectiveValues)((0, $9KaHw.GraphQLIncludeDirective), node, variableValues);
    if ((include === null || include === void 0 ? void 0 : include.if) === false) return false;
    return true;
}
/**
 * Determines if a fragment is applicable to the given type.
 */ function $6e91d73f567bfc26$var$doesFragmentConditionMatch(schema, fragment, type) {
    const typeConditionNode = fragment.typeCondition;
    if (!typeConditionNode) return true;
    const conditionalType = (0, $IvZa0.typeFromAST)(schema, typeConditionNode);
    if (conditionalType === type) return true;
    if ((0, $54dWd.isAbstractType)(conditionalType)) return schema.isSubType(conditionalType, type);
    return false;
}
/**
 * Implements the logic to compute the key of a given field's entry
 */ function $6e91d73f567bfc26$var$getFieldEntryKey(node) {
    return node.alias ? node.alias.value : node.name.value;
}

});
parcelRegister("bErfz", function(module, exports) {

$parcel$export(module.exports, "getVariableValues", () => $18ea968749030b2b$export$2038fbf5c9bccf57);
$parcel$export(module.exports, "getArgumentValues", () => $18ea968749030b2b$export$5af04a8495f7ef54);
$parcel$export(module.exports, "getDirectiveValues", () => $18ea968749030b2b$export$1f7174681493b2aa);

var $gHwk7 = parcelRequire("gHwk7");

var $1inQZ = parcelRequire("1inQZ");

var $fK7zf = parcelRequire("fK7zf");

var $fHcz3 = parcelRequire("fHcz3");

var $hu3w4 = parcelRequire("hu3w4");

var $3o9dz = parcelRequire("3o9dz");

var $54dWd = parcelRequire("54dWd");

var $5FHzh = parcelRequire("5FHzh");

var $IvZa0 = parcelRequire("IvZa0");

var $9lFiU = parcelRequire("9lFiU");
function $18ea968749030b2b$export$2038fbf5c9bccf57(schema, varDefNodes, inputs, options) {
    const errors = [];
    const maxErrors = options === null || options === void 0 ? void 0 : options.maxErrors;
    try {
        const coerced = $18ea968749030b2b$var$coerceVariableValues(schema, varDefNodes, inputs, (error)=>{
            if (maxErrors != null && errors.length >= maxErrors) throw new (0, $fHcz3.GraphQLError)("Too many errors processing variables, error limit reached. Execution aborted.");
            errors.push(error);
        });
        if (errors.length === 0) return {
            coerced: coerced
        };
    } catch (error) {
        errors.push(error);
    }
    return {
        errors: errors
    };
}
function $18ea968749030b2b$var$coerceVariableValues(schema, varDefNodes, inputs, onError) {
    const coercedValues = {};
    for (const varDefNode of varDefNodes){
        const varName = varDefNode.variable.name.value;
        const varType = (0, $IvZa0.typeFromAST)(schema, varDefNode.type);
        if (!(0, $54dWd.isInputType)(varType)) {
            // Must use input types for variables. This should be caught during
            // validation, however is checked again here for safety.
            const varTypeStr = (0, $3o9dz.print)(varDefNode.type);
            onError(new (0, $fHcz3.GraphQLError)(`Variable "$${varName}" expected value of type "${varTypeStr}" which cannot be used as an input type.`, {
                nodes: varDefNode.type
            }));
            continue;
        }
        if (!$18ea968749030b2b$var$hasOwnProperty(inputs, varName)) {
            if (varDefNode.defaultValue) coercedValues[varName] = (0, $9lFiU.valueFromAST)(varDefNode.defaultValue, varType);
            else if ((0, $54dWd.isNonNullType)(varType)) {
                const varTypeStr = (0, $gHwk7.inspect)(varType);
                onError(new (0, $fHcz3.GraphQLError)(`Variable "$${varName}" of required type "${varTypeStr}" was not provided.`, {
                    nodes: varDefNode
                }));
            }
            continue;
        }
        const value = inputs[varName];
        if (value === null && (0, $54dWd.isNonNullType)(varType)) {
            const varTypeStr = (0, $gHwk7.inspect)(varType);
            onError(new (0, $fHcz3.GraphQLError)(`Variable "$${varName}" of non-null type "${varTypeStr}" must not be null.`, {
                nodes: varDefNode
            }));
            continue;
        }
        coercedValues[varName] = (0, $5FHzh.coerceInputValue)(value, varType, (path, invalidValue, error)=>{
            let prefix = `Variable "$${varName}" got invalid value ` + (0, $gHwk7.inspect)(invalidValue);
            if (path.length > 0) prefix += ` at "${varName}${(0, $fK7zf.printPathArray)(path)}"`;
            onError(new (0, $fHcz3.GraphQLError)(prefix + "; " + error.message, {
                nodes: varDefNode,
                originalError: error
            }));
        });
    }
    return coercedValues;
}
function $18ea968749030b2b$export$5af04a8495f7ef54(def, node, variableValues) {
    var _node$arguments;
    const coercedValues = {}; // FIXME: https://github.com/graphql/graphql-js/issues/2203
    /* c8 ignore next */ const argumentNodes = (_node$arguments = node.arguments) !== null && _node$arguments !== void 0 ? _node$arguments : [];
    const argNodeMap = (0, $1inQZ.keyMap)(argumentNodes, (arg)=>arg.name.value);
    for (const argDef of def.args){
        const name = argDef.name;
        const argType = argDef.type;
        const argumentNode = argNodeMap[name];
        if (!argumentNode) {
            if (argDef.defaultValue !== undefined) coercedValues[name] = argDef.defaultValue;
            else if ((0, $54dWd.isNonNullType)(argType)) throw new (0, $fHcz3.GraphQLError)(`Argument "${name}" of required type "${(0, $gHwk7.inspect)(argType)}" ` + "was not provided.", {
                nodes: node
            });
            continue;
        }
        const valueNode = argumentNode.value;
        let isNull = valueNode.kind === (0, $hu3w4.Kind).NULL;
        if (valueNode.kind === (0, $hu3w4.Kind).VARIABLE) {
            const variableName = valueNode.name.value;
            if (variableValues == null || !$18ea968749030b2b$var$hasOwnProperty(variableValues, variableName)) {
                if (argDef.defaultValue !== undefined) coercedValues[name] = argDef.defaultValue;
                else if ((0, $54dWd.isNonNullType)(argType)) throw new (0, $fHcz3.GraphQLError)(`Argument "${name}" of required type "${(0, $gHwk7.inspect)(argType)}" ` + `was provided the variable "$${variableName}" which was not provided a runtime value.`, {
                    nodes: valueNode
                });
                continue;
            }
            isNull = variableValues[variableName] == null;
        }
        if (isNull && (0, $54dWd.isNonNullType)(argType)) throw new (0, $fHcz3.GraphQLError)(`Argument "${name}" of non-null type "${(0, $gHwk7.inspect)(argType)}" ` + "must not be null.", {
            nodes: valueNode
        });
        const coercedValue = (0, $9lFiU.valueFromAST)(valueNode, argType, variableValues);
        if (coercedValue === undefined) // Note: ValuesOfCorrectTypeRule validation should catch this before
        // execution. This is a runtime check to ensure execution does not
        // continue with an invalid argument value.
        throw new (0, $fHcz3.GraphQLError)(`Argument "${name}" has invalid value ${(0, $3o9dz.print)(valueNode)}.`, {
            nodes: valueNode
        });
        coercedValues[name] = coercedValue;
    }
    return coercedValues;
}
function $18ea968749030b2b$export$1f7174681493b2aa(directiveDef, node, variableValues) {
    var _node$directives;
    const directiveNode = (_node$directives = node.directives) === null || _node$directives === void 0 ? void 0 : _node$directives.find((directive)=>directive.name.value === directiveDef.name);
    if (directiveNode) return $18ea968749030b2b$export$5af04a8495f7ef54(directiveDef, directiveNode, variableValues);
}
function $18ea968749030b2b$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}

});
parcelRegister("fK7zf", function(module, exports) {

$parcel$export(module.exports, "printPathArray", () => $7def23c34c57343c$export$22dd8133a5cb3387);
/**
 * Build a string describing the path.
 */ function $7def23c34c57343c$export$22dd8133a5cb3387(path) {
    return path.map((key)=>typeof key === "number" ? "[" + key.toString() + "]" : "." + key).join("");
}

});

parcelRegister("5FHzh", function(module, exports) {

$parcel$export(module.exports, "coerceInputValue", () => $26c9efb2087626b7$export$7964ec791f1fa3f1);

var $ej6fd = parcelRequire("ej6fd");

var $gHwk7 = parcelRequire("gHwk7");

var $l3zHt = parcelRequire("l3zHt");

var $4wIbP = parcelRequire("4wIbP");

var $cryJ5 = parcelRequire("cryJ5");

var $1kt8t = parcelRequire("1kt8t");

var $fK7zf = parcelRequire("fK7zf");

var $a2eVh = parcelRequire("a2eVh");

var $fHcz3 = parcelRequire("fHcz3");

var $54dWd = parcelRequire("54dWd");
function $26c9efb2087626b7$export$7964ec791f1fa3f1(inputValue, type, onError = $26c9efb2087626b7$var$defaultOnError) {
    return $26c9efb2087626b7$var$coerceInputValueImpl(inputValue, type, onError, undefined);
}
function $26c9efb2087626b7$var$defaultOnError(path, invalidValue, error) {
    let errorPrefix = "Invalid value " + (0, $gHwk7.inspect)(invalidValue);
    if (path.length > 0) errorPrefix += ` at "value${(0, $fK7zf.printPathArray)(path)}"`;
    error.message = errorPrefix + ": " + error.message;
    throw error;
}
function $26c9efb2087626b7$var$coerceInputValueImpl(inputValue, type, onError, path) {
    if ((0, $54dWd.isNonNullType)(type)) {
        if (inputValue != null) return $26c9efb2087626b7$var$coerceInputValueImpl(inputValue, type.ofType, onError, path);
        onError((0, $1kt8t.pathToArray)(path), inputValue, new (0, $fHcz3.GraphQLError)(`Expected non-nullable type "${(0, $gHwk7.inspect)(type)}" not to be null.`));
        return;
    }
    if (inputValue == null) // Explicitly return the value null.
    return null;
    if ((0, $54dWd.isListType)(type)) {
        const itemType = type.ofType;
        if ((0, $4wIbP.isIterableObject)(inputValue)) return Array.from(inputValue, (itemValue, index)=>{
            const itemPath = (0, $1kt8t.addPath)(path, index, undefined);
            return $26c9efb2087626b7$var$coerceInputValueImpl(itemValue, itemType, onError, itemPath);
        });
         // Lists accept a non-list value as a list of one.
        return [
            $26c9efb2087626b7$var$coerceInputValueImpl(inputValue, itemType, onError, path)
        ];
    }
    if ((0, $54dWd.isInputObjectType)(type)) {
        if (!(0, $cryJ5.isObjectLike)(inputValue)) {
            onError((0, $1kt8t.pathToArray)(path), inputValue, new (0, $fHcz3.GraphQLError)(`Expected type "${type.name}" to be an object.`));
            return;
        }
        const coercedValue = {};
        const fieldDefs = type.getFields();
        for (const field of Object.values(fieldDefs)){
            const fieldValue = inputValue[field.name];
            if (fieldValue === undefined) {
                if (field.defaultValue !== undefined) coercedValue[field.name] = field.defaultValue;
                else if ((0, $54dWd.isNonNullType)(field.type)) {
                    const typeStr = (0, $gHwk7.inspect)(field.type);
                    onError((0, $1kt8t.pathToArray)(path), inputValue, new (0, $fHcz3.GraphQLError)(`Field "${field.name}" of required type "${typeStr}" was not provided.`));
                }
                continue;
            }
            coercedValue[field.name] = $26c9efb2087626b7$var$coerceInputValueImpl(fieldValue, field.type, onError, (0, $1kt8t.addPath)(path, field.name, type.name));
        } // Ensure every provided field is defined.
        for (const fieldName of Object.keys(inputValue))if (!fieldDefs[fieldName]) {
            const suggestions = (0, $a2eVh.suggestionList)(fieldName, Object.keys(type.getFields()));
            onError((0, $1kt8t.pathToArray)(path), inputValue, new (0, $fHcz3.GraphQLError)(`Field "${fieldName}" is not defined by type "${type.name}".` + (0, $ej6fd.didYouMean)(suggestions)));
        }
        return coercedValue;
    }
    if ((0, $54dWd.isLeafType)(type)) {
        let parseResult; // Scalars and Enums determine if a input value is valid via parseValue(),
        // which can throw to indicate failure. If it throws, maintain a reference
        // to the original error.
        try {
            parseResult = type.parseValue(inputValue);
        } catch (error) {
            if (error instanceof (0, $fHcz3.GraphQLError)) onError((0, $1kt8t.pathToArray)(path), inputValue, error);
            else onError((0, $1kt8t.pathToArray)(path), inputValue, new (0, $fHcz3.GraphQLError)(`Expected type "${type.name}". ` + error.message, {
                originalError: error
            }));
            return;
        }
        if (parseResult === undefined) onError((0, $1kt8t.pathToArray)(path), inputValue, new (0, $fHcz3.GraphQLError)(`Expected type "${type.name}".`));
        return parseResult;
    }
    /* c8 ignore next 3 */ // Not reachable, all possible types have been considered.
    (0, $l3zHt.invariant)(false, "Unexpected input type: " + (0, $gHwk7.inspect)(type));
}

});
parcelRegister("1kt8t", function(module, exports) {

$parcel$export(module.exports, "addPath", () => $f3c7ec526dfd8d9a$export$4c25481b843feb0b);
$parcel$export(module.exports, "pathToArray", () => $f3c7ec526dfd8d9a$export$38d939edd7751830);
/**
 * Given a Path and a key, return a new Path containing the new key.
 */ function $f3c7ec526dfd8d9a$export$4c25481b843feb0b(prev, key, typename) {
    return {
        prev: prev,
        key: key,
        typename: typename
    };
}
function $f3c7ec526dfd8d9a$export$38d939edd7751830(path) {
    const flattened = [];
    let curr = path;
    while(curr){
        flattened.push(curr.key);
        curr = curr.prev;
    }
    return flattened.reverse();
}

});





parcelRegister("g0gN2", function(module, exports) {

$parcel$export(module.exports, "UniqueArgumentDefinitionNamesRule", () => $de47cf2e675693d4$export$ab646ae82aac5486);

var $241n0 = parcelRequire("241n0");

var $fHcz3 = parcelRequire("fHcz3");
function $de47cf2e675693d4$export$ab646ae82aac5486(context) {
    return {
        DirectiveDefinition (directiveNode) {
            var _directiveNode$argume;
            // FIXME: https://github.com/graphql/graphql-js/issues/2203
            /* c8 ignore next */ const argumentNodes = (_directiveNode$argume = directiveNode.arguments) !== null && _directiveNode$argume !== void 0 ? _directiveNode$argume : [];
            return checkArgUniqueness(`@${directiveNode.name.value}`, argumentNodes);
        },
        InterfaceTypeDefinition: checkArgUniquenessPerField,
        InterfaceTypeExtension: checkArgUniquenessPerField,
        ObjectTypeDefinition: checkArgUniquenessPerField,
        ObjectTypeExtension: checkArgUniquenessPerField
    };
    function checkArgUniquenessPerField(typeNode) {
        var _typeNode$fields;
        const typeName = typeNode.name.value; // FIXME: https://github.com/graphql/graphql-js/issues/2203
        /* c8 ignore next */ const fieldNodes = (_typeNode$fields = typeNode.fields) !== null && _typeNode$fields !== void 0 ? _typeNode$fields : [];
        for (const fieldDef of fieldNodes){
            var _fieldDef$arguments;
            const fieldName = fieldDef.name.value; // FIXME: https://github.com/graphql/graphql-js/issues/2203
            /* c8 ignore next */ const argumentNodes = (_fieldDef$arguments = fieldDef.arguments) !== null && _fieldDef$arguments !== void 0 ? _fieldDef$arguments : [];
            checkArgUniqueness(`${typeName}.${fieldName}`, argumentNodes);
        }
        return false;
    }
    function checkArgUniqueness(parentName, argumentNodes) {
        const seenArgs = (0, $241n0.groupBy)(argumentNodes, (arg)=>arg.name.value);
        for (const [argName, argNodes] of seenArgs)if (argNodes.length > 1) context.reportError(new (0, $fHcz3.GraphQLError)(`Argument "${parentName}(${argName}:)" can only be defined once.`, {
            nodes: argNodes.map((node)=>node.name)
        }));
        return false;
    }
}

});
parcelRegister("241n0", function(module, exports) {

$parcel$export(module.exports, "groupBy", () => $d0c468a5ffec51d3$export$3f063810d7bf01bd);
/**
 * Groups array items into a Map, given a function to produce grouping key.
 */ function $d0c468a5ffec51d3$export$3f063810d7bf01bd(list, keyFn) {
    const result = new Map();
    for (const item of list){
        const key = keyFn(item);
        const group = result.get(key);
        if (group === undefined) result.set(key, [
            item
        ]);
        else group.push(item);
    }
    return result;
}

});


parcelRegister("2hatF", function(module, exports) {

$parcel$export(module.exports, "UniqueArgumentNamesRule", () => $0accf26435ca5e45$export$8598b5acb1d855ca);

var $241n0 = parcelRequire("241n0");

var $fHcz3 = parcelRequire("fHcz3");
function $0accf26435ca5e45$export$8598b5acb1d855ca(context) {
    return {
        Field: checkArgUniqueness,
        Directive: checkArgUniqueness
    };
    function checkArgUniqueness(parentNode) {
        var _parentNode$arguments;
        // FIXME: https://github.com/graphql/graphql-js/issues/2203
        /* c8 ignore next */ const argumentNodes = (_parentNode$arguments = parentNode.arguments) !== null && _parentNode$arguments !== void 0 ? _parentNode$arguments : [];
        const seenArgs = (0, $241n0.groupBy)(argumentNodes, (arg)=>arg.name.value);
        for (const [argName, argNodes] of seenArgs)if (argNodes.length > 1) context.reportError(new (0, $fHcz3.GraphQLError)(`There can be only one argument named "${argName}".`, {
            nodes: argNodes.map((node)=>node.name)
        }));
    }
}

});

parcelRegister("2ia4v", function(module, exports) {

$parcel$export(module.exports, "UniqueDirectiveNamesRule", () => $20987d8c914d4364$export$b06952068b20c86f);

var $fHcz3 = parcelRequire("fHcz3");
function $20987d8c914d4364$export$b06952068b20c86f(context) {
    const knownDirectiveNames = Object.create(null);
    const schema = context.getSchema();
    return {
        DirectiveDefinition (node) {
            const directiveName = node.name.value;
            if (schema !== null && schema !== void 0 && schema.getDirective(directiveName)) {
                context.reportError(new (0, $fHcz3.GraphQLError)(`Directive "@${directiveName}" already exists in the schema. It cannot be redefined.`, {
                    nodes: node.name
                }));
                return;
            }
            if (knownDirectiveNames[directiveName]) context.reportError(new (0, $fHcz3.GraphQLError)(`There can be only one directive named "@${directiveName}".`, {
                nodes: [
                    knownDirectiveNames[directiveName],
                    node.name
                ]
            }));
            else knownDirectiveNames[directiveName] = node.name;
            return false;
        }
    };
}

});

parcelRegister("464Lr", function(module, exports) {

$parcel$export(module.exports, "UniqueDirectivesPerLocationRule", () => $1febfcc70f2f6d10$export$4a38f68ea408504c);

var $fHcz3 = parcelRequire("fHcz3");

var $hu3w4 = parcelRequire("hu3w4");

var $cftRS = parcelRequire("cftRS");

var $9KaHw = parcelRequire("9KaHw");
function $1febfcc70f2f6d10$export$4a38f68ea408504c(context) {
    const uniqueDirectiveMap = Object.create(null);
    const schema = context.getSchema();
    const definedDirectives = schema ? schema.getDirectives() : (0, $9KaHw.specifiedDirectives);
    for (const directive of definedDirectives)uniqueDirectiveMap[directive.name] = !directive.isRepeatable;
    const astDefinitions = context.getDocument().definitions;
    for (const def of astDefinitions)if (def.kind === (0, $hu3w4.Kind).DIRECTIVE_DEFINITION) uniqueDirectiveMap[def.name.value] = !def.repeatable;
    const schemaDirectives = Object.create(null);
    const typeDirectivesMap = Object.create(null);
    return {
        // Many different AST nodes may contain directives. Rather than listing
        // them all, just listen for entering any node, and check to see if it
        // defines any directives.
        enter (node) {
            if (!("directives" in node) || !node.directives) return;
            let seenDirectives;
            if (node.kind === (0, $hu3w4.Kind).SCHEMA_DEFINITION || node.kind === (0, $hu3w4.Kind).SCHEMA_EXTENSION) seenDirectives = schemaDirectives;
            else if ((0, $cftRS.isTypeDefinitionNode)(node) || (0, $cftRS.isTypeExtensionNode)(node)) {
                const typeName = node.name.value;
                seenDirectives = typeDirectivesMap[typeName];
                if (seenDirectives === undefined) typeDirectivesMap[typeName] = seenDirectives = Object.create(null);
            } else seenDirectives = Object.create(null);
            for (const directive of node.directives){
                const directiveName = directive.name.value;
                if (uniqueDirectiveMap[directiveName]) {
                    if (seenDirectives[directiveName]) context.reportError(new (0, $fHcz3.GraphQLError)(`The directive "@${directiveName}" can only be used once at this location.`, {
                        nodes: [
                            seenDirectives[directiveName],
                            directive
                        ]
                    }));
                    else seenDirectives[directiveName] = directive;
                }
            }
        }
    };
}

});

parcelRegister("iH3W9", function(module, exports) {

$parcel$export(module.exports, "UniqueEnumValueNamesRule", () => $12e8cc349a2ab6a1$export$f5a22bb45cdc635d);

var $fHcz3 = parcelRequire("fHcz3");

var $54dWd = parcelRequire("54dWd");
function $12e8cc349a2ab6a1$export$f5a22bb45cdc635d(context) {
    const schema = context.getSchema();
    const existingTypeMap = schema ? schema.getTypeMap() : Object.create(null);
    const knownValueNames = Object.create(null);
    return {
        EnumTypeDefinition: checkValueUniqueness,
        EnumTypeExtension: checkValueUniqueness
    };
    function checkValueUniqueness(node) {
        var _node$values;
        const typeName = node.name.value;
        if (!knownValueNames[typeName]) knownValueNames[typeName] = Object.create(null);
         // FIXME: https://github.com/graphql/graphql-js/issues/2203
        /* c8 ignore next */ const valueNodes = (_node$values = node.values) !== null && _node$values !== void 0 ? _node$values : [];
        const valueNames = knownValueNames[typeName];
        for (const valueDef of valueNodes){
            const valueName = valueDef.name.value;
            const existingType = existingTypeMap[typeName];
            if ((0, $54dWd.isEnumType)(existingType) && existingType.getValue(valueName)) context.reportError(new (0, $fHcz3.GraphQLError)(`Enum value "${typeName}.${valueName}" already exists in the schema. It cannot also be defined in this type extension.`, {
                nodes: valueDef.name
            }));
            else if (valueNames[valueName]) context.reportError(new (0, $fHcz3.GraphQLError)(`Enum value "${typeName}.${valueName}" can only be defined once.`, {
                nodes: [
                    valueNames[valueName],
                    valueDef.name
                ]
            }));
            else valueNames[valueName] = valueDef.name;
        }
        return false;
    }
}

});

parcelRegister("3928j", function(module, exports) {

$parcel$export(module.exports, "UniqueFieldDefinitionNamesRule", () => $149c4ce4bb4194f8$export$b3dfc0de81924308);

var $fHcz3 = parcelRequire("fHcz3");

var $54dWd = parcelRequire("54dWd");
function $149c4ce4bb4194f8$export$b3dfc0de81924308(context) {
    const schema = context.getSchema();
    const existingTypeMap = schema ? schema.getTypeMap() : Object.create(null);
    const knownFieldNames = Object.create(null);
    return {
        InputObjectTypeDefinition: checkFieldUniqueness,
        InputObjectTypeExtension: checkFieldUniqueness,
        InterfaceTypeDefinition: checkFieldUniqueness,
        InterfaceTypeExtension: checkFieldUniqueness,
        ObjectTypeDefinition: checkFieldUniqueness,
        ObjectTypeExtension: checkFieldUniqueness
    };
    function checkFieldUniqueness(node) {
        var _node$fields;
        const typeName = node.name.value;
        if (!knownFieldNames[typeName]) knownFieldNames[typeName] = Object.create(null);
         // FIXME: https://github.com/graphql/graphql-js/issues/2203
        /* c8 ignore next */ const fieldNodes = (_node$fields = node.fields) !== null && _node$fields !== void 0 ? _node$fields : [];
        const fieldNames = knownFieldNames[typeName];
        for (const fieldDef of fieldNodes){
            const fieldName = fieldDef.name.value;
            if ($149c4ce4bb4194f8$var$hasField(existingTypeMap[typeName], fieldName)) context.reportError(new (0, $fHcz3.GraphQLError)(`Field "${typeName}.${fieldName}" already exists in the schema. It cannot also be defined in this type extension.`, {
                nodes: fieldDef.name
            }));
            else if (fieldNames[fieldName]) context.reportError(new (0, $fHcz3.GraphQLError)(`Field "${typeName}.${fieldName}" can only be defined once.`, {
                nodes: [
                    fieldNames[fieldName],
                    fieldDef.name
                ]
            }));
            else fieldNames[fieldName] = fieldDef.name;
        }
        return false;
    }
}
function $149c4ce4bb4194f8$var$hasField(type, fieldName) {
    if ((0, $54dWd.isObjectType)(type) || (0, $54dWd.isInterfaceType)(type) || (0, $54dWd.isInputObjectType)(type)) return type.getFields()[fieldName] != null;
    return false;
}

});

parcelRegister("iTZMn", function(module, exports) {

$parcel$export(module.exports, "UniqueFragmentNamesRule", () => $b808b93be697190b$export$a920e0f1967f4b0a);

var $fHcz3 = parcelRequire("fHcz3");
function $b808b93be697190b$export$a920e0f1967f4b0a(context) {
    const knownFragmentNames = Object.create(null);
    return {
        OperationDefinition: ()=>false,
        FragmentDefinition (node) {
            const fragmentName = node.name.value;
            if (knownFragmentNames[fragmentName]) context.reportError(new (0, $fHcz3.GraphQLError)(`There can be only one fragment named "${fragmentName}".`, {
                nodes: [
                    knownFragmentNames[fragmentName],
                    node.name
                ]
            }));
            else knownFragmentNames[fragmentName] = node.name;
            return false;
        }
    };
}

});

parcelRegister("8um4Z", function(module, exports) {

$parcel$export(module.exports, "UniqueInputFieldNamesRule", () => $3f037525a7867e72$export$de7865c052ebdd8c);

var $l3zHt = parcelRequire("l3zHt");

var $fHcz3 = parcelRequire("fHcz3");
function $3f037525a7867e72$export$de7865c052ebdd8c(context) {
    const knownNameStack = [];
    let knownNames = Object.create(null);
    return {
        ObjectValue: {
            enter () {
                knownNameStack.push(knownNames);
                knownNames = Object.create(null);
            },
            leave () {
                const prevKnownNames = knownNameStack.pop();
                prevKnownNames || (0, $l3zHt.invariant)(false);
                knownNames = prevKnownNames;
            }
        },
        ObjectField (node) {
            const fieldName = node.name.value;
            if (knownNames[fieldName]) context.reportError(new (0, $fHcz3.GraphQLError)(`There can be only one input field named "${fieldName}".`, {
                nodes: [
                    knownNames[fieldName],
                    node.name
                ]
            }));
            else knownNames[fieldName] = node.name;
        }
    };
}

});

parcelRegister("6zN5l", function(module, exports) {

$parcel$export(module.exports, "UniqueOperationNamesRule", () => $446bcc8a1c4e35db$export$a40a702cd7ad2eae);

var $fHcz3 = parcelRequire("fHcz3");
function $446bcc8a1c4e35db$export$a40a702cd7ad2eae(context) {
    const knownOperationNames = Object.create(null);
    return {
        OperationDefinition (node) {
            const operationName = node.name;
            if (operationName) {
                if (knownOperationNames[operationName.value]) context.reportError(new (0, $fHcz3.GraphQLError)(`There can be only one operation named "${operationName.value}".`, {
                    nodes: [
                        knownOperationNames[operationName.value],
                        operationName
                    ]
                }));
                else knownOperationNames[operationName.value] = operationName;
            }
            return false;
        },
        FragmentDefinition: ()=>false
    };
}

});

parcelRegister("5bfCp", function(module, exports) {

$parcel$export(module.exports, "UniqueOperationTypesRule", () => $9204a9c93d705943$export$d9750570c6d13894);

var $fHcz3 = parcelRequire("fHcz3");
function $9204a9c93d705943$export$d9750570c6d13894(context) {
    const schema = context.getSchema();
    const definedOperationTypes = Object.create(null);
    const existingOperationTypes = schema ? {
        query: schema.getQueryType(),
        mutation: schema.getMutationType(),
        subscription: schema.getSubscriptionType()
    } : {};
    return {
        SchemaDefinition: checkOperationTypes,
        SchemaExtension: checkOperationTypes
    };
    function checkOperationTypes(node) {
        var _node$operationTypes;
        // See: https://github.com/graphql/graphql-js/issues/2203
        /* c8 ignore next */ const operationTypesNodes = (_node$operationTypes = node.operationTypes) !== null && _node$operationTypes !== void 0 ? _node$operationTypes : [];
        for (const operationType of operationTypesNodes){
            const operation = operationType.operation;
            const alreadyDefinedOperationType = definedOperationTypes[operation];
            if (existingOperationTypes[operation]) context.reportError(new (0, $fHcz3.GraphQLError)(`Type for ${operation} already defined in the schema. It cannot be redefined.`, {
                nodes: operationType
            }));
            else if (alreadyDefinedOperationType) context.reportError(new (0, $fHcz3.GraphQLError)(`There can be only one ${operation} type in schema.`, {
                nodes: [
                    alreadyDefinedOperationType,
                    operationType
                ]
            }));
            else definedOperationTypes[operation] = operationType;
        }
        return false;
    }
}

});

parcelRegister("lpOFf", function(module, exports) {

$parcel$export(module.exports, "UniqueTypeNamesRule", () => $396f8dff105d3c7c$export$380307ee0123f80e);

var $fHcz3 = parcelRequire("fHcz3");
function $396f8dff105d3c7c$export$380307ee0123f80e(context) {
    const knownTypeNames = Object.create(null);
    const schema = context.getSchema();
    return {
        ScalarTypeDefinition: checkTypeName,
        ObjectTypeDefinition: checkTypeName,
        InterfaceTypeDefinition: checkTypeName,
        UnionTypeDefinition: checkTypeName,
        EnumTypeDefinition: checkTypeName,
        InputObjectTypeDefinition: checkTypeName
    };
    function checkTypeName(node) {
        const typeName = node.name.value;
        if (schema !== null && schema !== void 0 && schema.getType(typeName)) {
            context.reportError(new (0, $fHcz3.GraphQLError)(`Type "${typeName}" already exists in the schema. It cannot also be defined in this type definition.`, {
                nodes: node.name
            }));
            return;
        }
        if (knownTypeNames[typeName]) context.reportError(new (0, $fHcz3.GraphQLError)(`There can be only one type named "${typeName}".`, {
            nodes: [
                knownTypeNames[typeName],
                node.name
            ]
        }));
        else knownTypeNames[typeName] = node.name;
        return false;
    }
}

});

parcelRegister("972Dd", function(module, exports) {

$parcel$export(module.exports, "UniqueVariableNamesRule", () => $c4318ea97f2a97e9$export$b9352e3a23ba4aa2);

var $241n0 = parcelRequire("241n0");

var $fHcz3 = parcelRequire("fHcz3");
function $c4318ea97f2a97e9$export$b9352e3a23ba4aa2(context) {
    return {
        OperationDefinition (operationNode) {
            var _operationNode$variab;
            // See: https://github.com/graphql/graphql-js/issues/2203
            /* c8 ignore next */ const variableDefinitions = (_operationNode$variab = operationNode.variableDefinitions) !== null && _operationNode$variab !== void 0 ? _operationNode$variab : [];
            const seenVariableDefinitions = (0, $241n0.groupBy)(variableDefinitions, (node)=>node.variable.name.value);
            for (const [variableName, variableNodes] of seenVariableDefinitions)if (variableNodes.length > 1) context.reportError(new (0, $fHcz3.GraphQLError)(`There can be only one variable named "$${variableName}".`, {
                nodes: variableNodes.map((node)=>node.variable.name)
            }));
        }
    };
}

});

parcelRegister("l2KI6", function(module, exports) {

$parcel$export(module.exports, "ValuesOfCorrectTypeRule", () => $699c720551006516$export$669bf87f50cfda9b);

var $ej6fd = parcelRequire("ej6fd");

var $gHwk7 = parcelRequire("gHwk7");

var $1inQZ = parcelRequire("1inQZ");

var $a2eVh = parcelRequire("a2eVh");

var $fHcz3 = parcelRequire("fHcz3");

var $3o9dz = parcelRequire("3o9dz");

var $54dWd = parcelRequire("54dWd");
function $699c720551006516$export$669bf87f50cfda9b(context) {
    return {
        ListValue (node) {
            // Note: TypeInfo will traverse into a list's item type, so look to the
            // parent input type to check if it is a list.
            const type = (0, $54dWd.getNullableType)(context.getParentInputType());
            if (!(0, $54dWd.isListType)(type)) {
                $699c720551006516$var$isValidValueNode(context, node);
                return false; // Don't traverse further.
            }
        },
        ObjectValue (node) {
            const type = (0, $54dWd.getNamedType)(context.getInputType());
            if (!(0, $54dWd.isInputObjectType)(type)) {
                $699c720551006516$var$isValidValueNode(context, node);
                return false; // Don't traverse further.
            } // Ensure every required field exists.
            const fieldNodeMap = (0, $1inQZ.keyMap)(node.fields, (field)=>field.name.value);
            for (const fieldDef of Object.values(type.getFields())){
                const fieldNode = fieldNodeMap[fieldDef.name];
                if (!fieldNode && (0, $54dWd.isRequiredInputField)(fieldDef)) {
                    const typeStr = (0, $gHwk7.inspect)(fieldDef.type);
                    context.reportError(new (0, $fHcz3.GraphQLError)(`Field "${type.name}.${fieldDef.name}" of required type "${typeStr}" was not provided.`, {
                        nodes: node
                    }));
                }
            }
        },
        ObjectField (node) {
            const parentType = (0, $54dWd.getNamedType)(context.getParentInputType());
            const fieldType = context.getInputType();
            if (!fieldType && (0, $54dWd.isInputObjectType)(parentType)) {
                const suggestions = (0, $a2eVh.suggestionList)(node.name.value, Object.keys(parentType.getFields()));
                context.reportError(new (0, $fHcz3.GraphQLError)(`Field "${node.name.value}" is not defined by type "${parentType.name}".` + (0, $ej6fd.didYouMean)(suggestions), {
                    nodes: node
                }));
            }
        },
        NullValue (node) {
            const type = context.getInputType();
            if ((0, $54dWd.isNonNullType)(type)) context.reportError(new (0, $fHcz3.GraphQLError)(`Expected value of type "${(0, $gHwk7.inspect)(type)}", found ${(0, $3o9dz.print)(node)}.`, {
                nodes: node
            }));
        },
        EnumValue: (node)=>$699c720551006516$var$isValidValueNode(context, node),
        IntValue: (node)=>$699c720551006516$var$isValidValueNode(context, node),
        FloatValue: (node)=>$699c720551006516$var$isValidValueNode(context, node),
        StringValue: (node)=>$699c720551006516$var$isValidValueNode(context, node),
        BooleanValue: (node)=>$699c720551006516$var$isValidValueNode(context, node)
    };
}
/**
 * Any value literal may be a valid representation of a Scalar, depending on
 * that scalar type.
 */ function $699c720551006516$var$isValidValueNode(context, node) {
    // Report any error at the full type expected by the location.
    const locationType = context.getInputType();
    if (!locationType) return;
    const type = (0, $54dWd.getNamedType)(locationType);
    if (!(0, $54dWd.isLeafType)(type)) {
        const typeStr = (0, $gHwk7.inspect)(locationType);
        context.reportError(new (0, $fHcz3.GraphQLError)(`Expected value of type "${typeStr}", found ${(0, $3o9dz.print)(node)}.`, {
            nodes: node
        }));
        return;
    } // Scalars and Enums determine if a literal value is valid via parseLiteral(),
    // which may throw or return an invalid value to indicate failure.
    try {
        const parseResult = type.parseLiteral(node, undefined);
        if (parseResult === undefined) {
            const typeStr = (0, $gHwk7.inspect)(locationType);
            context.reportError(new (0, $fHcz3.GraphQLError)(`Expected value of type "${typeStr}", found ${(0, $3o9dz.print)(node)}.`, {
                nodes: node
            }));
        }
    } catch (error) {
        const typeStr = (0, $gHwk7.inspect)(locationType);
        if (error instanceof (0, $fHcz3.GraphQLError)) context.reportError(error);
        else context.reportError(new (0, $fHcz3.GraphQLError)(`Expected value of type "${typeStr}", found ${(0, $3o9dz.print)(node)}; ` + error.message, {
            nodes: node,
            originalError: error
        }));
    }
}

});

parcelRegister("iaWPa", function(module, exports) {

$parcel$export(module.exports, "VariablesAreInputTypesRule", () => $2673e1fb6da7cceb$export$f20a29632b437591);

var $fHcz3 = parcelRequire("fHcz3");

var $3o9dz = parcelRequire("3o9dz");

var $54dWd = parcelRequire("54dWd");

var $IvZa0 = parcelRequire("IvZa0");
function $2673e1fb6da7cceb$export$f20a29632b437591(context) {
    return {
        VariableDefinition (node) {
            const type = (0, $IvZa0.typeFromAST)(context.getSchema(), node.type);
            if (type !== undefined && !(0, $54dWd.isInputType)(type)) {
                const variableName = node.variable.name.value;
                const typeName = (0, $3o9dz.print)(node.type);
                context.reportError(new (0, $fHcz3.GraphQLError)(`Variable "$${variableName}" cannot be non-input type "${typeName}".`, {
                    nodes: node.type
                }));
            }
        }
    };
}

});

parcelRegister("e186G", function(module, exports) {

$parcel$export(module.exports, "VariablesInAllowedPositionRule", () => $4b10e4a40963cc6d$export$7251631d636f2f74);

var $gHwk7 = parcelRequire("gHwk7");

var $fHcz3 = parcelRequire("fHcz3");

var $hu3w4 = parcelRequire("hu3w4");

var $54dWd = parcelRequire("54dWd");

var $f0jWA = parcelRequire("f0jWA");

var $IvZa0 = parcelRequire("IvZa0");
function $4b10e4a40963cc6d$export$7251631d636f2f74(context) {
    let varDefMap = Object.create(null);
    return {
        OperationDefinition: {
            enter () {
                varDefMap = Object.create(null);
            },
            leave (operation) {
                const usages = context.getRecursiveVariableUsages(operation);
                for (const { node: node, type: type, defaultValue: defaultValue } of usages){
                    const varName = node.name.value;
                    const varDef = varDefMap[varName];
                    if (varDef && type) {
                        // A var type is allowed if it is the same or more strict (e.g. is
                        // a subtype of) than the expected type. It can be more strict if
                        // the variable type is non-null when the expected type is nullable.
                        // If both are list types, the variable item type can be more strict
                        // than the expected item type (contravariant).
                        const schema = context.getSchema();
                        const varType = (0, $IvZa0.typeFromAST)(schema, varDef.type);
                        if (varType && !$4b10e4a40963cc6d$var$allowedVariableUsage(schema, varType, varDef.defaultValue, type, defaultValue)) {
                            const varTypeStr = (0, $gHwk7.inspect)(varType);
                            const typeStr = (0, $gHwk7.inspect)(type);
                            context.reportError(new (0, $fHcz3.GraphQLError)(`Variable "$${varName}" of type "${varTypeStr}" used in position expecting type "${typeStr}".`, {
                                nodes: [
                                    varDef,
                                    node
                                ]
                            }));
                        }
                    }
                }
            }
        },
        VariableDefinition (node) {
            varDefMap[node.variable.name.value] = node;
        }
    };
}
/**
 * Returns true if the variable is allowed in the location it was found,
 * which includes considering if default values exist for either the variable
 * or the location at which it is located.
 */ function $4b10e4a40963cc6d$var$allowedVariableUsage(schema, varType, varDefaultValue, locationType, locationDefaultValue) {
    if ((0, $54dWd.isNonNullType)(locationType) && !(0, $54dWd.isNonNullType)(varType)) {
        const hasNonNullVariableDefaultValue = varDefaultValue != null && varDefaultValue.kind !== (0, $hu3w4.Kind).NULL;
        const hasLocationDefaultValue = locationDefaultValue !== undefined;
        if (!hasNonNullVariableDefaultValue && !hasLocationDefaultValue) return false;
        const nullableLocationType = locationType.ofType;
        return (0, $f0jWA.isTypeSubTypeOf)(schema, varType, nullableLocationType);
    }
    return (0, $f0jWA.isTypeSubTypeOf)(schema, varType, locationType);
}

});


parcelRegister("dFUlP", function(module, exports) {

$parcel$export(module.exports, "validate", () => $360a250ec3eae16c$export$a22775fa5e2eebd9);
$parcel$export(module.exports, "assertValidSDL", () => $360a250ec3eae16c$export$e53e4d7168bd6d92);
$parcel$export(module.exports, "assertValidSDLExtension", () => $360a250ec3eae16c$export$9917845776f624a4);

var $lDltR = parcelRequire("lDltR");

var $fHcz3 = parcelRequire("fHcz3");

var $9m7aI = parcelRequire("9m7aI");

var $dy8yN = parcelRequire("dy8yN");

var $eEwlA = parcelRequire("eEwlA");

var $cEYhC = parcelRequire("cEYhC");

var $g3U5B = parcelRequire("g3U5B");
function $360a250ec3eae16c$export$a22775fa5e2eebd9(schema, documentAST, rules = (0, $cEYhC.specifiedRules), options, /** @deprecated will be removed in 17.0.0 */ typeInfo = new (0, $eEwlA.TypeInfo)(schema)) {
    var _options$maxErrors;
    const maxErrors = (_options$maxErrors = options === null || options === void 0 ? void 0 : options.maxErrors) !== null && _options$maxErrors !== void 0 ? _options$maxErrors : 100;
    documentAST || (0, $lDltR.devAssert)(false, "Must provide document."); // If the schema used for validation is invalid, throw an error.
    (0, $dy8yN.assertValidSchema)(schema);
    const abortObj = Object.freeze({});
    const errors = [];
    const context = new (0, $g3U5B.ValidationContext)(schema, documentAST, typeInfo, (error)=>{
        if (errors.length >= maxErrors) {
            errors.push(new (0, $fHcz3.GraphQLError)("Too many validation errors, error limit reached. Validation aborted.")); // eslint-disable-next-line @typescript-eslint/no-throw-literal
            throw abortObj;
        }
        errors.push(error);
    }); // This uses a specialized visitor which runs multiple visitors in parallel,
    // while maintaining the visitor skip and break API.
    const visitor = (0, $9m7aI.visitInParallel)(rules.map((rule)=>rule(context))); // Visit the whole document with each instance of all provided rules.
    try {
        (0, $9m7aI.visit)(documentAST, (0, $eEwlA.visitWithTypeInfo)(typeInfo, visitor));
    } catch (e) {
        if (e !== abortObj) throw e;
    }
    return errors;
}
function $360a250ec3eae16c$export$664b3e1af4fc59b0(documentAST, schemaToExtend, rules = (0, $cEYhC.specifiedSDLRules)) {
    const errors = [];
    const context = new (0, $g3U5B.SDLValidationContext)(documentAST, schemaToExtend, (error)=>{
        errors.push(error);
    });
    const visitors = rules.map((rule)=>rule(context));
    (0, $9m7aI.visit)(documentAST, (0, $9m7aI.visitInParallel)(visitors));
    return errors;
}
function $360a250ec3eae16c$export$e53e4d7168bd6d92(documentAST) {
    const errors = $360a250ec3eae16c$export$664b3e1af4fc59b0(documentAST);
    if (errors.length !== 0) throw new Error(errors.map((error)=>error.message).join("\n\n"));
}
function $360a250ec3eae16c$export$9917845776f624a4(documentAST, schema) {
    const errors = $360a250ec3eae16c$export$664b3e1af4fc59b0(documentAST, schema);
    if (errors.length !== 0) throw new Error(errors.map((error)=>error.message).join("\n\n"));
}

});
parcelRegister("g3U5B", function(module, exports) {

$parcel$export(module.exports, "SDLValidationContext", () => $e3b2db75a479db43$export$62ce401b55355c79);
$parcel$export(module.exports, "ValidationContext", () => $e3b2db75a479db43$export$d452675449e81987);

var $hu3w4 = parcelRequire("hu3w4");

var $9m7aI = parcelRequire("9m7aI");

var $eEwlA = parcelRequire("eEwlA");
class $e3b2db75a479db43$export$ebdf7b7a2f7aef8b {
    constructor(ast, onError){
        this._ast = ast;
        this._fragments = undefined;
        this._fragmentSpreads = new Map();
        this._recursivelyReferencedFragments = new Map();
        this._onError = onError;
    }
    get [Symbol.toStringTag]() {
        return "ASTValidationContext";
    }
    reportError(error) {
        this._onError(error);
    }
    getDocument() {
        return this._ast;
    }
    getFragment(name) {
        let fragments;
        if (this._fragments) fragments = this._fragments;
        else {
            fragments = Object.create(null);
            for (const defNode of this.getDocument().definitions)if (defNode.kind === (0, $hu3w4.Kind).FRAGMENT_DEFINITION) fragments[defNode.name.value] = defNode;
            this._fragments = fragments;
        }
        return fragments[name];
    }
    getFragmentSpreads(node) {
        let spreads = this._fragmentSpreads.get(node);
        if (!spreads) {
            spreads = [];
            const setsToVisit = [
                node
            ];
            let set;
            while(set = setsToVisit.pop())for (const selection of set.selections){
                if (selection.kind === (0, $hu3w4.Kind).FRAGMENT_SPREAD) spreads.push(selection);
                else if (selection.selectionSet) setsToVisit.push(selection.selectionSet);
            }
            this._fragmentSpreads.set(node, spreads);
        }
        return spreads;
    }
    getRecursivelyReferencedFragments(operation) {
        let fragments = this._recursivelyReferencedFragments.get(operation);
        if (!fragments) {
            fragments = [];
            const collectedNames = Object.create(null);
            const nodesToVisit = [
                operation.selectionSet
            ];
            let node;
            while(node = nodesToVisit.pop())for (const spread of this.getFragmentSpreads(node)){
                const fragName = spread.name.value;
                if (collectedNames[fragName] !== true) {
                    collectedNames[fragName] = true;
                    const fragment = this.getFragment(fragName);
                    if (fragment) {
                        fragments.push(fragment);
                        nodesToVisit.push(fragment.selectionSet);
                    }
                }
            }
            this._recursivelyReferencedFragments.set(operation, fragments);
        }
        return fragments;
    }
}
class $e3b2db75a479db43$export$62ce401b55355c79 extends $e3b2db75a479db43$export$ebdf7b7a2f7aef8b {
    constructor(ast, schema, onError){
        super(ast, onError);
        this._schema = schema;
    }
    get [Symbol.toStringTag]() {
        return "SDLValidationContext";
    }
    getSchema() {
        return this._schema;
    }
}
class $e3b2db75a479db43$export$d452675449e81987 extends $e3b2db75a479db43$export$ebdf7b7a2f7aef8b {
    constructor(schema, ast, typeInfo, onError){
        super(ast, onError);
        this._schema = schema;
        this._typeInfo = typeInfo;
        this._variableUsages = new Map();
        this._recursiveVariableUsages = new Map();
    }
    get [Symbol.toStringTag]() {
        return "ValidationContext";
    }
    getSchema() {
        return this._schema;
    }
    getVariableUsages(node) {
        let usages = this._variableUsages.get(node);
        if (!usages) {
            const newUsages = [];
            const typeInfo = new (0, $eEwlA.TypeInfo)(this._schema);
            (0, $9m7aI.visit)(node, (0, $eEwlA.visitWithTypeInfo)(typeInfo, {
                VariableDefinition: ()=>false,
                Variable (variable) {
                    newUsages.push({
                        node: variable,
                        type: typeInfo.getInputType(),
                        defaultValue: typeInfo.getDefaultValue()
                    });
                }
            }));
            usages = newUsages;
            this._variableUsages.set(node, usages);
        }
        return usages;
    }
    getRecursiveVariableUsages(operation) {
        let usages = this._recursiveVariableUsages.get(operation);
        if (!usages) {
            usages = this.getVariableUsages(operation);
            for (const frag of this.getRecursivelyReferencedFragments(operation))usages = usages.concat(this.getVariableUsages(frag));
            this._recursiveVariableUsages.set(operation, usages);
        }
        return usages;
    }
    getType() {
        return this._typeInfo.getType();
    }
    getParentType() {
        return this._typeInfo.getParentType();
    }
    getInputType() {
        return this._typeInfo.getInputType();
    }
    getParentInputType() {
        return this._typeInfo.getParentInputType();
    }
    getFieldDef() {
        return this._typeInfo.getFieldDef();
    }
    getDirective() {
        return this._typeInfo.getDirective();
    }
    getArgument() {
        return this._typeInfo.getArgument();
    }
    getEnumValue() {
        return this._typeInfo.getEnumValue();
    }
}

});



parcelRegister("jAx3E", function(module, exports) {

$parcel$export(module.exports, "collectVariables", () => $e42b05b3193f9463$export$1f35113db04e985c);

var $l5aqI = parcelRequire("l5aqI");
var $hu3w4 = parcelRequire("hu3w4");
var $IvZa0 = parcelRequire("IvZa0");
function $e42b05b3193f9463$export$1f35113db04e985c(schema, documentAST) {
    const variableToType = Object.create(null);
    for (const definition of documentAST.definitions)if (definition.kind === "OperationDefinition") {
        const { variableDefinitions: variableDefinitions } = definition;
        if (variableDefinitions) for (const { variable: variable, type: type } of variableDefinitions){
            const inputType = (0, $IvZa0.typeFromAST)(schema, type);
            if (inputType) variableToType[variable.name.value] = inputType;
            else if (type.kind === (0, $hu3w4.Kind).NAMED_TYPE && type.name.value === "Float") variableToType[variable.name.value] = (0, $l5aqI.GraphQLFloat);
        }
    }
    return variableToType;
}

});

parcelRegister("8xP5p", function(module, exports) {

$parcel$export(module.exports, "default", () => $638908766d701fbf$export$2e2bcd8739ae039);

var $8DJ2k = parcelRequire("8DJ2k");
var $9m7aI = parcelRequire("9m7aI");

var $jAx3E = parcelRequire("jAx3E");
function $638908766d701fbf$export$85525c3c23c3b5e9(documentAST, schema) {
    const variableToType = schema ? (0, $jAx3E.collectVariables)(schema, documentAST) : undefined;
    const operations = [];
    (0, $9m7aI.visit)(documentAST, {
        OperationDefinition (node) {
            operations.push(node);
        }
    });
    return {
        variableToType: variableToType,
        operations: operations
    };
}
function $638908766d701fbf$export$2e2bcd8739ae039(schema, documentString) {
    if (!documentString) return;
    try {
        const documentAST = (0, $8DJ2k.parse)(documentString);
        return Object.assign(Object.assign({}, $638908766d701fbf$export$85525c3c23c3b5e9(documentAST, schema)), {
            documentAST: documentAST
        });
    } catch (_a) {
        return;
    }
}
const $638908766d701fbf$export$859873ba45d95626 = $638908766d701fbf$export$2e2bcd8739ae039;

});



parcelRegister("36lGu", function(module, exports) {

$parcel$export(module.exports, "getDiagnostics", () => $2422c0abdcb7a1dd$export$5ae6c96aeafe5287);

var $fHcz3 = parcelRequire("fHcz3");
var $ctLIg = parcelRequire("ctLIg");
var $8DJ2k = parcelRequire("8DJ2k");
var $3o9dz = parcelRequire("3o9dz");
var $dFUlP = parcelRequire("dFUlP");
parcelRequire("k1lDu");
var $8qHvn = parcelRequire("8qHvn");
var $imwtR = parcelRequire("imwtR");
parcelRequire("fcdqG");
var $87oLu = parcelRequire("87oLu");
var $eKt33 = parcelRequire("eKt33");
const $2422c0abdcb7a1dd$export$6a6bef12562cd865 = {
    Error: "Error",
    Warning: "Warning",
    Information: "Information",
    Hint: "Hint"
};
const $2422c0abdcb7a1dd$export$1e70b4656c0671b4 = {
    [$2422c0abdcb7a1dd$export$6a6bef12562cd865.Error]: 1,
    [$2422c0abdcb7a1dd$export$6a6bef12562cd865.Warning]: 2,
    [$2422c0abdcb7a1dd$export$6a6bef12562cd865.Information]: 3,
    [$2422c0abdcb7a1dd$export$6a6bef12562cd865.Hint]: 4
};
const $2422c0abdcb7a1dd$var$invariant = (condition, message)=>{
    if (!condition) throw new Error(message);
};
function $2422c0abdcb7a1dd$export$5ae6c96aeafe5287(query, schema = null, customRules, isRelayCompatMode, externalFragments) {
    var _a, _b;
    let ast = null;
    let fragments = "";
    if (externalFragments) fragments = typeof externalFragments === "string" ? externalFragments : externalFragments.reduce((acc, node)=>acc + (0, $3o9dz.print)(node) + "\n\n", "");
    const enhancedQuery = fragments ? `${query}\n\n${fragments}` : query;
    try {
        ast = (0, $8DJ2k.parse)(enhancedQuery);
    } catch (error) {
        if (error instanceof (0, $fHcz3.GraphQLError)) {
            const range = $2422c0abdcb7a1dd$export$fef151b94550e9f5((_b = (_a = error.locations) === null || _a === void 0 ? void 0 : _a[0]) !== null && _b !== void 0 ? _b : {
                line: 0,
                column: 0
            }, enhancedQuery);
            return [
                {
                    severity: $2422c0abdcb7a1dd$export$1e70b4656c0671b4.Error,
                    message: error.message,
                    source: "GraphQL: Syntax",
                    range: range
                }
            ];
        }
        throw error;
    }
    return $2422c0abdcb7a1dd$export$6d4016d301bc6e21(ast, schema, customRules, isRelayCompatMode);
}
function $2422c0abdcb7a1dd$export$6d4016d301bc6e21(ast, schema = null, customRules, isRelayCompatMode) {
    if (!schema) return [];
    const validationErrorAnnotations = (0, $eKt33.validateWithCustomRules)(schema, ast, customRules, isRelayCompatMode).flatMap((error)=>$2422c0abdcb7a1dd$var$annotations(error, $2422c0abdcb7a1dd$export$1e70b4656c0671b4.Error, "Validation"));
    const deprecationWarningAnnotations = (0, $dFUlP.validate)(schema, ast, [
        (0, $ctLIg.NoDeprecatedCustomRule)
    ]).flatMap((error)=>$2422c0abdcb7a1dd$var$annotations(error, $2422c0abdcb7a1dd$export$1e70b4656c0671b4.Warning, "Deprecation"));
    return validationErrorAnnotations.concat(deprecationWarningAnnotations);
}
function $2422c0abdcb7a1dd$var$annotations(error, severity, type) {
    if (!error.nodes) return [];
    const highlightedNodes = [];
    for (const [i, node] of error.nodes.entries()){
        const highlightNode = node.kind !== "Variable" && "name" in node && node.name !== undefined ? node.name : "variable" in node && node.variable !== undefined ? node.variable : node;
        if (highlightNode) {
            $2422c0abdcb7a1dd$var$invariant(error.locations, "GraphQL validation error requires locations.");
            const loc = error.locations[i];
            const highlightLoc = $2422c0abdcb7a1dd$var$getLocation(highlightNode);
            const end = loc.column + (highlightLoc.end - highlightLoc.start);
            highlightedNodes.push({
                source: `GraphQL: ${type}`,
                message: error.message,
                severity: severity,
                range: new (0, $87oLu.Range)(new (0, $87oLu.Position)(loc.line - 1, loc.column - 1), new (0, $87oLu.Position)(loc.line - 1, end))
            });
        }
    }
    return highlightedNodes;
}
function $2422c0abdcb7a1dd$export$fef151b94550e9f5(location, queryText) {
    const parser = (0, $imwtR.default)();
    const state = parser.startState();
    const lines = queryText.split("\n");
    $2422c0abdcb7a1dd$var$invariant(lines.length >= location.line, "Query text must have more lines than where the error happened");
    let stream = null;
    for(let i = 0; i < location.line; i++){
        stream = new (0, $8qHvn.default)(lines[i]);
        while(!stream.eol()){
            const style = parser.token(stream, state);
            if (style === "invalidchar") break;
        }
    }
    $2422c0abdcb7a1dd$var$invariant(stream, "Expected Parser stream to be available.");
    const line = location.line - 1;
    const start = stream.getStartOfToken();
    const end = stream.getCurrentPosition();
    return new (0, $87oLu.Range)(new (0, $87oLu.Position)(line, start), new (0, $87oLu.Position)(line, end));
}
function $2422c0abdcb7a1dd$var$getLocation(node) {
    const typeCastedNode = node;
    const location = typeCastedNode.loc;
    $2422c0abdcb7a1dd$var$invariant(location, "Expected ASTNode to have a location.");
    return location;
}

});
parcelRegister("ctLIg", function(module, exports) {

$parcel$export(module.exports, "NoDeprecatedCustomRule", () => $0b95f40a17a0892a$export$b047ea96646c83c8);

var $l3zHt = parcelRequire("l3zHt");

var $fHcz3 = parcelRequire("fHcz3");

var $54dWd = parcelRequire("54dWd");
function $0b95f40a17a0892a$export$b047ea96646c83c8(context) {
    return {
        Field (node) {
            const fieldDef = context.getFieldDef();
            const deprecationReason = fieldDef === null || fieldDef === void 0 ? void 0 : fieldDef.deprecationReason;
            if (fieldDef && deprecationReason != null) {
                const parentType = context.getParentType();
                parentType != null || (0, $l3zHt.invariant)(false);
                context.reportError(new (0, $fHcz3.GraphQLError)(`The field ${parentType.name}.${fieldDef.name} is deprecated. ${deprecationReason}`, {
                    nodes: node
                }));
            }
        },
        Argument (node) {
            const argDef = context.getArgument();
            const deprecationReason = argDef === null || argDef === void 0 ? void 0 : argDef.deprecationReason;
            if (argDef && deprecationReason != null) {
                const directiveDef = context.getDirective();
                if (directiveDef != null) context.reportError(new (0, $fHcz3.GraphQLError)(`Directive "@${directiveDef.name}" argument "${argDef.name}" is deprecated. ${deprecationReason}`, {
                    nodes: node
                }));
                else {
                    const parentType = context.getParentType();
                    const fieldDef = context.getFieldDef();
                    parentType != null && fieldDef != null || (0, $l3zHt.invariant)(false);
                    context.reportError(new (0, $fHcz3.GraphQLError)(`Field "${parentType.name}.${fieldDef.name}" argument "${argDef.name}" is deprecated. ${deprecationReason}`, {
                        nodes: node
                    }));
                }
            }
        },
        ObjectField (node) {
            const inputObjectDef = (0, $54dWd.getNamedType)(context.getParentInputType());
            if ((0, $54dWd.isInputObjectType)(inputObjectDef)) {
                const inputFieldDef = inputObjectDef.getFields()[node.name.value];
                const deprecationReason = inputFieldDef === null || inputFieldDef === void 0 ? void 0 : inputFieldDef.deprecationReason;
                if (deprecationReason != null) context.reportError(new (0, $fHcz3.GraphQLError)(`The input field ${inputObjectDef.name}.${inputFieldDef.name} is deprecated. ${deprecationReason}`, {
                    nodes: node
                }));
            }
        },
        EnumValue (node) {
            const enumValueDef = context.getEnumValue();
            const deprecationReason = enumValueDef === null || enumValueDef === void 0 ? void 0 : enumValueDef.deprecationReason;
            if (enumValueDef && deprecationReason != null) {
                const enumTypeDef = (0, $54dWd.getNamedType)(context.getInputType());
                enumTypeDef != null || (0, $l3zHt.invariant)(false);
                context.reportError(new (0, $fHcz3.GraphQLError)(`The enum value "${enumTypeDef.name}.${enumValueDef.name}" is deprecated. ${deprecationReason}`, {
                    nodes: node
                }));
            }
        }
    };
}

});


parcelRegister("k0EIl", function(module, exports) {

var $hu3w4 = parcelRequire("hu3w4");
var $8DJ2k = parcelRequire("8DJ2k");
var $9m7aI = parcelRequire("9m7aI");
parcelRequire("fcdqG");
var $87oLu = parcelRequire("87oLu");
const { INLINE_FRAGMENT: $e91363b8ceada9c9$var$INLINE_FRAGMENT } = (0, $hu3w4.Kind);
const $e91363b8ceada9c9$var$OUTLINEABLE_KINDS = {
    Field: true,
    OperationDefinition: true,
    Document: true,
    SelectionSet: true,
    Name: true,
    FragmentDefinition: true,
    FragmentSpread: true,
    InlineFragment: true,
    ObjectTypeDefinition: true,
    InputObjectTypeDefinition: true,
    InterfaceTypeDefinition: true,
    EnumTypeDefinition: true,
    EnumValueDefinition: true,
    InputValueDefinition: true,
    FieldDefinition: true
};
function $e91363b8ceada9c9$export$f835050eb96854fc(documentText) {
    let ast;
    try {
        ast = (0, $8DJ2k.parse)(documentText);
    } catch (_a) {
        return null;
    }
    const visitorFns = $e91363b8ceada9c9$var$outlineTreeConverter(documentText);
    const outlineTrees = (0, $9m7aI.visit)(ast, {
        leave (node) {
            if (visitorFns !== undefined && node.kind in visitorFns) return visitorFns[node.kind](node);
            return null;
        }
    });
    return {
        outlineTrees: outlineTrees
    };
}
function $e91363b8ceada9c9$var$outlineTreeConverter(docText) {
    const meta = (node)=>{
        return {
            representativeName: node.name,
            startPosition: (0, $87oLu.offsetToPosition)(docText, node.loc.start),
            endPosition: (0, $87oLu.offsetToPosition)(docText, node.loc.end),
            kind: node.kind,
            children: node.selectionSet || node.fields || node.values || node.arguments || []
        };
    };
    return {
        Field (node) {
            const tokenizedText = node.alias ? [
                $e91363b8ceada9c9$var$buildToken("plain", node.alias),
                $e91363b8ceada9c9$var$buildToken("plain", ": ")
            ] : [];
            tokenizedText.push($e91363b8ceada9c9$var$buildToken("plain", node.name));
            return Object.assign({
                tokenizedText: tokenizedText
            }, meta(node));
        },
        OperationDefinition: (node)=>Object.assign({
                tokenizedText: [
                    $e91363b8ceada9c9$var$buildToken("keyword", node.operation),
                    $e91363b8ceada9c9$var$buildToken("whitespace", " "),
                    $e91363b8ceada9c9$var$buildToken("class-name", node.name)
                ]
            }, meta(node)),
        Document: (node)=>node.definitions,
        SelectionSet: (node)=>$e91363b8ceada9c9$var$concatMap(node.selections, (child)=>{
                return child.kind === $e91363b8ceada9c9$var$INLINE_FRAGMENT ? child.selectionSet : child;
            }),
        Name: (node)=>node.value,
        FragmentDefinition: (node)=>Object.assign({
                tokenizedText: [
                    $e91363b8ceada9c9$var$buildToken("keyword", "fragment"),
                    $e91363b8ceada9c9$var$buildToken("whitespace", " "),
                    $e91363b8ceada9c9$var$buildToken("class-name", node.name)
                ]
            }, meta(node)),
        InterfaceTypeDefinition: (node)=>Object.assign({
                tokenizedText: [
                    $e91363b8ceada9c9$var$buildToken("keyword", "interface"),
                    $e91363b8ceada9c9$var$buildToken("whitespace", " "),
                    $e91363b8ceada9c9$var$buildToken("class-name", node.name)
                ]
            }, meta(node)),
        EnumTypeDefinition: (node)=>Object.assign({
                tokenizedText: [
                    $e91363b8ceada9c9$var$buildToken("keyword", "enum"),
                    $e91363b8ceada9c9$var$buildToken("whitespace", " "),
                    $e91363b8ceada9c9$var$buildToken("class-name", node.name)
                ]
            }, meta(node)),
        EnumValueDefinition: (node)=>Object.assign({
                tokenizedText: [
                    $e91363b8ceada9c9$var$buildToken("plain", node.name)
                ]
            }, meta(node)),
        ObjectTypeDefinition: (node)=>Object.assign({
                tokenizedText: [
                    $e91363b8ceada9c9$var$buildToken("keyword", "type"),
                    $e91363b8ceada9c9$var$buildToken("whitespace", " "),
                    $e91363b8ceada9c9$var$buildToken("class-name", node.name)
                ]
            }, meta(node)),
        InputObjectTypeDefinition: (node)=>Object.assign({
                tokenizedText: [
                    $e91363b8ceada9c9$var$buildToken("keyword", "input"),
                    $e91363b8ceada9c9$var$buildToken("whitespace", " "),
                    $e91363b8ceada9c9$var$buildToken("class-name", node.name)
                ]
            }, meta(node)),
        FragmentSpread: (node)=>Object.assign({
                tokenizedText: [
                    $e91363b8ceada9c9$var$buildToken("plain", "..."),
                    $e91363b8ceada9c9$var$buildToken("class-name", node.name)
                ]
            }, meta(node)),
        InputValueDefinition (node) {
            return Object.assign({
                tokenizedText: [
                    $e91363b8ceada9c9$var$buildToken("plain", node.name)
                ]
            }, meta(node));
        },
        FieldDefinition (node) {
            return Object.assign({
                tokenizedText: [
                    $e91363b8ceada9c9$var$buildToken("plain", node.name)
                ]
            }, meta(node));
        },
        InlineFragment: (node)=>node.selectionSet
    };
}
function $e91363b8ceada9c9$var$buildToken(kind, value) {
    return {
        kind: kind,
        value: value
    };
}
function $e91363b8ceada9c9$var$concatMap(arr, fn) {
    const res = [];
    for(let i = 0; i < arr.length; i++){
        const x = fn(arr[i], i);
        if (Array.isArray(x)) res.push(...x);
        else res.push(x);
    }
    return res;
}

});

parcelRegister("kNoXO", function(module, exports) {

var $54dWd = parcelRequire("54dWd");

var $fwdrM = parcelRequire("fwdrM");
function $f23bbf83ec7e34ed$export$1d0ce13cdea27455(schema, queryText, cursor, contextToken, config) {
    const token = contextToken || (0, $fwdrM.getTokenAtPosition)(queryText, cursor);
    if (!schema || !token || !token.state) return "";
    const { kind: kind, step: step } = token.state;
    const typeInfo = (0, $fwdrM.getTypeInfo)(schema, token.state);
    const options = Object.assign(Object.assign({}, config), {
        schema: schema
    });
    if (kind === "Field" && step === 0 && typeInfo.fieldDef || kind === "AliasedField" && step === 2 && typeInfo.fieldDef) {
        const into = [];
        $f23bbf83ec7e34ed$var$renderMdCodeStart(into, options);
        $f23bbf83ec7e34ed$var$renderField(into, typeInfo, options);
        $f23bbf83ec7e34ed$var$renderMdCodeEnd(into, options);
        $f23bbf83ec7e34ed$var$renderDescription(into, options, typeInfo.fieldDef);
        return into.join("").trim();
    }
    if (kind === "Directive" && step === 1 && typeInfo.directiveDef) {
        const into = [];
        $f23bbf83ec7e34ed$var$renderMdCodeStart(into, options);
        $f23bbf83ec7e34ed$var$renderDirective(into, typeInfo, options);
        $f23bbf83ec7e34ed$var$renderMdCodeEnd(into, options);
        $f23bbf83ec7e34ed$var$renderDescription(into, options, typeInfo.directiveDef);
        return into.join("").trim();
    }
    if (kind === "Argument" && step === 0 && typeInfo.argDef) {
        const into = [];
        $f23bbf83ec7e34ed$var$renderMdCodeStart(into, options);
        $f23bbf83ec7e34ed$var$renderArg(into, typeInfo, options);
        $f23bbf83ec7e34ed$var$renderMdCodeEnd(into, options);
        $f23bbf83ec7e34ed$var$renderDescription(into, options, typeInfo.argDef);
        return into.join("").trim();
    }
    if (kind === "EnumValue" && typeInfo.enumValue && "description" in typeInfo.enumValue) {
        const into = [];
        $f23bbf83ec7e34ed$var$renderMdCodeStart(into, options);
        $f23bbf83ec7e34ed$var$renderEnumValue(into, typeInfo, options);
        $f23bbf83ec7e34ed$var$renderMdCodeEnd(into, options);
        $f23bbf83ec7e34ed$var$renderDescription(into, options, typeInfo.enumValue);
        return into.join("").trim();
    }
    if (kind === "NamedType" && typeInfo.type && "description" in typeInfo.type) {
        const into = [];
        $f23bbf83ec7e34ed$var$renderMdCodeStart(into, options);
        $f23bbf83ec7e34ed$var$renderType(into, typeInfo, options, typeInfo.type);
        $f23bbf83ec7e34ed$var$renderMdCodeEnd(into, options);
        $f23bbf83ec7e34ed$var$renderDescription(into, options, typeInfo.type);
        return into.join("").trim();
    }
    return "";
}
function $f23bbf83ec7e34ed$var$renderMdCodeStart(into, options) {
    if (options.useMarkdown) $f23bbf83ec7e34ed$var$text(into, "```graphql\n");
}
function $f23bbf83ec7e34ed$var$renderMdCodeEnd(into, options) {
    if (options.useMarkdown) $f23bbf83ec7e34ed$var$text(into, "\n```");
}
function $f23bbf83ec7e34ed$var$renderField(into, typeInfo, options) {
    $f23bbf83ec7e34ed$var$renderQualifiedField(into, typeInfo, options);
    $f23bbf83ec7e34ed$var$renderTypeAnnotation(into, typeInfo, options, typeInfo.type);
}
function $f23bbf83ec7e34ed$var$renderQualifiedField(into, typeInfo, options) {
    if (!typeInfo.fieldDef) return;
    const fieldName = typeInfo.fieldDef.name;
    if (fieldName.slice(0, 2) !== "__") {
        $f23bbf83ec7e34ed$var$renderType(into, typeInfo, options, typeInfo.parentType);
        $f23bbf83ec7e34ed$var$text(into, ".");
    }
    $f23bbf83ec7e34ed$var$text(into, fieldName);
}
function $f23bbf83ec7e34ed$var$renderDirective(into, typeInfo, _options) {
    if (!typeInfo.directiveDef) return;
    const name = "@" + typeInfo.directiveDef.name;
    $f23bbf83ec7e34ed$var$text(into, name);
}
function $f23bbf83ec7e34ed$var$renderArg(into, typeInfo, options) {
    if (typeInfo.directiveDef) $f23bbf83ec7e34ed$var$renderDirective(into, typeInfo, options);
    else if (typeInfo.fieldDef) $f23bbf83ec7e34ed$var$renderQualifiedField(into, typeInfo, options);
    if (!typeInfo.argDef) return;
    const { name: name } = typeInfo.argDef;
    $f23bbf83ec7e34ed$var$text(into, "(");
    $f23bbf83ec7e34ed$var$text(into, name);
    $f23bbf83ec7e34ed$var$renderTypeAnnotation(into, typeInfo, options, typeInfo.inputType);
    $f23bbf83ec7e34ed$var$text(into, ")");
}
function $f23bbf83ec7e34ed$var$renderTypeAnnotation(into, typeInfo, options, t) {
    $f23bbf83ec7e34ed$var$text(into, ": ");
    $f23bbf83ec7e34ed$var$renderType(into, typeInfo, options, t);
}
function $f23bbf83ec7e34ed$var$renderEnumValue(into, typeInfo, options) {
    if (!typeInfo.enumValue) return;
    const { name: name } = typeInfo.enumValue;
    $f23bbf83ec7e34ed$var$renderType(into, typeInfo, options, typeInfo.inputType);
    $f23bbf83ec7e34ed$var$text(into, ".");
    $f23bbf83ec7e34ed$var$text(into, name);
}
function $f23bbf83ec7e34ed$var$renderType(into, typeInfo, options, t) {
    if (!t) return;
    if (t instanceof (0, $54dWd.GraphQLNonNull)) {
        $f23bbf83ec7e34ed$var$renderType(into, typeInfo, options, t.ofType);
        $f23bbf83ec7e34ed$var$text(into, "!");
    } else if (t instanceof (0, $54dWd.GraphQLList)) {
        $f23bbf83ec7e34ed$var$text(into, "[");
        $f23bbf83ec7e34ed$var$renderType(into, typeInfo, options, t.ofType);
        $f23bbf83ec7e34ed$var$text(into, "]");
    } else $f23bbf83ec7e34ed$var$text(into, t.name);
}
function $f23bbf83ec7e34ed$var$renderDescription(into, options, def) {
    if (!def) return;
    const description = typeof def.description === "string" ? def.description : null;
    if (description) {
        $f23bbf83ec7e34ed$var$text(into, "\n\n");
        $f23bbf83ec7e34ed$var$text(into, description);
    }
    $f23bbf83ec7e34ed$var$renderDeprecation(into, options, def);
}
function $f23bbf83ec7e34ed$var$renderDeprecation(into, _options, def) {
    if (!def) return;
    const reason = def.deprecationReason || null;
    if (!reason) return;
    $f23bbf83ec7e34ed$var$text(into, "\n\n");
    $f23bbf83ec7e34ed$var$text(into, "Deprecated: ");
    $f23bbf83ec7e34ed$var$text(into, reason);
}
function $f23bbf83ec7e34ed$var$text(into, content) {
    into.push(content);
}

});



parcelRegister("02uF4", function(module, exports) {
/*!
 * set-value <https://github.com/jonschlinkert/set-value>
 *
 * Copyright (c) Jon Schlinkert (https://github.com/jonschlinkert).
 * Released under the MIT License.
 */ "use strict";
const { deleteProperty: $0077f8bdcd039d42$var$deleteProperty } = Reflect;

var $8kRdd = parcelRequire("8kRdd");

var $lE4SR = parcelRequire("lE4SR");
const $0077f8bdcd039d42$var$isObject = (value)=>{
    return typeof value === "object" && value !== null || typeof value === "function";
};
const $0077f8bdcd039d42$var$isUnsafeKey = (key)=>{
    return key === "__proto__" || key === "constructor" || key === "prototype";
};
const $0077f8bdcd039d42$var$validateKey = (key)=>{
    if (!$8kRdd(key)) throw new TypeError("Object keys must be strings or symbols");
    if ($0077f8bdcd039d42$var$isUnsafeKey(key)) throw new Error(`Cannot set unsafe key: "${key}"`);
};
const $0077f8bdcd039d42$var$toStringKey = (input)=>{
    return Array.isArray(input) ? input.flat().map(String).join(",") : input;
};
const $0077f8bdcd039d42$var$createMemoKey = (input, options)=>{
    if (typeof input !== "string" || !options) return input;
    let key = input + ";";
    if (options.arrays !== undefined) key += `arrays=${options.arrays};`;
    if (options.separator !== undefined) key += `separator=${options.separator};`;
    if (options.split !== undefined) key += `split=${options.split};`;
    if (options.merge !== undefined) key += `merge=${options.merge};`;
    if (options.preservePaths !== undefined) key += `preservePaths=${options.preservePaths};`;
    return key;
};
const $0077f8bdcd039d42$var$memoize = (input, options, fn)=>{
    const key = $0077f8bdcd039d42$var$toStringKey(options ? $0077f8bdcd039d42$var$createMemoKey(input, options) : input);
    $0077f8bdcd039d42$var$validateKey(key);
    const value = $0077f8bdcd039d42$var$setValue.cache.get(key) || fn();
    $0077f8bdcd039d42$var$setValue.cache.set(key, value);
    return value;
};
const $0077f8bdcd039d42$var$splitString = (input, options = {})=>{
    const sep = options.separator || ".";
    const preserve = sep === "/" ? false : options.preservePaths;
    if (typeof input === "string" && preserve !== false && /\//.test(input)) return [
        input
    ];
    const parts = [];
    let part = "";
    const push = (part)=>{
        let number;
        if (part.trim() !== "" && Number.isInteger(number = Number(part))) parts.push(number);
        else parts.push(part);
    };
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        if (value === "\\") {
            part += input[++i];
            continue;
        }
        if (value === sep) {
            push(part);
            part = "";
            continue;
        }
        part += value;
    }
    if (part) push(part);
    return parts;
};
const $0077f8bdcd039d42$var$split = (input, options)=>{
    if (options && typeof options.split === "function") return options.split(input);
    if (typeof input === "symbol") return [
        input
    ];
    if (Array.isArray(input)) return input;
    return $0077f8bdcd039d42$var$memoize(input, options, ()=>$0077f8bdcd039d42$var$splitString(input, options));
};
const $0077f8bdcd039d42$var$assignProp = (obj, prop, value, options)=>{
    $0077f8bdcd039d42$var$validateKey(prop);
    // Delete property when "value" is undefined
    if (value === undefined) $0077f8bdcd039d42$var$deleteProperty(obj, prop);
    else if (options && options.merge) {
        const merge = options.merge === "function" ? options.merge : Object.assign;
        // Only merge plain objects
        if (merge && $lE4SR(obj[prop]) && $lE4SR(value)) obj[prop] = merge(obj[prop], value);
        else obj[prop] = value;
    } else obj[prop] = value;
    return obj;
};
const $0077f8bdcd039d42$var$setValue = (target, path, value, options)=>{
    if (!path || !$0077f8bdcd039d42$var$isObject(target)) return target;
    const keys = $0077f8bdcd039d42$var$split(path, options);
    let obj = target;
    for(let i = 0; i < keys.length; i++){
        const key = keys[i];
        const next = keys[i + 1];
        $0077f8bdcd039d42$var$validateKey(key);
        if (next === undefined) {
            $0077f8bdcd039d42$var$assignProp(obj, key, value, options);
            break;
        }
        if (typeof next === "number" && !Array.isArray(obj[key])) {
            obj = obj[key] = [];
            continue;
        }
        if (!$0077f8bdcd039d42$var$isObject(obj[key])) obj[key] = {};
        obj = obj[key];
    }
    return target;
};
$0077f8bdcd039d42$var$setValue.split = $0077f8bdcd039d42$var$split;
$0077f8bdcd039d42$var$setValue.cache = new Map();
$0077f8bdcd039d42$var$setValue.clear = ()=>{
    $0077f8bdcd039d42$var$setValue.cache = new Map();
};
module.exports = $0077f8bdcd039d42$var$setValue;

});
parcelRegister("8kRdd", function(module, exports) {
/*!
 * is-primitive <https://github.com/jonschlinkert/is-primitive>
 *
 * Copyright (c) 2014-present, Jon Schlinkert.
 * Released under the MIT License.
 */ "use strict";
module.exports = function isPrimitive(val) {
    if (typeof val === "object") return val === null;
    return typeof val !== "function";
};

});

parcelRegister("lE4SR", function(module, exports) {
/*!
 * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */ "use strict";

var $diHHR = parcelRequire("diHHR");
function $fc211f3d944510b3$var$isObjectObject(o) {
    return $diHHR(o) === true && Object.prototype.toString.call(o) === "[object Object]";
}
module.exports = function isPlainObject(o) {
    var ctor, prot;
    if ($fc211f3d944510b3$var$isObjectObject(o) === false) return false;
    // If has modified constructor
    ctor = o.constructor;
    if (typeof ctor !== "function") return false;
    // If has modified prototype
    prot = ctor.prototype;
    if ($fc211f3d944510b3$var$isObjectObject(prot) === false) return false;
    // If constructor does not have an Object-specific method
    if (prot.hasOwnProperty("isPrototypeOf") === false) return false;
    // Most likely a plain Object
    return true;
};

});
parcelRegister("diHHR", function(module, exports) {
/*!
 * isobject <https://github.com/jonschlinkert/isobject>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */ "use strict";
module.exports = function isObject(val) {
    return val != null && typeof val === "object" && Array.isArray(val) === false;
};

});



parcelRegister("jIrAL", function(module, exports) {
"use strict";

var $dBgTd = parcelRequire("dBgTd");
var $e5a78797c4262d1f$var$clipboardToIE11Formatting = {
    "text/plain": "Text",
    "text/html": "Url",
    "default": "Text"
};
var $e5a78797c4262d1f$var$defaultMessage = "Copy to clipboard: #{key}, Enter";
function $e5a78797c4262d1f$var$format(message) {
    var copyKey = (/mac os x/i.test(navigator.userAgent) ? "\u2318" : "Ctrl") + "+C";
    return message.replace(/#{\s*key\s*}/g, copyKey);
}
function $e5a78797c4262d1f$var$copy(text, options) {
    var debug, message, reselectPrevious, range, selection, mark, success = false;
    if (!options) options = {};
    debug = options.debug || false;
    try {
        reselectPrevious = $dBgTd();
        range = document.createRange();
        selection = document.getSelection();
        mark = document.createElement("span");
        mark.textContent = text;
        // avoid screen readers from reading out loud the text
        mark.ariaHidden = "true";
        // reset user styles for span element
        mark.style.all = "unset";
        // prevents scrolling to the end of the page
        mark.style.position = "fixed";
        mark.style.top = 0;
        mark.style.clip = "rect(0, 0, 0, 0)";
        // used to preserve spaces and line breaks
        mark.style.whiteSpace = "pre";
        // do not inherit user-select (it may be `none`)
        mark.style.webkitUserSelect = "text";
        mark.style.MozUserSelect = "text";
        mark.style.msUserSelect = "text";
        mark.style.userSelect = "text";
        mark.addEventListener("copy", function(e) {
            e.stopPropagation();
            if (options.format) {
                e.preventDefault();
                if (typeof e.clipboardData === "undefined") {
                    debug && console.warn("unable to use e.clipboardData");
                    debug && console.warn("trying IE specific stuff");
                    window.clipboardData.clearData();
                    var format = $e5a78797c4262d1f$var$clipboardToIE11Formatting[options.format] || $e5a78797c4262d1f$var$clipboardToIE11Formatting["default"];
                    window.clipboardData.setData(format, text);
                } else {
                    e.clipboardData.clearData();
                    e.clipboardData.setData(options.format, text);
                }
            }
            if (options.onCopy) {
                e.preventDefault();
                options.onCopy(e.clipboardData);
            }
        });
        document.body.appendChild(mark);
        range.selectNodeContents(mark);
        selection.addRange(range);
        var successful = document.execCommand("copy");
        if (!successful) throw new Error("copy command was unsuccessful");
        success = true;
    } catch (err) {
        debug && console.error("unable to copy using execCommand: ", err);
        debug && console.warn("trying IE specific stuff");
        try {
            window.clipboardData.setData(options.format || "text", text);
            options.onCopy && options.onCopy(window.clipboardData);
            success = true;
        } catch (err) {
            debug && console.error("unable to copy using clipboardData: ", err);
            debug && console.error("falling back to prompt");
            message = $e5a78797c4262d1f$var$format("message" in options ? options.message : $e5a78797c4262d1f$var$defaultMessage);
            window.prompt(message, text);
        }
    } finally{
        if (selection) {
            if (typeof selection.removeRange == "function") selection.removeRange(range);
            else selection.removeAllRanges();
        }
        if (mark) document.body.removeChild(mark);
        reselectPrevious();
    }
    return success;
}
module.exports = $e5a78797c4262d1f$var$copy;

});
parcelRegister("dBgTd", function(module, exports) {
module.exports = function() {
    var selection = document.getSelection();
    if (!selection.rangeCount) return function() {};
    var active = document.activeElement;
    var ranges = [];
    for(var i = 0; i < selection.rangeCount; i++)ranges.push(selection.getRangeAt(i));
    switch(active.tagName.toUpperCase()){
        case "INPUT":
        case "TEXTAREA":
            active.blur();
            break;
        default:
            active = null;
            break;
    }
    selection.removeAllRanges();
    return function() {
        selection.type === "Caret" && selection.removeAllRanges();
        if (!selection.rangeCount) ranges.forEach(function(range) {
            selection.addRange(range);
        });
        active && active.focus();
    };
};

});


parcelRegister("dBsUf", function(module, exports) {

$parcel$export(module.exports, "Root", () => $eeaeb48e23f662e7$export$be92b6f5f03c0fe9);
$parcel$export(module.exports, "Trigger", () => $eeaeb48e23f662e7$export$41fb9f06171c75f4);
$parcel$export(module.exports, "Portal", () => $eeaeb48e23f662e7$export$602eac185826482c);
$parcel$export(module.exports, "Overlay", () => $eeaeb48e23f662e7$export$c6fdb837b070b4ff);
$parcel$export(module.exports, "Content", () => $eeaeb48e23f662e7$export$7c6e2c02157bb7d2);
$parcel$export(module.exports, "Title", () => $eeaeb48e23f662e7$export$f99233281efd08a0);
$parcel$export(module.exports, "Description", () => $eeaeb48e23f662e7$export$393edc798c47379d);
$parcel$export(module.exports, "Close", () => $eeaeb48e23f662e7$export$f39c2d165cd861fe);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $2IwC4 = parcelRequire("2IwC4");

var $htT6J = parcelRequire("htT6J");

var $jnK0n = parcelRequire("jnK0n");

var $g2NP0 = parcelRequire("g2NP0");

var $88UcQ = parcelRequire("88UcQ");

var $4yZYB = parcelRequire("4yZYB");

var $kNgwr = parcelRequire("kNgwr");

var $5nYva = parcelRequire("5nYva");

var $cTFdF = parcelRequire("cTFdF");

var $kFbxc = parcelRequire("kFbxc");

var $fg1c6 = parcelRequire("fg1c6");

var $hPyeV = parcelRequire("hPyeV");

var $6okVC = parcelRequire("6okVC");

var $9UeUh = parcelRequire("9UeUh");
/* -------------------------------------------------------------------------------------------------
 * Dialog
 * -----------------------------------------------------------------------------------------------*/ const $eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$DIALOG_NAME = "Dialog";
const [$eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$createDialogContext, $eeaeb48e23f662e7$export$cc702773b8ea3e41] = (0, $jnK0n.createContextScope)($eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$DIALOG_NAME);
const [$eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$DialogProvider, $eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$useDialogContext] = $eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$createDialogContext($eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$DIALOG_NAME);
const $eeaeb48e23f662e7$export$3ddf2d174ce01153 = (props)=>{
    const { __scopeDialog: __scopeDialog, children: children, open: openProp, defaultOpen: defaultOpen, onOpenChange: onOpenChange, modal: modal = true } = props;
    const triggerRef = (0, $acw62.useRef)(null);
    const contentRef = (0, $acw62.useRef)(null);
    const [open = false, setOpen] = (0, $88UcQ.useControllableState)({
        prop: openProp,
        defaultProp: defaultOpen,
        onChange: onOpenChange
    });
    return /*#__PURE__*/ (0, $acw62.createElement)($eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$DialogProvider, {
        scope: __scopeDialog,
        triggerRef: triggerRef,
        contentRef: contentRef,
        contentId: (0, $g2NP0.useId)(),
        titleId: (0, $g2NP0.useId)(),
        descriptionId: (0, $g2NP0.useId)(),
        open: open,
        onOpenChange: setOpen,
        onOpenToggle: (0, $acw62.useCallback)(()=>setOpen((prevOpen)=>!prevOpen), [
            setOpen
        ]),
        modal: modal
    }, children);
};
/*#__PURE__*/ Object.assign($eeaeb48e23f662e7$export$3ddf2d174ce01153, {
    displayName: $eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$DIALOG_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DialogTrigger
 * -----------------------------------------------------------------------------------------------*/ const $eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$TRIGGER_NAME = "DialogTrigger";
const $eeaeb48e23f662e7$export$2e1e1122cf0cba88 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, ...triggerProps } = props;
    const context = $eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$useDialogContext($eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$TRIGGER_NAME, __scopeDialog);
    const composedTriggerRef = (0, $htT6J.useComposedRefs)(forwardedRef, context.triggerRef);
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $kFbxc.Primitive).button, (0, $8nd05.default)({
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": context.open,
        "aria-controls": context.contentId,
        "data-state": $eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$getState(context.open)
    }, triggerProps, {
        ref: composedTriggerRef,
        onClick: (0, $2IwC4.composeEventHandlers)(props.onClick, context.onOpenToggle)
    }));
});
/*#__PURE__*/ Object.assign($eeaeb48e23f662e7$export$2e1e1122cf0cba88, {
    displayName: $eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$TRIGGER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DialogPortal
 * -----------------------------------------------------------------------------------------------*/ const $eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$PORTAL_NAME = "DialogPortal";
const [$eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$PortalProvider, $eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$usePortalContext] = $eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$createDialogContext($eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$PORTAL_NAME, {
    forceMount: undefined
});
const $eeaeb48e23f662e7$export$dad7c95542bacce0 = (props)=>{
    const { __scopeDialog: __scopeDialog, forceMount: forceMount, children: children, container: container } = props;
    const context = $eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$useDialogContext($eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$PORTAL_NAME, __scopeDialog);
    return /*#__PURE__*/ (0, $acw62.createElement)($eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$PortalProvider, {
        scope: __scopeDialog,
        forceMount: forceMount
    }, (0, $acw62.Children).map(children, (child)=>/*#__PURE__*/ (0, $acw62.createElement)((0, $cTFdF.Presence), {
            present: forceMount || context.open
        }, /*#__PURE__*/ (0, $acw62.createElement)((0, $5nYva.Portal), {
            asChild: true,
            container: container
        }, child))));
};
/*#__PURE__*/ Object.assign($eeaeb48e23f662e7$export$dad7c95542bacce0, {
    displayName: $eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$PORTAL_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DialogOverlay
 * -----------------------------------------------------------------------------------------------*/ const $eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$OVERLAY_NAME = "DialogOverlay";
const $eeaeb48e23f662e7$export$bd1d06c79be19e17 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const portalContext = $eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$usePortalContext($eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$OVERLAY_NAME, props.__scopeDialog);
    const { forceMount: forceMount = portalContext.forceMount, ...overlayProps } = props;
    const context = $eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$useDialogContext($eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$OVERLAY_NAME, props.__scopeDialog);
    return context.modal ? /*#__PURE__*/ (0, $acw62.createElement)((0, $cTFdF.Presence), {
        present: forceMount || context.open
    }, /*#__PURE__*/ (0, $acw62.createElement)($eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$DialogOverlayImpl, (0, $8nd05.default)({}, overlayProps, {
        ref: forwardedRef
    }))) : null;
});
/*#__PURE__*/ Object.assign($eeaeb48e23f662e7$export$bd1d06c79be19e17, {
    displayName: $eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$OVERLAY_NAME
});
const $eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$DialogOverlayImpl = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, ...overlayProps } = props;
    const context = $eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$useDialogContext($eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$OVERLAY_NAME, __scopeDialog);
    return(/*#__PURE__*/ // ie. when `Overlay` and `Content` are siblings
    (0, $acw62.createElement)((0, $hPyeV.default), {
        as: (0, $9UeUh.Slot),
        allowPinchZoom: true,
        shards: [
            context.contentRef
        ]
    }, /*#__PURE__*/ (0, $acw62.createElement)((0, $kFbxc.Primitive).div, (0, $8nd05.default)({
        "data-state": $eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$getState(context.open)
    }, overlayProps, {
        ref: forwardedRef // We re-enable pointer-events prevented by `Dialog.Content` to allow scrolling the overlay.
        ,
        style: {
            pointerEvents: "auto",
            ...overlayProps.style
        }
    }))));
});
/* -------------------------------------------------------------------------------------------------
 * DialogContent
 * -----------------------------------------------------------------------------------------------*/ const $eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$CONTENT_NAME = "DialogContent";
const $eeaeb48e23f662e7$export$b6d9565de1e068cf = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const portalContext = $eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$usePortalContext($eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$CONTENT_NAME, props.__scopeDialog);
    const { forceMount: forceMount = portalContext.forceMount, ...contentProps } = props;
    const context = $eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$useDialogContext($eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$CONTENT_NAME, props.__scopeDialog);
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $cTFdF.Presence), {
        present: forceMount || context.open
    }, context.modal ? /*#__PURE__*/ (0, $acw62.createElement)($eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$DialogContentModal, (0, $8nd05.default)({}, contentProps, {
        ref: forwardedRef
    })) : /*#__PURE__*/ (0, $acw62.createElement)($eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$DialogContentNonModal, (0, $8nd05.default)({}, contentProps, {
        ref: forwardedRef
    })));
});
/*#__PURE__*/ Object.assign($eeaeb48e23f662e7$export$b6d9565de1e068cf, {
    displayName: $eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$CONTENT_NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$DialogContentModal = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const context = $eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$useDialogContext($eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$CONTENT_NAME, props.__scopeDialog);
    const contentRef = (0, $acw62.useRef)(null);
    const composedRefs = (0, $htT6J.useComposedRefs)(forwardedRef, context.contentRef, contentRef); // aria-hide everything except the content (better supported equivalent to setting aria-modal)
    (0, $acw62.useEffect)(()=>{
        const content = contentRef.current;
        if (content) return (0, $6okVC.hideOthers)(content);
    }, []);
    return /*#__PURE__*/ (0, $acw62.createElement)($eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$DialogContentImpl, (0, $8nd05.default)({}, props, {
        ref: composedRefs // we make sure focus isn't trapped once `DialogContent` has been closed
        ,
        trapFocus: context.open,
        disableOutsidePointerEvents: true,
        onCloseAutoFocus: (0, $2IwC4.composeEventHandlers)(props.onCloseAutoFocus, (event)=>{
            var _context$triggerRef$c;
            event.preventDefault();
            (_context$triggerRef$c = context.triggerRef.current) === null || _context$triggerRef$c === void 0 || _context$triggerRef$c.focus();
        }),
        onPointerDownOutside: (0, $2IwC4.composeEventHandlers)(props.onPointerDownOutside, (event)=>{
            const originalEvent = event.detail.originalEvent;
            const ctrlLeftClick = originalEvent.button === 0 && originalEvent.ctrlKey === true;
            const isRightClick = originalEvent.button === 2 || ctrlLeftClick; // If the event is a right-click, we shouldn't close because
            // it is effectively as if we right-clicked the `Overlay`.
            if (isRightClick) event.preventDefault();
        }) // When focus is trapped, a `focusout` event may still happen.
        ,
        onFocusOutside: (0, $2IwC4.composeEventHandlers)(props.onFocusOutside, (event)=>event.preventDefault())
    }));
});
/* -----------------------------------------------------------------------------------------------*/ const $eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$DialogContentNonModal = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const context = $eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$useDialogContext($eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$CONTENT_NAME, props.__scopeDialog);
    const hasInteractedOutsideRef = (0, $acw62.useRef)(false);
    const hasPointerDownOutsideRef = (0, $acw62.useRef)(false);
    return /*#__PURE__*/ (0, $acw62.createElement)($eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$DialogContentImpl, (0, $8nd05.default)({}, props, {
        ref: forwardedRef,
        trapFocus: false,
        disableOutsidePointerEvents: false,
        onCloseAutoFocus: (event)=>{
            var _props$onCloseAutoFoc;
            (_props$onCloseAutoFoc = props.onCloseAutoFocus) === null || _props$onCloseAutoFoc === void 0 || _props$onCloseAutoFoc.call(props, event);
            if (!event.defaultPrevented) {
                var _context$triggerRef$c2;
                if (!hasInteractedOutsideRef.current) (_context$triggerRef$c2 = context.triggerRef.current) === null || _context$triggerRef$c2 === void 0 || _context$triggerRef$c2.focus(); // Always prevent auto focus because we either focus manually or want user agent focus
                event.preventDefault();
            }
            hasInteractedOutsideRef.current = false;
            hasPointerDownOutsideRef.current = false;
        },
        onInteractOutside: (event)=>{
            var _props$onInteractOuts, _context$triggerRef$c3;
            (_props$onInteractOuts = props.onInteractOutside) === null || _props$onInteractOuts === void 0 || _props$onInteractOuts.call(props, event);
            if (!event.defaultPrevented) {
                hasInteractedOutsideRef.current = true;
                if (event.detail.originalEvent.type === "pointerdown") hasPointerDownOutsideRef.current = true;
            } // Prevent dismissing when clicking the trigger.
            // As the trigger is already setup to close, without doing so would
            // cause it to close and immediately open.
            const target = event.target;
            const targetIsTrigger = (_context$triggerRef$c3 = context.triggerRef.current) === null || _context$triggerRef$c3 === void 0 ? void 0 : _context$triggerRef$c3.contains(target);
            if (targetIsTrigger) event.preventDefault(); // On Safari if the trigger is inside a container with tabIndex={0}, when clicked
            // we will get the pointer down outside event on the trigger, but then a subsequent
            // focus outside event on the container, we ignore any focus outside event when we've
            // already had a pointer down outside event.
            if (event.detail.originalEvent.type === "focusin" && hasPointerDownOutsideRef.current) event.preventDefault();
        }
    }));
});
/* -----------------------------------------------------------------------------------------------*/ const $eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$DialogContentImpl = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, trapFocus: trapFocus, onOpenAutoFocus: onOpenAutoFocus, onCloseAutoFocus: onCloseAutoFocus, ...contentProps } = props;
    const context = $eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$useDialogContext($eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$CONTENT_NAME, __scopeDialog);
    const contentRef = (0, $acw62.useRef)(null);
    const composedRefs = (0, $htT6J.useComposedRefs)(forwardedRef, contentRef); // Make sure the whole tree has focus guards as our `Dialog` will be
    // the last element in the DOM (beacuse of the `Portal`)
    (0, $fg1c6.useFocusGuards)();
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $acw62.Fragment), null, /*#__PURE__*/ (0, $acw62.createElement)((0, $kNgwr.FocusScope), {
        asChild: true,
        loop: true,
        trapped: trapFocus,
        onMountAutoFocus: onOpenAutoFocus,
        onUnmountAutoFocus: onCloseAutoFocus
    }, /*#__PURE__*/ (0, $acw62.createElement)((0, $4yZYB.DismissableLayer), (0, $8nd05.default)({
        role: "dialog",
        id: context.contentId,
        "aria-describedby": context.descriptionId,
        "aria-labelledby": context.titleId,
        "data-state": $eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$getState(context.open)
    }, contentProps, {
        ref: composedRefs,
        onDismiss: ()=>context.onOpenChange(false)
    }))), false);
});
/* -------------------------------------------------------------------------------------------------
 * DialogTitle
 * -----------------------------------------------------------------------------------------------*/ const $eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$TITLE_NAME = "DialogTitle";
const $eeaeb48e23f662e7$export$16f7638e4a34b909 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, ...titleProps } = props;
    const context = $eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$useDialogContext($eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$TITLE_NAME, __scopeDialog);
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $kFbxc.Primitive).h2, (0, $8nd05.default)({
        id: context.titleId
    }, titleProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($eeaeb48e23f662e7$export$16f7638e4a34b909, {
    displayName: $eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$TITLE_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DialogDescription
 * -----------------------------------------------------------------------------------------------*/ const $eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$DESCRIPTION_NAME = "DialogDescription";
const $eeaeb48e23f662e7$export$94e94c2ec2c954d5 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, ...descriptionProps } = props;
    const context = $eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$useDialogContext($eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$DESCRIPTION_NAME, __scopeDialog);
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $kFbxc.Primitive).p, (0, $8nd05.default)({
        id: context.descriptionId
    }, descriptionProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($eeaeb48e23f662e7$export$94e94c2ec2c954d5, {
    displayName: $eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$DESCRIPTION_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DialogClose
 * -----------------------------------------------------------------------------------------------*/ const $eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$CLOSE_NAME = "DialogClose";
const $eeaeb48e23f662e7$export$fba2fb7cd781b7ac = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, ...closeProps } = props;
    const context = $eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$useDialogContext($eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$CLOSE_NAME, __scopeDialog);
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $kFbxc.Primitive).button, (0, $8nd05.default)({
        type: "button"
    }, closeProps, {
        ref: forwardedRef,
        onClick: (0, $2IwC4.composeEventHandlers)(props.onClick, ()=>context.onOpenChange(false))
    }));
});
/*#__PURE__*/ Object.assign($eeaeb48e23f662e7$export$fba2fb7cd781b7ac, {
    displayName: $eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$CLOSE_NAME
});
/* -----------------------------------------------------------------------------------------------*/ function $eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$getState(open) {
    return open ? "open" : "closed";
}
const $eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$TITLE_WARNING_NAME = "DialogTitleWarning";
const [$eeaeb48e23f662e7$export$69b62a49393917d6, $eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$useWarningContext] = (0, $jnK0n.createContext)($eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$TITLE_WARNING_NAME, {
    contentName: $eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$CONTENT_NAME,
    titleName: $eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$TITLE_NAME,
    docsSlug: "dialog"
});
const $eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$TitleWarning = ({ titleId: titleId })=>{
    const titleWarningContext = $eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$useWarningContext($eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$TITLE_WARNING_NAME);
    const MESSAGE = `\`${titleWarningContext.contentName}\` requires a \`${titleWarningContext.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${titleWarningContext.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${titleWarningContext.docsSlug}`;
    (0, $acw62.useEffect)(()=>{
        if (titleId) {
            const hasTitle = document.getElementById(titleId);
            if (!hasTitle) throw new Error(MESSAGE);
        }
    }, [
        MESSAGE,
        titleId
    ]);
    return null;
};
const $eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$DESCRIPTION_WARNING_NAME = "DialogDescriptionWarning";
const $eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$DescriptionWarning = ({ contentRef: contentRef, descriptionId: descriptionId })=>{
    const descriptionWarningContext = $eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$useWarningContext($eeaeb48e23f662e7$var$$5d3850c4d0b4e6c7$var$DESCRIPTION_WARNING_NAME);
    const MESSAGE = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${descriptionWarningContext.contentName}}.`;
    (0, $acw62.useEffect)(()=>{
        var _contentRef$current;
        const describedById = (_contentRef$current = contentRef.current) === null || _contentRef$current === void 0 ? void 0 : _contentRef$current.getAttribute("aria-describedby"); // if we have an id and the user hasn't set aria-describedby={undefined}
        if (descriptionId && describedById) {
            const hasDescription = document.getElementById(descriptionId);
            if (!hasDescription) console.warn(MESSAGE);
        }
    }, [
        MESSAGE,
        contentRef,
        descriptionId
    ]);
    return null;
};
const $eeaeb48e23f662e7$export$be92b6f5f03c0fe9 = $eeaeb48e23f662e7$export$3ddf2d174ce01153;
const $eeaeb48e23f662e7$export$41fb9f06171c75f4 = $eeaeb48e23f662e7$export$2e1e1122cf0cba88;
const $eeaeb48e23f662e7$export$602eac185826482c = $eeaeb48e23f662e7$export$dad7c95542bacce0;
const $eeaeb48e23f662e7$export$c6fdb837b070b4ff = $eeaeb48e23f662e7$export$bd1d06c79be19e17;
const $eeaeb48e23f662e7$export$7c6e2c02157bb7d2 = $eeaeb48e23f662e7$export$b6d9565de1e068cf;
const $eeaeb48e23f662e7$export$f99233281efd08a0 = $eeaeb48e23f662e7$export$16f7638e4a34b909;
const $eeaeb48e23f662e7$export$393edc798c47379d = $eeaeb48e23f662e7$export$94e94c2ec2c954d5;
const $eeaeb48e23f662e7$export$f39c2d165cd861fe = $eeaeb48e23f662e7$export$fba2fb7cd781b7ac;

});
parcelRegister("8nd05", function(module, exports) {

$parcel$export(module.exports, "default", () => $618a8e53233cd9fa$export$2e2bcd8739ae039);
function $618a8e53233cd9fa$export$2e2bcd8739ae039() {
    $618a8e53233cd9fa$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $618a8e53233cd9fa$export$2e2bcd8739ae039.apply(this, arguments);
}

});

parcelRegister("2IwC4", function(module, exports) {

$parcel$export(module.exports, "composeEventHandlers", () => $b4e9a20689651e16$export$b9ecd428b558ff10);
function $b4e9a20689651e16$export$b9ecd428b558ff10(originalEventHandler, ourEventHandler, { checkForDefaultPrevented: checkForDefaultPrevented = true } = {}) {
    return function handleEvent(event) {
        originalEventHandler === null || originalEventHandler === void 0 || originalEventHandler(event);
        if (checkForDefaultPrevented === false || !event.defaultPrevented) return ourEventHandler === null || ourEventHandler === void 0 ? void 0 : ourEventHandler(event);
    };
}

});

parcelRegister("htT6J", function(module, exports) {

$parcel$export(module.exports, "composeRefs", () => $fb3356a19a5676fa$export$43e446d32b3d21af);
$parcel$export(module.exports, "useComposedRefs", () => $fb3356a19a5676fa$export$c7b2cbe3552a0d05);

var $acw62 = parcelRequire("acw62");
/**
 * Set a given ref to a given value
 * This utility takes care of different types of refs: callback refs and RefObject(s)
 */ function $fb3356a19a5676fa$var$$6ed0406888f73fc4$var$setRef(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref !== null && ref !== undefined) ref.current = value;
}
/**
 * A utility to compose multiple refs together
 * Accepts callback refs and RefObject(s)
 */ function $fb3356a19a5676fa$export$43e446d32b3d21af(...refs) {
    return (node)=>refs.forEach((ref)=>$fb3356a19a5676fa$var$$6ed0406888f73fc4$var$setRef(ref, node));
}
/**
 * A custom hook that composes multiple refs
 * Accepts callback refs and RefObject(s)
 */ function $fb3356a19a5676fa$export$c7b2cbe3552a0d05(...refs) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return (0, $acw62.useCallback)($fb3356a19a5676fa$export$43e446d32b3d21af(...refs), refs);
}

});

parcelRegister("jnK0n", function(module, exports) {

$parcel$export(module.exports, "createContext", () => $45e038b71f97d914$export$fd42f52fd3ae1109);
$parcel$export(module.exports, "createContextScope", () => $45e038b71f97d914$export$50c7b4e9d9f19c1);

var $acw62 = parcelRequire("acw62");
function $45e038b71f97d914$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
    const Context = /*#__PURE__*/ (0, $acw62.createContext)(defaultContext);
    function Provider(props) {
        const { children: children, ...context } = props; // Only re-memoize when prop values change
        // eslint-disable-next-line react-hooks/exhaustive-deps
        const value = (0, $acw62.useMemo)(()=>context, Object.values(context));
        return /*#__PURE__*/ (0, $acw62.createElement)(Context.Provider, {
            value: value
        }, children);
    }
    function useContext(consumerName) {
        const context = (0, $acw62.useContext)(Context);
        if (context) return context;
        if (defaultContext !== undefined) return defaultContext; // if a defaultContext wasn't specified, it's a required context.
        throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
    }
    Provider.displayName = rootComponentName + "Provider";
    return [
        Provider,
        useContext
    ];
}
/* -------------------------------------------------------------------------------------------------
 * createContextScope
 * -----------------------------------------------------------------------------------------------*/ function $45e038b71f97d914$export$50c7b4e9d9f19c1(scopeName, createContextScopeDeps = []) {
    let defaultContexts = [];
    /* -----------------------------------------------------------------------------------------------
   * createContext
   * ---------------------------------------------------------------------------------------------*/ function $c512c27ab02ef895$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
        const BaseContext = /*#__PURE__*/ (0, $acw62.createContext)(defaultContext);
        const index = defaultContexts.length;
        defaultContexts = [
            ...defaultContexts,
            defaultContext
        ];
        function Provider(props) {
            const { scope: scope, children: children, ...context } = props;
            const Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index]) || BaseContext; // Only re-memoize when prop values change
            // eslint-disable-next-line react-hooks/exhaustive-deps
            const value = (0, $acw62.useMemo)(()=>context, Object.values(context));
            return /*#__PURE__*/ (0, $acw62.createElement)(Context.Provider, {
                value: value
            }, children);
        }
        function useContext(consumerName, scope) {
            const Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index]) || BaseContext;
            const context = (0, $acw62.useContext)(Context);
            if (context) return context;
            if (defaultContext !== undefined) return defaultContext; // if a defaultContext wasn't specified, it's a required context.
            throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
        }
        Provider.displayName = rootComponentName + "Provider";
        return [
            Provider,
            useContext
        ];
    }
    /* -----------------------------------------------------------------------------------------------
   * createScope
   * ---------------------------------------------------------------------------------------------*/ const createScope = ()=>{
        const scopeContexts = defaultContexts.map((defaultContext)=>{
            return /*#__PURE__*/ (0, $acw62.createContext)(defaultContext);
        });
        return function useScope(scope) {
            const contexts = (scope === null || scope === void 0 ? void 0 : scope[scopeName]) || scopeContexts;
            return (0, $acw62.useMemo)(()=>({
                    [`__scope${scopeName}`]: {
                        ...scope,
                        [scopeName]: contexts
                    }
                }), [
                scope,
                contexts
            ]);
        };
    };
    createScope.scopeName = scopeName;
    return [
        $c512c27ab02ef895$export$fd42f52fd3ae1109,
        $45e038b71f97d914$var$$c512c27ab02ef895$var$composeContextScopes(createScope, ...createContextScopeDeps)
    ];
}
/* -------------------------------------------------------------------------------------------------
 * composeContextScopes
 * -----------------------------------------------------------------------------------------------*/ function $45e038b71f97d914$var$$c512c27ab02ef895$var$composeContextScopes(...scopes) {
    const baseScope = scopes[0];
    if (scopes.length === 1) return baseScope;
    const createScope1 = ()=>{
        const scopeHooks = scopes.map((createScope)=>({
                useScope: createScope(),
                scopeName: createScope.scopeName
            }));
        return function useComposedScopes(overrideScopes) {
            const nextScopes1 = scopeHooks.reduce((nextScopes, { useScope: useScope, scopeName: scopeName })=>{
                // We are calling a hook inside a callback which React warns against to avoid inconsistent
                // renders, however, scoping doesn't have render side effects so we ignore the rule.
                // eslint-disable-next-line react-hooks/rules-of-hooks
                const scopeProps = useScope(overrideScopes);
                const currentScope = scopeProps[`__scope${scopeName}`];
                return {
                    ...nextScopes,
                    ...currentScope
                };
            }, {});
            return (0, $acw62.useMemo)(()=>({
                    [`__scope${baseScope.scopeName}`]: nextScopes1
                }), [
                nextScopes1
            ]);
        };
    };
    createScope1.scopeName = baseScope.scopeName;
    return createScope1;
}

});

parcelRegister("g2NP0", function(module, exports) {

$parcel$export(module.exports, "useId", () => $11885ec535b13ccc$export$f680877a34711e37);

var $acw62 = parcelRequire("acw62");

var $7g00o = parcelRequire("7g00o");
const $11885ec535b13ccc$var$$1746a345f3d73bb7$var$useReactId = $acw62["useId".toString()] || (()=>undefined);
let $11885ec535b13ccc$var$$1746a345f3d73bb7$var$count = 0;
function $11885ec535b13ccc$export$f680877a34711e37(deterministicId) {
    const [id, setId] = $acw62.useState($11885ec535b13ccc$var$$1746a345f3d73bb7$var$useReactId()); // React versions older than 18 will have client-side ids only.
    (0, $7g00o.useLayoutEffect)(()=>{
        if (!deterministicId) setId((reactId)=>reactId !== null && reactId !== void 0 ? reactId : String($11885ec535b13ccc$var$$1746a345f3d73bb7$var$count++));
    }, [
        deterministicId
    ]);
    return deterministicId || (id ? `radix-${id}` : "");
}

});
parcelRegister("7g00o", function(module, exports) {

$parcel$export(module.exports, "useLayoutEffect", () => $b68d88740313b08e$export$e5c5a5f917a5871c);

var $acw62 = parcelRequire("acw62");
/**
 * On the server, React emits a warning when calling `useLayoutEffect`.
 * This is because neither `useLayoutEffect` nor `useEffect` run on the server.
 * We use this safe version which suppresses the warning by replacing it with a noop on the server.
 *
 * See: https://reactjs.org/docs/hooks-reference.html#uselayouteffect
 */ const $b68d88740313b08e$export$e5c5a5f917a5871c = Boolean(globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) ? (0, $acw62.useLayoutEffect) : ()=>{};

});


parcelRegister("88UcQ", function(module, exports) {

$parcel$export(module.exports, "useControllableState", () => $aef12de5508fd46e$export$6f32135080cb4c3);

var $acw62 = parcelRequire("acw62");

var $by19I = parcelRequire("by19I");
function $aef12de5508fd46e$export$6f32135080cb4c3({ prop: prop, defaultProp: defaultProp, onChange: onChange = ()=>{} }) {
    const [uncontrolledProp, setUncontrolledProp] = $aef12de5508fd46e$var$$71cd76cc60e0454e$var$useUncontrolledState({
        defaultProp: defaultProp,
        onChange: onChange
    });
    const isControlled = prop !== undefined;
    const value1 = isControlled ? prop : uncontrolledProp;
    const handleChange = (0, $by19I.useCallbackRef)(onChange);
    const setValue = (0, $acw62.useCallback)((nextValue)=>{
        if (isControlled) {
            const setter = nextValue;
            const value = typeof nextValue === "function" ? setter(prop) : nextValue;
            if (value !== prop) handleChange(value);
        } else setUncontrolledProp(nextValue);
    }, [
        isControlled,
        prop,
        setUncontrolledProp,
        handleChange
    ]);
    return [
        value1,
        setValue
    ];
}
function $aef12de5508fd46e$var$$71cd76cc60e0454e$var$useUncontrolledState({ defaultProp: defaultProp, onChange: onChange }) {
    const uncontrolledState = (0, $acw62.useState)(defaultProp);
    const [value] = uncontrolledState;
    const prevValueRef = (0, $acw62.useRef)(value);
    const handleChange = (0, $by19I.useCallbackRef)(onChange);
    (0, $acw62.useEffect)(()=>{
        if (prevValueRef.current !== value) {
            handleChange(value);
            prevValueRef.current = value;
        }
    }, [
        value,
        prevValueRef,
        handleChange
    ]);
    return uncontrolledState;
}

});
parcelRegister("by19I", function(module, exports) {

$parcel$export(module.exports, "useCallbackRef", () => $95d2d9f03fd0d4db$export$25bec8c6f54ee79a);

var $acw62 = parcelRequire("acw62");
/**
 * A custom hook that converts a callback to a ref to avoid triggering re-renders when passed as a
 * prop or avoid re-executing effects when passed as a dependency
 */ function $95d2d9f03fd0d4db$export$25bec8c6f54ee79a(callback) {
    const callbackRef = (0, $acw62.useRef)(callback);
    (0, $acw62.useEffect)(()=>{
        callbackRef.current = callback;
    }); // https://github.com/facebook/react/issues/19240
    return (0, $acw62.useMemo)(()=>(...args)=>{
            var _callbackRef$current;
            return (_callbackRef$current = callbackRef.current) === null || _callbackRef$current === void 0 ? void 0 : _callbackRef$current.call(callbackRef, ...args);
        }, []);
}

});


parcelRegister("4yZYB", function(module, exports) {

$parcel$export(module.exports, "DismissableLayer", () => $30a399657994b369$export$177fb62ff3ec1f22);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $2IwC4 = parcelRequire("2IwC4");

var $kFbxc = parcelRequire("kFbxc");

var $htT6J = parcelRequire("htT6J");

var $by19I = parcelRequire("by19I");

var $e1oKh = parcelRequire("e1oKh");
/* -------------------------------------------------------------------------------------------------
 * DismissableLayer
 * -----------------------------------------------------------------------------------------------*/ const $30a399657994b369$var$$5cb92bef7577960e$var$DISMISSABLE_LAYER_NAME = "DismissableLayer";
const $30a399657994b369$var$$5cb92bef7577960e$var$CONTEXT_UPDATE = "dismissableLayer.update";
const $30a399657994b369$var$$5cb92bef7577960e$var$POINTER_DOWN_OUTSIDE = "dismissableLayer.pointerDownOutside";
const $30a399657994b369$var$$5cb92bef7577960e$var$FOCUS_OUTSIDE = "dismissableLayer.focusOutside";
let $30a399657994b369$var$$5cb92bef7577960e$var$originalBodyPointerEvents;
const $30a399657994b369$var$$5cb92bef7577960e$var$DismissableLayerContext = /*#__PURE__*/ (0, $acw62.createContext)({
    layers: new Set(),
    layersWithOutsidePointerEventsDisabled: new Set(),
    branches: new Set()
});
const $30a399657994b369$export$177fb62ff3ec1f22 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    var _node$ownerDocument;
    const { disableOutsidePointerEvents: disableOutsidePointerEvents = false, onEscapeKeyDown: onEscapeKeyDown, onPointerDownOutside: onPointerDownOutside, onFocusOutside: onFocusOutside, onInteractOutside: onInteractOutside, onDismiss: onDismiss, ...layerProps } = props;
    const context = (0, $acw62.useContext)($30a399657994b369$var$$5cb92bef7577960e$var$DismissableLayerContext);
    const [node1, setNode] = (0, $acw62.useState)(null);
    const ownerDocument = (_node$ownerDocument = node1 === null || node1 === void 0 ? void 0 : node1.ownerDocument) !== null && _node$ownerDocument !== void 0 ? _node$ownerDocument : globalThis === null || globalThis === void 0 ? void 0 : globalThis.document;
    const [, force] = (0, $acw62.useState)({});
    const composedRefs = (0, $htT6J.useComposedRefs)(forwardedRef, (node)=>setNode(node));
    const layers = Array.from(context.layers);
    const [highestLayerWithOutsidePointerEventsDisabled] = [
        ...context.layersWithOutsidePointerEventsDisabled
    ].slice(-1); // prettier-ignore
    const highestLayerWithOutsidePointerEventsDisabledIndex = layers.indexOf(highestLayerWithOutsidePointerEventsDisabled); // prettier-ignore
    const index = node1 ? layers.indexOf(node1) : -1;
    const isBodyPointerEventsDisabled = context.layersWithOutsidePointerEventsDisabled.size > 0;
    const isPointerEventsEnabled = index >= highestLayerWithOutsidePointerEventsDisabledIndex;
    const pointerDownOutside = $30a399657994b369$var$$5cb92bef7577960e$var$usePointerDownOutside((event)=>{
        const target = event.target;
        const isPointerDownOnBranch = [
            ...context.branches
        ].some((branch)=>branch.contains(target));
        if (!isPointerEventsEnabled || isPointerDownOnBranch) return;
        onPointerDownOutside === null || onPointerDownOutside === void 0 || onPointerDownOutside(event);
        onInteractOutside === null || onInteractOutside === void 0 || onInteractOutside(event);
        if (!event.defaultPrevented) onDismiss === null || onDismiss === void 0 || onDismiss();
    }, ownerDocument);
    const focusOutside = $30a399657994b369$var$$5cb92bef7577960e$var$useFocusOutside((event)=>{
        const target = event.target;
        const isFocusInBranch = [
            ...context.branches
        ].some((branch)=>branch.contains(target));
        if (isFocusInBranch) return;
        onFocusOutside === null || onFocusOutside === void 0 || onFocusOutside(event);
        onInteractOutside === null || onInteractOutside === void 0 || onInteractOutside(event);
        if (!event.defaultPrevented) onDismiss === null || onDismiss === void 0 || onDismiss();
    }, ownerDocument);
    (0, $e1oKh.useEscapeKeydown)((event)=>{
        const isHighestLayer = index === context.layers.size - 1;
        if (!isHighestLayer) return;
        onEscapeKeyDown === null || onEscapeKeyDown === void 0 || onEscapeKeyDown(event);
        if (!event.defaultPrevented && onDismiss) {
            event.preventDefault();
            onDismiss();
        }
    }, ownerDocument);
    (0, $acw62.useEffect)(()=>{
        if (!node1) return;
        if (disableOutsidePointerEvents) {
            if (context.layersWithOutsidePointerEventsDisabled.size === 0) {
                $30a399657994b369$var$$5cb92bef7577960e$var$originalBodyPointerEvents = ownerDocument.body.style.pointerEvents;
                ownerDocument.body.style.pointerEvents = "none";
            }
            context.layersWithOutsidePointerEventsDisabled.add(node1);
        }
        context.layers.add(node1);
        $30a399657994b369$var$$5cb92bef7577960e$var$dispatchUpdate();
        return ()=>{
            if (disableOutsidePointerEvents && context.layersWithOutsidePointerEventsDisabled.size === 1) ownerDocument.body.style.pointerEvents = $30a399657994b369$var$$5cb92bef7577960e$var$originalBodyPointerEvents;
        };
    }, [
        node1,
        ownerDocument,
        disableOutsidePointerEvents,
        context
    ]);
    /**
   * We purposefully prevent combining this effect with the `disableOutsidePointerEvents` effect
   * because a change to `disableOutsidePointerEvents` would remove this layer from the stack
   * and add it to the end again so the layering order wouldn't be _creation order_.
   * We only want them to be removed from context stacks when unmounted.
   */ (0, $acw62.useEffect)(()=>{
        return ()=>{
            if (!node1) return;
            context.layers.delete(node1);
            context.layersWithOutsidePointerEventsDisabled.delete(node1);
            $30a399657994b369$var$$5cb92bef7577960e$var$dispatchUpdate();
        };
    }, [
        node1,
        context
    ]);
    (0, $acw62.useEffect)(()=>{
        const handleUpdate = ()=>force({});
        document.addEventListener($30a399657994b369$var$$5cb92bef7577960e$var$CONTEXT_UPDATE, handleUpdate);
        return ()=>document.removeEventListener($30a399657994b369$var$$5cb92bef7577960e$var$CONTEXT_UPDATE, handleUpdate);
    }, []);
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $kFbxc.Primitive).div, (0, $8nd05.default)({}, layerProps, {
        ref: composedRefs,
        style: {
            pointerEvents: isBodyPointerEventsDisabled ? isPointerEventsEnabled ? "auto" : "none" : undefined,
            ...props.style
        },
        onFocusCapture: (0, $2IwC4.composeEventHandlers)(props.onFocusCapture, focusOutside.onFocusCapture),
        onBlurCapture: (0, $2IwC4.composeEventHandlers)(props.onBlurCapture, focusOutside.onBlurCapture),
        onPointerDownCapture: (0, $2IwC4.composeEventHandlers)(props.onPointerDownCapture, pointerDownOutside.onPointerDownCapture)
    }));
});
/*#__PURE__*/ Object.assign($30a399657994b369$export$177fb62ff3ec1f22, {
    displayName: $30a399657994b369$var$$5cb92bef7577960e$var$DISMISSABLE_LAYER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DismissableLayerBranch
 * -----------------------------------------------------------------------------------------------*/ const $30a399657994b369$var$$5cb92bef7577960e$var$BRANCH_NAME = "DismissableLayerBranch";
const $30a399657994b369$export$4d5eb2109db14228 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const context = (0, $acw62.useContext)($30a399657994b369$var$$5cb92bef7577960e$var$DismissableLayerContext);
    const ref = (0, $acw62.useRef)(null);
    const composedRefs = (0, $htT6J.useComposedRefs)(forwardedRef, ref);
    (0, $acw62.useEffect)(()=>{
        const node = ref.current;
        if (node) {
            context.branches.add(node);
            return ()=>{
                context.branches.delete(node);
            };
        }
    }, [
        context.branches
    ]);
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $kFbxc.Primitive).div, (0, $8nd05.default)({}, props, {
        ref: composedRefs
    }));
});
/*#__PURE__*/ Object.assign($30a399657994b369$export$4d5eb2109db14228, {
    displayName: $30a399657994b369$var$$5cb92bef7577960e$var$BRANCH_NAME
});
/* -----------------------------------------------------------------------------------------------*/ /**
 * Listens for `pointerdown` outside a react subtree. We use `pointerdown` rather than `pointerup`
 * to mimic layer dismissing behaviour present in OS.
 * Returns props to pass to the node we want to check for outside events.
 */ function $30a399657994b369$var$$5cb92bef7577960e$var$usePointerDownOutside(onPointerDownOutside, ownerDocument = globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) {
    const handlePointerDownOutside = (0, $by19I.useCallbackRef)(onPointerDownOutside);
    const isPointerInsideReactTreeRef = (0, $acw62.useRef)(false);
    const handleClickRef = (0, $acw62.useRef)(()=>{});
    (0, $acw62.useEffect)(()=>{
        const handlePointerDown = (event)=>{
            if (event.target && !isPointerInsideReactTreeRef.current) {
                const eventDetail = {
                    originalEvent: event
                };
                function handleAndDispatchPointerDownOutsideEvent() {
                    $30a399657994b369$var$$5cb92bef7577960e$var$handleAndDispatchCustomEvent($30a399657994b369$var$$5cb92bef7577960e$var$POINTER_DOWN_OUTSIDE, handlePointerDownOutside, eventDetail, {
                        discrete: true
                    });
                }
                /**
         * On touch devices, we need to wait for a click event because browsers implement
         * a ~350ms delay between the time the user stops touching the display and when the
         * browser executres events. We need to ensure we don't reactivate pointer-events within
         * this timeframe otherwise the browser may execute events that should have been prevented.
         *
         * Additionally, this also lets us deal automatically with cancellations when a click event
         * isn't raised because the page was considered scrolled/drag-scrolled, long-pressed, etc.
         *
         * This is why we also continuously remove the previous listener, because we cannot be
         * certain that it was raised, and therefore cleaned-up.
         */ if (event.pointerType === "touch") {
                    ownerDocument.removeEventListener("click", handleClickRef.current);
                    handleClickRef.current = handleAndDispatchPointerDownOutsideEvent;
                    ownerDocument.addEventListener("click", handleClickRef.current, {
                        once: true
                    });
                } else handleAndDispatchPointerDownOutsideEvent();
            } else // See: https://github.com/radix-ui/primitives/issues/2171
            ownerDocument.removeEventListener("click", handleClickRef.current);
            isPointerInsideReactTreeRef.current = false;
        };
        /**
     * if this hook executes in a component that mounts via a `pointerdown` event, the event
     * would bubble up to the document and trigger a `pointerDownOutside` event. We avoid
     * this by delaying the event listener registration on the document.
     * This is not React specific, but rather how the DOM works, ie:
     * ```
     * button.addEventListener('pointerdown', () => {
     *   console.log('I will log');
     *   document.addEventListener('pointerdown', () => {
     *     console.log('I will also log');
     *   })
     * });
     */ const timerId = window.setTimeout(()=>{
            ownerDocument.addEventListener("pointerdown", handlePointerDown);
        }, 0);
        return ()=>{
            window.clearTimeout(timerId);
            ownerDocument.removeEventListener("pointerdown", handlePointerDown);
            ownerDocument.removeEventListener("click", handleClickRef.current);
        };
    }, [
        ownerDocument,
        handlePointerDownOutside
    ]);
    return {
        // ensures we check React component tree (not just DOM tree)
        onPointerDownCapture: ()=>isPointerInsideReactTreeRef.current = true
    };
}
/**
 * Listens for when focus happens outside a react subtree.
 * Returns props to pass to the root (node) of the subtree we want to check.
 */ function $30a399657994b369$var$$5cb92bef7577960e$var$useFocusOutside(onFocusOutside, ownerDocument = globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) {
    const handleFocusOutside = (0, $by19I.useCallbackRef)(onFocusOutside);
    const isFocusInsideReactTreeRef = (0, $acw62.useRef)(false);
    (0, $acw62.useEffect)(()=>{
        const handleFocus = (event)=>{
            if (event.target && !isFocusInsideReactTreeRef.current) {
                const eventDetail = {
                    originalEvent: event
                };
                $30a399657994b369$var$$5cb92bef7577960e$var$handleAndDispatchCustomEvent($30a399657994b369$var$$5cb92bef7577960e$var$FOCUS_OUTSIDE, handleFocusOutside, eventDetail, {
                    discrete: false
                });
            }
        };
        ownerDocument.addEventListener("focusin", handleFocus);
        return ()=>ownerDocument.removeEventListener("focusin", handleFocus);
    }, [
        ownerDocument,
        handleFocusOutside
    ]);
    return {
        onFocusCapture: ()=>isFocusInsideReactTreeRef.current = true,
        onBlurCapture: ()=>isFocusInsideReactTreeRef.current = false
    };
}
function $30a399657994b369$var$$5cb92bef7577960e$var$dispatchUpdate() {
    const event = new CustomEvent($30a399657994b369$var$$5cb92bef7577960e$var$CONTEXT_UPDATE);
    document.dispatchEvent(event);
}
function $30a399657994b369$var$$5cb92bef7577960e$var$handleAndDispatchCustomEvent(name, handler, detail, { discrete: discrete }) {
    const target = detail.originalEvent.target;
    const event = new CustomEvent(name, {
        bubbles: false,
        cancelable: true,
        detail: detail
    });
    if (handler) target.addEventListener(name, handler, {
        once: true
    });
    if (discrete) (0, $kFbxc.dispatchDiscreteCustomEvent)(target, event);
    else target.dispatchEvent(event);
}
const $30a399657994b369$export$be92b6f5f03c0fe9 = $30a399657994b369$export$177fb62ff3ec1f22;
const $30a399657994b369$export$aecb2ddcb55c95be = $30a399657994b369$export$4d5eb2109db14228;

});
parcelRegister("kFbxc", function(module, exports) {

$parcel$export(module.exports, "Primitive", () => $dc7d5df3de21cdcb$export$250ffa63cdc0d034);
$parcel$export(module.exports, "dispatchDiscreteCustomEvent", () => $dc7d5df3de21cdcb$export$6d1a0317bde7de7f);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $9UeUh = parcelRequire("9UeUh");
const $dc7d5df3de21cdcb$var$$8927f6f2acc4f386$var$NODES = [
    "a",
    "button",
    "div",
    "form",
    "h2",
    "h3",
    "img",
    "input",
    "label",
    "li",
    "nav",
    "ol",
    "p",
    "span",
    "svg",
    "ul"
]; // Temporary while we await merge of this fix:
// https://github.com/DefinitelyTyped/DefinitelyTyped/pull/55396
// prettier-ignore
/* -------------------------------------------------------------------------------------------------
 * Primitive
 * -----------------------------------------------------------------------------------------------*/ const $dc7d5df3de21cdcb$export$250ffa63cdc0d034 = $dc7d5df3de21cdcb$var$$8927f6f2acc4f386$var$NODES.reduce((primitive, node)=>{
    const Node = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
        const { asChild: asChild, ...primitiveProps } = props;
        const Comp = asChild ? (0, $9UeUh.Slot) : node;
        (0, $acw62.useEffect)(()=>{
            window[Symbol.for("radix-ui")] = true;
        }, []);
        return /*#__PURE__*/ (0, $acw62.createElement)(Comp, (0, $8nd05.default)({}, primitiveProps, {
            ref: forwardedRef
        }));
    });
    Node.displayName = `Primitive.${node}`;
    return {
        ...primitive,
        [node]: Node
    };
}, {});
/* -------------------------------------------------------------------------------------------------
 * Utils
 * -----------------------------------------------------------------------------------------------*/ /**
 * Flush custom event dispatch
 * https://github.com/radix-ui/primitives/pull/1378
 *
 * React batches *all* event handlers since version 18, this introduces certain considerations when using custom event types.
 *
 * Internally, React prioritises events in the following order:
 *  - discrete
 *  - continuous
 *  - default
 *
 * https://github.com/facebook/react/blob/a8a4742f1c54493df00da648a3f9d26e3db9c8b5/packages/react-dom/src/events/ReactDOMEventListener.js#L294-L350
 *
 * `discrete` is an  important distinction as updates within these events are applied immediately.
 * React however, is not able to infer the priority of custom event types due to how they are detected internally.
 * Because of this, it's possible for updates from custom events to be unexpectedly batched when
 * dispatched by another `discrete` event.
 *
 * In order to ensure that updates from custom events are applied predictably, we need to manually flush the batch.
 * This utility should be used when dispatching a custom event from within another `discrete` event, this utility
 * is not nessesary when dispatching known event types, or if dispatching a custom type inside a non-discrete event.
 * For example:
 *
 * dispatching a known click 👎
 * target.dispatchEvent(new Event(‘click’))
 *
 * dispatching a custom type within a non-discrete event 👎
 * onScroll={(event) => event.target.dispatchEvent(new CustomEvent(‘customType’))}
 *
 * dispatching a custom type within a `discrete` event 👍
 * onPointerDown={(event) => dispatchDiscreteCustomEvent(event.target, new CustomEvent(‘customType’))}
 *
 * Note: though React classifies `focus`, `focusin` and `focusout` events as `discrete`, it's  not recommended to use
 * this utility with them. This is because it's possible for those handlers to be called implicitly during render
 * e.g. when focus is within a component as it is unmounted, or when managing focus on mount.
 */ function $dc7d5df3de21cdcb$export$6d1a0317bde7de7f(target, event) {
    if (target) (0, $1u0KT.flushSync)(()=>target.dispatchEvent(event));
}
/* -----------------------------------------------------------------------------------------------*/ const $dc7d5df3de21cdcb$export$be92b6f5f03c0fe9 = $dc7d5df3de21cdcb$export$250ffa63cdc0d034;

});
parcelRegister("1u0KT", function(module, exports) {
"use strict";
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

module.exports = (parcelRequire("Xw6Mv"));

});
parcelRegister("Xw6Mv", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $0b2e6adb871a3b94$export$ae55be85d98224ed, (v) => $0b2e6adb871a3b94$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $0b2e6adb871a3b94$export$d39a5bbd09211389, (v) => $0b2e6adb871a3b94$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $0b2e6adb871a3b94$export$882461b6382ed46c, (v) => $0b2e6adb871a3b94$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $0b2e6adb871a3b94$export$466bfc07425424d5, (v) => $0b2e6adb871a3b94$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4, (v) => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $0b2e6adb871a3b94$export$fa8d919ba61d84db, (v) => $0b2e6adb871a3b94$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $0b2e6adb871a3b94$export$757ceba2d55c277e, (v) => $0b2e6adb871a3b94$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $0b2e6adb871a3b94$export$b3890eb0ae9dca99, (v) => $0b2e6adb871a3b94$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $0b2e6adb871a3b94$export$502457920280e6be, (v) => $0b2e6adb871a3b94$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $0b2e6adb871a3b94$export$c78a37762a8d58e1, (v) => $0b2e6adb871a3b94$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $0b2e6adb871a3b94$export$dc54d992c10e8a18, (v) => $0b2e6adb871a3b94$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $0b2e6adb871a3b94$export$83d89fbfd8236492, (v) => $0b2e6adb871a3b94$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $0b2e6adb871a3b94$export$ae55be85d98224ed;
var $0b2e6adb871a3b94$export$d39a5bbd09211389;
var $0b2e6adb871a3b94$export$882461b6382ed46c;
var $0b2e6adb871a3b94$export$466bfc07425424d5;
var $0b2e6adb871a3b94$export$cd75ccfd720a3cd4;
var $0b2e6adb871a3b94$export$fa8d919ba61d84db;
var $0b2e6adb871a3b94$export$757ceba2d55c277e;
var $0b2e6adb871a3b94$export$b3890eb0ae9dca99;
var $0b2e6adb871a3b94$export$502457920280e6be;
var $0b2e6adb871a3b94$export$c78a37762a8d58e1;
var $0b2e6adb871a3b94$export$dc54d992c10e8a18;
var $0b2e6adb871a3b94$export$83d89fbfd8236492;
"use strict";

var $acw62 = parcelRequire("acw62");

var $fO90s = parcelRequire("fO90s");
function $0b2e6adb871a3b94$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $0b2e6adb871a3b94$var$da = new Set, $0b2e6adb871a3b94$var$ea = {};
function $0b2e6adb871a3b94$var$fa(a, b) {
    $0b2e6adb871a3b94$var$ha(a, b);
    $0b2e6adb871a3b94$var$ha(a + "Capture", b);
}
function $0b2e6adb871a3b94$var$ha(a, b) {
    $0b2e6adb871a3b94$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$da.add(b[a]);
}
var $0b2e6adb871a3b94$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $0b2e6adb871a3b94$var$ja = Object.prototype.hasOwnProperty, $0b2e6adb871a3b94$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $0b2e6adb871a3b94$var$la = {}, $0b2e6adb871a3b94$var$ma = {};
function $0b2e6adb871a3b94$var$oa(a) {
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$ma, a)) return !0;
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$la, a)) return !1;
    if ($0b2e6adb871a3b94$var$ka.test(a)) return $0b2e6adb871a3b94$var$ma[a] = !0;
    $0b2e6adb871a3b94$var$la[a] = !0;
    return !1;
}
function $0b2e6adb871a3b94$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $0b2e6adb871a3b94$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $0b2e6adb871a3b94$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $0b2e6adb871a3b94$var$ra = /[\-:]([a-z])/g;
function $0b2e6adb871a3b94$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$0b2e6adb871a3b94$var$z.xlinkHref = new $0b2e6adb871a3b94$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $0b2e6adb871a3b94$var$ta(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$z.hasOwnProperty(b) ? $0b2e6adb871a3b94$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $0b2e6adb871a3b94$var$qa(b, c, e, d) && (c = null), d || null === e ? $0b2e6adb871a3b94$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $0b2e6adb871a3b94$var$ua = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $0b2e6adb871a3b94$var$va = Symbol.for("react.element"), $0b2e6adb871a3b94$var$wa = Symbol.for("react.portal"), $0b2e6adb871a3b94$var$ya = Symbol.for("react.fragment"), $0b2e6adb871a3b94$var$za = Symbol.for("react.strict_mode"), $0b2e6adb871a3b94$var$Aa = Symbol.for("react.profiler"), $0b2e6adb871a3b94$var$Ba = Symbol.for("react.provider"), $0b2e6adb871a3b94$var$Ca = Symbol.for("react.context"), $0b2e6adb871a3b94$var$Da = Symbol.for("react.forward_ref"), $0b2e6adb871a3b94$var$Ea = Symbol.for("react.suspense"), $0b2e6adb871a3b94$var$Fa = Symbol.for("react.suspense_list"), $0b2e6adb871a3b94$var$Ga = Symbol.for("react.memo"), $0b2e6adb871a3b94$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $0b2e6adb871a3b94$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $0b2e6adb871a3b94$var$Ja = Symbol.iterator;
function $0b2e6adb871a3b94$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $0b2e6adb871a3b94$var$Ja && a[$0b2e6adb871a3b94$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $0b2e6adb871a3b94$var$A = Object.assign, $0b2e6adb871a3b94$var$La;
function $0b2e6adb871a3b94$var$Ma(a) {
    if (void 0 === $0b2e6adb871a3b94$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $0b2e6adb871a3b94$var$La = b && b[1] || "";
    }
    return "\n" + $0b2e6adb871a3b94$var$La + a;
}
var $0b2e6adb871a3b94$var$Na = !1;
function $0b2e6adb871a3b94$var$Oa(a, b) {
    if (!a || $0b2e6adb871a3b94$var$Na) return "";
    $0b2e6adb871a3b94$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $0b2e6adb871a3b94$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $0b2e6adb871a3b94$var$Ma(a) : "";
}
function $0b2e6adb871a3b94$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $0b2e6adb871a3b94$var$Ma(a.type);
        case 16:
            return $0b2e6adb871a3b94$var$Ma("Lazy");
        case 13:
            return $0b2e6adb871a3b94$var$Ma("Suspense");
        case 19:
            return $0b2e6adb871a3b94$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !1), a;
        case 11:
            return a = $0b2e6adb871a3b94$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return "Fragment";
        case $0b2e6adb871a3b94$var$wa:
            return "Portal";
        case $0b2e6adb871a3b94$var$Aa:
            return "Profiler";
        case $0b2e6adb871a3b94$var$za:
            return "StrictMode";
        case $0b2e6adb871a3b94$var$Ea:
            return "Suspense";
        case $0b2e6adb871a3b94$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $0b2e6adb871a3b94$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $0b2e6adb871a3b94$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $0b2e6adb871a3b94$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $0b2e6adb871a3b94$var$Ga:
            return b = a.displayName || null, null !== b ? b : $0b2e6adb871a3b94$var$Qa(a.type) || "Memo";
        case $0b2e6adb871a3b94$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $0b2e6adb871a3b94$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $0b2e6adb871a3b94$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $0b2e6adb871a3b94$var$Qa(b);
        case 8:
            return b === $0b2e6adb871a3b94$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $0b2e6adb871a3b94$var$Ua(a) {
    var b = $0b2e6adb871a3b94$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $0b2e6adb871a3b94$var$Va(a) {
    a._valueTracker || (a._valueTracker = $0b2e6adb871a3b94$var$Ua(a));
}
function $0b2e6adb871a3b94$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $0b2e6adb871a3b94$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $0b2e6adb871a3b94$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $0b2e6adb871a3b94$var$Ya(a, b) {
    var c = b.checked;
    return $0b2e6adb871a3b94$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $0b2e6adb871a3b94$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $0b2e6adb871a3b94$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $0b2e6adb871a3b94$var$ab(a, b) {
    b = b.checked;
    null != b && $0b2e6adb871a3b94$var$ta(a, "checked", b, !1);
}
function $0b2e6adb871a3b94$var$bb(a, b) {
    $0b2e6adb871a3b94$var$ab(a, b);
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $0b2e6adb871a3b94$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $0b2e6adb871a3b94$var$cb(a, b.type, $0b2e6adb871a3b94$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $0b2e6adb871a3b94$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $0b2e6adb871a3b94$var$cb(a, b, c) {
    if ("number" !== b || $0b2e6adb871a3b94$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $0b2e6adb871a3b94$var$eb = Array.isArray;
function $0b2e6adb871a3b94$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $0b2e6adb871a3b94$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $0b2e6adb871a3b94$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($0b2e6adb871a3b94$var$p(91));
    return $0b2e6adb871a3b94$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $0b2e6adb871a3b94$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($0b2e6adb871a3b94$var$p(92));
            if ($0b2e6adb871a3b94$var$eb(c)) {
                if (1 < c.length) throw Error($0b2e6adb871a3b94$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $0b2e6adb871a3b94$var$Sa(c)
    };
}
function $0b2e6adb871a3b94$var$ib(a, b) {
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = $0b2e6adb871a3b94$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $0b2e6adb871a3b94$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $0b2e6adb871a3b94$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $0b2e6adb871a3b94$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $0b2e6adb871a3b94$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $0b2e6adb871a3b94$var$mb, $0b2e6adb871a3b94$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $0b2e6adb871a3b94$var$mb = $0b2e6adb871a3b94$var$mb || document.createElement("div");
        $0b2e6adb871a3b94$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $0b2e6adb871a3b94$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $0b2e6adb871a3b94$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $0b2e6adb871a3b94$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $0b2e6adb871a3b94$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($0b2e6adb871a3b94$var$pb).forEach(function(a) {
    $0b2e6adb871a3b94$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $0b2e6adb871a3b94$var$pb[b] = $0b2e6adb871a3b94$var$pb[a];
    });
});
function $0b2e6adb871a3b94$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $0b2e6adb871a3b94$var$pb.hasOwnProperty(a) && $0b2e6adb871a3b94$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $0b2e6adb871a3b94$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $0b2e6adb871a3b94$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $0b2e6adb871a3b94$var$tb = $0b2e6adb871a3b94$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $0b2e6adb871a3b94$var$ub(a, b) {
    if (b) {
        if ($0b2e6adb871a3b94$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($0b2e6adb871a3b94$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($0b2e6adb871a3b94$var$p(62));
    }
}
function $0b2e6adb871a3b94$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $0b2e6adb871a3b94$var$wb = null;
function $0b2e6adb871a3b94$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $0b2e6adb871a3b94$var$yb = null, $0b2e6adb871a3b94$var$zb = null, $0b2e6adb871a3b94$var$Ab = null;
function $0b2e6adb871a3b94$var$Bb(a) {
    if (a = $0b2e6adb871a3b94$var$Cb(a)) {
        if ("function" !== typeof $0b2e6adb871a3b94$var$yb) throw Error($0b2e6adb871a3b94$var$p(280));
        var b = a.stateNode;
        b && (b = $0b2e6adb871a3b94$var$Db(b), $0b2e6adb871a3b94$var$yb(a.stateNode, a.type, b));
    }
}
function $0b2e6adb871a3b94$var$Eb(a) {
    $0b2e6adb871a3b94$var$zb ? $0b2e6adb871a3b94$var$Ab ? $0b2e6adb871a3b94$var$Ab.push(a) : $0b2e6adb871a3b94$var$Ab = [
        a
    ] : $0b2e6adb871a3b94$var$zb = a;
}
function $0b2e6adb871a3b94$var$Fb() {
    if ($0b2e6adb871a3b94$var$zb) {
        var a = $0b2e6adb871a3b94$var$zb, b = $0b2e6adb871a3b94$var$Ab;
        $0b2e6adb871a3b94$var$Ab = $0b2e6adb871a3b94$var$zb = null;
        $0b2e6adb871a3b94$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$Bb(b[a]);
    }
}
function $0b2e6adb871a3b94$var$Gb(a, b) {
    return a(b);
}
function $0b2e6adb871a3b94$var$Hb() {}
var $0b2e6adb871a3b94$var$Ib = !1;
function $0b2e6adb871a3b94$var$Jb(a, b, c) {
    if ($0b2e6adb871a3b94$var$Ib) return a(b, c);
    $0b2e6adb871a3b94$var$Ib = !0;
    try {
        return $0b2e6adb871a3b94$var$Gb(a, b, c);
    } finally{
        if ($0b2e6adb871a3b94$var$Ib = !1, null !== $0b2e6adb871a3b94$var$zb || null !== $0b2e6adb871a3b94$var$Ab) $0b2e6adb871a3b94$var$Hb(), $0b2e6adb871a3b94$var$Fb();
    }
}
function $0b2e6adb871a3b94$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $0b2e6adb871a3b94$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($0b2e6adb871a3b94$var$p(231, b, typeof c));
    return c;
}
var $0b2e6adb871a3b94$var$Lb = !1;
if ($0b2e6adb871a3b94$var$ia) try {
    var $0b2e6adb871a3b94$var$Mb = {};
    Object.defineProperty($0b2e6adb871a3b94$var$Mb, "passive", {
        get: function() {
            $0b2e6adb871a3b94$var$Lb = !0;
        }
    });
    window.addEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
    window.removeEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
} catch (a) {
    $0b2e6adb871a3b94$var$Lb = !1;
}
function $0b2e6adb871a3b94$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $0b2e6adb871a3b94$var$Ob = !1, $0b2e6adb871a3b94$var$Pb = null, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, $0b2e6adb871a3b94$var$Sb = {
    onError: function(a) {
        $0b2e6adb871a3b94$var$Ob = !0;
        $0b2e6adb871a3b94$var$Pb = a;
    }
};
function $0b2e6adb871a3b94$var$Tb(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Ob = !1;
    $0b2e6adb871a3b94$var$Pb = null;
    $0b2e6adb871a3b94$var$Nb.apply($0b2e6adb871a3b94$var$Sb, arguments);
}
function $0b2e6adb871a3b94$var$Ub(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Tb.apply(this, arguments);
    if ($0b2e6adb871a3b94$var$Ob) {
        if ($0b2e6adb871a3b94$var$Ob) {
            var l = $0b2e6adb871a3b94$var$Pb;
            $0b2e6adb871a3b94$var$Ob = !1;
            $0b2e6adb871a3b94$var$Pb = null;
        } else throw Error($0b2e6adb871a3b94$var$p(198));
        $0b2e6adb871a3b94$var$Qb || ($0b2e6adb871a3b94$var$Qb = !0, $0b2e6adb871a3b94$var$Rb = l);
    }
}
function $0b2e6adb871a3b94$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $0b2e6adb871a3b94$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Xb(a) {
    if ($0b2e6adb871a3b94$var$Vb(a) !== a) throw Error($0b2e6adb871a3b94$var$p(188));
}
function $0b2e6adb871a3b94$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $0b2e6adb871a3b94$var$Vb(a);
        if (null === b) throw Error($0b2e6adb871a3b94$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $0b2e6adb871a3b94$var$Xb(e), a;
                if (f === d) return $0b2e6adb871a3b94$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($0b2e6adb871a3b94$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($0b2e6adb871a3b94$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($0b2e6adb871a3b94$var$p(190));
    }
    if (3 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $0b2e6adb871a3b94$var$Zb(a) {
    a = $0b2e6adb871a3b94$var$Yb(a);
    return null !== a ? $0b2e6adb871a3b94$var$$b(a) : null;
}
function $0b2e6adb871a3b94$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $0b2e6adb871a3b94$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$ac = $fO90s.unstable_scheduleCallback, $0b2e6adb871a3b94$var$bc = $fO90s.unstable_cancelCallback, $0b2e6adb871a3b94$var$cc = $fO90s.unstable_shouldYield, $0b2e6adb871a3b94$var$dc = $fO90s.unstable_requestPaint, $0b2e6adb871a3b94$var$B = $fO90s.unstable_now, $0b2e6adb871a3b94$var$ec = $fO90s.unstable_getCurrentPriorityLevel, $0b2e6adb871a3b94$var$fc = $fO90s.unstable_ImmediatePriority, $0b2e6adb871a3b94$var$gc = $fO90s.unstable_UserBlockingPriority, $0b2e6adb871a3b94$var$hc = $fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$ic = $fO90s.unstable_LowPriority, $0b2e6adb871a3b94$var$jc = $fO90s.unstable_IdlePriority, $0b2e6adb871a3b94$var$kc = null, $0b2e6adb871a3b94$var$lc = null;
function $0b2e6adb871a3b94$var$mc(a) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberRoot) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberRoot($0b2e6adb871a3b94$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $0b2e6adb871a3b94$var$oc = Math.clz32 ? Math.clz32 : $0b2e6adb871a3b94$var$nc, $0b2e6adb871a3b94$var$pc = Math.log, $0b2e6adb871a3b94$var$qc = Math.LN2;
function $0b2e6adb871a3b94$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($0b2e6adb871a3b94$var$pc(a) / $0b2e6adb871a3b94$var$qc | 0) | 0;
}
var $0b2e6adb871a3b94$var$rc = 64, $0b2e6adb871a3b94$var$sc = 4194304;
function $0b2e6adb871a3b94$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $0b2e6adb871a3b94$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $0b2e6adb871a3b94$var$tc(h) : (f &= g, 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $0b2e6adb871a3b94$var$tc(g) : 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $0b2e6adb871a3b94$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $0b2e6adb871a3b94$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $0b2e6adb871a3b94$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $0b2e6adb871a3b94$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $0b2e6adb871a3b94$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $0b2e6adb871a3b94$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $0b2e6adb871a3b94$var$yc() {
    var a = $0b2e6adb871a3b94$var$rc;
    $0b2e6adb871a3b94$var$rc <<= 1;
    0 === ($0b2e6adb871a3b94$var$rc & 4194240) && ($0b2e6adb871a3b94$var$rc = 64);
    return a;
}
function $0b2e6adb871a3b94$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $0b2e6adb871a3b94$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $0b2e6adb871a3b94$var$oc(b);
    a[b] = c;
}
function $0b2e6adb871a3b94$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $0b2e6adb871a3b94$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $0b2e6adb871a3b94$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $0b2e6adb871a3b94$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $0b2e6adb871a3b94$var$C = 0;
function $0b2e6adb871a3b94$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $0b2e6adb871a3b94$var$Ec, $0b2e6adb871a3b94$var$Fc, $0b2e6adb871a3b94$var$Gc, $0b2e6adb871a3b94$var$Hc, $0b2e6adb871a3b94$var$Ic, $0b2e6adb871a3b94$var$Jc = !1, $0b2e6adb871a3b94$var$Kc = [], $0b2e6adb871a3b94$var$Lc = null, $0b2e6adb871a3b94$var$Mc = null, $0b2e6adb871a3b94$var$Nc = null, $0b2e6adb871a3b94$var$Oc = new Map, $0b2e6adb871a3b94$var$Pc = new Map, $0b2e6adb871a3b94$var$Qc = [], $0b2e6adb871a3b94$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $0b2e6adb871a3b94$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $0b2e6adb871a3b94$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $0b2e6adb871a3b94$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $0b2e6adb871a3b94$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $0b2e6adb871a3b94$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $0b2e6adb871a3b94$var$Pc.delete(b.pointerId);
    }
}
function $0b2e6adb871a3b94$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $0b2e6adb871a3b94$var$Cb(b), null !== b && $0b2e6adb871a3b94$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $0b2e6adb871a3b94$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $0b2e6adb871a3b94$var$Lc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $0b2e6adb871a3b94$var$Mc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $0b2e6adb871a3b94$var$Nc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $0b2e6adb871a3b94$var$Oc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $0b2e6adb871a3b94$var$Pc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Vc(a) {
    var b = $0b2e6adb871a3b94$var$Wc(a.target);
    if (null !== b) {
        var c = $0b2e6adb871a3b94$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $0b2e6adb871a3b94$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $0b2e6adb871a3b94$var$Ic(a.priority, function() {
                        $0b2e6adb871a3b94$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $0b2e6adb871a3b94$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $0b2e6adb871a3b94$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $0b2e6adb871a3b94$var$wb = d;
            c.target.dispatchEvent(d);
            $0b2e6adb871a3b94$var$wb = null;
        } else return b = $0b2e6adb871a3b94$var$Cb(c), null !== b && $0b2e6adb871a3b94$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Zc(a, b, c) {
    $0b2e6adb871a3b94$var$Xc(a) && c.delete(b);
}
function $0b2e6adb871a3b94$var$$c() {
    $0b2e6adb871a3b94$var$Jc = !1;
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Lc) && ($0b2e6adb871a3b94$var$Lc = null);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Mc) && ($0b2e6adb871a3b94$var$Mc = null);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Nc) && ($0b2e6adb871a3b94$var$Nc = null);
    $0b2e6adb871a3b94$var$Oc.forEach($0b2e6adb871a3b94$var$Zc);
    $0b2e6adb871a3b94$var$Pc.forEach($0b2e6adb871a3b94$var$Zc);
}
function $0b2e6adb871a3b94$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $0b2e6adb871a3b94$var$Jc || ($0b2e6adb871a3b94$var$Jc = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$$c)));
}
function $0b2e6adb871a3b94$var$bd(a) {
    function b(b) {
        return $0b2e6adb871a3b94$var$ad(b, a);
    }
    if (0 < $0b2e6adb871a3b94$var$Kc.length) {
        $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Kc[0], a);
        for(var c = 1; c < $0b2e6adb871a3b94$var$Kc.length; c++){
            var d = $0b2e6adb871a3b94$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Lc, a);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Mc, a);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Nc, a);
    $0b2e6adb871a3b94$var$Oc.forEach(b);
    $0b2e6adb871a3b94$var$Pc.forEach(b);
    for(c = 0; c < $0b2e6adb871a3b94$var$Qc.length; c++)d = $0b2e6adb871a3b94$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $0b2e6adb871a3b94$var$Qc.length && (c = $0b2e6adb871a3b94$var$Qc[0], null === c.blockedOn);)$0b2e6adb871a3b94$var$Vc(c), null === c.blockedOn && $0b2e6adb871a3b94$var$Qc.shift();
}
var $0b2e6adb871a3b94$var$cd = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$dd = !0;
function $0b2e6adb871a3b94$var$ed(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$gd(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 4, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$fd(a, b, c, d) {
    if ($0b2e6adb871a3b94$var$dd) {
        var e = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
        if (null === e) $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c), $0b2e6adb871a3b94$var$Sc(a, d);
        else if ($0b2e6adb871a3b94$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($0b2e6adb871a3b94$var$Sc(a, d), b & 4 && -1 < $0b2e6adb871a3b94$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $0b2e6adb871a3b94$var$Cb(e);
                null !== f && $0b2e6adb871a3b94$var$Ec(f);
                f = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
                null === f && $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $0b2e6adb871a3b94$var$hd(a, b, d, null, c);
    }
}
var $0b2e6adb871a3b94$var$id = null;
function $0b2e6adb871a3b94$var$Yc(a, b, c, d) {
    $0b2e6adb871a3b94$var$id = null;
    a = $0b2e6adb871a3b94$var$xb(d);
    a = $0b2e6adb871a3b94$var$Wc(a);
    if (null !== a) {
        if (b = $0b2e6adb871a3b94$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $0b2e6adb871a3b94$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $0b2e6adb871a3b94$var$id = a;
    return null;
}
function $0b2e6adb871a3b94$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($0b2e6adb871a3b94$var$ec()){
                case $0b2e6adb871a3b94$var$fc:
                    return 1;
                case $0b2e6adb871a3b94$var$gc:
                    return 4;
                case $0b2e6adb871a3b94$var$hc:
                case $0b2e6adb871a3b94$var$ic:
                    return 16;
                case $0b2e6adb871a3b94$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ld = null, $0b2e6adb871a3b94$var$md = null;
function $0b2e6adb871a3b94$var$nd() {
    if ($0b2e6adb871a3b94$var$md) return $0b2e6adb871a3b94$var$md;
    var a, b = $0b2e6adb871a3b94$var$ld, c = b.length, d, e = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $0b2e6adb871a3b94$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $0b2e6adb871a3b94$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $0b2e6adb871a3b94$var$pd() {
    return !0;
}
function $0b2e6adb871a3b94$var$qd() {
    return !1;
}
function $0b2e6adb871a3b94$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $0b2e6adb871a3b94$var$pd : $0b2e6adb871a3b94$var$qd;
        this.isPropagationStopped = $0b2e6adb871a3b94$var$qd;
        return this;
    }
    $0b2e6adb871a3b94$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $0b2e6adb871a3b94$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $0b2e6adb871a3b94$var$pd);
        },
        persist: function() {},
        isPersistent: $0b2e6adb871a3b94$var$pd
    });
    return b;
}
var $0b2e6adb871a3b94$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $0b2e6adb871a3b94$var$td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$sd), $0b2e6adb871a3b94$var$ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    view: 0,
    detail: 0
}), $0b2e6adb871a3b94$var$vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$ud), $0b2e6adb871a3b94$var$wd, $0b2e6adb871a3b94$var$xd, $0b2e6adb871a3b94$var$yd, $0b2e6adb871a3b94$var$Ad = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $0b2e6adb871a3b94$var$yd && ($0b2e6adb871a3b94$var$yd && "mousemove" === a.type ? ($0b2e6adb871a3b94$var$wd = a.screenX - $0b2e6adb871a3b94$var$yd.screenX, $0b2e6adb871a3b94$var$xd = a.screenY - $0b2e6adb871a3b94$var$yd.screenY) : $0b2e6adb871a3b94$var$xd = $0b2e6adb871a3b94$var$wd = 0, $0b2e6adb871a3b94$var$yd = a);
        return $0b2e6adb871a3b94$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $0b2e6adb871a3b94$var$xd;
    }
}), $0b2e6adb871a3b94$var$Bd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ad), $0b2e6adb871a3b94$var$Cd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    dataTransfer: 0
}), $0b2e6adb871a3b94$var$Dd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Cd), $0b2e6adb871a3b94$var$Ed = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    relatedTarget: 0
}), $0b2e6adb871a3b94$var$Fd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ed), $0b2e6adb871a3b94$var$Gd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Hd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Gd), $0b2e6adb871a3b94$var$Id = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $0b2e6adb871a3b94$var$Jd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Id), $0b2e6adb871a3b94$var$Kd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    data: 0
}), $0b2e6adb871a3b94$var$Ld = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Kd), $0b2e6adb871a3b94$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $0b2e6adb871a3b94$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $0b2e6adb871a3b94$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $0b2e6adb871a3b94$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $0b2e6adb871a3b94$var$Od[a]) ? !!b[a] : !1;
}
function $0b2e6adb871a3b94$var$zd() {
    return $0b2e6adb871a3b94$var$Pd;
}
var $0b2e6adb871a3b94$var$Qd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $0b2e6adb871a3b94$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $0b2e6adb871a3b94$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $0b2e6adb871a3b94$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $0b2e6adb871a3b94$var$Rd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Qd), $0b2e6adb871a3b94$var$Sd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $0b2e6adb871a3b94$var$Td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Sd), $0b2e6adb871a3b94$var$Ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd
}), $0b2e6adb871a3b94$var$Vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ud), $0b2e6adb871a3b94$var$Wd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Xd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Wd), $0b2e6adb871a3b94$var$Yd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $0b2e6adb871a3b94$var$Zd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Yd), $0b2e6adb871a3b94$var$$d = [
    9,
    13,
    27,
    32
], $0b2e6adb871a3b94$var$ae = $0b2e6adb871a3b94$var$ia && "CompositionEvent" in window, $0b2e6adb871a3b94$var$be = null;
$0b2e6adb871a3b94$var$ia && "documentMode" in document && ($0b2e6adb871a3b94$var$be = document.documentMode);
var $0b2e6adb871a3b94$var$ce = $0b2e6adb871a3b94$var$ia && "TextEvent" in window && !$0b2e6adb871a3b94$var$be, $0b2e6adb871a3b94$var$de = $0b2e6adb871a3b94$var$ia && (!$0b2e6adb871a3b94$var$ae || $0b2e6adb871a3b94$var$be && 8 < $0b2e6adb871a3b94$var$be && 11 >= $0b2e6adb871a3b94$var$be), $0b2e6adb871a3b94$var$ee = String.fromCharCode(32), $0b2e6adb871a3b94$var$fe = !1;
function $0b2e6adb871a3b94$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $0b2e6adb871a3b94$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $0b2e6adb871a3b94$var$ie = !1;
function $0b2e6adb871a3b94$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $0b2e6adb871a3b94$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $0b2e6adb871a3b94$var$fe = !0;
            return $0b2e6adb871a3b94$var$ee;
        case "textInput":
            return a = b.data, a === $0b2e6adb871a3b94$var$ee && $0b2e6adb871a3b94$var$fe ? null : a;
        default:
            return null;
    }
}
function $0b2e6adb871a3b94$var$ke(a, b) {
    if ($0b2e6adb871a3b94$var$ie) return "compositionend" === a || !$0b2e6adb871a3b94$var$ae && $0b2e6adb871a3b94$var$ge(a, b) ? (a = $0b2e6adb871a3b94$var$nd(), $0b2e6adb871a3b94$var$md = $0b2e6adb871a3b94$var$ld = $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $0b2e6adb871a3b94$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $0b2e6adb871a3b94$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$0b2e6adb871a3b94$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $0b2e6adb871a3b94$var$ne(a, b, c, d) {
    $0b2e6adb871a3b94$var$Eb(d);
    b = $0b2e6adb871a3b94$var$oe(b, "onChange");
    0 < b.length && (c = new $0b2e6adb871a3b94$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $0b2e6adb871a3b94$var$pe = null, $0b2e6adb871a3b94$var$qe = null;
function $0b2e6adb871a3b94$var$re(a) {
    $0b2e6adb871a3b94$var$se(a, 0);
}
function $0b2e6adb871a3b94$var$te(a) {
    var b = $0b2e6adb871a3b94$var$ue(a);
    if ($0b2e6adb871a3b94$var$Wa(b)) return a;
}
function $0b2e6adb871a3b94$var$ve(a, b) {
    if ("change" === a) return b;
}
var $0b2e6adb871a3b94$var$we = !1;
if ($0b2e6adb871a3b94$var$ia) {
    var $0b2e6adb871a3b94$var$xe;
    if ($0b2e6adb871a3b94$var$ia) {
        var $0b2e6adb871a3b94$var$ye = "oninput" in document;
        if (!$0b2e6adb871a3b94$var$ye) {
            var $0b2e6adb871a3b94$var$ze = document.createElement("div");
            $0b2e6adb871a3b94$var$ze.setAttribute("oninput", "return;");
            $0b2e6adb871a3b94$var$ye = "function" === typeof $0b2e6adb871a3b94$var$ze.oninput;
        }
        $0b2e6adb871a3b94$var$xe = $0b2e6adb871a3b94$var$ye;
    } else $0b2e6adb871a3b94$var$xe = !1;
    $0b2e6adb871a3b94$var$we = $0b2e6adb871a3b94$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $0b2e6adb871a3b94$var$Ae() {
    $0b2e6adb871a3b94$var$pe && ($0b2e6adb871a3b94$var$pe.detachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be), $0b2e6adb871a3b94$var$qe = $0b2e6adb871a3b94$var$pe = null);
}
function $0b2e6adb871a3b94$var$Be(a) {
    if ("value" === a.propertyName && $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe)) {
        var b = [];
        $0b2e6adb871a3b94$var$ne(b, $0b2e6adb871a3b94$var$qe, a, $0b2e6adb871a3b94$var$xb(a));
        $0b2e6adb871a3b94$var$Jb($0b2e6adb871a3b94$var$re, b);
    }
}
function $0b2e6adb871a3b94$var$Ce(a, b, c) {
    "focusin" === a ? ($0b2e6adb871a3b94$var$Ae(), $0b2e6adb871a3b94$var$pe = b, $0b2e6adb871a3b94$var$qe = c, $0b2e6adb871a3b94$var$pe.attachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be)) : "focusout" === a && $0b2e6adb871a3b94$var$Ae();
}
function $0b2e6adb871a3b94$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe);
}
function $0b2e6adb871a3b94$var$Ee(a, b) {
    if ("click" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $0b2e6adb871a3b94$var$He = "function" === typeof Object.is ? Object.is : $0b2e6adb871a3b94$var$Ge;
function $0b2e6adb871a3b94$var$Ie(a, b) {
    if ($0b2e6adb871a3b94$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$0b2e6adb871a3b94$var$ja.call(b, e) || !$0b2e6adb871a3b94$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $0b2e6adb871a3b94$var$Ke(a, b) {
    var c = $0b2e6adb871a3b94$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $0b2e6adb871a3b94$var$Je(c);
    }
}
function $0b2e6adb871a3b94$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $0b2e6adb871a3b94$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $0b2e6adb871a3b94$var$Me() {
    for(var a = window, b = $0b2e6adb871a3b94$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $0b2e6adb871a3b94$var$Xa(a.document);
    }
    return b;
}
function $0b2e6adb871a3b94$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $0b2e6adb871a3b94$var$Oe(a) {
    var b = $0b2e6adb871a3b94$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $0b2e6adb871a3b94$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $0b2e6adb871a3b94$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $0b2e6adb871a3b94$var$Ke(c, f);
                var g = $0b2e6adb871a3b94$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $0b2e6adb871a3b94$var$Pe = $0b2e6adb871a3b94$var$ia && "documentMode" in document && 11 >= document.documentMode, $0b2e6adb871a3b94$var$Qe = null, $0b2e6adb871a3b94$var$Re = null, $0b2e6adb871a3b94$var$Se = null, $0b2e6adb871a3b94$var$Te = !1;
function $0b2e6adb871a3b94$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $0b2e6adb871a3b94$var$Te || null == $0b2e6adb871a3b94$var$Qe || $0b2e6adb871a3b94$var$Qe !== $0b2e6adb871a3b94$var$Xa(d) || (d = $0b2e6adb871a3b94$var$Qe, "selectionStart" in d && $0b2e6adb871a3b94$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $0b2e6adb871a3b94$var$Se && $0b2e6adb871a3b94$var$Ie($0b2e6adb871a3b94$var$Se, d) || ($0b2e6adb871a3b94$var$Se = d, d = $0b2e6adb871a3b94$var$oe($0b2e6adb871a3b94$var$Re, "onSelect"), 0 < d.length && (b = new $0b2e6adb871a3b94$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $0b2e6adb871a3b94$var$Qe)));
}
function $0b2e6adb871a3b94$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $0b2e6adb871a3b94$var$We = {
    animationend: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationIteration"),
    animationstart: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationStart"),
    transitionend: $0b2e6adb871a3b94$var$Ve("Transition", "TransitionEnd")
}, $0b2e6adb871a3b94$var$Xe = {}, $0b2e6adb871a3b94$var$Ye = {};
$0b2e6adb871a3b94$var$ia && ($0b2e6adb871a3b94$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $0b2e6adb871a3b94$var$We.animationend.animation, delete $0b2e6adb871a3b94$var$We.animationiteration.animation, delete $0b2e6adb871a3b94$var$We.animationstart.animation), "TransitionEvent" in window || delete $0b2e6adb871a3b94$var$We.transitionend.transition);
function $0b2e6adb871a3b94$var$Ze(a) {
    if ($0b2e6adb871a3b94$var$Xe[a]) return $0b2e6adb871a3b94$var$Xe[a];
    if (!$0b2e6adb871a3b94$var$We[a]) return a;
    var b = $0b2e6adb871a3b94$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $0b2e6adb871a3b94$var$Ye) return $0b2e6adb871a3b94$var$Xe[a] = b[c];
    return a;
}
var $0b2e6adb871a3b94$var$$e = $0b2e6adb871a3b94$var$Ze("animationend"), $0b2e6adb871a3b94$var$af = $0b2e6adb871a3b94$var$Ze("animationiteration"), $0b2e6adb871a3b94$var$bf = $0b2e6adb871a3b94$var$Ze("animationstart"), $0b2e6adb871a3b94$var$cf = $0b2e6adb871a3b94$var$Ze("transitionend"), $0b2e6adb871a3b94$var$df = new Map, $0b2e6adb871a3b94$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $0b2e6adb871a3b94$var$ff(a, b) {
    $0b2e6adb871a3b94$var$df.set(a, b);
    $0b2e6adb871a3b94$var$fa(b, [
        a
    ]);
}
for(var $0b2e6adb871a3b94$var$gf = 0; $0b2e6adb871a3b94$var$gf < $0b2e6adb871a3b94$var$ef.length; $0b2e6adb871a3b94$var$gf++){
    var $0b2e6adb871a3b94$var$hf = $0b2e6adb871a3b94$var$ef[$0b2e6adb871a3b94$var$gf], $0b2e6adb871a3b94$var$jf = $0b2e6adb871a3b94$var$hf.toLowerCase(), $0b2e6adb871a3b94$var$kf = $0b2e6adb871a3b94$var$hf[0].toUpperCase() + $0b2e6adb871a3b94$var$hf.slice(1);
    $0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$jf, "on" + $0b2e6adb871a3b94$var$kf);
}
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$$e, "onAnimationEnd");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$af, "onAnimationIteration");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$bf, "onAnimationStart");
$0b2e6adb871a3b94$var$ff("dblclick", "onDoubleClick");
$0b2e6adb871a3b94$var$ff("focusin", "onFocus");
$0b2e6adb871a3b94$var$ff("focusout", "onBlur");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$cf, "onTransitionEnd");
$0b2e6adb871a3b94$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$0b2e6adb871a3b94$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $0b2e6adb871a3b94$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $0b2e6adb871a3b94$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($0b2e6adb871a3b94$var$lf));
function $0b2e6adb871a3b94$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $0b2e6adb871a3b94$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $0b2e6adb871a3b94$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($0b2e6adb871a3b94$var$Qb) throw a = $0b2e6adb871a3b94$var$Rb, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, a;
}
function $0b2e6adb871a3b94$var$D(a, b) {
    var c = b[$0b2e6adb871a3b94$var$of];
    void 0 === c && (c = b[$0b2e6adb871a3b94$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($0b2e6adb871a3b94$var$pf(b, a, 2, !1), c.add(d));
}
function $0b2e6adb871a3b94$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $0b2e6adb871a3b94$var$pf(c, a, d, b);
}
var $0b2e6adb871a3b94$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $0b2e6adb871a3b94$var$sf(a) {
    if (!a[$0b2e6adb871a3b94$var$rf]) {
        a[$0b2e6adb871a3b94$var$rf] = !0;
        $0b2e6adb871a3b94$var$da.forEach(function(b) {
            "selectionchange" !== b && ($0b2e6adb871a3b94$var$mf.has(b) || $0b2e6adb871a3b94$var$qf(b, !1, a), $0b2e6adb871a3b94$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$0b2e6adb871a3b94$var$rf] || (b[$0b2e6adb871a3b94$var$rf] = !0, $0b2e6adb871a3b94$var$qf("selectionchange", !1, b));
    }
}
function $0b2e6adb871a3b94$var$pf(a, b, c, d) {
    switch($0b2e6adb871a3b94$var$jd(b)){
        case 1:
            var e = $0b2e6adb871a3b94$var$ed;
            break;
        case 4:
            e = $0b2e6adb871a3b94$var$gd;
            break;
        default:
            e = $0b2e6adb871a3b94$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$0b2e6adb871a3b94$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $0b2e6adb871a3b94$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $0b2e6adb871a3b94$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $0b2e6adb871a3b94$var$Jb(function() {
        var d = f, e = $0b2e6adb871a3b94$var$xb(c), g = [];
        a: {
            var h = $0b2e6adb871a3b94$var$df.get(a);
            if (void 0 !== h) {
                var k = $0b2e6adb871a3b94$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $0b2e6adb871a3b94$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $0b2e6adb871a3b94$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $0b2e6adb871a3b94$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $0b2e6adb871a3b94$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $0b2e6adb871a3b94$var$Vd;
                        break;
                    case $0b2e6adb871a3b94$var$$e:
                    case $0b2e6adb871a3b94$var$af:
                    case $0b2e6adb871a3b94$var$bf:
                        k = $0b2e6adb871a3b94$var$Hd;
                        break;
                    case $0b2e6adb871a3b94$var$cf:
                        k = $0b2e6adb871a3b94$var$Xd;
                        break;
                    case "scroll":
                        k = $0b2e6adb871a3b94$var$vd;
                        break;
                    case "wheel":
                        k = $0b2e6adb871a3b94$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $0b2e6adb871a3b94$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $0b2e6adb871a3b94$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $0b2e6adb871a3b94$var$Kb(w, x), null != F && t.push($0b2e6adb871a3b94$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $0b2e6adb871a3b94$var$wb && (n = c.relatedTarget || c.fromElement) && ($0b2e6adb871a3b94$var$Wc(n) || n[$0b2e6adb871a3b94$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $0b2e6adb871a3b94$var$Wc(n) : null, null !== n && (J = $0b2e6adb871a3b94$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $0b2e6adb871a3b94$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $0b2e6adb871a3b94$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $0b2e6adb871a3b94$var$ue(k);
                        u = null == n ? h : $0b2e6adb871a3b94$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $0b2e6adb871a3b94$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $0b2e6adb871a3b94$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $0b2e6adb871a3b94$var$vf(F))u++;
                            for(; 0 < w - u;)t = $0b2e6adb871a3b94$var$vf(t), w--;
                            for(; 0 < u - w;)x = $0b2e6adb871a3b94$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $0b2e6adb871a3b94$var$vf(t);
                                x = $0b2e6adb871a3b94$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $0b2e6adb871a3b94$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $0b2e6adb871a3b94$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $0b2e6adb871a3b94$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $0b2e6adb871a3b94$var$ve;
                else if ($0b2e6adb871a3b94$var$me(h)) {
                    if ($0b2e6adb871a3b94$var$we) na = $0b2e6adb871a3b94$var$Fe;
                    else {
                        na = $0b2e6adb871a3b94$var$De;
                        var xa = $0b2e6adb871a3b94$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $0b2e6adb871a3b94$var$Ee);
                if (na && (na = na(a, d))) {
                    $0b2e6adb871a3b94$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $0b2e6adb871a3b94$var$cb(h, "number", h.value);
            }
            xa = d ? $0b2e6adb871a3b94$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($0b2e6adb871a3b94$var$me(xa) || "true" === xa.contentEditable) $0b2e6adb871a3b94$var$Qe = xa, $0b2e6adb871a3b94$var$Re = d, $0b2e6adb871a3b94$var$Se = null;
                    break;
                case "focusout":
                    $0b2e6adb871a3b94$var$Se = $0b2e6adb871a3b94$var$Re = $0b2e6adb871a3b94$var$Qe = null;
                    break;
                case "mousedown":
                    $0b2e6adb871a3b94$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $0b2e6adb871a3b94$var$Te = !1;
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($0b2e6adb871a3b94$var$Pe) break;
                case "keydown":
                case "keyup":
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
            }
            var $a;
            if ($0b2e6adb871a3b94$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $0b2e6adb871a3b94$var$ie ? $0b2e6adb871a3b94$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($0b2e6adb871a3b94$var$de && "ko" !== c.locale && ($0b2e6adb871a3b94$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $0b2e6adb871a3b94$var$ie && ($a = $0b2e6adb871a3b94$var$nd()) : ($0b2e6adb871a3b94$var$kd = e, $0b2e6adb871a3b94$var$ld = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, $0b2e6adb871a3b94$var$ie = !0)), xa = $0b2e6adb871a3b94$var$oe(d, ba), 0 < xa.length && (ba = new $0b2e6adb871a3b94$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $0b2e6adb871a3b94$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $0b2e6adb871a3b94$var$ce ? $0b2e6adb871a3b94$var$je(a, c) : $0b2e6adb871a3b94$var$ke(a, c)) d = $0b2e6adb871a3b94$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $0b2e6adb871a3b94$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $0b2e6adb871a3b94$var$se(g, b);
    });
}
function $0b2e6adb871a3b94$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $0b2e6adb871a3b94$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $0b2e6adb871a3b94$var$Kb(a, c), null != f && d.unshift($0b2e6adb871a3b94$var$tf(a, f, e)), f = $0b2e6adb871a3b94$var$Kb(a, b), null != f && d.push($0b2e6adb871a3b94$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $0b2e6adb871a3b94$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $0b2e6adb871a3b94$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.unshift($0b2e6adb871a3b94$var$tf(c, k, h))) : e || (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.push($0b2e6adb871a3b94$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $0b2e6adb871a3b94$var$xf = /\r\n?/g, $0b2e6adb871a3b94$var$yf = /\u0000|\uFFFD/g;
function $0b2e6adb871a3b94$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($0b2e6adb871a3b94$var$xf, "\n").replace($0b2e6adb871a3b94$var$yf, "");
}
function $0b2e6adb871a3b94$var$Af(a, b, c) {
    b = $0b2e6adb871a3b94$var$zf(b);
    if ($0b2e6adb871a3b94$var$zf(a) !== b && c) throw Error($0b2e6adb871a3b94$var$p(425));
}
function $0b2e6adb871a3b94$var$Bf() {}
var $0b2e6adb871a3b94$var$Cf = null, $0b2e6adb871a3b94$var$Df = null;
function $0b2e6adb871a3b94$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $0b2e6adb871a3b94$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $0b2e6adb871a3b94$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $0b2e6adb871a3b94$var$Hf = "function" === typeof Promise ? Promise : void 0, $0b2e6adb871a3b94$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $0b2e6adb871a3b94$var$Hf ? function(a) {
    return $0b2e6adb871a3b94$var$Hf.resolve(null).then(a).catch($0b2e6adb871a3b94$var$If);
} : $0b2e6adb871a3b94$var$Ff;
function $0b2e6adb871a3b94$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $0b2e6adb871a3b94$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $0b2e6adb871a3b94$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $0b2e6adb871a3b94$var$bd(b);
}
function $0b2e6adb871a3b94$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Nf = Math.random().toString(36).slice(2), $0b2e6adb871a3b94$var$Of = "__reactFiber$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Pf = "__reactProps$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$uf = "__reactContainer$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$of = "__reactEvents$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Qf = "__reactListeners$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Rf = "__reactHandles$" + $0b2e6adb871a3b94$var$Nf;
function $0b2e6adb871a3b94$var$Wc(a) {
    var b = a[$0b2e6adb871a3b94$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$0b2e6adb871a3b94$var$uf] || c[$0b2e6adb871a3b94$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $0b2e6adb871a3b94$var$Mf(a); null !== a;){
                if (c = a[$0b2e6adb871a3b94$var$Of]) return c;
                a = $0b2e6adb871a3b94$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Cb(a) {
    a = a[$0b2e6adb871a3b94$var$Of] || a[$0b2e6adb871a3b94$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $0b2e6adb871a3b94$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($0b2e6adb871a3b94$var$p(33));
}
function $0b2e6adb871a3b94$var$Db(a) {
    return a[$0b2e6adb871a3b94$var$Pf] || null;
}
var $0b2e6adb871a3b94$var$Sf = [], $0b2e6adb871a3b94$var$Tf = -1;
function $0b2e6adb871a3b94$var$Uf(a) {
    return {
        current: a
    };
}
function $0b2e6adb871a3b94$var$E(a) {
    0 > $0b2e6adb871a3b94$var$Tf || (a.current = $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf], $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = null, $0b2e6adb871a3b94$var$Tf--);
}
function $0b2e6adb871a3b94$var$G(a, b) {
    $0b2e6adb871a3b94$var$Tf++;
    $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = a.current;
    a.current = b;
}
var $0b2e6adb871a3b94$var$Vf = {}, $0b2e6adb871a3b94$var$H = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Vf), $0b2e6adb871a3b94$var$Wf = $0b2e6adb871a3b94$var$Uf(!1), $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$Vf;
function $0b2e6adb871a3b94$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $0b2e6adb871a3b94$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $0b2e6adb871a3b94$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $0b2e6adb871a3b94$var$$f() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
}
function $0b2e6adb871a3b94$var$ag(a, b, c) {
    if ($0b2e6adb871a3b94$var$H.current !== $0b2e6adb871a3b94$var$Vf) throw Error($0b2e6adb871a3b94$var$p(168));
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
function $0b2e6adb871a3b94$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($0b2e6adb871a3b94$var$p(108, $0b2e6adb871a3b94$var$Ra(a) || "Unknown", e));
    return $0b2e6adb871a3b94$var$A({}, c, d);
}
function $0b2e6adb871a3b94$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $0b2e6adb871a3b94$var$Vf;
    $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$H.current;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, $0b2e6adb871a3b94$var$Wf.current);
    return !0;
}
function $0b2e6adb871a3b94$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($0b2e6adb871a3b94$var$p(169));
    c ? (a = $0b2e6adb871a3b94$var$bg(a, b, $0b2e6adb871a3b94$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a)) : $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
var $0b2e6adb871a3b94$var$eg = null, $0b2e6adb871a3b94$var$fg = !1, $0b2e6adb871a3b94$var$gg = !1;
function $0b2e6adb871a3b94$var$hg(a) {
    null === $0b2e6adb871a3b94$var$eg ? $0b2e6adb871a3b94$var$eg = [
        a
    ] : $0b2e6adb871a3b94$var$eg.push(a);
}
function $0b2e6adb871a3b94$var$ig(a) {
    $0b2e6adb871a3b94$var$fg = !0;
    $0b2e6adb871a3b94$var$hg(a);
}
function $0b2e6adb871a3b94$var$jg() {
    if (!$0b2e6adb871a3b94$var$gg && null !== $0b2e6adb871a3b94$var$eg) {
        $0b2e6adb871a3b94$var$gg = !0;
        var a = 0, b = $0b2e6adb871a3b94$var$C;
        try {
            var c = $0b2e6adb871a3b94$var$eg;
            for($0b2e6adb871a3b94$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $0b2e6adb871a3b94$var$eg = null;
            $0b2e6adb871a3b94$var$fg = !1;
        } catch (e) {
            throw null !== $0b2e6adb871a3b94$var$eg && ($0b2e6adb871a3b94$var$eg = $0b2e6adb871a3b94$var$eg.slice(a + 1)), $0b2e6adb871a3b94$var$ac($0b2e6adb871a3b94$var$fc, $0b2e6adb871a3b94$var$jg), e;
        } finally{
            $0b2e6adb871a3b94$var$C = b, $0b2e6adb871a3b94$var$gg = !1;
        }
    }
    return null;
}
var $0b2e6adb871a3b94$var$kg = [], $0b2e6adb871a3b94$var$lg = 0, $0b2e6adb871a3b94$var$mg = null, $0b2e6adb871a3b94$var$ng = 0, $0b2e6adb871a3b94$var$og = [], $0b2e6adb871a3b94$var$pg = 0, $0b2e6adb871a3b94$var$qg = null, $0b2e6adb871a3b94$var$rg = 1, $0b2e6adb871a3b94$var$sg = "";
function $0b2e6adb871a3b94$var$tg(a, b) {
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$ng;
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$mg;
    $0b2e6adb871a3b94$var$mg = a;
    $0b2e6adb871a3b94$var$ng = b;
}
function $0b2e6adb871a3b94$var$ug(a, b, c) {
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg;
    $0b2e6adb871a3b94$var$qg = a;
    var d = $0b2e6adb871a3b94$var$rg;
    a = $0b2e6adb871a3b94$var$sg;
    var e = 32 - $0b2e6adb871a3b94$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $0b2e6adb871a3b94$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $0b2e6adb871a3b94$var$rg = 1 << 32 - $0b2e6adb871a3b94$var$oc(b) + e | c << e | d;
        $0b2e6adb871a3b94$var$sg = f + a;
    } else $0b2e6adb871a3b94$var$rg = 1 << f | c << e | d, $0b2e6adb871a3b94$var$sg = a;
}
function $0b2e6adb871a3b94$var$vg(a) {
    null !== a.return && ($0b2e6adb871a3b94$var$tg(a, 1), $0b2e6adb871a3b94$var$ug(a, 1, 0));
}
function $0b2e6adb871a3b94$var$wg(a) {
    for(; a === $0b2e6adb871a3b94$var$mg;)$0b2e6adb871a3b94$var$mg = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null, $0b2e6adb871a3b94$var$ng = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null;
    for(; a === $0b2e6adb871a3b94$var$qg;)$0b2e6adb871a3b94$var$qg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$sg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$rg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null;
}
var $0b2e6adb871a3b94$var$xg = null, $0b2e6adb871a3b94$var$yg = null, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$zg = null;
function $0b2e6adb871a3b94$var$Ag(a, b) {
    var c = $0b2e6adb871a3b94$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $0b2e6adb871a3b94$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $0b2e6adb871a3b94$var$qg ? {
                id: $0b2e6adb871a3b94$var$rg,
                overflow: $0b2e6adb871a3b94$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $0b2e6adb871a3b94$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $0b2e6adb871a3b94$var$Eg(a) {
    if ($0b2e6adb871a3b94$var$I) {
        var b = $0b2e6adb871a3b94$var$yg;
        if (b) {
            var c = b;
            if (!$0b2e6adb871a3b94$var$Cg(a, b)) {
                if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
                b = $0b2e6adb871a3b94$var$Lf(c.nextSibling);
                var d = $0b2e6adb871a3b94$var$xg;
                b && $0b2e6adb871a3b94$var$Cg(a, b) ? $0b2e6adb871a3b94$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$xg = a);
            }
        } else {
            if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $0b2e6adb871a3b94$var$I = !1;
            $0b2e6adb871a3b94$var$xg = a;
        }
    }
}
function $0b2e6adb871a3b94$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $0b2e6adb871a3b94$var$xg = a;
}
function $0b2e6adb871a3b94$var$Gg(a) {
    if (a !== $0b2e6adb871a3b94$var$xg) return !1;
    if (!$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$Fg(a), $0b2e6adb871a3b94$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$0b2e6adb871a3b94$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $0b2e6adb871a3b94$var$yg)) {
        if ($0b2e6adb871a3b94$var$Dg(a)) throw $0b2e6adb871a3b94$var$Hg(), Error($0b2e6adb871a3b94$var$p(418));
        for(; b;)$0b2e6adb871a3b94$var$Ag(a, b), b = $0b2e6adb871a3b94$var$Lf(b.nextSibling);
    }
    $0b2e6adb871a3b94$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($0b2e6adb871a3b94$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $0b2e6adb871a3b94$var$yg = null;
        }
    } else $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg ? $0b2e6adb871a3b94$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $0b2e6adb871a3b94$var$Hg() {
    for(var a = $0b2e6adb871a3b94$var$yg; a;)a = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
}
function $0b2e6adb871a3b94$var$Ig() {
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg = null;
    $0b2e6adb871a3b94$var$I = !1;
}
function $0b2e6adb871a3b94$var$Jg(a) {
    null === $0b2e6adb871a3b94$var$zg ? $0b2e6adb871a3b94$var$zg = [
        a
    ] : $0b2e6adb871a3b94$var$zg.push(a);
}
var $0b2e6adb871a3b94$var$Kg = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig;
function $0b2e6adb871a3b94$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $0b2e6adb871a3b94$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $0b2e6adb871a3b94$var$Mg = $0b2e6adb871a3b94$var$Uf(null), $0b2e6adb871a3b94$var$Ng = null, $0b2e6adb871a3b94$var$Og = null, $0b2e6adb871a3b94$var$Pg = null;
function $0b2e6adb871a3b94$var$Qg() {
    $0b2e6adb871a3b94$var$Pg = $0b2e6adb871a3b94$var$Og = $0b2e6adb871a3b94$var$Ng = null;
}
function $0b2e6adb871a3b94$var$Rg(a) {
    var b = $0b2e6adb871a3b94$var$Mg.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Mg);
    a._currentValue = b;
}
function $0b2e6adb871a3b94$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $0b2e6adb871a3b94$var$Tg(a, b) {
    $0b2e6adb871a3b94$var$Ng = a;
    $0b2e6adb871a3b94$var$Pg = $0b2e6adb871a3b94$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($0b2e6adb871a3b94$var$Ug = !0), a.firstContext = null);
}
function $0b2e6adb871a3b94$var$Vg(a) {
    var b = a._currentValue;
    if ($0b2e6adb871a3b94$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $0b2e6adb871a3b94$var$Og) {
            if (null === $0b2e6adb871a3b94$var$Ng) throw Error($0b2e6adb871a3b94$var$p(308));
            $0b2e6adb871a3b94$var$Og = a;
            $0b2e6adb871a3b94$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $0b2e6adb871a3b94$var$Og = $0b2e6adb871a3b94$var$Og.next = a;
    }
    return b;
}
var $0b2e6adb871a3b94$var$Wg = null;
function $0b2e6adb871a3b94$var$Xg(a) {
    null === $0b2e6adb871a3b94$var$Wg ? $0b2e6adb871a3b94$var$Wg = [
        a
    ] : $0b2e6adb871a3b94$var$Wg.push(a);
}
function $0b2e6adb871a3b94$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $0b2e6adb871a3b94$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $0b2e6adb871a3b94$var$Zg(a, d);
}
function $0b2e6adb871a3b94$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $0b2e6adb871a3b94$var$$g = !1;
function $0b2e6adb871a3b94$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $0b2e6adb871a3b94$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $0b2e6adb871a3b94$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $0b2e6adb871a3b94$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $0b2e6adb871a3b94$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $0b2e6adb871a3b94$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $0b2e6adb871a3b94$var$Zg(a, c);
}
function $0b2e6adb871a3b94$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
function $0b2e6adb871a3b94$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $0b2e6adb871a3b94$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $0b2e6adb871a3b94$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $0b2e6adb871a3b94$var$A({}, q, r);
                            break a;
                        case 2:
                            $0b2e6adb871a3b94$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $0b2e6adb871a3b94$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $0b2e6adb871a3b94$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($0b2e6adb871a3b94$var$p(191, e));
            e.call(d);
        }
    }
}
var $0b2e6adb871a3b94$var$jh = (new $acw62.Component).refs;
function $0b2e6adb871a3b94$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $0b2e6adb871a3b94$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $0b2e6adb871a3b94$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $0b2e6adb871a3b94$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$L(), e = $0b2e6adb871a3b94$var$lh(a), f = $0b2e6adb871a3b94$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$dh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$mh(b, a, e, d), $0b2e6adb871a3b94$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$L(), e = $0b2e6adb871a3b94$var$lh(a), f = $0b2e6adb871a3b94$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$dh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$mh(b, a, e, d), $0b2e6adb871a3b94$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $0b2e6adb871a3b94$var$L(), d = $0b2e6adb871a3b94$var$lh(a), e = $0b2e6adb871a3b94$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $0b2e6adb871a3b94$var$dh(a, e, d);
        null !== b && ($0b2e6adb871a3b94$var$mh(b, a, d, c), $0b2e6adb871a3b94$var$eh(b, a, d));
    }
};
function $0b2e6adb871a3b94$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$0b2e6adb871a3b94$var$Ie(c, d) || !$0b2e6adb871a3b94$var$Ie(e, f) : !0;
}
function $0b2e6adb871a3b94$var$ph(a, b, c) {
    var d = !1, e = $0b2e6adb871a3b94$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $0b2e6adb871a3b94$var$Vg(f) : (e = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $0b2e6adb871a3b94$var$Yf(a, e) : $0b2e6adb871a3b94$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $0b2e6adb871a3b94$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $0b2e6adb871a3b94$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $0b2e6adb871a3b94$var$nh.enqueueReplaceState(b, b.state, null);
}
function $0b2e6adb871a3b94$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $0b2e6adb871a3b94$var$jh;
    $0b2e6adb871a3b94$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $0b2e6adb871a3b94$var$Vg(f) : (f = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, e.context = $0b2e6adb871a3b94$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($0b2e6adb871a3b94$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $0b2e6adb871a3b94$var$nh.enqueueReplaceState(e, e.state, null), $0b2e6adb871a3b94$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $0b2e6adb871a3b94$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($0b2e6adb871a3b94$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $0b2e6adb871a3b94$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($0b2e6adb871a3b94$var$p(284));
        if (!c._owner) throw Error($0b2e6adb871a3b94$var$p(290, a));
    }
    return a;
}
function $0b2e6adb871a3b94$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($0b2e6adb871a3b94$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $0b2e6adb871a3b94$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $0b2e6adb871a3b94$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $0b2e6adb871a3b94$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $0b2e6adb871a3b94$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $0b2e6adb871a3b94$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $0b2e6adb871a3b94$var$sh(a, b, c), d.return = a, d;
        d = $0b2e6adb871a3b94$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $0b2e6adb871a3b94$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $0b2e6adb871a3b94$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $0b2e6adb871a3b94$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $0b2e6adb871a3b94$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c = $0b2e6adb871a3b94$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $0b2e6adb871a3b94$var$sh(a, null, b), c.return = a, c;
                case $0b2e6adb871a3b94$var$wa:
                    return b = $0b2e6adb871a3b94$var$zh(b, a.mode, c), b.return = a, b;
                case $0b2e6adb871a3b94$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($0b2e6adb871a3b94$var$eb(b) || $0b2e6adb871a3b94$var$Ka(b)) return b = $0b2e6adb871a3b94$var$Ah(b, a.mode, c, null), b.return = a, b;
            $0b2e6adb871a3b94$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($0b2e6adb871a3b94$var$eb(c) || $0b2e6adb871a3b94$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $0b2e6adb871a3b94$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $0b2e6adb871a3b94$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $0b2e6adb871a3b94$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($0b2e6adb871a3b94$var$eb(d) || $0b2e6adb871a3b94$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $0b2e6adb871a3b94$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $0b2e6adb871a3b94$var$Ka(h);
        if ("function" !== typeof l) throw Error($0b2e6adb871a3b94$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($0b2e6adb871a3b94$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $0b2e6adb871a3b94$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $0b2e6adb871a3b94$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $0b2e6adb871a3b94$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $0b2e6adb871a3b94$var$ya ? (d = $0b2e6adb871a3b94$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $0b2e6adb871a3b94$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $0b2e6adb871a3b94$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $0b2e6adb871a3b94$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($0b2e6adb871a3b94$var$eb(f)) return n(a, d, f, h);
            if ($0b2e6adb871a3b94$var$Ka(f)) return t(a, d, f, h);
            $0b2e6adb871a3b94$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $0b2e6adb871a3b94$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $0b2e6adb871a3b94$var$Bh = $0b2e6adb871a3b94$var$vh(!0), $0b2e6adb871a3b94$var$Ch = $0b2e6adb871a3b94$var$vh(!1), $0b2e6adb871a3b94$var$Dh = {}, $0b2e6adb871a3b94$var$Eh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Dh), $0b2e6adb871a3b94$var$Fh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Dh), $0b2e6adb871a3b94$var$Gh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Dh);
function $0b2e6adb871a3b94$var$Hh(a) {
    if (a === $0b2e6adb871a3b94$var$Dh) throw Error($0b2e6adb871a3b94$var$p(174));
    return a;
}
function $0b2e6adb871a3b94$var$Ih(a, b) {
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Gh, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Fh, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Eh, $0b2e6adb871a3b94$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $0b2e6adb871a3b94$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $0b2e6adb871a3b94$var$lb(b, a);
    }
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Eh);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Eh, b);
}
function $0b2e6adb871a3b94$var$Jh() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Eh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Fh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Gh);
}
function $0b2e6adb871a3b94$var$Kh(a) {
    $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Gh.current);
    var b = $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Eh.current);
    var c = $0b2e6adb871a3b94$var$lb(b, a.type);
    b !== c && ($0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Fh, a), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Eh, c));
}
function $0b2e6adb871a3b94$var$Lh(a) {
    $0b2e6adb871a3b94$var$Fh.current === a && ($0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Eh), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Fh));
}
var $0b2e6adb871a3b94$var$M = $0b2e6adb871a3b94$var$Uf(0);
function $0b2e6adb871a3b94$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Nh = [];
function $0b2e6adb871a3b94$var$Oh() {
    for(var a = 0; a < $0b2e6adb871a3b94$var$Nh.length; a++)$0b2e6adb871a3b94$var$Nh[a]._workInProgressVersionPrimary = null;
    $0b2e6adb871a3b94$var$Nh.length = 0;
}
var $0b2e6adb871a3b94$var$Ph = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$Qh = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$Rh = 0, $0b2e6adb871a3b94$var$N = null, $0b2e6adb871a3b94$var$O = null, $0b2e6adb871a3b94$var$P = null, $0b2e6adb871a3b94$var$Sh = !1, $0b2e6adb871a3b94$var$Th = !1, $0b2e6adb871a3b94$var$Uh = 0, $0b2e6adb871a3b94$var$Vh = 0;
function $0b2e6adb871a3b94$var$Q() {
    throw Error($0b2e6adb871a3b94$var$p(321));
}
function $0b2e6adb871a3b94$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$0b2e6adb871a3b94$var$He(a[c], b[c])) return !1;
    return !0;
}
function $0b2e6adb871a3b94$var$Xh(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$Rh = f;
    $0b2e6adb871a3b94$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $0b2e6adb871a3b94$var$Ph.current = null === a || null === a.memoizedState ? $0b2e6adb871a3b94$var$Yh : $0b2e6adb871a3b94$var$Zh;
    a = c(d, e);
    if ($0b2e6adb871a3b94$var$Th) {
        f = 0;
        do {
            $0b2e6adb871a3b94$var$Th = !1;
            $0b2e6adb871a3b94$var$Uh = 0;
            if (25 <= f) throw Error($0b2e6adb871a3b94$var$p(301));
            f += 1;
            $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$O = null;
            b.updateQueue = null;
            $0b2e6adb871a3b94$var$Ph.current = $0b2e6adb871a3b94$var$$h;
            a = c(d, e);
        }while ($0b2e6adb871a3b94$var$Th);
    }
    $0b2e6adb871a3b94$var$Ph.current = $0b2e6adb871a3b94$var$ai;
    b = null !== $0b2e6adb871a3b94$var$O && null !== $0b2e6adb871a3b94$var$O.next;
    $0b2e6adb871a3b94$var$Rh = 0;
    $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = null;
    $0b2e6adb871a3b94$var$Sh = !1;
    if (b) throw Error($0b2e6adb871a3b94$var$p(300));
    return a;
}
function $0b2e6adb871a3b94$var$bi() {
    var a = 0 !== $0b2e6adb871a3b94$var$Uh;
    $0b2e6adb871a3b94$var$Uh = 0;
    return a;
}
function $0b2e6adb871a3b94$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $0b2e6adb871a3b94$var$P ? $0b2e6adb871a3b94$var$N.memoizedState = $0b2e6adb871a3b94$var$P = a : $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$P.next = a;
    return $0b2e6adb871a3b94$var$P;
}
function $0b2e6adb871a3b94$var$di() {
    if (null === $0b2e6adb871a3b94$var$O) {
        var a = $0b2e6adb871a3b94$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $0b2e6adb871a3b94$var$O.next;
    var b = null === $0b2e6adb871a3b94$var$P ? $0b2e6adb871a3b94$var$N.memoizedState : $0b2e6adb871a3b94$var$P.next;
    if (null !== b) $0b2e6adb871a3b94$var$P = b, $0b2e6adb871a3b94$var$O = a;
    else {
        if (null === a) throw Error($0b2e6adb871a3b94$var$p(310));
        $0b2e6adb871a3b94$var$O = a;
        a = {
            memoizedState: $0b2e6adb871a3b94$var$O.memoizedState,
            baseState: $0b2e6adb871a3b94$var$O.baseState,
            baseQueue: $0b2e6adb871a3b94$var$O.baseQueue,
            queue: $0b2e6adb871a3b94$var$O.queue,
            next: null
        };
        null === $0b2e6adb871a3b94$var$P ? $0b2e6adb871a3b94$var$N.memoizedState = $0b2e6adb871a3b94$var$P = a : $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$P.next = a;
    }
    return $0b2e6adb871a3b94$var$P;
}
function $0b2e6adb871a3b94$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $0b2e6adb871a3b94$var$fi(a) {
    var b = $0b2e6adb871a3b94$var$di(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = $0b2e6adb871a3b94$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($0b2e6adb871a3b94$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $0b2e6adb871a3b94$var$N.lanes |= m;
                $0b2e6adb871a3b94$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $0b2e6adb871a3b94$var$He(d, b.memoizedState) || ($0b2e6adb871a3b94$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $0b2e6adb871a3b94$var$N.lanes |= f, $0b2e6adb871a3b94$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $0b2e6adb871a3b94$var$gi(a) {
    var b = $0b2e6adb871a3b94$var$di(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $0b2e6adb871a3b94$var$He(f, b.memoizedState) || ($0b2e6adb871a3b94$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $0b2e6adb871a3b94$var$hi() {}
function $0b2e6adb871a3b94$var$ii(a, b) {
    var c = $0b2e6adb871a3b94$var$N, d = $0b2e6adb871a3b94$var$di(), e = b(), f = !$0b2e6adb871a3b94$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $0b2e6adb871a3b94$var$Ug = !0);
    d = d.queue;
    $0b2e6adb871a3b94$var$ji($0b2e6adb871a3b94$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $0b2e6adb871a3b94$var$P && $0b2e6adb871a3b94$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $0b2e6adb871a3b94$var$li(9, $0b2e6adb871a3b94$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $0b2e6adb871a3b94$var$R) throw Error($0b2e6adb871a3b94$var$p(349));
        0 !== ($0b2e6adb871a3b94$var$Rh & 30) || $0b2e6adb871a3b94$var$ni(c, b, e);
    }
    return e;
}
function $0b2e6adb871a3b94$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $0b2e6adb871a3b94$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $0b2e6adb871a3b94$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $0b2e6adb871a3b94$var$oi(b) && $0b2e6adb871a3b94$var$pi(a);
}
function $0b2e6adb871a3b94$var$ki(a, b, c) {
    return c(function() {
        $0b2e6adb871a3b94$var$oi(b) && $0b2e6adb871a3b94$var$pi(a);
    });
}
function $0b2e6adb871a3b94$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$0b2e6adb871a3b94$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $0b2e6adb871a3b94$var$pi(a) {
    var b = $0b2e6adb871a3b94$var$Zg(a, 1);
    null !== b && $0b2e6adb871a3b94$var$mh(b, a, 1, -1);
}
function $0b2e6adb871a3b94$var$qi(a) {
    var b = $0b2e6adb871a3b94$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $0b2e6adb871a3b94$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $0b2e6adb871a3b94$var$ri.bind(null, $0b2e6adb871a3b94$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $0b2e6adb871a3b94$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $0b2e6adb871a3b94$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $0b2e6adb871a3b94$var$si() {
    return $0b2e6adb871a3b94$var$di().memoizedState;
}
function $0b2e6adb871a3b94$var$ti(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$ci();
    $0b2e6adb871a3b94$var$N.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $0b2e6adb871a3b94$var$ui(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $0b2e6adb871a3b94$var$O) {
        var g = $0b2e6adb871a3b94$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $0b2e6adb871a3b94$var$Wh(d, g.deps)) {
            e.memoizedState = $0b2e6adb871a3b94$var$li(b, c, f, d);
            return;
        }
    }
    $0b2e6adb871a3b94$var$N.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$li(1 | b, c, f, d);
}
function $0b2e6adb871a3b94$var$vi(a, b) {
    return $0b2e6adb871a3b94$var$ti(8390656, 8, a, b);
}
function $0b2e6adb871a3b94$var$ji(a, b) {
    return $0b2e6adb871a3b94$var$ui(2048, 8, a, b);
}
function $0b2e6adb871a3b94$var$wi(a, b) {
    return $0b2e6adb871a3b94$var$ui(4, 2, a, b);
}
function $0b2e6adb871a3b94$var$xi(a, b) {
    return $0b2e6adb871a3b94$var$ui(4, 4, a, b);
}
function $0b2e6adb871a3b94$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $0b2e6adb871a3b94$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $0b2e6adb871a3b94$var$ui(4, 4, $0b2e6adb871a3b94$var$yi.bind(null, b, a), c);
}
function $0b2e6adb871a3b94$var$Ai() {}
function $0b2e6adb871a3b94$var$Bi(a, b) {
    var c = $0b2e6adb871a3b94$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$Ci(a, b) {
    var c = $0b2e6adb871a3b94$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$Di(a, b, c) {
    if (0 === ($0b2e6adb871a3b94$var$Rh & 21)) return a.baseState && (a.baseState = !1, $0b2e6adb871a3b94$var$Ug = !0), a.memoizedState = c;
    $0b2e6adb871a3b94$var$He(c, b) || (c = $0b2e6adb871a3b94$var$yc(), $0b2e6adb871a3b94$var$N.lanes |= c, $0b2e6adb871a3b94$var$hh |= c, a.baseState = !0);
    return b;
}
function $0b2e6adb871a3b94$var$Ei(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    $0b2e6adb871a3b94$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $0b2e6adb871a3b94$var$Qh.transition;
    $0b2e6adb871a3b94$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$Qh.transition = d;
    }
}
function $0b2e6adb871a3b94$var$Fi() {
    return $0b2e6adb871a3b94$var$di().memoizedState;
}
function $0b2e6adb871a3b94$var$Gi(a, b, c) {
    var d = $0b2e6adb871a3b94$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$Hi(a)) $0b2e6adb871a3b94$var$Ii(b, c);
    else if (c = $0b2e6adb871a3b94$var$Yg(a, b, c, d), null !== c) {
        var e = $0b2e6adb871a3b94$var$L();
        $0b2e6adb871a3b94$var$mh(c, a, d, e);
        $0b2e6adb871a3b94$var$Ji(c, b, d);
    }
}
function $0b2e6adb871a3b94$var$ri(a, b, c) {
    var d = $0b2e6adb871a3b94$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$Hi(a)) $0b2e6adb871a3b94$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($0b2e6adb871a3b94$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $0b2e6adb871a3b94$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $0b2e6adb871a3b94$var$Yg(a, b, e, d);
        null !== c && (e = $0b2e6adb871a3b94$var$L(), $0b2e6adb871a3b94$var$mh(c, a, d, e), $0b2e6adb871a3b94$var$Ji(c, b, d));
    }
}
function $0b2e6adb871a3b94$var$Hi(a) {
    var b = a.alternate;
    return a === $0b2e6adb871a3b94$var$N || null !== b && b === $0b2e6adb871a3b94$var$N;
}
function $0b2e6adb871a3b94$var$Ii(a, b) {
    $0b2e6adb871a3b94$var$Th = $0b2e6adb871a3b94$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $0b2e6adb871a3b94$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
var $0b2e6adb871a3b94$var$ai = {
    readContext: $0b2e6adb871a3b94$var$Vg,
    useCallback: $0b2e6adb871a3b94$var$Q,
    useContext: $0b2e6adb871a3b94$var$Q,
    useEffect: $0b2e6adb871a3b94$var$Q,
    useImperativeHandle: $0b2e6adb871a3b94$var$Q,
    useInsertionEffect: $0b2e6adb871a3b94$var$Q,
    useLayoutEffect: $0b2e6adb871a3b94$var$Q,
    useMemo: $0b2e6adb871a3b94$var$Q,
    useReducer: $0b2e6adb871a3b94$var$Q,
    useRef: $0b2e6adb871a3b94$var$Q,
    useState: $0b2e6adb871a3b94$var$Q,
    useDebugValue: $0b2e6adb871a3b94$var$Q,
    useDeferredValue: $0b2e6adb871a3b94$var$Q,
    useTransition: $0b2e6adb871a3b94$var$Q,
    useMutableSource: $0b2e6adb871a3b94$var$Q,
    useSyncExternalStore: $0b2e6adb871a3b94$var$Q,
    useId: $0b2e6adb871a3b94$var$Q,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Yh = {
    readContext: $0b2e6adb871a3b94$var$Vg,
    useCallback: function(a, b) {
        $0b2e6adb871a3b94$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $0b2e6adb871a3b94$var$Vg,
    useEffect: $0b2e6adb871a3b94$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $0b2e6adb871a3b94$var$ti(4194308, 4, $0b2e6adb871a3b94$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $0b2e6adb871a3b94$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $0b2e6adb871a3b94$var$Gi.bind(null, $0b2e6adb871a3b94$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $0b2e6adb871a3b94$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $0b2e6adb871a3b94$var$qi,
    useDebugValue: $0b2e6adb871a3b94$var$Ai,
    useDeferredValue: function(a) {
        return $0b2e6adb871a3b94$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$qi(!1), b = a[0];
        a = $0b2e6adb871a3b94$var$Ei.bind(null, a[1]);
        $0b2e6adb871a3b94$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$N, e = $0b2e6adb871a3b94$var$ci();
        if ($0b2e6adb871a3b94$var$I) {
            if (void 0 === c) throw Error($0b2e6adb871a3b94$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $0b2e6adb871a3b94$var$R) throw Error($0b2e6adb871a3b94$var$p(349));
            0 !== ($0b2e6adb871a3b94$var$Rh & 30) || $0b2e6adb871a3b94$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $0b2e6adb871a3b94$var$vi($0b2e6adb871a3b94$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $0b2e6adb871a3b94$var$li(9, $0b2e6adb871a3b94$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $0b2e6adb871a3b94$var$ci(), b = $0b2e6adb871a3b94$var$R.identifierPrefix;
        if ($0b2e6adb871a3b94$var$I) {
            var c = $0b2e6adb871a3b94$var$sg;
            var d = $0b2e6adb871a3b94$var$rg;
            c = (d & ~(1 << 32 - $0b2e6adb871a3b94$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $0b2e6adb871a3b94$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $0b2e6adb871a3b94$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Zh = {
    readContext: $0b2e6adb871a3b94$var$Vg,
    useCallback: $0b2e6adb871a3b94$var$Bi,
    useContext: $0b2e6adb871a3b94$var$Vg,
    useEffect: $0b2e6adb871a3b94$var$ji,
    useImperativeHandle: $0b2e6adb871a3b94$var$zi,
    useInsertionEffect: $0b2e6adb871a3b94$var$wi,
    useLayoutEffect: $0b2e6adb871a3b94$var$xi,
    useMemo: $0b2e6adb871a3b94$var$Ci,
    useReducer: $0b2e6adb871a3b94$var$fi,
    useRef: $0b2e6adb871a3b94$var$si,
    useState: function() {
        return $0b2e6adb871a3b94$var$fi($0b2e6adb871a3b94$var$ei);
    },
    useDebugValue: $0b2e6adb871a3b94$var$Ai,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$di();
        return $0b2e6adb871a3b94$var$Di(b, $0b2e6adb871a3b94$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$fi($0b2e6adb871a3b94$var$ei)[0], b = $0b2e6adb871a3b94$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$hi,
    useSyncExternalStore: $0b2e6adb871a3b94$var$ii,
    useId: $0b2e6adb871a3b94$var$Fi,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$$h = {
    readContext: $0b2e6adb871a3b94$var$Vg,
    useCallback: $0b2e6adb871a3b94$var$Bi,
    useContext: $0b2e6adb871a3b94$var$Vg,
    useEffect: $0b2e6adb871a3b94$var$ji,
    useImperativeHandle: $0b2e6adb871a3b94$var$zi,
    useInsertionEffect: $0b2e6adb871a3b94$var$wi,
    useLayoutEffect: $0b2e6adb871a3b94$var$xi,
    useMemo: $0b2e6adb871a3b94$var$Ci,
    useReducer: $0b2e6adb871a3b94$var$gi,
    useRef: $0b2e6adb871a3b94$var$si,
    useState: function() {
        return $0b2e6adb871a3b94$var$gi($0b2e6adb871a3b94$var$ei);
    },
    useDebugValue: $0b2e6adb871a3b94$var$Ai,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$di();
        return null === $0b2e6adb871a3b94$var$O ? b.memoizedState = a : $0b2e6adb871a3b94$var$Di(b, $0b2e6adb871a3b94$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$gi($0b2e6adb871a3b94$var$ei)[0], b = $0b2e6adb871a3b94$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$hi,
    useSyncExternalStore: $0b2e6adb871a3b94$var$ii,
    useId: $0b2e6adb871a3b94$var$Fi,
    unstable_isNewReconciler: !1
};
function $0b2e6adb871a3b94$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $0b2e6adb871a3b94$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $0b2e6adb871a3b94$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $0b2e6adb871a3b94$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $0b2e6adb871a3b94$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $0b2e6adb871a3b94$var$Oi(a, b, c) {
    c = $0b2e6adb871a3b94$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $0b2e6adb871a3b94$var$Pi || ($0b2e6adb871a3b94$var$Pi = !0, $0b2e6adb871a3b94$var$Qi = d);
        $0b2e6adb871a3b94$var$Mi(a, b);
    };
    return c;
}
function $0b2e6adb871a3b94$var$Ri(a, b, c) {
    c = $0b2e6adb871a3b94$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $0b2e6adb871a3b94$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $0b2e6adb871a3b94$var$Mi(a, b);
        "function" !== typeof d && (null === $0b2e6adb871a3b94$var$Si ? $0b2e6adb871a3b94$var$Si = new Set([
            this
        ]) : $0b2e6adb871a3b94$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $0b2e6adb871a3b94$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $0b2e6adb871a3b94$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $0b2e6adb871a3b94$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $0b2e6adb871a3b94$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $0b2e6adb871a3b94$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $0b2e6adb871a3b94$var$ch(-1, 1), b.tag = 2, $0b2e6adb871a3b94$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $0b2e6adb871a3b94$var$Xi = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$Ug = !1;
function $0b2e6adb871a3b94$var$Yi(a, b, c, d) {
    b.child = null === a ? $0b2e6adb871a3b94$var$Ch(b, null, c, d) : $0b2e6adb871a3b94$var$Bh(b, a.child, c, d);
}
function $0b2e6adb871a3b94$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $0b2e6adb871a3b94$var$Tg(b, e);
    d = $0b2e6adb871a3b94$var$Xh(a, b, c, d, f, e);
    c = $0b2e6adb871a3b94$var$bi();
    if (null !== a && !$0b2e6adb871a3b94$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$$i(a, b, e);
    $0b2e6adb871a3b94$var$I && c && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Yi(a, b, d, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$0b2e6adb871a3b94$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $0b2e6adb871a3b94$var$cj(a, b, f, d, e);
        a = $0b2e6adb871a3b94$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $0b2e6adb871a3b94$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $0b2e6adb871a3b94$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $0b2e6adb871a3b94$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $0b2e6adb871a3b94$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($0b2e6adb871a3b94$var$Ie(f, d) && a.ref === b.ref) {
            if ($0b2e6adb871a3b94$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($0b2e6adb871a3b94$var$Ug = !0);
            else return b.lanes = a.lanes, $0b2e6adb871a3b94$var$$i(a, b, e);
        }
    }
    return $0b2e6adb871a3b94$var$dj(a, b, c, d, e);
}
function $0b2e6adb871a3b94$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$fj, $0b2e6adb871a3b94$var$gj), $0b2e6adb871a3b94$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$fj, $0b2e6adb871a3b94$var$gj), $0b2e6adb871a3b94$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$fj, $0b2e6adb871a3b94$var$gj);
            $0b2e6adb871a3b94$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$fj, $0b2e6adb871a3b94$var$gj), $0b2e6adb871a3b94$var$gj |= d;
    $0b2e6adb871a3b94$var$Yi(a, b, e, c);
    return b.child;
}
function $0b2e6adb871a3b94$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $0b2e6adb871a3b94$var$dj(a, b, c, d, e) {
    var f = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current;
    f = $0b2e6adb871a3b94$var$Yf(b, f);
    $0b2e6adb871a3b94$var$Tg(b, e);
    c = $0b2e6adb871a3b94$var$Xh(a, b, c, d, f, e);
    d = $0b2e6adb871a3b94$var$bi();
    if (null !== a && !$0b2e6adb871a3b94$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$$i(a, b, e);
    $0b2e6adb871a3b94$var$I && d && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Yi(a, b, c, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$ij(a, b, c, d, e) {
    if ($0b2e6adb871a3b94$var$Zf(c)) {
        var f = !0;
        $0b2e6adb871a3b94$var$cg(b);
    } else f = !1;
    $0b2e6adb871a3b94$var$Tg(b, e);
    if (null === b.stateNode) $0b2e6adb871a3b94$var$jj(a, b), $0b2e6adb871a3b94$var$ph(b, c, d), $0b2e6adb871a3b94$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $0b2e6adb871a3b94$var$Vg(l) : (l = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, l = $0b2e6adb871a3b94$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $0b2e6adb871a3b94$var$qh(b, g, d, l);
        $0b2e6adb871a3b94$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$$g ? ("function" === typeof m && ($0b2e6adb871a3b94$var$kh(b, c, m, d), k = b.memoizedState), (h = $0b2e6adb871a3b94$var$$g || $0b2e6adb871a3b94$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $0b2e6adb871a3b94$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $0b2e6adb871a3b94$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $0b2e6adb871a3b94$var$Vg(k) : (k = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, k = $0b2e6adb871a3b94$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $0b2e6adb871a3b94$var$qh(b, g, d, k);
        $0b2e6adb871a3b94$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$$g ? ("function" === typeof y && ($0b2e6adb871a3b94$var$kh(b, c, y, d), n = b.memoizedState), (l = $0b2e6adb871a3b94$var$$g || $0b2e6adb871a3b94$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $0b2e6adb871a3b94$var$kj(a, b, c, d, f, e);
}
function $0b2e6adb871a3b94$var$kj(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $0b2e6adb871a3b94$var$dg(b, c, !1), $0b2e6adb871a3b94$var$$i(a, b, f);
    d = b.stateNode;
    $0b2e6adb871a3b94$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $0b2e6adb871a3b94$var$Bh(b, a.child, null, f), b.child = $0b2e6adb871a3b94$var$Bh(b, null, h, f)) : $0b2e6adb871a3b94$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $0b2e6adb871a3b94$var$dg(b, c, !0);
    return b.child;
}
function $0b2e6adb871a3b94$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $0b2e6adb871a3b94$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $0b2e6adb871a3b94$var$ag(a, b.context, !1);
    $0b2e6adb871a3b94$var$Ih(a, b.containerInfo);
}
function $0b2e6adb871a3b94$var$mj(a, b, c, d, e) {
    $0b2e6adb871a3b94$var$Ig();
    $0b2e6adb871a3b94$var$Jg(e);
    b.flags |= 256;
    $0b2e6adb871a3b94$var$Yi(a, b, c, d);
    return b.child;
}
var $0b2e6adb871a3b94$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $0b2e6adb871a3b94$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $0b2e6adb871a3b94$var$pj(a, b, c) {
    var d = b.pendingProps, e = $0b2e6adb871a3b94$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, e & 1);
    if (null === a) {
        $0b2e6adb871a3b94$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $0b2e6adb871a3b94$var$qj(g, d, 0, null), a = $0b2e6adb871a3b94$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $0b2e6adb871a3b94$var$oj(c), b.memoizedState = $0b2e6adb871a3b94$var$nj, a) : $0b2e6adb871a3b94$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $0b2e6adb871a3b94$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $0b2e6adb871a3b94$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $0b2e6adb871a3b94$var$wh(h, f) : (f = $0b2e6adb871a3b94$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $0b2e6adb871a3b94$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $0b2e6adb871a3b94$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $0b2e6adb871a3b94$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $0b2e6adb871a3b94$var$rj(a, b) {
    b = $0b2e6adb871a3b94$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $0b2e6adb871a3b94$var$tj(a, b, c, d) {
    null !== d && $0b2e6adb871a3b94$var$Jg(d);
    $0b2e6adb871a3b94$var$Bh(b, a.child, null, c);
    a = $0b2e6adb871a3b94$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $0b2e6adb871a3b94$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $0b2e6adb871a3b94$var$Li(Error($0b2e6adb871a3b94$var$p(422))), $0b2e6adb871a3b94$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $0b2e6adb871a3b94$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $0b2e6adb871a3b94$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $0b2e6adb871a3b94$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $0b2e6adb871a3b94$var$oj(g);
        b.memoizedState = $0b2e6adb871a3b94$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $0b2e6adb871a3b94$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($0b2e6adb871a3b94$var$p(419));
        d = $0b2e6adb871a3b94$var$Li(f, d, void 0);
        return $0b2e6adb871a3b94$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($0b2e6adb871a3b94$var$Ug || h) {
        d = $0b2e6adb871a3b94$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $0b2e6adb871a3b94$var$Zg(a, e), $0b2e6adb871a3b94$var$mh(d, a, e, -1));
        }
        $0b2e6adb871a3b94$var$uj();
        d = $0b2e6adb871a3b94$var$Li(Error($0b2e6adb871a3b94$var$p(421)));
        return $0b2e6adb871a3b94$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $0b2e6adb871a3b94$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(e.nextSibling);
    $0b2e6adb871a3b94$var$xg = b;
    $0b2e6adb871a3b94$var$I = !0;
    $0b2e6adb871a3b94$var$zg = null;
    null !== a && ($0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg, $0b2e6adb871a3b94$var$rg = a.id, $0b2e6adb871a3b94$var$sg = a.overflow, $0b2e6adb871a3b94$var$qg = b);
    b = $0b2e6adb871a3b94$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $0b2e6adb871a3b94$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $0b2e6adb871a3b94$var$Sg(a.return, b, c);
}
function $0b2e6adb871a3b94$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $0b2e6adb871a3b94$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $0b2e6adb871a3b94$var$Yi(a, b, d.children, c);
    d = $0b2e6adb871a3b94$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $0b2e6adb871a3b94$var$wj(a, c, b);
            else if (19 === a.tag) $0b2e6adb871a3b94$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $0b2e6adb871a3b94$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $0b2e6adb871a3b94$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $0b2e6adb871a3b94$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $0b2e6adb871a3b94$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $0b2e6adb871a3b94$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $0b2e6adb871a3b94$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $0b2e6adb871a3b94$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($0b2e6adb871a3b94$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $0b2e6adb871a3b94$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $0b2e6adb871a3b94$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $0b2e6adb871a3b94$var$lj(b);
            $0b2e6adb871a3b94$var$Ig();
            break;
        case 5:
            $0b2e6adb871a3b94$var$Kh(b);
            break;
        case 1:
            $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$cg(b);
            break;
        case 4:
            $0b2e6adb871a3b94$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $0b2e6adb871a3b94$var$pj(a, b, c);
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current & 1);
                a = $0b2e6adb871a3b94$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $0b2e6adb871a3b94$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $0b2e6adb871a3b94$var$ej(a, b, c);
    }
    return $0b2e6adb871a3b94$var$$i(a, b, c);
}
var $0b2e6adb871a3b94$var$Aj, $0b2e6adb871a3b94$var$Bj, $0b2e6adb871a3b94$var$Cj, $0b2e6adb871a3b94$var$Dj;
$0b2e6adb871a3b94$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$0b2e6adb871a3b94$var$Bj = function() {};
$0b2e6adb871a3b94$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $0b2e6adb871a3b94$var$Ya(a, e);
                d = $0b2e6adb871a3b94$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $0b2e6adb871a3b94$var$A({}, e, {
                    value: void 0
                });
                d = $0b2e6adb871a3b94$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $0b2e6adb871a3b94$var$gb(a, e);
                d = $0b2e6adb871a3b94$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
        }
        $0b2e6adb871a3b94$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $0b2e6adb871a3b94$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$0b2e6adb871a3b94$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $0b2e6adb871a3b94$var$Ej(a, b) {
    if (!$0b2e6adb871a3b94$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $0b2e6adb871a3b94$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $0b2e6adb871a3b94$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $0b2e6adb871a3b94$var$S(b), null;
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 3:
            d = b.stateNode;
            $0b2e6adb871a3b94$var$Jh();
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
            $0b2e6adb871a3b94$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $0b2e6adb871a3b94$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Gj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null));
            $0b2e6adb871a3b94$var$Bj(a, b);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 5:
            $0b2e6adb871a3b94$var$Lh(b);
            var e = $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $0b2e6adb871a3b94$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                    $0b2e6adb871a3b94$var$S(b);
                    return null;
                }
                a = $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Eh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    d[$0b2e6adb871a3b94$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $0b2e6adb871a3b94$var$D("cancel", d);
                            $0b2e6adb871a3b94$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], d);
                            break;
                        case "source":
                            $0b2e6adb871a3b94$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $0b2e6adb871a3b94$var$D("error", d);
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "details":
                            $0b2e6adb871a3b94$var$D("toggle", d);
                            break;
                        case "input":
                            $0b2e6adb871a3b94$var$Za(d, f);
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$hb(d, f), $0b2e6adb871a3b94$var$D("invalid", d);
                    }
                    $0b2e6adb871a3b94$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $0b2e6adb871a3b94$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $0b2e6adb871a3b94$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $0b2e6adb871a3b94$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $0b2e6adb871a3b94$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$0b2e6adb871a3b94$var$Of] = b;
                    a[$0b2e6adb871a3b94$var$Pf] = d;
                    $0b2e6adb871a3b94$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $0b2e6adb871a3b94$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $0b2e6adb871a3b94$var$D("cancel", a);
                                $0b2e6adb871a3b94$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $0b2e6adb871a3b94$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $0b2e6adb871a3b94$var$D("error", a);
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $0b2e6adb871a3b94$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $0b2e6adb871a3b94$var$Za(a, d);
                                e = $0b2e6adb871a3b94$var$Ya(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $0b2e6adb871a3b94$var$A({}, d, {
                                    value: void 0
                                });
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$hb(a, d);
                                e = $0b2e6adb871a3b94$var$gb(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $0b2e6adb871a3b94$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $0b2e6adb871a3b94$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $0b2e6adb871a3b94$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $0b2e6adb871a3b94$var$ob(a, k) : "number" === typeof k && $0b2e6adb871a3b94$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $0b2e6adb871a3b94$var$D("scroll", a) : null != k && $0b2e6adb871a3b94$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $0b2e6adb871a3b94$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $0b2e6adb871a3b94$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $0b2e6adb871a3b94$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $0b2e6adb871a3b94$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                c = $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Gh.current);
                $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Eh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $0b2e6adb871a3b94$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$0b2e6adb871a3b94$var$Of] = b, b.stateNode = d;
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($0b2e6adb871a3b94$var$I && null !== $0b2e6adb871a3b94$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $0b2e6adb871a3b94$var$Hg(), $0b2e6adb871a3b94$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $0b2e6adb871a3b94$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(317));
                        f[$0b2e6adb871a3b94$var$Of] = b;
                    } else $0b2e6adb871a3b94$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $0b2e6adb871a3b94$var$S(b);
                    f = !1;
                } else null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Gj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($0b2e6adb871a3b94$var$M.current & 1) ? 0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 3) : $0b2e6adb871a3b94$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 4:
            return $0b2e6adb871a3b94$var$Jh(), $0b2e6adb871a3b94$var$Bj(a, b), null === a && $0b2e6adb871a3b94$var$sf(b.stateNode.containerInfo), $0b2e6adb871a3b94$var$S(b), null;
        case 10:
            return $0b2e6adb871a3b94$var$Rg(b.type._context), $0b2e6adb871a3b94$var$S(b), null;
        case 17:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 19:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
            f = b.memoizedState;
            if (null === f) return $0b2e6adb871a3b94$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $0b2e6adb871a3b94$var$Ej(f, !1);
                else {
                    if (0 !== $0b2e6adb871a3b94$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $0b2e6adb871a3b94$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $0b2e6adb871a3b94$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $0b2e6adb871a3b94$var$B() > $0b2e6adb871a3b94$var$Hj && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $0b2e6adb871a3b94$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $0b2e6adb871a3b94$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$S(b), null;
                    } else 2 * $0b2e6adb871a3b94$var$B() - f.renderingStartTime > $0b2e6adb871a3b94$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $0b2e6adb871a3b94$var$B(), b.sibling = null, c = $0b2e6adb871a3b94$var$M.current, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, d ? c & 1 | 2 : c & 1), b;
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($0b2e6adb871a3b94$var$gj & 1073741824) && ($0b2e6adb871a3b94$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $0b2e6adb871a3b94$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
}
function $0b2e6adb871a3b94$var$Jj(a, b) {
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $0b2e6adb871a3b94$var$Jh(), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $0b2e6adb871a3b94$var$Lh(b), null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($0b2e6adb871a3b94$var$p(340));
                $0b2e6adb871a3b94$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M), null;
        case 4:
            return $0b2e6adb871a3b94$var$Jh(), null;
        case 10:
            return $0b2e6adb871a3b94$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$Kj = !1, $0b2e6adb871a3b94$var$U = !1, $0b2e6adb871a3b94$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $0b2e6adb871a3b94$var$V = null;
function $0b2e6adb871a3b94$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $0b2e6adb871a3b94$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $0b2e6adb871a3b94$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $0b2e6adb871a3b94$var$W(a, b, d);
    }
}
var $0b2e6adb871a3b94$var$Oj = !1;
function $0b2e6adb871a3b94$var$Pj(a, b) {
    $0b2e6adb871a3b94$var$Cf = $0b2e6adb871a3b94$var$dd;
    a = $0b2e6adb871a3b94$var$Me();
    if ($0b2e6adb871a3b94$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $0b2e6adb871a3b94$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $0b2e6adb871a3b94$var$dd = !1;
    for($0b2e6adb871a3b94$var$V = b; null !== $0b2e6adb871a3b94$var$V;)if (b = $0b2e6adb871a3b94$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $0b2e6adb871a3b94$var$V = a;
    else for(; null !== $0b2e6adb871a3b94$var$V;){
        b = $0b2e6adb871a3b94$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $0b2e6adb871a3b94$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(163));
            }
        } catch (F) {
            $0b2e6adb871a3b94$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $0b2e6adb871a3b94$var$V = a;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
    n = $0b2e6adb871a3b94$var$Oj;
    $0b2e6adb871a3b94$var$Oj = !1;
    return n;
}
function $0b2e6adb871a3b94$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $0b2e6adb871a3b94$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $0b2e6adb871a3b94$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $0b2e6adb871a3b94$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $0b2e6adb871a3b94$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $0b2e6adb871a3b94$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$0b2e6adb871a3b94$var$Of], delete b[$0b2e6adb871a3b94$var$Pf], delete b[$0b2e6adb871a3b94$var$of], delete b[$0b2e6adb871a3b94$var$Qf], delete b[$0b2e6adb871a3b94$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $0b2e6adb871a3b94$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $0b2e6adb871a3b94$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $0b2e6adb871a3b94$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $0b2e6adb871a3b94$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $0b2e6adb871a3b94$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling;
}
function $0b2e6adb871a3b94$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Xj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Xj(a, b, c), a = a.sibling;
}
var $0b2e6adb871a3b94$var$X = null, $0b2e6adb871a3b94$var$Yj = !1;
function $0b2e6adb871a3b94$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$0b2e6adb871a3b94$var$ak(a, b, c), c = c.sibling;
}
function $0b2e6adb871a3b94$var$ak(a, b, c) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount($0b2e6adb871a3b94$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Mj(c, b);
        case 6:
            var d = $0b2e6adb871a3b94$var$X, e = $0b2e6adb871a3b94$var$Yj;
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Yj = e;
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Yj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $0b2e6adb871a3b94$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Yj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? $0b2e6adb871a3b94$var$Kf(a.parentNode, c) : 1 === a.nodeType && $0b2e6adb871a3b94$var$Kf(a, c), $0b2e6adb871a3b94$var$bd(a)) : $0b2e6adb871a3b94$var$Kf($0b2e6adb871a3b94$var$X, c.stateNode));
            break;
        case 4:
            d = $0b2e6adb871a3b94$var$X;
            e = $0b2e6adb871a3b94$var$Yj;
            $0b2e6adb871a3b94$var$X = c.stateNode.containerInfo;
            $0b2e6adb871a3b94$var$Yj = !0;
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$0b2e6adb871a3b94$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $0b2e6adb871a3b94$var$Nj(c, b, g) : 0 !== (f & 4) && $0b2e6adb871a3b94$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            break;
        case 1:
            if (!$0b2e6adb871a3b94$var$U && ($0b2e6adb871a3b94$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $0b2e6adb871a3b94$var$W(c, b, h);
            }
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            break;
        case 21:
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($0b2e6adb871a3b94$var$U = (d = $0b2e6adb871a3b94$var$U) || null !== c.memoizedState, $0b2e6adb871a3b94$var$Zj(a, b, c), $0b2e6adb871a3b94$var$U = d) : $0b2e6adb871a3b94$var$Zj(a, b, c);
            break;
        default:
            $0b2e6adb871a3b94$var$Zj(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $0b2e6adb871a3b94$var$Lj);
        b.forEach(function(b) {
            var d = $0b2e6adb871a3b94$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $0b2e6adb871a3b94$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $0b2e6adb871a3b94$var$X = h.stateNode;
                        $0b2e6adb871a3b94$var$Yj = !1;
                        break a;
                    case 3:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Yj = !0;
                        break a;
                    case 4:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $0b2e6adb871a3b94$var$X) throw Error($0b2e6adb871a3b94$var$p(160));
            $0b2e6adb871a3b94$var$ak(f, g, e);
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $0b2e6adb871a3b94$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$0b2e6adb871a3b94$var$ek(b, a), b = b.sibling;
}
function $0b2e6adb871a3b94$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            if (d & 4) {
                try {
                    $0b2e6adb871a3b94$var$Qj(3, a, a.return), $0b2e6adb871a3b94$var$Rj(3, a);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
                try {
                    $0b2e6adb871a3b94$var$Qj(5, a, a.return);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Mj(c, c.return);
            break;
        case 5:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $0b2e6adb871a3b94$var$ob(e, "");
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $0b2e6adb871a3b94$var$ab(e, f);
                    $0b2e6adb871a3b94$var$vb(h, g);
                    var l = $0b2e6adb871a3b94$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $0b2e6adb871a3b94$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $0b2e6adb871a3b94$var$nb(e, q) : "children" === m ? $0b2e6adb871a3b94$var$ob(e, q) : $0b2e6adb871a3b94$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $0b2e6adb871a3b94$var$bb(e, f);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.defaultValue, !0) : $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$0b2e6adb871a3b94$var$Pf] = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($0b2e6adb871a3b94$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $0b2e6adb871a3b94$var$bd(b.containerInfo);
            } catch (t) {
                $0b2e6adb871a3b94$var$W(a, a.return, t);
            }
            break;
        case 4:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            break;
        case 13:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($0b2e6adb871a3b94$var$gk = $0b2e6adb871a3b94$var$B()));
            d & 4 && $0b2e6adb871a3b94$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($0b2e6adb871a3b94$var$U = (l = $0b2e6adb871a3b94$var$U) || m, $0b2e6adb871a3b94$var$dk(b, a), $0b2e6adb871a3b94$var$U = l) : $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($0b2e6adb871a3b94$var$V = a, m = a.child; null !== m;){
                    for(q = $0b2e6adb871a3b94$var$V = m; null !== $0b2e6adb871a3b94$var$V;){
                        r = $0b2e6adb871a3b94$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $0b2e6adb871a3b94$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $0b2e6adb871a3b94$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $0b2e6adb871a3b94$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $0b2e6adb871a3b94$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $0b2e6adb871a3b94$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $0b2e6adb871a3b94$var$V = y) : $0b2e6adb871a3b94$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $0b2e6adb871a3b94$var$rb("display", g));
                            } catch (t) {
                                $0b2e6adb871a3b94$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $0b2e6adb871a3b94$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            d & 4 && $0b2e6adb871a3b94$var$bk(a);
            break;
        case 21:
            break;
        default:
            $0b2e6adb871a3b94$var$dk(b, a), $0b2e6adb871a3b94$var$fk(a);
    }
}
function $0b2e6adb871a3b94$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($0b2e6adb871a3b94$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($0b2e6adb871a3b94$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($0b2e6adb871a3b94$var$ob(e, ""), d.flags &= -33);
                    var f = $0b2e6adb871a3b94$var$Vj(a);
                    $0b2e6adb871a3b94$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $0b2e6adb871a3b94$var$Vj(a);
                    $0b2e6adb871a3b94$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(161));
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $0b2e6adb871a3b94$var$ik(a, b, c) {
    $0b2e6adb871a3b94$var$V = a;
    $0b2e6adb871a3b94$var$jk(a, b, c);
}
function $0b2e6adb871a3b94$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $0b2e6adb871a3b94$var$V;){
        var e = $0b2e6adb871a3b94$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $0b2e6adb871a3b94$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $0b2e6adb871a3b94$var$U;
                h = $0b2e6adb871a3b94$var$Kj;
                var l = $0b2e6adb871a3b94$var$U;
                $0b2e6adb871a3b94$var$Kj = g;
                if (($0b2e6adb871a3b94$var$U = k) && !l) for($0b2e6adb871a3b94$var$V = e; null !== $0b2e6adb871a3b94$var$V;)g = $0b2e6adb871a3b94$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $0b2e6adb871a3b94$var$kk(e) : null !== k ? (k.return = g, $0b2e6adb871a3b94$var$V = k) : $0b2e6adb871a3b94$var$kk(e);
                for(; null !== f;)$0b2e6adb871a3b94$var$V = f, $0b2e6adb871a3b94$var$jk(f, b, c), f = f.sibling;
                $0b2e6adb871a3b94$var$V = e;
                $0b2e6adb871a3b94$var$Kj = h;
                $0b2e6adb871a3b94$var$U = l;
            }
            $0b2e6adb871a3b94$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $0b2e6adb871a3b94$var$V = f) : $0b2e6adb871a3b94$var$lk(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$lk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$0b2e6adb871a3b94$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $0b2e6adb871a3b94$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $0b2e6adb871a3b94$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $0b2e6adb871a3b94$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $0b2e6adb871a3b94$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($0b2e6adb871a3b94$var$p(163));
                }
                $0b2e6adb871a3b94$var$U || b.flags & 512 && $0b2e6adb871a3b94$var$Sj(b);
            } catch (r) {
                $0b2e6adb871a3b94$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$hk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$kk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Rj(4, b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $0b2e6adb871a3b94$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Sj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Sj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(b, b.return, k);
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $0b2e6adb871a3b94$var$V = h;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
var $0b2e6adb871a3b94$var$mk = Math.ceil, $0b2e6adb871a3b94$var$nk = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$ok = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$pk = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$K = 0, $0b2e6adb871a3b94$var$R = null, $0b2e6adb871a3b94$var$Y = null, $0b2e6adb871a3b94$var$Z = 0, $0b2e6adb871a3b94$var$gj = 0, $0b2e6adb871a3b94$var$fj = $0b2e6adb871a3b94$var$Uf(0), $0b2e6adb871a3b94$var$T = 0, $0b2e6adb871a3b94$var$qk = null, $0b2e6adb871a3b94$var$hh = 0, $0b2e6adb871a3b94$var$rk = 0, $0b2e6adb871a3b94$var$sk = 0, $0b2e6adb871a3b94$var$tk = null, $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$gk = 0, $0b2e6adb871a3b94$var$Hj = Infinity, $0b2e6adb871a3b94$var$vk = null, $0b2e6adb871a3b94$var$Pi = !1, $0b2e6adb871a3b94$var$Qi = null, $0b2e6adb871a3b94$var$Si = null, $0b2e6adb871a3b94$var$wk = !1, $0b2e6adb871a3b94$var$xk = null, $0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = 0, $0b2e6adb871a3b94$var$Ak = null, $0b2e6adb871a3b94$var$Bk = -1, $0b2e6adb871a3b94$var$Ck = 0;
function $0b2e6adb871a3b94$var$L() {
    return 0 !== ($0b2e6adb871a3b94$var$K & 6) ? $0b2e6adb871a3b94$var$B() : -1 !== $0b2e6adb871a3b94$var$Bk ? $0b2e6adb871a3b94$var$Bk : $0b2e6adb871a3b94$var$Bk = $0b2e6adb871a3b94$var$B();
}
function $0b2e6adb871a3b94$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2) && 0 !== $0b2e6adb871a3b94$var$Z) return $0b2e6adb871a3b94$var$Z & -$0b2e6adb871a3b94$var$Z;
    if (null !== $0b2e6adb871a3b94$var$Kg.transition) return 0 === $0b2e6adb871a3b94$var$Ck && ($0b2e6adb871a3b94$var$Ck = $0b2e6adb871a3b94$var$yc()), $0b2e6adb871a3b94$var$Ck;
    a = $0b2e6adb871a3b94$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $0b2e6adb871a3b94$var$jd(a.type);
    return a;
}
function $0b2e6adb871a3b94$var$mh(a, b, c, d) {
    if (50 < $0b2e6adb871a3b94$var$zk) throw $0b2e6adb871a3b94$var$zk = 0, $0b2e6adb871a3b94$var$Ak = null, Error($0b2e6adb871a3b94$var$p(185));
    $0b2e6adb871a3b94$var$Ac(a, c, d);
    if (0 === ($0b2e6adb871a3b94$var$K & 2) || a !== $0b2e6adb871a3b94$var$R) a === $0b2e6adb871a3b94$var$R && (0 === ($0b2e6adb871a3b94$var$K & 2) && ($0b2e6adb871a3b94$var$rk |= c), 4 === $0b2e6adb871a3b94$var$T && $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$Z)), $0b2e6adb871a3b94$var$Ek(a, d), 1 === c && 0 === $0b2e6adb871a3b94$var$K && 0 === (b.mode & 1) && ($0b2e6adb871a3b94$var$Hj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
}
function $0b2e6adb871a3b94$var$Ek(a, b) {
    var c = a.callbackNode;
    $0b2e6adb871a3b94$var$wc(a, b);
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$R ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) null !== c && $0b2e6adb871a3b94$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $0b2e6adb871a3b94$var$bc(c);
        if (1 === b) 0 === a.tag ? $0b2e6adb871a3b94$var$ig($0b2e6adb871a3b94$var$Fk.bind(null, a)) : $0b2e6adb871a3b94$var$hg($0b2e6adb871a3b94$var$Fk.bind(null, a)), $0b2e6adb871a3b94$var$Jf(function() {
            0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
        }), c = null;
        else {
            switch($0b2e6adb871a3b94$var$Dc(d)){
                case 1:
                    c = $0b2e6adb871a3b94$var$fc;
                    break;
                case 4:
                    c = $0b2e6adb871a3b94$var$gc;
                    break;
                case 16:
                    c = $0b2e6adb871a3b94$var$hc;
                    break;
                case 536870912:
                    c = $0b2e6adb871a3b94$var$jc;
                    break;
                default:
                    c = $0b2e6adb871a3b94$var$hc;
            }
            c = $0b2e6adb871a3b94$var$Gk(c, $0b2e6adb871a3b94$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $0b2e6adb871a3b94$var$Hk(a, b) {
    $0b2e6adb871a3b94$var$Bk = -1;
    $0b2e6adb871a3b94$var$Ck = 0;
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    var c = a.callbackNode;
    if ($0b2e6adb871a3b94$var$Ik() && a.callbackNode !== c) return null;
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$R ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $0b2e6adb871a3b94$var$Jk(a, d);
    else {
        b = d;
        var e = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 2;
        var f = $0b2e6adb871a3b94$var$Kk();
        if ($0b2e6adb871a3b94$var$R !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$vk = null, $0b2e6adb871a3b94$var$Hj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$Lk(a, b);
        for(;;)try {
            $0b2e6adb871a3b94$var$Mk();
            break;
        } catch (h) {
            $0b2e6adb871a3b94$var$Nk(a, h);
        }
        $0b2e6adb871a3b94$var$Qg();
        $0b2e6adb871a3b94$var$nk.current = f;
        $0b2e6adb871a3b94$var$K = e;
        null !== $0b2e6adb871a3b94$var$Y ? b = 0 : ($0b2e6adb871a3b94$var$R = null, $0b2e6adb871a3b94$var$Z = 0, b = $0b2e6adb871a3b94$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $0b2e6adb871a3b94$var$xc(a), 0 !== e && (d = e, b = $0b2e6adb871a3b94$var$Ok(a, e)));
        if (1 === b) throw c = $0b2e6adb871a3b94$var$qk, $0b2e6adb871a3b94$var$Lk(a, 0), $0b2e6adb871a3b94$var$Dk(a, d), $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B()), c;
        if (6 === b) $0b2e6adb871a3b94$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$0b2e6adb871a3b94$var$Pk(e) && (b = $0b2e6adb871a3b94$var$Jk(a, d), 2 === b && (f = $0b2e6adb871a3b94$var$xc(a), 0 !== f && (d = f, b = $0b2e6adb871a3b94$var$Ok(a, f))), 1 === b)) throw c = $0b2e6adb871a3b94$var$qk, $0b2e6adb871a3b94$var$Lk(a, 0), $0b2e6adb871a3b94$var$Dk(a, d), $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($0b2e6adb871a3b94$var$p(345));
                case 2:
                    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
                    break;
                case 3:
                    $0b2e6adb871a3b94$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $0b2e6adb871a3b94$var$gk + 500 - $0b2e6adb871a3b94$var$B(), 10 < b)) {
                        if (0 !== $0b2e6adb871a3b94$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $0b2e6adb871a3b94$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Qk.bind(null, a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk), b);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
                    break;
                case 4:
                    $0b2e6adb871a3b94$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $0b2e6adb871a3b94$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $0b2e6adb871a3b94$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $0b2e6adb871a3b94$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Qk.bind(null, a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk), d);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
                    break;
                case 5:
                    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(329));
            }
        }
    }
    $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B());
    return a.callbackNode === c ? $0b2e6adb871a3b94$var$Hk.bind(null, a) : null;
}
function $0b2e6adb871a3b94$var$Ok(a, b) {
    var c = $0b2e6adb871a3b94$var$tk;
    a.current.memoizedState.isDehydrated && ($0b2e6adb871a3b94$var$Lk(a, b).flags |= 256);
    a = $0b2e6adb871a3b94$var$Jk(a, b);
    2 !== a && (b = $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$uk = c, null !== b && $0b2e6adb871a3b94$var$Gj(b));
    return a;
}
function $0b2e6adb871a3b94$var$Gj(a) {
    null === $0b2e6adb871a3b94$var$uk ? $0b2e6adb871a3b94$var$uk = a : $0b2e6adb871a3b94$var$uk.push.apply($0b2e6adb871a3b94$var$uk, a);
}
function $0b2e6adb871a3b94$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$0b2e6adb871a3b94$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Dk(a, b) {
    b &= ~$0b2e6adb871a3b94$var$sk;
    b &= ~$0b2e6adb871a3b94$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $0b2e6adb871a3b94$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $0b2e6adb871a3b94$var$Fk(a) {
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    $0b2e6adb871a3b94$var$Ik();
    var b = $0b2e6adb871a3b94$var$uc(a, 0);
    if (0 === (b & 1)) return $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B()), null;
    var c = $0b2e6adb871a3b94$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $0b2e6adb871a3b94$var$xc(a);
        0 !== d && (b = d, c = $0b2e6adb871a3b94$var$Ok(a, d));
    }
    if (1 === c) throw c = $0b2e6adb871a3b94$var$qk, $0b2e6adb871a3b94$var$Lk(a, 0), $0b2e6adb871a3b94$var$Dk(a, b), $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B()), c;
    if (6 === c) throw Error($0b2e6adb871a3b94$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
    $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B());
    return null;
}
function $0b2e6adb871a3b94$var$Rk(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    try {
        return a(b);
    } finally{
        $0b2e6adb871a3b94$var$K = c, 0 === $0b2e6adb871a3b94$var$K && ($0b2e6adb871a3b94$var$Hj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
    }
}
function $0b2e6adb871a3b94$var$Sk(a) {
    null !== $0b2e6adb871a3b94$var$xk && 0 === $0b2e6adb871a3b94$var$xk.tag && 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$Ik();
    var b = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    var c = $0b2e6adb871a3b94$var$pk.transition, d = $0b2e6adb871a3b94$var$C;
    try {
        if ($0b2e6adb871a3b94$var$pk.transition = null, $0b2e6adb871a3b94$var$C = 1, a) return a();
    } finally{
        $0b2e6adb871a3b94$var$C = d, $0b2e6adb871a3b94$var$pk.transition = c, $0b2e6adb871a3b94$var$K = b, 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
    }
}
function $0b2e6adb871a3b94$var$Ij() {
    $0b2e6adb871a3b94$var$gj = $0b2e6adb871a3b94$var$fj.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$fj);
}
function $0b2e6adb871a3b94$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $0b2e6adb871a3b94$var$Gf(c));
    if (null !== $0b2e6adb871a3b94$var$Y) for(c = $0b2e6adb871a3b94$var$Y.return; null !== c;){
        var d = c;
        $0b2e6adb871a3b94$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $0b2e6adb871a3b94$var$$f();
                break;
            case 3:
                $0b2e6adb871a3b94$var$Jh();
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
                $0b2e6adb871a3b94$var$Oh();
                break;
            case 5:
                $0b2e6adb871a3b94$var$Lh(d);
                break;
            case 4:
                $0b2e6adb871a3b94$var$Jh();
                break;
            case 13:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
                break;
            case 19:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
                break;
            case 10:
                $0b2e6adb871a3b94$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $0b2e6adb871a3b94$var$Ij();
        }
        c = c.return;
    }
    $0b2e6adb871a3b94$var$R = a;
    $0b2e6adb871a3b94$var$Y = a = $0b2e6adb871a3b94$var$wh(a.current, null);
    $0b2e6adb871a3b94$var$Z = $0b2e6adb871a3b94$var$gj = b;
    $0b2e6adb871a3b94$var$T = 0;
    $0b2e6adb871a3b94$var$qk = null;
    $0b2e6adb871a3b94$var$sk = $0b2e6adb871a3b94$var$rk = $0b2e6adb871a3b94$var$hh = 0;
    $0b2e6adb871a3b94$var$uk = $0b2e6adb871a3b94$var$tk = null;
    if (null !== $0b2e6adb871a3b94$var$Wg) {
        for(b = 0; b < $0b2e6adb871a3b94$var$Wg.length; b++)if (c = $0b2e6adb871a3b94$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $0b2e6adb871a3b94$var$Wg = null;
    }
    return a;
}
function $0b2e6adb871a3b94$var$Nk(a, b) {
    do {
        var c = $0b2e6adb871a3b94$var$Y;
        try {
            $0b2e6adb871a3b94$var$Qg();
            $0b2e6adb871a3b94$var$Ph.current = $0b2e6adb871a3b94$var$ai;
            if ($0b2e6adb871a3b94$var$Sh) {
                for(var d = $0b2e6adb871a3b94$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $0b2e6adb871a3b94$var$Sh = !1;
            }
            $0b2e6adb871a3b94$var$Rh = 0;
            $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = null;
            $0b2e6adb871a3b94$var$Th = !1;
            $0b2e6adb871a3b94$var$Uh = 0;
            $0b2e6adb871a3b94$var$ok.current = null;
            if (null === c || null === c.return) {
                $0b2e6adb871a3b94$var$T = 1;
                $0b2e6adb871a3b94$var$qk = b;
                $0b2e6adb871a3b94$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $0b2e6adb871a3b94$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $0b2e6adb871a3b94$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $0b2e6adb871a3b94$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $0b2e6adb871a3b94$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $0b2e6adb871a3b94$var$Ti(f, l, b);
                            $0b2e6adb871a3b94$var$uj();
                            break a;
                        }
                        k = Error($0b2e6adb871a3b94$var$p(426));
                    }
                } else if ($0b2e6adb871a3b94$var$I && h.mode & 1) {
                    var J = $0b2e6adb871a3b94$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $0b2e6adb871a3b94$var$Wi(J, g, h, f, b);
                        $0b2e6adb871a3b94$var$Jg($0b2e6adb871a3b94$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $0b2e6adb871a3b94$var$Ki(k, h);
                4 !== $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 2);
                null === $0b2e6adb871a3b94$var$tk ? $0b2e6adb871a3b94$var$tk = [
                    f
                ] : $0b2e6adb871a3b94$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $0b2e6adb871a3b94$var$Oi(f, k, b);
                            $0b2e6adb871a3b94$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $0b2e6adb871a3b94$var$Si || !$0b2e6adb871a3b94$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $0b2e6adb871a3b94$var$Ri(f, h, b);
                                $0b2e6adb871a3b94$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $0b2e6adb871a3b94$var$Tk(c);
        } catch (na) {
            b = na;
            $0b2e6adb871a3b94$var$Y === c && null !== c && ($0b2e6adb871a3b94$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $0b2e6adb871a3b94$var$Kk() {
    var a = $0b2e6adb871a3b94$var$nk.current;
    $0b2e6adb871a3b94$var$nk.current = $0b2e6adb871a3b94$var$ai;
    return null === a ? $0b2e6adb871a3b94$var$ai : a;
}
function $0b2e6adb871a3b94$var$uj() {
    if (0 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T || 2 === $0b2e6adb871a3b94$var$T) $0b2e6adb871a3b94$var$T = 4;
    null === $0b2e6adb871a3b94$var$R || 0 === ($0b2e6adb871a3b94$var$hh & 268435455) && 0 === ($0b2e6adb871a3b94$var$rk & 268435455) || $0b2e6adb871a3b94$var$Dk($0b2e6adb871a3b94$var$R, $0b2e6adb871a3b94$var$Z);
}
function $0b2e6adb871a3b94$var$Jk(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 2;
    var d = $0b2e6adb871a3b94$var$Kk();
    if ($0b2e6adb871a3b94$var$R !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$vk = null, $0b2e6adb871a3b94$var$Lk(a, b);
    for(;;)try {
        $0b2e6adb871a3b94$var$Uk();
        break;
    } catch (e) {
        $0b2e6adb871a3b94$var$Nk(a, e);
    }
    $0b2e6adb871a3b94$var$Qg();
    $0b2e6adb871a3b94$var$K = c;
    $0b2e6adb871a3b94$var$nk.current = d;
    if (null !== $0b2e6adb871a3b94$var$Y) throw Error($0b2e6adb871a3b94$var$p(261));
    $0b2e6adb871a3b94$var$R = null;
    $0b2e6adb871a3b94$var$Z = 0;
    return $0b2e6adb871a3b94$var$T;
}
function $0b2e6adb871a3b94$var$Uk() {
    for(; null !== $0b2e6adb871a3b94$var$Y;)$0b2e6adb871a3b94$var$Vk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Mk() {
    for(; null !== $0b2e6adb871a3b94$var$Y && !$0b2e6adb871a3b94$var$cc();)$0b2e6adb871a3b94$var$Vk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Vk(a) {
    var b = $0b2e6adb871a3b94$var$Wk(a.alternate, a, $0b2e6adb871a3b94$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $0b2e6adb871a3b94$var$Tk(a) : $0b2e6adb871a3b94$var$Y = b;
    $0b2e6adb871a3b94$var$ok.current = null;
}
function $0b2e6adb871a3b94$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $0b2e6adb871a3b94$var$Fj(c, b, $0b2e6adb871a3b94$var$gj), null !== c) {
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
        } else {
            c = $0b2e6adb871a3b94$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $0b2e6adb871a3b94$var$T = 6;
                $0b2e6adb871a3b94$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $0b2e6adb871a3b94$var$Y = b;
            return;
        }
        $0b2e6adb871a3b94$var$Y = b = a;
    }while (null !== b);
    0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 5);
}
function $0b2e6adb871a3b94$var$Qk(a, b, c) {
    var d = $0b2e6adb871a3b94$var$C, e = $0b2e6adb871a3b94$var$pk.transition;
    try {
        $0b2e6adb871a3b94$var$pk.transition = null, $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$Xk(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$pk.transition = e, $0b2e6adb871a3b94$var$C = d;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Xk(a, b, c, d) {
    do $0b2e6adb871a3b94$var$Ik();
    while (null !== $0b2e6adb871a3b94$var$xk);
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($0b2e6adb871a3b94$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $0b2e6adb871a3b94$var$Bc(a, f);
    a === $0b2e6adb871a3b94$var$R && ($0b2e6adb871a3b94$var$Y = $0b2e6adb871a3b94$var$R = null, $0b2e6adb871a3b94$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $0b2e6adb871a3b94$var$wk || ($0b2e6adb871a3b94$var$wk = !0, $0b2e6adb871a3b94$var$Gk($0b2e6adb871a3b94$var$hc, function() {
        $0b2e6adb871a3b94$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $0b2e6adb871a3b94$var$pk.transition;
        $0b2e6adb871a3b94$var$pk.transition = null;
        var g = $0b2e6adb871a3b94$var$C;
        $0b2e6adb871a3b94$var$C = 1;
        var h = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 4;
        $0b2e6adb871a3b94$var$ok.current = null;
        $0b2e6adb871a3b94$var$Pj(a, c);
        $0b2e6adb871a3b94$var$ek(c, a);
        $0b2e6adb871a3b94$var$Oe($0b2e6adb871a3b94$var$Df);
        $0b2e6adb871a3b94$var$dd = !!$0b2e6adb871a3b94$var$Cf;
        $0b2e6adb871a3b94$var$Df = $0b2e6adb871a3b94$var$Cf = null;
        a.current = c;
        $0b2e6adb871a3b94$var$ik(c, a, e);
        $0b2e6adb871a3b94$var$dc();
        $0b2e6adb871a3b94$var$K = h;
        $0b2e6adb871a3b94$var$C = g;
        $0b2e6adb871a3b94$var$pk.transition = f;
    } else a.current = c;
    $0b2e6adb871a3b94$var$wk && ($0b2e6adb871a3b94$var$wk = !1, $0b2e6adb871a3b94$var$xk = a, $0b2e6adb871a3b94$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($0b2e6adb871a3b94$var$Si = null);
    $0b2e6adb871a3b94$var$mc(c.stateNode, d);
    $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($0b2e6adb871a3b94$var$Pi) throw $0b2e6adb871a3b94$var$Pi = !1, a = $0b2e6adb871a3b94$var$Qi, $0b2e6adb871a3b94$var$Qi = null, a;
    0 !== ($0b2e6adb871a3b94$var$yk & 1) && 0 !== a.tag && $0b2e6adb871a3b94$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $0b2e6adb871a3b94$var$Ak ? $0b2e6adb871a3b94$var$zk++ : ($0b2e6adb871a3b94$var$zk = 0, $0b2e6adb871a3b94$var$Ak = a) : $0b2e6adb871a3b94$var$zk = 0;
    $0b2e6adb871a3b94$var$jg();
    return null;
}
function $0b2e6adb871a3b94$var$Ik() {
    if (null !== $0b2e6adb871a3b94$var$xk) {
        var a = $0b2e6adb871a3b94$var$Dc($0b2e6adb871a3b94$var$yk), b = $0b2e6adb871a3b94$var$pk.transition, c = $0b2e6adb871a3b94$var$C;
        try {
            $0b2e6adb871a3b94$var$pk.transition = null;
            $0b2e6adb871a3b94$var$C = 16 > a ? 16 : a;
            if (null === $0b2e6adb871a3b94$var$xk) var d = !1;
            else {
                a = $0b2e6adb871a3b94$var$xk;
                $0b2e6adb871a3b94$var$xk = null;
                $0b2e6adb871a3b94$var$yk = 0;
                if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(331));
                var e = $0b2e6adb871a3b94$var$K;
                $0b2e6adb871a3b94$var$K |= 4;
                for($0b2e6adb871a3b94$var$V = a.current; null !== $0b2e6adb871a3b94$var$V;){
                    var f = $0b2e6adb871a3b94$var$V, g = f.child;
                    if (0 !== ($0b2e6adb871a3b94$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($0b2e6adb871a3b94$var$V = l; null !== $0b2e6adb871a3b94$var$V;){
                                    var m = $0b2e6adb871a3b94$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $0b2e6adb871a3b94$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $0b2e6adb871a3b94$var$V = q;
                                    else for(; null !== $0b2e6adb871a3b94$var$V;){
                                        m = $0b2e6adb871a3b94$var$V;
                                        var r = m.sibling, y = m.return;
                                        $0b2e6adb871a3b94$var$Tj(m);
                                        if (m === l) {
                                            $0b2e6adb871a3b94$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $0b2e6adb871a3b94$var$V = r;
                                            break;
                                        }
                                        $0b2e6adb871a3b94$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $0b2e6adb871a3b94$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $0b2e6adb871a3b94$var$V = g;
                    else b: for(; null !== $0b2e6adb871a3b94$var$V;){
                        f = $0b2e6adb871a3b94$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $0b2e6adb871a3b94$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $0b2e6adb871a3b94$var$V = x;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = f.return;
                    }
                }
                var w = a.current;
                for($0b2e6adb871a3b94$var$V = w; null !== $0b2e6adb871a3b94$var$V;){
                    g = $0b2e6adb871a3b94$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $0b2e6adb871a3b94$var$V = u;
                    else b: for(g = w; null !== $0b2e6adb871a3b94$var$V;){
                        h = $0b2e6adb871a3b94$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $0b2e6adb871a3b94$var$Rj(9, h);
                            }
                        } catch (na) {
                            $0b2e6adb871a3b94$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $0b2e6adb871a3b94$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $0b2e6adb871a3b94$var$V = F;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = h.return;
                    }
                }
                $0b2e6adb871a3b94$var$K = e;
                $0b2e6adb871a3b94$var$jg();
                if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot) try {
                    $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot($0b2e6adb871a3b94$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$pk.transition = b;
        }
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Yk(a, b, c) {
    b = $0b2e6adb871a3b94$var$Ki(c, b);
    b = $0b2e6adb871a3b94$var$Oi(a, b, 1);
    a = $0b2e6adb871a3b94$var$dh(a, b, 1);
    b = $0b2e6adb871a3b94$var$L();
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, 1, b), $0b2e6adb871a3b94$var$Ek(a, b));
}
function $0b2e6adb871a3b94$var$W(a, b, c) {
    if (3 === a.tag) $0b2e6adb871a3b94$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $0b2e6adb871a3b94$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $0b2e6adb871a3b94$var$Si || !$0b2e6adb871a3b94$var$Si.has(d))) {
                a = $0b2e6adb871a3b94$var$Ki(c, a);
                a = $0b2e6adb871a3b94$var$Ri(b, a, 1);
                b = $0b2e6adb871a3b94$var$dh(b, a, 1);
                a = $0b2e6adb871a3b94$var$L();
                null !== b && ($0b2e6adb871a3b94$var$Ac(b, 1, a), $0b2e6adb871a3b94$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $0b2e6adb871a3b94$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $0b2e6adb871a3b94$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $0b2e6adb871a3b94$var$R === a && ($0b2e6adb871a3b94$var$Z & c) === c && (4 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$Z & 130023424) === $0b2e6adb871a3b94$var$Z && 500 > $0b2e6adb871a3b94$var$B() - $0b2e6adb871a3b94$var$gk ? $0b2e6adb871a3b94$var$Lk(a, 0) : $0b2e6adb871a3b94$var$sk |= c);
    $0b2e6adb871a3b94$var$Ek(a, b);
}
function $0b2e6adb871a3b94$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $0b2e6adb871a3b94$var$sc, $0b2e6adb871a3b94$var$sc <<= 1, 0 === ($0b2e6adb871a3b94$var$sc & 130023424) && ($0b2e6adb871a3b94$var$sc = 4194304)));
    var c = $0b2e6adb871a3b94$var$L();
    a = $0b2e6adb871a3b94$var$Zg(a, b);
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, b, c), $0b2e6adb871a3b94$var$Ek(a, c));
}
function $0b2e6adb871a3b94$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $0b2e6adb871a3b94$var$Zk(a, c);
}
function $0b2e6adb871a3b94$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($0b2e6adb871a3b94$var$p(314));
    }
    null !== d && d.delete(b);
    $0b2e6adb871a3b94$var$Zk(a, c);
}
var $0b2e6adb871a3b94$var$Wk;
$0b2e6adb871a3b94$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $0b2e6adb871a3b94$var$Wf.current) $0b2e6adb871a3b94$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $0b2e6adb871a3b94$var$Ug = !1, $0b2e6adb871a3b94$var$zj(a, b, c);
            $0b2e6adb871a3b94$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $0b2e6adb871a3b94$var$Ug = !1, $0b2e6adb871a3b94$var$I && 0 !== (b.flags & 1048576) && $0b2e6adb871a3b94$var$ug(b, $0b2e6adb871a3b94$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $0b2e6adb871a3b94$var$jj(a, b);
            a = b.pendingProps;
            var e = $0b2e6adb871a3b94$var$Yf(b, $0b2e6adb871a3b94$var$H.current);
            $0b2e6adb871a3b94$var$Tg(b, c);
            e = $0b2e6adb871a3b94$var$Xh(null, b, d, a, e, c);
            var f = $0b2e6adb871a3b94$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $0b2e6adb871a3b94$var$Zf(d) ? (f = !0, $0b2e6adb871a3b94$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $0b2e6adb871a3b94$var$ah(b), e.updater = $0b2e6adb871a3b94$var$nh, b.stateNode = e, e._reactInternals = b, $0b2e6adb871a3b94$var$rh(b, d, a, c), b = $0b2e6adb871a3b94$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $0b2e6adb871a3b94$var$I && f && $0b2e6adb871a3b94$var$vg(b), $0b2e6adb871a3b94$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $0b2e6adb871a3b94$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $0b2e6adb871a3b94$var$$k(d);
                a = $0b2e6adb871a3b94$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $0b2e6adb871a3b94$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $0b2e6adb871a3b94$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $0b2e6adb871a3b94$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $0b2e6adb871a3b94$var$aj(null, b, d, $0b2e6adb871a3b94$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($0b2e6adb871a3b94$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Lg(d, e), $0b2e6adb871a3b94$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Lg(d, e), $0b2e6adb871a3b94$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $0b2e6adb871a3b94$var$lj(b);
                if (null === a) throw Error($0b2e6adb871a3b94$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $0b2e6adb871a3b94$var$bh(a, b);
                $0b2e6adb871a3b94$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(423)), b);
                        b = $0b2e6adb871a3b94$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(424)), b);
                        b = $0b2e6adb871a3b94$var$mj(a, b, d, c, e);
                        break a;
                    } else for($0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.stateNode.containerInfo.firstChild), $0b2e6adb871a3b94$var$xg = b, $0b2e6adb871a3b94$var$I = !0, $0b2e6adb871a3b94$var$zg = null, c = $0b2e6adb871a3b94$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $0b2e6adb871a3b94$var$Ig();
                    if (d === e) {
                        b = $0b2e6adb871a3b94$var$$i(a, b, c);
                        break a;
                    }
                    $0b2e6adb871a3b94$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $0b2e6adb871a3b94$var$Kh(b), null === a && $0b2e6adb871a3b94$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $0b2e6adb871a3b94$var$Ef(d, e) ? g = null : null !== f && $0b2e6adb871a3b94$var$Ef(d, f) && (b.flags |= 32), $0b2e6adb871a3b94$var$hj(a, b), $0b2e6adb871a3b94$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $0b2e6adb871a3b94$var$Eg(b), null;
        case 13:
            return $0b2e6adb871a3b94$var$pj(a, b, c);
        case 4:
            return $0b2e6adb871a3b94$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $0b2e6adb871a3b94$var$Bh(b, null, d, c) : $0b2e6adb871a3b94$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Lg(d, e), $0b2e6adb871a3b94$var$Zi(a, b, d, e, c);
        case 7:
            return $0b2e6adb871a3b94$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $0b2e6adb871a3b94$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $0b2e6adb871a3b94$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($0b2e6adb871a3b94$var$He(f.value, g)) {
                        if (f.children === e.children && !$0b2e6adb871a3b94$var$Wf.current) {
                            b = $0b2e6adb871a3b94$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $0b2e6adb871a3b94$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $0b2e6adb871a3b94$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($0b2e6adb871a3b94$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $0b2e6adb871a3b94$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $0b2e6adb871a3b94$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $0b2e6adb871a3b94$var$Tg(b, c), e = $0b2e6adb871a3b94$var$Vg(e), d = d(e), b.flags |= 1, $0b2e6adb871a3b94$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $0b2e6adb871a3b94$var$Lg(d, b.pendingProps), e = $0b2e6adb871a3b94$var$Lg(d.type, e), $0b2e6adb871a3b94$var$aj(a, b, d, e, c);
        case 15:
            return $0b2e6adb871a3b94$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Lg(d, e), $0b2e6adb871a3b94$var$jj(a, b), b.tag = 1, $0b2e6adb871a3b94$var$Zf(d) ? (a = !0, $0b2e6adb871a3b94$var$cg(b)) : a = !1, $0b2e6adb871a3b94$var$Tg(b, c), $0b2e6adb871a3b94$var$ph(b, d, e), $0b2e6adb871a3b94$var$rh(b, d, e, c), $0b2e6adb871a3b94$var$kj(null, b, d, !0, a, c);
        case 19:
            return $0b2e6adb871a3b94$var$yj(a, b, c);
        case 22:
            return $0b2e6adb871a3b94$var$ej(a, b, c);
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
};
function $0b2e6adb871a3b94$var$Gk(a, b) {
    return $0b2e6adb871a3b94$var$ac(a, b);
}
function $0b2e6adb871a3b94$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $0b2e6adb871a3b94$var$Bg(a, b, c, d) {
    return new $0b2e6adb871a3b94$var$al(a, b, c, d);
}
function $0b2e6adb871a3b94$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $0b2e6adb871a3b94$var$$k(a) {
    if ("function" === typeof a) return $0b2e6adb871a3b94$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $0b2e6adb871a3b94$var$Da) return 11;
        if (a === $0b2e6adb871a3b94$var$Ga) return 14;
    }
    return 2;
}
function $0b2e6adb871a3b94$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $0b2e6adb871a3b94$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $0b2e6adb871a3b94$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $0b2e6adb871a3b94$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return $0b2e6adb871a3b94$var$Ah(c.children, e, f, b);
        case $0b2e6adb871a3b94$var$za:
            g = 8;
            e |= 8;
            break;
        case $0b2e6adb871a3b94$var$Aa:
            return a = $0b2e6adb871a3b94$var$Bg(12, c, b, e | 2), a.elementType = $0b2e6adb871a3b94$var$Aa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ea:
            return a = $0b2e6adb871a3b94$var$Bg(13, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Ea, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Fa:
            return a = $0b2e6adb871a3b94$var$Bg(19, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Fa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ia:
            return $0b2e6adb871a3b94$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $0b2e6adb871a3b94$var$Ba:
                    g = 10;
                    break a;
                case $0b2e6adb871a3b94$var$Ca:
                    g = 9;
                    break a;
                case $0b2e6adb871a3b94$var$Da:
                    g = 11;
                    break a;
                case $0b2e6adb871a3b94$var$Ga:
                    g = 14;
                    break a;
                case $0b2e6adb871a3b94$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($0b2e6adb871a3b94$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $0b2e6adb871a3b94$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $0b2e6adb871a3b94$var$Ah(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$qj(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(22, a, d, b);
    a.elementType = $0b2e6adb871a3b94$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $0b2e6adb871a3b94$var$xh(a, b, c) {
    a = $0b2e6adb871a3b94$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$zh(a, b, c) {
    b = $0b2e6adb871a3b94$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $0b2e6adb871a3b94$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $0b2e6adb871a3b94$var$zc(0);
    this.expirationTimes = $0b2e6adb871a3b94$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $0b2e6adb871a3b94$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $0b2e6adb871a3b94$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $0b2e6adb871a3b94$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $0b2e6adb871a3b94$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $0b2e6adb871a3b94$var$ah(f);
    return a;
}
function $0b2e6adb871a3b94$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $0b2e6adb871a3b94$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $0b2e6adb871a3b94$var$el(a) {
    if (!a) return $0b2e6adb871a3b94$var$Vf;
    a = a._reactInternals;
    a: {
        if ($0b2e6adb871a3b94$var$Vb(a) !== a || 1 !== a.tag) throw Error($0b2e6adb871a3b94$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($0b2e6adb871a3b94$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($0b2e6adb871a3b94$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($0b2e6adb871a3b94$var$Zf(c)) return $0b2e6adb871a3b94$var$bg(a, c, b);
    }
    return b;
}
function $0b2e6adb871a3b94$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $0b2e6adb871a3b94$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $0b2e6adb871a3b94$var$el(null);
    c = a.current;
    d = $0b2e6adb871a3b94$var$L();
    e = $0b2e6adb871a3b94$var$lh(c);
    f = $0b2e6adb871a3b94$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $0b2e6adb871a3b94$var$dh(c, f, e);
    a.current.lanes = e;
    $0b2e6adb871a3b94$var$Ac(a, e, d);
    $0b2e6adb871a3b94$var$Ek(a, d);
    return a;
}
function $0b2e6adb871a3b94$var$gl(a, b, c, d) {
    var e = b.current, f = $0b2e6adb871a3b94$var$L(), g = $0b2e6adb871a3b94$var$lh(e);
    c = $0b2e6adb871a3b94$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $0b2e6adb871a3b94$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $0b2e6adb871a3b94$var$dh(e, b, g);
    null !== a && ($0b2e6adb871a3b94$var$mh(a, e, g, f), $0b2e6adb871a3b94$var$eh(a, e, g));
    return g;
}
function $0b2e6adb871a3b94$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $0b2e6adb871a3b94$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $0b2e6adb871a3b94$var$jl(a, b) {
    $0b2e6adb871a3b94$var$il(a, b);
    (a = a.alternate) && $0b2e6adb871a3b94$var$il(a, b);
}
function $0b2e6adb871a3b94$var$kl() {
    return null;
}
var $0b2e6adb871a3b94$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $0b2e6adb871a3b94$var$ml(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$nl.prototype.render = $0b2e6adb871a3b94$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($0b2e6adb871a3b94$var$p(409));
    $0b2e6adb871a3b94$var$gl(a, b, null, null);
};
$0b2e6adb871a3b94$var$nl.prototype.unmount = $0b2e6adb871a3b94$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $0b2e6adb871a3b94$var$Sk(function() {
            $0b2e6adb871a3b94$var$gl(null, a, null, null);
        });
        b[$0b2e6adb871a3b94$var$uf] = null;
    }
};
function $0b2e6adb871a3b94$var$nl(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $0b2e6adb871a3b94$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $0b2e6adb871a3b94$var$Qc.length && 0 !== b && b < $0b2e6adb871a3b94$var$Qc[c].priority; c++);
        $0b2e6adb871a3b94$var$Qc.splice(c, 0, a);
        0 === c && $0b2e6adb871a3b94$var$Vc(a);
    }
};
function $0b2e6adb871a3b94$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $0b2e6adb871a3b94$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $0b2e6adb871a3b94$var$ql() {}
function $0b2e6adb871a3b94$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $0b2e6adb871a3b94$var$hl(g);
                f.call(a);
            };
        }
        var g = $0b2e6adb871a3b94$var$fl(b, d, a, 0, null, !1, !1, "", $0b2e6adb871a3b94$var$ql);
        a._reactRootContainer = g;
        a[$0b2e6adb871a3b94$var$uf] = g.current;
        $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
        $0b2e6adb871a3b94$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $0b2e6adb871a3b94$var$hl(k);
            h.call(a);
        };
    }
    var k = $0b2e6adb871a3b94$var$cl(a, 0, !1, null, null, !1, !1, "", $0b2e6adb871a3b94$var$ql);
    a._reactRootContainer = k;
    a[$0b2e6adb871a3b94$var$uf] = k.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    $0b2e6adb871a3b94$var$Sk(function() {
        $0b2e6adb871a3b94$var$gl(b, k, c, d);
    });
    return k;
}
function $0b2e6adb871a3b94$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $0b2e6adb871a3b94$var$hl(g);
                h.call(a);
            };
        }
        $0b2e6adb871a3b94$var$gl(b, g, a, e);
    } else g = $0b2e6adb871a3b94$var$rl(c, b, a, e, d);
    return $0b2e6adb871a3b94$var$hl(g);
}
$0b2e6adb871a3b94$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $0b2e6adb871a3b94$var$tc(b.pendingLanes);
                0 !== c && ($0b2e6adb871a3b94$var$Cc(b, c | 1), $0b2e6adb871a3b94$var$Ek(b, $0b2e6adb871a3b94$var$B()), 0 === ($0b2e6adb871a3b94$var$K & 6) && ($0b2e6adb871a3b94$var$Hj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$jg()));
            }
            break;
        case 13:
            $0b2e6adb871a3b94$var$Sk(function() {
                var b = $0b2e6adb871a3b94$var$Zg(a, 1);
                if (null !== b) {
                    var c = $0b2e6adb871a3b94$var$L();
                    $0b2e6adb871a3b94$var$mh(b, a, 1, c);
                }
            }), $0b2e6adb871a3b94$var$jl(a, 1);
    }
};
$0b2e6adb871a3b94$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $0b2e6adb871a3b94$var$L();
            $0b2e6adb871a3b94$var$mh(b, a, 134217728, c);
        }
        $0b2e6adb871a3b94$var$jl(a, 134217728);
    }
};
$0b2e6adb871a3b94$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$lh(a), c = $0b2e6adb871a3b94$var$Zg(a, b);
        if (null !== c) {
            var d = $0b2e6adb871a3b94$var$L();
            $0b2e6adb871a3b94$var$mh(c, a, b, d);
        }
        $0b2e6adb871a3b94$var$jl(a, b);
    }
};
$0b2e6adb871a3b94$var$Hc = function() {
    return $0b2e6adb871a3b94$var$C;
};
$0b2e6adb871a3b94$var$Ic = function(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    try {
        return $0b2e6adb871a3b94$var$C = a, b();
    } finally{
        $0b2e6adb871a3b94$var$C = c;
    }
};
$0b2e6adb871a3b94$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $0b2e6adb871a3b94$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $0b2e6adb871a3b94$var$Db(d);
                        if (!e) throw Error($0b2e6adb871a3b94$var$p(90));
                        $0b2e6adb871a3b94$var$Wa(d);
                        $0b2e6adb871a3b94$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $0b2e6adb871a3b94$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $0b2e6adb871a3b94$var$fb(a, !!c.multiple, b, !1);
    }
};
$0b2e6adb871a3b94$var$Gb = $0b2e6adb871a3b94$var$Rk;
$0b2e6adb871a3b94$var$Hb = $0b2e6adb871a3b94$var$Sk;
var $0b2e6adb871a3b94$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $0b2e6adb871a3b94$var$Cb,
        $0b2e6adb871a3b94$var$ue,
        $0b2e6adb871a3b94$var$Db,
        $0b2e6adb871a3b94$var$Eb,
        $0b2e6adb871a3b94$var$Fb,
        $0b2e6adb871a3b94$var$Rk
    ]
}, $0b2e6adb871a3b94$var$ul = {
    findFiberByHostInstance: $0b2e6adb871a3b94$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $0b2e6adb871a3b94$var$vl = {
    bundleType: $0b2e6adb871a3b94$var$ul.bundleType,
    version: $0b2e6adb871a3b94$var$ul.version,
    rendererPackageName: $0b2e6adb871a3b94$var$ul.rendererPackageName,
    rendererConfig: $0b2e6adb871a3b94$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $0b2e6adb871a3b94$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $0b2e6adb871a3b94$var$ul.findFiberByHostInstance || $0b2e6adb871a3b94$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $0b2e6adb871a3b94$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$0b2e6adb871a3b94$var$wl.isDisabled && $0b2e6adb871a3b94$var$wl.supportsFiber) try {
        $0b2e6adb871a3b94$var$kc = $0b2e6adb871a3b94$var$wl.inject($0b2e6adb871a3b94$var$vl), $0b2e6adb871a3b94$var$lc = $0b2e6adb871a3b94$var$wl;
    } catch (a) {}
}
$0b2e6adb871a3b94$export$ae55be85d98224ed = $0b2e6adb871a3b94$var$tl;
$0b2e6adb871a3b94$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$0b2e6adb871a3b94$var$ol(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$dl(a, b, null, c);
};
$0b2e6adb871a3b94$export$882461b6382ed46c = function(a, b) {
    if (!$0b2e6adb871a3b94$var$ol(a)) throw Error($0b2e6adb871a3b94$var$p(299));
    var c = !1, d = "", e = $0b2e6adb871a3b94$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $0b2e6adb871a3b94$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $0b2e6adb871a3b94$var$ml(b);
};
$0b2e6adb871a3b94$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($0b2e6adb871a3b94$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($0b2e6adb871a3b94$var$p(268, a));
    }
    a = $0b2e6adb871a3b94$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = function(a) {
    return $0b2e6adb871a3b94$var$Sk(a);
};
$0b2e6adb871a3b94$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$pl(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$sl(null, a, b, !0, c);
};
$0b2e6adb871a3b94$export$757ceba2d55c277e = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$ol(a)) throw Error($0b2e6adb871a3b94$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $0b2e6adb871a3b94$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $0b2e6adb871a3b94$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $0b2e6adb871a3b94$var$nl(b);
};
$0b2e6adb871a3b94$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$pl(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$sl(null, a, b, !1, c);
};
$0b2e6adb871a3b94$export$502457920280e6be = function(a) {
    if (!$0b2e6adb871a3b94$var$pl(a)) throw Error($0b2e6adb871a3b94$var$p(40));
    return a._reactRootContainer ? ($0b2e6adb871a3b94$var$Sk(function() {
        $0b2e6adb871a3b94$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$0b2e6adb871a3b94$var$uf] = null;
        });
    }), !0) : !1;
};
$0b2e6adb871a3b94$export$c78a37762a8d58e1 = $0b2e6adb871a3b94$var$Rk;
$0b2e6adb871a3b94$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$0b2e6adb871a3b94$var$pl(c)) throw Error($0b2e6adb871a3b94$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($0b2e6adb871a3b94$var$p(38));
    return $0b2e6adb871a3b94$var$sl(a, b, c, !1, d);
};
$0b2e6adb871a3b94$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRegister("fO90s", function(module, exports) {
"use strict";

module.exports = (parcelRequire("gcnCG"));

});
parcelRegister("gcnCG", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $bcb017604639e9d7$export$c4744153514ff05d, (v) => $bcb017604639e9d7$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $bcb017604639e9d7$export$3e506c1ccc9cc1a7, (v) => $bcb017604639e9d7$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $bcb017604639e9d7$export$e26fe2ed2fa76875, (v) => $bcb017604639e9d7$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $bcb017604639e9d7$export$502329bbf4b505b1, (v) => $bcb017604639e9d7$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $bcb017604639e9d7$export$6e3807111c4874c4, (v) => $bcb017604639e9d7$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $bcb017604639e9d7$export$c27134553091fb3a, (v) => $bcb017604639e9d7$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $bcb017604639e9d7$export$33ee1acdc04fd2a2, (v) => $bcb017604639e9d7$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $bcb017604639e9d7$export$b00a404bbd5edef2, (v) => $bcb017604639e9d7$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $bcb017604639e9d7$export$8352ce38b91d0c62, (v) => $bcb017604639e9d7$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $bcb017604639e9d7$export$d66a1c1c77bd778b, (v) => $bcb017604639e9d7$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $bcb017604639e9d7$export$d3dfb8e4810cb555, (v) => $bcb017604639e9d7$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $bcb017604639e9d7$export$839f9183b0465a69, (v) => $bcb017604639e9d7$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $bcb017604639e9d7$export$72fdf0e06517287b, (v) => $bcb017604639e9d7$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $bcb017604639e9d7$export$4b844e58a3e414b4, (v) => $bcb017604639e9d7$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $bcb017604639e9d7$export$816d2913ae6b83b1, (v) => $bcb017604639e9d7$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $bcb017604639e9d7$export$61bcfe829111a1d0, (v) => $bcb017604639e9d7$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $bcb017604639e9d7$export$7ee8c9beb337bc3f, (v) => $bcb017604639e9d7$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $bcb017604639e9d7$export$b5836b71941fa3ed, (v) => $bcb017604639e9d7$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $bcb017604639e9d7$export$cf845f2c119da08a, (v) => $bcb017604639e9d7$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bcb017604639e9d7$export$c4744153514ff05d;
var $bcb017604639e9d7$export$3e506c1ccc9cc1a7;
var $bcb017604639e9d7$export$e26fe2ed2fa76875;
var $bcb017604639e9d7$export$502329bbf4b505b1;
var $bcb017604639e9d7$export$6e3807111c4874c4;
var $bcb017604639e9d7$export$c27134553091fb3a;
var $bcb017604639e9d7$export$33ee1acdc04fd2a2;
var $bcb017604639e9d7$export$b00a404bbd5edef2;
var $bcb017604639e9d7$export$8352ce38b91d0c62;
var $bcb017604639e9d7$export$d66a1c1c77bd778b;
var $bcb017604639e9d7$export$d3dfb8e4810cb555;
var $bcb017604639e9d7$export$839f9183b0465a69;
var $bcb017604639e9d7$export$72fdf0e06517287b;
var $bcb017604639e9d7$export$4b844e58a3e414b4;
var $bcb017604639e9d7$export$816d2913ae6b83b1;
var $bcb017604639e9d7$export$61bcfe829111a1d0;
var $bcb017604639e9d7$export$7ee8c9beb337bc3f;
var $bcb017604639e9d7$export$b5836b71941fa3ed;
var $bcb017604639e9d7$export$cf845f2c119da08a;
"use strict";
function $bcb017604639e9d7$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $bcb017604639e9d7$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $bcb017604639e9d7$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $bcb017604639e9d7$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $bcb017604639e9d7$var$g(C, c)) n < e && 0 > $bcb017604639e9d7$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $bcb017604639e9d7$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $bcb017604639e9d7$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $bcb017604639e9d7$var$l = performance;
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$l.now();
    };
} else {
    var $bcb017604639e9d7$var$p = Date, $bcb017604639e9d7$var$q = $bcb017604639e9d7$var$p.now();
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$p.now() - $bcb017604639e9d7$var$q;
    };
}
var $bcb017604639e9d7$var$r = [], $bcb017604639e9d7$var$t = [], $bcb017604639e9d7$var$u = 1, $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = 3, $bcb017604639e9d7$var$z = !1, $bcb017604639e9d7$var$A = !1, $bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$D = "function" === typeof setTimeout ? setTimeout : null, $bcb017604639e9d7$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $bcb017604639e9d7$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $bcb017604639e9d7$var$G(a) {
    for(var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t); null !== b;){
        if (null === b.callback) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t);
        else if (b.startTime <= a) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t), b.sortIndex = b.expirationTime, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, b);
        else break;
        b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
    }
}
function $bcb017604639e9d7$var$H(a) {
    $bcb017604639e9d7$var$B = !1;
    $bcb017604639e9d7$var$G(a);
    if (!$bcb017604639e9d7$var$A) {
        if (null !== $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r)) $bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J);
        else {
            var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== b && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, b.startTime - a);
        }
    }
}
function $bcb017604639e9d7$var$J(a, b) {
    $bcb017604639e9d7$var$A = !1;
    $bcb017604639e9d7$var$B && ($bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1);
    $bcb017604639e9d7$var$z = !0;
    var c = $bcb017604639e9d7$var$y;
    try {
        $bcb017604639e9d7$var$G(b);
        for($bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r); null !== $bcb017604639e9d7$var$v && (!($bcb017604639e9d7$var$v.expirationTime > b) || a && !$bcb017604639e9d7$var$M());){
            var d = $bcb017604639e9d7$var$v.callback;
            if ("function" === typeof d) {
                $bcb017604639e9d7$var$v.callback = null;
                $bcb017604639e9d7$var$y = $bcb017604639e9d7$var$v.priorityLevel;
                var e = d($bcb017604639e9d7$var$v.expirationTime <= b);
                b = $bcb017604639e9d7$export$c4744153514ff05d();
                "function" === typeof e ? $bcb017604639e9d7$var$v.callback = e : $bcb017604639e9d7$var$v === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
                $bcb017604639e9d7$var$G(b);
            } else $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
            $bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
        }
        if (null !== $bcb017604639e9d7$var$v) var w = !0;
        else {
            var m = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== m && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = c, $bcb017604639e9d7$var$z = !1;
    }
}
var $bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null, $bcb017604639e9d7$var$L = -1, $bcb017604639e9d7$var$P = 5, $bcb017604639e9d7$var$Q = -1;
function $bcb017604639e9d7$var$M() {
    return $bcb017604639e9d7$export$c4744153514ff05d() - $bcb017604639e9d7$var$Q < $bcb017604639e9d7$var$P ? !1 : !0;
}
function $bcb017604639e9d7$var$R() {
    if (null !== $bcb017604639e9d7$var$O) {
        var a = $bcb017604639e9d7$export$c4744153514ff05d();
        $bcb017604639e9d7$var$Q = a;
        var b = !0;
        try {
            b = $bcb017604639e9d7$var$O(!0, a);
        } finally{
            b ? $bcb017604639e9d7$var$S() : ($bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null);
        }
    } else $bcb017604639e9d7$var$N = !1;
}
var $bcb017604639e9d7$var$S;
if ("function" === typeof $bcb017604639e9d7$var$F) $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$F($bcb017604639e9d7$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $bcb017604639e9d7$var$T = new MessageChannel, $bcb017604639e9d7$var$U = $bcb017604639e9d7$var$T.port2;
    $bcb017604639e9d7$var$T.port1.onmessage = $bcb017604639e9d7$var$R;
    $bcb017604639e9d7$var$S = function() {
        $bcb017604639e9d7$var$U.postMessage(null);
    };
} else $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$D($bcb017604639e9d7$var$R, 0);
};
function $bcb017604639e9d7$var$I(a) {
    $bcb017604639e9d7$var$O = a;
    $bcb017604639e9d7$var$N || ($bcb017604639e9d7$var$N = !0, $bcb017604639e9d7$var$S());
}
function $bcb017604639e9d7$var$K(a, b) {
    $bcb017604639e9d7$var$L = $bcb017604639e9d7$var$D(function() {
        a($bcb017604639e9d7$export$c4744153514ff05d());
    }, b);
}
$bcb017604639e9d7$export$3e506c1ccc9cc1a7 = 5;
$bcb017604639e9d7$export$e26fe2ed2fa76875 = 1;
$bcb017604639e9d7$export$502329bbf4b505b1 = 4;
$bcb017604639e9d7$export$6e3807111c4874c4 = 3;
$bcb017604639e9d7$export$c27134553091fb3a = null;
$bcb017604639e9d7$export$33ee1acdc04fd2a2 = 2;
$bcb017604639e9d7$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$bcb017604639e9d7$export$8352ce38b91d0c62 = function() {
    $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J));
};
$bcb017604639e9d7$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $bcb017604639e9d7$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$bcb017604639e9d7$export$d3dfb8e4810cb555 = function() {
    return $bcb017604639e9d7$var$y;
};
$bcb017604639e9d7$export$839f9183b0465a69 = function() {
    return $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
};
$bcb017604639e9d7$export$72fdf0e06517287b = function(a) {
    switch($bcb017604639e9d7$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $bcb017604639e9d7$var$y;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = b;
    try {
        return a();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$4b844e58a3e414b4 = function() {};
$bcb017604639e9d7$export$816d2913ae6b83b1 = function() {};
$bcb017604639e9d7$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = a;
    try {
        return b();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $bcb017604639e9d7$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $bcb017604639e9d7$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$t, a), null === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && a === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t) && ($bcb017604639e9d7$var$B ? ($bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1) : $bcb017604639e9d7$var$B = !0, $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, c - d))) : (a.sortIndex = e, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, a), $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J)));
    return a;
};
$bcb017604639e9d7$export$b5836b71941fa3ed = $bcb017604639e9d7$var$M;
$bcb017604639e9d7$export$cf845f2c119da08a = function(a) {
    var b = $bcb017604639e9d7$var$y;
    return function() {
        var c = $bcb017604639e9d7$var$y;
        $bcb017604639e9d7$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $bcb017604639e9d7$var$y = c;
        }
    };
};

});




parcelRegister("9UeUh", function(module, exports) {

$parcel$export(module.exports, "Slot", () => $cf381de56a25bc52$export$8c6ed5c666ac1360);
$parcel$export(module.exports, "Slottable", () => $cf381de56a25bc52$export$d9f1ccf0bdb05d45);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $htT6J = parcelRequire("htT6J");
/* -------------------------------------------------------------------------------------------------
 * Slot
 * -----------------------------------------------------------------------------------------------*/ const $cf381de56a25bc52$export$8c6ed5c666ac1360 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { children: children, ...slotProps } = props;
    const childrenArray = (0, $acw62.Children).toArray(children);
    const slottable = childrenArray.find($cf381de56a25bc52$var$$5e63c961fc1ce211$var$isSlottable);
    if (slottable) {
        // the new element to render is the one passed as a child of `Slottable`
        const newElement = slottable.props.children;
        const newChildren = childrenArray.map((child)=>{
            if (child === slottable) {
                // because the new element will be the one rendered, we are only interested
                // in grabbing its children (`newElement.props.children`)
                if ((0, $acw62.Children).count(newElement) > 1) return (0, $acw62.Children).only(null);
                return /*#__PURE__*/ (0, $acw62.isValidElement)(newElement) ? newElement.props.children : null;
            } else return child;
        });
        return /*#__PURE__*/ (0, $acw62.createElement)($cf381de56a25bc52$var$$5e63c961fc1ce211$var$SlotClone, (0, $8nd05.default)({}, slotProps, {
            ref: forwardedRef
        }), /*#__PURE__*/ (0, $acw62.isValidElement)(newElement) ? /*#__PURE__*/ (0, $acw62.cloneElement)(newElement, undefined, newChildren) : null);
    }
    return /*#__PURE__*/ (0, $acw62.createElement)($cf381de56a25bc52$var$$5e63c961fc1ce211$var$SlotClone, (0, $8nd05.default)({}, slotProps, {
        ref: forwardedRef
    }), children);
});
$cf381de56a25bc52$export$8c6ed5c666ac1360.displayName = "Slot";
/* -------------------------------------------------------------------------------------------------
 * SlotClone
 * -----------------------------------------------------------------------------------------------*/ const $cf381de56a25bc52$var$$5e63c961fc1ce211$var$SlotClone = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { children: children, ...slotProps } = props;
    if (/*#__PURE__*/ (0, $acw62.isValidElement)(children)) return /*#__PURE__*/ (0, $acw62.cloneElement)(children, {
        ...$cf381de56a25bc52$var$$5e63c961fc1ce211$var$mergeProps(slotProps, children.props),
        ref: forwardedRef ? (0, $htT6J.composeRefs)(forwardedRef, children.ref) : children.ref
    });
    return (0, $acw62.Children).count(children) > 1 ? (0, $acw62.Children).only(null) : null;
});
$cf381de56a25bc52$var$$5e63c961fc1ce211$var$SlotClone.displayName = "SlotClone";
/* -------------------------------------------------------------------------------------------------
 * Slottable
 * -----------------------------------------------------------------------------------------------*/ const $cf381de56a25bc52$export$d9f1ccf0bdb05d45 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $acw62.Fragment), null, children);
};
/* ---------------------------------------------------------------------------------------------- */ function $cf381de56a25bc52$var$$5e63c961fc1ce211$var$isSlottable(child) {
    return /*#__PURE__*/ (0, $acw62.isValidElement)(child) && child.type === $cf381de56a25bc52$export$d9f1ccf0bdb05d45;
}
function $cf381de56a25bc52$var$$5e63c961fc1ce211$var$mergeProps(slotProps, childProps) {
    // all child props should override
    const overrideProps = {
        ...childProps
    };
    for(const propName in childProps){
        const slotPropValue = slotProps[propName];
        const childPropValue = childProps[propName];
        const isHandler = /^on[A-Z]/.test(propName);
        if (isHandler) {
            // if the handler exists on both, we compose them
            if (slotPropValue && childPropValue) overrideProps[propName] = (...args)=>{
                childPropValue(...args);
                slotPropValue(...args);
            };
            else if (slotPropValue) overrideProps[propName] = slotPropValue;
        } else if (propName === "style") overrideProps[propName] = {
            ...slotPropValue,
            ...childPropValue
        };
        else if (propName === "className") overrideProps[propName] = [
            slotPropValue,
            childPropValue
        ].filter(Boolean).join(" ");
    }
    return {
        ...slotProps,
        ...overrideProps
    };
}
const $cf381de56a25bc52$export$be92b6f5f03c0fe9 = $cf381de56a25bc52$export$8c6ed5c666ac1360;

});


parcelRegister("e1oKh", function(module, exports) {

$parcel$export(module.exports, "useEscapeKeydown", () => $322b9f9e9e453dd6$export$3a72a57244d6e765);

var $acw62 = parcelRequire("acw62");

var $by19I = parcelRequire("by19I");
/**
 * Listens for when the escape key is down
 */ function $322b9f9e9e453dd6$export$3a72a57244d6e765(onEscapeKeyDownProp, ownerDocument = globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) {
    const onEscapeKeyDown = (0, $by19I.useCallbackRef)(onEscapeKeyDownProp);
    (0, $acw62.useEffect)(()=>{
        const handleKeyDown = (event)=>{
            if (event.key === "Escape") onEscapeKeyDown(event);
        };
        ownerDocument.addEventListener("keydown", handleKeyDown);
        return ()=>ownerDocument.removeEventListener("keydown", handleKeyDown);
    }, [
        onEscapeKeyDown,
        ownerDocument
    ]);
}

});


parcelRegister("kNgwr", function(module, exports) {

$parcel$export(module.exports, "FocusScope", () => $03c48a27777929a8$export$20e40289641fbbb6);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $htT6J = parcelRequire("htT6J");

var $kFbxc = parcelRequire("kFbxc");

var $by19I = parcelRequire("by19I");
const $03c48a27777929a8$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT = "focusScope.autoFocusOnMount";
const $03c48a27777929a8$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT = "focusScope.autoFocusOnUnmount";
const $03c48a27777929a8$var$$d3863c46a17e8a28$var$EVENT_OPTIONS = {
    bubbles: false,
    cancelable: true
};
/* -------------------------------------------------------------------------------------------------
 * FocusScope
 * -----------------------------------------------------------------------------------------------*/ const $03c48a27777929a8$var$$d3863c46a17e8a28$var$FOCUS_SCOPE_NAME = "FocusScope";
const $03c48a27777929a8$export$20e40289641fbbb6 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { loop: loop = false, trapped: trapped = false, onMountAutoFocus: onMountAutoFocusProp, onUnmountAutoFocus: onUnmountAutoFocusProp, ...scopeProps } = props;
    const [container1, setContainer] = (0, $acw62.useState)(null);
    const onMountAutoFocus = (0, $by19I.useCallbackRef)(onMountAutoFocusProp);
    const onUnmountAutoFocus = (0, $by19I.useCallbackRef)(onUnmountAutoFocusProp);
    const lastFocusedElementRef = (0, $acw62.useRef)(null);
    const composedRefs = (0, $htT6J.useComposedRefs)(forwardedRef, (node)=>setContainer(node));
    const focusScope = (0, $acw62.useRef)({
        paused: false,
        pause () {
            this.paused = true;
        },
        resume () {
            this.paused = false;
        }
    }).current; // Takes care of trapping focus if focus is moved outside programmatically for example
    (0, $acw62.useEffect)(()=>{
        if (trapped) {
            function handleFocusIn(event) {
                if (focusScope.paused || !container1) return;
                const target = event.target;
                if (container1.contains(target)) lastFocusedElementRef.current = target;
                else $03c48a27777929a8$var$$d3863c46a17e8a28$var$focus(lastFocusedElementRef.current, {
                    select: true
                });
            }
            function handleFocusOut(event) {
                if (focusScope.paused || !container1) return;
                const relatedTarget = event.relatedTarget; // A `focusout` event with a `null` `relatedTarget` will happen in at least two cases:
                //
                // 1. When the user switches app/tabs/windows/the browser itself loses focus.
                // 2. In Google Chrome, when the focused element is removed from the DOM.
                //
                // We let the browser do its thing here because:
                //
                // 1. The browser already keeps a memory of what's focused for when the page gets refocused.
                // 2. In Google Chrome, if we try to focus the deleted focused element (as per below), it
                //    throws the CPU to 100%, so we avoid doing anything for this reason here too.
                if (relatedTarget === null) return; // If the focus has moved to an actual legitimate element (`relatedTarget !== null`)
                // that is outside the container, we move focus to the last valid focused element inside.
                if (!container1.contains(relatedTarget)) $03c48a27777929a8$var$$d3863c46a17e8a28$var$focus(lastFocusedElementRef.current, {
                    select: true
                });
            } // When the focused element gets removed from the DOM, browsers move focus
            // back to the document.body. In this case, we move focus to the container
            // to keep focus trapped correctly.
            function handleMutations(mutations) {
                const focusedElement = document.activeElement;
                if (focusedElement !== document.body) return;
                for (const mutation of mutations)if (mutation.removedNodes.length > 0) $03c48a27777929a8$var$$d3863c46a17e8a28$var$focus(container1);
            }
            document.addEventListener("focusin", handleFocusIn);
            document.addEventListener("focusout", handleFocusOut);
            const mutationObserver = new MutationObserver(handleMutations);
            if (container1) mutationObserver.observe(container1, {
                childList: true,
                subtree: true
            });
            return ()=>{
                document.removeEventListener("focusin", handleFocusIn);
                document.removeEventListener("focusout", handleFocusOut);
                mutationObserver.disconnect();
            };
        }
    }, [
        trapped,
        container1,
        focusScope.paused
    ]);
    (0, $acw62.useEffect)(()=>{
        if (container1) {
            $03c48a27777929a8$var$$d3863c46a17e8a28$var$focusScopesStack.add(focusScope);
            const previouslyFocusedElement = document.activeElement;
            const hasFocusedCandidate = container1.contains(previouslyFocusedElement);
            if (!hasFocusedCandidate) {
                const mountEvent = new CustomEvent($03c48a27777929a8$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT, $03c48a27777929a8$var$$d3863c46a17e8a28$var$EVENT_OPTIONS);
                container1.addEventListener($03c48a27777929a8$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT, onMountAutoFocus);
                container1.dispatchEvent(mountEvent);
                if (!mountEvent.defaultPrevented) {
                    $03c48a27777929a8$var$$d3863c46a17e8a28$var$focusFirst($03c48a27777929a8$var$$d3863c46a17e8a28$var$removeLinks($03c48a27777929a8$var$$d3863c46a17e8a28$var$getTabbableCandidates(container1)), {
                        select: true
                    });
                    if (document.activeElement === previouslyFocusedElement) $03c48a27777929a8$var$$d3863c46a17e8a28$var$focus(container1);
                }
            }
            return ()=>{
                container1.removeEventListener($03c48a27777929a8$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT, onMountAutoFocus); // We hit a react bug (fixed in v17) with focusing in unmount.
                // We need to delay the focus a little to get around it for now.
                // See: https://github.com/facebook/react/issues/17894
                setTimeout(()=>{
                    const unmountEvent = new CustomEvent($03c48a27777929a8$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT, $03c48a27777929a8$var$$d3863c46a17e8a28$var$EVENT_OPTIONS);
                    container1.addEventListener($03c48a27777929a8$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
                    container1.dispatchEvent(unmountEvent);
                    if (!unmountEvent.defaultPrevented) $03c48a27777929a8$var$$d3863c46a17e8a28$var$focus(previouslyFocusedElement !== null && previouslyFocusedElement !== void 0 ? previouslyFocusedElement : document.body, {
                        select: true
                    });
                    // we need to remove the listener after we `dispatchEvent`
                    container1.removeEventListener($03c48a27777929a8$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
                    $03c48a27777929a8$var$$d3863c46a17e8a28$var$focusScopesStack.remove(focusScope);
                }, 0);
            };
        }
    }, [
        container1,
        onMountAutoFocus,
        onUnmountAutoFocus,
        focusScope
    ]); // Takes care of looping focus (when tabbing whilst at the edges)
    const handleKeyDown = (0, $acw62.useCallback)((event)=>{
        if (!loop && !trapped) return;
        if (focusScope.paused) return;
        const isTabKey = event.key === "Tab" && !event.altKey && !event.ctrlKey && !event.metaKey;
        const focusedElement = document.activeElement;
        if (isTabKey && focusedElement) {
            const container = event.currentTarget;
            const [first, last] = $03c48a27777929a8$var$$d3863c46a17e8a28$var$getTabbableEdges(container);
            const hasTabbableElementsInside = first && last; // we can only wrap focus if we have tabbable edges
            if (!hasTabbableElementsInside) {
                if (focusedElement === container) event.preventDefault();
            } else {
                if (!event.shiftKey && focusedElement === last) {
                    event.preventDefault();
                    if (loop) $03c48a27777929a8$var$$d3863c46a17e8a28$var$focus(first, {
                        select: true
                    });
                } else if (event.shiftKey && focusedElement === first) {
                    event.preventDefault();
                    if (loop) $03c48a27777929a8$var$$d3863c46a17e8a28$var$focus(last, {
                        select: true
                    });
                }
            }
        }
    }, [
        loop,
        trapped,
        focusScope.paused
    ]);
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $kFbxc.Primitive).div, (0, $8nd05.default)({
        tabIndex: -1
    }, scopeProps, {
        ref: composedRefs,
        onKeyDown: handleKeyDown
    }));
});
/*#__PURE__*/ Object.assign($03c48a27777929a8$export$20e40289641fbbb6, {
    displayName: $03c48a27777929a8$var$$d3863c46a17e8a28$var$FOCUS_SCOPE_NAME
});
/* -------------------------------------------------------------------------------------------------
 * Utils
 * -----------------------------------------------------------------------------------------------*/ /**
 * Attempts focusing the first element in a list of candidates.
 * Stops when focus has actually moved.
 */ function $03c48a27777929a8$var$$d3863c46a17e8a28$var$focusFirst(candidates, { select: select = false } = {}) {
    const previouslyFocusedElement = document.activeElement;
    for (const candidate of candidates){
        $03c48a27777929a8$var$$d3863c46a17e8a28$var$focus(candidate, {
            select: select
        });
        if (document.activeElement !== previouslyFocusedElement) return;
    }
}
/**
 * Returns the first and last tabbable elements inside a container.
 */ function $03c48a27777929a8$var$$d3863c46a17e8a28$var$getTabbableEdges(container) {
    const candidates = $03c48a27777929a8$var$$d3863c46a17e8a28$var$getTabbableCandidates(container);
    const first = $03c48a27777929a8$var$$d3863c46a17e8a28$var$findVisible(candidates, container);
    const last = $03c48a27777929a8$var$$d3863c46a17e8a28$var$findVisible(candidates.reverse(), container);
    return [
        first,
        last
    ];
}
/**
 * Returns a list of potential tabbable candidates.
 *
 * NOTE: This is only a close approximation. For example it doesn't take into account cases like when
 * elements are not visible. This cannot be worked out easily by just reading a property, but rather
 * necessitate runtime knowledge (computed styles, etc). We deal with these cases separately.
 *
 * See: https://developer.mozilla.org/en-US/docs/Web/API/TreeWalker
 * Credit: https://github.com/discord/focus-layers/blob/master/src/util/wrapFocus.tsx#L1
 */ function $03c48a27777929a8$var$$d3863c46a17e8a28$var$getTabbableCandidates(container) {
    const nodes = [];
    const walker = document.createTreeWalker(container, NodeFilter.SHOW_ELEMENT, {
        acceptNode: (node)=>{
            const isHiddenInput = node.tagName === "INPUT" && node.type === "hidden";
            if (node.disabled || node.hidden || isHiddenInput) return NodeFilter.FILTER_SKIP; // `.tabIndex` is not the same as the `tabindex` attribute. It works on the
            // runtime's understanding of tabbability, so this automatically accounts
            // for any kind of element that could be tabbed to.
            return node.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
        }
    });
    while(walker.nextNode())nodes.push(walker.currentNode); // we do not take into account the order of nodes with positive `tabIndex` as it
    // hinders accessibility to have tab order different from visual order.
    return nodes;
}
/**
 * Returns the first visible element in a list.
 * NOTE: Only checks visibility up to the `container`.
 */ function $03c48a27777929a8$var$$d3863c46a17e8a28$var$findVisible(elements, container) {
    for (const element of elements){
        // we stop checking if it's hidden at the `container` level (excluding)
        if (!$03c48a27777929a8$var$$d3863c46a17e8a28$var$isHidden(element, {
            upTo: container
        })) return element;
    }
}
function $03c48a27777929a8$var$$d3863c46a17e8a28$var$isHidden(node, { upTo: upTo }) {
    if (getComputedStyle(node).visibility === "hidden") return true;
    while(node){
        // we stop at `upTo` (excluding it)
        if (upTo !== undefined && node === upTo) return false;
        if (getComputedStyle(node).display === "none") return true;
        node = node.parentElement;
    }
    return false;
}
function $03c48a27777929a8$var$$d3863c46a17e8a28$var$isSelectableInput(element) {
    return element instanceof HTMLInputElement && "select" in element;
}
function $03c48a27777929a8$var$$d3863c46a17e8a28$var$focus(element, { select: select = false } = {}) {
    // only focus if that element is focusable
    if (element && element.focus) {
        const previouslyFocusedElement = document.activeElement; // NOTE: we prevent scrolling on focus, to minimize jarring transitions for users
        element.focus({
            preventScroll: true
        }); // only select if its not the same element, it supports selection and we need to select
        if (element !== previouslyFocusedElement && $03c48a27777929a8$var$$d3863c46a17e8a28$var$isSelectableInput(element) && select) element.select();
    }
}
/* -------------------------------------------------------------------------------------------------
 * FocusScope stack
 * -----------------------------------------------------------------------------------------------*/ const $03c48a27777929a8$var$$d3863c46a17e8a28$var$focusScopesStack = $03c48a27777929a8$var$$d3863c46a17e8a28$var$createFocusScopesStack();
function $03c48a27777929a8$var$$d3863c46a17e8a28$var$createFocusScopesStack() {
    /** A stack of focus scopes, with the active one at the top */ let stack = [];
    return {
        add (focusScope) {
            // pause the currently active focus scope (at the top of the stack)
            const activeFocusScope = stack[0];
            if (focusScope !== activeFocusScope) activeFocusScope === null || activeFocusScope === void 0 || activeFocusScope.pause();
            // remove in case it already exists (because we'll re-add it at the top of the stack)
            stack = $03c48a27777929a8$var$$d3863c46a17e8a28$var$arrayRemove(stack, focusScope);
            stack.unshift(focusScope);
        },
        remove (focusScope) {
            var _stack$;
            stack = $03c48a27777929a8$var$$d3863c46a17e8a28$var$arrayRemove(stack, focusScope);
            (_stack$ = stack[0]) === null || _stack$ === void 0 || _stack$.resume();
        }
    };
}
function $03c48a27777929a8$var$$d3863c46a17e8a28$var$arrayRemove(array, item) {
    const updatedArray = [
        ...array
    ];
    const index = updatedArray.indexOf(item);
    if (index !== -1) updatedArray.splice(index, 1);
    return updatedArray;
}
function $03c48a27777929a8$var$$d3863c46a17e8a28$var$removeLinks(items) {
    return items.filter((item)=>item.tagName !== "A");
}
const $03c48a27777929a8$export$be92b6f5f03c0fe9 = $03c48a27777929a8$export$20e40289641fbbb6;

});

parcelRegister("5nYva", function(module, exports) {

$parcel$export(module.exports, "Portal", () => $95d053caea9c023a$export$602eac185826482c);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $kFbxc = parcelRequire("kFbxc");
/* -------------------------------------------------------------------------------------------------
 * Portal
 * -----------------------------------------------------------------------------------------------*/ const $95d053caea9c023a$var$$f1701beae083dbae$var$PORTAL_NAME = "Portal";
const $95d053caea9c023a$export$602eac185826482c = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    var _globalThis$document;
    const { container: container = globalThis === null || globalThis === void 0 ? void 0 : (_globalThis$document = globalThis.document) === null || _globalThis$document === void 0 ? void 0 : _globalThis$document.body, ...portalProps } = props;
    return container ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).createPortal(/*#__PURE__*/ (0, $acw62.createElement)((0, $kFbxc.Primitive).div, (0, $8nd05.default)({}, portalProps, {
        ref: forwardedRef
    })), container) : null;
});
/*#__PURE__*/ Object.assign($95d053caea9c023a$export$602eac185826482c, {
    displayName: $95d053caea9c023a$var$$f1701beae083dbae$var$PORTAL_NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $95d053caea9c023a$export$be92b6f5f03c0fe9 = $95d053caea9c023a$export$602eac185826482c;

});

parcelRegister("cTFdF", function(module, exports) {

$parcel$export(module.exports, "Presence", () => $3207c0aa9f229d8f$export$99c2b779aa4e8b8b);

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $htT6J = parcelRequire("htT6J");

var $7g00o = parcelRequire("7g00o");
function $3207c0aa9f229d8f$var$$fe963b355347cc68$export$3e6543de14f8614f(initialState, machine) {
    return (0, $acw62.useReducer)((state, event)=>{
        const nextState = machine[state][event];
        return nextState !== null && nextState !== void 0 ? nextState : state;
    }, initialState);
}
const $3207c0aa9f229d8f$export$99c2b779aa4e8b8b = (props)=>{
    const { present: present, children: children } = props;
    const presence = $3207c0aa9f229d8f$var$$921a889cee6df7e8$var$usePresence(present);
    const child = typeof children === "function" ? children({
        present: presence.isPresent
    }) : (0, $acw62.Children).only(children);
    const ref = (0, $htT6J.useComposedRefs)(presence.ref, child.ref);
    const forceMount = typeof children === "function";
    return forceMount || presence.isPresent ? /*#__PURE__*/ (0, $acw62.cloneElement)(child, {
        ref: ref
    }) : null;
};
$3207c0aa9f229d8f$export$99c2b779aa4e8b8b.displayName = "Presence";
/* -------------------------------------------------------------------------------------------------
 * usePresence
 * -----------------------------------------------------------------------------------------------*/ function $3207c0aa9f229d8f$var$$921a889cee6df7e8$var$usePresence(present) {
    const [node1, setNode] = (0, $acw62.useState)();
    const stylesRef = (0, $acw62.useRef)({});
    const prevPresentRef = (0, $acw62.useRef)(present);
    const prevAnimationNameRef = (0, $acw62.useRef)("none");
    const initialState = present ? "mounted" : "unmounted";
    const [state, send] = $3207c0aa9f229d8f$var$$fe963b355347cc68$export$3e6543de14f8614f(initialState, {
        mounted: {
            UNMOUNT: "unmounted",
            ANIMATION_OUT: "unmountSuspended"
        },
        unmountSuspended: {
            MOUNT: "mounted",
            ANIMATION_END: "unmounted"
        },
        unmounted: {
            MOUNT: "mounted"
        }
    });
    (0, $acw62.useEffect)(()=>{
        const currentAnimationName = $3207c0aa9f229d8f$var$$921a889cee6df7e8$var$getAnimationName(stylesRef.current);
        prevAnimationNameRef.current = state === "mounted" ? currentAnimationName : "none";
    }, [
        state
    ]);
    (0, $7g00o.useLayoutEffect)(()=>{
        const styles = stylesRef.current;
        const wasPresent = prevPresentRef.current;
        const hasPresentChanged = wasPresent !== present;
        if (hasPresentChanged) {
            const prevAnimationName = prevAnimationNameRef.current;
            const currentAnimationName = $3207c0aa9f229d8f$var$$921a889cee6df7e8$var$getAnimationName(styles);
            if (present) send("MOUNT");
            else if (currentAnimationName === "none" || (styles === null || styles === void 0 ? void 0 : styles.display) === "none") // so we unmount instantly
            send("UNMOUNT");
            else {
                /**
         * When `present` changes to `false`, we check changes to animation-name to
         * determine whether an animation has started. We chose this approach (reading
         * computed styles) because there is no `animationrun` event and `animationstart`
         * fires after `animation-delay` has expired which would be too late.
         */ const isAnimating = prevAnimationName !== currentAnimationName;
                if (wasPresent && isAnimating) send("ANIMATION_OUT");
                else send("UNMOUNT");
            }
            prevPresentRef.current = present;
        }
    }, [
        present,
        send
    ]);
    (0, $7g00o.useLayoutEffect)(()=>{
        if (node1) {
            /**
       * Triggering an ANIMATION_OUT during an ANIMATION_IN will fire an `animationcancel`
       * event for ANIMATION_IN after we have entered `unmountSuspended` state. So, we
       * make sure we only trigger ANIMATION_END for the currently active animation.
       */ const handleAnimationEnd = (event)=>{
                const currentAnimationName = $3207c0aa9f229d8f$var$$921a889cee6df7e8$var$getAnimationName(stylesRef.current);
                const isCurrentAnimation = currentAnimationName.includes(event.animationName);
                if (event.target === node1 && isCurrentAnimation) // a frame after the animation ends, creating a flash of visible content.
                // By manually flushing we ensure they sync within a frame, removing the flash.
                (0, $1u0KT.flushSync)(()=>send("ANIMATION_END"));
            };
            const handleAnimationStart = (event)=>{
                if (event.target === node1) prevAnimationNameRef.current = $3207c0aa9f229d8f$var$$921a889cee6df7e8$var$getAnimationName(stylesRef.current);
            };
            node1.addEventListener("animationstart", handleAnimationStart);
            node1.addEventListener("animationcancel", handleAnimationEnd);
            node1.addEventListener("animationend", handleAnimationEnd);
            return ()=>{
                node1.removeEventListener("animationstart", handleAnimationStart);
                node1.removeEventListener("animationcancel", handleAnimationEnd);
                node1.removeEventListener("animationend", handleAnimationEnd);
            };
        } else // We avoid doing so during cleanup as the node may change but still exist.
        send("ANIMATION_END");
    }, [
        node1,
        send
    ]);
    return {
        isPresent: [
            "mounted",
            "unmountSuspended"
        ].includes(state),
        ref: (0, $acw62.useCallback)((node)=>{
            if (node) stylesRef.current = getComputedStyle(node);
            setNode(node);
        }, [])
    };
}
/* -----------------------------------------------------------------------------------------------*/ function $3207c0aa9f229d8f$var$$921a889cee6df7e8$var$getAnimationName(styles) {
    return (styles === null || styles === void 0 ? void 0 : styles.animationName) || "none";
}

});

parcelRegister("fg1c6", function(module, exports) {

$parcel$export(module.exports, "useFocusGuards", () => $264faec0fdf8876a$export$b7ece24a22aeda8c);

var $acw62 = parcelRequire("acw62");
/** Number of components which have requested interest to have focus guards */ let $264faec0fdf8876a$var$$3db38b7d1fb3fe6a$var$count = 0;
function $264faec0fdf8876a$export$ac5b58043b79449b(props) {
    $264faec0fdf8876a$export$b7ece24a22aeda8c();
    return props.children;
}
/**
 * Injects a pair of focus guards at the edges of the whole DOM tree
 * to ensure `focusin` & `focusout` events can be caught consistently.
 */ function $264faec0fdf8876a$export$b7ece24a22aeda8c() {
    (0, $acw62.useEffect)(()=>{
        var _edgeGuards$, _edgeGuards$2;
        const edgeGuards = document.querySelectorAll("[data-radix-focus-guard]");
        document.body.insertAdjacentElement("afterbegin", (_edgeGuards$ = edgeGuards[0]) !== null && _edgeGuards$ !== void 0 ? _edgeGuards$ : $264faec0fdf8876a$var$$3db38b7d1fb3fe6a$var$createFocusGuard());
        document.body.insertAdjacentElement("beforeend", (_edgeGuards$2 = edgeGuards[1]) !== null && _edgeGuards$2 !== void 0 ? _edgeGuards$2 : $264faec0fdf8876a$var$$3db38b7d1fb3fe6a$var$createFocusGuard());
        $264faec0fdf8876a$var$$3db38b7d1fb3fe6a$var$count++;
        return ()=>{
            if ($264faec0fdf8876a$var$$3db38b7d1fb3fe6a$var$count === 1) document.querySelectorAll("[data-radix-focus-guard]").forEach((node)=>node.remove());
            $264faec0fdf8876a$var$$3db38b7d1fb3fe6a$var$count--;
        };
    }, []);
}
function $264faec0fdf8876a$var$$3db38b7d1fb3fe6a$var$createFocusGuard() {
    const element = document.createElement("span");
    element.setAttribute("data-radix-focus-guard", "");
    element.tabIndex = 0;
    element.style.cssText = "outline: none; opacity: 0; position: fixed; pointer-events: none";
    return element;
}
const $264faec0fdf8876a$export$be92b6f5f03c0fe9 = $264faec0fdf8876a$export$ac5b58043b79449b;

});

parcelRegister("hPyeV", function(module, exports) {

$parcel$export(module.exports, "default", () => $cfb1c25e3ef3d3bc$export$2e2bcd8739ae039);

var $7WQrb = parcelRequire("7WQrb");

var $acw62 = parcelRequire("acw62");

var $hphuJ = parcelRequire("hphuJ");

var $1fmze = parcelRequire("1fmze");
var $cfb1c25e3ef3d3bc$var$ReactRemoveScroll = $acw62.forwardRef(function(props, ref) {
    return $acw62.createElement((0, $hphuJ.RemoveScroll), (0, $7WQrb.__assign)({}, props, {
        ref: ref,
        sideCar: (0, $1fmze.default)
    }));
});
$cfb1c25e3ef3d3bc$var$ReactRemoveScroll.classNames = (0, $hphuJ.RemoveScroll).classNames;
var $cfb1c25e3ef3d3bc$export$2e2bcd8739ae039 = $cfb1c25e3ef3d3bc$var$ReactRemoveScroll;

});
parcelRegister("7WQrb", function(module, exports) {

$parcel$export(module.exports, "__extends", () => $5c96a02c592fcff1$export$a8ba968b8961cb8a);
$parcel$export(module.exports, "__assign", () => $5c96a02c592fcff1$export$18ce0697a983be9b);
$parcel$export(module.exports, "__rest", () => $5c96a02c592fcff1$export$3c9a16f847548506);
$parcel$export(module.exports, "__read", () => $5c96a02c592fcff1$export$8d051b38c9118094);
$parcel$export(module.exports, "__spreadArray", () => $5c96a02c592fcff1$export$1216008129fb82ed);
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $5c96a02c592fcff1$var$extendStatics = function(d, b) {
    $5c96a02c592fcff1$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $5c96a02c592fcff1$var$extendStatics(d, b);
};
function $5c96a02c592fcff1$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $5c96a02c592fcff1$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $5c96a02c592fcff1$export$18ce0697a983be9b = function() {
    $5c96a02c592fcff1$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5c96a02c592fcff1$export$18ce0697a983be9b.apply(this, arguments);
};
function $5c96a02c592fcff1$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $5c96a02c592fcff1$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $5c96a02c592fcff1$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $5c96a02c592fcff1$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $5c96a02c592fcff1$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $5c96a02c592fcff1$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $5c96a02c592fcff1$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $5c96a02c592fcff1$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $5c96a02c592fcff1$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $5c96a02c592fcff1$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $5c96a02c592fcff1$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $5c96a02c592fcff1$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $5c96a02c592fcff1$export$45d3717a4c69092e(o, m, p);
}
function $5c96a02c592fcff1$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $5c96a02c592fcff1$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $5c96a02c592fcff1$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($5c96a02c592fcff1$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $5c96a02c592fcff1$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $5c96a02c592fcff1$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $5c96a02c592fcff1$export$10c90e4f7922046c(v) {
    return this instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? (this.v = v, this) : new $5c96a02c592fcff1$export$10c90e4f7922046c(v);
}
function $5c96a02c592fcff1$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $5c96a02c592fcff1$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $5c96a02c592fcff1$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $5c96a02c592fcff1$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $5c96a02c592fcff1$export$19a8beecd37a4c45 === "function" ? $5c96a02c592fcff1$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $5c96a02c592fcff1$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $5c96a02c592fcff1$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $5c96a02c592fcff1$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $5c96a02c592fcff1$export$45d3717a4c69092e(result, mod, k);
    }
    $5c96a02c592fcff1$var$__setModuleDefault(result, mod);
    return result;
}
function $5c96a02c592fcff1$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $5c96a02c592fcff1$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $5c96a02c592fcff1$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $5c96a02c592fcff1$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $5c96a02c592fcff1$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $5c96a02c592fcff1$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $5c96a02c592fcff1$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $5c96a02c592fcff1$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $5c96a02c592fcff1$export$2e2bcd8739ae039 = {
    __extends: $5c96a02c592fcff1$export$a8ba968b8961cb8a,
    __assign: $5c96a02c592fcff1$export$18ce0697a983be9b,
    __rest: $5c96a02c592fcff1$export$3c9a16f847548506,
    __decorate: $5c96a02c592fcff1$export$29e00dfd3077644b,
    __param: $5c96a02c592fcff1$export$d5ad3fd78186038f,
    __metadata: $5c96a02c592fcff1$export$f1db080c865becb9,
    __awaiter: $5c96a02c592fcff1$export$1050f835b63b671e,
    __generator: $5c96a02c592fcff1$export$67ebef60e6f28a6,
    __createBinding: $5c96a02c592fcff1$export$45d3717a4c69092e,
    __exportStar: $5c96a02c592fcff1$export$f33643c0debef087,
    __values: $5c96a02c592fcff1$export$19a8beecd37a4c45,
    __read: $5c96a02c592fcff1$export$8d051b38c9118094,
    __spread: $5c96a02c592fcff1$export$afc72e2116322959,
    __spreadArrays: $5c96a02c592fcff1$export$6388937ca91ccae8,
    __spreadArray: $5c96a02c592fcff1$export$1216008129fb82ed,
    __await: $5c96a02c592fcff1$export$10c90e4f7922046c,
    __asyncGenerator: $5c96a02c592fcff1$export$e427f37a30a4de9b,
    __asyncDelegator: $5c96a02c592fcff1$export$bbd80228419bb833,
    __asyncValues: $5c96a02c592fcff1$export$e3b29a3d6162315f,
    __makeTemplateObject: $5c96a02c592fcff1$export$4fb47efe1390b86f,
    __importStar: $5c96a02c592fcff1$export$c21735bcef00d192,
    __importDefault: $5c96a02c592fcff1$export$da59b14a69baef04,
    __classPrivateFieldGet: $5c96a02c592fcff1$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $5c96a02c592fcff1$export$d40a35129aaff81f,
    __classPrivateFieldIn: $5c96a02c592fcff1$export$81fdc39f203e4e04,
    __addDisposableResource: $5c96a02c592fcff1$export$88ac25d8e944e405,
    __disposeResources: $5c96a02c592fcff1$export$8f076105dc360e92
};

});

parcelRegister("hphuJ", function(module, exports) {

$parcel$export(module.exports, "RemoveScroll", () => $cac2578984d345ac$export$22940b497e769dee);

var $7WQrb = parcelRequire("7WQrb");

var $acw62 = parcelRequire("acw62");

var $5shKQ = parcelRequire("5shKQ");

var $2DGpc = parcelRequire("2DGpc");

var $lbTxE = parcelRequire("lbTxE");
var $cac2578984d345ac$var$nothing = function() {
    return;
};
/**
 * Removes scrollbar from the page and contain the scroll within the Lock
 */ var $cac2578984d345ac$export$22940b497e769dee = $acw62.forwardRef(function(props, parentRef) {
    var ref = $acw62.useRef(null);
    var _a = $acw62.useState({
        onScrollCapture: $cac2578984d345ac$var$nothing,
        onWheelCapture: $cac2578984d345ac$var$nothing,
        onTouchMoveCapture: $cac2578984d345ac$var$nothing
    }), callbacks = _a[0], setCallbacks = _a[1];
    var forwardProps = props.forwardProps, children = props.children, className = props.className, removeScrollBar = props.removeScrollBar, enabled = props.enabled, shards = props.shards, sideCar = props.sideCar, noIsolation = props.noIsolation, inert = props.inert, allowPinchZoom = props.allowPinchZoom, _b = props.as, Container = _b === void 0 ? "div" : _b, rest = (0, $7WQrb.__rest)(props, [
        "forwardProps",
        "children",
        "className",
        "removeScrollBar",
        "enabled",
        "shards",
        "sideCar",
        "noIsolation",
        "inert",
        "allowPinchZoom",
        "as"
    ]);
    var SideCar = sideCar;
    var containerRef = (0, $2DGpc.useMergeRefs)([
        ref,
        parentRef
    ]);
    var containerProps = (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, rest), callbacks);
    return $acw62.createElement($acw62.Fragment, null, enabled && $acw62.createElement(SideCar, {
        sideCar: (0, $lbTxE.effectCar),
        removeScrollBar: removeScrollBar,
        shards: shards,
        noIsolation: noIsolation,
        inert: inert,
        setCallbacks: setCallbacks,
        allowPinchZoom: !!allowPinchZoom,
        lockRef: ref
    }), forwardProps ? $acw62.cloneElement($acw62.Children.only(children), (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, containerProps), {
        ref: containerRef
    })) : $acw62.createElement(Container, (0, $7WQrb.__assign)({}, containerProps, {
        className: className,
        ref: containerRef
    }), children));
});
$cac2578984d345ac$export$22940b497e769dee.defaultProps = {
    enabled: true,
    removeScrollBar: true,
    inert: false
};
$cac2578984d345ac$export$22940b497e769dee.classNames = {
    fullWidth: (0, $5shKQ.fullWidthClassName),
    zeroRight: (0, $5shKQ.zeroRightClassName)
};

});
parcelRegister("5shKQ", function(module, exports) {

$parcel$export(module.exports, "zeroRightClassName", () => $3f8d56f1a38c65c8$export$1da7500147d4bc3);
$parcel$export(module.exports, "fullWidthClassName", () => $3f8d56f1a38c65c8$export$898e37bbd2a0ae4e);
$parcel$export(module.exports, "noScrollbarsClassName", () => $3f8d56f1a38c65c8$export$bb813dfbbc432abc);
$parcel$export(module.exports, "removedBarSizeVariable", () => $3f8d56f1a38c65c8$export$63d0edf80fea83b1);
var $3f8d56f1a38c65c8$export$1da7500147d4bc3 = "right-scroll-bar-position";
var $3f8d56f1a38c65c8$export$898e37bbd2a0ae4e = "width-before-scroll-bar";
var $3f8d56f1a38c65c8$export$bb813dfbbc432abc = "with-scroll-bars-hidden";
var $3f8d56f1a38c65c8$export$63d0edf80fea83b1 = "--removed-body-scroll-bar-size";

});

parcelRegister("2DGpc", function(module, exports) {

$parcel$export(module.exports, "useMergeRefs", () => $1ec01e2201501f3d$export$74665b213cb5c4cf);

var $acw62 = parcelRequire("acw62");

var $dtd3m = parcelRequire("dtd3m");

var $uclLN = parcelRequire("uclLN");
var $1ec01e2201501f3d$var$currentValues = new WeakMap();
function $1ec01e2201501f3d$export$74665b213cb5c4cf(refs, defaultValue) {
    var callbackRef = (0, $uclLN.useCallbackRef)(defaultValue || null, function(newValue) {
        return refs.forEach(function(ref) {
            return (0, $dtd3m.assignRef)(ref, newValue);
        });
    });
    // handle refs changes - added or removed
    $acw62.useLayoutEffect(function() {
        var oldValue = $1ec01e2201501f3d$var$currentValues.get(callbackRef);
        if (oldValue) {
            var prevRefs_1 = new Set(oldValue);
            var nextRefs_1 = new Set(refs);
            var current_1 = callbackRef.current;
            prevRefs_1.forEach(function(ref) {
                if (!nextRefs_1.has(ref)) (0, $dtd3m.assignRef)(ref, null);
            });
            nextRefs_1.forEach(function(ref) {
                if (!prevRefs_1.has(ref)) (0, $dtd3m.assignRef)(ref, current_1);
            });
        }
        $1ec01e2201501f3d$var$currentValues.set(callbackRef, refs);
    }, [
        refs
    ]);
    return callbackRef;
}

});
parcelRegister("dtd3m", function(module, exports) {

$parcel$export(module.exports, "assignRef", () => $9ce81be4473c2c96$export$d734136a7b018efe);
/**
 * Assigns a value for a given ref, no matter of the ref format
 * @param {RefObject} ref - a callback function or ref object
 * @param value - a new value
 *
 * @see https://github.com/theKashey/use-callback-ref#assignref
 * @example
 * const refObject = useRef();
 * const refFn = (ref) => {....}
 *
 * assignRef(refObject, "refValue");
 * assignRef(refFn, "refValue");
 */ function $9ce81be4473c2c96$export$d734136a7b018efe(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref) ref.current = value;
    return ref;
}

});

parcelRegister("uclLN", function(module, exports) {

$parcel$export(module.exports, "useCallbackRef", () => $05ac61ef45da8ec5$export$25bec8c6f54ee79a);

var $acw62 = parcelRequire("acw62");
function $05ac61ef45da8ec5$export$25bec8c6f54ee79a(initialValue, callback) {
    var ref = (0, $acw62.useState)(function() {
        return {
            // value
            value: initialValue,
            // last callback
            callback: callback,
            // "memoized" public interface
            facade: {
                get current () {
                    return ref.value;
                },
                set current (value){
                    var last = ref.value;
                    if (last !== value) {
                        ref.value = value;
                        ref.callback(value, last);
                    }
                }
            }
        };
    })[0];
    // update callback
    ref.callback = callback;
    return ref.facade;
}

});


parcelRegister("lbTxE", function(module, exports) {

$parcel$export(module.exports, "effectCar", () => $f6d5b57f3512e73c$export$e27363444bedfeac);

var $iXQwi = parcelRequire("iXQwi");
var $f6d5b57f3512e73c$export$e27363444bedfeac = (0, $iXQwi.createSidecarMedium)();

});
parcelRegister("iXQwi", function(module, exports) {

$parcel$export(module.exports, "createSidecarMedium", () => $dce67a1050af61cf$export$e13ec7dd7a14088d);

var $7WQrb = parcelRequire("7WQrb");
function $dce67a1050af61cf$var$ItoI(a) {
    return a;
}
function $dce67a1050af61cf$var$innerCreateMedium(defaults, middleware) {
    if (middleware === void 0) middleware = $dce67a1050af61cf$var$ItoI;
    var buffer = [];
    var assigned = false;
    var medium = {
        read: function() {
            if (assigned) throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
            if (buffer.length) return buffer[buffer.length - 1];
            return defaults;
        },
        useMedium: function(data) {
            var item = middleware(data, assigned);
            buffer.push(item);
            return function() {
                buffer = buffer.filter(function(x) {
                    return x !== item;
                });
            };
        },
        assignSyncMedium: function(cb) {
            assigned = true;
            while(buffer.length){
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
            }
            buffer = {
                push: function(x) {
                    return cb(x);
                },
                filter: function() {
                    return buffer;
                }
            };
        },
        assignMedium: function(cb) {
            assigned = true;
            var pendingQueue = [];
            if (buffer.length) {
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
                pendingQueue = buffer;
            }
            var executeQueue = function() {
                var cbs = pendingQueue;
                pendingQueue = [];
                cbs.forEach(cb);
            };
            var cycle = function() {
                return Promise.resolve().then(executeQueue);
            };
            cycle();
            buffer = {
                push: function(x) {
                    pendingQueue.push(x);
                    cycle();
                },
                filter: function(filter) {
                    pendingQueue = pendingQueue.filter(filter);
                    return buffer;
                }
            };
        }
    };
    return medium;
}
function $dce67a1050af61cf$export$9ffbfcaf067b02c6(defaults, middleware) {
    if (middleware === void 0) middleware = $dce67a1050af61cf$var$ItoI;
    return $dce67a1050af61cf$var$innerCreateMedium(defaults, middleware);
}
function $dce67a1050af61cf$export$e13ec7dd7a14088d(options) {
    if (options === void 0) options = {};
    var medium = $dce67a1050af61cf$var$innerCreateMedium(null);
    medium.options = (0, $7WQrb.__assign)({
        async: true,
        ssr: false
    }, options);
    return medium;
}

});



parcelRegister("1fmze", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e88b28988758ab2$export$2e2bcd8739ae039);

var $hcGtC = parcelRequire("hcGtC");

var $l793C = parcelRequire("l793C");

var $lbTxE = parcelRequire("lbTxE");
var $0e88b28988758ab2$export$2e2bcd8739ae039 = (0, $hcGtC.exportSidecar)((0, $lbTxE.effectCar), (0, $l793C.RemoveScrollSideCar));

});
parcelRegister("hcGtC", function(module, exports) {

$parcel$export(module.exports, "exportSidecar", () => $c86481a7b0dfcc68$export$6cacc8fb0a9b94ce);

var $7WQrb = parcelRequire("7WQrb");

var $acw62 = parcelRequire("acw62");
var $c86481a7b0dfcc68$var$SideCar = function(_a) {
    var sideCar = _a.sideCar, rest = (0, $7WQrb.__rest)(_a, [
        "sideCar"
    ]);
    if (!sideCar) throw new Error("Sidecar: please provide `sideCar` property to import the right car");
    var Target = sideCar.read();
    if (!Target) throw new Error("Sidecar medium not found");
    return $acw62.createElement(Target, (0, $7WQrb.__assign)({}, rest));
};
$c86481a7b0dfcc68$var$SideCar.isSideCarExport = true;
function $c86481a7b0dfcc68$export$6cacc8fb0a9b94ce(medium, exported) {
    medium.useMedium(exported);
    return $c86481a7b0dfcc68$var$SideCar;
}

});

parcelRegister("l793C", function(module, exports) {

$parcel$export(module.exports, "RemoveScrollSideCar", () => $f5f147098910888d$export$a09dbff87b5da2d);

var $7WQrb = parcelRequire("7WQrb");

var $acw62 = parcelRequire("acw62");
parcelRequire("bFkre");
var $dFfX5 = parcelRequire("dFfX5");
parcelRequire("i39OQ");
var $kc8mv = parcelRequire("kc8mv");

var $9x4sU = parcelRequire("9x4sU");

var $epYFP = parcelRequire("epYFP");
var $f5f147098910888d$export$6e085704a79f4f56 = function(event) {
    return "changedTouches" in event ? [
        event.changedTouches[0].clientX,
        event.changedTouches[0].clientY
    ] : [
        0,
        0
    ];
};
var $f5f147098910888d$export$39efaa2ca254a28d = function(event) {
    return [
        event.deltaX,
        event.deltaY
    ];
};
var $f5f147098910888d$var$extractRef = function(ref) {
    return ref && "current" in ref ? ref.current : ref;
};
var $f5f147098910888d$var$deltaCompare = function(x, y) {
    return x[0] === y[0] && x[1] === y[1];
};
var $f5f147098910888d$var$generateStyle = function(id) {
    return "\n  .block-interactivity-".concat(id, " {pointer-events: none;}\n  .allow-interactivity-").concat(id, " {pointer-events: all;}\n");
};
var $f5f147098910888d$var$idCounter = 0;
var $f5f147098910888d$var$lockStack = [];
function $f5f147098910888d$export$a09dbff87b5da2d(props) {
    var shouldPreventQueue = $acw62.useRef([]);
    var touchStartRef = $acw62.useRef([
        0,
        0
    ]);
    var activeAxis = $acw62.useRef();
    var id = $acw62.useState($f5f147098910888d$var$idCounter++)[0];
    var Style = $acw62.useState(function() {
        return (0, $kc8mv.styleSingleton)();
    })[0];
    var lastProps = $acw62.useRef(props);
    $acw62.useEffect(function() {
        lastProps.current = props;
    }, [
        props
    ]);
    $acw62.useEffect(function() {
        if (props.inert) {
            document.body.classList.add("block-interactivity-".concat(id));
            var allow_1 = (0, $7WQrb.__spreadArray)([
                props.lockRef.current
            ], (props.shards || []).map($f5f147098910888d$var$extractRef), true).filter(Boolean);
            allow_1.forEach(function(el) {
                return el.classList.add("allow-interactivity-".concat(id));
            });
            return function() {
                document.body.classList.remove("block-interactivity-".concat(id));
                allow_1.forEach(function(el) {
                    return el.classList.remove("allow-interactivity-".concat(id));
                });
            };
        }
        return;
    }, [
        props.inert,
        props.lockRef.current,
        props.shards
    ]);
    var shouldCancelEvent = $acw62.useCallback(function(event, parent) {
        if ("touches" in event && event.touches.length === 2) return !lastProps.current.allowPinchZoom;
        var touch = $f5f147098910888d$export$6e085704a79f4f56(event);
        var touchStart = touchStartRef.current;
        var deltaX = "deltaX" in event ? event.deltaX : touchStart[0] - touch[0];
        var deltaY = "deltaY" in event ? event.deltaY : touchStart[1] - touch[1];
        var currentAxis;
        var target = event.target;
        var moveDirection = Math.abs(deltaX) > Math.abs(deltaY) ? "h" : "v";
        // allow horizontal touch move on Range inputs. They will not cause any scroll
        if ("touches" in event && moveDirection === "h" && target.type === "range") return false;
        var canBeScrolledInMainDirection = (0, $epYFP.locationCouldBeScrolled)(moveDirection, target);
        if (!canBeScrolledInMainDirection) return true;
        if (canBeScrolledInMainDirection) currentAxis = moveDirection;
        else {
            currentAxis = moveDirection === "v" ? "h" : "v";
            canBeScrolledInMainDirection = (0, $epYFP.locationCouldBeScrolled)(moveDirection, target);
        // other axis might be not scrollable
        }
        if (!canBeScrolledInMainDirection) return false;
        if (!activeAxis.current && "changedTouches" in event && (deltaX || deltaY)) activeAxis.current = currentAxis;
        if (!currentAxis) return true;
        var cancelingAxis = activeAxis.current || currentAxis;
        return (0, $epYFP.handleScroll)(cancelingAxis, parent, event, cancelingAxis === "h" ? deltaX : deltaY, true);
    }, []);
    var shouldPrevent = $acw62.useCallback(function(_event) {
        var event = _event;
        if (!$f5f147098910888d$var$lockStack.length || $f5f147098910888d$var$lockStack[$f5f147098910888d$var$lockStack.length - 1] !== Style) // not the last active
        return;
        var delta = "deltaY" in event ? $f5f147098910888d$export$39efaa2ca254a28d(event) : $f5f147098910888d$export$6e085704a79f4f56(event);
        var sourceEvent = shouldPreventQueue.current.filter(function(e) {
            return e.name === event.type && e.target === event.target && $f5f147098910888d$var$deltaCompare(e.delta, delta);
        })[0];
        // self event, and should be canceled
        if (sourceEvent && sourceEvent.should) {
            if (event.cancelable) event.preventDefault();
            return;
        }
        // outside or shard event
        if (!sourceEvent) {
            var shardNodes = (lastProps.current.shards || []).map($f5f147098910888d$var$extractRef).filter(Boolean).filter(function(node) {
                return node.contains(event.target);
            });
            var shouldStop = shardNodes.length > 0 ? shouldCancelEvent(event, shardNodes[0]) : !lastProps.current.noIsolation;
            if (shouldStop) {
                if (event.cancelable) event.preventDefault();
            }
        }
    }, []);
    var shouldCancel = $acw62.useCallback(function(name, delta, target, should) {
        var event = {
            name: name,
            delta: delta,
            target: target,
            should: should
        };
        shouldPreventQueue.current.push(event);
        setTimeout(function() {
            shouldPreventQueue.current = shouldPreventQueue.current.filter(function(e) {
                return e !== event;
            });
        }, 1);
    }, []);
    var scrollTouchStart = $acw62.useCallback(function(event) {
        touchStartRef.current = $f5f147098910888d$export$6e085704a79f4f56(event);
        activeAxis.current = undefined;
    }, []);
    var scrollWheel = $acw62.useCallback(function(event) {
        shouldCancel(event.type, $f5f147098910888d$export$39efaa2ca254a28d(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    var scrollTouchMove = $acw62.useCallback(function(event) {
        shouldCancel(event.type, $f5f147098910888d$export$6e085704a79f4f56(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    $acw62.useEffect(function() {
        $f5f147098910888d$var$lockStack.push(Style);
        props.setCallbacks({
            onScrollCapture: scrollWheel,
            onWheelCapture: scrollWheel,
            onTouchMoveCapture: scrollTouchMove
        });
        document.addEventListener("wheel", shouldPrevent, (0, $9x4sU.nonPassive));
        document.addEventListener("touchmove", shouldPrevent, (0, $9x4sU.nonPassive));
        document.addEventListener("touchstart", scrollTouchStart, (0, $9x4sU.nonPassive));
        return function() {
            $f5f147098910888d$var$lockStack = $f5f147098910888d$var$lockStack.filter(function(inst) {
                return inst !== Style;
            });
            document.removeEventListener("wheel", shouldPrevent, (0, $9x4sU.nonPassive));
            document.removeEventListener("touchmove", shouldPrevent, (0, $9x4sU.nonPassive));
            document.removeEventListener("touchstart", scrollTouchStart, (0, $9x4sU.nonPassive));
        };
    }, []);
    var removeScrollBar = props.removeScrollBar, inert = props.inert;
    return $acw62.createElement($acw62.Fragment, null, inert ? $acw62.createElement(Style, {
        styles: $f5f147098910888d$var$generateStyle(id)
    }) : null, removeScrollBar ? $acw62.createElement((0, $dFfX5.RemoveScrollBar), {
        gapMode: "margin"
    }) : null);
}

});
parcelRegister("bFkre", function(module, exports) {

$parcel$export(module.exports, "RemoveScrollBar", () => (parcelRequire("dFfX5")).RemoveScrollBar);

var $dFfX5 = parcelRequire("dFfX5");

var $5shKQ = parcelRequire("5shKQ");

var $2ddNe = parcelRequire("2ddNe");

});
parcelRegister("dFfX5", function(module, exports) {

$parcel$export(module.exports, "RemoveScrollBar", () => $9f2b7a700f678519$export$9aa43b459c5ae9b9);

var $acw62 = parcelRequire("acw62");
parcelRequire("i39OQ");
var $kc8mv = parcelRequire("kc8mv");

var $5shKQ = parcelRequire("5shKQ");

var $2ddNe = parcelRequire("2ddNe");
var $9f2b7a700f678519$var$Style = (0, $kc8mv.styleSingleton)();
var $9f2b7a700f678519$export$65254d5f26cb9564 = "data-scroll-locked";
// important tip - once we measure scrollBar width and remove them
// we could not repeat this operation
// thus we are using style-singleton - only the first "yet correct" style will be applied.
var $9f2b7a700f678519$var$getStyles = function(_a, allowRelative, gapMode, important) {
    var left = _a.left, top = _a.top, right = _a.right, gap = _a.gap;
    if (gapMode === void 0) gapMode = "margin";
    return "\n  .".concat((0, $5shKQ.noScrollbarsClassName), " {\n   overflow: hidden ").concat(important, ";\n   padding-right: ").concat(gap, "px ").concat(important, ";\n  }\n  body[").concat($9f2b7a700f678519$export$65254d5f26cb9564, "] {\n    overflow: hidden ").concat(important, ";\n    overscroll-behavior: contain;\n    ").concat([
        allowRelative && "position: relative ".concat(important, ";"),
        gapMode === "margin" && "\n    padding-left: ".concat(left, "px;\n    padding-top: ").concat(top, "px;\n    padding-right: ").concat(right, "px;\n    margin-left:0;\n    margin-top:0;\n    margin-right: ").concat(gap, "px ").concat(important, ";\n    "),
        gapMode === "padding" && "padding-right: ".concat(gap, "px ").concat(important, ";")
    ].filter(Boolean).join(""), "\n  }\n  \n  .").concat((0, $5shKQ.zeroRightClassName), " {\n    right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat((0, $5shKQ.fullWidthClassName), " {\n    margin-right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat((0, $5shKQ.zeroRightClassName), " .").concat((0, $5shKQ.zeroRightClassName), " {\n    right: 0 ").concat(important, ";\n  }\n  \n  .").concat((0, $5shKQ.fullWidthClassName), " .").concat((0, $5shKQ.fullWidthClassName), " {\n    margin-right: 0 ").concat(important, ";\n  }\n  \n  body[").concat($9f2b7a700f678519$export$65254d5f26cb9564, "] {\n    ").concat((0, $5shKQ.removedBarSizeVariable), ": ").concat(gap, "px;\n  }\n");
};
var $9f2b7a700f678519$export$9aa43b459c5ae9b9 = function(props) {
    var noRelative = props.noRelative, noImportant = props.noImportant, _a = props.gapMode, gapMode = _a === void 0 ? "margin" : _a;
    /*
     gap will be measured on every component mount
     however it will be used only by the "first" invocation
     due to singleton nature of <Style
     */ var gap = $acw62.useMemo(function() {
        return (0, $2ddNe.getGapWidth)(gapMode);
    }, [
        gapMode
    ]);
    $acw62.useEffect(function() {
        document.body.setAttribute($9f2b7a700f678519$export$65254d5f26cb9564, "");
        return function() {
            document.body.removeAttribute($9f2b7a700f678519$export$65254d5f26cb9564);
        };
    }, []);
    return $acw62.createElement($9f2b7a700f678519$var$Style, {
        styles: $9f2b7a700f678519$var$getStyles(gap, !noRelative, gapMode, !noImportant ? "!important" : "")
    });
};

});
parcelRegister("i39OQ", function(module, exports) {

$parcel$export(module.exports, "styleSingleton", () => (parcelRequire("kc8mv")).styleSingleton);

var $kc8mv = parcelRequire("kc8mv");

var $gjYQD = parcelRequire("gjYQD");

var $fCBo2 = parcelRequire("fCBo2");

});
parcelRegister("kc8mv", function(module, exports) {

$parcel$export(module.exports, "styleSingleton", () => $eb3b6a23a33fb1ba$export$c1248ee86ba532c8);

var $fCBo2 = parcelRequire("fCBo2");
var $eb3b6a23a33fb1ba$export$c1248ee86ba532c8 = function() {
    var useStyle = (0, $fCBo2.styleHookSingleton)();
    var Sheet = function(_a) {
        var styles = _a.styles, dynamic = _a.dynamic;
        useStyle(styles, dynamic);
        return null;
    };
    return Sheet;
};

});
parcelRegister("fCBo2", function(module, exports) {

$parcel$export(module.exports, "styleHookSingleton", () => $b5f767dd03f483e5$export$7d7b35c2d250e94c);

var $acw62 = parcelRequire("acw62");

var $gjYQD = parcelRequire("gjYQD");
var $b5f767dd03f483e5$export$7d7b35c2d250e94c = function() {
    var sheet = (0, $gjYQD.stylesheetSingleton)();
    return function(styles, isDynamic) {
        $acw62.useEffect(function() {
            sheet.add(styles);
            return function() {
                sheet.remove();
            };
        }, [
            styles && isDynamic
        ]);
    };
};

});
parcelRegister("gjYQD", function(module, exports) {

$parcel$export(module.exports, "stylesheetSingleton", () => $be1d9ed5bb532264$export$7c74eec858d5d226);

var $1EetQ = parcelRequire("1EetQ");
function $be1d9ed5bb532264$var$makeStyleTag() {
    if (!document) return null;
    var tag = document.createElement("style");
    tag.type = "text/css";
    var nonce = (0, $1EetQ.getNonce)();
    if (nonce) tag.setAttribute("nonce", nonce);
    return tag;
}
function $be1d9ed5bb532264$var$injectStyles(tag, css) {
    // @ts-ignore
    if (tag.styleSheet) // @ts-ignore
    tag.styleSheet.cssText = css;
    else tag.appendChild(document.createTextNode(css));
}
function $be1d9ed5bb532264$var$insertStyleTag(tag) {
    var head = document.head || document.getElementsByTagName("head")[0];
    head.appendChild(tag);
}
var $be1d9ed5bb532264$export$7c74eec858d5d226 = function() {
    var counter = 0;
    var stylesheet = null;
    return {
        add: function(style) {
            if (counter == 0) {
                if (stylesheet = $be1d9ed5bb532264$var$makeStyleTag()) {
                    $be1d9ed5bb532264$var$injectStyles(stylesheet, style);
                    $be1d9ed5bb532264$var$insertStyleTag(stylesheet);
                }
            }
            counter++;
        },
        remove: function() {
            counter--;
            if (!counter && stylesheet) {
                stylesheet.parentNode && stylesheet.parentNode.removeChild(stylesheet);
                stylesheet = null;
            }
        }
    };
};

});
parcelRegister("1EetQ", function(module, exports) {

$parcel$export(module.exports, "getNonce", () => $1334c25f36aeceaf$export$2b85b721e524d74b);
var $1334c25f36aeceaf$var$currentNonce;
var $1334c25f36aeceaf$export$c5f670b24c0ae95a = function(nonce) {
    $1334c25f36aeceaf$var$currentNonce = nonce;
};
var $1334c25f36aeceaf$export$2b85b721e524d74b = function() {
    if ($1334c25f36aeceaf$var$currentNonce) return $1334c25f36aeceaf$var$currentNonce;
    if (typeof __webpack_nonce__ !== "undefined") return __webpack_nonce__;
    return undefined;
};

});





parcelRegister("2ddNe", function(module, exports) {

$parcel$export(module.exports, "getGapWidth", () => $19c77eb414ad2a19$export$75f2ca8f029c77f4);
var $19c77eb414ad2a19$export$efed13b5d0ca3386 = {
    left: 0,
    top: 0,
    right: 0,
    gap: 0
};
var $19c77eb414ad2a19$var$parse = function(x) {
    return parseInt(x || "", 10) || 0;
};
var $19c77eb414ad2a19$var$getOffset = function(gapMode) {
    var cs = window.getComputedStyle(document.body);
    var left = cs[gapMode === "padding" ? "paddingLeft" : "marginLeft"];
    var top = cs[gapMode === "padding" ? "paddingTop" : "marginTop"];
    var right = cs[gapMode === "padding" ? "paddingRight" : "marginRight"];
    return [
        $19c77eb414ad2a19$var$parse(left),
        $19c77eb414ad2a19$var$parse(top),
        $19c77eb414ad2a19$var$parse(right)
    ];
};
var $19c77eb414ad2a19$export$75f2ca8f029c77f4 = function(gapMode) {
    if (gapMode === void 0) gapMode = "margin";
    if (typeof window === "undefined") return $19c77eb414ad2a19$export$efed13b5d0ca3386;
    var offsets = $19c77eb414ad2a19$var$getOffset(gapMode);
    var documentWidth = document.documentElement.clientWidth;
    var windowWidth = window.innerWidth;
    return {
        left: offsets[0],
        top: offsets[1],
        right: offsets[2],
        gap: Math.max(0, windowWidth - documentWidth + offsets[2] - offsets[0])
    };
};

});



parcelRegister("9x4sU", function(module, exports) {

$parcel$export(module.exports, "nonPassive", () => $6f0aa8d921410141$export$10a6e88623fa9454);
var $6f0aa8d921410141$var$passiveSupported = false;
if (typeof window !== "undefined") try {
    var $6f0aa8d921410141$var$options = Object.defineProperty({}, "passive", {
        get: function() {
            $6f0aa8d921410141$var$passiveSupported = true;
            return true;
        }
    });
    // @ts-ignore
    window.addEventListener("test", $6f0aa8d921410141$var$options, $6f0aa8d921410141$var$options);
    // @ts-ignore
    window.removeEventListener("test", $6f0aa8d921410141$var$options, $6f0aa8d921410141$var$options);
} catch (err) {
    $6f0aa8d921410141$var$passiveSupported = false;
}
var $6f0aa8d921410141$export$10a6e88623fa9454 = $6f0aa8d921410141$var$passiveSupported ? {
    passive: false
} : false;

});

parcelRegister("epYFP", function(module, exports) {

$parcel$export(module.exports, "locationCouldBeScrolled", () => $a7f277057d6643d0$export$9ec64480cae49817);
$parcel$export(module.exports, "handleScroll", () => $a7f277057d6643d0$export$dde0441bd4a6ded8);
var $a7f277057d6643d0$var$alwaysContainsScroll = function(node) {
    // textarea will always _contain_ scroll inside self. It only can be hidden
    return node.tagName === "TEXTAREA";
};
var $a7f277057d6643d0$var$elementCanBeScrolled = function(node, overflow) {
    var styles = window.getComputedStyle(node);
    return(// not-not-scrollable
    styles[overflow] !== "hidden" && // contains scroll inside self
    !(styles.overflowY === styles.overflowX && !$a7f277057d6643d0$var$alwaysContainsScroll(node) && styles[overflow] === "visible"));
};
var $a7f277057d6643d0$var$elementCouldBeVScrolled = function(node) {
    return $a7f277057d6643d0$var$elementCanBeScrolled(node, "overflowY");
};
var $a7f277057d6643d0$var$elementCouldBeHScrolled = function(node) {
    return $a7f277057d6643d0$var$elementCanBeScrolled(node, "overflowX");
};
var $a7f277057d6643d0$export$9ec64480cae49817 = function(axis, node) {
    var current = node;
    do {
        // Skip over shadow root
        if (typeof ShadowRoot !== "undefined" && current instanceof ShadowRoot) current = current.host;
        var isScrollable = $a7f277057d6643d0$var$elementCouldBeScrolled(axis, current);
        if (isScrollable) {
            var _a = $a7f277057d6643d0$var$getScrollVariables(axis, current), s = _a[1], d = _a[2];
            if (s > d) return true;
        }
        current = current.parentNode;
    }while (current && current !== document.body);
    return false;
};
var $a7f277057d6643d0$var$getVScrollVariables = function(_a) {
    var scrollTop = _a.scrollTop, scrollHeight = _a.scrollHeight, clientHeight = _a.clientHeight;
    return [
        scrollTop,
        scrollHeight,
        clientHeight
    ];
};
var $a7f277057d6643d0$var$getHScrollVariables = function(_a) {
    var scrollLeft = _a.scrollLeft, scrollWidth = _a.scrollWidth, clientWidth = _a.clientWidth;
    return [
        scrollLeft,
        scrollWidth,
        clientWidth
    ];
};
var $a7f277057d6643d0$var$elementCouldBeScrolled = function(axis, node) {
    return axis === "v" ? $a7f277057d6643d0$var$elementCouldBeVScrolled(node) : $a7f277057d6643d0$var$elementCouldBeHScrolled(node);
};
var $a7f277057d6643d0$var$getScrollVariables = function(axis, node) {
    return axis === "v" ? $a7f277057d6643d0$var$getVScrollVariables(node) : $a7f277057d6643d0$var$getHScrollVariables(node);
};
var $a7f277057d6643d0$var$getDirectionFactor = function(axis, direction) {
    /**
     * If the element's direction is rtl (right-to-left), then scrollLeft is 0 when the scrollbar is at its rightmost position,
     * and then increasingly negative as you scroll towards the end of the content.
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollLeft
     */ return axis === "h" && direction === "rtl" ? -1 : 1;
};
var $a7f277057d6643d0$export$dde0441bd4a6ded8 = function(axis, endTarget, event, sourceDelta, noOverscroll) {
    var directionFactor = $a7f277057d6643d0$var$getDirectionFactor(axis, window.getComputedStyle(endTarget).direction);
    var delta = directionFactor * sourceDelta;
    // find scrollable target
    var target = event.target;
    var targetInLock = endTarget.contains(target);
    var shouldCancelScroll = false;
    var isDeltaPositive = delta > 0;
    var availableScroll = 0;
    var availableScrollTop = 0;
    do {
        var _a = $a7f277057d6643d0$var$getScrollVariables(axis, target), position = _a[0], scroll_1 = _a[1], capacity = _a[2];
        var elementScroll = scroll_1 - capacity - directionFactor * position;
        if (position || elementScroll) {
            if ($a7f277057d6643d0$var$elementCouldBeScrolled(axis, target)) {
                availableScroll += elementScroll;
                availableScrollTop += position;
            }
        }
        target = target.parentNode;
    }while (// portaled content
    !targetInLock && target !== document.body || // self content
    targetInLock && (endTarget.contains(target) || endTarget === target));
    if (isDeltaPositive && (noOverscroll && availableScroll === 0 || !noOverscroll && delta > availableScroll)) shouldCancelScroll = true;
    else if (!isDeltaPositive && (noOverscroll && availableScrollTop === 0 || !noOverscroll && -delta > availableScrollTop)) shouldCancelScroll = true;
    return shouldCancelScroll;
};

});




parcelRegister("6okVC", function(module, exports) {

$parcel$export(module.exports, "hideOthers", () => $4a7537e072260c10$export$6e33d16126ed003c);
var $4a7537e072260c10$var$getDefaultParent = function(originalTarget) {
    if (typeof document === "undefined") return null;
    var sampleTarget = Array.isArray(originalTarget) ? originalTarget[0] : originalTarget;
    return sampleTarget.ownerDocument.body;
};
var $4a7537e072260c10$var$counterMap = new WeakMap();
var $4a7537e072260c10$var$uncontrolledNodes = new WeakMap();
var $4a7537e072260c10$var$markerMap = {};
var $4a7537e072260c10$var$lockCount = 0;
var $4a7537e072260c10$var$unwrapHost = function(node) {
    return node && (node.host || $4a7537e072260c10$var$unwrapHost(node.parentNode));
};
var $4a7537e072260c10$var$correctTargets = function(parent, targets) {
    return targets.map(function(target) {
        if (parent.contains(target)) return target;
        var correctedTarget = $4a7537e072260c10$var$unwrapHost(target);
        if (correctedTarget && parent.contains(correctedTarget)) return correctedTarget;
        console.error("aria-hidden", target, "in not contained inside", parent, ". Doing nothing");
        return null;
    }).filter(function(x) {
        return Boolean(x);
    });
};
/**
 * Marks everything except given node(or nodes) as aria-hidden
 * @param {Element | Element[]} originalTarget - elements to keep on the page
 * @param [parentNode] - top element, defaults to document.body
 * @param {String} [markerName] - a special attribute to mark every node
 * @param {String} [controlAttribute] - html Attribute to control
 * @return {Undo} undo command
 */ var $4a7537e072260c10$var$applyAttributeToOthers = function(originalTarget, parentNode, markerName, controlAttribute) {
    var targets = $4a7537e072260c10$var$correctTargets(parentNode, Array.isArray(originalTarget) ? originalTarget : [
        originalTarget
    ]);
    if (!$4a7537e072260c10$var$markerMap[markerName]) $4a7537e072260c10$var$markerMap[markerName] = new WeakMap();
    var markerCounter = $4a7537e072260c10$var$markerMap[markerName];
    var hiddenNodes = [];
    var elementsToKeep = new Set();
    var elementsToStop = new Set(targets);
    var keep = function(el) {
        if (!el || elementsToKeep.has(el)) return;
        elementsToKeep.add(el);
        keep(el.parentNode);
    };
    targets.forEach(keep);
    var deep = function(parent) {
        if (!parent || elementsToStop.has(parent)) return;
        Array.prototype.forEach.call(parent.children, function(node) {
            if (elementsToKeep.has(node)) deep(node);
            else {
                var attr = node.getAttribute(controlAttribute);
                var alreadyHidden = attr !== null && attr !== "false";
                var counterValue = ($4a7537e072260c10$var$counterMap.get(node) || 0) + 1;
                var markerValue = (markerCounter.get(node) || 0) + 1;
                $4a7537e072260c10$var$counterMap.set(node, counterValue);
                markerCounter.set(node, markerValue);
                hiddenNodes.push(node);
                if (counterValue === 1 && alreadyHidden) $4a7537e072260c10$var$uncontrolledNodes.set(node, true);
                if (markerValue === 1) node.setAttribute(markerName, "true");
                if (!alreadyHidden) node.setAttribute(controlAttribute, "true");
            }
        });
    };
    deep(parentNode);
    elementsToKeep.clear();
    $4a7537e072260c10$var$lockCount++;
    return function() {
        hiddenNodes.forEach(function(node) {
            var counterValue = $4a7537e072260c10$var$counterMap.get(node) - 1;
            var markerValue = markerCounter.get(node) - 1;
            $4a7537e072260c10$var$counterMap.set(node, counterValue);
            markerCounter.set(node, markerValue);
            if (!counterValue) {
                if (!$4a7537e072260c10$var$uncontrolledNodes.has(node)) node.removeAttribute(controlAttribute);
                $4a7537e072260c10$var$uncontrolledNodes.delete(node);
            }
            if (!markerValue) node.removeAttribute(markerName);
        });
        $4a7537e072260c10$var$lockCount--;
        if (!$4a7537e072260c10$var$lockCount) {
            // clear
            $4a7537e072260c10$var$counterMap = new WeakMap();
            $4a7537e072260c10$var$counterMap = new WeakMap();
            $4a7537e072260c10$var$uncontrolledNodes = new WeakMap();
            $4a7537e072260c10$var$markerMap = {};
        }
    };
};
var $4a7537e072260c10$export$6e33d16126ed003c = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = "data-aria-hidden";
    var targets = Array.from(Array.isArray(originalTarget) ? originalTarget : [
        originalTarget
    ]);
    var activeParentNode = parentNode || $4a7537e072260c10$var$getDefaultParent(originalTarget);
    if (!activeParentNode) return function() {
        return null;
    };
    // we should not hide ariaLive elements - https://github.com/theKashey/aria-hidden/issues/10
    targets.push.apply(targets, Array.from(activeParentNode.querySelectorAll("[aria-live]")));
    return $4a7537e072260c10$var$applyAttributeToOthers(targets, activeParentNode, markerName, "aria-hidden");
};
var $4a7537e072260c10$export$59151cc8db999a24 = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = "data-inert-ed";
    var activeParentNode = parentNode || $4a7537e072260c10$var$getDefaultParent(originalTarget);
    if (!activeParentNode) return function() {
        return null;
    };
    return $4a7537e072260c10$var$applyAttributeToOthers(originalTarget, activeParentNode, markerName, "inert");
};
var $4a7537e072260c10$export$cc95fea82d705fca = function() {
    return typeof HTMLElement !== "undefined" && HTMLElement.prototype.hasOwnProperty("inert");
};
var $4a7537e072260c10$export$9845d4b6bdad192b = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = "data-suppressed";
    return ($4a7537e072260c10$export$cc95fea82d705fca() ? $4a7537e072260c10$export$59151cc8db999a24 : $4a7537e072260c10$export$6e33d16126ed003c)(originalTarget, parentNode, markerName);
};

});


parcelRegister("ac9wP", function(module, exports) {

$parcel$export(module.exports, "Root", () => $8d51f093cc1b6735$export$be92b6f5f03c0fe9);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $kFbxc = parcelRequire("kFbxc");
/* -------------------------------------------------------------------------------------------------
 * VisuallyHidden
 * -----------------------------------------------------------------------------------------------*/ const $8d51f093cc1b6735$var$$ea1ef594cf570d83$var$NAME = "VisuallyHidden";
const $8d51f093cc1b6735$export$439d29a4e110a164 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $kFbxc.Primitive).span, (0, $8nd05.default)({}, props, {
        ref: forwardedRef,
        style: {
            // See: https://github.com/twbs/bootstrap/blob/master/scss/mixins/_screen-reader.scss
            position: "absolute",
            border: 0,
            width: 1,
            height: 1,
            padding: 0,
            margin: -1,
            overflow: "hidden",
            clip: "rect(0, 0, 0, 0)",
            whiteSpace: "nowrap",
            wordWrap: "normal",
            ...props.style
        }
    }));
});
/*#__PURE__*/ Object.assign($8d51f093cc1b6735$export$439d29a4e110a164, {
    displayName: $8d51f093cc1b6735$var$$ea1ef594cf570d83$var$NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $8d51f093cc1b6735$export$be92b6f5f03c0fe9 = $8d51f093cc1b6735$export$439d29a4e110a164;

});

parcelRegister("41AHY", function(module, exports) {

$parcel$export(module.exports, "Root", () => $a51a7192f883dda1$export$be92b6f5f03c0fe9);
$parcel$export(module.exports, "Trigger", () => $a51a7192f883dda1$export$41fb9f06171c75f4);
$parcel$export(module.exports, "Portal", () => $a51a7192f883dda1$export$602eac185826482c);
$parcel$export(module.exports, "Content", () => $a51a7192f883dda1$export$7c6e2c02157bb7d2);
$parcel$export(module.exports, "Item", () => $a51a7192f883dda1$export$6d08773d2e66f8f2);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $2IwC4 = parcelRequire("2IwC4");

var $htT6J = parcelRequire("htT6J");

var $jnK0n = parcelRequire("jnK0n");

var $88UcQ = parcelRequire("88UcQ");

var $kFbxc = parcelRequire("kFbxc");

var $21LnN = parcelRequire("21LnN");

var $g2NP0 = parcelRequire("g2NP0");
/* -------------------------------------------------------------------------------------------------
 * DropdownMenu
 * -----------------------------------------------------------------------------------------------*/ const $a51a7192f883dda1$var$$d08ef79370b62062$var$DROPDOWN_MENU_NAME = "DropdownMenu";
const [$a51a7192f883dda1$var$$d08ef79370b62062$var$createDropdownMenuContext, $a51a7192f883dda1$export$c0623cd925aeb687] = (0, $jnK0n.createContextScope)($a51a7192f883dda1$var$$d08ef79370b62062$var$DROPDOWN_MENU_NAME, [
    (0, $21LnN.createMenuScope)
]);
const $a51a7192f883dda1$var$$d08ef79370b62062$var$useMenuScope = (0, $21LnN.createMenuScope)();
const [$a51a7192f883dda1$var$$d08ef79370b62062$var$DropdownMenuProvider, $a51a7192f883dda1$var$$d08ef79370b62062$var$useDropdownMenuContext] = $a51a7192f883dda1$var$$d08ef79370b62062$var$createDropdownMenuContext($a51a7192f883dda1$var$$d08ef79370b62062$var$DROPDOWN_MENU_NAME);
const $a51a7192f883dda1$export$e44a253a59704894 = (props)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, children: children, dir: dir, open: openProp, defaultOpen: defaultOpen, onOpenChange: onOpenChange, modal: modal = true } = props;
    const menuScope = $a51a7192f883dda1$var$$d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
    const triggerRef = (0, $acw62.useRef)(null);
    const [open = false, setOpen] = (0, $88UcQ.useControllableState)({
        prop: openProp,
        defaultProp: defaultOpen,
        onChange: onOpenChange
    });
    return /*#__PURE__*/ (0, $acw62.createElement)($a51a7192f883dda1$var$$d08ef79370b62062$var$DropdownMenuProvider, {
        scope: __scopeDropdownMenu,
        triggerId: (0, $g2NP0.useId)(),
        triggerRef: triggerRef,
        contentId: (0, $g2NP0.useId)(),
        open: open,
        onOpenChange: setOpen,
        onOpenToggle: (0, $acw62.useCallback)(()=>setOpen((prevOpen)=>!prevOpen), [
            setOpen
        ]),
        modal: modal
    }, /*#__PURE__*/ (0, $acw62.createElement)((0, $21LnN.Root), (0, $8nd05.default)({}, menuScope, {
        open: open,
        onOpenChange: setOpen,
        dir: dir,
        modal: modal
    }), children));
};
/*#__PURE__*/ Object.assign($a51a7192f883dda1$export$e44a253a59704894, {
    displayName: $a51a7192f883dda1$var$$d08ef79370b62062$var$DROPDOWN_MENU_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DropdownMenuTrigger
 * -----------------------------------------------------------------------------------------------*/ const $a51a7192f883dda1$var$$d08ef79370b62062$var$TRIGGER_NAME = "DropdownMenuTrigger";
const $a51a7192f883dda1$export$d2469213b3befba9 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, disabled: disabled = false, ...triggerProps } = props;
    const context = $a51a7192f883dda1$var$$d08ef79370b62062$var$useDropdownMenuContext($a51a7192f883dda1$var$$d08ef79370b62062$var$TRIGGER_NAME, __scopeDropdownMenu);
    const menuScope = $a51a7192f883dda1$var$$d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $21LnN.Anchor), (0, $8nd05.default)({
        asChild: true
    }, menuScope), /*#__PURE__*/ (0, $acw62.createElement)((0, $kFbxc.Primitive).button, (0, $8nd05.default)({
        type: "button",
        id: context.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": context.open,
        "aria-controls": context.open ? context.contentId : undefined,
        "data-state": context.open ? "open" : "closed",
        "data-disabled": disabled ? "" : undefined,
        disabled: disabled
    }, triggerProps, {
        ref: (0, $htT6J.composeRefs)(forwardedRef, context.triggerRef),
        onPointerDown: (0, $2IwC4.composeEventHandlers)(props.onPointerDown, (event)=>{
            // only call handler if it's the left button (mousedown gets triggered by all mouse buttons)
            // but not when the control key is pressed (avoiding MacOS right click)
            if (!disabled && event.button === 0 && event.ctrlKey === false) {
                context.onOpenToggle(); // prevent trigger focusing when opening
                // this allows the content to be given focus without competition
                if (!context.open) event.preventDefault();
            }
        }),
        onKeyDown: (0, $2IwC4.composeEventHandlers)(props.onKeyDown, (event)=>{
            if (disabled) return;
            if ([
                "Enter",
                " "
            ].includes(event.key)) context.onOpenToggle();
            if (event.key === "ArrowDown") context.onOpenChange(true); // prevent keydown from scrolling window / first focused item to execute
            // that keydown (inadvertently closing the menu)
            if ([
                "Enter",
                " ",
                "ArrowDown"
            ].includes(event.key)) event.preventDefault();
        })
    })));
});
/*#__PURE__*/ Object.assign($a51a7192f883dda1$export$d2469213b3befba9, {
    displayName: $a51a7192f883dda1$var$$d08ef79370b62062$var$TRIGGER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DropdownMenuPortal
 * -----------------------------------------------------------------------------------------------*/ const $a51a7192f883dda1$var$$d08ef79370b62062$var$PORTAL_NAME = "DropdownMenuPortal";
const $a51a7192f883dda1$export$cd369b4d4d54efc9 = (props)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, ...portalProps } = props;
    const menuScope = $a51a7192f883dda1$var$$d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $21LnN.Portal), (0, $8nd05.default)({}, menuScope, portalProps));
};
/*#__PURE__*/ Object.assign($a51a7192f883dda1$export$cd369b4d4d54efc9, {
    displayName: $a51a7192f883dda1$var$$d08ef79370b62062$var$PORTAL_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DropdownMenuContent
 * -----------------------------------------------------------------------------------------------*/ const $a51a7192f883dda1$var$$d08ef79370b62062$var$CONTENT_NAME = "DropdownMenuContent";
const $a51a7192f883dda1$export$6e76d93a37c01248 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, ...contentProps } = props;
    const context = $a51a7192f883dda1$var$$d08ef79370b62062$var$useDropdownMenuContext($a51a7192f883dda1$var$$d08ef79370b62062$var$CONTENT_NAME, __scopeDropdownMenu);
    const menuScope = $a51a7192f883dda1$var$$d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
    const hasInteractedOutsideRef = (0, $acw62.useRef)(false);
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $21LnN.Content), (0, $8nd05.default)({
        id: context.contentId,
        "aria-labelledby": context.triggerId
    }, menuScope, contentProps, {
        ref: forwardedRef,
        onCloseAutoFocus: (0, $2IwC4.composeEventHandlers)(props.onCloseAutoFocus, (event)=>{
            var _context$triggerRef$c;
            if (!hasInteractedOutsideRef.current) (_context$triggerRef$c = context.triggerRef.current) === null || _context$triggerRef$c === void 0 || _context$triggerRef$c.focus();
            hasInteractedOutsideRef.current = false; // Always prevent auto focus because we either focus manually or want user agent focus
            event.preventDefault();
        }),
        onInteractOutside: (0, $2IwC4.composeEventHandlers)(props.onInteractOutside, (event)=>{
            const originalEvent = event.detail.originalEvent;
            const ctrlLeftClick = originalEvent.button === 0 && originalEvent.ctrlKey === true;
            const isRightClick = originalEvent.button === 2 || ctrlLeftClick;
            if (!context.modal || isRightClick) hasInteractedOutsideRef.current = true;
        }),
        style: {
            ...props.style,
            "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
            "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
            "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
            "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
            "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
        }
    }));
});
/*#__PURE__*/ Object.assign($a51a7192f883dda1$export$6e76d93a37c01248, {
    displayName: $a51a7192f883dda1$var$$d08ef79370b62062$var$CONTENT_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DropdownMenuGroup
 * -----------------------------------------------------------------------------------------------*/ const $a51a7192f883dda1$var$$d08ef79370b62062$var$GROUP_NAME = "DropdownMenuGroup";
const $a51a7192f883dda1$export$246bebaba3a2f70e = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, ...groupProps } = props;
    const menuScope = $a51a7192f883dda1$var$$d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $21LnN.Group), (0, $8nd05.default)({}, menuScope, groupProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($a51a7192f883dda1$export$246bebaba3a2f70e, {
    displayName: $a51a7192f883dda1$var$$d08ef79370b62062$var$GROUP_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DropdownMenuLabel
 * -----------------------------------------------------------------------------------------------*/ const $a51a7192f883dda1$var$$d08ef79370b62062$var$LABEL_NAME = "DropdownMenuLabel";
const $a51a7192f883dda1$export$76e48c5b57f24495 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, ...labelProps } = props;
    const menuScope = $a51a7192f883dda1$var$$d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $21LnN.Label), (0, $8nd05.default)({}, menuScope, labelProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($a51a7192f883dda1$export$76e48c5b57f24495, {
    displayName: $a51a7192f883dda1$var$$d08ef79370b62062$var$LABEL_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DropdownMenuItem
 * -----------------------------------------------------------------------------------------------*/ const $a51a7192f883dda1$var$$d08ef79370b62062$var$ITEM_NAME = "DropdownMenuItem";
const $a51a7192f883dda1$export$ed97964d1871885d = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, ...itemProps } = props;
    const menuScope = $a51a7192f883dda1$var$$d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $21LnN.Item), (0, $8nd05.default)({}, menuScope, itemProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($a51a7192f883dda1$export$ed97964d1871885d, {
    displayName: $a51a7192f883dda1$var$$d08ef79370b62062$var$ITEM_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DropdownMenuCheckboxItem
 * -----------------------------------------------------------------------------------------------*/ const $a51a7192f883dda1$var$$d08ef79370b62062$var$CHECKBOX_ITEM_NAME = "DropdownMenuCheckboxItem";
const $a51a7192f883dda1$export$53a69729da201fa9 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, ...checkboxItemProps } = props;
    const menuScope = $a51a7192f883dda1$var$$d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $21LnN.CheckboxItem), (0, $8nd05.default)({}, menuScope, checkboxItemProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($a51a7192f883dda1$export$53a69729da201fa9, {
    displayName: $a51a7192f883dda1$var$$d08ef79370b62062$var$CHECKBOX_ITEM_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DropdownMenuRadioGroup
 * -----------------------------------------------------------------------------------------------*/ const $a51a7192f883dda1$var$$d08ef79370b62062$var$RADIO_GROUP_NAME = "DropdownMenuRadioGroup";
const $a51a7192f883dda1$export$3323ad73d55f587e = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, ...radioGroupProps } = props;
    const menuScope = $a51a7192f883dda1$var$$d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $21LnN.RadioGroup), (0, $8nd05.default)({}, menuScope, radioGroupProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($a51a7192f883dda1$export$3323ad73d55f587e, {
    displayName: $a51a7192f883dda1$var$$d08ef79370b62062$var$RADIO_GROUP_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DropdownMenuRadioItem
 * -----------------------------------------------------------------------------------------------*/ const $a51a7192f883dda1$var$$d08ef79370b62062$var$RADIO_ITEM_NAME = "DropdownMenuRadioItem";
const $a51a7192f883dda1$export$e4f69b41b1637536 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, ...radioItemProps } = props;
    const menuScope = $a51a7192f883dda1$var$$d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $21LnN.RadioItem), (0, $8nd05.default)({}, menuScope, radioItemProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($a51a7192f883dda1$export$e4f69b41b1637536, {
    displayName: $a51a7192f883dda1$var$$d08ef79370b62062$var$RADIO_ITEM_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DropdownMenuItemIndicator
 * -----------------------------------------------------------------------------------------------*/ const $a51a7192f883dda1$var$$d08ef79370b62062$var$INDICATOR_NAME = "DropdownMenuItemIndicator";
const $a51a7192f883dda1$export$42355ae145153fb6 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, ...itemIndicatorProps } = props;
    const menuScope = $a51a7192f883dda1$var$$d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $21LnN.ItemIndicator), (0, $8nd05.default)({}, menuScope, itemIndicatorProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($a51a7192f883dda1$export$42355ae145153fb6, {
    displayName: $a51a7192f883dda1$var$$d08ef79370b62062$var$INDICATOR_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DropdownMenuSeparator
 * -----------------------------------------------------------------------------------------------*/ const $a51a7192f883dda1$var$$d08ef79370b62062$var$SEPARATOR_NAME = "DropdownMenuSeparator";
const $a51a7192f883dda1$export$da160178fd3bc7e9 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, ...separatorProps } = props;
    const menuScope = $a51a7192f883dda1$var$$d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $21LnN.Separator), (0, $8nd05.default)({}, menuScope, separatorProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($a51a7192f883dda1$export$da160178fd3bc7e9, {
    displayName: $a51a7192f883dda1$var$$d08ef79370b62062$var$SEPARATOR_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DropdownMenuArrow
 * -----------------------------------------------------------------------------------------------*/ const $a51a7192f883dda1$var$$d08ef79370b62062$var$ARROW_NAME = "DropdownMenuArrow";
const $a51a7192f883dda1$export$34b8980744021ec5 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, ...arrowProps } = props;
    const menuScope = $a51a7192f883dda1$var$$d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $21LnN.Arrow), (0, $8nd05.default)({}, menuScope, arrowProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($a51a7192f883dda1$export$34b8980744021ec5, {
    displayName: $a51a7192f883dda1$var$$d08ef79370b62062$var$ARROW_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DropdownMenuSub
 * -----------------------------------------------------------------------------------------------*/ const $a51a7192f883dda1$export$2f307d81a64f5442 = (props)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, children: children, open: openProp, onOpenChange: onOpenChange, defaultOpen: defaultOpen } = props;
    const menuScope = $a51a7192f883dda1$var$$d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
    const [open = false, setOpen] = (0, $88UcQ.useControllableState)({
        prop: openProp,
        defaultProp: defaultOpen,
        onChange: onOpenChange
    });
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $21LnN.Sub), (0, $8nd05.default)({}, menuScope, {
        open: open,
        onOpenChange: setOpen
    }), children);
};
/* -------------------------------------------------------------------------------------------------
 * DropdownMenuSubTrigger
 * -----------------------------------------------------------------------------------------------*/ const $a51a7192f883dda1$var$$d08ef79370b62062$var$SUB_TRIGGER_NAME = "DropdownMenuSubTrigger";
const $a51a7192f883dda1$export$21dcb7ec56f874cf = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, ...subTriggerProps } = props;
    const menuScope = $a51a7192f883dda1$var$$d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $21LnN.SubTrigger), (0, $8nd05.default)({}, menuScope, subTriggerProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($a51a7192f883dda1$export$21dcb7ec56f874cf, {
    displayName: $a51a7192f883dda1$var$$d08ef79370b62062$var$SUB_TRIGGER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DropdownMenuSubContent
 * -----------------------------------------------------------------------------------------------*/ const $a51a7192f883dda1$var$$d08ef79370b62062$var$SUB_CONTENT_NAME = "DropdownMenuSubContent";
const $a51a7192f883dda1$export$f34ec8bc2482cc5f = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, ...subContentProps } = props;
    const menuScope = $a51a7192f883dda1$var$$d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $21LnN.SubContent), (0, $8nd05.default)({}, menuScope, subContentProps, {
        ref: forwardedRef,
        style: {
            ...props.style,
            "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
            "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
            "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
            "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
            "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
        }
    }));
});
/*#__PURE__*/ Object.assign($a51a7192f883dda1$export$f34ec8bc2482cc5f, {
    displayName: $a51a7192f883dda1$var$$d08ef79370b62062$var$SUB_CONTENT_NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $a51a7192f883dda1$export$be92b6f5f03c0fe9 = $a51a7192f883dda1$export$e44a253a59704894;
const $a51a7192f883dda1$export$41fb9f06171c75f4 = $a51a7192f883dda1$export$d2469213b3befba9;
const $a51a7192f883dda1$export$602eac185826482c = $a51a7192f883dda1$export$cd369b4d4d54efc9;
const $a51a7192f883dda1$export$7c6e2c02157bb7d2 = $a51a7192f883dda1$export$6e76d93a37c01248;
const $a51a7192f883dda1$export$eb2fcfdbd7ba97d4 = $a51a7192f883dda1$export$246bebaba3a2f70e;
const $a51a7192f883dda1$export$b04be29aa201d4f5 = $a51a7192f883dda1$export$76e48c5b57f24495;
const $a51a7192f883dda1$export$6d08773d2e66f8f2 = $a51a7192f883dda1$export$ed97964d1871885d;
const $a51a7192f883dda1$export$16ce288f89fa631c = $a51a7192f883dda1$export$53a69729da201fa9;
const $a51a7192f883dda1$export$a98f0dcb43a68a25 = $a51a7192f883dda1$export$3323ad73d55f587e;
const $a51a7192f883dda1$export$371ab307eab489c0 = $a51a7192f883dda1$export$e4f69b41b1637536;
const $a51a7192f883dda1$export$c3468e2714d175fa = $a51a7192f883dda1$export$42355ae145153fb6;
const $a51a7192f883dda1$export$1ff3c3f08ae963c0 = $a51a7192f883dda1$export$da160178fd3bc7e9;
const $a51a7192f883dda1$export$21b07c8f274aebd5 = $a51a7192f883dda1$export$34b8980744021ec5;
const $a51a7192f883dda1$export$d7a01e11500dfb6f = $a51a7192f883dda1$export$2f307d81a64f5442;
const $a51a7192f883dda1$export$2ea8a7a591ac5eac = $a51a7192f883dda1$export$21dcb7ec56f874cf;
const $a51a7192f883dda1$export$6d4de93b380beddf = $a51a7192f883dda1$export$f34ec8bc2482cc5f;

});
parcelRegister("21LnN", function(module, exports) {

$parcel$export(module.exports, "createMenuScope", () => $82110f2367303f9b$export$4027731b685e72eb);
$parcel$export(module.exports, "Root", () => $82110f2367303f9b$export$be92b6f5f03c0fe9);
$parcel$export(module.exports, "Anchor", () => $82110f2367303f9b$export$b688253958b8dfe7);
$parcel$export(module.exports, "Portal", () => $82110f2367303f9b$export$602eac185826482c);
$parcel$export(module.exports, "Content", () => $82110f2367303f9b$export$7c6e2c02157bb7d2);
$parcel$export(module.exports, "Group", () => $82110f2367303f9b$export$eb2fcfdbd7ba97d4);
$parcel$export(module.exports, "Label", () => $82110f2367303f9b$export$b04be29aa201d4f5);
$parcel$export(module.exports, "Item", () => $82110f2367303f9b$export$6d08773d2e66f8f2);
$parcel$export(module.exports, "CheckboxItem", () => $82110f2367303f9b$export$16ce288f89fa631c);
$parcel$export(module.exports, "RadioGroup", () => $82110f2367303f9b$export$a98f0dcb43a68a25);
$parcel$export(module.exports, "RadioItem", () => $82110f2367303f9b$export$371ab307eab489c0);
$parcel$export(module.exports, "ItemIndicator", () => $82110f2367303f9b$export$c3468e2714d175fa);
$parcel$export(module.exports, "Separator", () => $82110f2367303f9b$export$1ff3c3f08ae963c0);
$parcel$export(module.exports, "Arrow", () => $82110f2367303f9b$export$21b07c8f274aebd5);
$parcel$export(module.exports, "Sub", () => $82110f2367303f9b$export$d7a01e11500dfb6f);
$parcel$export(module.exports, "SubTrigger", () => $82110f2367303f9b$export$2ea8a7a591ac5eac);
$parcel$export(module.exports, "SubContent", () => $82110f2367303f9b$export$6d4de93b380beddf);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $2IwC4 = parcelRequire("2IwC4");

var $9nBzD = parcelRequire("9nBzD");

var $htT6J = parcelRequire("htT6J");

var $jnK0n = parcelRequire("jnK0n");

var $5ZQml = parcelRequire("5ZQml");

var $4yZYB = parcelRequire("4yZYB");

var $fg1c6 = parcelRequire("fg1c6");

var $kNgwr = parcelRequire("kNgwr");

var $g2NP0 = parcelRequire("g2NP0");

var $jxYRk = parcelRequire("jxYRk");

var $5nYva = parcelRequire("5nYva");

var $cTFdF = parcelRequire("cTFdF");

var $kFbxc = parcelRequire("kFbxc");

var $abA6z = parcelRequire("abA6z");

var $9UeUh = parcelRequire("9UeUh");

var $by19I = parcelRequire("by19I");

var $6okVC = parcelRequire("6okVC");

var $hPyeV = parcelRequire("hPyeV");
const $82110f2367303f9b$var$$6cc32821e9371a1c$var$SELECTION_KEYS = [
    "Enter",
    " "
];
const $82110f2367303f9b$var$$6cc32821e9371a1c$var$FIRST_KEYS = [
    "ArrowDown",
    "PageUp",
    "Home"
];
const $82110f2367303f9b$var$$6cc32821e9371a1c$var$LAST_KEYS = [
    "ArrowUp",
    "PageDown",
    "End"
];
const $82110f2367303f9b$var$$6cc32821e9371a1c$var$FIRST_LAST_KEYS = [
    ...$82110f2367303f9b$var$$6cc32821e9371a1c$var$FIRST_KEYS,
    ...$82110f2367303f9b$var$$6cc32821e9371a1c$var$LAST_KEYS
];
const $82110f2367303f9b$var$$6cc32821e9371a1c$var$SUB_OPEN_KEYS = {
    ltr: [
        ...$82110f2367303f9b$var$$6cc32821e9371a1c$var$SELECTION_KEYS,
        "ArrowRight"
    ],
    rtl: [
        ...$82110f2367303f9b$var$$6cc32821e9371a1c$var$SELECTION_KEYS,
        "ArrowLeft"
    ]
};
const $82110f2367303f9b$var$$6cc32821e9371a1c$var$SUB_CLOSE_KEYS = {
    ltr: [
        "ArrowLeft"
    ],
    rtl: [
        "ArrowRight"
    ]
};
/* -------------------------------------------------------------------------------------------------
 * Menu
 * -----------------------------------------------------------------------------------------------*/ const $82110f2367303f9b$var$$6cc32821e9371a1c$var$MENU_NAME = "Menu";
const [$82110f2367303f9b$var$$6cc32821e9371a1c$var$Collection, $82110f2367303f9b$var$$6cc32821e9371a1c$var$useCollection, $82110f2367303f9b$var$$6cc32821e9371a1c$var$createCollectionScope] = (0, $9nBzD.createCollection)($82110f2367303f9b$var$$6cc32821e9371a1c$var$MENU_NAME);
const [$82110f2367303f9b$var$$6cc32821e9371a1c$var$createMenuContext, $82110f2367303f9b$export$4027731b685e72eb] = (0, $jnK0n.createContextScope)($82110f2367303f9b$var$$6cc32821e9371a1c$var$MENU_NAME, [
    $82110f2367303f9b$var$$6cc32821e9371a1c$var$createCollectionScope,
    (0, $jxYRk.createPopperScope),
    (0, $abA6z.createRovingFocusGroupScope)
]);
const $82110f2367303f9b$var$$6cc32821e9371a1c$var$usePopperScope = (0, $jxYRk.createPopperScope)();
const $82110f2367303f9b$var$$6cc32821e9371a1c$var$useRovingFocusGroupScope = (0, $abA6z.createRovingFocusGroupScope)();
const [$82110f2367303f9b$var$$6cc32821e9371a1c$var$MenuProvider, $82110f2367303f9b$var$$6cc32821e9371a1c$var$useMenuContext] = $82110f2367303f9b$var$$6cc32821e9371a1c$var$createMenuContext($82110f2367303f9b$var$$6cc32821e9371a1c$var$MENU_NAME);
const [$82110f2367303f9b$var$$6cc32821e9371a1c$var$MenuRootProvider, $82110f2367303f9b$var$$6cc32821e9371a1c$var$useMenuRootContext] = $82110f2367303f9b$var$$6cc32821e9371a1c$var$createMenuContext($82110f2367303f9b$var$$6cc32821e9371a1c$var$MENU_NAME);
const $82110f2367303f9b$export$d9b273488cd8ce6f = (props)=>{
    const { __scopeMenu: __scopeMenu, open: open = false, children: children, dir: dir, onOpenChange: onOpenChange, modal: modal = true } = props;
    const popperScope = $82110f2367303f9b$var$$6cc32821e9371a1c$var$usePopperScope(__scopeMenu);
    const [content, setContent] = (0, $acw62.useState)(null);
    const isUsingKeyboardRef = (0, $acw62.useRef)(false);
    const handleOpenChange = (0, $by19I.useCallbackRef)(onOpenChange);
    const direction = (0, $5ZQml.useDirection)(dir);
    (0, $acw62.useEffect)(()=>{
        // Capture phase ensures we set the boolean before any side effects execute
        // in response to the key or pointer event as they might depend on this value.
        const handleKeyDown = ()=>{
            isUsingKeyboardRef.current = true;
            document.addEventListener("pointerdown", handlePointer, {
                capture: true,
                once: true
            });
            document.addEventListener("pointermove", handlePointer, {
                capture: true,
                once: true
            });
        };
        const handlePointer = ()=>isUsingKeyboardRef.current = false;
        document.addEventListener("keydown", handleKeyDown, {
            capture: true
        });
        return ()=>{
            document.removeEventListener("keydown", handleKeyDown, {
                capture: true
            });
            document.removeEventListener("pointerdown", handlePointer, {
                capture: true
            });
            document.removeEventListener("pointermove", handlePointer, {
                capture: true
            });
        };
    }, []);
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $jxYRk.Root), popperScope, /*#__PURE__*/ (0, $acw62.createElement)($82110f2367303f9b$var$$6cc32821e9371a1c$var$MenuProvider, {
        scope: __scopeMenu,
        open: open,
        onOpenChange: handleOpenChange,
        content: content,
        onContentChange: setContent
    }, /*#__PURE__*/ (0, $acw62.createElement)($82110f2367303f9b$var$$6cc32821e9371a1c$var$MenuRootProvider, {
        scope: __scopeMenu,
        onClose: (0, $acw62.useCallback)(()=>handleOpenChange(false), [
            handleOpenChange
        ]),
        isUsingKeyboardRef: isUsingKeyboardRef,
        dir: direction,
        modal: modal
    }, children)));
};
/*#__PURE__*/ Object.assign($82110f2367303f9b$export$d9b273488cd8ce6f, {
    displayName: $82110f2367303f9b$var$$6cc32821e9371a1c$var$MENU_NAME
});
/* -------------------------------------------------------------------------------------------------
 * MenuAnchor
 * -----------------------------------------------------------------------------------------------*/ const $82110f2367303f9b$var$$6cc32821e9371a1c$var$ANCHOR_NAME = "MenuAnchor";
const $82110f2367303f9b$export$9fa5ebd18bee4d43 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopeMenu: __scopeMenu, ...anchorProps } = props;
    const popperScope = $82110f2367303f9b$var$$6cc32821e9371a1c$var$usePopperScope(__scopeMenu);
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $jxYRk.Anchor), (0, $8nd05.default)({}, popperScope, anchorProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($82110f2367303f9b$export$9fa5ebd18bee4d43, {
    displayName: $82110f2367303f9b$var$$6cc32821e9371a1c$var$ANCHOR_NAME
});
/* -------------------------------------------------------------------------------------------------
 * MenuPortal
 * -----------------------------------------------------------------------------------------------*/ const $82110f2367303f9b$var$$6cc32821e9371a1c$var$PORTAL_NAME = "MenuPortal";
const [$82110f2367303f9b$var$$6cc32821e9371a1c$var$PortalProvider, $82110f2367303f9b$var$$6cc32821e9371a1c$var$usePortalContext] = $82110f2367303f9b$var$$6cc32821e9371a1c$var$createMenuContext($82110f2367303f9b$var$$6cc32821e9371a1c$var$PORTAL_NAME, {
    forceMount: undefined
});
const $82110f2367303f9b$export$793392f970497feb = (props)=>{
    const { __scopeMenu: __scopeMenu, forceMount: forceMount, children: children, container: container } = props;
    const context = $82110f2367303f9b$var$$6cc32821e9371a1c$var$useMenuContext($82110f2367303f9b$var$$6cc32821e9371a1c$var$PORTAL_NAME, __scopeMenu);
    return /*#__PURE__*/ (0, $acw62.createElement)($82110f2367303f9b$var$$6cc32821e9371a1c$var$PortalProvider, {
        scope: __scopeMenu,
        forceMount: forceMount
    }, /*#__PURE__*/ (0, $acw62.createElement)((0, $cTFdF.Presence), {
        present: forceMount || context.open
    }, /*#__PURE__*/ (0, $acw62.createElement)((0, $5nYva.Portal), {
        asChild: true,
        container: container
    }, children)));
};
/*#__PURE__*/ Object.assign($82110f2367303f9b$export$793392f970497feb, {
    displayName: $82110f2367303f9b$var$$6cc32821e9371a1c$var$PORTAL_NAME
});
/* -------------------------------------------------------------------------------------------------
 * MenuContent
 * -----------------------------------------------------------------------------------------------*/ const $82110f2367303f9b$var$$6cc32821e9371a1c$var$CONTENT_NAME = "MenuContent";
const [$82110f2367303f9b$var$$6cc32821e9371a1c$var$MenuContentProvider, $82110f2367303f9b$var$$6cc32821e9371a1c$var$useMenuContentContext] = $82110f2367303f9b$var$$6cc32821e9371a1c$var$createMenuContext($82110f2367303f9b$var$$6cc32821e9371a1c$var$CONTENT_NAME);
const $82110f2367303f9b$export$479f0f2f71193efe = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const portalContext = $82110f2367303f9b$var$$6cc32821e9371a1c$var$usePortalContext($82110f2367303f9b$var$$6cc32821e9371a1c$var$CONTENT_NAME, props.__scopeMenu);
    const { forceMount: forceMount = portalContext.forceMount, ...contentProps } = props;
    const context = $82110f2367303f9b$var$$6cc32821e9371a1c$var$useMenuContext($82110f2367303f9b$var$$6cc32821e9371a1c$var$CONTENT_NAME, props.__scopeMenu);
    const rootContext = $82110f2367303f9b$var$$6cc32821e9371a1c$var$useMenuRootContext($82110f2367303f9b$var$$6cc32821e9371a1c$var$CONTENT_NAME, props.__scopeMenu);
    return /*#__PURE__*/ (0, $acw62.createElement)($82110f2367303f9b$var$$6cc32821e9371a1c$var$Collection.Provider, {
        scope: props.__scopeMenu
    }, /*#__PURE__*/ (0, $acw62.createElement)((0, $cTFdF.Presence), {
        present: forceMount || context.open
    }, /*#__PURE__*/ (0, $acw62.createElement)($82110f2367303f9b$var$$6cc32821e9371a1c$var$Collection.Slot, {
        scope: props.__scopeMenu
    }, rootContext.modal ? /*#__PURE__*/ (0, $acw62.createElement)($82110f2367303f9b$var$$6cc32821e9371a1c$var$MenuRootContentModal, (0, $8nd05.default)({}, contentProps, {
        ref: forwardedRef
    })) : /*#__PURE__*/ (0, $acw62.createElement)($82110f2367303f9b$var$$6cc32821e9371a1c$var$MenuRootContentNonModal, (0, $8nd05.default)({}, contentProps, {
        ref: forwardedRef
    })))));
});
/* ---------------------------------------------------------------------------------------------- */ const $82110f2367303f9b$var$$6cc32821e9371a1c$var$MenuRootContentModal = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const context = $82110f2367303f9b$var$$6cc32821e9371a1c$var$useMenuContext($82110f2367303f9b$var$$6cc32821e9371a1c$var$CONTENT_NAME, props.__scopeMenu);
    const ref = (0, $acw62.useRef)(null);
    const composedRefs = (0, $htT6J.useComposedRefs)(forwardedRef, ref); // Hide everything from ARIA except the `MenuContent`
    (0, $acw62.useEffect)(()=>{
        const content = ref.current;
        if (content) return (0, $6okVC.hideOthers)(content);
    }, []);
    return /*#__PURE__*/ (0, $acw62.createElement)($82110f2367303f9b$var$$6cc32821e9371a1c$var$MenuContentImpl, (0, $8nd05.default)({}, props, {
        ref: composedRefs // we make sure we're not trapping once it's been closed
        ,
        trapFocus: context.open // make sure to only disable pointer events when open
        ,
        disableOutsidePointerEvents: context.open,
        disableOutsideScroll: true // When focus is trapped, a `focusout` event may still happen.
        ,
        onFocusOutside: (0, $2IwC4.composeEventHandlers)(props.onFocusOutside, (event)=>event.preventDefault(), {
            checkForDefaultPrevented: false
        }),
        onDismiss: ()=>context.onOpenChange(false)
    }));
});
const $82110f2367303f9b$var$$6cc32821e9371a1c$var$MenuRootContentNonModal = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const context = $82110f2367303f9b$var$$6cc32821e9371a1c$var$useMenuContext($82110f2367303f9b$var$$6cc32821e9371a1c$var$CONTENT_NAME, props.__scopeMenu);
    return /*#__PURE__*/ (0, $acw62.createElement)($82110f2367303f9b$var$$6cc32821e9371a1c$var$MenuContentImpl, (0, $8nd05.default)({}, props, {
        ref: forwardedRef,
        trapFocus: false,
        disableOutsidePointerEvents: false,
        disableOutsideScroll: false,
        onDismiss: ()=>context.onOpenChange(false)
    }));
});
/* ---------------------------------------------------------------------------------------------- */ const $82110f2367303f9b$var$$6cc32821e9371a1c$var$MenuContentImpl = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopeMenu: __scopeMenu, loop: loop = false, trapFocus: trapFocus, onOpenAutoFocus: onOpenAutoFocus, onCloseAutoFocus: onCloseAutoFocus, disableOutsidePointerEvents: disableOutsidePointerEvents, onEntryFocus: onEntryFocus, onEscapeKeyDown: onEscapeKeyDown, onPointerDownOutside: onPointerDownOutside, onFocusOutside: onFocusOutside, onInteractOutside: onInteractOutside, onDismiss: onDismiss, disableOutsideScroll: disableOutsideScroll, ...contentProps } = props;
    const context = $82110f2367303f9b$var$$6cc32821e9371a1c$var$useMenuContext($82110f2367303f9b$var$$6cc32821e9371a1c$var$CONTENT_NAME, __scopeMenu);
    const rootContext = $82110f2367303f9b$var$$6cc32821e9371a1c$var$useMenuRootContext($82110f2367303f9b$var$$6cc32821e9371a1c$var$CONTENT_NAME, __scopeMenu);
    const popperScope = $82110f2367303f9b$var$$6cc32821e9371a1c$var$usePopperScope(__scopeMenu);
    const rovingFocusGroupScope = $82110f2367303f9b$var$$6cc32821e9371a1c$var$useRovingFocusGroupScope(__scopeMenu);
    const getItems = $82110f2367303f9b$var$$6cc32821e9371a1c$var$useCollection(__scopeMenu);
    const [currentItemId, setCurrentItemId] = (0, $acw62.useState)(null);
    const contentRef = (0, $acw62.useRef)(null);
    const composedRefs = (0, $htT6J.useComposedRefs)(forwardedRef, contentRef, context.onContentChange);
    const timerRef = (0, $acw62.useRef)(0);
    const searchRef = (0, $acw62.useRef)("");
    const pointerGraceTimerRef = (0, $acw62.useRef)(0);
    const pointerGraceIntentRef = (0, $acw62.useRef)(null);
    const pointerDirRef = (0, $acw62.useRef)("right");
    const lastPointerXRef = (0, $acw62.useRef)(0);
    const ScrollLockWrapper = disableOutsideScroll ? (0, $hPyeV.default) : (0, $acw62.Fragment);
    const scrollLockWrapperProps = disableOutsideScroll ? {
        as: (0, $9UeUh.Slot),
        allowPinchZoom: true
    } : undefined;
    const handleTypeaheadSearch = (key)=>{
        var _items$find, _items$find2;
        const search = searchRef.current + key;
        const items = getItems().filter((item)=>!item.disabled);
        const currentItem = document.activeElement;
        const currentMatch = (_items$find = items.find((item)=>item.ref.current === currentItem)) === null || _items$find === void 0 ? void 0 : _items$find.textValue;
        const values = items.map((item)=>item.textValue);
        const nextMatch = $82110f2367303f9b$var$$6cc32821e9371a1c$var$getNextMatch(values, search, currentMatch);
        const newItem = (_items$find2 = items.find((item)=>item.textValue === nextMatch)) === null || _items$find2 === void 0 ? void 0 : _items$find2.ref.current; // Reset `searchRef` 1 second after it was last updated
        (function updateSearch(value) {
            searchRef.current = value;
            window.clearTimeout(timerRef.current);
            if (value !== "") timerRef.current = window.setTimeout(()=>updateSearch(""), 1000);
        })(search);
        if (newItem) /**
       * Imperative focus during keydown is risky so we prevent React's batching updates
       * to avoid potential bugs. See: https://github.com/facebook/react/issues/20332
       */ setTimeout(()=>newItem.focus());
    };
    (0, $acw62.useEffect)(()=>{
        return ()=>window.clearTimeout(timerRef.current);
    }, []); // Make sure the whole tree has focus guards as our `MenuContent` may be
    // the last element in the DOM (beacuse of the `Portal`)
    (0, $fg1c6.useFocusGuards)();
    const isPointerMovingToSubmenu = (0, $acw62.useCallback)((event)=>{
        var _pointerGraceIntentRe, _pointerGraceIntentRe2;
        const isMovingTowards = pointerDirRef.current === ((_pointerGraceIntentRe = pointerGraceIntentRef.current) === null || _pointerGraceIntentRe === void 0 ? void 0 : _pointerGraceIntentRe.side);
        return isMovingTowards && $82110f2367303f9b$var$$6cc32821e9371a1c$var$isPointerInGraceArea(event, (_pointerGraceIntentRe2 = pointerGraceIntentRef.current) === null || _pointerGraceIntentRe2 === void 0 ? void 0 : _pointerGraceIntentRe2.area);
    }, []);
    return /*#__PURE__*/ (0, $acw62.createElement)($82110f2367303f9b$var$$6cc32821e9371a1c$var$MenuContentProvider, {
        scope: __scopeMenu,
        searchRef: searchRef,
        onItemEnter: (0, $acw62.useCallback)((event)=>{
            if (isPointerMovingToSubmenu(event)) event.preventDefault();
        }, [
            isPointerMovingToSubmenu
        ]),
        onItemLeave: (0, $acw62.useCallback)((event)=>{
            var _contentRef$current;
            if (isPointerMovingToSubmenu(event)) return;
            (_contentRef$current = contentRef.current) === null || _contentRef$current === void 0 || _contentRef$current.focus();
            setCurrentItemId(null);
        }, [
            isPointerMovingToSubmenu
        ]),
        onTriggerLeave: (0, $acw62.useCallback)((event)=>{
            if (isPointerMovingToSubmenu(event)) event.preventDefault();
        }, [
            isPointerMovingToSubmenu
        ]),
        pointerGraceTimerRef: pointerGraceTimerRef,
        onPointerGraceIntentChange: (0, $acw62.useCallback)((intent)=>{
            pointerGraceIntentRef.current = intent;
        }, [])
    }, /*#__PURE__*/ (0, $acw62.createElement)(ScrollLockWrapper, scrollLockWrapperProps, /*#__PURE__*/ (0, $acw62.createElement)((0, $kNgwr.FocusScope), {
        asChild: true,
        trapped: trapFocus,
        onMountAutoFocus: (0, $2IwC4.composeEventHandlers)(onOpenAutoFocus, (event)=>{
            var _contentRef$current2;
            // when opening, explicitly focus the content area only and leave
            // `onEntryFocus` in  control of focusing first item
            event.preventDefault();
            (_contentRef$current2 = contentRef.current) === null || _contentRef$current2 === void 0 || _contentRef$current2.focus();
        }),
        onUnmountAutoFocus: onCloseAutoFocus
    }, /*#__PURE__*/ (0, $acw62.createElement)((0, $4yZYB.DismissableLayer), {
        asChild: true,
        disableOutsidePointerEvents: disableOutsidePointerEvents,
        onEscapeKeyDown: onEscapeKeyDown,
        onPointerDownOutside: onPointerDownOutside,
        onFocusOutside: onFocusOutside,
        onInteractOutside: onInteractOutside,
        onDismiss: onDismiss
    }, /*#__PURE__*/ (0, $acw62.createElement)((0, $abA6z.Root), (0, $8nd05.default)({
        asChild: true
    }, rovingFocusGroupScope, {
        dir: rootContext.dir,
        orientation: "vertical",
        loop: loop,
        currentTabStopId: currentItemId,
        onCurrentTabStopIdChange: setCurrentItemId,
        onEntryFocus: (0, $2IwC4.composeEventHandlers)(onEntryFocus, (event)=>{
            // only focus first item when using keyboard
            if (!rootContext.isUsingKeyboardRef.current) event.preventDefault();
        })
    }), /*#__PURE__*/ (0, $acw62.createElement)((0, $jxYRk.Content), (0, $8nd05.default)({
        role: "menu",
        "aria-orientation": "vertical",
        "data-state": $82110f2367303f9b$var$$6cc32821e9371a1c$var$getOpenState(context.open),
        "data-radix-menu-content": "",
        dir: rootContext.dir
    }, popperScope, contentProps, {
        ref: composedRefs,
        style: {
            outline: "none",
            ...contentProps.style
        },
        onKeyDown: (0, $2IwC4.composeEventHandlers)(contentProps.onKeyDown, (event)=>{
            // submenu key events bubble through portals. We only care about keys in this menu.
            const target = event.target;
            const isKeyDownInside = target.closest("[data-radix-menu-content]") === event.currentTarget;
            const isModifierKey = event.ctrlKey || event.altKey || event.metaKey;
            const isCharacterKey = event.key.length === 1;
            if (isKeyDownInside) {
                // menus should not be navigated using tab key so we prevent it
                if (event.key === "Tab") event.preventDefault();
                if (!isModifierKey && isCharacterKey) handleTypeaheadSearch(event.key);
            } // focus first/last item based on key pressed
            const content = contentRef.current;
            if (event.target !== content) return;
            if (!$82110f2367303f9b$var$$6cc32821e9371a1c$var$FIRST_LAST_KEYS.includes(event.key)) return;
            event.preventDefault();
            const items = getItems().filter((item)=>!item.disabled);
            const candidateNodes = items.map((item)=>item.ref.current);
            if ($82110f2367303f9b$var$$6cc32821e9371a1c$var$LAST_KEYS.includes(event.key)) candidateNodes.reverse();
            $82110f2367303f9b$var$$6cc32821e9371a1c$var$focusFirst(candidateNodes);
        }),
        onBlur: (0, $2IwC4.composeEventHandlers)(props.onBlur, (event)=>{
            // clear search buffer when leaving the menu
            if (!event.currentTarget.contains(event.target)) {
                window.clearTimeout(timerRef.current);
                searchRef.current = "";
            }
        }),
        onPointerMove: (0, $2IwC4.composeEventHandlers)(props.onPointerMove, $82110f2367303f9b$var$$6cc32821e9371a1c$var$whenMouse((event)=>{
            const target = event.target;
            const pointerXHasChanged = lastPointerXRef.current !== event.clientX; // We don't use `event.movementX` for this check because Safari will
            // always return `0` on a pointer event.
            if (event.currentTarget.contains(target) && pointerXHasChanged) {
                const newDir = event.clientX > lastPointerXRef.current ? "right" : "left";
                pointerDirRef.current = newDir;
                lastPointerXRef.current = event.clientX;
            }
        }))
    })))))));
});
/*#__PURE__*/ Object.assign($82110f2367303f9b$export$479f0f2f71193efe, {
    displayName: $82110f2367303f9b$var$$6cc32821e9371a1c$var$CONTENT_NAME
});
/* -------------------------------------------------------------------------------------------------
 * MenuGroup
 * -----------------------------------------------------------------------------------------------*/ const $82110f2367303f9b$var$$6cc32821e9371a1c$var$GROUP_NAME = "MenuGroup";
const $82110f2367303f9b$export$22a631d1f72787bb = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopeMenu: __scopeMenu, ...groupProps } = props;
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $kFbxc.Primitive).div, (0, $8nd05.default)({
        role: "group"
    }, groupProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($82110f2367303f9b$export$22a631d1f72787bb, {
    displayName: $82110f2367303f9b$var$$6cc32821e9371a1c$var$GROUP_NAME
});
/* -------------------------------------------------------------------------------------------------
 * MenuLabel
 * -----------------------------------------------------------------------------------------------*/ const $82110f2367303f9b$var$$6cc32821e9371a1c$var$LABEL_NAME = "MenuLabel";
const $82110f2367303f9b$export$dd37bec0e8a99143 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopeMenu: __scopeMenu, ...labelProps } = props;
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $kFbxc.Primitive).div, (0, $8nd05.default)({}, labelProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($82110f2367303f9b$export$dd37bec0e8a99143, {
    displayName: $82110f2367303f9b$var$$6cc32821e9371a1c$var$LABEL_NAME
});
/* -------------------------------------------------------------------------------------------------
 * MenuItem
 * -----------------------------------------------------------------------------------------------*/ const $82110f2367303f9b$var$$6cc32821e9371a1c$var$ITEM_NAME = "MenuItem";
const $82110f2367303f9b$var$$6cc32821e9371a1c$var$ITEM_SELECT = "menu.itemSelect";
const $82110f2367303f9b$export$2ce376c2cc3355c8 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { disabled: disabled = false, onSelect: onSelect, ...itemProps } = props;
    const ref = (0, $acw62.useRef)(null);
    const rootContext = $82110f2367303f9b$var$$6cc32821e9371a1c$var$useMenuRootContext($82110f2367303f9b$var$$6cc32821e9371a1c$var$ITEM_NAME, props.__scopeMenu);
    const contentContext = $82110f2367303f9b$var$$6cc32821e9371a1c$var$useMenuContentContext($82110f2367303f9b$var$$6cc32821e9371a1c$var$ITEM_NAME, props.__scopeMenu);
    const composedRefs = (0, $htT6J.useComposedRefs)(forwardedRef, ref);
    const isPointerDownRef = (0, $acw62.useRef)(false);
    const handleSelect = ()=>{
        const menuItem = ref.current;
        if (!disabled && menuItem) {
            const itemSelectEvent = new CustomEvent($82110f2367303f9b$var$$6cc32821e9371a1c$var$ITEM_SELECT, {
                bubbles: true,
                cancelable: true
            });
            menuItem.addEventListener($82110f2367303f9b$var$$6cc32821e9371a1c$var$ITEM_SELECT, (event)=>onSelect === null || onSelect === void 0 ? void 0 : onSelect(event), {
                once: true
            });
            (0, $kFbxc.dispatchDiscreteCustomEvent)(menuItem, itemSelectEvent);
            if (itemSelectEvent.defaultPrevented) isPointerDownRef.current = false;
            else rootContext.onClose();
        }
    };
    return /*#__PURE__*/ (0, $acw62.createElement)($82110f2367303f9b$var$$6cc32821e9371a1c$var$MenuItemImpl, (0, $8nd05.default)({}, itemProps, {
        ref: composedRefs,
        disabled: disabled,
        onClick: (0, $2IwC4.composeEventHandlers)(props.onClick, handleSelect),
        onPointerDown: (event)=>{
            var _props$onPointerDown;
            (_props$onPointerDown = props.onPointerDown) === null || _props$onPointerDown === void 0 || _props$onPointerDown.call(props, event);
            isPointerDownRef.current = true;
        },
        onPointerUp: (0, $2IwC4.composeEventHandlers)(props.onPointerUp, (event)=>{
            var _event$currentTarget;
            // Pointer down can move to a different menu item which should activate it on pointer up.
            // We dispatch a click for selection to allow composition with click based triggers and to
            // prevent Firefox from getting stuck in text selection mode when the menu closes.
            if (!isPointerDownRef.current) (_event$currentTarget = event.currentTarget) === null || _event$currentTarget === void 0 || _event$currentTarget.click();
        }),
        onKeyDown: (0, $2IwC4.composeEventHandlers)(props.onKeyDown, (event)=>{
            const isTypingAhead = contentContext.searchRef.current !== "";
            if (disabled || isTypingAhead && event.key === " ") return;
            if ($82110f2367303f9b$var$$6cc32821e9371a1c$var$SELECTION_KEYS.includes(event.key)) {
                event.currentTarget.click();
                /**
         * We prevent default browser behaviour for selection keys as they should trigger
         * a selection only:
         * - prevents space from scrolling the page.
         * - if keydown causes focus to move, prevents keydown from firing on the new target.
         */ event.preventDefault();
            }
        })
    }));
});
/*#__PURE__*/ Object.assign($82110f2367303f9b$export$2ce376c2cc3355c8, {
    displayName: $82110f2367303f9b$var$$6cc32821e9371a1c$var$ITEM_NAME
});
/* ---------------------------------------------------------------------------------------------- */ const $82110f2367303f9b$var$$6cc32821e9371a1c$var$MenuItemImpl = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopeMenu: __scopeMenu, disabled: disabled = false, textValue: textValue, ...itemProps } = props;
    const contentContext = $82110f2367303f9b$var$$6cc32821e9371a1c$var$useMenuContentContext($82110f2367303f9b$var$$6cc32821e9371a1c$var$ITEM_NAME, __scopeMenu);
    const rovingFocusGroupScope = $82110f2367303f9b$var$$6cc32821e9371a1c$var$useRovingFocusGroupScope(__scopeMenu);
    const ref = (0, $acw62.useRef)(null);
    const composedRefs = (0, $htT6J.useComposedRefs)(forwardedRef, ref);
    const [isFocused, setIsFocused] = (0, $acw62.useState)(false); // get the item's `.textContent` as default strategy for typeahead `textValue`
    const [textContent, setTextContent] = (0, $acw62.useState)("");
    (0, $acw62.useEffect)(()=>{
        const menuItem = ref.current;
        if (menuItem) {
            var _menuItem$textContent;
            setTextContent(((_menuItem$textContent = menuItem.textContent) !== null && _menuItem$textContent !== void 0 ? _menuItem$textContent : "").trim());
        }
    }, [
        itemProps.children
    ]);
    return /*#__PURE__*/ (0, $acw62.createElement)($82110f2367303f9b$var$$6cc32821e9371a1c$var$Collection.ItemSlot, {
        scope: __scopeMenu,
        disabled: disabled,
        textValue: textValue !== null && textValue !== void 0 ? textValue : textContent
    }, /*#__PURE__*/ (0, $acw62.createElement)((0, $abA6z.Item), (0, $8nd05.default)({
        asChild: true
    }, rovingFocusGroupScope, {
        focusable: !disabled
    }), /*#__PURE__*/ (0, $acw62.createElement)((0, $kFbxc.Primitive).div, (0, $8nd05.default)({
        role: "menuitem",
        "data-highlighted": isFocused ? "" : undefined,
        "aria-disabled": disabled || undefined,
        "data-disabled": disabled ? "" : undefined
    }, itemProps, {
        ref: composedRefs,
        onPointerMove: (0, $2IwC4.composeEventHandlers)(props.onPointerMove, $82110f2367303f9b$var$$6cc32821e9371a1c$var$whenMouse((event)=>{
            if (disabled) contentContext.onItemLeave(event);
            else {
                contentContext.onItemEnter(event);
                if (!event.defaultPrevented) {
                    const item = event.currentTarget;
                    item.focus();
                }
            }
        })),
        onPointerLeave: (0, $2IwC4.composeEventHandlers)(props.onPointerLeave, $82110f2367303f9b$var$$6cc32821e9371a1c$var$whenMouse((event)=>contentContext.onItemLeave(event))),
        onFocus: (0, $2IwC4.composeEventHandlers)(props.onFocus, ()=>setIsFocused(true)),
        onBlur: (0, $2IwC4.composeEventHandlers)(props.onBlur, ()=>setIsFocused(false))
    }))));
});
/* -------------------------------------------------------------------------------------------------
 * MenuCheckboxItem
 * -----------------------------------------------------------------------------------------------*/ const $82110f2367303f9b$var$$6cc32821e9371a1c$var$CHECKBOX_ITEM_NAME = "MenuCheckboxItem";
const $82110f2367303f9b$export$f6f243521332502d = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { checked: checked = false, onCheckedChange: onCheckedChange, ...checkboxItemProps } = props;
    return /*#__PURE__*/ (0, $acw62.createElement)($82110f2367303f9b$var$$6cc32821e9371a1c$var$ItemIndicatorProvider, {
        scope: props.__scopeMenu,
        checked: checked
    }, /*#__PURE__*/ (0, $acw62.createElement)($82110f2367303f9b$export$2ce376c2cc3355c8, (0, $8nd05.default)({
        role: "menuitemcheckbox",
        "aria-checked": $82110f2367303f9b$var$$6cc32821e9371a1c$var$isIndeterminate(checked) ? "mixed" : checked
    }, checkboxItemProps, {
        ref: forwardedRef,
        "data-state": $82110f2367303f9b$var$$6cc32821e9371a1c$var$getCheckedState(checked),
        onSelect: (0, $2IwC4.composeEventHandlers)(checkboxItemProps.onSelect, ()=>onCheckedChange === null || onCheckedChange === void 0 ? void 0 : onCheckedChange($82110f2367303f9b$var$$6cc32821e9371a1c$var$isIndeterminate(checked) ? true : !checked), {
            checkForDefaultPrevented: false
        })
    })));
});
/*#__PURE__*/ Object.assign($82110f2367303f9b$export$f6f243521332502d, {
    displayName: $82110f2367303f9b$var$$6cc32821e9371a1c$var$CHECKBOX_ITEM_NAME
});
/* -------------------------------------------------------------------------------------------------
 * MenuRadioGroup
 * -----------------------------------------------------------------------------------------------*/ const $82110f2367303f9b$var$$6cc32821e9371a1c$var$RADIO_GROUP_NAME = "MenuRadioGroup";
const [$82110f2367303f9b$var$$6cc32821e9371a1c$var$RadioGroupProvider, $82110f2367303f9b$var$$6cc32821e9371a1c$var$useRadioGroupContext] = $82110f2367303f9b$var$$6cc32821e9371a1c$var$createMenuContext($82110f2367303f9b$var$$6cc32821e9371a1c$var$RADIO_GROUP_NAME, {
    value: undefined,
    onValueChange: ()=>{}
});
const $82110f2367303f9b$export$ea2200c9eee416b3 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { value: value, onValueChange: onValueChange, ...groupProps } = props;
    const handleValueChange = (0, $by19I.useCallbackRef)(onValueChange);
    return /*#__PURE__*/ (0, $acw62.createElement)($82110f2367303f9b$var$$6cc32821e9371a1c$var$RadioGroupProvider, {
        scope: props.__scopeMenu,
        value: value,
        onValueChange: handleValueChange
    }, /*#__PURE__*/ (0, $acw62.createElement)($82110f2367303f9b$export$22a631d1f72787bb, (0, $8nd05.default)({}, groupProps, {
        ref: forwardedRef
    })));
});
/*#__PURE__*/ Object.assign($82110f2367303f9b$export$ea2200c9eee416b3, {
    displayName: $82110f2367303f9b$var$$6cc32821e9371a1c$var$RADIO_GROUP_NAME
});
/* -------------------------------------------------------------------------------------------------
 * MenuRadioItem
 * -----------------------------------------------------------------------------------------------*/ const $82110f2367303f9b$var$$6cc32821e9371a1c$var$RADIO_ITEM_NAME = "MenuRadioItem";
const $82110f2367303f9b$export$69bd225e9817f6d0 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { value: value, ...radioItemProps } = props;
    const context = $82110f2367303f9b$var$$6cc32821e9371a1c$var$useRadioGroupContext($82110f2367303f9b$var$$6cc32821e9371a1c$var$RADIO_ITEM_NAME, props.__scopeMenu);
    const checked = value === context.value;
    return /*#__PURE__*/ (0, $acw62.createElement)($82110f2367303f9b$var$$6cc32821e9371a1c$var$ItemIndicatorProvider, {
        scope: props.__scopeMenu,
        checked: checked
    }, /*#__PURE__*/ (0, $acw62.createElement)($82110f2367303f9b$export$2ce376c2cc3355c8, (0, $8nd05.default)({
        role: "menuitemradio",
        "aria-checked": checked
    }, radioItemProps, {
        ref: forwardedRef,
        "data-state": $82110f2367303f9b$var$$6cc32821e9371a1c$var$getCheckedState(checked),
        onSelect: (0, $2IwC4.composeEventHandlers)(radioItemProps.onSelect, ()=>{
            var _context$onValueChang;
            return (_context$onValueChang = context.onValueChange) === null || _context$onValueChang === void 0 ? void 0 : _context$onValueChang.call(context, value);
        }, {
            checkForDefaultPrevented: false
        })
    })));
});
/*#__PURE__*/ Object.assign($82110f2367303f9b$export$69bd225e9817f6d0, {
    displayName: $82110f2367303f9b$var$$6cc32821e9371a1c$var$RADIO_ITEM_NAME
});
/* -------------------------------------------------------------------------------------------------
 * MenuItemIndicator
 * -----------------------------------------------------------------------------------------------*/ const $82110f2367303f9b$var$$6cc32821e9371a1c$var$ITEM_INDICATOR_NAME = "MenuItemIndicator";
const [$82110f2367303f9b$var$$6cc32821e9371a1c$var$ItemIndicatorProvider, $82110f2367303f9b$var$$6cc32821e9371a1c$var$useItemIndicatorContext] = $82110f2367303f9b$var$$6cc32821e9371a1c$var$createMenuContext($82110f2367303f9b$var$$6cc32821e9371a1c$var$ITEM_INDICATOR_NAME, {
    checked: false
});
const $82110f2367303f9b$export$a2593e23056970a3 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopeMenu: __scopeMenu, forceMount: forceMount, ...itemIndicatorProps } = props;
    const indicatorContext = $82110f2367303f9b$var$$6cc32821e9371a1c$var$useItemIndicatorContext($82110f2367303f9b$var$$6cc32821e9371a1c$var$ITEM_INDICATOR_NAME, __scopeMenu);
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $cTFdF.Presence), {
        present: forceMount || $82110f2367303f9b$var$$6cc32821e9371a1c$var$isIndeterminate(indicatorContext.checked) || indicatorContext.checked === true
    }, /*#__PURE__*/ (0, $acw62.createElement)((0, $kFbxc.Primitive).span, (0, $8nd05.default)({}, itemIndicatorProps, {
        ref: forwardedRef,
        "data-state": $82110f2367303f9b$var$$6cc32821e9371a1c$var$getCheckedState(indicatorContext.checked)
    })));
});
/*#__PURE__*/ Object.assign($82110f2367303f9b$export$a2593e23056970a3, {
    displayName: $82110f2367303f9b$var$$6cc32821e9371a1c$var$ITEM_INDICATOR_NAME
});
/* -------------------------------------------------------------------------------------------------
 * MenuSeparator
 * -----------------------------------------------------------------------------------------------*/ const $82110f2367303f9b$var$$6cc32821e9371a1c$var$SEPARATOR_NAME = "MenuSeparator";
const $82110f2367303f9b$export$1cec7dcdd713e220 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopeMenu: __scopeMenu, ...separatorProps } = props;
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $kFbxc.Primitive).div, (0, $8nd05.default)({
        role: "separator",
        "aria-orientation": "horizontal"
    }, separatorProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($82110f2367303f9b$export$1cec7dcdd713e220, {
    displayName: $82110f2367303f9b$var$$6cc32821e9371a1c$var$SEPARATOR_NAME
});
/* -------------------------------------------------------------------------------------------------
 * MenuArrow
 * -----------------------------------------------------------------------------------------------*/ const $82110f2367303f9b$var$$6cc32821e9371a1c$var$ARROW_NAME = "MenuArrow";
const $82110f2367303f9b$export$bcdda4773debf5fa = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopeMenu: __scopeMenu, ...arrowProps } = props;
    const popperScope = $82110f2367303f9b$var$$6cc32821e9371a1c$var$usePopperScope(__scopeMenu);
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $jxYRk.Arrow), (0, $8nd05.default)({}, popperScope, arrowProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($82110f2367303f9b$export$bcdda4773debf5fa, {
    displayName: $82110f2367303f9b$var$$6cc32821e9371a1c$var$ARROW_NAME
});
/* -------------------------------------------------------------------------------------------------
 * MenuSub
 * -----------------------------------------------------------------------------------------------*/ const $82110f2367303f9b$var$$6cc32821e9371a1c$var$SUB_NAME = "MenuSub";
const [$82110f2367303f9b$var$$6cc32821e9371a1c$var$MenuSubProvider, $82110f2367303f9b$var$$6cc32821e9371a1c$var$useMenuSubContext] = $82110f2367303f9b$var$$6cc32821e9371a1c$var$createMenuContext($82110f2367303f9b$var$$6cc32821e9371a1c$var$SUB_NAME);
const $82110f2367303f9b$export$71bdb9d1e2909932 = (props)=>{
    const { __scopeMenu: __scopeMenu, children: children, open: open = false, onOpenChange: onOpenChange } = props;
    const parentMenuContext = $82110f2367303f9b$var$$6cc32821e9371a1c$var$useMenuContext($82110f2367303f9b$var$$6cc32821e9371a1c$var$SUB_NAME, __scopeMenu);
    const popperScope = $82110f2367303f9b$var$$6cc32821e9371a1c$var$usePopperScope(__scopeMenu);
    const [trigger, setTrigger] = (0, $acw62.useState)(null);
    const [content, setContent] = (0, $acw62.useState)(null);
    const handleOpenChange = (0, $by19I.useCallbackRef)(onOpenChange); // Prevent the parent menu from reopening with open submenus.
    (0, $acw62.useEffect)(()=>{
        if (parentMenuContext.open === false) handleOpenChange(false);
        return ()=>handleOpenChange(false);
    }, [
        parentMenuContext.open,
        handleOpenChange
    ]);
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $jxYRk.Root), popperScope, /*#__PURE__*/ (0, $acw62.createElement)($82110f2367303f9b$var$$6cc32821e9371a1c$var$MenuProvider, {
        scope: __scopeMenu,
        open: open,
        onOpenChange: handleOpenChange,
        content: content,
        onContentChange: setContent
    }, /*#__PURE__*/ (0, $acw62.createElement)($82110f2367303f9b$var$$6cc32821e9371a1c$var$MenuSubProvider, {
        scope: __scopeMenu,
        contentId: (0, $g2NP0.useId)(),
        triggerId: (0, $g2NP0.useId)(),
        trigger: trigger,
        onTriggerChange: setTrigger
    }, children)));
};
/*#__PURE__*/ Object.assign($82110f2367303f9b$export$71bdb9d1e2909932, {
    displayName: $82110f2367303f9b$var$$6cc32821e9371a1c$var$SUB_NAME
});
/* -------------------------------------------------------------------------------------------------
 * MenuSubTrigger
 * -----------------------------------------------------------------------------------------------*/ const $82110f2367303f9b$var$$6cc32821e9371a1c$var$SUB_TRIGGER_NAME = "MenuSubTrigger";
const $82110f2367303f9b$export$5fbbb3ba7297405f = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const context = $82110f2367303f9b$var$$6cc32821e9371a1c$var$useMenuContext($82110f2367303f9b$var$$6cc32821e9371a1c$var$SUB_TRIGGER_NAME, props.__scopeMenu);
    const rootContext = $82110f2367303f9b$var$$6cc32821e9371a1c$var$useMenuRootContext($82110f2367303f9b$var$$6cc32821e9371a1c$var$SUB_TRIGGER_NAME, props.__scopeMenu);
    const subContext = $82110f2367303f9b$var$$6cc32821e9371a1c$var$useMenuSubContext($82110f2367303f9b$var$$6cc32821e9371a1c$var$SUB_TRIGGER_NAME, props.__scopeMenu);
    const contentContext = $82110f2367303f9b$var$$6cc32821e9371a1c$var$useMenuContentContext($82110f2367303f9b$var$$6cc32821e9371a1c$var$SUB_TRIGGER_NAME, props.__scopeMenu);
    const openTimerRef = (0, $acw62.useRef)(null);
    const { pointerGraceTimerRef: pointerGraceTimerRef, onPointerGraceIntentChange: onPointerGraceIntentChange } = contentContext;
    const scope = {
        __scopeMenu: props.__scopeMenu
    };
    const clearOpenTimer = (0, $acw62.useCallback)(()=>{
        if (openTimerRef.current) window.clearTimeout(openTimerRef.current);
        openTimerRef.current = null;
    }, []);
    (0, $acw62.useEffect)(()=>clearOpenTimer, [
        clearOpenTimer
    ]);
    (0, $acw62.useEffect)(()=>{
        const pointerGraceTimer = pointerGraceTimerRef.current;
        return ()=>{
            window.clearTimeout(pointerGraceTimer);
            onPointerGraceIntentChange(null);
        };
    }, [
        pointerGraceTimerRef,
        onPointerGraceIntentChange
    ]);
    return /*#__PURE__*/ (0, $acw62.createElement)($82110f2367303f9b$export$9fa5ebd18bee4d43, (0, $8nd05.default)({
        asChild: true
    }, scope), /*#__PURE__*/ (0, $acw62.createElement)($82110f2367303f9b$var$$6cc32821e9371a1c$var$MenuItemImpl, (0, $8nd05.default)({
        id: subContext.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": context.open,
        "aria-controls": subContext.contentId,
        "data-state": $82110f2367303f9b$var$$6cc32821e9371a1c$var$getOpenState(context.open)
    }, props, {
        ref: (0, $htT6J.composeRefs)(forwardedRef, subContext.onTriggerChange) // This is redundant for mouse users but we cannot determine pointer type from
        ,
        onClick: (event)=>{
            var _props$onClick;
            (_props$onClick = props.onClick) === null || _props$onClick === void 0 || _props$onClick.call(props, event);
            if (props.disabled || event.defaultPrevented) return;
            /**
       * We manually focus because iOS Safari doesn't always focus on click (e.g. buttons)
       * and we rely heavily on `onFocusOutside` for submenus to close when switching
       * between separate submenus.
       */ event.currentTarget.focus();
            if (!context.open) context.onOpenChange(true);
        },
        onPointerMove: (0, $2IwC4.composeEventHandlers)(props.onPointerMove, $82110f2367303f9b$var$$6cc32821e9371a1c$var$whenMouse((event)=>{
            contentContext.onItemEnter(event);
            if (event.defaultPrevented) return;
            if (!props.disabled && !context.open && !openTimerRef.current) {
                contentContext.onPointerGraceIntentChange(null);
                openTimerRef.current = window.setTimeout(()=>{
                    context.onOpenChange(true);
                    clearOpenTimer();
                }, 100);
            }
        })),
        onPointerLeave: (0, $2IwC4.composeEventHandlers)(props.onPointerLeave, $82110f2367303f9b$var$$6cc32821e9371a1c$var$whenMouse((event)=>{
            var _context$content;
            clearOpenTimer();
            const contentRect = (_context$content = context.content) === null || _context$content === void 0 ? void 0 : _context$content.getBoundingClientRect();
            if (contentRect) {
                var _context$content2;
                // TODO: make sure to update this when we change positioning logic
                const side = (_context$content2 = context.content) === null || _context$content2 === void 0 ? void 0 : _context$content2.dataset.side;
                const rightSide = side === "right";
                const bleed = rightSide ? -5 : 5;
                const contentNearEdge = contentRect[rightSide ? "left" : "right"];
                const contentFarEdge = contentRect[rightSide ? "right" : "left"];
                contentContext.onPointerGraceIntentChange({
                    area: [
                        // consistently within polygon bounds
                        {
                            x: event.clientX + bleed,
                            y: event.clientY
                        },
                        {
                            x: contentNearEdge,
                            y: contentRect.top
                        },
                        {
                            x: contentFarEdge,
                            y: contentRect.top
                        },
                        {
                            x: contentFarEdge,
                            y: contentRect.bottom
                        },
                        {
                            x: contentNearEdge,
                            y: contentRect.bottom
                        }
                    ],
                    side: side
                });
                window.clearTimeout(pointerGraceTimerRef.current);
                pointerGraceTimerRef.current = window.setTimeout(()=>contentContext.onPointerGraceIntentChange(null), 300);
            } else {
                contentContext.onTriggerLeave(event);
                if (event.defaultPrevented) return; // There's 100ms where the user may leave an item before the submenu was opened.
                contentContext.onPointerGraceIntentChange(null);
            }
        })),
        onKeyDown: (0, $2IwC4.composeEventHandlers)(props.onKeyDown, (event)=>{
            const isTypingAhead = contentContext.searchRef.current !== "";
            if (props.disabled || isTypingAhead && event.key === " ") return;
            if ($82110f2367303f9b$var$$6cc32821e9371a1c$var$SUB_OPEN_KEYS[rootContext.dir].includes(event.key)) {
                var _context$content3;
                context.onOpenChange(true); // The trigger may hold focus if opened via pointer interaction
                // so we ensure content is given focus again when switching to keyboard.
                (_context$content3 = context.content) === null || _context$content3 === void 0 || _context$content3.focus(); // prevent window from scrolling
                event.preventDefault();
            }
        })
    })));
});
/*#__PURE__*/ Object.assign($82110f2367303f9b$export$5fbbb3ba7297405f, {
    displayName: $82110f2367303f9b$var$$6cc32821e9371a1c$var$SUB_TRIGGER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * MenuSubContent
 * -----------------------------------------------------------------------------------------------*/ const $82110f2367303f9b$var$$6cc32821e9371a1c$var$SUB_CONTENT_NAME = "MenuSubContent";
const $82110f2367303f9b$export$e7142ab31822bde6 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const portalContext = $82110f2367303f9b$var$$6cc32821e9371a1c$var$usePortalContext($82110f2367303f9b$var$$6cc32821e9371a1c$var$CONTENT_NAME, props.__scopeMenu);
    const { forceMount: forceMount = portalContext.forceMount, ...subContentProps } = props;
    const context = $82110f2367303f9b$var$$6cc32821e9371a1c$var$useMenuContext($82110f2367303f9b$var$$6cc32821e9371a1c$var$CONTENT_NAME, props.__scopeMenu);
    const rootContext = $82110f2367303f9b$var$$6cc32821e9371a1c$var$useMenuRootContext($82110f2367303f9b$var$$6cc32821e9371a1c$var$CONTENT_NAME, props.__scopeMenu);
    const subContext = $82110f2367303f9b$var$$6cc32821e9371a1c$var$useMenuSubContext($82110f2367303f9b$var$$6cc32821e9371a1c$var$SUB_CONTENT_NAME, props.__scopeMenu);
    const ref = (0, $acw62.useRef)(null);
    const composedRefs = (0, $htT6J.useComposedRefs)(forwardedRef, ref);
    return /*#__PURE__*/ (0, $acw62.createElement)($82110f2367303f9b$var$$6cc32821e9371a1c$var$Collection.Provider, {
        scope: props.__scopeMenu
    }, /*#__PURE__*/ (0, $acw62.createElement)((0, $cTFdF.Presence), {
        present: forceMount || context.open
    }, /*#__PURE__*/ (0, $acw62.createElement)($82110f2367303f9b$var$$6cc32821e9371a1c$var$Collection.Slot, {
        scope: props.__scopeMenu
    }, /*#__PURE__*/ (0, $acw62.createElement)($82110f2367303f9b$var$$6cc32821e9371a1c$var$MenuContentImpl, (0, $8nd05.default)({
        id: subContext.contentId,
        "aria-labelledby": subContext.triggerId
    }, subContentProps, {
        ref: composedRefs,
        align: "start",
        side: rootContext.dir === "rtl" ? "left" : "right",
        disableOutsidePointerEvents: false,
        disableOutsideScroll: false,
        trapFocus: false,
        onOpenAutoFocus: (event)=>{
            var _ref$current;
            // when opening a submenu, focus content for keyboard users only
            if (rootContext.isUsingKeyboardRef.current) (_ref$current = ref.current) === null || _ref$current === void 0 || _ref$current.focus();
            event.preventDefault();
        } // The menu might close because of focusing another menu item in the parent menu. We
        ,
        onCloseAutoFocus: (event)=>event.preventDefault(),
        onFocusOutside: (0, $2IwC4.composeEventHandlers)(props.onFocusOutside, (event)=>{
            // We prevent closing when the trigger is focused to avoid triggering a re-open animation
            // on pointer interaction.
            if (event.target !== subContext.trigger) context.onOpenChange(false);
        }),
        onEscapeKeyDown: (0, $2IwC4.composeEventHandlers)(props.onEscapeKeyDown, (event)=>{
            rootContext.onClose(); // ensure pressing escape in submenu doesn't escape full screen mode
            event.preventDefault();
        }),
        onKeyDown: (0, $2IwC4.composeEventHandlers)(props.onKeyDown, (event)=>{
            // Submenu key events bubble through portals. We only care about keys in this menu.
            const isKeyDownInside = event.currentTarget.contains(event.target);
            const isCloseKey = $82110f2367303f9b$var$$6cc32821e9371a1c$var$SUB_CLOSE_KEYS[rootContext.dir].includes(event.key);
            if (isKeyDownInside && isCloseKey) {
                var _subContext$trigger;
                context.onOpenChange(false); // We focus manually because we prevented it in `onCloseAutoFocus`
                (_subContext$trigger = subContext.trigger) === null || _subContext$trigger === void 0 || _subContext$trigger.focus(); // prevent window from scrolling
                event.preventDefault();
            }
        })
    })))));
});
/*#__PURE__*/ Object.assign($82110f2367303f9b$export$e7142ab31822bde6, {
    displayName: $82110f2367303f9b$var$$6cc32821e9371a1c$var$SUB_CONTENT_NAME
});
/* -----------------------------------------------------------------------------------------------*/ function $82110f2367303f9b$var$$6cc32821e9371a1c$var$getOpenState(open) {
    return open ? "open" : "closed";
}
function $82110f2367303f9b$var$$6cc32821e9371a1c$var$isIndeterminate(checked) {
    return checked === "indeterminate";
}
function $82110f2367303f9b$var$$6cc32821e9371a1c$var$getCheckedState(checked) {
    return $82110f2367303f9b$var$$6cc32821e9371a1c$var$isIndeterminate(checked) ? "indeterminate" : checked ? "checked" : "unchecked";
}
function $82110f2367303f9b$var$$6cc32821e9371a1c$var$focusFirst(candidates) {
    const PREVIOUSLY_FOCUSED_ELEMENT = document.activeElement;
    for (const candidate of candidates){
        // if focus is already where we want to go, we don't want to keep going through the candidates
        if (candidate === PREVIOUSLY_FOCUSED_ELEMENT) return;
        candidate.focus();
        if (document.activeElement !== PREVIOUSLY_FOCUSED_ELEMENT) return;
    }
}
/**
 * Wraps an array around itself at a given start index
 * Example: `wrapArray(['a', 'b', 'c', 'd'], 2) === ['c', 'd', 'a', 'b']`
 */ function $82110f2367303f9b$var$$6cc32821e9371a1c$var$wrapArray(array, startIndex) {
    return array.map((_, index)=>array[(startIndex + index) % array.length]);
}
/**
 * This is the "meat" of the typeahead matching logic. It takes in all the values,
 * the search and the current match, and returns the next match (or `undefined`).
 *
 * We normalize the search because if a user has repeatedly pressed a character,
 * we want the exact same behavior as if we only had that one character
 * (ie. cycle through options starting with that character)
 *
 * We also reorder the values by wrapping the array around the current match.
 * This is so we always look forward from the current match, and picking the first
 * match will always be the correct one.
 *
 * Finally, if the normalized search is exactly one character, we exclude the
 * current match from the values because otherwise it would be the first to match always
 * and focus would never move. This is as opposed to the regular case, where we
 * don't want focus to move if the current match still matches.
 */ function $82110f2367303f9b$var$$6cc32821e9371a1c$var$getNextMatch(values, search, currentMatch) {
    const isRepeated = search.length > 1 && Array.from(search).every((char)=>char === search[0]);
    const normalizedSearch = isRepeated ? search[0] : search;
    const currentMatchIndex = currentMatch ? values.indexOf(currentMatch) : -1;
    let wrappedValues = $82110f2367303f9b$var$$6cc32821e9371a1c$var$wrapArray(values, Math.max(currentMatchIndex, 0));
    const excludeCurrentMatch = normalizedSearch.length === 1;
    if (excludeCurrentMatch) wrappedValues = wrappedValues.filter((v)=>v !== currentMatch);
    const nextMatch = wrappedValues.find((value)=>value.toLowerCase().startsWith(normalizedSearch.toLowerCase()));
    return nextMatch !== currentMatch ? nextMatch : undefined;
}
// Determine if a point is inside of a polygon.
// Based on https://github.com/substack/point-in-polygon
function $82110f2367303f9b$var$$6cc32821e9371a1c$var$isPointInPolygon(point, polygon) {
    const { x: x, y: y } = point;
    let inside = false;
    for(let i = 0, j = polygon.length - 1; i < polygon.length; j = i++){
        const xi = polygon[i].x;
        const yi = polygon[i].y;
        const xj = polygon[j].x;
        const yj = polygon[j].y; // prettier-ignore
        const intersect = yi > y !== yj > y && x < (xj - xi) * (y - yi) / (yj - yi) + xi;
        if (intersect) inside = !inside;
    }
    return inside;
}
function $82110f2367303f9b$var$$6cc32821e9371a1c$var$isPointerInGraceArea(event, area) {
    if (!area) return false;
    const cursorPos = {
        x: event.clientX,
        y: event.clientY
    };
    return $82110f2367303f9b$var$$6cc32821e9371a1c$var$isPointInPolygon(cursorPos, area);
}
function $82110f2367303f9b$var$$6cc32821e9371a1c$var$whenMouse(handler) {
    return (event)=>event.pointerType === "mouse" ? handler(event) : undefined;
}
const $82110f2367303f9b$export$be92b6f5f03c0fe9 = $82110f2367303f9b$export$d9b273488cd8ce6f;
const $82110f2367303f9b$export$b688253958b8dfe7 = $82110f2367303f9b$export$9fa5ebd18bee4d43;
const $82110f2367303f9b$export$602eac185826482c = $82110f2367303f9b$export$793392f970497feb;
const $82110f2367303f9b$export$7c6e2c02157bb7d2 = $82110f2367303f9b$export$479f0f2f71193efe;
const $82110f2367303f9b$export$eb2fcfdbd7ba97d4 = $82110f2367303f9b$export$22a631d1f72787bb;
const $82110f2367303f9b$export$b04be29aa201d4f5 = $82110f2367303f9b$export$dd37bec0e8a99143;
const $82110f2367303f9b$export$6d08773d2e66f8f2 = $82110f2367303f9b$export$2ce376c2cc3355c8;
const $82110f2367303f9b$export$16ce288f89fa631c = $82110f2367303f9b$export$f6f243521332502d;
const $82110f2367303f9b$export$a98f0dcb43a68a25 = $82110f2367303f9b$export$ea2200c9eee416b3;
const $82110f2367303f9b$export$371ab307eab489c0 = $82110f2367303f9b$export$69bd225e9817f6d0;
const $82110f2367303f9b$export$c3468e2714d175fa = $82110f2367303f9b$export$a2593e23056970a3;
const $82110f2367303f9b$export$1ff3c3f08ae963c0 = $82110f2367303f9b$export$1cec7dcdd713e220;
const $82110f2367303f9b$export$21b07c8f274aebd5 = $82110f2367303f9b$export$bcdda4773debf5fa;
const $82110f2367303f9b$export$d7a01e11500dfb6f = $82110f2367303f9b$export$71bdb9d1e2909932;
const $82110f2367303f9b$export$2ea8a7a591ac5eac = $82110f2367303f9b$export$5fbbb3ba7297405f;
const $82110f2367303f9b$export$6d4de93b380beddf = $82110f2367303f9b$export$e7142ab31822bde6;

});
parcelRegister("9nBzD", function(module, exports) {

$parcel$export(module.exports, "createCollection", () => $a9634733d4b9bce9$export$c74125a8e3af6bb2);

var $acw62 = parcelRequire("acw62");

var $jnK0n = parcelRequire("jnK0n");

var $htT6J = parcelRequire("htT6J");

var $9UeUh = parcelRequire("9UeUh");
// We have resorted to returning slots directly rather than exposing primitives that can then
// be slotted like `<CollectionItem as={Slot}>…</CollectionItem>`.
// This is because we encountered issues with generic types that cannot be statically analysed
// due to creating them dynamically via createCollection.
function $a9634733d4b9bce9$export$c74125a8e3af6bb2(name) {
    /* -----------------------------------------------------------------------------------------------
   * CollectionProvider
   * ---------------------------------------------------------------------------------------------*/ const PROVIDER_NAME = name + "CollectionProvider";
    const [createCollectionContext, createCollectionScope] = (0, $jnK0n.createContextScope)(PROVIDER_NAME);
    const [CollectionProviderImpl, useCollectionContext] = createCollectionContext(PROVIDER_NAME, {
        collectionRef: {
            current: null
        },
        itemMap: new Map()
    });
    const CollectionProvider = (props)=>{
        const { scope: scope, children: children } = props;
        const ref = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
        const itemMap = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(new Map()).current;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(CollectionProviderImpl, {
            scope: scope,
            itemMap: itemMap,
            collectionRef: ref
        }, children);
    };
    /*#__PURE__*/ Object.assign(CollectionProvider, {
        displayName: PROVIDER_NAME
    });
    /* -----------------------------------------------------------------------------------------------
   * CollectionSlot
   * ---------------------------------------------------------------------------------------------*/ const COLLECTION_SLOT_NAME = name + "CollectionSlot";
    const CollectionSlot = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((props, forwardedRef)=>{
        const { scope: scope, children: children } = props;
        const context = useCollectionContext(COLLECTION_SLOT_NAME, scope);
        const composedRefs = (0, $htT6J.useComposedRefs)(forwardedRef, context.collectionRef);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9UeUh.Slot), {
            ref: composedRefs
        }, children);
    });
    /*#__PURE__*/ Object.assign(CollectionSlot, {
        displayName: COLLECTION_SLOT_NAME
    });
    /* -----------------------------------------------------------------------------------------------
   * CollectionItem
   * ---------------------------------------------------------------------------------------------*/ const ITEM_SLOT_NAME = name + "CollectionItemSlot";
    const ITEM_DATA_ATTR = "data-radix-collection-item";
    const CollectionItemSlot = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((props, forwardedRef)=>{
        const { scope: scope, children: children, ...itemData } = props;
        const ref = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
        const composedRefs = (0, $htT6J.useComposedRefs)(forwardedRef, ref);
        const context = useCollectionContext(ITEM_SLOT_NAME, scope);
        (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
            context.itemMap.set(ref, {
                ref: ref,
                ...itemData
            });
            return ()=>void context.itemMap.delete(ref);
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9UeUh.Slot), {
            [ITEM_DATA_ATTR]: "",
            ref: composedRefs
        }, children);
    });
    /*#__PURE__*/ Object.assign(CollectionItemSlot, {
        displayName: ITEM_SLOT_NAME
    });
    /* -----------------------------------------------------------------------------------------------
   * useCollection
   * ---------------------------------------------------------------------------------------------*/ function useCollection(scope) {
        const context = useCollectionContext(name + "CollectionConsumer", scope);
        const getItems = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
            const collectionNode = context.collectionRef.current;
            if (!collectionNode) return [];
            const orderedNodes = Array.from(collectionNode.querySelectorAll(`[${ITEM_DATA_ATTR}]`));
            const items = Array.from(context.itemMap.values());
            const orderedItems = items.sort((a, b)=>orderedNodes.indexOf(a.ref.current) - orderedNodes.indexOf(b.ref.current));
            return orderedItems;
        }, [
            context.collectionRef,
            context.itemMap
        ]);
        return getItems;
    }
    return [
        {
            Provider: CollectionProvider,
            Slot: CollectionSlot,
            ItemSlot: CollectionItemSlot
        },
        useCollection,
        createCollectionScope
    ];
}

});

parcelRegister("5ZQml", function(module, exports) {

$parcel$export(module.exports, "useDirection", () => $f9ad7d2f57cc5bec$export$b39126d51d94e6f3);

var $acw62 = parcelRequire("acw62");
const $f9ad7d2f57cc5bec$var$$f631663db3294ace$var$DirectionContext = /*#__PURE__*/ (0, $acw62.createContext)(undefined);
/* -------------------------------------------------------------------------------------------------
 * Direction
 * -----------------------------------------------------------------------------------------------*/ const $f9ad7d2f57cc5bec$export$c760c09fdd558351 = (props)=>{
    const { dir: dir, children: children } = props;
    return /*#__PURE__*/ (0, $acw62.createElement)($f9ad7d2f57cc5bec$var$$f631663db3294ace$var$DirectionContext.Provider, {
        value: dir
    }, children);
};
/* -----------------------------------------------------------------------------------------------*/ function $f9ad7d2f57cc5bec$export$b39126d51d94e6f3(localDir) {
    const globalDir = (0, $acw62.useContext)($f9ad7d2f57cc5bec$var$$f631663db3294ace$var$DirectionContext);
    return localDir || globalDir || "ltr";
}
const $f9ad7d2f57cc5bec$export$2881499e37b75b9a = $f9ad7d2f57cc5bec$export$c760c09fdd558351;

});

parcelRegister("jxYRk", function(module, exports) {

$parcel$export(module.exports, "createPopperScope", () => $a0ac11a1da65e329$export$722aac194ae923);
$parcel$export(module.exports, "Root", () => $a0ac11a1da65e329$export$be92b6f5f03c0fe9);
$parcel$export(module.exports, "Anchor", () => $a0ac11a1da65e329$export$b688253958b8dfe7);
$parcel$export(module.exports, "Content", () => $a0ac11a1da65e329$export$7c6e2c02157bb7d2);
$parcel$export(module.exports, "Arrow", () => $a0ac11a1da65e329$export$21b07c8f274aebd5);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $33OG6 = parcelRequire("33OG6");
var $618j3 = parcelRequire("618j3");
var $cZ41y = parcelRequire("cZ41y");

var $3vR0G = parcelRequire("3vR0G");

var $htT6J = parcelRequire("htT6J");

var $jnK0n = parcelRequire("jnK0n");

var $kFbxc = parcelRequire("kFbxc");

var $by19I = parcelRequire("by19I");

var $7g00o = parcelRequire("7g00o");

var $8727j = parcelRequire("8727j");
const $a0ac11a1da65e329$export$36f0086da09c4b9f = [
    "top",
    "right",
    "bottom",
    "left"
];
const $a0ac11a1da65e329$export$3671ffab7b302fc9 = [
    "start",
    "center",
    "end"
];
/* -------------------------------------------------------------------------------------------------
 * Popper
 * -----------------------------------------------------------------------------------------------*/ const $a0ac11a1da65e329$var$$cf1ac5d9fe0e8206$var$POPPER_NAME = "Popper";
const [$a0ac11a1da65e329$var$$cf1ac5d9fe0e8206$var$createPopperContext, $a0ac11a1da65e329$export$722aac194ae923] = (0, $jnK0n.createContextScope)($a0ac11a1da65e329$var$$cf1ac5d9fe0e8206$var$POPPER_NAME);
const [$a0ac11a1da65e329$var$$cf1ac5d9fe0e8206$var$PopperProvider, $a0ac11a1da65e329$var$$cf1ac5d9fe0e8206$var$usePopperContext] = $a0ac11a1da65e329$var$$cf1ac5d9fe0e8206$var$createPopperContext($a0ac11a1da65e329$var$$cf1ac5d9fe0e8206$var$POPPER_NAME);
const $a0ac11a1da65e329$export$badac9ada3a0bdf9 = (props)=>{
    const { __scopePopper: __scopePopper, children: children } = props;
    const [anchor, setAnchor] = (0, $acw62.useState)(null);
    return /*#__PURE__*/ (0, $acw62.createElement)($a0ac11a1da65e329$var$$cf1ac5d9fe0e8206$var$PopperProvider, {
        scope: __scopePopper,
        anchor: anchor,
        onAnchorChange: setAnchor
    }, children);
};
/*#__PURE__*/ Object.assign($a0ac11a1da65e329$export$badac9ada3a0bdf9, {
    displayName: $a0ac11a1da65e329$var$$cf1ac5d9fe0e8206$var$POPPER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * PopperAnchor
 * -----------------------------------------------------------------------------------------------*/ const $a0ac11a1da65e329$var$$cf1ac5d9fe0e8206$var$ANCHOR_NAME = "PopperAnchor";
const $a0ac11a1da65e329$export$ecd4e1ccab6ed6d = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopePopper: __scopePopper, virtualRef: virtualRef, ...anchorProps } = props;
    const context = $a0ac11a1da65e329$var$$cf1ac5d9fe0e8206$var$usePopperContext($a0ac11a1da65e329$var$$cf1ac5d9fe0e8206$var$ANCHOR_NAME, __scopePopper);
    const ref = (0, $acw62.useRef)(null);
    const composedRefs = (0, $htT6J.useComposedRefs)(forwardedRef, ref);
    (0, $acw62.useEffect)(()=>{
        // Consumer can anchor the popper to something that isn't
        // a DOM node e.g. pointer position, so we override the
        // `anchorRef` with their virtual ref in this case.
        context.onAnchorChange((virtualRef === null || virtualRef === void 0 ? void 0 : virtualRef.current) || ref.current);
    });
    return virtualRef ? null : /*#__PURE__*/ (0, $acw62.createElement)((0, $kFbxc.Primitive).div, (0, $8nd05.default)({}, anchorProps, {
        ref: composedRefs
    }));
});
/*#__PURE__*/ Object.assign($a0ac11a1da65e329$export$ecd4e1ccab6ed6d, {
    displayName: $a0ac11a1da65e329$var$$cf1ac5d9fe0e8206$var$ANCHOR_NAME
});
/* -------------------------------------------------------------------------------------------------
 * PopperContent
 * -----------------------------------------------------------------------------------------------*/ const $a0ac11a1da65e329$var$$cf1ac5d9fe0e8206$var$CONTENT_NAME = "PopperContent";
const [$a0ac11a1da65e329$var$$cf1ac5d9fe0e8206$var$PopperContentProvider, $a0ac11a1da65e329$var$$cf1ac5d9fe0e8206$var$useContentContext] = $a0ac11a1da65e329$var$$cf1ac5d9fe0e8206$var$createPopperContext($a0ac11a1da65e329$var$$cf1ac5d9fe0e8206$var$CONTENT_NAME);
const $a0ac11a1da65e329$export$bc4ae5855d3c4fc = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    var _arrowSize$width, _arrowSize$height, _middlewareData$arrow, _middlewareData$arrow2, _middlewareData$arrow3, _middlewareData$trans, _middlewareData$trans2, _middlewareData$hide;
    const { __scopePopper: __scopePopper, side: side = "bottom", sideOffset: sideOffset = 0, align: align = "center", alignOffset: alignOffset = 0, arrowPadding: arrowPadding = 0, avoidCollisions: avoidCollisions = true, collisionBoundary: collisionBoundary = [], collisionPadding: collisionPaddingProp = 0, sticky: sticky = "partial", hideWhenDetached: hideWhenDetached = false, updatePositionStrategy: updatePositionStrategy = "optimized", onPlaced: onPlaced, ...contentProps } = props;
    const context = $a0ac11a1da65e329$var$$cf1ac5d9fe0e8206$var$usePopperContext($a0ac11a1da65e329$var$$cf1ac5d9fe0e8206$var$CONTENT_NAME, __scopePopper);
    const [content, setContent] = (0, $acw62.useState)(null);
    const composedRefs = (0, $htT6J.useComposedRefs)(forwardedRef, (node)=>setContent(node));
    const [arrow, setArrow] = (0, $acw62.useState)(null);
    const arrowSize = (0, $8727j.useSize)(arrow);
    const arrowWidth = (_arrowSize$width = arrowSize === null || arrowSize === void 0 ? void 0 : arrowSize.width) !== null && _arrowSize$width !== void 0 ? _arrowSize$width : 0;
    const arrowHeight = (_arrowSize$height = arrowSize === null || arrowSize === void 0 ? void 0 : arrowSize.height) !== null && _arrowSize$height !== void 0 ? _arrowSize$height : 0;
    const desiredPlacement = side + (align !== "center" ? "-" + align : "");
    const collisionPadding = typeof collisionPaddingProp === "number" ? collisionPaddingProp : {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...collisionPaddingProp
    };
    const boundary = Array.isArray(collisionBoundary) ? collisionBoundary : [
        collisionBoundary
    ];
    const hasExplicitBoundaries = boundary.length > 0;
    const detectOverflowOptions = {
        padding: collisionPadding,
        boundary: boundary.filter($a0ac11a1da65e329$var$$cf1ac5d9fe0e8206$var$isNotNull),
        // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
        altBoundary: hasExplicitBoundaries
    };
    const { refs: refs, floatingStyles: floatingStyles, placement: placement, isPositioned: isPositioned, middlewareData: middlewareData } = (0, $33OG6.useFloating)({
        // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
        strategy: "fixed",
        placement: desiredPlacement,
        whileElementsMounted: (...args)=>{
            const cleanup = (0, $618j3.autoUpdate)(...args, {
                animationFrame: updatePositionStrategy === "always"
            });
            return cleanup;
        },
        elements: {
            reference: context.anchor
        },
        middleware: [
            (0, $cZ41y.offset)({
                mainAxis: sideOffset + arrowHeight,
                alignmentAxis: alignOffset
            }),
            avoidCollisions && (0, $618j3.shift)({
                mainAxis: true,
                crossAxis: false,
                limiter: sticky === "partial" ? (0, $618j3.limitShift)() : undefined,
                ...detectOverflowOptions
            }),
            avoidCollisions && (0, $618j3.flip)({
                ...detectOverflowOptions
            }),
            (0, $618j3.size)({
                ...detectOverflowOptions,
                apply: ({ elements: elements, rects: rects, availableWidth: availableWidth, availableHeight: availableHeight })=>{
                    const { width: anchorWidth, height: anchorHeight } = rects.reference;
                    const contentStyle = elements.floating.style;
                    contentStyle.setProperty("--radix-popper-available-width", `${availableWidth}px`);
                    contentStyle.setProperty("--radix-popper-available-height", `${availableHeight}px`);
                    contentStyle.setProperty("--radix-popper-anchor-width", `${anchorWidth}px`);
                    contentStyle.setProperty("--radix-popper-anchor-height", `${anchorHeight}px`);
                }
            }),
            arrow && (0, $33OG6.arrow)({
                element: arrow,
                padding: arrowPadding
            }),
            $a0ac11a1da65e329$var$$cf1ac5d9fe0e8206$var$transformOrigin({
                arrowWidth: arrowWidth,
                arrowHeight: arrowHeight
            }),
            hideWhenDetached && (0, $618j3.hide)({
                strategy: "referenceHidden",
                ...detectOverflowOptions
            })
        ]
    });
    const [placedSide, placedAlign] = $a0ac11a1da65e329$var$$cf1ac5d9fe0e8206$var$getSideAndAlignFromPlacement(placement);
    const handlePlaced = (0, $by19I.useCallbackRef)(onPlaced);
    (0, $7g00o.useLayoutEffect)(()=>{
        if (isPositioned) handlePlaced === null || handlePlaced === void 0 || handlePlaced();
    }, [
        isPositioned,
        handlePlaced
    ]);
    const arrowX = (_middlewareData$arrow = middlewareData.arrow) === null || _middlewareData$arrow === void 0 ? void 0 : _middlewareData$arrow.x;
    const arrowY = (_middlewareData$arrow2 = middlewareData.arrow) === null || _middlewareData$arrow2 === void 0 ? void 0 : _middlewareData$arrow2.y;
    const cannotCenterArrow = ((_middlewareData$arrow3 = middlewareData.arrow) === null || _middlewareData$arrow3 === void 0 ? void 0 : _middlewareData$arrow3.centerOffset) !== 0;
    const [contentZIndex, setContentZIndex] = (0, $acw62.useState)();
    (0, $7g00o.useLayoutEffect)(()=>{
        if (content) setContentZIndex(window.getComputedStyle(content).zIndex);
    }, [
        content
    ]);
    return /*#__PURE__*/ (0, $acw62.createElement)("div", {
        ref: refs.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
            ...floatingStyles,
            transform: isPositioned ? floatingStyles.transform : "translate(0, -200%)",
            // keep off the page when measuring
            minWidth: "max-content",
            zIndex: contentZIndex,
            ["--radix-popper-transform-origin"]: [
                (_middlewareData$trans = middlewareData.transformOrigin) === null || _middlewareData$trans === void 0 ? void 0 : _middlewareData$trans.x,
                (_middlewareData$trans2 = middlewareData.transformOrigin) === null || _middlewareData$trans2 === void 0 ? void 0 : _middlewareData$trans2.y
            ].join(" ")
        } // Floating UI interally calculates logical alignment based the `dir` attribute on
        ,
        dir: props.dir
    }, /*#__PURE__*/ (0, $acw62.createElement)($a0ac11a1da65e329$var$$cf1ac5d9fe0e8206$var$PopperContentProvider, {
        scope: __scopePopper,
        placedSide: placedSide,
        onArrowChange: setArrow,
        arrowX: arrowX,
        arrowY: arrowY,
        shouldHideArrow: cannotCenterArrow
    }, /*#__PURE__*/ (0, $acw62.createElement)((0, $kFbxc.Primitive).div, (0, $8nd05.default)({
        "data-side": placedSide,
        "data-align": placedAlign
    }, contentProps, {
        ref: composedRefs,
        style: {
            ...contentProps.style,
            // if the PopperContent hasn't been placed yet (not all measurements done)
            // we prevent animations so that users's animation don't kick in too early referring wrong sides
            animation: !isPositioned ? "none" : undefined,
            // hide the content if using the hide middleware and should be hidden
            opacity: (_middlewareData$hide = middlewareData.hide) !== null && _middlewareData$hide !== void 0 && _middlewareData$hide.referenceHidden ? 0 : undefined
        }
    }))));
});
/*#__PURE__*/ Object.assign($a0ac11a1da65e329$export$bc4ae5855d3c4fc, {
    displayName: $a0ac11a1da65e329$var$$cf1ac5d9fe0e8206$var$CONTENT_NAME
});
/* -------------------------------------------------------------------------------------------------
 * PopperArrow
 * -----------------------------------------------------------------------------------------------*/ const $a0ac11a1da65e329$var$$cf1ac5d9fe0e8206$var$ARROW_NAME = "PopperArrow";
const $a0ac11a1da65e329$var$$cf1ac5d9fe0e8206$var$OPPOSITE_SIDE = {
    top: "bottom",
    right: "left",
    bottom: "top",
    left: "right"
};
const $a0ac11a1da65e329$export$79d62cd4e10a3fd0 = /*#__PURE__*/ (0, $acw62.forwardRef)(function $cf1ac5d9fe0e8206$export$79d62cd4e10a3fd0(props, forwardedRef) {
    const { __scopePopper: __scopePopper, ...arrowProps } = props;
    const contentContext = $a0ac11a1da65e329$var$$cf1ac5d9fe0e8206$var$useContentContext($a0ac11a1da65e329$var$$cf1ac5d9fe0e8206$var$ARROW_NAME, __scopePopper);
    const baseSide = $a0ac11a1da65e329$var$$cf1ac5d9fe0e8206$var$OPPOSITE_SIDE[contentContext.placedSide];
    return(/*#__PURE__*/ // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    (0, $acw62.createElement)("span", {
        ref: contentContext.onArrowChange,
        style: {
            position: "absolute",
            left: contentContext.arrowX,
            top: contentContext.arrowY,
            [baseSide]: 0,
            transformOrigin: {
                top: "",
                right: "0 0",
                bottom: "center 0",
                left: "100% 0"
            }[contentContext.placedSide],
            transform: {
                top: "translateY(100%)",
                right: "translateY(50%) rotate(90deg) translateX(-50%)",
                bottom: `rotate(180deg)`,
                left: "translateY(50%) rotate(-90deg) translateX(50%)"
            }[contentContext.placedSide],
            visibility: contentContext.shouldHideArrow ? "hidden" : undefined
        }
    }, /*#__PURE__*/ (0, $acw62.createElement)((0, $3vR0G.Root), (0, $8nd05.default)({}, arrowProps, {
        ref: forwardedRef,
        style: {
            ...arrowProps.style,
            // ensures the element can be measured correctly (mostly for if SVG)
            display: "block"
        }
    }))));
});
/*#__PURE__*/ Object.assign($a0ac11a1da65e329$export$79d62cd4e10a3fd0, {
    displayName: $a0ac11a1da65e329$var$$cf1ac5d9fe0e8206$var$ARROW_NAME
});
/* -----------------------------------------------------------------------------------------------*/ function $a0ac11a1da65e329$var$$cf1ac5d9fe0e8206$var$isNotNull(value) {
    return value !== null;
}
const $a0ac11a1da65e329$var$$cf1ac5d9fe0e8206$var$transformOrigin = (options)=>({
        name: "transformOrigin",
        options: options,
        fn (data) {
            var _middlewareData$arrow4, _middlewareData$arrow5, _middlewareData$arrow6, _middlewareData$arrow7, _middlewareData$arrow8;
            const { placement: placement, rects: rects, middlewareData: middlewareData } = data;
            const cannotCenterArrow = ((_middlewareData$arrow4 = middlewareData.arrow) === null || _middlewareData$arrow4 === void 0 ? void 0 : _middlewareData$arrow4.centerOffset) !== 0;
            const isArrowHidden = cannotCenterArrow;
            const arrowWidth = isArrowHidden ? 0 : options.arrowWidth;
            const arrowHeight = isArrowHidden ? 0 : options.arrowHeight;
            const [placedSide, placedAlign] = $a0ac11a1da65e329$var$$cf1ac5d9fe0e8206$var$getSideAndAlignFromPlacement(placement);
            const noArrowAlign = {
                start: "0%",
                center: "50%",
                end: "100%"
            }[placedAlign];
            const arrowXCenter = ((_middlewareData$arrow5 = (_middlewareData$arrow6 = middlewareData.arrow) === null || _middlewareData$arrow6 === void 0 ? void 0 : _middlewareData$arrow6.x) !== null && _middlewareData$arrow5 !== void 0 ? _middlewareData$arrow5 : 0) + arrowWidth / 2;
            const arrowYCenter = ((_middlewareData$arrow7 = (_middlewareData$arrow8 = middlewareData.arrow) === null || _middlewareData$arrow8 === void 0 ? void 0 : _middlewareData$arrow8.y) !== null && _middlewareData$arrow7 !== void 0 ? _middlewareData$arrow7 : 0) + arrowHeight / 2;
            let x = "";
            let y = "";
            if (placedSide === "bottom") {
                x = isArrowHidden ? noArrowAlign : `${arrowXCenter}px`;
                y = `${-arrowHeight}px`;
            } else if (placedSide === "top") {
                x = isArrowHidden ? noArrowAlign : `${arrowXCenter}px`;
                y = `${rects.floating.height + arrowHeight}px`;
            } else if (placedSide === "right") {
                x = `${-arrowHeight}px`;
                y = isArrowHidden ? noArrowAlign : `${arrowYCenter}px`;
            } else if (placedSide === "left") {
                x = `${rects.floating.width + arrowHeight}px`;
                y = isArrowHidden ? noArrowAlign : `${arrowYCenter}px`;
            }
            return {
                data: {
                    x: x,
                    y: y
                }
            };
        }
    });
function $a0ac11a1da65e329$var$$cf1ac5d9fe0e8206$var$getSideAndAlignFromPlacement(placement) {
    const [side, align = "center"] = placement.split("-");
    return [
        side,
        align
    ];
}
const $a0ac11a1da65e329$export$be92b6f5f03c0fe9 = $a0ac11a1da65e329$export$badac9ada3a0bdf9;
const $a0ac11a1da65e329$export$b688253958b8dfe7 = $a0ac11a1da65e329$export$ecd4e1ccab6ed6d;
const $a0ac11a1da65e329$export$7c6e2c02157bb7d2 = $a0ac11a1da65e329$export$bc4ae5855d3c4fc;
const $a0ac11a1da65e329$export$21b07c8f274aebd5 = $a0ac11a1da65e329$export$79d62cd4e10a3fd0;

});
parcelRegister("33OG6", function(module, exports) {

$parcel$export(module.exports, "arrow", () => $23a8f689f1d4c3be$export$f2120bbfa5450bd2);
$parcel$export(module.exports, "useFloating", () => $23a8f689f1d4c3be$export$4e02a5c1d08bac65);

var $618j3 = parcelRequire("618j3");
var $cZ41y = parcelRequire("cZ41y");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */ const $23a8f689f1d4c3be$export$f2120bbfa5450bd2 = (options)=>{
    function isRef(value) {
        return ({}).hasOwnProperty.call(value, "current");
    }
    return {
        name: "arrow",
        options: options,
        fn (state) {
            const { element: element, padding: padding } = typeof options === "function" ? options(state) : options;
            if (element && isRef(element)) {
                if (element.current != null) return (0, $618j3.arrow)({
                    element: element.current,
                    padding: padding
                }).fn(state);
                return {};
            }
            if (element) return (0, $618j3.arrow)({
                element: element,
                padding: padding
            }).fn(state);
            return {};
        }
    };
};
var $23a8f689f1d4c3be$var$index = typeof document !== "undefined" ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);
// Fork of `fast-deep-equal` that only does the comparisons we need and compares
// functions
function $23a8f689f1d4c3be$var$deepEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (typeof a === "function" && a.toString() === b.toString()) return true;
    let length;
    let i;
    let keys;
    if (a && b && typeof a === "object") {
        if (Array.isArray(a)) {
            length = a.length;
            if (length !== b.length) return false;
            for(i = length; i-- !== 0;){
                if (!$23a8f689f1d4c3be$var$deepEqual(a[i], b[i])) return false;
            }
            return true;
        }
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;){
            if (!({}).hasOwnProperty.call(b, keys[i])) return false;
        }
        for(i = length; i-- !== 0;){
            const key = keys[i];
            if (key === "_owner" && a.$$typeof) continue;
            if (!$23a8f689f1d4c3be$var$deepEqual(a[key], b[key])) return false;
        }
        return true;
    }
    // biome-ignore lint/suspicious/noSelfCompare: in source
    return a !== a && b !== b;
}
function $23a8f689f1d4c3be$var$getDPR(element) {
    if (typeof window === "undefined") return 1;
    const win = element.ownerDocument.defaultView || window;
    return win.devicePixelRatio || 1;
}
function $23a8f689f1d4c3be$var$roundByDPR(element, value) {
    const dpr = $23a8f689f1d4c3be$var$getDPR(element);
    return Math.round(value * dpr) / dpr;
}
function $23a8f689f1d4c3be$var$useLatestRef(value) {
    const ref = $acw62.useRef(value);
    $23a8f689f1d4c3be$var$index(()=>{
        ref.current = value;
    });
    return ref;
}
/**
 * Provides data to position a floating element.
 * @see https://floating-ui.com/docs/useFloating
 */ function $23a8f689f1d4c3be$export$4e02a5c1d08bac65(options) {
    if (options === void 0) options = {};
    const { placement: placement = "bottom", strategy: strategy = "absolute", middleware: middleware = [], platform: platform, elements: { reference: externalReference, floating: externalFloating } = {}, transform: transform = true, whileElementsMounted: whileElementsMounted, open: open } = options;
    const [data, setData] = $acw62.useState({
        x: 0,
        y: 0,
        strategy: strategy,
        placement: placement,
        middlewareData: {},
        isPositioned: false
    });
    const [latestMiddleware, setLatestMiddleware] = $acw62.useState(middleware);
    if (!$23a8f689f1d4c3be$var$deepEqual(latestMiddleware, middleware)) setLatestMiddleware(middleware);
    const [_reference, _setReference] = $acw62.useState(null);
    const [_floating, _setFloating] = $acw62.useState(null);
    const setReference = $acw62.useCallback((node)=>{
        if (node !== referenceRef.current) {
            referenceRef.current = node;
            _setReference(node);
        }
    }, []);
    const setFloating = $acw62.useCallback((node)=>{
        if (node !== floatingRef.current) {
            floatingRef.current = node;
            _setFloating(node);
        }
    }, []);
    const referenceEl = externalReference || _reference;
    const floatingEl = externalFloating || _floating;
    const referenceRef = $acw62.useRef(null);
    const floatingRef = $acw62.useRef(null);
    const dataRef = $acw62.useRef(data);
    const hasWhileElementsMounted = whileElementsMounted != null;
    const whileElementsMountedRef = $23a8f689f1d4c3be$var$useLatestRef(whileElementsMounted);
    const platformRef = $23a8f689f1d4c3be$var$useLatestRef(platform);
    const update = $acw62.useCallback(()=>{
        if (!referenceRef.current || !floatingRef.current) return;
        const config = {
            placement: placement,
            strategy: strategy,
            middleware: latestMiddleware
        };
        if (platformRef.current) config.platform = platformRef.current;
        (0, $618j3.computePosition)(referenceRef.current, floatingRef.current, config).then((data)=>{
            const fullData = {
                ...data,
                isPositioned: true
            };
            if (isMountedRef.current && !$23a8f689f1d4c3be$var$deepEqual(dataRef.current, fullData)) {
                dataRef.current = fullData;
                $1u0KT.flushSync(()=>{
                    setData(fullData);
                });
            }
        });
    }, [
        latestMiddleware,
        placement,
        strategy,
        platformRef
    ]);
    $23a8f689f1d4c3be$var$index(()=>{
        if (open === false && dataRef.current.isPositioned) {
            dataRef.current.isPositioned = false;
            setData((data)=>({
                    ...data,
                    isPositioned: false
                }));
        }
    }, [
        open
    ]);
    const isMountedRef = $acw62.useRef(false);
    $23a8f689f1d4c3be$var$index(()=>{
        isMountedRef.current = true;
        return ()=>{
            isMountedRef.current = false;
        };
    }, []);
    // biome-ignore lint/correctness/useExhaustiveDependencies: `hasWhileElementsMounted` is intentionally included.
    $23a8f689f1d4c3be$var$index(()=>{
        if (referenceEl) referenceRef.current = referenceEl;
        if (floatingEl) floatingRef.current = floatingEl;
        if (referenceEl && floatingEl) {
            if (whileElementsMountedRef.current) return whileElementsMountedRef.current(referenceEl, floatingEl, update);
            update();
        }
    }, [
        referenceEl,
        floatingEl,
        update,
        whileElementsMountedRef,
        hasWhileElementsMounted
    ]);
    const refs = $acw62.useMemo(()=>({
            reference: referenceRef,
            floating: floatingRef,
            setReference: setReference,
            setFloating: setFloating
        }), [
        setReference,
        setFloating
    ]);
    const elements = $acw62.useMemo(()=>({
            reference: referenceEl,
            floating: floatingEl
        }), [
        referenceEl,
        floatingEl
    ]);
    const floatingStyles = $acw62.useMemo(()=>{
        const initialStyles = {
            position: strategy,
            left: 0,
            top: 0
        };
        if (!elements.floating) return initialStyles;
        const x = $23a8f689f1d4c3be$var$roundByDPR(elements.floating, data.x);
        const y = $23a8f689f1d4c3be$var$roundByDPR(elements.floating, data.y);
        if (transform) return {
            ...initialStyles,
            transform: "translate(" + x + "px, " + y + "px)",
            ...$23a8f689f1d4c3be$var$getDPR(elements.floating) >= 1.5 && {
                willChange: "transform"
            }
        };
        return {
            position: strategy,
            left: x,
            top: y
        };
    }, [
        strategy,
        transform,
        elements.floating,
        data.x,
        data.y
    ]);
    return $acw62.useMemo(()=>({
            ...data,
            update: update,
            refs: refs,
            elements: elements,
            floatingStyles: floatingStyles
        }), [
        data,
        update,
        refs,
        elements,
        floatingStyles
    ]);
}

});
parcelRegister("618j3", function(module, exports) {

$parcel$export(module.exports, "autoUpdate", () => $461947879dcdbcd4$export$deee3a793edee05f);
$parcel$export(module.exports, "shift", () => $461947879dcdbcd4$export$fba63a578e423eb);
$parcel$export(module.exports, "flip", () => $461947879dcdbcd4$export$8a83211c878a3f1f);
$parcel$export(module.exports, "size", () => $461947879dcdbcd4$export$346677f925de839c);
$parcel$export(module.exports, "hide", () => $461947879dcdbcd4$export$fe8985bb6374093c);
$parcel$export(module.exports, "arrow", () => $461947879dcdbcd4$export$f2120bbfa5450bd2);
$parcel$export(module.exports, "limitShift", () => $461947879dcdbcd4$export$7bf07e38f3dc4b69);
$parcel$export(module.exports, "computePosition", () => $461947879dcdbcd4$export$48a53dcb22e581d0);

var $cZ41y = parcelRequire("cZ41y");
var $1obCQ = parcelRequire("1obCQ");

var $1obCQ = parcelRequire("1obCQ");

var $33bLr = parcelRequire("33bLr");
function $461947879dcdbcd4$var$getCssDimensions(element) {
    const css = (0, $33bLr.getComputedStyle)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $33bLr.isHTMLElement)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $1obCQ.round)(width) !== offsetWidth || (0, $1obCQ.round)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $461947879dcdbcd4$var$unwrapElement(element) {
    return !(0, $33bLr.isElement)(element) ? element.contextElement : element;
}
function $461947879dcdbcd4$var$getScale(element) {
    const domElement = $461947879dcdbcd4$var$unwrapElement(element);
    if (!(0, $33bLr.isHTMLElement)(domElement)) return (0, $1obCQ.createCoords)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $461947879dcdbcd4$var$getCssDimensions(domElement);
    let x = ($ ? (0, $1obCQ.round)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $1obCQ.round)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $461947879dcdbcd4$var$noOffsets = /*#__PURE__*/ (0, $1obCQ.createCoords)(0);
function $461947879dcdbcd4$var$getVisualOffsets(element) {
    const win = (0, $33bLr.getWindow)(element);
    if (!(0, $33bLr.isWebKit)() || !win.visualViewport) return $461947879dcdbcd4$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $461947879dcdbcd4$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, $33bLr.getWindow)(element)) return false;
    return isFixed;
}
function $461947879dcdbcd4$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $461947879dcdbcd4$var$unwrapElement(element);
    let scale = (0, $1obCQ.createCoords)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $33bLr.isElement)(offsetParent)) scale = $461947879dcdbcd4$var$getScale(offsetParent);
        } else scale = $461947879dcdbcd4$var$getScale(element);
    }
    const visualOffsets = $461947879dcdbcd4$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $461947879dcdbcd4$var$getVisualOffsets(domElement) : (0, $1obCQ.createCoords)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, $33bLr.getWindow)(domElement);
        const offsetWin = offsetParent && (0, $33bLr.isElement)(offsetParent) ? (0, $33bLr.getWindow)(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = currentWin.frameElement;
        while(currentIFrame && offsetParent && offsetWin !== currentWin){
            const iframeScale = $461947879dcdbcd4$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $33bLr.getComputedStyle)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, $33bLr.getWindow)(currentIFrame);
            currentIFrame = currentWin.frameElement;
        }
    }
    return (0, $1obCQ.rectToClientRect)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
const $461947879dcdbcd4$var$topLayerSelectors = [
    ":popover-open",
    ":modal"
];
function $461947879dcdbcd4$var$isTopLayer(floating) {
    return $461947879dcdbcd4$var$topLayerSelectors.some((selector)=>{
        try {
            return floating.matches(selector);
        } catch (e) {
            return false;
        }
    });
}
function $461947879dcdbcd4$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isFixed = strategy === "fixed";
    const documentElement = (0, $33bLr.getDocumentElement)(offsetParent);
    const topLayer = elements ? $461947879dcdbcd4$var$isTopLayer(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $1obCQ.createCoords)(1);
    const offsets = (0, $1obCQ.createCoords)(0);
    const isOffsetParentAnElement = (0, $33bLr.isHTMLElement)(offsetParent);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $33bLr.getNodeName)(offsetParent) !== "body" || (0, $33bLr.isOverflowElement)(documentElement)) scroll = (0, $33bLr.getNodeScroll)(offsetParent);
        if ((0, $33bLr.isHTMLElement)(offsetParent)) {
            const offsetRect = $461947879dcdbcd4$var$getBoundingClientRect(offsetParent);
            scale = $461947879dcdbcd4$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y
    };
}
function $461947879dcdbcd4$var$getClientRects(element) {
    return Array.from(element.getClientRects());
}
function $461947879dcdbcd4$var$getWindowScrollBarX(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    return $461947879dcdbcd4$var$getBoundingClientRect((0, $33bLr.getDocumentElement)(element)).left + (0, $33bLr.getNodeScroll)(element).scrollLeft;
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $461947879dcdbcd4$var$getDocumentRect(element) {
    const html = (0, $33bLr.getDocumentElement)(element);
    const scroll = (0, $33bLr.getNodeScroll)(element);
    const body = element.ownerDocument.body;
    const width = (0, $1obCQ.max)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $1obCQ.max)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $461947879dcdbcd4$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, $33bLr.getComputedStyle)(body).direction === "rtl") x += (0, $1obCQ.max)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $461947879dcdbcd4$var$getViewportRect(element, strategy) {
    const win = (0, $33bLr.getWindow)(element);
    const html = (0, $33bLr.getDocumentElement)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, $33bLr.isWebKit)();
        if (!visualViewportBased || visualViewportBased && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $461947879dcdbcd4$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $461947879dcdbcd4$var$getBoundingClientRect(element, true, strategy === "fixed");
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, $33bLr.isHTMLElement)(element) ? $461947879dcdbcd4$var$getScale(element) : (0, $1obCQ.createCoords)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $461947879dcdbcd4$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === "viewport") rect = $461947879dcdbcd4$var$getViewportRect(element, strategy);
    else if (clippingAncestor === "document") rect = $461947879dcdbcd4$var$getDocumentRect((0, $33bLr.getDocumentElement)(element));
    else if ((0, $33bLr.isElement)(clippingAncestor)) rect = $461947879dcdbcd4$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $461947879dcdbcd4$var$getVisualOffsets(element);
        rect = {
            ...clippingAncestor,
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y
        };
    }
    return (0, $1obCQ.rectToClientRect)(rect);
}
function $461947879dcdbcd4$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, $33bLr.getParentNode)(element);
    if (parentNode === stopNode || !(0, $33bLr.isElement)(parentNode) || (0, $33bLr.isLastTraversableNode)(parentNode)) return false;
    return (0, $33bLr.getComputedStyle)(parentNode).position === "fixed" || $461947879dcdbcd4$var$hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $461947879dcdbcd4$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $33bLr.getOverflowAncestors)(element, [], false).filter((el)=>(0, $33bLr.isElement)(el) && (0, $33bLr.getNodeName)(el) !== "body");
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, $33bLr.getComputedStyle)(element).position === "fixed";
    let currentNode = elementIsFixed ? (0, $33bLr.getParentNode)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $33bLr.isElement)(currentNode) && !(0, $33bLr.isLastTraversableNode)(currentNode)){
        const computedStyle = (0, $33bLr.getComputedStyle)(currentNode);
        const currentNodeIsContaining = (0, $33bLr.isContainingBlock)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === "fixed") currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === "static" && !!currentContainingBlockComputedStyle && [
            "absolute",
            "fixed"
        ].includes(currentContainingBlockComputedStyle.position) || (0, $33bLr.isOverflowElement)(currentNode) && !currentNodeIsContaining && $461947879dcdbcd4$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, $33bLr.getParentNode)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $461947879dcdbcd4$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === "clippingAncestors" ? $461947879dcdbcd4$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstClippingAncestor = clippingAncestors[0];
    const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
        const rect = $461947879dcdbcd4$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = (0, $1obCQ.max)(rect.top, accRect.top);
        accRect.right = (0, $1obCQ.min)(rect.right, accRect.right);
        accRect.bottom = (0, $1obCQ.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $1obCQ.max)(rect.left, accRect.left);
        return accRect;
    }, $461947879dcdbcd4$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
function $461947879dcdbcd4$var$getDimensions(element) {
    const { width: width, height: height } = $461947879dcdbcd4$var$getCssDimensions(element);
    return {
        width: width,
        height: height
    };
}
function $461947879dcdbcd4$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $33bLr.isHTMLElement)(offsetParent);
    const documentElement = (0, $33bLr.getDocumentElement)(offsetParent);
    const isFixed = strategy === "fixed";
    const rect = $461947879dcdbcd4$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $1obCQ.createCoords)(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $33bLr.getNodeName)(offsetParent) !== "body" || (0, $33bLr.isOverflowElement)(documentElement)) scroll = (0, $33bLr.getNodeScroll)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $461947879dcdbcd4$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) offsets.x = $461947879dcdbcd4$var$getWindowScrollBarX(documentElement);
    }
    const x = rect.left + scroll.scrollLeft - offsets.x;
    const y = rect.top + scroll.scrollTop - offsets.y;
    return {
        x: x,
        y: y,
        width: rect.width,
        height: rect.height
    };
}
function $461947879dcdbcd4$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $33bLr.isHTMLElement)(element) || (0, $33bLr.getComputedStyle)(element).position === "fixed") return null;
    if (polyfill) return polyfill(element);
    return element.offsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $461947879dcdbcd4$var$getOffsetParent(element, polyfill) {
    const window = (0, $33bLr.getWindow)(element);
    if (!(0, $33bLr.isHTMLElement)(element) || $461947879dcdbcd4$var$isTopLayer(element)) return window;
    let offsetParent = $461947879dcdbcd4$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $33bLr.isTableElement)(offsetParent) && (0, $33bLr.getComputedStyle)(offsetParent).position === "static")offsetParent = $461947879dcdbcd4$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && ((0, $33bLr.getNodeName)(offsetParent) === "html" || (0, $33bLr.getNodeName)(offsetParent) === "body" && (0, $33bLr.getComputedStyle)(offsetParent).position === "static" && !(0, $33bLr.isContainingBlock)(offsetParent))) return window;
    return offsetParent || (0, $33bLr.getContainingBlock)(element) || window;
}
const $461947879dcdbcd4$var$getElementRects = async function(data) {
    const getOffsetParentFn = this.getOffsetParent || $461947879dcdbcd4$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    return {
        reference: $461947879dcdbcd4$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            ...await getDimensionsFn(data.floating)
        }
    };
};
function $461947879dcdbcd4$var$isRTL(element) {
    return (0, $33bLr.getComputedStyle)(element).direction === "rtl";
}
const $461947879dcdbcd4$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $461947879dcdbcd4$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $33bLr.getDocumentElement,
    getClippingRect: $461947879dcdbcd4$var$getClippingRect,
    getOffsetParent: $461947879dcdbcd4$var$getOffsetParent,
    getElementRects: $461947879dcdbcd4$var$getElementRects,
    getClientRects: $461947879dcdbcd4$var$getClientRects,
    getDimensions: $461947879dcdbcd4$var$getDimensions,
    getScale: $461947879dcdbcd4$var$getScale,
    isElement: $33bLr.isElement,
    isRTL: $461947879dcdbcd4$var$isRTL
};
// https://samthor.au/2021/observing-dom/
function $461947879dcdbcd4$var$observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, $33bLr.getDocumentElement)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const { left: left, top: top, width: width, height: height } = element.getBoundingClientRect();
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $1obCQ.floor)(top);
        const insetRight = (0, $1obCQ.floor)(root.clientWidth - (left + width));
        const insetBottom = (0, $1obCQ.floor)(root.clientHeight - (top + height));
        const insetLeft = (0, $1obCQ.floor)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $1obCQ.max)(0, (0, $1obCQ.min)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 100);
                else refresh(false, ratio);
            }
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $461947879dcdbcd4$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === "function", layoutShift: layoutShift = typeof IntersectionObserver === "function", animationFrame: animationFrame = false } = options;
    const referenceEl = $461947879dcdbcd4$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $33bLr.getOverflowAncestors)(referenceEl) : [],
        ...(0, $33bLr.getOverflowAncestors)(floating)
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener("scroll", update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener("resize", update);
    });
    const cleanupIo = referenceEl && layoutShift ? $461947879dcdbcd4$var$observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $461947879dcdbcd4$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $461947879dcdbcd4$var$getBoundingClientRect(reference);
        if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener("scroll", update);
            ancestorResize && ancestor.removeEventListener("resize", update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $461947879dcdbcd4$export$91fb6ecbd551914 = (0, $cZ41y.autoPlacement);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $461947879dcdbcd4$export$fba63a578e423eb = (0, $cZ41y.shift);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $461947879dcdbcd4$export$8a83211c878a3f1f = (0, $cZ41y.flip);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $461947879dcdbcd4$export$346677f925de839c = (0, $cZ41y.size);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $461947879dcdbcd4$export$fe8985bb6374093c = (0, $cZ41y.hide);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $461947879dcdbcd4$export$f2120bbfa5450bd2 = (0, $cZ41y.arrow);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $461947879dcdbcd4$export$18c8ad048e32c7d5 = (0, $cZ41y.inline);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $461947879dcdbcd4$export$7bf07e38f3dc4b69 = (0, $cZ41y.limitShift);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const $461947879dcdbcd4$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = {
        platform: $461947879dcdbcd4$export$722a64dea1b767dc,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, $cZ41y.computePosition)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};

});
parcelRegister("cZ41y", function(module, exports) {

$parcel$export(module.exports, "computePosition", () => $973e4da43f2a375d$export$48a53dcb22e581d0);
$parcel$export(module.exports, "arrow", () => $973e4da43f2a375d$export$f2120bbfa5450bd2);
$parcel$export(module.exports, "autoPlacement", () => $973e4da43f2a375d$export$91fb6ecbd551914);
$parcel$export(module.exports, "flip", () => $973e4da43f2a375d$export$8a83211c878a3f1f);
$parcel$export(module.exports, "hide", () => $973e4da43f2a375d$export$fe8985bb6374093c);
$parcel$export(module.exports, "inline", () => $973e4da43f2a375d$export$18c8ad048e32c7d5);
$parcel$export(module.exports, "offset", () => $973e4da43f2a375d$export$cc800923e997bb8);
$parcel$export(module.exports, "shift", () => $973e4da43f2a375d$export$fba63a578e423eb);
$parcel$export(module.exports, "limitShift", () => $973e4da43f2a375d$export$7bf07e38f3dc4b69);
$parcel$export(module.exports, "size", () => $973e4da43f2a375d$export$346677f925de839c);
$parcel$export(module.exports, "rectToClientRect", () => (parcelRequire("1obCQ")).rectToClientRect);

var $1obCQ = parcelRequire("1obCQ");
function $973e4da43f2a375d$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $1obCQ.getSideAxis)(placement);
    const alignmentAxis = (0, $1obCQ.getAlignmentAxis)(placement);
    const alignLength = (0, $1obCQ.getAxisLength)(alignmentAxis);
    const side = (0, $1obCQ.getSide)(placement);
    const isVertical = sideAxis === "y";
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case "top":
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case "bottom":
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case "right":
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case "left":
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, $1obCQ.getAlignment)(placement)){
        case "start":
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case "end":
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $973e4da43f2a375d$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = "bottom", strategy: strategy = "absolute", middleware: middleware = [], platform: platform } = config;
    const validMiddleware = middleware.filter(Boolean);
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $973e4da43f2a375d$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let middlewareData = {};
    let resetCount = 0;
    for(let i = 0; i < validMiddleware.length; i++){
        const { name: name, fn: fn } = validMiddleware[i];
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platform,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData = {
            ...middlewareData,
            [name]: {
                ...middlewareData[name],
                ...data
            }
        };
        if (reset && resetCount <= 50) {
            resetCount++;
            if (typeof reset === "object") {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $973e4da43f2a375d$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $973e4da43f2a375d$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = "clippingAncestors", rootBoundary: rootBoundary = "viewport", elementContext: elementContext = "floating", altBoundary: altBoundary = false, padding: padding = 0 } = (0, $1obCQ.evaluate)(options, state);
    const paddingObject = (0, $1obCQ.getPaddingObject)(padding);
    const altContext = elementContext === "floating" ? "reference" : "floating";
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $1obCQ.rectToClientRect)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === "floating" ? {
        ...rects.floating,
        x: x,
        y: y
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $1obCQ.rectToClientRect)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements: elements,
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $973e4da43f2a375d$export$f2120bbfa5450bd2 = (options)=>({
        name: "arrow",
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $1obCQ.evaluate)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $1obCQ.getPaddingObject)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $1obCQ.getAlignmentAxis)(placement);
            const length = (0, $1obCQ.getAxisLength)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === "y";
            const minProp = isYAxis ? "top" : "left";
            const maxProp = isYAxis ? "bottom" : "right";
            const clientProp = isYAxis ? "clientHeight" : "clientWidth";
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $1obCQ.min)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $1obCQ.min)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $1obCQ.clamp)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $1obCQ.getAlignment)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset: alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function $973e4da43f2a375d$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $1obCQ.getAlignment)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $1obCQ.getAlignment)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $1obCQ.getSide)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $1obCQ.getAlignment)(placement) === alignment || (autoAlignment ? (0, $1obCQ.getOppositeAlignmentPlacement)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $973e4da43f2a375d$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "autoPlacement",
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, $1obCQ.placements), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, $1obCQ.evaluate)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $1obCQ.placements) ? $973e4da43f2a375d$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await $973e4da43f2a375d$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, $1obCQ.getAlignmentSides)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, $1obCQ.getSide)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $1obCQ.getAlignment)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $1obCQ.getAlignment)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $973e4da43f2a375d$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: "flip",
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = "bestFit", fallbackAxisSideDirection: fallbackAxisSideDirection = "none", flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, $1obCQ.evaluate)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $1obCQ.getSide)(placement);
            const isBasePlacement = (0, $1obCQ.getSide)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $1obCQ.getOppositePlacement)(initialPlacement)
            ] : (0, $1obCQ.getExpandedPlacements)(initialPlacement));
            if (!specifiedFallbackPlacements && fallbackAxisSideDirection !== "none") fallbackPlacements.push(...(0, $1obCQ.getOppositeAxisPlacements)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await $973e4da43f2a375d$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $1obCQ.getAlignmentSides)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) // Try next placement and re-run the lifecycle.
                return {
                    data: {
                        index: nextIndex,
                        overflows: overflowsData
                    },
                    reset: {
                        placement: nextPlacement
                    }
                };
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case "bestFit":
                        {
                            var _overflowsData$map$so;
                            const placement = (_overflowsData$map$so = overflowsData.map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$map$so[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case "initialPlacement":
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $973e4da43f2a375d$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $973e4da43f2a375d$var$isAnySideFullyClipped(overflow) {
    return (0, $1obCQ.sides).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $973e4da43f2a375d$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: "hide",
        options: options,
        async fn (state) {
            const { rects: rects } = state;
            const { strategy: strategy = "referenceHidden", ...detectOverflowOptions } = (0, $1obCQ.evaluate)(options, state);
            switch(strategy){
                case "referenceHidden":
                    {
                        const overflow = await $973e4da43f2a375d$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            elementContext: "reference"
                        });
                        const offsets = $973e4da43f2a375d$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $973e4da43f2a375d$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case "escaped":
                    {
                        const overflow = await $973e4da43f2a375d$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $973e4da43f2a375d$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $973e4da43f2a375d$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $973e4da43f2a375d$var$getBoundingRect(rects) {
    const minX = (0, $1obCQ.min)(...rects.map((rect)=>rect.left));
    const minY = (0, $1obCQ.min)(...rects.map((rect)=>rect.top));
    const maxX = (0, $1obCQ.max)(...rects.map((rect)=>rect.right));
    const maxY = (0, $1obCQ.max)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $973e4da43f2a375d$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $1obCQ.rectToClientRect)($973e4da43f2a375d$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $973e4da43f2a375d$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "inline",
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = (0, $1obCQ.evaluate)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = $973e4da43f2a375d$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $1obCQ.rectToClientRect)($973e4da43f2a375d$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $1obCQ.getPaddingObject)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $1obCQ.getSideAxis)(placement) === "y") {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $1obCQ.getSide)(placement) === "top";
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, $1obCQ.getSide)(placement) === "left";
                    const maxRight = (0, $1obCQ.max)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $1obCQ.min)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top: top,
                        bottom: bottom,
                        left: left,
                        right: right,
                        width: width,
                        height: height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $973e4da43f2a375d$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $1obCQ.getSide)(placement);
    const alignment = (0, $1obCQ.getAlignment)(placement);
    const isVertical = (0, $1obCQ.getSideAxis)(placement) === "y";
    const mainAxisMulti = [
        "left",
        "top"
    ].includes(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $1obCQ.evaluate)(options, state);
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === "number" ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: 0,
        crossAxis: 0,
        alignmentAxis: null,
        ...rawValue
    };
    if (alignment && typeof alignmentAxis === "number") crossAxis = alignment === "end" ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $973e4da43f2a375d$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: "offset",
        options: options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
            const diffCoords = await $973e4da43f2a375d$var$convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: {
                    ...diffCoords,
                    placement: placement
                }
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $973e4da43f2a375d$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: "shift",
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            }, ...detectOverflowOptions } = (0, $1obCQ.evaluate)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await $973e4da43f2a375d$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const crossAxis = (0, $1obCQ.getSideAxis)((0, $1obCQ.getSide)(placement));
            const mainAxis = (0, $1obCQ.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === "y" ? "top" : "left";
                const maxSide = mainAxis === "y" ? "bottom" : "right";
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, $1obCQ.clamp)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === "y" ? "top" : "left";
                const maxSide = crossAxis === "y" ? "bottom" : "right";
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, $1obCQ.clamp)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $973e4da43f2a375d$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $1obCQ.evaluate)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $1obCQ.getSideAxis)(placement);
            const mainAxis = (0, $1obCQ.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $1obCQ.evaluate)(offset, state);
            const computedOffset = typeof rawOffset === "number" ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === "y" ? "height" : "width";
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === "y" ? "width" : "height";
                const isOriginSide = [
                    "top",
                    "left"
                ].includes((0, $1obCQ.getSide)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $973e4da43f2a375d$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: "size",
        options: options,
        async fn (state) {
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, $1obCQ.evaluate)(options, state);
            const overflow = await $973e4da43f2a375d$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const side = (0, $1obCQ.getSide)(placement);
            const alignment = (0, $1obCQ.getAlignment)(placement);
            const isYAxis = (0, $1obCQ.getSideAxis)(placement) === "y";
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === "top" || side === "bottom") {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? "start" : "end") ? "left" : "right";
            } else {
                widthSide = side;
                heightSide = alignment === "end" ? "top" : "bottom";
            }
            const overflowAvailableHeight = height - overflow[heightSide];
            const overflowAvailableWidth = width - overflow[widthSide];
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if (isYAxis) {
                const maximumClippingWidth = width - overflow.left - overflow.right;
                availableWidth = alignment || noShift ? (0, $1obCQ.min)(overflowAvailableWidth, maximumClippingWidth) : maximumClippingWidth;
            } else {
                const maximumClippingHeight = height - overflow.top - overflow.bottom;
                availableHeight = alignment || noShift ? (0, $1obCQ.min)(overflowAvailableHeight, maximumClippingHeight) : maximumClippingHeight;
            }
            if (noShift && !alignment) {
                const xMin = (0, $1obCQ.max)(overflow.left, 0);
                const xMax = (0, $1obCQ.max)(overflow.right, 0);
                const yMin = (0, $1obCQ.max)(overflow.top, 0);
                const yMax = (0, $1obCQ.max)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, $1obCQ.max)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, $1obCQ.max)(overflow.top, overflow.bottom));
            }
            await apply({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};

});
parcelRegister("1obCQ", function(module, exports) {

$parcel$export(module.exports, "sides", () => $10310cf078d13212$export$832b6fa47fa053d2);
$parcel$export(module.exports, "placements", () => $10310cf078d13212$export$803cd8101b6c182b);
$parcel$export(module.exports, "min", () => $10310cf078d13212$export$96ec731ed4dcb222);
$parcel$export(module.exports, "max", () => $10310cf078d13212$export$8960430cfd85939f);
$parcel$export(module.exports, "round", () => $10310cf078d13212$export$2077e0241d6afd3c);
$parcel$export(module.exports, "floor", () => $10310cf078d13212$export$a3fe094919f356fd);
$parcel$export(module.exports, "createCoords", () => $10310cf078d13212$export$a397704b5e280835);
$parcel$export(module.exports, "clamp", () => $10310cf078d13212$export$7d15b64cf5a3a4c4);
$parcel$export(module.exports, "evaluate", () => $10310cf078d13212$export$fef61f332f2c0afc);
$parcel$export(module.exports, "getSide", () => $10310cf078d13212$export$3c915306cb7fc97a);
$parcel$export(module.exports, "getAlignment", () => $10310cf078d13212$export$f0989780f32bfcda);
$parcel$export(module.exports, "getOppositeAxis", () => $10310cf078d13212$export$8a000a963141ac32);
$parcel$export(module.exports, "getAxisLength", () => $10310cf078d13212$export$320bd9d53520c68a);
$parcel$export(module.exports, "getSideAxis", () => $10310cf078d13212$export$f28e8f882010718a);
$parcel$export(module.exports, "getAlignmentAxis", () => $10310cf078d13212$export$2b57e0052a6d6d4c);
$parcel$export(module.exports, "getAlignmentSides", () => $10310cf078d13212$export$be42861551f17911);
$parcel$export(module.exports, "getOppositePlacement", () => $10310cf078d13212$export$9c5e28bad23365fa);
$parcel$export(module.exports, "getExpandedPlacements", () => $10310cf078d13212$export$496432a3699e50b1);
$parcel$export(module.exports, "getOppositeAlignmentPlacement", () => $10310cf078d13212$export$2b182c584985588b);
$parcel$export(module.exports, "getOppositeAxisPlacements", () => $10310cf078d13212$export$a9b6fb18fd92c3ec);
$parcel$export(module.exports, "getPaddingObject", () => $10310cf078d13212$export$598c291c29bc2e71);
$parcel$export(module.exports, "rectToClientRect", () => $10310cf078d13212$export$ee05aea0aeecbad4);
/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ const $10310cf078d13212$export$832b6fa47fa053d2 = [
    "top",
    "right",
    "bottom",
    "left"
];
const $10310cf078d13212$export$27b07d8a310ed8b5 = [
    "start",
    "end"
];
const $10310cf078d13212$export$803cd8101b6c182b = /*#__PURE__*/ $10310cf078d13212$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $10310cf078d13212$export$27b07d8a310ed8b5[0], side + "-" + $10310cf078d13212$export$27b07d8a310ed8b5[1]), []);
const $10310cf078d13212$export$96ec731ed4dcb222 = Math.min;
const $10310cf078d13212$export$8960430cfd85939f = Math.max;
const $10310cf078d13212$export$2077e0241d6afd3c = Math.round;
const $10310cf078d13212$export$a3fe094919f356fd = Math.floor;
const $10310cf078d13212$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $10310cf078d13212$var$oppositeSideMap = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
const $10310cf078d13212$var$oppositeAlignmentMap = {
    start: "end",
    end: "start"
};
function $10310cf078d13212$export$7d15b64cf5a3a4c4(start, value, end) {
    return $10310cf078d13212$export$8960430cfd85939f(start, $10310cf078d13212$export$96ec731ed4dcb222(value, end));
}
function $10310cf078d13212$export$fef61f332f2c0afc(value, param) {
    return typeof value === "function" ? value(param) : value;
}
function $10310cf078d13212$export$3c915306cb7fc97a(placement) {
    return placement.split("-")[0];
}
function $10310cf078d13212$export$f0989780f32bfcda(placement) {
    return placement.split("-")[1];
}
function $10310cf078d13212$export$8a000a963141ac32(axis) {
    return axis === "x" ? "y" : "x";
}
function $10310cf078d13212$export$320bd9d53520c68a(axis) {
    return axis === "y" ? "height" : "width";
}
function $10310cf078d13212$export$f28e8f882010718a(placement) {
    return [
        "top",
        "bottom"
    ].includes($10310cf078d13212$export$3c915306cb7fc97a(placement)) ? "y" : "x";
}
function $10310cf078d13212$export$2b57e0052a6d6d4c(placement) {
    return $10310cf078d13212$export$8a000a963141ac32($10310cf078d13212$export$f28e8f882010718a(placement));
}
function $10310cf078d13212$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $10310cf078d13212$export$f0989780f32bfcda(placement);
    const alignmentAxis = $10310cf078d13212$export$2b57e0052a6d6d4c(placement);
    const length = $10310cf078d13212$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === "x" ? alignment === (rtl ? "end" : "start") ? "right" : "left" : alignment === "start" ? "bottom" : "top";
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $10310cf078d13212$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $10310cf078d13212$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $10310cf078d13212$export$496432a3699e50b1(placement) {
    const oppositePlacement = $10310cf078d13212$export$9c5e28bad23365fa(placement);
    return [
        $10310cf078d13212$export$2b182c584985588b(placement),
        oppositePlacement,
        $10310cf078d13212$export$2b182c584985588b(oppositePlacement)
    ];
}
function $10310cf078d13212$export$2b182c584985588b(placement) {
    return placement.replace(/start|end/g, (alignment)=>$10310cf078d13212$var$oppositeAlignmentMap[alignment]);
}
function $10310cf078d13212$var$getSideList(side, isStart, rtl) {
    const lr = [
        "left",
        "right"
    ];
    const rl = [
        "right",
        "left"
    ];
    const tb = [
        "top",
        "bottom"
    ];
    const bt = [
        "bottom",
        "top"
    ];
    switch(side){
        case "top":
        case "bottom":
            if (rtl) return isStart ? rl : lr;
            return isStart ? lr : rl;
        case "left":
        case "right":
            return isStart ? tb : bt;
        default:
            return [];
    }
}
function $10310cf078d13212$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $10310cf078d13212$export$f0989780f32bfcda(placement);
    let list = $10310cf078d13212$var$getSideList($10310cf078d13212$export$3c915306cb7fc97a(placement), direction === "start", rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($10310cf078d13212$export$2b182c584985588b));
    }
    return list;
}
function $10310cf078d13212$export$9c5e28bad23365fa(placement) {
    return placement.replace(/left|right|bottom|top/g, (side)=>$10310cf078d13212$var$oppositeSideMap[side]);
}
function $10310cf078d13212$export$1c66dbf1a9e34223(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function $10310cf078d13212$export$598c291c29bc2e71(padding) {
    return typeof padding !== "number" ? $10310cf078d13212$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $10310cf078d13212$export$ee05aea0aeecbad4(rect) {
    return {
        ...rect,
        top: rect.y,
        left: rect.x,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    };
}

});


parcelRegister("33bLr", function(module, exports) {

$parcel$export(module.exports, "getNodeName", () => $238ac70369f38756$export$651544f548703224);
$parcel$export(module.exports, "getWindow", () => $238ac70369f38756$export$38b2d434cce3ea22);
$parcel$export(module.exports, "getDocumentElement", () => $238ac70369f38756$export$e495491855dc5418);
$parcel$export(module.exports, "isElement", () => $238ac70369f38756$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isHTMLElement", () => $238ac70369f38756$export$1b3bfaa9684536aa);
$parcel$export(module.exports, "isOverflowElement", () => $238ac70369f38756$export$989e911fa9af580a);
$parcel$export(module.exports, "getComputedStyle", () => $238ac70369f38756$export$3735103072e4a80);
$parcel$export(module.exports, "isTableElement", () => $238ac70369f38756$export$71535ffaa902797f);
$parcel$export(module.exports, "isContainingBlock", () => $238ac70369f38756$export$d6c4e8150c35fed1);
$parcel$export(module.exports, "isWebKit", () => $238ac70369f38756$export$78551043582a6a98);
$parcel$export(module.exports, "getContainingBlock", () => $238ac70369f38756$export$940d8225183e1404);
$parcel$export(module.exports, "getParentNode", () => $238ac70369f38756$export$4e12058fc4d51d56);
$parcel$export(module.exports, "isLastTraversableNode", () => $238ac70369f38756$export$d1162fb0b6d4cd51);
$parcel$export(module.exports, "getNodeScroll", () => $238ac70369f38756$export$dc8fc79fa2800137);
$parcel$export(module.exports, "getOverflowAncestors", () => $238ac70369f38756$export$3b57c1601291186b);
function $238ac70369f38756$export$651544f548703224(node) {
    if ($238ac70369f38756$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || "").toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return "#document";
}
function $238ac70369f38756$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $238ac70369f38756$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($238ac70369f38756$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $238ac70369f38756$export$8ee0fc9ee280b4ee(value) {
    return value instanceof Node || value instanceof $238ac70369f38756$export$38b2d434cce3ea22(value).Node;
}
function $238ac70369f38756$export$45a5e7f76e0caa8d(value) {
    return value instanceof Element || value instanceof $238ac70369f38756$export$38b2d434cce3ea22(value).Element;
}
function $238ac70369f38756$export$1b3bfaa9684536aa(value) {
    return value instanceof HTMLElement || value instanceof $238ac70369f38756$export$38b2d434cce3ea22(value).HTMLElement;
}
function $238ac70369f38756$export$af51f0f06c0f328a(value) {
    // Browsers without `ShadowRoot` support.
    if (typeof ShadowRoot === "undefined") return false;
    return value instanceof ShadowRoot || value instanceof $238ac70369f38756$export$38b2d434cce3ea22(value).ShadowRoot;
}
function $238ac70369f38756$export$989e911fa9af580a(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $238ac70369f38756$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && ![
        "inline",
        "contents"
    ].includes(display);
}
function $238ac70369f38756$export$71535ffaa902797f(element) {
    return [
        "table",
        "td",
        "th"
    ].includes($238ac70369f38756$export$651544f548703224(element));
}
function $238ac70369f38756$export$d6c4e8150c35fed1(element) {
    const webkit = $238ac70369f38756$export$78551043582a6a98();
    const css = $238ac70369f38756$export$3735103072e4a80(element);
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    return css.transform !== "none" || css.perspective !== "none" || (css.containerType ? css.containerType !== "normal" : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== "none" : false) || !webkit && (css.filter ? css.filter !== "none" : false) || [
        "transform",
        "perspective",
        "filter"
    ].some((value)=>(css.willChange || "").includes(value)) || [
        "paint",
        "layout",
        "strict",
        "content"
    ].some((value)=>(css.contain || "").includes(value));
}
function $238ac70369f38756$export$940d8225183e1404(element) {
    let currentNode = $238ac70369f38756$export$4e12058fc4d51d56(element);
    while($238ac70369f38756$export$1b3bfaa9684536aa(currentNode) && !$238ac70369f38756$export$d1162fb0b6d4cd51(currentNode)){
        if ($238ac70369f38756$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        else currentNode = $238ac70369f38756$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $238ac70369f38756$export$78551043582a6a98() {
    if (typeof CSS === "undefined" || !CSS.supports) return false;
    return CSS.supports("-webkit-backdrop-filter", "none");
}
function $238ac70369f38756$export$d1162fb0b6d4cd51(node) {
    return [
        "html",
        "body",
        "#document"
    ].includes($238ac70369f38756$export$651544f548703224(node));
}
function $238ac70369f38756$export$3735103072e4a80(element) {
    return $238ac70369f38756$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $238ac70369f38756$export$dc8fc79fa2800137(element) {
    if ($238ac70369f38756$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.pageXOffset,
        scrollTop: element.pageYOffset
    };
}
function $238ac70369f38756$export$4e12058fc4d51d56(node) {
    if ($238ac70369f38756$export$651544f548703224(node) === "html") return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $238ac70369f38756$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $238ac70369f38756$export$e495491855dc5418(node);
    return $238ac70369f38756$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $238ac70369f38756$export$7cd01a57c8ca906c(node) {
    const parentNode = $238ac70369f38756$export$4e12058fc4d51d56(node);
    if ($238ac70369f38756$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if ($238ac70369f38756$export$1b3bfaa9684536aa(parentNode) && $238ac70369f38756$export$989e911fa9af580a(parentNode)) return parentNode;
    return $238ac70369f38756$export$7cd01a57c8ca906c(parentNode);
}
function $238ac70369f38756$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $238ac70369f38756$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $238ac70369f38756$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) return list.concat(win, win.visualViewport || [], $238ac70369f38756$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], win.frameElement && traverseIframes ? $238ac70369f38756$export$3b57c1601291186b(win.frameElement) : []);
    return list.concat(scrollableAncestor, $238ac70369f38756$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}

});



parcelRegister("3vR0G", function(module, exports) {

$parcel$export(module.exports, "Root", () => $1002b17d420264b2$export$be92b6f5f03c0fe9);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $kFbxc = parcelRequire("kFbxc");
/* -------------------------------------------------------------------------------------------------
 * Arrow
 * -----------------------------------------------------------------------------------------------*/ const $1002b17d420264b2$var$$7e8f5cd07187803e$var$NAME = "Arrow";
const $1002b17d420264b2$export$21b07c8f274aebd5 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { children: children, width: width = 10, height: height = 5, ...arrowProps } = props;
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $kFbxc.Primitive).svg, (0, $8nd05.default)({}, arrowProps, {
        ref: forwardedRef,
        width: width,
        height: height,
        viewBox: "0 0 30 10",
        preserveAspectRatio: "none"
    }), props.asChild ? children : /*#__PURE__*/ (0, $acw62.createElement)("polygon", {
        points: "0,0 30,0 15,10"
    }));
});
/*#__PURE__*/ Object.assign($1002b17d420264b2$export$21b07c8f274aebd5, {
    displayName: $1002b17d420264b2$var$$7e8f5cd07187803e$var$NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $1002b17d420264b2$export$be92b6f5f03c0fe9 = $1002b17d420264b2$export$21b07c8f274aebd5;

});

parcelRegister("8727j", function(module, exports) {

$parcel$export(module.exports, "useSize", () => $db5ba6ddde57f255$export$1ab7ae714698c4b8);

var $acw62 = parcelRequire("acw62");

var $7g00o = parcelRequire("7g00o");
function $db5ba6ddde57f255$export$1ab7ae714698c4b8(element) {
    const [size, setSize] = (0, $acw62.useState)(undefined);
    (0, $7g00o.useLayoutEffect)(()=>{
        if (element) {
            // provide size as early as possible
            setSize({
                width: element.offsetWidth,
                height: element.offsetHeight
            });
            const resizeObserver = new ResizeObserver((entries)=>{
                if (!Array.isArray(entries)) return;
                // Since we only observe the one element, we don't need to loop over the
                // array
                if (!entries.length) return;
                const entry = entries[0];
                let width;
                let height;
                if ("borderBoxSize" in entry) {
                    const borderSizeEntry = entry["borderBoxSize"]; // iron out differences between browsers
                    const borderSize = Array.isArray(borderSizeEntry) ? borderSizeEntry[0] : borderSizeEntry;
                    width = borderSize["inlineSize"];
                    height = borderSize["blockSize"];
                } else {
                    // for browsers that don't support `borderBoxSize`
                    // we calculate it ourselves to get the correct border box.
                    width = element.offsetWidth;
                    height = element.offsetHeight;
                }
                setSize({
                    width: width,
                    height: height
                });
            });
            resizeObserver.observe(element, {
                box: "border-box"
            });
            return ()=>resizeObserver.unobserve(element);
        } else // not if it changes to another element.
        setSize(undefined);
    }, [
        element
    ]);
    return size;
}

});


parcelRegister("abA6z", function(module, exports) {

$parcel$export(module.exports, "createRovingFocusGroupScope", () => $0483c88073bf4923$export$c7109489551a4f4);
$parcel$export(module.exports, "Root", () => $0483c88073bf4923$export$be92b6f5f03c0fe9);
$parcel$export(module.exports, "Item", () => $0483c88073bf4923$export$6d08773d2e66f8f2);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $2IwC4 = parcelRequire("2IwC4");

var $9nBzD = parcelRequire("9nBzD");

var $htT6J = parcelRequire("htT6J");

var $jnK0n = parcelRequire("jnK0n");

var $g2NP0 = parcelRequire("g2NP0");

var $kFbxc = parcelRequire("kFbxc");

var $by19I = parcelRequire("by19I");

var $88UcQ = parcelRequire("88UcQ");

var $5ZQml = parcelRequire("5ZQml");
const $0483c88073bf4923$var$$d7bdfb9eb0fdf311$var$ENTRY_FOCUS = "rovingFocusGroup.onEntryFocus";
const $0483c88073bf4923$var$$d7bdfb9eb0fdf311$var$EVENT_OPTIONS = {
    bubbles: false,
    cancelable: true
};
/* -------------------------------------------------------------------------------------------------
 * RovingFocusGroup
 * -----------------------------------------------------------------------------------------------*/ const $0483c88073bf4923$var$$d7bdfb9eb0fdf311$var$GROUP_NAME = "RovingFocusGroup";
const [$0483c88073bf4923$var$$d7bdfb9eb0fdf311$var$Collection, $0483c88073bf4923$var$$d7bdfb9eb0fdf311$var$useCollection, $0483c88073bf4923$var$$d7bdfb9eb0fdf311$var$createCollectionScope] = (0, $9nBzD.createCollection)($0483c88073bf4923$var$$d7bdfb9eb0fdf311$var$GROUP_NAME);
const [$0483c88073bf4923$var$$d7bdfb9eb0fdf311$var$createRovingFocusGroupContext, $0483c88073bf4923$export$c7109489551a4f4] = (0, $jnK0n.createContextScope)($0483c88073bf4923$var$$d7bdfb9eb0fdf311$var$GROUP_NAME, [
    $0483c88073bf4923$var$$d7bdfb9eb0fdf311$var$createCollectionScope
]);
const [$0483c88073bf4923$var$$d7bdfb9eb0fdf311$var$RovingFocusProvider, $0483c88073bf4923$var$$d7bdfb9eb0fdf311$var$useRovingFocusContext] = $0483c88073bf4923$var$$d7bdfb9eb0fdf311$var$createRovingFocusGroupContext($0483c88073bf4923$var$$d7bdfb9eb0fdf311$var$GROUP_NAME);
const $0483c88073bf4923$export$8699f7c8af148338 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    return /*#__PURE__*/ (0, $acw62.createElement)($0483c88073bf4923$var$$d7bdfb9eb0fdf311$var$Collection.Provider, {
        scope: props.__scopeRovingFocusGroup
    }, /*#__PURE__*/ (0, $acw62.createElement)($0483c88073bf4923$var$$d7bdfb9eb0fdf311$var$Collection.Slot, {
        scope: props.__scopeRovingFocusGroup
    }, /*#__PURE__*/ (0, $acw62.createElement)($0483c88073bf4923$var$$d7bdfb9eb0fdf311$var$RovingFocusGroupImpl, (0, $8nd05.default)({}, props, {
        ref: forwardedRef
    }))));
});
/*#__PURE__*/ Object.assign($0483c88073bf4923$export$8699f7c8af148338, {
    displayName: $0483c88073bf4923$var$$d7bdfb9eb0fdf311$var$GROUP_NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $0483c88073bf4923$var$$d7bdfb9eb0fdf311$var$RovingFocusGroupImpl = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopeRovingFocusGroup: __scopeRovingFocusGroup, orientation: orientation, loop: loop = false, dir: dir, currentTabStopId: currentTabStopIdProp, defaultCurrentTabStopId: defaultCurrentTabStopId, onCurrentTabStopIdChange: onCurrentTabStopIdChange, onEntryFocus: onEntryFocus, ...groupProps } = props;
    const ref = (0, $acw62.useRef)(null);
    const composedRefs = (0, $htT6J.useComposedRefs)(forwardedRef, ref);
    const direction = (0, $5ZQml.useDirection)(dir);
    const [currentTabStopId = null, setCurrentTabStopId] = (0, $88UcQ.useControllableState)({
        prop: currentTabStopIdProp,
        defaultProp: defaultCurrentTabStopId,
        onChange: onCurrentTabStopIdChange
    });
    const [isTabbingBackOut, setIsTabbingBackOut] = (0, $acw62.useState)(false);
    const handleEntryFocus = (0, $by19I.useCallbackRef)(onEntryFocus);
    const getItems = $0483c88073bf4923$var$$d7bdfb9eb0fdf311$var$useCollection(__scopeRovingFocusGroup);
    const isClickFocusRef = (0, $acw62.useRef)(false);
    const [focusableItemsCount, setFocusableItemsCount] = (0, $acw62.useState)(0);
    (0, $acw62.useEffect)(()=>{
        const node = ref.current;
        if (node) {
            node.addEventListener($0483c88073bf4923$var$$d7bdfb9eb0fdf311$var$ENTRY_FOCUS, handleEntryFocus);
            return ()=>node.removeEventListener($0483c88073bf4923$var$$d7bdfb9eb0fdf311$var$ENTRY_FOCUS, handleEntryFocus);
        }
    }, [
        handleEntryFocus
    ]);
    return /*#__PURE__*/ (0, $acw62.createElement)($0483c88073bf4923$var$$d7bdfb9eb0fdf311$var$RovingFocusProvider, {
        scope: __scopeRovingFocusGroup,
        orientation: orientation,
        dir: direction,
        loop: loop,
        currentTabStopId: currentTabStopId,
        onItemFocus: (0, $acw62.useCallback)((tabStopId)=>setCurrentTabStopId(tabStopId), [
            setCurrentTabStopId
        ]),
        onItemShiftTab: (0, $acw62.useCallback)(()=>setIsTabbingBackOut(true), []),
        onFocusableItemAdd: (0, $acw62.useCallback)(()=>setFocusableItemsCount((prevCount)=>prevCount + 1), []),
        onFocusableItemRemove: (0, $acw62.useCallback)(()=>setFocusableItemsCount((prevCount)=>prevCount - 1), [])
    }, /*#__PURE__*/ (0, $acw62.createElement)((0, $kFbxc.Primitive).div, (0, $8nd05.default)({
        tabIndex: isTabbingBackOut || focusableItemsCount === 0 ? -1 : 0,
        "data-orientation": orientation
    }, groupProps, {
        ref: composedRefs,
        style: {
            outline: "none",
            ...props.style
        },
        onMouseDown: (0, $2IwC4.composeEventHandlers)(props.onMouseDown, ()=>{
            isClickFocusRef.current = true;
        }),
        onFocus: (0, $2IwC4.composeEventHandlers)(props.onFocus, (event)=>{
            // We normally wouldn't need this check, because we already check
            // that the focus is on the current target and not bubbling to it.
            // We do this because Safari doesn't focus buttons when clicked, and
            // instead, the wrapper will get focused and not through a bubbling event.
            const isKeyboardFocus = !isClickFocusRef.current;
            if (event.target === event.currentTarget && isKeyboardFocus && !isTabbingBackOut) {
                const entryFocusEvent = new CustomEvent($0483c88073bf4923$var$$d7bdfb9eb0fdf311$var$ENTRY_FOCUS, $0483c88073bf4923$var$$d7bdfb9eb0fdf311$var$EVENT_OPTIONS);
                event.currentTarget.dispatchEvent(entryFocusEvent);
                if (!entryFocusEvent.defaultPrevented) {
                    const items = getItems().filter((item)=>item.focusable);
                    const activeItem = items.find((item)=>item.active);
                    const currentItem = items.find((item)=>item.id === currentTabStopId);
                    const candidateItems = [
                        activeItem,
                        currentItem,
                        ...items
                    ].filter(Boolean);
                    const candidateNodes = candidateItems.map((item)=>item.ref.current);
                    $0483c88073bf4923$var$$d7bdfb9eb0fdf311$var$focusFirst(candidateNodes);
                }
            }
            isClickFocusRef.current = false;
        }),
        onBlur: (0, $2IwC4.composeEventHandlers)(props.onBlur, ()=>setIsTabbingBackOut(false))
    })));
});
/* -------------------------------------------------------------------------------------------------
 * RovingFocusGroupItem
 * -----------------------------------------------------------------------------------------------*/ const $0483c88073bf4923$var$$d7bdfb9eb0fdf311$var$ITEM_NAME = "RovingFocusGroupItem";
const $0483c88073bf4923$export$ab9df7c53fe8454 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopeRovingFocusGroup: __scopeRovingFocusGroup, focusable: focusable = true, active: active = false, tabStopId: tabStopId, ...itemProps } = props;
    const autoId = (0, $g2NP0.useId)();
    const id = tabStopId || autoId;
    const context = $0483c88073bf4923$var$$d7bdfb9eb0fdf311$var$useRovingFocusContext($0483c88073bf4923$var$$d7bdfb9eb0fdf311$var$ITEM_NAME, __scopeRovingFocusGroup);
    const isCurrentTabStop = context.currentTabStopId === id;
    const getItems = $0483c88073bf4923$var$$d7bdfb9eb0fdf311$var$useCollection(__scopeRovingFocusGroup);
    const { onFocusableItemAdd: onFocusableItemAdd, onFocusableItemRemove: onFocusableItemRemove } = context;
    (0, $acw62.useEffect)(()=>{
        if (focusable) {
            onFocusableItemAdd();
            return ()=>onFocusableItemRemove();
        }
    }, [
        focusable,
        onFocusableItemAdd,
        onFocusableItemRemove
    ]);
    return /*#__PURE__*/ (0, $acw62.createElement)($0483c88073bf4923$var$$d7bdfb9eb0fdf311$var$Collection.ItemSlot, {
        scope: __scopeRovingFocusGroup,
        id: id,
        focusable: focusable,
        active: active
    }, /*#__PURE__*/ (0, $acw62.createElement)((0, $kFbxc.Primitive).span, (0, $8nd05.default)({
        tabIndex: isCurrentTabStop ? 0 : -1,
        "data-orientation": context.orientation
    }, itemProps, {
        ref: forwardedRef,
        onMouseDown: (0, $2IwC4.composeEventHandlers)(props.onMouseDown, (event)=>{
            // We prevent focusing non-focusable items on `mousedown`.
            // Even though the item has tabIndex={-1}, that only means take it out of the tab order.
            if (!focusable) event.preventDefault(); // Safari doesn't focus a button when clicked so we run our logic on mousedown also
            else context.onItemFocus(id);
        }),
        onFocus: (0, $2IwC4.composeEventHandlers)(props.onFocus, ()=>context.onItemFocus(id)),
        onKeyDown: (0, $2IwC4.composeEventHandlers)(props.onKeyDown, (event)=>{
            if (event.key === "Tab" && event.shiftKey) {
                context.onItemShiftTab();
                return;
            }
            if (event.target !== event.currentTarget) return;
            const focusIntent = $0483c88073bf4923$var$$d7bdfb9eb0fdf311$var$getFocusIntent(event, context.orientation, context.dir);
            if (focusIntent !== undefined) {
                event.preventDefault();
                const items = getItems().filter((item)=>item.focusable);
                let candidateNodes = items.map((item)=>item.ref.current);
                if (focusIntent === "last") candidateNodes.reverse();
                else if (focusIntent === "prev" || focusIntent === "next") {
                    if (focusIntent === "prev") candidateNodes.reverse();
                    const currentIndex = candidateNodes.indexOf(event.currentTarget);
                    candidateNodes = context.loop ? $0483c88073bf4923$var$$d7bdfb9eb0fdf311$var$wrapArray(candidateNodes, currentIndex + 1) : candidateNodes.slice(currentIndex + 1);
                }
                /**
         * Imperative focus during keydown is risky so we prevent React's batching updates
         * to avoid potential bugs. See: https://github.com/facebook/react/issues/20332
         */ setTimeout(()=>$0483c88073bf4923$var$$d7bdfb9eb0fdf311$var$focusFirst(candidateNodes));
            }
        })
    })));
});
/*#__PURE__*/ Object.assign($0483c88073bf4923$export$ab9df7c53fe8454, {
    displayName: $0483c88073bf4923$var$$d7bdfb9eb0fdf311$var$ITEM_NAME
});
/* -----------------------------------------------------------------------------------------------*/ // prettier-ignore
const $0483c88073bf4923$var$$d7bdfb9eb0fdf311$var$MAP_KEY_TO_FOCUS_INTENT = {
    ArrowLeft: "prev",
    ArrowUp: "prev",
    ArrowRight: "next",
    ArrowDown: "next",
    PageUp: "first",
    Home: "first",
    PageDown: "last",
    End: "last"
};
function $0483c88073bf4923$var$$d7bdfb9eb0fdf311$var$getDirectionAwareKey(key, dir) {
    if (dir !== "rtl") return key;
    return key === "ArrowLeft" ? "ArrowRight" : key === "ArrowRight" ? "ArrowLeft" : key;
}
function $0483c88073bf4923$var$$d7bdfb9eb0fdf311$var$getFocusIntent(event, orientation, dir) {
    const key = $0483c88073bf4923$var$$d7bdfb9eb0fdf311$var$getDirectionAwareKey(event.key, dir);
    if (orientation === "vertical" && [
        "ArrowLeft",
        "ArrowRight"
    ].includes(key)) return undefined;
    if (orientation === "horizontal" && [
        "ArrowUp",
        "ArrowDown"
    ].includes(key)) return undefined;
    return $0483c88073bf4923$var$$d7bdfb9eb0fdf311$var$MAP_KEY_TO_FOCUS_INTENT[key];
}
function $0483c88073bf4923$var$$d7bdfb9eb0fdf311$var$focusFirst(candidates) {
    const PREVIOUSLY_FOCUSED_ELEMENT = document.activeElement;
    for (const candidate of candidates){
        // if focus is already where we want to go, we don't want to keep going through the candidates
        if (candidate === PREVIOUSLY_FOCUSED_ELEMENT) return;
        candidate.focus();
        if (document.activeElement !== PREVIOUSLY_FOCUSED_ELEMENT) return;
    }
}
/**
 * Wraps an array around itself at a given start index
 * Example: `wrapArray(['a', 'b', 'c', 'd'], 2) === ['c', 'd', 'a', 'b']`
 */ function $0483c88073bf4923$var$$d7bdfb9eb0fdf311$var$wrapArray(array, startIndex) {
    return array.map((_, index)=>array[(startIndex + index) % array.length]);
}
const $0483c88073bf4923$export$be92b6f5f03c0fe9 = $0483c88073bf4923$export$8699f7c8af148338;
const $0483c88073bf4923$export$6d08773d2e66f8f2 = $0483c88073bf4923$export$ab9df7c53fe8454;

});



parcelRegister("htSut", function(module, exports) {
"use strict";

module.exports = (parcelRequire("405T6"));

});
parcelRegister("405T6", function(module, exports) {
// Main parser class
"use strict";

var $cNF1f = parcelRequire("cNF1f");

var $4FEdr = parcelRequire("4FEdr");

var $6Aw5F = parcelRequire("6Aw5F");

var $9OAeu = parcelRequire("9OAeu");

var $ksQT7 = parcelRequire("ksQT7");

var $dgJn4 = parcelRequire("dgJn4");

var $kgioT = parcelRequire("kgioT");

var $9l2bS = parcelRequire("9l2bS");

var $dBHwk = parcelRequire("dBHwk");



var $2e9bbaae9d29e4e9$var$config = {
    default: (parcelRequire("hzfZQ")),
    zero: (parcelRequire("azWcK")),
    commonmark: (parcelRequire("7xkVi"))
};
////////////////////////////////////////////////////////////////////////////////
//
// This validator can prohibit more than really needed to prevent XSS. It's a
// tradeoff to keep code simple and to be secure by default.
//
// If you need different setup - override validator method as you wish. Or
// replace it with dummy function and use external sanitizer.
//
var $2e9bbaae9d29e4e9$var$BAD_PROTO_RE = /^(vbscript|javascript|file|data):/;
var $2e9bbaae9d29e4e9$var$GOOD_DATA_RE = /^data:image\/(gif|png|jpeg|webp);/;
function $2e9bbaae9d29e4e9$var$validateLink(url) {
    // url should be normalized at this point, and existing entities are decoded
    var str = url.trim().toLowerCase();
    return $2e9bbaae9d29e4e9$var$BAD_PROTO_RE.test(str) ? $2e9bbaae9d29e4e9$var$GOOD_DATA_RE.test(str) ? true : false : true;
}
////////////////////////////////////////////////////////////////////////////////
var $2e9bbaae9d29e4e9$var$RECODE_HOSTNAME_FOR = [
    "http:",
    "https:",
    "mailto:"
];
function $2e9bbaae9d29e4e9$var$normalizeLink(url) {
    var parsed = $9l2bS.parse(url, true);
    if (parsed.hostname) {
        // Encode hostnames in urls like:
        // `http://host/`, `https://host/`, `mailto:user@host`, `//host/`
        //
        // We don't encode unknown schemas, because it's likely that we encode
        // something we shouldn't (e.g. `skype:name` treated as `skype:host`)
        //
        if (!parsed.protocol || $2e9bbaae9d29e4e9$var$RECODE_HOSTNAME_FOR.indexOf(parsed.protocol) >= 0) try {
            parsed.hostname = $dBHwk.toASCII(parsed.hostname);
        } catch (er) {}
    }
    return $9l2bS.encode($9l2bS.format(parsed));
}
function $2e9bbaae9d29e4e9$var$normalizeLinkText(url) {
    var parsed = $9l2bS.parse(url, true);
    if (parsed.hostname) {
        // Encode hostnames in urls like:
        // `http://host/`, `https://host/`, `mailto:user@host`, `//host/`
        //
        // We don't encode unknown schemas, because it's likely that we encode
        // something we shouldn't (e.g. `skype:name` treated as `skype:host`)
        //
        if (!parsed.protocol || $2e9bbaae9d29e4e9$var$RECODE_HOSTNAME_FOR.indexOf(parsed.protocol) >= 0) try {
            parsed.hostname = $dBHwk.toUnicode(parsed.hostname);
        } catch (er) {}
    }
    // add '%' to exclude list because of https://github.com/markdown-it/markdown-it/issues/720
    return $9l2bS.decode($9l2bS.format(parsed), $9l2bS.decode.defaultChars + "%");
}
/**
 * class MarkdownIt
 *
 * Main parser/renderer class.
 *
 * ##### Usage
 *
 * ```javascript
 * // node.js, "classic" way:
 * var MarkdownIt = require('markdown-it'),
 *     md = new MarkdownIt();
 * var result = md.render('# markdown-it rulezz!');
 *
 * // node.js, the same, but with sugar:
 * var md = require('markdown-it')();
 * var result = md.render('# markdown-it rulezz!');
 *
 * // browser without AMD, added to "window" on script load
 * // Note, there are no dash.
 * var md = window.markdownit();
 * var result = md.render('# markdown-it rulezz!');
 * ```
 *
 * Single line rendering, without paragraph wrap:
 *
 * ```javascript
 * var md = require('markdown-it')();
 * var result = md.renderInline('__markdown-it__ rulezz!');
 * ```
 **/ /**
 * new MarkdownIt([presetName, options])
 * - presetName (String): optional, `commonmark` / `zero`
 * - options (Object)
 *
 * Creates parser instanse with given config. Can be called without `new`.
 *
 * ##### presetName
 *
 * MarkdownIt provides named presets as a convenience to quickly
 * enable/disable active syntax rules and options for common use cases.
 *
 * - ["commonmark"](https://github.com/markdown-it/markdown-it/blob/master/lib/presets/commonmark.js) -
 *   configures parser to strict [CommonMark](http://commonmark.org/) mode.
 * - [default](https://github.com/markdown-it/markdown-it/blob/master/lib/presets/default.js) -
 *   similar to GFM, used when no preset name given. Enables all available rules,
 *   but still without html, typographer & autolinker.
 * - ["zero"](https://github.com/markdown-it/markdown-it/blob/master/lib/presets/zero.js) -
 *   all rules disabled. Useful to quickly setup your config via `.enable()`.
 *   For example, when you need only `bold` and `italic` markup and nothing else.
 *
 * ##### options:
 *
 * - __html__ - `false`. Set `true` to enable HTML tags in source. Be careful!
 *   That's not safe! You may need external sanitizer to protect output from XSS.
 *   It's better to extend features via plugins, instead of enabling HTML.
 * - __xhtmlOut__ - `false`. Set `true` to add '/' when closing single tags
 *   (`<br />`). This is needed only for full CommonMark compatibility. In real
 *   world you will need HTML output.
 * - __breaks__ - `false`. Set `true` to convert `\n` in paragraphs into `<br>`.
 * - __langPrefix__ - `language-`. CSS language class prefix for fenced blocks.
 *   Can be useful for external highlighters.
 * - __linkify__ - `false`. Set `true` to autoconvert URL-like text to links.
 * - __typographer__  - `false`. Set `true` to enable [some language-neutral
 *   replacement](https://github.com/markdown-it/markdown-it/blob/master/lib/rules_core/replacements.js) +
 *   quotes beautification (smartquotes).
 * - __quotes__ - `“”‘’`, String or Array. Double + single quotes replacement
 *   pairs, when typographer enabled and smartquotes on. For example, you can
 *   use `'«»„“'` for Russian, `'„“‚‘'` for German, and
 *   `['«\xA0', '\xA0»', '‹\xA0', '\xA0›']` for French (including nbsp).
 * - __highlight__ - `null`. Highlighter function for fenced code blocks.
 *   Highlighter `function (str, lang)` should return escaped HTML. It can also
 *   return empty string if the source was not changed and should be escaped
 *   externaly. If result starts with <pre... internal wrapper is skipped.
 *
 * ##### Example
 *
 * ```javascript
 * // commonmark mode
 * var md = require('markdown-it')('commonmark');
 *
 * // default mode
 * var md = require('markdown-it')();
 *
 * // enable everything
 * var md = require('markdown-it')({
 *   html: true,
 *   linkify: true,
 *   typographer: true
 * });
 * ```
 *
 * ##### Syntax highlighting
 *
 * ```js
 * var hljs = require('highlight.js') // https://highlightjs.org/
 *
 * var md = require('markdown-it')({
 *   highlight: function (str, lang) {
 *     if (lang && hljs.getLanguage(lang)) {
 *       try {
 *         return hljs.highlight(str, { language: lang, ignoreIllegals: true }).value;
 *       } catch (__) {}
 *     }
 *
 *     return ''; // use external default escaping
 *   }
 * });
 * ```
 *
 * Or with full wrapper override (if you need assign class to `<pre>`):
 *
 * ```javascript
 * var hljs = require('highlight.js') // https://highlightjs.org/
 *
 * // Actual default values
 * var md = require('markdown-it')({
 *   highlight: function (str, lang) {
 *     if (lang && hljs.getLanguage(lang)) {
 *       try {
 *         return '<pre class="hljs"><code>' +
 *                hljs.highlight(str, { language: lang, ignoreIllegals: true }).value +
 *                '</code></pre>';
 *       } catch (__) {}
 *     }
 *
 *     return '<pre class="hljs"><code>' + md.utils.escapeHtml(str) + '</code></pre>';
 *   }
 * });
 * ```
 *
 **/ function $2e9bbaae9d29e4e9$var$MarkdownIt(presetName, options) {
    if (!(this instanceof $2e9bbaae9d29e4e9$var$MarkdownIt)) return new $2e9bbaae9d29e4e9$var$MarkdownIt(presetName, options);
    if (!options) {
        if (!$cNF1f.isString(presetName)) {
            options = presetName || {};
            presetName = "default";
        }
    }
    /**
   * MarkdownIt#inline -> ParserInline
   *
   * Instance of [[ParserInline]]. You may need it to add new rules when
   * writing plugins. For simple rules control use [[MarkdownIt.disable]] and
   * [[MarkdownIt.enable]].
   **/ this.inline = new $dgJn4();
    /**
   * MarkdownIt#block -> ParserBlock
   *
   * Instance of [[ParserBlock]]. You may need it to add new rules when
   * writing plugins. For simple rules control use [[MarkdownIt.disable]] and
   * [[MarkdownIt.enable]].
   **/ this.block = new $ksQT7();
    /**
   * MarkdownIt#core -> Core
   *
   * Instance of [[Core]] chain executor. You may need it to add new rules when
   * writing plugins. For simple rules control use [[MarkdownIt.disable]] and
   * [[MarkdownIt.enable]].
   **/ this.core = new $9OAeu();
    /**
   * MarkdownIt#renderer -> Renderer
   *
   * Instance of [[Renderer]]. Use it to modify output look. Or to add rendering
   * rules for new token types, generated by plugins.
   *
   * ##### Example
   *
   * ```javascript
   * var md = require('markdown-it')();
   *
   * function myToken(tokens, idx, options, env, self) {
   *   //...
   *   return result;
   * };
   *
   * md.renderer.rules['my_token'] = myToken
   * ```
   *
   * See [[Renderer]] docs and [source code](https://github.com/markdown-it/markdown-it/blob/master/lib/renderer.js).
   **/ this.renderer = new $6Aw5F();
    /**
   * MarkdownIt#linkify -> LinkifyIt
   *
   * [linkify-it](https://github.com/markdown-it/linkify-it) instance.
   * Used by [linkify](https://github.com/markdown-it/markdown-it/blob/master/lib/rules_core/linkify.js)
   * rule.
   **/ this.linkify = new $kgioT();
    /**
   * MarkdownIt#validateLink(url) -> Boolean
   *
   * Link validation function. CommonMark allows too much in links. By default
   * we disable `javascript:`, `vbscript:`, `file:` schemas, and almost all `data:...` schemas
   * except some embedded image types.
   *
   * You can change this behaviour:
   *
   * ```javascript
   * var md = require('markdown-it')();
   * // enable everything
   * md.validateLink = function () { return true; }
   * ```
   **/ this.validateLink = $2e9bbaae9d29e4e9$var$validateLink;
    /**
   * MarkdownIt#normalizeLink(url) -> String
   *
   * Function used to encode link url to a machine-readable format,
   * which includes url-encoding, punycode, etc.
   **/ this.normalizeLink = $2e9bbaae9d29e4e9$var$normalizeLink;
    /**
   * MarkdownIt#normalizeLinkText(url) -> String
   *
   * Function used to decode link url to a human-readable format`
   **/ this.normalizeLinkText = $2e9bbaae9d29e4e9$var$normalizeLinkText;
    // Expose utils & helpers for easy acces from plugins
    /**
   * MarkdownIt#utils -> utils
   *
   * Assorted utility functions, useful to write plugins. See details
   * [here](https://github.com/markdown-it/markdown-it/blob/master/lib/common/utils.js).
   **/ this.utils = $cNF1f;
    /**
   * MarkdownIt#helpers -> helpers
   *
   * Link components parser functions, useful to write plugins. See details
   * [here](https://github.com/markdown-it/markdown-it/blob/master/lib/helpers).
   **/ this.helpers = $cNF1f.assign({}, $4FEdr);
    this.options = {};
    this.configure(presetName);
    if (options) this.set(options);
}
/** chainable
 * MarkdownIt.set(options)
 *
 * Set parser options (in the same format as in constructor). Probably, you
 * will never need it, but you can change options after constructor call.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')()
 *             .set({ html: true, breaks: true })
 *             .set({ typographer, true });
 * ```
 *
 * __Note:__ To achieve the best possible performance, don't modify a
 * `markdown-it` instance options on the fly. If you need multiple configurations
 * it's best to create multiple instances and initialize each with separate
 * config.
 **/ $2e9bbaae9d29e4e9$var$MarkdownIt.prototype.set = function(options) {
    $cNF1f.assign(this.options, options);
    return this;
};
/** chainable, internal
 * MarkdownIt.configure(presets)
 *
 * Batch load of all options and compenent settings. This is internal method,
 * and you probably will not need it. But if you will - see available presets
 * and data structure [here](https://github.com/markdown-it/markdown-it/tree/master/lib/presets)
 *
 * We strongly recommend to use presets instead of direct config loads. That
 * will give better compatibility with next versions.
 **/ $2e9bbaae9d29e4e9$var$MarkdownIt.prototype.configure = function(presets) {
    var self = this, presetName;
    if ($cNF1f.isString(presets)) {
        presetName = presets;
        presets = $2e9bbaae9d29e4e9$var$config[presetName];
        if (!presets) throw new Error('Wrong `markdown-it` preset "' + presetName + '", check name');
    }
    if (!presets) throw new Error("Wrong `markdown-it` preset, can't be empty");
    if (presets.options) self.set(presets.options);
    if (presets.components) Object.keys(presets.components).forEach(function(name) {
        if (presets.components[name].rules) self[name].ruler.enableOnly(presets.components[name].rules);
        if (presets.components[name].rules2) self[name].ruler2.enableOnly(presets.components[name].rules2);
    });
    return this;
};
/** chainable
 * MarkdownIt.enable(list, ignoreInvalid)
 * - list (String|Array): rule name or list of rule names to enable
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Enable list or rules. It will automatically find appropriate components,
 * containing rules with given names. If rule not found, and `ignoreInvalid`
 * not set - throws exception.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')()
 *             .enable(['sub', 'sup'])
 *             .disable('smartquotes');
 * ```
 **/ $2e9bbaae9d29e4e9$var$MarkdownIt.prototype.enable = function(list, ignoreInvalid) {
    var result = [];
    if (!Array.isArray(list)) list = [
        list
    ];
    [
        "core",
        "block",
        "inline"
    ].forEach(function(chain) {
        result = result.concat(this[chain].ruler.enable(list, true));
    }, this);
    result = result.concat(this.inline.ruler2.enable(list, true));
    var missed = list.filter(function(name) {
        return result.indexOf(name) < 0;
    });
    if (missed.length && !ignoreInvalid) throw new Error("MarkdownIt. Failed to enable unknown rule(s): " + missed);
    return this;
};
/** chainable
 * MarkdownIt.disable(list, ignoreInvalid)
 * - list (String|Array): rule name or list of rule names to disable.
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * The same as [[MarkdownIt.enable]], but turn specified rules off.
 **/ $2e9bbaae9d29e4e9$var$MarkdownIt.prototype.disable = function(list, ignoreInvalid) {
    var result = [];
    if (!Array.isArray(list)) list = [
        list
    ];
    [
        "core",
        "block",
        "inline"
    ].forEach(function(chain) {
        result = result.concat(this[chain].ruler.disable(list, true));
    }, this);
    result = result.concat(this.inline.ruler2.disable(list, true));
    var missed = list.filter(function(name) {
        return result.indexOf(name) < 0;
    });
    if (missed.length && !ignoreInvalid) throw new Error("MarkdownIt. Failed to disable unknown rule(s): " + missed);
    return this;
};
/** chainable
 * MarkdownIt.use(plugin, params)
 *
 * Load specified plugin with given params into current parser instance.
 * It's just a sugar to call `plugin(md, params)` with curring.
 *
 * ##### Example
 *
 * ```javascript
 * var iterator = require('markdown-it-for-inline');
 * var md = require('markdown-it')()
 *             .use(iterator, 'foo_replace', 'text', function (tokens, idx) {
 *               tokens[idx].content = tokens[idx].content.replace(/foo/g, 'bar');
 *             });
 * ```
 **/ $2e9bbaae9d29e4e9$var$MarkdownIt.prototype.use = function(plugin /*, params, ... */ ) {
    var args = [
        this
    ].concat(Array.prototype.slice.call(arguments, 1));
    plugin.apply(plugin, args);
    return this;
};
/** internal
 * MarkdownIt.parse(src, env) -> Array
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * Parse input string and return list of block tokens (special token type
 * "inline" will contain list of inline tokens). You should not call this
 * method directly, until you write custom renderer (for example, to produce
 * AST).
 *
 * `env` is used to pass data between "distributed" rules and return additional
 * metadata like reference info, needed for the renderer. It also can be used to
 * inject data in specific cases. Usually, you will be ok to pass `{}`,
 * and then pass updated object to renderer.
 **/ $2e9bbaae9d29e4e9$var$MarkdownIt.prototype.parse = function(src, env) {
    if (typeof src !== "string") throw new Error("Input data should be a String");
    var state = new this.core.State(src, this, env);
    this.core.process(state);
    return state.tokens;
};
/**
 * MarkdownIt.render(src [, env]) -> String
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * Render markdown string into html. It does all magic for you :).
 *
 * `env` can be used to inject additional metadata (`{}` by default).
 * But you will not need it with high probability. See also comment
 * in [[MarkdownIt.parse]].
 **/ $2e9bbaae9d29e4e9$var$MarkdownIt.prototype.render = function(src, env) {
    env = env || {};
    return this.renderer.render(this.parse(src, env), this.options, env);
};
/** internal
 * MarkdownIt.parseInline(src, env) -> Array
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * The same as [[MarkdownIt.parse]] but skip all block rules. It returns the
 * block tokens list with the single `inline` element, containing parsed inline
 * tokens in `children` property. Also updates `env` object.
 **/ $2e9bbaae9d29e4e9$var$MarkdownIt.prototype.parseInline = function(src, env) {
    var state = new this.core.State(src, this, env);
    state.inlineMode = true;
    this.core.process(state);
    return state.tokens;
};
/**
 * MarkdownIt.renderInline(src [, env]) -> String
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * Similar to [[MarkdownIt.render]] but for single paragraph content. Result
 * will NOT be wrapped into `<p>` tags.
 **/ $2e9bbaae9d29e4e9$var$MarkdownIt.prototype.renderInline = function(src, env) {
    env = env || {};
    return this.renderer.render(this.parseInline(src, env), this.options, env);
};
module.exports = $2e9bbaae9d29e4e9$var$MarkdownIt;

});
parcelRegister("cNF1f", function(module, exports) {

$parcel$export(module.exports, "lib", () => $9519e12d7df95113$export$16c08b91f883959a, (v) => $9519e12d7df95113$export$16c08b91f883959a = v);
$parcel$export(module.exports, "assign", () => $9519e12d7df95113$export$e6e34fd1f2686227, (v) => $9519e12d7df95113$export$e6e34fd1f2686227 = v);
$parcel$export(module.exports, "isString", () => $9519e12d7df95113$export$844ec244b1367d54, (v) => $9519e12d7df95113$export$844ec244b1367d54 = v);
$parcel$export(module.exports, "has", () => $9519e12d7df95113$export$a4f4bb6b1453fff5, (v) => $9519e12d7df95113$export$a4f4bb6b1453fff5 = v);
$parcel$export(module.exports, "unescapeMd", () => $9519e12d7df95113$export$5ccde1ea0c14bb03, (v) => $9519e12d7df95113$export$5ccde1ea0c14bb03 = v);
$parcel$export(module.exports, "unescapeAll", () => $9519e12d7df95113$export$db8a17c6655f7e2c, (v) => $9519e12d7df95113$export$db8a17c6655f7e2c = v);
$parcel$export(module.exports, "isValidEntityCode", () => $9519e12d7df95113$export$644a8f5b13b2a36d, (v) => $9519e12d7df95113$export$644a8f5b13b2a36d = v);
$parcel$export(module.exports, "fromCodePoint", () => $9519e12d7df95113$export$73bfc63873071f74, (v) => $9519e12d7df95113$export$73bfc63873071f74 = v);
$parcel$export(module.exports, "escapeHtml", () => $9519e12d7df95113$export$4cf11838cdc2a8a8, (v) => $9519e12d7df95113$export$4cf11838cdc2a8a8 = v);
$parcel$export(module.exports, "arrayReplaceAt", () => $9519e12d7df95113$export$f78478f71955b6bc, (v) => $9519e12d7df95113$export$f78478f71955b6bc = v);
$parcel$export(module.exports, "isSpace", () => $9519e12d7df95113$export$1d5ccafae59b4926, (v) => $9519e12d7df95113$export$1d5ccafae59b4926 = v);
$parcel$export(module.exports, "isWhiteSpace", () => $9519e12d7df95113$export$3c52dd84024ae72c, (v) => $9519e12d7df95113$export$3c52dd84024ae72c = v);
$parcel$export(module.exports, "isMdAsciiPunct", () => $9519e12d7df95113$export$829a0d33ae4e744, (v) => $9519e12d7df95113$export$829a0d33ae4e744 = v);
$parcel$export(module.exports, "isPunctChar", () => $9519e12d7df95113$export$4888a643af800fc1, (v) => $9519e12d7df95113$export$4888a643af800fc1 = v);
$parcel$export(module.exports, "escapeRE", () => $9519e12d7df95113$export$bc616c8f7dc20d5d, (v) => $9519e12d7df95113$export$bc616c8f7dc20d5d = v);
$parcel$export(module.exports, "normalizeReference", () => $9519e12d7df95113$export$20ef46802c8744b, (v) => $9519e12d7df95113$export$20ef46802c8744b = v);
// Utilities
//
////////////////////////////////////////////////////////////////////////////////
// Re-export libraries commonly used in both markdown-it and its plugins,
// so plugins won't have to depend on them explicitly, which reduces their
// bundled size (e.g. a browser build).
//
var $9519e12d7df95113$export$16c08b91f883959a;
var $9519e12d7df95113$export$e6e34fd1f2686227;
var $9519e12d7df95113$export$844ec244b1367d54;
var $9519e12d7df95113$export$a4f4bb6b1453fff5;
var $9519e12d7df95113$export$5ccde1ea0c14bb03;
var $9519e12d7df95113$export$db8a17c6655f7e2c;
var $9519e12d7df95113$export$644a8f5b13b2a36d;
var $9519e12d7df95113$export$73bfc63873071f74;
// exports.replaceEntities     = replaceEntities;
var $9519e12d7df95113$export$4cf11838cdc2a8a8;
var $9519e12d7df95113$export$f78478f71955b6bc;
var $9519e12d7df95113$export$1d5ccafae59b4926;
var $9519e12d7df95113$export$3c52dd84024ae72c;
var $9519e12d7df95113$export$829a0d33ae4e744;
var $9519e12d7df95113$export$4888a643af800fc1;
var $9519e12d7df95113$export$bc616c8f7dc20d5d;
var $9519e12d7df95113$export$20ef46802c8744b;
"use strict";
function $9519e12d7df95113$var$_class(obj) {
    return Object.prototype.toString.call(obj);
}
function $9519e12d7df95113$var$isString(obj) {
    return $9519e12d7df95113$var$_class(obj) === "[object String]";
}
var $9519e12d7df95113$var$_hasOwnProperty = Object.prototype.hasOwnProperty;
function $9519e12d7df95113$var$has(object, key) {
    return $9519e12d7df95113$var$_hasOwnProperty.call(object, key);
}
// Merge objects
//
function $9519e12d7df95113$var$assign(obj /*from1, from2, from3, ...*/ ) {
    var sources = Array.prototype.slice.call(arguments, 1);
    sources.forEach(function(source) {
        if (!source) return;
        if (typeof source !== "object") throw new TypeError(source + "must be object");
        Object.keys(source).forEach(function(key) {
            obj[key] = source[key];
        });
    });
    return obj;
}
// Remove element from array and put another array at those position.
// Useful for some operations with tokens
function $9519e12d7df95113$var$arrayReplaceAt(src, pos, newElements) {
    return [].concat(src.slice(0, pos), newElements, src.slice(pos + 1));
}
////////////////////////////////////////////////////////////////////////////////
function $9519e12d7df95113$var$isValidEntityCode(c) {
    /*eslint no-bitwise:0*/ // broken sequence
    if (c >= 0xD800 && c <= 0xDFFF) return false;
    // never used
    if (c >= 0xFDD0 && c <= 0xFDEF) return false;
    if ((c & 0xFFFF) === 0xFFFF || (c & 0xFFFF) === 0xFFFE) return false;
    // control codes
    if (c >= 0x00 && c <= 0x08) return false;
    if (c === 0x0B) return false;
    if (c >= 0x0E && c <= 0x1F) return false;
    if (c >= 0x7F && c <= 0x9F) return false;
    // out of range
    if (c > 0x10FFFF) return false;
    return true;
}
function $9519e12d7df95113$var$fromCodePoint(c) {
    /*eslint no-bitwise:0*/ if (c > 0xffff) {
        c -= 0x10000;
        var surrogate1 = 0xd800 + (c >> 10), surrogate2 = 0xdc00 + (c & 0x3ff);
        return String.fromCharCode(surrogate1, surrogate2);
    }
    return String.fromCharCode(c);
}
var $9519e12d7df95113$var$UNESCAPE_MD_RE = /\\([!"#$%&'()*+,\-.\/:;<=>?@[\\\]^_`{|}~])/g;
var $9519e12d7df95113$var$ENTITY_RE = /&([a-z#][a-z0-9]{1,31});/gi;
var $9519e12d7df95113$var$UNESCAPE_ALL_RE = new RegExp($9519e12d7df95113$var$UNESCAPE_MD_RE.source + "|" + $9519e12d7df95113$var$ENTITY_RE.source, "gi");
var $9519e12d7df95113$var$DIGITAL_ENTITY_TEST_RE = /^#((?:x[a-f0-9]{1,8}|[0-9]{1,8}))/i;

var $7fxX9 = parcelRequire("7fxX9");
function $9519e12d7df95113$var$replaceEntityPattern(match, name) {
    var code = 0;
    if ($9519e12d7df95113$var$has($7fxX9, name)) return $7fxX9[name];
    if (name.charCodeAt(0) === 0x23 /* # */  && $9519e12d7df95113$var$DIGITAL_ENTITY_TEST_RE.test(name)) {
        code = name[1].toLowerCase() === "x" ? parseInt(name.slice(2), 16) : parseInt(name.slice(1), 10);
        if ($9519e12d7df95113$var$isValidEntityCode(code)) return $9519e12d7df95113$var$fromCodePoint(code);
    }
    return match;
}
/*function replaceEntities(str) {
  if (str.indexOf('&') < 0) { return str; }

  return str.replace(ENTITY_RE, replaceEntityPattern);
}*/ function $9519e12d7df95113$var$unescapeMd(str) {
    if (str.indexOf("\\") < 0) return str;
    return str.replace($9519e12d7df95113$var$UNESCAPE_MD_RE, "$1");
}
function $9519e12d7df95113$var$unescapeAll(str) {
    if (str.indexOf("\\") < 0 && str.indexOf("&") < 0) return str;
    return str.replace($9519e12d7df95113$var$UNESCAPE_ALL_RE, function(match, escaped, entity) {
        if (escaped) return escaped;
        return $9519e12d7df95113$var$replaceEntityPattern(match, entity);
    });
}
////////////////////////////////////////////////////////////////////////////////
var $9519e12d7df95113$var$HTML_ESCAPE_TEST_RE = /[&<>"]/;
var $9519e12d7df95113$var$HTML_ESCAPE_REPLACE_RE = /[&<>"]/g;
var $9519e12d7df95113$var$HTML_REPLACEMENTS = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;"
};
function $9519e12d7df95113$var$replaceUnsafeChar(ch) {
    return $9519e12d7df95113$var$HTML_REPLACEMENTS[ch];
}
function $9519e12d7df95113$var$escapeHtml(str) {
    if ($9519e12d7df95113$var$HTML_ESCAPE_TEST_RE.test(str)) return str.replace($9519e12d7df95113$var$HTML_ESCAPE_REPLACE_RE, $9519e12d7df95113$var$replaceUnsafeChar);
    return str;
}
////////////////////////////////////////////////////////////////////////////////
var $9519e12d7df95113$var$REGEXP_ESCAPE_RE = /[.?*+^$[\]\\(){}|-]/g;
function $9519e12d7df95113$var$escapeRE(str) {
    return str.replace($9519e12d7df95113$var$REGEXP_ESCAPE_RE, "\\$&");
}
////////////////////////////////////////////////////////////////////////////////
function $9519e12d7df95113$var$isSpace(code) {
    switch(code){
        case 0x09:
        case 0x20:
            return true;
    }
    return false;
}
// Zs (unicode class) || [\t\f\v\r\n]
function $9519e12d7df95113$var$isWhiteSpace(code) {
    if (code >= 0x2000 && code <= 0x200A) return true;
    switch(code){
        case 0x09:
        case 0x0A:
        case 0x0B:
        case 0x0C:
        case 0x0D:
        case 0x20:
        case 0xA0:
        case 0x1680:
        case 0x202F:
        case 0x205F:
        case 0x3000:
            return true;
    }
    return false;
}

var $hKVfa = parcelRequire("hKVfa");
// Currently without astral characters support.
function $9519e12d7df95113$var$isPunctChar(ch) {
    return $hKVfa.test(ch);
}
// Markdown ASCII punctuation characters.
//
// !, ", #, $, %, &, ', (, ), *, +, ,, -, ., /, :, ;, <, =, >, ?, @, [, \, ], ^, _, `, {, |, }, or ~
// http://spec.commonmark.org/0.15/#ascii-punctuation-character
//
// Don't confuse with unicode punctuation !!! It lacks some chars in ascii range.
//
function $9519e12d7df95113$var$isMdAsciiPunct(ch) {
    switch(ch){
        case 0x21 /* ! */ :
        case 0x22 /* " */ :
        case 0x23 /* # */ :
        case 0x24 /* $ */ :
        case 0x25 /* % */ :
        case 0x26 /* & */ :
        case 0x27 /* ' */ :
        case 0x28 /* ( */ :
        case 0x29 /* ) */ :
        case 0x2A /* * */ :
        case 0x2B /* + */ :
        case 0x2C /* , */ :
        case 0x2D /* - */ :
        case 0x2E /* . */ :
        case 0x2F /* / */ :
        case 0x3A /* : */ :
        case 0x3B /* ; */ :
        case 0x3C /* < */ :
        case 0x3D /* = */ :
        case 0x3E /* > */ :
        case 0x3F /* ? */ :
        case 0x40 /* @ */ :
        case 0x5B /* [ */ :
        case 0x5C /* \ */ :
        case 0x5D /* ] */ :
        case 0x5E /* ^ */ :
        case 0x5F /* _ */ :
        case 0x60 /* ` */ :
        case 0x7B /* { */ :
        case 0x7C /* | */ :
        case 0x7D /* } */ :
        case 0x7E /* ~ */ :
            return true;
        default:
            return false;
    }
}
// Hepler to unify [reference labels].
//
function $9519e12d7df95113$var$normalizeReference(str) {
    // Trim and collapse whitespace
    //
    str = str.trim().replace(/\s+/g, " ");
    // In node v10 'ẞ'.toLowerCase() === 'Ṿ', which is presumed to be a bug
    // fixed in v12 (couldn't find any details).
    //
    // So treat this one as a special case
    // (remove this when node v10 is no longer supported).
    //
    if ("\u1E9E".toLowerCase() === "\u1E7E") str = str.replace(/ẞ/g, "\xdf");
    // .toLowerCase().toUpperCase() should get rid of all differences
    // between letter variants.
    //
    // Simple .toLowerCase() doesn't normalize 125 code points correctly,
    // and .toUpperCase doesn't normalize 6 of them (list of exceptions:
    // İ, ϴ, ẞ, Ω, K, Å - those are already uppercased, but have differently
    // uppercased versions).
    //
    // Here's an example showing how it happens. Lets take greek letter omega:
    // uppercase U+0398 (Θ), U+03f4 (ϴ) and lowercase U+03b8 (θ), U+03d1 (ϑ)
    //
    // Unicode entries:
    // 0398;GREEK CAPITAL LETTER THETA;Lu;0;L;;;;;N;;;;03B8;
    // 03B8;GREEK SMALL LETTER THETA;Ll;0;L;;;;;N;;;0398;;0398
    // 03D1;GREEK THETA SYMBOL;Ll;0;L;<compat> 03B8;;;;N;GREEK SMALL LETTER SCRIPT THETA;;0398;;0398
    // 03F4;GREEK CAPITAL THETA SYMBOL;Lu;0;L;<compat> 0398;;;;N;;;;03B8;
    //
    // Case-insensitive comparison should treat all of them as equivalent.
    //
    // But .toLowerCase() doesn't change ϑ (it's already lowercase),
    // and .toUpperCase() doesn't change ϴ (already uppercase).
    //
    // Applying first lower then upper case normalizes any character:
    // '\u0398\u03f4\u03b8\u03d1'.toLowerCase().toUpperCase() === '\u0398\u0398\u0398\u0398'
    //
    // Note: this is equivalent to unicode case folding; unicode normalization
    // is a different step that is not required here.
    //
    // Final result should be uppercased, because it's later stored in an object
    // (this avoid a conflict with Object.prototype members,
    // most notably, `__proto__`)
    //
    return str.toLowerCase().toUpperCase();
}
$9519e12d7df95113$export$16c08b91f883959a = {};

$9519e12d7df95113$export$16c08b91f883959a.mdurl = (parcelRequire("9l2bS"));

$9519e12d7df95113$export$16c08b91f883959a.ucmicro = (parcelRequire("e4cqX"));
$9519e12d7df95113$export$e6e34fd1f2686227 = $9519e12d7df95113$var$assign;
$9519e12d7df95113$export$844ec244b1367d54 = $9519e12d7df95113$var$isString;
$9519e12d7df95113$export$a4f4bb6b1453fff5 = $9519e12d7df95113$var$has;
$9519e12d7df95113$export$5ccde1ea0c14bb03 = $9519e12d7df95113$var$unescapeMd;
$9519e12d7df95113$export$db8a17c6655f7e2c = $9519e12d7df95113$var$unescapeAll;
$9519e12d7df95113$export$644a8f5b13b2a36d = $9519e12d7df95113$var$isValidEntityCode;
$9519e12d7df95113$export$73bfc63873071f74 = $9519e12d7df95113$var$fromCodePoint;
$9519e12d7df95113$export$4cf11838cdc2a8a8 = $9519e12d7df95113$var$escapeHtml;
$9519e12d7df95113$export$f78478f71955b6bc = $9519e12d7df95113$var$arrayReplaceAt;
$9519e12d7df95113$export$1d5ccafae59b4926 = $9519e12d7df95113$var$isSpace;
$9519e12d7df95113$export$3c52dd84024ae72c = $9519e12d7df95113$var$isWhiteSpace;
$9519e12d7df95113$export$829a0d33ae4e744 = $9519e12d7df95113$var$isMdAsciiPunct;
$9519e12d7df95113$export$4888a643af800fc1 = $9519e12d7df95113$var$isPunctChar;
$9519e12d7df95113$export$bc616c8f7dc20d5d = $9519e12d7df95113$var$escapeRE;
$9519e12d7df95113$export$20ef46802c8744b = $9519e12d7df95113$var$normalizeReference;

});
parcelRegister("7fxX9", function(module, exports) {
// HTML5 entities map: { name -> utf16string }
//
"use strict";

/*eslint quotes:0*/ module.exports = (parcelRequire("3x13G"));

});
parcelRegister("3x13G", function(module, exports) {
module.exports = JSON.parse('{"Aacute":"\xc1","aacute":"\xe1","Abreve":"\u0102","abreve":"\u0103","ac":"\u223E","acd":"\u223F","acE":"\u223E\u0333","Acirc":"\xc2","acirc":"\xe2","acute":"\xb4","Acy":"\u0410","acy":"\u0430","AElig":"\xc6","aelig":"\xe6","af":"\u2061","Afr":"\uD835\uDD04","afr":"\uD835\uDD1E","Agrave":"\xc0","agrave":"\xe0","alefsym":"\u2135","aleph":"\u2135","Alpha":"\u0391","alpha":"\u03B1","Amacr":"\u0100","amacr":"\u0101","amalg":"\u2A3F","amp":"&","AMP":"&","andand":"\u2A55","And":"\u2A53","and":"\u2227","andd":"\u2A5C","andslope":"\u2A58","andv":"\u2A5A","ang":"\u2220","ange":"\u29A4","angle":"\u2220","angmsdaa":"\u29A8","angmsdab":"\u29A9","angmsdac":"\u29AA","angmsdad":"\u29AB","angmsdae":"\u29AC","angmsdaf":"\u29AD","angmsdag":"\u29AE","angmsdah":"\u29AF","angmsd":"\u2221","angrt":"\u221F","angrtvb":"\u22BE","angrtvbd":"\u299D","angsph":"\u2222","angst":"\xc5","angzarr":"\u237C","Aogon":"\u0104","aogon":"\u0105","Aopf":"\uD835\uDD38","aopf":"\uD835\uDD52","apacir":"\u2A6F","ap":"\u2248","apE":"\u2A70","ape":"\u224A","apid":"\u224B","apos":"\'","ApplyFunction":"\u2061","approx":"\u2248","approxeq":"\u224A","Aring":"\xc5","aring":"\xe5","Ascr":"\uD835\uDC9C","ascr":"\uD835\uDCB6","Assign":"\u2254","ast":"*","asymp":"\u2248","asympeq":"\u224D","Atilde":"\xc3","atilde":"\xe3","Auml":"\xc4","auml":"\xe4","awconint":"\u2233","awint":"\u2A11","backcong":"\u224C","backepsilon":"\u03F6","backprime":"\u2035","backsim":"\u223D","backsimeq":"\u22CD","Backslash":"\u2216","Barv":"\u2AE7","barvee":"\u22BD","barwed":"\u2305","Barwed":"\u2306","barwedge":"\u2305","bbrk":"\u23B5","bbrktbrk":"\u23B6","bcong":"\u224C","Bcy":"\u0411","bcy":"\u0431","bdquo":"\u201E","becaus":"\u2235","because":"\u2235","Because":"\u2235","bemptyv":"\u29B0","bepsi":"\u03F6","bernou":"\u212C","Bernoullis":"\u212C","Beta":"\u0392","beta":"\u03B2","beth":"\u2136","between":"\u226C","Bfr":"\uD835\uDD05","bfr":"\uD835\uDD1F","bigcap":"\u22C2","bigcirc":"\u25EF","bigcup":"\u22C3","bigodot":"\u2A00","bigoplus":"\u2A01","bigotimes":"\u2A02","bigsqcup":"\u2A06","bigstar":"\u2605","bigtriangledown":"\u25BD","bigtriangleup":"\u25B3","biguplus":"\u2A04","bigvee":"\u22C1","bigwedge":"\u22C0","bkarow":"\u290D","blacklozenge":"\u29EB","blacksquare":"\u25AA","blacktriangle":"\u25B4","blacktriangledown":"\u25BE","blacktriangleleft":"\u25C2","blacktriangleright":"\u25B8","blank":"\u2423","blk12":"\u2592","blk14":"\u2591","blk34":"\u2593","block":"\u2588","bne":"=\u20E5","bnequiv":"\u2261\u20E5","bNot":"\u2AED","bnot":"\u2310","Bopf":"\uD835\uDD39","bopf":"\uD835\uDD53","bot":"\u22A5","bottom":"\u22A5","bowtie":"\u22C8","boxbox":"\u29C9","boxdl":"\u2510","boxdL":"\u2555","boxDl":"\u2556","boxDL":"\u2557","boxdr":"\u250C","boxdR":"\u2552","boxDr":"\u2553","boxDR":"\u2554","boxh":"\u2500","boxH":"\u2550","boxhd":"\u252C","boxHd":"\u2564","boxhD":"\u2565","boxHD":"\u2566","boxhu":"\u2534","boxHu":"\u2567","boxhU":"\u2568","boxHU":"\u2569","boxminus":"\u229F","boxplus":"\u229E","boxtimes":"\u22A0","boxul":"\u2518","boxuL":"\u255B","boxUl":"\u255C","boxUL":"\u255D","boxur":"\u2514","boxuR":"\u2558","boxUr":"\u2559","boxUR":"\u255A","boxv":"\u2502","boxV":"\u2551","boxvh":"\u253C","boxvH":"\u256A","boxVh":"\u256B","boxVH":"\u256C","boxvl":"\u2524","boxvL":"\u2561","boxVl":"\u2562","boxVL":"\u2563","boxvr":"\u251C","boxvR":"\u255E","boxVr":"\u255F","boxVR":"\u2560","bprime":"\u2035","breve":"\u02D8","Breve":"\u02D8","brvbar":"\xa6","bscr":"\uD835\uDCB7","Bscr":"\u212C","bsemi":"\u204F","bsim":"\u223D","bsime":"\u22CD","bsolb":"\u29C5","bsol":"\\\\","bsolhsub":"\u27C8","bull":"\u2022","bullet":"\u2022","bump":"\u224E","bumpE":"\u2AAE","bumpe":"\u224F","Bumpeq":"\u224E","bumpeq":"\u224F","Cacute":"\u0106","cacute":"\u0107","capand":"\u2A44","capbrcup":"\u2A49","capcap":"\u2A4B","cap":"\u2229","Cap":"\u22D2","capcup":"\u2A47","capdot":"\u2A40","CapitalDifferentialD":"\u2145","caps":"\u2229\uFE00","caret":"\u2041","caron":"\u02C7","Cayleys":"\u212D","ccaps":"\u2A4D","Ccaron":"\u010C","ccaron":"\u010D","Ccedil":"\xc7","ccedil":"\xe7","Ccirc":"\u0108","ccirc":"\u0109","Cconint":"\u2230","ccups":"\u2A4C","ccupssm":"\u2A50","Cdot":"\u010A","cdot":"\u010B","cedil":"\xb8","Cedilla":"\xb8","cemptyv":"\u29B2","cent":"\xa2","centerdot":"\xb7","CenterDot":"\xb7","cfr":"\uD835\uDD20","Cfr":"\u212D","CHcy":"\u0427","chcy":"\u0447","check":"\u2713","checkmark":"\u2713","Chi":"\u03A7","chi":"\u03C7","circ":"\u02C6","circeq":"\u2257","circlearrowleft":"\u21BA","circlearrowright":"\u21BB","circledast":"\u229B","circledcirc":"\u229A","circleddash":"\u229D","CircleDot":"\u2299","circledR":"\xae","circledS":"\u24C8","CircleMinus":"\u2296","CirclePlus":"\u2295","CircleTimes":"\u2297","cir":"\u25CB","cirE":"\u29C3","cire":"\u2257","cirfnint":"\u2A10","cirmid":"\u2AEF","cirscir":"\u29C2","ClockwiseContourIntegral":"\u2232","CloseCurlyDoubleQuote":"\u201D","CloseCurlyQuote":"\u2019","clubs":"\u2663","clubsuit":"\u2663","colon":":","Colon":"\u2237","Colone":"\u2A74","colone":"\u2254","coloneq":"\u2254","comma":",","commat":"@","comp":"\u2201","compfn":"\u2218","complement":"\u2201","complexes":"\u2102","cong":"\u2245","congdot":"\u2A6D","Congruent":"\u2261","conint":"\u222E","Conint":"\u222F","ContourIntegral":"\u222E","copf":"\uD835\uDD54","Copf":"\u2102","coprod":"\u2210","Coproduct":"\u2210","copy":"\xa9","COPY":"\xa9","copysr":"\u2117","CounterClockwiseContourIntegral":"\u2233","crarr":"\u21B5","cross":"\u2717","Cross":"\u2A2F","Cscr":"\uD835\uDC9E","cscr":"\uD835\uDCB8","csub":"\u2ACF","csube":"\u2AD1","csup":"\u2AD0","csupe":"\u2AD2","ctdot":"\u22EF","cudarrl":"\u2938","cudarrr":"\u2935","cuepr":"\u22DE","cuesc":"\u22DF","cularr":"\u21B6","cularrp":"\u293D","cupbrcap":"\u2A48","cupcap":"\u2A46","CupCap":"\u224D","cup":"\u222A","Cup":"\u22D3","cupcup":"\u2A4A","cupdot":"\u228D","cupor":"\u2A45","cups":"\u222A\uFE00","curarr":"\u21B7","curarrm":"\u293C","curlyeqprec":"\u22DE","curlyeqsucc":"\u22DF","curlyvee":"\u22CE","curlywedge":"\u22CF","curren":"\xa4","curvearrowleft":"\u21B6","curvearrowright":"\u21B7","cuvee":"\u22CE","cuwed":"\u22CF","cwconint":"\u2232","cwint":"\u2231","cylcty":"\u232D","dagger":"\u2020","Dagger":"\u2021","daleth":"\u2138","darr":"\u2193","Darr":"\u21A1","dArr":"\u21D3","dash":"\u2010","Dashv":"\u2AE4","dashv":"\u22A3","dbkarow":"\u290F","dblac":"\u02DD","Dcaron":"\u010E","dcaron":"\u010F","Dcy":"\u0414","dcy":"\u0434","ddagger":"\u2021","ddarr":"\u21CA","DD":"\u2145","dd":"\u2146","DDotrahd":"\u2911","ddotseq":"\u2A77","deg":"\xb0","Del":"\u2207","Delta":"\u0394","delta":"\u03B4","demptyv":"\u29B1","dfisht":"\u297F","Dfr":"\uD835\uDD07","dfr":"\uD835\uDD21","dHar":"\u2965","dharl":"\u21C3","dharr":"\u21C2","DiacriticalAcute":"\xb4","DiacriticalDot":"\u02D9","DiacriticalDoubleAcute":"\u02DD","DiacriticalGrave":"`","DiacriticalTilde":"\u02DC","diam":"\u22C4","diamond":"\u22C4","Diamond":"\u22C4","diamondsuit":"\u2666","diams":"\u2666","die":"\xa8","DifferentialD":"\u2146","digamma":"\u03DD","disin":"\u22F2","div":"\xf7","divide":"\xf7","divideontimes":"\u22C7","divonx":"\u22C7","DJcy":"\u0402","djcy":"\u0452","dlcorn":"\u231E","dlcrop":"\u230D","dollar":"$","Dopf":"\uD835\uDD3B","dopf":"\uD835\uDD55","Dot":"\xa8","dot":"\u02D9","DotDot":"\u20DC","doteq":"\u2250","doteqdot":"\u2251","DotEqual":"\u2250","dotminus":"\u2238","dotplus":"\u2214","dotsquare":"\u22A1","doublebarwedge":"\u2306","DoubleContourIntegral":"\u222F","DoubleDot":"\xa8","DoubleDownArrow":"\u21D3","DoubleLeftArrow":"\u21D0","DoubleLeftRightArrow":"\u21D4","DoubleLeftTee":"\u2AE4","DoubleLongLeftArrow":"\u27F8","DoubleLongLeftRightArrow":"\u27FA","DoubleLongRightArrow":"\u27F9","DoubleRightArrow":"\u21D2","DoubleRightTee":"\u22A8","DoubleUpArrow":"\u21D1","DoubleUpDownArrow":"\u21D5","DoubleVerticalBar":"\u2225","DownArrowBar":"\u2913","downarrow":"\u2193","DownArrow":"\u2193","Downarrow":"\u21D3","DownArrowUpArrow":"\u21F5","DownBreve":"\u0311","downdownarrows":"\u21CA","downharpoonleft":"\u21C3","downharpoonright":"\u21C2","DownLeftRightVector":"\u2950","DownLeftTeeVector":"\u295E","DownLeftVectorBar":"\u2956","DownLeftVector":"\u21BD","DownRightTeeVector":"\u295F","DownRightVectorBar":"\u2957","DownRightVector":"\u21C1","DownTeeArrow":"\u21A7","DownTee":"\u22A4","drbkarow":"\u2910","drcorn":"\u231F","drcrop":"\u230C","Dscr":"\uD835\uDC9F","dscr":"\uD835\uDCB9","DScy":"\u0405","dscy":"\u0455","dsol":"\u29F6","Dstrok":"\u0110","dstrok":"\u0111","dtdot":"\u22F1","dtri":"\u25BF","dtrif":"\u25BE","duarr":"\u21F5","duhar":"\u296F","dwangle":"\u29A6","DZcy":"\u040F","dzcy":"\u045F","dzigrarr":"\u27FF","Eacute":"\xc9","eacute":"\xe9","easter":"\u2A6E","Ecaron":"\u011A","ecaron":"\u011B","Ecirc":"\xca","ecirc":"\xea","ecir":"\u2256","ecolon":"\u2255","Ecy":"\u042D","ecy":"\u044D","eDDot":"\u2A77","Edot":"\u0116","edot":"\u0117","eDot":"\u2251","ee":"\u2147","efDot":"\u2252","Efr":"\uD835\uDD08","efr":"\uD835\uDD22","eg":"\u2A9A","Egrave":"\xc8","egrave":"\xe8","egs":"\u2A96","egsdot":"\u2A98","el":"\u2A99","Element":"\u2208","elinters":"\u23E7","ell":"\u2113","els":"\u2A95","elsdot":"\u2A97","Emacr":"\u0112","emacr":"\u0113","empty":"\u2205","emptyset":"\u2205","EmptySmallSquare":"\u25FB","emptyv":"\u2205","EmptyVerySmallSquare":"\u25AB","emsp13":"\u2004","emsp14":"\u2005","emsp":"\u2003","ENG":"\u014A","eng":"\u014B","ensp":"\u2002","Eogon":"\u0118","eogon":"\u0119","Eopf":"\uD835\uDD3C","eopf":"\uD835\uDD56","epar":"\u22D5","eparsl":"\u29E3","eplus":"\u2A71","epsi":"\u03B5","Epsilon":"\u0395","epsilon":"\u03B5","epsiv":"\u03F5","eqcirc":"\u2256","eqcolon":"\u2255","eqsim":"\u2242","eqslantgtr":"\u2A96","eqslantless":"\u2A95","Equal":"\u2A75","equals":"=","EqualTilde":"\u2242","equest":"\u225F","Equilibrium":"\u21CC","equiv":"\u2261","equivDD":"\u2A78","eqvparsl":"\u29E5","erarr":"\u2971","erDot":"\u2253","escr":"\u212F","Escr":"\u2130","esdot":"\u2250","Esim":"\u2A73","esim":"\u2242","Eta":"\u0397","eta":"\u03B7","ETH":"\xd0","eth":"\xf0","Euml":"\xcb","euml":"\xeb","euro":"\u20AC","excl":"!","exist":"\u2203","Exists":"\u2203","expectation":"\u2130","exponentiale":"\u2147","ExponentialE":"\u2147","fallingdotseq":"\u2252","Fcy":"\u0424","fcy":"\u0444","female":"\u2640","ffilig":"\uFB03","fflig":"\uFB00","ffllig":"\uFB04","Ffr":"\uD835\uDD09","ffr":"\uD835\uDD23","filig":"\uFB01","FilledSmallSquare":"\u25FC","FilledVerySmallSquare":"\u25AA","fjlig":"fj","flat":"\u266D","fllig":"\uFB02","fltns":"\u25B1","fnof":"\u0192","Fopf":"\uD835\uDD3D","fopf":"\uD835\uDD57","forall":"\u2200","ForAll":"\u2200","fork":"\u22D4","forkv":"\u2AD9","Fouriertrf":"\u2131","fpartint":"\u2A0D","frac12":"\xbd","frac13":"\u2153","frac14":"\xbc","frac15":"\u2155","frac16":"\u2159","frac18":"\u215B","frac23":"\u2154","frac25":"\u2156","frac34":"\xbe","frac35":"\u2157","frac38":"\u215C","frac45":"\u2158","frac56":"\u215A","frac58":"\u215D","frac78":"\u215E","frasl":"\u2044","frown":"\u2322","fscr":"\uD835\uDCBB","Fscr":"\u2131","gacute":"\u01F5","Gamma":"\u0393","gamma":"\u03B3","Gammad":"\u03DC","gammad":"\u03DD","gap":"\u2A86","Gbreve":"\u011E","gbreve":"\u011F","Gcedil":"\u0122","Gcirc":"\u011C","gcirc":"\u011D","Gcy":"\u0413","gcy":"\u0433","Gdot":"\u0120","gdot":"\u0121","ge":"\u2265","gE":"\u2267","gEl":"\u2A8C","gel":"\u22DB","geq":"\u2265","geqq":"\u2267","geqslant":"\u2A7E","gescc":"\u2AA9","ges":"\u2A7E","gesdot":"\u2A80","gesdoto":"\u2A82","gesdotol":"\u2A84","gesl":"\u22DB\uFE00","gesles":"\u2A94","Gfr":"\uD835\uDD0A","gfr":"\uD835\uDD24","gg":"\u226B","Gg":"\u22D9","ggg":"\u22D9","gimel":"\u2137","GJcy":"\u0403","gjcy":"\u0453","gla":"\u2AA5","gl":"\u2277","glE":"\u2A92","glj":"\u2AA4","gnap":"\u2A8A","gnapprox":"\u2A8A","gne":"\u2A88","gnE":"\u2269","gneq":"\u2A88","gneqq":"\u2269","gnsim":"\u22E7","Gopf":"\uD835\uDD3E","gopf":"\uD835\uDD58","grave":"`","GreaterEqual":"\u2265","GreaterEqualLess":"\u22DB","GreaterFullEqual":"\u2267","GreaterGreater":"\u2AA2","GreaterLess":"\u2277","GreaterSlantEqual":"\u2A7E","GreaterTilde":"\u2273","Gscr":"\uD835\uDCA2","gscr":"\u210A","gsim":"\u2273","gsime":"\u2A8E","gsiml":"\u2A90","gtcc":"\u2AA7","gtcir":"\u2A7A","gt":">","GT":">","Gt":"\u226B","gtdot":"\u22D7","gtlPar":"\u2995","gtquest":"\u2A7C","gtrapprox":"\u2A86","gtrarr":"\u2978","gtrdot":"\u22D7","gtreqless":"\u22DB","gtreqqless":"\u2A8C","gtrless":"\u2277","gtrsim":"\u2273","gvertneqq":"\u2269\uFE00","gvnE":"\u2269\uFE00","Hacek":"\u02C7","hairsp":"\u200A","half":"\xbd","hamilt":"\u210B","HARDcy":"\u042A","hardcy":"\u044A","harrcir":"\u2948","harr":"\u2194","hArr":"\u21D4","harrw":"\u21AD","Hat":"^","hbar":"\u210F","Hcirc":"\u0124","hcirc":"\u0125","hearts":"\u2665","heartsuit":"\u2665","hellip":"\u2026","hercon":"\u22B9","hfr":"\uD835\uDD25","Hfr":"\u210C","HilbertSpace":"\u210B","hksearow":"\u2925","hkswarow":"\u2926","hoarr":"\u21FF","homtht":"\u223B","hookleftarrow":"\u21A9","hookrightarrow":"\u21AA","hopf":"\uD835\uDD59","Hopf":"\u210D","horbar":"\u2015","HorizontalLine":"\u2500","hscr":"\uD835\uDCBD","Hscr":"\u210B","hslash":"\u210F","Hstrok":"\u0126","hstrok":"\u0127","HumpDownHump":"\u224E","HumpEqual":"\u224F","hybull":"\u2043","hyphen":"\u2010","Iacute":"\xcd","iacute":"\xed","ic":"\u2063","Icirc":"\xce","icirc":"\xee","Icy":"\u0418","icy":"\u0438","Idot":"\u0130","IEcy":"\u0415","iecy":"\u0435","iexcl":"\xa1","iff":"\u21D4","ifr":"\uD835\uDD26","Ifr":"\u2111","Igrave":"\xcc","igrave":"\xec","ii":"\u2148","iiiint":"\u2A0C","iiint":"\u222D","iinfin":"\u29DC","iiota":"\u2129","IJlig":"\u0132","ijlig":"\u0133","Imacr":"\u012A","imacr":"\u012B","image":"\u2111","ImaginaryI":"\u2148","imagline":"\u2110","imagpart":"\u2111","imath":"\u0131","Im":"\u2111","imof":"\u22B7","imped":"\u01B5","Implies":"\u21D2","incare":"\u2105","in":"\u2208","infin":"\u221E","infintie":"\u29DD","inodot":"\u0131","intcal":"\u22BA","int":"\u222B","Int":"\u222C","integers":"\u2124","Integral":"\u222B","intercal":"\u22BA","Intersection":"\u22C2","intlarhk":"\u2A17","intprod":"\u2A3C","InvisibleComma":"\u2063","InvisibleTimes":"\u2062","IOcy":"\u0401","iocy":"\u0451","Iogon":"\u012E","iogon":"\u012F","Iopf":"\uD835\uDD40","iopf":"\uD835\uDD5A","Iota":"\u0399","iota":"\u03B9","iprod":"\u2A3C","iquest":"\xbf","iscr":"\uD835\uDCBE","Iscr":"\u2110","isin":"\u2208","isindot":"\u22F5","isinE":"\u22F9","isins":"\u22F4","isinsv":"\u22F3","isinv":"\u2208","it":"\u2062","Itilde":"\u0128","itilde":"\u0129","Iukcy":"\u0406","iukcy":"\u0456","Iuml":"\xcf","iuml":"\xef","Jcirc":"\u0134","jcirc":"\u0135","Jcy":"\u0419","jcy":"\u0439","Jfr":"\uD835\uDD0D","jfr":"\uD835\uDD27","jmath":"\u0237","Jopf":"\uD835\uDD41","jopf":"\uD835\uDD5B","Jscr":"\uD835\uDCA5","jscr":"\uD835\uDCBF","Jsercy":"\u0408","jsercy":"\u0458","Jukcy":"\u0404","jukcy":"\u0454","Kappa":"\u039A","kappa":"\u03BA","kappav":"\u03F0","Kcedil":"\u0136","kcedil":"\u0137","Kcy":"\u041A","kcy":"\u043A","Kfr":"\uD835\uDD0E","kfr":"\uD835\uDD28","kgreen":"\u0138","KHcy":"\u0425","khcy":"\u0445","KJcy":"\u040C","kjcy":"\u045C","Kopf":"\uD835\uDD42","kopf":"\uD835\uDD5C","Kscr":"\uD835\uDCA6","kscr":"\uD835\uDCC0","lAarr":"\u21DA","Lacute":"\u0139","lacute":"\u013A","laemptyv":"\u29B4","lagran":"\u2112","Lambda":"\u039B","lambda":"\u03BB","lang":"\u27E8","Lang":"\u27EA","langd":"\u2991","langle":"\u27E8","lap":"\u2A85","Laplacetrf":"\u2112","laquo":"\xab","larrb":"\u21E4","larrbfs":"\u291F","larr":"\u2190","Larr":"\u219E","lArr":"\u21D0","larrfs":"\u291D","larrhk":"\u21A9","larrlp":"\u21AB","larrpl":"\u2939","larrsim":"\u2973","larrtl":"\u21A2","latail":"\u2919","lAtail":"\u291B","lat":"\u2AAB","late":"\u2AAD","lates":"\u2AAD\uFE00","lbarr":"\u290C","lBarr":"\u290E","lbbrk":"\u2772","lbrace":"{","lbrack":"[","lbrke":"\u298B","lbrksld":"\u298F","lbrkslu":"\u298D","Lcaron":"\u013D","lcaron":"\u013E","Lcedil":"\u013B","lcedil":"\u013C","lceil":"\u2308","lcub":"{","Lcy":"\u041B","lcy":"\u043B","ldca":"\u2936","ldquo":"\u201C","ldquor":"\u201E","ldrdhar":"\u2967","ldrushar":"\u294B","ldsh":"\u21B2","le":"\u2264","lE":"\u2266","LeftAngleBracket":"\u27E8","LeftArrowBar":"\u21E4","leftarrow":"\u2190","LeftArrow":"\u2190","Leftarrow":"\u21D0","LeftArrowRightArrow":"\u21C6","leftarrowtail":"\u21A2","LeftCeiling":"\u2308","LeftDoubleBracket":"\u27E6","LeftDownTeeVector":"\u2961","LeftDownVectorBar":"\u2959","LeftDownVector":"\u21C3","LeftFloor":"\u230A","leftharpoondown":"\u21BD","leftharpoonup":"\u21BC","leftleftarrows":"\u21C7","leftrightarrow":"\u2194","LeftRightArrow":"\u2194","Leftrightarrow":"\u21D4","leftrightarrows":"\u21C6","leftrightharpoons":"\u21CB","leftrightsquigarrow":"\u21AD","LeftRightVector":"\u294E","LeftTeeArrow":"\u21A4","LeftTee":"\u22A3","LeftTeeVector":"\u295A","leftthreetimes":"\u22CB","LeftTriangleBar":"\u29CF","LeftTriangle":"\u22B2","LeftTriangleEqual":"\u22B4","LeftUpDownVector":"\u2951","LeftUpTeeVector":"\u2960","LeftUpVectorBar":"\u2958","LeftUpVector":"\u21BF","LeftVectorBar":"\u2952","LeftVector":"\u21BC","lEg":"\u2A8B","leg":"\u22DA","leq":"\u2264","leqq":"\u2266","leqslant":"\u2A7D","lescc":"\u2AA8","les":"\u2A7D","lesdot":"\u2A7F","lesdoto":"\u2A81","lesdotor":"\u2A83","lesg":"\u22DA\uFE00","lesges":"\u2A93","lessapprox":"\u2A85","lessdot":"\u22D6","lesseqgtr":"\u22DA","lesseqqgtr":"\u2A8B","LessEqualGreater":"\u22DA","LessFullEqual":"\u2266","LessGreater":"\u2276","lessgtr":"\u2276","LessLess":"\u2AA1","lesssim":"\u2272","LessSlantEqual":"\u2A7D","LessTilde":"\u2272","lfisht":"\u297C","lfloor":"\u230A","Lfr":"\uD835\uDD0F","lfr":"\uD835\uDD29","lg":"\u2276","lgE":"\u2A91","lHar":"\u2962","lhard":"\u21BD","lharu":"\u21BC","lharul":"\u296A","lhblk":"\u2584","LJcy":"\u0409","ljcy":"\u0459","llarr":"\u21C7","ll":"\u226A","Ll":"\u22D8","llcorner":"\u231E","Lleftarrow":"\u21DA","llhard":"\u296B","lltri":"\u25FA","Lmidot":"\u013F","lmidot":"\u0140","lmoustache":"\u23B0","lmoust":"\u23B0","lnap":"\u2A89","lnapprox":"\u2A89","lne":"\u2A87","lnE":"\u2268","lneq":"\u2A87","lneqq":"\u2268","lnsim":"\u22E6","loang":"\u27EC","loarr":"\u21FD","lobrk":"\u27E6","longleftarrow":"\u27F5","LongLeftArrow":"\u27F5","Longleftarrow":"\u27F8","longleftrightarrow":"\u27F7","LongLeftRightArrow":"\u27F7","Longleftrightarrow":"\u27FA","longmapsto":"\u27FC","longrightarrow":"\u27F6","LongRightArrow":"\u27F6","Longrightarrow":"\u27F9","looparrowleft":"\u21AB","looparrowright":"\u21AC","lopar":"\u2985","Lopf":"\uD835\uDD43","lopf":"\uD835\uDD5D","loplus":"\u2A2D","lotimes":"\u2A34","lowast":"\u2217","lowbar":"_","LowerLeftArrow":"\u2199","LowerRightArrow":"\u2198","loz":"\u25CA","lozenge":"\u25CA","lozf":"\u29EB","lpar":"(","lparlt":"\u2993","lrarr":"\u21C6","lrcorner":"\u231F","lrhar":"\u21CB","lrhard":"\u296D","lrm":"\u200E","lrtri":"\u22BF","lsaquo":"\u2039","lscr":"\uD835\uDCC1","Lscr":"\u2112","lsh":"\u21B0","Lsh":"\u21B0","lsim":"\u2272","lsime":"\u2A8D","lsimg":"\u2A8F","lsqb":"[","lsquo":"\u2018","lsquor":"\u201A","Lstrok":"\u0141","lstrok":"\u0142","ltcc":"\u2AA6","ltcir":"\u2A79","lt":"<","LT":"<","Lt":"\u226A","ltdot":"\u22D6","lthree":"\u22CB","ltimes":"\u22C9","ltlarr":"\u2976","ltquest":"\u2A7B","ltri":"\u25C3","ltrie":"\u22B4","ltrif":"\u25C2","ltrPar":"\u2996","lurdshar":"\u294A","luruhar":"\u2966","lvertneqq":"\u2268\uFE00","lvnE":"\u2268\uFE00","macr":"\xaf","male":"\u2642","malt":"\u2720","maltese":"\u2720","Map":"\u2905","map":"\u21A6","mapsto":"\u21A6","mapstodown":"\u21A7","mapstoleft":"\u21A4","mapstoup":"\u21A5","marker":"\u25AE","mcomma":"\u2A29","Mcy":"\u041C","mcy":"\u043C","mdash":"\u2014","mDDot":"\u223A","measuredangle":"\u2221","MediumSpace":"\u205F","Mellintrf":"\u2133","Mfr":"\uD835\uDD10","mfr":"\uD835\uDD2A","mho":"\u2127","micro":"\xb5","midast":"*","midcir":"\u2AF0","mid":"\u2223","middot":"\xb7","minusb":"\u229F","minus":"\u2212","minusd":"\u2238","minusdu":"\u2A2A","MinusPlus":"\u2213","mlcp":"\u2ADB","mldr":"\u2026","mnplus":"\u2213","models":"\u22A7","Mopf":"\uD835\uDD44","mopf":"\uD835\uDD5E","mp":"\u2213","mscr":"\uD835\uDCC2","Mscr":"\u2133","mstpos":"\u223E","Mu":"\u039C","mu":"\u03BC","multimap":"\u22B8","mumap":"\u22B8","nabla":"\u2207","Nacute":"\u0143","nacute":"\u0144","nang":"\u2220\u20D2","nap":"\u2249","napE":"\u2A70\u0338","napid":"\u224B\u0338","napos":"\u0149","napprox":"\u2249","natural":"\u266E","naturals":"\u2115","natur":"\u266E","nbsp":"\xa0","nbump":"\u224E\u0338","nbumpe":"\u224F\u0338","ncap":"\u2A43","Ncaron":"\u0147","ncaron":"\u0148","Ncedil":"\u0145","ncedil":"\u0146","ncong":"\u2247","ncongdot":"\u2A6D\u0338","ncup":"\u2A42","Ncy":"\u041D","ncy":"\u043D","ndash":"\u2013","nearhk":"\u2924","nearr":"\u2197","neArr":"\u21D7","nearrow":"\u2197","ne":"\u2260","nedot":"\u2250\u0338","NegativeMediumSpace":"\u200B","NegativeThickSpace":"\u200B","NegativeThinSpace":"\u200B","NegativeVeryThinSpace":"\u200B","nequiv":"\u2262","nesear":"\u2928","nesim":"\u2242\u0338","NestedGreaterGreater":"\u226B","NestedLessLess":"\u226A","NewLine":"\\n","nexist":"\u2204","nexists":"\u2204","Nfr":"\uD835\uDD11","nfr":"\uD835\uDD2B","ngE":"\u2267\u0338","nge":"\u2271","ngeq":"\u2271","ngeqq":"\u2267\u0338","ngeqslant":"\u2A7E\u0338","nges":"\u2A7E\u0338","nGg":"\u22D9\u0338","ngsim":"\u2275","nGt":"\u226B\u20D2","ngt":"\u226F","ngtr":"\u226F","nGtv":"\u226B\u0338","nharr":"\u21AE","nhArr":"\u21CE","nhpar":"\u2AF2","ni":"\u220B","nis":"\u22FC","nisd":"\u22FA","niv":"\u220B","NJcy":"\u040A","njcy":"\u045A","nlarr":"\u219A","nlArr":"\u21CD","nldr":"\u2025","nlE":"\u2266\u0338","nle":"\u2270","nleftarrow":"\u219A","nLeftarrow":"\u21CD","nleftrightarrow":"\u21AE","nLeftrightarrow":"\u21CE","nleq":"\u2270","nleqq":"\u2266\u0338","nleqslant":"\u2A7D\u0338","nles":"\u2A7D\u0338","nless":"\u226E","nLl":"\u22D8\u0338","nlsim":"\u2274","nLt":"\u226A\u20D2","nlt":"\u226E","nltri":"\u22EA","nltrie":"\u22EC","nLtv":"\u226A\u0338","nmid":"\u2224","NoBreak":"\u2060","NonBreakingSpace":"\xa0","nopf":"\uD835\uDD5F","Nopf":"\u2115","Not":"\u2AEC","not":"\xac","NotCongruent":"\u2262","NotCupCap":"\u226D","NotDoubleVerticalBar":"\u2226","NotElement":"\u2209","NotEqual":"\u2260","NotEqualTilde":"\u2242\u0338","NotExists":"\u2204","NotGreater":"\u226F","NotGreaterEqual":"\u2271","NotGreaterFullEqual":"\u2267\u0338","NotGreaterGreater":"\u226B\u0338","NotGreaterLess":"\u2279","NotGreaterSlantEqual":"\u2A7E\u0338","NotGreaterTilde":"\u2275","NotHumpDownHump":"\u224E\u0338","NotHumpEqual":"\u224F\u0338","notin":"\u2209","notindot":"\u22F5\u0338","notinE":"\u22F9\u0338","notinva":"\u2209","notinvb":"\u22F7","notinvc":"\u22F6","NotLeftTriangleBar":"\u29CF\u0338","NotLeftTriangle":"\u22EA","NotLeftTriangleEqual":"\u22EC","NotLess":"\u226E","NotLessEqual":"\u2270","NotLessGreater":"\u2278","NotLessLess":"\u226A\u0338","NotLessSlantEqual":"\u2A7D\u0338","NotLessTilde":"\u2274","NotNestedGreaterGreater":"\u2AA2\u0338","NotNestedLessLess":"\u2AA1\u0338","notni":"\u220C","notniva":"\u220C","notnivb":"\u22FE","notnivc":"\u22FD","NotPrecedes":"\u2280","NotPrecedesEqual":"\u2AAF\u0338","NotPrecedesSlantEqual":"\u22E0","NotReverseElement":"\u220C","NotRightTriangleBar":"\u29D0\u0338","NotRightTriangle":"\u22EB","NotRightTriangleEqual":"\u22ED","NotSquareSubset":"\u228F\u0338","NotSquareSubsetEqual":"\u22E2","NotSquareSuperset":"\u2290\u0338","NotSquareSupersetEqual":"\u22E3","NotSubset":"\u2282\u20D2","NotSubsetEqual":"\u2288","NotSucceeds":"\u2281","NotSucceedsEqual":"\u2AB0\u0338","NotSucceedsSlantEqual":"\u22E1","NotSucceedsTilde":"\u227F\u0338","NotSuperset":"\u2283\u20D2","NotSupersetEqual":"\u2289","NotTilde":"\u2241","NotTildeEqual":"\u2244","NotTildeFullEqual":"\u2247","NotTildeTilde":"\u2249","NotVerticalBar":"\u2224","nparallel":"\u2226","npar":"\u2226","nparsl":"\u2AFD\u20E5","npart":"\u2202\u0338","npolint":"\u2A14","npr":"\u2280","nprcue":"\u22E0","nprec":"\u2280","npreceq":"\u2AAF\u0338","npre":"\u2AAF\u0338","nrarrc":"\u2933\u0338","nrarr":"\u219B","nrArr":"\u21CF","nrarrw":"\u219D\u0338","nrightarrow":"\u219B","nRightarrow":"\u21CF","nrtri":"\u22EB","nrtrie":"\u22ED","nsc":"\u2281","nsccue":"\u22E1","nsce":"\u2AB0\u0338","Nscr":"\uD835\uDCA9","nscr":"\uD835\uDCC3","nshortmid":"\u2224","nshortparallel":"\u2226","nsim":"\u2241","nsime":"\u2244","nsimeq":"\u2244","nsmid":"\u2224","nspar":"\u2226","nsqsube":"\u22E2","nsqsupe":"\u22E3","nsub":"\u2284","nsubE":"\u2AC5\u0338","nsube":"\u2288","nsubset":"\u2282\u20D2","nsubseteq":"\u2288","nsubseteqq":"\u2AC5\u0338","nsucc":"\u2281","nsucceq":"\u2AB0\u0338","nsup":"\u2285","nsupE":"\u2AC6\u0338","nsupe":"\u2289","nsupset":"\u2283\u20D2","nsupseteq":"\u2289","nsupseteqq":"\u2AC6\u0338","ntgl":"\u2279","Ntilde":"\xd1","ntilde":"\xf1","ntlg":"\u2278","ntriangleleft":"\u22EA","ntrianglelefteq":"\u22EC","ntriangleright":"\u22EB","ntrianglerighteq":"\u22ED","Nu":"\u039D","nu":"\u03BD","num":"#","numero":"\u2116","numsp":"\u2007","nvap":"\u224D\u20D2","nvdash":"\u22AC","nvDash":"\u22AD","nVdash":"\u22AE","nVDash":"\u22AF","nvge":"\u2265\u20D2","nvgt":">\u20D2","nvHarr":"\u2904","nvinfin":"\u29DE","nvlArr":"\u2902","nvle":"\u2264\u20D2","nvlt":"<\u20D2","nvltrie":"\u22B4\u20D2","nvrArr":"\u2903","nvrtrie":"\u22B5\u20D2","nvsim":"\u223C\u20D2","nwarhk":"\u2923","nwarr":"\u2196","nwArr":"\u21D6","nwarrow":"\u2196","nwnear":"\u2927","Oacute":"\xd3","oacute":"\xf3","oast":"\u229B","Ocirc":"\xd4","ocirc":"\xf4","ocir":"\u229A","Ocy":"\u041E","ocy":"\u043E","odash":"\u229D","Odblac":"\u0150","odblac":"\u0151","odiv":"\u2A38","odot":"\u2299","odsold":"\u29BC","OElig":"\u0152","oelig":"\u0153","ofcir":"\u29BF","Ofr":"\uD835\uDD12","ofr":"\uD835\uDD2C","ogon":"\u02DB","Ograve":"\xd2","ograve":"\xf2","ogt":"\u29C1","ohbar":"\u29B5","ohm":"\u03A9","oint":"\u222E","olarr":"\u21BA","olcir":"\u29BE","olcross":"\u29BB","oline":"\u203E","olt":"\u29C0","Omacr":"\u014C","omacr":"\u014D","Omega":"\u03A9","omega":"\u03C9","Omicron":"\u039F","omicron":"\u03BF","omid":"\u29B6","ominus":"\u2296","Oopf":"\uD835\uDD46","oopf":"\uD835\uDD60","opar":"\u29B7","OpenCurlyDoubleQuote":"\u201C","OpenCurlyQuote":"\u2018","operp":"\u29B9","oplus":"\u2295","orarr":"\u21BB","Or":"\u2A54","or":"\u2228","ord":"\u2A5D","order":"\u2134","orderof":"\u2134","ordf":"\xaa","ordm":"\xba","origof":"\u22B6","oror":"\u2A56","orslope":"\u2A57","orv":"\u2A5B","oS":"\u24C8","Oscr":"\uD835\uDCAA","oscr":"\u2134","Oslash":"\xd8","oslash":"\xf8","osol":"\u2298","Otilde":"\xd5","otilde":"\xf5","otimesas":"\u2A36","Otimes":"\u2A37","otimes":"\u2297","Ouml":"\xd6","ouml":"\xf6","ovbar":"\u233D","OverBar":"\u203E","OverBrace":"\u23DE","OverBracket":"\u23B4","OverParenthesis":"\u23DC","para":"\xb6","parallel":"\u2225","par":"\u2225","parsim":"\u2AF3","parsl":"\u2AFD","part":"\u2202","PartialD":"\u2202","Pcy":"\u041F","pcy":"\u043F","percnt":"%","period":".","permil":"\u2030","perp":"\u22A5","pertenk":"\u2031","Pfr":"\uD835\uDD13","pfr":"\uD835\uDD2D","Phi":"\u03A6","phi":"\u03C6","phiv":"\u03D5","phmmat":"\u2133","phone":"\u260E","Pi":"\u03A0","pi":"\u03C0","pitchfork":"\u22D4","piv":"\u03D6","planck":"\u210F","planckh":"\u210E","plankv":"\u210F","plusacir":"\u2A23","plusb":"\u229E","pluscir":"\u2A22","plus":"+","plusdo":"\u2214","plusdu":"\u2A25","pluse":"\u2A72","PlusMinus":"\xb1","plusmn":"\xb1","plussim":"\u2A26","plustwo":"\u2A27","pm":"\xb1","Poincareplane":"\u210C","pointint":"\u2A15","popf":"\uD835\uDD61","Popf":"\u2119","pound":"\xa3","prap":"\u2AB7","Pr":"\u2ABB","pr":"\u227A","prcue":"\u227C","precapprox":"\u2AB7","prec":"\u227A","preccurlyeq":"\u227C","Precedes":"\u227A","PrecedesEqual":"\u2AAF","PrecedesSlantEqual":"\u227C","PrecedesTilde":"\u227E","preceq":"\u2AAF","precnapprox":"\u2AB9","precneqq":"\u2AB5","precnsim":"\u22E8","pre":"\u2AAF","prE":"\u2AB3","precsim":"\u227E","prime":"\u2032","Prime":"\u2033","primes":"\u2119","prnap":"\u2AB9","prnE":"\u2AB5","prnsim":"\u22E8","prod":"\u220F","Product":"\u220F","profalar":"\u232E","profline":"\u2312","profsurf":"\u2313","prop":"\u221D","Proportional":"\u221D","Proportion":"\u2237","propto":"\u221D","prsim":"\u227E","prurel":"\u22B0","Pscr":"\uD835\uDCAB","pscr":"\uD835\uDCC5","Psi":"\u03A8","psi":"\u03C8","puncsp":"\u2008","Qfr":"\uD835\uDD14","qfr":"\uD835\uDD2E","qint":"\u2A0C","qopf":"\uD835\uDD62","Qopf":"\u211A","qprime":"\u2057","Qscr":"\uD835\uDCAC","qscr":"\uD835\uDCC6","quaternions":"\u210D","quatint":"\u2A16","quest":"?","questeq":"\u225F","quot":"\\"","QUOT":"\\"","rAarr":"\u21DB","race":"\u223D\u0331","Racute":"\u0154","racute":"\u0155","radic":"\u221A","raemptyv":"\u29B3","rang":"\u27E9","Rang":"\u27EB","rangd":"\u2992","range":"\u29A5","rangle":"\u27E9","raquo":"\xbb","rarrap":"\u2975","rarrb":"\u21E5","rarrbfs":"\u2920","rarrc":"\u2933","rarr":"\u2192","Rarr":"\u21A0","rArr":"\u21D2","rarrfs":"\u291E","rarrhk":"\u21AA","rarrlp":"\u21AC","rarrpl":"\u2945","rarrsim":"\u2974","Rarrtl":"\u2916","rarrtl":"\u21A3","rarrw":"\u219D","ratail":"\u291A","rAtail":"\u291C","ratio":"\u2236","rationals":"\u211A","rbarr":"\u290D","rBarr":"\u290F","RBarr":"\u2910","rbbrk":"\u2773","rbrace":"}","rbrack":"]","rbrke":"\u298C","rbrksld":"\u298E","rbrkslu":"\u2990","Rcaron":"\u0158","rcaron":"\u0159","Rcedil":"\u0156","rcedil":"\u0157","rceil":"\u2309","rcub":"}","Rcy":"\u0420","rcy":"\u0440","rdca":"\u2937","rdldhar":"\u2969","rdquo":"\u201D","rdquor":"\u201D","rdsh":"\u21B3","real":"\u211C","realine":"\u211B","realpart":"\u211C","reals":"\u211D","Re":"\u211C","rect":"\u25AD","reg":"\xae","REG":"\xae","ReverseElement":"\u220B","ReverseEquilibrium":"\u21CB","ReverseUpEquilibrium":"\u296F","rfisht":"\u297D","rfloor":"\u230B","rfr":"\uD835\uDD2F","Rfr":"\u211C","rHar":"\u2964","rhard":"\u21C1","rharu":"\u21C0","rharul":"\u296C","Rho":"\u03A1","rho":"\u03C1","rhov":"\u03F1","RightAngleBracket":"\u27E9","RightArrowBar":"\u21E5","rightarrow":"\u2192","RightArrow":"\u2192","Rightarrow":"\u21D2","RightArrowLeftArrow":"\u21C4","rightarrowtail":"\u21A3","RightCeiling":"\u2309","RightDoubleBracket":"\u27E7","RightDownTeeVector":"\u295D","RightDownVectorBar":"\u2955","RightDownVector":"\u21C2","RightFloor":"\u230B","rightharpoondown":"\u21C1","rightharpoonup":"\u21C0","rightleftarrows":"\u21C4","rightleftharpoons":"\u21CC","rightrightarrows":"\u21C9","rightsquigarrow":"\u219D","RightTeeArrow":"\u21A6","RightTee":"\u22A2","RightTeeVector":"\u295B","rightthreetimes":"\u22CC","RightTriangleBar":"\u29D0","RightTriangle":"\u22B3","RightTriangleEqual":"\u22B5","RightUpDownVector":"\u294F","RightUpTeeVector":"\u295C","RightUpVectorBar":"\u2954","RightUpVector":"\u21BE","RightVectorBar":"\u2953","RightVector":"\u21C0","ring":"\u02DA","risingdotseq":"\u2253","rlarr":"\u21C4","rlhar":"\u21CC","rlm":"\u200F","rmoustache":"\u23B1","rmoust":"\u23B1","rnmid":"\u2AEE","roang":"\u27ED","roarr":"\u21FE","robrk":"\u27E7","ropar":"\u2986","ropf":"\uD835\uDD63","Ropf":"\u211D","roplus":"\u2A2E","rotimes":"\u2A35","RoundImplies":"\u2970","rpar":")","rpargt":"\u2994","rppolint":"\u2A12","rrarr":"\u21C9","Rrightarrow":"\u21DB","rsaquo":"\u203A","rscr":"\uD835\uDCC7","Rscr":"\u211B","rsh":"\u21B1","Rsh":"\u21B1","rsqb":"]","rsquo":"\u2019","rsquor":"\u2019","rthree":"\u22CC","rtimes":"\u22CA","rtri":"\u25B9","rtrie":"\u22B5","rtrif":"\u25B8","rtriltri":"\u29CE","RuleDelayed":"\u29F4","ruluhar":"\u2968","rx":"\u211E","Sacute":"\u015A","sacute":"\u015B","sbquo":"\u201A","scap":"\u2AB8","Scaron":"\u0160","scaron":"\u0161","Sc":"\u2ABC","sc":"\u227B","sccue":"\u227D","sce":"\u2AB0","scE":"\u2AB4","Scedil":"\u015E","scedil":"\u015F","Scirc":"\u015C","scirc":"\u015D","scnap":"\u2ABA","scnE":"\u2AB6","scnsim":"\u22E9","scpolint":"\u2A13","scsim":"\u227F","Scy":"\u0421","scy":"\u0441","sdotb":"\u22A1","sdot":"\u22C5","sdote":"\u2A66","searhk":"\u2925","searr":"\u2198","seArr":"\u21D8","searrow":"\u2198","sect":"\xa7","semi":";","seswar":"\u2929","setminus":"\u2216","setmn":"\u2216","sext":"\u2736","Sfr":"\uD835\uDD16","sfr":"\uD835\uDD30","sfrown":"\u2322","sharp":"\u266F","SHCHcy":"\u0429","shchcy":"\u0449","SHcy":"\u0428","shcy":"\u0448","ShortDownArrow":"\u2193","ShortLeftArrow":"\u2190","shortmid":"\u2223","shortparallel":"\u2225","ShortRightArrow":"\u2192","ShortUpArrow":"\u2191","shy":"\xad","Sigma":"\u03A3","sigma":"\u03C3","sigmaf":"\u03C2","sigmav":"\u03C2","sim":"\u223C","simdot":"\u2A6A","sime":"\u2243","simeq":"\u2243","simg":"\u2A9E","simgE":"\u2AA0","siml":"\u2A9D","simlE":"\u2A9F","simne":"\u2246","simplus":"\u2A24","simrarr":"\u2972","slarr":"\u2190","SmallCircle":"\u2218","smallsetminus":"\u2216","smashp":"\u2A33","smeparsl":"\u29E4","smid":"\u2223","smile":"\u2323","smt":"\u2AAA","smte":"\u2AAC","smtes":"\u2AAC\uFE00","SOFTcy":"\u042C","softcy":"\u044C","solbar":"\u233F","solb":"\u29C4","sol":"/","Sopf":"\uD835\uDD4A","sopf":"\uD835\uDD64","spades":"\u2660","spadesuit":"\u2660","spar":"\u2225","sqcap":"\u2293","sqcaps":"\u2293\uFE00","sqcup":"\u2294","sqcups":"\u2294\uFE00","Sqrt":"\u221A","sqsub":"\u228F","sqsube":"\u2291","sqsubset":"\u228F","sqsubseteq":"\u2291","sqsup":"\u2290","sqsupe":"\u2292","sqsupset":"\u2290","sqsupseteq":"\u2292","square":"\u25A1","Square":"\u25A1","SquareIntersection":"\u2293","SquareSubset":"\u228F","SquareSubsetEqual":"\u2291","SquareSuperset":"\u2290","SquareSupersetEqual":"\u2292","SquareUnion":"\u2294","squarf":"\u25AA","squ":"\u25A1","squf":"\u25AA","srarr":"\u2192","Sscr":"\uD835\uDCAE","sscr":"\uD835\uDCC8","ssetmn":"\u2216","ssmile":"\u2323","sstarf":"\u22C6","Star":"\u22C6","star":"\u2606","starf":"\u2605","straightepsilon":"\u03F5","straightphi":"\u03D5","strns":"\xaf","sub":"\u2282","Sub":"\u22D0","subdot":"\u2ABD","subE":"\u2AC5","sube":"\u2286","subedot":"\u2AC3","submult":"\u2AC1","subnE":"\u2ACB","subne":"\u228A","subplus":"\u2ABF","subrarr":"\u2979","subset":"\u2282","Subset":"\u22D0","subseteq":"\u2286","subseteqq":"\u2AC5","SubsetEqual":"\u2286","subsetneq":"\u228A","subsetneqq":"\u2ACB","subsim":"\u2AC7","subsub":"\u2AD5","subsup":"\u2AD3","succapprox":"\u2AB8","succ":"\u227B","succcurlyeq":"\u227D","Succeeds":"\u227B","SucceedsEqual":"\u2AB0","SucceedsSlantEqual":"\u227D","SucceedsTilde":"\u227F","succeq":"\u2AB0","succnapprox":"\u2ABA","succneqq":"\u2AB6","succnsim":"\u22E9","succsim":"\u227F","SuchThat":"\u220B","sum":"\u2211","Sum":"\u2211","sung":"\u266A","sup1":"\xb9","sup2":"\xb2","sup3":"\xb3","sup":"\u2283","Sup":"\u22D1","supdot":"\u2ABE","supdsub":"\u2AD8","supE":"\u2AC6","supe":"\u2287","supedot":"\u2AC4","Superset":"\u2283","SupersetEqual":"\u2287","suphsol":"\u27C9","suphsub":"\u2AD7","suplarr":"\u297B","supmult":"\u2AC2","supnE":"\u2ACC","supne":"\u228B","supplus":"\u2AC0","supset":"\u2283","Supset":"\u22D1","supseteq":"\u2287","supseteqq":"\u2AC6","supsetneq":"\u228B","supsetneqq":"\u2ACC","supsim":"\u2AC8","supsub":"\u2AD4","supsup":"\u2AD6","swarhk":"\u2926","swarr":"\u2199","swArr":"\u21D9","swarrow":"\u2199","swnwar":"\u292A","szlig":"\xdf","Tab":"\\t","target":"\u2316","Tau":"\u03A4","tau":"\u03C4","tbrk":"\u23B4","Tcaron":"\u0164","tcaron":"\u0165","Tcedil":"\u0162","tcedil":"\u0163","Tcy":"\u0422","tcy":"\u0442","tdot":"\u20DB","telrec":"\u2315","Tfr":"\uD835\uDD17","tfr":"\uD835\uDD31","there4":"\u2234","therefore":"\u2234","Therefore":"\u2234","Theta":"\u0398","theta":"\u03B8","thetasym":"\u03D1","thetav":"\u03D1","thickapprox":"\u2248","thicksim":"\u223C","ThickSpace":"\u205F\u200A","ThinSpace":"\u2009","thinsp":"\u2009","thkap":"\u2248","thksim":"\u223C","THORN":"\xde","thorn":"\xfe","tilde":"\u02DC","Tilde":"\u223C","TildeEqual":"\u2243","TildeFullEqual":"\u2245","TildeTilde":"\u2248","timesbar":"\u2A31","timesb":"\u22A0","times":"\xd7","timesd":"\u2A30","tint":"\u222D","toea":"\u2928","topbot":"\u2336","topcir":"\u2AF1","top":"\u22A4","Topf":"\uD835\uDD4B","topf":"\uD835\uDD65","topfork":"\u2ADA","tosa":"\u2929","tprime":"\u2034","trade":"\u2122","TRADE":"\u2122","triangle":"\u25B5","triangledown":"\u25BF","triangleleft":"\u25C3","trianglelefteq":"\u22B4","triangleq":"\u225C","triangleright":"\u25B9","trianglerighteq":"\u22B5","tridot":"\u25EC","trie":"\u225C","triminus":"\u2A3A","TripleDot":"\u20DB","triplus":"\u2A39","trisb":"\u29CD","tritime":"\u2A3B","trpezium":"\u23E2","Tscr":"\uD835\uDCAF","tscr":"\uD835\uDCC9","TScy":"\u0426","tscy":"\u0446","TSHcy":"\u040B","tshcy":"\u045B","Tstrok":"\u0166","tstrok":"\u0167","twixt":"\u226C","twoheadleftarrow":"\u219E","twoheadrightarrow":"\u21A0","Uacute":"\xda","uacute":"\xfa","uarr":"\u2191","Uarr":"\u219F","uArr":"\u21D1","Uarrocir":"\u2949","Ubrcy":"\u040E","ubrcy":"\u045E","Ubreve":"\u016C","ubreve":"\u016D","Ucirc":"\xdb","ucirc":"\xfb","Ucy":"\u0423","ucy":"\u0443","udarr":"\u21C5","Udblac":"\u0170","udblac":"\u0171","udhar":"\u296E","ufisht":"\u297E","Ufr":"\uD835\uDD18","ufr":"\uD835\uDD32","Ugrave":"\xd9","ugrave":"\xf9","uHar":"\u2963","uharl":"\u21BF","uharr":"\u21BE","uhblk":"\u2580","ulcorn":"\u231C","ulcorner":"\u231C","ulcrop":"\u230F","ultri":"\u25F8","Umacr":"\u016A","umacr":"\u016B","uml":"\xa8","UnderBar":"_","UnderBrace":"\u23DF","UnderBracket":"\u23B5","UnderParenthesis":"\u23DD","Union":"\u22C3","UnionPlus":"\u228E","Uogon":"\u0172","uogon":"\u0173","Uopf":"\uD835\uDD4C","uopf":"\uD835\uDD66","UpArrowBar":"\u2912","uparrow":"\u2191","UpArrow":"\u2191","Uparrow":"\u21D1","UpArrowDownArrow":"\u21C5","updownarrow":"\u2195","UpDownArrow":"\u2195","Updownarrow":"\u21D5","UpEquilibrium":"\u296E","upharpoonleft":"\u21BF","upharpoonright":"\u21BE","uplus":"\u228E","UpperLeftArrow":"\u2196","UpperRightArrow":"\u2197","upsi":"\u03C5","Upsi":"\u03D2","upsih":"\u03D2","Upsilon":"\u03A5","upsilon":"\u03C5","UpTeeArrow":"\u21A5","UpTee":"\u22A5","upuparrows":"\u21C8","urcorn":"\u231D","urcorner":"\u231D","urcrop":"\u230E","Uring":"\u016E","uring":"\u016F","urtri":"\u25F9","Uscr":"\uD835\uDCB0","uscr":"\uD835\uDCCA","utdot":"\u22F0","Utilde":"\u0168","utilde":"\u0169","utri":"\u25B5","utrif":"\u25B4","uuarr":"\u21C8","Uuml":"\xdc","uuml":"\xfc","uwangle":"\u29A7","vangrt":"\u299C","varepsilon":"\u03F5","varkappa":"\u03F0","varnothing":"\u2205","varphi":"\u03D5","varpi":"\u03D6","varpropto":"\u221D","varr":"\u2195","vArr":"\u21D5","varrho":"\u03F1","varsigma":"\u03C2","varsubsetneq":"\u228A\uFE00","varsubsetneqq":"\u2ACB\uFE00","varsupsetneq":"\u228B\uFE00","varsupsetneqq":"\u2ACC\uFE00","vartheta":"\u03D1","vartriangleleft":"\u22B2","vartriangleright":"\u22B3","vBar":"\u2AE8","Vbar":"\u2AEB","vBarv":"\u2AE9","Vcy":"\u0412","vcy":"\u0432","vdash":"\u22A2","vDash":"\u22A8","Vdash":"\u22A9","VDash":"\u22AB","Vdashl":"\u2AE6","veebar":"\u22BB","vee":"\u2228","Vee":"\u22C1","veeeq":"\u225A","vellip":"\u22EE","verbar":"|","Verbar":"\u2016","vert":"|","Vert":"\u2016","VerticalBar":"\u2223","VerticalLine":"|","VerticalSeparator":"\u2758","VerticalTilde":"\u2240","VeryThinSpace":"\u200A","Vfr":"\uD835\uDD19","vfr":"\uD835\uDD33","vltri":"\u22B2","vnsub":"\u2282\u20D2","vnsup":"\u2283\u20D2","Vopf":"\uD835\uDD4D","vopf":"\uD835\uDD67","vprop":"\u221D","vrtri":"\u22B3","Vscr":"\uD835\uDCB1","vscr":"\uD835\uDCCB","vsubnE":"\u2ACB\uFE00","vsubne":"\u228A\uFE00","vsupnE":"\u2ACC\uFE00","vsupne":"\u228B\uFE00","Vvdash":"\u22AA","vzigzag":"\u299A","Wcirc":"\u0174","wcirc":"\u0175","wedbar":"\u2A5F","wedge":"\u2227","Wedge":"\u22C0","wedgeq":"\u2259","weierp":"\u2118","Wfr":"\uD835\uDD1A","wfr":"\uD835\uDD34","Wopf":"\uD835\uDD4E","wopf":"\uD835\uDD68","wp":"\u2118","wr":"\u2240","wreath":"\u2240","Wscr":"\uD835\uDCB2","wscr":"\uD835\uDCCC","xcap":"\u22C2","xcirc":"\u25EF","xcup":"\u22C3","xdtri":"\u25BD","Xfr":"\uD835\uDD1B","xfr":"\uD835\uDD35","xharr":"\u27F7","xhArr":"\u27FA","Xi":"\u039E","xi":"\u03BE","xlarr":"\u27F5","xlArr":"\u27F8","xmap":"\u27FC","xnis":"\u22FB","xodot":"\u2A00","Xopf":"\uD835\uDD4F","xopf":"\uD835\uDD69","xoplus":"\u2A01","xotime":"\u2A02","xrarr":"\u27F6","xrArr":"\u27F9","Xscr":"\uD835\uDCB3","xscr":"\uD835\uDCCD","xsqcup":"\u2A06","xuplus":"\u2A04","xutri":"\u25B3","xvee":"\u22C1","xwedge":"\u22C0","Yacute":"\xdd","yacute":"\xfd","YAcy":"\u042F","yacy":"\u044F","Ycirc":"\u0176","ycirc":"\u0177","Ycy":"\u042B","ycy":"\u044B","yen":"\xa5","Yfr":"\uD835\uDD1C","yfr":"\uD835\uDD36","YIcy":"\u0407","yicy":"\u0457","Yopf":"\uD835\uDD50","yopf":"\uD835\uDD6A","Yscr":"\uD835\uDCB4","yscr":"\uD835\uDCCE","YUcy":"\u042E","yucy":"\u044E","yuml":"\xff","Yuml":"\u0178","Zacute":"\u0179","zacute":"\u017A","Zcaron":"\u017D","zcaron":"\u017E","Zcy":"\u0417","zcy":"\u0437","Zdot":"\u017B","zdot":"\u017C","zeetrf":"\u2128","ZeroWidthSpace":"\u200B","Zeta":"\u0396","zeta":"\u03B6","zfr":"\uD835\uDD37","Zfr":"\u2128","ZHcy":"\u0416","zhcy":"\u0436","zigrarr":"\u21DD","zopf":"\uD835\uDD6B","Zopf":"\u2124","Zscr":"\uD835\uDCB5","zscr":"\uD835\uDCCF","zwj":"\u200D","zwnj":"\u200C"}');

});


parcelRegister("hKVfa", function(module, exports) {
module.exports = /[!-#%-\*,-\/:;\?@\[-\]_\{\}\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4E\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD803[\uDF55-\uDF59]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC8\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDF3C-\uDF3E]|\uD806[\uDC3B\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2]|\uD807[\uDC41-\uDC45\uDC70\uDC71\uDEF7\uDEF8]|\uD809[\uDC70-\uDC74]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD81B[\uDE97-\uDE9A]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]/;

});

parcelRegister("9l2bS", function(module, exports) {

$parcel$export(module.exports, "encode", () => $6cc7c638bd081c26$export$c564cdbbe6da493, (v) => $6cc7c638bd081c26$export$c564cdbbe6da493 = v);
$parcel$export(module.exports, "decode", () => $6cc7c638bd081c26$export$2f872c0f2117be69, (v) => $6cc7c638bd081c26$export$2f872c0f2117be69 = v);
$parcel$export(module.exports, "format", () => $6cc7c638bd081c26$export$d9468344d3651243, (v) => $6cc7c638bd081c26$export$d9468344d3651243 = v);
$parcel$export(module.exports, "parse", () => $6cc7c638bd081c26$export$98e6a39c04603d36, (v) => $6cc7c638bd081c26$export$98e6a39c04603d36 = v);
var $6cc7c638bd081c26$export$c564cdbbe6da493;
var $6cc7c638bd081c26$export$2f872c0f2117be69;
var $6cc7c638bd081c26$export$d9468344d3651243;
var $6cc7c638bd081c26$export$98e6a39c04603d36;
"use strict";

$6cc7c638bd081c26$export$c564cdbbe6da493 = (parcelRequire("dMZD4"));

$6cc7c638bd081c26$export$2f872c0f2117be69 = (parcelRequire("dgcDJ"));

$6cc7c638bd081c26$export$d9468344d3651243 = (parcelRequire("64QYH"));

$6cc7c638bd081c26$export$98e6a39c04603d36 = (parcelRequire("5UyDJ"));

});
parcelRegister("dMZD4", function(module, exports) {
"use strict";
var $a09f9057097f68d0$var$encodeCache = {};
// Create a lookup array where anything but characters in `chars` string
// and alphanumeric chars is percent-encoded.
//
function $a09f9057097f68d0$var$getEncodeCache(exclude) {
    var i, ch, cache = $a09f9057097f68d0$var$encodeCache[exclude];
    if (cache) return cache;
    cache = $a09f9057097f68d0$var$encodeCache[exclude] = [];
    for(i = 0; i < 128; i++){
        ch = String.fromCharCode(i);
        if (/^[0-9a-z]$/i.test(ch)) // always allow unencoded alphanumeric characters
        cache.push(ch);
        else cache.push("%" + ("0" + i.toString(16).toUpperCase()).slice(-2));
    }
    for(i = 0; i < exclude.length; i++)cache[exclude.charCodeAt(i)] = exclude[i];
    return cache;
}
// Encode unsafe characters with percent-encoding, skipping already
// encoded sequences.
//
//  - string       - string to encode
//  - exclude      - list of characters to ignore (in addition to a-zA-Z0-9)
//  - keepEscaped  - don't encode '%' in a correct escape sequence (default: true)
//
function $a09f9057097f68d0$var$encode(string, exclude, keepEscaped) {
    var i, l, code, nextCode, cache, result = "";
    if (typeof exclude !== "string") {
        // encode(string, keepEscaped)
        keepEscaped = exclude;
        exclude = $a09f9057097f68d0$var$encode.defaultChars;
    }
    if (typeof keepEscaped === "undefined") keepEscaped = true;
    cache = $a09f9057097f68d0$var$getEncodeCache(exclude);
    for(i = 0, l = string.length; i < l; i++){
        code = string.charCodeAt(i);
        if (keepEscaped && code === 0x25 /* % */  && i + 2 < l) {
            if (/^[0-9a-f]{2}$/i.test(string.slice(i + 1, i + 3))) {
                result += string.slice(i, i + 3);
                i += 2;
                continue;
            }
        }
        if (code < 128) {
            result += cache[code];
            continue;
        }
        if (code >= 0xD800 && code <= 0xDFFF) {
            if (code >= 0xD800 && code <= 0xDBFF && i + 1 < l) {
                nextCode = string.charCodeAt(i + 1);
                if (nextCode >= 0xDC00 && nextCode <= 0xDFFF) {
                    result += encodeURIComponent(string[i] + string[i + 1]);
                    i++;
                    continue;
                }
            }
            result += "%EF%BF%BD";
            continue;
        }
        result += encodeURIComponent(string[i]);
    }
    return result;
}
$a09f9057097f68d0$var$encode.defaultChars = ";/?:@&=+$,-_.!~*'()#";
$a09f9057097f68d0$var$encode.componentChars = "-_.!~*'()";
module.exports = $a09f9057097f68d0$var$encode;

});

parcelRegister("dgcDJ", function(module, exports) {
"use strict";
/* eslint-disable no-bitwise */ var $9a7692f91d5cdbee$var$decodeCache = {};
function $9a7692f91d5cdbee$var$getDecodeCache(exclude) {
    var i, ch, cache = $9a7692f91d5cdbee$var$decodeCache[exclude];
    if (cache) return cache;
    cache = $9a7692f91d5cdbee$var$decodeCache[exclude] = [];
    for(i = 0; i < 128; i++){
        ch = String.fromCharCode(i);
        cache.push(ch);
    }
    for(i = 0; i < exclude.length; i++){
        ch = exclude.charCodeAt(i);
        cache[ch] = "%" + ("0" + ch.toString(16).toUpperCase()).slice(-2);
    }
    return cache;
}
// Decode percent-encoded string.
//
function $9a7692f91d5cdbee$var$decode(string, exclude) {
    var cache;
    if (typeof exclude !== "string") exclude = $9a7692f91d5cdbee$var$decode.defaultChars;
    cache = $9a7692f91d5cdbee$var$getDecodeCache(exclude);
    return string.replace(/(%[a-f0-9]{2})+/gi, function(seq) {
        var i, l, b1, b2, b3, b4, chr, result = "";
        for(i = 0, l = seq.length; i < l; i += 3){
            b1 = parseInt(seq.slice(i + 1, i + 3), 16);
            if (b1 < 0x80) {
                result += cache[b1];
                continue;
            }
            if ((b1 & 0xE0) === 0xC0 && i + 3 < l) {
                // 110xxxxx 10xxxxxx
                b2 = parseInt(seq.slice(i + 4, i + 6), 16);
                if ((b2 & 0xC0) === 0x80) {
                    chr = b1 << 6 & 0x7C0 | b2 & 0x3F;
                    if (chr < 0x80) result += "\uFFFD\uFFFD";
                    else result += String.fromCharCode(chr);
                    i += 3;
                    continue;
                }
            }
            if ((b1 & 0xF0) === 0xE0 && i + 6 < l) {
                // 1110xxxx 10xxxxxx 10xxxxxx
                b2 = parseInt(seq.slice(i + 4, i + 6), 16);
                b3 = parseInt(seq.slice(i + 7, i + 9), 16);
                if ((b2 & 0xC0) === 0x80 && (b3 & 0xC0) === 0x80) {
                    chr = b1 << 12 & 0xF000 | b2 << 6 & 0xFC0 | b3 & 0x3F;
                    if (chr < 0x800 || chr >= 0xD800 && chr <= 0xDFFF) result += "\uFFFD\uFFFD\uFFFD";
                    else result += String.fromCharCode(chr);
                    i += 6;
                    continue;
                }
            }
            if ((b1 & 0xF8) === 0xF0 && i + 9 < l) {
                // 111110xx 10xxxxxx 10xxxxxx 10xxxxxx
                b2 = parseInt(seq.slice(i + 4, i + 6), 16);
                b3 = parseInt(seq.slice(i + 7, i + 9), 16);
                b4 = parseInt(seq.slice(i + 10, i + 12), 16);
                if ((b2 & 0xC0) === 0x80 && (b3 & 0xC0) === 0x80 && (b4 & 0xC0) === 0x80) {
                    chr = b1 << 18 & 0x1C0000 | b2 << 12 & 0x3F000 | b3 << 6 & 0xFC0 | b4 & 0x3F;
                    if (chr < 0x10000 || chr > 0x10FFFF) result += "\uFFFD\uFFFD\uFFFD\uFFFD";
                    else {
                        chr -= 0x10000;
                        result += String.fromCharCode(0xD800 + (chr >> 10), 0xDC00 + (chr & 0x3FF));
                    }
                    i += 9;
                    continue;
                }
            }
            result += "\uFFFD";
        }
        return result;
    });
}
$9a7692f91d5cdbee$var$decode.defaultChars = ";/?:@&=+$,#";
$9a7692f91d5cdbee$var$decode.componentChars = "";
module.exports = $9a7692f91d5cdbee$var$decode;

});

parcelRegister("64QYH", function(module, exports) {
"use strict";
module.exports = function format(url) {
    var result = "";
    result += url.protocol || "";
    result += url.slashes ? "//" : "";
    result += url.auth ? url.auth + "@" : "";
    if (url.hostname && url.hostname.indexOf(":") !== -1) // ipv6 address
    result += "[" + url.hostname + "]";
    else result += url.hostname || "";
    result += url.port ? ":" + url.port : "";
    result += url.pathname || "";
    result += url.search || "";
    result += url.hash || "";
    return result;
};

});

parcelRegister("5UyDJ", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
"use strict";
//
// Changes from joyent/node:
//
// 1. No leading slash in paths,
//    e.g. in `url.parse('http://foo?bar')` pathname is ``, not `/`
//
// 2. Backslashes are not replaced with slashes,
//    so `http:\\example.org\` is treated like a relative path
//
// 3. Trailing colon is treated like a part of the path,
//    i.e. in `http://example.org:foo` pathname is `:foo`
//
// 4. Nothing is URL-encoded in the resulting object,
//    (in joyent/node some chars in auth and paths are encoded)
//
// 5. `url.parse()` does not have `parseQueryString` argument
//
// 6. Removed extraneous result properties: `host`, `path`, `query`, etc.,
//    which can be constructed using other parts of the url.
//
function $44dd0d7d10900ebb$var$Url() {
    this.protocol = null;
    this.slashes = null;
    this.auth = null;
    this.port = null;
    this.hostname = null;
    this.hash = null;
    this.search = null;
    this.pathname = null;
}
// Reference: RFC 3986, RFC 1808, RFC 2396
// define these here so at least they only have to be
// compiled once on the first module load.
var $44dd0d7d10900ebb$var$protocolPattern = /^([a-z0-9.+-]+:)/i, $44dd0d7d10900ebb$var$portPattern = /:[0-9]*$/, // Special case for a simple path URL
$44dd0d7d10900ebb$var$simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/, // RFC 2396: characters reserved for delimiting URLs.
// We actually just auto-escape these.
$44dd0d7d10900ebb$var$delims = [
    "<",
    ">",
    '"',
    "`",
    " ",
    "\r",
    "\n",
    "	"
], // RFC 2396: characters not allowed for various reasons.
$44dd0d7d10900ebb$var$unwise = [
    "{",
    "}",
    "|",
    "\\",
    "^",
    "`"
].concat($44dd0d7d10900ebb$var$delims), // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
$44dd0d7d10900ebb$var$autoEscape = [
    "'"
].concat($44dd0d7d10900ebb$var$unwise), // Characters that are never ever allowed in a hostname.
// Note that any invalid chars are also handled, but these
// are the ones that are *expected* to be seen, so we fast-path
// them.
$44dd0d7d10900ebb$var$nonHostChars = [
    "%",
    "/",
    "?",
    ";",
    "#"
].concat($44dd0d7d10900ebb$var$autoEscape), $44dd0d7d10900ebb$var$hostEndingChars = [
    "/",
    "?",
    "#"
], $44dd0d7d10900ebb$var$hostnameMaxLen = 255, $44dd0d7d10900ebb$var$hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/, $44dd0d7d10900ebb$var$hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, // protocols that can allow "unsafe" and "unwise" chars.
/* eslint-disable no-script-url */ // protocols that never have a hostname.
$44dd0d7d10900ebb$var$hostlessProtocol = {
    "javascript": true,
    "javascript:": true
}, // protocols that always contain a // bit.
$44dd0d7d10900ebb$var$slashedProtocol = {
    "http": true,
    "https": true,
    "ftp": true,
    "gopher": true,
    "file": true,
    "http:": true,
    "https:": true,
    "ftp:": true,
    "gopher:": true,
    "file:": true
};
/* eslint-enable no-script-url */ function $44dd0d7d10900ebb$var$urlParse(url, slashesDenoteHost) {
    if (url && url instanceof $44dd0d7d10900ebb$var$Url) return url;
    var u = new $44dd0d7d10900ebb$var$Url();
    u.parse(url, slashesDenoteHost);
    return u;
}
$44dd0d7d10900ebb$var$Url.prototype.parse = function(url, slashesDenoteHost) {
    var i, l, lowerProto, hec, slashes, rest = url;
    // trim before proceeding.
    // This is to support parse stuff like "  http://foo.com  \n"
    rest = rest.trim();
    if (!slashesDenoteHost && url.split("#").length === 1) {
        // Try fast path regexp
        var simplePath = $44dd0d7d10900ebb$var$simplePathPattern.exec(rest);
        if (simplePath) {
            this.pathname = simplePath[1];
            if (simplePath[2]) this.search = simplePath[2];
            return this;
        }
    }
    var proto = $44dd0d7d10900ebb$var$protocolPattern.exec(rest);
    if (proto) {
        proto = proto[0];
        lowerProto = proto.toLowerCase();
        this.protocol = proto;
        rest = rest.substr(proto.length);
    }
    // figure out if it's got a host
    // user@server is *always* interpreted as a hostname, and url
    // resolution will treat //foo/bar as host=foo,path=bar because that's
    // how the browser resolves relative URLs.
    if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
        slashes = rest.substr(0, 2) === "//";
        if (slashes && !(proto && $44dd0d7d10900ebb$var$hostlessProtocol[proto])) {
            rest = rest.substr(2);
            this.slashes = true;
        }
    }
    if (!$44dd0d7d10900ebb$var$hostlessProtocol[proto] && (slashes || proto && !$44dd0d7d10900ebb$var$slashedProtocol[proto])) {
        // there's a hostname.
        // the first instance of /, ?, ;, or # ends the host.
        //
        // If there is an @ in the hostname, then non-host chars *are* allowed
        // to the left of the last @ sign, unless some host-ending character
        // comes *before* the @-sign.
        // URLs are obnoxious.
        //
        // ex:
        // http://a@b@c/ => user:a@b host:c
        // http://a@b?@c => user:a host:c path:/?@c
        // v0.12 TODO(isaacs): This is not quite how Chrome does things.
        // Review our test case against browsers more comprehensively.
        // find the first instance of any hostEndingChars
        var hostEnd = -1;
        for(i = 0; i < $44dd0d7d10900ebb$var$hostEndingChars.length; i++){
            hec = rest.indexOf($44dd0d7d10900ebb$var$hostEndingChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // at this point, either we have an explicit point where the
        // auth portion cannot go past, or the last @ char is the decider.
        var auth, atSign;
        if (hostEnd === -1) // atSign can be anywhere.
        atSign = rest.lastIndexOf("@");
        else // atSign must be in auth portion.
        // http://a@b/c@d => host:b auth:a path:/c@d
        atSign = rest.lastIndexOf("@", hostEnd);
        // Now we have a portion which is definitely the auth.
        // Pull that off.
        if (atSign !== -1) {
            auth = rest.slice(0, atSign);
            rest = rest.slice(atSign + 1);
            this.auth = auth;
        }
        // the host is the remaining to the left of the first non-host char
        hostEnd = -1;
        for(i = 0; i < $44dd0d7d10900ebb$var$nonHostChars.length; i++){
            hec = rest.indexOf($44dd0d7d10900ebb$var$nonHostChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // if we still have not hit it, then the entire thing is a host.
        if (hostEnd === -1) hostEnd = rest.length;
        if (rest[hostEnd - 1] === ":") hostEnd--;
        var host = rest.slice(0, hostEnd);
        rest = rest.slice(hostEnd);
        // pull out port.
        this.parseHost(host);
        // we've indicated that there is a hostname,
        // so even if it's empty, it has to be present.
        this.hostname = this.hostname || "";
        // if hostname begins with [ and ends with ]
        // assume that it's an IPv6 address.
        var ipv6Hostname = this.hostname[0] === "[" && this.hostname[this.hostname.length - 1] === "]";
        // validate a little.
        if (!ipv6Hostname) {
            var hostparts = this.hostname.split(/\./);
            for(i = 0, l = hostparts.length; i < l; i++){
                var part = hostparts[i];
                if (!part) continue;
                if (!part.match($44dd0d7d10900ebb$var$hostnamePartPattern)) {
                    var newpart = "";
                    for(var j = 0, k = part.length; j < k; j++)if (part.charCodeAt(j) > 127) // we replace non-ASCII char with a temporary placeholder
                    // we need this to make sure size of hostname is not
                    // broken by replacing non-ASCII by nothing
                    newpart += "x";
                    else newpart += part[j];
                    // we test again with ASCII char only
                    if (!newpart.match($44dd0d7d10900ebb$var$hostnamePartPattern)) {
                        var validParts = hostparts.slice(0, i);
                        var notHost = hostparts.slice(i + 1);
                        var bit = part.match($44dd0d7d10900ebb$var$hostnamePartStart);
                        if (bit) {
                            validParts.push(bit[1]);
                            notHost.unshift(bit[2]);
                        }
                        if (notHost.length) rest = notHost.join(".") + rest;
                        this.hostname = validParts.join(".");
                        break;
                    }
                }
            }
        }
        if (this.hostname.length > $44dd0d7d10900ebb$var$hostnameMaxLen) this.hostname = "";
        // strip [ and ] from the hostname
        // the host field still retains them, though
        if (ipv6Hostname) this.hostname = this.hostname.substr(1, this.hostname.length - 2);
    }
    // chop off from the tail first.
    var hash = rest.indexOf("#");
    if (hash !== -1) {
        // got a fragment string.
        this.hash = rest.substr(hash);
        rest = rest.slice(0, hash);
    }
    var qm = rest.indexOf("?");
    if (qm !== -1) {
        this.search = rest.substr(qm);
        rest = rest.slice(0, qm);
    }
    if (rest) this.pathname = rest;
    if ($44dd0d7d10900ebb$var$slashedProtocol[lowerProto] && this.hostname && !this.pathname) this.pathname = "";
    return this;
};
$44dd0d7d10900ebb$var$Url.prototype.parseHost = function(host) {
    var port = $44dd0d7d10900ebb$var$portPattern.exec(host);
    if (port) {
        port = port[0];
        if (port !== ":") this.port = port.substr(1);
        host = host.substr(0, host.length - port.length);
    }
    if (host) this.hostname = host;
};
module.exports = $44dd0d7d10900ebb$var$urlParse;

});


parcelRegister("e4cqX", function(module, exports) {

$parcel$export(module.exports, "Any", () => $a3db15857efd761d$export$b24b633b1364b94b, (v) => $a3db15857efd761d$export$b24b633b1364b94b = v);
$parcel$export(module.exports, "Cc", () => $a3db15857efd761d$export$15dafbac7aec8a57, (v) => $a3db15857efd761d$export$15dafbac7aec8a57 = v);
$parcel$export(module.exports, "Cf", () => $a3db15857efd761d$export$239cff0cce87eb56, (v) => $a3db15857efd761d$export$239cff0cce87eb56 = v);
$parcel$export(module.exports, "P", () => $a3db15857efd761d$export$56c0d5a1e737357d, (v) => $a3db15857efd761d$export$56c0d5a1e737357d = v);
$parcel$export(module.exports, "Z", () => $a3db15857efd761d$export$dc98b0b04f4c7758, (v) => $a3db15857efd761d$export$dc98b0b04f4c7758 = v);
var $a3db15857efd761d$export$b24b633b1364b94b;
var $a3db15857efd761d$export$15dafbac7aec8a57;
var $a3db15857efd761d$export$239cff0cce87eb56;
var $a3db15857efd761d$export$56c0d5a1e737357d;
var $a3db15857efd761d$export$dc98b0b04f4c7758;
"use strict";

$a3db15857efd761d$export$b24b633b1364b94b = (parcelRequire("kYZFY"));

$a3db15857efd761d$export$15dafbac7aec8a57 = (parcelRequire("6hNPW"));

$a3db15857efd761d$export$239cff0cce87eb56 = (parcelRequire("71roD"));

$a3db15857efd761d$export$56c0d5a1e737357d = (parcelRequire("hKVfa"));

$a3db15857efd761d$export$dc98b0b04f4c7758 = (parcelRequire("h5t0s"));

});
parcelRegister("kYZFY", function(module, exports) {
module.exports = /[\0-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/;

});

parcelRegister("6hNPW", function(module, exports) {
module.exports = /[\0-\x1F\x7F-\x9F]/;

});

parcelRegister("71roD", function(module, exports) {
module.exports = /[\xAD\u0600-\u0605\u061C\u06DD\u070F\u08E2\u180E\u200B-\u200F\u202A-\u202E\u2060-\u2064\u2066-\u206F\uFEFF\uFFF9-\uFFFB]|\uD804[\uDCBD\uDCCD]|\uD82F[\uDCA0-\uDCA3]|\uD834[\uDD73-\uDD7A]|\uDB40[\uDC01\uDC20-\uDC7F]/;

});

parcelRegister("h5t0s", function(module, exports) {
module.exports = /[ \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000]/;

});



parcelRegister("4FEdr", function(module, exports) {

$parcel$export(module.exports, "parseLinkLabel", () => $366a2fc9ae37ef5d$export$2a2c8612930e58d0, (v) => $366a2fc9ae37ef5d$export$2a2c8612930e58d0 = v);
$parcel$export(module.exports, "parseLinkDestination", () => $366a2fc9ae37ef5d$export$22bd24080f95f2b3, (v) => $366a2fc9ae37ef5d$export$22bd24080f95f2b3 = v);
$parcel$export(module.exports, "parseLinkTitle", () => $366a2fc9ae37ef5d$export$89650c5477a69db9, (v) => $366a2fc9ae37ef5d$export$89650c5477a69db9 = v);
// Just a shortcut for bulk export
var $366a2fc9ae37ef5d$export$2a2c8612930e58d0;
var $366a2fc9ae37ef5d$export$22bd24080f95f2b3;
var $366a2fc9ae37ef5d$export$89650c5477a69db9;
"use strict";

$366a2fc9ae37ef5d$export$2a2c8612930e58d0 = (parcelRequire("aWlLb"));

$366a2fc9ae37ef5d$export$22bd24080f95f2b3 = (parcelRequire("1tAep"));

$366a2fc9ae37ef5d$export$89650c5477a69db9 = (parcelRequire("lbNd0"));

});
parcelRegister("aWlLb", function(module, exports) {
// Parse link label
//
// this function assumes that first character ("[") already matches;
// returns the end of the label
//
"use strict";
module.exports = function parseLinkLabel(state, start, disableNested) {
    var level, found, marker, prevPos, labelEnd = -1, max = state.posMax, oldPos = state.pos;
    state.pos = start + 1;
    level = 1;
    while(state.pos < max){
        marker = state.src.charCodeAt(state.pos);
        if (marker === 0x5D /* ] */ ) {
            level--;
            if (level === 0) {
                found = true;
                break;
            }
        }
        prevPos = state.pos;
        state.md.inline.skipToken(state);
        if (marker === 0x5B /* [ */ ) {
            if (prevPos === state.pos - 1) // increase level if we find text `[`, which is not a part of any token
            level++;
            else if (disableNested) {
                state.pos = oldPos;
                return -1;
            }
        }
    }
    if (found) labelEnd = state.pos;
    // restore old state
    state.pos = oldPos;
    return labelEnd;
};

});

parcelRegister("1tAep", function(module, exports) {
// Parse link destination
//
"use strict";

var $cNF1f = parcelRequire("cNF1f");
var $11349aab2acd54a7$require$unescapeAll = $cNF1f.unescapeAll;
module.exports = function parseLinkDestination(str, pos, max) {
    var code, level, lines = 0, start = pos, result = {
        ok: false,
        pos: 0,
        lines: 0,
        str: ""
    };
    if (str.charCodeAt(pos) === 0x3C /* < */ ) {
        pos++;
        while(pos < max){
            code = str.charCodeAt(pos);
            if (code === 0x0A /* \n */ ) return result;
            if (code === 0x3C /* < */ ) return result;
            if (code === 0x3E /* > */ ) {
                result.pos = pos + 1;
                result.str = $11349aab2acd54a7$require$unescapeAll(str.slice(start + 1, pos));
                result.ok = true;
                return result;
            }
            if (code === 0x5C /* \ */  && pos + 1 < max) {
                pos += 2;
                continue;
            }
            pos++;
        }
        // no closing '>'
        return result;
    }
    // this should be ... } else { ... branch
    level = 0;
    while(pos < max){
        code = str.charCodeAt(pos);
        if (code === 0x20) break;
        // ascii control characters
        if (code < 0x20 || code === 0x7F) break;
        if (code === 0x5C /* \ */  && pos + 1 < max) {
            if (str.charCodeAt(pos + 1) === 0x20) break;
            pos += 2;
            continue;
        }
        if (code === 0x28 /* ( */ ) {
            level++;
            if (level > 32) return result;
        }
        if (code === 0x29 /* ) */ ) {
            if (level === 0) break;
            level--;
        }
        pos++;
    }
    if (start === pos) return result;
    if (level !== 0) return result;
    result.str = $11349aab2acd54a7$require$unescapeAll(str.slice(start, pos));
    result.lines = lines;
    result.pos = pos;
    result.ok = true;
    return result;
};

});

parcelRegister("lbNd0", function(module, exports) {
// Parse link title
//
"use strict";

var $cNF1f = parcelRequire("cNF1f");
var $03fb1c1022db9839$require$unescapeAll = $cNF1f.unescapeAll;
module.exports = function parseLinkTitle(str, pos, max) {
    var code, marker, lines = 0, start = pos, result = {
        ok: false,
        pos: 0,
        lines: 0,
        str: ""
    };
    if (pos >= max) return result;
    marker = str.charCodeAt(pos);
    if (marker !== 0x22 /* " */  && marker !== 0x27 /* ' */  && marker !== 0x28 /* ( */ ) return result;
    pos++;
    // if opening marker is "(", switch it to closing marker ")"
    if (marker === 0x28) marker = 0x29;
    while(pos < max){
        code = str.charCodeAt(pos);
        if (code === marker) {
            result.pos = pos + 1;
            result.lines = lines;
            result.str = $03fb1c1022db9839$require$unescapeAll(str.slice(start + 1, pos));
            result.ok = true;
            return result;
        } else if (code === 0x28 /* ( */  && marker === 0x29 /* ) */ ) return result;
        else if (code === 0x0A) lines++;
        else if (code === 0x5C /* \ */  && pos + 1 < max) {
            pos++;
            if (str.charCodeAt(pos) === 0x0A) lines++;
        }
        pos++;
    }
    return result;
};

});


parcelRegister("6Aw5F", function(module, exports) {
/**
 * class Renderer
 *
 * Generates HTML from parsed token stream. Each instance has independent
 * copy of rules. Those can be rewritten with ease. Also, you can add new
 * rules if you create plugin and adds new token types.
 **/ "use strict";

var $cNF1f = parcelRequire("cNF1f");
var $4cbeff578aa772ed$require$assign = $cNF1f.assign;

var $cNF1f = parcelRequire("cNF1f");
var $4cbeff578aa772ed$require$unescapeAll = $cNF1f.unescapeAll;

var $cNF1f = parcelRequire("cNF1f");
var $4cbeff578aa772ed$require$escapeHtml = $cNF1f.escapeHtml;
////////////////////////////////////////////////////////////////////////////////
var $4cbeff578aa772ed$var$default_rules = {};
$4cbeff578aa772ed$var$default_rules.code_inline = function(tokens, idx, options, env, slf) {
    var token = tokens[idx];
    return "<code" + slf.renderAttrs(token) + ">" + $4cbeff578aa772ed$require$escapeHtml(tokens[idx].content) + "</code>";
};
$4cbeff578aa772ed$var$default_rules.code_block = function(tokens, idx, options, env, slf) {
    var token = tokens[idx];
    return "<pre" + slf.renderAttrs(token) + "><code>" + $4cbeff578aa772ed$require$escapeHtml(tokens[idx].content) + "</code></pre>\n";
};
$4cbeff578aa772ed$var$default_rules.fence = function(tokens, idx, options, env, slf) {
    var token = tokens[idx], info = token.info ? $4cbeff578aa772ed$require$unescapeAll(token.info).trim() : "", langName = "", langAttrs = "", highlighted, i, arr, tmpAttrs, tmpToken;
    if (info) {
        arr = info.split(/(\s+)/g);
        langName = arr[0];
        langAttrs = arr.slice(2).join("");
    }
    if (options.highlight) highlighted = options.highlight(token.content, langName, langAttrs) || $4cbeff578aa772ed$require$escapeHtml(token.content);
    else highlighted = $4cbeff578aa772ed$require$escapeHtml(token.content);
    if (highlighted.indexOf("<pre") === 0) return highlighted + "\n";
    // If language exists, inject class gently, without modifying original token.
    // May be, one day we will add .deepClone() for token and simplify this part, but
    // now we prefer to keep things local.
    if (info) {
        i = token.attrIndex("class");
        tmpAttrs = token.attrs ? token.attrs.slice() : [];
        if (i < 0) tmpAttrs.push([
            "class",
            options.langPrefix + langName
        ]);
        else {
            tmpAttrs[i] = tmpAttrs[i].slice();
            tmpAttrs[i][1] += " " + options.langPrefix + langName;
        }
        // Fake token just to render attributes
        tmpToken = {
            attrs: tmpAttrs
        };
        return "<pre><code" + slf.renderAttrs(tmpToken) + ">" + highlighted + "</code></pre>\n";
    }
    return "<pre><code" + slf.renderAttrs(token) + ">" + highlighted + "</code></pre>\n";
};
$4cbeff578aa772ed$var$default_rules.image = function(tokens, idx, options, env, slf) {
    var token = tokens[idx];
    // "alt" attr MUST be set, even if empty. Because it's mandatory and
    // should be placed on proper position for tests.
    //
    // Replace content with actual value
    token.attrs[token.attrIndex("alt")][1] = slf.renderInlineAsText(token.children, options, env);
    return slf.renderToken(tokens, idx, options);
};
$4cbeff578aa772ed$var$default_rules.hardbreak = function(tokens, idx, options /*, env */ ) {
    return options.xhtmlOut ? "<br />\n" : "<br>\n";
};
$4cbeff578aa772ed$var$default_rules.softbreak = function(tokens, idx, options /*, env */ ) {
    return options.breaks ? options.xhtmlOut ? "<br />\n" : "<br>\n" : "\n";
};
$4cbeff578aa772ed$var$default_rules.text = function(tokens, idx /*, options, env */ ) {
    return $4cbeff578aa772ed$require$escapeHtml(tokens[idx].content);
};
$4cbeff578aa772ed$var$default_rules.html_block = function(tokens, idx /*, options, env */ ) {
    return tokens[idx].content;
};
$4cbeff578aa772ed$var$default_rules.html_inline = function(tokens, idx /*, options, env */ ) {
    return tokens[idx].content;
};
/**
 * new Renderer()
 *
 * Creates new [[Renderer]] instance and fill [[Renderer#rules]] with defaults.
 **/ function $4cbeff578aa772ed$var$Renderer() {
    /**
   * Renderer#rules -> Object
   *
   * Contains render rules for tokens. Can be updated and extended.
   *
   * ##### Example
   *
   * ```javascript
   * var md = require('markdown-it')();
   *
   * md.renderer.rules.strong_open  = function () { return '<b>'; };
   * md.renderer.rules.strong_close = function () { return '</b>'; };
   *
   * var result = md.renderInline(...);
   * ```
   *
   * Each rule is called as independent static function with fixed signature:
   *
   * ```javascript
   * function my_token_render(tokens, idx, options, env, renderer) {
   *   // ...
   *   return renderedHTML;
   * }
   * ```
   *
   * See [source code](https://github.com/markdown-it/markdown-it/blob/master/lib/renderer.js)
   * for more details and examples.
   **/ this.rules = $4cbeff578aa772ed$require$assign({}, $4cbeff578aa772ed$var$default_rules);
}
/**
 * Renderer.renderAttrs(token) -> String
 *
 * Render token attributes to string.
 **/ $4cbeff578aa772ed$var$Renderer.prototype.renderAttrs = function renderAttrs(token) {
    var i, l, result;
    if (!token.attrs) return "";
    result = "";
    for(i = 0, l = token.attrs.length; i < l; i++)result += " " + $4cbeff578aa772ed$require$escapeHtml(token.attrs[i][0]) + '="' + $4cbeff578aa772ed$require$escapeHtml(token.attrs[i][1]) + '"';
    return result;
};
/**
 * Renderer.renderToken(tokens, idx, options) -> String
 * - tokens (Array): list of tokens
 * - idx (Numbed): token index to render
 * - options (Object): params of parser instance
 *
 * Default token renderer. Can be overriden by custom function
 * in [[Renderer#rules]].
 **/ $4cbeff578aa772ed$var$Renderer.prototype.renderToken = function renderToken(tokens, idx, options) {
    var nextToken, result = "", needLf = false, token = tokens[idx];
    // Tight list paragraphs
    if (token.hidden) return "";
    // Insert a newline between hidden paragraph and subsequent opening
    // block-level tag.
    //
    // For example, here we should insert a newline before blockquote:
    //  - a
    //    >
    //
    if (token.block && token.nesting !== -1 && idx && tokens[idx - 1].hidden) result += "\n";
    // Add token name, e.g. `<img`
    result += (token.nesting === -1 ? "</" : "<") + token.tag;
    // Encode attributes, e.g. `<img src="foo"`
    result += this.renderAttrs(token);
    // Add a slash for self-closing tags, e.g. `<img src="foo" /`
    if (token.nesting === 0 && options.xhtmlOut) result += " /";
    // Check if we need to add a newline after this tag
    if (token.block) {
        needLf = true;
        if (token.nesting === 1) {
            if (idx + 1 < tokens.length) {
                nextToken = tokens[idx + 1];
                if (nextToken.type === "inline" || nextToken.hidden) // Block-level tag containing an inline tag.
                //
                needLf = false;
                else if (nextToken.nesting === -1 && nextToken.tag === token.tag) // Opening tag + closing tag of the same type. E.g. `<li></li>`.
                //
                needLf = false;
            }
        }
    }
    result += needLf ? ">\n" : ">";
    return result;
};
/**
 * Renderer.renderInline(tokens, options, env) -> String
 * - tokens (Array): list on block tokens to render
 * - options (Object): params of parser instance
 * - env (Object): additional data from parsed input (references, for example)
 *
 * The same as [[Renderer.render]], but for single token of `inline` type.
 **/ $4cbeff578aa772ed$var$Renderer.prototype.renderInline = function(tokens, options, env) {
    var type, result = "", rules = this.rules;
    for(var i = 0, len = tokens.length; i < len; i++){
        type = tokens[i].type;
        if (typeof rules[type] !== "undefined") result += rules[type](tokens, i, options, env, this);
        else result += this.renderToken(tokens, i, options);
    }
    return result;
};
/** internal
 * Renderer.renderInlineAsText(tokens, options, env) -> String
 * - tokens (Array): list on block tokens to render
 * - options (Object): params of parser instance
 * - env (Object): additional data from parsed input (references, for example)
 *
 * Special kludge for image `alt` attributes to conform CommonMark spec.
 * Don't try to use it! Spec requires to show `alt` content with stripped markup,
 * instead of simple escaping.
 **/ $4cbeff578aa772ed$var$Renderer.prototype.renderInlineAsText = function(tokens, options, env) {
    var result = "";
    for(var i = 0, len = tokens.length; i < len; i++){
        if (tokens[i].type === "text") result += tokens[i].content;
        else if (tokens[i].type === "image") result += this.renderInlineAsText(tokens[i].children, options, env);
        else if (tokens[i].type === "softbreak") result += "\n";
    }
    return result;
};
/**
 * Renderer.render(tokens, options, env) -> String
 * - tokens (Array): list on block tokens to render
 * - options (Object): params of parser instance
 * - env (Object): additional data from parsed input (references, for example)
 *
 * Takes token stream and generates HTML. Probably, you will never need to call
 * this method directly.
 **/ $4cbeff578aa772ed$var$Renderer.prototype.render = function(tokens, options, env) {
    var i, len, type, result = "", rules = this.rules;
    for(i = 0, len = tokens.length; i < len; i++){
        type = tokens[i].type;
        if (type === "inline") result += this.renderInline(tokens[i].children, options, env);
        else if (typeof rules[type] !== "undefined") result += rules[tokens[i].type](tokens, i, options, env, this);
        else result += this.renderToken(tokens, i, options, env);
    }
    return result;
};
module.exports = $4cbeff578aa772ed$var$Renderer;

});

parcelRegister("9OAeu", function(module, exports) {
/** internal
 * class Core
 *
 * Top-level rules executor. Glues block/inline parsers and does intermediate
 * transformations.
 **/ "use strict";

var $9bWv8 = parcelRequire("9bWv8");






var $7254e3a246a6453e$var$_rules = [
    [
        "normalize",
        (parcelRequire("hyqpI"))
    ],
    [
        "block",
        (parcelRequire("eAskl"))
    ],
    [
        "inline",
        (parcelRequire("7tC2h"))
    ],
    [
        "linkify",
        (parcelRequire("jVyIC"))
    ],
    [
        "replacements",
        (parcelRequire("hWbNE"))
    ],
    [
        "smartquotes",
        (parcelRequire("hXXtU"))
    ]
];
/**
 * new Core()
 **/ function $7254e3a246a6453e$var$Core() {
    /**
   * Core#ruler -> Ruler
   *
   * [[Ruler]] instance. Keep configuration of core rules.
   **/ this.ruler = new $9bWv8();
    for(var i = 0; i < $7254e3a246a6453e$var$_rules.length; i++)this.ruler.push($7254e3a246a6453e$var$_rules[i][0], $7254e3a246a6453e$var$_rules[i][1]);
}
/**
 * Core.process(state)
 *
 * Executes core chain rules.
 **/ $7254e3a246a6453e$var$Core.prototype.process = function(state) {
    var i, l, rules;
    rules = this.ruler.getRules("");
    for(i = 0, l = rules.length; i < l; i++)rules[i](state);
};

$7254e3a246a6453e$var$Core.prototype.State = (parcelRequire("jmvCN"));
module.exports = $7254e3a246a6453e$var$Core;

});
parcelRegister("9bWv8", function(module, exports) {
/**
 * class Ruler
 *
 * Helper class, used by [[MarkdownIt#core]], [[MarkdownIt#block]] and
 * [[MarkdownIt#inline]] to manage sequences of functions (rules):
 *
 * - keep rules in defined order
 * - assign the name to each rule
 * - enable/disable rules
 * - add/replace rules
 * - allow assign rules to additional named chains (in the same)
 * - cacheing lists of active rules
 *
 * You will not need use this class directly until write plugins. For simple
 * rules control use [[MarkdownIt.disable]], [[MarkdownIt.enable]] and
 * [[MarkdownIt.use]].
 **/ "use strict";
/**
 * new Ruler()
 **/ function $6b12853b19ab2634$var$Ruler() {
    // List of added rules. Each element is:
    //
    // {
    //   name: XXX,
    //   enabled: Boolean,
    //   fn: Function(),
    //   alt: [ name2, name3 ]
    // }
    //
    this.__rules__ = [];
    // Cached rule chains.
    //
    // First level - chain name, '' for default.
    // Second level - diginal anchor for fast filtering by charcodes.
    //
    this.__cache__ = null;
}
////////////////////////////////////////////////////////////////////////////////
// Helper methods, should not be used directly
// Find rule index by name
//
$6b12853b19ab2634$var$Ruler.prototype.__find__ = function(name) {
    for(var i = 0; i < this.__rules__.length; i++){
        if (this.__rules__[i].name === name) return i;
    }
    return -1;
};
// Build rules lookup cache
//
$6b12853b19ab2634$var$Ruler.prototype.__compile__ = function() {
    var self = this;
    var chains = [
        ""
    ];
    // collect unique names
    self.__rules__.forEach(function(rule) {
        if (!rule.enabled) return;
        rule.alt.forEach(function(altName) {
            if (chains.indexOf(altName) < 0) chains.push(altName);
        });
    });
    self.__cache__ = {};
    chains.forEach(function(chain) {
        self.__cache__[chain] = [];
        self.__rules__.forEach(function(rule) {
            if (!rule.enabled) return;
            if (chain && rule.alt.indexOf(chain) < 0) return;
            self.__cache__[chain].push(rule.fn);
        });
    });
};
/**
 * Ruler.at(name, fn [, options])
 * - name (String): rule name to replace.
 * - fn (Function): new rule function.
 * - options (Object): new rule options (not mandatory).
 *
 * Replace rule by name with new function & options. Throws error if name not
 * found.
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * Replace existing typographer replacement rule with new one:
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.core.ruler.at('replacements', function replace(state) {
 *   //...
 * });
 * ```
 **/ $6b12853b19ab2634$var$Ruler.prototype.at = function(name, fn, options) {
    var index = this.__find__(name);
    var opt = options || {};
    if (index === -1) throw new Error("Parser rule not found: " + name);
    this.__rules__[index].fn = fn;
    this.__rules__[index].alt = opt.alt || [];
    this.__cache__ = null;
};
/**
 * Ruler.before(beforeName, ruleName, fn [, options])
 * - beforeName (String): new rule will be added before this one.
 * - ruleName (String): name of added rule.
 * - fn (Function): rule function.
 * - options (Object): rule options (not mandatory).
 *
 * Add new rule to chain before one with given name. See also
 * [[Ruler.after]], [[Ruler.push]].
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.block.ruler.before('paragraph', 'my_rule', function replace(state) {
 *   //...
 * });
 * ```
 **/ $6b12853b19ab2634$var$Ruler.prototype.before = function(beforeName, ruleName, fn, options) {
    var index = this.__find__(beforeName);
    var opt = options || {};
    if (index === -1) throw new Error("Parser rule not found: " + beforeName);
    this.__rules__.splice(index, 0, {
        name: ruleName,
        enabled: true,
        fn: fn,
        alt: opt.alt || []
    });
    this.__cache__ = null;
};
/**
 * Ruler.after(afterName, ruleName, fn [, options])
 * - afterName (String): new rule will be added after this one.
 * - ruleName (String): name of added rule.
 * - fn (Function): rule function.
 * - options (Object): rule options (not mandatory).
 *
 * Add new rule to chain after one with given name. See also
 * [[Ruler.before]], [[Ruler.push]].
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.inline.ruler.after('text', 'my_rule', function replace(state) {
 *   //...
 * });
 * ```
 **/ $6b12853b19ab2634$var$Ruler.prototype.after = function(afterName, ruleName, fn, options) {
    var index = this.__find__(afterName);
    var opt = options || {};
    if (index === -1) throw new Error("Parser rule not found: " + afterName);
    this.__rules__.splice(index + 1, 0, {
        name: ruleName,
        enabled: true,
        fn: fn,
        alt: opt.alt || []
    });
    this.__cache__ = null;
};
/**
 * Ruler.push(ruleName, fn [, options])
 * - ruleName (String): name of added rule.
 * - fn (Function): rule function.
 * - options (Object): rule options (not mandatory).
 *
 * Push new rule to the end of chain. See also
 * [[Ruler.before]], [[Ruler.after]].
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.core.ruler.push('my_rule', function replace(state) {
 *   //...
 * });
 * ```
 **/ $6b12853b19ab2634$var$Ruler.prototype.push = function(ruleName, fn, options) {
    var opt = options || {};
    this.__rules__.push({
        name: ruleName,
        enabled: true,
        fn: fn,
        alt: opt.alt || []
    });
    this.__cache__ = null;
};
/**
 * Ruler.enable(list [, ignoreInvalid]) -> Array
 * - list (String|Array): list of rule names to enable.
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Enable rules with given names. If any rule name not found - throw Error.
 * Errors can be disabled by second param.
 *
 * Returns list of found rule names (if no exception happened).
 *
 * See also [[Ruler.disable]], [[Ruler.enableOnly]].
 **/ $6b12853b19ab2634$var$Ruler.prototype.enable = function(list, ignoreInvalid) {
    if (!Array.isArray(list)) list = [
        list
    ];
    var result = [];
    // Search by name and enable
    list.forEach(function(name) {
        var idx = this.__find__(name);
        if (idx < 0) {
            if (ignoreInvalid) return;
            throw new Error("Rules manager: invalid rule name " + name);
        }
        this.__rules__[idx].enabled = true;
        result.push(name);
    }, this);
    this.__cache__ = null;
    return result;
};
/**
 * Ruler.enableOnly(list [, ignoreInvalid])
 * - list (String|Array): list of rule names to enable (whitelist).
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Enable rules with given names, and disable everything else. If any rule name
 * not found - throw Error. Errors can be disabled by second param.
 *
 * See also [[Ruler.disable]], [[Ruler.enable]].
 **/ $6b12853b19ab2634$var$Ruler.prototype.enableOnly = function(list, ignoreInvalid) {
    if (!Array.isArray(list)) list = [
        list
    ];
    this.__rules__.forEach(function(rule) {
        rule.enabled = false;
    });
    this.enable(list, ignoreInvalid);
};
/**
 * Ruler.disable(list [, ignoreInvalid]) -> Array
 * - list (String|Array): list of rule names to disable.
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Disable rules with given names. If any rule name not found - throw Error.
 * Errors can be disabled by second param.
 *
 * Returns list of found rule names (if no exception happened).
 *
 * See also [[Ruler.enable]], [[Ruler.enableOnly]].
 **/ $6b12853b19ab2634$var$Ruler.prototype.disable = function(list, ignoreInvalid) {
    if (!Array.isArray(list)) list = [
        list
    ];
    var result = [];
    // Search by name and disable
    list.forEach(function(name) {
        var idx = this.__find__(name);
        if (idx < 0) {
            if (ignoreInvalid) return;
            throw new Error("Rules manager: invalid rule name " + name);
        }
        this.__rules__[idx].enabled = false;
        result.push(name);
    }, this);
    this.__cache__ = null;
    return result;
};
/**
 * Ruler.getRules(chainName) -> Array
 *
 * Return array of active functions (rules) for given chain name. It analyzes
 * rules configuration, compiles caches if not exists and returns result.
 *
 * Default chain name is `''` (empty string). It can't be skipped. That's
 * done intentionally, to keep signature monomorphic for high speed.
 **/ $6b12853b19ab2634$var$Ruler.prototype.getRules = function(chainName) {
    if (this.__cache__ === null) this.__compile__();
    // Chain can be empty, if rules disabled. But we still have to return Array.
    return this.__cache__[chainName] || [];
};
module.exports = $6b12853b19ab2634$var$Ruler;

});

parcelRegister("hyqpI", function(module, exports) {
// Normalize input string
"use strict";
// https://spec.commonmark.org/0.29/#line-ending
var $cc7a19d8434424cb$var$NEWLINES_RE = /\r\n?|\n/g;
var $cc7a19d8434424cb$var$NULL_RE = /\0/g;
module.exports = function normalize(state) {
    var str;
    // Normalize newlines
    str = state.src.replace($cc7a19d8434424cb$var$NEWLINES_RE, "\n");
    // Replace NULL characters
    str = str.replace($cc7a19d8434424cb$var$NULL_RE, "\uFFFD");
    state.src = str;
};

});

parcelRegister("eAskl", function(module, exports) {
"use strict";
module.exports = function block(state) {
    var token;
    if (state.inlineMode) {
        token = new state.Token("inline", "", 0);
        token.content = state.src;
        token.map = [
            0,
            1
        ];
        token.children = [];
        state.tokens.push(token);
    } else state.md.block.parse(state.src, state.md, state.env, state.tokens);
};

});

parcelRegister("7tC2h", function(module, exports) {
"use strict";
module.exports = function inline(state) {
    var tokens = state.tokens, tok, i, l;
    // Parse inlines
    for(i = 0, l = tokens.length; i < l; i++){
        tok = tokens[i];
        if (tok.type === "inline") state.md.inline.parse(tok.content, state.md, state.env, tok.children);
    }
};

});

parcelRegister("jVyIC", function(module, exports) {
// Replace link-like texts with link nodes.
//
// Currently restricted by `md.validateLink()` to http/https/ftp
//
"use strict";

var $cNF1f = parcelRequire("cNF1f");
var $e81e45942517393e$require$arrayReplaceAt = $cNF1f.arrayReplaceAt;
function $e81e45942517393e$var$isLinkOpen(str) {
    return /^<a[>\s]/i.test(str);
}
function $e81e45942517393e$var$isLinkClose(str) {
    return /^<\/a\s*>/i.test(str);
}
module.exports = function linkify(state) {
    var i, j, l, tokens, token, currentToken, nodes, ln, text, pos, lastPos, level, htmlLinkLevel, url, fullUrl, urlText, blockTokens = state.tokens, links;
    if (!state.md.options.linkify) return;
    for(j = 0, l = blockTokens.length; j < l; j++){
        if (blockTokens[j].type !== "inline" || !state.md.linkify.pretest(blockTokens[j].content)) continue;
        tokens = blockTokens[j].children;
        htmlLinkLevel = 0;
        // We scan from the end, to keep position when new tags added.
        // Use reversed logic in links start/end match
        for(i = tokens.length - 1; i >= 0; i--){
            currentToken = tokens[i];
            // Skip content of markdown links
            if (currentToken.type === "link_close") {
                i--;
                while(tokens[i].level !== currentToken.level && tokens[i].type !== "link_open")i--;
                continue;
            }
            // Skip content of html tag links
            if (currentToken.type === "html_inline") {
                if ($e81e45942517393e$var$isLinkOpen(currentToken.content) && htmlLinkLevel > 0) htmlLinkLevel--;
                if ($e81e45942517393e$var$isLinkClose(currentToken.content)) htmlLinkLevel++;
            }
            if (htmlLinkLevel > 0) continue;
            if (currentToken.type === "text" && state.md.linkify.test(currentToken.content)) {
                text = currentToken.content;
                links = state.md.linkify.match(text);
                // Now split string to nodes
                nodes = [];
                level = currentToken.level;
                lastPos = 0;
                for(ln = 0; ln < links.length; ln++){
                    url = links[ln].url;
                    fullUrl = state.md.normalizeLink(url);
                    if (!state.md.validateLink(fullUrl)) continue;
                    urlText = links[ln].text;
                    // Linkifier might send raw hostnames like "example.com", where url
                    // starts with domain name. So we prepend http:// in those cases,
                    // and remove it afterwards.
                    //
                    if (!links[ln].schema) urlText = state.md.normalizeLinkText("http://" + urlText).replace(/^http:\/\//, "");
                    else if (links[ln].schema === "mailto:" && !/^mailto:/i.test(urlText)) urlText = state.md.normalizeLinkText("mailto:" + urlText).replace(/^mailto:/, "");
                    else urlText = state.md.normalizeLinkText(urlText);
                    pos = links[ln].index;
                    if (pos > lastPos) {
                        token = new state.Token("text", "", 0);
                        token.content = text.slice(lastPos, pos);
                        token.level = level;
                        nodes.push(token);
                    }
                    token = new state.Token("link_open", "a", 1);
                    token.attrs = [
                        [
                            "href",
                            fullUrl
                        ]
                    ];
                    token.level = level++;
                    token.markup = "linkify";
                    token.info = "auto";
                    nodes.push(token);
                    token = new state.Token("text", "", 0);
                    token.content = urlText;
                    token.level = level;
                    nodes.push(token);
                    token = new state.Token("link_close", "a", -1);
                    token.level = --level;
                    token.markup = "linkify";
                    token.info = "auto";
                    nodes.push(token);
                    lastPos = links[ln].lastIndex;
                }
                if (lastPos < text.length) {
                    token = new state.Token("text", "", 0);
                    token.content = text.slice(lastPos);
                    token.level = level;
                    nodes.push(token);
                }
                // replace current node
                blockTokens[j].children = tokens = $e81e45942517393e$require$arrayReplaceAt(tokens, i, nodes);
            }
        }
    }
};

});

parcelRegister("hWbNE", function(module, exports) {
// Simple typographic replacements
//
// (c) (C) → ©
// (tm) (TM) → ™
// (r) (R) → ®
// +- → ±
// (p) (P) -> §
// ... → … (also ?.... → ?.., !.... → !..)
// ???????? → ???, !!!!! → !!!, `,,` → `,`
// -- → &ndash;, --- → &mdash;
//
"use strict";
// TODO:
// - fractionals 1/2, 1/4, 3/4 -> ½, ¼, ¾
// - miltiplication 2 x 4 -> 2 × 4
var $d0f101a3145d2207$var$RARE_RE = /\+-|\.\.|\?\?\?\?|!!!!|,,|--/;
// Workaround for phantomjs - need regex without /g flag,
// or root check will fail every second time
var $d0f101a3145d2207$var$SCOPED_ABBR_TEST_RE = /\((c|tm|r|p)\)/i;
var $d0f101a3145d2207$var$SCOPED_ABBR_RE = /\((c|tm|r|p)\)/ig;
var $d0f101a3145d2207$var$SCOPED_ABBR = {
    c: "\xa9",
    r: "\xae",
    p: "\xa7",
    tm: "\u2122"
};
function $d0f101a3145d2207$var$replaceFn(match, name) {
    return $d0f101a3145d2207$var$SCOPED_ABBR[name.toLowerCase()];
}
function $d0f101a3145d2207$var$replace_scoped(inlineTokens) {
    var i, token, inside_autolink = 0;
    for(i = inlineTokens.length - 1; i >= 0; i--){
        token = inlineTokens[i];
        if (token.type === "text" && !inside_autolink) token.content = token.content.replace($d0f101a3145d2207$var$SCOPED_ABBR_RE, $d0f101a3145d2207$var$replaceFn);
        if (token.type === "link_open" && token.info === "auto") inside_autolink--;
        if (token.type === "link_close" && token.info === "auto") inside_autolink++;
    }
}
function $d0f101a3145d2207$var$replace_rare(inlineTokens) {
    var i, token, inside_autolink = 0;
    for(i = inlineTokens.length - 1; i >= 0; i--){
        token = inlineTokens[i];
        if (token.type === "text" && !inside_autolink) {
            if ($d0f101a3145d2207$var$RARE_RE.test(token.content)) token.content = token.content.replace(/\+-/g, "\xb1")// .., ..., ....... -> …
            // but ?..... & !..... -> ?.. & !..
            .replace(/\.{2,}/g, "\u2026").replace(/([?!])…/g, "$1..").replace(/([?!]){4,}/g, "$1$1$1").replace(/,{2,}/g, ",")// em-dash
            .replace(/(^|[^-])---(?=[^-]|$)/mg, "$1\u2014")// en-dash
            .replace(/(^|\s)--(?=\s|$)/mg, "$1\u2013").replace(/(^|[^-\s])--(?=[^-\s]|$)/mg, "$1\u2013");
        }
        if (token.type === "link_open" && token.info === "auto") inside_autolink--;
        if (token.type === "link_close" && token.info === "auto") inside_autolink++;
    }
}
module.exports = function replace(state) {
    var blkIdx;
    if (!state.md.options.typographer) return;
    for(blkIdx = state.tokens.length - 1; blkIdx >= 0; blkIdx--){
        if (state.tokens[blkIdx].type !== "inline") continue;
        if ($d0f101a3145d2207$var$SCOPED_ABBR_TEST_RE.test(state.tokens[blkIdx].content)) $d0f101a3145d2207$var$replace_scoped(state.tokens[blkIdx].children);
        if ($d0f101a3145d2207$var$RARE_RE.test(state.tokens[blkIdx].content)) $d0f101a3145d2207$var$replace_rare(state.tokens[blkIdx].children);
    }
};

});

parcelRegister("hXXtU", function(module, exports) {
// Convert straight quotation marks to typographic ones
//
"use strict";

var $cNF1f = parcelRequire("cNF1f");
var $d14616218819961f$require$isWhiteSpace = $cNF1f.isWhiteSpace;

var $cNF1f = parcelRequire("cNF1f");
var $d14616218819961f$require$isPunctChar = $cNF1f.isPunctChar;

var $cNF1f = parcelRequire("cNF1f");
var $d14616218819961f$require$isMdAsciiPunct = $cNF1f.isMdAsciiPunct;
var $d14616218819961f$var$QUOTE_TEST_RE = /['"]/;
var $d14616218819961f$var$QUOTE_RE = /['"]/g;
var $d14616218819961f$var$APOSTROPHE = "\u2019"; /* ’ */ 
function $d14616218819961f$var$replaceAt(str, index, ch) {
    return str.substr(0, index) + ch + str.substr(index + 1);
}
function $d14616218819961f$var$process_inlines(tokens, state) {
    var i, token, text, t, pos, max, thisLevel, item, lastChar, nextChar, isLastPunctChar, isNextPunctChar, isLastWhiteSpace, isNextWhiteSpace, canOpen, canClose, j, isSingle, stack, openQuote, closeQuote;
    stack = [];
    for(i = 0; i < tokens.length; i++){
        token = tokens[i];
        thisLevel = tokens[i].level;
        for(j = stack.length - 1; j >= 0; j--){
            if (stack[j].level <= thisLevel) break;
        }
        stack.length = j + 1;
        if (token.type !== "text") continue;
        text = token.content;
        pos = 0;
        max = text.length;
        /*eslint no-labels:0,block-scoped-var:0*/ OUTER: while(pos < max){
            $d14616218819961f$var$QUOTE_RE.lastIndex = pos;
            t = $d14616218819961f$var$QUOTE_RE.exec(text);
            if (!t) break;
            canOpen = canClose = true;
            pos = t.index + 1;
            isSingle = t[0] === "'";
            // Find previous character,
            // default to space if it's the beginning of the line
            //
            lastChar = 0x20;
            if (t.index - 1 >= 0) lastChar = text.charCodeAt(t.index - 1);
            else for(j = i - 1; j >= 0; j--){
                if (tokens[j].type === "softbreak" || tokens[j].type === "hardbreak") break; // lastChar defaults to 0x20
                if (!tokens[j].content) continue; // should skip all tokens except 'text', 'html_inline' or 'code_inline'
                lastChar = tokens[j].content.charCodeAt(tokens[j].content.length - 1);
                break;
            }
            // Find next character,
            // default to space if it's the end of the line
            //
            nextChar = 0x20;
            if (pos < max) nextChar = text.charCodeAt(pos);
            else for(j = i + 1; j < tokens.length; j++){
                if (tokens[j].type === "softbreak" || tokens[j].type === "hardbreak") break; // nextChar defaults to 0x20
                if (!tokens[j].content) continue; // should skip all tokens except 'text', 'html_inline' or 'code_inline'
                nextChar = tokens[j].content.charCodeAt(0);
                break;
            }
            isLastPunctChar = $d14616218819961f$require$isMdAsciiPunct(lastChar) || $d14616218819961f$require$isPunctChar(String.fromCharCode(lastChar));
            isNextPunctChar = $d14616218819961f$require$isMdAsciiPunct(nextChar) || $d14616218819961f$require$isPunctChar(String.fromCharCode(nextChar));
            isLastWhiteSpace = $d14616218819961f$require$isWhiteSpace(lastChar);
            isNextWhiteSpace = $d14616218819961f$require$isWhiteSpace(nextChar);
            if (isNextWhiteSpace) canOpen = false;
            else if (isNextPunctChar) {
                if (!(isLastWhiteSpace || isLastPunctChar)) canOpen = false;
            }
            if (isLastWhiteSpace) canClose = false;
            else if (isLastPunctChar) {
                if (!(isNextWhiteSpace || isNextPunctChar)) canClose = false;
            }
            if (nextChar === 0x22 /* " */  && t[0] === '"') {
                if (lastChar >= 0x30 /* 0 */  && lastChar <= 0x39 /* 9 */ ) // special case: 1"" - count first quote as an inch
                canClose = canOpen = false;
            }
            if (canOpen && canClose) {
                // Replace quotes in the middle of punctuation sequence, but not
                // in the middle of the words, i.e.:
                //
                // 1. foo " bar " baz - not replaced
                // 2. foo-"-bar-"-baz - replaced
                // 3. foo"bar"baz     - not replaced
                //
                canOpen = isLastPunctChar;
                canClose = isNextPunctChar;
            }
            if (!canOpen && !canClose) {
                // middle of word
                if (isSingle) token.content = $d14616218819961f$var$replaceAt(token.content, t.index, $d14616218819961f$var$APOSTROPHE);
                continue;
            }
            if (canClose) // this could be a closing quote, rewind the stack to get a match
            for(j = stack.length - 1; j >= 0; j--){
                item = stack[j];
                if (stack[j].level < thisLevel) break;
                if (item.single === isSingle && stack[j].level === thisLevel) {
                    item = stack[j];
                    if (isSingle) {
                        openQuote = state.md.options.quotes[2];
                        closeQuote = state.md.options.quotes[3];
                    } else {
                        openQuote = state.md.options.quotes[0];
                        closeQuote = state.md.options.quotes[1];
                    }
                    // replace token.content *before* tokens[item.token].content,
                    // because, if they are pointing at the same token, replaceAt
                    // could mess up indices when quote length != 1
                    token.content = $d14616218819961f$var$replaceAt(token.content, t.index, closeQuote);
                    tokens[item.token].content = $d14616218819961f$var$replaceAt(tokens[item.token].content, item.pos, openQuote);
                    pos += closeQuote.length - 1;
                    if (item.token === i) pos += openQuote.length - 1;
                    text = token.content;
                    max = text.length;
                    stack.length = j;
                    continue OUTER;
                }
            }
            if (canOpen) stack.push({
                token: i,
                pos: t.index,
                single: isSingle,
                level: thisLevel
            });
            else if (canClose && isSingle) token.content = $d14616218819961f$var$replaceAt(token.content, t.index, $d14616218819961f$var$APOSTROPHE);
        }
    }
}
module.exports = function smartquotes(state) {
    /*eslint max-depth:0*/ var blkIdx;
    if (!state.md.options.typographer) return;
    for(blkIdx = state.tokens.length - 1; blkIdx >= 0; blkIdx--){
        if (state.tokens[blkIdx].type !== "inline" || !$d14616218819961f$var$QUOTE_TEST_RE.test(state.tokens[blkIdx].content)) continue;
        $d14616218819961f$var$process_inlines(state.tokens[blkIdx].children, state);
    }
};

});

parcelRegister("jmvCN", function(module, exports) {
// Core state object
//
"use strict";

var $h1S9x = parcelRequire("h1S9x");
function $e1889a65739cd74d$var$StateCore(src, md, env) {
    this.src = src;
    this.env = env;
    this.tokens = [];
    this.inlineMode = false;
    this.md = md; // link to parser instance
}
// re-export Token class to use in core rules
$e1889a65739cd74d$var$StateCore.prototype.Token = $h1S9x;
module.exports = $e1889a65739cd74d$var$StateCore;

});
parcelRegister("h1S9x", function(module, exports) {
// Token class
"use strict";
/**
 * class Token
 **/ /**
 * new Token(type, tag, nesting)
 *
 * Create new token and fill passed properties.
 **/ function $c65c8950915cb28e$var$Token(type, tag, nesting) {
    /**
   * Token#type -> String
   *
   * Type of the token (string, e.g. "paragraph_open")
   **/ this.type = type;
    /**
   * Token#tag -> String
   *
   * html tag name, e.g. "p"
   **/ this.tag = tag;
    /**
   * Token#attrs -> Array
   *
   * Html attributes. Format: `[ [ name1, value1 ], [ name2, value2 ] ]`
   **/ this.attrs = null;
    /**
   * Token#map -> Array
   *
   * Source map info. Format: `[ line_begin, line_end ]`
   **/ this.map = null;
    /**
   * Token#nesting -> Number
   *
   * Level change (number in {-1, 0, 1} set), where:
   *
   * -  `1` means the tag is opening
   * -  `0` means the tag is self-closing
   * - `-1` means the tag is closing
   **/ this.nesting = nesting;
    /**
   * Token#level -> Number
   *
   * nesting level, the same as `state.level`
   **/ this.level = 0;
    /**
   * Token#children -> Array
   *
   * An array of child nodes (inline and img tokens)
   **/ this.children = null;
    /**
   * Token#content -> String
   *
   * In a case of self-closing tag (code, html, fence, etc.),
   * it has contents of this tag.
   **/ this.content = "";
    /**
   * Token#markup -> String
   *
   * '*' or '_' for emphasis, fence string for fence, etc.
   **/ this.markup = "";
    /**
   * Token#info -> String
   *
   * Additional information:
   *
   * - Info string for "fence" tokens
   * - The value "auto" for autolink "link_open" and "link_close" tokens
   * - The string value of the item marker for ordered-list "list_item_open" tokens
   **/ this.info = "";
    /**
   * Token#meta -> Object
   *
   * A place for plugins to store an arbitrary data
   **/ this.meta = null;
    /**
   * Token#block -> Boolean
   *
   * True for block-level tokens, false for inline tokens.
   * Used in renderer to calculate line breaks
   **/ this.block = false;
    /**
   * Token#hidden -> Boolean
   *
   * If it's true, ignore this element when rendering. Used for tight lists
   * to hide paragraphs.
   **/ this.hidden = false;
}
/**
 * Token.attrIndex(name) -> Number
 *
 * Search attribute index by name.
 **/ $c65c8950915cb28e$var$Token.prototype.attrIndex = function attrIndex(name) {
    var attrs, i, len;
    if (!this.attrs) return -1;
    attrs = this.attrs;
    for(i = 0, len = attrs.length; i < len; i++){
        if (attrs[i][0] === name) return i;
    }
    return -1;
};
/**
 * Token.attrPush(attrData)
 *
 * Add `[ name, value ]` attribute to list. Init attrs if necessary
 **/ $c65c8950915cb28e$var$Token.prototype.attrPush = function attrPush(attrData) {
    if (this.attrs) this.attrs.push(attrData);
    else this.attrs = [
        attrData
    ];
};
/**
 * Token.attrSet(name, value)
 *
 * Set `name` attribute to `value`. Override old value if exists.
 **/ $c65c8950915cb28e$var$Token.prototype.attrSet = function attrSet(name, value) {
    var idx = this.attrIndex(name), attrData = [
        name,
        value
    ];
    if (idx < 0) this.attrPush(attrData);
    else this.attrs[idx] = attrData;
};
/**
 * Token.attrGet(name)
 *
 * Get the value of attribute `name`, or null if it does not exist.
 **/ $c65c8950915cb28e$var$Token.prototype.attrGet = function attrGet(name) {
    var idx = this.attrIndex(name), value = null;
    if (idx >= 0) value = this.attrs[idx][1];
    return value;
};
/**
 * Token.attrJoin(name, value)
 *
 * Join value to existing attribute via space. Or create new attribute if not
 * exists. Useful to operate with token classes.
 **/ $c65c8950915cb28e$var$Token.prototype.attrJoin = function attrJoin(name, value) {
    var idx = this.attrIndex(name);
    if (idx < 0) this.attrPush([
        name,
        value
    ]);
    else this.attrs[idx][1] = this.attrs[idx][1] + " " + value;
};
module.exports = $c65c8950915cb28e$var$Token;

});



parcelRegister("ksQT7", function(module, exports) {
/** internal
 * class ParserBlock
 *
 * Block-level tokenizer.
 **/ "use strict";

var $9bWv8 = parcelRequire("9bWv8");











var $ee5f729fe7192fd3$var$_rules = [
    // First 2 params - rule name & source. Secondary array - list of rules,
    // which can be terminated by this one.
    [
        "table",
        (parcelRequire("61PXn")),
        [
            "paragraph",
            "reference"
        ]
    ],
    [
        "code",
        (parcelRequire("3JidD"))
    ],
    [
        "fence",
        (parcelRequire("fKYv5")),
        [
            "paragraph",
            "reference",
            "blockquote",
            "list"
        ]
    ],
    [
        "blockquote",
        (parcelRequire("em2m4")),
        [
            "paragraph",
            "reference",
            "blockquote",
            "list"
        ]
    ],
    [
        "hr",
        (parcelRequire("gqcgk")),
        [
            "paragraph",
            "reference",
            "blockquote",
            "list"
        ]
    ],
    [
        "list",
        (parcelRequire("gh1di")),
        [
            "paragraph",
            "reference",
            "blockquote"
        ]
    ],
    [
        "reference",
        (parcelRequire("1p8h0"))
    ],
    [
        "html_block",
        (parcelRequire("cxiWR")),
        [
            "paragraph",
            "reference",
            "blockquote"
        ]
    ],
    [
        "heading",
        (parcelRequire("eJAfj")),
        [
            "paragraph",
            "reference",
            "blockquote"
        ]
    ],
    [
        "lheading",
        (parcelRequire("3kLp8"))
    ],
    [
        "paragraph",
        (parcelRequire("3c8A1"))
    ]
];
/**
 * new ParserBlock()
 **/ function $ee5f729fe7192fd3$var$ParserBlock() {
    /**
   * ParserBlock#ruler -> Ruler
   *
   * [[Ruler]] instance. Keep configuration of block rules.
   **/ this.ruler = new $9bWv8();
    for(var i = 0; i < $ee5f729fe7192fd3$var$_rules.length; i++)this.ruler.push($ee5f729fe7192fd3$var$_rules[i][0], $ee5f729fe7192fd3$var$_rules[i][1], {
        alt: ($ee5f729fe7192fd3$var$_rules[i][2] || []).slice()
    });
}
// Generate tokens for input range
//
$ee5f729fe7192fd3$var$ParserBlock.prototype.tokenize = function(state, startLine, endLine) {
    var ok, i, rules = this.ruler.getRules(""), len = rules.length, line = startLine, hasEmptyLines = false, maxNesting = state.md.options.maxNesting;
    while(line < endLine){
        state.line = line = state.skipEmptyLines(line);
        if (line >= endLine) break;
        // Termination condition for nested calls.
        // Nested calls currently used for blockquotes & lists
        if (state.sCount[line] < state.blkIndent) break;
        // If nesting level exceeded - skip tail to the end. That's not ordinary
        // situation and we should not care about content.
        if (state.level >= maxNesting) {
            state.line = endLine;
            break;
        }
        // Try all possible rules.
        // On success, rule should:
        //
        // - update `state.line`
        // - update `state.tokens`
        // - return true
        for(i = 0; i < len; i++){
            ok = rules[i](state, line, endLine, false);
            if (ok) break;
        }
        // set state.tight if we had an empty line before current tag
        // i.e. latest empty line should not count
        state.tight = !hasEmptyLines;
        // paragraph might "eat" one newline after it in nested lists
        if (state.isEmpty(state.line - 1)) hasEmptyLines = true;
        line = state.line;
        if (line < endLine && state.isEmpty(line)) {
            hasEmptyLines = true;
            line++;
            state.line = line;
        }
    }
};
/**
 * ParserBlock.parse(str, md, env, outTokens)
 *
 * Process input string and push block tokens into `outTokens`
 **/ $ee5f729fe7192fd3$var$ParserBlock.prototype.parse = function(src, md, env, outTokens) {
    var state;
    if (!src) return;
    state = new this.State(src, md, env, outTokens);
    this.tokenize(state, state.line, state.lineMax);
};

$ee5f729fe7192fd3$var$ParserBlock.prototype.State = (parcelRequire("hGhU8"));
module.exports = $ee5f729fe7192fd3$var$ParserBlock;

});
parcelRegister("61PXn", function(module, exports) {
// GFM table, https://github.github.com/gfm/#tables-extension-
"use strict";

var $cNF1f = parcelRequire("cNF1f");
var $463b239b2250089e$require$isSpace = $cNF1f.isSpace;
function $463b239b2250089e$var$getLine(state, line) {
    var pos = state.bMarks[line] + state.tShift[line], max = state.eMarks[line];
    return state.src.substr(pos, max - pos);
}
function $463b239b2250089e$var$escapedSplit(str) {
    var result = [], pos = 0, max = str.length, ch, isEscaped = false, lastPos = 0, current = "";
    ch = str.charCodeAt(pos);
    while(pos < max){
        if (ch === 0x7c /* | */ ) {
            if (!isEscaped) {
                // pipe separating cells, '|'
                result.push(current + str.substring(lastPos, pos));
                current = "";
                lastPos = pos + 1;
            } else {
                // escaped pipe, '\|'
                current += str.substring(lastPos, pos - 1);
                lastPos = pos;
            }
        }
        isEscaped = ch === 0x5c /* \ */ ;
        pos++;
        ch = str.charCodeAt(pos);
    }
    result.push(current + str.substring(lastPos));
    return result;
}
module.exports = function table(state, startLine, endLine, silent) {
    var ch, lineText, pos, i, l, nextLine, columns, columnCount, token, aligns, t, tableLines, tbodyLines, oldParentType, terminate, terminatorRules, firstCh, secondCh;
    // should have at least two lines
    if (startLine + 2 > endLine) return false;
    nextLine = startLine + 1;
    if (state.sCount[nextLine] < state.blkIndent) return false;
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[nextLine] - state.blkIndent >= 4) return false;
    // first character of the second line should be '|', '-', ':',
    // and no other characters are allowed but spaces;
    // basically, this is the equivalent of /^[-:|][-:|\s]*$/ regexp
    pos = state.bMarks[nextLine] + state.tShift[nextLine];
    if (pos >= state.eMarks[nextLine]) return false;
    firstCh = state.src.charCodeAt(pos++);
    if (firstCh !== 0x7C /* | */  && firstCh !== 0x2D /* - */  && firstCh !== 0x3A /* : */ ) return false;
    if (pos >= state.eMarks[nextLine]) return false;
    secondCh = state.src.charCodeAt(pos++);
    if (secondCh !== 0x7C /* | */  && secondCh !== 0x2D /* - */  && secondCh !== 0x3A /* : */  && !$463b239b2250089e$require$isSpace(secondCh)) return false;
    // if first character is '-', then second character must not be a space
    // (due to parsing ambiguity with list)
    if (firstCh === 0x2D /* - */  && $463b239b2250089e$require$isSpace(secondCh)) return false;
    while(pos < state.eMarks[nextLine]){
        ch = state.src.charCodeAt(pos);
        if (ch !== 0x7C /* | */  && ch !== 0x2D /* - */  && ch !== 0x3A /* : */  && !$463b239b2250089e$require$isSpace(ch)) return false;
        pos++;
    }
    lineText = $463b239b2250089e$var$getLine(state, startLine + 1);
    columns = lineText.split("|");
    aligns = [];
    for(i = 0; i < columns.length; i++){
        t = columns[i].trim();
        if (!t) {
            // allow empty columns before and after table, but not in between columns;
            // e.g. allow ` |---| `, disallow ` ---||--- `
            if (i === 0 || i === columns.length - 1) continue;
            else return false;
        }
        if (!/^:?-+:?$/.test(t)) return false;
        if (t.charCodeAt(t.length - 1) === 0x3A /* : */ ) aligns.push(t.charCodeAt(0) === 0x3A /* : */  ? "center" : "right");
        else if (t.charCodeAt(0) === 0x3A /* : */ ) aligns.push("left");
        else aligns.push("");
    }
    lineText = $463b239b2250089e$var$getLine(state, startLine).trim();
    if (lineText.indexOf("|") === -1) return false;
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    columns = $463b239b2250089e$var$escapedSplit(lineText);
    if (columns.length && columns[0] === "") columns.shift();
    if (columns.length && columns[columns.length - 1] === "") columns.pop();
    // header row will define an amount of columns in the entire table,
    // and align row should be exactly the same (the rest of the rows can differ)
    columnCount = columns.length;
    if (columnCount === 0 || columnCount !== aligns.length) return false;
    if (silent) return true;
    oldParentType = state.parentType;
    state.parentType = "table";
    // use 'blockquote' lists for termination because it's
    // the most similar to tables
    terminatorRules = state.md.block.ruler.getRules("blockquote");
    token = state.push("table_open", "table", 1);
    token.map = tableLines = [
        startLine,
        0
    ];
    token = state.push("thead_open", "thead", 1);
    token.map = [
        startLine,
        startLine + 1
    ];
    token = state.push("tr_open", "tr", 1);
    token.map = [
        startLine,
        startLine + 1
    ];
    for(i = 0; i < columns.length; i++){
        token = state.push("th_open", "th", 1);
        if (aligns[i]) token.attrs = [
            [
                "style",
                "text-align:" + aligns[i]
            ]
        ];
        token = state.push("inline", "", 0);
        token.content = columns[i].trim();
        token.children = [];
        token = state.push("th_close", "th", -1);
    }
    token = state.push("tr_close", "tr", -1);
    token = state.push("thead_close", "thead", -1);
    for(nextLine = startLine + 2; nextLine < endLine; nextLine++){
        if (state.sCount[nextLine] < state.blkIndent) break;
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
        lineText = $463b239b2250089e$var$getLine(state, nextLine).trim();
        if (!lineText) break;
        if (state.sCount[nextLine] - state.blkIndent >= 4) break;
        columns = $463b239b2250089e$var$escapedSplit(lineText);
        if (columns.length && columns[0] === "") columns.shift();
        if (columns.length && columns[columns.length - 1] === "") columns.pop();
        if (nextLine === startLine + 2) {
            token = state.push("tbody_open", "tbody", 1);
            token.map = tbodyLines = [
                startLine + 2,
                0
            ];
        }
        token = state.push("tr_open", "tr", 1);
        token.map = [
            nextLine,
            nextLine + 1
        ];
        for(i = 0; i < columnCount; i++){
            token = state.push("td_open", "td", 1);
            if (aligns[i]) token.attrs = [
                [
                    "style",
                    "text-align:" + aligns[i]
                ]
            ];
            token = state.push("inline", "", 0);
            token.content = columns[i] ? columns[i].trim() : "";
            token.children = [];
            token = state.push("td_close", "td", -1);
        }
        token = state.push("tr_close", "tr", -1);
    }
    if (tbodyLines) {
        token = state.push("tbody_close", "tbody", -1);
        tbodyLines[1] = nextLine;
    }
    token = state.push("table_close", "table", -1);
    tableLines[1] = nextLine;
    state.parentType = oldParentType;
    state.line = nextLine;
    return true;
};

});

parcelRegister("3JidD", function(module, exports) {
// Code block (4 spaces padded)
"use strict";
module.exports = function code(state, startLine, endLine /*, silent*/ ) {
    var nextLine, last, token;
    if (state.sCount[startLine] - state.blkIndent < 4) return false;
    last = nextLine = startLine + 1;
    while(nextLine < endLine){
        if (state.isEmpty(nextLine)) {
            nextLine++;
            continue;
        }
        if (state.sCount[nextLine] - state.blkIndent >= 4) {
            nextLine++;
            last = nextLine;
            continue;
        }
        break;
    }
    state.line = last;
    token = state.push("code_block", "code", 0);
    token.content = state.getLines(startLine, last, 4 + state.blkIndent, false) + "\n";
    token.map = [
        startLine,
        state.line
    ];
    return true;
};

});

parcelRegister("fKYv5", function(module, exports) {
// fences (``` lang, ~~~ lang)
"use strict";
module.exports = function fence(state, startLine, endLine, silent) {
    var marker, len, params, nextLine, mem, token, markup, haveEndMarker = false, pos = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    if (pos + 3 > max) return false;
    marker = state.src.charCodeAt(pos);
    if (marker !== 0x7E /* ~ */  && marker !== 0x60 /* ` */ ) return false;
    // scan marker length
    mem = pos;
    pos = state.skipChars(pos, marker);
    len = pos - mem;
    if (len < 3) return false;
    markup = state.src.slice(mem, pos);
    params = state.src.slice(pos, max);
    if (marker === 0x60 /* ` */ ) {
        if (params.indexOf(String.fromCharCode(marker)) >= 0) return false;
    }
    // Since start is found, we can report success here in validation mode
    if (silent) return true;
    // search end of block
    nextLine = startLine;
    for(;;){
        nextLine++;
        if (nextLine >= endLine) break;
        pos = mem = state.bMarks[nextLine] + state.tShift[nextLine];
        max = state.eMarks[nextLine];
        if (pos < max && state.sCount[nextLine] < state.blkIndent) break;
        if (state.src.charCodeAt(pos) !== marker) continue;
        if (state.sCount[nextLine] - state.blkIndent >= 4) continue;
        pos = state.skipChars(pos, marker);
        // closing code fence must be at least as long as the opening one
        if (pos - mem < len) continue;
        // make sure tail has spaces only
        pos = state.skipSpaces(pos);
        if (pos < max) continue;
        haveEndMarker = true;
        break;
    }
    // If a fence has heading spaces, they should be removed from its inner block
    len = state.sCount[startLine];
    state.line = nextLine + (haveEndMarker ? 1 : 0);
    token = state.push("fence", "code", 0);
    token.info = params;
    token.content = state.getLines(startLine + 1, nextLine, len, true);
    token.markup = markup;
    token.map = [
        startLine,
        state.line
    ];
    return true;
};

});

parcelRegister("em2m4", function(module, exports) {
// Block quotes
"use strict";

var $cNF1f = parcelRequire("cNF1f");
var $a734f267363dc462$require$isSpace = $cNF1f.isSpace;
module.exports = function blockquote(state, startLine, endLine, silent) {
    var adjustTab, ch, i, initial, l, lastLineEmpty, lines, nextLine, offset, oldBMarks, oldBSCount, oldIndent, oldParentType, oldSCount, oldTShift, spaceAfterMarker, terminate, terminatorRules, token, isOutdented, oldLineMax = state.lineMax, pos = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    // check the block quote marker
    if (state.src.charCodeAt(pos++) !== 0x3E /* > */ ) return false;
    // we know that it's going to be a valid blockquote,
    // so no point trying to find the end of it in silent mode
    if (silent) return true;
    // set offset past spaces and ">"
    initial = offset = state.sCount[startLine] + 1;
    // skip one optional space after '>'
    if (state.src.charCodeAt(pos) === 0x20 /* space */ ) {
        // ' >   test '
        //     ^ -- position start of line here:
        pos++;
        initial++;
        offset++;
        adjustTab = false;
        spaceAfterMarker = true;
    } else if (state.src.charCodeAt(pos) === 0x09 /* tab */ ) {
        spaceAfterMarker = true;
        if ((state.bsCount[startLine] + offset) % 4 === 3) {
            // '  >\t  test '
            //       ^ -- position start of line here (tab has width===1)
            pos++;
            initial++;
            offset++;
            adjustTab = false;
        } else // ' >\t  test '
        //    ^ -- position start of line here + shift bsCount slightly
        //         to make extra space appear
        adjustTab = true;
    } else spaceAfterMarker = false;
    oldBMarks = [
        state.bMarks[startLine]
    ];
    state.bMarks[startLine] = pos;
    while(pos < max){
        ch = state.src.charCodeAt(pos);
        if ($a734f267363dc462$require$isSpace(ch)) {
            if (ch === 0x09) offset += 4 - (offset + state.bsCount[startLine] + (adjustTab ? 1 : 0)) % 4;
            else offset++;
        } else break;
        pos++;
    }
    oldBSCount = [
        state.bsCount[startLine]
    ];
    state.bsCount[startLine] = state.sCount[startLine] + 1 + (spaceAfterMarker ? 1 : 0);
    lastLineEmpty = pos >= max;
    oldSCount = [
        state.sCount[startLine]
    ];
    state.sCount[startLine] = offset - initial;
    oldTShift = [
        state.tShift[startLine]
    ];
    state.tShift[startLine] = pos - state.bMarks[startLine];
    terminatorRules = state.md.block.ruler.getRules("blockquote");
    oldParentType = state.parentType;
    state.parentType = "blockquote";
    // Search the end of the block
    //
    // Block ends with either:
    //  1. an empty line outside:
    //     ```
    //     > test
    //
    //     ```
    //  2. an empty line inside:
    //     ```
    //     >
    //     test
    //     ```
    //  3. another tag:
    //     ```
    //     > test
    //      - - -
    //     ```
    for(nextLine = startLine + 1; nextLine < endLine; nextLine++){
        // check if it's outdented, i.e. it's inside list item and indented
        // less than said list item:
        //
        // ```
        // 1. anything
        //    > current blockquote
        // 2. checking this line
        // ```
        isOutdented = state.sCount[nextLine] < state.blkIndent;
        pos = state.bMarks[nextLine] + state.tShift[nextLine];
        max = state.eMarks[nextLine];
        if (pos >= max) break;
        if (state.src.charCodeAt(pos++) === 0x3E /* > */  && !isOutdented) {
            // This line is inside the blockquote.
            // set offset past spaces and ">"
            initial = offset = state.sCount[nextLine] + 1;
            // skip one optional space after '>'
            if (state.src.charCodeAt(pos) === 0x20 /* space */ ) {
                // ' >   test '
                //     ^ -- position start of line here:
                pos++;
                initial++;
                offset++;
                adjustTab = false;
                spaceAfterMarker = true;
            } else if (state.src.charCodeAt(pos) === 0x09 /* tab */ ) {
                spaceAfterMarker = true;
                if ((state.bsCount[nextLine] + offset) % 4 === 3) {
                    // '  >\t  test '
                    //       ^ -- position start of line here (tab has width===1)
                    pos++;
                    initial++;
                    offset++;
                    adjustTab = false;
                } else // ' >\t  test '
                //    ^ -- position start of line here + shift bsCount slightly
                //         to make extra space appear
                adjustTab = true;
            } else spaceAfterMarker = false;
            oldBMarks.push(state.bMarks[nextLine]);
            state.bMarks[nextLine] = pos;
            while(pos < max){
                ch = state.src.charCodeAt(pos);
                if ($a734f267363dc462$require$isSpace(ch)) {
                    if (ch === 0x09) offset += 4 - (offset + state.bsCount[nextLine] + (adjustTab ? 1 : 0)) % 4;
                    else offset++;
                } else break;
                pos++;
            }
            lastLineEmpty = pos >= max;
            oldBSCount.push(state.bsCount[nextLine]);
            state.bsCount[nextLine] = state.sCount[nextLine] + 1 + (spaceAfterMarker ? 1 : 0);
            oldSCount.push(state.sCount[nextLine]);
            state.sCount[nextLine] = offset - initial;
            oldTShift.push(state.tShift[nextLine]);
            state.tShift[nextLine] = pos - state.bMarks[nextLine];
            continue;
        }
        // Case 2: line is not inside the blockquote, and the last line was empty.
        if (lastLineEmpty) break;
        // Case 3: another tag found.
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) {
            // Quirk to enforce "hard termination mode" for paragraphs;
            // normally if you call `tokenize(state, startLine, nextLine)`,
            // paragraphs will look below nextLine for paragraph continuation,
            // but if blockquote is terminated by another tag, they shouldn't
            state.lineMax = nextLine;
            if (state.blkIndent !== 0) {
                // state.blkIndent was non-zero, we now set it to zero,
                // so we need to re-calculate all offsets to appear as
                // if indent wasn't changed
                oldBMarks.push(state.bMarks[nextLine]);
                oldBSCount.push(state.bsCount[nextLine]);
                oldTShift.push(state.tShift[nextLine]);
                oldSCount.push(state.sCount[nextLine]);
                state.sCount[nextLine] -= state.blkIndent;
            }
            break;
        }
        oldBMarks.push(state.bMarks[nextLine]);
        oldBSCount.push(state.bsCount[nextLine]);
        oldTShift.push(state.tShift[nextLine]);
        oldSCount.push(state.sCount[nextLine]);
        // A negative indentation means that this is a paragraph continuation
        //
        state.sCount[nextLine] = -1;
    }
    oldIndent = state.blkIndent;
    state.blkIndent = 0;
    token = state.push("blockquote_open", "blockquote", 1);
    token.markup = ">";
    token.map = lines = [
        startLine,
        0
    ];
    state.md.block.tokenize(state, startLine, nextLine);
    token = state.push("blockquote_close", "blockquote", -1);
    token.markup = ">";
    state.lineMax = oldLineMax;
    state.parentType = oldParentType;
    lines[1] = state.line;
    // Restore original tShift; this might not be necessary since the parser
    // has already been here, but just to make sure we can do that.
    for(i = 0; i < oldTShift.length; i++){
        state.bMarks[i + startLine] = oldBMarks[i];
        state.tShift[i + startLine] = oldTShift[i];
        state.sCount[i + startLine] = oldSCount[i];
        state.bsCount[i + startLine] = oldBSCount[i];
    }
    state.blkIndent = oldIndent;
    return true;
};

});

parcelRegister("gqcgk", function(module, exports) {
// Horizontal rule
"use strict";

var $cNF1f = parcelRequire("cNF1f");
var $bf48961491fe2d88$require$isSpace = $cNF1f.isSpace;
module.exports = function hr(state, startLine, endLine, silent) {
    var marker, cnt, ch, token, pos = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    marker = state.src.charCodeAt(pos++);
    // Check hr marker
    if (marker !== 0x2A /* * */  && marker !== 0x2D /* - */  && marker !== 0x5F /* _ */ ) return false;
    // markers can be mixed with spaces, but there should be at least 3 of them
    cnt = 1;
    while(pos < max){
        ch = state.src.charCodeAt(pos++);
        if (ch !== marker && !$bf48961491fe2d88$require$isSpace(ch)) return false;
        if (ch === marker) cnt++;
    }
    if (cnt < 3) return false;
    if (silent) return true;
    state.line = startLine + 1;
    token = state.push("hr", "hr", 0);
    token.map = [
        startLine,
        state.line
    ];
    token.markup = Array(cnt + 1).join(String.fromCharCode(marker));
    return true;
};

});

parcelRegister("gh1di", function(module, exports) {
// Lists
"use strict";

var $cNF1f = parcelRequire("cNF1f");
var $bd8f2cdc538279d1$require$isSpace = $cNF1f.isSpace;
// Search `[-+*][\n ]`, returns next pos after marker on success
// or -1 on fail.
function $bd8f2cdc538279d1$var$skipBulletListMarker(state, startLine) {
    var marker, pos, max, ch;
    pos = state.bMarks[startLine] + state.tShift[startLine];
    max = state.eMarks[startLine];
    marker = state.src.charCodeAt(pos++);
    // Check bullet
    if (marker !== 0x2A /* * */  && marker !== 0x2D /* - */  && marker !== 0x2B /* + */ ) return -1;
    if (pos < max) {
        ch = state.src.charCodeAt(pos);
        if (!$bd8f2cdc538279d1$require$isSpace(ch)) // " -test " - is not a list item
        return -1;
    }
    return pos;
}
// Search `\d+[.)][\n ]`, returns next pos after marker on success
// or -1 on fail.
function $bd8f2cdc538279d1$var$skipOrderedListMarker(state, startLine) {
    var ch, start = state.bMarks[startLine] + state.tShift[startLine], pos = start, max = state.eMarks[startLine];
    // List marker should have at least 2 chars (digit + dot)
    if (pos + 1 >= max) return -1;
    ch = state.src.charCodeAt(pos++);
    if (ch < 0x30 /* 0 */  || ch > 0x39 /* 9 */ ) return -1;
    for(;;){
        // EOL -> fail
        if (pos >= max) return -1;
        ch = state.src.charCodeAt(pos++);
        if (ch >= 0x30 /* 0 */  && ch <= 0x39 /* 9 */ ) {
            // List marker should have no more than 9 digits
            // (prevents integer overflow in browsers)
            if (pos - start >= 10) return -1;
            continue;
        }
        // found valid marker
        if (ch === 0x29 /* ) */  || ch === 0x2e /* . */ ) break;
        return -1;
    }
    if (pos < max) {
        ch = state.src.charCodeAt(pos);
        if (!$bd8f2cdc538279d1$require$isSpace(ch)) // " 1.test " - is not a list item
        return -1;
    }
    return pos;
}
function $bd8f2cdc538279d1$var$markTightParagraphs(state, idx) {
    var i, l, level = state.level + 2;
    for(i = idx + 2, l = state.tokens.length - 2; i < l; i++)if (state.tokens[i].level === level && state.tokens[i].type === "paragraph_open") {
        state.tokens[i + 2].hidden = true;
        state.tokens[i].hidden = true;
        i += 2;
    }
}
module.exports = function list(state, startLine, endLine, silent) {
    var ch, contentStart, i, indent, indentAfterMarker, initial, isOrdered, itemLines, l, listLines, listTokIdx, markerCharCode, markerValue, max, nextLine, offset, oldListIndent, oldParentType, oldSCount, oldTShift, oldTight, pos, posAfterMarker, prevEmptyEnd, start, terminate, terminatorRules, token, isTerminatingParagraph = false, tight = true;
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    // Special case:
    //  - item 1
    //   - item 2
    //    - item 3
    //     - item 4
    //      - this one is a paragraph continuation
    if (state.listIndent >= 0 && state.sCount[startLine] - state.listIndent >= 4 && state.sCount[startLine] < state.blkIndent) return false;
    // limit conditions when list can interrupt
    // a paragraph (validation mode only)
    if (silent && state.parentType === "paragraph") // Next list item should still terminate previous list item;
    //
    // This code can fail if plugins use blkIndent as well as lists,
    // but I hope the spec gets fixed long before that happens.
    //
    {
        if (state.sCount[startLine] >= state.blkIndent) isTerminatingParagraph = true;
    }
    // Detect list type and position after marker
    if ((posAfterMarker = $bd8f2cdc538279d1$var$skipOrderedListMarker(state, startLine)) >= 0) {
        isOrdered = true;
        start = state.bMarks[startLine] + state.tShift[startLine];
        markerValue = Number(state.src.slice(start, posAfterMarker - 1));
        // If we're starting a new ordered list right after
        // a paragraph, it should start with 1.
        if (isTerminatingParagraph && markerValue !== 1) return false;
    } else if ((posAfterMarker = $bd8f2cdc538279d1$var$skipBulletListMarker(state, startLine)) >= 0) isOrdered = false;
    else return false;
    // If we're starting a new unordered list right after
    // a paragraph, first line should not be empty.
    if (isTerminatingParagraph) {
        if (state.skipSpaces(posAfterMarker) >= state.eMarks[startLine]) return false;
    }
    // We should terminate list on style change. Remember first one to compare.
    markerCharCode = state.src.charCodeAt(posAfterMarker - 1);
    // For validation mode we can terminate immediately
    if (silent) return true;
    // Start list
    listTokIdx = state.tokens.length;
    if (isOrdered) {
        token = state.push("ordered_list_open", "ol", 1);
        if (markerValue !== 1) token.attrs = [
            [
                "start",
                markerValue
            ]
        ];
    } else token = state.push("bullet_list_open", "ul", 1);
    token.map = listLines = [
        startLine,
        0
    ];
    token.markup = String.fromCharCode(markerCharCode);
    //
    // Iterate list items
    //
    nextLine = startLine;
    prevEmptyEnd = false;
    terminatorRules = state.md.block.ruler.getRules("list");
    oldParentType = state.parentType;
    state.parentType = "list";
    while(nextLine < endLine){
        pos = posAfterMarker;
        max = state.eMarks[nextLine];
        initial = offset = state.sCount[nextLine] + posAfterMarker - (state.bMarks[startLine] + state.tShift[startLine]);
        while(pos < max){
            ch = state.src.charCodeAt(pos);
            if (ch === 0x09) offset += 4 - (offset + state.bsCount[nextLine]) % 4;
            else if (ch === 0x20) offset++;
            else break;
            pos++;
        }
        contentStart = pos;
        if (contentStart >= max) // trimming space in "-    \n  3" case, indent is 1 here
        indentAfterMarker = 1;
        else indentAfterMarker = offset - initial;
        // If we have more than 4 spaces, the indent is 1
        // (the rest is just indented code block)
        if (indentAfterMarker > 4) indentAfterMarker = 1;
        // "  -  test"
        //  ^^^^^ - calculating total length of this thing
        indent = initial + indentAfterMarker;
        // Run subparser & write tokens
        token = state.push("list_item_open", "li", 1);
        token.markup = String.fromCharCode(markerCharCode);
        token.map = itemLines = [
            startLine,
            0
        ];
        if (isOrdered) token.info = state.src.slice(start, posAfterMarker - 1);
        // change current state, then restore it after parser subcall
        oldTight = state.tight;
        oldTShift = state.tShift[startLine];
        oldSCount = state.sCount[startLine];
        //  - example list
        // ^ listIndent position will be here
        //   ^ blkIndent position will be here
        //
        oldListIndent = state.listIndent;
        state.listIndent = state.blkIndent;
        state.blkIndent = indent;
        state.tight = true;
        state.tShift[startLine] = contentStart - state.bMarks[startLine];
        state.sCount[startLine] = offset;
        if (contentStart >= max && state.isEmpty(startLine + 1)) // workaround for this case
        // (list item is empty, list terminates before "foo"):
        // ~~~~~~~~
        //   -
        //
        //     foo
        // ~~~~~~~~
        state.line = Math.min(state.line + 2, endLine);
        else state.md.block.tokenize(state, startLine, endLine, true);
        // If any of list item is tight, mark list as tight
        if (!state.tight || prevEmptyEnd) tight = false;
        // Item become loose if finish with empty line,
        // but we should filter last element, because it means list finish
        prevEmptyEnd = state.line - startLine > 1 && state.isEmpty(state.line - 1);
        state.blkIndent = state.listIndent;
        state.listIndent = oldListIndent;
        state.tShift[startLine] = oldTShift;
        state.sCount[startLine] = oldSCount;
        state.tight = oldTight;
        token = state.push("list_item_close", "li", -1);
        token.markup = String.fromCharCode(markerCharCode);
        nextLine = startLine = state.line;
        itemLines[1] = nextLine;
        contentStart = state.bMarks[startLine];
        if (nextLine >= endLine) break;
        //
        // Try to check if list is terminated or continued.
        //
        if (state.sCount[nextLine] < state.blkIndent) break;
        // if it's indented more than 3 spaces, it should be a code block
        if (state.sCount[startLine] - state.blkIndent >= 4) break;
        // fail if terminating block found
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
        // fail if list has another type
        if (isOrdered) {
            posAfterMarker = $bd8f2cdc538279d1$var$skipOrderedListMarker(state, nextLine);
            if (posAfterMarker < 0) break;
            start = state.bMarks[nextLine] + state.tShift[nextLine];
        } else {
            posAfterMarker = $bd8f2cdc538279d1$var$skipBulletListMarker(state, nextLine);
            if (posAfterMarker < 0) break;
        }
        if (markerCharCode !== state.src.charCodeAt(posAfterMarker - 1)) break;
    }
    // Finalize list
    if (isOrdered) token = state.push("ordered_list_close", "ol", -1);
    else token = state.push("bullet_list_close", "ul", -1);
    token.markup = String.fromCharCode(markerCharCode);
    listLines[1] = nextLine;
    state.line = nextLine;
    state.parentType = oldParentType;
    // mark paragraphs tight if needed
    if (tight) $bd8f2cdc538279d1$var$markTightParagraphs(state, listTokIdx);
    return true;
};

});

parcelRegister("1p8h0", function(module, exports) {
"use strict";

var $cNF1f = parcelRequire("cNF1f");
var $105e8b2646d2a2ae$require$normalizeReference = $cNF1f.normalizeReference;

var $cNF1f = parcelRequire("cNF1f");
var $105e8b2646d2a2ae$require$isSpace = $cNF1f.isSpace;
module.exports = function reference(state, startLine, _endLine, silent) {
    var ch, destEndPos, destEndLineNo, endLine, href, i, l, label, labelEnd, oldParentType, res, start, str, terminate, terminatorRules, title, lines = 0, pos = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine], nextLine = startLine + 1;
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    if (state.src.charCodeAt(pos) !== 0x5B /* [ */ ) return false;
    // Simple check to quickly interrupt scan on [link](url) at the start of line.
    // Can be useful on practice: https://github.com/markdown-it/markdown-it/issues/54
    while(++pos < max)if (state.src.charCodeAt(pos) === 0x5D /* ] */  && state.src.charCodeAt(pos - 1) !== 0x5C /* \ */ ) {
        if (pos + 1 === max) return false;
        if (state.src.charCodeAt(pos + 1) !== 0x3A /* : */ ) return false;
        break;
    }
    endLine = state.lineMax;
    // jump line-by-line until empty one or EOF
    terminatorRules = state.md.block.ruler.getRules("reference");
    oldParentType = state.parentType;
    state.parentType = "reference";
    for(; nextLine < endLine && !state.isEmpty(nextLine); nextLine++){
        // this would be a code block normally, but after paragraph
        // it's considered a lazy continuation regardless of what's there
        if (state.sCount[nextLine] - state.blkIndent > 3) continue;
        // quirk for blockquotes, this line should already be checked by that rule
        if (state.sCount[nextLine] < 0) continue;
        // Some tags can terminate paragraph without empty line.
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
    }
    str = state.getLines(startLine, nextLine, state.blkIndent, false).trim();
    max = str.length;
    for(pos = 1; pos < max; pos++){
        ch = str.charCodeAt(pos);
        if (ch === 0x5B /* [ */ ) return false;
        else if (ch === 0x5D /* ] */ ) {
            labelEnd = pos;
            break;
        } else if (ch === 0x0A /* \n */ ) lines++;
        else if (ch === 0x5C /* \ */ ) {
            pos++;
            if (pos < max && str.charCodeAt(pos) === 0x0A) lines++;
        }
    }
    if (labelEnd < 0 || str.charCodeAt(labelEnd + 1) !== 0x3A /* : */ ) return false;
    // [label]:   destination   'title'
    //         ^^^ skip optional whitespace here
    for(pos = labelEnd + 2; pos < max; pos++){
        ch = str.charCodeAt(pos);
        if (ch === 0x0A) lines++;
        else if ($105e8b2646d2a2ae$require$isSpace(ch)) ;
        else break;
    }
    // [label]:   destination   'title'
    //            ^^^^^^^^^^^ parse this
    res = state.md.helpers.parseLinkDestination(str, pos, max);
    if (!res.ok) return false;
    href = state.md.normalizeLink(res.str);
    if (!state.md.validateLink(href)) return false;
    pos = res.pos;
    lines += res.lines;
    // save cursor state, we could require to rollback later
    destEndPos = pos;
    destEndLineNo = lines;
    // [label]:   destination   'title'
    //                       ^^^ skipping those spaces
    start = pos;
    for(; pos < max; pos++){
        ch = str.charCodeAt(pos);
        if (ch === 0x0A) lines++;
        else if ($105e8b2646d2a2ae$require$isSpace(ch)) ;
        else break;
    }
    // [label]:   destination   'title'
    //                          ^^^^^^^ parse this
    res = state.md.helpers.parseLinkTitle(str, pos, max);
    if (pos < max && start !== pos && res.ok) {
        title = res.str;
        pos = res.pos;
        lines += res.lines;
    } else {
        title = "";
        pos = destEndPos;
        lines = destEndLineNo;
    }
    // skip trailing spaces until the rest of the line
    while(pos < max){
        ch = str.charCodeAt(pos);
        if (!$105e8b2646d2a2ae$require$isSpace(ch)) break;
        pos++;
    }
    if (pos < max && str.charCodeAt(pos) !== 0x0A) {
        if (title) {
            // garbage at the end of the line after title,
            // but it could still be a valid reference if we roll back
            title = "";
            pos = destEndPos;
            lines = destEndLineNo;
            while(pos < max){
                ch = str.charCodeAt(pos);
                if (!$105e8b2646d2a2ae$require$isSpace(ch)) break;
                pos++;
            }
        }
    }
    if (pos < max && str.charCodeAt(pos) !== 0x0A) // garbage at the end of the line
    return false;
    label = $105e8b2646d2a2ae$require$normalizeReference(str.slice(1, labelEnd));
    if (!label) // CommonMark 0.20 disallows empty labels
    return false;
    // Reference can not terminate anything. This check is for safety only.
    /*istanbul ignore if*/ if (silent) return true;
    if (typeof state.env.references === "undefined") state.env.references = {};
    if (typeof state.env.references[label] === "undefined") state.env.references[label] = {
        title: title,
        href: href
    };
    state.parentType = oldParentType;
    state.line = startLine + lines + 1;
    return true;
};

});

parcelRegister("cxiWR", function(module, exports) {
// HTML block
"use strict";

var $dJpCM = parcelRequire("dJpCM");

var $kVzDW = parcelRequire("kVzDW");
var $920743d86dda92bc$require$HTML_OPEN_CLOSE_TAG_RE = $kVzDW.HTML_OPEN_CLOSE_TAG_RE;
// An array of opening and corresponding closing sequences for html tags,
// last argument defines whether it can terminate a paragraph or not
//
var $920743d86dda92bc$var$HTML_SEQUENCES = [
    [
        /^<(script|pre|style|textarea)(?=(\s|>|$))/i,
        /<\/(script|pre|style|textarea)>/i,
        true
    ],
    [
        /^<!--/,
        /-->/,
        true
    ],
    [
        /^<\?/,
        /\?>/,
        true
    ],
    [
        /^<![A-Z]/,
        />/,
        true
    ],
    [
        /^<!\[CDATA\[/,
        /\]\]>/,
        true
    ],
    [
        new RegExp("^</?(" + $dJpCM.join("|") + ")(?=(\\s|/?>|$))", "i"),
        /^$/,
        true
    ],
    [
        new RegExp($920743d86dda92bc$require$HTML_OPEN_CLOSE_TAG_RE.source + "\\s*$"),
        /^$/,
        false
    ]
];
module.exports = function html_block(state, startLine, endLine, silent) {
    var i, nextLine, token, lineText, pos = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    if (!state.md.options.html) return false;
    if (state.src.charCodeAt(pos) !== 0x3C /* < */ ) return false;
    lineText = state.src.slice(pos, max);
    for(i = 0; i < $920743d86dda92bc$var$HTML_SEQUENCES.length; i++){
        if ($920743d86dda92bc$var$HTML_SEQUENCES[i][0].test(lineText)) break;
    }
    if (i === $920743d86dda92bc$var$HTML_SEQUENCES.length) return false;
    if (silent) // true if this sequence can be a terminator, false otherwise
    return $920743d86dda92bc$var$HTML_SEQUENCES[i][2];
    nextLine = startLine + 1;
    // If we are here - we detected HTML block.
    // Let's roll down till block end.
    if (!$920743d86dda92bc$var$HTML_SEQUENCES[i][1].test(lineText)) for(; nextLine < endLine; nextLine++){
        if (state.sCount[nextLine] < state.blkIndent) break;
        pos = state.bMarks[nextLine] + state.tShift[nextLine];
        max = state.eMarks[nextLine];
        lineText = state.src.slice(pos, max);
        if ($920743d86dda92bc$var$HTML_SEQUENCES[i][1].test(lineText)) {
            if (lineText.length !== 0) nextLine++;
            break;
        }
    }
    state.line = nextLine;
    token = state.push("html_block", "", 0);
    token.map = [
        startLine,
        nextLine
    ];
    token.content = state.getLines(startLine, nextLine, state.blkIndent, true);
    return true;
};

});
parcelRegister("dJpCM", function(module, exports) {
// List of valid html blocks names, accorting to commonmark spec
// http://jgm.github.io/CommonMark/spec.html#html-blocks
"use strict";
module.exports = [
    "address",
    "article",
    "aside",
    "base",
    "basefont",
    "blockquote",
    "body",
    "caption",
    "center",
    "col",
    "colgroup",
    "dd",
    "details",
    "dialog",
    "dir",
    "div",
    "dl",
    "dt",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "frame",
    "frameset",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hr",
    "html",
    "iframe",
    "legend",
    "li",
    "link",
    "main",
    "menu",
    "menuitem",
    "nav",
    "noframes",
    "ol",
    "optgroup",
    "option",
    "p",
    "param",
    "section",
    "source",
    "summary",
    "table",
    "tbody",
    "td",
    "tfoot",
    "th",
    "thead",
    "title",
    "tr",
    "track",
    "ul"
];

});

parcelRegister("kVzDW", function(module, exports) {

$parcel$export(module.exports, "HTML_TAG_RE", () => $f3c4c77f82149845$export$6db61d2c3a16e419, (v) => $f3c4c77f82149845$export$6db61d2c3a16e419 = v);
$parcel$export(module.exports, "HTML_OPEN_CLOSE_TAG_RE", () => $f3c4c77f82149845$export$cd48660d06f74639, (v) => $f3c4c77f82149845$export$cd48660d06f74639 = v);
// Regexps to match html elements
var $f3c4c77f82149845$export$6db61d2c3a16e419;
var $f3c4c77f82149845$export$cd48660d06f74639;
"use strict";
var $f3c4c77f82149845$var$attr_name = "[a-zA-Z_:][a-zA-Z0-9:._-]*";
var $f3c4c77f82149845$var$unquoted = "[^\"'=<>`\\x00-\\x20]+";
var $f3c4c77f82149845$var$single_quoted = "'[^']*'";
var $f3c4c77f82149845$var$double_quoted = '"[^"]*"';
var $f3c4c77f82149845$var$attr_value = "(?:" + $f3c4c77f82149845$var$unquoted + "|" + $f3c4c77f82149845$var$single_quoted + "|" + $f3c4c77f82149845$var$double_quoted + ")";
var $f3c4c77f82149845$var$attribute = "(?:\\s+" + $f3c4c77f82149845$var$attr_name + "(?:\\s*=\\s*" + $f3c4c77f82149845$var$attr_value + ")?)";
var $f3c4c77f82149845$var$open_tag = "<[A-Za-z][A-Za-z0-9\\-]*" + $f3c4c77f82149845$var$attribute + "*\\s*\\/?>";
var $f3c4c77f82149845$var$close_tag = "<\\/[A-Za-z][A-Za-z0-9\\-]*\\s*>";
var $f3c4c77f82149845$var$comment = "<!---->|<!--(?:-?[^>-])(?:-?[^-])*-->";
var $f3c4c77f82149845$var$processing = "<[?][\\s\\S]*?[?]>";
var $f3c4c77f82149845$var$declaration = "<![A-Z]+\\s+[^>]*>";
var $f3c4c77f82149845$var$cdata = "<!\\[CDATA\\[[\\s\\S]*?\\]\\]>";
var $f3c4c77f82149845$var$HTML_TAG_RE = new RegExp("^(?:" + $f3c4c77f82149845$var$open_tag + "|" + $f3c4c77f82149845$var$close_tag + "|" + $f3c4c77f82149845$var$comment + "|" + $f3c4c77f82149845$var$processing + "|" + $f3c4c77f82149845$var$declaration + "|" + $f3c4c77f82149845$var$cdata + ")");
var $f3c4c77f82149845$var$HTML_OPEN_CLOSE_TAG_RE = new RegExp("^(?:" + $f3c4c77f82149845$var$open_tag + "|" + $f3c4c77f82149845$var$close_tag + ")");
$f3c4c77f82149845$export$6db61d2c3a16e419 = $f3c4c77f82149845$var$HTML_TAG_RE;
$f3c4c77f82149845$export$cd48660d06f74639 = $f3c4c77f82149845$var$HTML_OPEN_CLOSE_TAG_RE;

});


parcelRegister("eJAfj", function(module, exports) {
// heading (#, ##, ...)
"use strict";

var $cNF1f = parcelRequire("cNF1f");
var $aba1625e67b4b17a$require$isSpace = $cNF1f.isSpace;
module.exports = function heading(state, startLine, endLine, silent) {
    var ch, level, tmp, token, pos = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    ch = state.src.charCodeAt(pos);
    if (ch !== 0x23 /* # */  || pos >= max) return false;
    // count heading level
    level = 1;
    ch = state.src.charCodeAt(++pos);
    while(ch === 0x23 /* # */  && pos < max && level <= 6){
        level++;
        ch = state.src.charCodeAt(++pos);
    }
    if (level > 6 || pos < max && !$aba1625e67b4b17a$require$isSpace(ch)) return false;
    if (silent) return true;
    // Let's cut tails like '    ###  ' from the end of string
    max = state.skipSpacesBack(max, pos);
    tmp = state.skipCharsBack(max, 0x23, pos); // #
    if (tmp > pos && $aba1625e67b4b17a$require$isSpace(state.src.charCodeAt(tmp - 1))) max = tmp;
    state.line = startLine + 1;
    token = state.push("heading_open", "h" + String(level), 1);
    token.markup = "########".slice(0, level);
    token.map = [
        startLine,
        state.line
    ];
    token = state.push("inline", "", 0);
    token.content = state.src.slice(pos, max).trim();
    token.map = [
        startLine,
        state.line
    ];
    token.children = [];
    token = state.push("heading_close", "h" + String(level), -1);
    token.markup = "########".slice(0, level);
    return true;
};

});

parcelRegister("3kLp8", function(module, exports) {
// lheading (---, ===)
"use strict";
module.exports = function lheading(state, startLine, endLine /*, silent*/ ) {
    var content, terminate, i, l, token, pos, max, level, marker, nextLine = startLine + 1, oldParentType, terminatorRules = state.md.block.ruler.getRules("paragraph");
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    oldParentType = state.parentType;
    state.parentType = "paragraph"; // use paragraph to match terminatorRules
    // jump line-by-line until empty one or EOF
    for(; nextLine < endLine && !state.isEmpty(nextLine); nextLine++){
        // this would be a code block normally, but after paragraph
        // it's considered a lazy continuation regardless of what's there
        if (state.sCount[nextLine] - state.blkIndent > 3) continue;
        //
        // Check for underline in setext header
        //
        if (state.sCount[nextLine] >= state.blkIndent) {
            pos = state.bMarks[nextLine] + state.tShift[nextLine];
            max = state.eMarks[nextLine];
            if (pos < max) {
                marker = state.src.charCodeAt(pos);
                if (marker === 0x2D /* - */  || marker === 0x3D /* = */ ) {
                    pos = state.skipChars(pos, marker);
                    pos = state.skipSpaces(pos);
                    if (pos >= max) {
                        level = marker === 0x3D /* = */  ? 1 : 2;
                        break;
                    }
                }
            }
        }
        // quirk for blockquotes, this line should already be checked by that rule
        if (state.sCount[nextLine] < 0) continue;
        // Some tags can terminate paragraph without empty line.
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
    }
    if (!level) // Didn't find valid underline
    return false;
    content = state.getLines(startLine, nextLine, state.blkIndent, false).trim();
    state.line = nextLine + 1;
    token = state.push("heading_open", "h" + String(level), 1);
    token.markup = String.fromCharCode(marker);
    token.map = [
        startLine,
        state.line
    ];
    token = state.push("inline", "", 0);
    token.content = content;
    token.map = [
        startLine,
        state.line - 1
    ];
    token.children = [];
    token = state.push("heading_close", "h" + String(level), -1);
    token.markup = String.fromCharCode(marker);
    state.parentType = oldParentType;
    return true;
};

});

parcelRegister("3c8A1", function(module, exports) {
// Paragraph
"use strict";
module.exports = function paragraph(state, startLine /*, endLine*/ ) {
    var content, terminate, i, l, token, oldParentType, nextLine = startLine + 1, terminatorRules = state.md.block.ruler.getRules("paragraph"), endLine = state.lineMax;
    oldParentType = state.parentType;
    state.parentType = "paragraph";
    // jump line-by-line until empty one or EOF
    for(; nextLine < endLine && !state.isEmpty(nextLine); nextLine++){
        // this would be a code block normally, but after paragraph
        // it's considered a lazy continuation regardless of what's there
        if (state.sCount[nextLine] - state.blkIndent > 3) continue;
        // quirk for blockquotes, this line should already be checked by that rule
        if (state.sCount[nextLine] < 0) continue;
        // Some tags can terminate paragraph without empty line.
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
    }
    content = state.getLines(startLine, nextLine, state.blkIndent, false).trim();
    state.line = nextLine;
    token = state.push("paragraph_open", "p", 1);
    token.map = [
        startLine,
        state.line
    ];
    token = state.push("inline", "", 0);
    token.content = content;
    token.map = [
        startLine,
        state.line
    ];
    token.children = [];
    token = state.push("paragraph_close", "p", -1);
    state.parentType = oldParentType;
    return true;
};

});

parcelRegister("hGhU8", function(module, exports) {
// Parser state class
"use strict";

var $h1S9x = parcelRequire("h1S9x");

var $cNF1f = parcelRequire("cNF1f");
var $cdf43f5ab4c7e423$require$isSpace = $cNF1f.isSpace;
function $cdf43f5ab4c7e423$var$StateBlock(src, md, env, tokens) {
    var ch, s, start, pos, len, indent, offset, indent_found;
    this.src = src;
    // link to parser instance
    this.md = md;
    this.env = env;
    //
    // Internal state vartiables
    //
    this.tokens = tokens;
    this.bMarks = []; // line begin offsets for fast jumps
    this.eMarks = []; // line end offsets for fast jumps
    this.tShift = []; // offsets of the first non-space characters (tabs not expanded)
    this.sCount = []; // indents for each line (tabs expanded)
    // An amount of virtual spaces (tabs expanded) between beginning
    // of each line (bMarks) and real beginning of that line.
    //
    // It exists only as a hack because blockquotes override bMarks
    // losing information in the process.
    //
    // It's used only when expanding tabs, you can think about it as
    // an initial tab length, e.g. bsCount=21 applied to string `\t123`
    // means first tab should be expanded to 4-21%4 === 3 spaces.
    //
    this.bsCount = [];
    // block parser variables
    this.blkIndent = 0; // required block content indent (for example, if we are
    // inside a list, it would be positioned after list marker)
    this.line = 0; // line index in src
    this.lineMax = 0; // lines count
    this.tight = false; // loose/tight mode for lists
    this.ddIndent = -1; // indent of the current dd block (-1 if there isn't any)
    this.listIndent = -1; // indent of the current list block (-1 if there isn't any)
    // can be 'blockquote', 'list', 'root', 'paragraph' or 'reference'
    // used in lists to determine if they interrupt a paragraph
    this.parentType = "root";
    this.level = 0;
    // renderer
    this.result = "";
    // Create caches
    // Generate markers.
    s = this.src;
    indent_found = false;
    for(start = pos = indent = offset = 0, len = s.length; pos < len; pos++){
        ch = s.charCodeAt(pos);
        if (!indent_found) {
            if ($cdf43f5ab4c7e423$require$isSpace(ch)) {
                indent++;
                if (ch === 0x09) offset += 4 - offset % 4;
                else offset++;
                continue;
            } else indent_found = true;
        }
        if (ch === 0x0A || pos === len - 1) {
            if (ch !== 0x0A) pos++;
            this.bMarks.push(start);
            this.eMarks.push(pos);
            this.tShift.push(indent);
            this.sCount.push(offset);
            this.bsCount.push(0);
            indent_found = false;
            indent = 0;
            offset = 0;
            start = pos + 1;
        }
    }
    // Push fake entry to simplify cache bounds checks
    this.bMarks.push(s.length);
    this.eMarks.push(s.length);
    this.tShift.push(0);
    this.sCount.push(0);
    this.bsCount.push(0);
    this.lineMax = this.bMarks.length - 1; // don't count last fake line
}
// Push new token to "stream".
//
$cdf43f5ab4c7e423$var$StateBlock.prototype.push = function(type, tag, nesting) {
    var token = new $h1S9x(type, tag, nesting);
    token.block = true;
    if (nesting < 0) this.level--; // closing tag
    token.level = this.level;
    if (nesting > 0) this.level++; // opening tag
    this.tokens.push(token);
    return token;
};
$cdf43f5ab4c7e423$var$StateBlock.prototype.isEmpty = function isEmpty(line) {
    return this.bMarks[line] + this.tShift[line] >= this.eMarks[line];
};
$cdf43f5ab4c7e423$var$StateBlock.prototype.skipEmptyLines = function skipEmptyLines(from) {
    for(var max = this.lineMax; from < max; from++){
        if (this.bMarks[from] + this.tShift[from] < this.eMarks[from]) break;
    }
    return from;
};
// Skip spaces from given position.
$cdf43f5ab4c7e423$var$StateBlock.prototype.skipSpaces = function skipSpaces(pos) {
    var ch;
    for(var max = this.src.length; pos < max; pos++){
        ch = this.src.charCodeAt(pos);
        if (!$cdf43f5ab4c7e423$require$isSpace(ch)) break;
    }
    return pos;
};
// Skip spaces from given position in reverse.
$cdf43f5ab4c7e423$var$StateBlock.prototype.skipSpacesBack = function skipSpacesBack(pos, min) {
    if (pos <= min) return pos;
    while(pos > min){
        if (!$cdf43f5ab4c7e423$require$isSpace(this.src.charCodeAt(--pos))) return pos + 1;
    }
    return pos;
};
// Skip char codes from given position
$cdf43f5ab4c7e423$var$StateBlock.prototype.skipChars = function skipChars(pos, code) {
    for(var max = this.src.length; pos < max; pos++){
        if (this.src.charCodeAt(pos) !== code) break;
    }
    return pos;
};
// Skip char codes reverse from given position - 1
$cdf43f5ab4c7e423$var$StateBlock.prototype.skipCharsBack = function skipCharsBack(pos, code, min) {
    if (pos <= min) return pos;
    while(pos > min){
        if (code !== this.src.charCodeAt(--pos)) return pos + 1;
    }
    return pos;
};
// cut lines range from source.
$cdf43f5ab4c7e423$var$StateBlock.prototype.getLines = function getLines(begin, end, indent, keepLastLF) {
    var i, lineIndent, ch, first, last, queue, lineStart, line = begin;
    if (begin >= end) return "";
    queue = new Array(end - begin);
    for(i = 0; line < end; line++, i++){
        lineIndent = 0;
        lineStart = first = this.bMarks[line];
        if (line + 1 < end || keepLastLF) // No need for bounds check because we have fake entry on tail.
        last = this.eMarks[line] + 1;
        else last = this.eMarks[line];
        while(first < last && lineIndent < indent){
            ch = this.src.charCodeAt(first);
            if ($cdf43f5ab4c7e423$require$isSpace(ch)) {
                if (ch === 0x09) lineIndent += 4 - (lineIndent + this.bsCount[line]) % 4;
                else lineIndent++;
            } else if (first - lineStart < this.tShift[line]) // patched tShift masked characters to look like spaces (blockquotes, list markers)
            lineIndent++;
            else break;
            first++;
        }
        if (lineIndent > indent) // partially expanding tabs in code blocks, e.g '\t\tfoobar'
        // with indent=2 becomes '  \tfoobar'
        queue[i] = new Array(lineIndent - indent + 1).join(" ") + this.src.slice(first, last);
        else queue[i] = this.src.slice(first, last);
    }
    return queue.join("");
};
// re-export Token class to use in block rules
$cdf43f5ab4c7e423$var$StateBlock.prototype.Token = $h1S9x;
module.exports = $cdf43f5ab4c7e423$var$StateBlock;

});


parcelRegister("dgJn4", function(module, exports) {
/** internal
 * class ParserInline
 *
 * Tokenizes paragraph content.
 **/ "use strict";

var $9bWv8 = parcelRequire("9bWv8");











////////////////////////////////////////////////////////////////////////////////
// Parser rules
var $9a8ff6bd42306002$var$_rules = [
    [
        "text",
        (parcelRequire("9VLIO"))
    ],
    [
        "newline",
        (parcelRequire("1GdVx"))
    ],
    [
        "escape",
        (parcelRequire("9LIpV"))
    ],
    [
        "backticks",
        (parcelRequire("9RVIw"))
    ],
    [
        "strikethrough",
        (parcelRequire("klVub")).tokenize
    ],
    [
        "emphasis",
        (parcelRequire("e2cHF")).tokenize
    ],
    [
        "link",
        (parcelRequire("dUqxD"))
    ],
    [
        "image",
        (parcelRequire("4XOaR"))
    ],
    [
        "autolink",
        (parcelRequire("a3Sj0"))
    ],
    [
        "html_inline",
        (parcelRequire("8sZWD"))
    ],
    [
        "entity",
        (parcelRequire("7Nnfd"))
    ]
];




var $9a8ff6bd42306002$var$_rules2 = [
    [
        "balance_pairs",
        (parcelRequire("lPBJE"))
    ],
    [
        "strikethrough",
        (parcelRequire("klVub")).postProcess
    ],
    [
        "emphasis",
        (parcelRequire("e2cHF")).postProcess
    ],
    [
        "text_collapse",
        (parcelRequire("ffudn"))
    ]
];
/**
 * new ParserInline()
 **/ function $9a8ff6bd42306002$var$ParserInline() {
    var i;
    /**
   * ParserInline#ruler -> Ruler
   *
   * [[Ruler]] instance. Keep configuration of inline rules.
   **/ this.ruler = new $9bWv8();
    for(i = 0; i < $9a8ff6bd42306002$var$_rules.length; i++)this.ruler.push($9a8ff6bd42306002$var$_rules[i][0], $9a8ff6bd42306002$var$_rules[i][1]);
    /**
   * ParserInline#ruler2 -> Ruler
   *
   * [[Ruler]] instance. Second ruler used for post-processing
   * (e.g. in emphasis-like rules).
   **/ this.ruler2 = new $9bWv8();
    for(i = 0; i < $9a8ff6bd42306002$var$_rules2.length; i++)this.ruler2.push($9a8ff6bd42306002$var$_rules2[i][0], $9a8ff6bd42306002$var$_rules2[i][1]);
}
// Skip single token by running all rules in validation mode;
// returns `true` if any rule reported success
//
$9a8ff6bd42306002$var$ParserInline.prototype.skipToken = function(state) {
    var ok, i, pos = state.pos, rules = this.ruler.getRules(""), len = rules.length, maxNesting = state.md.options.maxNesting, cache = state.cache;
    if (typeof cache[pos] !== "undefined") {
        state.pos = cache[pos];
        return;
    }
    if (state.level < maxNesting) for(i = 0; i < len; i++){
        // Increment state.level and decrement it later to limit recursion.
        // It's harmless to do here, because no tokens are created. But ideally,
        // we'd need a separate private state variable for this purpose.
        //
        state.level++;
        ok = rules[i](state, true);
        state.level--;
        if (ok) break;
    }
    else // Too much nesting, just skip until the end of the paragraph.
    //
    // NOTE: this will cause links to behave incorrectly in the following case,
    //       when an amount of `[` is exactly equal to `maxNesting + 1`:
    //
    //       [[[[[[[[[[[[[[[[[[[[[foo]()
    //
    // TODO: remove this workaround when CM standard will allow nested links
    //       (we can replace it by preventing links from being parsed in
    //       validation mode)
    //
    state.pos = state.posMax;
    if (!ok) state.pos++;
    cache[pos] = state.pos;
};
// Generate tokens for input range
//
$9a8ff6bd42306002$var$ParserInline.prototype.tokenize = function(state) {
    var ok, i, rules = this.ruler.getRules(""), len = rules.length, end = state.posMax, maxNesting = state.md.options.maxNesting;
    while(state.pos < end){
        // Try all possible rules.
        // On success, rule should:
        //
        // - update `state.pos`
        // - update `state.tokens`
        // - return true
        if (state.level < maxNesting) for(i = 0; i < len; i++){
            ok = rules[i](state, false);
            if (ok) break;
        }
        if (ok) {
            if (state.pos >= end) break;
            continue;
        }
        state.pending += state.src[state.pos++];
    }
    if (state.pending) state.pushPending();
};
/**
 * ParserInline.parse(str, md, env, outTokens)
 *
 * Process input string and push inline tokens into `outTokens`
 **/ $9a8ff6bd42306002$var$ParserInline.prototype.parse = function(str, md, env, outTokens) {
    var i, rules, len;
    var state = new this.State(str, md, env, outTokens);
    this.tokenize(state);
    rules = this.ruler2.getRules("");
    len = rules.length;
    for(i = 0; i < len; i++)rules[i](state);
};

$9a8ff6bd42306002$var$ParserInline.prototype.State = (parcelRequire("8xn9e"));
module.exports = $9a8ff6bd42306002$var$ParserInline;

});
parcelRegister("9VLIO", function(module, exports) {
// Skip text characters for text token, place those to pending buffer
// and increment current pos
"use strict";
// Rule to skip pure text
// '{}$%@~+=:' reserved for extentions
// !, ", #, $, %, &, ', (, ), *, +, ,, -, ., /, :, ;, <, =, >, ?, @, [, \, ], ^, _, `, {, |, }, or ~
// !!!! Don't confuse with "Markdown ASCII Punctuation" chars
// http://spec.commonmark.org/0.15/#ascii-punctuation-character
function $73ae7474cfb2903f$var$isTerminatorChar(ch) {
    switch(ch){
        case 0x0A /* \n */ :
        case 0x21 /* ! */ :
        case 0x23 /* # */ :
        case 0x24 /* $ */ :
        case 0x25 /* % */ :
        case 0x26 /* & */ :
        case 0x2A /* * */ :
        case 0x2B /* + */ :
        case 0x2D /* - */ :
        case 0x3A /* : */ :
        case 0x3C /* < */ :
        case 0x3D /* = */ :
        case 0x3E /* > */ :
        case 0x40 /* @ */ :
        case 0x5B /* [ */ :
        case 0x5C /* \ */ :
        case 0x5D /* ] */ :
        case 0x5E /* ^ */ :
        case 0x5F /* _ */ :
        case 0x60 /* ` */ :
        case 0x7B /* { */ :
        case 0x7D /* } */ :
        case 0x7E /* ~ */ :
            return true;
        default:
            return false;
    }
}
module.exports = function text(state, silent) {
    var pos = state.pos;
    while(pos < state.posMax && !$73ae7474cfb2903f$var$isTerminatorChar(state.src.charCodeAt(pos)))pos++;
    if (pos === state.pos) return false;
    if (!silent) state.pending += state.src.slice(state.pos, pos);
    state.pos = pos;
    return true;
}; // Alternative implementation, for memory.
 //
 // It costs 10% of performance, but allows extend terminators list, if place it
 // to `ParcerInline` property. Probably, will switch to it sometime, such
 // flexibility required.
 /*
var TERMINATOR_RE = /[\n!#$%&*+\-:<=>@[\\\]^_`{}~]/;

module.exports = function text(state, silent) {
  var pos = state.pos,
      idx = state.src.slice(pos).search(TERMINATOR_RE);

  // first char is terminator -> empty text
  if (idx === 0) { return false; }

  // no terminator -> text till end of string
  if (idx < 0) {
    if (!silent) { state.pending += state.src.slice(pos); }
    state.pos = state.src.length;
    return true;
  }

  if (!silent) { state.pending += state.src.slice(pos, pos + idx); }

  state.pos += idx;

  return true;
};*/ 

});

parcelRegister("1GdVx", function(module, exports) {
// Proceess '\n'
"use strict";

var $cNF1f = parcelRequire("cNF1f");
var $13948449d3214696$require$isSpace = $cNF1f.isSpace;
module.exports = function newline(state, silent) {
    var pmax, max, ws, pos = state.pos;
    if (state.src.charCodeAt(pos) !== 0x0A /* \n */ ) return false;
    pmax = state.pending.length - 1;
    max = state.posMax;
    // '  \n' -> hardbreak
    // Lookup in pending chars is bad practice! Don't copy to other rules!
    // Pending string is stored in concat mode, indexed lookups will cause
    // convertion to flat mode.
    if (!silent) {
        if (pmax >= 0 && state.pending.charCodeAt(pmax) === 0x20) {
            if (pmax >= 1 && state.pending.charCodeAt(pmax - 1) === 0x20) {
                // Find whitespaces tail of pending chars.
                ws = pmax - 1;
                while(ws >= 1 && state.pending.charCodeAt(ws - 1) === 0x20)ws--;
                state.pending = state.pending.slice(0, ws);
                state.push("hardbreak", "br", 0);
            } else {
                state.pending = state.pending.slice(0, -1);
                state.push("softbreak", "br", 0);
            }
        } else state.push("softbreak", "br", 0);
    }
    pos++;
    // skip heading spaces for next line
    while(pos < max && $13948449d3214696$require$isSpace(state.src.charCodeAt(pos)))pos++;
    state.pos = pos;
    return true;
};

});

parcelRegister("9LIpV", function(module, exports) {
// Process escaped chars and hardbreaks
"use strict";

var $cNF1f = parcelRequire("cNF1f");
var $71caf526e3f7b8eb$require$isSpace = $cNF1f.isSpace;
var $71caf526e3f7b8eb$var$ESCAPED = [];
for(var $71caf526e3f7b8eb$var$i = 0; $71caf526e3f7b8eb$var$i < 256; $71caf526e3f7b8eb$var$i++)$71caf526e3f7b8eb$var$ESCAPED.push(0);
"\\!\"#$%&'()*+,./:;<=>?@[]^_`{|}~-".split("").forEach(function(ch) {
    $71caf526e3f7b8eb$var$ESCAPED[ch.charCodeAt(0)] = 1;
});
module.exports = function escape(state, silent) {
    var ch, pos = state.pos, max = state.posMax;
    if (state.src.charCodeAt(pos) !== 0x5C /* \ */ ) return false;
    pos++;
    if (pos < max) {
        ch = state.src.charCodeAt(pos);
        if (ch < 256 && $71caf526e3f7b8eb$var$ESCAPED[ch] !== 0) {
            if (!silent) state.pending += state.src[pos];
            state.pos += 2;
            return true;
        }
        if (ch === 0x0A) {
            if (!silent) state.push("hardbreak", "br", 0);
            pos++;
            // skip leading whitespaces from next line
            while(pos < max){
                ch = state.src.charCodeAt(pos);
                if (!$71caf526e3f7b8eb$require$isSpace(ch)) break;
                pos++;
            }
            state.pos = pos;
            return true;
        }
    }
    if (!silent) state.pending += "\\";
    state.pos++;
    return true;
};

});

parcelRegister("9RVIw", function(module, exports) {
// Parse backticks
"use strict";
module.exports = function backtick(state, silent) {
    var start, max, marker, token, matchStart, matchEnd, openerLength, closerLength, pos = state.pos, ch = state.src.charCodeAt(pos);
    if (ch !== 0x60 /* ` */ ) return false;
    start = pos;
    pos++;
    max = state.posMax;
    // scan marker length
    while(pos < max && state.src.charCodeAt(pos) === 0x60 /* ` */ )pos++;
    marker = state.src.slice(start, pos);
    openerLength = marker.length;
    if (state.backticksScanned && (state.backticks[openerLength] || 0) <= start) {
        if (!silent) state.pending += marker;
        state.pos += openerLength;
        return true;
    }
    matchStart = matchEnd = pos;
    // Nothing found in the cache, scan until the end of the line (or until marker is found)
    while((matchStart = state.src.indexOf("`", matchEnd)) !== -1){
        matchEnd = matchStart + 1;
        // scan marker length
        while(matchEnd < max && state.src.charCodeAt(matchEnd) === 0x60 /* ` */ )matchEnd++;
        closerLength = matchEnd - matchStart;
        if (closerLength === openerLength) {
            // Found matching closer length.
            if (!silent) {
                token = state.push("code_inline", "code", 0);
                token.markup = marker;
                token.content = state.src.slice(pos, matchStart).replace(/\n/g, " ").replace(/^ (.+) $/, "$1");
            }
            state.pos = matchEnd;
            return true;
        }
        // Some different length found, put it in cache as upper limit of where closer can be found
        state.backticks[closerLength] = matchStart;
    }
    // Scanned through the end, didn't find anything
    state.backticksScanned = true;
    if (!silent) state.pending += marker;
    state.pos += openerLength;
    return true;
};

});

parcelRegister("klVub", function(module, exports) {

$parcel$export(module.exports, "tokenize", () => $ed125c4a30a32732$export$660b2ee2d4fb4eff, (v) => $ed125c4a30a32732$export$660b2ee2d4fb4eff = v);
$parcel$export(module.exports, "postProcess", () => $ed125c4a30a32732$export$7b804a0e0ce836d9, (v) => $ed125c4a30a32732$export$7b804a0e0ce836d9 = v);
// ~~strike through~~
//
// Insert each marker as a separate text token, and add it to delimiter list
//
var $ed125c4a30a32732$export$660b2ee2d4fb4eff;
// Walk through delimiter list and replace text tokens with tags
//
var $ed125c4a30a32732$export$7b804a0e0ce836d9;
"use strict";
$ed125c4a30a32732$export$660b2ee2d4fb4eff = function strikethrough(state, silent) {
    var i, scanned, token, len, ch, start = state.pos, marker = state.src.charCodeAt(start);
    if (silent) return false;
    if (marker !== 0x7E /* ~ */ ) return false;
    scanned = state.scanDelims(state.pos, true);
    len = scanned.length;
    ch = String.fromCharCode(marker);
    if (len < 2) return false;
    if (len % 2) {
        token = state.push("text", "", 0);
        token.content = ch;
        len--;
    }
    for(i = 0; i < len; i += 2){
        token = state.push("text", "", 0);
        token.content = ch + ch;
        state.delimiters.push({
            marker: marker,
            length: 0,
            token: state.tokens.length - 1,
            end: -1,
            open: scanned.can_open,
            close: scanned.can_close
        });
    }
    state.pos += scanned.length;
    return true;
};
function $ed125c4a30a32732$var$postProcess(state, delimiters) {
    var i, j, startDelim, endDelim, token, loneMarkers = [], max = delimiters.length;
    for(i = 0; i < max; i++){
        startDelim = delimiters[i];
        if (startDelim.marker !== 0x7E /* ~ */ ) continue;
        if (startDelim.end === -1) continue;
        endDelim = delimiters[startDelim.end];
        token = state.tokens[startDelim.token];
        token.type = "s_open";
        token.tag = "s";
        token.nesting = 1;
        token.markup = "~~";
        token.content = "";
        token = state.tokens[endDelim.token];
        token.type = "s_close";
        token.tag = "s";
        token.nesting = -1;
        token.markup = "~~";
        token.content = "";
        if (state.tokens[endDelim.token - 1].type === "text" && state.tokens[endDelim.token - 1].content === "~") loneMarkers.push(endDelim.token - 1);
    }
    // If a marker sequence has an odd number of characters, it's splitted
    // like this: `~~~~~` -> `~` + `~~` + `~~`, leaving one marker at the
    // start of the sequence.
    //
    // So, we have to move all those markers after subsequent s_close tags.
    //
    while(loneMarkers.length){
        i = loneMarkers.pop();
        j = i + 1;
        while(j < state.tokens.length && state.tokens[j].type === "s_close")j++;
        j--;
        if (i !== j) {
            token = state.tokens[j];
            state.tokens[j] = state.tokens[i];
            state.tokens[i] = token;
        }
    }
}
$ed125c4a30a32732$export$7b804a0e0ce836d9 = function strikethrough(state) {
    var curr, tokens_meta = state.tokens_meta, max = state.tokens_meta.length;
    $ed125c4a30a32732$var$postProcess(state, state.delimiters);
    for(curr = 0; curr < max; curr++)if (tokens_meta[curr] && tokens_meta[curr].delimiters) $ed125c4a30a32732$var$postProcess(state, tokens_meta[curr].delimiters);
};

});

parcelRegister("e2cHF", function(module, exports) {

$parcel$export(module.exports, "tokenize", () => $a37b1b2edd024f36$export$660b2ee2d4fb4eff, (v) => $a37b1b2edd024f36$export$660b2ee2d4fb4eff = v);
$parcel$export(module.exports, "postProcess", () => $a37b1b2edd024f36$export$7b804a0e0ce836d9, (v) => $a37b1b2edd024f36$export$7b804a0e0ce836d9 = v);
// Process *this* and _that_
//
// Insert each marker as a separate text token, and add it to delimiter list
//
var $a37b1b2edd024f36$export$660b2ee2d4fb4eff;
// Walk through delimiter list and replace text tokens with tags
//
var $a37b1b2edd024f36$export$7b804a0e0ce836d9;
"use strict";
$a37b1b2edd024f36$export$660b2ee2d4fb4eff = function emphasis(state, silent) {
    var i, scanned, token, start = state.pos, marker = state.src.charCodeAt(start);
    if (silent) return false;
    if (marker !== 0x5F /* _ */  && marker !== 0x2A /* * */ ) return false;
    scanned = state.scanDelims(state.pos, marker === 0x2A);
    for(i = 0; i < scanned.length; i++){
        token = state.push("text", "", 0);
        token.content = String.fromCharCode(marker);
        state.delimiters.push({
            // Char code of the starting marker (number).
            //
            marker: marker,
            // Total length of these series of delimiters.
            //
            length: scanned.length,
            // A position of the token this delimiter corresponds to.
            //
            token: state.tokens.length - 1,
            // If this delimiter is matched as a valid opener, `end` will be
            // equal to its position, otherwise it's `-1`.
            //
            end: -1,
            // Boolean flags that determine if this delimiter could open or close
            // an emphasis.
            //
            open: scanned.can_open,
            close: scanned.can_close
        });
    }
    state.pos += scanned.length;
    return true;
};
function $a37b1b2edd024f36$var$postProcess(state, delimiters) {
    var i, startDelim, endDelim, token, ch, isStrong, max = delimiters.length;
    for(i = max - 1; i >= 0; i--){
        startDelim = delimiters[i];
        if (startDelim.marker !== 0x5F /* _ */  && startDelim.marker !== 0x2A /* * */ ) continue;
        // Process only opening markers
        if (startDelim.end === -1) continue;
        endDelim = delimiters[startDelim.end];
        // If the previous delimiter has the same marker and is adjacent to this one,
        // merge those into one strong delimiter.
        //
        // `<em><em>whatever</em></em>` -> `<strong>whatever</strong>`
        //
        isStrong = i > 0 && delimiters[i - 1].end === startDelim.end + 1 && // check that first two markers match and adjacent
        delimiters[i - 1].marker === startDelim.marker && delimiters[i - 1].token === startDelim.token - 1 && // check that last two markers are adjacent (we can safely assume they match)
        delimiters[startDelim.end + 1].token === endDelim.token + 1;
        ch = String.fromCharCode(startDelim.marker);
        token = state.tokens[startDelim.token];
        token.type = isStrong ? "strong_open" : "em_open";
        token.tag = isStrong ? "strong" : "em";
        token.nesting = 1;
        token.markup = isStrong ? ch + ch : ch;
        token.content = "";
        token = state.tokens[endDelim.token];
        token.type = isStrong ? "strong_close" : "em_close";
        token.tag = isStrong ? "strong" : "em";
        token.nesting = -1;
        token.markup = isStrong ? ch + ch : ch;
        token.content = "";
        if (isStrong) {
            state.tokens[delimiters[i - 1].token].content = "";
            state.tokens[delimiters[startDelim.end + 1].token].content = "";
            i--;
        }
    }
}
$a37b1b2edd024f36$export$7b804a0e0ce836d9 = function emphasis(state) {
    var curr, tokens_meta = state.tokens_meta, max = state.tokens_meta.length;
    $a37b1b2edd024f36$var$postProcess(state, state.delimiters);
    for(curr = 0; curr < max; curr++)if (tokens_meta[curr] && tokens_meta[curr].delimiters) $a37b1b2edd024f36$var$postProcess(state, tokens_meta[curr].delimiters);
};

});

parcelRegister("dUqxD", function(module, exports) {
// Process [link](<to> "stuff")
"use strict";

var $cNF1f = parcelRequire("cNF1f");
var $a20517ef3f42cb87$require$normalizeReference = $cNF1f.normalizeReference;

var $cNF1f = parcelRequire("cNF1f");
var $a20517ef3f42cb87$require$isSpace = $cNF1f.isSpace;
module.exports = function link(state, silent) {
    var attrs, code, label, labelEnd, labelStart, pos, res, ref, token, href = "", title = "", oldPos = state.pos, max = state.posMax, start = state.pos, parseReference = true;
    if (state.src.charCodeAt(state.pos) !== 0x5B /* [ */ ) return false;
    labelStart = state.pos + 1;
    labelEnd = state.md.helpers.parseLinkLabel(state, state.pos, true);
    // parser failed to find ']', so it's not a valid link
    if (labelEnd < 0) return false;
    pos = labelEnd + 1;
    if (pos < max && state.src.charCodeAt(pos) === 0x28 /* ( */ ) {
        //
        // Inline link
        //
        // might have found a valid shortcut link, disable reference parsing
        parseReference = false;
        // [link](  <href>  "title"  )
        //        ^^ skipping these spaces
        pos++;
        for(; pos < max; pos++){
            code = state.src.charCodeAt(pos);
            if (!$a20517ef3f42cb87$require$isSpace(code) && code !== 0x0A) break;
        }
        if (pos >= max) return false;
        // [link](  <href>  "title"  )
        //          ^^^^^^ parsing link destination
        start = pos;
        res = state.md.helpers.parseLinkDestination(state.src, pos, state.posMax);
        if (res.ok) {
            href = state.md.normalizeLink(res.str);
            if (state.md.validateLink(href)) pos = res.pos;
            else href = "";
            // [link](  <href>  "title"  )
            //                ^^ skipping these spaces
            start = pos;
            for(; pos < max; pos++){
                code = state.src.charCodeAt(pos);
                if (!$a20517ef3f42cb87$require$isSpace(code) && code !== 0x0A) break;
            }
            // [link](  <href>  "title"  )
            //                  ^^^^^^^ parsing link title
            res = state.md.helpers.parseLinkTitle(state.src, pos, state.posMax);
            if (pos < max && start !== pos && res.ok) {
                title = res.str;
                pos = res.pos;
                // [link](  <href>  "title"  )
                //                         ^^ skipping these spaces
                for(; pos < max; pos++){
                    code = state.src.charCodeAt(pos);
                    if (!$a20517ef3f42cb87$require$isSpace(code) && code !== 0x0A) break;
                }
            }
        }
        if (pos >= max || state.src.charCodeAt(pos) !== 0x29 /* ) */ ) // parsing a valid shortcut link failed, fallback to reference
        parseReference = true;
        pos++;
    }
    if (parseReference) {
        //
        // Link reference
        //
        if (typeof state.env.references === "undefined") return false;
        if (pos < max && state.src.charCodeAt(pos) === 0x5B /* [ */ ) {
            start = pos + 1;
            pos = state.md.helpers.parseLinkLabel(state, pos);
            if (pos >= 0) label = state.src.slice(start, pos++);
            else pos = labelEnd + 1;
        } else pos = labelEnd + 1;
        // covers label === '' and label === undefined
        // (collapsed reference link and shortcut reference link respectively)
        if (!label) label = state.src.slice(labelStart, labelEnd);
        ref = state.env.references[$a20517ef3f42cb87$require$normalizeReference(label)];
        if (!ref) {
            state.pos = oldPos;
            return false;
        }
        href = ref.href;
        title = ref.title;
    }
    //
    // We found the end of the link, and know for a fact it's a valid link;
    // so all that's left to do is to call tokenizer.
    //
    if (!silent) {
        state.pos = labelStart;
        state.posMax = labelEnd;
        token = state.push("link_open", "a", 1);
        token.attrs = attrs = [
            [
                "href",
                href
            ]
        ];
        if (title) attrs.push([
            "title",
            title
        ]);
        state.md.inline.tokenize(state);
        token = state.push("link_close", "a", -1);
    }
    state.pos = pos;
    state.posMax = max;
    return true;
};

});

parcelRegister("4XOaR", function(module, exports) {
// Process ![image](<src> "title")
"use strict";

var $cNF1f = parcelRequire("cNF1f");
var $39d397ad0b9bac47$require$normalizeReference = $cNF1f.normalizeReference;

var $cNF1f = parcelRequire("cNF1f");
var $39d397ad0b9bac47$require$isSpace = $cNF1f.isSpace;
module.exports = function image(state, silent) {
    var attrs, code, content, label, labelEnd, labelStart, pos, ref, res, title, token, tokens, start, href = "", oldPos = state.pos, max = state.posMax;
    if (state.src.charCodeAt(state.pos) !== 0x21 /* ! */ ) return false;
    if (state.src.charCodeAt(state.pos + 1) !== 0x5B /* [ */ ) return false;
    labelStart = state.pos + 2;
    labelEnd = state.md.helpers.parseLinkLabel(state, state.pos + 1, false);
    // parser failed to find ']', so it's not a valid link
    if (labelEnd < 0) return false;
    pos = labelEnd + 1;
    if (pos < max && state.src.charCodeAt(pos) === 0x28 /* ( */ ) {
        //
        // Inline link
        //
        // [link](  <href>  "title"  )
        //        ^^ skipping these spaces
        pos++;
        for(; pos < max; pos++){
            code = state.src.charCodeAt(pos);
            if (!$39d397ad0b9bac47$require$isSpace(code) && code !== 0x0A) break;
        }
        if (pos >= max) return false;
        // [link](  <href>  "title"  )
        //          ^^^^^^ parsing link destination
        start = pos;
        res = state.md.helpers.parseLinkDestination(state.src, pos, state.posMax);
        if (res.ok) {
            href = state.md.normalizeLink(res.str);
            if (state.md.validateLink(href)) pos = res.pos;
            else href = "";
        }
        // [link](  <href>  "title"  )
        //                ^^ skipping these spaces
        start = pos;
        for(; pos < max; pos++){
            code = state.src.charCodeAt(pos);
            if (!$39d397ad0b9bac47$require$isSpace(code) && code !== 0x0A) break;
        }
        // [link](  <href>  "title"  )
        //                  ^^^^^^^ parsing link title
        res = state.md.helpers.parseLinkTitle(state.src, pos, state.posMax);
        if (pos < max && start !== pos && res.ok) {
            title = res.str;
            pos = res.pos;
            // [link](  <href>  "title"  )
            //                         ^^ skipping these spaces
            for(; pos < max; pos++){
                code = state.src.charCodeAt(pos);
                if (!$39d397ad0b9bac47$require$isSpace(code) && code !== 0x0A) break;
            }
        } else title = "";
        if (pos >= max || state.src.charCodeAt(pos) !== 0x29 /* ) */ ) {
            state.pos = oldPos;
            return false;
        }
        pos++;
    } else {
        //
        // Link reference
        //
        if (typeof state.env.references === "undefined") return false;
        if (pos < max && state.src.charCodeAt(pos) === 0x5B /* [ */ ) {
            start = pos + 1;
            pos = state.md.helpers.parseLinkLabel(state, pos);
            if (pos >= 0) label = state.src.slice(start, pos++);
            else pos = labelEnd + 1;
        } else pos = labelEnd + 1;
        // covers label === '' and label === undefined
        // (collapsed reference link and shortcut reference link respectively)
        if (!label) label = state.src.slice(labelStart, labelEnd);
        ref = state.env.references[$39d397ad0b9bac47$require$normalizeReference(label)];
        if (!ref) {
            state.pos = oldPos;
            return false;
        }
        href = ref.href;
        title = ref.title;
    }
    //
    // We found the end of the link, and know for a fact it's a valid link;
    // so all that's left to do is to call tokenizer.
    //
    if (!silent) {
        content = state.src.slice(labelStart, labelEnd);
        state.md.inline.parse(content, state.md, state.env, tokens = []);
        token = state.push("image", "img", 0);
        token.attrs = attrs = [
            [
                "src",
                href
            ],
            [
                "alt",
                ""
            ]
        ];
        token.children = tokens;
        token.content = content;
        if (title) attrs.push([
            "title",
            title
        ]);
    }
    state.pos = pos;
    state.posMax = max;
    return true;
};

});

parcelRegister("a3Sj0", function(module, exports) {
// Process autolinks '<protocol:...>'
"use strict";
/*eslint max-len:0*/ var $75344f22165df84e$var$EMAIL_RE = /^([a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*)$/;
var $75344f22165df84e$var$AUTOLINK_RE = /^([a-zA-Z][a-zA-Z0-9+.\-]{1,31}):([^<>\x00-\x20]*)$/;
module.exports = function autolink(state, silent) {
    var url, fullUrl, token, ch, start, max, pos = state.pos;
    if (state.src.charCodeAt(pos) !== 0x3C /* < */ ) return false;
    start = state.pos;
    max = state.posMax;
    for(;;){
        if (++pos >= max) return false;
        ch = state.src.charCodeAt(pos);
        if (ch === 0x3C /* < */ ) return false;
        if (ch === 0x3E /* > */ ) break;
    }
    url = state.src.slice(start + 1, pos);
    if ($75344f22165df84e$var$AUTOLINK_RE.test(url)) {
        fullUrl = state.md.normalizeLink(url);
        if (!state.md.validateLink(fullUrl)) return false;
        if (!silent) {
            token = state.push("link_open", "a", 1);
            token.attrs = [
                [
                    "href",
                    fullUrl
                ]
            ];
            token.markup = "autolink";
            token.info = "auto";
            token = state.push("text", "", 0);
            token.content = state.md.normalizeLinkText(url);
            token = state.push("link_close", "a", -1);
            token.markup = "autolink";
            token.info = "auto";
        }
        state.pos += url.length + 2;
        return true;
    }
    if ($75344f22165df84e$var$EMAIL_RE.test(url)) {
        fullUrl = state.md.normalizeLink("mailto:" + url);
        if (!state.md.validateLink(fullUrl)) return false;
        if (!silent) {
            token = state.push("link_open", "a", 1);
            token.attrs = [
                [
                    "href",
                    fullUrl
                ]
            ];
            token.markup = "autolink";
            token.info = "auto";
            token = state.push("text", "", 0);
            token.content = state.md.normalizeLinkText(url);
            token = state.push("link_close", "a", -1);
            token.markup = "autolink";
            token.info = "auto";
        }
        state.pos += url.length + 2;
        return true;
    }
    return false;
};

});

parcelRegister("8sZWD", function(module, exports) {
// Process html tags
"use strict";

var $kVzDW = parcelRequire("kVzDW");
var $01973de3ef17be62$require$HTML_TAG_RE = $kVzDW.HTML_TAG_RE;
function $01973de3ef17be62$var$isLetter(ch) {
    /*eslint no-bitwise:0*/ var lc = ch | 0x20; // to lower case
    return lc >= 0x61 /* a */  && lc <= 0x7a /* z */ ;
}
module.exports = function html_inline(state, silent) {
    var ch, match, max, token, pos = state.pos;
    if (!state.md.options.html) return false;
    // Check start
    max = state.posMax;
    if (state.src.charCodeAt(pos) !== 0x3C /* < */  || pos + 2 >= max) return false;
    // Quick fail on second char
    ch = state.src.charCodeAt(pos + 1);
    if (ch !== 0x21 /* ! */  && ch !== 0x3F /* ? */  && ch !== 0x2F /* / */  && !$01973de3ef17be62$var$isLetter(ch)) return false;
    match = state.src.slice(pos).match($01973de3ef17be62$require$HTML_TAG_RE);
    if (!match) return false;
    if (!silent) {
        token = state.push("html_inline", "", 0);
        token.content = state.src.slice(pos, pos + match[0].length);
    }
    state.pos += match[0].length;
    return true;
};

});

parcelRegister("7Nnfd", function(module, exports) {
// Process html entity - &#123;, &#xAF;, &quot;, ...
"use strict";

var $7fxX9 = parcelRequire("7fxX9");

var $cNF1f = parcelRequire("cNF1f");
var $5acf23e0e8c2f56b$require$has = $cNF1f.has;

var $cNF1f = parcelRequire("cNF1f");
var $5acf23e0e8c2f56b$require$isValidEntityCode = $cNF1f.isValidEntityCode;

var $cNF1f = parcelRequire("cNF1f");
var $5acf23e0e8c2f56b$require$fromCodePoint = $cNF1f.fromCodePoint;
var $5acf23e0e8c2f56b$var$DIGITAL_RE = /^&#((?:x[a-f0-9]{1,6}|[0-9]{1,7}));/i;
var $5acf23e0e8c2f56b$var$NAMED_RE = /^&([a-z][a-z0-9]{1,31});/i;
module.exports = function entity(state, silent) {
    var ch, code, match, pos = state.pos, max = state.posMax;
    if (state.src.charCodeAt(pos) !== 0x26 /* & */ ) return false;
    if (pos + 1 < max) {
        ch = state.src.charCodeAt(pos + 1);
        if (ch === 0x23 /* # */ ) {
            match = state.src.slice(pos).match($5acf23e0e8c2f56b$var$DIGITAL_RE);
            if (match) {
                if (!silent) {
                    code = match[1][0].toLowerCase() === "x" ? parseInt(match[1].slice(1), 16) : parseInt(match[1], 10);
                    state.pending += $5acf23e0e8c2f56b$require$isValidEntityCode(code) ? $5acf23e0e8c2f56b$require$fromCodePoint(code) : $5acf23e0e8c2f56b$require$fromCodePoint(0xFFFD);
                }
                state.pos += match[0].length;
                return true;
            }
        } else {
            match = state.src.slice(pos).match($5acf23e0e8c2f56b$var$NAMED_RE);
            if (match) {
                if ($5acf23e0e8c2f56b$require$has($7fxX9, match[1])) {
                    if (!silent) state.pending += $7fxX9[match[1]];
                    state.pos += match[0].length;
                    return true;
                }
            }
        }
    }
    if (!silent) state.pending += "&";
    state.pos++;
    return true;
};

});

parcelRegister("lPBJE", function(module, exports) {
// For each opening emphasis-like marker find a matching closing one
//
"use strict";
function $fe4ba1db367468a5$var$processDelimiters(state, delimiters) {
    var closerIdx, openerIdx, closer, opener, minOpenerIdx, newMinOpenerIdx, isOddMatch, lastJump, openersBottom = {}, max = delimiters.length;
    if (!max) return;
    // headerIdx is the first delimiter of the current (where closer is) delimiter run
    var headerIdx = 0;
    var lastTokenIdx = -2; // needs any value lower than -1
    var jumps = [];
    for(closerIdx = 0; closerIdx < max; closerIdx++){
        closer = delimiters[closerIdx];
        jumps.push(0);
        // markers belong to same delimiter run if:
        //  - they have adjacent tokens
        //  - AND markers are the same
        //
        if (delimiters[headerIdx].marker !== closer.marker || lastTokenIdx !== closer.token - 1) headerIdx = closerIdx;
        lastTokenIdx = closer.token;
        // Length is only used for emphasis-specific "rule of 3",
        // if it's not defined (in strikethrough or 3rd party plugins),
        // we can default it to 0 to disable those checks.
        //
        closer.length = closer.length || 0;
        if (!closer.close) continue;
        // Previously calculated lower bounds (previous fails)
        // for each marker, each delimiter length modulo 3,
        // and for whether this closer can be an opener;
        // https://github.com/commonmark/cmark/commit/34250e12ccebdc6372b8b49c44fab57c72443460
        if (!openersBottom.hasOwnProperty(closer.marker)) openersBottom[closer.marker] = [
            -1,
            -1,
            -1,
            -1,
            -1,
            -1
        ];
        minOpenerIdx = openersBottom[closer.marker][(closer.open ? 3 : 0) + closer.length % 3];
        openerIdx = headerIdx - jumps[headerIdx] - 1;
        newMinOpenerIdx = openerIdx;
        for(; openerIdx > minOpenerIdx; openerIdx -= jumps[openerIdx] + 1){
            opener = delimiters[openerIdx];
            if (opener.marker !== closer.marker) continue;
            if (opener.open && opener.end < 0) {
                isOddMatch = false;
                // from spec:
                //
                // If one of the delimiters can both open and close emphasis, then the
                // sum of the lengths of the delimiter runs containing the opening and
                // closing delimiters must not be a multiple of 3 unless both lengths
                // are multiples of 3.
                //
                if (opener.close || closer.open) {
                    if ((opener.length + closer.length) % 3 === 0) {
                        if (opener.length % 3 !== 0 || closer.length % 3 !== 0) isOddMatch = true;
                    }
                }
                if (!isOddMatch) {
                    // If previous delimiter cannot be an opener, we can safely skip
                    // the entire sequence in future checks. This is required to make
                    // sure algorithm has linear complexity (see *_*_*_*_*_... case).
                    //
                    lastJump = openerIdx > 0 && !delimiters[openerIdx - 1].open ? jumps[openerIdx - 1] + 1 : 0;
                    jumps[closerIdx] = closerIdx - openerIdx + lastJump;
                    jumps[openerIdx] = lastJump;
                    closer.open = false;
                    opener.end = closerIdx;
                    opener.close = false;
                    newMinOpenerIdx = -1;
                    // treat next token as start of run,
                    // it optimizes skips in **<...>**a**<...>** pathological case
                    lastTokenIdx = -2;
                    break;
                }
            }
        }
        if (newMinOpenerIdx !== -1) // If match for this delimiter run failed, we want to set lower bound for
        // future lookups. This is required to make sure algorithm has linear
        // complexity.
        //
        // See details here:
        // https://github.com/commonmark/cmark/issues/178#issuecomment-270417442
        //
        openersBottom[closer.marker][(closer.open ? 3 : 0) + (closer.length || 0) % 3] = newMinOpenerIdx;
    }
}
module.exports = function link_pairs(state) {
    var curr, tokens_meta = state.tokens_meta, max = state.tokens_meta.length;
    $fe4ba1db367468a5$var$processDelimiters(state, state.delimiters);
    for(curr = 0; curr < max; curr++)if (tokens_meta[curr] && tokens_meta[curr].delimiters) $fe4ba1db367468a5$var$processDelimiters(state, tokens_meta[curr].delimiters);
};

});

parcelRegister("ffudn", function(module, exports) {
// Clean up tokens after emphasis and strikethrough postprocessing:
// merge adjacent text nodes into one and re-calculate all token levels
//
// This is necessary because initially emphasis delimiter markers (*, _, ~)
// are treated as their own separate text tokens. Then emphasis rule either
// leaves them as text (needed to merge with adjacent text) or turns them
// into opening/closing tags (which messes up levels inside).
//
"use strict";
module.exports = function text_collapse(state) {
    var curr, last, level = 0, tokens = state.tokens, max = state.tokens.length;
    for(curr = last = 0; curr < max; curr++){
        // re-calculate levels after emphasis/strikethrough turns some text nodes
        // into opening/closing tags
        if (tokens[curr].nesting < 0) level--; // closing tag
        tokens[curr].level = level;
        if (tokens[curr].nesting > 0) level++; // opening tag
        if (tokens[curr].type === "text" && curr + 1 < max && tokens[curr + 1].type === "text") // collapse two adjacent text nodes
        tokens[curr + 1].content = tokens[curr].content + tokens[curr + 1].content;
        else {
            if (curr !== last) tokens[last] = tokens[curr];
            last++;
        }
    }
    if (curr !== last) tokens.length = last;
};

});

parcelRegister("8xn9e", function(module, exports) {
// Inline parser state
"use strict";

var $h1S9x = parcelRequire("h1S9x");

var $cNF1f = parcelRequire("cNF1f");
var $63735c774878bf2f$require$isWhiteSpace = $cNF1f.isWhiteSpace;

var $cNF1f = parcelRequire("cNF1f");
var $63735c774878bf2f$require$isPunctChar = $cNF1f.isPunctChar;

var $cNF1f = parcelRequire("cNF1f");
var $63735c774878bf2f$require$isMdAsciiPunct = $cNF1f.isMdAsciiPunct;
function $63735c774878bf2f$var$StateInline(src, md, env, outTokens) {
    this.src = src;
    this.env = env;
    this.md = md;
    this.tokens = outTokens;
    this.tokens_meta = Array(outTokens.length);
    this.pos = 0;
    this.posMax = this.src.length;
    this.level = 0;
    this.pending = "";
    this.pendingLevel = 0;
    // Stores { start: end } pairs. Useful for backtrack
    // optimization of pairs parse (emphasis, strikes).
    this.cache = {};
    // List of emphasis-like delimiters for current tag
    this.delimiters = [];
    // Stack of delimiter lists for upper level tags
    this._prev_delimiters = [];
    // backtick length => last seen position
    this.backticks = {};
    this.backticksScanned = false;
}
// Flush pending text
//
$63735c774878bf2f$var$StateInline.prototype.pushPending = function() {
    var token = new $h1S9x("text", "", 0);
    token.content = this.pending;
    token.level = this.pendingLevel;
    this.tokens.push(token);
    this.pending = "";
    return token;
};
// Push new token to "stream".
// If pending text exists - flush it as text token
//
$63735c774878bf2f$var$StateInline.prototype.push = function(type, tag, nesting) {
    if (this.pending) this.pushPending();
    var token = new $h1S9x(type, tag, nesting);
    var token_meta = null;
    if (nesting < 0) {
        // closing tag
        this.level--;
        this.delimiters = this._prev_delimiters.pop();
    }
    token.level = this.level;
    if (nesting > 0) {
        // opening tag
        this.level++;
        this._prev_delimiters.push(this.delimiters);
        this.delimiters = [];
        token_meta = {
            delimiters: this.delimiters
        };
    }
    this.pendingLevel = this.level;
    this.tokens.push(token);
    this.tokens_meta.push(token_meta);
    return token;
};
// Scan a sequence of emphasis-like markers, and determine whether
// it can start an emphasis sequence or end an emphasis sequence.
//
//  - start - position to scan from (it should point at a valid marker);
//  - canSplitWord - determine if these markers can be found inside a word
//
$63735c774878bf2f$var$StateInline.prototype.scanDelims = function(start, canSplitWord) {
    var pos = start, lastChar, nextChar, count, can_open, can_close, isLastWhiteSpace, isLastPunctChar, isNextWhiteSpace, isNextPunctChar, left_flanking = true, right_flanking = true, max = this.posMax, marker = this.src.charCodeAt(start);
    // treat beginning of the line as a whitespace
    lastChar = start > 0 ? this.src.charCodeAt(start - 1) : 0x20;
    while(pos < max && this.src.charCodeAt(pos) === marker)pos++;
    count = pos - start;
    // treat end of the line as a whitespace
    nextChar = pos < max ? this.src.charCodeAt(pos) : 0x20;
    isLastPunctChar = $63735c774878bf2f$require$isMdAsciiPunct(lastChar) || $63735c774878bf2f$require$isPunctChar(String.fromCharCode(lastChar));
    isNextPunctChar = $63735c774878bf2f$require$isMdAsciiPunct(nextChar) || $63735c774878bf2f$require$isPunctChar(String.fromCharCode(nextChar));
    isLastWhiteSpace = $63735c774878bf2f$require$isWhiteSpace(lastChar);
    isNextWhiteSpace = $63735c774878bf2f$require$isWhiteSpace(nextChar);
    if (isNextWhiteSpace) left_flanking = false;
    else if (isNextPunctChar) {
        if (!(isLastWhiteSpace || isLastPunctChar)) left_flanking = false;
    }
    if (isLastWhiteSpace) right_flanking = false;
    else if (isLastPunctChar) {
        if (!(isNextWhiteSpace || isNextPunctChar)) right_flanking = false;
    }
    if (!canSplitWord) {
        can_open = left_flanking && (!right_flanking || isLastPunctChar);
        can_close = right_flanking && (!left_flanking || isNextPunctChar);
    } else {
        can_open = left_flanking;
        can_close = right_flanking;
    }
    return {
        can_open: can_open,
        can_close: can_close,
        length: count
    };
};
// re-export Token class to use in block rules
$63735c774878bf2f$var$StateInline.prototype.Token = $h1S9x;
module.exports = $63735c774878bf2f$var$StateInline;

});


parcelRegister("kgioT", function(module, exports) {
"use strict";
////////////////////////////////////////////////////////////////////////////////
// Helpers
// Merge objects
//
function $ec039338a8bb4566$var$assign(obj /*from1, from2, from3, ...*/ ) {
    var sources = Array.prototype.slice.call(arguments, 1);
    sources.forEach(function(source) {
        if (!source) return;
        Object.keys(source).forEach(function(key) {
            obj[key] = source[key];
        });
    });
    return obj;
}
function $ec039338a8bb4566$var$_class(obj) {
    return Object.prototype.toString.call(obj);
}
function $ec039338a8bb4566$var$isString(obj) {
    return $ec039338a8bb4566$var$_class(obj) === "[object String]";
}
function $ec039338a8bb4566$var$isObject(obj) {
    return $ec039338a8bb4566$var$_class(obj) === "[object Object]";
}
function $ec039338a8bb4566$var$isRegExp(obj) {
    return $ec039338a8bb4566$var$_class(obj) === "[object RegExp]";
}
function $ec039338a8bb4566$var$isFunction(obj) {
    return $ec039338a8bb4566$var$_class(obj) === "[object Function]";
}
function $ec039338a8bb4566$var$escapeRE(str) {
    return str.replace(/[.?*+^$[\]\\(){}|-]/g, "\\$&");
}
////////////////////////////////////////////////////////////////////////////////
var $ec039338a8bb4566$var$defaultOptions = {
    fuzzyLink: true,
    fuzzyEmail: true,
    fuzzyIP: false
};
function $ec039338a8bb4566$var$isOptionsObj(obj) {
    return Object.keys(obj || {}).reduce(function(acc, k) {
        return acc || $ec039338a8bb4566$var$defaultOptions.hasOwnProperty(k);
    }, false);
}
var $ec039338a8bb4566$var$defaultSchemas = {
    "http:": {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.http = new RegExp("^\\/\\/" + self.re.src_auth + self.re.src_host_port_strict + self.re.src_path, "i");
            if (self.re.http.test(tail)) return tail.match(self.re.http)[0].length;
            return 0;
        }
    },
    "https:": "http:",
    "ftp:": "http:",
    "//": {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.no_http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.no_http = new RegExp("^" + self.re.src_auth + // Don't allow single-level domains, because of false positives like '//test'
            // with code comments
            "(?:localhost|(?:(?:" + self.re.src_domain + ")\\.)+" + self.re.src_domain_root + ")" + self.re.src_port + self.re.src_host_terminator + self.re.src_path, "i");
            if (self.re.no_http.test(tail)) {
                // should not be `://` & `///`, that protects from errors in protocol name
                if (pos >= 3 && text[pos - 3] === ":") return 0;
                if (pos >= 3 && text[pos - 3] === "/") return 0;
                return tail.match(self.re.no_http)[0].length;
            }
            return 0;
        }
    },
    "mailto:": {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.mailto) self.re.mailto = new RegExp("^" + self.re.src_email_name + "@" + self.re.src_host_strict, "i");
            if (self.re.mailto.test(tail)) return tail.match(self.re.mailto)[0].length;
            return 0;
        }
    }
};
/*eslint-disable max-len*/ // RE pattern for 2-character tlds (autogenerated by ./support/tlds_2char_gen.js)
var $ec039338a8bb4566$var$tlds_2ch_src_re = "a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]";
// DON'T try to make PRs with changes. Extend TLDs with LinkifyIt.tlds() instead
var $ec039338a8bb4566$var$tlds_default = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split("|");
/*eslint-enable max-len*/ ////////////////////////////////////////////////////////////////////////////////
function $ec039338a8bb4566$var$resetScanCache(self) {
    self.__index__ = -1;
    self.__text_cache__ = "";
}
function $ec039338a8bb4566$var$createValidator(re) {
    return function(text, pos) {
        var tail = text.slice(pos);
        if (re.test(tail)) return tail.match(re)[0].length;
        return 0;
    };
}
function $ec039338a8bb4566$var$createNormalizer() {
    return function(match, self) {
        self.normalize(match);
    };
}

// Schemas compiler. Build regexps.
//
function $ec039338a8bb4566$var$compile(self) {
    // Load & clone RE patterns.
    var re = self.re = (parcelRequire("ebQYg"))(self.__opts__);
    // Define dynamic patterns
    var tlds = self.__tlds__.slice();
    self.onCompile();
    if (!self.__tlds_replaced__) tlds.push($ec039338a8bb4566$var$tlds_2ch_src_re);
    tlds.push(re.src_xn);
    re.src_tlds = tlds.join("|");
    function untpl(tpl) {
        return tpl.replace("%TLDS%", re.src_tlds);
    }
    re.email_fuzzy = RegExp(untpl(re.tpl_email_fuzzy), "i");
    re.link_fuzzy = RegExp(untpl(re.tpl_link_fuzzy), "i");
    re.link_no_ip_fuzzy = RegExp(untpl(re.tpl_link_no_ip_fuzzy), "i");
    re.host_fuzzy_test = RegExp(untpl(re.tpl_host_fuzzy_test), "i");
    //
    // Compile each schema
    //
    var aliases = [];
    self.__compiled__ = {}; // Reset compiled data
    function schemaError(name, val) {
        throw new Error('(LinkifyIt) Invalid schema "' + name + '": ' + val);
    }
    Object.keys(self.__schemas__).forEach(function(name) {
        var val = self.__schemas__[name];
        // skip disabled methods
        if (val === null) return;
        var compiled = {
            validate: null,
            link: null
        };
        self.__compiled__[name] = compiled;
        if ($ec039338a8bb4566$var$isObject(val)) {
            if ($ec039338a8bb4566$var$isRegExp(val.validate)) compiled.validate = $ec039338a8bb4566$var$createValidator(val.validate);
            else if ($ec039338a8bb4566$var$isFunction(val.validate)) compiled.validate = val.validate;
            else schemaError(name, val);
            if ($ec039338a8bb4566$var$isFunction(val.normalize)) compiled.normalize = val.normalize;
            else if (!val.normalize) compiled.normalize = $ec039338a8bb4566$var$createNormalizer();
            else schemaError(name, val);
            return;
        }
        if ($ec039338a8bb4566$var$isString(val)) {
            aliases.push(name);
            return;
        }
        schemaError(name, val);
    });
    //
    // Compile postponed aliases
    //
    aliases.forEach(function(alias) {
        if (!self.__compiled__[self.__schemas__[alias]]) // Silently fail on missed schemas to avoid errons on disable.
        // schemaError(alias, self.__schemas__[alias]);
        return;
        self.__compiled__[alias].validate = self.__compiled__[self.__schemas__[alias]].validate;
        self.__compiled__[alias].normalize = self.__compiled__[self.__schemas__[alias]].normalize;
    });
    //
    // Fake record for guessed links
    //
    self.__compiled__[""] = {
        validate: null,
        normalize: $ec039338a8bb4566$var$createNormalizer()
    };
    //
    // Build schema condition
    //
    var slist = Object.keys(self.__compiled__).filter(function(name) {
        // Filter disabled & fake schemas
        return name.length > 0 && self.__compiled__[name];
    }).map($ec039338a8bb4566$var$escapeRE).join("|");
    // (?!_) cause 1.5x slowdown
    self.re.schema_test = RegExp("(^|(?!_)(?:[><\uFF5C]|" + re.src_ZPCc + "))(" + slist + ")", "i");
    self.re.schema_search = RegExp("(^|(?!_)(?:[><\uFF5C]|" + re.src_ZPCc + "))(" + slist + ")", "ig");
    self.re.pretest = RegExp("(" + self.re.schema_test.source + ")|(" + self.re.host_fuzzy_test.source + ")|@", "i");
    //
    // Cleanup
    //
    $ec039338a8bb4566$var$resetScanCache(self);
}
/**
 * class Match
 *
 * Match result. Single element of array, returned by [[LinkifyIt#match]]
 **/ function $ec039338a8bb4566$var$Match(self, shift) {
    var start = self.__index__, end = self.__last_index__, text = self.__text_cache__.slice(start, end);
    /**
   * Match#schema -> String
   *
   * Prefix (protocol) for matched string.
   **/ this.schema = self.__schema__.toLowerCase();
    /**
   * Match#index -> Number
   *
   * First position of matched string.
   **/ this.index = start + shift;
    /**
   * Match#lastIndex -> Number
   *
   * Next position after matched string.
   **/ this.lastIndex = end + shift;
    /**
   * Match#raw -> String
   *
   * Matched string.
   **/ this.raw = text;
    /**
   * Match#text -> String
   *
   * Notmalized text of matched string.
   **/ this.text = text;
    /**
   * Match#url -> String
   *
   * Normalized url of matched string.
   **/ this.url = text;
}
function $ec039338a8bb4566$var$createMatch(self, shift) {
    var match = new $ec039338a8bb4566$var$Match(self, shift);
    self.__compiled__[match.schema].normalize(match, self);
    return match;
}
/**
 * class LinkifyIt
 **/ /**
 * new LinkifyIt(schemas, options)
 * - schemas (Object): Optional. Additional schemas to validate (prefix/validator)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Creates new linkifier instance with optional additional schemas.
 * Can be called without `new` keyword for convenience.
 *
 * By default understands:
 *
 * - `http(s)://...` , `ftp://...`, `mailto:...` & `//...` links
 * - "fuzzy" links and emails (example.com, foo@bar.com).
 *
 * `schemas` is an object, where each key/value describes protocol/rule:
 *
 * - __key__ - link prefix (usually, protocol name with `:` at the end, `skype:`
 *   for example). `linkify-it` makes shure that prefix is not preceeded with
 *   alphanumeric char and symbols. Only whitespaces and punctuation allowed.
 * - __value__ - rule to check tail after link prefix
 *   - _String_ - just alias to existing rule
 *   - _Object_
 *     - _validate_ - validator function (should return matched length on success),
 *       or `RegExp`.
 *     - _normalize_ - optional function to normalize text & url of matched result
 *       (for example, for @twitter mentions).
 *
 * `options`:
 *
 * - __fuzzyLink__ - recognige URL-s without `http(s):` prefix. Default `true`.
 * - __fuzzyIP__ - allow IPs in fuzzy links above. Can conflict with some texts
 *   like version numbers. Default `false`.
 * - __fuzzyEmail__ - recognize emails without `mailto:` prefix.
 *
 **/ function $ec039338a8bb4566$var$LinkifyIt(schemas, options) {
    if (!(this instanceof $ec039338a8bb4566$var$LinkifyIt)) return new $ec039338a8bb4566$var$LinkifyIt(schemas, options);
    if (!options) {
        if ($ec039338a8bb4566$var$isOptionsObj(schemas)) {
            options = schemas;
            schemas = {};
        }
    }
    this.__opts__ = $ec039338a8bb4566$var$assign({}, $ec039338a8bb4566$var$defaultOptions, options);
    // Cache last tested result. Used to skip repeating steps on next `match` call.
    this.__index__ = -1;
    this.__last_index__ = -1; // Next scan position
    this.__schema__ = "";
    this.__text_cache__ = "";
    this.__schemas__ = $ec039338a8bb4566$var$assign({}, $ec039338a8bb4566$var$defaultSchemas, schemas);
    this.__compiled__ = {};
    this.__tlds__ = $ec039338a8bb4566$var$tlds_default;
    this.__tlds_replaced__ = false;
    this.re = {};
    $ec039338a8bb4566$var$compile(this);
}
/** chainable
 * LinkifyIt#add(schema, definition)
 * - schema (String): rule name (fixed pattern prefix)
 * - definition (String|RegExp|Object): schema definition
 *
 * Add new rule definition. See constructor description for details.
 **/ $ec039338a8bb4566$var$LinkifyIt.prototype.add = function add(schema, definition) {
    this.__schemas__[schema] = definition;
    $ec039338a8bb4566$var$compile(this);
    return this;
};
/** chainable
 * LinkifyIt#set(options)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Set recognition options for links without schema.
 **/ $ec039338a8bb4566$var$LinkifyIt.prototype.set = function set(options) {
    this.__opts__ = $ec039338a8bb4566$var$assign(this.__opts__, options);
    return this;
};
/**
 * LinkifyIt#test(text) -> Boolean
 *
 * Searches linkifiable pattern and returns `true` on success or `false` on fail.
 **/ $ec039338a8bb4566$var$LinkifyIt.prototype.test = function test(text) {
    // Reset scan cache
    this.__text_cache__ = text;
    this.__index__ = -1;
    if (!text.length) return false;
    var m, ml, me, len, shift, next, re, tld_pos, at_pos;
    // try to scan for link with schema - that's the most simple rule
    if (this.re.schema_test.test(text)) {
        re = this.re.schema_search;
        re.lastIndex = 0;
        while((m = re.exec(text)) !== null){
            len = this.testSchemaAt(text, m[2], re.lastIndex);
            if (len) {
                this.__schema__ = m[2];
                this.__index__ = m.index + m[1].length;
                this.__last_index__ = m.index + m[0].length + len;
                break;
            }
        }
    }
    if (this.__opts__.fuzzyLink && this.__compiled__["http:"]) {
        // guess schemaless links
        tld_pos = text.search(this.re.host_fuzzy_test);
        if (tld_pos >= 0) {
            // if tld is located after found link - no need to check fuzzy pattern
            if (this.__index__ < 0 || tld_pos < this.__index__) {
                if ((ml = text.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null) {
                    shift = ml.index + ml[1].length;
                    if (this.__index__ < 0 || shift < this.__index__) {
                        this.__schema__ = "";
                        this.__index__ = shift;
                        this.__last_index__ = ml.index + ml[0].length;
                    }
                }
            }
        }
    }
    if (this.__opts__.fuzzyEmail && this.__compiled__["mailto:"]) {
        // guess schemaless emails
        at_pos = text.indexOf("@");
        if (at_pos >= 0) // We can't skip this check, because this cases are possible:
        // 192.168.1.1@gmail.com, my.in@example.com
        {
            if ((me = text.match(this.re.email_fuzzy)) !== null) {
                shift = me.index + me[1].length;
                next = me.index + me[0].length;
                if (this.__index__ < 0 || shift < this.__index__ || shift === this.__index__ && next > this.__last_index__) {
                    this.__schema__ = "mailto:";
                    this.__index__ = shift;
                    this.__last_index__ = next;
                }
            }
        }
    }
    return this.__index__ >= 0;
};
/**
 * LinkifyIt#pretest(text) -> Boolean
 *
 * Very quick check, that can give false positives. Returns true if link MAY BE
 * can exists. Can be used for speed optimization, when you need to check that
 * link NOT exists.
 **/ $ec039338a8bb4566$var$LinkifyIt.prototype.pretest = function pretest(text) {
    return this.re.pretest.test(text);
};
/**
 * LinkifyIt#testSchemaAt(text, name, position) -> Number
 * - text (String): text to scan
 * - name (String): rule (schema) name
 * - position (Number): text offset to check from
 *
 * Similar to [[LinkifyIt#test]] but checks only specific protocol tail exactly
 * at given position. Returns length of found pattern (0 on fail).
 **/ $ec039338a8bb4566$var$LinkifyIt.prototype.testSchemaAt = function testSchemaAt(text, schema, pos) {
    // If not supported schema check requested - terminate
    if (!this.__compiled__[schema.toLowerCase()]) return 0;
    return this.__compiled__[schema.toLowerCase()].validate(text, pos, this);
};
/**
 * LinkifyIt#match(text) -> Array|null
 *
 * Returns array of found link descriptions or `null` on fail. We strongly
 * recommend to use [[LinkifyIt#test]] first, for best speed.
 *
 * ##### Result match description
 *
 * - __schema__ - link schema, can be empty for fuzzy links, or `//` for
 *   protocol-neutral  links.
 * - __index__ - offset of matched text
 * - __lastIndex__ - index of next char after mathch end
 * - __raw__ - matched text
 * - __text__ - normalized text
 * - __url__ - link, generated from matched text
 **/ $ec039338a8bb4566$var$LinkifyIt.prototype.match = function match(text) {
    var shift = 0, result = [];
    // Try to take previous element from cache, if .test() called before
    if (this.__index__ >= 0 && this.__text_cache__ === text) {
        result.push($ec039338a8bb4566$var$createMatch(this, shift));
        shift = this.__last_index__;
    }
    // Cut head if cache was used
    var tail = shift ? text.slice(shift) : text;
    // Scan string until end reached
    while(this.test(tail)){
        result.push($ec039338a8bb4566$var$createMatch(this, shift));
        tail = tail.slice(this.__last_index__);
        shift += this.__last_index__;
    }
    if (result.length) return result;
    return null;
};
/** chainable
 * LinkifyIt#tlds(list [, keepOld]) -> this
 * - list (Array): list of tlds
 * - keepOld (Boolean): merge with current list if `true` (`false` by default)
 *
 * Load (or merge) new tlds list. Those are user for fuzzy links (without prefix)
 * to avoid false positives. By default this algorythm used:
 *
 * - hostname with any 2-letter root zones are ok.
 * - biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф
 *   are ok.
 * - encoded (`xn--...`) root zones are ok.
 *
 * If list is replaced, then exact match for 2-chars root zones will be checked.
 **/ $ec039338a8bb4566$var$LinkifyIt.prototype.tlds = function tlds(list, keepOld) {
    list = Array.isArray(list) ? list : [
        list
    ];
    if (!keepOld) {
        this.__tlds__ = list.slice();
        this.__tlds_replaced__ = true;
        $ec039338a8bb4566$var$compile(this);
        return this;
    }
    this.__tlds__ = this.__tlds__.concat(list).sort().filter(function(el, idx, arr) {
        return el !== arr[idx - 1];
    }).reverse();
    $ec039338a8bb4566$var$compile(this);
    return this;
};
/**
 * LinkifyIt#normalize(match)
 *
 * Default normalizer (if schema does not define it's own).
 **/ $ec039338a8bb4566$var$LinkifyIt.prototype.normalize = function normalize(match) {
    // Do minimal possible changes by default. Need to collect feedback prior
    // to move forward https://github.com/markdown-it/linkify-it/issues/1
    if (!match.schema) match.url = "http://" + match.url;
    if (match.schema === "mailto:" && !/^mailto:/i.test(match.url)) match.url = "mailto:" + match.url;
};
/**
 * LinkifyIt#onCompile()
 *
 * Override to modify basic RegExp-s.
 **/ $ec039338a8bb4566$var$LinkifyIt.prototype.onCompile = function onCompile() {};
module.exports = $ec039338a8bb4566$var$LinkifyIt;

});
parcelRegister("ebQYg", function(module, exports) {
"use strict";




module.exports = function(opts) {
    var re = {};
    // Use direct extract instead of `regenerate` to reduse browserified size
    re.src_Any = (parcelRequire("kYZFY")).source;
    re.src_Cc = (parcelRequire("6hNPW")).source;
    re.src_Z = (parcelRequire("h5t0s")).source;
    re.src_P = (parcelRequire("hKVfa")).source;
    // \p{\Z\P\Cc\CF} (white spaces + control + format + punctuation)
    re.src_ZPCc = [
        re.src_Z,
        re.src_P,
        re.src_Cc
    ].join("|");
    // \p{\Z\Cc} (white spaces + control)
    re.src_ZCc = [
        re.src_Z,
        re.src_Cc
    ].join("|");
    // Experimental. List of chars, completely prohibited in links
    // because can separate it from other part of text
    var text_separators = "[><\uFF5C]";
    // All possible word characters (everything without punctuation, spaces & controls)
    // Defined via punctuation & spaces to save space
    // Should be something like \p{\L\N\S\M} (\w but without `_`)
    re.src_pseudo_letter = "(?:(?!" + text_separators + "|" + re.src_ZPCc + ")" + re.src_Any + ")";
    // The same as abothe but without [0-9]
    // var src_pseudo_letter_non_d = '(?:(?![0-9]|' + src_ZPCc + ')' + src_Any + ')';
    ////////////////////////////////////////////////////////////////////////////////
    re.src_ip4 = "(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)";
    // Prohibit any of "@/[]()" in user/pass to avoid wrong domain fetch.
    re.src_auth = "(?:(?:(?!" + re.src_ZCc + "|[@/\\[\\]()]).)+@)?";
    re.src_port = "(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?";
    re.src_host_terminator = "(?=$|" + text_separators + "|" + re.src_ZPCc + ")(?!-|_|:\\d|\\.-|\\.(?!$|" + re.src_ZPCc + "))";
    re.src_path = "(?:[/?#](?:(?!" + re.src_ZCc + "|" + text_separators + "|[()[\\]{}.,\"'?!\\-;]).|" + "\\[(?:(?!" + re.src_ZCc + "|\\]).)*\\]|" + "\\((?:(?!" + re.src_ZCc + "|[)]).)*\\)|" + "\\{(?:(?!" + re.src_ZCc + "|[}]).)*\\}|" + '\\"(?:(?!' + re.src_ZCc + '|["]).)+\\"|' + "\\'(?:(?!" + re.src_ZCc + "|[']).)+\\'|" + "\\'(?=" + re.src_pseudo_letter + "|[-]).|" + // allow `I'm_king` if no pair found
    "\\.{2,}[a-zA-Z0-9%/&]|" + // google has many dots in "google search" links (#66, #81).
    // github has ... in commit range links,
    // Restrict to
    // - english
    // - percent-encoded
    // - parts of file path
    // - params separator
    // until more examples found.
    "\\.(?!" + re.src_ZCc + "|[.]).|" + (opts && opts["---"] ? "\\-(?!--(?:[^-]|$))(?:-*)|" // `---` => long dash, terminate
     : "\\-+|") + ",(?!" + re.src_ZCc + ").|" + // allow `,,,` in paths
    ";(?!" + re.src_ZCc + ").|" + // allow `;` if not followed by space-like char
    "\\!+(?!" + re.src_ZCc + "|[!]).|" + // allow `!!!` in paths, but not at the end
    "\\?(?!" + re.src_ZCc + "|[?])." + ")+" + "|\\/" + ")?";
    // Allow anything in markdown spec, forbid quote (") at the first position
    // because emails enclosed in quotes are far more common
    re.src_email_name = '[\\-;:&=\\+\\$,\\.a-zA-Z0-9_][\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]*';
    re.src_xn = "xn--[a-z0-9\\-]{1,59}";
    // More to read about domain names
    // http://serverfault.com/questions/638260/
    re.src_domain_root = // Allow letters & digits (http://test1)
    "(?:" + re.src_xn + "|" + re.src_pseudo_letter + "{1,63}" + ")";
    re.src_domain = "(?:" + re.src_xn + "|" + "(?:" + re.src_pseudo_letter + ")" + "|" + "(?:" + re.src_pseudo_letter + "(?:-|" + re.src_pseudo_letter + "){0,61}" + re.src_pseudo_letter + ")" + ")";
    re.src_host = "(?:(?:(?:(?:" + re.src_domain + ")\\.)*" + re.src_domain /*_root*/  + ")" + ")";
    re.tpl_host_fuzzy = "(?:" + re.src_ip4 + "|" + "(?:(?:(?:" + re.src_domain + ")\\.)+(?:%TLDS%))" + ")";
    re.tpl_host_no_ip_fuzzy = "(?:(?:(?:" + re.src_domain + ")\\.)+(?:%TLDS%))";
    re.src_host_strict = re.src_host + re.src_host_terminator;
    re.tpl_host_fuzzy_strict = re.tpl_host_fuzzy + re.src_host_terminator;
    re.src_host_port_strict = re.src_host + re.src_port + re.src_host_terminator;
    re.tpl_host_port_fuzzy_strict = re.tpl_host_fuzzy + re.src_port + re.src_host_terminator;
    re.tpl_host_port_no_ip_fuzzy_strict = re.tpl_host_no_ip_fuzzy + re.src_port + re.src_host_terminator;
    ////////////////////////////////////////////////////////////////////////////////
    // Main rules
    // Rude test fuzzy links by host, for quick deny
    re.tpl_host_fuzzy_test = "localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:" + re.src_ZPCc + "|>|$))";
    re.tpl_email_fuzzy = "(^|" + text_separators + '|"|\\(|' + re.src_ZCc + ")" + "(" + re.src_email_name + "@" + re.tpl_host_fuzzy_strict + ")";
    re.tpl_link_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    "(^|(?![.:/\\-_@])(?:[$+<=>^`|\uFF5C]|" + re.src_ZPCc + "))" + "((?![$+<=>^`|\uFF5C])" + re.tpl_host_port_fuzzy_strict + re.src_path + ")";
    re.tpl_link_no_ip_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    "(^|(?![.:/\\-_@])(?:[$+<=>^`|\uFF5C]|" + re.src_ZPCc + "))" + "((?![$+<=>^`|\uFF5C])" + re.tpl_host_port_no_ip_fuzzy_strict + re.src_path + ")";
    return re;
};

});


parcelRegister("dBHwk", function(module, exports) {
(function(root) {
    /** Detect free variables */ var freeExports = exports && !exports.nodeType && exports;
    var freeModule = module && !module.nodeType && module;
    var freeGlobal = typeof $parcel$global == "object" && $parcel$global;
    if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal || freeGlobal.self === freeGlobal) root = freeGlobal;
    /**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */ var punycode, /** Highest positive signed 32-bit float value */ maxInt = 2147483647, /** Bootstring parameters */ base = 36, tMin = 1, tMax = 26, skew = 38, damp = 700, initialBias = 72, initialN = 128, delimiter = "-", /** Regular expressions */ regexPunycode = /^xn--/, regexNonASCII = /[^\x20-\x7E]/, regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, /** Error messages */ errors = {
        "overflow": "Overflow: input needs wider integers to process",
        "not-basic": "Illegal input >= 0x80 (not a basic code point)",
        "invalid-input": "Invalid input"
    }, /** Convenience shortcuts */ baseMinusTMin = base - tMin, floor = Math.floor, stringFromCharCode = String.fromCharCode, /** Temporary variable */ key;
    /*--------------------------------------------------------------------------*/ /**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */ function error(type) {
        throw new RangeError(errors[type]);
    }
    /**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */ function map(array, fn) {
        var length = array.length;
        var result = [];
        while(length--)result[length] = fn(array[length]);
        return result;
    }
    /**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */ function mapDomain(string, fn) {
        var parts = string.split("@");
        var result = "";
        if (parts.length > 1) {
            // In email addresses, only the domain name should be punycoded. Leave
            // the local part (i.e. everything up to `@`) intact.
            result = parts[0] + "@";
            string = parts[1];
        }
        // Avoid `split(regex)` for IE8 compatibility. See #17.
        string = string.replace(regexSeparators, ".");
        var labels = string.split(".");
        var encoded = map(labels, fn).join(".");
        return result + encoded;
    }
    /**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */ function ucs2decode(string) {
        var output = [], counter = 0, length = string.length, value, extra;
        while(counter < length){
            value = string.charCodeAt(counter++);
            if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
                // high surrogate, and there is a next character
                extra = string.charCodeAt(counter++);
                if ((extra & 0xFC00) == 0xDC00) output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
                else {
                    // unmatched surrogate; only append this code unit, in case the next
                    // code unit is the high surrogate of a surrogate pair
                    output.push(value);
                    counter--;
                }
            } else output.push(value);
        }
        return output;
    }
    /**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */ function ucs2encode(array) {
        return map(array, function(value) {
            var output = "";
            if (value > 0xFFFF) {
                value -= 0x10000;
                output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
                value = 0xDC00 | value & 0x3FF;
            }
            output += stringFromCharCode(value);
            return output;
        }).join("");
    }
    /**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */ function basicToDigit(codePoint) {
        if (codePoint - 48 < 10) return codePoint - 22;
        if (codePoint - 65 < 26) return codePoint - 65;
        if (codePoint - 97 < 26) return codePoint - 97;
        return base;
    }
    /**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */ function digitToBasic(digit, flag) {
        //  0..25 map to ASCII a..z or A..Z
        // 26..35 map to ASCII 0..9
        return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
    }
    /**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * https://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */ function adapt(delta, numPoints, firstTime) {
        var k = 0;
        delta = firstTime ? floor(delta / damp) : delta >> 1;
        delta += floor(delta / numPoints);
        for(; delta > baseMinusTMin * tMax >> 1; k += base)delta = floor(delta / baseMinusTMin);
        return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
    }
    /**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */ function decode(input) {
        // Don't use UCS-2
        var output = [], inputLength = input.length, out, i = 0, n = initialN, bias = initialBias, basic, j, index, oldi, w, k, digit, t, /** Cached calculation results */ baseMinusT;
        // Handle the basic code points: let `basic` be the number of input code
        // points before the last delimiter, or `0` if there is none, then copy
        // the first basic code points to the output.
        basic = input.lastIndexOf(delimiter);
        if (basic < 0) basic = 0;
        for(j = 0; j < basic; ++j){
            // if it's not a basic code point
            if (input.charCodeAt(j) >= 0x80) error("not-basic");
            output.push(input.charCodeAt(j));
        }
        // Main decoding loop: start just after the last delimiter if any basic code
        // points were copied; start at the beginning otherwise.
        for(index = basic > 0 ? basic + 1 : 0; index < inputLength;){
            // `index` is the index of the next character to be consumed.
            // Decode a generalized variable-length integer into `delta`,
            // which gets added to `i`. The overflow checking is easier
            // if we increase `i` as we go, then subtract off its starting
            // value at the end to obtain `delta`.
            for(oldi = i, w = 1, k = base;; k += base){
                if (index >= inputLength) error("invalid-input");
                digit = basicToDigit(input.charCodeAt(index++));
                if (digit >= base || digit > floor((maxInt - i) / w)) error("overflow");
                i += digit * w;
                t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                if (digit < t) break;
                baseMinusT = base - t;
                if (w > floor(maxInt / baseMinusT)) error("overflow");
                w *= baseMinusT;
            }
            out = output.length + 1;
            bias = adapt(i - oldi, out, oldi == 0);
            // `i` was supposed to wrap around from `out` to `0`,
            // incrementing `n` each time, so we'll fix that now:
            if (floor(i / out) > maxInt - n) error("overflow");
            n += floor(i / out);
            i %= out;
            // Insert `n` at position `i` of the output
            output.splice(i++, 0, n);
        }
        return ucs2encode(output);
    }
    /**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */ function encode(input) {
        var n, delta, handledCPCount, basicLength, bias, j, m, q, k, t, currentValue, output = [], /** `inputLength` will hold the number of code points in `input`. */ inputLength, /** Cached calculation results */ handledCPCountPlusOne, baseMinusT, qMinusT;
        // Convert the input in UCS-2 to Unicode
        input = ucs2decode(input);
        // Cache the length
        inputLength = input.length;
        // Initialize the state
        n = initialN;
        delta = 0;
        bias = initialBias;
        // Handle the basic code points
        for(j = 0; j < inputLength; ++j){
            currentValue = input[j];
            if (currentValue < 0x80) output.push(stringFromCharCode(currentValue));
        }
        handledCPCount = basicLength = output.length;
        // `handledCPCount` is the number of code points that have been handled;
        // `basicLength` is the number of basic code points.
        // Finish the basic string - if it is not empty - with a delimiter
        if (basicLength) output.push(delimiter);
        // Main encoding loop:
        while(handledCPCount < inputLength){
            // All non-basic code points < n have been handled already. Find the next
            // larger one:
            for(m = maxInt, j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue >= n && currentValue < m) m = currentValue;
            }
            // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
            // but guard against overflow
            handledCPCountPlusOne = handledCPCount + 1;
            if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) error("overflow");
            delta += (m - n) * handledCPCountPlusOne;
            n = m;
            for(j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue < n && ++delta > maxInt) error("overflow");
                if (currentValue == n) {
                    // Represent delta as a generalized variable-length integer
                    for(q = delta, k = base;; k += base){
                        t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                        if (q < t) break;
                        qMinusT = q - t;
                        baseMinusT = base - t;
                        output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0)));
                        q = floor(qMinusT / baseMinusT);
                    }
                    output.push(stringFromCharCode(digitToBasic(q, 0)));
                    bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
                    delta = 0;
                    ++handledCPCount;
                }
            }
            ++delta;
            ++n;
        }
        return output.join("");
    }
    /**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */ function toUnicode(input) {
        return mapDomain(input, function(string) {
            return regexPunycode.test(string) ? decode(string.slice(4).toLowerCase()) : string;
        });
    }
    /**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */ function toASCII(input) {
        return mapDomain(input, function(string) {
            return regexNonASCII.test(string) ? "xn--" + encode(string) : string;
        });
    }
    /*--------------------------------------------------------------------------*/ /** Define the public API */ punycode = {
        /**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */ "version": "1.4.1",
        /**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */ "ucs2": {
            "decode": ucs2decode,
            "encode": ucs2encode
        },
        "decode": decode,
        "encode": encode,
        "toASCII": toASCII,
        "toUnicode": toUnicode
    };
    /** Expose `punycode` */ // Some AMD build optimizers, like r.js, check for specific condition patterns
    // like the following:
    if (typeof define == "function" && typeof define.amd == "object" && define.amd) define("punycode", function() {
        return punycode;
    });
    else if (freeExports && freeModule) {
        if (module.exports == freeExports) // in Node.js, io.js, or RingoJS v0.8.0+
        freeModule.exports = punycode;
        else // in Narwhal or RingoJS v0.7.0-
        for(key in punycode)punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
    } else // in Rhino or a web browser
    root.punycode = punycode;
})(this);

});

parcelRegister("hzfZQ", function(module, exports) {
// markdown-it default options
"use strict";
module.exports = {
    options: {
        html: false,
        xhtmlOut: false,
        breaks: false,
        langPrefix: "language-",
        linkify: false,
        // Enable some language-neutral replacements + quotes beautification
        typographer: false,
        // Double + single quotes replacement pairs, when typographer enabled,
        // and smartquotes on. Could be either a String or an Array.
        //
        // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
        // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
        quotes: "\u201C\u201D\u2018\u2019",
        /* “”‘’ */ // Highlighter function. Should return escaped HTML,
        // or '' if the source string is not changed and should be escaped externaly.
        // If result starts with <pre... internal wrapper is skipped.
        //
        // function (/*str, lang*/) { return ''; }
        //
        highlight: null,
        maxNesting: 100 // Internal protection, recursion limit
    },
    components: {
        core: {},
        block: {},
        inline: {}
    }
};

});

parcelRegister("azWcK", function(module, exports) {
// "Zero" preset, with nothing enabled. Useful for manual configuring of simple
// modes. For example, to parse bold/italic only.
"use strict";
module.exports = {
    options: {
        html: false,
        xhtmlOut: false,
        breaks: false,
        langPrefix: "language-",
        linkify: false,
        // Enable some language-neutral replacements + quotes beautification
        typographer: false,
        // Double + single quotes replacement pairs, when typographer enabled,
        // and smartquotes on. Could be either a String or an Array.
        //
        // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
        // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
        quotes: "\u201C\u201D\u2018\u2019",
        /* “”‘’ */ // Highlighter function. Should return escaped HTML,
        // or '' if the source string is not changed and should be escaped externaly.
        // If result starts with <pre... internal wrapper is skipped.
        //
        // function (/*str, lang*/) { return ''; }
        //
        highlight: null,
        maxNesting: 20 // Internal protection, recursion limit
    },
    components: {
        core: {
            rules: [
                "normalize",
                "block",
                "inline"
            ]
        },
        block: {
            rules: [
                "paragraph"
            ]
        },
        inline: {
            rules: [
                "text"
            ],
            rules2: [
                "balance_pairs",
                "text_collapse"
            ]
        }
    }
};

});

parcelRegister("7xkVi", function(module, exports) {
// Commonmark default options
"use strict";
module.exports = {
    options: {
        html: true,
        xhtmlOut: true,
        breaks: false,
        langPrefix: "language-",
        linkify: false,
        // Enable some language-neutral replacements + quotes beautification
        typographer: false,
        // Double + single quotes replacement pairs, when typographer enabled,
        // and smartquotes on. Could be either a String or an Array.
        //
        // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
        // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
        quotes: "\u201C\u201D\u2018\u2019",
        /* “”‘’ */ // Highlighter function. Should return escaped HTML,
        // or '' if the source string is not changed and should be escaped externaly.
        // If result starts with <pre... internal wrapper is skipped.
        //
        // function (/*str, lang*/) { return ''; }
        //
        highlight: null,
        maxNesting: 20 // Internal protection, recursion limit
    },
    components: {
        core: {
            rules: [
                "normalize",
                "block",
                "inline"
            ]
        },
        block: {
            rules: [
                "blockquote",
                "code",
                "fence",
                "heading",
                "hr",
                "html_block",
                "lheading",
                "list",
                "reference",
                "paragraph"
            ]
        },
        inline: {
            rules: [
                "autolink",
                "backticks",
                "emphasis",
                "entity",
                "escape",
                "html_inline",
                "image",
                "link",
                "newline",
                "text"
            ],
            rules2: [
                "balance_pairs",
                "emphasis",
                "text_collapse"
            ]
        }
    }
};

});



parcelRegister("6b0aG", function(module, exports) {

$parcel$export(module.exports, "Reorder", () => $9c86cd671359483b$export$335fca4219867448);

var $eOUII = parcelRequire("eOUII");

var $3839M = parcelRequire("3839M");
var $9c86cd671359483b$export$335fca4219867448 = {
    Group: (0, $eOUII.Group),
    Item: (0, $3839M.Item)
};

});
parcelRegister("eOUII", function(module, exports) {

$parcel$export(module.exports, "Group", () => $0365bba34f1d466d$export$eb2fcfdbd7ba97d4);

var $7WQrb = parcelRequire("7WQrb");

var $6QSfE = parcelRequire("6QSfE");

var $acw62 = parcelRequire("acw62");

var $cjo2Y = parcelRequire("cjo2Y");

var $fRJCp = parcelRequire("fRJCp");

var $aTYEI = parcelRequire("aTYEI");

var $cS2nl = parcelRequire("cS2nl");
function $0365bba34f1d466d$export$be27b7672e0f20ab(_a, externalRef) {
    var children = _a.children, _b = _a.as, as = _b === void 0 ? "ul" : _b, _c = _a.axis, axis = _c === void 0 ? "y" : _c, onReorder = _a.onReorder, values = _a.values, props = (0, $7WQrb.__rest)(_a, [
        "children",
        "as",
        "axis",
        "onReorder",
        "values"
    ]);
    var Component = (0, $aTYEI.useConstant)(function() {
        return (0, $fRJCp.motion)(as);
    });
    var order = [];
    var isReordering = (0, $acw62.useRef)(false);
    (0, $6QSfE.invariant)(Boolean(values), "Reorder.Group must be provided a values prop");
    var context = {
        axis: axis,
        registerItem: function(value, layout) {
            /**
             * Ensure entries can't add themselves more than once
             */ if (layout && order.findIndex(function(entry) {
                return value === entry.value;
            }) === -1) {
                order.push({
                    value: value,
                    layout: layout[axis]
                });
                order.sort($0365bba34f1d466d$var$compareMin);
            }
        },
        updateOrder: function(id, offset, velocity) {
            if (isReordering.current) return;
            var newOrder = (0, $cS2nl.checkReorder)(order, id, offset, velocity);
            if (order !== newOrder) {
                isReordering.current = true;
                onReorder(newOrder.map($0365bba34f1d466d$var$getValue).filter(function(value) {
                    return values.indexOf(value) !== -1;
                }));
            }
        }
    };
    (0, $acw62.useEffect)(function() {
        isReordering.current = false;
    });
    return $acw62.createElement(Component, (0, $7WQrb.__assign)({}, props, {
        ref: externalRef
    }), $acw62.createElement((0, $cjo2Y.ReorderContext).Provider, {
        value: context
    }, children));
}
var $0365bba34f1d466d$export$eb2fcfdbd7ba97d4 = (0, $acw62.forwardRef)($0365bba34f1d466d$export$be27b7672e0f20ab);
function $0365bba34f1d466d$var$getValue(item) {
    return item.value;
}
function $0365bba34f1d466d$var$compareMin(a, b) {
    return a.layout.min - b.layout.min;
}

});
parcelRegister("6QSfE", function(module, exports) {

$parcel$export(module.exports, "warning", () => $4fd1ae9b00853f6f$export$491112666e282270);
$parcel$export(module.exports, "invariant", () => $4fd1ae9b00853f6f$export$f5708dca728d7177);
var $4fd1ae9b00853f6f$export$491112666e282270 = function() {};
var $4fd1ae9b00853f6f$export$f5708dca728d7177 = function() {};

});

parcelRegister("cjo2Y", function(module, exports) {

$parcel$export(module.exports, "ReorderContext", () => $7d57c5da66682d92$export$2b8a1fb072f61d10);

var $acw62 = parcelRequire("acw62");
var $7d57c5da66682d92$export$2b8a1fb072f61d10 = (0, $acw62.createContext)(null);

});

parcelRegister("fRJCp", function(module, exports) {

$parcel$export(module.exports, "motion", () => $a93b6401f922fd1e$export$e25e478948902b8b);

var $7WQrb = parcelRequire("7WQrb");

var $lqm1a = parcelRequire("lqm1a");

var $hrSjo = parcelRequire("hrSjo");

var $i2j08 = parcelRequire("i2j08");

var $iLse2 = parcelRequire("iLse2");

var $crTFY = parcelRequire("crTFY");

var $80qKP = parcelRequire("80qKP");

var $6LgnS = parcelRequire("6LgnS");

var $h1u5n = parcelRequire("h1u5n");

var $9ycLt = parcelRequire("9ycLt");
var $a93b6401f922fd1e$var$featureBundle = (0, $7WQrb.__assign)((0, $7WQrb.__assign)((0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, (0, $crTFY.animations)), (0, $iLse2.gestureAnimations)), (0, $80qKP.drag)), (0, $h1u5n.layoutFeatures));
/**
 * HTML & SVG components, optimised for use with gestures and animation. These can be used as
 * drop-in replacements for any HTML & SVG component, all CSS & SVG properties are supported.
 *
 * @public
 */ var $a93b6401f922fd1e$export$e25e478948902b8b = /*@__PURE__*/ (0, $hrSjo.createMotionProxy)(function(Component, config) {
    return (0, $i2j08.createDomMotionConfig)(Component, config, $a93b6401f922fd1e$var$featureBundle, (0, $6LgnS.createDomVisualElement), (0, $9ycLt.HTMLProjectionNode));
});
/**
 * Create a DOM `motion` component with the provided string. This is primarily intended
 * as a full alternative to `motion` for consumers who have to support environments that don't
 * support `Proxy`.
 *
 * ```javascript
 * import { createDomMotionComponent } from "framer-motion"
 *
 * const motion = {
 *   div: createDomMotionComponent('div')
 * }
 * ```
 *
 * @public
 */ function $a93b6401f922fd1e$export$546614c4a05701f9(key) {
    return (0, $lqm1a.createMotionComponent)((0, $i2j08.createDomMotionConfig)(key, {
        forwardMotionProps: false
    }, $a93b6401f922fd1e$var$featureBundle, (0, $6LgnS.createDomVisualElement), (0, $9ycLt.HTMLProjectionNode)));
}

});
parcelRegister("lqm1a", function(module, exports) {

$parcel$export(module.exports, "createMotionComponent", () => $b40dad60036091a1$export$46b7e4b9dc6110c3);

var $7WQrb = parcelRequire("7WQrb");

var $acw62 = parcelRequire("acw62");

var $gvdBu = parcelRequire("gvdBu");

var $7iCGF = parcelRequire("7iCGF");

var $e3EFx = parcelRequire("e3EFx");

var $ju9rq = parcelRequire("ju9rq");

var $1mSqb = parcelRequire("1mSqb");

var $2XQbq = parcelRequire("2XQbq");

var $7bH6a = parcelRequire("7bH6a");

var $4L0T5 = parcelRequire("4L0T5");

var $jwTou = parcelRequire("jwTou");

var $cNR5T = parcelRequire("cNR5T");

var $gRT2S = parcelRequire("gRT2S");

var $IwILZ = parcelRequire("IwILZ");
/**
 * Create a `motion` component.
 *
 * This function accepts a Component argument, which can be either a string (ie "div"
 * for `motion.div`), or an actual React component.
 *
 * Alongside this is a config option which provides a way of rendering the provided
 * component "offline", or outside the React render cycle.
 */ function $b40dad60036091a1$export$46b7e4b9dc6110c3(_a) {
    var preloadedFeatures = _a.preloadedFeatures, createVisualElement = _a.createVisualElement, projectionNodeConstructor = _a.projectionNodeConstructor, useRender = _a.useRender, useVisualState = _a.useVisualState, Component = _a.Component;
    preloadedFeatures && (0, $7bH6a.loadFeatures)(preloadedFeatures);
    function MotionComponent(props, externalRef) {
        var layoutId = $b40dad60036091a1$var$useLayoutId(props);
        props = (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, props), {
            layoutId: layoutId
        });
        /**
         * If we're rendering in a static environment, we only visually update the component
         * as a result of a React-rerender rather than interactions or animations. This
         * means we don't need to load additional memory structures like VisualElement,
         * or any gesture/animation features.
         */ var config = (0, $acw62.useContext)((0, $7iCGF.MotionConfigContext));
        var features = null;
        var context = (0, $2XQbq.useCreateMotionContext)(props);
        /**
         * Create a unique projection ID for this component. If a new component is added
         * during a layout animation we'll use this to query the DOM and hydrate its ref early, allowing
         * us to measure it as soon as any layout effect flushes pending layout animations.
         *
         * Performance note: It'd be better not to have to search the DOM for these elements.
         * For newly-entering components it could be enough to only correct treeScale, in which
         * case we could mount in a scale-correction mode. This wouldn't be enough for
         * shared element transitions however. Perhaps for those we could revert to a root node
         * that gets forceRendered and layout animations are triggered on its layout effect.
         */ var projectionId = config.isStatic ? undefined : (0, $jwTou.useProjectionId)();
        /**
         *
         */ var visualState = useVisualState(props, config.isStatic);
        if (!config.isStatic && (0, $4L0T5.isBrowser)) {
            /**
             * Create a VisualElement for this component. A VisualElement provides a common
             * interface to renderer-specific APIs (ie DOM/Three.js etc) as well as
             * providing a way of rendering to these APIs outside of the React render loop
             * for more performant animations and interactions
             */ context.visualElement = (0, $ju9rq.useVisualElement)(Component, visualState, (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, config), props), createVisualElement);
            (0, $gRT2S.useProjection)(projectionId, props, context.visualElement, projectionNodeConstructor || (0, $7bH6a.featureDefinitions).projectionNodeConstructor);
            /**
             * Load Motion gesture and animation features. These are rendered as renderless
             * components so each feature can optionally make use of React lifecycle methods.
             */ features = (0, $gvdBu.useFeatures)(props, context.visualElement, preloadedFeatures);
        }
        /**
         * The mount order and hierarchy is specific to ensure our element ref
         * is hydrated by the time features fire their effects.
         */ return $acw62.createElement((0, $IwILZ.VisualElementHandler), {
            visualElement: context.visualElement,
            props: (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, config), props)
        }, features, $acw62.createElement((0, $e3EFx.MotionContext).Provider, {
            value: context
        }, useRender(Component, props, projectionId, (0, $1mSqb.useMotionRef)(visualState, context.visualElement, externalRef), visualState, config.isStatic, context.visualElement)));
    }
    return (0, $acw62.forwardRef)(MotionComponent);
}
function $b40dad60036091a1$var$useLayoutId(_a) {
    var _b;
    var layoutId = _a.layoutId;
    var layoutGroupId = (_b = (0, $acw62.useContext)((0, $cNR5T.LayoutGroupContext))) === null || _b === void 0 ? void 0 : _b.id;
    return layoutGroupId && layoutId !== undefined ? layoutGroupId + "-" + layoutId : layoutId;
}

});
parcelRegister("gvdBu", function(module, exports) {

$parcel$export(module.exports, "useFeatures", () => $73c1b54532db957d$export$4a39035bacc4ed76);

var $7WQrb = parcelRequire("7WQrb");

var $acw62 = parcelRequire("acw62");

var $4ziSZ = parcelRequire("4ziSZ");

var $7bH6a = parcelRequire("7bH6a");

var $6QSfE = parcelRequire("6QSfE");

var $3WGFy = parcelRequire("3WGFy");
var $73c1b54532db957d$var$featureNames = Object.keys((0, $7bH6a.featureDefinitions));
var $73c1b54532db957d$var$numFeatures = $73c1b54532db957d$var$featureNames.length;
/**
 * Load features via renderless components based on the provided MotionProps.
 */ function $73c1b54532db957d$export$4a39035bacc4ed76(props, visualElement, preloadedFeatures) {
    var features = [];
    var lazyContext = (0, $acw62.useContext)((0, $3WGFy.LazyContext));
    if (!visualElement) return null;
    /**
     * If we're in development mode, check to make sure we're not rendering a motion component
     * as a child of LazyMotion, as this will break the file-size benefits of using it.
     */ if ((0, $4ziSZ.env) !== "production" && preloadedFeatures && lazyContext.strict) (0, $6QSfE.invariant)(false, "You have rendered a `motion` component within a `LazyMotion` component. This will break tree shaking. Import and render a `m` component instead.");
    for(var i = 0; i < $73c1b54532db957d$var$numFeatures; i++){
        var name_1 = $73c1b54532db957d$var$featureNames[i];
        var _a = (0, $7bH6a.featureDefinitions)[name_1], isEnabled = _a.isEnabled, Component = _a.Component;
        /**
         * It might be possible in the future to use this moment to
         * dynamically request functionality. In initial tests this
         * was producing a lot of duplication amongst bundles.
         */ if (isEnabled(props) && Component) features.push($acw62.createElement(Component, (0, $7WQrb.__assign)({
            key: name_1
        }, props, {
            visualElement: visualElement
        })));
    }
    return features;
}

});
parcelRegister("4ziSZ", function(module, exports) {

$parcel$export(module.exports, "env", () => $99d7f0237561b447$export$a7b6bc01c63cdfc3);
/**
 * Browser-safe usage of process
 */ 
var $hPtJY = parcelRequire("hPtJY");
var $99d7f0237561b447$var$defaultEnvironment = "production";
var $99d7f0237561b447$export$a7b6bc01c63cdfc3 = typeof $hPtJY === "undefined" || $hPtJY.env === undefined ? $99d7f0237561b447$var$defaultEnvironment : "production";

});
parcelRegister("hPtJY", function(module, exports) {
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = "browser";
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ""; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return "/";
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};

});


parcelRegister("7bH6a", function(module, exports) {

$parcel$export(module.exports, "featureDefinitions", () => $a8d82256030e9525$export$65570e08d843624d);
$parcel$export(module.exports, "loadFeatures", () => $a8d82256030e9525$export$449561ec5703cdc8);
var $a8d82256030e9525$var$createDefinition = function(propNames) {
    return {
        isEnabled: function(props) {
            return propNames.some(function(name) {
                return !!props[name];
            });
        }
    };
};
var $a8d82256030e9525$export$65570e08d843624d = {
    measureLayout: $a8d82256030e9525$var$createDefinition([
        "layout",
        "layoutId",
        "drag"
    ]),
    animation: $a8d82256030e9525$var$createDefinition([
        "animate",
        "exit",
        "variants",
        "whileHover",
        "whileTap",
        "whileFocus",
        "whileDrag",
        "whileInView"
    ]),
    exit: $a8d82256030e9525$var$createDefinition([
        "exit"
    ]),
    drag: $a8d82256030e9525$var$createDefinition([
        "drag",
        "dragControls"
    ]),
    focus: $a8d82256030e9525$var$createDefinition([
        "whileFocus"
    ]),
    hover: $a8d82256030e9525$var$createDefinition([
        "whileHover",
        "onHoverStart",
        "onHoverEnd"
    ]),
    tap: $a8d82256030e9525$var$createDefinition([
        "whileTap",
        "onTap",
        "onTapStart",
        "onTapCancel"
    ]),
    pan: $a8d82256030e9525$var$createDefinition([
        "onPan",
        "onPanStart",
        "onPanSessionStart",
        "onPanEnd"
    ]),
    inView: $a8d82256030e9525$var$createDefinition([
        "whileInView",
        "onViewportEnter",
        "onViewportLeave"
    ])
};
function $a8d82256030e9525$export$449561ec5703cdc8(features) {
    for(var key in features){
        if (features[key] === null) continue;
        if (key === "projectionNodeConstructor") $a8d82256030e9525$export$65570e08d843624d.projectionNodeConstructor = features[key];
        else $a8d82256030e9525$export$65570e08d843624d[key].Component = features[key];
    }
}

});

parcelRegister("3WGFy", function(module, exports) {

$parcel$export(module.exports, "LazyContext", () => $410b846e117db9e1$export$40f10139ecf1f171);

var $acw62 = parcelRequire("acw62");
var $410b846e117db9e1$export$40f10139ecf1f171 = (0, $acw62.createContext)({
    strict: false
});

});


parcelRegister("7iCGF", function(module, exports) {

$parcel$export(module.exports, "MotionConfigContext", () => $3bbbde5b328b4154$export$22a697fb29aac98d);

var $acw62 = parcelRequire("acw62");
/**
 * @public
 */ var $3bbbde5b328b4154$export$22a697fb29aac98d = (0, $acw62.createContext)({
    transformPagePoint: function(p) {
        return p;
    },
    isStatic: false,
    reducedMotion: "never"
});

});

parcelRegister("e3EFx", function(module, exports) {

$parcel$export(module.exports, "MotionContext", () => $3ce32ada97cfc8f7$export$2285bbca2c666415);
$parcel$export(module.exports, "useVisualElementContext", () => $3ce32ada97cfc8f7$export$cd995842eb2ab956);

var $acw62 = parcelRequire("acw62");
var $3ce32ada97cfc8f7$export$2285bbca2c666415 = (0, $acw62.createContext)({});
function $3ce32ada97cfc8f7$export$cd995842eb2ab956() {
    return (0, $acw62.useContext)($3ce32ada97cfc8f7$export$2285bbca2c666415).visualElement;
}

});

parcelRegister("ju9rq", function(module, exports) {

$parcel$export(module.exports, "useVisualElement", () => $7fb0f4644b9cc8ad$export$dc0335d73ab0b115);

var $acw62 = parcelRequire("acw62");

var $gtJis = parcelRequire("gtJis");

var $e3EFx = parcelRequire("e3EFx");

var $6S63t = parcelRequire("6S63t");

var $3WGFy = parcelRequire("3WGFy");

var $8J7at = parcelRequire("8J7at");
function $7fb0f4644b9cc8ad$export$dc0335d73ab0b115(Component, visualState, props, createVisualElement) {
    var lazyContext = (0, $acw62.useContext)((0, $3WGFy.LazyContext));
    var parent = (0, $e3EFx.useVisualElementContext)();
    var presenceContext = (0, $acw62.useContext)((0, $gtJis.PresenceContext));
    var shouldReduceMotion = (0, $8J7at.useReducedMotionConfig)();
    var visualElementRef = (0, $acw62.useRef)(undefined);
    /**
     * If we haven't preloaded a renderer, check to see if we have one lazy-loaded
     */ if (!createVisualElement) createVisualElement = lazyContext.renderer;
    if (!visualElementRef.current && createVisualElement) visualElementRef.current = createVisualElement(Component, {
        visualState: visualState,
        parent: parent,
        props: props,
        presenceId: presenceContext === null || presenceContext === void 0 ? void 0 : presenceContext.id,
        blockInitialAnimation: (presenceContext === null || presenceContext === void 0 ? void 0 : presenceContext.initial) === false,
        shouldReduceMotion: shouldReduceMotion
    });
    var visualElement = visualElementRef.current;
    (0, $6S63t.useIsomorphicLayoutEffect)(function() {
        visualElement === null || visualElement === void 0 || visualElement.syncRender();
    });
    (0, $acw62.useEffect)(function() {
        var _a;
        (_a = visualElement === null || visualElement === void 0 ? void 0 : visualElement.animationState) === null || _a === void 0 || _a.animateChanges();
    });
    (0, $6S63t.useIsomorphicLayoutEffect)(function() {
        return function() {
            return visualElement === null || visualElement === void 0 ? void 0 : visualElement.notifyUnmount();
        };
    }, []);
    return visualElement;
}

});
parcelRegister("gtJis", function(module, exports) {

$parcel$export(module.exports, "PresenceContext", () => $dba5d94a982c4145$export$f224e4635b6f8ce2);

var $acw62 = parcelRequire("acw62");
/**
 * @public
 */ var $dba5d94a982c4145$export$f224e4635b6f8ce2 = (0, $acw62.createContext)(null);

});

parcelRegister("6S63t", function(module, exports) {

$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $9c674755a93db746$export$700979bc83e7db82);

var $acw62 = parcelRequire("acw62");

var $4L0T5 = parcelRequire("4L0T5");
var $9c674755a93db746$export$700979bc83e7db82 = (0, $4L0T5.isBrowser) ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);

});
parcelRegister("4L0T5", function(module, exports) {

$parcel$export(module.exports, "isBrowser", () => $784730508f12f72c$export$4e09c449d6c407f7);
var $784730508f12f72c$export$4e09c449d6c407f7 = typeof document !== "undefined";

});


parcelRegister("8J7at", function(module, exports) {

$parcel$export(module.exports, "useReducedMotionConfig", () => $5332c6c3d284aaae$export$ec21f7709af6bc1e);

var $7WQrb = parcelRequire("7WQrb");

var $acw62 = parcelRequire("acw62");

var $7iCGF = parcelRequire("7iCGF");

var $4L0T5 = parcelRequire("4L0T5");
// Does this device prefer reduced motion? Returns `null` server-side.
var $5332c6c3d284aaae$var$prefersReducedMotion = {
    current: null
};
var $5332c6c3d284aaae$var$hasDetected = false;
function $5332c6c3d284aaae$var$initPrefersReducedMotion() {
    $5332c6c3d284aaae$var$hasDetected = true;
    if (!(0, $4L0T5.isBrowser)) return;
    if (window.matchMedia) {
        var motionMediaQuery_1 = window.matchMedia("(prefers-reduced-motion)");
        var setReducedMotionPreferences = function() {
            return $5332c6c3d284aaae$var$prefersReducedMotion.current = motionMediaQuery_1.matches;
        };
        motionMediaQuery_1.addListener(setReducedMotionPreferences);
        setReducedMotionPreferences();
    } else $5332c6c3d284aaae$var$prefersReducedMotion.current = false;
}
/**
 * A hook that returns `true` if we should be using reduced motion based on the current device's Reduced Motion setting.
 *
 * This can be used to implement changes to your UI based on Reduced Motion. For instance, replacing motion-sickness inducing
 * `x`/`y` animations with `opacity`, disabling the autoplay of background videos, or turning off parallax motion.
 *
 * It will actively respond to changes and re-render your components with the latest setting.
 *
 * ```jsx
 * export function Sidebar({ isOpen }) {
 *   const shouldReduceMotion = useReducedMotion()
 *   const closedX = shouldReduceMotion ? 0 : "-100%"
 *
 *   return (
 *     <motion.div animate={{
 *       opacity: isOpen ? 1 : 0,
 *       x: isOpen ? 0 : closedX
 *     }} />
 *   )
 * }
 * ```
 *
 * @return boolean
 *
 * @public
 */ function $5332c6c3d284aaae$export$6a42007cf1e7b6f8() {
    /**
     * Lazy initialisation of prefersReducedMotion
     */ !$5332c6c3d284aaae$var$hasDetected && $5332c6c3d284aaae$var$initPrefersReducedMotion();
    var _a = (0, $7WQrb.__read)((0, $acw62.useState)($5332c6c3d284aaae$var$prefersReducedMotion.current), 1), shouldReduceMotion = _a[0];
    /**
     * TODO See if people miss automatically updating shouldReduceMotion setting
     */ return shouldReduceMotion;
}
function $5332c6c3d284aaae$export$ec21f7709af6bc1e() {
    var reducedMotionPreference = $5332c6c3d284aaae$export$6a42007cf1e7b6f8();
    var reducedMotion = (0, $acw62.useContext)((0, $7iCGF.MotionConfigContext)).reducedMotion;
    if (reducedMotion === "never") return false;
    else if (reducedMotion === "always") return true;
    else return reducedMotionPreference;
}

});


parcelRegister("1mSqb", function(module, exports) {

$parcel$export(module.exports, "useMotionRef", () => $88efa764bb00537b$export$c684914703d321fd);

var $acw62 = parcelRequire("acw62");

var $cg30p = parcelRequire("cg30p");
/**
 * Creates a ref function that, when called, hydrates the provided
 * external ref and VisualElement.
 */ function $88efa764bb00537b$export$c684914703d321fd(visualState, visualElement, externalRef) {
    return (0, $acw62.useCallback)(function(instance) {
        var _a;
        instance && ((_a = visualState.mount) === null || _a === void 0 || _a.call(visualState, instance));
        if (visualElement) instance ? visualElement.mount(instance) : visualElement.unmount();
        if (externalRef) {
            if (typeof externalRef === "function") externalRef(instance);
            else if ((0, $cg30p.isRefObject)(externalRef)) externalRef.current = instance;
        }
    }, /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */ [
        visualElement
    ]);
}

});
parcelRegister("cg30p", function(module, exports) {

$parcel$export(module.exports, "isRefObject", () => $d157673547c2a934$export$dedd81df7bc1307);
function $d157673547c2a934$export$dedd81df7bc1307(ref) {
    return typeof ref === "object" && Object.prototype.hasOwnProperty.call(ref, "current");
}

});


parcelRegister("2XQbq", function(module, exports) {

$parcel$export(module.exports, "useCreateMotionContext", () => $4cb87fa0b981df8c$export$c5638d843b37a176);

var $acw62 = parcelRequire("acw62");

var $e3EFx = parcelRequire("e3EFx");

var $aZXLC = parcelRequire("aZXLC");
function $4cb87fa0b981df8c$export$c5638d843b37a176(props) {
    var _a = (0, $aZXLC.getCurrentTreeVariants)(props, (0, $acw62.useContext)((0, $e3EFx.MotionContext))), initial = _a.initial, animate = _a.animate;
    return (0, $acw62.useMemo)(function() {
        return {
            initial: initial,
            animate: animate
        };
    }, [
        $4cb87fa0b981df8c$var$variantLabelsAsDependency(initial),
        $4cb87fa0b981df8c$var$variantLabelsAsDependency(animate)
    ]);
}
function $4cb87fa0b981df8c$var$variantLabelsAsDependency(prop) {
    return Array.isArray(prop) ? prop.join(" ") : prop;
}

});
parcelRegister("aZXLC", function(module, exports) {

$parcel$export(module.exports, "getCurrentTreeVariants", () => $9e57028cf0cad086$export$12fc32fc096a04a3);

var $8QQaD = parcelRequire("8QQaD");
function $9e57028cf0cad086$export$12fc32fc096a04a3(props, context) {
    if ((0, $8QQaD.checkIfControllingVariants)(props)) {
        var initial = props.initial, animate = props.animate;
        return {
            initial: initial === false || (0, $8QQaD.isVariantLabel)(initial) ? initial : undefined,
            animate: (0, $8QQaD.isVariantLabel)(animate) ? animate : undefined
        };
    }
    return props.inherit !== false ? context : {};
}

});
parcelRegister("8QQaD", function(module, exports) {

$parcel$export(module.exports, "isVariantLabels", () => $0861f93f2aa87ed8$export$562271cd22f751d);
$parcel$export(module.exports, "isVariantLabel", () => $0861f93f2aa87ed8$export$720b90e312cea233);
$parcel$export(module.exports, "resolveVariantFromProps", () => $0861f93f2aa87ed8$export$d68f140c4d9b48bc);
$parcel$export(module.exports, "resolveVariant", () => $0861f93f2aa87ed8$export$7b1b1c981f4f0558);
$parcel$export(module.exports, "checkIfControllingVariants", () => $0861f93f2aa87ed8$export$cf3a7bd331c35bf0);
$parcel$export(module.exports, "checkIfVariantNode", () => $0861f93f2aa87ed8$export$c0eba02279c18fea);
/**
 * Decides if the supplied variable is an array of variant labels
 */ function $0861f93f2aa87ed8$export$562271cd22f751d(v) {
    return Array.isArray(v);
}
/**
 * Decides if the supplied variable is variant label
 */ function $0861f93f2aa87ed8$export$720b90e312cea233(v) {
    return typeof v === "string" || $0861f93f2aa87ed8$export$562271cd22f751d(v);
}
/**
 * Creates an object containing the latest state of every MotionValue on a VisualElement
 */ function $0861f93f2aa87ed8$var$getCurrent(visualElement) {
    var current = {};
    visualElement.forEachValue(function(value, key) {
        return current[key] = value.get();
    });
    return current;
}
/**
 * Creates an object containing the latest velocity of every MotionValue on a VisualElement
 */ function $0861f93f2aa87ed8$var$getVelocity(visualElement) {
    var velocity = {};
    visualElement.forEachValue(function(value, key) {
        return velocity[key] = value.getVelocity();
    });
    return velocity;
}
function $0861f93f2aa87ed8$export$d68f140c4d9b48bc(props, definition, custom, currentValues, currentVelocity) {
    var _a;
    if (currentValues === void 0) currentValues = {};
    if (currentVelocity === void 0) currentVelocity = {};
    /**
     * If the variant definition is a function, resolve.
     */ if (typeof definition === "function") definition = definition(custom !== null && custom !== void 0 ? custom : props.custom, currentValues, currentVelocity);
    /**
     * If the variant definition is a variant label, or
     * the function returned a variant label, resolve.
     */ if (typeof definition === "string") definition = (_a = props.variants) === null || _a === void 0 ? void 0 : _a[definition];
    /**
     * At this point we've resolved both functions and variant labels,
     * but the resolved variant label might itself have been a function.
     * If so, resolve. This can only have returned a valid target object.
     */ if (typeof definition === "function") definition = definition(custom !== null && custom !== void 0 ? custom : props.custom, currentValues, currentVelocity);
    return definition;
}
function $0861f93f2aa87ed8$export$7b1b1c981f4f0558(visualElement, definition, custom) {
    var props = visualElement.getProps();
    return $0861f93f2aa87ed8$export$d68f140c4d9b48bc(props, definition, custom !== null && custom !== void 0 ? custom : props.custom, $0861f93f2aa87ed8$var$getCurrent(visualElement), $0861f93f2aa87ed8$var$getVelocity(visualElement));
}
function $0861f93f2aa87ed8$export$cf3a7bd331c35bf0(props) {
    var _a;
    return typeof ((_a = props.animate) === null || _a === void 0 ? void 0 : _a.start) === "function" || $0861f93f2aa87ed8$export$720b90e312cea233(props.initial) || $0861f93f2aa87ed8$export$720b90e312cea233(props.animate) || $0861f93f2aa87ed8$export$720b90e312cea233(props.whileHover) || $0861f93f2aa87ed8$export$720b90e312cea233(props.whileDrag) || $0861f93f2aa87ed8$export$720b90e312cea233(props.whileTap) || $0861f93f2aa87ed8$export$720b90e312cea233(props.whileFocus) || $0861f93f2aa87ed8$export$720b90e312cea233(props.exit);
}
function $0861f93f2aa87ed8$export$c0eba02279c18fea(props) {
    return Boolean($0861f93f2aa87ed8$export$cf3a7bd331c35bf0(props) || props.variants);
}

});



parcelRegister("jwTou", function(module, exports) {

$parcel$export(module.exports, "useProjectionId", () => $050be86dbc9816d5$export$5ed57b87c18af11a);

var $aTYEI = parcelRequire("aTYEI");

var $9CWXG = parcelRequire("9CWXG");
var $050be86dbc9816d5$var$id = 1;
function $050be86dbc9816d5$export$5ed57b87c18af11a() {
    return (0, $aTYEI.useConstant)(function() {
        if ((0, $9CWXG.globalProjectionState).hasEverUpdated) return $050be86dbc9816d5$var$id++;
    });
}

});
parcelRegister("aTYEI", function(module, exports) {

$parcel$export(module.exports, "useConstant", () => $40f5fd83135889a9$export$fe4300aa8eebea86);

var $acw62 = parcelRequire("acw62");
/**
 * Creates a constant value over the lifecycle of a component.
 *
 * Even if `useMemo` is provided an empty array as its final argument, it doesn't offer
 * a guarantee that it won't re-run for performance reasons later on. By using `useConstant`
 * you can ensure that initialisers don't execute twice or more.
 */ function $40f5fd83135889a9$export$fe4300aa8eebea86(init) {
    var ref = (0, $acw62.useRef)(null);
    if (ref.current === null) ref.current = init();
    return ref.current;
}

});

parcelRegister("9CWXG", function(module, exports) {

$parcel$export(module.exports, "globalProjectionState", () => $b29dc04080b74d0c$export$97db156a3ed1593b);
/**
 * This should only ever be modified on the client otherwise it'll
 * persist through server requests. If we need instanced states we
 * could lazy-init via root.
 */ var $b29dc04080b74d0c$export$97db156a3ed1593b = {
    /**
     * Global flag as to whether the tree has animated since the last time
     * we resized the window
     */ hasAnimatedSinceResize: true,
    /**
     * We set this to true once, on the first update. Any nodes added to the tree beyond that
     * update will be given a `data-projection-id` attribute.
     */ hasEverUpdated: false
};

});


parcelRegister("cNR5T", function(module, exports) {

$parcel$export(module.exports, "LayoutGroupContext", () => $4ae202aab5791dbc$export$a3579ca508007a95);

var $acw62 = parcelRequire("acw62");
var $4ae202aab5791dbc$export$a3579ca508007a95 = (0, $acw62.createContext)({});

});

parcelRegister("gRT2S", function(module, exports) {

$parcel$export(module.exports, "useProjection", () => $c3c3c69892b6a008$export$80ade90e64f5118b);

var $cg30p = parcelRequire("cg30p");

var $acw62 = parcelRequire("acw62");

var $9lcvq = parcelRequire("9lcvq");
function $c3c3c69892b6a008$export$80ade90e64f5118b(projectionId, _a, visualElement, ProjectionNodeConstructor) {
    var _b;
    var layoutId = _a.layoutId, layout = _a.layout, drag = _a.drag, dragConstraints = _a.dragConstraints, layoutScroll = _a.layoutScroll;
    var initialPromotionConfig = (0, $acw62.useContext)((0, $9lcvq.SwitchLayoutGroupContext));
    if (!ProjectionNodeConstructor || !visualElement || (visualElement === null || visualElement === void 0 ? void 0 : visualElement.projection)) return;
    visualElement.projection = new ProjectionNodeConstructor(projectionId, visualElement.getLatestValues(), (_b = visualElement.parent) === null || _b === void 0 ? void 0 : _b.projection);
    visualElement.projection.setOptions({
        layoutId: layoutId,
        layout: layout,
        alwaysMeasureLayout: Boolean(drag) || dragConstraints && (0, $cg30p.isRefObject)(dragConstraints),
        visualElement: visualElement,
        scheduleRender: function() {
            return visualElement.scheduleRender();
        },
        /**
         * TODO: Update options in an effect. This could be tricky as it'll be too late
         * to update by the time layout animations run.
         * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
         * ensuring it gets called if there's no potential layout animations.
         *
         */ animationType: typeof layout === "string" ? layout : "both",
        initialPromotionConfig: initialPromotionConfig,
        layoutScroll: layoutScroll
    });
}

});
parcelRegister("9lcvq", function(module, exports) {

$parcel$export(module.exports, "SwitchLayoutGroupContext", () => $c612a166b65a9c69$export$da5f7b802957459a);

var $acw62 = parcelRequire("acw62");
/**
 * Internal, exported only for usage in Framer
 */ var $c612a166b65a9c69$export$da5f7b802957459a = (0, $acw62.createContext)({});

});


parcelRegister("IwILZ", function(module, exports) {

$parcel$export(module.exports, "VisualElementHandler", () => $f5d17fe65e7e845e$export$a9ca437df31f9491);

var $7WQrb = parcelRequire("7WQrb");

var $acw62 = parcelRequire("acw62");
var $f5d17fe65e7e845e$export$a9ca437df31f9491 = /** @class */ function(_super) {
    (0, $7WQrb.__extends)(VisualElementHandler, _super);
    function VisualElementHandler() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Update visual element props as soon as we know this update is going to be commited.
     */ VisualElementHandler.prototype.getSnapshotBeforeUpdate = function() {
        this.updateProps();
        return null;
    };
    VisualElementHandler.prototype.componentDidUpdate = function() {};
    VisualElementHandler.prototype.updateProps = function() {
        var _a = this.props, visualElement = _a.visualElement, props = _a.props;
        if (visualElement) visualElement.setProps(props);
    };
    VisualElementHandler.prototype.render = function() {
        return this.props.children;
    };
    return VisualElementHandler;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);

});


parcelRegister("hrSjo", function(module, exports) {

$parcel$export(module.exports, "createMotionProxy", () => $16a09bb264d348bb$export$a28d6df673050e18);

var $lqm1a = parcelRequire("lqm1a");
/**
 * Convert any React component into a `motion` component. The provided component
 * **must** use `React.forwardRef` to the underlying DOM component you want to animate.
 *
 * ```jsx
 * const Component = React.forwardRef((props, ref) => {
 *   return <div ref={ref} />
 * })
 *
 * const MotionComponent = motion(Component)
 * ```
 *
 * @public
 */ function $16a09bb264d348bb$export$a28d6df673050e18(createConfig) {
    function custom(Component, customMotionComponentConfig) {
        if (customMotionComponentConfig === void 0) customMotionComponentConfig = {};
        return (0, $lqm1a.createMotionComponent)(createConfig(Component, customMotionComponentConfig));
    }
    if (typeof Proxy === "undefined") return custom;
    /**
     * A cache of generated `motion` components, e.g `motion.div`, `motion.input` etc.
     * Rather than generating them anew every render.
     */ var componentCache = new Map();
    return new Proxy(custom, {
        /**
         * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
         * The prop name is passed through as `key` and we can use that to generate a `motion`
         * DOM component with that name.
         */ get: function(_target, key) {
            /**
             * If this element doesn't exist in the component cache, create it and cache.
             */ if (!componentCache.has(key)) componentCache.set(key, custom(key));
            return componentCache.get(key);
        }
    });
}

});

parcelRegister("i2j08", function(module, exports) {

$parcel$export(module.exports, "createDomMotionConfig", () => $73e3a8d89278ed7b$export$732916c0e88175fb);

var $7WQrb = parcelRequire("7WQrb");

var $9GusU = parcelRequire("9GusU");

var $fFVoM = parcelRequire("fFVoM");

var $AO3i6 = parcelRequire("AO3i6");

var $jCKYH = parcelRequire("jCKYH");
function $73e3a8d89278ed7b$export$732916c0e88175fb(Component, _a, preloadedFeatures, createVisualElement, projectionNodeConstructor) {
    var _b = _a.forwardMotionProps, forwardMotionProps = _b === void 0 ? false : _b;
    var baseConfig = (0, $9GusU.isSVGComponent)(Component) ? (0, $AO3i6.svgMotionConfig) : (0, $jCKYH.htmlMotionConfig);
    return (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, baseConfig), {
        preloadedFeatures: preloadedFeatures,
        useRender: (0, $fFVoM.createUseRender)(forwardMotionProps),
        createVisualElement: createVisualElement,
        projectionNodeConstructor: projectionNodeConstructor,
        Component: Component
    });
}

});
parcelRegister("9GusU", function(module, exports) {

$parcel$export(module.exports, "isSVGComponent", () => $ca4ea6365adee72d$export$88f3fc2fd3766989);

var $2jNiu = parcelRequire("2jNiu");
function $ca4ea6365adee72d$export$88f3fc2fd3766989(Component) {
    if (/**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */ typeof Component !== "string" || /**
         * If it contains a dash, the element is a custom HTML webcomponent.
         */ Component.includes("-")) return false;
    else if (/**
     * If it's in our list of lowercase SVG tags, it's an SVG component
     */ (0, $2jNiu.lowercaseSVGElements).indexOf(Component) > -1 || /**
         * If it contains a capital letter, it's an SVG component
         */ /[A-Z]/.test(Component)) return true;
    return false;
}

});
parcelRegister("2jNiu", function(module, exports) {

$parcel$export(module.exports, "lowercaseSVGElements", () => $1d85745fbdd79bfa$export$40209c4c512158e6);
/**
 * We keep these listed seperately as we use the lowercase tag names as part
 * of the runtime bundle to detect SVG components
 */ var $1d85745fbdd79bfa$export$40209c4c512158e6 = [
    "animate",
    "circle",
    "defs",
    "desc",
    "ellipse",
    "g",
    "image",
    "line",
    "filter",
    "marker",
    "mask",
    "metadata",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "rect",
    "stop",
    "svg",
    "switch",
    "symbol",
    "text",
    "tspan",
    "use",
    "view"
];

});


parcelRegister("fFVoM", function(module, exports) {

$parcel$export(module.exports, "createUseRender", () => $dc80cb5954e76638$export$5d29104eefd89cc8);

var $7WQrb = parcelRequire("7WQrb");

var $acw62 = parcelRequire("acw62");

var $aZIZO = parcelRequire("aZIZO");

var $8RV9d = parcelRequire("8RV9d");

var $9GusU = parcelRequire("9GusU");

var $cc1pG = parcelRequire("cc1pG");
function $dc80cb5954e76638$export$5d29104eefd89cc8(forwardMotionProps) {
    if (forwardMotionProps === void 0) forwardMotionProps = false;
    var useRender = function(Component, props, projectionId, ref, _a, isStatic) {
        var latestValues = _a.latestValues;
        var useVisualProps = (0, $9GusU.isSVGComponent)(Component) ? (0, $cc1pG.useSVGProps) : (0, $aZIZO.useHTMLProps);
        var visualProps = useVisualProps(props, latestValues, isStatic);
        var filteredProps = (0, $8RV9d.filterProps)(props, typeof Component === "string", forwardMotionProps);
        var elementProps = (0, $7WQrb.__assign)((0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, filteredProps), visualProps), {
            ref: ref
        });
        if (projectionId) elementProps["data-projection-id"] = projectionId;
        return (0, $acw62.createElement)(Component, elementProps);
    };
    return useRender;
}

});
parcelRegister("aZIZO", function(module, exports) {

$parcel$export(module.exports, "copyRawValuesOnly", () => $81d8dfeeb8038b0d$export$40dafdb8630c956b);
$parcel$export(module.exports, "useHTMLProps", () => $81d8dfeeb8038b0d$export$57be0a314572d87d);

var $7WQrb = parcelRequire("7WQrb");

var $acw62 = parcelRequire("acw62");

var $8tTaz = parcelRequire("8tTaz");

var $jqFCw = parcelRequire("jqFCw");

var $9U95V = parcelRequire("9U95V");

var $fiQRA = parcelRequire("fiQRA");
function $81d8dfeeb8038b0d$export$40dafdb8630c956b(target, source, props) {
    for(var key in source)if (!(0, $jqFCw.isMotionValue)(source[key]) && !(0, $8tTaz.isForcedMotionValue)(key, props)) target[key] = source[key];
}
function $81d8dfeeb8038b0d$var$useInitialMotionValues(_a, visualState, isStatic) {
    var transformTemplate = _a.transformTemplate;
    return (0, $acw62.useMemo)(function() {
        var state = (0, $fiQRA.createHtmlRenderState)();
        (0, $9U95V.buildHTMLStyles)(state, visualState, {
            enableHardwareAcceleration: !isStatic
        }, transformTemplate);
        var vars = state.vars, style = state.style;
        return (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, vars), style);
    }, [
        visualState
    ]);
}
function $81d8dfeeb8038b0d$export$72c85e333541e7f(props, visualState, isStatic) {
    var styleProp = props.style || {};
    var style = {};
    /**
     * Copy non-Motion Values straight into style
     */ $81d8dfeeb8038b0d$export$40dafdb8630c956b(style, styleProp, props);
    Object.assign(style, $81d8dfeeb8038b0d$var$useInitialMotionValues(props, visualState, isStatic));
    if (props.transformValues) style = props.transformValues(style);
    return style;
}
function $81d8dfeeb8038b0d$export$57be0a314572d87d(props, visualState, isStatic) {
    // The `any` isn't ideal but it is the type of createElement props argument
    var htmlProps = {};
    var style = $81d8dfeeb8038b0d$export$72c85e333541e7f(props, visualState, isStatic);
    if (Boolean(props.drag) && props.dragListener !== false) {
        // Disable the ghost element when a user drags
        htmlProps.draggable = false;
        // Disable text selection
        style.userSelect = style.WebkitUserSelect = style.WebkitTouchCallout = "none";
        // Disable scrolling on the draggable direction
        style.touchAction = props.drag === true ? "none" : "pan-".concat(props.drag === "x" ? "y" : "x");
    }
    htmlProps.style = style;
    return htmlProps;
}

});
parcelRegister("8tTaz", function(module, exports) {

$parcel$export(module.exports, "isForcedMotionValue", () => $443c859766df5778$export$6d27ce8e3de1c3cf);

var $i0qI9 = parcelRequire("i0qI9");

var $5f0mC = parcelRequire("5f0mC");
function $443c859766df5778$export$6d27ce8e3de1c3cf(key, _a) {
    var layout = _a.layout, layoutId = _a.layoutId;
    return (0, $5f0mC.isTransformProp)(key) || (0, $5f0mC.isTransformOriginProp)(key) || (layout || layoutId !== undefined) && (!!(0, $i0qI9.scaleCorrectors)[key] || key === "opacity");
}

});
parcelRegister("i0qI9", function(module, exports) {

$parcel$export(module.exports, "scaleCorrectors", () => $eced91e16bda42df$export$91ddd985b97788d1);
$parcel$export(module.exports, "addScaleCorrector", () => $eced91e16bda42df$export$de9e7791c71225fd);
var $eced91e16bda42df$export$91ddd985b97788d1 = {};
function $eced91e16bda42df$export$de9e7791c71225fd(correctors) {
    Object.assign($eced91e16bda42df$export$91ddd985b97788d1, correctors);
}

});

parcelRegister("5f0mC", function(module, exports) {

$parcel$export(module.exports, "transformAxes", () => $ac502869c4d3e65a$export$67cd428da31419e1);
$parcel$export(module.exports, "transformProps", () => $ac502869c4d3e65a$export$7b42a0094fb00b6e);
$parcel$export(module.exports, "sortTransformProps", () => $ac502869c4d3e65a$export$61f68472e7973485);
$parcel$export(module.exports, "isTransformProp", () => $ac502869c4d3e65a$export$15240a8a4379d8de);
$parcel$export(module.exports, "isTransformOriginProp", () => $ac502869c4d3e65a$export$91fe49ee9d172523);
/**
 * A list of all transformable axes. We'll use this list to generated a version
 * of each axes for each transform.
 */ var $ac502869c4d3e65a$export$67cd428da31419e1 = [
    "",
    "X",
    "Y",
    "Z"
];
/**
 * An ordered array of each transformable value. By default, transform values
 * will be sorted to this order.
 */ var $ac502869c4d3e65a$var$order = [
    "translate",
    "scale",
    "rotate",
    "skew"
];
/**
 * Generate a list of every possible transform key.
 */ var $ac502869c4d3e65a$export$7b42a0094fb00b6e = [
    "transformPerspective",
    "x",
    "y",
    "z"
];
$ac502869c4d3e65a$var$order.forEach(function(operationKey) {
    return $ac502869c4d3e65a$export$67cd428da31419e1.forEach(function(axesKey) {
        return $ac502869c4d3e65a$export$7b42a0094fb00b6e.push(operationKey + axesKey);
    });
});
/**
 * A function to use with Array.sort to sort transform keys by their default order.
 */ function $ac502869c4d3e65a$export$61f68472e7973485(a, b) {
    return $ac502869c4d3e65a$export$7b42a0094fb00b6e.indexOf(a) - $ac502869c4d3e65a$export$7b42a0094fb00b6e.indexOf(b);
}
/**
 * A quick lookup for transform props.
 */ var $ac502869c4d3e65a$var$transformPropSet = new Set($ac502869c4d3e65a$export$7b42a0094fb00b6e);
function $ac502869c4d3e65a$export$15240a8a4379d8de(key) {
    return $ac502869c4d3e65a$var$transformPropSet.has(key);
}
/**
 * A quick lookup for transform origin props
 */ var $ac502869c4d3e65a$var$transformOriginProps = new Set([
    "originX",
    "originY",
    "originZ"
]);
function $ac502869c4d3e65a$export$91fe49ee9d172523(key) {
    return $ac502869c4d3e65a$var$transformOriginProps.has(key);
}

});


parcelRegister("jqFCw", function(module, exports) {

$parcel$export(module.exports, "isMotionValue", () => $55c3387a92452647$export$605d60a2578142d3);
var $55c3387a92452647$export$605d60a2578142d3 = function(value) {
    return Boolean(value !== null && typeof value === "object" && value.getVelocity);
};

});

parcelRegister("9U95V", function(module, exports) {

$parcel$export(module.exports, "buildHTMLStyles", () => $a883e7c624291d03$export$bb517f8b40f8e99d);

var $et7Or = parcelRequire("et7Or");

var $dAJIO = parcelRequire("dAJIO");

var $5f0mC = parcelRequire("5f0mC");

var $mpKah = parcelRequire("mpKah");

var $hsgeP = parcelRequire("hsgeP");
function $a883e7c624291d03$export$bb517f8b40f8e99d(state, latestValues, options, transformTemplate) {
    var _a;
    var style = state.style, vars = state.vars, transform = state.transform, transformKeys = state.transformKeys, transformOrigin = state.transformOrigin;
    // Empty the transformKeys array. As we're throwing out refs to its items
    // this might not be as cheap as suspected. Maybe using the array as a buffer
    // with a manual incrementation would be better.
    transformKeys.length = 0;
    // Track whether we encounter any transform or transformOrigin values.
    var hasTransform = false;
    var hasTransformOrigin = false;
    // Does the calculated transform essentially equal "none"?
    var transformIsNone = true;
    /**
     * Loop over all our latest animated values and decide whether to handle them
     * as a style or CSS variable.
     *
     * Transforms and transform origins are kept seperately for further processing.
     */ for(var key in latestValues){
        var value = latestValues[key];
        /**
         * If this is a CSS variable we don't do any further processing.
         */ if ((0, $dAJIO.isCSSVariable)(key)) {
            vars[key] = value;
            continue;
        }
        // Convert the value to its default value type, ie 0 -> "0px"
        var valueType = (0, $hsgeP.numberValueTypes)[key];
        var valueAsType = (0, $mpKah.getValueAsType)(value, valueType);
        if ((0, $5f0mC.isTransformProp)(key)) {
            // If this is a transform, flag to enable further transform processing
            hasTransform = true;
            transform[key] = valueAsType;
            transformKeys.push(key);
            // If we already know we have a non-default transform, early return
            if (!transformIsNone) continue;
            // Otherwise check to see if this is a default transform
            if (value !== ((_a = valueType.default) !== null && _a !== void 0 ? _a : 0)) transformIsNone = false;
        } else if ((0, $5f0mC.isTransformOriginProp)(key)) {
            transformOrigin[key] = valueAsType;
            // If this is a transform origin, flag and enable further transform-origin processing
            hasTransformOrigin = true;
        } else style[key] = valueAsType;
    }
    if (hasTransform) style.transform = (0, $et7Or.buildTransform)(state, options, transformIsNone, transformTemplate);
    else if (transformTemplate) style.transform = transformTemplate({}, "");
    else if (!latestValues.transform && style.transform) style.transform = "none";
    if (hasTransformOrigin) style.transformOrigin = (0, $et7Or.buildTransformOrigin)(transformOrigin);
}

});
parcelRegister("et7Or", function(module, exports) {

$parcel$export(module.exports, "buildTransform", () => $1724c99b9b724858$export$bdc96e0d5c8f914);
$parcel$export(module.exports, "buildTransformOrigin", () => $1724c99b9b724858$export$22d2fbf39767d07a);

var $5f0mC = parcelRequire("5f0mC");
var $1724c99b9b724858$var$translateAlias = {
    x: "translateX",
    y: "translateY",
    z: "translateZ",
    transformPerspective: "perspective"
};
/**
 * Build a CSS transform style from individual x/y/scale etc properties.
 *
 * This outputs with a default order of transforms/scales/rotations, this can be customised by
 * providing a transformTemplate function.
 */ function $1724c99b9b724858$export$bdc96e0d5c8f914(_a, _b, transformIsDefault, transformTemplate) {
    var transform = _a.transform, transformKeys = _a.transformKeys;
    var _c = _b.enableHardwareAcceleration, enableHardwareAcceleration = _c === void 0 ? true : _c, _d = _b.allowTransformNone, allowTransformNone = _d === void 0 ? true : _d;
    // The transform string we're going to build into.
    var transformString = "";
    // Transform keys into their default order - this will determine the output order.
    transformKeys.sort((0, $5f0mC.sortTransformProps));
    // Track whether the defined transform has a defined z so we don't add a
    // second to enable hardware acceleration
    var transformHasZ = false;
    // Loop over each transform and build them into transformString
    var numTransformKeys = transformKeys.length;
    for(var i = 0; i < numTransformKeys; i++){
        var key = transformKeys[i];
        transformString += "".concat($1724c99b9b724858$var$translateAlias[key] || key, "(").concat(transform[key], ") ");
        if (key === "z") transformHasZ = true;
    }
    if (!transformHasZ && enableHardwareAcceleration) transformString += "translateZ(0)";
    else transformString = transformString.trim();
    // If we have a custom `transform` template, pass our transform values and
    // generated transformString to that before returning
    if (transformTemplate) transformString = transformTemplate(transform, transformIsDefault ? "" : transformString);
    else if (allowTransformNone && transformIsDefault) transformString = "none";
    return transformString;
}
/**
 * Build a transformOrigin style. Uses the same defaults as the browser for
 * undefined origins.
 */ function $1724c99b9b724858$export$22d2fbf39767d07a(_a) {
    var _b = _a.originX, originX = _b === void 0 ? "50%" : _b, _c = _a.originY, originY = _c === void 0 ? "50%" : _c, _d = _a.originZ, originZ = _d === void 0 ? 0 : _d;
    return "".concat(originX, " ").concat(originY, " ").concat(originZ);
}

});

parcelRegister("dAJIO", function(module, exports) {

$parcel$export(module.exports, "isCSSVariable", () => $f9c5e88311214d2a$export$451bc42768436155);
/**
 * Returns true if the provided key is a CSS variable
 */ function $f9c5e88311214d2a$export$451bc42768436155(key) {
    return key.startsWith("--");
}

});

parcelRegister("mpKah", function(module, exports) {

$parcel$export(module.exports, "getValueAsType", () => $a19b1277e1098e3a$export$453ef540a9a1bd6b);
/**
 * Provided a value and a ValueType, returns the value as that value type.
 */ var $a19b1277e1098e3a$export$453ef540a9a1bd6b = function(value, type) {
    return type && typeof value === "number" ? type.transform(value) : value;
};

});

parcelRegister("hsgeP", function(module, exports) {

$parcel$export(module.exports, "numberValueTypes", () => $d5c56ef81d4ff9c2$export$eec14432cd1cb67b);

var $g4T9J = parcelRequire("g4T9J");
var $1fCxR = parcelRequire("1fCxR");

var $bt85H = parcelRequire("bt85H");
var $d5c56ef81d4ff9c2$export$eec14432cd1cb67b = {
    // Border props
    borderWidth: (0, $1fCxR.px),
    borderTopWidth: (0, $1fCxR.px),
    borderRightWidth: (0, $1fCxR.px),
    borderBottomWidth: (0, $1fCxR.px),
    borderLeftWidth: (0, $1fCxR.px),
    borderRadius: (0, $1fCxR.px),
    radius: (0, $1fCxR.px),
    borderTopLeftRadius: (0, $1fCxR.px),
    borderTopRightRadius: (0, $1fCxR.px),
    borderBottomRightRadius: (0, $1fCxR.px),
    borderBottomLeftRadius: (0, $1fCxR.px),
    // Positioning props
    width: (0, $1fCxR.px),
    maxWidth: (0, $1fCxR.px),
    height: (0, $1fCxR.px),
    maxHeight: (0, $1fCxR.px),
    size: (0, $1fCxR.px),
    top: (0, $1fCxR.px),
    right: (0, $1fCxR.px),
    bottom: (0, $1fCxR.px),
    left: (0, $1fCxR.px),
    // Spacing props
    padding: (0, $1fCxR.px),
    paddingTop: (0, $1fCxR.px),
    paddingRight: (0, $1fCxR.px),
    paddingBottom: (0, $1fCxR.px),
    paddingLeft: (0, $1fCxR.px),
    margin: (0, $1fCxR.px),
    marginTop: (0, $1fCxR.px),
    marginRight: (0, $1fCxR.px),
    marginBottom: (0, $1fCxR.px),
    marginLeft: (0, $1fCxR.px),
    // Transform props
    rotate: (0, $1fCxR.degrees),
    rotateX: (0, $1fCxR.degrees),
    rotateY: (0, $1fCxR.degrees),
    rotateZ: (0, $1fCxR.degrees),
    scale: (0, $g4T9J.scale),
    scaleX: (0, $g4T9J.scale),
    scaleY: (0, $g4T9J.scale),
    scaleZ: (0, $g4T9J.scale),
    skew: (0, $1fCxR.degrees),
    skewX: (0, $1fCxR.degrees),
    skewY: (0, $1fCxR.degrees),
    distance: (0, $1fCxR.px),
    translateX: (0, $1fCxR.px),
    translateY: (0, $1fCxR.px),
    translateZ: (0, $1fCxR.px),
    x: (0, $1fCxR.px),
    y: (0, $1fCxR.px),
    z: (0, $1fCxR.px),
    perspective: (0, $1fCxR.px),
    transformPerspective: (0, $1fCxR.px),
    opacity: (0, $g4T9J.alpha),
    originX: (0, $1fCxR.progressPercentage),
    originY: (0, $1fCxR.progressPercentage),
    originZ: (0, $1fCxR.px),
    // Misc
    zIndex: (0, $bt85H.int),
    // SVG
    fillOpacity: (0, $g4T9J.alpha),
    strokeOpacity: (0, $g4T9J.alpha),
    numOctaves: (0, $bt85H.int)
};

});
parcelRegister("g4T9J", function(module, exports) {

$parcel$export(module.exports, "number", () => $b4f6d145fa485818$export$98e628dec113755e);
$parcel$export(module.exports, "alpha", () => $b4f6d145fa485818$export$58f0f39f63f3cf42);
$parcel$export(module.exports, "scale", () => $b4f6d145fa485818$export$dcdf75081b88279d);

var $5sH7B = parcelRequire("5sH7B");
const $b4f6d145fa485818$export$98e628dec113755e = {
    test: (v)=>typeof v === "number",
    parse: parseFloat,
    transform: (v)=>v
};
const $b4f6d145fa485818$export$58f0f39f63f3cf42 = Object.assign(Object.assign({}, $b4f6d145fa485818$export$98e628dec113755e), {
    transform: (0, $5sH7B.clamp)(0, 1)
});
const $b4f6d145fa485818$export$dcdf75081b88279d = Object.assign(Object.assign({}, $b4f6d145fa485818$export$98e628dec113755e), {
    default: 1
});

});
parcelRegister("5sH7B", function(module, exports) {

$parcel$export(module.exports, "clamp", () => $470374f87b8ca393$export$7d15b64cf5a3a4c4);
$parcel$export(module.exports, "sanitize", () => $470374f87b8ca393$export$83d2e9e3e4ee39ed);
$parcel$export(module.exports, "floatRegex", () => $470374f87b8ca393$export$2444ca58c08448e4);
$parcel$export(module.exports, "colorRegex", () => $470374f87b8ca393$export$740b69c5fad25dba);
$parcel$export(module.exports, "singleColorRegex", () => $470374f87b8ca393$export$ed808ff6ecd39e8d);
$parcel$export(module.exports, "isString", () => $470374f87b8ca393$export$844ec244b1367d54);
const $470374f87b8ca393$export$7d15b64cf5a3a4c4 = (min, max)=>(v)=>Math.max(Math.min(v, max), min);
const $470374f87b8ca393$export$83d2e9e3e4ee39ed = (v)=>v % 1 ? Number(v.toFixed(5)) : v;
const $470374f87b8ca393$export$2444ca58c08448e4 = /(-)?([\d]*\.?[\d])+/g;
const $470374f87b8ca393$export$740b69c5fad25dba = /(#[0-9a-f]{6}|#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2,3}\s*\/*\s*[\d\.]+%?\))/gi;
const $470374f87b8ca393$export$ed808ff6ecd39e8d = /^(#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2,3}\s*\/*\s*[\d\.]+%?\))$/i;
function $470374f87b8ca393$export$844ec244b1367d54(v) {
    return typeof v === "string";
}

});


parcelRegister("1fCxR", function(module, exports) {

$parcel$export(module.exports, "degrees", () => $9ad32cb76340910d$export$41fc368e1a942b97);
$parcel$export(module.exports, "percent", () => $9ad32cb76340910d$export$626336c2cd4b14de);
$parcel$export(module.exports, "px", () => $9ad32cb76340910d$export$91c0eda1d06bf008);
$parcel$export(module.exports, "vh", () => $9ad32cb76340910d$export$f91e8c45a95a32f2);
$parcel$export(module.exports, "vw", () => $9ad32cb76340910d$export$aed3d7b7d206c196);
$parcel$export(module.exports, "progressPercentage", () => $9ad32cb76340910d$export$44e2e1705876d7ed);

var $5sH7B = parcelRequire("5sH7B");
const $9ad32cb76340910d$var$createUnitType = (unit)=>({
        test: (v)=>(0, $5sH7B.isString)(v) && v.endsWith(unit) && v.split(" ").length === 1,
        parse: parseFloat,
        transform: (v)=>`${v}${unit}`
    });
const $9ad32cb76340910d$export$41fc368e1a942b97 = $9ad32cb76340910d$var$createUnitType("deg");
const $9ad32cb76340910d$export$626336c2cd4b14de = $9ad32cb76340910d$var$createUnitType("%");
const $9ad32cb76340910d$export$91c0eda1d06bf008 = $9ad32cb76340910d$var$createUnitType("px");
const $9ad32cb76340910d$export$f91e8c45a95a32f2 = $9ad32cb76340910d$var$createUnitType("vh");
const $9ad32cb76340910d$export$aed3d7b7d206c196 = $9ad32cb76340910d$var$createUnitType("vw");
const $9ad32cb76340910d$export$44e2e1705876d7ed = Object.assign(Object.assign({}, $9ad32cb76340910d$export$626336c2cd4b14de), {
    parse: (v)=>$9ad32cb76340910d$export$626336c2cd4b14de.parse(v) / 100,
    transform: (v)=>$9ad32cb76340910d$export$626336c2cd4b14de.transform(v * 100)
});

});

parcelRegister("bt85H", function(module, exports) {

$parcel$export(module.exports, "int", () => $dfe40ab2e6446bb9$export$7d260a2a5f8bc19e);

var $7WQrb = parcelRequire("7WQrb");

var $g4T9J = parcelRequire("g4T9J");
var $dfe40ab2e6446bb9$export$7d260a2a5f8bc19e = (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, (0, $g4T9J.number)), {
    transform: Math.round
});

});



parcelRegister("fiQRA", function(module, exports) {

$parcel$export(module.exports, "createHtmlRenderState", () => $57bb451bc3d87577$export$8940b483cf52eeda);
var $57bb451bc3d87577$export$8940b483cf52eeda = function() {
    return {
        style: {},
        transform: {},
        transformKeys: [],
        transformOrigin: {},
        vars: {}
    };
};

});


parcelRegister("8RV9d", function(module, exports) {

$parcel$export(module.exports, "filterProps", () => $05db6db4ebcdf5f1$export$d697c39a2985a4c);

var $nQeJi = parcelRequire("nQeJi");
var $05db6db4ebcdf5f1$var$shouldForward = function(key) {
    return !(0, $nQeJi.isValidMotionProp)(key);
};
function $05db6db4ebcdf5f1$export$59d6962c470509a5(isValidProp) {
    if (!isValidProp) return;
    // Explicitly filter our events
    $05db6db4ebcdf5f1$var$shouldForward = function(key) {
        return key.startsWith("on") ? !(0, $nQeJi.isValidMotionProp)(key) : isValidProp(key);
    };
}

/**
 * Emotion and Styled Components both allow users to pass through arbitrary props to their components
 * to dynamically generate CSS. They both use the `@emotion/is-prop-valid` package to determine which
 * of these should be passed to the underlying DOM node.
 *
 * However, when styling a Motion component `styled(motion.div)`, both packages pass through *all* props
 * as it's seen as an arbitrary component rather than a DOM node. Motion only allows arbitrary props
 * passed through the `custom` prop so it doesn't *need* the payload or computational overhead of
 * `@emotion/is-prop-valid`, however to fix this problem we need to use it.
 *
 * By making it an optionalDependency we can offer this functionality only in the situations where it's
 * actually required.
 */ try {
    /**
     * We attempt to import this package but require won't be defined in esm environments, in that case
     * isPropValid will have to be provided via `MotionContext`. In a 6.0.0 this should probably be removed
     * in favour of explicit injection.
     */ $05db6db4ebcdf5f1$export$59d6962c470509a5((parcelRequire("7dGEo")).default);
} catch (_a) {
// We don't need to actually do anything here - the fallback is the existing `isPropValid`.
}
function $05db6db4ebcdf5f1$export$d697c39a2985a4c(props, isDom, forwardMotionProps) {
    var filteredProps = {};
    for(var key in props)if ($05db6db4ebcdf5f1$var$shouldForward(key) || forwardMotionProps === true && (0, $nQeJi.isValidMotionProp)(key) || !isDom && !(0, $nQeJi.isValidMotionProp)(key) || // If trying to use native HTML drag events, forward drag listeners
    props["draggable"] && key.startsWith("onDrag")) filteredProps[key] = props[key];
    return filteredProps;
}

});
parcelRegister("nQeJi", function(module, exports) {

$parcel$export(module.exports, "isValidMotionProp", () => $c4bee6acbf082b7d$export$2f9c46555243bf04);
/**
 * A list of all valid MotionProps.
 *
 * @privateRemarks
 * This doesn't throw if a `MotionProp` name is missing - it should.
 */ var $c4bee6acbf082b7d$var$validMotionProps = new Set([
    "initial",
    "animate",
    "exit",
    "style",
    "variants",
    "transition",
    "transformTemplate",
    "transformValues",
    "custom",
    "inherit",
    "layout",
    "layoutId",
    "layoutDependency",
    "onLayoutAnimationStart",
    "onLayoutAnimationComplete",
    "onLayoutMeasure",
    "onBeforeLayoutMeasure",
    "onAnimationStart",
    "onAnimationComplete",
    "onUpdate",
    "onDragStart",
    "onDrag",
    "onDragEnd",
    "onMeasureDragConstraints",
    "onDirectionLock",
    "onDragTransitionEnd",
    "drag",
    "dragControls",
    "dragListener",
    "dragConstraints",
    "dragDirectionLock",
    "dragSnapToOrigin",
    "_dragX",
    "_dragY",
    "dragElastic",
    "dragMomentum",
    "dragPropagation",
    "dragTransition",
    "whileDrag",
    "onPan",
    "onPanStart",
    "onPanEnd",
    "onPanSessionStart",
    "onTap",
    "onTapStart",
    "onTapCancel",
    "onHoverStart",
    "onHoverEnd",
    "whileFocus",
    "whileTap",
    "whileHover",
    "whileInView",
    "onViewportEnter",
    "onViewportLeave",
    "viewport",
    "layoutScroll"
]);
/**
 * Check whether a prop name is a valid `MotionProp` key.
 *
 * @param key - Name of the property to check
 * @returns `true` is key is a valid `MotionProp`.
 *
 * @public
 */ function $c4bee6acbf082b7d$export$2f9c46555243bf04(key) {
    return $c4bee6acbf082b7d$var$validMotionProps.has(key);
}

});

parcelRegister("7dGEo", function(module, exports) {

$parcel$export(module.exports, "default", () => $541ad4d15ffa42f6$export$2e2bcd8739ae039);

var $l7O8P = parcelRequire("l7O8P");
var $541ad4d15ffa42f6$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|inert|itemProp|itemScope|itemType|itemID|itemRef|on|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $541ad4d15ffa42f6$var$index = (0, $l7O8P.default)(function(prop) {
    return $541ad4d15ffa42f6$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});
var $541ad4d15ffa42f6$export$2e2bcd8739ae039 = $541ad4d15ffa42f6$var$index;

});
parcelRegister("l7O8P", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6112573aba91cb3$export$2e2bcd8739ae039);
function $f6112573aba91cb3$var$memoize(fn) {
    var cache = {};
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}
var $f6112573aba91cb3$export$2e2bcd8739ae039 = $f6112573aba91cb3$var$memoize;

});



parcelRegister("cc1pG", function(module, exports) {

$parcel$export(module.exports, "useSVGProps", () => $268dc116ac4d3a3d$export$84309c4f53cb1bd5);

var $7WQrb = parcelRequire("7WQrb");

var $acw62 = parcelRequire("acw62");

var $aZIZO = parcelRequire("aZIZO");

var $2g66t = parcelRequire("2g66t");

var $g9aPP = parcelRequire("g9aPP");
function $268dc116ac4d3a3d$export$84309c4f53cb1bd5(props, visualState) {
    var visualProps = (0, $acw62.useMemo)(function() {
        var state = (0, $g9aPP.createSvgRenderState)();
        (0, $2g66t.buildSVGAttrs)(state, visualState, {
            enableHardwareAcceleration: false
        }, props.transformTemplate);
        return (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, state.attrs), {
            style: (0, $7WQrb.__assign)({}, state.style)
        });
    }, [
        visualState
    ]);
    if (props.style) {
        var rawStyles = {};
        (0, $aZIZO.copyRawValuesOnly)(rawStyles, props.style, props);
        visualProps.style = (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, rawStyles), visualProps.style);
    }
    return visualProps;
}

});
parcelRegister("2g66t", function(module, exports) {

$parcel$export(module.exports, "buildSVGAttrs", () => $59f141cfaf6fcabb$export$5475d24f125d7053);

var $7WQrb = parcelRequire("7WQrb");

var $9U95V = parcelRequire("9U95V");

var $4DYGO = parcelRequire("4DYGO");

var $kc1Jt = parcelRequire("kc1Jt");
/**
 * Build SVG visual attrbutes, like cx and style.transform
 */ function $59f141cfaf6fcabb$export$5475d24f125d7053(state, _a, options, transformTemplate) {
    var attrX = _a.attrX, attrY = _a.attrY, originX = _a.originX, originY = _a.originY, pathLength = _a.pathLength, _b = _a.pathSpacing, pathSpacing = _b === void 0 ? 1 : _b, _c = _a.pathOffset, pathOffset = _c === void 0 ? 0 : _c, // This is object creation, which we try to avoid per-frame.
    latest = (0, $7WQrb.__rest)(_a, [
        "attrX",
        "attrY",
        "originX",
        "originY",
        "pathLength",
        "pathSpacing",
        "pathOffset"
    ]);
    (0, $9U95V.buildHTMLStyles)(state, latest, options, transformTemplate);
    state.attrs = state.style;
    state.style = {};
    var attrs = state.attrs, style = state.style, dimensions = state.dimensions;
    /**
     * However, we apply transforms as CSS transforms. So if we detect a transform we take it from attrs
     * and copy it into style.
     */ if (attrs.transform) {
        if (dimensions) style.transform = attrs.transform;
        delete attrs.transform;
    }
    // Parse transformOrigin
    if (dimensions && (originX !== undefined || originY !== undefined || style.transform)) style.transformOrigin = (0, $4DYGO.calcSVGTransformOrigin)(dimensions, originX !== undefined ? originX : 0.5, originY !== undefined ? originY : 0.5);
    // Treat x/y not as shortcuts but as actual attributes
    if (attrX !== undefined) attrs.x = attrX;
    if (attrY !== undefined) attrs.y = attrY;
    // Build SVG path if one has been defined
    if (pathLength !== undefined) (0, $kc1Jt.buildSVGPath)(attrs, pathLength, pathSpacing, pathOffset, false);
}

});
parcelRegister("4DYGO", function(module, exports) {

$parcel$export(module.exports, "calcSVGTransformOrigin", () => $2860344bf6c6c49f$export$d4fbcfc8e5472155);

var $1fCxR = parcelRequire("1fCxR");
function $2860344bf6c6c49f$var$calcOrigin(origin, offset, size) {
    return typeof origin === "string" ? origin : (0, $1fCxR.px).transform(offset + size * origin);
}
/**
 * The SVG transform origin defaults are different to CSS and is less intuitive,
 * so we use the measured dimensions of the SVG to reconcile these.
 */ function $2860344bf6c6c49f$export$d4fbcfc8e5472155(dimensions, originX, originY) {
    var pxOriginX = $2860344bf6c6c49f$var$calcOrigin(originX, dimensions.x, dimensions.width);
    var pxOriginY = $2860344bf6c6c49f$var$calcOrigin(originY, dimensions.y, dimensions.height);
    return "".concat(pxOriginX, " ").concat(pxOriginY);
}

});

parcelRegister("kc1Jt", function(module, exports) {

$parcel$export(module.exports, "buildSVGPath", () => $f5fdba1fd96a9ba7$export$311b43f666da1d82);

var $1fCxR = parcelRequire("1fCxR");
var $f5fdba1fd96a9ba7$var$dashKeys = {
    offset: "stroke-dashoffset",
    array: "stroke-dasharray"
};
var $f5fdba1fd96a9ba7$var$camelKeys = {
    offset: "strokeDashoffset",
    array: "strokeDasharray"
};
/**
 * Build SVG path properties. Uses the path's measured length to convert
 * our custom pathLength, pathSpacing and pathOffset into stroke-dashoffset
 * and stroke-dasharray attributes.
 *
 * This function is mutative to reduce per-frame GC.
 */ function $f5fdba1fd96a9ba7$export$311b43f666da1d82(attrs, length, spacing, offset, useDashCase) {
    if (spacing === void 0) spacing = 1;
    if (offset === void 0) offset = 0;
    if (useDashCase === void 0) useDashCase = true;
    // Normalise path length by setting SVG attribute pathLength to 1
    attrs.pathLength = 1;
    // We use dash case when setting attributes directly to the DOM node and camel case
    // when defining props on a React component.
    var keys = useDashCase ? $f5fdba1fd96a9ba7$var$dashKeys : $f5fdba1fd96a9ba7$var$camelKeys;
    // Build the dash offset
    attrs[keys.offset] = (0, $1fCxR.px).transform(-offset);
    // Build the dash array
    var pathLength = (0, $1fCxR.px).transform(length);
    var pathSpacing = (0, $1fCxR.px).transform(spacing);
    attrs[keys.array] = "".concat(pathLength, " ").concat(pathSpacing);
}

});


parcelRegister("g9aPP", function(module, exports) {

$parcel$export(module.exports, "createSvgRenderState", () => $b7a2547211637b3c$export$41be8b43e1c4d4f9);

var $7WQrb = parcelRequire("7WQrb");

var $fiQRA = parcelRequire("fiQRA");
var $b7a2547211637b3c$export$41be8b43e1c4d4f9 = function() {
    return (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, (0, $fiQRA.createHtmlRenderState)()), {
        attrs: {}
    });
};

});



parcelRegister("AO3i6", function(module, exports) {

$parcel$export(module.exports, "svgMotionConfig", () => $fde6d634ecc7ed6c$export$44dabd3fae512e85);

var $daTxn = parcelRequire("daTxn");

var $JEDlr = parcelRequire("JEDlr");

var $hac5G = parcelRequire("hac5G");

var $g9aPP = parcelRequire("g9aPP");

var $2g66t = parcelRequire("2g66t");
var $fde6d634ecc7ed6c$export$44dabd3fae512e85 = {
    useVisualState: (0, $hac5G.makeUseVisualState)({
        scrapeMotionValuesFromProps: (0, $JEDlr.scrapeMotionValuesFromProps),
        createRenderState: (0, $g9aPP.createSvgRenderState),
        onMount: function(props, instance, _a) {
            var renderState = _a.renderState, latestValues = _a.latestValues;
            try {
                renderState.dimensions = typeof instance.getBBox === "function" ? instance.getBBox() : instance.getBoundingClientRect();
            } catch (e) {
                // Most likely trying to measure an unrendered element under Firefox
                renderState.dimensions = {
                    x: 0,
                    y: 0,
                    width: 0,
                    height: 0
                };
            }
            (0, $2g66t.buildSVGAttrs)(renderState, latestValues, {
                enableHardwareAcceleration: false
            }, props.transformTemplate);
            (0, $daTxn.renderSVG)(instance, renderState);
        }
    })
};

});
parcelRegister("daTxn", function(module, exports) {

$parcel$export(module.exports, "renderSVG", () => $9422342e44092cf6$export$c5f8399d19a7394b);

var $4kYgl = parcelRequire("4kYgl");

var $fMnH3 = parcelRequire("fMnH3");

var $945PB = parcelRequire("945PB");
function $9422342e44092cf6$export$c5f8399d19a7394b(element, renderState, _styleProp, projection) {
    (0, $fMnH3.renderHTML)(element, renderState, undefined, projection);
    for(var key in renderState.attrs)element.setAttribute(!(0, $945PB.camelCaseAttributes).has(key) ? (0, $4kYgl.camelToDash)(key) : key, renderState.attrs[key]);
}

});
parcelRegister("4kYgl", function(module, exports) {

$parcel$export(module.exports, "camelToDash", () => $9dc069bda924fd3f$export$9fd24a634729c672);
var $9dc069bda924fd3f$var$CAMEL_CASE_PATTERN = /([a-z])([A-Z])/g;
var $9dc069bda924fd3f$var$REPLACE_TEMPLATE = "$1-$2";
/**
 * Convert camelCase to dash-case properties.
 */ var $9dc069bda924fd3f$export$9fd24a634729c672 = function(str) {
    return str.replace($9dc069bda924fd3f$var$CAMEL_CASE_PATTERN, $9dc069bda924fd3f$var$REPLACE_TEMPLATE).toLowerCase();
};

});

parcelRegister("fMnH3", function(module, exports) {

$parcel$export(module.exports, "renderHTML", () => $a52b6fc2f3af305f$export$1a32bf6229c258c0);
function $a52b6fc2f3af305f$export$1a32bf6229c258c0(element, _a, styleProp, projection) {
    var style = _a.style, vars = _a.vars;
    Object.assign(element.style, style, projection && projection.getProjectionStyles(styleProp));
    // Loop over any CSS variables and assign those.
    for(var key in vars)element.style.setProperty(key, vars[key]);
}

});

parcelRegister("945PB", function(module, exports) {

$parcel$export(module.exports, "camelCaseAttributes", () => $ea3ecc5fb2887a0f$export$28931db5d57958e5);
/**
 * A set of attribute names that are always read/written as camel case.
 */ var $ea3ecc5fb2887a0f$export$28931db5d57958e5 = new Set([
    "baseFrequency",
    "diffuseConstant",
    "kernelMatrix",
    "kernelUnitLength",
    "keySplines",
    "keyTimes",
    "limitingConeAngle",
    "markerHeight",
    "markerWidth",
    "numOctaves",
    "targetX",
    "targetY",
    "surfaceScale",
    "specularConstant",
    "specularExponent",
    "stdDeviation",
    "tableValues",
    "viewBox",
    "gradientTransform",
    "pathLength"
]);

});


parcelRegister("JEDlr", function(module, exports) {

$parcel$export(module.exports, "scrapeMotionValuesFromProps", () => $eac085b45c9e0925$export$16da615486abaa45);

var $jqFCw = parcelRequire("jqFCw");

var $eZ617 = parcelRequire("eZ617");
function $eac085b45c9e0925$export$16da615486abaa45(props) {
    var newValues = (0, $eZ617.scrapeMotionValuesFromProps)(props);
    for(var key in props)if ((0, $jqFCw.isMotionValue)(props[key])) {
        var targetKey = key === "x" || key === "y" ? "attr" + key.toUpperCase() : key;
        newValues[targetKey] = props[key];
    }
    return newValues;
}

});
parcelRegister("eZ617", function(module, exports) {

$parcel$export(module.exports, "scrapeMotionValuesFromProps", () => $a8ee53e44f8c4ac8$export$16da615486abaa45);

var $8tTaz = parcelRequire("8tTaz");

var $jqFCw = parcelRequire("jqFCw");
function $a8ee53e44f8c4ac8$export$16da615486abaa45(props) {
    var style = props.style;
    var newValues = {};
    for(var key in style)if ((0, $jqFCw.isMotionValue)(style[key]) || (0, $8tTaz.isForcedMotionValue)(key, props)) newValues[key] = style[key];
    return newValues;
}

});


parcelRegister("hac5G", function(module, exports) {

$parcel$export(module.exports, "makeUseVisualState", () => $5c26ebcca6422185$export$e91e107bc6d03a8e);

var $7WQrb = parcelRequire("7WQrb");

var $acw62 = parcelRequire("acw62");

var $k8Lf0 = parcelRequire("k8Lf0");

var $gtJis = parcelRequire("gtJis");

var $8QQaD = parcelRequire("8QQaD");

var $aTYEI = parcelRequire("aTYEI");

var $cz2ac = parcelRequire("cz2ac");

var $e3EFx = parcelRequire("e3EFx");
function $5c26ebcca6422185$var$makeState(_a, props, context, presenceContext) {
    var scrapeMotionValuesFromProps = _a.scrapeMotionValuesFromProps, createRenderState = _a.createRenderState, onMount = _a.onMount;
    var state = {
        latestValues: $5c26ebcca6422185$var$makeLatestValues(props, context, presenceContext, scrapeMotionValuesFromProps),
        renderState: createRenderState()
    };
    if (onMount) state.mount = function(instance) {
        return onMount(props, instance, state);
    };
    return state;
}
var $5c26ebcca6422185$export$e91e107bc6d03a8e = function(config) {
    return function(props, isStatic) {
        var context = (0, $acw62.useContext)((0, $e3EFx.MotionContext));
        var presenceContext = (0, $acw62.useContext)((0, $gtJis.PresenceContext));
        return isStatic ? $5c26ebcca6422185$var$makeState(config, props, context, presenceContext) : (0, $aTYEI.useConstant)(function() {
            return $5c26ebcca6422185$var$makeState(config, props, context, presenceContext);
        });
    };
};
function $5c26ebcca6422185$var$makeLatestValues(props, context, presenceContext, scrapeMotionValues) {
    var values = {};
    var blockInitialAnimation = (presenceContext === null || presenceContext === void 0 ? void 0 : presenceContext.initial) === false;
    var motionValues = scrapeMotionValues(props);
    for(var key in motionValues)values[key] = (0, $cz2ac.resolveMotionValue)(motionValues[key]);
    var initial = props.initial, animate = props.animate;
    var isControllingVariants = (0, $8QQaD.checkIfControllingVariants)(props);
    var isVariantNode = (0, $8QQaD.checkIfVariantNode)(props);
    if (context && isVariantNode && !isControllingVariants && props.inherit !== false) {
        initial !== null && initial !== void 0 ? initial : initial = context.initial;
        animate !== null && animate !== void 0 ? animate : animate = context.animate;
    }
    var initialAnimationIsBlocked = blockInitialAnimation || initial === false;
    var variantToSet = initialAnimationIsBlocked ? animate : initial;
    if (variantToSet && typeof variantToSet !== "boolean" && !(0, $k8Lf0.isAnimationControls)(variantToSet)) {
        var list = Array.isArray(variantToSet) ? variantToSet : [
            variantToSet
        ];
        list.forEach(function(definition) {
            var resolved = (0, $8QQaD.resolveVariantFromProps)(props, definition);
            if (!resolved) return;
            var transitionEnd = resolved.transitionEnd;
            resolved.transition;
            var target = (0, $7WQrb.__rest)(resolved, [
                "transitionEnd",
                "transition"
            ]);
            for(var key in target){
                var valueTarget = target[key];
                if (Array.isArray(valueTarget)) {
                    /**
                     * Take final keyframe if the initial animation is blocked because
                     * we want to initialise at the end of that blocked animation.
                     */ var index = initialAnimationIsBlocked ? valueTarget.length - 1 : 0;
                    valueTarget = valueTarget[index];
                }
                if (valueTarget !== null) values[key] = valueTarget;
            }
            for(var key in transitionEnd)values[key] = transitionEnd[key];
        });
    }
    return values;
}

});
parcelRegister("k8Lf0", function(module, exports) {

$parcel$export(module.exports, "isAnimationControls", () => $1e5344c7f0db9c8f$export$aa71198ceeaf53ce);
function $1e5344c7f0db9c8f$export$aa71198ceeaf53ce(v) {
    return typeof v === "object" && typeof v.start === "function";
}

});

parcelRegister("cz2ac", function(module, exports) {

$parcel$export(module.exports, "resolveMotionValue", () => $18cbbcef55016eac$export$fcc2206ecb6d74b);

var $lyAek = parcelRequire("lyAek");

var $jqFCw = parcelRequire("jqFCw");
/**
 * If the provided value is a MotionValue, this returns the actual value, otherwise just the value itself
 *
 * TODO: Remove and move to library
 */ function $18cbbcef55016eac$export$fcc2206ecb6d74b(value) {
    var unwrappedValue = (0, $jqFCw.isMotionValue)(value) ? value.get() : value;
    return (0, $lyAek.isCustomValue)(unwrappedValue) ? unwrappedValue.toValue() : unwrappedValue;
}

});
parcelRegister("lyAek", function(module, exports) {

$parcel$export(module.exports, "isCustomValue", () => $21f654501c04362b$export$2f308ad9864b3ac9);
$parcel$export(module.exports, "resolveFinalValueInKeyframes", () => $21f654501c04362b$export$5485128c47bd48bb);

var $eT2fJ = parcelRequire("eT2fJ");
var $21f654501c04362b$export$2f308ad9864b3ac9 = function(v) {
    return Boolean(v && typeof v === "object" && v.mix && v.toValue);
};
var $21f654501c04362b$export$5485128c47bd48bb = function(v) {
    // TODO maybe throw if v.length - 1 is placeholder token?
    return (0, $eT2fJ.isKeyframesTarget)(v) ? v[v.length - 1] || 0 : v;
};

});
parcelRegister("eT2fJ", function(module, exports) {

$parcel$export(module.exports, "isKeyframesTarget", () => $ef59b2359a289b82$export$9153ad4c4999f4a0);
var $ef59b2359a289b82$export$9153ad4c4999f4a0 = function(v) {
    return Array.isArray(v);
};

});





parcelRegister("jCKYH", function(module, exports) {

$parcel$export(module.exports, "htmlMotionConfig", () => $dcb38e10dcfb6316$export$e13ea21d87ea57c8);

var $hac5G = parcelRequire("hac5G");

var $eZ617 = parcelRequire("eZ617");

var $fiQRA = parcelRequire("fiQRA");
var $dcb38e10dcfb6316$export$e13ea21d87ea57c8 = {
    useVisualState: (0, $hac5G.makeUseVisualState)({
        scrapeMotionValuesFromProps: (0, $eZ617.scrapeMotionValuesFromProps),
        createRenderState: (0, $fiQRA.createHtmlRenderState)
    })
};

});


parcelRegister("iLse2", function(module, exports) {

$parcel$export(module.exports, "gestureAnimations", () => $5e115984cd871deb$export$e5b72898e5a201f1);

var $8rdqr = parcelRequire("8rdqr");

var $5hXXR = parcelRequire("5hXXR");

var $4FEq8 = parcelRequire("4FEq8");

var $15bsJ = parcelRequire("15bsJ");

var $igYbV = parcelRequire("igYbV");
var $5e115984cd871deb$export$e5b72898e5a201f1 = {
    inView: (0, $igYbV.makeRenderlessComponent)((0, $15bsJ.useViewport)),
    tap: (0, $igYbV.makeRenderlessComponent)((0, $4FEq8.useTapGesture)),
    focus: (0, $igYbV.makeRenderlessComponent)((0, $8rdqr.useFocusGesture)),
    hover: (0, $igYbV.makeRenderlessComponent)((0, $5hXXR.useHoverGesture))
};

});
parcelRegister("8rdqr", function(module, exports) {

$parcel$export(module.exports, "useFocusGesture", () => $5431ad674d2aa8ad$export$cac52d7cca250a66);

var $5fU40 = parcelRequire("5fU40");

var $ao8nn = parcelRequire("ao8nn");
/**
 *
 * @param props
 * @param ref
 * @internal
 */ function $5431ad674d2aa8ad$export$cac52d7cca250a66(_a) {
    var whileFocus = _a.whileFocus, visualElement = _a.visualElement;
    var onFocus = function() {
        var _a;
        (_a = visualElement.animationState) === null || _a === void 0 || _a.setActive((0, $5fU40.AnimationType).Focus, true);
    };
    var onBlur = function() {
        var _a;
        (_a = visualElement.animationState) === null || _a === void 0 || _a.setActive((0, $5fU40.AnimationType).Focus, false);
    };
    (0, $ao8nn.useDomEvent)(visualElement, "focus", whileFocus ? onFocus : undefined);
    (0, $ao8nn.useDomEvent)(visualElement, "blur", whileFocus ? onBlur : undefined);
}

});
parcelRegister("5fU40", function(module, exports) {

$parcel$export(module.exports, "AnimationType", () => $bc94049262afe059$export$2deb71ebd3734d23);
var $bc94049262afe059$export$2deb71ebd3734d23;
(function(AnimationType) {
    AnimationType["Animate"] = "animate";
    AnimationType["Hover"] = "whileHover";
    AnimationType["Tap"] = "whileTap";
    AnimationType["Drag"] = "whileDrag";
    AnimationType["Focus"] = "whileFocus";
    AnimationType["InView"] = "whileInView";
    AnimationType["Exit"] = "exit";
})($bc94049262afe059$export$2deb71ebd3734d23 || ($bc94049262afe059$export$2deb71ebd3734d23 = {}));

});

parcelRegister("ao8nn", function(module, exports) {

$parcel$export(module.exports, "addDomEvent", () => $cba4f237926ffdf7$export$b1d829ddf82884aa);
$parcel$export(module.exports, "useDomEvent", () => $cba4f237926ffdf7$export$c1052189363cb2e0);

var $acw62 = parcelRequire("acw62");
function $cba4f237926ffdf7$export$b1d829ddf82884aa(target, eventName, handler, options) {
    if (options === void 0) options = {
        passive: true
    };
    target.addEventListener(eventName, handler, options);
    return function() {
        return target.removeEventListener(eventName, handler);
    };
}
/**
 * Attaches an event listener directly to the provided DOM element.
 *
 * Bypassing React's event system can be desirable, for instance when attaching non-passive
 * event handlers.
 *
 * ```jsx
 * const ref = useRef(null)
 *
 * useDomEvent(ref, 'wheel', onWheel, { passive: false })
 *
 * return <div ref={ref} />
 * ```
 *
 * @param ref - React.RefObject that's been provided to the element you want to bind the listener to.
 * @param eventName - Name of the event you want listen for.
 * @param handler - Function to fire when receiving the event.
 * @param options - Options to pass to `Event.addEventListener`.
 *
 * @public
 */ function $cba4f237926ffdf7$export$c1052189363cb2e0(ref, eventName, handler, options) {
    (0, $acw62.useEffect)(function() {
        var element = ref.current;
        if (handler && element) return $cba4f237926ffdf7$export$b1d829ddf82884aa(element, eventName, handler, options);
    }, [
        ref,
        eventName,
        handler,
        options
    ]);
}

});


parcelRegister("5hXXR", function(module, exports) {

$parcel$export(module.exports, "useHoverGesture", () => $68f67e0924891ff4$export$dea06860711b7ebc);

var $3K60Y = parcelRequire("3K60Y");

var $5fU40 = parcelRequire("5fU40");

var $kkba7 = parcelRequire("kkba7");

var $bYmgt = parcelRequire("bYmgt");
function $68f67e0924891ff4$var$createHoverEvent(visualElement, isActive, callback) {
    return function(event, info) {
        var _a;
        if (!(0, $3K60Y.isMouseEvent)(event) || (0, $bYmgt.isDragActive)()) return;
        /**
         * Ensure we trigger animations before firing event callback
         */ (_a = visualElement.animationState) === null || _a === void 0 || _a.setActive((0, $5fU40.AnimationType).Hover, isActive);
        callback === null || callback === void 0 || callback(event, info);
    };
}
function $68f67e0924891ff4$export$dea06860711b7ebc(_a) {
    var onHoverStart = _a.onHoverStart, onHoverEnd = _a.onHoverEnd, whileHover = _a.whileHover, visualElement = _a.visualElement;
    (0, $kkba7.usePointerEvent)(visualElement, "pointerenter", onHoverStart || whileHover ? $68f67e0924891ff4$var$createHoverEvent(visualElement, true, onHoverStart) : undefined, {
        passive: !onHoverStart
    });
    (0, $kkba7.usePointerEvent)(visualElement, "pointerleave", onHoverEnd || whileHover ? $68f67e0924891ff4$var$createHoverEvent(visualElement, false, onHoverEnd) : undefined, {
        passive: !onHoverEnd
    });
}

});
parcelRegister("3K60Y", function(module, exports) {

$parcel$export(module.exports, "isMouseEvent", () => $c87aba2e7df5c6a6$export$764db16956f554f8);
$parcel$export(module.exports, "isTouchEvent", () => $c87aba2e7df5c6a6$export$c4dfce035d43d1e0);
function $c87aba2e7df5c6a6$export$764db16956f554f8(event) {
    // PointerEvent inherits from MouseEvent so we can't use a straight instanceof check.
    if (typeof PointerEvent !== "undefined" && event instanceof PointerEvent) return !!(event.pointerType === "mouse");
    return event instanceof MouseEvent;
}
function $c87aba2e7df5c6a6$export$c4dfce035d43d1e0(event) {
    var hasTouches = !!event.touches;
    return hasTouches;
}

});

parcelRegister("kkba7", function(module, exports) {

$parcel$export(module.exports, "addPointerEvent", () => $a3f7c96fbe45f23e$export$fcff2e64e6676b81);
$parcel$export(module.exports, "usePointerEvent", () => $a3f7c96fbe45f23e$export$734d04395f5243cd);

var $ao8nn = parcelRequire("ao8nn");

var $2BisC = parcelRequire("2BisC");

var $84vaP = parcelRequire("84vaP");
var $a3f7c96fbe45f23e$var$mouseEventNames = {
    pointerdown: "mousedown",
    pointermove: "mousemove",
    pointerup: "mouseup",
    pointercancel: "mousecancel",
    pointerover: "mouseover",
    pointerout: "mouseout",
    pointerenter: "mouseenter",
    pointerleave: "mouseleave"
};
var $a3f7c96fbe45f23e$var$touchEventNames = {
    pointerdown: "touchstart",
    pointermove: "touchmove",
    pointerup: "touchend",
    pointercancel: "touchcancel"
};
function $a3f7c96fbe45f23e$var$getPointerEventName(name) {
    if ((0, $84vaP.supportsPointerEvents)()) return name;
    else if ((0, $84vaP.supportsTouchEvents)()) return $a3f7c96fbe45f23e$var$touchEventNames[name];
    else if ((0, $84vaP.supportsMouseEvents)()) return $a3f7c96fbe45f23e$var$mouseEventNames[name];
    return name;
}
function $a3f7c96fbe45f23e$export$fcff2e64e6676b81(target, eventName, handler, options) {
    return (0, $ao8nn.addDomEvent)(target, $a3f7c96fbe45f23e$var$getPointerEventName(eventName), (0, $2BisC.wrapHandler)(handler, eventName === "pointerdown"), options);
}
function $a3f7c96fbe45f23e$export$734d04395f5243cd(ref, eventName, handler, options) {
    return (0, $ao8nn.useDomEvent)(ref, $a3f7c96fbe45f23e$var$getPointerEventName(eventName), handler && (0, $2BisC.wrapHandler)(handler, eventName === "pointerdown"), options);
}

});
parcelRegister("2BisC", function(module, exports) {

$parcel$export(module.exports, "extractEventInfo", () => $23ab615c547792c0$export$12f84bb882d06e1a);
$parcel$export(module.exports, "wrapHandler", () => $23ab615c547792c0$export$f4437ba81469b709);

var $3K60Y = parcelRequire("3K60Y");
/**
 * Filters out events not attached to the primary pointer (currently left mouse button)
 * @param eventHandler
 */ function $23ab615c547792c0$var$filterPrimaryPointer(eventHandler) {
    return function(event) {
        var isMouseEvent = event instanceof MouseEvent;
        var isPrimaryPointer = !isMouseEvent || isMouseEvent && event.button === 0;
        if (isPrimaryPointer) eventHandler(event);
    };
}
var $23ab615c547792c0$var$defaultPagePoint = {
    pageX: 0,
    pageY: 0
};
function $23ab615c547792c0$var$pointFromTouch(e, pointType) {
    if (pointType === void 0) pointType = "page";
    var primaryTouch = e.touches[0] || e.changedTouches[0];
    var point = primaryTouch || $23ab615c547792c0$var$defaultPagePoint;
    return {
        x: point[pointType + "X"],
        y: point[pointType + "Y"]
    };
}
function $23ab615c547792c0$var$pointFromMouse(point, pointType) {
    if (pointType === void 0) pointType = "page";
    return {
        x: point[pointType + "X"],
        y: point[pointType + "Y"]
    };
}
function $23ab615c547792c0$export$12f84bb882d06e1a(event, pointType) {
    if (pointType === void 0) pointType = "page";
    return {
        point: (0, $3K60Y.isTouchEvent)(event) ? $23ab615c547792c0$var$pointFromTouch(event, pointType) : $23ab615c547792c0$var$pointFromMouse(event, pointType)
    };
}
var $23ab615c547792c0$export$f4437ba81469b709 = function(handler, shouldFilterPrimaryPointer) {
    if (shouldFilterPrimaryPointer === void 0) shouldFilterPrimaryPointer = false;
    var listener = function(event) {
        return handler(event, $23ab615c547792c0$export$12f84bb882d06e1a(event));
    };
    return shouldFilterPrimaryPointer ? $23ab615c547792c0$var$filterPrimaryPointer(listener) : listener;
};

});

parcelRegister("84vaP", function(module, exports) {

$parcel$export(module.exports, "supportsPointerEvents", () => $4162ff6cb212f32f$export$ed662207763ba653);
$parcel$export(module.exports, "supportsTouchEvents", () => $4162ff6cb212f32f$export$58e9cbc5718eb8c2);
$parcel$export(module.exports, "supportsMouseEvents", () => $4162ff6cb212f32f$export$1a3879af679d3ede);

var $4L0T5 = parcelRequire("4L0T5");
// We check for event support via functions in case they've been mocked by a testing suite.
var $4162ff6cb212f32f$export$ed662207763ba653 = function() {
    return (0, $4L0T5.isBrowser) && window.onpointerdown === null;
};
var $4162ff6cb212f32f$export$58e9cbc5718eb8c2 = function() {
    return (0, $4L0T5.isBrowser) && window.ontouchstart === null;
};
var $4162ff6cb212f32f$export$1a3879af679d3ede = function() {
    return (0, $4L0T5.isBrowser) && window.onmousedown === null;
};

});


parcelRegister("bYmgt", function(module, exports) {

$parcel$export(module.exports, "getGlobalLock", () => $df8cc4eab047d382$export$2b7959ed03c1a3fe);
$parcel$export(module.exports, "isDragActive", () => $df8cc4eab047d382$export$1b3dd616664938e4);
function $df8cc4eab047d382$export$518c5fc2dcb7974b(name) {
    var lock = null;
    return function() {
        var openLock = function() {
            lock = null;
        };
        if (lock === null) {
            lock = name;
            return openLock;
        }
        return false;
    };
}
var $df8cc4eab047d382$var$globalHorizontalLock = $df8cc4eab047d382$export$518c5fc2dcb7974b("dragHorizontal");
var $df8cc4eab047d382$var$globalVerticalLock = $df8cc4eab047d382$export$518c5fc2dcb7974b("dragVertical");
function $df8cc4eab047d382$export$2b7959ed03c1a3fe(drag) {
    var lock = false;
    if (drag === "y") lock = $df8cc4eab047d382$var$globalVerticalLock();
    else if (drag === "x") lock = $df8cc4eab047d382$var$globalHorizontalLock();
    else {
        var openHorizontal_1 = $df8cc4eab047d382$var$globalHorizontalLock();
        var openVertical_1 = $df8cc4eab047d382$var$globalVerticalLock();
        if (openHorizontal_1 && openVertical_1) lock = function() {
            openHorizontal_1();
            openVertical_1();
        };
        else {
            // Release the locks because we don't use them
            if (openHorizontal_1) openHorizontal_1();
            if (openVertical_1) openVertical_1();
        }
    }
    return lock;
}
function $df8cc4eab047d382$export$1b3dd616664938e4() {
    // Check the gesture lock - if we get it, it means no drag gesture is active
    // and we can safely fire the tap gesture.
    var openGestureLock = $df8cc4eab047d382$export$2b7959ed03c1a3fe(true);
    if (!openGestureLock) return true;
    openGestureLock();
    return false;
}

});


parcelRegister("4FEq8", function(module, exports) {

$parcel$export(module.exports, "useTapGesture", () => $3f9742550fb7ca4c$export$16dee6ef8c34532);

var $acw62 = parcelRequire("acw62");

var $l2YMH = parcelRequire("l2YMH");

var $kkba7 = parcelRequire("kkba7");

var $brX5J = parcelRequire("brX5J");

var $iBhIU = parcelRequire("iBhIU");

var $5fU40 = parcelRequire("5fU40");

var $bYmgt = parcelRequire("bYmgt");
/**
 * @param handlers -
 * @internal
 */ function $3f9742550fb7ca4c$export$16dee6ef8c34532(_a) {
    var onTap = _a.onTap, onTapStart = _a.onTapStart, onTapCancel = _a.onTapCancel, whileTap = _a.whileTap, visualElement = _a.visualElement;
    var hasPressListeners = onTap || onTapStart || onTapCancel || whileTap;
    var isPressing = (0, $acw62.useRef)(false);
    var cancelPointerEndListeners = (0, $acw62.useRef)(null);
    /**
     * Only set listener to passive if there are no external listeners.
     */ var eventOptions = {
        passive: !(onTapStart || onTap || onTapCancel || onPointerDown)
    };
    function removePointerEndListener() {
        var _a;
        (_a = cancelPointerEndListeners.current) === null || _a === void 0 || _a.call(cancelPointerEndListeners);
        cancelPointerEndListeners.current = null;
    }
    function checkPointerEnd() {
        var _a;
        removePointerEndListener();
        isPressing.current = false;
        (_a = visualElement.animationState) === null || _a === void 0 || _a.setActive((0, $5fU40.AnimationType).Tap, false);
        return !(0, $bYmgt.isDragActive)();
    }
    function onPointerUp(event, info) {
        if (!checkPointerEnd()) return;
        /**
         * We only count this as a tap gesture if the event.target is the same
         * as, or a child of, this component's element
         */ !(0, $l2YMH.isNodeOrChild)(visualElement.getInstance(), event.target) ? onTapCancel === null || onTapCancel === void 0 || onTapCancel(event, info) : onTap === null || onTap === void 0 || onTap(event, info);
    }
    function onPointerCancel(event, info) {
        if (!checkPointerEnd()) return;
        onTapCancel === null || onTapCancel === void 0 || onTapCancel(event, info);
    }
    function onPointerDown(event, info) {
        var _a;
        removePointerEndListener();
        if (isPressing.current) return;
        isPressing.current = true;
        cancelPointerEndListeners.current = (0, $iBhIU.pipe)((0, $kkba7.addPointerEvent)(window, "pointerup", onPointerUp, eventOptions), (0, $kkba7.addPointerEvent)(window, "pointercancel", onPointerCancel, eventOptions));
        /**
         * Ensure we trigger animations before firing event callback
         */ (_a = visualElement.animationState) === null || _a === void 0 || _a.setActive((0, $5fU40.AnimationType).Tap, true);
        onTapStart === null || onTapStart === void 0 || onTapStart(event, info);
    }
    (0, $kkba7.usePointerEvent)(visualElement, "pointerdown", hasPressListeners ? onPointerDown : undefined, eventOptions);
    (0, $brX5J.useUnmountEffect)(removePointerEndListener);
}

});
parcelRegister("l2YMH", function(module, exports) {

$parcel$export(module.exports, "isNodeOrChild", () => $ae5289b89bf4fd95$export$e841ada32ff745b);
/**
 * Recursively traverse up the tree to check whether the provided child node
 * is the parent or a descendant of it.
 *
 * @param parent - Element to find
 * @param child - Element to test against parent
 */ var $ae5289b89bf4fd95$export$e841ada32ff745b = function(parent, child) {
    if (!child) return false;
    else if (parent === child) return true;
    else return $ae5289b89bf4fd95$export$e841ada32ff745b(parent, child.parentElement);
};

});

parcelRegister("brX5J", function(module, exports) {

$parcel$export(module.exports, "useUnmountEffect", () => $7bbbf777b15ef7cf$export$f3a192d0cbd30b96);

var $acw62 = parcelRequire("acw62");
function $7bbbf777b15ef7cf$export$f3a192d0cbd30b96(callback) {
    return (0, $acw62.useEffect)(function() {
        return function() {
            return callback();
        };
    }, []);
}

});

parcelRegister("iBhIU", function(module, exports) {

$parcel$export(module.exports, "pipe", () => $bcf7a994d3c628d6$export$a4627e546088548d);
const $bcf7a994d3c628d6$var$combineFunctions = (a, b)=>(v)=>b(a(v));
const $bcf7a994d3c628d6$export$a4627e546088548d = (...transformers)=>transformers.reduce($bcf7a994d3c628d6$var$combineFunctions);

});


parcelRegister("15bsJ", function(module, exports) {

$parcel$export(module.exports, "useViewport", () => $554007e400b24229$export$297ec8eb77d6211d);

var $4ziSZ = parcelRequire("4ziSZ");

var $acw62 = parcelRequire("acw62");

var $5fU40 = parcelRequire("5fU40");

var $awzGD = parcelRequire("awzGD");

var $fUEqC = parcelRequire("fUEqC");
function $554007e400b24229$export$297ec8eb77d6211d(_a) {
    var visualElement = _a.visualElement, whileInView = _a.whileInView, onViewportEnter = _a.onViewportEnter, onViewportLeave = _a.onViewportLeave, _b = _a.viewport, viewport = _b === void 0 ? {} : _b;
    var state = (0, $acw62.useRef)({
        hasEnteredView: false,
        isInView: false
    });
    var shouldObserve = Boolean(whileInView || onViewportEnter || onViewportLeave);
    if (viewport.once && state.current.hasEnteredView) shouldObserve = false;
    var useObserver = typeof IntersectionObserver === "undefined" ? $554007e400b24229$var$useMissingIntersectionObserver : $554007e400b24229$var$useIntersectionObserver;
    useObserver(shouldObserve, state.current, visualElement, viewport);
}
var $554007e400b24229$var$thresholdNames = {
    some: 0,
    all: 1
};
function $554007e400b24229$var$useIntersectionObserver(shouldObserve, state, visualElement, _a) {
    var root = _a.root, rootMargin = _a.margin, _b = _a.amount, amount = _b === void 0 ? "some" : _b, once = _a.once;
    (0, $acw62.useEffect)(function() {
        if (!shouldObserve) return;
        var options = {
            root: root === null || root === void 0 ? void 0 : root.current,
            rootMargin: rootMargin,
            threshold: typeof amount === "number" ? amount : $554007e400b24229$var$thresholdNames[amount]
        };
        var intersectionCallback = function(entry) {
            var _a;
            var isIntersecting = entry.isIntersecting;
            /**
             * If there's been no change in the viewport state, early return.
             */ if (state.isInView === isIntersecting) return;
            state.isInView = isIntersecting;
            /**
             * Handle hasEnteredView. If this is only meant to run once, and
             * element isn't visible, early return. Otherwise set hasEnteredView to true.
             */ if (once && !isIntersecting && state.hasEnteredView) return;
            else if (isIntersecting) state.hasEnteredView = true;
            (_a = visualElement.animationState) === null || _a === void 0 || _a.setActive((0, $5fU40.AnimationType).InView, isIntersecting);
            /**
             * Use the latest committed props rather than the ones in scope
             * when this observer is created
             */ var props = visualElement.getProps();
            var callback = isIntersecting ? props.onViewportEnter : props.onViewportLeave;
            callback === null || callback === void 0 || callback(entry);
        };
        return (0, $fUEqC.observeIntersection)(visualElement.getInstance(), options, intersectionCallback);
    }, [
        shouldObserve,
        root,
        rootMargin,
        amount
    ]);
}
/**
 * If IntersectionObserver is missing, we activate inView and fire onViewportEnter
 * on mount. This way, the page will be in the state the author expects users
 * to see it in for everyone.
 */ function $554007e400b24229$var$useMissingIntersectionObserver(shouldObserve, state, visualElement, _a) {
    var _b = _a.fallback, fallback = _b === void 0 ? true : _b;
    (0, $acw62.useEffect)(function() {
        if (!shouldObserve || !fallback) return;
        if ((0, $4ziSZ.env) !== "production") (0, $awzGD.warnOnce)(false, "IntersectionObserver not available on this device. whileInView animations will trigger on mount.");
        /**
         * Fire this in an rAF because, at this point, the animation state
         * won't have flushed for the first time and there's certain logic in
         * there that behaves differently on the initial animation.
         *
         * This hook should be quite rarely called so setting this in an rAF
         * is preferred to changing the behaviour of the animation state.
         */ requestAnimationFrame(function() {
            var _a;
            state.hasEnteredView = true;
            var onViewportEnter = visualElement.getProps().onViewportEnter;
            onViewportEnter === null || onViewportEnter === void 0 || onViewportEnter(null);
            (_a = visualElement.animationState) === null || _a === void 0 || _a.setActive((0, $5fU40.AnimationType).InView, true);
        });
    }, [
        shouldObserve
    ]);
}

});
parcelRegister("awzGD", function(module, exports) {

$parcel$export(module.exports, "warnOnce", () => $60b2a1a48da7d044$export$5b28268982f175ba);
var $60b2a1a48da7d044$var$warned = new Set();
function $60b2a1a48da7d044$export$5b28268982f175ba(condition, message, element) {
    if (condition || $60b2a1a48da7d044$var$warned.has(message)) return;
    console.warn(message);
    if (element) console.warn(element);
    $60b2a1a48da7d044$var$warned.add(message);
}

});

parcelRegister("fUEqC", function(module, exports) {

$parcel$export(module.exports, "observeIntersection", () => $577133ec08d9e334$export$b2bcd62fb7925aa5);

var $7WQrb = parcelRequire("7WQrb");
/**
 * Map an IntersectionHandler callback to an element. We only ever make one handler for one
 * element, so even though these handlers might all be triggered by different
 * observers, we can keep them in the same map.
 */ var $577133ec08d9e334$var$observerCallbacks = new WeakMap();
/**
 * Multiple observers can be created for multiple element/document roots. Each with
 * different settings. So here we store dictionaries of observers to each root,
 * using serialised settings (threshold/margin) as lookup keys.
 */ var $577133ec08d9e334$var$observers = new WeakMap();
var $577133ec08d9e334$var$fireObserverCallback = function(entry) {
    var _a;
    (_a = $577133ec08d9e334$var$observerCallbacks.get(entry.target)) === null || _a === void 0 || _a(entry);
};
var $577133ec08d9e334$var$fireAllObserverCallbacks = function(entries) {
    entries.forEach($577133ec08d9e334$var$fireObserverCallback);
};
function $577133ec08d9e334$var$initIntersectionObserver(_a) {
    var root = _a.root, options = (0, $7WQrb.__rest)(_a, [
        "root"
    ]);
    var lookupRoot = root || document;
    /**
     * If we don't have an observer lookup map for this root, create one.
     */ if (!$577133ec08d9e334$var$observers.has(lookupRoot)) $577133ec08d9e334$var$observers.set(lookupRoot, {});
    var rootObservers = $577133ec08d9e334$var$observers.get(lookupRoot);
    var key = JSON.stringify(options);
    /**
     * If we don't have an observer for this combination of root and settings,
     * create one.
     */ if (!rootObservers[key]) rootObservers[key] = new IntersectionObserver($577133ec08d9e334$var$fireAllObserverCallbacks, (0, $7WQrb.__assign)({
        root: root
    }, options));
    return rootObservers[key];
}
function $577133ec08d9e334$export$b2bcd62fb7925aa5(element, options, callback) {
    var rootInteresectionObserver = $577133ec08d9e334$var$initIntersectionObserver(options);
    $577133ec08d9e334$var$observerCallbacks.set(element, callback);
    rootInteresectionObserver.observe(element);
    return function() {
        $577133ec08d9e334$var$observerCallbacks.delete(element);
        rootInteresectionObserver.unobserve(element);
    };
}

});


parcelRegister("igYbV", function(module, exports) {

$parcel$export(module.exports, "makeRenderlessComponent", () => $ff62e0eea2bbc1b2$export$46d1d6d046f826e4);
var $ff62e0eea2bbc1b2$export$46d1d6d046f826e4 = function(hook) {
    return function(props) {
        hook(props);
        return null;
    };
};

});


parcelRegister("crTFY", function(module, exports) {

$parcel$export(module.exports, "animations", () => $03e8b675a1009b68$export$7f9953c70dacfd7f);

var $7WQrb = parcelRequire("7WQrb");

var $acw62 = parcelRequire("acw62");

var $k8Lf0 = parcelRequire("k8Lf0");

var $iL8MI = parcelRequire("iL8MI");

var $gtJis = parcelRequire("gtJis");

var $dOx92 = parcelRequire("dOx92");

var $5fU40 = parcelRequire("5fU40");

var $igYbV = parcelRequire("igYbV");
var $03e8b675a1009b68$export$7f9953c70dacfd7f = {
    animation: (0, $igYbV.makeRenderlessComponent)(function(_a) {
        var visualElement = _a.visualElement, animate = _a.animate;
        /**
         * We dynamically generate the AnimationState manager as it contains a reference
         * to the underlying animation library. We only want to load that if we load this,
         * so people can optionally code split it out using the `m` component.
         */ visualElement.animationState || (visualElement.animationState = (0, $dOx92.createAnimationState)(visualElement));
        /**
         * Subscribe any provided AnimationControls to the component's VisualElement
         */ if ((0, $k8Lf0.isAnimationControls)(animate)) (0, $acw62.useEffect)(function() {
            return animate.subscribe(visualElement);
        }, [
            animate
        ]);
    }),
    exit: (0, $igYbV.makeRenderlessComponent)(function(props) {
        var custom = props.custom, visualElement = props.visualElement;
        var _a = (0, $7WQrb.__read)((0, $iL8MI.usePresence)(), 2), isPresent = _a[0], safeToRemove = _a[1];
        var presenceContext = (0, $acw62.useContext)((0, $gtJis.PresenceContext));
        (0, $acw62.useEffect)(function() {
            var _a, _b;
            visualElement.isPresent = isPresent;
            var animation = (_a = visualElement.animationState) === null || _a === void 0 ? void 0 : _a.setActive((0, $5fU40.AnimationType).Exit, !isPresent, {
                custom: (_b = presenceContext === null || presenceContext === void 0 ? void 0 : presenceContext.custom) !== null && _b !== void 0 ? _b : custom
            });
            !isPresent && (animation === null || animation === void 0 || animation.then(safeToRemove));
        }, [
            isPresent
        ]);
    })
};

});
parcelRegister("iL8MI", function(module, exports) {

$parcel$export(module.exports, "usePresence", () => $bc77fac60b5d77cc$export$2a8c16d82a0a0e26);

var $acw62 = parcelRequire("acw62");

var $gtJis = parcelRequire("gtJis");

var $2XkbO = parcelRequire("2XkbO");
/**
 * When a component is the child of `AnimatePresence`, it can use `usePresence`
 * to access information about whether it's still present in the React tree.
 *
 * ```jsx
 * import { usePresence } from "framer-motion"
 *
 * export const Component = () => {
 *   const [isPresent, safeToRemove] = usePresence()
 *
 *   useEffect(() => {
 *     !isPresent && setTimeout(safeToRemove, 1000)
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * If `isPresent` is `false`, it means that a component has been removed the tree, but
 * `AnimatePresence` won't really remove it until `safeToRemove` has been called.
 *
 * @public
 */ function $bc77fac60b5d77cc$export$2a8c16d82a0a0e26() {
    var context = (0, $acw62.useContext)((0, $gtJis.PresenceContext));
    if (context === null) return [
        true,
        null
    ];
    var isPresent = context.isPresent, onExitComplete = context.onExitComplete, register = context.register;
    // It's safe to call the following hooks conditionally (after an early return) because the context will always
    // either be null or non-null for the lifespan of the component.
    // Replace with useId when released in React
    var id = (0, $2XkbO.useId)();
    (0, $acw62.useEffect)(function() {
        return register(id);
    }, []);
    var safeToRemove = function() {
        return onExitComplete === null || onExitComplete === void 0 ? void 0 : onExitComplete(id);
    };
    return !isPresent && onExitComplete ? [
        false,
        safeToRemove
    ] : [
        true
    ];
}
/**
 * Similar to `usePresence`, except `useIsPresent` simply returns whether or not the component is present.
 * There is no `safeToRemove` function.
 *
 * ```jsx
 * import { useIsPresent } from "framer-motion"
 *
 * export const Component = () => {
 *   const isPresent = useIsPresent()
 *
 *   useEffect(() => {
 *     !isPresent && console.log("I've been removed!")
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * @public
 */ function $bc77fac60b5d77cc$export$8249053f690ea39a() {
    return $bc77fac60b5d77cc$export$ee27c052bca048fb((0, $acw62.useContext)((0, $gtJis.PresenceContext)));
}
function $bc77fac60b5d77cc$export$ee27c052bca048fb(context) {
    return context === null ? true : context.isPresent;
}

});
parcelRegister("2XkbO", function(module, exports) {

$parcel$export(module.exports, "useId", () => $127b7aeab05cc0df$export$f680877a34711e37);

var $aTYEI = parcelRequire("aTYEI");
var $127b7aeab05cc0df$var$counter = 0;
var $127b7aeab05cc0df$var$incrementId = function() {
    return $127b7aeab05cc0df$var$counter++;
};
var $127b7aeab05cc0df$export$f680877a34711e37 = function() {
    return (0, $aTYEI.useConstant)($127b7aeab05cc0df$var$incrementId);
};

});


parcelRegister("dOx92", function(module, exports) {

$parcel$export(module.exports, "variantPriorityOrder", () => $351ff45a987b08cc$export$16e45afcc206d3a8);
$parcel$export(module.exports, "createAnimationState", () => $351ff45a987b08cc$export$bb53502b7a672aa8);

var $7WQrb = parcelRequire("7WQrb");

var $k8Lf0 = parcelRequire("k8Lf0");

var $eT2fJ = parcelRequire("eT2fJ");

var $3aeKv = parcelRequire("3aeKv");

var $1jp9R = parcelRequire("1jp9R");

var $5fU40 = parcelRequire("5fU40");

var $8QQaD = parcelRequire("8QQaD");
var $351ff45a987b08cc$export$16e45afcc206d3a8 = [
    (0, $5fU40.AnimationType).Animate,
    (0, $5fU40.AnimationType).InView,
    (0, $5fU40.AnimationType).Focus,
    (0, $5fU40.AnimationType).Hover,
    (0, $5fU40.AnimationType).Tap,
    (0, $5fU40.AnimationType).Drag,
    (0, $5fU40.AnimationType).Exit
];
var $351ff45a987b08cc$var$reversePriorityOrder = (0, $7WQrb.__spreadArray)([], (0, $7WQrb.__read)($351ff45a987b08cc$export$16e45afcc206d3a8), false).reverse();
var $351ff45a987b08cc$var$numAnimationTypes = $351ff45a987b08cc$export$16e45afcc206d3a8.length;
function $351ff45a987b08cc$var$animateList(visualElement) {
    return function(animations) {
        return Promise.all(animations.map(function(_a) {
            var animation = _a.animation, options = _a.options;
            return (0, $1jp9R.animateVisualElement)(visualElement, animation, options);
        }));
    };
}
function $351ff45a987b08cc$export$bb53502b7a672aa8(visualElement) {
    var animate = $351ff45a987b08cc$var$animateList(visualElement);
    var state = $351ff45a987b08cc$var$createState();
    var allAnimatedKeys = {};
    var isInitialRender = true;
    /**
     * This function will be used to reduce the animation definitions for
     * each active animation type into an object of resolved values for it.
     */ var buildResolvedTypeValues = function(acc, definition) {
        var resolved = (0, $8QQaD.resolveVariant)(visualElement, definition);
        if (resolved) {
            resolved.transition;
            var transitionEnd = resolved.transitionEnd, target = (0, $7WQrb.__rest)(resolved, [
                "transition",
                "transitionEnd"
            ]);
            acc = (0, $7WQrb.__assign)((0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, acc), target), transitionEnd);
        }
        return acc;
    };
    function isAnimated(key) {
        return allAnimatedKeys[key] !== undefined;
    }
    /**
     * This just allows us to inject mocked animation functions
     * @internal
     */ function setAnimateFunction(makeAnimator) {
        animate = makeAnimator(visualElement);
    }
    /**
     * When we receive new props, we need to:
     * 1. Create a list of protected keys for each type. This is a directory of
     *    value keys that are currently being "handled" by types of a higher priority
     *    so that whenever an animation is played of a given type, these values are
     *    protected from being animated.
     * 2. Determine if an animation type needs animating.
     * 3. Determine if any values have been removed from a type and figure out
     *    what to animate those to.
     */ function animateChanges(options, changedActiveType) {
        var _a;
        var props = visualElement.getProps();
        var context = visualElement.getVariantContext(true) || {};
        /**
         * A list of animations that we'll build into as we iterate through the animation
         * types. This will get executed at the end of the function.
         */ var animations = [];
        /**
         * Keep track of which values have been removed. Then, as we hit lower priority
         * animation types, we can check if they contain removed values and animate to that.
         */ var removedKeys = new Set();
        /**
         * A dictionary of all encountered keys. This is an object to let us build into and
         * copy it without iteration. Each time we hit an animation type we set its protected
         * keys - the keys its not allowed to animate - to the latest version of this object.
         */ var encounteredKeys = {};
        /**
         * If a variant has been removed at a given index, and this component is controlling
         * variant animations, we want to ensure lower-priority variants are forced to animate.
         */ var removedVariantIndex = Infinity;
        var _loop_1 = function(i) {
            var type = $351ff45a987b08cc$var$reversePriorityOrder[i];
            var typeState = state[type];
            var prop = (_a = props[type]) !== null && _a !== void 0 ? _a : context[type];
            var propIsVariant = (0, $8QQaD.isVariantLabel)(prop);
            /**
             * If this type has *just* changed isActive status, set activeDelta
             * to that status. Otherwise set to null.
             */ var activeDelta = type === changedActiveType ? typeState.isActive : null;
            if (activeDelta === false) removedVariantIndex = i;
            /**
             * If this prop is an inherited variant, rather than been set directly on the
             * component itself, we want to make sure we allow the parent to trigger animations.
             *
             * TODO: Can probably change this to a !isControllingVariants check
             */ var isInherited = prop === context[type] && prop !== props[type] && propIsVariant;
            /**
             *
             */ if (isInherited && isInitialRender && visualElement.manuallyAnimateOnMount) isInherited = false;
            /**
             * Set all encountered keys so far as the protected keys for this type. This will
             * be any key that has been animated or otherwise handled by active, higher-priortiy types.
             */ typeState.protectedKeys = (0, $7WQrb.__assign)({}, encounteredKeys);
            // Check if we can skip analysing this prop early
            if (// If it isn't active and hasn't *just* been set as inactive
            !typeState.isActive && activeDelta === null || // If we didn't and don't have any defined prop for this animation type
            !prop && !typeState.prevProp || // Or if the prop doesn't define an animation
            (0, $k8Lf0.isAnimationControls)(prop) || typeof prop === "boolean") return "continue";
            /**
             * As we go look through the values defined on this type, if we detect
             * a changed value or a value that was removed in a higher priority, we set
             * this to true and add this prop to the animation list.
             */ var variantDidChange = $351ff45a987b08cc$export$68651800594fd43c(typeState.prevProp, prop);
            var shouldAnimateType = variantDidChange || // If we're making this variant active, we want to always make it active
            type === changedActiveType && typeState.isActive && !isInherited && propIsVariant || // If we removed a higher-priority variant (i is in reverse order)
            i > removedVariantIndex && propIsVariant;
            /**
             * As animations can be set as variant lists, variants or target objects, we
             * coerce everything to an array if it isn't one already
             */ var definitionList = Array.isArray(prop) ? prop : [
                prop
            ];
            /**
             * Build an object of all the resolved values. We'll use this in the subsequent
             * animateChanges calls to determine whether a value has changed.
             */ var resolvedValues = definitionList.reduce(buildResolvedTypeValues, {});
            if (activeDelta === false) resolvedValues = {};
            /**
             * Now we need to loop through all the keys in the prev prop and this prop,
             * and decide:
             * 1. If the value has changed, and needs animating
             * 2. If it has been removed, and needs adding to the removedKeys set
             * 3. If it has been removed in a higher priority type and needs animating
             * 4. If it hasn't been removed in a higher priority but hasn't changed, and
             *    needs adding to the type's protectedKeys list.
             */ var _b = typeState.prevResolvedValues, prevResolvedValues = _b === void 0 ? {} : _b;
            var allKeys = (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, prevResolvedValues), resolvedValues);
            var markToAnimate = function(key) {
                shouldAnimateType = true;
                removedKeys.delete(key);
                typeState.needsAnimating[key] = true;
            };
            for(var key in allKeys){
                var next = resolvedValues[key];
                var prev = prevResolvedValues[key];
                // If we've already handled this we can just skip ahead
                if (encounteredKeys.hasOwnProperty(key)) continue;
                /**
                 * If the value has changed, we probably want to animate it.
                 */ if (next !== prev) {
                    /**
                     * If both values are keyframes, we need to shallow compare them to
                     * detect whether any value has changed. If it has, we animate it.
                     */ if ((0, $eT2fJ.isKeyframesTarget)(next) && (0, $eT2fJ.isKeyframesTarget)(prev)) {
                        if (!(0, $3aeKv.shallowCompare)(next, prev) || variantDidChange) markToAnimate(key);
                        else /**
                             * If it hasn't changed, we want to ensure it doesn't animate by
                             * adding it to the list of protected keys.
                             */ typeState.protectedKeys[key] = true;
                    } else if (next !== undefined) // If next is defined and doesn't equal prev, it needs animating
                    markToAnimate(key);
                    else // If it's undefined, it's been removed.
                    removedKeys.add(key);
                } else if (next !== undefined && removedKeys.has(key)) /**
                     * If next hasn't changed and it isn't undefined, we want to check if it's
                     * been removed by a higher priority
                     */ markToAnimate(key);
                else /**
                     * If it hasn't changed, we add it to the list of protected values
                     * to ensure it doesn't get animated.
                     */ typeState.protectedKeys[key] = true;
            }
            /**
             * Update the typeState so next time animateChanges is called we can compare the
             * latest prop and resolvedValues to these.
             */ typeState.prevProp = prop;
            typeState.prevResolvedValues = resolvedValues;
            /**
             *
             */ if (typeState.isActive) encounteredKeys = (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, encounteredKeys), resolvedValues);
            if (isInitialRender && visualElement.blockInitialAnimation) shouldAnimateType = false;
            /**
             * If this is an inherited prop we want to hard-block animations
             * TODO: Test as this should probably still handle animations triggered
             * by removed values?
             */ if (shouldAnimateType && !isInherited) animations.push.apply(animations, (0, $7WQrb.__spreadArray)([], (0, $7WQrb.__read)(definitionList.map(function(animation) {
                return {
                    animation: animation,
                    options: (0, $7WQrb.__assign)({
                        type: type
                    }, options)
                };
            })), false));
        };
        /**
         * Iterate through all animation types in reverse priority order. For each, we want to
         * detect which values it's handling and whether or not they've changed (and therefore
         * need to be animated). If any values have been removed, we want to detect those in
         * lower priority props and flag for animation.
         */ for(var i = 0; i < $351ff45a987b08cc$var$numAnimationTypes; i++)_loop_1(i);
        allAnimatedKeys = (0, $7WQrb.__assign)({}, encounteredKeys);
        /**
         * If there are some removed value that haven't been dealt with,
         * we need to create a new animation that falls back either to the value
         * defined in the style prop, or the last read value.
         */ if (removedKeys.size) {
            var fallbackAnimation_1 = {};
            removedKeys.forEach(function(key) {
                var fallbackTarget = visualElement.getBaseTarget(key);
                if (fallbackTarget !== undefined) fallbackAnimation_1[key] = fallbackTarget;
            });
            animations.push({
                animation: fallbackAnimation_1
            });
        }
        var shouldAnimate = Boolean(animations.length);
        if (isInitialRender && props.initial === false && !visualElement.manuallyAnimateOnMount) shouldAnimate = false;
        isInitialRender = false;
        return shouldAnimate ? animate(animations) : Promise.resolve();
    }
    /**
     * Change whether a certain animation type is active.
     */ function setActive(type, isActive, options) {
        var _a;
        // If the active state hasn't changed, we can safely do nothing here
        if (state[type].isActive === isActive) return Promise.resolve();
        // Propagate active change to children
        (_a = visualElement.variantChildren) === null || _a === void 0 || _a.forEach(function(child) {
            var _a;
            return (_a = child.animationState) === null || _a === void 0 ? void 0 : _a.setActive(type, isActive);
        });
        state[type].isActive = isActive;
        var animations = animateChanges(options, type);
        for(var key in state)state[key].protectedKeys = {};
        return animations;
    }
    return {
        isAnimated: isAnimated,
        animateChanges: animateChanges,
        setActive: setActive,
        setAnimateFunction: setAnimateFunction,
        getState: function() {
            return state;
        }
    };
}
function $351ff45a987b08cc$export$68651800594fd43c(prev, next) {
    if (typeof next === "string") return next !== prev;
    else if ((0, $8QQaD.isVariantLabels)(next)) return !(0, $3aeKv.shallowCompare)(next, prev);
    return false;
}
function $351ff45a987b08cc$var$createTypeState(isActive) {
    if (isActive === void 0) isActive = false;
    return {
        isActive: isActive,
        protectedKeys: {},
        needsAnimating: {},
        prevResolvedValues: {}
    };
}
function $351ff45a987b08cc$var$createState() {
    var _a;
    return _a = {}, _a[(0, $5fU40.AnimationType).Animate] = $351ff45a987b08cc$var$createTypeState(true), _a[(0, $5fU40.AnimationType).InView] = $351ff45a987b08cc$var$createTypeState(), _a[(0, $5fU40.AnimationType).Hover] = $351ff45a987b08cc$var$createTypeState(), _a[(0, $5fU40.AnimationType).Tap] = $351ff45a987b08cc$var$createTypeState(), _a[(0, $5fU40.AnimationType).Drag] = $351ff45a987b08cc$var$createTypeState(), _a[(0, $5fU40.AnimationType).Focus] = $351ff45a987b08cc$var$createTypeState(), _a[(0, $5fU40.AnimationType).Exit] = $351ff45a987b08cc$var$createTypeState(), _a;
}

});
parcelRegister("3aeKv", function(module, exports) {

$parcel$export(module.exports, "shallowCompare", () => $21ec58272207c53a$export$90e866afbd6b9f1a);
function $21ec58272207c53a$export$90e866afbd6b9f1a(next, prev) {
    if (!Array.isArray(prev)) return false;
    var prevLength = prev.length;
    if (prevLength !== next.length) return false;
    for(var i = 0; i < prevLength; i++){
        if (prev[i] !== next[i]) return false;
    }
    return true;
}

});

parcelRegister("1jp9R", function(module, exports) {

$parcel$export(module.exports, "animateVisualElement", () => $66bcda5a48aeb596$export$ff62cf473653f109);

var $7WQrb = parcelRequire("7WQrb");

var $bUTXm = parcelRequire("bUTXm");

var $87OLY = parcelRequire("87OLY");

var $8QQaD = parcelRequire("8QQaD");

var $5f0mC = parcelRequire("5f0mC");
function $66bcda5a48aeb596$export$ff62cf473653f109(visualElement, definition, options) {
    if (options === void 0) options = {};
    visualElement.notifyAnimationStart(definition);
    var animation;
    if (Array.isArray(definition)) {
        var animations = definition.map(function(variant) {
            return $66bcda5a48aeb596$var$animateVariant(visualElement, variant, options);
        });
        animation = Promise.all(animations);
    } else if (typeof definition === "string") animation = $66bcda5a48aeb596$var$animateVariant(visualElement, definition, options);
    else {
        var resolvedDefinition = typeof definition === "function" ? (0, $8QQaD.resolveVariant)(visualElement, definition, options.custom) : definition;
        animation = $66bcda5a48aeb596$var$animateTarget(visualElement, resolvedDefinition, options);
    }
    return animation.then(function() {
        return visualElement.notifyAnimationComplete(definition);
    });
}
function $66bcda5a48aeb596$var$animateVariant(visualElement, variant, options) {
    var _a;
    if (options === void 0) options = {};
    var resolved = (0, $8QQaD.resolveVariant)(visualElement, variant, options.custom);
    var _b = (resolved || {}).transition, transition = _b === void 0 ? visualElement.getDefaultTransition() || {} : _b;
    if (options.transitionOverride) transition = options.transitionOverride;
    /**
     * If we have a variant, create a callback that runs it as an animation.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ var getAnimation = resolved ? function() {
        return $66bcda5a48aeb596$var$animateTarget(visualElement, resolved, options);
    } : function() {
        return Promise.resolve();
    };
    /**
     * If we have children, create a callback that runs all their animations.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ var getChildAnimations = ((_a = visualElement.variantChildren) === null || _a === void 0 ? void 0 : _a.size) ? function(forwardDelay) {
        if (forwardDelay === void 0) forwardDelay = 0;
        var _a = transition.delayChildren, delayChildren = _a === void 0 ? 0 : _a, staggerChildren = transition.staggerChildren, staggerDirection = transition.staggerDirection;
        return $66bcda5a48aeb596$var$animateChildren(visualElement, variant, delayChildren + forwardDelay, staggerChildren, staggerDirection, options);
    } : function() {
        return Promise.resolve();
    };
    /**
     * If the transition explicitly defines a "when" option, we need to resolve either
     * this animation or all children animations before playing the other.
     */ var when = transition.when;
    if (when) {
        var _c = (0, $7WQrb.__read)(when === "beforeChildren" ? [
            getAnimation,
            getChildAnimations
        ] : [
            getChildAnimations,
            getAnimation
        ], 2), first = _c[0], last = _c[1];
        return first().then(last);
    } else return Promise.all([
        getAnimation(),
        getChildAnimations(options.delay)
    ]);
}
/**
 * @internal
 */ function $66bcda5a48aeb596$var$animateTarget(visualElement, definition, _a) {
    var _b;
    var _c = _a === void 0 ? {} : _a, _d = _c.delay, delay = _d === void 0 ? 0 : _d, transitionOverride = _c.transitionOverride, type = _c.type;
    var _e = visualElement.makeTargetAnimatable(definition), _f = _e.transition, transition = _f === void 0 ? visualElement.getDefaultTransition() : _f, transitionEnd = _e.transitionEnd, target = (0, $7WQrb.__rest)(_e, [
        "transition",
        "transitionEnd"
    ]);
    if (transitionOverride) transition = transitionOverride;
    var animations = [];
    var animationTypeState = type && ((_b = visualElement.animationState) === null || _b === void 0 ? void 0 : _b.getState()[type]);
    for(var key in target){
        var value = visualElement.getValue(key);
        var valueTarget = target[key];
        if (!value || valueTarget === undefined || animationTypeState && $66bcda5a48aeb596$var$shouldBlockAnimation(animationTypeState, key)) continue;
        var valueTransition = (0, $7WQrb.__assign)({
            delay: delay
        }, transition);
        /**
         * Make animation instant if this is a transform prop and we should reduce motion.
         */ if (visualElement.shouldReduceMotion && (0, $5f0mC.isTransformProp)(key)) valueTransition = (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, valueTransition), {
            type: false,
            delay: 0
        });
        var animation = (0, $bUTXm.startAnimation)(key, value, valueTarget, valueTransition);
        animations.push(animation);
    }
    return Promise.all(animations).then(function() {
        transitionEnd && (0, $87OLY.setTarget)(visualElement, transitionEnd);
    });
}
function $66bcda5a48aeb596$var$animateChildren(visualElement, variant, delayChildren, staggerChildren, staggerDirection, options) {
    if (delayChildren === void 0) delayChildren = 0;
    if (staggerChildren === void 0) staggerChildren = 0;
    if (staggerDirection === void 0) staggerDirection = 1;
    var animations = [];
    var maxStaggerDuration = (visualElement.variantChildren.size - 1) * staggerChildren;
    var generateStaggerDuration = staggerDirection === 1 ? function(i) {
        if (i === void 0) i = 0;
        return i * staggerChildren;
    } : function(i) {
        if (i === void 0) i = 0;
        return maxStaggerDuration - i * staggerChildren;
    };
    Array.from(visualElement.variantChildren).sort($66bcda5a48aeb596$export$523a0bedf33ad781).forEach(function(child, i) {
        animations.push($66bcda5a48aeb596$var$animateVariant(child, variant, (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, options), {
            delay: delayChildren + generateStaggerDuration(i)
        })).then(function() {
            return child.notifyAnimationComplete(variant);
        }));
    });
    return Promise.all(animations);
}
function $66bcda5a48aeb596$export$3cc6f911ef1fd837(visualElement) {
    visualElement.forEachValue(function(value) {
        return value.stop();
    });
}
function $66bcda5a48aeb596$export$523a0bedf33ad781(a, b) {
    return a.sortNodePosition(b);
}
/**
 * Decide whether we should block this animation. Previously, we achieved this
 * just by checking whether the key was listed in protectedKeys, but this
 * posed problems if an animation was triggered by afterChildren and protectedKeys
 * had been set to true in the meantime.
 */ function $66bcda5a48aeb596$var$shouldBlockAnimation(_a, key) {
    var protectedKeys = _a.protectedKeys, needsAnimating = _a.needsAnimating;
    var shouldBlock = protectedKeys.hasOwnProperty(key) && needsAnimating[key] !== true;
    needsAnimating[key] = false;
    return shouldBlock;
}

});
parcelRegister("bUTXm", function(module, exports) {

$parcel$export(module.exports, "getValueTransition", () => $ec9bae3b9c638c7a$export$7c1391340308742e);
$parcel$export(module.exports, "startAnimation", () => $ec9bae3b9c638c7a$export$592dbd515a49cf1b);

var $7WQrb = parcelRequire("7WQrb");

var $lCAKk = parcelRequire("lCAKk");
var $ihubQ = parcelRequire("ihubQ");

var $iNwSi = parcelRequire("iNwSi");

var $335pm = parcelRequire("335pm");

var $fyA1E = parcelRequire("fyA1E");

var $kSXzE = parcelRequire("kSXzE");

var $6QSfE = parcelRequire("6QSfE");

var $adXv8 = parcelRequire("adXv8");

var $cImAs = parcelRequire("cImAs");

var $lyAek = parcelRequire("lyAek");
/**
 * Decide whether a transition is defined on a given Transition.
 * This filters out orchestration options and returns true
 * if any options are left.
 */ function $ec9bae3b9c638c7a$export$ca8e47dc8ed5a9d7(_a) {
    _a.when;
    _a.delay;
    _a.delayChildren;
    _a.staggerChildren;
    _a.staggerDirection;
    _a.repeat;
    _a.repeatType;
    _a.repeatDelay;
    _a.from;
    var transition = (0, $7WQrb.__rest)(_a, [
        "when",
        "delay",
        "delayChildren",
        "staggerChildren",
        "staggerDirection",
        "repeat",
        "repeatType",
        "repeatDelay",
        "from"
    ]);
    return !!Object.keys(transition).length;
}
var $ec9bae3b9c638c7a$var$legacyRepeatWarning = false;
/**
 * Convert Framer Motion's Transition type into Popmotion-compatible options.
 */ function $ec9bae3b9c638c7a$export$998eb6d72a6574db(_a) {
    var ease = _a.ease, times = _a.times, yoyo = _a.yoyo, flip = _a.flip, loop = _a.loop, transition = (0, $7WQrb.__rest)(_a, [
        "ease",
        "times",
        "yoyo",
        "flip",
        "loop"
    ]);
    var options = (0, $7WQrb.__assign)({}, transition);
    if (times) options["offset"] = times;
    /**
     * Convert any existing durations from seconds to milliseconds
     */ if (transition.duration) options["duration"] = (0, $iNwSi.secondsToMilliseconds)(transition.duration);
    if (transition.repeatDelay) options.repeatDelay = (0, $iNwSi.secondsToMilliseconds)(transition.repeatDelay);
    /**
     * Map easing names to Popmotion's easing functions
     */ if (ease) options["ease"] = (0, $335pm.isEasingArray)(ease) ? ease.map((0, $335pm.easingDefinitionToFunction)) : (0, $335pm.easingDefinitionToFunction)(ease);
    /**
     * Support legacy transition API
     */ if (transition.type === "tween") options.type = "keyframes";
    /**
     * TODO: These options are officially removed from the API.
     */ if (yoyo || loop || flip) {
        (0, $6QSfE.warning)(!$ec9bae3b9c638c7a$var$legacyRepeatWarning, "yoyo, loop and flip have been removed from the API. Replace with repeat and repeatType options.");
        $ec9bae3b9c638c7a$var$legacyRepeatWarning = true;
        if (yoyo) options.repeatType = "reverse";
        else if (loop) options.repeatType = "loop";
        else if (flip) options.repeatType = "mirror";
        options.repeat = loop || yoyo || flip || transition.repeat;
    }
    /**
     * TODO: Popmotion 9 has the ability to automatically detect whether to use
     * a keyframes or spring animation, but does so by detecting velocity and other spring options.
     * It'd be good to introduce a similar thing here.
     */ if (transition.type !== "spring") options.type = "keyframes";
    return options;
}
/**
 * Get the delay for a value by checking Transition with decreasing specificity.
 */ function $ec9bae3b9c638c7a$export$b55a0e77aebddb70(transition, key) {
    var _a, _b;
    var valueTransition = $ec9bae3b9c638c7a$export$7c1391340308742e(transition, key) || {};
    return (_b = (_a = valueTransition.delay) !== null && _a !== void 0 ? _a : transition.delay) !== null && _b !== void 0 ? _b : 0;
}
function $ec9bae3b9c638c7a$export$3d2f5b3e7004e0cf(options) {
    if (Array.isArray(options.to) && options.to[0] === null) {
        options.to = (0, $7WQrb.__spreadArray)([], (0, $7WQrb.__read)(options.to), false);
        options.to[0] = options.from;
    }
    return options;
}
function $ec9bae3b9c638c7a$export$9019a69adbea191(transition, options, key) {
    var _a;
    if (Array.isArray(options.to)) (_a = transition.duration) !== null && _a !== void 0 ? _a : transition.duration = 0.8;
    $ec9bae3b9c638c7a$export$3d2f5b3e7004e0cf(options);
    /**
     * Get a default transition if none is determined to be defined.
     */ if (!$ec9bae3b9c638c7a$export$ca8e47dc8ed5a9d7(transition)) transition = (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, transition), (0, $kSXzE.getDefaultTransition)(key, options.to));
    return (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, options), $ec9bae3b9c638c7a$export$998eb6d72a6574db(transition));
}
/**
 *
 */ function $ec9bae3b9c638c7a$var$getAnimation(key, value, target, transition, onComplete) {
    var _a;
    var valueTransition = $ec9bae3b9c638c7a$export$7c1391340308742e(transition, key);
    var origin = (_a = valueTransition.from) !== null && _a !== void 0 ? _a : value.get();
    var isTargetAnimatable = (0, $fyA1E.isAnimatable)(key, target);
    if (origin === "none" && isTargetAnimatable && typeof target === "string") /**
         * If we're trying to animate from "none", try and get an animatable version
         * of the target. This could be improved to work both ways.
         */ origin = (0, $adXv8.getAnimatableNone)(key, target);
    else if ($ec9bae3b9c638c7a$export$c46ec7d82fb1f602(origin) && typeof target === "string") origin = $ec9bae3b9c638c7a$export$36cd6032f9de8a48(target);
    else if (!Array.isArray(target) && $ec9bae3b9c638c7a$export$c46ec7d82fb1f602(target) && typeof origin === "string") target = $ec9bae3b9c638c7a$export$36cd6032f9de8a48(origin);
    var isOriginAnimatable = (0, $fyA1E.isAnimatable)(key, origin);
    (0, $6QSfE.warning)(isOriginAnimatable === isTargetAnimatable, "You are trying to animate ".concat(key, ' from "').concat(origin, '" to "').concat(target, '". ').concat(origin, " is not an animatable value - to enable this animation set ").concat(origin, " to a value animatable to ").concat(target, " via the `style` property."));
    function start() {
        var options = {
            from: origin,
            to: target,
            velocity: value.getVelocity(),
            onComplete: onComplete,
            onUpdate: function(v) {
                return value.set(v);
            }
        };
        return valueTransition.type === "inertia" || valueTransition.type === "decay" ? (0, $ihubQ.inertia)((0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, options), valueTransition)) : (0, $lCAKk.animate)((0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, $ec9bae3b9c638c7a$export$9019a69adbea191(valueTransition, options, key)), {
            onUpdate: function(v) {
                var _a;
                options.onUpdate(v);
                (_a = valueTransition.onUpdate) === null || _a === void 0 || _a.call(valueTransition, v);
            },
            onComplete: function() {
                var _a;
                options.onComplete();
                (_a = valueTransition.onComplete) === null || _a === void 0 || _a.call(valueTransition);
            }
        }));
    }
    function set() {
        var _a, _b;
        var finalTarget = (0, $lyAek.resolveFinalValueInKeyframes)(target);
        value.set(finalTarget);
        onComplete();
        (_a = valueTransition === null || valueTransition === void 0 ? void 0 : valueTransition.onUpdate) === null || _a === void 0 || _a.call(valueTransition, finalTarget);
        (_b = valueTransition === null || valueTransition === void 0 ? void 0 : valueTransition.onComplete) === null || _b === void 0 || _b.call(valueTransition);
        return {
            stop: function() {}
        };
    }
    return !isOriginAnimatable || !isTargetAnimatable || valueTransition.type === false ? set : start;
}
function $ec9bae3b9c638c7a$export$c46ec7d82fb1f602(value) {
    return value === 0 || typeof value === "string" && parseFloat(value) === 0 && value.indexOf(" ") === -1;
}
function $ec9bae3b9c638c7a$export$36cd6032f9de8a48(potentialUnitType) {
    return typeof potentialUnitType === "number" ? 0 : (0, $adXv8.getAnimatableNone)("", potentialUnitType);
}
function $ec9bae3b9c638c7a$export$7c1391340308742e(transition, key) {
    return transition[key] || transition["default"] || transition;
}
/**
 * Start animation on a MotionValue. This function is an interface between
 * Framer Motion and Popmotion
 */ function $ec9bae3b9c638c7a$export$592dbd515a49cf1b(key, value, target, transition) {
    if (transition === void 0) transition = {};
    if ((0, $cImAs.instantAnimationState).current) transition = {
        type: false
    };
    return value.start(function(onComplete) {
        var delayTimer;
        var controls;
        var animation = $ec9bae3b9c638c7a$var$getAnimation(key, value, target, transition, onComplete);
        var delay = $ec9bae3b9c638c7a$export$b55a0e77aebddb70(transition, key);
        var start = function() {
            return controls = animation();
        };
        if (delay) delayTimer = window.setTimeout(start, (0, $iNwSi.secondsToMilliseconds)(delay));
        else start();
        return function() {
            clearTimeout(delayTimer);
            controls === null || controls === void 0 || controls.stop();
        };
    });
}

});
parcelRegister("lCAKk", function(module, exports) {

$parcel$export(module.exports, "animate", () => $78eae5210e62d013$export$e3607ec2d7a891c4);

var $7WQrb = parcelRequire("7WQrb");

var $02hDU = parcelRequire("02hDU");

var $9ksIr = parcelRequire("9ksIr");

var $cXE0o = parcelRequire("cXE0o");

var $4KuFA = parcelRequire("4KuFA");
const $78eae5210e62d013$var$framesync = (update)=>{
    const passTimestamp = ({ delta: delta })=>update(delta);
    return {
        start: ()=>(0, $9ksIr.default).update(passTimestamp, true),
        stop: ()=>(0, $9ksIr.cancelSync).update(passTimestamp)
    };
};
function $78eae5210e62d013$export$e3607ec2d7a891c4(_a) {
    var _b, _c;
    var { from: from, autoplay: autoplay = true, driver: driver = $78eae5210e62d013$var$framesync, elapsed: elapsed = 0, repeat: repeatMax = 0, repeatType: repeatType = "loop", repeatDelay: repeatDelay = 0, onPlay: onPlay, onStop: onStop, onComplete: onComplete, onRepeat: onRepeat, onUpdate: onUpdate } = _a, options = (0, $7WQrb.__rest)(_a, [
        "from",
        "autoplay",
        "driver",
        "elapsed",
        "repeat",
        "repeatType",
        "repeatDelay",
        "onPlay",
        "onStop",
        "onComplete",
        "onRepeat",
        "onUpdate"
    ]);
    let { to: to } = options;
    let driverControls;
    let repeatCount = 0;
    let computedDuration = options.duration;
    let latest;
    let isComplete = false;
    let isForwardPlayback = true;
    let interpolateFromNumber;
    const animator = (0, $02hDU.detectAnimationFromOptions)(options);
    if ((_c = (_b = animator).needsInterpolation) === null || _c === void 0 ? void 0 : _c.call(_b, from, to)) {
        interpolateFromNumber = (0, $cXE0o.interpolate)([
            0,
            100
        ], [
            from,
            to
        ], {
            clamp: false
        });
        from = 0;
        to = 100;
    }
    const animation = animator(Object.assign(Object.assign({}, options), {
        from: from,
        to: to
    }));
    function repeat() {
        repeatCount++;
        if (repeatType === "reverse") {
            isForwardPlayback = repeatCount % 2 === 0;
            elapsed = (0, $4KuFA.reverseElapsed)(elapsed, computedDuration, repeatDelay, isForwardPlayback);
        } else {
            elapsed = (0, $4KuFA.loopElapsed)(elapsed, computedDuration, repeatDelay);
            if (repeatType === "mirror") animation.flipTarget();
        }
        isComplete = false;
        onRepeat && onRepeat();
    }
    function complete() {
        driverControls.stop();
        onComplete && onComplete();
    }
    function update(delta) {
        if (!isForwardPlayback) delta = -delta;
        elapsed += delta;
        if (!isComplete) {
            const state = animation.next(Math.max(0, elapsed));
            latest = state.value;
            if (interpolateFromNumber) latest = interpolateFromNumber(latest);
            isComplete = isForwardPlayback ? state.done : elapsed <= 0;
        }
        onUpdate === null || onUpdate === void 0 || onUpdate(latest);
        if (isComplete) {
            if (repeatCount === 0) computedDuration !== null && computedDuration !== void 0 ? computedDuration : computedDuration = elapsed;
            if (repeatCount < repeatMax) (0, $4KuFA.hasRepeatDelayElapsed)(elapsed, computedDuration, repeatDelay, isForwardPlayback) && repeat();
            else complete();
        }
    }
    function play() {
        onPlay === null || onPlay === void 0 || onPlay();
        driverControls = driver(update);
        driverControls.start();
    }
    autoplay && play();
    return {
        stop: ()=>{
            onStop === null || onStop === void 0 || onStop();
            driverControls.stop();
        }
    };
}

});
parcelRegister("02hDU", function(module, exports) {

$parcel$export(module.exports, "detectAnimationFromOptions", () => $62946488586fc0f6$export$74df49bbebf8cb2c);

var $7N55U = parcelRequire("7N55U");

var $1Wo4Q = parcelRequire("1Wo4Q");

var $2plaU = parcelRequire("2plaU");
const $62946488586fc0f6$var$types = {
    keyframes: $1Wo4Q.keyframes,
    spring: $7N55U.spring,
    decay: $2plaU.decay
};
function $62946488586fc0f6$export$74df49bbebf8cb2c(config) {
    if (Array.isArray(config.to)) return 0, $1Wo4Q.keyframes;
    else if ($62946488586fc0f6$var$types[config.type]) return $62946488586fc0f6$var$types[config.type];
    const keys = new Set(Object.keys(config));
    if (keys.has("ease") || keys.has("duration") && !keys.has("dampingRatio")) return 0, $1Wo4Q.keyframes;
    else if (keys.has("dampingRatio") || keys.has("stiffness") || keys.has("mass") || keys.has("damping") || keys.has("restSpeed") || keys.has("restDelta")) return 0, $7N55U.spring;
    return 0, $1Wo4Q.keyframes;
}

});
parcelRegister("7N55U", function(module, exports) {

$parcel$export(module.exports, "spring", () => $2d5853cd754ec0a8$export$b36281d89752ae66);

var $7WQrb = parcelRequire("7WQrb");

var $afNa3 = parcelRequire("afNa3");
const $2d5853cd754ec0a8$var$durationKeys = [
    "duration",
    "bounce"
];
const $2d5853cd754ec0a8$var$physicsKeys = [
    "stiffness",
    "damping",
    "mass"
];
function $2d5853cd754ec0a8$var$isSpringType(options, keys) {
    return keys.some((key)=>options[key] !== undefined);
}
function $2d5853cd754ec0a8$var$getSpringOptions(options) {
    let springOptions = Object.assign({
        velocity: 0.0,
        stiffness: 100,
        damping: 10,
        mass: 1.0,
        isResolvedFromDuration: false
    }, options);
    if (!$2d5853cd754ec0a8$var$isSpringType(options, $2d5853cd754ec0a8$var$physicsKeys) && $2d5853cd754ec0a8$var$isSpringType(options, $2d5853cd754ec0a8$var$durationKeys)) {
        const derived = (0, $afNa3.findSpring)(options);
        springOptions = Object.assign(Object.assign(Object.assign({}, springOptions), derived), {
            velocity: 0.0,
            mass: 1.0
        });
        springOptions.isResolvedFromDuration = true;
    }
    return springOptions;
}
function $2d5853cd754ec0a8$export$b36281d89752ae66(_a) {
    var { from: from = 0.0, to: to = 1.0, restSpeed: restSpeed = 2, restDelta: restDelta } = _a, options = (0, $7WQrb.__rest)(_a, [
        "from",
        "to",
        "restSpeed",
        "restDelta"
    ]);
    const state = {
        done: false,
        value: from
    };
    let { stiffness: stiffness, damping: damping, mass: mass, velocity: velocity, duration: duration, isResolvedFromDuration: isResolvedFromDuration } = $2d5853cd754ec0a8$var$getSpringOptions(options);
    let resolveSpring = $2d5853cd754ec0a8$var$zero;
    let resolveVelocity = $2d5853cd754ec0a8$var$zero;
    function createSpring() {
        const initialVelocity = velocity ? -(velocity / 1000) : 0.0;
        const initialDelta = to - from;
        const dampingRatio = damping / (2 * Math.sqrt(stiffness * mass));
        const undampedAngularFreq = Math.sqrt(stiffness / mass) / 1000;
        if (restDelta === undefined) restDelta = Math.min(Math.abs(to - from) / 100, 0.4);
        if (dampingRatio < 1) {
            const angularFreq = (0, $afNa3.calcAngularFreq)(undampedAngularFreq, dampingRatio);
            resolveSpring = (t)=>{
                const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
                return to - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) / angularFreq * Math.sin(angularFreq * t) + initialDelta * Math.cos(angularFreq * t));
            };
            resolveVelocity = (t)=>{
                const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
                return dampingRatio * undampedAngularFreq * envelope * (Math.sin(angularFreq * t) * (initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) / angularFreq + initialDelta * Math.cos(angularFreq * t)) - envelope * (Math.cos(angularFreq * t) * (initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) - angularFreq * initialDelta * Math.sin(angularFreq * t));
            };
        } else if (dampingRatio === 1) resolveSpring = (t)=>to - Math.exp(-undampedAngularFreq * t) * (initialDelta + (initialVelocity + undampedAngularFreq * initialDelta) * t);
        else {
            const dampedAngularFreq = undampedAngularFreq * Math.sqrt(dampingRatio * dampingRatio - 1);
            resolveSpring = (t)=>{
                const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
                const freqForT = Math.min(dampedAngularFreq * t, 300);
                return to - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) * Math.sinh(freqForT) + dampedAngularFreq * initialDelta * Math.cosh(freqForT)) / dampedAngularFreq;
            };
        }
    }
    createSpring();
    return {
        next: (t)=>{
            const current = resolveSpring(t);
            if (!isResolvedFromDuration) {
                const currentVelocity = resolveVelocity(t) * 1000;
                const isBelowVelocityThreshold = Math.abs(currentVelocity) <= restSpeed;
                const isBelowDisplacementThreshold = Math.abs(to - current) <= restDelta;
                state.done = isBelowVelocityThreshold && isBelowDisplacementThreshold;
            } else state.done = t >= duration;
            state.value = state.done ? to : current;
            return state;
        },
        flipTarget: ()=>{
            velocity = -velocity;
            [from, to] = [
                to,
                from
            ];
            createSpring();
        }
    };
}
$2d5853cd754ec0a8$export$b36281d89752ae66.needsInterpolation = (a, b)=>typeof a === "string" || typeof b === "string";
const $2d5853cd754ec0a8$var$zero = (_t)=>0;

});
parcelRegister("afNa3", function(module, exports) {

$parcel$export(module.exports, "findSpring", () => $b1fa26b3c95498fa$export$b15f158dc6d6f458);
$parcel$export(module.exports, "calcAngularFreq", () => $b1fa26b3c95498fa$export$5f679887c3a78b15);

var $6QSfE = parcelRequire("6QSfE");

var $ezcIX = parcelRequire("ezcIX");
const $b1fa26b3c95498fa$var$safeMin = 0.001;
const $b1fa26b3c95498fa$export$a3cdb76e84ee608e = 0.01;
const $b1fa26b3c95498fa$export$1824b851fad8862b = 10.0;
const $b1fa26b3c95498fa$export$ff08f2d53484465 = 0.05;
const $b1fa26b3c95498fa$export$201ca48e54038115 = 1;
function $b1fa26b3c95498fa$export$b15f158dc6d6f458({ duration: duration = 800, bounce: bounce = 0.25, velocity: velocity = 0, mass: mass = 1 }) {
    let envelope;
    let derivative;
    (0, $6QSfE.warning)(duration <= $b1fa26b3c95498fa$export$1824b851fad8862b * 1000, "Spring duration must be 10 seconds or less");
    let dampingRatio = 1 - bounce;
    dampingRatio = (0, $ezcIX.clamp)($b1fa26b3c95498fa$export$ff08f2d53484465, $b1fa26b3c95498fa$export$201ca48e54038115, dampingRatio);
    duration = (0, $ezcIX.clamp)($b1fa26b3c95498fa$export$a3cdb76e84ee608e, $b1fa26b3c95498fa$export$1824b851fad8862b, duration / 1000);
    if (dampingRatio < 1) {
        envelope = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const a = exponentialDecay - velocity;
            const b = $b1fa26b3c95498fa$export$5f679887c3a78b15(undampedFreq, dampingRatio);
            const c = Math.exp(-delta);
            return $b1fa26b3c95498fa$var$safeMin - a / b * c;
        };
        derivative = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const d = delta * velocity + velocity;
            const e = Math.pow(dampingRatio, 2) * Math.pow(undampedFreq, 2) * duration;
            const f = Math.exp(-delta);
            const g = $b1fa26b3c95498fa$export$5f679887c3a78b15(Math.pow(undampedFreq, 2), dampingRatio);
            const factor = -envelope(undampedFreq) + $b1fa26b3c95498fa$var$safeMin > 0 ? -1 : 1;
            return factor * ((d - e) * f) / g;
        };
    } else {
        envelope = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (undampedFreq - velocity) * duration + 1;
            return -$b1fa26b3c95498fa$var$safeMin + a * b;
        };
        derivative = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (velocity - undampedFreq) * (duration * duration);
            return a * b;
        };
    }
    const initialGuess = 5 / duration;
    const undampedFreq = $b1fa26b3c95498fa$var$approximateRoot(envelope, derivative, initialGuess);
    duration = duration * 1000;
    if (isNaN(undampedFreq)) return {
        stiffness: 100,
        damping: 10,
        duration: duration
    };
    else {
        const stiffness = Math.pow(undampedFreq, 2) * mass;
        return {
            stiffness: stiffness,
            damping: dampingRatio * 2 * Math.sqrt(mass * stiffness),
            duration: duration
        };
    }
}
const $b1fa26b3c95498fa$var$rootIterations = 12;
function $b1fa26b3c95498fa$var$approximateRoot(envelope, derivative, initialGuess) {
    let result = initialGuess;
    for(let i = 1; i < $b1fa26b3c95498fa$var$rootIterations; i++)result = result - envelope(result) / derivative(result);
    return result;
}
function $b1fa26b3c95498fa$export$5f679887c3a78b15(undampedFreq, dampingRatio) {
    return undampedFreq * Math.sqrt(1 - dampingRatio * dampingRatio);
}

});
parcelRegister("ezcIX", function(module, exports) {

$parcel$export(module.exports, "clamp", () => $8fe3552f3a53f5df$export$7d15b64cf5a3a4c4);
const $8fe3552f3a53f5df$export$7d15b64cf5a3a4c4 = (min, max, v)=>Math.min(Math.max(v, min), max);

});



parcelRegister("1Wo4Q", function(module, exports) {

$parcel$export(module.exports, "keyframes", () => $f140e7c3230b24ec$export$d25ddfdf17c3ad3e);

var $cXE0o = parcelRequire("cXE0o");

var $bsiRs = parcelRequire("bsiRs");
function $f140e7c3230b24ec$export$6b60b58e4ea7d715(values, easing) {
    return values.map(()=>easing || (0, $bsiRs.easeInOut)).splice(0, values.length - 1);
}
function $f140e7c3230b24ec$export$24dbcec0b26e6d9d(values) {
    const numValues = values.length;
    return values.map((_value, i)=>i !== 0 ? i / (numValues - 1) : 0);
}
function $f140e7c3230b24ec$export$2a91b4e3a4539316(offset, duration) {
    return offset.map((o)=>o * duration);
}
function $f140e7c3230b24ec$export$d25ddfdf17c3ad3e({ from: from = 0, to: to = 1, ease: ease, offset: offset, duration: duration = 300 }) {
    const state = {
        done: false,
        value: from
    };
    const values = Array.isArray(to) ? to : [
        from,
        to
    ];
    const times = $f140e7c3230b24ec$export$2a91b4e3a4539316(offset && offset.length === values.length ? offset : $f140e7c3230b24ec$export$24dbcec0b26e6d9d(values), duration);
    function createInterpolator() {
        return (0, $cXE0o.interpolate)(times, values, {
            ease: Array.isArray(ease) ? ease : $f140e7c3230b24ec$export$6b60b58e4ea7d715(values, ease)
        });
    }
    let interpolator = createInterpolator();
    return {
        next: (t)=>{
            state.value = interpolator(t);
            state.done = t >= duration;
            return state;
        },
        flipTarget: ()=>{
            values.reverse();
            interpolator = createInterpolator();
        }
    };
}

});
parcelRegister("cXE0o", function(module, exports) {

$parcel$export(module.exports, "interpolate", () => $be73afde9516fed0$export$89e29e4ab65e70a9);

var $j248P = parcelRequire("j248P");

var $bqVjQ = parcelRequire("bqVjQ");

var $epqQR = parcelRequire("epqQR");

var $dZykM = parcelRequire("dZykM");

var $fKUMu = parcelRequire("fKUMu");

var $ezcIX = parcelRequire("ezcIX");

var $iBhIU = parcelRequire("iBhIU");

var $6QSfE = parcelRequire("6QSfE");
const $be73afde9516fed0$var$mixNumber = (from, to)=>(p)=>(0, $bqVjQ.mix)(from, to, p);
function $be73afde9516fed0$var$detectMixerFactory(v) {
    if (typeof v === "number") return $be73afde9516fed0$var$mixNumber;
    else if (typeof v === "string") {
        if ((0, $fKUMu.color).test(v)) return 0, $epqQR.mixColor;
        else return 0, $dZykM.mixComplex;
    } else if (Array.isArray(v)) return 0, $dZykM.mixArray;
    else if (typeof v === "object") return 0, $dZykM.mixObject;
}
function $be73afde9516fed0$var$createMixers(output, ease, customMixer) {
    const mixers = [];
    const mixerFactory = customMixer || $be73afde9516fed0$var$detectMixerFactory(output[0]);
    const numMixers = output.length - 1;
    for(let i = 0; i < numMixers; i++){
        let mixer = mixerFactory(output[i], output[i + 1]);
        if (ease) {
            const easingFunction = Array.isArray(ease) ? ease[i] : ease;
            mixer = (0, $iBhIU.pipe)(easingFunction, mixer);
        }
        mixers.push(mixer);
    }
    return mixers;
}
function $be73afde9516fed0$var$fastInterpolate([from, to], [mixer]) {
    return (v)=>mixer((0, $j248P.progress)(from, to, v));
}
function $be73afde9516fed0$var$slowInterpolate(input, mixers) {
    const inputLength = input.length;
    const lastInputIndex = inputLength - 1;
    return (v)=>{
        let mixerIndex = 0;
        let foundMixerIndex = false;
        if (v <= input[0]) foundMixerIndex = true;
        else if (v >= input[lastInputIndex]) {
            mixerIndex = lastInputIndex - 1;
            foundMixerIndex = true;
        }
        if (!foundMixerIndex) {
            let i = 1;
            for(; i < inputLength; i++){
                if (input[i] > v || i === lastInputIndex) break;
            }
            mixerIndex = i - 1;
        }
        const progressInRange = (0, $j248P.progress)(input[mixerIndex], input[mixerIndex + 1], v);
        return mixers[mixerIndex](progressInRange);
    };
}
function $be73afde9516fed0$export$89e29e4ab65e70a9(input, output, { clamp: isClamp = true, ease: ease, mixer: mixer } = {}) {
    const inputLength = input.length;
    (0, $6QSfE.invariant)(inputLength === output.length, "Both input and output ranges must be the same length");
    (0, $6QSfE.invariant)(!ease || !Array.isArray(ease) || ease.length === inputLength - 1, "Array of easing functions must be of length `input.length - 1`, as it applies to the transitions **between** the defined values.");
    if (input[0] > input[inputLength - 1]) {
        input = [].concat(input);
        output = [].concat(output);
        input.reverse();
        output.reverse();
    }
    const mixers = $be73afde9516fed0$var$createMixers(output, ease, mixer);
    const interpolator = inputLength === 2 ? $be73afde9516fed0$var$fastInterpolate(input, mixers) : $be73afde9516fed0$var$slowInterpolate(input, mixers);
    return isClamp ? (v)=>interpolator((0, $ezcIX.clamp)(input[0], input[inputLength - 1], v)) : interpolator;
}

});
parcelRegister("j248P", function(module, exports) {

$parcel$export(module.exports, "progress", () => $8719e706e42e5d1d$export$504d7abb21fa8c9);
const $8719e706e42e5d1d$export$504d7abb21fa8c9 = (from, to, value)=>{
    const toFromDifference = to - from;
    return toFromDifference === 0 ? 1 : (value - from) / toFromDifference;
};

});

parcelRegister("bqVjQ", function(module, exports) {

$parcel$export(module.exports, "mix", () => $9e031a435715a19b$export$2c9e8a9632a706b2);
const $9e031a435715a19b$export$2c9e8a9632a706b2 = (from, to, progress)=>-progress * from + progress * to + from;

});

parcelRegister("epqQR", function(module, exports) {

$parcel$export(module.exports, "mixColor", () => $fdafb3318c3fe2b0$export$51e568cf5c039bac);

var $bqVjQ = parcelRequire("bqVjQ");

var $25y9Z = parcelRequire("25y9Z");
var $kAUPl = parcelRequire("kAUPl");
var $1opZP = parcelRequire("1opZP");

var $6QSfE = parcelRequire("6QSfE");

var $gveyP = parcelRequire("gveyP");
const $fdafb3318c3fe2b0$export$d4ecea248cce73c = (from, to, v)=>{
    const fromExpo = from * from;
    const toExpo = to * to;
    return Math.sqrt(Math.max(0, v * (toExpo - fromExpo) + fromExpo));
};
const $fdafb3318c3fe2b0$var$colorTypes = [
    (0, $25y9Z.hex),
    (0, $1opZP.rgba),
    (0, $kAUPl.hsla)
];
const $fdafb3318c3fe2b0$var$getColorType = (v)=>$fdafb3318c3fe2b0$var$colorTypes.find((type)=>type.test(v));
const $fdafb3318c3fe2b0$var$notAnimatable = (color)=>`'${color}' is not an animatable color. Use the equivalent color code instead.`;
const $fdafb3318c3fe2b0$export$51e568cf5c039bac = (from, to)=>{
    let fromColorType = $fdafb3318c3fe2b0$var$getColorType(from);
    let toColorType = $fdafb3318c3fe2b0$var$getColorType(to);
    (0, $6QSfE.invariant)(!!fromColorType, $fdafb3318c3fe2b0$var$notAnimatable(from));
    (0, $6QSfE.invariant)(!!toColorType, $fdafb3318c3fe2b0$var$notAnimatable(to));
    let fromColor = fromColorType.parse(from);
    let toColor = toColorType.parse(to);
    if (fromColorType === (0, $kAUPl.hsla)) {
        fromColor = (0, $gveyP.hslaToRgba)(fromColor);
        fromColorType = (0, $1opZP.rgba);
    }
    if (toColorType === (0, $kAUPl.hsla)) {
        toColor = (0, $gveyP.hslaToRgba)(toColor);
        toColorType = (0, $1opZP.rgba);
    }
    const blended = Object.assign({}, fromColor);
    return (v)=>{
        for(const key in blended)if (key !== "alpha") blended[key] = $fdafb3318c3fe2b0$export$d4ecea248cce73c(fromColor[key], toColor[key], v);
        blended.alpha = (0, $bqVjQ.mix)(fromColor.alpha, toColor.alpha, v);
        return fromColorType.transform(blended);
    };
};

});
parcelRegister("25y9Z", function(module, exports) {

$parcel$export(module.exports, "hex", () => $6ec2859d7d1d6efc$export$834dfc94dde4b3d8);

var $1opZP = parcelRequire("1opZP");

var $GRVO8 = parcelRequire("GRVO8");
function $6ec2859d7d1d6efc$var$parseHex(v) {
    let r = "";
    let g = "";
    let b = "";
    let a = "";
    if (v.length > 5) {
        r = v.substr(1, 2);
        g = v.substr(3, 2);
        b = v.substr(5, 2);
        a = v.substr(7, 2);
    } else {
        r = v.substr(1, 1);
        g = v.substr(2, 1);
        b = v.substr(3, 1);
        a = v.substr(4, 1);
        r += r;
        g += g;
        b += b;
        a += a;
    }
    return {
        red: parseInt(r, 16),
        green: parseInt(g, 16),
        blue: parseInt(b, 16),
        alpha: a ? parseInt(a, 16) / 255 : 1
    };
}
const $6ec2859d7d1d6efc$export$834dfc94dde4b3d8 = {
    test: (0, $GRVO8.isColorString)("#"),
    parse: $6ec2859d7d1d6efc$var$parseHex,
    transform: (0, $1opZP.rgba).transform
};

});
parcelRegister("1opZP", function(module, exports) {

$parcel$export(module.exports, "rgba", () => $4c712cf83c0d6669$export$4e46ac54fc82cf3b);

var $g4T9J = parcelRequire("g4T9J");

var $5sH7B = parcelRequire("5sH7B");

var $GRVO8 = parcelRequire("GRVO8");
const $4c712cf83c0d6669$var$clampRgbUnit = (0, $5sH7B.clamp)(0, 255);
const $4c712cf83c0d6669$export$7a99c86b5b1f4c9e = Object.assign(Object.assign({}, (0, $g4T9J.number)), {
    transform: (v)=>Math.round($4c712cf83c0d6669$var$clampRgbUnit(v))
});
const $4c712cf83c0d6669$export$4e46ac54fc82cf3b = {
    test: (0, $GRVO8.isColorString)("rgb", "red"),
    parse: (0, $GRVO8.splitColor)("red", "green", "blue"),
    transform: ({ red: red, green: green, blue: blue, alpha: alpha$1 = 1 })=>"rgba(" + $4c712cf83c0d6669$export$7a99c86b5b1f4c9e.transform(red) + ", " + $4c712cf83c0d6669$export$7a99c86b5b1f4c9e.transform(green) + ", " + $4c712cf83c0d6669$export$7a99c86b5b1f4c9e.transform(blue) + ", " + (0, $5sH7B.sanitize)((0, $g4T9J.alpha).transform(alpha$1)) + ")"
};

});
parcelRegister("GRVO8", function(module, exports) {

$parcel$export(module.exports, "isColorString", () => $e52c9920d7616a04$export$2c8400d58aca05e);
$parcel$export(module.exports, "splitColor", () => $e52c9920d7616a04$export$73d6f35be992df24);

var $5sH7B = parcelRequire("5sH7B");
const $e52c9920d7616a04$export$2c8400d58aca05e = (type, testProp)=>(v)=>{
        return Boolean((0, $5sH7B.isString)(v) && (0, $5sH7B.singleColorRegex).test(v) && v.startsWith(type) || testProp && Object.prototype.hasOwnProperty.call(v, testProp));
    };
const $e52c9920d7616a04$export$73d6f35be992df24 = (aName, bName, cName)=>(v)=>{
        if (!(0, $5sH7B.isString)(v)) return v;
        const [a, b, c, alpha] = v.match((0, $5sH7B.floatRegex));
        return {
            [aName]: parseFloat(a),
            [bName]: parseFloat(b),
            [cName]: parseFloat(c),
            alpha: alpha !== undefined ? parseFloat(alpha) : 1
        };
    };

});



parcelRegister("kAUPl", function(module, exports) {

$parcel$export(module.exports, "hsla", () => $5c4e1dc606ae22d6$export$810b04175080204c);

var $g4T9J = parcelRequire("g4T9J");

var $1fCxR = parcelRequire("1fCxR");

var $5sH7B = parcelRequire("5sH7B");

var $GRVO8 = parcelRequire("GRVO8");
const $5c4e1dc606ae22d6$export$810b04175080204c = {
    test: (0, $GRVO8.isColorString)("hsl", "hue"),
    parse: (0, $GRVO8.splitColor)("hue", "saturation", "lightness"),
    transform: ({ hue: hue, saturation: saturation, lightness: lightness, alpha: alpha$1 = 1 })=>{
        return "hsla(" + Math.round(hue) + ", " + (0, $1fCxR.percent).transform((0, $5sH7B.sanitize)(saturation)) + ", " + (0, $1fCxR.percent).transform((0, $5sH7B.sanitize)(lightness)) + ", " + (0, $5sH7B.sanitize)((0, $g4T9J.alpha).transform(alpha$1)) + ")";
    }
};

});

parcelRegister("gveyP", function(module, exports) {

$parcel$export(module.exports, "hslaToRgba", () => $dffcb3dff20862a2$export$6ae64dbcd6bfc33e);
function $dffcb3dff20862a2$var$hueToRgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function $dffcb3dff20862a2$export$6ae64dbcd6bfc33e({ hue: hue, saturation: saturation, lightness: lightness, alpha: alpha }) {
    hue /= 360;
    saturation /= 100;
    lightness /= 100;
    let red = 0;
    let green = 0;
    let blue = 0;
    if (!saturation) red = green = blue = lightness;
    else {
        const q = lightness < 0.5 ? lightness * (1 + saturation) : lightness + saturation - lightness * saturation;
        const p = 2 * lightness - q;
        red = $dffcb3dff20862a2$var$hueToRgb(p, q, hue + 1 / 3);
        green = $dffcb3dff20862a2$var$hueToRgb(p, q, hue);
        blue = $dffcb3dff20862a2$var$hueToRgb(p, q, hue - 1 / 3);
    }
    return {
        red: Math.round(red * 255),
        green: Math.round(green * 255),
        blue: Math.round(blue * 255),
        alpha: alpha
    };
}

});


parcelRegister("dZykM", function(module, exports) {

$parcel$export(module.exports, "mixComplex", () => $096fbb201a57836c$export$65516310a87d8205);
$parcel$export(module.exports, "mixArray", () => $096fbb201a57836c$export$3bbefa2f402845c4);
$parcel$export(module.exports, "mixObject", () => $096fbb201a57836c$export$ebc23b6840c51ba1);

var $fKUMu = parcelRequire("fKUMu");
var $DYJG5 = parcelRequire("DYJG5");

var $bqVjQ = parcelRequire("bqVjQ");

var $epqQR = parcelRequire("epqQR");

var $78s4y = parcelRequire("78s4y");

var $iBhIU = parcelRequire("iBhIU");

var $6QSfE = parcelRequire("6QSfE");
function $096fbb201a57836c$var$getMixer(origin, target) {
    if ((0, $78s4y.isNum)(origin)) return (v)=>(0, $bqVjQ.mix)(origin, target, v);
    else if ((0, $fKUMu.color).test(origin)) return (0, $epqQR.mixColor)(origin, target);
    else return $096fbb201a57836c$export$65516310a87d8205(origin, target);
}
const $096fbb201a57836c$export$3bbefa2f402845c4 = (from, to)=>{
    const output = [
        ...from
    ];
    const numValues = output.length;
    const blendValue = from.map((fromThis, i)=>$096fbb201a57836c$var$getMixer(fromThis, to[i]));
    return (v)=>{
        for(let i = 0; i < numValues; i++)output[i] = blendValue[i](v);
        return output;
    };
};
const $096fbb201a57836c$export$ebc23b6840c51ba1 = (origin, target)=>{
    const output = Object.assign(Object.assign({}, origin), target);
    const blendValue = {};
    for(const key in output)if (origin[key] !== undefined && target[key] !== undefined) blendValue[key] = $096fbb201a57836c$var$getMixer(origin[key], target[key]);
    return (v)=>{
        for(const key in blendValue)output[key] = blendValue[key](v);
        return output;
    };
};
function $096fbb201a57836c$var$analyse(value) {
    const parsed = (0, $DYJG5.complex).parse(value);
    const numValues = parsed.length;
    let numNumbers = 0;
    let numRGB = 0;
    let numHSL = 0;
    for(let i = 0; i < numValues; i++){
        if (numNumbers || typeof parsed[i] === "number") numNumbers++;
        else if (parsed[i].hue !== undefined) numHSL++;
        else numRGB++;
    }
    return {
        parsed: parsed,
        numNumbers: numNumbers,
        numRGB: numRGB,
        numHSL: numHSL
    };
}
const $096fbb201a57836c$export$65516310a87d8205 = (origin, target)=>{
    const template = (0, $DYJG5.complex).createTransformer(target);
    const originStats = $096fbb201a57836c$var$analyse(origin);
    const targetStats = $096fbb201a57836c$var$analyse(target);
    const canInterpolate = originStats.numHSL === targetStats.numHSL && originStats.numRGB === targetStats.numRGB && originStats.numNumbers >= targetStats.numNumbers;
    if (canInterpolate) return (0, $iBhIU.pipe)($096fbb201a57836c$export$3bbefa2f402845c4(originStats.parsed, targetStats.parsed), template);
    else {
        (0, $6QSfE.warning)(true, `Complex values '${origin}' and '${target}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`);
        return (p)=>`${p > 0 ? target : origin}`;
    }
};

});
parcelRegister("fKUMu", function(module, exports) {

$parcel$export(module.exports, "color", () => $fcbc8d85f0f592e3$export$35e9368ef982300f);

var $5sH7B = parcelRequire("5sH7B");

var $25y9Z = parcelRequire("25y9Z");

var $kAUPl = parcelRequire("kAUPl");

var $1opZP = parcelRequire("1opZP");
const $fcbc8d85f0f592e3$export$35e9368ef982300f = {
    test: (v)=>(0, $1opZP.rgba).test(v) || (0, $25y9Z.hex).test(v) || (0, $kAUPl.hsla).test(v),
    parse: (v)=>{
        if ((0, $1opZP.rgba).test(v)) return (0, $1opZP.rgba).parse(v);
        else if ((0, $kAUPl.hsla).test(v)) return (0, $kAUPl.hsla).parse(v);
        else return (0, $25y9Z.hex).parse(v);
    },
    transform: (v)=>{
        return (0, $5sH7B.isString)(v) ? v : v.hasOwnProperty("red") ? (0, $1opZP.rgba).transform(v) : (0, $kAUPl.hsla).transform(v);
    }
};

});

parcelRegister("DYJG5", function(module, exports) {

$parcel$export(module.exports, "complex", () => $fe3e8d578aa8b27f$export$83a0e34f1302825b);

var $fKUMu = parcelRequire("fKUMu");

var $g4T9J = parcelRequire("g4T9J");

var $5sH7B = parcelRequire("5sH7B");
const $fe3e8d578aa8b27f$var$colorToken = "${c}";
const $fe3e8d578aa8b27f$var$numberToken = "${n}";
function $fe3e8d578aa8b27f$var$test(v) {
    var _a, _b, _c, _d;
    return isNaN(v) && (0, $5sH7B.isString)(v) && ((_b = (_a = v.match((0, $5sH7B.floatRegex))) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) + ((_d = (_c = v.match((0, $5sH7B.colorRegex))) === null || _c === void 0 ? void 0 : _c.length) !== null && _d !== void 0 ? _d : 0) > 0;
}
function $fe3e8d578aa8b27f$var$analyse(v) {
    if (typeof v === "number") v = `${v}`;
    const values = [];
    let numColors = 0;
    const colors = v.match((0, $5sH7B.colorRegex));
    if (colors) {
        numColors = colors.length;
        v = v.replace((0, $5sH7B.colorRegex), $fe3e8d578aa8b27f$var$colorToken);
        values.push(...colors.map((0, $fKUMu.color).parse));
    }
    const numbers = v.match((0, $5sH7B.floatRegex));
    if (numbers) {
        v = v.replace((0, $5sH7B.floatRegex), $fe3e8d578aa8b27f$var$numberToken);
        values.push(...numbers.map((0, $g4T9J.number).parse));
    }
    return {
        values: values,
        numColors: numColors,
        tokenised: v
    };
}
function $fe3e8d578aa8b27f$var$parse(v) {
    return $fe3e8d578aa8b27f$var$analyse(v).values;
}
function $fe3e8d578aa8b27f$var$createTransformer(v) {
    const { values: values, numColors: numColors, tokenised: tokenised } = $fe3e8d578aa8b27f$var$analyse(v);
    const numValues = values.length;
    return (v)=>{
        let output = tokenised;
        for(let i = 0; i < numValues; i++)output = output.replace(i < numColors ? $fe3e8d578aa8b27f$var$colorToken : $fe3e8d578aa8b27f$var$numberToken, i < numColors ? (0, $fKUMu.color).transform(v[i]) : (0, $5sH7B.sanitize)(v[i]));
        return output;
    };
}
const $fe3e8d578aa8b27f$var$convertNumbersToZero = (v)=>typeof v === "number" ? 0 : v;
function $fe3e8d578aa8b27f$var$getAnimatableNone(v) {
    const parsed = $fe3e8d578aa8b27f$var$parse(v);
    const transformer = $fe3e8d578aa8b27f$var$createTransformer(v);
    return transformer(parsed.map($fe3e8d578aa8b27f$var$convertNumbersToZero));
}
const $fe3e8d578aa8b27f$export$83a0e34f1302825b = {
    test: $fe3e8d578aa8b27f$var$test,
    parse: $fe3e8d578aa8b27f$var$parse,
    createTransformer: $fe3e8d578aa8b27f$var$createTransformer,
    getAnimatableNone: $fe3e8d578aa8b27f$var$getAnimatableNone
};

});

parcelRegister("78s4y", function(module, exports) {

$parcel$export(module.exports, "isNum", () => $a75d904cf9cd8fdb$export$4e960b977ccfec97);
const $a75d904cf9cd8fdb$export$c0c148ccc4f34a76 = {
    x: 0,
    y: 0,
    z: 0
};
const $a75d904cf9cd8fdb$export$4e960b977ccfec97 = (v)=>typeof v === "number";

});



parcelRegister("bsiRs", function(module, exports) {

$parcel$export(module.exports, "linear", () => $d43a9d278bbed66c$export$45db2fc2f15997e7);
$parcel$export(module.exports, "easeIn", () => $d43a9d278bbed66c$export$929e5a82286172a6);
$parcel$export(module.exports, "easeOut", () => $d43a9d278bbed66c$export$57636bb43b1ccbb0);
$parcel$export(module.exports, "easeInOut", () => $d43a9d278bbed66c$export$c07234257a03d5e9);
$parcel$export(module.exports, "circIn", () => $d43a9d278bbed66c$export$e444123e42d03385);
$parcel$export(module.exports, "circOut", () => $d43a9d278bbed66c$export$c8d67a19199d1a50);
$parcel$export(module.exports, "circInOut", () => $d43a9d278bbed66c$export$30d3455eee55bed5);
$parcel$export(module.exports, "backIn", () => $d43a9d278bbed66c$export$b01116c84cdfe1a2);
$parcel$export(module.exports, "backOut", () => $d43a9d278bbed66c$export$77edfce482316a60);
$parcel$export(module.exports, "backInOut", () => $d43a9d278bbed66c$export$ddc5fd596f6c71b2);
$parcel$export(module.exports, "anticipate", () => $d43a9d278bbed66c$export$6b0af63b873d419e);
$parcel$export(module.exports, "bounceOut", () => $d43a9d278bbed66c$export$cccc9e04465dce11);
$parcel$export(module.exports, "bounceIn", () => $d43a9d278bbed66c$export$fccebd7948554554);
$parcel$export(module.exports, "bounceInOut", () => $d43a9d278bbed66c$export$41ad9e9849a703ce);

var $hwzny = parcelRequire("hwzny");
const $d43a9d278bbed66c$var$DEFAULT_OVERSHOOT_STRENGTH = 1.525;
const $d43a9d278bbed66c$var$BOUNCE_FIRST_THRESHOLD = 4.0 / 11.0;
const $d43a9d278bbed66c$var$BOUNCE_SECOND_THRESHOLD = 8.0 / 11.0;
const $d43a9d278bbed66c$var$BOUNCE_THIRD_THRESHOLD = 0.9;
const $d43a9d278bbed66c$export$45db2fc2f15997e7 = (p)=>p;
const $d43a9d278bbed66c$export$929e5a82286172a6 = (0, $hwzny.createExpoIn)(2);
const $d43a9d278bbed66c$export$57636bb43b1ccbb0 = (0, $hwzny.reverseEasing)($d43a9d278bbed66c$export$929e5a82286172a6);
const $d43a9d278bbed66c$export$c07234257a03d5e9 = (0, $hwzny.mirrorEasing)($d43a9d278bbed66c$export$929e5a82286172a6);
const $d43a9d278bbed66c$export$e444123e42d03385 = (p)=>1 - Math.sin(Math.acos(p));
const $d43a9d278bbed66c$export$c8d67a19199d1a50 = (0, $hwzny.reverseEasing)($d43a9d278bbed66c$export$e444123e42d03385);
const $d43a9d278bbed66c$export$30d3455eee55bed5 = (0, $hwzny.mirrorEasing)($d43a9d278bbed66c$export$c8d67a19199d1a50);
const $d43a9d278bbed66c$export$b01116c84cdfe1a2 = (0, $hwzny.createBackIn)($d43a9d278bbed66c$var$DEFAULT_OVERSHOOT_STRENGTH);
const $d43a9d278bbed66c$export$77edfce482316a60 = (0, $hwzny.reverseEasing)($d43a9d278bbed66c$export$b01116c84cdfe1a2);
const $d43a9d278bbed66c$export$ddc5fd596f6c71b2 = (0, $hwzny.mirrorEasing)($d43a9d278bbed66c$export$b01116c84cdfe1a2);
const $d43a9d278bbed66c$export$6b0af63b873d419e = (0, $hwzny.createAnticipate)($d43a9d278bbed66c$var$DEFAULT_OVERSHOOT_STRENGTH);
const $d43a9d278bbed66c$var$ca = 4356.0 / 361.0;
const $d43a9d278bbed66c$var$cb = 35442.0 / 1805.0;
const $d43a9d278bbed66c$var$cc = 16061.0 / 1805.0;
const $d43a9d278bbed66c$export$cccc9e04465dce11 = (p)=>{
    if (p === 1 || p === 0) return p;
    const p2 = p * p;
    return p < $d43a9d278bbed66c$var$BOUNCE_FIRST_THRESHOLD ? 7.5625 * p2 : p < $d43a9d278bbed66c$var$BOUNCE_SECOND_THRESHOLD ? 9.075 * p2 - 9.9 * p + 3.4 : p < $d43a9d278bbed66c$var$BOUNCE_THIRD_THRESHOLD ? $d43a9d278bbed66c$var$ca * p2 - $d43a9d278bbed66c$var$cb * p + $d43a9d278bbed66c$var$cc : 10.8 * p * p - 20.52 * p + 10.72;
};
const $d43a9d278bbed66c$export$fccebd7948554554 = (0, $hwzny.reverseEasing)($d43a9d278bbed66c$export$cccc9e04465dce11);
const $d43a9d278bbed66c$export$41ad9e9849a703ce = (p)=>p < 0.5 ? 0.5 * (1.0 - $d43a9d278bbed66c$export$cccc9e04465dce11(1.0 - p * 2.0)) : 0.5 * $d43a9d278bbed66c$export$cccc9e04465dce11(p * 2.0 - 1.0) + 0.5;

});
parcelRegister("hwzny", function(module, exports) {

$parcel$export(module.exports, "reverseEasing", () => $2b1e2a499c7bcc27$export$2c07eeff45156d4d);
$parcel$export(module.exports, "mirrorEasing", () => $2b1e2a499c7bcc27$export$f946554fb8aeaf0d);
$parcel$export(module.exports, "createExpoIn", () => $2b1e2a499c7bcc27$export$c90c8c5a3c7a5e80);
$parcel$export(module.exports, "createBackIn", () => $2b1e2a499c7bcc27$export$2a739ba6da1d1495);
$parcel$export(module.exports, "createAnticipate", () => $2b1e2a499c7bcc27$export$222fa0be41d8b537);
const $2b1e2a499c7bcc27$export$2c07eeff45156d4d = (easing)=>(p)=>1 - easing(1 - p);
const $2b1e2a499c7bcc27$export$f946554fb8aeaf0d = (easing)=>(p)=>p <= 0.5 ? easing(2 * p) / 2 : (2 - easing(2 * (1 - p))) / 2;
const $2b1e2a499c7bcc27$export$c90c8c5a3c7a5e80 = (power)=>(p)=>Math.pow(p, power);
const $2b1e2a499c7bcc27$export$2a739ba6da1d1495 = (power)=>(p)=>p * p * ((power + 1) * p - power);
const $2b1e2a499c7bcc27$export$222fa0be41d8b537 = (power)=>{
    const backEasing = $2b1e2a499c7bcc27$export$2a739ba6da1d1495(power);
    return (p)=>(p *= 2) < 1 ? 0.5 * backEasing(p) : 0.5 * (2 - Math.pow(2, -10 * (p - 1)));
};

});



parcelRegister("2plaU", function(module, exports) {

$parcel$export(module.exports, "decay", () => $eafa347091683871$export$e9341ba102272ab9);
function $eafa347091683871$export$e9341ba102272ab9({ velocity: velocity = 0, from: from = 0, power: power = 0.8, timeConstant: timeConstant = 350, restDelta: restDelta = 0.5, modifyTarget: modifyTarget }) {
    const state = {
        done: false,
        value: from
    };
    let amplitude = power * velocity;
    const ideal = from + amplitude;
    const target = modifyTarget === undefined ? ideal : modifyTarget(ideal);
    if (target !== ideal) amplitude = target - from;
    return {
        next: (t)=>{
            const delta = -amplitude * Math.exp(-t / timeConstant);
            state.done = !(delta > restDelta || delta < -restDelta);
            state.value = state.done ? target : target + delta;
            return state;
        },
        flipTarget: ()=>{}
    };
}

});


parcelRegister("9ksIr", function(module, exports) {

$parcel$export(module.exports, "cancelSync", () => $741aad569b766a4c$export$d93e9c1fe0553512);
$parcel$export(module.exports, "flushSync", () => $741aad569b766a4c$export$cd75ccfd720a3cd4);
$parcel$export(module.exports, "getFrameData", () => $741aad569b766a4c$export$7244445918e670ed);
$parcel$export(module.exports, "default", () => $741aad569b766a4c$export$2e2bcd8739ae039);

var $l7ogK = parcelRequire("l7ogK");

var $fvRoK = parcelRequire("fvRoK");
const $741aad569b766a4c$var$maxElapsed = 40;
let $741aad569b766a4c$var$useDefaultElapsed = true;
let $741aad569b766a4c$var$runNextFrame = false;
let $741aad569b766a4c$var$isProcessing = false;
const $741aad569b766a4c$var$frame = {
    delta: 0,
    timestamp: 0
};
const $741aad569b766a4c$var$stepsOrder = [
    "read",
    "update",
    "preRender",
    "render",
    "postRender"
];
const $741aad569b766a4c$var$steps = $741aad569b766a4c$var$stepsOrder.reduce((acc, key)=>{
    acc[key] = (0, $fvRoK.createRenderStep)(()=>$741aad569b766a4c$var$runNextFrame = true);
    return acc;
}, {});
const $741aad569b766a4c$var$sync = $741aad569b766a4c$var$stepsOrder.reduce((acc, key)=>{
    const step = $741aad569b766a4c$var$steps[key];
    acc[key] = (process, keepAlive = false, immediate = false)=>{
        if (!$741aad569b766a4c$var$runNextFrame) $741aad569b766a4c$var$startLoop();
        return step.schedule(process, keepAlive, immediate);
    };
    return acc;
}, {});
const $741aad569b766a4c$export$d93e9c1fe0553512 = $741aad569b766a4c$var$stepsOrder.reduce((acc, key)=>{
    acc[key] = $741aad569b766a4c$var$steps[key].cancel;
    return acc;
}, {});
const $741aad569b766a4c$export$cd75ccfd720a3cd4 = $741aad569b766a4c$var$stepsOrder.reduce((acc, key)=>{
    acc[key] = ()=>$741aad569b766a4c$var$steps[key].process($741aad569b766a4c$var$frame);
    return acc;
}, {});
const $741aad569b766a4c$var$processStep = (stepId)=>$741aad569b766a4c$var$steps[stepId].process($741aad569b766a4c$var$frame);
const $741aad569b766a4c$var$processFrame = (timestamp)=>{
    $741aad569b766a4c$var$runNextFrame = false;
    $741aad569b766a4c$var$frame.delta = $741aad569b766a4c$var$useDefaultElapsed ? (0, $l7ogK.defaultTimestep) : Math.max(Math.min(timestamp - $741aad569b766a4c$var$frame.timestamp, $741aad569b766a4c$var$maxElapsed), 1);
    $741aad569b766a4c$var$frame.timestamp = timestamp;
    $741aad569b766a4c$var$isProcessing = true;
    $741aad569b766a4c$var$stepsOrder.forEach($741aad569b766a4c$var$processStep);
    $741aad569b766a4c$var$isProcessing = false;
    if ($741aad569b766a4c$var$runNextFrame) {
        $741aad569b766a4c$var$useDefaultElapsed = false;
        (0, $l7ogK.onNextFrame)($741aad569b766a4c$var$processFrame);
    }
};
const $741aad569b766a4c$var$startLoop = ()=>{
    $741aad569b766a4c$var$runNextFrame = true;
    $741aad569b766a4c$var$useDefaultElapsed = true;
    if (!$741aad569b766a4c$var$isProcessing) (0, $l7ogK.onNextFrame)($741aad569b766a4c$var$processFrame);
};
const $741aad569b766a4c$export$7244445918e670ed = ()=>$741aad569b766a4c$var$frame;
var $741aad569b766a4c$export$2e2bcd8739ae039 = $741aad569b766a4c$var$sync;

});
parcelRegister("l7ogK", function(module, exports) {

$parcel$export(module.exports, "defaultTimestep", () => $1c49e3de0f86bd12$export$f8caf8121275292d);
$parcel$export(module.exports, "onNextFrame", () => $1c49e3de0f86bd12$export$4fdea63ab5513fd5);
const $1c49e3de0f86bd12$export$f8caf8121275292d = 1 / 60 * 1000;
const $1c49e3de0f86bd12$var$getCurrentTime = typeof performance !== "undefined" ? ()=>performance.now() : ()=>Date.now();
const $1c49e3de0f86bd12$export$4fdea63ab5513fd5 = typeof window !== "undefined" ? (callback)=>window.requestAnimationFrame(callback) : (callback)=>setTimeout(()=>callback($1c49e3de0f86bd12$var$getCurrentTime()), $1c49e3de0f86bd12$export$f8caf8121275292d);

});

parcelRegister("fvRoK", function(module, exports) {

$parcel$export(module.exports, "createRenderStep", () => $56b75657d7530209$export$b995e5e85f5c8289);
function $56b75657d7530209$export$b995e5e85f5c8289(runNextFrame) {
    let toRun = [];
    let toRunNextFrame = [];
    let numToRun = 0;
    let isProcessing = false;
    let flushNextFrame = false;
    const toKeepAlive = new WeakSet();
    const step = {
        schedule: (callback, keepAlive = false, immediate = false)=>{
            const addToCurrentFrame = immediate && isProcessing;
            const buffer = addToCurrentFrame ? toRun : toRunNextFrame;
            if (keepAlive) toKeepAlive.add(callback);
            if (buffer.indexOf(callback) === -1) {
                buffer.push(callback);
                if (addToCurrentFrame && isProcessing) numToRun = toRun.length;
            }
            return callback;
        },
        cancel: (callback)=>{
            const index = toRunNextFrame.indexOf(callback);
            if (index !== -1) toRunNextFrame.splice(index, 1);
            toKeepAlive.delete(callback);
        },
        process: (frameData)=>{
            if (isProcessing) {
                flushNextFrame = true;
                return;
            }
            isProcessing = true;
            [toRun, toRunNextFrame] = [
                toRunNextFrame,
                toRun
            ];
            toRunNextFrame.length = 0;
            numToRun = toRun.length;
            if (numToRun) for(let i = 0; i < numToRun; i++){
                const callback = toRun[i];
                callback(frameData);
                if (toKeepAlive.has(callback)) {
                    step.schedule(callback);
                    runNextFrame();
                }
            }
            isProcessing = false;
            if (flushNextFrame) {
                flushNextFrame = false;
                step.process(frameData);
            }
        }
    };
    return step;
}

});


parcelRegister("4KuFA", function(module, exports) {

$parcel$export(module.exports, "loopElapsed", () => $230e5bd75deb454c$export$7d0784e050d8e25f);
$parcel$export(module.exports, "reverseElapsed", () => $230e5bd75deb454c$export$ab9042754680126b);
$parcel$export(module.exports, "hasRepeatDelayElapsed", () => $230e5bd75deb454c$export$c9c9437f9b8733b5);
function $230e5bd75deb454c$export$7d0784e050d8e25f(elapsed, duration, delay = 0) {
    return elapsed - duration - delay;
}
function $230e5bd75deb454c$export$ab9042754680126b(elapsed, duration, delay = 0, isForwardPlayback = true) {
    return isForwardPlayback ? $230e5bd75deb454c$export$7d0784e050d8e25f(duration + -elapsed, duration, delay) : duration - (elapsed - duration) + delay;
}
function $230e5bd75deb454c$export$c9c9437f9b8733b5(elapsed, duration, delay, isForwardPlayback) {
    return isForwardPlayback ? elapsed >= duration + delay : elapsed <= -delay;
}

});


parcelRegister("ihubQ", function(module, exports) {

$parcel$export(module.exports, "inertia", () => $f0c0f80569e2e087$export$ee3ff3a17106998);

var $lCAKk = parcelRequire("lCAKk");

var $1jVr4 = parcelRequire("1jVr4");

var $9ksIr = parcelRequire("9ksIr");
function $f0c0f80569e2e087$export$ee3ff3a17106998({ from: from = 0, velocity: velocity = 0, min: min, max: max, power: power = 0.8, timeConstant: timeConstant = 750, bounceStiffness: bounceStiffness = 500, bounceDamping: bounceDamping = 10, restDelta: restDelta = 1, modifyTarget: modifyTarget, driver: driver, onUpdate: onUpdate, onComplete: onComplete, onStop: onStop }) {
    let currentAnimation;
    function isOutOfBounds(v) {
        return min !== undefined && v < min || max !== undefined && v > max;
    }
    function boundaryNearest(v) {
        if (min === undefined) return max;
        if (max === undefined) return min;
        return Math.abs(min - v) < Math.abs(max - v) ? min : max;
    }
    function startAnimation(options) {
        currentAnimation === null || currentAnimation === void 0 || currentAnimation.stop();
        currentAnimation = (0, $lCAKk.animate)(Object.assign(Object.assign({}, options), {
            driver: driver,
            onUpdate: (v)=>{
                var _a;
                onUpdate === null || onUpdate === void 0 || onUpdate(v);
                (_a = options.onUpdate) === null || _a === void 0 || _a.call(options, v);
            },
            onComplete: onComplete,
            onStop: onStop
        }));
    }
    function startSpring(options) {
        startAnimation(Object.assign({
            type: "spring",
            stiffness: bounceStiffness,
            damping: bounceDamping,
            restDelta: restDelta
        }, options));
    }
    if (isOutOfBounds(from)) startSpring({
        from: from,
        velocity: velocity,
        to: boundaryNearest(from)
    });
    else {
        let target = power * velocity + from;
        if (typeof modifyTarget !== "undefined") target = modifyTarget(target);
        const boundary = boundaryNearest(target);
        const heading = boundary === min ? -1 : 1;
        let prev;
        let current;
        const checkBoundary = (v)=>{
            prev = current;
            current = v;
            velocity = (0, $1jVr4.velocityPerSecond)(v - prev, (0, $9ksIr.getFrameData)().delta);
            if (heading === 1 && v > boundary || heading === -1 && v < boundary) startSpring({
                from: v,
                to: boundary,
                velocity: velocity
            });
        };
        startAnimation({
            type: "decay",
            from: from,
            velocity: velocity,
            timeConstant: timeConstant,
            power: power,
            restDelta: restDelta,
            modifyTarget: modifyTarget,
            onUpdate: isOutOfBounds(target) ? checkBoundary : undefined
        });
    }
    return {
        stop: ()=>currentAnimation === null || currentAnimation === void 0 ? void 0 : currentAnimation.stop()
    };
}

});
parcelRegister("1jVr4", function(module, exports) {

$parcel$export(module.exports, "velocityPerSecond", () => $4e1c00700aa06d40$export$eab0632f7ad4f9d7);
function $4e1c00700aa06d40$export$eab0632f7ad4f9d7(velocity, frameDuration) {
    return frameDuration ? velocity * (1000 / frameDuration) : 0;
}

});


parcelRegister("iNwSi", function(module, exports) {

$parcel$export(module.exports, "secondsToMilliseconds", () => $083454c8244247d6$export$fc3e7e8557f8c8c7);
/**
 * Converts seconds to milliseconds
 *
 * @param seconds - Time in seconds.
 * @return milliseconds - Converted time in milliseconds.
 */ var $083454c8244247d6$export$fc3e7e8557f8c8c7 = function(seconds) {
    return seconds * 1000;
};

});

parcelRegister("335pm", function(module, exports) {

$parcel$export(module.exports, "easingDefinitionToFunction", () => $09ac0b286989a3ae$export$ef97fe084f156ca4);
$parcel$export(module.exports, "isEasingArray", () => $09ac0b286989a3ae$export$216948827bbdc797);

var $7WQrb = parcelRequire("7WQrb");

var $6QSfE = parcelRequire("6QSfE");

var $bsiRs = parcelRequire("bsiRs");
var $jpolx = parcelRequire("jpolx");
var $09ac0b286989a3ae$var$easingLookup = {
    linear: (0, $bsiRs.linear),
    easeIn: (0, $bsiRs.easeIn),
    easeInOut: (0, $bsiRs.easeInOut),
    easeOut: (0, $bsiRs.easeOut),
    circIn: (0, $bsiRs.circIn),
    circInOut: (0, $bsiRs.circInOut),
    circOut: (0, $bsiRs.circOut),
    backIn: (0, $bsiRs.backIn),
    backInOut: (0, $bsiRs.backInOut),
    backOut: (0, $bsiRs.backOut),
    anticipate: (0, $bsiRs.anticipate),
    bounceIn: (0, $bsiRs.bounceIn),
    bounceInOut: (0, $bsiRs.bounceInOut),
    bounceOut: (0, $bsiRs.bounceOut)
};
var $09ac0b286989a3ae$export$ef97fe084f156ca4 = function(definition) {
    if (Array.isArray(definition)) {
        // If cubic bezier definition, create bezier curve
        (0, $6QSfE.invariant)(definition.length === 4, "Cubic bezier arrays must contain four numerical values.");
        var _a = (0, $7WQrb.__read)(definition, 4), x1 = _a[0], y1 = _a[1], x2 = _a[2], y2 = _a[3];
        return (0, $jpolx.cubicBezier)(x1, y1, x2, y2);
    } else if (typeof definition === "string") {
        // Else lookup from table
        (0, $6QSfE.invariant)($09ac0b286989a3ae$var$easingLookup[definition] !== undefined, "Invalid easing type '".concat(definition, "'"));
        return $09ac0b286989a3ae$var$easingLookup[definition];
    }
    return definition;
};
var $09ac0b286989a3ae$export$216948827bbdc797 = function(ease) {
    return Array.isArray(ease) && typeof ease[0] !== "number";
};

});
parcelRegister("jpolx", function(module, exports) {

$parcel$export(module.exports, "cubicBezier", () => $fb965d9058fcbe5e$export$2c575fa1d20488bd);

var $bsiRs = parcelRequire("bsiRs");
const $fb965d9058fcbe5e$var$a = (a1, a2)=>1.0 - 3.0 * a2 + 3.0 * a1;
const $fb965d9058fcbe5e$var$b = (a1, a2)=>3.0 * a2 - 6.0 * a1;
const $fb965d9058fcbe5e$var$c = (a1)=>3.0 * a1;
const $fb965d9058fcbe5e$var$calcBezier = (t, a1, a2)=>(($fb965d9058fcbe5e$var$a(a1, a2) * t + $fb965d9058fcbe5e$var$b(a1, a2)) * t + $fb965d9058fcbe5e$var$c(a1)) * t;
const $fb965d9058fcbe5e$var$getSlope = (t, a1, a2)=>3.0 * $fb965d9058fcbe5e$var$a(a1, a2) * t * t + 2.0 * $fb965d9058fcbe5e$var$b(a1, a2) * t + $fb965d9058fcbe5e$var$c(a1);
const $fb965d9058fcbe5e$var$subdivisionPrecision = 0.0000001;
const $fb965d9058fcbe5e$var$subdivisionMaxIterations = 10;
function $fb965d9058fcbe5e$var$binarySubdivide(aX, aA, aB, mX1, mX2) {
    let currentX;
    let currentT;
    let i = 0;
    do {
        currentT = aA + (aB - aA) / 2.0;
        currentX = $fb965d9058fcbe5e$var$calcBezier(currentT, mX1, mX2) - aX;
        if (currentX > 0.0) aB = currentT;
        else aA = currentT;
    }while (Math.abs(currentX) > $fb965d9058fcbe5e$var$subdivisionPrecision && ++i < $fb965d9058fcbe5e$var$subdivisionMaxIterations);
    return currentT;
}
const $fb965d9058fcbe5e$var$newtonIterations = 8;
const $fb965d9058fcbe5e$var$newtonMinSlope = 0.001;
function $fb965d9058fcbe5e$var$newtonRaphsonIterate(aX, aGuessT, mX1, mX2) {
    for(let i = 0; i < $fb965d9058fcbe5e$var$newtonIterations; ++i){
        const currentSlope = $fb965d9058fcbe5e$var$getSlope(aGuessT, mX1, mX2);
        if (currentSlope === 0.0) return aGuessT;
        const currentX = $fb965d9058fcbe5e$var$calcBezier(aGuessT, mX1, mX2) - aX;
        aGuessT -= currentX / currentSlope;
    }
    return aGuessT;
}
const $fb965d9058fcbe5e$var$kSplineTableSize = 11;
const $fb965d9058fcbe5e$var$kSampleStepSize = 1.0 / ($fb965d9058fcbe5e$var$kSplineTableSize - 1.0);
function $fb965d9058fcbe5e$export$2c575fa1d20488bd(mX1, mY1, mX2, mY2) {
    if (mX1 === mY1 && mX2 === mY2) return 0, $bsiRs.linear;
    const sampleValues = new Float32Array($fb965d9058fcbe5e$var$kSplineTableSize);
    for(let i = 0; i < $fb965d9058fcbe5e$var$kSplineTableSize; ++i)sampleValues[i] = $fb965d9058fcbe5e$var$calcBezier(i * $fb965d9058fcbe5e$var$kSampleStepSize, mX1, mX2);
    function getTForX(aX) {
        let intervalStart = 0.0;
        let currentSample = 1;
        const lastSample = $fb965d9058fcbe5e$var$kSplineTableSize - 1;
        for(; currentSample !== lastSample && sampleValues[currentSample] <= aX; ++currentSample)intervalStart += $fb965d9058fcbe5e$var$kSampleStepSize;
        --currentSample;
        const dist = (aX - sampleValues[currentSample]) / (sampleValues[currentSample + 1] - sampleValues[currentSample]);
        const guessForT = intervalStart + dist * $fb965d9058fcbe5e$var$kSampleStepSize;
        const initialSlope = $fb965d9058fcbe5e$var$getSlope(guessForT, mX1, mX2);
        if (initialSlope >= $fb965d9058fcbe5e$var$newtonMinSlope) return $fb965d9058fcbe5e$var$newtonRaphsonIterate(aX, guessForT, mX1, mX2);
        else if (initialSlope === 0.0) return guessForT;
        else return $fb965d9058fcbe5e$var$binarySubdivide(aX, intervalStart, intervalStart + $fb965d9058fcbe5e$var$kSampleStepSize, mX1, mX2);
    }
    return (t)=>t === 0 || t === 1 ? t : $fb965d9058fcbe5e$var$calcBezier(getTForX(t), mY1, mY2);
}

});


parcelRegister("fyA1E", function(module, exports) {

$parcel$export(module.exports, "isAnimatable", () => $ef4086713d7b0bdb$export$65676b58b122bc38);

var $DYJG5 = parcelRequire("DYJG5");
/**
 * Check if a value is animatable. Examples:
 *
 * ✅: 100, "100px", "#fff"
 * ❌: "block", "url(2.jpg)"
 * @param value
 *
 * @internal
 */ var $ef4086713d7b0bdb$export$65676b58b122bc38 = function(key, value) {
    // If the list of keys tat might be non-animatable grows, replace with Set
    if (key === "zIndex") return false;
    // If it's a number or a keyframes array, we can animate it. We might at some point
    // need to do a deep isAnimatable check of keyframes, or let Popmotion handle this,
    // but for now lets leave it like this for performance reasons
    if (typeof value === "number" || Array.isArray(value)) return true;
    if (typeof value === "string" && // It's animatable if we have a string
    (0, $DYJG5.complex).test(value) && // And it contains numbers and/or colors
    !value.startsWith("url(") // Unless it starts with "url("
    ) return true;
    return false;
};

});

parcelRegister("kSXzE", function(module, exports) {

$parcel$export(module.exports, "getDefaultTransition", () => $5f1d5ca1d398e82d$export$262124b154b9f1c0);

var $7WQrb = parcelRequire("7WQrb");

var $eT2fJ = parcelRequire("eT2fJ");
var $5f1d5ca1d398e82d$export$2577c2184b2254d3 = function() {
    return {
        type: "spring",
        stiffness: 500,
        damping: 25,
        restSpeed: 10
    };
};
var $5f1d5ca1d398e82d$export$a743142a31c132c = function(to) {
    return {
        type: "spring",
        stiffness: 550,
        damping: to === 0 ? 2 * Math.sqrt(550) : 30,
        restSpeed: 10
    };
};
var $5f1d5ca1d398e82d$export$c2d663fbb86d66d6 = function() {
    return {
        type: "keyframes",
        ease: "linear",
        duration: 0.3
    };
};
var $5f1d5ca1d398e82d$var$keyframes = function(values) {
    return {
        type: "keyframes",
        duration: 0.8,
        values: values
    };
};
var $5f1d5ca1d398e82d$var$defaultTransitions = {
    x: $5f1d5ca1d398e82d$export$2577c2184b2254d3,
    y: $5f1d5ca1d398e82d$export$2577c2184b2254d3,
    z: $5f1d5ca1d398e82d$export$2577c2184b2254d3,
    rotate: $5f1d5ca1d398e82d$export$2577c2184b2254d3,
    rotateX: $5f1d5ca1d398e82d$export$2577c2184b2254d3,
    rotateY: $5f1d5ca1d398e82d$export$2577c2184b2254d3,
    rotateZ: $5f1d5ca1d398e82d$export$2577c2184b2254d3,
    scaleX: $5f1d5ca1d398e82d$export$a743142a31c132c,
    scaleY: $5f1d5ca1d398e82d$export$a743142a31c132c,
    scale: $5f1d5ca1d398e82d$export$a743142a31c132c,
    opacity: $5f1d5ca1d398e82d$export$c2d663fbb86d66d6,
    backgroundColor: $5f1d5ca1d398e82d$export$c2d663fbb86d66d6,
    color: $5f1d5ca1d398e82d$export$c2d663fbb86d66d6,
    default: $5f1d5ca1d398e82d$export$a743142a31c132c
};
var $5f1d5ca1d398e82d$export$262124b154b9f1c0 = function(valueKey, to) {
    var transitionFactory;
    if ((0, $eT2fJ.isKeyframesTarget)(to)) transitionFactory = $5f1d5ca1d398e82d$var$keyframes;
    else transitionFactory = $5f1d5ca1d398e82d$var$defaultTransitions[valueKey] || $5f1d5ca1d398e82d$var$defaultTransitions.default;
    return (0, $7WQrb.__assign)({
        to: to
    }, transitionFactory(to));
};

});

parcelRegister("adXv8", function(module, exports) {

$parcel$export(module.exports, "getAnimatableNone", () => $ca0a3798777df465$export$cea0cedcb94873b5);

var $DYJG5 = parcelRequire("DYJG5");
var $eOgcc = parcelRequire("eOgcc");

var $h8BN3 = parcelRequire("h8BN3");
function $ca0a3798777df465$export$cea0cedcb94873b5(key, value) {
    var _a;
    var defaultValueType = (0, $h8BN3.getDefaultValueType)(key);
    if (defaultValueType !== (0, $eOgcc.filter)) defaultValueType = (0, $DYJG5.complex);
    // If value is not recognised as animatable, ie "none", create an animatable version origin based on the target
    return (_a = defaultValueType.getAnimatableNone) === null || _a === void 0 ? void 0 : _a.call(defaultValueType, value);
}

});
parcelRegister("eOgcc", function(module, exports) {

$parcel$export(module.exports, "filter", () => $bd3d3cb23febe6a9$export$3dea766d36a8935f);

var $DYJG5 = parcelRequire("DYJG5");

var $5sH7B = parcelRequire("5sH7B");
const $bd3d3cb23febe6a9$var$maxDefaults = new Set([
    "brightness",
    "contrast",
    "saturate",
    "opacity"
]);
function $bd3d3cb23febe6a9$var$applyDefaultFilter(v) {
    let [name, value] = v.slice(0, -1).split("(");
    if (name === "drop-shadow") return v;
    const [number] = value.match((0, $5sH7B.floatRegex)) || [];
    if (!number) return v;
    const unit = value.replace(number, "");
    let defaultValue = $bd3d3cb23febe6a9$var$maxDefaults.has(name) ? 1 : 0;
    if (number !== value) defaultValue *= 100;
    return name + "(" + defaultValue + unit + ")";
}
const $bd3d3cb23febe6a9$var$functionRegex = /([a-z-]*)\(.*?\)/g;
const $bd3d3cb23febe6a9$export$3dea766d36a8935f = Object.assign(Object.assign({}, (0, $DYJG5.complex)), {
    getAnimatableNone: (v)=>{
        const functions = v.match($bd3d3cb23febe6a9$var$functionRegex);
        return functions ? functions.map($bd3d3cb23febe6a9$var$applyDefaultFilter).join(" ") : v;
    }
});

});

parcelRegister("h8BN3", function(module, exports) {

$parcel$export(module.exports, "getDefaultValueType", () => $6da1de6e0a9a8c9d$export$67d1babe0338d23b);

var $7WQrb = parcelRequire("7WQrb");

var $fKUMu = parcelRequire("fKUMu");
var $eOgcc = parcelRequire("eOgcc");

var $hsgeP = parcelRequire("hsgeP");
/**
 * A map of default value types for common values
 */ var $6da1de6e0a9a8c9d$export$98cd7c72c5a731fb = (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, (0, $hsgeP.numberValueTypes)), {
    // Color props
    color: (0, $fKUMu.color),
    backgroundColor: (0, $fKUMu.color),
    outlineColor: (0, $fKUMu.color),
    fill: (0, $fKUMu.color),
    stroke: (0, $fKUMu.color),
    // Border props
    borderColor: (0, $fKUMu.color),
    borderTopColor: (0, $fKUMu.color),
    borderRightColor: (0, $fKUMu.color),
    borderBottomColor: (0, $fKUMu.color),
    borderLeftColor: (0, $fKUMu.color),
    filter: (0, $eOgcc.filter),
    WebkitFilter: (0, $eOgcc.filter)
});
/**
 * Gets the default ValueType for the provided value key
 */ var $6da1de6e0a9a8c9d$export$67d1babe0338d23b = function(key) {
    return $6da1de6e0a9a8c9d$export$98cd7c72c5a731fb[key];
};

});


parcelRegister("cImAs", function(module, exports) {

$parcel$export(module.exports, "instantAnimationState", () => $77818709e1bb6833$export$888a3d84909f9e3d);
var $77818709e1bb6833$export$888a3d84909f9e3d = {
    current: false
};

});


parcelRegister("87OLY", function(module, exports) {

$parcel$export(module.exports, "setTarget", () => $ea04fe669600292a$export$1f61c53461aff4a5);
$parcel$export(module.exports, "checkTargetForNewValues", () => $ea04fe669600292a$export$6afbed164019a54c);
$parcel$export(module.exports, "getOrigin", () => $ea04fe669600292a$export$5a759dc7a1cfb72a);

var $7WQrb = parcelRequire("7WQrb");

var $DYJG5 = parcelRequire("DYJG5");

var $bjEgh = parcelRequire("bjEgh");

var $e2LUE = parcelRequire("e2LUE");

var $lyAek = parcelRequire("lyAek");

var $9s8eJ = parcelRequire("9s8eJ");

var $adXv8 = parcelRequire("adXv8");

var $82f3D = parcelRequire("82f3D");

var $8QQaD = parcelRequire("8QQaD");
/**
 * Set VisualElement's MotionValue, creating a new MotionValue for it if
 * it doesn't exist.
 */ function $ea04fe669600292a$var$setMotionValue(visualElement, key, value) {
    if (visualElement.hasValue(key)) visualElement.getValue(key).set(value);
    else visualElement.addValue(key, (0, $9s8eJ.motionValue)(value));
}
function $ea04fe669600292a$export$1f61c53461aff4a5(visualElement, definition) {
    var resolved = (0, $8QQaD.resolveVariant)(visualElement, definition);
    var _a = resolved ? visualElement.makeTargetAnimatable(resolved, false) : {}, _b = _a.transitionEnd, transitionEnd = _b === void 0 ? {} : _b;
    _a.transition;
    var target = (0, $7WQrb.__rest)(_a, [
        "transitionEnd",
        "transition"
    ]);
    target = (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, target), transitionEnd);
    for(var key in target){
        var value = (0, $lyAek.resolveFinalValueInKeyframes)(target[key]);
        $ea04fe669600292a$var$setMotionValue(visualElement, key, value);
    }
}
function $ea04fe669600292a$var$setVariants(visualElement, variantLabels) {
    var reversedLabels = (0, $7WQrb.__spreadArray)([], (0, $7WQrb.__read)(variantLabels), false).reverse();
    reversedLabels.forEach(function(key) {
        var _a;
        var variant = visualElement.getVariant(key);
        variant && $ea04fe669600292a$export$1f61c53461aff4a5(visualElement, variant);
        (_a = visualElement.variantChildren) === null || _a === void 0 || _a.forEach(function(child) {
            $ea04fe669600292a$var$setVariants(child, variantLabels);
        });
    });
}
function $ea04fe669600292a$export$b7771d60d308862f(visualElement, definition) {
    if (Array.isArray(definition)) return $ea04fe669600292a$var$setVariants(visualElement, definition);
    else if (typeof definition === "string") return $ea04fe669600292a$var$setVariants(visualElement, [
        definition
    ]);
    else $ea04fe669600292a$export$1f61c53461aff4a5(visualElement, definition);
}
function $ea04fe669600292a$export$6afbed164019a54c(visualElement, target, origin) {
    var _a, _b, _c;
    var _d;
    var newValueKeys = Object.keys(target).filter(function(key) {
        return !visualElement.hasValue(key);
    });
    var numNewValues = newValueKeys.length;
    if (!numNewValues) return;
    for(var i = 0; i < numNewValues; i++){
        var key = newValueKeys[i];
        var targetValue = target[key];
        var value = null;
        /**
         * If the target is a series of keyframes, we can use the first value
         * in the array. If this first value is null, we'll still need to read from the DOM.
         */ if (Array.isArray(targetValue)) value = targetValue[0];
        /**
         * If the target isn't keyframes, or the first keyframe was null, we need to
         * first check if an origin value was explicitly defined in the transition as "from",
         * if not read the value from the DOM. As an absolute fallback, take the defined target value.
         */ if (value === null) value = (_b = (_a = origin[key]) !== null && _a !== void 0 ? _a : visualElement.readValue(key)) !== null && _b !== void 0 ? _b : target[key];
        /**
         * If value is still undefined or null, ignore it. Preferably this would throw,
         * but this was causing issues in Framer.
         */ if (value === undefined || value === null) continue;
        if (typeof value === "string" && ((0, $bjEgh.isNumericalString)(value) || (0, $e2LUE.isZeroValueString)(value))) // If this is a number read as a string, ie "0" or "200", convert it to a number
        value = parseFloat(value);
        else if (!(0, $82f3D.findValueType)(value) && (0, $DYJG5.complex).test(targetValue)) value = (0, $adXv8.getAnimatableNone)(key, targetValue);
        visualElement.addValue(key, (0, $9s8eJ.motionValue)(value));
        (_c = (_d = origin)[key]) !== null && _c !== void 0 ? _c : _d[key] = value;
        visualElement.setBaseTarget(key, value);
    }
}
function $ea04fe669600292a$export$c3befe8e18686628(key, transition) {
    if (!transition) return;
    var valueTransition = transition[key] || transition["default"] || transition;
    return valueTransition.from;
}
function $ea04fe669600292a$export$5a759dc7a1cfb72a(target, transition, visualElement) {
    var _a, _b;
    var origin = {};
    for(var key in target)origin[key] = (_a = $ea04fe669600292a$export$c3befe8e18686628(key, transition)) !== null && _a !== void 0 ? _a : (_b = visualElement.getValue(key)) === null || _b === void 0 ? void 0 : _b.get();
    return origin;
}

});
parcelRegister("bjEgh", function(module, exports) {

$parcel$export(module.exports, "isNumericalString", () => $d56714d1e4e43615$export$65583ed5a868f2d9);
/**
 * Check if value is a numerical string, ie a string that is purely a number eg "100" or "-100.1"
 */ var $d56714d1e4e43615$export$65583ed5a868f2d9 = function(v) {
    return /^\-?\d*\.?\d+$/.test(v);
};

});

parcelRegister("e2LUE", function(module, exports) {

$parcel$export(module.exports, "isZeroValueString", () => $933209bc9c035719$export$ade84c85e44a6cb1);
/**
 * Check if the value is a zero value string like "0px" or "0%"
 */ var $933209bc9c035719$export$ade84c85e44a6cb1 = function(v) {
    return /^0[^.\s]+$/.test(v);
};

});

parcelRegister("9s8eJ", function(module, exports) {

$parcel$export(module.exports, "motionValue", () => $e32104bb79321603$export$ce8bdc721e76545f);

var $9ksIr = parcelRequire("9ksIr");

var $1jVr4 = parcelRequire("1jVr4");

var $es3uG = parcelRequire("es3uG");
var $e32104bb79321603$var$isFloat = function(value) {
    return !isNaN(parseFloat(value));
};
/**
 * `MotionValue` is used to track the state and velocity of motion values.
 *
 * @public
 */ var $e32104bb79321603$export$8cea36d14ee64562 = /** @class */ function() {
    /**
     * @param init - The initiating value
     * @param config - Optional configuration options
     *
     * -  `transformer`: A function to transform incoming values with.
     *
     * @internal
     */ function MotionValue(init) {
        var _this = this;
        /**
         * This will be replaced by the build step with the latest version number.
         * When MotionValues are provided to motion components, warn if versions are mixed.
         */ this.version = "6.5.1";
        /**
         * Duration, in milliseconds, since last updating frame.
         *
         * @internal
         */ this.timeDelta = 0;
        /**
         * Timestamp of the last time this `MotionValue` was updated.
         *
         * @internal
         */ this.lastUpdated = 0;
        /**
         * Functions to notify when the `MotionValue` updates.
         *
         * @internal
         */ this.updateSubscribers = new (0, $es3uG.SubscriptionManager)();
        /**
         * Functions to notify when the velocity updates.
         *
         * @internal
         */ this.velocityUpdateSubscribers = new (0, $es3uG.SubscriptionManager)();
        /**
         * Functions to notify when the `MotionValue` updates and `render` is set to `true`.
         *
         * @internal
         */ this.renderSubscribers = new (0, $es3uG.SubscriptionManager)();
        /**
         * Tracks whether this value can output a velocity. Currently this is only true
         * if the value is numerical, but we might be able to widen the scope here and support
         * other value types.
         *
         * @internal
         */ this.canTrackVelocity = false;
        this.updateAndNotify = function(v, render) {
            if (render === void 0) render = true;
            _this.prev = _this.current;
            _this.current = v;
            // Update timestamp
            var _a = (0, $9ksIr.getFrameData)(), delta = _a.delta, timestamp = _a.timestamp;
            if (_this.lastUpdated !== timestamp) {
                _this.timeDelta = delta;
                _this.lastUpdated = timestamp;
                (0, $9ksIr.default).postRender(_this.scheduleVelocityCheck);
            }
            // Update update subscribers
            if (_this.prev !== _this.current) _this.updateSubscribers.notify(_this.current);
            // Update velocity subscribers
            if (_this.velocityUpdateSubscribers.getSize()) _this.velocityUpdateSubscribers.notify(_this.getVelocity());
            // Update render subscribers
            if (render) _this.renderSubscribers.notify(_this.current);
        };
        /**
         * Schedule a velocity check for the next frame.
         *
         * This is an instanced and bound function to prevent generating a new
         * function once per frame.
         *
         * @internal
         */ this.scheduleVelocityCheck = function() {
            return (0, $9ksIr.default).postRender(_this.velocityCheck);
        };
        /**
         * Updates `prev` with `current` if the value hasn't been updated this frame.
         * This ensures velocity calculations return `0`.
         *
         * This is an instanced and bound function to prevent generating a new
         * function once per frame.
         *
         * @internal
         */ this.velocityCheck = function(_a) {
            var timestamp = _a.timestamp;
            if (timestamp !== _this.lastUpdated) {
                _this.prev = _this.current;
                _this.velocityUpdateSubscribers.notify(_this.getVelocity());
            }
        };
        this.hasAnimated = false;
        this.prev = this.current = init;
        this.canTrackVelocity = $e32104bb79321603$var$isFloat(this.current);
    }
    /**
     * Adds a function that will be notified when the `MotionValue` is updated.
     *
     * It returns a function that, when called, will cancel the subscription.
     *
     * When calling `onChange` inside a React component, it should be wrapped with the
     * `useEffect` hook. As it returns an unsubscribe function, this should be returned
     * from the `useEffect` function to ensure you don't add duplicate subscribers..
     *
     * ```jsx
     * export const MyComponent = () => {
     *   const x = useMotionValue(0)
     *   const y = useMotionValue(0)
     *   const opacity = useMotionValue(1)
     *
     *   useEffect(() => {
     *     function updateOpacity() {
     *       const maxXY = Math.max(x.get(), y.get())
     *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
     *       opacity.set(newOpacity)
     *     }
     *
     *     const unsubscribeX = x.onChange(updateOpacity)
     *     const unsubscribeY = y.onChange(updateOpacity)
     *
     *     return () => {
     *       unsubscribeX()
     *       unsubscribeY()
     *     }
     *   }, [])
     *
     *   return <motion.div style={{ x }} />
     * }
     * ```
     *
     * @privateRemarks
     *
     * We could look into a `useOnChange` hook if the above lifecycle management proves confusing.
     *
     * ```jsx
     * useOnChange(x, () => {})
     * ```
     *
     * @param subscriber - A function that receives the latest value.
     * @returns A function that, when called, will cancel this subscription.
     *
     * @public
     */ MotionValue.prototype.onChange = function(subscription) {
        return this.updateSubscribers.add(subscription);
    };
    MotionValue.prototype.clearListeners = function() {
        this.updateSubscribers.clear();
    };
    /**
     * Adds a function that will be notified when the `MotionValue` requests a render.
     *
     * @param subscriber - A function that's provided the latest value.
     * @returns A function that, when called, will cancel this subscription.
     *
     * @internal
     */ MotionValue.prototype.onRenderRequest = function(subscription) {
        // Render immediately
        subscription(this.get());
        return this.renderSubscribers.add(subscription);
    };
    /**
     * Attaches a passive effect to the `MotionValue`.
     *
     * @internal
     */ MotionValue.prototype.attach = function(passiveEffect) {
        this.passiveEffect = passiveEffect;
    };
    /**
     * Sets the state of the `MotionValue`.
     *
     * @remarks
     *
     * ```jsx
     * const x = useMotionValue(0)
     * x.set(10)
     * ```
     *
     * @param latest - Latest value to set.
     * @param render - Whether to notify render subscribers. Defaults to `true`
     *
     * @public
     */ MotionValue.prototype.set = function(v, render) {
        if (render === void 0) render = true;
        if (!render || !this.passiveEffect) this.updateAndNotify(v, render);
        else this.passiveEffect(v, this.updateAndNotify);
    };
    /**
     * Returns the latest state of `MotionValue`
     *
     * @returns - The latest state of `MotionValue`
     *
     * @public
     */ MotionValue.prototype.get = function() {
        return this.current;
    };
    /**
     * @public
     */ MotionValue.prototype.getPrevious = function() {
        return this.prev;
    };
    /**
     * Returns the latest velocity of `MotionValue`
     *
     * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
     *
     * @public
     */ MotionValue.prototype.getVelocity = function() {
        // This could be isFloat(this.prev) && isFloat(this.current), but that would be wasteful
        return this.canTrackVelocity ? (0, $1jVr4.velocityPerSecond)(parseFloat(this.current) - parseFloat(this.prev), this.timeDelta) : 0;
    };
    /**
     * Registers a new animation to control this `MotionValue`. Only one
     * animation can drive a `MotionValue` at one time.
     *
     * ```jsx
     * value.start()
     * ```
     *
     * @param animation - A function that starts the provided animation
     *
     * @internal
     */ MotionValue.prototype.start = function(animation) {
        var _this = this;
        this.stop();
        return new Promise(function(resolve) {
            _this.hasAnimated = true;
            _this.stopAnimation = animation(resolve);
        }).then(function() {
            return _this.clearAnimation();
        });
    };
    /**
     * Stop the currently active animation.
     *
     * @public
     */ MotionValue.prototype.stop = function() {
        if (this.stopAnimation) this.stopAnimation();
        this.clearAnimation();
    };
    /**
     * Returns `true` if this value is currently animating.
     *
     * @public
     */ MotionValue.prototype.isAnimating = function() {
        return !!this.stopAnimation;
    };
    MotionValue.prototype.clearAnimation = function() {
        this.stopAnimation = null;
    };
    /**
     * Destroy and clean up subscribers to this `MotionValue`.
     *
     * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
     * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
     * created a `MotionValue` via the `motionValue` function.
     *
     * @public
     */ MotionValue.prototype.destroy = function() {
        this.updateSubscribers.clear();
        this.renderSubscribers.clear();
        this.stop();
    };
    return MotionValue;
}();
function $e32104bb79321603$export$ce8bdc721e76545f(init) {
    return new $e32104bb79321603$export$8cea36d14ee64562(init);
}

});
parcelRegister("es3uG", function(module, exports) {

$parcel$export(module.exports, "SubscriptionManager", () => $ad746ac6e5aa4783$export$e7dff9482a5fd23c);

var $8DEVZ = parcelRequire("8DEVZ");
var $ad746ac6e5aa4783$export$e7dff9482a5fd23c = /** @class */ function() {
    function SubscriptionManager() {
        this.subscriptions = [];
    }
    SubscriptionManager.prototype.add = function(handler) {
        var _this = this;
        (0, $8DEVZ.addUniqueItem)(this.subscriptions, handler);
        return function() {
            return (0, $8DEVZ.removeItem)(_this.subscriptions, handler);
        };
    };
    SubscriptionManager.prototype.notify = function(a, b, c) {
        var numSubscriptions = this.subscriptions.length;
        if (!numSubscriptions) return;
        if (numSubscriptions === 1) /**
             * If there's only a single handler we can just call it without invoking a loop.
             */ this.subscriptions[0](a, b, c);
        else for(var i = 0; i < numSubscriptions; i++){
            /**
                 * Check whether the handler exists before firing as it's possible
                 * the subscriptions were modified during this loop running.
                 */ var handler = this.subscriptions[i];
            handler && handler(a, b, c);
        }
    };
    SubscriptionManager.prototype.getSize = function() {
        return this.subscriptions.length;
    };
    SubscriptionManager.prototype.clear = function() {
        this.subscriptions.length = 0;
    };
    return SubscriptionManager;
}();

});
parcelRegister("8DEVZ", function(module, exports) {

$parcel$export(module.exports, "addUniqueItem", () => $f9c6cc6428ae273c$export$20e507e47fae79fd);
$parcel$export(module.exports, "removeItem", () => $f9c6cc6428ae273c$export$fe2d9b4e03920b4c);
$parcel$export(module.exports, "moveItem", () => $f9c6cc6428ae273c$export$ec937e64de6c1257);

var $7WQrb = parcelRequire("7WQrb");
function $f9c6cc6428ae273c$export$20e507e47fae79fd(arr, item) {
    arr.indexOf(item) === -1 && arr.push(item);
}
function $f9c6cc6428ae273c$export$fe2d9b4e03920b4c(arr, item) {
    var index = arr.indexOf(item);
    index > -1 && arr.splice(index, 1);
}
// Adapted from array-move
function $f9c6cc6428ae273c$export$ec937e64de6c1257(_a, fromIndex, toIndex) {
    var _b = (0, $7WQrb.__read)(_a), arr = _b.slice(0);
    var startIndex = fromIndex < 0 ? arr.length + fromIndex : fromIndex;
    if (startIndex >= 0 && startIndex < arr.length) {
        var endIndex = toIndex < 0 ? arr.length + toIndex : toIndex;
        var _c = (0, $7WQrb.__read)(arr.splice(fromIndex, 1), 1), item = _c[0];
        arr.splice(endIndex, 0, item);
    }
    return arr;
}

});



parcelRegister("82f3D", function(module, exports) {

$parcel$export(module.exports, "findValueType", () => $0bb49f6c51badae3$export$950e7e59ea1ffed7);

var $7WQrb = parcelRequire("7WQrb");

var $fKUMu = parcelRequire("fKUMu");
var $DYJG5 = parcelRequire("DYJG5");

var $4Vyka = parcelRequire("4Vyka");

var $cobvw = parcelRequire("cobvw");
/**
 * A list of all ValueTypes
 */ var $0bb49f6c51badae3$var$valueTypes = (0, $7WQrb.__spreadArray)((0, $7WQrb.__spreadArray)([], (0, $7WQrb.__read)((0, $4Vyka.dimensionValueTypes)), false), [
    (0, $fKUMu.color),
    (0, $DYJG5.complex)
], false);
/**
 * Tests a value against the list of ValueTypes
 */ var $0bb49f6c51badae3$export$950e7e59ea1ffed7 = function(v) {
    return $0bb49f6c51badae3$var$valueTypes.find((0, $cobvw.testValueType)(v));
};

});
parcelRegister("4Vyka", function(module, exports) {

$parcel$export(module.exports, "dimensionValueTypes", () => $a90ec5e4ad59372f$export$d176691c1998a1f5);
$parcel$export(module.exports, "findDimensionValueType", () => $a90ec5e4ad59372f$export$eefdd52e3ccae428);

var $1fCxR = parcelRequire("1fCxR");
var $g4T9J = parcelRequire("g4T9J");

var $cobvw = parcelRequire("cobvw");

var $2RKFx = parcelRequire("2RKFx");
/**
 * A list of value types commonly used for dimensions
 */ var $a90ec5e4ad59372f$export$d176691c1998a1f5 = [
    (0, $g4T9J.number),
    (0, $1fCxR.px),
    (0, $1fCxR.percent),
    (0, $1fCxR.degrees),
    (0, $1fCxR.vw),
    (0, $1fCxR.vh),
    (0, $2RKFx.auto)
];
/**
 * Tests a dimensional value against the list of dimension ValueTypes
 */ var $a90ec5e4ad59372f$export$eefdd52e3ccae428 = function(v) {
    return $a90ec5e4ad59372f$export$d176691c1998a1f5.find((0, $cobvw.testValueType)(v));
};

});
parcelRegister("cobvw", function(module, exports) {

$parcel$export(module.exports, "testValueType", () => $a1e2618328995be8$export$6eae4d0a6a7ca7cd);
/**
 * Tests a provided value against a ValueType
 */ var $a1e2618328995be8$export$6eae4d0a6a7ca7cd = function(v) {
    return function(type) {
        return type.test(v);
    };
};

});

parcelRegister("2RKFx", function(module, exports) {

$parcel$export(module.exports, "auto", () => $c231a4375b038d3c$export$dfb5619354ba860);
/**
 * ValueType for "auto"
 */ var $c231a4375b038d3c$export$dfb5619354ba860 = {
    test: function(v) {
        return v === "auto";
    },
    parse: function(v) {
        return v;
    }
};

});







parcelRegister("80qKP", function(module, exports) {

$parcel$export(module.exports, "drag", () => $fc1974bcfc4fde1a$export$d7d5d435647ed5a0);

var $ef7ZE = parcelRequire("ef7ZE");

var $9uZOf = parcelRequire("9uZOf");

var $igYbV = parcelRequire("igYbV");
var $fc1974bcfc4fde1a$export$d7d5d435647ed5a0 = {
    pan: (0, $igYbV.makeRenderlessComponent)((0, $9uZOf.usePanGesture)),
    drag: (0, $igYbV.makeRenderlessComponent)((0, $ef7ZE.useDrag))
};

});
parcelRegister("ef7ZE", function(module, exports) {

$parcel$export(module.exports, "useDrag", () => $b89949ca91f83f6d$export$7941f8aafa4b6021);

var $acw62 = parcelRequire("acw62");

var $4Zpic = parcelRequire("4Zpic");

var $aTYEI = parcelRequire("aTYEI");
/**
 * A hook that allows an element to be dragged.
 *
 * @internal
 */ function $b89949ca91f83f6d$export$7941f8aafa4b6021(props) {
    var groupDragControls = props.dragControls, visualElement = props.visualElement;
    var dragControls = (0, $aTYEI.useConstant)(function() {
        return new (0, $4Zpic.VisualElementDragControls)(visualElement);
    });
    // If we've been provided a DragControls for manual control over the drag gesture,
    // subscribe this component to it on mount.
    (0, $acw62.useEffect)(function() {
        return groupDragControls && groupDragControls.subscribe(dragControls);
    }, [
        dragControls,
        groupDragControls
    ]);
    // Apply the event listeners to the element
    (0, $acw62.useEffect)(function() {
        return dragControls.addListeners();
    }, [
        dragControls
    ]);
}

});
parcelRegister("4Zpic", function(module, exports) {

$parcel$export(module.exports, "VisualElementDragControls", () => $59924ee873defaad$export$86bff71f18910307);

var $7WQrb = parcelRequire("7WQrb");

var $6QSfE = parcelRequire("6QSfE");

var $hgCC7 = parcelRequire("hgCC7");

var $bYmgt = parcelRequire("bYmgt");

var $cg30p = parcelRequire("cg30p");

var $kkba7 = parcelRequire("kkba7");

var $j55Mj = parcelRequire("j55Mj");

var $5fU40 = parcelRequire("5fU40");

var $8v3iT = parcelRequire("8v3iT");

var $tnnCU = parcelRequire("tnnCU");

var $dJ8Md = parcelRequire("dJ8Md");

var $2BisC = parcelRequire("2BisC");

var $bUTXm = parcelRequire("bUTXm");

var $iaeDY = parcelRequire("iaeDY");

var $ao8nn = parcelRequire("ao8nn");

var $bqVjQ = parcelRequire("bqVjQ");

var $1fCxR = parcelRequire("1fCxR");

var $8BLfb = parcelRequire("8BLfb");
var $59924ee873defaad$export$f0a15892c27dc07c = new WeakMap();
/**
 *
 */ // let latestPointerEvent: AnyPointerEvent
var $59924ee873defaad$export$86bff71f18910307 = /** @class */ function() {
    function VisualElementDragControls(visualElement) {
        // This is a reference to the global drag gesture lock, ensuring only one component
        // can "capture" the drag of one or both axes.
        // TODO: Look into moving this into pansession?
        this.openGlobalLock = null;
        this.isDragging = false;
        this.currentDirection = null;
        this.originPoint = {
            x: 0,
            y: 0
        };
        /**
         * The permitted boundaries of travel, in pixels.
         */ this.constraints = false;
        this.hasMutatedConstraints = false;
        /**
         * The per-axis resolved elastic values.
         */ this.elastic = (0, $8v3iT.createBox)();
        this.visualElement = visualElement;
    }
    VisualElementDragControls.prototype.start = function(originEvent, _a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, _c = _b.snapToCursor, snapToCursor = _c === void 0 ? false : _c;
        /**
         * Don't start dragging if this component is exiting
         */ if (this.visualElement.isPresent === false) return;
        var onSessionStart = function(event) {
            // Stop any animations on both axis values immediately. This allows the user to throw and catch
            // the component.
            _this.stopAnimation();
            if (snapToCursor) _this.snapToCursor((0, $2BisC.extractEventInfo)(event, "page").point);
        };
        var onStart = function(event, info) {
            var _a;
            // Attempt to grab the global drag gesture lock - maybe make this part of PanSession
            var _b = _this.getProps(), drag = _b.drag, dragPropagation = _b.dragPropagation, onDragStart = _b.onDragStart;
            if (drag && !dragPropagation) {
                if (_this.openGlobalLock) _this.openGlobalLock();
                _this.openGlobalLock = (0, $bYmgt.getGlobalLock)(drag);
                // If we don 't have the lock, don't start dragging
                if (!_this.openGlobalLock) return;
            }
            _this.isDragging = true;
            _this.currentDirection = null;
            _this.resolveConstraints();
            if (_this.visualElement.projection) {
                _this.visualElement.projection.isAnimationBlocked = true;
                _this.visualElement.projection.target = undefined;
            }
            /**
             * Record gesture origin
             */ (0, $tnnCU.eachAxis)(function(axis) {
                var _a, _b;
                var current = _this.getAxisMotionValue(axis).get() || 0;
                /**
                 * If the MotionValue is a percentage value convert to px
                 */ if ((0, $1fCxR.percent).test(current)) {
                    var measuredAxis = (_b = (_a = _this.visualElement.projection) === null || _a === void 0 ? void 0 : _a.layout) === null || _b === void 0 ? void 0 : _b.actual[axis];
                    if (measuredAxis) {
                        var length_1 = (0, $8BLfb.calcLength)(measuredAxis);
                        current = length_1 * (parseFloat(current) / 100);
                    }
                }
                _this.originPoint[axis] = current;
            });
            // Fire onDragStart event
            onDragStart === null || onDragStart === void 0 || onDragStart(event, info);
            (_a = _this.visualElement.animationState) === null || _a === void 0 || _a.setActive((0, $5fU40.AnimationType).Drag, true);
        };
        var onMove = function(event, info) {
            // latestPointerEvent = event
            var _a = _this.getProps(), dragPropagation = _a.dragPropagation, dragDirectionLock = _a.dragDirectionLock, onDirectionLock = _a.onDirectionLock, onDrag = _a.onDrag;
            // If we didn't successfully receive the gesture lock, early return.
            if (!dragPropagation && !_this.openGlobalLock) return;
            var offset = info.offset;
            // Attempt to detect drag direction if directionLock is true
            if (dragDirectionLock && _this.currentDirection === null) {
                _this.currentDirection = $59924ee873defaad$var$getCurrentDirection(offset);
                // If we've successfully set a direction, notify listener
                if (_this.currentDirection !== null) onDirectionLock === null || onDirectionLock === void 0 || onDirectionLock(_this.currentDirection);
                return;
            }
            // Update each point with the latest position
            _this.updateAxis("x", info.point, offset);
            _this.updateAxis("y", info.point, offset);
            /**
             * Ideally we would leave the renderer to fire naturally at the end of
             * this frame but if the element is about to change layout as the result
             * of a re-render we want to ensure the browser can read the latest
             * bounding box to ensure the pointer and element don't fall out of sync.
             */ _this.visualElement.syncRender();
            /**
             * This must fire after the syncRender call as it might trigger a state
             * change which itself might trigger a layout update.
             */ onDrag === null || onDrag === void 0 || onDrag(event, info);
        };
        var onSessionEnd = function(event, info) {
            return _this.stop(event, info);
        };
        this.panSession = new (0, $hgCC7.PanSession)(originEvent, {
            onSessionStart: onSessionStart,
            onStart: onStart,
            onMove: onMove,
            onSessionEnd: onSessionEnd
        }, {
            transformPagePoint: this.visualElement.getTransformPagePoint()
        });
    };
    VisualElementDragControls.prototype.stop = function(event, info) {
        var isDragging = this.isDragging;
        this.cancel();
        if (!isDragging) return;
        var velocity = info.velocity;
        this.startAnimation(velocity);
        var onDragEnd = this.getProps().onDragEnd;
        onDragEnd === null || onDragEnd === void 0 || onDragEnd(event, info);
    };
    VisualElementDragControls.prototype.cancel = function() {
        var _a, _b;
        this.isDragging = false;
        if (this.visualElement.projection) this.visualElement.projection.isAnimationBlocked = false;
        (_a = this.panSession) === null || _a === void 0 || _a.end();
        this.panSession = undefined;
        var dragPropagation = this.getProps().dragPropagation;
        if (!dragPropagation && this.openGlobalLock) {
            this.openGlobalLock();
            this.openGlobalLock = null;
        }
        (_b = this.visualElement.animationState) === null || _b === void 0 || _b.setActive((0, $5fU40.AnimationType).Drag, false);
    };
    VisualElementDragControls.prototype.updateAxis = function(axis, _point, offset) {
        var drag = this.getProps().drag;
        // If we're not dragging this axis, do an early return.
        if (!offset || !$59924ee873defaad$var$shouldDrag(axis, drag, this.currentDirection)) return;
        var axisValue = this.getAxisMotionValue(axis);
        var next = this.originPoint[axis] + offset[axis];
        // Apply constraints
        if (this.constraints && this.constraints[axis]) next = (0, $j55Mj.applyConstraints)(next, this.constraints[axis], this.elastic[axis]);
        axisValue.set(next);
    };
    VisualElementDragControls.prototype.resolveConstraints = function() {
        var _this = this;
        var _a = this.getProps(), dragConstraints = _a.dragConstraints, dragElastic = _a.dragElastic;
        var layout = (this.visualElement.projection || {}).layout;
        var prevConstraints = this.constraints;
        if (dragConstraints && (0, $cg30p.isRefObject)(dragConstraints)) {
            if (!this.constraints) this.constraints = this.resolveRefConstraints();
        } else if (dragConstraints && layout) this.constraints = (0, $j55Mj.calcRelativeConstraints)(layout.actual, dragConstraints);
        else this.constraints = false;
        this.elastic = (0, $j55Mj.resolveDragElastic)(dragElastic);
        /**
         * If we're outputting to external MotionValues, we want to rebase the measured constraints
         * from viewport-relative to component-relative.
         */ if (prevConstraints !== this.constraints && layout && this.constraints && !this.hasMutatedConstraints) (0, $tnnCU.eachAxis)(function(axis) {
            if (_this.getAxisMotionValue(axis)) _this.constraints[axis] = (0, $j55Mj.rebaseAxisConstraints)(layout.actual[axis], _this.constraints[axis]);
        });
    };
    VisualElementDragControls.prototype.resolveRefConstraints = function() {
        var _a = this.getProps(), constraints = _a.dragConstraints, onMeasureDragConstraints = _a.onMeasureDragConstraints;
        if (!constraints || !(0, $cg30p.isRefObject)(constraints)) return false;
        var constraintsElement = constraints.current;
        (0, $6QSfE.invariant)(constraintsElement !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
        var projection = this.visualElement.projection;
        // TODO
        if (!projection || !projection.layout) return false;
        var constraintsBox = (0, $dJ8Md.measurePageBox)(constraintsElement, projection.root, this.visualElement.getTransformPagePoint());
        var measuredConstraints = (0, $j55Mj.calcViewportConstraints)(projection.layout.actual, constraintsBox);
        /**
         * If there's an onMeasureDragConstraints listener we call it and
         * if different constraints are returned, set constraints to that
         */ if (onMeasureDragConstraints) {
            var userConstraints = onMeasureDragConstraints((0, $iaeDY.convertBoxToBoundingBox)(measuredConstraints));
            this.hasMutatedConstraints = !!userConstraints;
            if (userConstraints) measuredConstraints = (0, $iaeDY.convertBoundingBoxToBox)(userConstraints);
        }
        return measuredConstraints;
    };
    VisualElementDragControls.prototype.startAnimation = function(velocity) {
        var _this = this;
        var _a = this.getProps(), drag = _a.drag, dragMomentum = _a.dragMomentum, dragElastic = _a.dragElastic, dragTransition = _a.dragTransition, dragSnapToOrigin = _a.dragSnapToOrigin, onDragTransitionEnd = _a.onDragTransitionEnd;
        var constraints = this.constraints || {};
        var momentumAnimations = (0, $tnnCU.eachAxis)(function(axis) {
            var _a;
            if (!$59924ee873defaad$var$shouldDrag(axis, drag, _this.currentDirection)) return;
            var transition = (_a = constraints === null || constraints === void 0 ? void 0 : constraints[axis]) !== null && _a !== void 0 ? _a : {};
            if (dragSnapToOrigin) transition = {
                min: 0,
                max: 0
            };
            /**
             * Overdamp the boundary spring if `dragElastic` is disabled. There's still a frame
             * of spring animations so we should look into adding a disable spring option to `inertia`.
             * We could do something here where we affect the `bounceStiffness` and `bounceDamping`
             * using the value of `dragElastic`.
             */ var bounceStiffness = dragElastic ? 200 : 1000000;
            var bounceDamping = dragElastic ? 40 : 10000000;
            var inertia = (0, $7WQrb.__assign)((0, $7WQrb.__assign)({
                type: "inertia",
                velocity: dragMomentum ? velocity[axis] : 0,
                bounceStiffness: bounceStiffness,
                bounceDamping: bounceDamping,
                timeConstant: 750,
                restDelta: 1,
                restSpeed: 10
            }, dragTransition), transition);
            // If we're not animating on an externally-provided `MotionValue` we can use the
            // component's animation controls which will handle interactions with whileHover (etc),
            // otherwise we just have to animate the `MotionValue` itself.
            return _this.startAxisValueAnimation(axis, inertia);
        });
        // Run all animations and then resolve the new drag constraints.
        return Promise.all(momentumAnimations).then(onDragTransitionEnd);
    };
    VisualElementDragControls.prototype.startAxisValueAnimation = function(axis, transition) {
        var axisValue = this.getAxisMotionValue(axis);
        return (0, $bUTXm.startAnimation)(axis, axisValue, 0, transition);
    };
    VisualElementDragControls.prototype.stopAnimation = function() {
        var _this = this;
        (0, $tnnCU.eachAxis)(function(axis) {
            return _this.getAxisMotionValue(axis).stop();
        });
    };
    /**
     * Drag works differently depending on which props are provided.
     *
     * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
     * - Otherwise, we apply the delta to the x/y motion values.
     */ VisualElementDragControls.prototype.getAxisMotionValue = function(axis) {
        var _a, _b;
        var dragKey = "_drag" + axis.toUpperCase();
        var externalMotionValue = this.visualElement.getProps()[dragKey];
        return externalMotionValue ? externalMotionValue : this.visualElement.getValue(axis, (_b = (_a = this.visualElement.getProps().initial) === null || _a === void 0 ? void 0 : _a[axis]) !== null && _b !== void 0 ? _b : 0);
    };
    VisualElementDragControls.prototype.snapToCursor = function(point) {
        var _this = this;
        (0, $tnnCU.eachAxis)(function(axis) {
            var drag = _this.getProps().drag;
            // If we're not dragging this axis, do an early return.
            if (!$59924ee873defaad$var$shouldDrag(axis, drag, _this.currentDirection)) return;
            var projection = _this.visualElement.projection;
            var axisValue = _this.getAxisMotionValue(axis);
            if (projection && projection.layout) {
                var _a = projection.layout.actual[axis], min = _a.min, max = _a.max;
                axisValue.set(point[axis] - (0, $bqVjQ.mix)(min, max, 0.5));
            }
        });
    };
    /**
     * When the viewport resizes we want to check if the measured constraints
     * have changed and, if so, reposition the element within those new constraints
     * relative to where it was before the resize.
     */ VisualElementDragControls.prototype.scalePositionWithinConstraints = function() {
        var _this = this;
        var _a;
        var _b = this.getProps(), drag = _b.drag, dragConstraints = _b.dragConstraints;
        var projection = this.visualElement.projection;
        if (!(0, $cg30p.isRefObject)(dragConstraints) || !projection || !this.constraints) return;
        /**
         * Stop current animations as there can be visual glitching if we try to do
         * this mid-animation
         */ this.stopAnimation();
        /**
         * Record the relative position of the dragged element relative to the
         * constraints box and save as a progress value.
         */ var boxProgress = {
            x: 0,
            y: 0
        };
        (0, $tnnCU.eachAxis)(function(axis) {
            var axisValue = _this.getAxisMotionValue(axis);
            if (axisValue) {
                var latest = axisValue.get();
                boxProgress[axis] = (0, $j55Mj.calcOrigin)({
                    min: latest,
                    max: latest
                }, _this.constraints[axis]);
            }
        });
        /**
         * Update the layout of this element and resolve the latest drag constraints
         */ var transformTemplate = this.visualElement.getProps().transformTemplate;
        this.visualElement.getInstance().style.transform = transformTemplate ? transformTemplate({}, "") : "none";
        (_a = projection.root) === null || _a === void 0 || _a.updateScroll();
        projection.updateLayout();
        this.resolveConstraints();
        /**
         * For each axis, calculate the current progress of the layout axis
         * within the new constraints.
         */ (0, $tnnCU.eachAxis)(function(axis) {
            if (!$59924ee873defaad$var$shouldDrag(axis, drag, null)) return;
            /**
             * Calculate a new transform based on the previous box progress
             */ var axisValue = _this.getAxisMotionValue(axis);
            var _a = _this.constraints[axis], min = _a.min, max = _a.max;
            axisValue.set((0, $bqVjQ.mix)(min, max, boxProgress[axis]));
        });
    };
    VisualElementDragControls.prototype.addListeners = function() {
        var _this = this;
        var _a;
        $59924ee873defaad$export$f0a15892c27dc07c.set(this.visualElement, this);
        var element = this.visualElement.getInstance();
        /**
         * Attach a pointerdown event listener on this DOM element to initiate drag tracking.
         */ var stopPointerListener = (0, $kkba7.addPointerEvent)(element, "pointerdown", function(event) {
            var _a = _this.getProps(), drag = _a.drag, _b = _a.dragListener, dragListener = _b === void 0 ? true : _b;
            drag && dragListener && _this.start(event);
        });
        var measureDragConstraints = function() {
            var dragConstraints = _this.getProps().dragConstraints;
            if ((0, $cg30p.isRefObject)(dragConstraints)) _this.constraints = _this.resolveRefConstraints();
        };
        var projection = this.visualElement.projection;
        var stopMeasureLayoutListener = projection.addEventListener("measure", measureDragConstraints);
        if (projection && !projection.layout) {
            (_a = projection.root) === null || _a === void 0 || _a.updateScroll();
            projection.updateLayout();
        }
        measureDragConstraints();
        /**
         * Attach a window resize listener to scale the draggable target within its defined
         * constraints as the window resizes.
         */ var stopResizeListener = (0, $ao8nn.addDomEvent)(window, "resize", function() {
            return _this.scalePositionWithinConstraints();
        });
        /**
         * If the element's layout changes, calculate the delta and apply that to
         * the drag gesture's origin point.
         */ projection.addEventListener("didUpdate", function(_a) {
            var delta = _a.delta, hasLayoutChanged = _a.hasLayoutChanged;
            if (_this.isDragging && hasLayoutChanged) {
                (0, $tnnCU.eachAxis)(function(axis) {
                    var motionValue = _this.getAxisMotionValue(axis);
                    if (!motionValue) return;
                    _this.originPoint[axis] += delta[axis].translate;
                    motionValue.set(motionValue.get() + delta[axis].translate);
                });
                _this.visualElement.syncRender();
            }
        });
        return function() {
            stopResizeListener();
            stopPointerListener();
            stopMeasureLayoutListener();
        };
    };
    VisualElementDragControls.prototype.getProps = function() {
        var props = this.visualElement.getProps();
        var _a = props.drag, drag = _a === void 0 ? false : _a, _b = props.dragDirectionLock, dragDirectionLock = _b === void 0 ? false : _b, _c = props.dragPropagation, dragPropagation = _c === void 0 ? false : _c, _d = props.dragConstraints, dragConstraints = _d === void 0 ? false : _d, _e = props.dragElastic, dragElastic = _e === void 0 ? (0, $j55Mj.defaultElastic) : _e, _f = props.dragMomentum, dragMomentum = _f === void 0 ? true : _f;
        return (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, props), {
            drag: drag,
            dragDirectionLock: dragDirectionLock,
            dragPropagation: dragPropagation,
            dragConstraints: dragConstraints,
            dragElastic: dragElastic,
            dragMomentum: dragMomentum
        });
    };
    return VisualElementDragControls;
}();
function $59924ee873defaad$var$shouldDrag(direction, drag, currentDirection) {
    return (drag === true || drag === direction) && (currentDirection === null || currentDirection === direction);
}
/**
 * Based on an x/y offset determine the current drag direction. If both axis' offsets are lower
 * than the provided threshold, return `null`.
 *
 * @param offset - The x/y offset from origin.
 * @param lockThreshold - (Optional) - the minimum absolute offset before we can determine a drag direction.
 */ function $59924ee873defaad$var$getCurrentDirection(offset, lockThreshold) {
    if (lockThreshold === void 0) lockThreshold = 10;
    var direction = null;
    if (Math.abs(offset.y) > lockThreshold) direction = "y";
    else if (Math.abs(offset.x) > lockThreshold) direction = "x";
    return direction;
}

});
parcelRegister("hgCC7", function(module, exports) {

$parcel$export(module.exports, "PanSession", () => $6af3e4ae1e03c8d7$export$d9c66232c9c4689c);

var $7WQrb = parcelRequire("7WQrb");

var $3K60Y = parcelRequire("3K60Y");

var $2BisC = parcelRequire("2BisC");

var $9ksIr = parcelRequire("9ksIr");

var $iNwSi = parcelRequire("iNwSi");

var $kkba7 = parcelRequire("kkba7");

var $aCdn9 = parcelRequire("aCdn9");
var $iBhIU = parcelRequire("iBhIU");
/**
 * @internal
 */ var $6af3e4ae1e03c8d7$export$d9c66232c9c4689c = /** @class */ function() {
    function PanSession(event, handlers, _a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, transformPagePoint = _b.transformPagePoint;
        /**
         * @internal
         */ this.startEvent = null;
        /**
         * @internal
         */ this.lastMoveEvent = null;
        /**
         * @internal
         */ this.lastMoveEventInfo = null;
        /**
         * @internal
         */ this.handlers = {};
        this.updatePoint = function() {
            if (!(_this.lastMoveEvent && _this.lastMoveEventInfo)) return;
            var info = $6af3e4ae1e03c8d7$var$getPanInfo(_this.lastMoveEventInfo, _this.history);
            var isPanStarted = _this.startEvent !== null;
            // Only start panning if the offset is larger than 3 pixels. If we make it
            // any larger than this we'll want to reset the pointer history
            // on the first update to avoid visual snapping to the cursoe.
            var isDistancePastThreshold = (0, $aCdn9.distance)(info.offset, {
                x: 0,
                y: 0
            }) >= 3;
            if (!isPanStarted && !isDistancePastThreshold) return;
            var point = info.point;
            var timestamp = (0, $9ksIr.getFrameData)().timestamp;
            _this.history.push((0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, point), {
                timestamp: timestamp
            }));
            var _a = _this.handlers, onStart = _a.onStart, onMove = _a.onMove;
            if (!isPanStarted) {
                onStart && onStart(_this.lastMoveEvent, info);
                _this.startEvent = _this.lastMoveEvent;
            }
            onMove && onMove(_this.lastMoveEvent, info);
        };
        this.handlePointerMove = function(event, info) {
            _this.lastMoveEvent = event;
            _this.lastMoveEventInfo = $6af3e4ae1e03c8d7$var$transformPoint(info, _this.transformPagePoint);
            // Because Safari doesn't trigger mouseup events when it's above a `<select>`
            if ((0, $3K60Y.isMouseEvent)(event) && event.buttons === 0) {
                _this.handlePointerUp(event, info);
                return;
            }
            // Throttle mouse move event to once per frame
            (0, $9ksIr.default).update(_this.updatePoint, true);
        };
        this.handlePointerUp = function(event, info) {
            _this.end();
            var _a = _this.handlers, onEnd = _a.onEnd, onSessionEnd = _a.onSessionEnd;
            var panInfo = $6af3e4ae1e03c8d7$var$getPanInfo($6af3e4ae1e03c8d7$var$transformPoint(info, _this.transformPagePoint), _this.history);
            if (_this.startEvent && onEnd) onEnd(event, panInfo);
            onSessionEnd && onSessionEnd(event, panInfo);
        };
        // If we have more than one touch, don't start detecting this gesture
        if ((0, $3K60Y.isTouchEvent)(event) && event.touches.length > 1) return;
        this.handlers = handlers;
        this.transformPagePoint = transformPagePoint;
        var info = (0, $2BisC.extractEventInfo)(event);
        var initialInfo = $6af3e4ae1e03c8d7$var$transformPoint(info, this.transformPagePoint);
        var point = initialInfo.point;
        var timestamp = (0, $9ksIr.getFrameData)().timestamp;
        this.history = [
            (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, point), {
                timestamp: timestamp
            })
        ];
        var onSessionStart = handlers.onSessionStart;
        onSessionStart && onSessionStart(event, $6af3e4ae1e03c8d7$var$getPanInfo(initialInfo, this.history));
        this.removeListeners = (0, $iBhIU.pipe)((0, $kkba7.addPointerEvent)(window, "pointermove", this.handlePointerMove), (0, $kkba7.addPointerEvent)(window, "pointerup", this.handlePointerUp), (0, $kkba7.addPointerEvent)(window, "pointercancel", this.handlePointerUp));
    }
    PanSession.prototype.updateHandlers = function(handlers) {
        this.handlers = handlers;
    };
    PanSession.prototype.end = function() {
        this.removeListeners && this.removeListeners();
        (0, $9ksIr.cancelSync).update(this.updatePoint);
    };
    return PanSession;
}();
function $6af3e4ae1e03c8d7$var$transformPoint(info, transformPagePoint) {
    return transformPagePoint ? {
        point: transformPagePoint(info.point)
    } : info;
}
function $6af3e4ae1e03c8d7$var$subtractPoint(a, b) {
    return {
        x: a.x - b.x,
        y: a.y - b.y
    };
}
function $6af3e4ae1e03c8d7$var$getPanInfo(_a, history) {
    var point = _a.point;
    return {
        point: point,
        delta: $6af3e4ae1e03c8d7$var$subtractPoint(point, $6af3e4ae1e03c8d7$var$lastDevicePoint(history)),
        offset: $6af3e4ae1e03c8d7$var$subtractPoint(point, $6af3e4ae1e03c8d7$var$startDevicePoint(history)),
        velocity: $6af3e4ae1e03c8d7$var$getVelocity(history, 0.1)
    };
}
function $6af3e4ae1e03c8d7$var$startDevicePoint(history) {
    return history[0];
}
function $6af3e4ae1e03c8d7$var$lastDevicePoint(history) {
    return history[history.length - 1];
}
function $6af3e4ae1e03c8d7$var$getVelocity(history, timeDelta) {
    if (history.length < 2) return {
        x: 0,
        y: 0
    };
    var i = history.length - 1;
    var timestampedPoint = null;
    var lastPoint = $6af3e4ae1e03c8d7$var$lastDevicePoint(history);
    while(i >= 0){
        timestampedPoint = history[i];
        if (lastPoint.timestamp - timestampedPoint.timestamp > (0, $iNwSi.secondsToMilliseconds)(timeDelta)) break;
        i--;
    }
    if (!timestampedPoint) return {
        x: 0,
        y: 0
    };
    var time = (lastPoint.timestamp - timestampedPoint.timestamp) / 1000;
    if (time === 0) return {
        x: 0,
        y: 0
    };
    var currentVelocity = {
        x: (lastPoint.x - timestampedPoint.x) / time,
        y: (lastPoint.y - timestampedPoint.y) / time
    };
    if (currentVelocity.x === Infinity) currentVelocity.x = 0;
    if (currentVelocity.y === Infinity) currentVelocity.y = 0;
    return currentVelocity;
}

});
parcelRegister("aCdn9", function(module, exports) {

$parcel$export(module.exports, "distance", () => $2b642d68d8bc1f9f$export$9f17032d917177de);

var $d2tEt = parcelRequire("d2tEt");

var $bfOsw = parcelRequire("bfOsw");

var $78s4y = parcelRequire("78s4y");
const $2b642d68d8bc1f9f$var$distance1D = (a, b)=>Math.abs(a - b);
function $2b642d68d8bc1f9f$export$9f17032d917177de(a, b) {
    if ((0, $78s4y.isNum)(a) && (0, $78s4y.isNum)(b)) return $2b642d68d8bc1f9f$var$distance1D(a, b);
    else if ((0, $d2tEt.isPoint)(a) && (0, $d2tEt.isPoint)(b)) {
        const xDelta = $2b642d68d8bc1f9f$var$distance1D(a.x, b.x);
        const yDelta = $2b642d68d8bc1f9f$var$distance1D(a.y, b.y);
        const zDelta = (0, $bfOsw.isPoint3D)(a) && (0, $bfOsw.isPoint3D)(b) ? $2b642d68d8bc1f9f$var$distance1D(a.z, b.z) : 0;
        return Math.sqrt(Math.pow(xDelta, 2) + Math.pow(yDelta, 2) + Math.pow(zDelta, 2));
    }
}

});
parcelRegister("d2tEt", function(module, exports) {

$parcel$export(module.exports, "isPoint", () => $e0f954ec4e900a72$export$aff838a5553f2a92);
const $e0f954ec4e900a72$export$aff838a5553f2a92 = (point)=>point.hasOwnProperty("x") && point.hasOwnProperty("y");

});

parcelRegister("bfOsw", function(module, exports) {

$parcel$export(module.exports, "isPoint3D", () => $b52ae3d15e0e9b72$export$319d74662aaa2966);

var $d2tEt = parcelRequire("d2tEt");
const $b52ae3d15e0e9b72$export$319d74662aaa2966 = (point)=>(0, $d2tEt.isPoint)(point) && point.hasOwnProperty("z");

});



parcelRegister("j55Mj", function(module, exports) {

$parcel$export(module.exports, "applyConstraints", () => $2df0cf7aa8fef8fc$export$b3c764d3fca3ffe3);
$parcel$export(module.exports, "calcRelativeConstraints", () => $2df0cf7aa8fef8fc$export$4e9195bf7793bc78);
$parcel$export(module.exports, "calcViewportConstraints", () => $2df0cf7aa8fef8fc$export$4228500f19d4cdf7);
$parcel$export(module.exports, "calcOrigin", () => $2df0cf7aa8fef8fc$export$13abbfca044ca46d);
$parcel$export(module.exports, "rebaseAxisConstraints", () => $2df0cf7aa8fef8fc$export$e9672cc4c36a8b87);
$parcel$export(module.exports, "defaultElastic", () => $2df0cf7aa8fef8fc$export$a3366d3bac43a742);
$parcel$export(module.exports, "resolveDragElastic", () => $2df0cf7aa8fef8fc$export$7c5eaef8f4723d22);

var $7WQrb = parcelRequire("7WQrb");

var $ezcIX = parcelRequire("ezcIX");
var $bqVjQ = parcelRequire("bqVjQ");
var $j248P = parcelRequire("j248P");

var $8BLfb = parcelRequire("8BLfb");
/**
 * Apply constraints to a point. These constraints are both physical along an
 * axis, and an elastic factor that determines how much to constrain the point
 * by if it does lie outside the defined parameters.
 */ function $2df0cf7aa8fef8fc$export$b3c764d3fca3ffe3(point, _a, elastic) {
    var min = _a.min, max = _a.max;
    if (min !== undefined && point < min) // If we have a min point defined, and this is outside of that, constrain
    point = elastic ? (0, $bqVjQ.mix)(min, point, elastic.min) : Math.max(point, min);
    else if (max !== undefined && point > max) // If we have a max point defined, and this is outside of that, constrain
    point = elastic ? (0, $bqVjQ.mix)(max, point, elastic.max) : Math.min(point, max);
    return point;
}
/**
 * Calculate constraints in terms of the viewport when defined relatively to the
 * measured axis. This is measured from the nearest edge, so a max constraint of 200
 * on an axis with a max value of 300 would return a constraint of 500 - axis length
 */ function $2df0cf7aa8fef8fc$export$690c180aa5775042(axis, min, max) {
    return {
        min: min !== undefined ? axis.min + min : undefined,
        max: max !== undefined ? axis.max + max - (axis.max - axis.min) : undefined
    };
}
/**
 * Calculate constraints in terms of the viewport when
 * defined relatively to the measured bounding box.
 */ function $2df0cf7aa8fef8fc$export$4e9195bf7793bc78(layoutBox, _a) {
    var top = _a.top, left = _a.left, bottom = _a.bottom, right = _a.right;
    return {
        x: $2df0cf7aa8fef8fc$export$690c180aa5775042(layoutBox.x, left, right),
        y: $2df0cf7aa8fef8fc$export$690c180aa5775042(layoutBox.y, top, bottom)
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative axis
 */ function $2df0cf7aa8fef8fc$export$87abc398c3c7ce27(layoutAxis, constraintsAxis) {
    var _a;
    var min = constraintsAxis.min - layoutAxis.min;
    var max = constraintsAxis.max - layoutAxis.max;
    // If the constraints axis is actually smaller than the layout axis then we can
    // flip the constraints
    if (constraintsAxis.max - constraintsAxis.min < layoutAxis.max - layoutAxis.min) _a = (0, $7WQrb.__read)([
        max,
        min
    ], 2), min = _a[0], max = _a[1];
    return {
        min: min,
        max: max
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative box
 */ function $2df0cf7aa8fef8fc$export$4228500f19d4cdf7(layoutBox, constraintsBox) {
    return {
        x: $2df0cf7aa8fef8fc$export$87abc398c3c7ce27(layoutBox.x, constraintsBox.x),
        y: $2df0cf7aa8fef8fc$export$87abc398c3c7ce27(layoutBox.y, constraintsBox.y)
    };
}
/**
 * Calculate a transform origin relative to the source axis, between 0-1, that results
 * in an asthetically pleasing scale/transform needed to project from source to target.
 */ function $2df0cf7aa8fef8fc$export$13abbfca044ca46d(source, target) {
    var origin = 0.5;
    var sourceLength = (0, $8BLfb.calcLength)(source);
    var targetLength = (0, $8BLfb.calcLength)(target);
    if (targetLength > sourceLength) origin = (0, $j248P.progress)(target.min, target.max - sourceLength, source.min);
    else if (sourceLength > targetLength) origin = (0, $j248P.progress)(source.min, source.max - targetLength, target.min);
    return (0, $ezcIX.clamp)(0, 1, origin);
}
/**
 * Rebase the calculated viewport constraints relative to the layout.min point.
 */ function $2df0cf7aa8fef8fc$export$e9672cc4c36a8b87(layout, constraints) {
    var relativeConstraints = {};
    if (constraints.min !== undefined) relativeConstraints.min = constraints.min - layout.min;
    if (constraints.max !== undefined) relativeConstraints.max = constraints.max - layout.min;
    return relativeConstraints;
}
var $2df0cf7aa8fef8fc$export$a3366d3bac43a742 = 0.35;
/**
 * Accepts a dragElastic prop and returns resolved elastic values for each axis.
 */ function $2df0cf7aa8fef8fc$export$7c5eaef8f4723d22(dragElastic) {
    if (dragElastic === void 0) dragElastic = $2df0cf7aa8fef8fc$export$a3366d3bac43a742;
    if (dragElastic === false) dragElastic = 0;
    else if (dragElastic === true) dragElastic = $2df0cf7aa8fef8fc$export$a3366d3bac43a742;
    return {
        x: $2df0cf7aa8fef8fc$export$589076940abb04b5(dragElastic, "left", "right"),
        y: $2df0cf7aa8fef8fc$export$589076940abb04b5(dragElastic, "top", "bottom")
    };
}
function $2df0cf7aa8fef8fc$export$589076940abb04b5(dragElastic, minLabel, maxLabel) {
    return {
        min: $2df0cf7aa8fef8fc$export$bbbc10b82e6c0afb(dragElastic, minLabel),
        max: $2df0cf7aa8fef8fc$export$bbbc10b82e6c0afb(dragElastic, maxLabel)
    };
}
function $2df0cf7aa8fef8fc$export$bbbc10b82e6c0afb(dragElastic, label) {
    var _a;
    return typeof dragElastic === "number" ? dragElastic : (_a = dragElastic[label]) !== null && _a !== void 0 ? _a : 0;
}

});
parcelRegister("8BLfb", function(module, exports) {

$parcel$export(module.exports, "calcLength", () => $b352f7cdd42c49d7$export$c1c127004b72a37);
$parcel$export(module.exports, "calcBoxDelta", () => $b352f7cdd42c49d7$export$c0d25e96fc67d310);
$parcel$export(module.exports, "calcRelativeBox", () => $b352f7cdd42c49d7$export$426154f9d100f99);
$parcel$export(module.exports, "calcRelativePosition", () => $b352f7cdd42c49d7$export$2785bfcc929c5650);

var $aCdn9 = parcelRequire("aCdn9");
var $bqVjQ = parcelRequire("bqVjQ");
function $b352f7cdd42c49d7$export$c1c127004b72a37(axis) {
    return axis.max - axis.min;
}
function $b352f7cdd42c49d7$export$28d0384c4b79bde2(value, target, maxDistance) {
    if (target === void 0) target = 0;
    if (maxDistance === void 0) maxDistance = 0.01;
    return (0, $aCdn9.distance)(value, target) < maxDistance;
}
function $b352f7cdd42c49d7$export$e90fc1ae5e3e48ed(delta, source, target, origin) {
    if (origin === void 0) origin = 0.5;
    delta.origin = origin;
    delta.originPoint = (0, $bqVjQ.mix)(source.min, source.max, delta.origin);
    delta.scale = $b352f7cdd42c49d7$export$c1c127004b72a37(target) / $b352f7cdd42c49d7$export$c1c127004b72a37(source);
    if ($b352f7cdd42c49d7$export$28d0384c4b79bde2(delta.scale, 1, 0.0001) || isNaN(delta.scale)) delta.scale = 1;
    delta.translate = (0, $bqVjQ.mix)(target.min, target.max, delta.origin) - delta.originPoint;
    if ($b352f7cdd42c49d7$export$28d0384c4b79bde2(delta.translate) || isNaN(delta.translate)) delta.translate = 0;
}
function $b352f7cdd42c49d7$export$c0d25e96fc67d310(delta, source, target, origin) {
    $b352f7cdd42c49d7$export$e90fc1ae5e3e48ed(delta.x, source.x, target.x, origin === null || origin === void 0 ? void 0 : origin.originX);
    $b352f7cdd42c49d7$export$e90fc1ae5e3e48ed(delta.y, source.y, target.y, origin === null || origin === void 0 ? void 0 : origin.originY);
}
function $b352f7cdd42c49d7$export$cabef5b392704b41(target, relative, parent) {
    target.min = parent.min + relative.min;
    target.max = target.min + $b352f7cdd42c49d7$export$c1c127004b72a37(relative);
}
function $b352f7cdd42c49d7$export$426154f9d100f99(target, relative, parent) {
    $b352f7cdd42c49d7$export$cabef5b392704b41(target.x, relative.x, parent.x);
    $b352f7cdd42c49d7$export$cabef5b392704b41(target.y, relative.y, parent.y);
}
function $b352f7cdd42c49d7$export$ecd3d3bef81102c3(target, layout, parent) {
    target.min = layout.min - parent.min;
    target.max = target.min + $b352f7cdd42c49d7$export$c1c127004b72a37(layout);
}
function $b352f7cdd42c49d7$export$2785bfcc929c5650(target, layout, parent) {
    $b352f7cdd42c49d7$export$ecd3d3bef81102c3(target.x, layout.x, parent.x);
    $b352f7cdd42c49d7$export$ecd3d3bef81102c3(target.y, layout.y, parent.y);
}

});


parcelRegister("8v3iT", function(module, exports) {

$parcel$export(module.exports, "createDelta", () => $a3727e4e12b23353$export$3d227df54007d73a);
$parcel$export(module.exports, "createBox", () => $a3727e4e12b23353$export$6459fc9e86be362e);
var $a3727e4e12b23353$export$ff25708b37f72782 = function() {
    return {
        translate: 0,
        scale: 1,
        origin: 0,
        originPoint: 0
    };
};
var $a3727e4e12b23353$export$3d227df54007d73a = function() {
    return {
        x: $a3727e4e12b23353$export$ff25708b37f72782(),
        y: $a3727e4e12b23353$export$ff25708b37f72782()
    };
};
var $a3727e4e12b23353$export$6db76765312617ac = function() {
    return {
        min: 0,
        max: 0
    };
};
var $a3727e4e12b23353$export$6459fc9e86be362e = function() {
    return {
        x: $a3727e4e12b23353$export$6db76765312617ac(),
        y: $a3727e4e12b23353$export$6db76765312617ac()
    };
};

});

parcelRegister("tnnCU", function(module, exports) {

$parcel$export(module.exports, "eachAxis", () => $247f90d2510fbc55$export$b789de563eb43b1);
function $247f90d2510fbc55$export$b789de563eb43b1(callback) {
    return [
        callback("x"),
        callback("y")
    ];
}

});

parcelRegister("dJ8Md", function(module, exports) {

$parcel$export(module.exports, "measureViewportBox", () => $4ca2f8055771ddf4$export$d8718b6a7e5c624e);
$parcel$export(module.exports, "measurePageBox", () => $4ca2f8055771ddf4$export$6a597be7a7940a96);

var $iaeDY = parcelRequire("iaeDY");

var $fxwRw = parcelRequire("fxwRw");
function $4ca2f8055771ddf4$export$d8718b6a7e5c624e(instance, transformPoint) {
    return (0, $iaeDY.convertBoundingBoxToBox)((0, $iaeDY.transformBoxPoints)(instance.getBoundingClientRect(), transformPoint));
}
function $4ca2f8055771ddf4$export$6a597be7a7940a96(element, rootProjectionNode, transformPagePoint) {
    var viewportBox = $4ca2f8055771ddf4$export$d8718b6a7e5c624e(element, transformPagePoint);
    var scroll = rootProjectionNode.scroll;
    if (scroll) {
        (0, $fxwRw.translateAxis)(viewportBox.x, scroll.x);
        (0, $fxwRw.translateAxis)(viewportBox.y, scroll.y);
    }
    return viewportBox;
}

});
parcelRegister("iaeDY", function(module, exports) {

$parcel$export(module.exports, "convertBoundingBoxToBox", () => $0e0401fe38bd0bd1$export$d3955c6a8f65a36b);
$parcel$export(module.exports, "convertBoxToBoundingBox", () => $0e0401fe38bd0bd1$export$b6b9cd4198191a47);
$parcel$export(module.exports, "transformBoxPoints", () => $0e0401fe38bd0bd1$export$21543fb75483a50);
/**
 * Bounding boxes tend to be defined as top, left, right, bottom. For various operations
 * it's easier to consider each axis individually. This function returns a bounding box
 * as a map of single-axis min/max values.
 */ function $0e0401fe38bd0bd1$export$d3955c6a8f65a36b(_a) {
    var top = _a.top, left = _a.left, right = _a.right, bottom = _a.bottom;
    return {
        x: {
            min: left,
            max: right
        },
        y: {
            min: top,
            max: bottom
        }
    };
}
function $0e0401fe38bd0bd1$export$b6b9cd4198191a47(_a) {
    var x = _a.x, y = _a.y;
    return {
        top: y.min,
        right: x.max,
        bottom: y.max,
        left: x.min
    };
}
/**
 * Applies a TransformPoint function to a bounding box. TransformPoint is usually a function
 * provided by Framer to allow measured points to be corrected for device scaling. This is used
 * when measuring DOM elements and DOM event points.
 */ function $0e0401fe38bd0bd1$export$21543fb75483a50(point, transformPoint) {
    if (!transformPoint) return point;
    var topLeft = transformPoint({
        x: point.left,
        y: point.top
    });
    var bottomRight = transformPoint({
        x: point.right,
        y: point.bottom
    });
    return {
        top: topLeft.y,
        left: topLeft.x,
        bottom: bottomRight.y,
        right: bottomRight.x
    };
}

});

parcelRegister("fxwRw", function(module, exports) {

$parcel$export(module.exports, "scalePoint", () => $d8332eb74969584e$export$2290ec7febe36dd6);
$parcel$export(module.exports, "applyBoxDelta", () => $d8332eb74969584e$export$d80074982803af5c);
$parcel$export(module.exports, "applyTreeDeltas", () => $d8332eb74969584e$export$e2a980535c55eabb);
$parcel$export(module.exports, "transformBox", () => $d8332eb74969584e$export$58b16271041fbfb);
$parcel$export(module.exports, "translateAxis", () => $d8332eb74969584e$export$a807a5ce5ebb3895);

var $7WQrb = parcelRequire("7WQrb");

var $bqVjQ = parcelRequire("bqVjQ");

var $3xchP = parcelRequire("3xchP");
/**
 * Scales a point based on a factor and an originPoint
 */ function $d8332eb74969584e$export$2290ec7febe36dd6(point, scale, originPoint) {
    var distanceFromOrigin = point - originPoint;
    var scaled = scale * distanceFromOrigin;
    return originPoint + scaled;
}
/**
 * Applies a translate/scale delta to a point
 */ function $d8332eb74969584e$export$4e122ddcc0c61a2e(point, translate, scale, originPoint, boxScale) {
    if (boxScale !== undefined) point = $d8332eb74969584e$export$2290ec7febe36dd6(point, boxScale, originPoint);
    return $d8332eb74969584e$export$2290ec7febe36dd6(point, scale, originPoint) + translate;
}
/**
 * Applies a translate/scale delta to an axis
 */ function $d8332eb74969584e$export$e8e3a712e9ebf422(axis, translate, scale, originPoint, boxScale) {
    if (translate === void 0) translate = 0;
    if (scale === void 0) scale = 1;
    axis.min = $d8332eb74969584e$export$4e122ddcc0c61a2e(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $d8332eb74969584e$export$4e122ddcc0c61a2e(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Applies a translate/scale delta to a box
 */ function $d8332eb74969584e$export$d80074982803af5c(box, _a) {
    var x = _a.x, y = _a.y;
    $d8332eb74969584e$export$e8e3a712e9ebf422(box.x, x.translate, x.scale, x.originPoint);
    $d8332eb74969584e$export$e8e3a712e9ebf422(box.y, y.translate, y.scale, y.originPoint);
}
/**
 * Apply a tree of deltas to a box. We do this to calculate the effect of all the transforms
 * in a tree upon our box before then calculating how to project it into our desired viewport-relative box
 *
 * This is the final nested loop within updateLayoutDelta for future refactoring
 */ function $d8332eb74969584e$export$e2a980535c55eabb(box, treeScale, treePath, isSharedTransition) {
    var _a, _b;
    if (isSharedTransition === void 0) isSharedTransition = false;
    var treeLength = treePath.length;
    if (!treeLength) return;
    // Reset the treeScale
    treeScale.x = treeScale.y = 1;
    var node;
    var delta;
    for(var i = 0; i < treeLength; i++){
        node = treePath[i];
        delta = node.projectionDelta;
        if (((_b = (_a = node.instance) === null || _a === void 0 ? void 0 : _a.style) === null || _b === void 0 ? void 0 : _b.display) === "contents") continue;
        if (isSharedTransition && node.options.layoutScroll && node.scroll && node !== node.root) $d8332eb74969584e$export$58b16271041fbfb(box, {
            x: -node.scroll.x,
            y: -node.scroll.y
        });
        if (delta) {
            // Incoporate each ancestor's scale into a culmulative treeScale for this component
            treeScale.x *= delta.x.scale;
            treeScale.y *= delta.y.scale;
            // Apply each ancestor's calculated delta into this component's recorded layout box
            $d8332eb74969584e$export$d80074982803af5c(box, delta);
        }
        if (isSharedTransition && (0, $3xchP.hasTransform)(node.latestValues)) $d8332eb74969584e$export$58b16271041fbfb(box, node.latestValues);
    }
}
function $d8332eb74969584e$export$a807a5ce5ebb3895(axis, distance) {
    axis.min = axis.min + distance;
    axis.max = axis.max + distance;
}
/**
 * Apply a transform to an axis from the latest resolved motion values.
 * This function basically acts as a bridge between a flat motion value map
 * and applyAxisDelta
 */ function $d8332eb74969584e$export$625f1dd140a2f5e7(axis, transforms, _a) {
    var _b = (0, $7WQrb.__read)(_a, 3), key = _b[0], scaleKey = _b[1], originKey = _b[2];
    var axisOrigin = transforms[originKey] !== undefined ? transforms[originKey] : 0.5;
    var originPoint = (0, $bqVjQ.mix)(axis.min, axis.max, axisOrigin);
    // Apply the axis delta to the final axis
    $d8332eb74969584e$export$e8e3a712e9ebf422(axis, transforms[key], transforms[scaleKey], originPoint, transforms.scale);
}
/**
 * The names of the motion values we want to apply as translation, scale and origin.
 */ var $d8332eb74969584e$var$xKeys = [
    "x",
    "scaleX",
    "originX"
];
var $d8332eb74969584e$var$yKeys = [
    "y",
    "scaleY",
    "originY"
];
/**
 * Apply a transform to a box from the latest resolved motion values.
 */ function $d8332eb74969584e$export$58b16271041fbfb(box, transform) {
    $d8332eb74969584e$export$625f1dd140a2f5e7(box.x, transform, $d8332eb74969584e$var$xKeys);
    $d8332eb74969584e$export$625f1dd140a2f5e7(box.y, transform, $d8332eb74969584e$var$yKeys);
}

});
parcelRegister("3xchP", function(module, exports) {

$parcel$export(module.exports, "hasScale", () => $fe0ee806cd19fc1f$export$bdf30dca883ea463);
$parcel$export(module.exports, "hasTransform", () => $fe0ee806cd19fc1f$export$a545127cf1fbb600);
function $fe0ee806cd19fc1f$var$isIdentityScale(scale) {
    return scale === undefined || scale === 1;
}
function $fe0ee806cd19fc1f$export$bdf30dca883ea463(_a) {
    var scale = _a.scale, scaleX = _a.scaleX, scaleY = _a.scaleY;
    return !$fe0ee806cd19fc1f$var$isIdentityScale(scale) || !$fe0ee806cd19fc1f$var$isIdentityScale(scaleX) || !$fe0ee806cd19fc1f$var$isIdentityScale(scaleY);
}
function $fe0ee806cd19fc1f$export$a545127cf1fbb600(values) {
    return $fe0ee806cd19fc1f$export$bdf30dca883ea463(values) || $fe0ee806cd19fc1f$var$hasTranslate(values.x) || $fe0ee806cd19fc1f$var$hasTranslate(values.y) || values.z || values.rotate || values.rotateX || values.rotateY;
}
function $fe0ee806cd19fc1f$var$hasTranslate(value) {
    return value && value !== "0%";
}

});





parcelRegister("9uZOf", function(module, exports) {

$parcel$export(module.exports, "usePanGesture", () => $86a042f96484b9fd$export$eb0f62174cac1aec);

var $acw62 = parcelRequire("acw62");

var $7iCGF = parcelRequire("7iCGF");

var $brX5J = parcelRequire("brX5J");

var $kkba7 = parcelRequire("kkba7");

var $hgCC7 = parcelRequire("hgCC7");
/**
 *
 * @param handlers -
 * @param ref -
 *
 * @privateRemarks
 * Currently this sets new pan gesture functions every render. The memo route has been explored
 * in the past but ultimately we're still creating new functions every render. An optimisation
 * to explore is creating the pan gestures and loading them into a `ref`.
 *
 * @internal
 */ function $86a042f96484b9fd$export$eb0f62174cac1aec(_a) {
    var onPan = _a.onPan, onPanStart = _a.onPanStart, onPanEnd = _a.onPanEnd, onPanSessionStart = _a.onPanSessionStart, visualElement = _a.visualElement;
    var hasPanEvents = onPan || onPanStart || onPanEnd || onPanSessionStart;
    var panSession = (0, $acw62.useRef)(null);
    var transformPagePoint = (0, $acw62.useContext)((0, $7iCGF.MotionConfigContext)).transformPagePoint;
    var handlers = {
        onSessionStart: onPanSessionStart,
        onStart: onPanStart,
        onMove: onPan,
        onEnd: function(event, info) {
            panSession.current = null;
            onPanEnd && onPanEnd(event, info);
        }
    };
    (0, $acw62.useEffect)(function() {
        if (panSession.current !== null) panSession.current.updateHandlers(handlers);
    });
    function onPointerDown(event) {
        panSession.current = new (0, $hgCC7.PanSession)(event, handlers, {
            transformPagePoint: transformPagePoint
        });
    }
    (0, $kkba7.usePointerEvent)(visualElement, "pointerdown", hasPanEvents && onPointerDown);
    (0, $brX5J.useUnmountEffect)(function() {
        return panSession.current && panSession.current.end();
    });
}

});


parcelRegister("6LgnS", function(module, exports) {

$parcel$export(module.exports, "createDomVisualElement", () => $2f8881102ac6dde9$export$56ba0183203348f5);

var $1tKT6 = parcelRequire("1tKT6");

var $eBO7r = parcelRequire("eBO7r");

var $9GusU = parcelRequire("9GusU");
var $2f8881102ac6dde9$export$56ba0183203348f5 = function(Component, options) {
    return (0, $9GusU.isSVGComponent)(Component) ? (0, $eBO7r.svgVisualElement)(options, {
        enableHardwareAcceleration: false
    }) : (0, $1tKT6.htmlVisualElement)(options, {
        enableHardwareAcceleration: true
    });
};

});
parcelRegister("1tKT6", function(module, exports) {

$parcel$export(module.exports, "htmlConfig", () => $f16d3e35a730d0e1$export$985b1494d4aeee90);
$parcel$export(module.exports, "htmlVisualElement", () => $f16d3e35a730d0e1$export$9509f7c142585e92);

var $7WQrb = parcelRequire("7WQrb");

var $ebUnu = parcelRequire("ebUnu");

var $87OLY = parcelRequire("87OLY");

var $9U95V = parcelRequire("9U95V");

var $dAJIO = parcelRequire("dAJIO");

var $9o6ZN = parcelRequire("9o6ZN");

var $5f0mC = parcelRequire("5f0mC");

var $eZ617 = parcelRequire("eZ617");

var $fMnH3 = parcelRequire("fMnH3");

var $h8BN3 = parcelRequire("h8BN3");

var $dJ8Md = parcelRequire("dJ8Md");
function $f16d3e35a730d0e1$export$3735103072e4a80(element) {
    return window.getComputedStyle(element);
}
var $f16d3e35a730d0e1$export$985b1494d4aeee90 = {
    treeType: "dom",
    readValueFromInstance: function(domElement, key) {
        if ((0, $5f0mC.isTransformProp)(key)) {
            var defaultType = (0, $h8BN3.getDefaultValueType)(key);
            return defaultType ? defaultType.default || 0 : 0;
        } else {
            var computedStyle = $f16d3e35a730d0e1$export$3735103072e4a80(domElement);
            return ((0, $dAJIO.isCSSVariable)(key) ? computedStyle.getPropertyValue(key) : computedStyle[key]) || 0;
        }
    },
    sortNodePosition: function(a, b) {
        /**
         * compareDocumentPosition returns a bitmask, by using the bitwise &
         * we're returning true if 2 in that bitmask is set to true. 2 is set
         * to true if b preceeds a.
         */ return a.compareDocumentPosition(b) & 2 ? 1 : -1;
    },
    getBaseTarget: function(props, key) {
        var _a;
        return (_a = props.style) === null || _a === void 0 ? void 0 : _a[key];
    },
    measureViewportBox: function(element, _a) {
        var transformPagePoint = _a.transformPagePoint;
        return (0, $dJ8Md.measureViewportBox)(element, transformPagePoint);
    },
    /**
     * Reset the transform on the current Element. This is called as part
     * of a batched process across the entire layout tree. To remove this write
     * cycle it'd be interesting to see if it's possible to "undo" all the current
     * layout transforms up the tree in the same way this.getBoundingBoxWithoutTransforms
     * works
     */ resetTransform: function(element, domElement, props) {
        var transformTemplate = props.transformTemplate;
        domElement.style.transform = transformTemplate ? transformTemplate({}, "") : "none";
        // Ensure that whatever happens next, we restore our transform on the next frame
        element.scheduleRender();
    },
    restoreTransform: function(instance, mutableState) {
        instance.style.transform = mutableState.style.transform;
    },
    removeValueFromRenderState: function(key, _a) {
        var vars = _a.vars, style = _a.style;
        delete vars[key];
        delete style[key];
    },
    /**
     * Ensure that HTML and Framer-specific value types like `px`->`%` and `Color`
     * can be animated by Motion.
     */ makeTargetAnimatable: function(element, _a, _b, isMounted) {
        var transformValues = _b.transformValues;
        if (isMounted === void 0) isMounted = true;
        var transition = _a.transition, transitionEnd = _a.transitionEnd, target = (0, $7WQrb.__rest)(_a, [
            "transition",
            "transitionEnd"
        ]);
        var origin = (0, $87OLY.getOrigin)(target, transition || {}, element);
        /**
         * If Framer has provided a function to convert `Color` etc value types, convert them
         */ if (transformValues) {
            if (transitionEnd) transitionEnd = transformValues(transitionEnd);
            if (target) target = transformValues(target);
            if (origin) origin = transformValues(origin);
        }
        if (isMounted) {
            (0, $87OLY.checkTargetForNewValues)(element, target, origin);
            var parsed = (0, $9o6ZN.parseDomVariant)(element, target, origin, transitionEnd);
            transitionEnd = parsed.transitionEnd;
            target = parsed.target;
        }
        return (0, $7WQrb.__assign)({
            transition: transition,
            transitionEnd: transitionEnd
        }, target);
    },
    scrapeMotionValuesFromProps: (0, $eZ617.scrapeMotionValuesFromProps),
    build: function(element, renderState, latestValues, options, props) {
        if (element.isVisible !== undefined) renderState.style.visibility = element.isVisible ? "visible" : "hidden";
        (0, $9U95V.buildHTMLStyles)(renderState, latestValues, options, props.transformTemplate);
    },
    render: (0, $fMnH3.renderHTML)
};
var $f16d3e35a730d0e1$export$9509f7c142585e92 = (0, $ebUnu.visualElement)($f16d3e35a730d0e1$export$985b1494d4aeee90);

});
parcelRegister("ebUnu", function(module, exports) {

$parcel$export(module.exports, "visualElement", () => $cb00410237ef0648$export$5ad594e944c33d76);

var $7WQrb = parcelRequire("7WQrb");

var $9ksIr = parcelRequire("9ksIr");

var $9s8eJ = parcelRequire("9s8eJ");

var $jqFCw = parcelRequire("jqFCw");

var $dOx92 = parcelRequire("dOx92");

var $g4QPe = parcelRequire("g4QPe");

var $jyqX9 = parcelRequire("jyqX9");

var $8QQaD = parcelRequire("8QQaD");
var $cb00410237ef0648$export$5ad594e944c33d76 = function(_a) {
    var _b = _a.treeType, treeType = _b === void 0 ? "" : _b, build = _a.build, getBaseTarget = _a.getBaseTarget, makeTargetAnimatable = _a.makeTargetAnimatable, measureViewportBox = _a.measureViewportBox, renderInstance = _a.render, readValueFromInstance = _a.readValueFromInstance, removeValueFromRenderState = _a.removeValueFromRenderState, sortNodePosition = _a.sortNodePosition, scrapeMotionValuesFromProps = _a.scrapeMotionValuesFromProps;
    return function(_a, options) {
        var parent = _a.parent, props = _a.props, presenceId = _a.presenceId, blockInitialAnimation = _a.blockInitialAnimation, visualState = _a.visualState, shouldReduceMotion = _a.shouldReduceMotion;
        if (options === void 0) options = {};
        var isMounted = false;
        var latestValues = visualState.latestValues, renderState = visualState.renderState;
        /**
         * The instance of the render-specific node that will be hydrated by the
         * exposed React ref. So for example, this visual element can host a
         * HTMLElement, plain object, or Three.js object. The functions provided
         * in VisualElementConfig allow us to interface with this instance.
         */ var instance;
        /**
         * Manages the subscriptions for a visual element's lifecycle, for instance
         * onRender
         */ var lifecycles = (0, $g4QPe.createLifecycles)();
        /**
         * A map of all motion values attached to this visual element. Motion
         * values are source of truth for any given animated value. A motion
         * value might be provided externally by the component via props.
         */ var values = new Map();
        /**
         * A map of every subscription that binds the provided or generated
         * motion values onChange listeners to this visual element.
         */ var valueSubscriptions = new Map();
        /**
         * A reference to the previously-provided motion values as returned
         * from scrapeMotionValuesFromProps. We use the keys in here to determine
         * if any motion values need to be removed after props are updated.
         */ var prevMotionValues = {};
        /**
         * When values are removed from all animation props we need to search
         * for a fallback value to animate to. These values are tracked in baseTarget.
         */ var baseTarget = (0, $7WQrb.__assign)({}, latestValues);
        // Internal methods ========================
        /**
         * On mount, this will be hydrated with a callback to disconnect
         * this visual element from its parent on unmount.
         */ var removeFromVariantTree;
        /**
         * Render the element with the latest styles outside of the React
         * render lifecycle
         */ function render() {
            if (!instance || !isMounted) return;
            triggerBuild();
            renderInstance(instance, renderState, props.style, element.projection);
        }
        function triggerBuild() {
            build(element, renderState, latestValues, options, props);
        }
        function update() {
            lifecycles.notifyUpdate(latestValues);
        }
        /**
         *
         */ function bindToMotionValue(key, value) {
            var removeOnChange = value.onChange(function(latestValue) {
                latestValues[key] = latestValue;
                props.onUpdate && (0, $9ksIr.default).update(update, false, true);
            });
            var removeOnRenderRequest = value.onRenderRequest(element.scheduleRender);
            valueSubscriptions.set(key, function() {
                removeOnChange();
                removeOnRenderRequest();
            });
        }
        /**
         * Any motion values that are provided to the element when created
         * aren't yet bound to the element, as this would technically be impure.
         * However, we iterate through the motion values and set them to the
         * initial values for this component.
         *
         * TODO: This is impure and we should look at changing this to run on mount.
         * Doing so will break some tests but this isn't neccessarily a breaking change,
         * more a reflection of the test.
         */ var initialMotionValues = scrapeMotionValuesFromProps(props);
        for(var key in initialMotionValues){
            var value = initialMotionValues[key];
            if (latestValues[key] !== undefined && (0, $jqFCw.isMotionValue)(value)) value.set(latestValues[key], false);
        }
        /**
         * Determine what role this visual element should take in the variant tree.
         */ var isControllingVariants = (0, $8QQaD.checkIfControllingVariants)(props);
        var isVariantNode = (0, $8QQaD.checkIfVariantNode)(props);
        var element = (0, $7WQrb.__assign)((0, $7WQrb.__assign)({
            treeType: treeType,
            /**
             * This is a mirror of the internal instance prop, which keeps
             * VisualElement type-compatible with React's RefObject.
             */ current: null,
            /**
             * The depth of this visual element within the visual element tree.
             */ depth: parent ? parent.depth + 1 : 0,
            parent: parent,
            children: new Set(),
            /**
             *
             */ presenceId: presenceId,
            shouldReduceMotion: shouldReduceMotion,
            /**
             * If this component is part of the variant tree, it should track
             * any children that are also part of the tree. This is essentially
             * a shadow tree to simplify logic around how to stagger over children.
             */ variantChildren: isVariantNode ? new Set() : undefined,
            /**
             * Whether this instance is visible. This can be changed imperatively
             * by the projection tree, is analogous to CSS's visibility in that
             * hidden elements should take up layout, and needs enacting by the configured
             * render function.
             */ isVisible: undefined,
            /**
             * Normally, if a component is controlled by a parent's variants, it can
             * rely on that ancestor to trigger animations further down the tree.
             * However, if a component is created after its parent is mounted, the parent
             * won't trigger that mount animation so the child needs to.
             *
             * TODO: This might be better replaced with a method isParentMounted
             */ manuallyAnimateOnMount: Boolean(parent === null || parent === void 0 ? void 0 : parent.isMounted()),
            /**
             * This can be set by AnimatePresence to force components that mount
             * at the same time as it to mount as if they have initial={false} set.
             */ blockInitialAnimation: blockInitialAnimation,
            /**
             * Determine whether this component has mounted yet. This is mostly used
             * by variant children to determine whether they need to trigger their
             * own animations on mount.
             */ isMounted: function() {
                return Boolean(instance);
            },
            mount: function(newInstance) {
                isMounted = true;
                instance = element.current = newInstance;
                if (element.projection) element.projection.mount(newInstance);
                if (isVariantNode && parent && !isControllingVariants) removeFromVariantTree = parent === null || parent === void 0 ? void 0 : parent.addVariantChild(element);
                values.forEach(function(value, key) {
                    return bindToMotionValue(key, value);
                });
                parent === null || parent === void 0 || parent.children.add(element);
                element.setProps(props);
            },
            /**
             *
             */ unmount: function() {
                var _a;
                (_a = element.projection) === null || _a === void 0 || _a.unmount();
                (0, $9ksIr.cancelSync).update(update);
                (0, $9ksIr.cancelSync).render(render);
                valueSubscriptions.forEach(function(remove) {
                    return remove();
                });
                removeFromVariantTree === null || removeFromVariantTree === void 0 || removeFromVariantTree();
                parent === null || parent === void 0 || parent.children.delete(element);
                lifecycles.clearAllListeners();
                instance = undefined;
                isMounted = false;
            },
            /**
             * Add a child visual element to our set of children.
             */ addVariantChild: function(child) {
                var _a;
                var closestVariantNode = element.getClosestVariantNode();
                if (closestVariantNode) {
                    (_a = closestVariantNode.variantChildren) === null || _a === void 0 || _a.add(child);
                    return function() {
                        return closestVariantNode.variantChildren.delete(child);
                    };
                }
            },
            sortNodePosition: function(other) {
                /**
                 * If these nodes aren't even of the same type we can't compare their depth.
                 */ if (!sortNodePosition || treeType !== other.treeType) return 0;
                return sortNodePosition(element.getInstance(), other.getInstance());
            },
            /**
             * Returns the closest variant node in the tree starting from
             * this visual element.
             */ getClosestVariantNode: function() {
                return isVariantNode ? element : parent === null || parent === void 0 ? void 0 : parent.getClosestVariantNode();
            },
            /**
             * Expose the latest layoutId prop.
             */ getLayoutId: function() {
                return props.layoutId;
            },
            /**
             * Returns the current instance.
             */ getInstance: function() {
                return instance;
            },
            /**
             * Get/set the latest static values.
             */ getStaticValue: function(key) {
                return latestValues[key];
            },
            setStaticValue: function(key, value) {
                return latestValues[key] = value;
            },
            /**
             * Returns the latest motion value state. Currently only used to take
             * a snapshot of the visual element - perhaps this can return the whole
             * visual state
             */ getLatestValues: function() {
                return latestValues;
            },
            /**
             * Set the visiblity of the visual element. If it's changed, schedule
             * a render to reflect these changes.
             */ setVisibility: function(visibility) {
                if (element.isVisible === visibility) return;
                element.isVisible = visibility;
                element.scheduleRender();
            },
            /**
             * Make a target animatable by Popmotion. For instance, if we're
             * trying to animate width from 100px to 100vw we need to measure 100vw
             * in pixels to determine what we really need to animate to. This is also
             * pluggable to support Framer's custom value types like Color,
             * and CSS variables.
             */ makeTargetAnimatable: function(target, canMutate) {
                if (canMutate === void 0) canMutate = true;
                return makeTargetAnimatable(element, target, props, canMutate);
            },
            /**
             * Measure the current viewport box with or without transforms.
             * Only measures axis-aligned boxes, rotate and skew must be manually
             * removed with a re-render to work.
             */ measureViewportBox: function() {
                return measureViewportBox(instance, props);
            },
            // Motion values ========================
            /**
             * Add a motion value and bind it to this visual element.
             */ addValue: function(key, value) {
                // Remove existing value if it exists
                if (element.hasValue(key)) element.removeValue(key);
                values.set(key, value);
                latestValues[key] = value.get();
                bindToMotionValue(key, value);
            },
            /**
             * Remove a motion value and unbind any active subscriptions.
             */ removeValue: function(key) {
                var _a;
                values.delete(key);
                (_a = valueSubscriptions.get(key)) === null || _a === void 0 || _a();
                valueSubscriptions.delete(key);
                delete latestValues[key];
                removeValueFromRenderState(key, renderState);
            },
            /**
             * Check whether we have a motion value for this key
             */ hasValue: function(key) {
                return values.has(key);
            },
            /**
             * Get a motion value for this key. If called with a default
             * value, we'll create one if none exists.
             */ getValue: function(key, defaultValue) {
                var value = values.get(key);
                if (value === undefined && defaultValue !== undefined) {
                    value = (0, $9s8eJ.motionValue)(defaultValue);
                    element.addValue(key, value);
                }
                return value;
            },
            /**
             * Iterate over our motion values.
             */ forEachValue: function(callback) {
                return values.forEach(callback);
            },
            /**
             * If we're trying to animate to a previously unencountered value,
             * we need to check for it in our state and as a last resort read it
             * directly from the instance (which might have performance implications).
             */ readValue: function(key) {
                var _a;
                return (_a = latestValues[key]) !== null && _a !== void 0 ? _a : readValueFromInstance(instance, key, options);
            },
            /**
             * Set the base target to later animate back to. This is currently
             * only hydrated on creation and when we first read a value.
             */ setBaseTarget: function(key, value) {
                baseTarget[key] = value;
            },
            /**
             * Find the base target for a value thats been removed from all animation
             * props.
             */ getBaseTarget: function(key) {
                if (getBaseTarget) {
                    var target = getBaseTarget(props, key);
                    if (target !== undefined && !(0, $jqFCw.isMotionValue)(target)) return target;
                }
                return baseTarget[key];
            }
        }, lifecycles), {
            /**
             * Build the renderer state based on the latest visual state.
             */ build: function() {
                triggerBuild();
                return renderState;
            },
            /**
             * Schedule a render on the next animation frame.
             */ scheduleRender: function() {
                (0, $9ksIr.default).render(render, false, true);
            },
            /**
             * Synchronously fire render. It's prefered that we batch renders but
             * in many circumstances, like layout measurement, we need to run this
             * synchronously. However in those instances other measures should be taken
             * to batch reads/writes.
             */ syncRender: render,
            /**
             * Update the provided props. Ensure any newly-added motion values are
             * added to our map, old ones removed, and listeners updated.
             */ setProps: function(newProps) {
                if (newProps.transformTemplate || props.transformTemplate) element.scheduleRender();
                props = newProps;
                lifecycles.updatePropListeners(newProps);
                prevMotionValues = (0, $jyqX9.updateMotionValuesFromProps)(element, scrapeMotionValuesFromProps(props), prevMotionValues);
            },
            getProps: function() {
                return props;
            },
            // Variants ==============================
            /**
             * Returns the variant definition with a given name.
             */ getVariant: function(name) {
                var _a;
                return (_a = props.variants) === null || _a === void 0 ? void 0 : _a[name];
            },
            /**
             * Returns the defined default transition on this component.
             */ getDefaultTransition: function() {
                return props.transition;
            },
            getTransformPagePoint: function() {
                return props.transformPagePoint;
            },
            /**
             * Used by child variant nodes to get the closest ancestor variant props.
             */ getVariantContext: function(startAtParent) {
                if (startAtParent === void 0) startAtParent = false;
                if (startAtParent) return parent === null || parent === void 0 ? void 0 : parent.getVariantContext();
                if (!isControllingVariants) {
                    var context_1 = (parent === null || parent === void 0 ? void 0 : parent.getVariantContext()) || {};
                    if (props.initial !== undefined) context_1.initial = props.initial;
                    return context_1;
                }
                var context = {};
                for(var i = 0; i < $cb00410237ef0648$var$numVariantProps; i++){
                    var name_1 = $cb00410237ef0648$var$variantProps[i];
                    var prop = props[name_1];
                    if ((0, $8QQaD.isVariantLabel)(prop) || prop === false) context[name_1] = prop;
                }
                return context;
            }
        });
        return element;
    };
};
var $cb00410237ef0648$var$variantProps = (0, $7WQrb.__spreadArray)([
    "initial"
], (0, $7WQrb.__read)((0, $dOx92.variantPriorityOrder)), false);
var $cb00410237ef0648$var$numVariantProps = $cb00410237ef0648$var$variantProps.length;

});
parcelRegister("g4QPe", function(module, exports) {

$parcel$export(module.exports, "createLifecycles", () => $e09883f5c35cc3a7$export$f6841af6ea5003ab);

var $7WQrb = parcelRequire("7WQrb");

var $es3uG = parcelRequire("es3uG");
var $e09883f5c35cc3a7$var$names = [
    "LayoutMeasure",
    "BeforeLayoutMeasure",
    "LayoutUpdate",
    "ViewportBoxUpdate",
    "Update",
    "Render",
    "AnimationComplete",
    "LayoutAnimationComplete",
    "AnimationStart",
    "LayoutAnimationStart",
    "SetAxisTarget",
    "Unmount"
];
function $e09883f5c35cc3a7$export$f6841af6ea5003ab() {
    var managers = $e09883f5c35cc3a7$var$names.map(function() {
        return new (0, $es3uG.SubscriptionManager)();
    });
    var propSubscriptions = {};
    var lifecycles = {
        clearAllListeners: function() {
            return managers.forEach(function(manager) {
                return manager.clear();
            });
        },
        updatePropListeners: function(props) {
            $e09883f5c35cc3a7$var$names.forEach(function(name) {
                var _a;
                var on = "on" + name;
                var propListener = props[on];
                // Unsubscribe existing subscription
                (_a = propSubscriptions[name]) === null || _a === void 0 || _a.call(propSubscriptions);
                // Add new subscription
                if (propListener) propSubscriptions[name] = lifecycles[on](propListener);
            });
        }
    };
    managers.forEach(function(manager, i) {
        lifecycles["on" + $e09883f5c35cc3a7$var$names[i]] = function(handler) {
            return manager.add(handler);
        };
        lifecycles["notify" + $e09883f5c35cc3a7$var$names[i]] = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return manager.notify.apply(manager, (0, $7WQrb.__spreadArray)([], (0, $7WQrb.__read)(args), false));
        };
    });
    return lifecycles;
}

});

parcelRegister("jyqX9", function(module, exports) {

$parcel$export(module.exports, "updateMotionValuesFromProps", () => $69635cdb8982f9d2$export$9a552858d5197f6e);


var $9s8eJ = parcelRequire("9s8eJ");

var $jqFCw = parcelRequire("jqFCw");
function $69635cdb8982f9d2$export$9a552858d5197f6e(element, next, prev) {
    var _a;
    for(var key in next){
        var nextValue = next[key];
        var prevValue = prev[key];
        if ((0, $jqFCw.isMotionValue)(nextValue)) /**
             * If this is a motion value found in props or style, we want to add it
             * to our visual element's motion value map.
             */ element.addValue(key, nextValue);
        else if ((0, $jqFCw.isMotionValue)(prevValue)) /**
             * If we're swapping to a new motion value, create a new motion value
             * from that
             */ element.addValue(key, (0, $9s8eJ.motionValue)(nextValue));
        else if (prevValue !== nextValue) {
            /**
             * If this is a flat value that has changed, update the motion value
             * or create one if it doesn't exist. We only want to do this if we're
             * not handling the value with our animation state.
             */ if (element.hasValue(key)) {
                var existingValue = element.getValue(key);
                // TODO: Only update values that aren't being animated or even looked at
                !existingValue.hasAnimated && existingValue.set(nextValue);
            } else element.addValue(key, (0, $9s8eJ.motionValue)((_a = element.getStaticValue(key)) !== null && _a !== void 0 ? _a : nextValue));
        }
    }
    // Handle removed values
    for(var key in prev)if (next[key] === undefined) element.removeValue(key);
    return next;
}

});


parcelRegister("9o6ZN", function(module, exports) {

$parcel$export(module.exports, "parseDomVariant", () => $d9a589b84d5ec1d1$export$5849e743e29831d6);

var $lFblP = parcelRequire("lFblP");

var $bFZFs = parcelRequire("bFZFs");
/**
 * Parse a DOM variant to make it animatable. This involves resolving CSS variables
 * and ensuring animations like "20%" => "calc(50vw)" are performed in pixels.
 */ var $d9a589b84d5ec1d1$export$5849e743e29831d6 = function(visualElement, target, origin, transitionEnd) {
    var resolved = (0, $lFblP.resolveCSSVariables)(visualElement, target, transitionEnd);
    target = resolved.target;
    transitionEnd = resolved.transitionEnd;
    return (0, $bFZFs.unitConversion)(visualElement, target, origin, transitionEnd);
};

});
parcelRegister("lFblP", function(module, exports) {

$parcel$export(module.exports, "cssVariableRegex", () => $ac0e5a3978f40f61$export$f7c0a352d8ef6313);
$parcel$export(module.exports, "resolveCSSVariables", () => $ac0e5a3978f40f61$export$669319b042b57350);

var $7WQrb = parcelRequire("7WQrb");

var $6QSfE = parcelRequire("6QSfE");
function $ac0e5a3978f40f61$var$isCSSVariable(value) {
    return typeof value === "string" && value.startsWith("var(--");
}
/**
 * Parse Framer's special CSS variable format into a CSS token and a fallback.
 *
 * ```
 * `var(--foo, #fff)` => [`--foo`, '#fff']
 * ```
 *
 * @param current
 */ var $ac0e5a3978f40f61$export$f7c0a352d8ef6313 = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;
function $ac0e5a3978f40f61$export$b9f0c1f373aee2b0(current) {
    var match = $ac0e5a3978f40f61$export$f7c0a352d8ef6313.exec(current);
    if (!match) return [
        , 
    ];
    var _a = (0, $7WQrb.__read)(match, 3), token = _a[1], fallback = _a[2];
    return [
        token,
        fallback
    ];
}
var $ac0e5a3978f40f61$var$maxDepth = 4;
function $ac0e5a3978f40f61$var$getVariableValue(current, element, depth) {
    if (depth === void 0) depth = 1;
    (0, $6QSfE.invariant)(depth <= $ac0e5a3978f40f61$var$maxDepth, 'Max CSS variable fallback depth detected in property "'.concat(current, '". This may indicate a circular fallback dependency.'));
    var _a = (0, $7WQrb.__read)($ac0e5a3978f40f61$export$b9f0c1f373aee2b0(current), 2), token = _a[0], fallback = _a[1];
    // No CSS variable detected
    if (!token) return;
    // Attempt to read this CSS variable off the element
    var resolved = window.getComputedStyle(element).getPropertyValue(token);
    if (resolved) return resolved.trim();
    else if ($ac0e5a3978f40f61$var$isCSSVariable(fallback)) // The fallback might itself be a CSS variable, in which case we attempt to resolve it too.
    return $ac0e5a3978f40f61$var$getVariableValue(fallback, element, depth + 1);
    else return fallback;
}
/**
 * Resolve CSS variables from
 *
 * @internal
 */ function $ac0e5a3978f40f61$export$669319b042b57350(visualElement, _a, transitionEnd) {
    var _b;
    var target = (0, $7WQrb.__rest)(_a, []);
    var element = visualElement.getInstance();
    if (!(element instanceof Element)) return {
        target: target,
        transitionEnd: transitionEnd
    };
    // If `transitionEnd` isn't `undefined`, clone it. We could clone `target` and `transitionEnd`
    // only if they change but I think this reads clearer and this isn't a performance-critical path.
    if (transitionEnd) transitionEnd = (0, $7WQrb.__assign)({}, transitionEnd);
    // Go through existing `MotionValue`s and ensure any existing CSS variables are resolved
    visualElement.forEachValue(function(value) {
        var current = value.get();
        if (!$ac0e5a3978f40f61$var$isCSSVariable(current)) return;
        var resolved = $ac0e5a3978f40f61$var$getVariableValue(current, element);
        if (resolved) value.set(resolved);
    });
    // Cycle through every target property and resolve CSS variables. Currently
    // we only read single-var properties like `var(--foo)`, not `calc(var(--foo) + 20px)`
    for(var key in target){
        var current = target[key];
        if (!$ac0e5a3978f40f61$var$isCSSVariable(current)) continue;
        var resolved = $ac0e5a3978f40f61$var$getVariableValue(current, element);
        if (!resolved) continue;
        // Clone target if it hasn't already been
        target[key] = resolved;
        // If the user hasn't already set this key on `transitionEnd`, set it to the unresolved
        // CSS variable. This will ensure that after the animation the component will reflect
        // changes in the value of the CSS variable.
        if (transitionEnd) (_b = transitionEnd[key]) !== null && _b !== void 0 ? _b : transitionEnd[key] = current;
    }
    return {
        target: target,
        transitionEnd: transitionEnd
    };
}

});

parcelRegister("bFZFs", function(module, exports) {

$parcel$export(module.exports, "unitConversion", () => $a731b8aa4fe311d9$export$9e04b0cab841a28);

var $7WQrb = parcelRequire("7WQrb");

var $g4T9J = parcelRequire("g4T9J");
var $1fCxR = parcelRequire("1fCxR");

var $eT2fJ = parcelRequire("eT2fJ");

var $6QSfE = parcelRequire("6QSfE");

var $5f0mC = parcelRequire("5f0mC");

var $4Vyka = parcelRequire("4Vyka");
var $a731b8aa4fe311d9$var$positionalKeys = new Set([
    "width",
    "height",
    "top",
    "left",
    "right",
    "bottom",
    "x",
    "y"
]);
var $a731b8aa4fe311d9$var$isPositionalKey = function(key) {
    return $a731b8aa4fe311d9$var$positionalKeys.has(key);
};
var $a731b8aa4fe311d9$var$hasPositionalKey = function(target) {
    return Object.keys(target).some($a731b8aa4fe311d9$var$isPositionalKey);
};
var $a731b8aa4fe311d9$var$setAndResetVelocity = function(value, to) {
    // Looks odd but setting it twice doesn't render, it'll just
    // set both prev and current to the latest value
    value.set(to, false);
    value.set(to);
};
var $a731b8aa4fe311d9$var$isNumOrPxType = function(v) {
    return v === (0, $g4T9J.number) || v === (0, $1fCxR.px);
};
var $a731b8aa4fe311d9$export$d0c75e4fa9e69db8;
(function(BoundingBoxDimension) {
    BoundingBoxDimension["width"] = "width";
    BoundingBoxDimension["height"] = "height";
    BoundingBoxDimension["left"] = "left";
    BoundingBoxDimension["right"] = "right";
    BoundingBoxDimension["top"] = "top";
    BoundingBoxDimension["bottom"] = "bottom";
})($a731b8aa4fe311d9$export$d0c75e4fa9e69db8 || ($a731b8aa4fe311d9$export$d0c75e4fa9e69db8 = {}));
var $a731b8aa4fe311d9$var$getPosFromMatrix = function(matrix, pos) {
    return parseFloat(matrix.split(", ")[pos]);
};
var $a731b8aa4fe311d9$var$getTranslateFromMatrix = function(pos2, pos3) {
    return function(_bbox, _a) {
        var transform = _a.transform;
        if (transform === "none" || !transform) return 0;
        var matrix3d = transform.match(/^matrix3d\((.+)\)$/);
        if (matrix3d) return $a731b8aa4fe311d9$var$getPosFromMatrix(matrix3d[1], pos3);
        else {
            var matrix = transform.match(/^matrix\((.+)\)$/);
            if (matrix) return $a731b8aa4fe311d9$var$getPosFromMatrix(matrix[1], pos2);
            else return 0;
        }
    };
};
var $a731b8aa4fe311d9$var$transformKeys = new Set([
    "x",
    "y",
    "z"
]);
var $a731b8aa4fe311d9$var$nonTranslationalTransformKeys = (0, $5f0mC.transformProps).filter(function(key) {
    return !$a731b8aa4fe311d9$var$transformKeys.has(key);
});
function $a731b8aa4fe311d9$var$removeNonTranslationalTransform(visualElement) {
    var removedTransforms = [];
    $a731b8aa4fe311d9$var$nonTranslationalTransformKeys.forEach(function(key) {
        var value = visualElement.getValue(key);
        if (value !== undefined) {
            removedTransforms.push([
                key,
                value.get()
            ]);
            value.set(key.startsWith("scale") ? 1 : 0);
        }
    });
    // Apply changes to element before measurement
    if (removedTransforms.length) visualElement.syncRender();
    return removedTransforms;
}
var $a731b8aa4fe311d9$export$781d46a8aa670d52 = {
    // Dimensions
    width: function(_a, _b) {
        var x = _a.x;
        var _c = _b.paddingLeft, paddingLeft = _c === void 0 ? "0" : _c, _d = _b.paddingRight, paddingRight = _d === void 0 ? "0" : _d;
        return x.max - x.min - parseFloat(paddingLeft) - parseFloat(paddingRight);
    },
    height: function(_a, _b) {
        var y = _a.y;
        var _c = _b.paddingTop, paddingTop = _c === void 0 ? "0" : _c, _d = _b.paddingBottom, paddingBottom = _d === void 0 ? "0" : _d;
        return y.max - y.min - parseFloat(paddingTop) - parseFloat(paddingBottom);
    },
    top: function(_bbox, _a) {
        var top = _a.top;
        return parseFloat(top);
    },
    left: function(_bbox, _a) {
        var left = _a.left;
        return parseFloat(left);
    },
    bottom: function(_a, _b) {
        var y = _a.y;
        var top = _b.top;
        return parseFloat(top) + (y.max - y.min);
    },
    right: function(_a, _b) {
        var x = _a.x;
        var left = _b.left;
        return parseFloat(left) + (x.max - x.min);
    },
    // Transform
    x: $a731b8aa4fe311d9$var$getTranslateFromMatrix(4, 13),
    y: $a731b8aa4fe311d9$var$getTranslateFromMatrix(5, 14)
};
var $a731b8aa4fe311d9$var$convertChangedValueTypes = function(target, visualElement, changedKeys) {
    var originBbox = visualElement.measureViewportBox();
    var element = visualElement.getInstance();
    var elementComputedStyle = getComputedStyle(element);
    var display = elementComputedStyle.display;
    var origin = {};
    // If the element is currently set to display: "none", make it visible before
    // measuring the target bounding box
    if (display === "none") visualElement.setStaticValue("display", target.display || "block");
    /**
     * Record origins before we render and update styles
     */ changedKeys.forEach(function(key) {
        origin[key] = $a731b8aa4fe311d9$export$781d46a8aa670d52[key](originBbox, elementComputedStyle);
    });
    // Apply the latest values (as set in checkAndConvertChangedValueTypes)
    visualElement.syncRender();
    var targetBbox = visualElement.measureViewportBox();
    changedKeys.forEach(function(key) {
        // Restore styles to their **calculated computed style**, not their actual
        // originally set style. This allows us to animate between equivalent pixel units.
        var value = visualElement.getValue(key);
        $a731b8aa4fe311d9$var$setAndResetVelocity(value, origin[key]);
        target[key] = $a731b8aa4fe311d9$export$781d46a8aa670d52[key](targetBbox, elementComputedStyle);
    });
    return target;
};
var $a731b8aa4fe311d9$var$checkAndConvertChangedValueTypes = function(visualElement, target, origin, transitionEnd) {
    if (origin === void 0) origin = {};
    if (transitionEnd === void 0) transitionEnd = {};
    target = (0, $7WQrb.__assign)({}, target);
    transitionEnd = (0, $7WQrb.__assign)({}, transitionEnd);
    var targetPositionalKeys = Object.keys(target).filter($a731b8aa4fe311d9$var$isPositionalKey);
    // We want to remove any transform values that could affect the element's bounding box before
    // it's measured. We'll reapply these later.
    var removedTransformValues = [];
    var hasAttemptedToRemoveTransformValues = false;
    var changedValueTypeKeys = [];
    targetPositionalKeys.forEach(function(key) {
        var value = visualElement.getValue(key);
        if (!visualElement.hasValue(key)) return;
        var from = origin[key];
        var fromType = (0, $4Vyka.findDimensionValueType)(from);
        var to = target[key];
        var toType;
        // TODO: The current implementation of this basically throws an error
        // if you try and do value conversion via keyframes. There's probably
        // a way of doing this but the performance implications would need greater scrutiny,
        // as it'd be doing multiple resize-remeasure operations.
        if ((0, $eT2fJ.isKeyframesTarget)(to)) {
            var numKeyframes = to.length;
            var fromIndex = to[0] === null ? 1 : 0;
            from = to[fromIndex];
            fromType = (0, $4Vyka.findDimensionValueType)(from);
            for(var i = fromIndex; i < numKeyframes; i++)if (!toType) {
                toType = (0, $4Vyka.findDimensionValueType)(to[i]);
                (0, $6QSfE.invariant)(toType === fromType || $a731b8aa4fe311d9$var$isNumOrPxType(fromType) && $a731b8aa4fe311d9$var$isNumOrPxType(toType), "Keyframes must be of the same dimension as the current value");
            } else (0, $6QSfE.invariant)((0, $4Vyka.findDimensionValueType)(to[i]) === toType, "All keyframes must be of the same type");
        } else toType = (0, $4Vyka.findDimensionValueType)(to);
        if (fromType !== toType) {
            // If they're both just number or px, convert them both to numbers rather than
            // relying on resize/remeasure to convert (which is wasteful in this situation)
            if ($a731b8aa4fe311d9$var$isNumOrPxType(fromType) && $a731b8aa4fe311d9$var$isNumOrPxType(toType)) {
                var current = value.get();
                if (typeof current === "string") value.set(parseFloat(current));
                if (typeof to === "string") target[key] = parseFloat(to);
                else if (Array.isArray(to) && toType === (0, $1fCxR.px)) target[key] = to.map(parseFloat);
            } else if ((fromType === null || fromType === void 0 ? void 0 : fromType.transform) && (toType === null || toType === void 0 ? void 0 : toType.transform) && (from === 0 || to === 0)) {
                // If one or the other value is 0, it's safe to coerce it to the
                // type of the other without measurement
                if (from === 0) value.set(toType.transform(from));
                else target[key] = fromType.transform(to);
            } else {
                // If we're going to do value conversion via DOM measurements, we first
                // need to remove non-positional transform values that could affect the bbox measurements.
                if (!hasAttemptedToRemoveTransformValues) {
                    removedTransformValues = $a731b8aa4fe311d9$var$removeNonTranslationalTransform(visualElement);
                    hasAttemptedToRemoveTransformValues = true;
                }
                changedValueTypeKeys.push(key);
                transitionEnd[key] = transitionEnd[key] !== undefined ? transitionEnd[key] : target[key];
                $a731b8aa4fe311d9$var$setAndResetVelocity(value, to);
            }
        }
    });
    if (changedValueTypeKeys.length) {
        var scrollY_1 = changedValueTypeKeys.indexOf("height") >= 0 ? window.pageYOffset : null;
        var convertedTarget = $a731b8aa4fe311d9$var$convertChangedValueTypes(target, visualElement, changedValueTypeKeys);
        // If we removed transform values, reapply them before the next render
        if (removedTransformValues.length) removedTransformValues.forEach(function(_a) {
            var _b = (0, $7WQrb.__read)(_a, 2), key = _b[0], value = _b[1];
            visualElement.getValue(key).set(value);
        });
        // Reapply original values
        visualElement.syncRender();
        // Restore scroll position
        if (scrollY_1 !== null) window.scrollTo({
            top: scrollY_1
        });
        return {
            target: convertedTarget,
            transitionEnd: transitionEnd
        };
    } else return {
        target: target,
        transitionEnd: transitionEnd
    };
};
/**
 * Convert value types for x/y/width/height/top/left/bottom/right
 *
 * Allows animation between `'auto'` -> `'100%'` or `0` -> `'calc(50% - 10vw)'`
 *
 * @internal
 */ function $a731b8aa4fe311d9$export$9e04b0cab841a28(visualElement, target, origin, transitionEnd) {
    return $a731b8aa4fe311d9$var$hasPositionalKey(target) ? $a731b8aa4fe311d9$var$checkAndConvertChangedValueTypes(visualElement, target, origin, transitionEnd) : {
        target: target,
        transitionEnd: transitionEnd
    };
}

});



parcelRegister("eBO7r", function(module, exports) {

$parcel$export(module.exports, "svgVisualElement", () => $697788b593031f52$export$3ba8992de7b705bc);

var $7WQrb = parcelRequire("7WQrb");

var $ebUnu = parcelRequire("ebUnu");

var $JEDlr = parcelRequire("JEDlr");

var $1tKT6 = parcelRequire("1tKT6");

var $2g66t = parcelRequire("2g66t");

var $4kYgl = parcelRequire("4kYgl");

var $945PB = parcelRequire("945PB");

var $5f0mC = parcelRequire("5f0mC");

var $daTxn = parcelRequire("daTxn");

var $h8BN3 = parcelRequire("h8BN3");
var $697788b593031f52$export$3ba8992de7b705bc = (0, $ebUnu.visualElement)((0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, (0, $1tKT6.htmlConfig)), {
    getBaseTarget: function(props, key) {
        return props[key];
    },
    readValueFromInstance: function(domElement, key) {
        var _a;
        if ((0, $5f0mC.isTransformProp)(key)) return ((_a = (0, $h8BN3.getDefaultValueType)(key)) === null || _a === void 0 ? void 0 : _a.default) || 0;
        key = !(0, $945PB.camelCaseAttributes).has(key) ? (0, $4kYgl.camelToDash)(key) : key;
        return domElement.getAttribute(key);
    },
    scrapeMotionValuesFromProps: (0, $JEDlr.scrapeMotionValuesFromProps),
    build: function(_element, renderState, latestValues, options, props) {
        (0, $2g66t.buildSVGAttrs)(renderState, latestValues, options, props.transformTemplate);
    },
    render: (0, $daTxn.renderSVG)
}));

});


parcelRegister("h1u5n", function(module, exports) {

$parcel$export(module.exports, "layoutFeatures", () => $2cb9ab33756189ff$export$518df03f164c507);

var $aTisU = parcelRequire("aTisU");
var $2cb9ab33756189ff$export$518df03f164c507 = {
    measureLayout: (0, $aTisU.MeasureLayout)
};

});
parcelRegister("aTisU", function(module, exports) {

$parcel$export(module.exports, "MeasureLayout", () => $cdf2a2ac04e7ce67$export$779f5fb01ad751cd);

var $7WQrb = parcelRequire("7WQrb");

var $9ksIr = parcelRequire("9ksIr");

var $acw62 = parcelRequire("acw62");

var $iL8MI = parcelRequire("iL8MI");

var $cNR5T = parcelRequire("cNR5T");

var $9lcvq = parcelRequire("9lcvq");

var $9CWXG = parcelRequire("9CWXG");

var $5g4ML = parcelRequire("5g4ML");

var $kUOYE = parcelRequire("kUOYE");

var $i0qI9 = parcelRequire("i0qI9");
var $cdf2a2ac04e7ce67$var$MeasureLayoutWithContext = /** @class */ function(_super) {
    (0, $7WQrb.__extends)(MeasureLayoutWithContext, _super);
    function MeasureLayoutWithContext() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * This only mounts projection nodes for components that
     * need measuring, we might want to do it for all components
     * in order to incorporate transforms
     */ MeasureLayoutWithContext.prototype.componentDidMount = function() {
        var _this = this;
        var _a = this.props, visualElement = _a.visualElement, layoutGroup = _a.layoutGroup, switchLayoutGroup = _a.switchLayoutGroup, layoutId = _a.layoutId;
        var projection = visualElement.projection;
        (0, $i0qI9.addScaleCorrector)($cdf2a2ac04e7ce67$var$defaultScaleCorrectors);
        if (projection) {
            if (layoutGroup === null || layoutGroup === void 0 ? void 0 : layoutGroup.group) layoutGroup.group.add(projection);
            if ((switchLayoutGroup === null || switchLayoutGroup === void 0 ? void 0 : switchLayoutGroup.register) && layoutId) switchLayoutGroup.register(projection);
            projection.root.didUpdate();
            projection.addEventListener("animationComplete", function() {
                _this.safeToRemove();
            });
            projection.setOptions((0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, projection.options), {
                onExitComplete: function() {
                    return _this.safeToRemove();
                }
            }));
        }
        (0, $9CWXG.globalProjectionState).hasEverUpdated = true;
    };
    MeasureLayoutWithContext.prototype.getSnapshotBeforeUpdate = function(prevProps) {
        var _this = this;
        var _a = this.props, layoutDependency = _a.layoutDependency, visualElement = _a.visualElement, drag = _a.drag, isPresent = _a.isPresent;
        var projection = visualElement.projection;
        if (!projection) return null;
        /**
         * TODO: We use this data in relegate to determine whether to
         * promote a previous element. There's no guarantee its presence data
         * will have updated by this point - if a bug like this arises it will
         * have to be that we markForRelegation and then find a new lead some other way,
         * perhaps in didUpdate
         */ projection.isPresent = isPresent;
        if (drag || prevProps.layoutDependency !== layoutDependency || layoutDependency === undefined) projection.willUpdate();
        else this.safeToRemove();
        if (prevProps.isPresent !== isPresent) {
            if (isPresent) projection.promote();
            else if (!projection.relegate()) /**
                 * If there's another stack member taking over from this one,
                 * it's in charge of the exit animation and therefore should
                 * be in charge of the safe to remove. Otherwise we call it here.
                 */ (0, $9ksIr.default).postRender(function() {
                var _a;
                if (!((_a = projection.getStack()) === null || _a === void 0 ? void 0 : _a.members.length)) _this.safeToRemove();
            });
        }
        return null;
    };
    MeasureLayoutWithContext.prototype.componentDidUpdate = function() {
        var projection = this.props.visualElement.projection;
        if (projection) {
            projection.root.didUpdate();
            if (!projection.currentAnimation && projection.isLead()) this.safeToRemove();
        }
    };
    MeasureLayoutWithContext.prototype.componentWillUnmount = function() {
        var _a = this.props, visualElement = _a.visualElement, layoutGroup = _a.layoutGroup, promoteContext = _a.switchLayoutGroup;
        var projection = visualElement.projection;
        if (projection) {
            projection.scheduleCheckAfterUnmount();
            if (layoutGroup === null || layoutGroup === void 0 ? void 0 : layoutGroup.group) layoutGroup.group.remove(projection);
            if (promoteContext === null || promoteContext === void 0 ? void 0 : promoteContext.deregister) promoteContext.deregister(projection);
        }
    };
    MeasureLayoutWithContext.prototype.safeToRemove = function() {
        var safeToRemove = this.props.safeToRemove;
        safeToRemove === null || safeToRemove === void 0 || safeToRemove();
    };
    MeasureLayoutWithContext.prototype.render = function() {
        return null;
    };
    return MeasureLayoutWithContext;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
function $cdf2a2ac04e7ce67$export$779f5fb01ad751cd(props) {
    var _a = (0, $7WQrb.__read)((0, $iL8MI.usePresence)(), 2), isPresent = _a[0], safeToRemove = _a[1];
    var layoutGroup = (0, $acw62.useContext)((0, $cNR5T.LayoutGroupContext));
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($cdf2a2ac04e7ce67$var$MeasureLayoutWithContext, (0, $7WQrb.__assign)({}, props, {
        layoutGroup: layoutGroup,
        switchLayoutGroup: (0, $acw62.useContext)((0, $9lcvq.SwitchLayoutGroupContext)),
        isPresent: isPresent,
        safeToRemove: safeToRemove
    }));
}
var $cdf2a2ac04e7ce67$var$defaultScaleCorrectors = {
    borderRadius: (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, (0, $5g4ML.correctBorderRadius)), {
        applyTo: [
            "borderTopLeftRadius",
            "borderTopRightRadius",
            "borderBottomLeftRadius",
            "borderBottomRightRadius"
        ]
    }),
    borderTopLeftRadius: (0, $5g4ML.correctBorderRadius),
    borderTopRightRadius: (0, $5g4ML.correctBorderRadius),
    borderBottomLeftRadius: (0, $5g4ML.correctBorderRadius),
    borderBottomRightRadius: (0, $5g4ML.correctBorderRadius),
    boxShadow: (0, $kUOYE.correctBoxShadow)
};

});
parcelRegister("5g4ML", function(module, exports) {

$parcel$export(module.exports, "correctBorderRadius", () => $967b202c839557ef$export$5eafb6257a5844c);

var $1fCxR = parcelRequire("1fCxR");
function $967b202c839557ef$export$fafff692be55225d(pixels, axis) {
    if (axis.max === axis.min) return 0;
    return pixels / (axis.max - axis.min) * 100;
}
/**
 * We always correct borderRadius as a percentage rather than pixels to reduce paints.
 * For example, if you are projecting a box that is 100px wide with a 10px borderRadius
 * into a box that is 200px wide with a 20px borderRadius, that is actually a 10%
 * borderRadius in both states. If we animate between the two in pixels that will trigger
 * a paint each time. If we animate between the two in percentage we'll avoid a paint.
 */ var $967b202c839557ef$export$5eafb6257a5844c = {
    correct: function(latest, node) {
        if (!node.target) return latest;
        /**
         * If latest is a string, if it's a percentage we can return immediately as it's
         * going to be stretched appropriately. Otherwise, if it's a pixel, convert it to a number.
         */ if (typeof latest === "string") {
            if ((0, $1fCxR.px).test(latest)) latest = parseFloat(latest);
            else return latest;
        }
        /**
         * If latest is a number, it's a pixel value. We use the current viewportBox to calculate that
         * pixel value as a percentage of each axis
         */ var x = $967b202c839557ef$export$fafff692be55225d(latest, node.target.x);
        var y = $967b202c839557ef$export$fafff692be55225d(latest, node.target.y);
        return "".concat(x, "% ").concat(y, "%");
    }
};

});

parcelRegister("kUOYE", function(module, exports) {

$parcel$export(module.exports, "correctBoxShadow", () => $a42cd9e0ef50cb70$export$eb0bc629e74dcf8);

var $bqVjQ = parcelRequire("bqVjQ");

var $DYJG5 = parcelRequire("DYJG5");

var $lFblP = parcelRequire("lFblP");
var $a42cd9e0ef50cb70$var$varToken = "_$css";
var $a42cd9e0ef50cb70$export$eb0bc629e74dcf8 = {
    correct: function(latest, _a) {
        var treeScale = _a.treeScale, projectionDelta = _a.projectionDelta;
        var original = latest;
        /**
         * We need to first strip and store CSS variables from the string.
         */ var containsCSSVariables = latest.includes("var(");
        var cssVariables = [];
        if (containsCSSVariables) latest = latest.replace((0, $lFblP.cssVariableRegex), function(match) {
            cssVariables.push(match);
            return $a42cd9e0ef50cb70$var$varToken;
        });
        var shadow = (0, $DYJG5.complex).parse(latest);
        // TODO: Doesn't support multiple shadows
        if (shadow.length > 5) return original;
        var template = (0, $DYJG5.complex).createTransformer(latest);
        var offset = typeof shadow[0] !== "number" ? 1 : 0;
        // Calculate the overall context scale
        var xScale = projectionDelta.x.scale * treeScale.x;
        var yScale = projectionDelta.y.scale * treeScale.y;
        shadow[0 + offset] /= xScale;
        shadow[1 + offset] /= yScale;
        /**
         * Ideally we'd correct x and y scales individually, but because blur and
         * spread apply to both we have to take a scale average and apply that instead.
         * We could potentially improve the outcome of this by incorporating the ratio between
         * the two scales.
         */ var averageScale = (0, $bqVjQ.mix)(xScale, yScale, 0.5);
        // Blur
        if (typeof shadow[2 + offset] === "number") shadow[2 + offset] /= averageScale;
        // Spread
        if (typeof shadow[3 + offset] === "number") shadow[3 + offset] /= averageScale;
        var output = template(shadow);
        if (containsCSSVariables) {
            var i_1 = 0;
            output = output.replace($a42cd9e0ef50cb70$var$varToken, function() {
                var cssVariable = cssVariables[i_1];
                i_1++;
                return cssVariable;
            });
        }
        return output;
    }
};

});



parcelRegister("9ycLt", function(module, exports) {

$parcel$export(module.exports, "HTMLProjectionNode", () => $a3289660bde9b219$export$b61a9eb3dbde8858);

var $15nIA = parcelRequire("15nIA");

var $h0X6O = parcelRequire("h0X6O");
var $a3289660bde9b219$export$b91509fcf893b648 = {
    current: undefined
};
var $a3289660bde9b219$export$b61a9eb3dbde8858 = (0, $15nIA.createProjectionNode)({
    measureScroll: function(instance) {
        return {
            x: instance.scrollLeft,
            y: instance.scrollTop
        };
    },
    defaultParent: function() {
        if (!$a3289660bde9b219$export$b91509fcf893b648.current) {
            var documentNode = new (0, $h0X6O.DocumentProjectionNode)(0, {});
            documentNode.mount(window);
            documentNode.setOptions({
                layoutScroll: true
            });
            $a3289660bde9b219$export$b91509fcf893b648.current = documentNode;
        }
        return $a3289660bde9b219$export$b91509fcf893b648.current;
    },
    resetTransform: function(instance, value) {
        instance.style.transform = value !== null && value !== void 0 ? value : "none";
    },
    checkIsScrollRoot: function(instance) {
        return Boolean(window.getComputedStyle(instance).position === "fixed");
    }
});

});
parcelRegister("15nIA", function(module, exports) {

$parcel$export(module.exports, "createProjectionNode", () => $d2ca41ba1b84bcfe$export$a84b61f69daa9da0);

var $7WQrb = parcelRequire("7WQrb");

var $9ksIr = parcelRequire("9ksIr");

var $bqVjQ = parcelRequire("bqVjQ");

var $e8dlz = parcelRequire("e8dlz");

var $es3uG = parcelRequire("es3uG");

var $kKryO = parcelRequire("kKryO");

var $96kmk = parcelRequire("96kmk");

var $fxwRw = parcelRequire("fxwRw");

var $8BLfb = parcelRequire("8BLfb");

var $lldi8 = parcelRequire("lldi8");

var $8v3iT = parcelRequire("8v3iT");

var $bUTXm = parcelRequire("bUTXm");

var $hPJ9o = parcelRequire("hPJ9o");

var $24cVq = parcelRequire("24cVq");

var $i0qI9 = parcelRequire("i0qI9");

var $cjbno = parcelRequire("cjbno");

var $tnnCU = parcelRequire("tnnCU");

var $3xchP = parcelRequire("3xchP");

var $5f0mC = parcelRequire("5f0mC");

var $73AdZ = parcelRequire("73AdZ");

var $cz2ac = parcelRequire("cz2ac");

var $9CWXG = parcelRequire("9CWXG");
/**
 * We use 1000 as the animation target as 0-1000 maps better to pixels than 0-1
 * which has a noticeable difference in spring animations
 */ var $d2ca41ba1b84bcfe$var$animationTarget = 1000;
function $d2ca41ba1b84bcfe$export$a84b61f69daa9da0(_a) {
    var attachResizeListener = _a.attachResizeListener, defaultParent = _a.defaultParent, measureScroll = _a.measureScroll, checkIsScrollRoot = _a.checkIsScrollRoot, resetTransform = _a.resetTransform;
    return /** @class */ function() {
        function ProjectionNode(id, latestValues, parent) {
            var _this = this;
            if (latestValues === void 0) latestValues = {};
            if (parent === void 0) parent = defaultParent === null || defaultParent === void 0 ? void 0 : defaultParent();
            /**
             * A Set containing all this component's children. This is used to iterate
             * through the children.
             *
             * TODO: This could be faster to iterate as a flat array stored on the root node.
             */ this.children = new Set();
            /**
             * Options for the node. We use this to configure what kind of layout animations
             * we should perform (if any).
             */ this.options = {};
            /**
             * We use this to detect when its safe to shut down part of a projection tree.
             * We have to keep projecting children for scale correction and relative projection
             * until all their parents stop performing layout animations.
             */ this.isTreeAnimating = false;
            this.isAnimationBlocked = false;
            /**
             * Flag to true if we think this layout has been changed. We can't always know this,
             * currently we set it to true every time a component renders, or if it has a layoutDependency
             * if that has changed between renders. Additionally, components can be grouped by LayoutGroup
             * and if one node is dirtied, they all are.
             */ this.isLayoutDirty = false;
            /**
             * Block layout updates for instant layout transitions throughout the tree.
             */ this.updateManuallyBlocked = false;
            this.updateBlockedByResize = false;
            /**
             * Set to true between the start of the first `willUpdate` call and the end of the `didUpdate`
             * call.
             */ this.isUpdating = false;
            /**
             * If this is an SVG element we currently disable projection transforms
             */ this.isSVG = false;
            /**
             * Flag to true (during promotion) if a node doing an instant layout transition needs to reset
             * its projection styles.
             */ this.needsReset = false;
            /**
             * Flags whether this node should have its transform reset prior to measuring.
             */ this.shouldResetTransform = false;
            /**
             * An object representing the calculated contextual/accumulated/tree scale.
             * This will be used to scale calculcated projection transforms, as these are
             * calculated in screen-space but need to be scaled for elements to actually
             * make it to their calculated destinations.
             *
             * TODO: Lazy-init
             */ this.treeScale = {
                x: 1,
                y: 1
            };
            /**
             *
             */ this.eventHandlers = new Map();
            // Note: Currently only running on root node
            this.potentialNodes = new Map();
            this.checkUpdateFailed = function() {
                if (_this.isUpdating) {
                    _this.isUpdating = false;
                    _this.clearAllSnapshots();
                }
            };
            this.updateProjection = function() {
                _this.nodes.forEach($d2ca41ba1b84bcfe$var$resolveTargetDelta);
                _this.nodes.forEach($d2ca41ba1b84bcfe$var$calcProjection);
            };
            this.hasProjected = false;
            this.isVisible = true;
            this.animationProgress = 0;
            /**
             * Shared layout
             */ // TODO Only running on root node
            this.sharedNodes = new Map();
            this.id = id;
            this.latestValues = latestValues;
            this.root = parent ? parent.root || parent : this;
            this.path = parent ? (0, $7WQrb.__spreadArray)((0, $7WQrb.__spreadArray)([], (0, $7WQrb.__read)(parent.path), false), [
                parent
            ], false) : [];
            this.parent = parent;
            this.depth = parent ? parent.depth + 1 : 0;
            id && this.root.registerPotentialNode(id, this);
            for(var i = 0; i < this.path.length; i++)this.path[i].shouldResetTransform = true;
            if (this.root === this) this.nodes = new (0, $73AdZ.FlatTree)();
        }
        ProjectionNode.prototype.addEventListener = function(name, handler) {
            if (!this.eventHandlers.has(name)) this.eventHandlers.set(name, new (0, $es3uG.SubscriptionManager)());
            return this.eventHandlers.get(name).add(handler);
        };
        ProjectionNode.prototype.notifyListeners = function(name) {
            var args = [];
            for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
            var subscriptionManager = this.eventHandlers.get(name);
            subscriptionManager === null || subscriptionManager === void 0 || subscriptionManager.notify.apply(subscriptionManager, (0, $7WQrb.__spreadArray)([], (0, $7WQrb.__read)(args), false));
        };
        ProjectionNode.prototype.hasListeners = function(name) {
            return this.eventHandlers.has(name);
        };
        ProjectionNode.prototype.registerPotentialNode = function(id, node) {
            this.potentialNodes.set(id, node);
        };
        /**
         * Lifecycles
         */ ProjectionNode.prototype.mount = function(instance, isLayoutDirty) {
            var _this = this;
            var _a;
            if (isLayoutDirty === void 0) isLayoutDirty = false;
            if (this.instance) return;
            this.isSVG = instance instanceof SVGElement && instance.tagName !== "svg";
            this.instance = instance;
            var _b = this.options, layoutId = _b.layoutId, layout = _b.layout, visualElement = _b.visualElement;
            if (visualElement && !visualElement.getInstance()) visualElement.mount(instance);
            this.root.nodes.add(this);
            (_a = this.parent) === null || _a === void 0 || _a.children.add(this);
            this.id && this.root.potentialNodes.delete(this.id);
            if (isLayoutDirty && (layout || layoutId)) this.isLayoutDirty = true;
            if (attachResizeListener) {
                var unblockTimeout_1;
                var resizeUnblockUpdate_1 = function() {
                    return _this.root.updateBlockedByResize = false;
                };
                attachResizeListener(instance, function() {
                    _this.root.updateBlockedByResize = true;
                    clearTimeout(unblockTimeout_1);
                    unblockTimeout_1 = window.setTimeout(resizeUnblockUpdate_1, 250);
                    if ((0, $9CWXG.globalProjectionState).hasAnimatedSinceResize) {
                        (0, $9CWXG.globalProjectionState).hasAnimatedSinceResize = false;
                        _this.nodes.forEach($d2ca41ba1b84bcfe$var$finishAnimation);
                    }
                });
            }
            if (layoutId) this.root.registerSharedNode(layoutId, this);
            // Only register the handler if it requires layout animation
            if (this.options.animate !== false && visualElement && (layoutId || layout)) this.addEventListener("didUpdate", function(_a) {
                var _b, _c, _d, _e, _f;
                var delta = _a.delta, hasLayoutChanged = _a.hasLayoutChanged, hasRelativeTargetChanged = _a.hasRelativeTargetChanged, newLayout = _a.layout;
                if (_this.isTreeAnimationBlocked()) {
                    _this.target = undefined;
                    _this.relativeTarget = undefined;
                    return;
                }
                // TODO: Check here if an animation exists
                var layoutTransition = (_c = (_b = _this.options.transition) !== null && _b !== void 0 ? _b : visualElement.getDefaultTransition()) !== null && _c !== void 0 ? _c : $d2ca41ba1b84bcfe$var$defaultLayoutTransition;
                var _g = visualElement.getProps(), onLayoutAnimationStart = _g.onLayoutAnimationStart, onLayoutAnimationComplete = _g.onLayoutAnimationComplete;
                /**
                     * The target layout of the element might stay the same,
                     * but its position relative to its parent has changed.
                     */ var targetChanged = !_this.targetLayout || !(0, $hPJ9o.boxEquals)(_this.targetLayout, newLayout) || hasRelativeTargetChanged;
                /**
                     * If the layout hasn't seemed to have changed, it might be that the
                     * element is visually in the same place in the document but its position
                     * relative to its parent has indeed changed. So here we check for that.
                     */ var hasOnlyRelativeTargetChanged = !hasLayoutChanged && hasRelativeTargetChanged;
                if (((_d = _this.resumeFrom) === null || _d === void 0 ? void 0 : _d.instance) || hasOnlyRelativeTargetChanged || hasLayoutChanged && (targetChanged || !_this.currentAnimation)) {
                    if (_this.resumeFrom) {
                        _this.resumingFrom = _this.resumeFrom;
                        _this.resumingFrom.resumingFrom = undefined;
                    }
                    _this.setAnimationOrigin(delta, hasOnlyRelativeTargetChanged);
                    var animationOptions = (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, (0, $bUTXm.getValueTransition)(layoutTransition, "layout")), {
                        onPlay: onLayoutAnimationStart,
                        onComplete: onLayoutAnimationComplete
                    });
                    if (visualElement.shouldReduceMotion) {
                        animationOptions.delay = 0;
                        animationOptions.type = false;
                    }
                    _this.startAnimation(animationOptions);
                } else {
                    /**
                         * If the layout hasn't changed and we have an animation that hasn't started yet,
                         * finish it immediately. Otherwise it will be animating from a location
                         * that was probably never commited to screen and look like a jumpy box.
                         */ if (!hasLayoutChanged && _this.animationProgress === 0) _this.finishAnimation();
                    _this.isLead() && ((_f = (_e = _this.options).onExitComplete) === null || _f === void 0 || _f.call(_e));
                }
                _this.targetLayout = newLayout;
            });
        };
        ProjectionNode.prototype.unmount = function() {
            var _a, _b;
            this.options.layoutId && this.willUpdate();
            this.root.nodes.remove(this);
            (_a = this.getStack()) === null || _a === void 0 || _a.remove(this);
            (_b = this.parent) === null || _b === void 0 || _b.children.delete(this);
            this.instance = undefined;
            (0, $9ksIr.cancelSync).preRender(this.updateProjection);
        };
        // only on the root
        ProjectionNode.prototype.blockUpdate = function() {
            this.updateManuallyBlocked = true;
        };
        ProjectionNode.prototype.unblockUpdate = function() {
            this.updateManuallyBlocked = false;
        };
        ProjectionNode.prototype.isUpdateBlocked = function() {
            return this.updateManuallyBlocked || this.updateBlockedByResize;
        };
        ProjectionNode.prototype.isTreeAnimationBlocked = function() {
            var _a;
            return this.isAnimationBlocked || ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isTreeAnimationBlocked()) || false;
        };
        // Note: currently only running on root node
        ProjectionNode.prototype.startUpdate = function() {
            var _a;
            if (this.isUpdateBlocked()) return;
            this.isUpdating = true;
            (_a = this.nodes) === null || _a === void 0 || _a.forEach($d2ca41ba1b84bcfe$var$resetRotation);
        };
        ProjectionNode.prototype.willUpdate = function(shouldNotifyListeners) {
            var _a, _b, _c;
            if (shouldNotifyListeners === void 0) shouldNotifyListeners = true;
            if (this.root.isUpdateBlocked()) {
                (_b = (_a = this.options).onExitComplete) === null || _b === void 0 || _b.call(_a);
                return;
            }
            !this.root.isUpdating && this.root.startUpdate();
            if (this.isLayoutDirty) return;
            this.isLayoutDirty = true;
            for(var i = 0; i < this.path.length; i++){
                var node = this.path[i];
                node.shouldResetTransform = true;
                /**
                 * TODO: Check we haven't updated the scroll
                 * since the last didUpdate
                 */ node.updateScroll();
            }
            var _d = this.options, layoutId = _d.layoutId, layout = _d.layout;
            if (layoutId === undefined && !layout) return;
            var transformTemplate = (_c = this.options.visualElement) === null || _c === void 0 ? void 0 : _c.getProps().transformTemplate;
            this.prevTransformTemplateValue = transformTemplate === null || transformTemplate === void 0 ? void 0 : transformTemplate(this.latestValues, "");
            this.updateSnapshot();
            shouldNotifyListeners && this.notifyListeners("willUpdate");
        };
        // Note: Currently only running on root node
        ProjectionNode.prototype.didUpdate = function() {
            var updateWasBlocked = this.isUpdateBlocked();
            // When doing an instant transition, we skip the layout update,
            // but should still clean up the measurements so that the next
            // snapshot could be taken correctly.
            if (updateWasBlocked) {
                this.unblockUpdate();
                this.clearAllSnapshots();
                this.nodes.forEach($d2ca41ba1b84bcfe$var$clearMeasurements);
                return;
            }
            if (!this.isUpdating) return;
            this.isUpdating = false;
            /**
             * Search for and mount newly-added projection elements.
             *
             * TODO: Every time a new component is rendered we could search up the tree for
             * the closest mounted node and query from there rather than document.
             */ if (this.potentialNodes.size) {
                this.potentialNodes.forEach($d2ca41ba1b84bcfe$var$mountNodeEarly);
                this.potentialNodes.clear();
            }
            /**
             * Write
             */ this.nodes.forEach($d2ca41ba1b84bcfe$var$resetTransformStyle);
            /**
             * Read ==================
             */ // Update layout measurements of updated children
            this.nodes.forEach($d2ca41ba1b84bcfe$var$updateLayout);
            /**
             * Write
             */ // Notify listeners that the layout is updated
            this.nodes.forEach($d2ca41ba1b84bcfe$var$notifyLayoutUpdate);
            this.clearAllSnapshots();
            // Flush any scheduled updates
            (0, $9ksIr.flushSync).update();
            (0, $9ksIr.flushSync).preRender();
            (0, $9ksIr.flushSync).render();
        };
        ProjectionNode.prototype.clearAllSnapshots = function() {
            this.nodes.forEach($d2ca41ba1b84bcfe$var$clearSnapshot);
            this.sharedNodes.forEach($d2ca41ba1b84bcfe$var$removeLeadSnapshots);
        };
        ProjectionNode.prototype.scheduleUpdateProjection = function() {
            (0, $9ksIr.default).preRender(this.updateProjection, false, true);
        };
        ProjectionNode.prototype.scheduleCheckAfterUnmount = function() {
            var _this = this;
            /**
             * If the unmounting node is in a layoutGroup and did trigger a willUpdate,
             * we manually call didUpdate to give a chance to the siblings to animate.
             * Otherwise, cleanup all snapshots to prevents future nodes from reusing them.
             */ (0, $9ksIr.default).postRender(function() {
                if (_this.isLayoutDirty) _this.root.didUpdate();
                else _this.root.checkUpdateFailed();
            });
        };
        /**
         * Update measurements
         */ ProjectionNode.prototype.updateSnapshot = function() {
            if (this.snapshot || !this.instance) return;
            var measured = this.measure();
            var layout = this.removeTransform(this.removeElementScroll(measured));
            $d2ca41ba1b84bcfe$var$roundBox(layout);
            this.snapshot = {
                measured: measured,
                layout: layout,
                latestValues: {}
            };
        };
        ProjectionNode.prototype.updateLayout = function() {
            var _a;
            if (!this.instance) return;
            // TODO: Incorporate into a forwarded scroll offset
            this.updateScroll();
            if (!(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty) return;
            /**
             * When a node is mounted, it simply resumes from the prevLead's
             * snapshot instead of taking a new one, but the ancestors scroll
             * might have updated while the prevLead is unmounted. We need to
             * update the scroll again to make sure the layout we measure is
             * up to date.
             */ if (this.resumeFrom && !this.resumeFrom.instance) for(var i = 0; i < this.path.length; i++){
                var node = this.path[i];
                node.updateScroll();
            }
            var measured = this.measure();
            $d2ca41ba1b84bcfe$var$roundBox(measured);
            var prevLayout = this.layout;
            this.layout = {
                measured: measured,
                actual: this.removeElementScroll(measured)
            };
            this.layoutCorrected = (0, $8v3iT.createBox)();
            this.isLayoutDirty = false;
            this.projectionDelta = undefined;
            this.notifyListeners("measure", this.layout.actual);
            (_a = this.options.visualElement) === null || _a === void 0 || _a.notifyLayoutMeasure(this.layout.actual, prevLayout === null || prevLayout === void 0 ? void 0 : prevLayout.actual);
        };
        ProjectionNode.prototype.updateScroll = function() {
            if (this.options.layoutScroll && this.instance) {
                this.isScrollRoot = checkIsScrollRoot(this.instance);
                this.scroll = measureScroll(this.instance);
            }
        };
        ProjectionNode.prototype.resetTransform = function() {
            var _a;
            if (!resetTransform) return;
            var isResetRequested = this.isLayoutDirty || this.shouldResetTransform;
            var hasProjection = this.projectionDelta && !(0, $hPJ9o.isDeltaZero)(this.projectionDelta);
            var transformTemplate = (_a = this.options.visualElement) === null || _a === void 0 ? void 0 : _a.getProps().transformTemplate;
            var transformTemplateValue = transformTemplate === null || transformTemplate === void 0 ? void 0 : transformTemplate(this.latestValues, "");
            var transformTemplateHasChanged = transformTemplateValue !== this.prevTransformTemplateValue;
            if (isResetRequested && (hasProjection || (0, $3xchP.hasTransform)(this.latestValues) || transformTemplateHasChanged)) {
                resetTransform(this.instance, transformTemplateValue);
                this.shouldResetTransform = false;
                this.scheduleRender();
            }
        };
        ProjectionNode.prototype.measure = function() {
            var visualElement = this.options.visualElement;
            if (!visualElement) return (0, $8v3iT.createBox)();
            var box = visualElement.measureViewportBox();
            // Remove viewport scroll to give page-relative coordinates
            var scroll = this.root.scroll;
            if (scroll) {
                (0, $fxwRw.translateAxis)(box.x, scroll.x);
                (0, $fxwRw.translateAxis)(box.y, scroll.y);
            }
            return box;
        };
        ProjectionNode.prototype.removeElementScroll = function(box) {
            var boxWithoutScroll = (0, $8v3iT.createBox)();
            (0, $96kmk.copyBoxInto)(boxWithoutScroll, box);
            /**
             * Performance TODO: Keep a cumulative scroll offset down the tree
             * rather than loop back up the path.
             */ for(var i = 0; i < this.path.length; i++){
                var node = this.path[i];
                var scroll_1 = node.scroll, options = node.options, isScrollRoot = node.isScrollRoot;
                if (node !== this.root && scroll_1 && options.layoutScroll) {
                    /**
                     * If this is a new scroll root, we want to remove all previous scrolls
                     * from the viewport box.
                     */ if (isScrollRoot) {
                        (0, $96kmk.copyBoxInto)(boxWithoutScroll, box);
                        var rootScroll = this.root.scroll;
                        /**
                         * Undo the application of page scroll that was originally added
                         * to the measured bounding box.
                         */ if (rootScroll) {
                            (0, $fxwRw.translateAxis)(boxWithoutScroll.x, -rootScroll.x);
                            (0, $fxwRw.translateAxis)(boxWithoutScroll.y, -rootScroll.y);
                        }
                    }
                    (0, $fxwRw.translateAxis)(boxWithoutScroll.x, scroll_1.x);
                    (0, $fxwRw.translateAxis)(boxWithoutScroll.y, scroll_1.y);
                }
            }
            return boxWithoutScroll;
        };
        ProjectionNode.prototype.applyTransform = function(box, transformOnly) {
            if (transformOnly === void 0) transformOnly = false;
            var withTransforms = (0, $8v3iT.createBox)();
            (0, $96kmk.copyBoxInto)(withTransforms, box);
            for(var i = 0; i < this.path.length; i++){
                var node = this.path[i];
                if (!transformOnly && node.options.layoutScroll && node.scroll && node !== node.root) (0, $fxwRw.transformBox)(withTransforms, {
                    x: -node.scroll.x,
                    y: -node.scroll.y
                });
                if (!(0, $3xchP.hasTransform)(node.latestValues)) continue;
                (0, $fxwRw.transformBox)(withTransforms, node.latestValues);
            }
            if ((0, $3xchP.hasTransform)(this.latestValues)) (0, $fxwRw.transformBox)(withTransforms, this.latestValues);
            return withTransforms;
        };
        ProjectionNode.prototype.removeTransform = function(box) {
            var _a;
            var boxWithoutTransform = (0, $8v3iT.createBox)();
            (0, $96kmk.copyBoxInto)(boxWithoutTransform, box);
            for(var i = 0; i < this.path.length; i++){
                var node = this.path[i];
                if (!node.instance) continue;
                if (!(0, $3xchP.hasTransform)(node.latestValues)) continue;
                (0, $3xchP.hasScale)(node.latestValues) && node.updateSnapshot();
                var sourceBox = (0, $8v3iT.createBox)();
                var nodeBox = node.measure();
                (0, $96kmk.copyBoxInto)(sourceBox, nodeBox);
                (0, $lldi8.removeBoxTransforms)(boxWithoutTransform, node.latestValues, (_a = node.snapshot) === null || _a === void 0 ? void 0 : _a.layout, sourceBox);
            }
            if ((0, $3xchP.hasTransform)(this.latestValues)) (0, $lldi8.removeBoxTransforms)(boxWithoutTransform, this.latestValues);
            return boxWithoutTransform;
        };
        /**
         *
         */ ProjectionNode.prototype.setTargetDelta = function(delta) {
            this.targetDelta = delta;
            this.root.scheduleUpdateProjection();
        };
        ProjectionNode.prototype.setOptions = function(options) {
            var _a;
            this.options = (0, $7WQrb.__assign)((0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, this.options), options), {
                crossfade: (_a = options.crossfade) !== null && _a !== void 0 ? _a : true
            });
        };
        ProjectionNode.prototype.clearMeasurements = function() {
            this.scroll = undefined;
            this.layout = undefined;
            this.snapshot = undefined;
            this.prevTransformTemplateValue = undefined;
            this.targetDelta = undefined;
            this.target = undefined;
            this.isLayoutDirty = false;
        };
        /**
         * Frame calculations
         */ ProjectionNode.prototype.resolveTargetDelta = function() {
            var _a;
            var _b = this.options, layout = _b.layout, layoutId = _b.layoutId;
            /**
             * If we have no layout, we can't perform projection, so early return
             */ if (!this.layout || !(layout || layoutId)) return;
            /**
             * If we don't have a targetDelta but do have a layout, we can attempt to resolve
             * a relativeParent. This will allow a component to perform scale correction
             * even if no animation has started.
             */ // TODO If this is unsuccessful this currently happens every frame
            if (!this.targetDelta && !this.relativeTarget) {
                // TODO: This is a semi-repetition of further down this function, make DRY
                this.relativeParent = this.getClosestProjectingParent();
                if (this.relativeParent && this.relativeParent.layout) {
                    this.relativeTarget = (0, $8v3iT.createBox)();
                    this.relativeTargetOrigin = (0, $8v3iT.createBox)();
                    (0, $8BLfb.calcRelativePosition)(this.relativeTargetOrigin, this.layout.actual, this.relativeParent.layout.actual);
                    (0, $96kmk.copyBoxInto)(this.relativeTarget, this.relativeTargetOrigin);
                }
            }
            /**
             * If we have no relative target or no target delta our target isn't valid
             * for this frame.
             */ if (!this.relativeTarget && !this.targetDelta) return;
            /**
             * Lazy-init target data structure
             */ if (!this.target) {
                this.target = (0, $8v3iT.createBox)();
                this.targetWithTransforms = (0, $8v3iT.createBox)();
            }
            /**
             * If we've got a relative box for this component, resolve it into a target relative to the parent.
             */ if (this.relativeTarget && this.relativeTargetOrigin && ((_a = this.relativeParent) === null || _a === void 0 ? void 0 : _a.target)) (0, $8BLfb.calcRelativeBox)(this.target, this.relativeTarget, this.relativeParent.target);
            else if (this.targetDelta) {
                if (Boolean(this.resumingFrom)) // TODO: This is creating a new object every frame
                this.target = this.applyTransform(this.layout.actual);
                else (0, $96kmk.copyBoxInto)(this.target, this.layout.actual);
                (0, $fxwRw.applyBoxDelta)(this.target, this.targetDelta);
            } else /**
                 * If no target, use own layout as target
                 */ (0, $96kmk.copyBoxInto)(this.target, this.layout.actual);
            /**
             * If we've been told to attempt to resolve a relative target, do so.
             */ if (this.attemptToResolveRelativeTarget) {
                this.attemptToResolveRelativeTarget = false;
                this.relativeParent = this.getClosestProjectingParent();
                if (this.relativeParent && Boolean(this.relativeParent.resumingFrom) === Boolean(this.resumingFrom) && !this.relativeParent.options.layoutScroll && this.relativeParent.target) {
                    this.relativeTarget = (0, $8v3iT.createBox)();
                    this.relativeTargetOrigin = (0, $8v3iT.createBox)();
                    (0, $8BLfb.calcRelativePosition)(this.relativeTargetOrigin, this.target, this.relativeParent.target);
                    (0, $96kmk.copyBoxInto)(this.relativeTarget, this.relativeTargetOrigin);
                }
            }
        };
        ProjectionNode.prototype.getClosestProjectingParent = function() {
            if (!this.parent || (0, $3xchP.hasTransform)(this.parent.latestValues)) return undefined;
            if ((this.parent.relativeTarget || this.parent.targetDelta) && this.parent.layout) return this.parent;
            else return this.parent.getClosestProjectingParent();
        };
        ProjectionNode.prototype.calcProjection = function() {
            var _a;
            var _b = this.options, layout = _b.layout, layoutId = _b.layoutId;
            /**
             * If this section of the tree isn't animating we can
             * delete our target sources for the following frame.
             */ this.isTreeAnimating = Boolean(((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isTreeAnimating) || this.currentAnimation || this.pendingAnimation);
            if (!this.isTreeAnimating) this.targetDelta = this.relativeTarget = undefined;
            if (!this.layout || !(layout || layoutId)) return;
            var lead = this.getLead();
            /**
             * Reset the corrected box with the latest values from box, as we're then going
             * to perform mutative operations on it.
             */ (0, $96kmk.copyBoxInto)(this.layoutCorrected, this.layout.actual);
            /**
             * Apply all the parent deltas to this box to produce the corrected box. This
             * is the layout box, as it will appear on screen as a result of the transforms of its parents.
             */ (0, $fxwRw.applyTreeDeltas)(this.layoutCorrected, this.treeScale, this.path, Boolean(this.resumingFrom) || this !== lead);
            var target = lead.target;
            if (!target) return;
            if (!this.projectionDelta) {
                this.projectionDelta = (0, $8v3iT.createDelta)();
                this.projectionDeltaWithTransform = (0, $8v3iT.createDelta)();
            }
            var prevTreeScaleX = this.treeScale.x;
            var prevTreeScaleY = this.treeScale.y;
            var prevProjectionTransform = this.projectionTransform;
            /**
             * Update the delta between the corrected box and the target box before user-set transforms were applied.
             * This will allow us to calculate the corrected borderRadius and boxShadow to compensate
             * for our layout reprojection, but still allow them to be scaled correctly by the user.
             * It might be that to simplify this we may want to accept that user-set scale is also corrected
             * and we wouldn't have to keep and calc both deltas, OR we could support a user setting
             * to allow people to choose whether these styles are corrected based on just the
             * layout reprojection or the final bounding box.
             */ (0, $8BLfb.calcBoxDelta)(this.projectionDelta, this.layoutCorrected, target, this.latestValues);
            this.projectionTransform = (0, $cjbno.buildProjectionTransform)(this.projectionDelta, this.treeScale);
            if (this.projectionTransform !== prevProjectionTransform || this.treeScale.x !== prevTreeScaleX || this.treeScale.y !== prevTreeScaleY) {
                this.hasProjected = true;
                this.scheduleRender();
                this.notifyListeners("projectionUpdate", target);
            }
        };
        ProjectionNode.prototype.hide = function() {
            this.isVisible = false;
        // TODO: Schedule render
        };
        ProjectionNode.prototype.show = function() {
            this.isVisible = true;
        // TODO: Schedule render
        };
        ProjectionNode.prototype.scheduleRender = function(notifyAll) {
            var _a, _b, _c;
            if (notifyAll === void 0) notifyAll = true;
            (_b = (_a = this.options).scheduleRender) === null || _b === void 0 || _b.call(_a);
            notifyAll && ((_c = this.getStack()) === null || _c === void 0 || _c.scheduleRender());
            if (this.resumingFrom && !this.resumingFrom.instance) this.resumingFrom = undefined;
        };
        ProjectionNode.prototype.setAnimationOrigin = function(delta, hasOnlyRelativeTargetChanged) {
            var _this = this;
            var _a;
            if (hasOnlyRelativeTargetChanged === void 0) hasOnlyRelativeTargetChanged = false;
            var snapshot = this.snapshot;
            var snapshotLatestValues = (snapshot === null || snapshot === void 0 ? void 0 : snapshot.latestValues) || {};
            var mixedValues = (0, $7WQrb.__assign)({}, this.latestValues);
            var targetDelta = (0, $8v3iT.createDelta)();
            this.relativeTarget = this.relativeTargetOrigin = undefined;
            this.attemptToResolveRelativeTarget = !hasOnlyRelativeTargetChanged;
            var relativeLayout = (0, $8v3iT.createBox)();
            var isSharedLayoutAnimation = snapshot === null || snapshot === void 0 ? void 0 : snapshot.isShared;
            var isOnlyMember = (((_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.members.length) || 0) <= 1;
            var shouldCrossfadeOpacity = Boolean(isSharedLayoutAnimation && !isOnlyMember && this.options.crossfade === true && !this.path.some($d2ca41ba1b84bcfe$var$hasOpacityCrossfade));
            this.animationProgress = 0;
            this.mixTargetDelta = function(latest) {
                var _a;
                var progress = latest / 1000;
                $d2ca41ba1b84bcfe$export$91dbf443e1bf1de1(targetDelta.x, delta.x, progress);
                $d2ca41ba1b84bcfe$export$91dbf443e1bf1de1(targetDelta.y, delta.y, progress);
                _this.setTargetDelta(targetDelta);
                if (_this.relativeTarget && _this.relativeTargetOrigin && _this.layout && ((_a = _this.relativeParent) === null || _a === void 0 ? void 0 : _a.layout)) {
                    (0, $8BLfb.calcRelativePosition)(relativeLayout, _this.layout.actual, _this.relativeParent.layout.actual);
                    $d2ca41ba1b84bcfe$export$6ffd3e6ae339a132(_this.relativeTarget, _this.relativeTargetOrigin, relativeLayout, progress);
                }
                if (isSharedLayoutAnimation) {
                    _this.animationValues = mixedValues;
                    (0, $kKryO.mixValues)(mixedValues, snapshotLatestValues, _this.latestValues, progress, shouldCrossfadeOpacity, isOnlyMember);
                }
                _this.root.scheduleUpdateProjection();
                _this.scheduleRender();
                _this.animationProgress = progress;
            };
            this.mixTargetDelta(0);
        };
        ProjectionNode.prototype.startAnimation = function(options) {
            var _this = this;
            var _a, _b;
            this.notifyListeners("animationStart");
            (_a = this.currentAnimation) === null || _a === void 0 || _a.stop();
            if (this.resumingFrom) (_b = this.resumingFrom.currentAnimation) === null || _b === void 0 || _b.stop();
            if (this.pendingAnimation) {
                (0, $9ksIr.cancelSync).update(this.pendingAnimation);
                this.pendingAnimation = undefined;
            }
            /**
             * Start the animation in the next frame to have a frame with progress 0,
             * where the target is the same as when the animation started, so we can
             * calculate the relative positions correctly for instant transitions.
             */ this.pendingAnimation = (0, $9ksIr.default).update(function() {
                (0, $9CWXG.globalProjectionState).hasAnimatedSinceResize = true;
                _this.currentAnimation = (0, $e8dlz.animate)(0, $d2ca41ba1b84bcfe$var$animationTarget, (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, options), {
                    onUpdate: function(latest) {
                        var _a;
                        _this.mixTargetDelta(latest);
                        (_a = options.onUpdate) === null || _a === void 0 || _a.call(options, latest);
                    },
                    onComplete: function() {
                        var _a;
                        (_a = options.onComplete) === null || _a === void 0 || _a.call(options);
                        _this.completeAnimation();
                    }
                }));
                if (_this.resumingFrom) _this.resumingFrom.currentAnimation = _this.currentAnimation;
                _this.pendingAnimation = undefined;
            });
        };
        ProjectionNode.prototype.completeAnimation = function() {
            var _a;
            if (this.resumingFrom) {
                this.resumingFrom.currentAnimation = undefined;
                this.resumingFrom.preserveOpacity = undefined;
            }
            (_a = this.getStack()) === null || _a === void 0 || _a.exitAnimationComplete();
            this.resumingFrom = this.currentAnimation = this.animationValues = undefined;
            this.notifyListeners("animationComplete");
        };
        ProjectionNode.prototype.finishAnimation = function() {
            var _a;
            if (this.currentAnimation) {
                (_a = this.mixTargetDelta) === null || _a === void 0 || _a.call(this, $d2ca41ba1b84bcfe$var$animationTarget);
                this.currentAnimation.stop();
            }
            this.completeAnimation();
        };
        ProjectionNode.prototype.applyTransformsToTarget = function() {
            var _a = this.getLead(), targetWithTransforms = _a.targetWithTransforms, target = _a.target, layout = _a.layout, latestValues = _a.latestValues;
            if (!targetWithTransforms || !target || !layout) return;
            (0, $96kmk.copyBoxInto)(targetWithTransforms, target);
            /**
             * Apply the latest user-set transforms to the targetBox to produce the targetBoxFinal.
             * This is the final box that we will then project into by calculating a transform delta and
             * applying it to the corrected box.
             */ (0, $fxwRw.transformBox)(targetWithTransforms, latestValues);
            /**
             * Update the delta between the corrected box and the final target box, after
             * user-set transforms are applied to it. This will be used by the renderer to
             * create a transform style that will reproject the element from its actual layout
             * into the desired bounding box.
             */ (0, $8BLfb.calcBoxDelta)(this.projectionDeltaWithTransform, this.layoutCorrected, targetWithTransforms, latestValues);
        };
        ProjectionNode.prototype.registerSharedNode = function(layoutId, node) {
            var _a, _b, _c;
            if (!this.sharedNodes.has(layoutId)) this.sharedNodes.set(layoutId, new (0, $24cVq.NodeStack)());
            var stack = this.sharedNodes.get(layoutId);
            stack.add(node);
            node.promote({
                transition: (_a = node.options.initialPromotionConfig) === null || _a === void 0 ? void 0 : _a.transition,
                preserveFollowOpacity: (_c = (_b = node.options.initialPromotionConfig) === null || _b === void 0 ? void 0 : _b.shouldPreserveFollowOpacity) === null || _c === void 0 ? void 0 : _c.call(_b, node)
            });
        };
        ProjectionNode.prototype.isLead = function() {
            var stack = this.getStack();
            return stack ? stack.lead === this : true;
        };
        ProjectionNode.prototype.getLead = function() {
            var _a;
            var layoutId = this.options.layoutId;
            return layoutId ? ((_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.lead) || this : this;
        };
        ProjectionNode.prototype.getPrevLead = function() {
            var _a;
            var layoutId = this.options.layoutId;
            return layoutId ? (_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.prevLead : undefined;
        };
        ProjectionNode.prototype.getStack = function() {
            var layoutId = this.options.layoutId;
            if (layoutId) return this.root.sharedNodes.get(layoutId);
        };
        ProjectionNode.prototype.promote = function(_a) {
            var _b = _a === void 0 ? {} : _a, needsReset = _b.needsReset, transition = _b.transition, preserveFollowOpacity = _b.preserveFollowOpacity;
            var stack = this.getStack();
            if (stack) stack.promote(this, preserveFollowOpacity);
            if (needsReset) {
                this.projectionDelta = undefined;
                this.needsReset = true;
            }
            if (transition) this.setOptions({
                transition: transition
            });
        };
        ProjectionNode.prototype.relegate = function() {
            var stack = this.getStack();
            if (stack) return stack.relegate(this);
            else return false;
        };
        ProjectionNode.prototype.resetRotation = function() {
            var visualElement = this.options.visualElement;
            if (!visualElement) return;
            // If there's no detected rotation values, we can early return without a forced render.
            var hasRotate = false;
            // Keep a record of all the values we've reset
            var resetValues = {};
            // Check the rotate value of all axes and reset to 0
            for(var i = 0; i < (0, $5f0mC.transformAxes).length; i++){
                var axis = (0, $5f0mC.transformAxes)[i];
                var key = "rotate" + axis;
                // If this rotation doesn't exist as a motion value, then we don't
                // need to reset it
                if (!visualElement.getStaticValue(key)) continue;
                hasRotate = true;
                // Record the rotation and then temporarily set it to 0
                resetValues[key] = visualElement.getStaticValue(key);
                visualElement.setStaticValue(key, 0);
            }
            // If there's no rotation values, we don't need to do any more.
            if (!hasRotate) return;
            // Force a render of this element to apply the transform with all rotations
            // set to 0.
            visualElement === null || visualElement === void 0 || visualElement.syncRender();
            // Put back all the values we reset
            for(var key in resetValues)visualElement.setStaticValue(key, resetValues[key]);
            // Schedule a render for the next frame. This ensures we won't visually
            // see the element with the reset rotate value applied.
            visualElement.scheduleRender();
        };
        ProjectionNode.prototype.getProjectionStyles = function(styleProp) {
            var _a, _b, _c, _d, _e, _f;
            if (styleProp === void 0) styleProp = {};
            // TODO: Return lifecycle-persistent object
            var styles = {};
            if (!this.instance || this.isSVG) return styles;
            if (!this.isVisible) return {
                visibility: "hidden"
            };
            else styles.visibility = "";
            var transformTemplate = (_a = this.options.visualElement) === null || _a === void 0 ? void 0 : _a.getProps().transformTemplate;
            if (this.needsReset) {
                this.needsReset = false;
                styles.opacity = "";
                styles.pointerEvents = (0, $cz2ac.resolveMotionValue)(styleProp.pointerEvents) || "";
                styles.transform = transformTemplate ? transformTemplate(this.latestValues, "") : "none";
                return styles;
            }
            var lead = this.getLead();
            if (!this.projectionDelta || !this.layout || !lead.target) {
                var emptyStyles = {};
                if (this.options.layoutId) {
                    emptyStyles.opacity = (_b = this.latestValues.opacity) !== null && _b !== void 0 ? _b : 1;
                    emptyStyles.pointerEvents = (0, $cz2ac.resolveMotionValue)(styleProp.pointerEvents) || "";
                }
                if (this.hasProjected && !(0, $3xchP.hasTransform)(this.latestValues)) {
                    emptyStyles.transform = transformTemplate ? transformTemplate({}, "") : "none";
                    this.hasProjected = false;
                }
                return emptyStyles;
            }
            var valuesToRender = lead.animationValues || lead.latestValues;
            this.applyTransformsToTarget();
            styles.transform = (0, $cjbno.buildProjectionTransform)(this.projectionDeltaWithTransform, this.treeScale, valuesToRender);
            if (transformTemplate) styles.transform = transformTemplate(valuesToRender, styles.transform);
            var _g = this.projectionDelta, x = _g.x, y = _g.y;
            styles.transformOrigin = "".concat(x.origin * 100, "% ").concat(y.origin * 100, "% 0");
            if (lead.animationValues) /**
                 * If the lead component is animating, assign this either the entering/leaving
                 * opacity
                 */ styles.opacity = lead === this ? (_d = (_c = valuesToRender.opacity) !== null && _c !== void 0 ? _c : this.latestValues.opacity) !== null && _d !== void 0 ? _d : 1 : this.preserveOpacity ? this.latestValues.opacity : valuesToRender.opacityExit;
            else /**
                 * Or we're not animating at all, set the lead component to its actual
                 * opacity and other components to hidden.
                 */ styles.opacity = lead === this ? (_e = valuesToRender.opacity) !== null && _e !== void 0 ? _e : "" : (_f = valuesToRender.opacityExit) !== null && _f !== void 0 ? _f : 0;
            /**
             * Apply scale correction
             */ for(var key in 0, $i0qI9.scaleCorrectors){
                if (valuesToRender[key] === undefined) continue;
                var _h = (0, $i0qI9.scaleCorrectors)[key], correct = _h.correct, applyTo = _h.applyTo;
                var corrected = correct(valuesToRender[key], lead);
                if (applyTo) {
                    var num = applyTo.length;
                    for(var i = 0; i < num; i++)styles[applyTo[i]] = corrected;
                } else styles[key] = corrected;
            }
            /**
             * Disable pointer events on follow components. This is to ensure
             * that if a follow component covers a lead component it doesn't block
             * pointer events on the lead.
             */ if (this.options.layoutId) styles.pointerEvents = lead === this ? (0, $cz2ac.resolveMotionValue)(styleProp.pointerEvents) || "" : "none";
            return styles;
        };
        ProjectionNode.prototype.clearSnapshot = function() {
            this.resumeFrom = this.snapshot = undefined;
        };
        // Only run on root
        ProjectionNode.prototype.resetTree = function() {
            this.root.nodes.forEach(function(node) {
                var _a;
                return (_a = node.currentAnimation) === null || _a === void 0 ? void 0 : _a.stop();
            });
            this.root.nodes.forEach($d2ca41ba1b84bcfe$var$clearMeasurements);
            this.root.sharedNodes.clear();
        };
        return ProjectionNode;
    }();
}
function $d2ca41ba1b84bcfe$var$updateLayout(node) {
    node.updateLayout();
}
function $d2ca41ba1b84bcfe$var$notifyLayoutUpdate(node) {
    var _a, _b, _c, _d;
    var snapshot = (_b = (_a = node.resumeFrom) === null || _a === void 0 ? void 0 : _a.snapshot) !== null && _b !== void 0 ? _b : node.snapshot;
    if (node.isLead() && node.layout && snapshot && node.hasListeners("didUpdate")) {
        var _e = node.layout, layout_1 = _e.actual, measuredLayout = _e.measured;
        // TODO Maybe we want to also resize the layout snapshot so we don't trigger
        // animations for instance if layout="size" and an element has only changed position
        if (node.options.animationType === "size") (0, $tnnCU.eachAxis)(function(axis) {
            var axisSnapshot = snapshot.isShared ? snapshot.measured[axis] : snapshot.layout[axis];
            var length = (0, $8BLfb.calcLength)(axisSnapshot);
            axisSnapshot.min = layout_1[axis].min;
            axisSnapshot.max = axisSnapshot.min + length;
        });
        else if (node.options.animationType === "position") (0, $tnnCU.eachAxis)(function(axis) {
            var axisSnapshot = snapshot.isShared ? snapshot.measured[axis] : snapshot.layout[axis];
            var length = (0, $8BLfb.calcLength)(layout_1[axis]);
            axisSnapshot.max = axisSnapshot.min + length;
        });
        var layoutDelta = (0, $8v3iT.createDelta)();
        (0, $8BLfb.calcBoxDelta)(layoutDelta, layout_1, snapshot.layout);
        var visualDelta = (0, $8v3iT.createDelta)();
        if (snapshot.isShared) (0, $8BLfb.calcBoxDelta)(visualDelta, node.applyTransform(measuredLayout, true), snapshot.measured);
        else (0, $8BLfb.calcBoxDelta)(visualDelta, layout_1, snapshot.layout);
        var hasLayoutChanged = !(0, $hPJ9o.isDeltaZero)(layoutDelta);
        var hasRelativeTargetChanged = false;
        if (!node.resumeFrom) {
            node.relativeParent = node.getClosestProjectingParent();
            /**
             * If the relativeParent is itself resuming from a different element then
             * the relative snapshot is not relavent
             */ if (node.relativeParent && !node.relativeParent.resumeFrom) {
                var _f = node.relativeParent, parentSnapshot = _f.snapshot, parentLayout = _f.layout;
                if (parentSnapshot && parentLayout) {
                    var relativeSnapshot = (0, $8v3iT.createBox)();
                    (0, $8BLfb.calcRelativePosition)(relativeSnapshot, snapshot.layout, parentSnapshot.layout);
                    var relativeLayout = (0, $8v3iT.createBox)();
                    (0, $8BLfb.calcRelativePosition)(relativeLayout, layout_1, parentLayout.actual);
                    if (!(0, $hPJ9o.boxEquals)(relativeSnapshot, relativeLayout)) hasRelativeTargetChanged = true;
                }
            }
        }
        node.notifyListeners("didUpdate", {
            layout: layout_1,
            snapshot: snapshot,
            delta: visualDelta,
            layoutDelta: layoutDelta,
            hasLayoutChanged: hasLayoutChanged,
            hasRelativeTargetChanged: hasRelativeTargetChanged
        });
    } else if (node.isLead()) (_d = (_c = node.options).onExitComplete) === null || _d === void 0 || _d.call(_c);
    /**
     * Clearing transition
     * TODO: Investigate why this transition is being passed in as {type: false } from Framer
     * and why we need it at all
     */ node.options.transition = undefined;
}
function $d2ca41ba1b84bcfe$var$clearSnapshot(node) {
    node.clearSnapshot();
}
function $d2ca41ba1b84bcfe$var$clearMeasurements(node) {
    node.clearMeasurements();
}
function $d2ca41ba1b84bcfe$var$resetTransformStyle(node) {
    var visualElement = node.options.visualElement;
    if (visualElement === null || visualElement === void 0 ? void 0 : visualElement.getProps().onBeforeLayoutMeasure) visualElement.notifyBeforeLayoutMeasure();
    node.resetTransform();
}
function $d2ca41ba1b84bcfe$var$finishAnimation(node) {
    node.finishAnimation();
    node.targetDelta = node.relativeTarget = node.target = undefined;
}
function $d2ca41ba1b84bcfe$var$resolveTargetDelta(node) {
    node.resolveTargetDelta();
}
function $d2ca41ba1b84bcfe$var$calcProjection(node) {
    node.calcProjection();
}
function $d2ca41ba1b84bcfe$var$resetRotation(node) {
    node.resetRotation();
}
function $d2ca41ba1b84bcfe$var$removeLeadSnapshots(stack) {
    stack.removeLeadSnapshot();
}
function $d2ca41ba1b84bcfe$export$91dbf443e1bf1de1(output, delta, p) {
    output.translate = (0, $bqVjQ.mix)(delta.translate, 0, p);
    output.scale = (0, $bqVjQ.mix)(delta.scale, 1, p);
    output.origin = delta.origin;
    output.originPoint = delta.originPoint;
}
function $d2ca41ba1b84bcfe$export$8f9f6b0c76c773c7(output, from, to, p) {
    output.min = (0, $bqVjQ.mix)(from.min, to.min, p);
    output.max = (0, $bqVjQ.mix)(from.max, to.max, p);
}
function $d2ca41ba1b84bcfe$export$6ffd3e6ae339a132(output, from, to, p) {
    $d2ca41ba1b84bcfe$export$8f9f6b0c76c773c7(output.x, from.x, to.x, p);
    $d2ca41ba1b84bcfe$export$8f9f6b0c76c773c7(output.y, from.y, to.y, p);
}
function $d2ca41ba1b84bcfe$var$hasOpacityCrossfade(node) {
    return node.animationValues && node.animationValues.opacityExit !== undefined;
}
var $d2ca41ba1b84bcfe$var$defaultLayoutTransition = {
    duration: 0.45,
    ease: [
        0.4,
        0,
        0.1,
        1
    ]
};
function $d2ca41ba1b84bcfe$var$mountNodeEarly(node, id) {
    /**
     * Rather than searching the DOM from document we can search the
     * path for the deepest mounted ancestor and search from there
     */ var searchNode = node.root;
    for(var i = node.path.length - 1; i >= 0; i--)if (Boolean(node.path[i].instance)) {
        searchNode = node.path[i];
        break;
    }
    var searchElement = searchNode && searchNode !== node.root ? searchNode.instance : document;
    var element = searchElement.querySelector('[data-projection-id="'.concat(id, '"]'));
    if (element) node.mount(element, true);
}
function $d2ca41ba1b84bcfe$var$roundAxis(axis) {
    axis.min = Math.round(axis.min);
    axis.max = Math.round(axis.max);
}
function $d2ca41ba1b84bcfe$var$roundBox(box) {
    $d2ca41ba1b84bcfe$var$roundAxis(box.x);
    $d2ca41ba1b84bcfe$var$roundAxis(box.y);
}

});
parcelRegister("e8dlz", function(module, exports) {

$parcel$export(module.exports, "animate", () => $1ef13963bb19565a$export$e3607ec2d7a891c4);

var $9s8eJ = parcelRequire("9s8eJ");

var $jqFCw = parcelRequire("jqFCw");

var $bUTXm = parcelRequire("bUTXm");
/**
 * Animate a single value or a `MotionValue`.
 *
 * The first argument is either a `MotionValue` to animate, or an initial animation value.
 *
 * The second is either a value to animate to, or an array of keyframes to animate through.
 *
 * The third argument can be either tween or spring options, and optional lifecycle methods: `onUpdate`, `onPlay`, `onComplete`, `onRepeat` and `onStop`.
 *
 * Returns `AnimationPlaybackControls`, currently just a `stop` method.
 *
 * ```javascript
 * const x = useMotionValue(0)
 *
 * useEffect(() => {
 *   const controls = animate(x, 100, {
 *     type: "spring",
 *     stiffness: 2000,
 *     onComplete: v => {}
 *   })
 *
 *   return controls.stop
 * })
 * ```
 *
 * @public
 */ function $1ef13963bb19565a$export$e3607ec2d7a891c4(from, to, transition) {
    if (transition === void 0) transition = {};
    var value = (0, $jqFCw.isMotionValue)(from) ? from : (0, $9s8eJ.motionValue)(from);
    (0, $bUTXm.startAnimation)("", value, to, transition);
    return {
        stop: function() {
            return value.stop();
        },
        isAnimating: function() {
            return value.isAnimating();
        }
    };
}

});

parcelRegister("kKryO", function(module, exports) {

$parcel$export(module.exports, "mixValues", () => $82b1c16a20b13fa0$export$739e279c17d51c3d);

var $bsiRs = parcelRequire("bsiRs");
var $bqVjQ = parcelRequire("bqVjQ");
var $j248P = parcelRequire("j248P");

var $1fCxR = parcelRequire("1fCxR");
var $82b1c16a20b13fa0$var$borders = [
    "TopLeft",
    "TopRight",
    "BottomLeft",
    "BottomRight"
];
var $82b1c16a20b13fa0$var$numBorders = $82b1c16a20b13fa0$var$borders.length;
var $82b1c16a20b13fa0$var$asNumber = function(value) {
    return typeof value === "string" ? parseFloat(value) : value;
};
var $82b1c16a20b13fa0$var$isPx = function(value) {
    return typeof value === "number" || (0, $1fCxR.px).test(value);
};
function $82b1c16a20b13fa0$export$739e279c17d51c3d(target, follow, lead, progress, shouldCrossfadeOpacity, isOnlyMember) {
    var _a, _b, _c, _d;
    if (shouldCrossfadeOpacity) {
        target.opacity = (0, $bqVjQ.mix)(0, // (follow?.opacity as number) ?? 0,
        // TODO Reinstate this if only child
        (_a = lead.opacity) !== null && _a !== void 0 ? _a : 1, $82b1c16a20b13fa0$var$easeCrossfadeIn(progress));
        target.opacityExit = (0, $bqVjQ.mix)((_b = follow.opacity) !== null && _b !== void 0 ? _b : 1, 0, $82b1c16a20b13fa0$var$easeCrossfadeOut(progress));
    } else if (isOnlyMember) target.opacity = (0, $bqVjQ.mix)((_c = follow.opacity) !== null && _c !== void 0 ? _c : 1, (_d = lead.opacity) !== null && _d !== void 0 ? _d : 1, progress);
    /**
     * Mix border radius
     */ for(var i = 0; i < $82b1c16a20b13fa0$var$numBorders; i++){
        var borderLabel = "border".concat($82b1c16a20b13fa0$var$borders[i], "Radius");
        var followRadius = $82b1c16a20b13fa0$var$getRadius(follow, borderLabel);
        var leadRadius = $82b1c16a20b13fa0$var$getRadius(lead, borderLabel);
        if (followRadius === undefined && leadRadius === undefined) continue;
        followRadius || (followRadius = 0);
        leadRadius || (leadRadius = 0);
        var canMix = followRadius === 0 || leadRadius === 0 || $82b1c16a20b13fa0$var$isPx(followRadius) === $82b1c16a20b13fa0$var$isPx(leadRadius);
        if (canMix) {
            target[borderLabel] = Math.max((0, $bqVjQ.mix)($82b1c16a20b13fa0$var$asNumber(followRadius), $82b1c16a20b13fa0$var$asNumber(leadRadius), progress), 0);
            if ((0, $1fCxR.percent).test(leadRadius) || (0, $1fCxR.percent).test(followRadius)) target[borderLabel] += "%";
        } else target[borderLabel] = leadRadius;
    }
    /**
     * Mix rotation
     */ if (follow.rotate || lead.rotate) target.rotate = (0, $bqVjQ.mix)(follow.rotate || 0, lead.rotate || 0, progress);
}
function $82b1c16a20b13fa0$var$getRadius(values, radiusName) {
    var _a;
    return (_a = values[radiusName]) !== null && _a !== void 0 ? _a : values.borderRadius;
}
// /**
//  * We only want to mix the background color if there's a follow element
//  * that we're not crossfading opacity between. For instance with switch
//  * AnimateSharedLayout animations, this helps the illusion of a continuous
//  * element being animated but also cuts down on the number of paints triggered
//  * for elements where opacity is doing that work for us.
//  */
// if (
//     !hasFollowElement &&
//     latestLeadValues.backgroundColor &&
//     latestFollowValues.backgroundColor
// ) {
//     /**
//      * This isn't ideal performance-wise as mixColor is creating a new function every frame.
//      * We could probably create a mixer that runs at the start of the animation but
//      * the idea behind the crossfader is that it runs dynamically between two potentially
//      * changing targets (ie opacity or borderRadius may be animating independently via variants)
//      */
//     leadState.backgroundColor = followState.backgroundColor = mixColor(
//         latestFollowValues.backgroundColor as string,
//         latestLeadValues.backgroundColor as string
//     )(p)
// }
var $82b1c16a20b13fa0$var$easeCrossfadeIn = $82b1c16a20b13fa0$var$compress(0, 0.5, (0, $bsiRs.circOut));
var $82b1c16a20b13fa0$var$easeCrossfadeOut = $82b1c16a20b13fa0$var$compress(0.5, 0.95, (0, $bsiRs.linear));
function $82b1c16a20b13fa0$var$compress(min, max, easing) {
    return function(p) {
        // Could replace ifs with clamp
        if (p < min) return 0;
        if (p > max) return 1;
        return easing((0, $j248P.progress)(min, max, p));
    };
}

});

parcelRegister("96kmk", function(module, exports) {

$parcel$export(module.exports, "copyBoxInto", () => $5960d81994414d5a$export$c53fd88f45d77e4b);
/**
 * Reset an axis to the provided origin box.
 *
 * This is a mutative operation.
 */ function $5960d81994414d5a$export$a0230ae482601ae8(axis, originAxis) {
    axis.min = originAxis.min;
    axis.max = originAxis.max;
}
/**
 * Reset a box to the provided origin box.
 *
 * This is a mutative operation.
 */ function $5960d81994414d5a$export$c53fd88f45d77e4b(box, originBox) {
    $5960d81994414d5a$export$a0230ae482601ae8(box.x, originBox.x);
    $5960d81994414d5a$export$a0230ae482601ae8(box.y, originBox.y);
}

});

parcelRegister("lldi8", function(module, exports) {

$parcel$export(module.exports, "removeBoxTransforms", () => $db628fcc785b8b87$export$73e1ad0a9694e25c);

var $7WQrb = parcelRequire("7WQrb");

var $bqVjQ = parcelRequire("bqVjQ");

var $1fCxR = parcelRequire("1fCxR");

var $fxwRw = parcelRequire("fxwRw");
/**
 * Remove a delta from a point. This is essentially the steps of applyPointDelta in reverse
 */ function $db628fcc785b8b87$export$691f07066b3be7c5(point, translate, scale, originPoint, boxScale) {
    point -= translate;
    point = (0, $fxwRw.scalePoint)(point, 1 / scale, originPoint);
    if (boxScale !== undefined) point = (0, $fxwRw.scalePoint)(point, 1 / boxScale, originPoint);
    return point;
}
/**
 * Remove a delta from an axis. This is essentially the steps of applyAxisDelta in reverse
 */ function $db628fcc785b8b87$export$cc12a0672fae5b4a(axis, translate, scale, origin, boxScale, originAxis, sourceAxis) {
    if (translate === void 0) translate = 0;
    if (scale === void 0) scale = 1;
    if (origin === void 0) origin = 0.5;
    if (originAxis === void 0) originAxis = axis;
    if (sourceAxis === void 0) sourceAxis = axis;
    if ((0, $1fCxR.percent).test(translate)) {
        translate = parseFloat(translate);
        var relativeProgress = (0, $bqVjQ.mix)(sourceAxis.min, sourceAxis.max, translate / 100);
        translate = relativeProgress - sourceAxis.min;
    }
    if (typeof translate !== "number") return;
    var originPoint = (0, $bqVjQ.mix)(originAxis.min, originAxis.max, origin);
    if (axis === originAxis) originPoint -= translate;
    axis.min = $db628fcc785b8b87$export$691f07066b3be7c5(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $db628fcc785b8b87$export$691f07066b3be7c5(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Remove a transforms from an axis. This is essentially the steps of applyAxisTransforms in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $db628fcc785b8b87$export$42b76f1d0d16d5b(axis, transforms, _a, origin, sourceAxis) {
    var _b = (0, $7WQrb.__read)(_a, 3), key = _b[0], scaleKey = _b[1], originKey = _b[2];
    $db628fcc785b8b87$export$cc12a0672fae5b4a(axis, transforms[key], transforms[scaleKey], transforms[originKey], transforms.scale, origin, sourceAxis);
}
/**
 * The names of the motion values we want to apply as translation, scale and origin.
 */ var $db628fcc785b8b87$var$xKeys = [
    "x",
    "scaleX",
    "originX"
];
var $db628fcc785b8b87$var$yKeys = [
    "y",
    "scaleY",
    "originY"
];
/**
 * Remove a transforms from an box. This is essentially the steps of applyAxisBox in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $db628fcc785b8b87$export$73e1ad0a9694e25c(box, transforms, originBox, sourceBox) {
    $db628fcc785b8b87$export$42b76f1d0d16d5b(box.x, transforms, $db628fcc785b8b87$var$xKeys, originBox === null || originBox === void 0 ? void 0 : originBox.x, sourceBox === null || sourceBox === void 0 ? void 0 : sourceBox.x);
    $db628fcc785b8b87$export$42b76f1d0d16d5b(box.y, transforms, $db628fcc785b8b87$var$yKeys, originBox === null || originBox === void 0 ? void 0 : originBox.y, sourceBox === null || sourceBox === void 0 ? void 0 : sourceBox.y);
}

});

parcelRegister("hPJ9o", function(module, exports) {

$parcel$export(module.exports, "isDeltaZero", () => $b070f9c5f268d45c$export$a7ec7642fe550fb6);
$parcel$export(module.exports, "boxEquals", () => $b070f9c5f268d45c$export$8d5cf76bb7daff09);
function $b070f9c5f268d45c$var$isAxisDeltaZero(delta) {
    return delta.translate === 0 && delta.scale === 1;
}
function $b070f9c5f268d45c$export$a7ec7642fe550fb6(delta) {
    return $b070f9c5f268d45c$var$isAxisDeltaZero(delta.x) && $b070f9c5f268d45c$var$isAxisDeltaZero(delta.y);
}
function $b070f9c5f268d45c$export$8d5cf76bb7daff09(a, b) {
    return a.x.min === b.x.min && a.x.max === b.x.max && a.y.min === b.y.min && a.y.max === b.y.max;
}

});

parcelRegister("24cVq", function(module, exports) {

$parcel$export(module.exports, "NodeStack", () => $a040ab986103db06$export$39be5b2d82fc9dc7);

var $8DEVZ = parcelRequire("8DEVZ");
var $a040ab986103db06$export$39be5b2d82fc9dc7 = /** @class */ function() {
    function NodeStack() {
        this.members = [];
    }
    NodeStack.prototype.add = function(node) {
        (0, $8DEVZ.addUniqueItem)(this.members, node);
        node.scheduleRender();
    };
    NodeStack.prototype.remove = function(node) {
        (0, $8DEVZ.removeItem)(this.members, node);
        if (node === this.prevLead) this.prevLead = undefined;
        if (node === this.lead) {
            var prevLead = this.members[this.members.length - 1];
            if (prevLead) this.promote(prevLead);
        }
    };
    NodeStack.prototype.relegate = function(node) {
        var indexOfNode = this.members.findIndex(function(member) {
            return node === member;
        });
        if (indexOfNode === 0) return false;
        /**
         * Find the next projection node that is present
         */ var prevLead;
        for(var i = indexOfNode; i >= 0; i--){
            var member = this.members[i];
            if (member.isPresent !== false) {
                prevLead = member;
                break;
            }
        }
        if (prevLead) {
            this.promote(prevLead);
            return true;
        } else return false;
    };
    NodeStack.prototype.promote = function(node, preserveFollowOpacity) {
        var _a;
        var prevLead = this.lead;
        if (node === prevLead) return;
        this.prevLead = prevLead;
        this.lead = node;
        node.show();
        if (prevLead) {
            prevLead.instance && prevLead.scheduleRender();
            node.scheduleRender();
            node.resumeFrom = prevLead;
            if (preserveFollowOpacity) node.resumeFrom.preserveOpacity = true;
            if (prevLead.snapshot) {
                node.snapshot = prevLead.snapshot;
                node.snapshot.latestValues = prevLead.animationValues || prevLead.latestValues;
                node.snapshot.isShared = true;
            }
            if ((_a = node.root) === null || _a === void 0 ? void 0 : _a.isUpdating) node.isLayoutDirty = true;
            var crossfade = node.options.crossfade;
            if (crossfade === false) prevLead.hide();
        /**
             * TODO:
             *   - Test border radius when previous node was deleted
             *   - boxShadow mixing
             *   - Shared between element A in scrolled container and element B (scroll stays the same or changes)
             *   - Shared between element A in transformed container and element B (transform stays the same or changes)
             *   - Shared between element A in scrolled page and element B (scroll stays the same or changes)
             * ---
             *   - Crossfade opacity of root nodes
             *   - layoutId changes after animation
             *   - layoutId changes mid animation
             */ }
    };
    NodeStack.prototype.exitAnimationComplete = function() {
        this.members.forEach(function(node) {
            var _a, _b, _c, _d, _e;
            (_b = (_a = node.options).onExitComplete) === null || _b === void 0 || _b.call(_a);
            (_e = (_c = node.resumingFrom) === null || _c === void 0 ? void 0 : (_d = _c.options).onExitComplete) === null || _e === void 0 || _e.call(_d);
        });
    };
    NodeStack.prototype.scheduleRender = function() {
        this.members.forEach(function(node) {
            node.instance && node.scheduleRender(false);
        });
    };
    /**
     * Clear any leads that have been removed this render to prevent them from being
     * used in future animations and to prevent memory leaks
     */ NodeStack.prototype.removeLeadSnapshot = function() {
        if (this.lead && this.lead.snapshot) this.lead.snapshot = undefined;
    };
    return NodeStack;
}();

});

parcelRegister("cjbno", function(module, exports) {

$parcel$export(module.exports, "buildProjectionTransform", () => $0214cdf9d4bb801d$export$d33653b270fe725c);
var $0214cdf9d4bb801d$export$f6730f82d2dcfda3 = "translate3d(0px, 0px, 0) scale(1, 1) scale(1, 1)";
function $0214cdf9d4bb801d$export$d33653b270fe725c(delta, treeScale, latestTransform) {
    /**
     * The translations we use to calculate are always relative to the viewport coordinate space.
     * But when we apply scales, we also scale the coordinate space of an element and its children.
     * For instance if we have a treeScale (the culmination of all parent scales) of 0.5 and we need
     * to move an element 100 pixels, we actually need to move it 200 in within that scaled space.
     */ var xTranslate = delta.x.translate / treeScale.x;
    var yTranslate = delta.y.translate / treeScale.y;
    var transform = "translate3d(".concat(xTranslate, "px, ").concat(yTranslate, "px, 0) ");
    /**
     * Apply scale correction for the tree transform.
     * This will apply scale to the screen-orientated axes.
     */ transform += "scale(".concat(1 / treeScale.x, ", ").concat(1 / treeScale.y, ") ");
    if (latestTransform) {
        var rotate = latestTransform.rotate, rotateX = latestTransform.rotateX, rotateY = latestTransform.rotateY;
        if (rotate) transform += "rotate(".concat(rotate, "deg) ");
        if (rotateX) transform += "rotateX(".concat(rotateX, "deg) ");
        if (rotateY) transform += "rotateY(".concat(rotateY, "deg) ");
    }
    /**
     * Apply scale to match the size of the element to the size we want it.
     * This will apply scale to the element-orientated axes.
     */ var elementScaleX = delta.x.scale * treeScale.x;
    var elementScaleY = delta.y.scale * treeScale.y;
    transform += "scale(".concat(elementScaleX, ", ").concat(elementScaleY, ")");
    return transform === $0214cdf9d4bb801d$export$f6730f82d2dcfda3 ? "none" : transform;
}

});

parcelRegister("73AdZ", function(module, exports) {

$parcel$export(module.exports, "FlatTree", () => $e21f5e6c9473a18c$export$1465d17e3de78a96);

var $8DEVZ = parcelRequire("8DEVZ");

var $f5OKq = parcelRequire("f5OKq");
var $e21f5e6c9473a18c$export$1465d17e3de78a96 = /** @class */ function() {
    function FlatTree() {
        this.children = [];
        this.isDirty = false;
    }
    FlatTree.prototype.add = function(child) {
        (0, $8DEVZ.addUniqueItem)(this.children, child);
        this.isDirty = true;
    };
    FlatTree.prototype.remove = function(child) {
        (0, $8DEVZ.removeItem)(this.children, child);
        this.isDirty = true;
    };
    FlatTree.prototype.forEach = function(callback) {
        this.isDirty && this.children.sort((0, $f5OKq.compareByDepth));
        this.isDirty = false;
        this.children.forEach(callback);
    };
    return FlatTree;
}();

});
parcelRegister("f5OKq", function(module, exports) {

$parcel$export(module.exports, "compareByDepth", () => $8e214807702da081$export$d689d9dec5ad338);
var $8e214807702da081$export$d689d9dec5ad338 = function(a, b) {
    return a.depth - b.depth;
};

});



parcelRegister("h0X6O", function(module, exports) {

$parcel$export(module.exports, "DocumentProjectionNode", () => $6e97f3a9a89d5fc1$export$2d029a49a09b6177);

var $15nIA = parcelRequire("15nIA");

var $ao8nn = parcelRequire("ao8nn");
var $6e97f3a9a89d5fc1$export$2d029a49a09b6177 = (0, $15nIA.createProjectionNode)({
    attachResizeListener: function(ref, notify) {
        return (0, $ao8nn.addDomEvent)(ref, "resize", notify);
    },
    measureScroll: function() {
        return {
            x: document.documentElement.scrollLeft || document.body.scrollLeft,
            y: document.documentElement.scrollTop || document.body.scrollTop
        };
    },
    checkIsScrollRoot: function() {
        return true;
    }
});

});



parcelRegister("cS2nl", function(module, exports) {

$parcel$export(module.exports, "checkReorder", () => $af62d797ba363b9d$export$bdf3520827dcd47e);

var $bqVjQ = parcelRequire("bqVjQ");

var $8DEVZ = parcelRequire("8DEVZ");
function $af62d797ba363b9d$export$bdf3520827dcd47e(order, value, offset, velocity) {
    if (!velocity) return order;
    var index = order.findIndex(function(item) {
        return item.value === value;
    });
    if (index === -1) return order;
    var nextOffset = velocity > 0 ? 1 : -1;
    var nextItem = order[index + nextOffset];
    if (!nextItem) return order;
    var item = order[index];
    var nextLayout = nextItem.layout;
    var nextItemCenter = (0, $bqVjQ.mix)(nextLayout.min, nextLayout.max, 0.5);
    if (nextOffset === 1 && item.layout.max + offset > nextItemCenter || nextOffset === -1 && item.layout.min + offset < nextItemCenter) return (0, $8DEVZ.moveItem)(order, index, index + nextOffset);
    return order;
}

});


parcelRegister("3839M", function(module, exports) {

$parcel$export(module.exports, "Item", () => $a263876ae5e44502$export$6d08773d2e66f8f2);

var $7WQrb = parcelRequire("7WQrb");

var $6QSfE = parcelRequire("6QSfE");

var $acw62 = parcelRequire("acw62");

var $cjo2Y = parcelRequire("cjo2Y");

var $fRJCp = parcelRequire("fRJCp");

var $aTYEI = parcelRequire("aTYEI");

var $6Q7j0 = parcelRequire("6Q7j0");

var $8N3lc = parcelRequire("8N3lc");

var $jqFCw = parcelRequire("jqFCw");
function $a263876ae5e44502$var$useDefaultMotionValue(value, defaultValue) {
    if (defaultValue === void 0) defaultValue = 0;
    return (0, $jqFCw.isMotionValue)(value) ? value : (0, $6Q7j0.useMotionValue)(defaultValue);
}
function $a263876ae5e44502$export$dfd959aaaf2d771a(_a, externalRef) {
    var children = _a.children, style = _a.style, value = _a.value, _b = _a.as, as = _b === void 0 ? "li" : _b, onDrag = _a.onDrag, _c = _a.layout, layout = _c === void 0 ? true : _c, props = (0, $7WQrb.__rest)(_a, [
        "children",
        "style",
        "value",
        "as",
        "onDrag",
        "layout"
    ]);
    var Component = (0, $aTYEI.useConstant)(function() {
        return (0, $fRJCp.motion)(as);
    });
    var context = (0, $acw62.useContext)((0, $cjo2Y.ReorderContext));
    var point = {
        x: $a263876ae5e44502$var$useDefaultMotionValue(style === null || style === void 0 ? void 0 : style.x),
        y: $a263876ae5e44502$var$useDefaultMotionValue(style === null || style === void 0 ? void 0 : style.y)
    };
    var zIndex = (0, $8N3lc.useTransform)([
        point.x,
        point.y
    ], function(_a) {
        var _b = (0, $7WQrb.__read)(_a, 2), latestX = _b[0], latestY = _b[1];
        return latestX || latestY ? 1 : "unset";
    });
    var measuredLayout = (0, $acw62.useRef)(null);
    (0, $6QSfE.invariant)(Boolean(context), "Reorder.Item must be a child of Reorder.Group");
    var _d = context, axis = _d.axis, registerItem = _d.registerItem, updateOrder = _d.updateOrder;
    (0, $acw62.useEffect)(function() {
        registerItem(value, measuredLayout.current);
    }, [
        context
    ]);
    return $acw62.createElement(Component, (0, $7WQrb.__assign)({
        drag: axis
    }, props, {
        dragSnapToOrigin: true,
        style: (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, style), {
            x: point.x,
            y: point.y,
            zIndex: zIndex
        }),
        layout: layout,
        onDrag: function(event, gesturePoint) {
            var velocity = gesturePoint.velocity;
            velocity[axis] && updateOrder(value, point[axis].get(), velocity[axis]);
            onDrag === null || onDrag === void 0 || onDrag(event, gesturePoint);
        },
        onLayoutMeasure: function(measured) {
            measuredLayout.current = measured;
        },
        ref: externalRef
    }), children);
}
var $a263876ae5e44502$export$6d08773d2e66f8f2 = (0, $acw62.forwardRef)($a263876ae5e44502$export$dfd959aaaf2d771a);

});
parcelRegister("6Q7j0", function(module, exports) {

$parcel$export(module.exports, "useMotionValue", () => $ac90f167dce3c254$export$15b697acf84c78b9);

var $7WQrb = parcelRequire("7WQrb");

var $acw62 = parcelRequire("acw62");

var $9s8eJ = parcelRequire("9s8eJ");

var $7iCGF = parcelRequire("7iCGF");

var $aTYEI = parcelRequire("aTYEI");
/**
 * Creates a `MotionValue` to track the state and velocity of a value.
 *
 * Usually, these are created automatically. For advanced use-cases, like use with `useTransform`, you can create `MotionValue`s externally and pass them into the animated component via the `style` prop.
 *
 * ```jsx
 * export const MyComponent = () => {
 *   const scale = useMotionValue(1)
 *
 *   return <motion.div style={{ scale }} />
 * }
 * ```
 *
 * @param initial - The initial state.
 *
 * @public
 */ function $ac90f167dce3c254$export$15b697acf84c78b9(initial) {
    var value = (0, $aTYEI.useConstant)(function() {
        return (0, $9s8eJ.motionValue)(initial);
    });
    /**
     * If this motion value is being used in static mode, like on
     * the Framer canvas, force components to rerender when the motion
     * value is updated.
     */ var isStatic = (0, $acw62.useContext)((0, $7iCGF.MotionConfigContext)).isStatic;
    if (isStatic) {
        var _a = (0, $7WQrb.__read)((0, $acw62.useState)(initial), 2), setLatest_1 = _a[1];
        (0, $acw62.useEffect)(function() {
            return value.onChange(setLatest_1);
        }, []);
    }
    return value;
}

});

parcelRegister("8N3lc", function(module, exports) {

$parcel$export(module.exports, "useTransform", () => $891cfbf1f21500da$export$a87ba948fb2b39ec);

var $7WQrb = parcelRequire("7WQrb");

var $2yyBD = parcelRequire("2yyBD");

var $kPkKc = parcelRequire("kPkKc");

var $aTYEI = parcelRequire("aTYEI");
function $891cfbf1f21500da$export$a87ba948fb2b39ec(input, inputRangeOrTransformer, outputRange, options) {
    var transformer = typeof inputRangeOrTransformer === "function" ? inputRangeOrTransformer : (0, $2yyBD.transform)(inputRangeOrTransformer, outputRange, options);
    return Array.isArray(input) ? $891cfbf1f21500da$var$useListTransform(input, transformer) : $891cfbf1f21500da$var$useListTransform([
        input
    ], function(_a) {
        var _b = (0, $7WQrb.__read)(_a, 1), latest = _b[0];
        return transformer(latest);
    });
}
function $891cfbf1f21500da$var$useListTransform(values, transformer) {
    var latest = (0, $aTYEI.useConstant)(function() {
        return [];
    });
    return (0, $kPkKc.useCombineMotionValues)(values, function() {
        latest.length = 0;
        var numValues = values.length;
        for(var i = 0; i < numValues; i++)latest[i] = values[i].get();
        return transformer(latest);
    });
}

});
parcelRegister("2yyBD", function(module, exports) {

$parcel$export(module.exports, "transform", () => $a329b851bac61d6b$export$51186ad6e864892a);

var $7WQrb = parcelRequire("7WQrb");

var $cXE0o = parcelRequire("cXE0o");
var $a329b851bac61d6b$var$isCustomValueType = function(v) {
    return typeof v === "object" && v.mix;
};
var $a329b851bac61d6b$var$getMixer = function(v) {
    return $a329b851bac61d6b$var$isCustomValueType(v) ? v.mix : undefined;
};
function $a329b851bac61d6b$export$51186ad6e864892a() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var useImmediate = !Array.isArray(args[0]);
    var argOffset = useImmediate ? 0 : -1;
    var inputValue = args[0 + argOffset];
    var inputRange = args[1 + argOffset];
    var outputRange = args[2 + argOffset];
    var options = args[3 + argOffset];
    var interpolator = (0, $cXE0o.interpolate)(inputRange, outputRange, (0, $7WQrb.__assign)({
        mixer: $a329b851bac61d6b$var$getMixer(outputRange[0])
    }, options));
    return useImmediate ? interpolator(inputValue) : interpolator;
}

});

parcelRegister("kPkKc", function(module, exports) {

$parcel$export(module.exports, "useCombineMotionValues", () => $746cb9d2ff647761$export$7dee4fa9fc2b33f3);

var $6Q7j0 = parcelRequire("6Q7j0");

var $73P9s = parcelRequire("73P9s");

var $9ksIr = parcelRequire("9ksIr");
function $746cb9d2ff647761$export$7dee4fa9fc2b33f3(values, combineValues) {
    /**
     * Initialise the returned motion value. This remains the same between renders.
     */ var value = (0, $6Q7j0.useMotionValue)(combineValues());
    /**
     * Create a function that will update the template motion value with the latest values.
     * This is pre-bound so whenever a motion value updates it can schedule its
     * execution in Framesync. If it's already been scheduled it won't be fired twice
     * in a single frame.
     */ var updateValue = function() {
        return value.set(combineValues());
    };
    /**
     * Synchronously update the motion value with the latest values during the render.
     * This ensures that within a React render, the styles applied to the DOM are up-to-date.
     */ updateValue();
    /**
     * Subscribe to all motion values found within the template. Whenever any of them change,
     * schedule an update.
     */ (0, $73P9s.useMultiOnChange)(values, function() {
        return (0, $9ksIr.default).update(updateValue, false, true);
    });
    return value;
}

});
parcelRegister("73P9s", function(module, exports) {

$parcel$export(module.exports, "useMultiOnChange", () => $1fec17d322b1993b$export$3b74dd024f4dcdcf);

var $jqFCw = parcelRequire("jqFCw");

var $6S63t = parcelRequire("6S63t");
function $1fec17d322b1993b$export$2bdac801b4d0d028(value, callback) {
    (0, $6S63t.useIsomorphicLayoutEffect)(function() {
        if ((0, $jqFCw.isMotionValue)(value)) return value.onChange(callback);
    }, [
        callback
    ]);
}
function $1fec17d322b1993b$export$3b74dd024f4dcdcf(values, handler) {
    (0, $6S63t.useIsomorphicLayoutEffect)(function() {
        var subscriptions = values.map(function(value) {
            return value.onChange(handler);
        });
        return function() {
            return subscriptions.forEach(function(unsubscribe) {
                return unsubscribe();
            });
        };
    });
}

});





parcelRegister("7UNcR", function(module, exports) {

$parcel$export(module.exports, "Provider", () => $68beda14d3b7350e$export$2881499e37b75b9a);
$parcel$export(module.exports, "Root", () => $68beda14d3b7350e$export$be92b6f5f03c0fe9);
$parcel$export(module.exports, "Trigger", () => $68beda14d3b7350e$export$41fb9f06171c75f4);
$parcel$export(module.exports, "Portal", () => $68beda14d3b7350e$export$602eac185826482c);
$parcel$export(module.exports, "Content", () => $68beda14d3b7350e$export$7c6e2c02157bb7d2);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $2IwC4 = parcelRequire("2IwC4");

var $htT6J = parcelRequire("htT6J");

var $jnK0n = parcelRequire("jnK0n");

var $4yZYB = parcelRequire("4yZYB");

var $g2NP0 = parcelRequire("g2NP0");

var $jxYRk = parcelRequire("jxYRk");

var $5nYva = parcelRequire("5nYva");

var $cTFdF = parcelRequire("cTFdF");

var $kFbxc = parcelRequire("kFbxc");

var $9UeUh = parcelRequire("9UeUh");

var $88UcQ = parcelRequire("88UcQ");

var $ac9wP = parcelRequire("ac9wP");
const [$68beda14d3b7350e$var$$a093c7e1ec25a057$var$createTooltipContext, $68beda14d3b7350e$export$1c540a2224f0d865] = (0, $jnK0n.createContextScope)("Tooltip", [
    (0, $jxYRk.createPopperScope)
]);
const $68beda14d3b7350e$var$$a093c7e1ec25a057$var$usePopperScope = (0, $jxYRk.createPopperScope)();
/* -------------------------------------------------------------------------------------------------
 * TooltipProvider
 * -----------------------------------------------------------------------------------------------*/ const $68beda14d3b7350e$var$$a093c7e1ec25a057$var$PROVIDER_NAME = "TooltipProvider";
const $68beda14d3b7350e$var$$a093c7e1ec25a057$var$DEFAULT_DELAY_DURATION = 700;
const $68beda14d3b7350e$var$$a093c7e1ec25a057$var$TOOLTIP_OPEN = "tooltip.open";
const [$68beda14d3b7350e$var$$a093c7e1ec25a057$var$TooltipProviderContextProvider, $68beda14d3b7350e$var$$a093c7e1ec25a057$var$useTooltipProviderContext] = $68beda14d3b7350e$var$$a093c7e1ec25a057$var$createTooltipContext($68beda14d3b7350e$var$$a093c7e1ec25a057$var$PROVIDER_NAME);
const $68beda14d3b7350e$export$f78649fb9ca566b8 = (props)=>{
    const { __scopeTooltip: __scopeTooltip, delayDuration: delayDuration = $68beda14d3b7350e$var$$a093c7e1ec25a057$var$DEFAULT_DELAY_DURATION, skipDelayDuration: skipDelayDuration = 300, disableHoverableContent: disableHoverableContent = false, children: children } = props;
    const [isOpenDelayed, setIsOpenDelayed] = (0, $acw62.useState)(true);
    const isPointerInTransitRef = (0, $acw62.useRef)(false);
    const skipDelayTimerRef = (0, $acw62.useRef)(0);
    (0, $acw62.useEffect)(()=>{
        const skipDelayTimer = skipDelayTimerRef.current;
        return ()=>window.clearTimeout(skipDelayTimer);
    }, []);
    return /*#__PURE__*/ (0, $acw62.createElement)($68beda14d3b7350e$var$$a093c7e1ec25a057$var$TooltipProviderContextProvider, {
        scope: __scopeTooltip,
        isOpenDelayed: isOpenDelayed,
        delayDuration: delayDuration,
        onOpen: (0, $acw62.useCallback)(()=>{
            window.clearTimeout(skipDelayTimerRef.current);
            setIsOpenDelayed(false);
        }, []),
        onClose: (0, $acw62.useCallback)(()=>{
            window.clearTimeout(skipDelayTimerRef.current);
            skipDelayTimerRef.current = window.setTimeout(()=>setIsOpenDelayed(true), skipDelayDuration);
        }, [
            skipDelayDuration
        ]),
        isPointerInTransitRef: isPointerInTransitRef,
        onPointerInTransitChange: (0, $acw62.useCallback)((inTransit)=>{
            isPointerInTransitRef.current = inTransit;
        }, []),
        disableHoverableContent: disableHoverableContent
    }, children);
};
/*#__PURE__*/ Object.assign($68beda14d3b7350e$export$f78649fb9ca566b8, {
    displayName: $68beda14d3b7350e$var$$a093c7e1ec25a057$var$PROVIDER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * Tooltip
 * -----------------------------------------------------------------------------------------------*/ const $68beda14d3b7350e$var$$a093c7e1ec25a057$var$TOOLTIP_NAME = "Tooltip";
const [$68beda14d3b7350e$var$$a093c7e1ec25a057$var$TooltipContextProvider, $68beda14d3b7350e$var$$a093c7e1ec25a057$var$useTooltipContext] = $68beda14d3b7350e$var$$a093c7e1ec25a057$var$createTooltipContext($68beda14d3b7350e$var$$a093c7e1ec25a057$var$TOOLTIP_NAME);
const $68beda14d3b7350e$export$28c660c63b792dea = (props)=>{
    const { __scopeTooltip: __scopeTooltip, children: children, open: openProp, defaultOpen: defaultOpen = false, onOpenChange: onOpenChange, disableHoverableContent: disableHoverableContentProp, delayDuration: delayDurationProp } = props;
    const providerContext = $68beda14d3b7350e$var$$a093c7e1ec25a057$var$useTooltipProviderContext($68beda14d3b7350e$var$$a093c7e1ec25a057$var$TOOLTIP_NAME, props.__scopeTooltip);
    const popperScope = $68beda14d3b7350e$var$$a093c7e1ec25a057$var$usePopperScope(__scopeTooltip);
    const [trigger, setTrigger] = (0, $acw62.useState)(null);
    const contentId = (0, $g2NP0.useId)();
    const openTimerRef = (0, $acw62.useRef)(0);
    const disableHoverableContent = disableHoverableContentProp !== null && disableHoverableContentProp !== void 0 ? disableHoverableContentProp : providerContext.disableHoverableContent;
    const delayDuration = delayDurationProp !== null && delayDurationProp !== void 0 ? delayDurationProp : providerContext.delayDuration;
    const wasOpenDelayedRef = (0, $acw62.useRef)(false);
    const [open1 = false, setOpen] = (0, $88UcQ.useControllableState)({
        prop: openProp,
        defaultProp: defaultOpen,
        onChange: (open)=>{
            if (open) {
                providerContext.onOpen(); // as `onChange` is called within a lifecycle method we
                // avoid dispatching via `dispatchDiscreteCustomEvent`.
                document.dispatchEvent(new CustomEvent($68beda14d3b7350e$var$$a093c7e1ec25a057$var$TOOLTIP_OPEN));
            } else providerContext.onClose();
            onOpenChange === null || onOpenChange === void 0 || onOpenChange(open);
        }
    });
    const stateAttribute = (0, $acw62.useMemo)(()=>{
        return open1 ? wasOpenDelayedRef.current ? "delayed-open" : "instant-open" : "closed";
    }, [
        open1
    ]);
    const handleOpen = (0, $acw62.useCallback)(()=>{
        window.clearTimeout(openTimerRef.current);
        wasOpenDelayedRef.current = false;
        setOpen(true);
    }, [
        setOpen
    ]);
    const handleClose = (0, $acw62.useCallback)(()=>{
        window.clearTimeout(openTimerRef.current);
        setOpen(false);
    }, [
        setOpen
    ]);
    const handleDelayedOpen = (0, $acw62.useCallback)(()=>{
        window.clearTimeout(openTimerRef.current);
        openTimerRef.current = window.setTimeout(()=>{
            wasOpenDelayedRef.current = true;
            setOpen(true);
        }, delayDuration);
    }, [
        delayDuration,
        setOpen
    ]);
    (0, $acw62.useEffect)(()=>{
        return ()=>window.clearTimeout(openTimerRef.current);
    }, []);
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $jxYRk.Root), popperScope, /*#__PURE__*/ (0, $acw62.createElement)($68beda14d3b7350e$var$$a093c7e1ec25a057$var$TooltipContextProvider, {
        scope: __scopeTooltip,
        contentId: contentId,
        open: open1,
        stateAttribute: stateAttribute,
        trigger: trigger,
        onTriggerChange: setTrigger,
        onTriggerEnter: (0, $acw62.useCallback)(()=>{
            if (providerContext.isOpenDelayed) handleDelayedOpen();
            else handleOpen();
        }, [
            providerContext.isOpenDelayed,
            handleDelayedOpen,
            handleOpen
        ]),
        onTriggerLeave: (0, $acw62.useCallback)(()=>{
            if (disableHoverableContent) handleClose();
            else window.clearTimeout(openTimerRef.current);
        }, [
            handleClose,
            disableHoverableContent
        ]),
        onOpen: handleOpen,
        onClose: handleClose,
        disableHoverableContent: disableHoverableContent
    }, children));
};
/*#__PURE__*/ Object.assign($68beda14d3b7350e$export$28c660c63b792dea, {
    displayName: $68beda14d3b7350e$var$$a093c7e1ec25a057$var$TOOLTIP_NAME
});
/* -------------------------------------------------------------------------------------------------
 * TooltipTrigger
 * -----------------------------------------------------------------------------------------------*/ const $68beda14d3b7350e$var$$a093c7e1ec25a057$var$TRIGGER_NAME = "TooltipTrigger";
const $68beda14d3b7350e$export$8c610744efcf8a1d = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopeTooltip: __scopeTooltip, ...triggerProps } = props;
    const context = $68beda14d3b7350e$var$$a093c7e1ec25a057$var$useTooltipContext($68beda14d3b7350e$var$$a093c7e1ec25a057$var$TRIGGER_NAME, __scopeTooltip);
    const providerContext = $68beda14d3b7350e$var$$a093c7e1ec25a057$var$useTooltipProviderContext($68beda14d3b7350e$var$$a093c7e1ec25a057$var$TRIGGER_NAME, __scopeTooltip);
    const popperScope = $68beda14d3b7350e$var$$a093c7e1ec25a057$var$usePopperScope(__scopeTooltip);
    const ref = (0, $acw62.useRef)(null);
    const composedRefs = (0, $htT6J.useComposedRefs)(forwardedRef, ref, context.onTriggerChange);
    const isPointerDownRef = (0, $acw62.useRef)(false);
    const hasPointerMoveOpenedRef = (0, $acw62.useRef)(false);
    const handlePointerUp = (0, $acw62.useCallback)(()=>isPointerDownRef.current = false, []);
    (0, $acw62.useEffect)(()=>{
        return ()=>document.removeEventListener("pointerup", handlePointerUp);
    }, [
        handlePointerUp
    ]);
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $jxYRk.Anchor), (0, $8nd05.default)({
        asChild: true
    }, popperScope), /*#__PURE__*/ (0, $acw62.createElement)((0, $kFbxc.Primitive).button, (0, $8nd05.default)({
        // We purposefully avoid adding `type=button` here because tooltip triggers are also
        // commonly anchors and the anchor `type` attribute signifies MIME type.
        "aria-describedby": context.open ? context.contentId : undefined,
        "data-state": context.stateAttribute
    }, triggerProps, {
        ref: composedRefs,
        onPointerMove: (0, $2IwC4.composeEventHandlers)(props.onPointerMove, (event)=>{
            if (event.pointerType === "touch") return;
            if (!hasPointerMoveOpenedRef.current && !providerContext.isPointerInTransitRef.current) {
                context.onTriggerEnter();
                hasPointerMoveOpenedRef.current = true;
            }
        }),
        onPointerLeave: (0, $2IwC4.composeEventHandlers)(props.onPointerLeave, ()=>{
            context.onTriggerLeave();
            hasPointerMoveOpenedRef.current = false;
        }),
        onPointerDown: (0, $2IwC4.composeEventHandlers)(props.onPointerDown, ()=>{
            isPointerDownRef.current = true;
            document.addEventListener("pointerup", handlePointerUp, {
                once: true
            });
        }),
        onFocus: (0, $2IwC4.composeEventHandlers)(props.onFocus, ()=>{
            if (!isPointerDownRef.current) context.onOpen();
        }),
        onBlur: (0, $2IwC4.composeEventHandlers)(props.onBlur, context.onClose),
        onClick: (0, $2IwC4.composeEventHandlers)(props.onClick, context.onClose)
    })));
});
/*#__PURE__*/ Object.assign($68beda14d3b7350e$export$8c610744efcf8a1d, {
    displayName: $68beda14d3b7350e$var$$a093c7e1ec25a057$var$TRIGGER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * TooltipPortal
 * -----------------------------------------------------------------------------------------------*/ const $68beda14d3b7350e$var$$a093c7e1ec25a057$var$PORTAL_NAME = "TooltipPortal";
const [$68beda14d3b7350e$var$$a093c7e1ec25a057$var$PortalProvider, $68beda14d3b7350e$var$$a093c7e1ec25a057$var$usePortalContext] = $68beda14d3b7350e$var$$a093c7e1ec25a057$var$createTooltipContext($68beda14d3b7350e$var$$a093c7e1ec25a057$var$PORTAL_NAME, {
    forceMount: undefined
});
const $68beda14d3b7350e$export$7b36b8f925ab7497 = (props)=>{
    const { __scopeTooltip: __scopeTooltip, forceMount: forceMount, children: children, container: container } = props;
    const context = $68beda14d3b7350e$var$$a093c7e1ec25a057$var$useTooltipContext($68beda14d3b7350e$var$$a093c7e1ec25a057$var$PORTAL_NAME, __scopeTooltip);
    return /*#__PURE__*/ (0, $acw62.createElement)($68beda14d3b7350e$var$$a093c7e1ec25a057$var$PortalProvider, {
        scope: __scopeTooltip,
        forceMount: forceMount
    }, /*#__PURE__*/ (0, $acw62.createElement)((0, $cTFdF.Presence), {
        present: forceMount || context.open
    }, /*#__PURE__*/ (0, $acw62.createElement)((0, $5nYva.Portal), {
        asChild: true,
        container: container
    }, children)));
};
/*#__PURE__*/ Object.assign($68beda14d3b7350e$export$7b36b8f925ab7497, {
    displayName: $68beda14d3b7350e$var$$a093c7e1ec25a057$var$PORTAL_NAME
});
/* -------------------------------------------------------------------------------------------------
 * TooltipContent
 * -----------------------------------------------------------------------------------------------*/ const $68beda14d3b7350e$var$$a093c7e1ec25a057$var$CONTENT_NAME = "TooltipContent";
const $68beda14d3b7350e$export$e9003e2be37ec060 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const portalContext = $68beda14d3b7350e$var$$a093c7e1ec25a057$var$usePortalContext($68beda14d3b7350e$var$$a093c7e1ec25a057$var$CONTENT_NAME, props.__scopeTooltip);
    const { forceMount: forceMount = portalContext.forceMount, side: side = "top", ...contentProps } = props;
    const context = $68beda14d3b7350e$var$$a093c7e1ec25a057$var$useTooltipContext($68beda14d3b7350e$var$$a093c7e1ec25a057$var$CONTENT_NAME, props.__scopeTooltip);
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $cTFdF.Presence), {
        present: forceMount || context.open
    }, context.disableHoverableContent ? /*#__PURE__*/ (0, $acw62.createElement)($68beda14d3b7350e$var$$a093c7e1ec25a057$var$TooltipContentImpl, (0, $8nd05.default)({
        side: side
    }, contentProps, {
        ref: forwardedRef
    })) : /*#__PURE__*/ (0, $acw62.createElement)($68beda14d3b7350e$var$$a093c7e1ec25a057$var$TooltipContentHoverable, (0, $8nd05.default)({
        side: side
    }, contentProps, {
        ref: forwardedRef
    })));
});
const $68beda14d3b7350e$var$$a093c7e1ec25a057$var$TooltipContentHoverable = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const context = $68beda14d3b7350e$var$$a093c7e1ec25a057$var$useTooltipContext($68beda14d3b7350e$var$$a093c7e1ec25a057$var$CONTENT_NAME, props.__scopeTooltip);
    const providerContext = $68beda14d3b7350e$var$$a093c7e1ec25a057$var$useTooltipProviderContext($68beda14d3b7350e$var$$a093c7e1ec25a057$var$CONTENT_NAME, props.__scopeTooltip);
    const ref = (0, $acw62.useRef)(null);
    const composedRefs = (0, $htT6J.useComposedRefs)(forwardedRef, ref);
    const [pointerGraceArea, setPointerGraceArea] = (0, $acw62.useState)(null);
    const { trigger: trigger, onClose: onClose } = context;
    const content = ref.current;
    const { onPointerInTransitChange: onPointerInTransitChange } = providerContext;
    const handleRemoveGraceArea = (0, $acw62.useCallback)(()=>{
        setPointerGraceArea(null);
        onPointerInTransitChange(false);
    }, [
        onPointerInTransitChange
    ]);
    const handleCreateGraceArea = (0, $acw62.useCallback)((event, hoverTarget)=>{
        const currentTarget = event.currentTarget;
        const exitPoint = {
            x: event.clientX,
            y: event.clientY
        };
        const exitSide = $68beda14d3b7350e$var$$a093c7e1ec25a057$var$getExitSideFromRect(exitPoint, currentTarget.getBoundingClientRect());
        const paddedExitPoints = $68beda14d3b7350e$var$$a093c7e1ec25a057$var$getPaddedExitPoints(exitPoint, exitSide);
        const hoverTargetPoints = $68beda14d3b7350e$var$$a093c7e1ec25a057$var$getPointsFromRect(hoverTarget.getBoundingClientRect());
        const graceArea = $68beda14d3b7350e$var$$a093c7e1ec25a057$var$getHull([
            ...paddedExitPoints,
            ...hoverTargetPoints
        ]);
        setPointerGraceArea(graceArea);
        onPointerInTransitChange(true);
    }, [
        onPointerInTransitChange
    ]);
    (0, $acw62.useEffect)(()=>{
        return ()=>handleRemoveGraceArea();
    }, [
        handleRemoveGraceArea
    ]);
    (0, $acw62.useEffect)(()=>{
        if (trigger && content) {
            const handleTriggerLeave = (event)=>handleCreateGraceArea(event, content);
            const handleContentLeave = (event)=>handleCreateGraceArea(event, trigger);
            trigger.addEventListener("pointerleave", handleTriggerLeave);
            content.addEventListener("pointerleave", handleContentLeave);
            return ()=>{
                trigger.removeEventListener("pointerleave", handleTriggerLeave);
                content.removeEventListener("pointerleave", handleContentLeave);
            };
        }
    }, [
        trigger,
        content,
        handleCreateGraceArea,
        handleRemoveGraceArea
    ]);
    (0, $acw62.useEffect)(()=>{
        if (pointerGraceArea) {
            const handleTrackPointerGrace = (event)=>{
                const target = event.target;
                const pointerPosition = {
                    x: event.clientX,
                    y: event.clientY
                };
                const hasEnteredTarget = (trigger === null || trigger === void 0 ? void 0 : trigger.contains(target)) || (content === null || content === void 0 ? void 0 : content.contains(target));
                const isPointerOutsideGraceArea = !$68beda14d3b7350e$var$$a093c7e1ec25a057$var$isPointInPolygon(pointerPosition, pointerGraceArea);
                if (hasEnteredTarget) handleRemoveGraceArea();
                else if (isPointerOutsideGraceArea) {
                    handleRemoveGraceArea();
                    onClose();
                }
            };
            document.addEventListener("pointermove", handleTrackPointerGrace);
            return ()=>document.removeEventListener("pointermove", handleTrackPointerGrace);
        }
    }, [
        trigger,
        content,
        pointerGraceArea,
        onClose,
        handleRemoveGraceArea
    ]);
    return /*#__PURE__*/ (0, $acw62.createElement)($68beda14d3b7350e$var$$a093c7e1ec25a057$var$TooltipContentImpl, (0, $8nd05.default)({}, props, {
        ref: composedRefs
    }));
});
const [$68beda14d3b7350e$var$$a093c7e1ec25a057$var$VisuallyHiddenContentContextProvider, $68beda14d3b7350e$var$$a093c7e1ec25a057$var$useVisuallyHiddenContentContext] = $68beda14d3b7350e$var$$a093c7e1ec25a057$var$createTooltipContext($68beda14d3b7350e$var$$a093c7e1ec25a057$var$TOOLTIP_NAME, {
    isInside: false
});
const $68beda14d3b7350e$var$$a093c7e1ec25a057$var$TooltipContentImpl = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopeTooltip: __scopeTooltip, children: children, "aria-label": ariaLabel, onEscapeKeyDown: onEscapeKeyDown, onPointerDownOutside: onPointerDownOutside, ...contentProps } = props;
    const context = $68beda14d3b7350e$var$$a093c7e1ec25a057$var$useTooltipContext($68beda14d3b7350e$var$$a093c7e1ec25a057$var$CONTENT_NAME, __scopeTooltip);
    const popperScope = $68beda14d3b7350e$var$$a093c7e1ec25a057$var$usePopperScope(__scopeTooltip);
    const { onClose: onClose } = context; // Close this tooltip if another one opens
    (0, $acw62.useEffect)(()=>{
        document.addEventListener($68beda14d3b7350e$var$$a093c7e1ec25a057$var$TOOLTIP_OPEN, onClose);
        return ()=>document.removeEventListener($68beda14d3b7350e$var$$a093c7e1ec25a057$var$TOOLTIP_OPEN, onClose);
    }, [
        onClose
    ]); // Close the tooltip if the trigger is scrolled
    (0, $acw62.useEffect)(()=>{
        if (context.trigger) {
            const handleScroll = (event)=>{
                const target = event.target;
                if (target !== null && target !== void 0 && target.contains(context.trigger)) onClose();
            };
            window.addEventListener("scroll", handleScroll, {
                capture: true
            });
            return ()=>window.removeEventListener("scroll", handleScroll, {
                    capture: true
                });
        }
    }, [
        context.trigger,
        onClose
    ]);
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $4yZYB.DismissableLayer), {
        asChild: true,
        disableOutsidePointerEvents: false,
        onEscapeKeyDown: onEscapeKeyDown,
        onPointerDownOutside: onPointerDownOutside,
        onFocusOutside: (event)=>event.preventDefault(),
        onDismiss: onClose
    }, /*#__PURE__*/ (0, $acw62.createElement)((0, $jxYRk.Content), (0, $8nd05.default)({
        "data-state": context.stateAttribute
    }, popperScope, contentProps, {
        ref: forwardedRef,
        style: {
            ...contentProps.style,
            "--radix-tooltip-content-transform-origin": "var(--radix-popper-transform-origin)",
            "--radix-tooltip-content-available-width": "var(--radix-popper-available-width)",
            "--radix-tooltip-content-available-height": "var(--radix-popper-available-height)",
            "--radix-tooltip-trigger-width": "var(--radix-popper-anchor-width)",
            "--radix-tooltip-trigger-height": "var(--radix-popper-anchor-height)"
        }
    }), /*#__PURE__*/ (0, $acw62.createElement)((0, $9UeUh.Slottable), null, children), /*#__PURE__*/ (0, $acw62.createElement)($68beda14d3b7350e$var$$a093c7e1ec25a057$var$VisuallyHiddenContentContextProvider, {
        scope: __scopeTooltip,
        isInside: true
    }, /*#__PURE__*/ (0, $acw62.createElement)((0, $ac9wP.Root), {
        id: context.contentId,
        role: "tooltip"
    }, ariaLabel || children))));
});
/*#__PURE__*/ Object.assign($68beda14d3b7350e$export$e9003e2be37ec060, {
    displayName: $68beda14d3b7350e$var$$a093c7e1ec25a057$var$CONTENT_NAME
});
/* -------------------------------------------------------------------------------------------------
 * TooltipArrow
 * -----------------------------------------------------------------------------------------------*/ const $68beda14d3b7350e$var$$a093c7e1ec25a057$var$ARROW_NAME = "TooltipArrow";
const $68beda14d3b7350e$export$c27ee0ad710f7559 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopeTooltip: __scopeTooltip, ...arrowProps } = props;
    const popperScope = $68beda14d3b7350e$var$$a093c7e1ec25a057$var$usePopperScope(__scopeTooltip);
    const visuallyHiddenContentContext = $68beda14d3b7350e$var$$a093c7e1ec25a057$var$useVisuallyHiddenContentContext($68beda14d3b7350e$var$$a093c7e1ec25a057$var$ARROW_NAME, __scopeTooltip); // if the arrow is inside the `VisuallyHidden`, we don't want to render it all to
    // prevent issues in positioning the arrow due to the duplicate
    return visuallyHiddenContentContext.isInside ? null : /*#__PURE__*/ (0, $acw62.createElement)((0, $jxYRk.Arrow), (0, $8nd05.default)({}, popperScope, arrowProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($68beda14d3b7350e$export$c27ee0ad710f7559, {
    displayName: $68beda14d3b7350e$var$$a093c7e1ec25a057$var$ARROW_NAME
});
/* -----------------------------------------------------------------------------------------------*/ function $68beda14d3b7350e$var$$a093c7e1ec25a057$var$getExitSideFromRect(point, rect) {
    const top = Math.abs(rect.top - point.y);
    const bottom = Math.abs(rect.bottom - point.y);
    const right = Math.abs(rect.right - point.x);
    const left = Math.abs(rect.left - point.x);
    switch(Math.min(top, bottom, right, left)){
        case left:
            return "left";
        case right:
            return "right";
        case top:
            return "top";
        case bottom:
            return "bottom";
        default:
            throw new Error("unreachable");
    }
}
function $68beda14d3b7350e$var$$a093c7e1ec25a057$var$getPaddedExitPoints(exitPoint, exitSide, padding = 5) {
    const paddedExitPoints = [];
    switch(exitSide){
        case "top":
            paddedExitPoints.push({
                x: exitPoint.x - padding,
                y: exitPoint.y + padding
            }, {
                x: exitPoint.x + padding,
                y: exitPoint.y + padding
            });
            break;
        case "bottom":
            paddedExitPoints.push({
                x: exitPoint.x - padding,
                y: exitPoint.y - padding
            }, {
                x: exitPoint.x + padding,
                y: exitPoint.y - padding
            });
            break;
        case "left":
            paddedExitPoints.push({
                x: exitPoint.x + padding,
                y: exitPoint.y - padding
            }, {
                x: exitPoint.x + padding,
                y: exitPoint.y + padding
            });
            break;
        case "right":
            paddedExitPoints.push({
                x: exitPoint.x - padding,
                y: exitPoint.y - padding
            }, {
                x: exitPoint.x - padding,
                y: exitPoint.y + padding
            });
            break;
    }
    return paddedExitPoints;
}
function $68beda14d3b7350e$var$$a093c7e1ec25a057$var$getPointsFromRect(rect) {
    const { top: top, right: right, bottom: bottom, left: left } = rect;
    return [
        {
            x: left,
            y: top
        },
        {
            x: right,
            y: top
        },
        {
            x: right,
            y: bottom
        },
        {
            x: left,
            y: bottom
        }
    ];
} // Determine if a point is inside of a polygon.
// Based on https://github.com/substack/point-in-polygon
function $68beda14d3b7350e$var$$a093c7e1ec25a057$var$isPointInPolygon(point, polygon) {
    const { x: x, y: y } = point;
    let inside = false;
    for(let i = 0, j = polygon.length - 1; i < polygon.length; j = i++){
        const xi = polygon[i].x;
        const yi = polygon[i].y;
        const xj = polygon[j].x;
        const yj = polygon[j].y; // prettier-ignore
        const intersect = yi > y !== yj > y && x < (xj - xi) * (y - yi) / (yj - yi) + xi;
        if (intersect) inside = !inside;
    }
    return inside;
} // Returns a new array of points representing the convex hull of the given set of points.
// https://www.nayuki.io/page/convex-hull-algorithm
function $68beda14d3b7350e$var$$a093c7e1ec25a057$var$getHull(points) {
    const newPoints = points.slice();
    newPoints.sort((a, b)=>{
        if (a.x < b.x) return -1;
        else if (a.x > b.x) return 1;
        else if (a.y < b.y) return -1;
        else if (a.y > b.y) return 1;
        else return 0;
    });
    return $68beda14d3b7350e$var$$a093c7e1ec25a057$var$getHullPresorted(newPoints);
} // Returns the convex hull, assuming that each points[i] <= points[i + 1]. Runs in O(n) time.
function $68beda14d3b7350e$var$$a093c7e1ec25a057$var$getHullPresorted(points) {
    if (points.length <= 1) return points.slice();
    const upperHull = [];
    for(let i = 0; i < points.length; i++){
        const p = points[i];
        while(upperHull.length >= 2){
            const q = upperHull[upperHull.length - 1];
            const r = upperHull[upperHull.length - 2];
            if ((q.x - r.x) * (p.y - r.y) >= (q.y - r.y) * (p.x - r.x)) upperHull.pop();
            else break;
        }
        upperHull.push(p);
    }
    upperHull.pop();
    const lowerHull = [];
    for(let i1 = points.length - 1; i1 >= 0; i1--){
        const p = points[i1];
        while(lowerHull.length >= 2){
            const q = lowerHull[lowerHull.length - 1];
            const r = lowerHull[lowerHull.length - 2];
            if ((q.x - r.x) * (p.y - r.y) >= (q.y - r.y) * (p.x - r.x)) lowerHull.pop();
            else break;
        }
        lowerHull.push(p);
    }
    lowerHull.pop();
    if (upperHull.length === 1 && lowerHull.length === 1 && upperHull[0].x === lowerHull[0].x && upperHull[0].y === lowerHull[0].y) return upperHull;
    else return upperHull.concat(lowerHull);
}
const $68beda14d3b7350e$export$2881499e37b75b9a = $68beda14d3b7350e$export$f78649fb9ca566b8;
const $68beda14d3b7350e$export$be92b6f5f03c0fe9 = $68beda14d3b7350e$export$28c660c63b792dea;
const $68beda14d3b7350e$export$41fb9f06171c75f4 = $68beda14d3b7350e$export$8c610744efcf8a1d;
const $68beda14d3b7350e$export$602eac185826482c = $68beda14d3b7350e$export$7b36b8f925ab7497;
const $68beda14d3b7350e$export$7c6e2c02157bb7d2 = $68beda14d3b7350e$export$e9003e2be37ec060;
const $68beda14d3b7350e$export$21b07c8f274aebd5 = $68beda14d3b7350e$export$c27ee0ad710f7559;

});

parcelRegister("kausY", function(module, exports) {

$parcel$export(module.exports, "Combobox", () => $eaec5fceb04f7d33$export$27957ad87354dd7e);

var $8EDjv = parcelRequire("8EDjv");

var $acw62 = parcelRequire("acw62");

var $ivoM3 = parcelRequire("ivoM3");

var $h26ct = parcelRequire("h26ct");

var $5Ai9V = parcelRequire("5Ai9V");

var $114Mg = parcelRequire("114Mg");

var $kPvke = parcelRequire("kPvke");

var $8KgIp = parcelRequire("8KgIp");

var $ltgxC = parcelRequire("ltgxC");

var $23pTr = parcelRequire("23pTr");

var $5IEAk = parcelRequire("5IEAk");

var $gm4XX = parcelRequire("gm4XX");

var $6mpbl = parcelRequire("6mpbl");

var $ipity = parcelRequire("ipity");

var $1nOiu = parcelRequire("1nOiu");

var $lEQT2 = parcelRequire("lEQT2");

var $k9Al5 = parcelRequire("k9Al5");

var $auuNT = parcelRequire("auuNT");

var $2C9FE = parcelRequire("2C9FE");

var $5fYEB = parcelRequire("5fYEB");

var $fLrGx = parcelRequire("fLrGx");

var $1COYr = parcelRequire("1COYr");

var $hsQxB = parcelRequire("hsQxB");

var $7FnlJ = parcelRequire("7FnlJ");

var $6Ngq1 = parcelRequire("6Ngq1");

var $8UjaS = parcelRequire("8UjaS");

var $ebRQH = parcelRequire("ebRQH");

var $6AKlm = parcelRequire("6AKlm");

var $hPtJY = parcelRequire("hPtJY");
var $eaec5fceb04f7d33$var$$e = ((o)=>(o[o.Open = 0] = "Open", o[o.Closed = 1] = "Closed", o))($eaec5fceb04f7d33$var$$e || {}), $eaec5fceb04f7d33$var$qe = ((o)=>(o[o.Single = 0] = "Single", o[o.Multi = 1] = "Multi", o))($eaec5fceb04f7d33$var$qe || {}), $eaec5fceb04f7d33$var$ze = ((a)=>(a[a.Pointer = 0] = "Pointer", a[a.Focus = 1] = "Focus", a[a.Other = 2] = "Other", a))($eaec5fceb04f7d33$var$ze || {}), $eaec5fceb04f7d33$var$Ye = ((e)=>(e[e.OpenCombobox = 0] = "OpenCombobox", e[e.CloseCombobox = 1] = "CloseCombobox", e[e.GoToOption = 2] = "GoToOption", e[e.RegisterOption = 3] = "RegisterOption", e[e.UnregisterOption = 4] = "UnregisterOption", e[e.RegisterLabel = 5] = "RegisterLabel", e[e.SetActivationTrigger = 6] = "SetActivationTrigger", e[e.UpdateVirtualOptions = 7] = "UpdateVirtualOptions", e))($eaec5fceb04f7d33$var$Ye || {});
function $eaec5fceb04f7d33$var$de(t, r = (o)=>o) {
    let o = t.activeOptionIndex !== null ? t.options[t.activeOptionIndex] : null, a = r(t.options.slice()), i = a.length > 0 && a[0].dataRef.current.order !== null ? a.sort((p, c)=>p.dataRef.current.order - c.dataRef.current.order) : (0, $hsQxB.sortByDomNode)(a, (p)=>p.dataRef.current.domRef.current), u = o ? i.indexOf(o) : null;
    return u === -1 && (u = null), {
        options: i,
        activeOptionIndex: u
    };
}
let $eaec5fceb04f7d33$var$Qe = {
    [1] (t) {
        var r;
        return (r = t.dataRef.current) != null && r.disabled || t.comboboxState === 1 ? t : {
            ...t,
            activeOptionIndex: null,
            comboboxState: 1
        };
    },
    [0] (t) {
        var r, o;
        if ((r = t.dataRef.current) != null && r.disabled || t.comboboxState === 0) return t;
        if ((o = t.dataRef.current) != null && o.value) {
            let a = t.dataRef.current.calculateIndex(t.dataRef.current.value);
            if (a !== -1) return {
                ...t,
                activeOptionIndex: a,
                comboboxState: 0
            };
        }
        return {
            ...t,
            comboboxState: 0
        };
    },
    [2] (t, r) {
        var u, p, c, e, l;
        if ((u = t.dataRef.current) != null && u.disabled || (p = t.dataRef.current) != null && p.optionsRef.current && !((c = t.dataRef.current) != null && c.optionsPropsRef.current.static) && t.comboboxState === 1) return t;
        if (t.virtual) {
            let T = r.focus === (0, $fLrGx.Focus).Specific ? r.idx : (0, $fLrGx.calculateActiveIndex)(r, {
                resolveItems: ()=>t.virtual.options,
                resolveActiveIndex: ()=>{
                    var f, v;
                    return (v = (f = t.activeOptionIndex) != null ? f : t.virtual.options.findIndex((S)=>!t.virtual.disabled(S))) != null ? v : null;
                },
                resolveDisabled: t.virtual.disabled,
                resolveId () {
                    throw new Error("Function not implemented.");
                }
            }), g = (e = r.trigger) != null ? e : 2;
            return t.activeOptionIndex === T && t.activationTrigger === g ? t : {
                ...t,
                activeOptionIndex: T,
                activationTrigger: g
            };
        }
        let o = $eaec5fceb04f7d33$var$de(t);
        if (o.activeOptionIndex === null) {
            let T = o.options.findIndex((g)=>!g.dataRef.current.disabled);
            T !== -1 && (o.activeOptionIndex = T);
        }
        let a = r.focus === (0, $fLrGx.Focus).Specific ? r.idx : (0, $fLrGx.calculateActiveIndex)(r, {
            resolveItems: ()=>o.options,
            resolveActiveIndex: ()=>o.activeOptionIndex,
            resolveId: (T)=>T.id,
            resolveDisabled: (T)=>T.dataRef.current.disabled
        }), i = (l = r.trigger) != null ? l : 2;
        return t.activeOptionIndex === a && t.activationTrigger === i ? t : {
            ...t,
            ...o,
            activeOptionIndex: a,
            activationTrigger: i
        };
    },
    [3]: (t, r)=>{
        var u, p, c;
        if ((u = t.dataRef.current) != null && u.virtual) return {
            ...t,
            options: [
                ...t.options,
                r.payload
            ]
        };
        let o = r.payload, a = $eaec5fceb04f7d33$var$de(t, (e)=>(e.push(o), e));
        t.activeOptionIndex === null && (p = t.dataRef.current) != null && p.isSelected(r.payload.dataRef.current.value) && (a.activeOptionIndex = a.options.indexOf(o));
        let i = {
            ...t,
            ...a,
            activationTrigger: 2
        };
        return (c = t.dataRef.current) != null && c.__demoMode && t.dataRef.current.value === void 0 && (i.activeOptionIndex = 0), i;
    },
    [4]: (t, r)=>{
        var a;
        if ((a = t.dataRef.current) != null && a.virtual) return {
            ...t,
            options: t.options.filter((i)=>i.id !== r.id)
        };
        let o = $eaec5fceb04f7d33$var$de(t, (i)=>{
            let u = i.findIndex((p)=>p.id === r.id);
            return u !== -1 && i.splice(u, 1), i;
        });
        return {
            ...t,
            ...o,
            activationTrigger: 2
        };
    },
    [5]: (t, r)=>t.labelId === r.id ? t : {
            ...t,
            labelId: r.id
        },
    [6]: (t, r)=>t.activationTrigger === r.trigger ? t : {
            ...t,
            activationTrigger: r.trigger
        },
    [7]: (t, r)=>{
        var a;
        if (((a = t.virtual) == null ? void 0 : a.options) === r.options) return t;
        let o = t.activeOptionIndex;
        if (t.activeOptionIndex !== null) {
            let i = r.options.indexOf(t.virtual.options[t.activeOptionIndex]);
            i !== -1 ? o = i : o = null;
        }
        return {
            ...t,
            activeOptionIndex: o,
            virtual: Object.assign({}, t.virtual, {
                options: r.options
            })
        };
    }
}, $eaec5fceb04f7d33$var$be = (0, $acw62.createContext)(null);
$eaec5fceb04f7d33$var$be.displayName = "ComboboxActionsContext";
function $eaec5fceb04f7d33$var$ee(t) {
    let r = (0, $acw62.useContext)($eaec5fceb04f7d33$var$be);
    if (r === null) {
        let o = new Error(`<${t} /> is missing a parent <Combobox /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(o, $eaec5fceb04f7d33$var$ee), o;
    }
    return r;
}
let $eaec5fceb04f7d33$var$Ce = (0, $acw62.createContext)(null);
function $eaec5fceb04f7d33$var$Ze(t) {
    var c;
    let r = $eaec5fceb04f7d33$var$j("VirtualProvider"), [o, a] = (0, $acw62.useMemo)(()=>{
        let e = r.optionsRef.current;
        if (!e) return [
            0,
            0
        ];
        let l = window.getComputedStyle(e);
        return [
            parseFloat(l.paddingBlockStart || l.paddingTop),
            parseFloat(l.paddingBlockEnd || l.paddingBottom)
        ];
    }, [
        r.optionsRef.current
    ]), i = (0, $8EDjv.useVirtualizer)({
        scrollPaddingStart: o,
        scrollPaddingEnd: a,
        count: r.virtual.options.length,
        estimateSize () {
            return 40;
        },
        getScrollElement () {
            var e;
            return (e = r.optionsRef.current) != null ? e : null;
        },
        overscan: 12
    }), [u, p] = (0, $acw62.useState)(0);
    return (0, $8KgIp.useIsoMorphicEffect)(()=>{
        p((e)=>e + 1);
    }, [
        (c = r.virtual) == null ? void 0 : c.options
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($eaec5fceb04f7d33$var$Ce.Provider, {
        value: i
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            position: "relative",
            width: "100%",
            height: `${i.getTotalSize()}px`
        },
        ref: (e)=>{
            if (e) {
                if (typeof $hPtJY, r.activationTrigger === 0) return;
                r.activeOptionIndex !== null && r.virtual.options.length > r.activeOptionIndex && i.scrollToIndex(r.activeOptionIndex);
            }
        }
    }, i.getVirtualItems().map((e)=>{
        var l;
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $acw62.Fragment), {
            key: e.key
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement((l = t.children) == null ? void 0 : l.call(t, {
            option: r.virtual.options[e.index],
            open: r.comboboxState === 0
        }), {
            key: `${u}-${e.key}`,
            "data-index": e.index,
            "aria-setsize": r.virtual.options.length,
            "aria-posinset": e.index + 1,
            style: {
                position: "absolute",
                top: 0,
                left: 0,
                transform: `translateY(${e.start}px)`,
                overflowAnchor: "none"
            }
        }));
    })));
}
let $eaec5fceb04f7d33$var$ce = (0, $acw62.createContext)(null);
$eaec5fceb04f7d33$var$ce.displayName = "ComboboxDataContext";
function $eaec5fceb04f7d33$var$j(t) {
    let r = (0, $acw62.useContext)($eaec5fceb04f7d33$var$ce);
    if (r === null) {
        let o = new Error(`<${t} /> is missing a parent <Combobox /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(o, $eaec5fceb04f7d33$var$j), o;
    }
    return r;
}
function $eaec5fceb04f7d33$var$et(t, r) {
    return (0, $6Ngq1.match)(r.type, $eaec5fceb04f7d33$var$Qe, t, r);
}
let $eaec5fceb04f7d33$var$tt = (0, $acw62.Fragment);
function $eaec5fceb04f7d33$var$ot(t, r) {
    var fe;
    let { value: o, defaultValue: a, onChange: i, form: u, name: p, by: c = null, disabled: e = !1, __demoMode: l = !1, nullable: T = !1, multiple: g = !1, immediate: f = !1, virtual: v = null, ...S } = t, R = !1, s = null, [I = g ? [] : void 0, V] = (0, $h26ct.useControllable)(o, i, a), [_, E] = (0, $acw62.useReducer)($eaec5fceb04f7d33$var$et, {
        dataRef: (0, $acw62.createRef)(),
        comboboxState: l ? 0 : 1,
        options: [],
        virtual: s ? {
            options: s.options,
            disabled: (fe = s.disabled) != null ? fe : ()=>!1
        } : null,
        activeOptionIndex: null,
        activationTrigger: 2,
        labelId: null
    }), k = (0, $acw62.useRef)(!1), J = (0, $acw62.useRef)({
        static: !1,
        hold: !1
    }), K = (0, $acw62.useRef)(null), z = (0, $acw62.useRef)(null), te = (0, $acw62.useRef)(null), X = (0, $acw62.useRef)(null), x = (0, $114Mg.useEvent)(typeof c == "string" ? (d, b)=>{
        let P = c;
        return (d == null ? void 0 : d[P]) === (b == null ? void 0 : b[P]);
    } : c != null ? c : (d, b)=>d === b), O = (0, $114Mg.useEvent)((d)=>s ? c === null ? s.options.indexOf(d) : s.options.findIndex((b)=>x(b, d)) : _.options.findIndex((b)=>x(b.dataRef.current.value, d))), L = (0, $acw62.useCallback)((d)=>(0, $6Ngq1.match)(n.mode, {
            [1]: ()=>I.some((b)=>x(b, d)),
            [0]: ()=>x(I, d)
        }), [
        I
    ]), oe = (0, $114Mg.useEvent)((d)=>_.activeOptionIndex === O(d)), n = (0, $acw62.useMemo)(()=>({
            ..._,
            immediate: R,
            optionsPropsRef: J,
            labelRef: K,
            inputRef: z,
            buttonRef: te,
            optionsRef: X,
            value: I,
            defaultValue: a,
            disabled: e,
            mode: g ? 1 : 0,
            virtual: _.virtual,
            get activeOptionIndex () {
                if (k.current && _.activeOptionIndex === null && (s ? s.options.length > 0 : _.options.length > 0)) {
                    if (s) {
                        let b = s.options.findIndex((P)=>{
                            var G, Y;
                            return !((Y = (G = s == null ? void 0 : s.disabled) == null ? void 0 : G.call(s, P)) != null && Y);
                        });
                        if (b !== -1) return b;
                    }
                    let d = _.options.findIndex((b)=>!b.dataRef.current.disabled);
                    if (d !== -1) return d;
                }
                return _.activeOptionIndex;
            },
            calculateIndex: O,
            compare: x,
            isSelected: L,
            isActive: oe,
            nullable: T,
            __demoMode: l
        }), [
        I,
        a,
        e,
        g,
        T,
        l,
        _,
        s
    ]);
    (0, $8KgIp.useIsoMorphicEffect)(()=>{
        s && E({
            type: 7,
            options: s.options
        });
    }, [
        s,
        s == null ? void 0 : s.options
    ]), (0, $8KgIp.useIsoMorphicEffect)(()=>{
        _.dataRef.current = n;
    }, [
        n
    ]), (0, $23pTr.useOutsideClick)([
        n.buttonRef,
        n.inputRef,
        n.optionsRef
    ], ()=>le.closeCombobox(), n.comboboxState === 0);
    let F = (0, $acw62.useMemo)(()=>{
        var d, b, P;
        return {
            open: n.comboboxState === 0,
            disabled: e,
            activeIndex: n.activeOptionIndex,
            activeOption: n.activeOptionIndex === null ? null : n.virtual ? n.virtual.options[(d = n.activeOptionIndex) != null ? d : 0] : (P = (b = n.options[n.activeOptionIndex]) == null ? void 0 : b.dataRef.current.value) != null ? P : null,
            value: I
        };
    }, [
        n,
        e,
        I
    ]), A = (0, $114Mg.useEvent)(()=>{
        if (n.activeOptionIndex !== null) {
            if (n.virtual) ae(n.virtual.options[n.activeOptionIndex]);
            else {
                let { dataRef: d } = n.options[n.activeOptionIndex];
                ae(d.current.value);
            }
            le.goToOption((0, $fLrGx.Focus).Specific, n.activeOptionIndex);
        }
    }), h = (0, $114Mg.useEvent)(()=>{
        E({
            type: 0
        }), k.current = !0;
    }), C = (0, $114Mg.useEvent)(()=>{
        E({
            type: 1
        }), k.current = !1;
    }), D = (0, $114Mg.useEvent)((d, b, P)=>(k.current = !1, d === (0, $fLrGx.Focus).Specific ? E({
            type: 2,
            focus: (0, $fLrGx.Focus).Specific,
            idx: b,
            trigger: P
        }) : E({
            type: 2,
            focus: d,
            trigger: P
        }))), N = (0, $114Mg.useEvent)((d, b)=>(E({
            type: 3,
            payload: {
                id: d,
                dataRef: b
            }
        }), ()=>{
            n.isActive(b.current.value) && (k.current = !0), E({
                type: 4,
                id: d
            });
        })), ye = (0, $114Mg.useEvent)((d)=>(E({
            type: 5,
            id: d
        }), ()=>E({
                type: 5,
                id: null
            }))), ae = (0, $114Mg.useEvent)((d)=>(0, $6Ngq1.match)(n.mode, {
            [0] () {
                return V == null ? void 0 : V(d);
            },
            [1] () {
                let b = n.value.slice(), P = b.findIndex((G)=>x(G, d));
                return P === -1 ? b.push(d) : b.splice(P, 1), V == null ? void 0 : V(b);
            }
        })), Re = (0, $114Mg.useEvent)((d)=>{
        E({
            type: 6,
            trigger: d
        });
    }), le = (0, $acw62.useMemo)(()=>({
            onChange: ae,
            registerOption: N,
            registerLabel: ye,
            goToOption: D,
            closeCombobox: C,
            openCombobox: h,
            setActivationTrigger: Re,
            selectActiveOption: A
        }), []), Ae = r === null ? {} : {
        ref: r
    }, ne = (0, $acw62.useRef)(null), Se = (0, $5Ai9V.useDisposables)();
    return (0, $acw62.useEffect)(()=>{
        ne.current && a !== void 0 && Se.addEventListener(ne.current, "reset", ()=>{
            V == null || V(a);
        });
    }, [
        ne,
        V
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($eaec5fceb04f7d33$var$be.Provider, {
        value: le
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($eaec5fceb04f7d33$var$ce.Provider, {
        value: n
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $auuNT.OpenClosedProvider), {
        value: (0, $6Ngq1.match)(n.comboboxState, {
            [0]: (0, $auuNT.State).Open,
            [1]: (0, $auuNT.State).Closed
        })
    }, p != null && I != null && (0, $7FnlJ.objectToFormEntries)({
        [p]: I
    }).map(([d, b], P)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $k9Al5.Hidden), {
            features: (0, $k9Al5.Features).Hidden,
            ref: P === 0 ? (G)=>{
                var Y;
                ne.current = (Y = G == null ? void 0 : G.closest("form")) != null ? Y : null;
            } : void 0,
            ...(0, $ebRQH.compact)({
                key: d,
                as: "input",
                type: "hidden",
                hidden: !0,
                readOnly: !0,
                form: u,
                name: d,
                value: b
            })
        })), (0, $ebRQH.render)({
        ourProps: Ae,
        theirProps: S,
        slot: F,
        defaultTag: $eaec5fceb04f7d33$var$tt,
        name: "Combobox"
    }))));
}
let $eaec5fceb04f7d33$var$nt = "input";
function $eaec5fceb04f7d33$var$rt(t, r) {
    var X, x, O, L, oe;
    let o = (0, $kPvke.useId)(), { id: a = `headlessui-combobox-input-${o}`, onChange: i, displayValue: u, type: p = "text", ...c } = t, e = $eaec5fceb04f7d33$var$j("Combobox.Input"), l = $eaec5fceb04f7d33$var$ee("Combobox.Input"), T = (0, $6mpbl.useSyncRefs)(e.inputRef, r), g = (0, $5IEAk.useOwnerDocument)(e.inputRef), f = (0, $acw62.useRef)(!1), v = (0, $5Ai9V.useDisposables)(), S = (0, $114Mg.useEvent)(()=>{
        l.onChange(null), e.optionsRef.current && (e.optionsRef.current.scrollTop = 0), l.goToOption((0, $fLrGx.Focus).Nothing);
    }), R = function() {
        var n;
        return typeof u == "function" && e.value !== void 0 ? (n = u(e.value)) != null ? n : "" : typeof e.value == "string" ? e.value : "";
    }();
    (0, $lEQT2.useWatch)(([n, F], [A, h])=>{
        if (f.current) return;
        let C = e.inputRef.current;
        C && ((h === 0 && F === 1 || n !== A) && (C.value = n), requestAnimationFrame(()=>{
            if (f.current || !C || (g == null ? void 0 : g.activeElement) !== C) return;
            let { selectionStart: D, selectionEnd: N } = C;
            Math.abs((N != null ? N : 0) - (D != null ? D : 0)) === 0 && D === 0 && C.setSelectionRange(C.value.length, C.value.length);
        }));
    }, [
        R,
        e.comboboxState,
        g
    ]), (0, $lEQT2.useWatch)(([n], [F])=>{
        if (n === 0 && F === 1) {
            if (f.current) return;
            let A = e.inputRef.current;
            if (!A) return;
            let h = A.value, { selectionStart: C, selectionEnd: D, selectionDirection: N } = A;
            A.value = "", A.value = h, N !== null ? A.setSelectionRange(C, D, N) : A.setSelectionRange(C, D);
        }
    }, [
        e.comboboxState
    ]);
    let s = (0, $acw62.useRef)(!1), I = (0, $114Mg.useEvent)(()=>{
        s.current = !0;
    }), V = (0, $114Mg.useEvent)(()=>{
        v.nextFrame(()=>{
            s.current = !1;
        });
    }), _ = (0, $114Mg.useEvent)((n)=>{
        switch(f.current = !0, n.key){
            case (0, $6AKlm.Keys).Enter:
                if (f.current = !1, e.comboboxState !== 0 || s.current) return;
                if (n.preventDefault(), n.stopPropagation(), e.activeOptionIndex === null) {
                    l.closeCombobox();
                    return;
                }
                l.selectActiveOption(), e.mode === 0 && l.closeCombobox();
                break;
            case (0, $6AKlm.Keys).ArrowDown:
                return f.current = !1, n.preventDefault(), n.stopPropagation(), (0, $6Ngq1.match)(e.comboboxState, {
                    [0]: ()=>l.goToOption((0, $fLrGx.Focus).Next),
                    [1]: ()=>l.openCombobox()
                });
            case (0, $6AKlm.Keys).ArrowUp:
                return f.current = !1, n.preventDefault(), n.stopPropagation(), (0, $6Ngq1.match)(e.comboboxState, {
                    [0]: ()=>l.goToOption((0, $fLrGx.Focus).Previous),
                    [1]: ()=>{
                        l.openCombobox(), v.nextFrame(()=>{
                            e.value || l.goToOption((0, $fLrGx.Focus).Last);
                        });
                    }
                });
            case (0, $6AKlm.Keys).Home:
                if (n.shiftKey) break;
                return f.current = !1, n.preventDefault(), n.stopPropagation(), l.goToOption((0, $fLrGx.Focus).First);
            case (0, $6AKlm.Keys).PageUp:
                return f.current = !1, n.preventDefault(), n.stopPropagation(), l.goToOption((0, $fLrGx.Focus).First);
            case (0, $6AKlm.Keys).End:
                if (n.shiftKey) break;
                return f.current = !1, n.preventDefault(), n.stopPropagation(), l.goToOption((0, $fLrGx.Focus).Last);
            case (0, $6AKlm.Keys).PageDown:
                return f.current = !1, n.preventDefault(), n.stopPropagation(), l.goToOption((0, $fLrGx.Focus).Last);
            case (0, $6AKlm.Keys).Escape:
                return f.current = !1, e.comboboxState !== 0 ? void 0 : (n.preventDefault(), e.optionsRef.current && !e.optionsPropsRef.current.static && n.stopPropagation(), e.nullable && e.mode === 0 && e.value === null && S(), l.closeCombobox());
            case (0, $6AKlm.Keys).Tab:
                if (f.current = !1, e.comboboxState !== 0) return;
                e.mode === 0 && e.activationTrigger !== 1 && l.selectActiveOption(), l.closeCombobox();
                break;
        }
    }), E = (0, $114Mg.useEvent)((n)=>{
        i == null || i(n), e.nullable && e.mode === 0 && n.target.value === "" && S(), l.openCombobox();
    }), k = (0, $114Mg.useEvent)((n)=>{
        var A, h, C;
        let F = (A = n.relatedTarget) != null ? A : (0, $2C9FE.history).find((D)=>D !== n.currentTarget);
        if (f.current = !1, !((h = e.optionsRef.current) != null && h.contains(F)) && !((C = e.buttonRef.current) != null && C.contains(F)) && e.comboboxState === 0) return n.preventDefault(), e.mode === 0 && (e.nullable && e.value === null ? S() : e.activationTrigger !== 1 && l.selectActiveOption()), l.closeCombobox();
    }), J = (0, $114Mg.useEvent)((n)=>{
        var A, h, C;
        let F = (A = n.relatedTarget) != null ? A : (0, $2C9FE.history).find((D)=>D !== n.currentTarget);
        (h = e.buttonRef.current) != null && h.contains(F) || (C = e.optionsRef.current) != null && C.contains(F) || e.disabled || e.immediate && e.comboboxState !== 0 && (l.openCombobox(), v.nextFrame(()=>{
            l.setActivationTrigger(1);
        }));
    }), K = (0, $ivoM3.useComputed)(()=>{
        if (e.labelId) return [
            e.labelId
        ].join(" ");
    }, [
        e.labelId
    ]), z = (0, $acw62.useMemo)(()=>({
            open: e.comboboxState === 0,
            disabled: e.disabled
        }), [
        e
    ]), te = {
        ref: T,
        id: a,
        role: "combobox",
        type: p,
        "aria-controls": (X = e.optionsRef.current) == null ? void 0 : X.id,
        "aria-expanded": e.comboboxState === 0,
        "aria-activedescendant": e.activeOptionIndex === null ? void 0 : e.virtual ? (x = e.options.find((n)=>{
            var F;
            return !((F = e.virtual) != null && F.disabled(n.dataRef.current.value)) && e.compare(n.dataRef.current.value, e.virtual.options[e.activeOptionIndex]);
        })) == null ? void 0 : x.id : (O = e.options[e.activeOptionIndex]) == null ? void 0 : O.id,
        "aria-labelledby": K,
        "aria-autocomplete": "list",
        defaultValue: (oe = (L = t.defaultValue) != null ? L : e.defaultValue !== void 0 ? u == null ? void 0 : u(e.defaultValue) : null) != null ? oe : e.defaultValue,
        disabled: e.disabled,
        onCompositionStart: I,
        onCompositionEnd: V,
        onKeyDown: _,
        onChange: E,
        onFocus: J,
        onBlur: k
    };
    return (0, $ebRQH.render)({
        ourProps: te,
        theirProps: c,
        slot: z,
        defaultTag: $eaec5fceb04f7d33$var$nt,
        name: "Combobox.Input"
    });
}
let $eaec5fceb04f7d33$var$at = "button";
function $eaec5fceb04f7d33$var$lt(t, r) {
    var S;
    let o = $eaec5fceb04f7d33$var$j("Combobox.Button"), a = $eaec5fceb04f7d33$var$ee("Combobox.Button"), i = (0, $6mpbl.useSyncRefs)(o.buttonRef, r), u = (0, $kPvke.useId)(), { id: p = `headlessui-combobox-button-${u}`, ...c } = t, e = (0, $5Ai9V.useDisposables)(), l = (0, $114Mg.useEvent)((R)=>{
        switch(R.key){
            case (0, $6AKlm.Keys).ArrowDown:
                return R.preventDefault(), R.stopPropagation(), o.comboboxState === 1 && a.openCombobox(), e.nextFrame(()=>{
                    var s;
                    return (s = o.inputRef.current) == null ? void 0 : s.focus({
                        preventScroll: !0
                    });
                });
            case (0, $6AKlm.Keys).ArrowUp:
                return R.preventDefault(), R.stopPropagation(), o.comboboxState === 1 && (a.openCombobox(), e.nextFrame(()=>{
                    o.value || a.goToOption((0, $fLrGx.Focus).Last);
                })), e.nextFrame(()=>{
                    var s;
                    return (s = o.inputRef.current) == null ? void 0 : s.focus({
                        preventScroll: !0
                    });
                });
            case (0, $6AKlm.Keys).Escape:
                return o.comboboxState !== 0 ? void 0 : (R.preventDefault(), o.optionsRef.current && !o.optionsPropsRef.current.static && R.stopPropagation(), a.closeCombobox(), e.nextFrame(()=>{
                    var s;
                    return (s = o.inputRef.current) == null ? void 0 : s.focus({
                        preventScroll: !0
                    });
                }));
            default:
                return;
        }
    }), T = (0, $114Mg.useEvent)((R)=>{
        if ((0, $5fYEB.isDisabledReactIssue7711)(R.currentTarget)) return R.preventDefault();
        o.comboboxState === 0 ? a.closeCombobox() : (R.preventDefault(), a.openCombobox()), e.nextFrame(()=>{
            var s;
            return (s = o.inputRef.current) == null ? void 0 : s.focus({
                preventScroll: !0
            });
        });
    }), g = (0, $ivoM3.useComputed)(()=>{
        if (o.labelId) return [
            o.labelId,
            p
        ].join(" ");
    }, [
        o.labelId,
        p
    ]), f = (0, $acw62.useMemo)(()=>({
            open: o.comboboxState === 0,
            disabled: o.disabled,
            value: o.value
        }), [
        o
    ]), v = {
        ref: i,
        id: p,
        type: (0, $gm4XX.useResolveButtonType)(t, o.buttonRef),
        tabIndex: -1,
        "aria-haspopup": "listbox",
        "aria-controls": (S = o.optionsRef.current) == null ? void 0 : S.id,
        "aria-expanded": o.comboboxState === 0,
        "aria-labelledby": g,
        disabled: o.disabled,
        onClick: T,
        onKeyDown: l
    };
    return (0, $ebRQH.render)({
        ourProps: v,
        theirProps: c,
        slot: f,
        defaultTag: $eaec5fceb04f7d33$var$at,
        name: "Combobox.Button"
    });
}
let $eaec5fceb04f7d33$var$it = "label";
function $eaec5fceb04f7d33$var$ut(t, r) {
    let o = (0, $kPvke.useId)(), { id: a = `headlessui-combobox-label-${o}`, ...i } = t, u = $eaec5fceb04f7d33$var$j("Combobox.Label"), p = $eaec5fceb04f7d33$var$ee("Combobox.Label"), c = (0, $6mpbl.useSyncRefs)(u.labelRef, r);
    (0, $8KgIp.useIsoMorphicEffect)(()=>p.registerLabel(a), [
        a
    ]);
    let e = (0, $114Mg.useEvent)(()=>{
        var g;
        return (g = u.inputRef.current) == null ? void 0 : g.focus({
            preventScroll: !0
        });
    }), l = (0, $acw62.useMemo)(()=>({
            open: u.comboboxState === 0,
            disabled: u.disabled
        }), [
        u
    ]);
    return (0, $ebRQH.render)({
        ourProps: {
            ref: c,
            id: a,
            onClick: e
        },
        theirProps: i,
        slot: l,
        defaultTag: $eaec5fceb04f7d33$var$it,
        name: "Combobox.Label"
    });
}
let $eaec5fceb04f7d33$var$pt = "ul", $eaec5fceb04f7d33$var$st = (0, $ebRQH.Features).RenderStrategy | (0, $ebRQH.Features).Static;
function $eaec5fceb04f7d33$var$dt(t, r) {
    let o = (0, $kPvke.useId)(), { id: a = `headlessui-combobox-options-${o}`, hold: i = !1, ...u } = t, p = $eaec5fceb04f7d33$var$j("Combobox.Options"), c = (0, $6mpbl.useSyncRefs)(p.optionsRef, r), e = (0, $auuNT.useOpenClosed)(), l = (()=>e !== null ? (e & (0, $auuNT.State).Open) === (0, $auuNT.State).Open : p.comboboxState === 0)();
    (0, $8KgIp.useIsoMorphicEffect)(()=>{
        var v;
        p.optionsPropsRef.current.static = (v = t.static) != null ? v : !1;
    }, [
        p.optionsPropsRef,
        t.static
    ]), (0, $8KgIp.useIsoMorphicEffect)(()=>{
        p.optionsPropsRef.current.hold = i;
    }, [
        p.optionsPropsRef,
        i
    ]), (0, $1nOiu.useTreeWalker)({
        container: p.optionsRef.current,
        enabled: p.comboboxState === 0,
        accept (v) {
            return v.getAttribute("role") === "option" ? NodeFilter.FILTER_REJECT : v.hasAttribute("role") ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
        },
        walk (v) {
            v.setAttribute("role", "none");
        }
    });
    let T = (0, $ivoM3.useComputed)(()=>{
        var v, S;
        return (S = p.labelId) != null ? S : (v = p.buttonRef.current) == null ? void 0 : v.id;
    }, [
        p.labelId,
        p.buttonRef.current
    ]), g = (0, $acw62.useMemo)(()=>({
            open: p.comboboxState === 0,
            option: void 0
        }), [
        p
    ]), f = {
        "aria-labelledby": T,
        role: "listbox",
        "aria-multiselectable": p.mode === 1 ? !0 : void 0,
        id: a,
        ref: c
    };
    return p.virtual && p.comboboxState === 0 && Object.assign(u, {
        children: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($eaec5fceb04f7d33$var$Ze, null, u.children)
    }), (0, $ebRQH.render)({
        ourProps: f,
        theirProps: u,
        slot: g,
        defaultTag: $eaec5fceb04f7d33$var$pt,
        features: $eaec5fceb04f7d33$var$st,
        visible: l,
        name: "Combobox.Options"
    });
}
let $eaec5fceb04f7d33$var$bt = "li";
function $eaec5fceb04f7d33$var$ct(t, r) {
    var X;
    let o = (0, $kPvke.useId)(), { id: a = `headlessui-combobox-option-${o}`, disabled: i = !1, value: u, order: p = null, ...c } = t, e = $eaec5fceb04f7d33$var$j("Combobox.Option"), l = $eaec5fceb04f7d33$var$ee("Combobox.Option"), T = e.virtual ? e.activeOptionIndex === e.calculateIndex(u) : e.activeOptionIndex === null ? !1 : ((X = e.options[e.activeOptionIndex]) == null ? void 0 : X.id) === a, g = e.isSelected(u), f = (0, $acw62.useRef)(null), v = (0, $ltgxC.useLatestValue)({
        disabled: i,
        value: u,
        domRef: f,
        order: p
    }), S = (0, $acw62.useContext)($eaec5fceb04f7d33$var$Ce), R = (0, $6mpbl.useSyncRefs)(r, f, S ? S.measureElement : null), s = (0, $114Mg.useEvent)(()=>l.onChange(u));
    (0, $8KgIp.useIsoMorphicEffect)(()=>l.registerOption(a, v), [
        v,
        a
    ]);
    let I = (0, $acw62.useRef)(!(e.virtual || e.__demoMode));
    (0, $8KgIp.useIsoMorphicEffect)(()=>{
        if (!e.virtual || !e.__demoMode) return;
        let x = (0, $1COYr.disposables)();
        return x.requestAnimationFrame(()=>{
            I.current = !0;
        }), x.dispose;
    }, [
        e.virtual,
        e.__demoMode
    ]), (0, $8KgIp.useIsoMorphicEffect)(()=>{
        if (!I.current || e.comboboxState !== 0 || !T || e.activationTrigger === 0) return;
        let x = (0, $1COYr.disposables)();
        return x.requestAnimationFrame(()=>{
            var O, L;
            (L = (O = f.current) == null ? void 0 : O.scrollIntoView) == null || L.call(O, {
                block: "nearest"
            });
        }), x.dispose;
    }, [
        f,
        T,
        e.comboboxState,
        e.activationTrigger,
        e.activeOptionIndex
    ]);
    let V = (0, $114Mg.useEvent)((x)=>{
        var O;
        if (i || (O = e.virtual) != null && O.disabled(u)) return x.preventDefault();
        s(), (0, $8UjaS.isMobile)() || requestAnimationFrame(()=>{
            var L;
            return (L = e.inputRef.current) == null ? void 0 : L.focus({
                preventScroll: !0
            });
        }), e.mode === 0 && requestAnimationFrame(()=>l.closeCombobox());
    }), _ = (0, $114Mg.useEvent)(()=>{
        var O;
        if (i || (O = e.virtual) != null && O.disabled(u)) return l.goToOption((0, $fLrGx.Focus).Nothing);
        let x = e.calculateIndex(u);
        l.goToOption((0, $fLrGx.Focus).Specific, x);
    }), E = (0, $ipity.useTrackedPointer)(), k = (0, $114Mg.useEvent)((x)=>E.update(x)), J = (0, $114Mg.useEvent)((x)=>{
        var L;
        if (!E.wasMoved(x) || i || (L = e.virtual) != null && L.disabled(u) || T) return;
        let O = e.calculateIndex(u);
        l.goToOption((0, $fLrGx.Focus).Specific, O, 0);
    }), K = (0, $114Mg.useEvent)((x)=>{
        var O;
        E.wasMoved(x) && (i || (O = e.virtual) != null && O.disabled(u) || T && (e.optionsPropsRef.current.hold || l.goToOption((0, $fLrGx.Focus).Nothing)));
    }), z = (0, $acw62.useMemo)(()=>({
            active: T,
            selected: g,
            disabled: i
        }), [
        T,
        g,
        i
    ]);
    return (0, $ebRQH.render)({
        ourProps: {
            id: a,
            ref: R,
            role: "option",
            tabIndex: i === !0 ? void 0 : -1,
            "aria-disabled": i === !0 ? !0 : void 0,
            "aria-selected": g,
            disabled: void 0,
            onClick: V,
            onFocus: _,
            onPointerEnter: k,
            onMouseEnter: k,
            onPointerMove: J,
            onMouseMove: J,
            onPointerLeave: K,
            onMouseLeave: K
        },
        theirProps: c,
        slot: z,
        defaultTag: $eaec5fceb04f7d33$var$bt,
        name: "Combobox.Option"
    });
}
let $eaec5fceb04f7d33$var$ft = (0, $ebRQH.forwardRefWithAs)($eaec5fceb04f7d33$var$ot), $eaec5fceb04f7d33$var$mt = (0, $ebRQH.forwardRefWithAs)($eaec5fceb04f7d33$var$lt), $eaec5fceb04f7d33$var$Tt = (0, $ebRQH.forwardRefWithAs)($eaec5fceb04f7d33$var$rt), $eaec5fceb04f7d33$var$xt = (0, $ebRQH.forwardRefWithAs)($eaec5fceb04f7d33$var$ut), $eaec5fceb04f7d33$var$gt = (0, $ebRQH.forwardRefWithAs)($eaec5fceb04f7d33$var$dt), $eaec5fceb04f7d33$var$vt = (0, $ebRQH.forwardRefWithAs)($eaec5fceb04f7d33$var$ct), $eaec5fceb04f7d33$export$27957ad87354dd7e = Object.assign($eaec5fceb04f7d33$var$ft, {
    Input: $eaec5fceb04f7d33$var$Tt,
    Button: $eaec5fceb04f7d33$var$mt,
    Label: $eaec5fceb04f7d33$var$xt,
    Options: $eaec5fceb04f7d33$var$gt,
    Option: $eaec5fceb04f7d33$var$vt
});

});
parcelRegister("8EDjv", function(module, exports) {

$parcel$export(module.exports, "useVirtualizer", () => $64d08e094a93fa77$export$dd6d526d88b5a137);

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $eYRSY = parcelRequire("eYRSY");
const $64d08e094a93fa77$var$useIsomorphicLayoutEffect = typeof document !== "undefined" ? $acw62.useLayoutEffect : $acw62.useEffect;
function $64d08e094a93fa77$var$useVirtualizerBase(options) {
    const rerender = $acw62.useReducer(()=>({}), {})[1];
    const resolvedOptions = {
        ...options,
        onChange: (instance2, sync)=>{
            var _a;
            if (sync) (0, $1u0KT.flushSync)(rerender);
            else rerender();
            (_a = options.onChange) == null || _a.call(options, instance2, sync);
        }
    };
    const [instance] = $acw62.useState(()=>new (0, $eYRSY.Virtualizer)(resolvedOptions));
    instance.setOptions(resolvedOptions);
    $acw62.useEffect(()=>{
        return instance._didMount();
    }, []);
    $64d08e094a93fa77$var$useIsomorphicLayoutEffect(()=>{
        return instance._willUpdate();
    });
    return instance;
}
function $64d08e094a93fa77$export$dd6d526d88b5a137(options) {
    return $64d08e094a93fa77$var$useVirtualizerBase({
        observeElementRect: $eYRSY.observeElementRect,
        observeElementOffset: $eYRSY.observeElementOffset,
        scrollToFn: (0, $eYRSY.elementScroll),
        ...options
    });
}
function $64d08e094a93fa77$export$645722dcac657cb9(options) {
    return $64d08e094a93fa77$var$useVirtualizerBase({
        getScrollElement: ()=>typeof document !== "undefined" ? window : null,
        observeElementRect: (0, $eYRSY.observeWindowRect),
        observeElementOffset: (0, $eYRSY.observeWindowOffset),
        scrollToFn: (0, $eYRSY.windowScroll),
        initialOffset: typeof document !== "undefined" ? window.scrollY : void 0,
        ...options
    });
}

});
parcelRegister("eYRSY", function(module, exports) {

$parcel$export(module.exports, "observeElementRect", () => $ae8077da5dad972b$export$5a50ff2cde8c3802);
$parcel$export(module.exports, "observeWindowRect", () => $ae8077da5dad972b$export$e911b82c7a99311);
$parcel$export(module.exports, "observeElementOffset", () => $ae8077da5dad972b$export$fbc040aee017375a);
$parcel$export(module.exports, "observeWindowOffset", () => $ae8077da5dad972b$export$518998f8c5d09287);
$parcel$export(module.exports, "windowScroll", () => $ae8077da5dad972b$export$2162c5b3eeedd27);
$parcel$export(module.exports, "elementScroll", () => $ae8077da5dad972b$export$1cdb988e5ab69fe7);
$parcel$export(module.exports, "Virtualizer", () => $ae8077da5dad972b$export$89be5a243e59c4b2);

var $f2V6E = parcelRequire("f2V6E");
const $ae8077da5dad972b$export$76974b428a49f15b = (index)=>index;
const $ae8077da5dad972b$export$7eb7cb13fd21e5e1 = (range)=>{
    const start = Math.max(range.startIndex - range.overscan, 0);
    const end = Math.min(range.endIndex + range.overscan, range.count - 1);
    const arr = [];
    for(let i = start; i <= end; i++)arr.push(i);
    return arr;
};
const $ae8077da5dad972b$export$5a50ff2cde8c3802 = (instance, cb)=>{
    const element = instance.scrollElement;
    if (!element) return;
    const handler = (rect)=>{
        const { width: width, height: height } = rect;
        cb({
            width: Math.round(width),
            height: Math.round(height)
        });
    };
    handler(element.getBoundingClientRect());
    if (typeof ResizeObserver === "undefined") return ()=>{};
    const observer = new ResizeObserver((entries)=>{
        const entry = entries[0];
        if (entry == null ? void 0 : entry.borderBoxSize) {
            const box = entry.borderBoxSize[0];
            if (box) {
                handler({
                    width: box.inlineSize,
                    height: box.blockSize
                });
                return;
            }
        }
        handler(element.getBoundingClientRect());
    });
    observer.observe(element, {
        box: "border-box"
    });
    return ()=>{
        observer.unobserve(element);
    };
};
const $ae8077da5dad972b$export$e911b82c7a99311 = (instance, cb)=>{
    const element = instance.scrollElement;
    if (!element) return;
    const handler = ()=>{
        cb({
            width: element.innerWidth,
            height: element.innerHeight
        });
    };
    handler();
    element.addEventListener("resize", handler, {
        passive: true
    });
    return ()=>{
        element.removeEventListener("resize", handler);
    };
};
const $ae8077da5dad972b$export$fbc040aee017375a = (instance, cb)=>{
    const element = instance.scrollElement;
    if (!element) return;
    const handler = ()=>{
        cb(element[instance.options.horizontal ? "scrollLeft" : "scrollTop"]);
    };
    handler();
    element.addEventListener("scroll", handler, {
        passive: true
    });
    return ()=>{
        element.removeEventListener("scroll", handler);
    };
};
const $ae8077da5dad972b$export$518998f8c5d09287 = (instance, cb)=>{
    const element = instance.scrollElement;
    if (!element) return;
    const handler = ()=>{
        cb(element[instance.options.horizontal ? "scrollX" : "scrollY"]);
    };
    handler();
    element.addEventListener("scroll", handler, {
        passive: true
    });
    return ()=>{
        element.removeEventListener("scroll", handler);
    };
};
const $ae8077da5dad972b$export$6aa9c23c0f5932af = (element, entry, instance)=>{
    if (entry == null ? void 0 : entry.borderBoxSize) {
        const box = entry.borderBoxSize[0];
        if (box) {
            const size = Math.round(box[instance.options.horizontal ? "inlineSize" : "blockSize"]);
            return size;
        }
    }
    return Math.round(element.getBoundingClientRect()[instance.options.horizontal ? "width" : "height"]);
};
const $ae8077da5dad972b$export$2162c5b3eeedd27 = (offset, { adjustments: adjustments = 0, behavior: behavior }, instance)=>{
    var _a, _b;
    const toOffset = offset + adjustments;
    (_b = (_a = instance.scrollElement) == null ? void 0 : _a.scrollTo) == null || _b.call(_a, {
        [instance.options.horizontal ? "left" : "top"]: toOffset,
        behavior: behavior
    });
};
const $ae8077da5dad972b$export$1cdb988e5ab69fe7 = (offset, { adjustments: adjustments = 0, behavior: behavior }, instance)=>{
    var _a, _b;
    const toOffset = offset + adjustments;
    (_b = (_a = instance.scrollElement) == null ? void 0 : _a.scrollTo) == null || _b.call(_a, {
        [instance.options.horizontal ? "left" : "top"]: toOffset,
        behavior: behavior
    });
};
class $ae8077da5dad972b$export$89be5a243e59c4b2 {
    constructor(opts){
        this.unsubs = [];
        this.scrollElement = null;
        this.isScrolling = false;
        this.isScrollingTimeoutId = null;
        this.scrollToIndexTimeoutId = null;
        this.measurementsCache = [];
        this.itemSizeCache = /* @__PURE__ */ new Map();
        this.pendingMeasuredCacheIndexes = [];
        this.scrollDirection = null;
        this.scrollAdjustments = 0;
        this.measureElementCache = /* @__PURE__ */ new Map();
        this.observer = /* @__PURE__ */ (()=>{
            let _ro = null;
            const get = ()=>{
                if (_ro) return _ro;
                else if (typeof ResizeObserver !== "undefined") return _ro = new ResizeObserver((entries)=>{
                    entries.forEach((entry)=>{
                        this._measureElement(entry.target, entry);
                    });
                });
                else return null;
            };
            return {
                disconnect: ()=>{
                    var _a;
                    return (_a = get()) == null ? void 0 : _a.disconnect();
                },
                observe: (target)=>{
                    var _a;
                    return (_a = get()) == null ? void 0 : _a.observe(target, {
                        box: "border-box"
                    });
                },
                unobserve: (target)=>{
                    var _a;
                    return (_a = get()) == null ? void 0 : _a.unobserve(target);
                }
            };
        })();
        this.range = null;
        this.setOptions = (opts2)=>{
            Object.entries(opts2).forEach(([key, value])=>{
                if (typeof value === "undefined") delete opts2[key];
            });
            this.options = {
                debug: false,
                initialOffset: 0,
                overscan: 1,
                paddingStart: 0,
                paddingEnd: 0,
                scrollPaddingStart: 0,
                scrollPaddingEnd: 0,
                horizontal: false,
                getItemKey: $ae8077da5dad972b$export$76974b428a49f15b,
                rangeExtractor: $ae8077da5dad972b$export$7eb7cb13fd21e5e1,
                onChange: ()=>{},
                measureElement: $ae8077da5dad972b$export$6aa9c23c0f5932af,
                initialRect: {
                    width: 0,
                    height: 0
                },
                scrollMargin: 0,
                scrollingDelay: 150,
                indexAttribute: "data-index",
                initialMeasurementsCache: [],
                lanes: 1,
                ...opts2
            };
        };
        this.notify = (sync)=>{
            var _a, _b;
            (_b = (_a = this.options).onChange) == null || _b.call(_a, this, sync);
        };
        this.maybeNotify = (0, $f2V6E.memo)(()=>{
            this.calculateRange();
            return [
                this.isScrolling,
                this.range ? this.range.startIndex : null,
                this.range ? this.range.endIndex : null
            ];
        }, (isScrolling)=>{
            this.notify(isScrolling);
        }, {
            key: false,
            debug: ()=>this.options.debug,
            initialDeps: [
                this.isScrolling,
                this.range ? this.range.startIndex : null,
                this.range ? this.range.endIndex : null
            ]
        });
        this.cleanup = ()=>{
            this.unsubs.filter(Boolean).forEach((d)=>d());
            this.unsubs = [];
            this.scrollElement = null;
        };
        this._didMount = ()=>{
            this.measureElementCache.forEach(this.observer.observe);
            return ()=>{
                this.observer.disconnect();
                this.cleanup();
            };
        };
        this._willUpdate = ()=>{
            const scrollElement = this.options.getScrollElement();
            if (this.scrollElement !== scrollElement) {
                this.cleanup();
                this.scrollElement = scrollElement;
                this._scrollToOffset(this.scrollOffset, {
                    adjustments: void 0,
                    behavior: void 0
                });
                this.unsubs.push(this.options.observeElementRect(this, (rect)=>{
                    this.scrollRect = rect;
                    this.maybeNotify();
                }));
                this.unsubs.push(this.options.observeElementOffset(this, (offset)=>{
                    this.scrollAdjustments = 0;
                    if (this.scrollOffset === offset) return;
                    if (this.isScrollingTimeoutId !== null) {
                        clearTimeout(this.isScrollingTimeoutId);
                        this.isScrollingTimeoutId = null;
                    }
                    this.isScrolling = true;
                    this.scrollDirection = this.scrollOffset < offset ? "forward" : "backward";
                    this.scrollOffset = offset;
                    this.maybeNotify();
                    this.isScrollingTimeoutId = setTimeout(()=>{
                        this.isScrollingTimeoutId = null;
                        this.isScrolling = false;
                        this.scrollDirection = null;
                        this.maybeNotify();
                    }, this.options.scrollingDelay);
                }));
            }
        };
        this.getSize = ()=>{
            return this.scrollRect[this.options.horizontal ? "width" : "height"];
        };
        this.memoOptions = (0, $f2V6E.memo)(()=>[
                this.options.count,
                this.options.paddingStart,
                this.options.scrollMargin,
                this.options.getItemKey
            ], (count, paddingStart, scrollMargin, getItemKey)=>{
            this.pendingMeasuredCacheIndexes = [];
            return {
                count: count,
                paddingStart: paddingStart,
                scrollMargin: scrollMargin,
                getItemKey: getItemKey
            };
        }, {
            key: false
        });
        this.getFurthestMeasurement = (measurements, index)=>{
            const furthestMeasurementsFound = /* @__PURE__ */ new Map();
            const furthestMeasurements = /* @__PURE__ */ new Map();
            for(let m = index - 1; m >= 0; m--){
                const measurement = measurements[m];
                if (furthestMeasurementsFound.has(measurement.lane)) continue;
                const previousFurthestMeasurement = furthestMeasurements.get(measurement.lane);
                if (previousFurthestMeasurement == null || measurement.end > previousFurthestMeasurement.end) furthestMeasurements.set(measurement.lane, measurement);
                else if (measurement.end < previousFurthestMeasurement.end) furthestMeasurementsFound.set(measurement.lane, true);
                if (furthestMeasurementsFound.size === this.options.lanes) break;
            }
            return furthestMeasurements.size === this.options.lanes ? Array.from(furthestMeasurements.values()).sort((a, b)=>{
                if (a.end === b.end) return a.index - b.index;
                return a.end - b.end;
            })[0] : void 0;
        };
        this.getMeasurements = (0, $f2V6E.memo)(()=>[
                this.memoOptions(),
                this.itemSizeCache
            ], ({ count: count, paddingStart: paddingStart, scrollMargin: scrollMargin, getItemKey: getItemKey }, itemSizeCache)=>{
            const min = this.pendingMeasuredCacheIndexes.length > 0 ? Math.min(...this.pendingMeasuredCacheIndexes) : 0;
            this.pendingMeasuredCacheIndexes = [];
            const measurements = this.measurementsCache.slice(0, min);
            for(let i = min; i < count; i++){
                const key = getItemKey(i);
                const furthestMeasurement = this.options.lanes === 1 ? measurements[i - 1] : this.getFurthestMeasurement(measurements, i);
                const start = furthestMeasurement ? furthestMeasurement.end : paddingStart + scrollMargin;
                const measuredSize = itemSizeCache.get(key);
                const size = typeof measuredSize === "number" ? measuredSize : this.options.estimateSize(i);
                const end = start + size;
                const lane = furthestMeasurement ? furthestMeasurement.lane : i % this.options.lanes;
                measurements[i] = {
                    index: i,
                    start: start,
                    size: size,
                    end: end,
                    key: key,
                    lane: lane
                };
            }
            this.measurementsCache = measurements;
            return measurements;
        }, {
            key: false,
            debug: ()=>this.options.debug
        });
        this.calculateRange = (0, $f2V6E.memo)(()=>[
                this.getMeasurements(),
                this.getSize(),
                this.scrollOffset
            ], (measurements, outerSize, scrollOffset)=>{
            return this.range = measurements.length > 0 && outerSize > 0 ? $ae8077da5dad972b$var$calculateRange({
                measurements: measurements,
                outerSize: outerSize,
                scrollOffset: scrollOffset
            }) : null;
        }, {
            key: false,
            debug: ()=>this.options.debug
        });
        this.getIndexes = (0, $f2V6E.memo)(()=>[
                this.options.rangeExtractor,
                this.calculateRange(),
                this.options.overscan,
                this.options.count
            ], (rangeExtractor, range, overscan, count)=>{
            return range === null ? [] : rangeExtractor({
                ...range,
                overscan: overscan,
                count: count
            });
        }, {
            key: false,
            debug: ()=>this.options.debug
        });
        this.indexFromElement = (node)=>{
            const attributeName = this.options.indexAttribute;
            const indexStr = node.getAttribute(attributeName);
            if (!indexStr) {
                console.warn(`Missing attribute name '${attributeName}={index}' on measured element.`);
                return -1;
            }
            return parseInt(indexStr, 10);
        };
        this._measureElement = (node, entry)=>{
            const item = this.measurementsCache[this.indexFromElement(node)];
            if (!item || !node.isConnected) {
                this.measureElementCache.forEach((cached, key)=>{
                    if (cached === node) {
                        this.observer.unobserve(node);
                        this.measureElementCache.delete(key);
                    }
                });
                return;
            }
            const prevNode = this.measureElementCache.get(item.key);
            if (prevNode !== node) {
                if (prevNode) this.observer.unobserve(prevNode);
                this.observer.observe(node);
                this.measureElementCache.set(item.key, node);
            }
            const measuredItemSize = this.options.measureElement(node, entry, this);
            this.resizeItem(item, measuredItemSize);
        };
        this.resizeItem = (item, size)=>{
            const itemSize = this.itemSizeCache.get(item.key) ?? item.size;
            const delta = size - itemSize;
            if (delta !== 0) {
                if (item.start < this.scrollOffset + this.scrollAdjustments) this._scrollToOffset(this.scrollOffset, {
                    adjustments: this.scrollAdjustments += delta,
                    behavior: void 0
                });
                this.pendingMeasuredCacheIndexes.push(item.index);
                this.itemSizeCache = new Map(this.itemSizeCache.set(item.key, size));
                this.notify(false);
            }
        };
        this.measureElement = (node)=>{
            if (!node) return;
            this._measureElement(node, void 0);
        };
        this.getVirtualItems = (0, $f2V6E.memo)(()=>[
                this.getIndexes(),
                this.getMeasurements()
            ], (indexes, measurements)=>{
            const virtualItems = [];
            for(let k = 0, len = indexes.length; k < len; k++){
                const i = indexes[k];
                const measurement = measurements[i];
                virtualItems.push(measurement);
            }
            return virtualItems;
        }, {
            key: false,
            debug: ()=>this.options.debug
        });
        this.getVirtualItemForOffset = (offset)=>{
            const measurements = this.getMeasurements();
            return (0, $f2V6E.notUndefined)(measurements[$ae8077da5dad972b$var$findNearestBinarySearch(0, measurements.length - 1, (index)=>(0, $f2V6E.notUndefined)(measurements[index]).start, offset)]);
        };
        this.getOffsetForAlignment = (toOffset, align)=>{
            const size = this.getSize();
            if (align === "auto") {
                if (toOffset <= this.scrollOffset) align = "start";
                else if (toOffset >= this.scrollOffset + size) align = "end";
                else align = "start";
            }
            if (align === "start") toOffset;
            else if (align === "end") toOffset = toOffset - size;
            else if (align === "center") toOffset = toOffset - size / 2;
            const scrollSizeProp = this.options.horizontal ? "scrollWidth" : "scrollHeight";
            const scrollSize = this.scrollElement ? "document" in this.scrollElement ? this.scrollElement.document.documentElement[scrollSizeProp] : this.scrollElement[scrollSizeProp] : 0;
            const maxOffset = scrollSize - this.getSize();
            return Math.max(Math.min(maxOffset, toOffset), 0);
        };
        this.getOffsetForIndex = (index, align = "auto")=>{
            index = Math.max(0, Math.min(index, this.options.count - 1));
            const measurement = (0, $f2V6E.notUndefined)(this.getMeasurements()[index]);
            if (align === "auto") {
                if (measurement.end >= this.scrollOffset + this.getSize() - this.options.scrollPaddingEnd) align = "end";
                else if (measurement.start <= this.scrollOffset + this.options.scrollPaddingStart) align = "start";
                else return [
                    this.scrollOffset,
                    align
                ];
            }
            const toOffset = align === "end" ? measurement.end + this.options.scrollPaddingEnd : measurement.start - this.options.scrollPaddingStart;
            return [
                this.getOffsetForAlignment(toOffset, align),
                align
            ];
        };
        this.isDynamicMode = ()=>this.measureElementCache.size > 0;
        this.cancelScrollToIndex = ()=>{
            if (this.scrollToIndexTimeoutId !== null) {
                clearTimeout(this.scrollToIndexTimeoutId);
                this.scrollToIndexTimeoutId = null;
            }
        };
        this.scrollToOffset = (toOffset, { align: align = "start", behavior: behavior } = {})=>{
            this.cancelScrollToIndex();
            if (behavior === "smooth" && this.isDynamicMode()) console.warn("The `smooth` scroll behavior is not fully supported with dynamic size.");
            this._scrollToOffset(this.getOffsetForAlignment(toOffset, align), {
                adjustments: void 0,
                behavior: behavior
            });
        };
        this.scrollToIndex = (index, { align: initialAlign = "auto", behavior: behavior } = {})=>{
            index = Math.max(0, Math.min(index, this.options.count - 1));
            this.cancelScrollToIndex();
            if (behavior === "smooth" && this.isDynamicMode()) console.warn("The `smooth` scroll behavior is not fully supported with dynamic size.");
            const [toOffset, align] = this.getOffsetForIndex(index, initialAlign);
            this._scrollToOffset(toOffset, {
                adjustments: void 0,
                behavior: behavior
            });
            if (behavior !== "smooth" && this.isDynamicMode()) this.scrollToIndexTimeoutId = setTimeout(()=>{
                this.scrollToIndexTimeoutId = null;
                const elementInDOM = this.measureElementCache.has(this.options.getItemKey(index));
                if (elementInDOM) {
                    const [toOffset2] = this.getOffsetForIndex(index, align);
                    if (!(0, $f2V6E.approxEqual)(toOffset2, this.scrollOffset)) this.scrollToIndex(index, {
                        align: align,
                        behavior: behavior
                    });
                } else this.scrollToIndex(index, {
                    align: align,
                    behavior: behavior
                });
            });
        };
        this.scrollBy = (delta, { behavior: behavior } = {})=>{
            this.cancelScrollToIndex();
            if (behavior === "smooth" && this.isDynamicMode()) console.warn("The `smooth` scroll behavior is not fully supported with dynamic size.");
            this._scrollToOffset(this.scrollOffset + delta, {
                adjustments: void 0,
                behavior: behavior
            });
        };
        this.getTotalSize = ()=>{
            var _a;
            const measurements = this.getMeasurements();
            let end;
            if (measurements.length === 0) end = this.options.paddingStart;
            else end = this.options.lanes === 1 ? ((_a = measurements[measurements.length - 1]) == null ? void 0 : _a.end) ?? 0 : Math.max(...measurements.slice(-this.options.lanes).map((m)=>m.end));
            return end - this.options.scrollMargin + this.options.paddingEnd;
        };
        this._scrollToOffset = (offset, { adjustments: adjustments, behavior: behavior })=>{
            this.options.scrollToFn(offset, {
                behavior: behavior,
                adjustments: adjustments
            }, this);
        };
        this.measure = ()=>{
            this.itemSizeCache = /* @__PURE__ */ new Map();
            this.notify(false);
        };
        this.setOptions(opts);
        this.scrollRect = this.options.initialRect;
        this.scrollOffset = this.options.initialOffset;
        this.measurementsCache = this.options.initialMeasurementsCache;
        this.measurementsCache.forEach((item)=>{
            this.itemSizeCache.set(item.key, item.size);
        });
        this.maybeNotify();
    }
}
const $ae8077da5dad972b$var$findNearestBinarySearch = (low, high, getCurrentValue, value)=>{
    while(low <= high){
        const middle = (low + high) / 2 | 0;
        const currentValue = getCurrentValue(middle);
        if (currentValue < value) low = middle + 1;
        else if (currentValue > value) high = middle - 1;
        else return middle;
    }
    if (low > 0) return low - 1;
    else return 0;
};
function $ae8077da5dad972b$var$calculateRange({ measurements: measurements, outerSize: outerSize, scrollOffset: scrollOffset }) {
    const count = measurements.length - 1;
    const getOffset = (index)=>measurements[index].start;
    const startIndex = $ae8077da5dad972b$var$findNearestBinarySearch(0, count, getOffset, scrollOffset);
    let endIndex = startIndex;
    while(endIndex < count && measurements[endIndex].end < scrollOffset + outerSize)endIndex++;
    return {
        startIndex: startIndex,
        endIndex: endIndex
    };
}

});
parcelRegister("f2V6E", function(module, exports) {

$parcel$export(module.exports, "memo", () => $af43570ba0a8567e$export$7c73462e0d25e514);
$parcel$export(module.exports, "notUndefined", () => $af43570ba0a8567e$export$9a1adf421b69c6a);
$parcel$export(module.exports, "approxEqual", () => $af43570ba0a8567e$export$8a4f1dcc58a69dbd);
function $af43570ba0a8567e$export$7c73462e0d25e514(getDeps, fn, opts) {
    let deps = opts.initialDeps ?? [];
    let result;
    return ()=>{
        var _a, _b, _c, _d;
        let depTime;
        if (opts.key && ((_a = opts.debug) == null ? void 0 : _a.call(opts))) depTime = Date.now();
        const newDeps = getDeps();
        const depsChanged = newDeps.length !== deps.length || newDeps.some((dep, index)=>deps[index] !== dep);
        if (!depsChanged) return result;
        deps = newDeps;
        let resultTime;
        if (opts.key && ((_b = opts.debug) == null ? void 0 : _b.call(opts))) resultTime = Date.now();
        result = fn(...newDeps);
        if (opts.key && ((_c = opts.debug) == null ? void 0 : _c.call(opts))) {
            const depEndTime = Math.round((Date.now() - depTime) * 100) / 100;
            const resultEndTime = Math.round((Date.now() - resultTime) * 100) / 100;
            const resultFpsPercentage = resultEndTime / 16;
            const pad = (str, num)=>{
                str = String(str);
                while(str.length < num)str = " " + str;
                return str;
            };
            console.info(`%c\u{23F1} ${pad(resultEndTime, 5)} /${pad(depEndTime, 5)} ms`, `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(0, Math.min(120 - 120 * resultFpsPercentage, 120))}deg 100% 31%);`, opts == null ? void 0 : opts.key);
        }
        (_d = opts == null ? void 0 : opts.onChange) == null || _d.call(opts, result);
        return result;
    };
}
function $af43570ba0a8567e$export$9a1adf421b69c6a(value, msg) {
    if (value === void 0) throw new Error(`Unexpected undefined${msg ? `: ${msg}` : ""}`);
    else return value;
}
const $af43570ba0a8567e$export$8a4f1dcc58a69dbd = (a, b)=>Math.abs(a - b) < 1;

});



parcelRegister("ivoM3", function(module, exports) {

$parcel$export(module.exports, "useComputed", () => $d78e56d87e9d66e2$export$e3d20747ab930783);

var $acw62 = parcelRequire("acw62");

var $8KgIp = parcelRequire("8KgIp");

var $ltgxC = parcelRequire("ltgxC");
function $d78e56d87e9d66e2$export$e3d20747ab930783(e, o) {
    let [u, t] = (0, $acw62.useState)(e), r = (0, $ltgxC.useLatestValue)(e);
    return (0, $8KgIp.useIsoMorphicEffect)(()=>t(r.current), [
        r,
        t,
        ...o
    ]), u;
}

});
parcelRegister("8KgIp", function(module, exports) {

$parcel$export(module.exports, "useIsoMorphicEffect", () => $65df95ec9b1bb6a8$export$ce5ed857c741fd71);

var $acw62 = parcelRequire("acw62");

var $Iy8e1 = parcelRequire("Iy8e1");
let $65df95ec9b1bb6a8$export$ce5ed857c741fd71 = (e, f)=>{
    (0, $Iy8e1.env).isServer ? (0, $acw62.useEffect)(e, f) : (0, $acw62.useLayoutEffect)(e, f);
};

});
parcelRegister("Iy8e1", function(module, exports) {

$parcel$export(module.exports, "env", () => $085e96034c813fbf$export$a7b6bc01c63cdfc3);
var $085e96034c813fbf$var$i = Object.defineProperty;
var $085e96034c813fbf$var$d = (t, e, n)=>e in t ? $085e96034c813fbf$var$i(t, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: n
    }) : t[e] = n;
var $085e96034c813fbf$var$r = (t, e, n)=>($085e96034c813fbf$var$d(t, typeof e != "symbol" ? e + "" : e, n), n);
class $085e96034c813fbf$var$o {
    constructor(){
        $085e96034c813fbf$var$r(this, "current", this.detect());
        $085e96034c813fbf$var$r(this, "handoffState", "pending");
        $085e96034c813fbf$var$r(this, "currentId", 0);
    }
    set(e) {
        this.current !== e && (this.handoffState = "pending", this.currentId = 0, this.current = e);
    }
    reset() {
        this.set(this.detect());
    }
    nextId() {
        return ++this.currentId;
    }
    get isServer() {
        return this.current === "server";
    }
    get isClient() {
        return this.current === "client";
    }
    detect() {
        return typeof window == "undefined" || typeof document == "undefined" ? "server" : "client";
    }
    handoff() {
        this.handoffState === "pending" && (this.handoffState = "complete");
    }
    get isHandoffComplete() {
        return this.handoffState === "complete";
    }
}
let $085e96034c813fbf$export$a7b6bc01c63cdfc3 = new $085e96034c813fbf$var$o;

});


parcelRegister("ltgxC", function(module, exports) {

$parcel$export(module.exports, "useLatestValue", () => $fa1923261638cacc$export$86c4283a11f23f95);

var $acw62 = parcelRequire("acw62");

var $8KgIp = parcelRequire("8KgIp");
function $fa1923261638cacc$export$86c4283a11f23f95(e) {
    let r = (0, $acw62.useRef)(e);
    return (0, $8KgIp.useIsoMorphicEffect)(()=>{
        r.current = e;
    }, [
        e
    ]), r;
}

});


parcelRegister("h26ct", function(module, exports) {

$parcel$export(module.exports, "useControllable", () => $c6676ed1f400443a$export$454217e89aea72b);

var $acw62 = parcelRequire("acw62");

var $114Mg = parcelRequire("114Mg");
function $c6676ed1f400443a$export$454217e89aea72b(l, r, c) {
    let [i, s] = (0, $acw62.useState)(c), e = l !== void 0, t = (0, $acw62.useRef)(e), u = (0, $acw62.useRef)(!1), d = (0, $acw62.useRef)(!1);
    return e && !t.current && !u.current ? (u.current = !0, t.current = e, console.error("A component is changing from uncontrolled to controlled. This may be caused by the value changing from undefined to a defined value, which should not happen.")) : !e && t.current && !d.current && (d.current = !0, t.current = e, console.error("A component is changing from controlled to uncontrolled. This may be caused by the value changing from a defined value to undefined, which should not happen.")), [
        e ? l : i,
        (0, $114Mg.useEvent)((n)=>(e || s(n), r == null ? void 0 : r(n)))
    ];
}

});
parcelRegister("114Mg", function(module, exports) {

$parcel$export(module.exports, "useEvent", () => $0bd9972698c32399$export$90fc3a17d93f704c);

var $acw62 = parcelRequire("acw62");

var $ltgxC = parcelRequire("ltgxC");
let $0bd9972698c32399$export$90fc3a17d93f704c = function(t) {
    let e = (0, $ltgxC.useLatestValue)(t);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((...r)=>e.current(...r), [
        e
    ]);
};

});


parcelRegister("5Ai9V", function(module, exports) {

$parcel$export(module.exports, "useDisposables", () => $410e668b7f520622$export$fd183955ff4b45d9);

var $acw62 = parcelRequire("acw62");

var $1COYr = parcelRequire("1COYr");
function $410e668b7f520622$export$fd183955ff4b45d9() {
    let [e] = (0, $acw62.useState)((0, $1COYr.disposables));
    return (0, $acw62.useEffect)(()=>()=>e.dispose(), [
        e
    ]), e;
}

});
parcelRegister("1COYr", function(module, exports) {

$parcel$export(module.exports, "disposables", () => $12f0e1633d904536$export$12b26c28a05aa001);

var $eJKgu = parcelRequire("eJKgu");
function $12f0e1633d904536$export$12b26c28a05aa001() {
    let n = [], r = {
        addEventListener (e, t, s, a) {
            return e.addEventListener(t, s, a), r.add(()=>e.removeEventListener(t, s, a));
        },
        requestAnimationFrame (...e) {
            let t = requestAnimationFrame(...e);
            return r.add(()=>cancelAnimationFrame(t));
        },
        nextFrame (...e) {
            return r.requestAnimationFrame(()=>r.requestAnimationFrame(...e));
        },
        setTimeout (...e) {
            let t = setTimeout(...e);
            return r.add(()=>clearTimeout(t));
        },
        microTask (...e) {
            let t = {
                current: !0
            };
            return (0, $eJKgu.microTask)(()=>{
                t.current && e[0]();
            }), r.add(()=>{
                t.current = !1;
            });
        },
        style (e, t, s) {
            let a = e.style.getPropertyValue(t);
            return Object.assign(e.style, {
                [t]: s
            }), this.add(()=>{
                Object.assign(e.style, {
                    [t]: a
                });
            });
        },
        group (e) {
            let t = $12f0e1633d904536$export$12b26c28a05aa001();
            return e(t), this.add(()=>t.dispose());
        },
        add (e) {
            return n.push(e), ()=>{
                let t = n.indexOf(e);
                if (t >= 0) for (let s of n.splice(t, 1))s();
            };
        },
        dispose () {
            for (let e of n.splice(0))e();
        }
    };
    return r;
}

});
parcelRegister("eJKgu", function(module, exports) {

$parcel$export(module.exports, "microTask", () => $aba927e9b3929756$export$a5ff0d6a738703ca);
function $aba927e9b3929756$export$a5ff0d6a738703ca(e) {
    typeof queueMicrotask == "function" ? queueMicrotask(e) : Promise.resolve().then(e).catch((o)=>setTimeout(()=>{
            throw o;
        }));
}

});



parcelRegister("kPvke", function(module, exports) {

$parcel$export(module.exports, "useId", () => $f2a0dea4caee12c6$export$f680877a34711e37);

var $acw62 = parcelRequire("acw62");

var $Iy8e1 = parcelRequire("Iy8e1");

var $8KgIp = parcelRequire("8KgIp");

var $b8md9 = parcelRequire("b8md9");
var $f2a0dea4caee12c6$var$o;
let $f2a0dea4caee12c6$export$f680877a34711e37 = ($f2a0dea4caee12c6$var$o = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useId) != null ? $f2a0dea4caee12c6$var$o : function() {
    let n = (0, $b8md9.useServerHandoffComplete)(), [e, u] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(n ? ()=>(0, $Iy8e1.env).nextId() : null);
    return (0, $8KgIp.useIsoMorphicEffect)(()=>{
        e === null && u((0, $Iy8e1.env).nextId());
    }, [
        e
    ]), e != null ? "" + e : void 0;
};

});
parcelRegister("b8md9", function(module, exports) {

$parcel$export(module.exports, "useServerHandoffComplete", () => $81b1abbf8717f9cc$export$44ab2b9f2d09b0fa);

var $acw62 = parcelRequire("acw62");

var $Iy8e1 = parcelRequire("Iy8e1");
function $81b1abbf8717f9cc$var$s() {
    let r = typeof document == "undefined";
    return "useSyncExternalStore" in $acw62 ? ((o)=>o.useSyncExternalStore)($acw62)(()=>()=>{}, ()=>!1, ()=>!r) : !1;
}
function $81b1abbf8717f9cc$export$44ab2b9f2d09b0fa() {
    let r = $81b1abbf8717f9cc$var$s(), [e, n] = $acw62.useState((0, $Iy8e1.env).isHandoffComplete);
    return e && (0, $Iy8e1.env).isHandoffComplete === !1 && n(!1), $acw62.useEffect(()=>{
        e !== !0 && n(!0);
    }, [
        e
    ]), $acw62.useEffect(()=>(0, $Iy8e1.env).handoff(), []), r ? !1 : e;
}

});


parcelRegister("23pTr", function(module, exports) {

$parcel$export(module.exports, "useOutsideClick", () => $17eff26b89e4b024$export$71b2224f1ce5e08e);

var $acw62 = parcelRequire("acw62");

var $hsQxB = parcelRequire("hsQxB");

var $8UjaS = parcelRequire("8UjaS");

var $fA3F6 = parcelRequire("fA3F6");

var $5vI4D = parcelRequire("5vI4D");
function $17eff26b89e4b024$export$71b2224f1ce5e08e(s, m, a = !0) {
    let i = (0, $acw62.useRef)(!1);
    (0, $acw62.useEffect)(()=>{
        requestAnimationFrame(()=>{
            i.current = a;
        });
    }, [
        a
    ]);
    function c(e, r) {
        if (!i.current || e.defaultPrevented) return;
        let t = r(e);
        if (t === null || !t.getRootNode().contains(t) || !t.isConnected) return;
        let E = function u(n) {
            return typeof n == "function" ? u(n()) : Array.isArray(n) || n instanceof Set ? n : [
                n
            ];
        }(s);
        for (let u of E){
            if (u === null) continue;
            let n = u instanceof HTMLElement ? u : u.current;
            if (n != null && n.contains(t) || e.composed && e.composedPath().includes(n)) return;
        }
        return !(0, $hsQxB.isFocusableElement)(t, (0, $hsQxB.FocusableMode).Loose) && t.tabIndex !== -1 && e.preventDefault(), m(e, t);
    }
    let o = (0, $acw62.useRef)(null);
    (0, $fA3F6.useDocumentEvent)("pointerdown", (e)=>{
        var r, t;
        i.current && (o.current = ((t = (r = e.composedPath) == null ? void 0 : r.call(e)) == null ? void 0 : t[0]) || e.target);
    }, !0), (0, $fA3F6.useDocumentEvent)("mousedown", (e)=>{
        var r, t;
        i.current && (o.current = ((t = (r = e.composedPath) == null ? void 0 : r.call(e)) == null ? void 0 : t[0]) || e.target);
    }, !0), (0, $fA3F6.useDocumentEvent)("click", (e)=>{
        (0, $8UjaS.isMobile)() || o.current && (c(e, ()=>o.current), o.current = null);
    }, !0), (0, $fA3F6.useDocumentEvent)("touchend", (e)=>c(e, ()=>e.target instanceof HTMLElement ? e.target : null), !0), (0, $5vI4D.useWindowEvent)("blur", (e)=>c(e, ()=>window.document.activeElement instanceof HTMLIFrameElement ? window.document.activeElement : null), !0);
}

});
parcelRegister("hsQxB", function(module, exports) {

$parcel$export(module.exports, "FocusableMode", () => $cb6dceb64e6c0606$export$27112a34f2f8402d);
$parcel$export(module.exports, "isFocusableElement", () => $cb6dceb64e6c0606$export$ff1ec1c740b3c8d5);
$parcel$export(module.exports, "sortByDomNode", () => $cb6dceb64e6c0606$export$20305e96f91bf103);

var $1COYr = parcelRequire("1COYr");

var $6Ngq1 = parcelRequire("6Ngq1");

var $gxwGc = parcelRequire("gxwGc");
let $cb6dceb64e6c0606$var$c = [
    "[contentEditable=true]",
    "[tabindex]",
    "a[href]",
    "area[href]",
    "button:not([disabled])",
    "iframe",
    "input:not([disabled])",
    "select:not([disabled])",
    "textarea:not([disabled])"
].map((e)=>`${e}:not([tabindex='-1'])`).join(",");
var $cb6dceb64e6c0606$export$807a7eae502106e7 = ((n)=>(n[n.First = 1] = "First", n[n.Previous = 2] = "Previous", n[n.Next = 4] = "Next", n[n.Last = 8] = "Last", n[n.WrapAround = 16] = "WrapAround", n[n.NoScroll = 32] = "NoScroll", n))($cb6dceb64e6c0606$export$807a7eae502106e7 || {}), $cb6dceb64e6c0606$export$abf286375dfa6dbd = ((o)=>(o[o.Error = 0] = "Error", o[o.Overflow = 1] = "Overflow", o[o.Success = 2] = "Success", o[o.Underflow = 3] = "Underflow", o))($cb6dceb64e6c0606$export$abf286375dfa6dbd || {}), $cb6dceb64e6c0606$var$F = ((t)=>(t[t.Previous = -1] = "Previous", t[t.Next = 1] = "Next", t))($cb6dceb64e6c0606$var$F || {});
function $cb6dceb64e6c0606$export$433aaa1f216cf32d(e = document.body) {
    return e == null ? [] : Array.from(e.querySelectorAll($cb6dceb64e6c0606$var$c)).sort((r, t)=>Math.sign((r.tabIndex || Number.MAX_SAFE_INTEGER) - (t.tabIndex || Number.MAX_SAFE_INTEGER)));
}
var $cb6dceb64e6c0606$export$27112a34f2f8402d = ((t)=>(t[t.Strict = 0] = "Strict", t[t.Loose = 1] = "Loose", t))($cb6dceb64e6c0606$export$27112a34f2f8402d || {});
function $cb6dceb64e6c0606$export$ff1ec1c740b3c8d5(e, r = 0) {
    var t;
    return e === ((t = (0, $gxwGc.getOwnerDocument)(e)) == null ? void 0 : t.body) ? !1 : (0, $6Ngq1.match)(r, {
        [0] () {
            return e.matches($cb6dceb64e6c0606$var$c);
        },
        [1] () {
            let l = e;
            for(; l !== null;){
                if (l.matches($cb6dceb64e6c0606$var$c)) return !0;
                l = l.parentElement;
            }
            return !1;
        }
    });
}
function $cb6dceb64e6c0606$export$46388676ec35ab85(e) {
    let r = (0, $gxwGc.getOwnerDocument)(e);
    (0, $1COYr.disposables)().nextFrame(()=>{
        r && !$cb6dceb64e6c0606$export$ff1ec1c740b3c8d5(r.activeElement, 0) && $cb6dceb64e6c0606$export$5fed9cc43865dc7e(e);
    });
}
var $cb6dceb64e6c0606$var$w = ((t)=>(t[t.Keyboard = 0] = "Keyboard", t[t.Mouse = 1] = "Mouse", t))($cb6dceb64e6c0606$var$w || {});
typeof window != "undefined" && typeof document != "undefined" && (document.addEventListener("keydown", (e)=>{
    e.metaKey || e.altKey || e.ctrlKey || (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0), document.addEventListener("click", (e)=>{
    e.detail === 1 ? delete document.documentElement.dataset.headlessuiFocusVisible : e.detail === 0 && (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0));
function $cb6dceb64e6c0606$export$5fed9cc43865dc7e(e) {
    e == null || e.focus({
        preventScroll: !0
    });
}
let $cb6dceb64e6c0606$var$S = [
    "textarea",
    "input"
].join(",");
function $cb6dceb64e6c0606$var$H(e) {
    var r, t;
    return (t = (r = e == null ? void 0 : e.matches) == null ? void 0 : r.call(e, $cb6dceb64e6c0606$var$S)) != null ? t : !1;
}
function $cb6dceb64e6c0606$export$20305e96f91bf103(e, r = (t)=>t) {
    return e.slice().sort((t, l)=>{
        let o = r(t), i = r(l);
        if (o === null || i === null) return 0;
        let n = o.compareDocumentPosition(i);
        return n & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : n & Node.DOCUMENT_POSITION_PRECEDING ? 1 : 0;
    });
}
function $cb6dceb64e6c0606$export$7fb6c844b485e870(e, r) {
    return $cb6dceb64e6c0606$export$82e1f4f412218a1d($cb6dceb64e6c0606$export$433aaa1f216cf32d(), r, {
        relativeTo: e
    });
}
function $cb6dceb64e6c0606$export$82e1f4f412218a1d(e, r, { sorted: t = !0, relativeTo: l = null, skipElements: o = [] } = {}) {
    let i = Array.isArray(e) ? e.length > 0 ? e[0].ownerDocument : document : e.ownerDocument, n = Array.isArray(e) ? t ? $cb6dceb64e6c0606$export$20305e96f91bf103(e) : e : $cb6dceb64e6c0606$export$433aaa1f216cf32d(e);
    o.length > 0 && n.length > 1 && (n = n.filter((s)=>!o.includes(s))), l = l != null ? l : i.activeElement;
    let E = (()=>{
        if (r & 5) return 1;
        if (r & 10) return -1;
        throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
    })(), x = (()=>{
        if (r & 1) return 0;
        if (r & 2) return Math.max(0, n.indexOf(l)) - 1;
        if (r & 4) return Math.max(0, n.indexOf(l)) + 1;
        if (r & 8) return n.length - 1;
        throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
    })(), p = r & 32 ? {
        preventScroll: !0
    } : {}, d = 0, a = n.length, u;
    do {
        if (d >= a || d + a <= 0) return 0;
        let s = x + d;
        if (r & 16) s = (s + a) % a;
        else {
            if (s < 0) return 3;
            if (s >= a) return 1;
        }
        u = n[s], u == null || u.focus(p), d += E;
    }while (u !== i.activeElement);
    return r & 6 && $cb6dceb64e6c0606$var$H(u) && u.select(), 2;
}

});
parcelRegister("6Ngq1", function(module, exports) {

$parcel$export(module.exports, "match", () => $4f240e1aafd2c298$export$4659b591c19bdf3d);
function $4f240e1aafd2c298$export$4659b591c19bdf3d(r, n, ...a) {
    if (r in n) {
        let e = n[r];
        return typeof e == "function" ? e(...a) : e;
    }
    let t = new Error(`Tried to handle "${r}" but there is no handler defined. Only defined handlers are: ${Object.keys(n).map((e)=>`"${e}"`).join(", ")}.`);
    throw Error.captureStackTrace && Error.captureStackTrace(t, $4f240e1aafd2c298$export$4659b591c19bdf3d), t;
}

});

parcelRegister("gxwGc", function(module, exports) {

$parcel$export(module.exports, "getOwnerDocument", () => $c0a913ecfa4bf5e5$export$b204af158042fbac);

var $Iy8e1 = parcelRequire("Iy8e1");
function $c0a913ecfa4bf5e5$export$b204af158042fbac(r) {
    return (0, $Iy8e1.env).isServer ? null : r instanceof Node ? r.ownerDocument : r != null && r.hasOwnProperty("current") && r.current instanceof Node ? r.current.ownerDocument : document;
}

});


parcelRegister("8UjaS", function(module, exports) {

$parcel$export(module.exports, "isMobile", () => $67c26d51fee0b51a$export$d0a8044dce8ff2fc);
function $67c26d51fee0b51a$export$fedb369cb70207f1() {
    return /iPhone/gi.test(window.navigator.platform) || /Mac/gi.test(window.navigator.platform) && window.navigator.maxTouchPoints > 0;
}
function $67c26d51fee0b51a$export$a11b0059900ceec8() {
    return /Android/gi.test(window.navigator.userAgent);
}
function $67c26d51fee0b51a$export$d0a8044dce8ff2fc() {
    return $67c26d51fee0b51a$export$fedb369cb70207f1() || $67c26d51fee0b51a$export$a11b0059900ceec8();
}

});

parcelRegister("fA3F6", function(module, exports) {

$parcel$export(module.exports, "useDocumentEvent", () => $b57d0f015e93db3a$export$55d2b5df396a097b);

var $acw62 = parcelRequire("acw62");

var $ltgxC = parcelRequire("ltgxC");
function $b57d0f015e93db3a$export$55d2b5df396a097b(e, r, n) {
    let o = (0, $ltgxC.useLatestValue)(r);
    (0, $acw62.useEffect)(()=>{
        function t(u) {
            o.current(u);
        }
        return document.addEventListener(e, t, n), ()=>document.removeEventListener(e, t, n);
    }, [
        e,
        n
    ]);
}

});

parcelRegister("5vI4D", function(module, exports) {

$parcel$export(module.exports, "useWindowEvent", () => $40320926a37dc1cc$export$ee579bb285b8d4aa);

var $acw62 = parcelRequire("acw62");

var $ltgxC = parcelRequire("ltgxC");
function $40320926a37dc1cc$export$ee579bb285b8d4aa(e, r, n) {
    let o = (0, $ltgxC.useLatestValue)(r);
    (0, $acw62.useEffect)(()=>{
        function t(i) {
            o.current(i);
        }
        return window.addEventListener(e, t, n), ()=>window.removeEventListener(e, t, n);
    }, [
        e,
        n
    ]);
}

});


parcelRegister("5IEAk", function(module, exports) {

$parcel$export(module.exports, "useOwnerDocument", () => $42a08b28a285ca8e$export$dd9fbcea3de0ae36);

var $acw62 = parcelRequire("acw62");

var $gxwGc = parcelRequire("gxwGc");
function $42a08b28a285ca8e$export$dd9fbcea3de0ae36(...e) {
    return (0, $acw62.useMemo)(()=>(0, $gxwGc.getOwnerDocument)(...e), [
        ...e
    ]);
}

});

parcelRegister("gm4XX", function(module, exports) {

$parcel$export(module.exports, "useResolveButtonType", () => $be828d8bf9bb25ca$export$53652b2b272efe9c);

var $acw62 = parcelRequire("acw62");

var $8KgIp = parcelRequire("8KgIp");
function $be828d8bf9bb25ca$var$i(t) {
    var n;
    if (t.type) return t.type;
    let e = (n = t.as) != null ? n : "button";
    if (typeof e == "string" && e.toLowerCase() === "button") return "button";
}
function $be828d8bf9bb25ca$export$53652b2b272efe9c(t, e) {
    let [n, u] = (0, $acw62.useState)(()=>$be828d8bf9bb25ca$var$i(t));
    return (0, $8KgIp.useIsoMorphicEffect)(()=>{
        u($be828d8bf9bb25ca$var$i(t));
    }, [
        t.type,
        t.as
    ]), (0, $8KgIp.useIsoMorphicEffect)(()=>{
        n || e.current && e.current instanceof HTMLButtonElement && !e.current.hasAttribute("type") && u("button");
    }, [
        n,
        e
    ]), n;
}

});

parcelRegister("6mpbl", function(module, exports) {

$parcel$export(module.exports, "useSyncRefs", () => $4a1854c6a3ad5196$export$f6a25a78204acc7e);

var $acw62 = parcelRequire("acw62");

var $114Mg = parcelRequire("114Mg");
let $4a1854c6a3ad5196$var$u = Symbol();
function $4a1854c6a3ad5196$export$7029785b750eb74(t, n = !0) {
    return Object.assign(t, {
        [$4a1854c6a3ad5196$var$u]: n
    });
}
function $4a1854c6a3ad5196$export$f6a25a78204acc7e(...t) {
    let n = (0, $acw62.useRef)(t);
    (0, $acw62.useEffect)(()=>{
        n.current = t;
    }, [
        t
    ]);
    let c = (0, $114Mg.useEvent)((e)=>{
        for (let o of n.current)o != null && (typeof o == "function" ? o(e) : o.current = e);
    });
    return t.every((e)=>e == null || (e == null ? void 0 : e[$4a1854c6a3ad5196$var$u])) ? void 0 : c;
}

});

parcelRegister("ipity", function(module, exports) {

$parcel$export(module.exports, "useTrackedPointer", () => $d668e4b1d0c2f85c$export$24ebee078bde85c3);

var $acw62 = parcelRequire("acw62");
function $d668e4b1d0c2f85c$var$t(e) {
    return [
        e.screenX,
        e.screenY
    ];
}
function $d668e4b1d0c2f85c$export$24ebee078bde85c3() {
    let e = (0, $acw62.useRef)([
        -1,
        -1
    ]);
    return {
        wasMoved (r) {
            let n = $d668e4b1d0c2f85c$var$t(r);
            return e.current[0] === n[0] && e.current[1] === n[1] ? !1 : (e.current = n, !0);
        },
        update (r) {
            e.current = $d668e4b1d0c2f85c$var$t(r);
        }
    };
}

});

parcelRegister("1nOiu", function(module, exports) {

$parcel$export(module.exports, "useTreeWalker", () => $101ef4628501ab0d$export$b0abce39eb34b36);

var $acw62 = parcelRequire("acw62");

var $gxwGc = parcelRequire("gxwGc");

var $8KgIp = parcelRequire("8KgIp");
function $101ef4628501ab0d$export$b0abce39eb34b36({ container: e, accept: t, walk: r, enabled: c = !0 }) {
    let o = (0, $acw62.useRef)(t), l = (0, $acw62.useRef)(r);
    (0, $acw62.useEffect)(()=>{
        o.current = t, l.current = r;
    }, [
        t,
        r
    ]), (0, $8KgIp.useIsoMorphicEffect)(()=>{
        if (!e || !c) return;
        let n = (0, $gxwGc.getOwnerDocument)(e);
        if (!n) return;
        let f = o.current, p = l.current, d = Object.assign((i)=>f(i), {
            acceptNode: f
        }), u = n.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, d, !1);
        for(; u.nextNode();)p(u.currentNode);
    }, [
        e,
        c,
        o,
        l
    ]);
}

});

parcelRegister("lEQT2", function(module, exports) {

$parcel$export(module.exports, "useWatch", () => $fc465b9f88c2456a$export$3c773aa2b84f29e0);

var $acw62 = parcelRequire("acw62");

var $114Mg = parcelRequire("114Mg");
function $fc465b9f88c2456a$export$3c773aa2b84f29e0(u, t) {
    let e = (0, $acw62.useRef)([]), r = (0, $114Mg.useEvent)(u);
    (0, $acw62.useEffect)(()=>{
        let o = [
            ...e.current
        ];
        for (let [n, a] of t.entries())if (e.current[n] !== a) {
            let l = r(t, o);
            return e.current = t, l;
        }
    }, [
        r,
        ...t
    ]);
}

});

parcelRegister("k9Al5", function(module, exports) {

$parcel$export(module.exports, "Features", () => $eac0d614a77ee96b$export$617d79dae526d2cf);
$parcel$export(module.exports, "Hidden", () => $eac0d614a77ee96b$export$8dc98ba7eadeaa56);

var $ebRQH = parcelRequire("ebRQH");
let $eac0d614a77ee96b$var$p = "div";
var $eac0d614a77ee96b$export$617d79dae526d2cf = ((e)=>(e[e.None = 1] = "None", e[e.Focusable = 2] = "Focusable", e[e.Hidden = 4] = "Hidden", e))($eac0d614a77ee96b$export$617d79dae526d2cf || {});
function $eac0d614a77ee96b$var$l(d, o) {
    var n;
    let { features: t = 1, ...e } = d, r = {
        ref: o,
        "aria-hidden": (t & 2) === 2 ? !0 : (n = e["aria-hidden"]) != null ? n : void 0,
        style: {
            position: "fixed",
            top: 1,
            left: 1,
            width: 1,
            height: 0,
            padding: 0,
            margin: -1,
            overflow: "hidden",
            clip: "rect(0, 0, 0, 0)",
            whiteSpace: "nowrap",
            borderWidth: "0",
            ...(t & 4) === 4 && (t & 2) !== 2 && {
                display: "none"
            }
        }
    };
    return (0, $ebRQH.render)({
        ourProps: r,
        theirProps: e,
        slot: {},
        defaultTag: $eac0d614a77ee96b$var$p,
        name: "Hidden"
    });
}
let $eac0d614a77ee96b$export$8dc98ba7eadeaa56 = (0, $ebRQH.forwardRefWithAs)($eac0d614a77ee96b$var$l);

});
parcelRegister("ebRQH", function(module, exports) {

$parcel$export(module.exports, "Features", () => $a54bdd13402af126$export$617d79dae526d2cf);
$parcel$export(module.exports, "render", () => $a54bdd13402af126$export$b3890eb0ae9dca99);
$parcel$export(module.exports, "compact", () => $a54bdd13402af126$export$8e16b83750b44988);
$parcel$export(module.exports, "forwardRefWithAs", () => $a54bdd13402af126$export$e43f39796049410c);

var $acw62 = parcelRequire("acw62");

var $4Mkm0 = parcelRequire("4Mkm0");

var $6Ngq1 = parcelRequire("6Ngq1");
var $a54bdd13402af126$export$617d79dae526d2cf = ((n)=>(n[n.None = 0] = "None", n[n.RenderStrategy = 1] = "RenderStrategy", n[n.Static = 2] = "Static", n))($a54bdd13402af126$export$617d79dae526d2cf || {}), $a54bdd13402af126$export$80c0a745e59f7989 = ((e)=>(e[e.Unmount = 0] = "Unmount", e[e.Hidden = 1] = "Hidden", e))($a54bdd13402af126$export$80c0a745e59f7989 || {});
function $a54bdd13402af126$export$b3890eb0ae9dca99({ ourProps: r, theirProps: t, slot: e, defaultTag: n, features: o, visible: a = !0, name: f, mergeRefs: l }) {
    l = l != null ? l : $a54bdd13402af126$var$k;
    let s = $a54bdd13402af126$var$R(t, r);
    if (a) return $a54bdd13402af126$var$m(s, e, n, f, l);
    let y = o != null ? o : 0;
    if (y & 2) {
        let { static: u = !1, ...d } = s;
        if (u) return $a54bdd13402af126$var$m(d, e, n, f, l);
    }
    if (y & 1) {
        let { unmount: u = !0, ...d } = s;
        return (0, $6Ngq1.match)(u ? 0 : 1, {
            [0] () {
                return null;
            },
            [1] () {
                return $a54bdd13402af126$var$m({
                    ...d,
                    hidden: !0,
                    style: {
                        display: "none"
                    }
                }, e, n, f, l);
            }
        });
    }
    return $a54bdd13402af126$var$m(s, e, n, f, l);
}
function $a54bdd13402af126$var$m(r, t = {}, e, n, o) {
    let { as: a = e, children: f, refName: l = "ref", ...s } = $a54bdd13402af126$var$F(r, [
        "unmount",
        "static"
    ]), y = r.ref !== void 0 ? {
        [l]: r.ref
    } : {}, u = typeof f == "function" ? f(t) : f;
    "className" in s && s.className && typeof s.className == "function" && (s.className = s.className(t));
    let d = {};
    if (t) {
        let i = !1, c = [];
        for (let [T, p] of Object.entries(t))typeof p == "boolean" && (i = !0), p === !0 && c.push(T);
        i && (d["data-headlessui-state"] = c.join(" "));
    }
    if (a === (0, $acw62.Fragment) && Object.keys($a54bdd13402af126$export$8e16b83750b44988(s)).length > 0) {
        if (!(0, $acw62.isValidElement)(u) || Array.isArray(u) && u.length > 1) throw new Error([
            'Passing props on "Fragment"!',
            "",
            `The current component <${n} /> is rendering a "Fragment".`,
            "However we need to passthrough the following props:",
            Object.keys(s).map((p)=>`  - ${p}`).join(`
`),
            "",
            "You can apply a few solutions:",
            [
                'Add an `as="..."` prop, to ensure that we render an actual element instead of a "Fragment".',
                "Render a single element as the child so that we can forward the props onto that element."
            ].map((p)=>`  - ${p}`).join(`
`)
        ].join(`
`));
        let i = u.props, c = typeof (i == null ? void 0 : i.className) == "function" ? (...p)=>(0, $4Mkm0.classNames)(i == null ? void 0 : i.className(...p), s.className) : (0, $4Mkm0.classNames)(i == null ? void 0 : i.className, s.className), T = c ? {
            className: c
        } : {};
        return (0, $acw62.cloneElement)(u, Object.assign({}, $a54bdd13402af126$var$R(u.props, $a54bdd13402af126$export$8e16b83750b44988($a54bdd13402af126$var$F(s, [
            "ref"
        ]))), d, y, {
            ref: o(u.ref, y.ref)
        }, T));
    }
    return (0, $acw62.createElement)(a, Object.assign({}, $a54bdd13402af126$var$F(s, [
        "ref"
    ]), a !== (0, $acw62.Fragment) && y, a !== (0, $acw62.Fragment) && d), u);
}
function $a54bdd13402af126$export$81218df071161f0a() {
    let r = (0, $acw62.useRef)([]), t = (0, $acw62.useCallback)((e)=>{
        for (let n of r.current)n != null && (typeof n == "function" ? n(e) : n.current = e);
    }, []);
    return (...e)=>{
        if (!e.every((n)=>n == null)) return r.current = e, t;
    };
}
function $a54bdd13402af126$var$k(...r) {
    return r.every((t)=>t == null) ? void 0 : (t)=>{
        for (let e of r)e != null && (typeof e == "function" ? e(t) : e.current = t);
    };
}
function $a54bdd13402af126$var$R(...r) {
    var n;
    if (r.length === 0) return {};
    if (r.length === 1) return r[0];
    let t = {}, e = {};
    for (let o of r)for(let a in o)a.startsWith("on") && typeof o[a] == "function" ? ((n = e[a]) != null || (e[a] = []), e[a].push(o[a])) : t[a] = o[a];
    if (t.disabled || t["aria-disabled"]) return Object.assign(t, Object.fromEntries(Object.keys(e).map((o)=>[
            o,
            void 0
        ])));
    for(let o in e)Object.assign(t, {
        [o] (a, ...f) {
            let l = e[o];
            for (let s of l){
                if ((a instanceof Event || (a == null ? void 0 : a.nativeEvent) instanceof Event) && a.defaultPrevented) return;
                s(a, ...f);
            }
        }
    });
    return t;
}
function $a54bdd13402af126$export$e43f39796049410c(r) {
    var t;
    return Object.assign((0, $acw62.forwardRef)(r), {
        displayName: (t = r.displayName) != null ? t : r.name
    });
}
function $a54bdd13402af126$export$8e16b83750b44988(r) {
    let t = Object.assign({}, r);
    for(let e in t)t[e] === void 0 && delete t[e];
    return t;
}
function $a54bdd13402af126$var$F(r, t = []) {
    let e = Object.assign({}, r);
    for (let n of t)n in e && delete e[n];
    return e;
}

});
parcelRegister("4Mkm0", function(module, exports) {

$parcel$export(module.exports, "classNames", () => $37ab6efe1f53a2e0$export$ce4ab0c55987d1ff);
function $37ab6efe1f53a2e0$export$ce4ab0c55987d1ff(...r) {
    return Array.from(new Set(r.flatMap((n)=>typeof n == "string" ? n.split(" ") : []))).filter(Boolean).join(" ");
}

});



parcelRegister("auuNT", function(module, exports) {

$parcel$export(module.exports, "State", () => $7a3499b4b3c6f184$export$7254cc27399e90bd);
$parcel$export(module.exports, "useOpenClosed", () => $7a3499b4b3c6f184$export$fc6fdf0ecf360e);
$parcel$export(module.exports, "OpenClosedProvider", () => $7a3499b4b3c6f184$export$2a0ed818b175f558);

var $acw62 = parcelRequire("acw62");
let $7a3499b4b3c6f184$var$n = (0, $acw62.createContext)(null);
$7a3499b4b3c6f184$var$n.displayName = "OpenClosedContext";
var $7a3499b4b3c6f184$export$7254cc27399e90bd = ((e)=>(e[e.Open = 1] = "Open", e[e.Closed = 2] = "Closed", e[e.Closing = 4] = "Closing", e[e.Opening = 8] = "Opening", e))($7a3499b4b3c6f184$export$7254cc27399e90bd || {});
function $7a3499b4b3c6f184$export$fc6fdf0ecf360e() {
    return (0, $acw62.useContext)($7a3499b4b3c6f184$var$n);
}
function $7a3499b4b3c6f184$export$2a0ed818b175f558({ value: o, children: r }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($7a3499b4b3c6f184$var$n.Provider, {
        value: o
    }, r);
}

});

parcelRegister("2C9FE", function(module, exports) {

$parcel$export(module.exports, "history", () => $1e76a1cad0cb58a8$export$55abd4691b317664);

var $ixVas = parcelRequire("ixVas");
let $1e76a1cad0cb58a8$export$55abd4691b317664 = [];
(0, $ixVas.onDocumentReady)(()=>{
    function e(n) {
        n.target instanceof HTMLElement && n.target !== document.body && $1e76a1cad0cb58a8$export$55abd4691b317664[0] !== n.target && ($1e76a1cad0cb58a8$export$55abd4691b317664.unshift(n.target), $1e76a1cad0cb58a8$export$55abd4691b317664 = $1e76a1cad0cb58a8$export$55abd4691b317664.filter((r)=>r != null && r.isConnected), $1e76a1cad0cb58a8$export$55abd4691b317664.splice(10));
    }
    window.addEventListener("click", e, {
        capture: !0
    }), window.addEventListener("mousedown", e, {
        capture: !0
    }), window.addEventListener("focus", e, {
        capture: !0
    }), document.body.addEventListener("click", e, {
        capture: !0
    }), document.body.addEventListener("mousedown", e, {
        capture: !0
    }), document.body.addEventListener("focus", e, {
        capture: !0
    });
});

});
parcelRegister("ixVas", function(module, exports) {

$parcel$export(module.exports, "onDocumentReady", () => $d807a76564ed2203$export$a6a2315df743a26b);
function $d807a76564ed2203$export$a6a2315df743a26b(n) {
    function e() {
        document.readyState !== "loading" && (n(), document.removeEventListener("DOMContentLoaded", e));
    }
    typeof window != "undefined" && typeof document != "undefined" && (document.addEventListener("DOMContentLoaded", e), e());
}

});


parcelRegister("5fYEB", function(module, exports) {

$parcel$export(module.exports, "isDisabledReactIssue7711", () => $3d3d670dbe2ceed6$export$db61f031a278447c);
function $3d3d670dbe2ceed6$export$db61f031a278447c(n) {
    let e = n.parentElement, l = null;
    for(; e && !(e instanceof HTMLFieldSetElement);)e instanceof HTMLLegendElement && (l = e), e = e.parentElement;
    let t = (e == null ? void 0 : e.getAttribute("disabled")) === "";
    return t && $3d3d670dbe2ceed6$var$i(l) ? !1 : t;
}
function $3d3d670dbe2ceed6$var$i(n) {
    if (!n) return !1;
    let e = n.previousElementSibling;
    for(; e !== null;){
        if (e instanceof HTMLLegendElement) return !1;
        e = e.previousElementSibling;
    }
    return !0;
}

});

parcelRegister("fLrGx", function(module, exports) {

$parcel$export(module.exports, "Focus", () => $b7a0b87cd8a0fa3d$export$807a7eae502106e7);
$parcel$export(module.exports, "calculateActiveIndex", () => $b7a0b87cd8a0fa3d$export$c6b4626b54936d5e);
function $b7a0b87cd8a0fa3d$var$u(l) {
    throw new Error("Unexpected object: " + l);
}
var $b7a0b87cd8a0fa3d$export$807a7eae502106e7 = ((i)=>(i[i.First = 0] = "First", i[i.Previous = 1] = "Previous", i[i.Next = 2] = "Next", i[i.Last = 3] = "Last", i[i.Specific = 4] = "Specific", i[i.Nothing = 5] = "Nothing", i))($b7a0b87cd8a0fa3d$export$807a7eae502106e7 || {});
function $b7a0b87cd8a0fa3d$export$c6b4626b54936d5e(l, n) {
    let t = n.resolveItems();
    if (t.length <= 0) return null;
    let r = n.resolveActiveIndex(), s = r != null ? r : -1;
    switch(l.focus){
        case 0:
            for(let e = 0; e < t.length; ++e)if (!n.resolveDisabled(t[e], e, t)) return e;
            return r;
        case 1:
            for(let e = s - 1; e >= 0; --e)if (!n.resolveDisabled(t[e], e, t)) return e;
            return r;
        case 2:
            for(let e = s + 1; e < t.length; ++e)if (!n.resolveDisabled(t[e], e, t)) return e;
            return r;
        case 3:
            for(let e = t.length - 1; e >= 0; --e)if (!n.resolveDisabled(t[e], e, t)) return e;
            return r;
        case 4:
            for(let e = 0; e < t.length; ++e)if (n.resolveId(t[e], e, t) === l.id) return e;
            return r;
        case 5:
            return null;
        default:
            $b7a0b87cd8a0fa3d$var$u(l);
    }
}

});

parcelRegister("7FnlJ", function(module, exports) {

$parcel$export(module.exports, "objectToFormEntries", () => $594e79751740d704$export$bc22b3e852574dab);
function $594e79751740d704$export$bc22b3e852574dab(i = {}, s = null, t = []) {
    for (let [r, n] of Object.entries(i))$594e79751740d704$var$o(t, $594e79751740d704$var$f(s, r), n);
    return t;
}
function $594e79751740d704$var$f(i, s) {
    return i ? i + "[" + s + "]" : s;
}
function $594e79751740d704$var$o(i, s, t) {
    if (Array.isArray(t)) for (let [r, n] of t.entries())$594e79751740d704$var$o(i, $594e79751740d704$var$f(s, r.toString()), n);
    else t instanceof Date ? i.push([
        s,
        t.toISOString()
    ]) : typeof t == "boolean" ? i.push([
        s,
        t ? "1" : "0"
    ]) : typeof t == "string" ? i.push([
        s,
        t
    ]) : typeof t == "number" ? i.push([
        s,
        `${t}`
    ]) : t == null ? i.push([
        s,
        ""
    ]) : $594e79751740d704$export$bc22b3e852574dab(t, s, i);
}
function $594e79751740d704$export$ee02894bdc79dd36(i) {
    var t, r;
    let s = (t = i == null ? void 0 : i.form) != null ? t : i.closest("form");
    if (s) {
        for (let n of s.elements)if (n !== i && (n.tagName === "INPUT" && n.type === "submit" || n.tagName === "BUTTON" && n.type === "submit" || n.nodeName === "INPUT" && n.type === "image")) {
            n.click();
            return;
        }
        (r = s.requestSubmit) == null || r.call(s);
    }
}

});

parcelRegister("6AKlm", function(module, exports) {

$parcel$export(module.exports, "Keys", () => $4cca0dbc68b0507a$export$4b0075e5ea5e1f26);
var $4cca0dbc68b0507a$export$4b0075e5ea5e1f26 = ((r)=>(r.Space = " ", r.Enter = "Enter", r.Escape = "Escape", r.Backspace = "Backspace", r.Delete = "Delete", r.ArrowLeft = "ArrowLeft", r.ArrowUp = "ArrowUp", r.ArrowRight = "ArrowRight", r.ArrowDown = "ArrowDown", r.Home = "Home", r.End = "End", r.PageUp = "PageUp", r.PageDown = "PageDown", r.Tab = "Tab", r))($4cca0dbc68b0507a$export$4b0075e5ea5e1f26 || {});

});


parcelRegister("dPZJA", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("8NX0R"),
    $Gr8vk("iahae")
]).then(()=>parcelRequire("cdryb"));

});
parcelRegister("Gr8vk", function(module, exports) {
"use strict";

function $07f8f9093a769793$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("27Lyk")).resolve(id));
}
module.exports = $07f8f9093a769793$var$load;

});
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $18c11f3350a906ea$export$f7ad0328861e2f03, (v) => $18c11f3350a906ea$export$f7ad0328861e2f03 = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});



parcelRegister("lJBCZ", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("8NX0R"),
    $Gr8vk("e7xYb")
]).then(()=>parcelRequire("5IrB9"));

});

parcelRegister("cTVBx", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("8NX0R"),
    $Gr8vk("jKo9T")
]).then(()=>parcelRequire("es5rq"));

});

parcelRegister("gCqBl", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("8NX0R"),
    $Gr8vk("eTDbm")
]).then(()=>parcelRequire("lQPai"));

});

parcelRegister("3gtj7", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("8NX0R"),
    $Gr8vk("dq3FJ")
]).then(()=>parcelRequire("iiEyQ"));

});

parcelRegister("j9HgW", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("8NX0R"),
    $Gr8vk("g58IY")
]).then(()=>parcelRequire("2Slex"));

});

parcelRegister("9MfZT", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("8NX0R"),
    $Gr8vk("aIb4L")
]).then(()=>parcelRequire("f7Ea7"));

});

parcelRegister("bEIbx", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("8NX0R"),
    $Gr8vk("jR5cZ")
]).then(()=>parcelRequire("37034"));

});

parcelRegister("8dNb8", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("8NX0R"),
    $Gr8vk("i8ttG"),
    $Gr8vk("5p4D9")
]).then(()=>parcelRequire("6wANf"));

});

parcelRegister("k6ghe", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("8NX0R"),
    $Gr8vk("i8ttG")
]).then(()=>parcelRequire("lnozu"));

});

parcelRegister("2dlfv", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("8NX0R"),
    $Gr8vk("9hHBY")
]).then(()=>parcelRequire("knYuI"));

});

parcelRegister("kuRNp", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("8NX0R"),
    $Gr8vk("istnT")
]).then(()=>parcelRequire("9428V"));

});

parcelRegister("701BD", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("8NX0R"),
    $Gr8vk("20onw")
]).then(()=>parcelRequire("eWIWk"));

});

parcelRegister("dfFxh", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("8NX0R"),
    $Gr8vk("i8ttG"),
    $Gr8vk("1CO4q")
]).then(()=>parcelRequire("cBwtq"));

});

parcelRegister("7xtjt", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("e7xYb"),
    $Gr8vk("8NX0R"),
    $Gr8vk("iahae"),
    $Gr8vk("eFTuG")
]).then(()=>parcelRequire("9aPsM"));

});

parcelRegister("hk8RF", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("8NX0R"),
    $Gr8vk("iahae"),
    $Gr8vk("gm4BA")
]).then(()=>parcelRequire("f6UhB"));

});

parcelRegister("9Aiqa", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("jyTJx"),
    $Gr8vk("8NX0R"),
    $Gr8vk("iahae"),
    $Gr8vk("6vYRi")
]).then(()=>parcelRequire("ijV5U"));

});

parcelRegister("3FX5h", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("8NX0R"),
    $Gr8vk("iahae"),
    $Gr8vk("6I0kU")
]).then(()=>parcelRequire("k3Pvy"));

});

parcelRegister("9uJ5q", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("8NX0R"),
    $Gr8vk("iahae"),
    $Gr8vk("7s0Uc")
]).then(()=>parcelRequire("4KpV7"));

});

parcelRegister("e4CiW", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("8NX0R"),
    $Gr8vk("iahae"),
    $Gr8vk("iciWh")
]).then(()=>parcelRequire("74PlI"));

});

parcelRegister("6WJqa", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("8NX0R"),
    $Gr8vk("iahae"),
    $Gr8vk("SHMIf")
]).then(()=>parcelRequire("c8SUI"));

});

parcelRegister("2kkuJ", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("8NX0R"),
    $Gr8vk("iahae"),
    $Gr8vk("9ulvl")
]).then(()=>parcelRequire("j3jqL"));

});

parcelRegister("e8vFr", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("8NX0R"),
    $Gr8vk("iahae"),
    $Gr8vk("lwwC2")
]).then(()=>parcelRequire("fR48J"));

});

parcelRegister("b4VEc", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("8NX0R"),
    $Gr8vk("iahae"),
    $Gr8vk("jyTJx")
]).then(()=>parcelRequire("la7Uh"));

});



//# sourceMappingURL=index.0a335976.js.map
